
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("lUiUI", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $4951a70d6f0b0dd4$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
parcelRequire("kQSGw");

var $5BRby = parcelRequire("5BRby");

var $8BZ1O = parcelRequire("8BZ1O");

var $ji3xf = parcelRequire("ji3xf");
var $7c3W1 = parcelRequire("7c3W1");

var $psWLM = parcelRequire("psWLM");

var $203kY = parcelRequire("203kY");

var $fD1Hq = parcelRequire("fD1Hq");

var $aeIT6 = parcelRequire("aeIT6");

var $fO5rB = parcelRequire("fO5rB");

var $bhwgQ = parcelRequire("bhwgQ");

var $jK1pm = parcelRequire("jK1pm");
const $4951a70d6f0b0dd4$var$JiraBusinessTimelineApp = ()=>{
    const { data: project } = (0, $aeIT6.useProject)();
    const canLinkIssues = Boolean(project?.permissions.linkIssues);
    const canScheduleIssues = Boolean(project?.permissions.scheduleIssues);
    const canCreateIssues = Boolean(project?.permissions.createIssues);
    const isSubtasksEnabled = (0, $fD1Hq.useIsSubtasksEnabled)();
    const isSimplifiedProject = Boolean(project?.isSimplified);
    const canCreateSubtask = canCreateIssues && (isSimplifiedProject || isSubtasksEnabled);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jK1pm.default), {
        name: "jira-business-timeline-app"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bhwgQ.AuthenticationCheck), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5BRby.default), {
        id: "business"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8BZ1O.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $203kY.default), {
        hasInlineCreate: canCreateIssues,
        hasCreateSubtask: canCreateSubtask,
        hasIssueLinking: canLinkIssues,
        hasScheduleIssues: canScheduleIssues
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7c3W1.ViewPreferencesProvider), {
        view: "timeline",
        preferences: (0, $ji3xf.TIMELINE_VIEW_PREFERENCES)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $psWLM.default), null)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fO5rB.SubProductUpdater), {
        subProduct: "core"
    }))));
};
var $4951a70d6f0b0dd4$export$2e2bcd8739ae039 = $4951a70d6f0b0dd4$var$JiraBusinessTimelineApp;

});
parcelRegister("8BZ1O", function(module, exports) {

$parcel$export(module.exports, "default", () => $80390eebeffb6a20$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $bDUCT = parcelRequire("bDUCT");
var $fDLFb = parcelRequire("fDLFb");
var $eZbpk = parcelRequire("eZbpk");
var $ePgRW = parcelRequire("ePgRW");

var $kQAZu = parcelRequire("kQAZu");

var $4G5xU = parcelRequire("4G5xU");

var $jWIW7 = parcelRequire("jWIW7");

var $7IBv4 = parcelRequire("7IBv4");

var $8WuJm = parcelRequire("8WuJm");

var $kJlBc = parcelRequire("kJlBc");

var $aeIT6 = parcelRequire("aeIT6");

var $dWLk9 = parcelRequire("dWLk9");

var $hCCuu = parcelRequire("hCCuu");

var $k4xGW = parcelRequire("k4xGW");
const $80390eebeffb6a20$var$ProjectContextProvider = ({ children: children })=>{
    const { data: project, loading: loading, error: error } = (0, $aeIT6.useProject)();
    const { replace: replace } = (0, $kJlBc.useRouterActions)();
    const cloudId = (0, $dWLk9.useCloudId)();
    const projectId = project?.id;
    const projectKey = project?.key;
    const projectType = project?.type;
    const isTeamManaged = Boolean(project?.isSimplified);
    const jqlContext = projectKey ? `project = '${projectKey}'` : '';
    const analyticsAttributes = (0, $eUqFw.useMemo)(()=>({
            projectId: projectId,
            isTeamManaged: isTeamManaged,
            projectType: projectType
        }), [
        projectId,
        isTeamManaged,
        projectType
    ]);
    const entityData = (0, $eUqFw.useMemo)(()=>project?.permissions?.viewIssues ? {
            name: project.name,
            id: String(project.id)
        } : null, [
        project
    ]);
    const projects = (0, $eUqFw.useMemo)(()=>project ? [
            project
        ] : undefined, [
        project
    ]);
    const projectIdList = (0, $eUqFw.useMemo)(()=>projectId ? [
            projectId
        ] : undefined, [
        projectId
    ]);
    const projectAri = `ari:cloud:jira:${cloudId}:project/${projectId}`;
    if (project?.status === 'ARCHIVED') {
        replace('/jira/errors/project-archived');
        return null;
    }
    let content;
    if (loading) content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7IBv4.ThemedLazySkeleton), null);
    else if (project == null || entityData == null || error) content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $k4xGW.default), null), error && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4G5xU.ExperienceFailed), {
        experience: (0, $hCCuu.FETCH_PROJECT_EXPERIENCE),
        error: error
    }));
    else content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kQAZu.ProjectHookProvider), {
        project: project
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fDLFb.BusinessEntityProvider), {
        data: entityData
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ePgRW.RealtimeProvider), {
        ids: projectIdList
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bDUCT.AriProvider), {
        ari: projectAri
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eZbpk.JqlProvider), {
        jqlContext: jqlContext
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jWIW7.FiltersProvider), {
        projects: projects
    }, children)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4G5xU.ExperienceSuccess), {
        experience: (0, $hCCuu.FETCH_PROJECT_EXPERIENCE)
    })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        containerId: String(project?.id),
        containerType: "project",
        sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a),
        sourceName: "businessProjectContext",
        attributes: analyticsAttributes,
        // we set a key on the first element to force React to re-render when the context changes
        // to avoid query race-conditions that would lead to promises from a previous context
        // resolving in the current context view, and thus seeing unrelated data
        key: String(project?.id)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4G5xU.ExperienceStart), {
        experience: (0, $hCCuu.FETCH_PROJECT_EXPERIENCE)
    }), content);
};
var $80390eebeffb6a20$export$2e2bcd8739ae039 = $80390eebeffb6a20$var$ProjectContextProvider;

});
parcelRegister("bDUCT", function(module, exports) {

$parcel$export(module.exports, "AriProvider", () => $76c0a50c757f3bcd$export$c806f8ac05dc61fa);
$parcel$export(module.exports, "useEntityAri", () => $76c0a50c757f3bcd$export$badcacdc306567b8);

var $eUqFw = parcelRequire("eUqFw");
const $76c0a50c757f3bcd$var$AriContext = /*#__PURE__*/ (0, $eUqFw.createContext)('');
const $76c0a50c757f3bcd$export$c806f8ac05dc61fa = ({ ari: ari, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($76c0a50c757f3bcd$var$AriContext.Provider, {
        value: ari
    }, children);
const $76c0a50c757f3bcd$export$badcacdc306567b8 = ()=>(0, $eUqFw.useContext)($76c0a50c757f3bcd$var$AriContext);

});

parcelRegister("fDLFb", function(module, exports) {

$parcel$export(module.exports, "BusinessEntityProvider", () => $984e8248b41af828$export$c800e064c3c327ef);
$parcel$export(module.exports, "useBusinessEntity", () => $984e8248b41af828$export$ff2574b00bc1c100);

var $eUqFw = parcelRequire("eUqFw");
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
const $984e8248b41af828$var$BusinessEntityContext = /*#__PURE__*/ (0, $eUqFw.createContext)(null);
const $984e8248b41af828$export$c800e064c3c327ef = ({ data: data, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($984e8248b41af828$var$BusinessEntityContext.Provider, {
        value: data
    }, children);
const $984e8248b41af828$export$ff2574b00bc1c100 = ()=>{
    const entity = (0, $eUqFw.useContext)($984e8248b41af828$var$BusinessEntityContext);
    return {
        data: entity
    };
};

});

parcelRegister("eZbpk", function(module, exports) {

$parcel$export(module.exports, "JqlProvider", () => $28ab7b3257a6571c$export$fdc879e2ba0da048);
$parcel$export(module.exports, "useJqlContext", () => $28ab7b3257a6571c$export$f32e2f688fc08561);

var $eUqFw = parcelRequire("eUqFw");
const $28ab7b3257a6571c$var$JqlContext = /*#__PURE__*/ (0, $eUqFw.createContext)('');
const $28ab7b3257a6571c$export$fdc879e2ba0da048 = ({ jqlContext: jqlContext, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($28ab7b3257a6571c$var$JqlContext.Provider, {
        value: jqlContext
    }, children);
const $28ab7b3257a6571c$export$f32e2f688fc08561 = ()=>(0, $eUqFw.useContext)($28ab7b3257a6571c$var$JqlContext);

});

parcelRegister("ePgRW", function(module, exports) {

$parcel$export(module.exports, "RealtimeProvider", () => $d87d469a5640e4cf$export$64d242981d970821);
$parcel$export(module.exports, "useRealtimeContext", () => $d87d469a5640e4cf$export$f39c07717ad8c35b);

var $eUqFw = parcelRequire("eUqFw");
const $d87d469a5640e4cf$var$RealtimeContext = /*#__PURE__*/ (0, $eUqFw.createContext)([]);
const $d87d469a5640e4cf$export$64d242981d970821 = ({ ids: ids, children: children })=>{
    const projectsIds = (0, $eUqFw.useMemo)(()=>ids ? ids.map((pid)=>String(pid)) : [], [
        ids
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d87d469a5640e4cf$var$RealtimeContext.Provider, {
        value: projectsIds
    }, children);
};
const $d87d469a5640e4cf$export$f39c07717ad8c35b = ()=>(0, $eUqFw.useContext)($d87d469a5640e4cf$var$RealtimeContext);

});

parcelRegister("kQAZu", function(module, exports) {

$parcel$export(module.exports, "ProjectHookProvider", () => $5a070342b3707183$export$f1938a4916a14d9f);
$parcel$export(module.exports, "useProject", () => $5a070342b3707183$export$51b1383ef8844a7);

var $eUqFw = parcelRequire("eUqFw");
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
const $5a070342b3707183$var$Context = /*#__PURE__*/ (0, $eUqFw.createContext)(null);
const $5a070342b3707183$export$f1938a4916a14d9f = ({ project: project, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5a070342b3707183$var$Context.Provider, {
        value: project
    }, children);
const $5a070342b3707183$export$51b1383ef8844a7 = ()=>{
    const project = (0, $eUqFw.useContext)($5a070342b3707183$var$Context);
    if (!project) throw new Error('useProject must be used within a ProjectHookProvider');
    return project;
};

});

parcelRegister("jWIW7", function(module, exports) {

$parcel$export(module.exports, "FiltersProvider", () => $85c94258ff14c8b6$export$905df3588d1d8c75);
$parcel$export(module.exports, "useAssigneesFilterQuery", () => $85c94258ff14c8b6$export$f39bce8705b01ff5);
$parcel$export(module.exports, "useProjectFilter", () => $85c94258ff14c8b6$export$b71768ffb8163578);
$parcel$export(module.exports, "useAllowedFieldTypes", () => $85c94258ff14c8b6$export$9dc8a291956c2fa9);

var $eUqFw = parcelRequire("eUqFw");

var $lO4Or = parcelRequire("lO4Or");

var $9TEHc = parcelRequire("9TEHc");
const $85c94258ff14c8b6$var$DEFAULT_VALUE = {
    assigneeQuery: '',
    projectFilter: {
        totalCount: 0,
        options: []
    }
};
const $85c94258ff14c8b6$var$FiltersContext = /*#__PURE__*/ (0, $eUqFw.createContext)($85c94258ff14c8b6$var$DEFAULT_VALUE);
const $85c94258ff14c8b6$export$905df3588d1d8c75 = ({ projects: projects, children: children })=>{
    const value = (0, $eUqFw.useMemo)(()=>{
        if (!projects) return $85c94258ff14c8b6$var$DEFAULT_VALUE;
        const assigneeQuery = `is assignee of (${projects.map((project)=>project.key).join(', ')})`;
        const projectFilter = {
            totalCount: projects.length,
            options: projects.map((project)=>({
                    label: project.name,
                    value: String(project.id),
                    avatar: project.avatarUrl,
                    square: true
                }))
        };
        return {
            assigneeQuery: assigneeQuery,
            projectFilter: projectFilter
        };
    }, [
        projects
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($85c94258ff14c8b6$var$FiltersContext.Provider, {
        value: value
    }, children);
};
const $85c94258ff14c8b6$export$f39bce8705b01ff5 = ()=>(0, $eUqFw.useContext)($85c94258ff14c8b6$var$FiltersContext).assigneeQuery;
const $85c94258ff14c8b6$export$b71768ffb8163578 = ()=>(0, $eUqFw.useContext)($85c94258ff14c8b6$var$FiltersContext).projectFilter;
const $85c94258ff14c8b6$export$9dc8a291956c2fa9 = (inputAllowedFieldTypes)=>{
    const filtersContext = (0, $eUqFw.useContext)($85c94258ff14c8b6$var$FiltersContext);
    return (0, $eUqFw.useMemo)(()=>{
        const result = new Set(inputAllowedFieldTypes ?? (0, $9TEHc.BUSINESS_FIELD_TYPES));
        if (filtersContext.projectFilter.totalCount <= 1) result.delete((0, $lO4Or.PROJECT_TYPE));
        return result;
    }, [
        filtersContext,
        inputAllowedFieldTypes
    ]);
};

});
parcelRegister("9TEHc", function(module, exports) {

$parcel$export(module.exports, "POPUP_WIDTH", () => $199ced4cefdf295b$export$b6d617db656efcca);
$parcel$export(module.exports, "SHOW_MORE_OPTIONS_BTN_SIZE", () => $199ced4cefdf295b$export$dd535f74d98d8b3);
$parcel$export(module.exports, "OPTIONS_AVAILABLE_WIDTH", () => $199ced4cefdf295b$export$dba112976ea61483);
$parcel$export(module.exports, "GAP_BETWEEN_OPTION", () => $199ced4cefdf295b$export$fe1082abeeda69ed);
$parcel$export(module.exports, "OPTION_SPAN_PADDING", () => $199ced4cefdf295b$export$17ed91292eb6c163);
$parcel$export(module.exports, "OPTION_DEFAULT_FONT_SIZE", () => $199ced4cefdf295b$export$fb22dccd99438559);
$parcel$export(module.exports, "POPUP_OFFSET_TOP", () => $199ced4cefdf295b$export$15839778e99d81e7);
$parcel$export(module.exports, "OPTION_MAX_WIDTH", () => $199ced4cefdf295b$export$39aa3a14ebf850c7);
$parcel$export(module.exports, "DATE_RANGE_TYPE", () => $199ced4cefdf295b$export$1178808c606e043b);
$parcel$export(module.exports, "BUSINESS_FIELD_TYPES", () => $199ced4cefdf295b$export$c269ba5d631cb115);
$parcel$export(module.exports, "SOFTWARE_FIELD_TYPES", () => $199ced4cefdf295b$export$232814e45256d5dc);
$parcel$export(module.exports, "IMPLEMENTED_TYPES", () => $199ced4cefdf295b$export$9615a3d79408a88a);
$parcel$export(module.exports, "EXTRA_CUSTOM_FIELD_TYPES", () => $199ced4cefdf295b$export$a21166a4b76932b5);
$parcel$export(module.exports, "SAVED_FILTERS_PER_PAGE", () => $199ced4cefdf295b$export$1989c7236a398e8a);
// eslint-disable-next-line jira/restricted/@atlassian+jira-common-styles

var $c9TLT = parcelRequire("c9TLT");

var $lO4Or = parcelRequire("lO4Or");
const $199ced4cefdf295b$export$b6d617db656efcca = 360;
const $199ced4cefdf295b$export$90bfd0dcc25478e1 = (0, $c9TLT.gridSize) * 2.5;
const $199ced4cefdf295b$export$dd535f74d98d8b3 = 32;
const $199ced4cefdf295b$export$dba112976ea61483 = $199ced4cefdf295b$export$b6d617db656efcca - $199ced4cefdf295b$export$90bfd0dcc25478e1 * 2;
const $199ced4cefdf295b$export$fe1082abeeda69ed = (0, $c9TLT.gridSize) / 2;
const $199ced4cefdf295b$export$17ed91292eb6c163 = (0, $c9TLT.gridSize) * 2;
const $199ced4cefdf295b$export$fb22dccd99438559 = 14;
const $199ced4cefdf295b$export$15839778e99d81e7 = 215;
const $199ced4cefdf295b$export$de3cbeaaf9d2669 = 28;
const $199ced4cefdf295b$export$39aa3a14ebf850c7 = 150;
const $199ced4cefdf295b$export$1178808c606e043b = 'dateRange';
const $199ced4cefdf295b$export$c269ba5d631cb115 = [
    (0, $lO4Or.ASSIGNEE_TYPE),
    (0, $lO4Or.CATEGORY_TYPE),
    (0, $lO4Or.COMPONENTS_TYPE),
    (0, $lO4Or.CREATED),
    $199ced4cefdf295b$export$1178808c606e043b,
    (0, $lO4Or.ISSUE_TYPE),
    (0, $lO4Or.LABELS_TYPE),
    (0, $lO4Or.PRIORITY_TYPE),
    (0, $lO4Or.PROJECT_TYPE),
    (0, $lO4Or.REPORTER_TYPE),
    (0, $lO4Or.STATUS_TYPE),
    (0, $lO4Or.UPDATED),
    (0, $lO4Or.USER_CF_TYPE),
    (0, $lO4Or.SELECT_CF_TYPE),
    (0, $lO4Or.MULTI_SELECT_CF_TYPE),
    (0, $lO4Or.MULTI_CHECKBOXES_CF_TYPE),
    (0, $lO4Or.PEOPLE_CF_TYPE),
    (0, $lO4Or.DATE_CF_TYPE),
    (0, $lO4Or.GOALS_CF_TYPE),
    (0, $lO4Or.TEAMS_PLATFORM_CF_TYPE),
    (0, $lO4Or.PARENT_FIELD_TYPE)
];
const $199ced4cefdf295b$export$232814e45256d5dc = [
    (0, $lO4Or.SPRINT_TYPE),
    (0, $lO4Or.FIX_VERSIONS_TYPE)
];
const $199ced4cefdf295b$export$9615a3d79408a88a = new Set([
    ...$199ced4cefdf295b$export$c269ba5d631cb115,
    ...$199ced4cefdf295b$export$232814e45256d5dc
]);
const $199ced4cefdf295b$export$a21166a4b76932b5 = new Set([
    (0, $lO4Or.USER_CF_TYPE),
    (0, $lO4Or.SELECT_CF_TYPE),
    (0, $lO4Or.MULTI_SELECT_CF_TYPE),
    (0, $lO4Or.MULTI_CHECKBOXES_CF_TYPE),
    (0, $lO4Or.PEOPLE_CF_TYPE),
    (0, $lO4Or.DATE_CF_TYPE)
]);
const $199ced4cefdf295b$export$90ca377eb0b24ff1 = {
    assignee: (0, $lO4Or.ASSIGNEE_TYPE),
    component: (0, $lO4Or.COMPONENTS_TYPE),
    created: (0, $lO4Or.CREATED),
    issuetype: (0, $lO4Or.ISSUE_TYPE),
    labels: (0, $lO4Or.LABELS_TYPE),
    priority: (0, $lO4Or.PRIORITY_TYPE),
    project: (0, $lO4Or.PROJECT_TYPE),
    reporter: (0, $lO4Or.REPORTER_TYPE),
    status: (0, $lO4Or.STATUS_TYPE),
    type: (0, $lO4Or.ISSUE_TYPE),
    updated: (0, $lO4Or.UPDATED)
};
const $199ced4cefdf295b$export$6a2e733db5135f27 = (0, $c9TLT.gridSize) * 3.5;
const $199ced4cefdf295b$export$1989c7236a398e8a = 50;
const $199ced4cefdf295b$export$91fc9d65fca142a3 = 'users';
const $199ced4cefdf295b$export$d74c70f8fb216c6b = 'recentlyUsedUsers';

});


// SCREENS
const $41ea3621645e2acc$export$f636b5b56f1d624a = 'Screen';
const $41ea3621645e2acc$export$9d2de6eebf7462b5 = 'Drawer';
const $41ea3621645e2acc$export$1171103ea9083ffa = 'Modal';
const $41ea3621645e2acc$export$cae2783c9279926 = 'InlineDialog';
const $41ea3621645e2acc$export$d1123261ca8831d2 = 'Dropdown';
const $41ea3621645e2acc$export$238d30785c4bca84 = 'Banner';
const $41ea3621645e2acc$export$a1562d08625f5d7e = 'UI';
const $41ea3621645e2acc$export$947dac6c72b26f81 = 'TRACK';
const $41ea3621645e2acc$export$f1d537d508d2945a = 'SCREEN';
const $41ea3621645e2acc$export$12346a674644c156 = 'OPERATIONAL';

parcelRegister("hCCuu", function(module, exports) {

$parcel$export(module.exports, "FETCH_PROJECT_EXPERIENCE", () => $be9e1adc5e199dda$export$cb40bbf7ea51db63);
const $be9e1adc5e199dda$export$cb40bbf7ea51db63 = {
    experience: 'fetch-project',
    packageName: 'jiraBusinessEntityProjectProvider',
    teamName: 'wanjel'
};

});

parcelRegister("k4xGW", function(module, exports) {

$parcel$export(module.exports, "default", () => $7e1de8d4690ad3f8$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $gGtKh = parcelRequire("gGtKh");

const $7e1de8d4690ad3f8$var$NotFoundComponent = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("3m77k")), {
    moduleId: "./src/packages/business/entity/project-provider/src/ui/project-context/not-found/main.tsx"
});
const $7e1de8d4690ad3f8$var$NotFoundAsync = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "not-found-component",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7e1de8d4690ad3f8$var$NotFoundComponent, null));
var $7e1de8d4690ad3f8$export$2e2bcd8739ae039 = $7e1de8d4690ad3f8$var$NotFoundAsync;

});
parcelRegister("3m77k", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('dX4bq');
        const value = parcelRequire('gutLJ');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("dX4bq").then(()=>parcelRequire('gutLJ'));
}

});



parcelRegister("ji3xf", function(module, exports) {

$parcel$export(module.exports, "ACTIVE_WORKFLOW_PREFERENCE", () => $3ed190d907cd42b1$export$5d3f940b56d7af28);
$parcel$export(module.exports, "COLLAPSED_COLUMNS_PREFERENCE", () => $3ed190d907cd42b1$export$8019dfa5a44f6d46);
$parcel$export(module.exports, "COLUMNS_ORDER_PREFERENCE", () => $3ed190d907cd42b1$export$3ef984a9f784490f);
$parcel$export(module.exports, "CREATE_TYPE_ID_PREFERENCE", () => $3ed190d907cd42b1$export$2df4c3d44dcb1e5b);
$parcel$export(module.exports, "EXPANDED_ISSUES_PREFERENCE", () => $3ed190d907cd42b1$export$638c3932e4cbdede);
$parcel$export(module.exports, "FIELDS_PREFERENCE", () => $3ed190d907cd42b1$export$e3ddfc509464e305);
$parcel$export(module.exports, "FIELDS_DETAIL_PREFERENCE", () => $3ed190d907cd42b1$export$ffcb5603c64e12d0);
$parcel$export(module.exports, "FILTER_PREFERENCE", () => $3ed190d907cd42b1$export$f50d5db589fb1475);
$parcel$export(module.exports, "GROUPING_PREFERENCE", () => $3ed190d907cd42b1$export$ac8a4771da7f03af);
$parcel$export(module.exports, "HIDE_DONE_ITEMS_PREFERENCE", () => $3ed190d907cd42b1$export$4aace169721c2927);
$parcel$export(module.exports, "HIDE_SOFTWARE_RELEASE_PREFERENCE", () => $3ed190d907cd42b1$export$983f0d3325e2938);
$parcel$export(module.exports, "RANGE_MODE_PREFERENCE", () => $3ed190d907cd42b1$export$f43988a3762bf711);
$parcel$export(module.exports, "SORTING_PREFERENCE", () => $3ed190d907cd42b1$export$373eea1341dcff74);
$parcel$export(module.exports, "BOARD_VIEW_PREFERENCES", () => $3ed190d907cd42b1$export$4ec60be96e9eadc0);
$parcel$export(module.exports, "LIST_VIEW_PREFERENCES", () => $3ed190d907cd42b1$export$43fc1ec27b2f1801);
$parcel$export(module.exports, "CALENDAR_VIEW_PREFERENCES", () => $3ed190d907cd42b1$export$14e2a519a8c2881a);
$parcel$export(module.exports, "TIMELINE_VIEW_PREFERENCES", () => $3ed190d907cd42b1$export$8443f3f4fd94276);
$parcel$export(module.exports, "ATTACHMENTS_VIEW_PREFERENCES", () => $3ed190d907cd42b1$export$2e2923d9c9daba20);

var $jGcn0 = parcelRequire("jGcn0");

var $khRV9 = parcelRequire("khRV9");
const $3ed190d907cd42b1$export$5d3f940b56d7af28 = (0, $khRV9.createSimplePreference)('activeWorkflow');
const $3ed190d907cd42b1$export$8019dfa5a44f6d46 = (0, $khRV9.createSimplePreference)('collapsedColumns');
const $3ed190d907cd42b1$export$3ef984a9f784490f = (0, $khRV9.createSimplePreference)('columnOrder');
const $3ed190d907cd42b1$export$2df4c3d44dcb1e5b = (0, $khRV9.createSimplePreference)('createType');
const $3ed190d907cd42b1$export$638c3932e4cbdede = (0, $khRV9.createSimplePreference)('expandedIssues');
const $3ed190d907cd42b1$export$e3ddfc509464e305 = (0, $khRV9.createSimplePreference)('fields');
const $3ed190d907cd42b1$export$ffcb5603c64e12d0 = (0, $khRV9.createSimplePreference)('fieldsDetail');
const $3ed190d907cd42b1$export$f50d5db589fb1475 = (0, $khRV9.createSimpleUrlPreference)((0, $jGcn0.FILTER_PARAM));
const $3ed190d907cd42b1$export$ac8a4771da7f03af = (0, $khRV9.createSimpleUrlPreference)('groupBy');
const $3ed190d907cd42b1$export$4aace169721c2927 = (0, $khRV9.createSimpleUrlPreference)('hideDone');
const $3ed190d907cd42b1$export$983f0d3325e2938 = (0, $khRV9.createSimpleUrlPreference)('hideSoftwareRelease');
const $3ed190d907cd42b1$export$f43988a3762bf711 = (0, $khRV9.createSimpleUrlPreference)('rangeMode');
const $3ed190d907cd42b1$export$373eea1341dcff74 = {
    ...(0, $khRV9.createSimplePreference)('sorting'),
    queryParameter: {
        serialize: (value)=>({
                sortBy: value?.sortBy,
                direction: value?.direction
            }),
        deserialize: (value)=>value.sortBy ? {
                sortBy: value.sortBy,
                direction: value.direction
            } : undefined
    }
};
const $3ed190d907cd42b1$export$4ec60be96e9eadc0 = [
    $3ed190d907cd42b1$export$5d3f940b56d7af28,
    $3ed190d907cd42b1$export$8019dfa5a44f6d46,
    $3ed190d907cd42b1$export$3ef984a9f784490f,
    $3ed190d907cd42b1$export$2df4c3d44dcb1e5b,
    $3ed190d907cd42b1$export$638c3932e4cbdede,
    $3ed190d907cd42b1$export$e3ddfc509464e305,
    $3ed190d907cd42b1$export$f50d5db589fb1475,
    $3ed190d907cd42b1$export$ac8a4771da7f03af
];
const $3ed190d907cd42b1$export$43fc1ec27b2f1801 = [
    $3ed190d907cd42b1$export$2df4c3d44dcb1e5b,
    $3ed190d907cd42b1$export$e3ddfc509464e305,
    $3ed190d907cd42b1$export$ffcb5603c64e12d0,
    $3ed190d907cd42b1$export$f50d5db589fb1475,
    $3ed190d907cd42b1$export$ac8a4771da7f03af,
    $3ed190d907cd42b1$export$4aace169721c2927,
    $3ed190d907cd42b1$export$373eea1341dcff74
];
const $3ed190d907cd42b1$export$14e2a519a8c2881a = [
    $3ed190d907cd42b1$export$2df4c3d44dcb1e5b,
    $3ed190d907cd42b1$export$f50d5db589fb1475,
    $3ed190d907cd42b1$export$4aace169721c2927,
    $3ed190d907cd42b1$export$983f0d3325e2938
];
const $3ed190d907cd42b1$export$8443f3f4fd94276 = [
    $3ed190d907cd42b1$export$2df4c3d44dcb1e5b,
    $3ed190d907cd42b1$export$f50d5db589fb1475,
    $3ed190d907cd42b1$export$4aace169721c2927,
    $3ed190d907cd42b1$export$f43988a3762bf711
];
const $3ed190d907cd42b1$export$2e2923d9c9daba20 = [
    $3ed190d907cd42b1$export$f50d5db589fb1475
];

});
parcelRegister("jGcn0", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_RANK_SORTING_DIRECTION", () => $15ed10c690a013f2$export$8386e51ba415e85d);
$parcel$export(module.exports, "DEFAULT_AVATAR_RES", () => $15ed10c690a013f2$export$159fe44438c210e9);
$parcel$export(module.exports, "FILTER_PARAM", () => $15ed10c690a013f2$export$d8301e0b33832d94);
$parcel$export(module.exports, "INLINE_CREATE_PARAM", () => $15ed10c690a013f2$export$599c163c1570a353);
$parcel$export(module.exports, "INVITE_OPEN_PARAM", () => $15ed10c690a013f2$export$3a74d1a195d2f007);
$parcel$export(module.exports, "SELECTED_ISSUE_PARAM", () => $15ed10c690a013f2$export$c070acdc9b0f1be5);
$parcel$export(module.exports, "SELECTED_COMMENT_PARAM", () => $15ed10c690a013f2$export$3bcbd99d0f9ad6d8);
$parcel$export(module.exports, "GROUP_BY_ASSIGNEE", () => $15ed10c690a013f2$export$dba794af6c0f2afc);
$parcel$export(module.exports, "GROUP_BY_PRIORITY", () => $15ed10c690a013f2$export$56ecb5d2dfb80edc);
$parcel$export(module.exports, "GROUP_BY_CATEGORY", () => $15ed10c690a013f2$export$22ef551f315f2786);
$parcel$export(module.exports, "GROUP_BY_STATUS", () => $15ed10c690a013f2$export$6d69efb296b78a);
$parcel$export(module.exports, "START_DATE_ALIAS_FIELD_ID", () => $15ed10c690a013f2$export$e23e1d1ea45171c2);
$parcel$export(module.exports, "RANK_ALIAS_FIELD_ID", () => $15ed10c690a013f2$export$e35c6e217c75dc4b);
$parcel$export(module.exports, "REMOTE_ISSUE_LINKS_TYPE", () => $15ed10c690a013f2$export$e5eab344feb92af9);
$parcel$export(module.exports, "COMMENT_SUMMARY_TYPE", () => $15ed10c690a013f2$export$a311e1b78816c048);
$parcel$export(module.exports, "CARD_COVERS_TYPE", () => $15ed10c690a013f2$export$f5583ff4ab4d63e5);
$parcel$export(module.exports, "DEFAULT_PAGE_SIZE", () => $15ed10c690a013f2$export$5716e8bcb003888d);
$parcel$export(module.exports, "STORY_POINTS_ALIAS_FIELD_ID", () => $15ed10c690a013f2$export$1f9fb9f15184100f);
$parcel$export(module.exports, "STORY_POINT_ESTIMATE_ALIAS_FIELD_ID", () => $15ed10c690a013f2$export$c72ea455b368cdd9);

const $15ed10c690a013f2$export$8386e51ba415e85d = (0, $44cab0426b6cf0d7$export$1dee026a19752d6b);
const $15ed10c690a013f2$export$159fe44438c210e9 = '48x48';
const $15ed10c690a013f2$export$d8301e0b33832d94 = 'filter';
const $15ed10c690a013f2$export$599c163c1570a353 = 'inlineCreate';
const $15ed10c690a013f2$export$3a74d1a195d2f007 = 'inviteOpen';
const $15ed10c690a013f2$export$e1e3f9fa6f04d6d = 'quickFilters';
const $15ed10c690a013f2$export$c070acdc9b0f1be5 = 'selectedIssue';
const $15ed10c690a013f2$export$3bcbd99d0f9ad6d8 = 'selectedComment';
const $15ed10c690a013f2$export$dba794af6c0f2afc = 'assignee';
const $15ed10c690a013f2$export$56ecb5d2dfb80edc = 'priority';
const $15ed10c690a013f2$export$22ef551f315f2786 = 'category';
const $15ed10c690a013f2$export$6d69efb296b78a = 'status';
const $15ed10c690a013f2$export$e23e1d1ea45171c2 = 'startdate';
const $15ed10c690a013f2$export$e35c6e217c75dc4b = 'rank';
const $15ed10c690a013f2$export$e5eab344feb92af9 = 'remoteIssueLinks';
const $15ed10c690a013f2$export$a311e1b78816c048 = 'commentsummary';
const $15ed10c690a013f2$export$f5583ff4ab4d63e5 = 'cardCovers';
const $15ed10c690a013f2$export$5716e8bcb003888d = 25;
const $15ed10c690a013f2$export$1f9fb9f15184100f = 'storypoints';
const $15ed10c690a013f2$export$c72ea455b368cdd9 = 'storypointestimate';
const $15ed10c690a013f2$export$786b42b4618e6ee4 = 'sprint';

});
const $44cab0426b6cf0d7$export$1dee026a19752d6b = 'ASC';
const $44cab0426b6cf0d7$export$b6abcf7fa1d94f65 = 'DESC';


parcelRegister("khRV9", function(module, exports) {

$parcel$export(module.exports, "createSimplePreference", () => $462fa2c618ea906f$export$464a71be397e5f3d);
$parcel$export(module.exports, "createSimpleUrlPreference", () => $462fa2c618ea906f$export$78f3983105936d30);

var $3QMTK = parcelRequire("3QMTK");
const $462fa2c618ea906f$export$464a71be397e5f3d = (id)=>({
        id: id,
        serialize: (0, (/*@__PURE__*/$parcel$interopDefault($3QMTK))),
        deserialize: (0, (/*@__PURE__*/$parcel$interopDefault($3QMTK)))
    });
const $462fa2c618ea906f$export$78f3983105936d30 = (queryParameter)=>({
        id: queryParameter,
        serialize: (0, (/*@__PURE__*/$parcel$interopDefault($3QMTK))),
        deserialize: (0, (/*@__PURE__*/$parcel$interopDefault($3QMTK))),
        queryParameter: {
            serialize: (value)=>({
                    [queryParameter]: value
                }),
            deserialize: (value)=>value[queryParameter]
        }
    });

});


parcelRegister("7c3W1", function(module, exports) {

$parcel$export(module.exports, "ViewPreferencesProvider", () => $6117ab20ad9a3ccd$export$1db44e21d818b27);
$parcel$export(module.exports, "useViewPreference", () => $6117ab20ad9a3ccd$export$ee494de6c0ff45d7);

var $eUqFw = parcelRequire("eUqFw");

var $hTLlD = parcelRequire("hTLlD");

var $fDLFb = parcelRequire("fDLFb");

var $hzcvF = parcelRequire("hzcvF");

var $kJlBc = parcelRequire("kJlBc");

var $6YT9E = parcelRequire("6YT9E");
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
const $6117ab20ad9a3ccd$var$ViewPreferencesContext = /*#__PURE__*/ (0, $eUqFw.createContext)(null);
const $6117ab20ad9a3ccd$export$1db44e21d818b27 = ({ view: view, preferences: preferences, children: children, persistChanges: persistChanges = true })=>{
    const { data: entity } = (0, $fDLFb.useBusinessEntity)();
    const [{ query: query }, routerActions] = (0, $kJlBc.useRouter)();
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const { updateQueryParam: updateQueryParam } = routerActions;
    const prevQuery = (0, $hzcvF.usePreviousWithInitial)(query);
    const [store, setStore] = (0, $eUqFw.useState)(()=>preferences.reduce((acc, preference)=>{
            let value;
            const { id: id, queryParameter: queryParameter } = preference;
            // if the URL has a preference value set
            // we prioritize those values over the persisted ones
            const queryValue = queryParameter && queryParameter.deserialize(query);
            if (queryValue) value = queryValue;
            else if (persistChanges) // if the view is persisting changes, restore the preferences from local storage
            value = preference.deserialize((0, $6YT9E.getPreference)(entity.id, view, preference.id));
            acc[id] = value;
            return acc;
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        }, {}));
    const setPreferenceValue = (0, $eUqFw.useCallback)((preference, value, action)=>{
        // set the new preference value in the store
        setStore((prevStore)=>{
            const newStore = {
                ...prevStore,
                [preference.id]: value
            };
            return newStore;
        });
        // if the preference serialises to the URL, update the URL
        if (preference.queryParameter && action !== 'none') updateQueryParam(preference.queryParameter.serialize(value), action);
        // if the view is persisting changes, update the preference in local storage
        if (persistChanges) {
            const serializedValue = preference.serialize(value);
            (0, $6YT9E.setPreference)(entity.id, view, preference.id, serializedValue);
        }
    }, [
        persistChanges,
        updateQueryParam,
        entity.id,
        view
    ]);
    (0, $eUqFw.useEffect)(()=>{
        // if the view is persisting changes, on initial mount
        // check all preferences that serialise to the URL, and set their values to the URL
        if (!persistChanges) return;
        let restoredQuery = {};
        for (const preference of preferences){
            const value = store[preference.id];
            if (value && preference.queryParameter) restoredQuery = {
                ...restoredQuery,
                ...preference.queryParameter.serialize(value)
            };
        }
        updateQueryParam({
            ...restoredQuery,
            ...query
        }, 'replace');
    // only run this effect on mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, $eUqFw.useEffect)(()=>{
        // this effect updates the store value only when the query has changed
        // we shouldn't run it when the component is mounting the first time
        // or when the query hasn't changed
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))(prevQuery, query)) {
            // update the store if the query is updated
            const newState = preferences.reduce((acc, preference)=>{
                const { id: id, queryParameter: queryParameter } = preference;
                if (queryParameter) {
                    const queryValue = queryParameter.deserialize(query);
                    acc[id] = queryValue;
                }
                return acc;
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            }, {});
            setStore({
                ...store,
                ...newState
            });
        }
    }, [
        preferences,
        query,
        store,
        entity.id,
        view,
        prevQuery
    ]);
    const contextValue = (0, $eUqFw.useMemo)(()=>({
            store: store,
            setPreferenceValue: setPreferenceValue
        }), [
        store,
        setPreferenceValue
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6117ab20ad9a3ccd$var$ViewPreferencesContext.Provider, {
        value: contextValue
    }, children);
};
const $6117ab20ad9a3ccd$export$ee494de6c0ff45d7 = (preference)=>{
    const { store: store, setPreferenceValue: setPreferenceValue } = (0, $eUqFw.useContext)($6117ab20ad9a3ccd$var$ViewPreferencesContext);
    const setValue = (0, $eUqFw.useCallback)((value, action = 'push')=>{
        setPreferenceValue(preference, value, action);
    }, [
        preference,
        setPreferenceValue
    ]);
    const value = store[preference.id];
    return [
        value,
        setValue
    ];
};

});
parcelRegister("6YT9E", function(module, exports) {

$parcel$export(module.exports, "setPreference", () => $e32968ac8498b8dc$export$c6483f3cdc3e51e1);
$parcel$export(module.exports, "getPreference", () => $e32968ac8498b8dc$export$5fa261395d19a143);

var $aZaPn = parcelRequire("aZaPn");
const $e32968ac8498b8dc$var$store = (0, $aZaPn.createLocalStorageProvider)('jwm-view-preferences');
const $e32968ac8498b8dc$var$buildPreferenceKey = (entityId, viewId, preferenceId)=>`${entityId}_${viewId}_${preferenceId}`;
const $e32968ac8498b8dc$export$c6483f3cdc3e51e1 = (entityId, viewId, preferenceId, value)=>{
    const key = $e32968ac8498b8dc$var$buildPreferenceKey(entityId, viewId, preferenceId);
    $e32968ac8498b8dc$var$store.set(key, value);
};
const $e32968ac8498b8dc$export$5fa261395d19a143 = (entityId, viewId, preferenceId)=>{
    const key = $e32968ac8498b8dc$var$buildPreferenceKey(entityId, viewId, preferenceId);
    return $e32968ac8498b8dc$var$store.get(key);
};

});


parcelRegister("psWLM", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c35a0f00b84642b$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7T0RP = parcelRequire("7T0RP");

var $yuXsW = parcelRequire("yuXsW");

var $7e8pf = parcelRequire("7e8pf");

var $cWd72 = parcelRequire("cWd72");

var $4G5xU = parcelRequire("4G5xU");

var $d3C6e = parcelRequire("d3C6e");

var $8WuJm = parcelRequire("8WuJm");
var $d6f6c = parcelRequire("d6f6c");

var $2nzpw = parcelRequire("2nzpw");

var $203kY = parcelRequire("203kY");

var $eTH8y = parcelRequire("eTH8y");

var $f4bDW = parcelRequire("f4bDW");

var $haDkv = parcelRequire("haDkv");
const $7c35a0f00b84642b$var$analyticsSourceName = 'timelineView';
const $7c35a0f00b84642b$export$3395082fff6e3088 = /*#__PURE__*/ (0, $eUqFw.memo)(()=>{
    const { hasInlineCreate: hasInlineCreate, hasFilterCustomFields: hasFilterCustomFields } = (0, $203kY.useTimelineFeatures)();
    const [{ timelineMode: timelineMode }] = (0, $eTH8y.useTimelineUI)();
    const analyticsAttributes = (0, $eUqFw.useMemo)(()=>({
            timelineMode: timelineMode
        }), [
        timelineMode
    ]);
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        objectType: "timeline",
        attributes: analyticsAttributes,
        sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a),
        sourceName: $7c35a0f00b84642b$var$analyticsSourceName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $haDkv.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireScreenAnalytics), null));
    const isUsingIssueTypesAndFields = hasInlineCreate || hasFilterCustomFields;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7e8pf.default), {
        withSidebar: true,
        withOverflow: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $yuXsW.ApolloClientProvider), {
        client: (0, $7T0RP.default)
    }, isUsingIssueTypesAndFields ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cWd72.IssueTypesAndFieldsContext), null, hasInlineCreate ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d3C6e.IssueCreateProvider), {
        mutation: (0, $f4bDW.CREATE_ISSUE_MUTATION),
        query: (0, $f4bDW.ISSUE_REFETCH_QUERY)
    }, content) : content) : content));
});
const $7c35a0f00b84642b$var$Timeline = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4G5xU.ExperienceErrorBoundary), {
        experience: (0, $2nzpw.MAIN_EXPERIENCE),
        shouldStartExperience: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7c35a0f00b84642b$export$3395082fff6e3088, null));
var $7c35a0f00b84642b$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($7c35a0f00b84642b$var$Timeline);

});
parcelRegister("7T0RP", function(module, exports) {

$parcel$export(module.exports, "default", () => $e42cc5e4608d3fe0$export$2e2bcd8739ae039);

var $illlw = parcelRequire("illlw");

var $2vRh6 = parcelRequire("2vRh6");

var $jlBDe = parcelRequire("jlBDe");

var $bvQX6 = parcelRequire("bvQX6");
var $5ECju = parcelRequire("5ECju");

var $aqG9W = parcelRequire("aqG9W");

var $35Kb7 = parcelRequire("35Kb7");

var $kcwGc = parcelRequire("kcwGc");

var $10n8H = parcelRequire("10n8H");

var $gUUjF = parcelRequire("gUUjF");

var $aXA7t = parcelRequire("aXA7t");

var $iV2Ac = parcelRequire("iV2Ac");

var $1ZkL6 = parcelRequire("1ZkL6");

var $9ypom = parcelRequire("9ypom");
const $e42cc5e4608d3fe0$var$GIRA_APOLLO_CLIENT_ID = 'gira';
const $e42cc5e4608d3fe0$var$CACHE_NAME = `apollo-cache/${$e42cc5e4608d3fe0$var$GIRA_APOLLO_CLIENT_ID}`;
const $e42cc5e4608d3fe0$var$LOG_NAMESPACE = `apollo.${$e42cc5e4608d3fe0$var$GIRA_APOLLO_CLIENT_ID}.error.graphql`;
const $e42cc5e4608d3fe0$var$isSsrSuccessful = ()=>false ? true : !window || !window.SPA_STATE;
const $e42cc5e4608d3fe0$var$NETWORK_ERRORS_COUNTER_KEY = 'networkErrorsCounter';
const $e42cc5e4608d3fe0$export$851a7159daf49c89 = new (0, $2vRh6.IntrospectionFragmentMatcher)({
    introspectionQueryResultData: (/*@__PURE__*/$parcel$interopDefault($iV2Ac))
});
const $e42cc5e4608d3fe0$var$errorLink = (0, $aqG9W.onError)(({ graphQLErrors: graphQLErrors, networkError: networkError, operation: operation })=>{
    // Ignore network errors as they will be logged in the retry link
    (0, $1ZkL6.reportErrors)({
        graphQLErrors: graphQLErrors,
        operation: operation
    });
    // Skip default error logging if analytics context data is defined for the query.
    const errorAnalytics = (0, $1ZkL6.getErrorAnalyticsContext)(operation.getContext());
    if (errorAnalytics !== undefined) return;
    if (graphQLErrors) {
        if (Array.isArray(graphQLErrors)) graphQLErrors.map(({ message: message, locations: locations, path: path })=>(0, $gUUjF.default).safeErrorWithoutCustomerData($e42cc5e4608d3fe0$var$LOG_NAMESPACE, `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`, {
                message: JSON.stringify(message),
                path: JSON.stringify(path),
                locations: JSON.stringify(locations)
            }));
        else (0, $gUUjF.default).safeErrorWithoutCustomerData($e42cc5e4608d3fe0$var$LOG_NAMESPACE, '[GraphQL error]: Unexpected error message format', {
            message: JSON.stringify(graphQLErrors)
        });
    }
    if (networkError) {
        const occuredNetworkErrorsBefore = (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(operation.getContext(), [
            $e42cc5e4608d3fe0$var$NETWORK_ERRORS_COUNTER_KEY
        ], 0);
        (0, $gUUjF.default).safeErrorWithoutCustomerData($e42cc5e4608d3fe0$var$LOG_NAMESPACE, `[Network error]: ${networkError}, attempt ${occuredNetworkErrorsBefore + 1}`);
        operation.setContext({
            [$e42cc5e4608d3fe0$var$NETWORK_ERRORS_COUNTER_KEY]: occuredNetworkErrorsBefore + 1
        });
    }
});
const $e42cc5e4608d3fe0$var$retryLinkWithFama = new (0, $kcwGc.RetryLink)({
    delay: {
        initial: 300,
        max: 120000,
        jitter: true
    },
    attempts: (count, operation, networkError)=>{
        const retry = count < 5 && networkError && !networkError.statusCode;
        // Don't report any error if we're going to attempt a retry
        if (!retry) (0, $1ZkL6.reportErrors)({
            networkError: networkError,
            operation: operation
        });
        return retry;
    }
});
class $e42cc5e4608d3fe0$var$CancelableRequestLink extends (0, $bvQX6.ApolloLink) {
    constructor(){
        super();
        this.inFlightRequestControllers = {};
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    request(operation, forward) {
        const context = operation.getContext();
        if (!context.cancelable) return forward(operation);
        const key = JSON.stringify([
            operation.operationName,
            operation.query
        ]); // Equivalent to `operation.toKey` less the _actual_ variables
        this.inFlightRequestControllers[key]?.abort(); // Always abort the previous request
        const abortController = new AbortController();
        operation.setContext({
            ...context,
            fetchOptions: {
                signal: abortController.signal
            } // HttpLink passes this directly to fetch implementation
        });
        this.inFlightRequestControllers[key] = abortController;
        const cleanup = ()=>{
            // This callback may be called long after the request is replaced
            if (this.inFlightRequestControllers[key] === abortController) delete this.inFlightRequestControllers[key];
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return new (0, $5ECju.default)((observer)=>{
            const subscription = forward(operation).subscribe({
                next: observer.next.bind(observer),
                // @ts-expect-error - TS7006 - Parameter 'error' implicitly has an 'any' type.
                error: (error)=>{
                    observer.error(error);
                    cleanup();
                },
                complete: observer.complete.bind(observer)
            });
            return ()=>{
                subscription?.unsubscribe();
                cleanup();
            };
        });
    }
}
const $e42cc5e4608d3fe0$var$cache = new (0, $2vRh6.InMemoryCache)({
    cacheRedirects: {
        Query: {
            ...(0, $10n8H.fragmentCacheRedirect)()
        }
    },
    fragmentMatcher: $e42cc5e4608d3fe0$export$851a7159daf49c89,
    dataIdFromObject: (object)=>object.id && `${object.id}${object.__typename}`
}).restore(!$e42cc5e4608d3fe0$var$isSsrSuccessful() && window.SPA_STATE[$e42cc5e4608d3fe0$var$CACHE_NAME] || {});
const $e42cc5e4608d3fe0$export$de66868aab9e79ea = (baseUrl)=>new (0, $jlBDe.ApolloClient)({
        name: $e42cc5e4608d3fe0$var$GIRA_APOLLO_CLIENT_ID,
        ssrMode: $e42cc5e4608d3fe0$var$isSsrSuccessful(),
        // @ts-expect-error - TS2345 - Argument of type '{ name: string; ssrMode: boolean; addTypename: boolean; link: ApolloLink; cache: InMemoryCache; connectToDevTools: boolean; }' is not assignable to parameter of type 'ApolloClientOptions<NormalizedCacheObject>'.
        addTypename: true,
        link: (0, $bvQX6.ApolloLink).from([
            $e42cc5e4608d3fe0$var$retryLinkWithFama,
            $e42cc5e4608d3fe0$var$errorLink,
            (0, $aXA7t.UFOLoggerLink),
            (0, $10n8H.fragmentLinkState)($e42cc5e4608d3fe0$var$cache),
            ...!$e42cc5e4608d3fe0$var$isSsrSuccessful() ? [
                new $e42cc5e4608d3fe0$var$CancelableRequestLink()
            ] : [],
            new (0, $35Kb7.HttpLink)({
                uri: ({ operationName: operationName })=>`${baseUrl}/rest/${$e42cc5e4608d3fe0$var$GIRA_APOLLO_CLIENT_ID}/1/?operation=${encodeURIComponent(operationName)}`,
                credentials: 'same-origin',
                // @ts-expect-error - TS2345 - Argument of type '{ uri: ({ operationName }: Operation) => string; credentials: string; abortErrorDoesNotCauseError: boolean; }' is not assignable to parameter of type 'Options'.
                abortErrorDoesNotCauseError: !$e42cc5e4608d3fe0$var$isSsrSuccessful()
            })
        ].filter(Boolean)),
        cache: $e42cc5e4608d3fe0$var$cache,
        connectToDevTools: false
    });
var $e42cc5e4608d3fe0$export$2e2bcd8739ae039 = {
    clientId: $e42cc5e4608d3fe0$var$GIRA_APOLLO_CLIENT_ID,
    clientCreator: $e42cc5e4608d3fe0$export$de66868aab9e79ea
};

});
parcelRegister("2vRh6", function(module, exports) {

$parcel$export(module.exports, "IntrospectionFragmentMatcher", () => $1d47cd4d9b8db33d$export$3b71c6b829c99d21);
$parcel$export(module.exports, "defaultDataIdFromObject", () => $1d47cd4d9b8db33d$export$bd03c5a9c99d6bce);
$parcel$export(module.exports, "InMemoryCache", () => $1d47cd4d9b8db33d$export$467265324939f47f);

var $fKE23 = parcelRequire("fKE23");

var $bO1Qv = parcelRequire("bO1Qv");

var $42BH7 = parcelRequire("42BH7");
var $66hGB = parcelRequire("66hGB");

var $7xYai = parcelRequire("7xYai");

var $8j2fP = parcelRequire("8j2fP");
var $1d47cd4d9b8db33d$var$haveWarned = false;
function $1d47cd4d9b8db33d$var$shouldWarn() {
    var answer = !$1d47cd4d9b8db33d$var$haveWarned;
    if (!(0, $42BH7.isTest)()) $1d47cd4d9b8db33d$var$haveWarned = true;
    return answer;
}
var $1d47cd4d9b8db33d$export$5d3fcf53267091de = function() {
    function HeuristicFragmentMatcher() {}
    HeuristicFragmentMatcher.prototype.ensureReady = function() {
        return Promise.resolve();
    };
    HeuristicFragmentMatcher.prototype.canBypassInit = function() {
        return true;
    };
    HeuristicFragmentMatcher.prototype.match = function(idValue, typeCondition, context) {
        var obj = context.store.get(idValue.id);
        var isRootQuery = idValue.id === 'ROOT_QUERY';
        if (!obj) return isRootQuery;
        var _a = obj.__typename, __typename = _a === void 0 ? isRootQuery && 'Query' : _a;
        if (!__typename) {
            $1d47cd4d9b8db33d$var$shouldWarn();
            return 'heuristic';
        }
        if (__typename === typeCondition) return true;
        $1d47cd4d9b8db33d$var$shouldWarn();
        return 'heuristic';
    };
    return HeuristicFragmentMatcher;
}();
var $1d47cd4d9b8db33d$export$3b71c6b829c99d21 = function() {
    function IntrospectionFragmentMatcher(options) {
        if (options && options.introspectionQueryResultData) {
            this.possibleTypesMap = this.parseIntrospectionResult(options.introspectionQueryResultData);
            this.isReady = true;
        } else this.isReady = false;
        this.match = this.match.bind(this);
    }
    IntrospectionFragmentMatcher.prototype.match = function(idValue, typeCondition, context) {
        (0, $8j2fP.invariant)(this.isReady, 1);
        var obj = context.store.get(idValue.id);
        var isRootQuery = idValue.id === 'ROOT_QUERY';
        if (!obj) return isRootQuery;
        var _a = obj.__typename, __typename = _a === void 0 ? isRootQuery && 'Query' : _a;
        (0, $8j2fP.invariant)(__typename, 2);
        if (__typename === typeCondition) return true;
        var implementingTypes = this.possibleTypesMap[typeCondition];
        if (__typename && implementingTypes && implementingTypes.indexOf(__typename) > -1) return true;
        return false;
    };
    IntrospectionFragmentMatcher.prototype.parseIntrospectionResult = function(introspectionResultData) {
        var typeMap = {};
        introspectionResultData.__schema.types.forEach(function(type) {
            if (type.kind === 'UNION' || type.kind === 'INTERFACE') typeMap[type.name] = type.possibleTypes.map(function(implementingType) {
                return implementingType.name;
            });
        });
        return typeMap;
    };
    return IntrospectionFragmentMatcher;
}();
var $1d47cd4d9b8db33d$var$hasOwn = Object.prototype.hasOwnProperty;
var $1d47cd4d9b8db33d$var$DepTrackingCache = function() {
    function DepTrackingCache(data) {
        var _this = this;
        if (data === void 0) data = Object.create(null);
        this.data = data;
        this.depend = (0, $7xYai.wrap)(function(dataId) {
            return _this.data[dataId];
        }, {
            disposable: true,
            makeCacheKey: function(dataId) {
                return dataId;
            }
        });
    }
    DepTrackingCache.prototype.toObject = function() {
        return this.data;
    };
    DepTrackingCache.prototype.get = function(dataId) {
        this.depend(dataId);
        return this.data[dataId];
    };
    DepTrackingCache.prototype.set = function(dataId, value) {
        var oldValue = this.data[dataId];
        if (value !== oldValue) {
            this.data[dataId] = value;
            this.depend.dirty(dataId);
        }
    };
    DepTrackingCache.prototype.delete = function(dataId) {
        if ($1d47cd4d9b8db33d$var$hasOwn.call(this.data, dataId)) {
            delete this.data[dataId];
            this.depend.dirty(dataId);
        }
    };
    DepTrackingCache.prototype.clear = function() {
        this.replace(null);
    };
    DepTrackingCache.prototype.replace = function(newData) {
        var _this = this;
        if (newData) {
            Object.keys(newData).forEach(function(dataId) {
                _this.set(dataId, newData[dataId]);
            });
            Object.keys(this.data).forEach(function(dataId) {
                if (!$1d47cd4d9b8db33d$var$hasOwn.call(newData, dataId)) _this.delete(dataId);
            });
        } else Object.keys(this.data).forEach(function(dataId) {
            _this.delete(dataId);
        });
    };
    return DepTrackingCache;
}();
function $1d47cd4d9b8db33d$var$defaultNormalizedCacheFactory(seed) {
    return new $1d47cd4d9b8db33d$var$DepTrackingCache(seed);
}
var $1d47cd4d9b8db33d$export$628ef07ba8965f12 = function() {
    function StoreReader(_a) {
        var _this = this;
        var _b = _a === void 0 ? {} : _a, _c = _b.cacheKeyRoot, cacheKeyRoot = _c === void 0 ? new (0, $7xYai.KeyTrie)((0, $42BH7.canUseWeakMap)) : _c, _d = _b.freezeResults, freezeResults = _d === void 0 ? false : _d;
        var _e = this, executeStoreQuery = _e.executeStoreQuery, executeSelectionSet = _e.executeSelectionSet, executeSubSelectedArray = _e.executeSubSelectedArray;
        this.freezeResults = freezeResults;
        this.executeStoreQuery = (0, $7xYai.wrap)(function(options) {
            return executeStoreQuery.call(_this, options);
        }, {
            makeCacheKey: function(_a) {
                var query = _a.query, rootValue = _a.rootValue, contextValue = _a.contextValue, variableValues = _a.variableValues, fragmentMatcher = _a.fragmentMatcher;
                if (contextValue.store instanceof $1d47cd4d9b8db33d$var$DepTrackingCache) return cacheKeyRoot.lookup(contextValue.store, query, fragmentMatcher, JSON.stringify(variableValues), rootValue.id);
            }
        });
        this.executeSelectionSet = (0, $7xYai.wrap)(function(options) {
            return executeSelectionSet.call(_this, options);
        }, {
            makeCacheKey: function(_a) {
                var selectionSet = _a.selectionSet, rootValue = _a.rootValue, execContext = _a.execContext;
                if (execContext.contextValue.store instanceof $1d47cd4d9b8db33d$var$DepTrackingCache) return cacheKeyRoot.lookup(execContext.contextValue.store, selectionSet, execContext.fragmentMatcher, JSON.stringify(execContext.variableValues), rootValue.id);
            }
        });
        this.executeSubSelectedArray = (0, $7xYai.wrap)(function(options) {
            return executeSubSelectedArray.call(_this, options);
        }, {
            makeCacheKey: function(_a) {
                var field = _a.field, array = _a.array, execContext = _a.execContext;
                if (execContext.contextValue.store instanceof $1d47cd4d9b8db33d$var$DepTrackingCache) return cacheKeyRoot.lookup(execContext.contextValue.store, field, array, JSON.stringify(execContext.variableValues));
            }
        });
    }
    StoreReader.prototype.readQueryFromStore = function(options) {
        return this.diffQueryAgainstStore((0, $fKE23.__assign)((0, $fKE23.__assign)({}, options), {
            returnPartialData: false
        })).result;
    };
    StoreReader.prototype.diffQueryAgainstStore = function(_a) {
        var store = _a.store, query = _a.query, variables = _a.variables, previousResult = _a.previousResult, _b = _a.returnPartialData, returnPartialData = _b === void 0 ? true : _b, _c = _a.rootId, rootId = _c === void 0 ? 'ROOT_QUERY' : _c, fragmentMatcherFunction = _a.fragmentMatcherFunction, config = _a.config;
        var queryDefinition = (0, $42BH7.getQueryDefinition)(query);
        variables = (0, $42BH7.assign)({}, (0, $42BH7.getDefaultValues)(queryDefinition), variables);
        var context = {
            store: store,
            dataIdFromObject: config && config.dataIdFromObject,
            cacheRedirects: config && config.cacheRedirects || {}
        };
        var execResult = this.executeStoreQuery({
            query: query,
            rootValue: {
                type: 'id',
                id: rootId,
                generated: true,
                typename: 'Query'
            },
            contextValue: context,
            variableValues: variables,
            fragmentMatcher: fragmentMatcherFunction
        });
        var hasMissingFields = execResult.missing && execResult.missing.length > 0;
        if (hasMissingFields && !returnPartialData) execResult.missing.forEach(function(info) {
            if (info.tolerable) return;
            throw new (0, $8j2fP.InvariantError)(8);
        });
        if (previousResult) {
            if ((0, $66hGB.equal)(previousResult, execResult.result)) execResult.result = previousResult;
        }
        return {
            result: execResult.result,
            complete: !hasMissingFields
        };
    };
    StoreReader.prototype.executeStoreQuery = function(_a) {
        var query = _a.query, rootValue = _a.rootValue, contextValue = _a.contextValue, variableValues = _a.variableValues, _b = _a.fragmentMatcher, fragmentMatcher = _b === void 0 ? $1d47cd4d9b8db33d$var$defaultFragmentMatcher : _b;
        var mainDefinition = (0, $42BH7.getMainDefinition)(query);
        var fragments = (0, $42BH7.getFragmentDefinitions)(query);
        var fragmentMap = (0, $42BH7.createFragmentMap)(fragments);
        var execContext = {
            query: query,
            fragmentMap: fragmentMap,
            contextValue: contextValue,
            variableValues: variableValues,
            fragmentMatcher: fragmentMatcher
        };
        return this.executeSelectionSet({
            selectionSet: mainDefinition.selectionSet,
            rootValue: rootValue,
            execContext: execContext
        });
    };
    StoreReader.prototype.executeSelectionSet = function(_a) {
        var _this = this;
        var selectionSet = _a.selectionSet, rootValue = _a.rootValue, execContext = _a.execContext;
        var fragmentMap = execContext.fragmentMap, contextValue = execContext.contextValue, variables = execContext.variableValues;
        var finalResult = {
            result: null
        };
        var objectsToMerge = [];
        var object = contextValue.store.get(rootValue.id);
        var typename = object && object.__typename || rootValue.id === 'ROOT_QUERY' && 'Query' || void 0;
        function handleMissing(result) {
            var _a;
            if (result.missing) {
                finalResult.missing = finalResult.missing || [];
                (_a = finalResult.missing).push.apply(_a, result.missing);
            }
            return result.result;
        }
        selectionSet.selections.forEach(function(selection) {
            var _a;
            if (!(0, $42BH7.shouldInclude)(selection, variables)) return;
            if ((0, $42BH7.isField)(selection)) {
                var fieldResult = handleMissing(_this.executeField(object, typename, selection, execContext));
                if (typeof fieldResult !== 'undefined') objectsToMerge.push((_a = {}, _a[(0, $42BH7.resultKeyNameFromField)(selection)] = fieldResult, _a));
            } else {
                var fragment = void 0;
                if ((0, $42BH7.isInlineFragment)(selection)) fragment = selection;
                else {
                    fragment = fragmentMap[selection.name.value];
                    if (!fragment) throw new (0, $8j2fP.InvariantError)(9);
                }
                var typeCondition = fragment.typeCondition && fragment.typeCondition.name.value;
                var match = !typeCondition || execContext.fragmentMatcher(rootValue, typeCondition, contextValue);
                if (match) {
                    var fragmentExecResult = _this.executeSelectionSet({
                        selectionSet: fragment.selectionSet,
                        rootValue: rootValue,
                        execContext: execContext
                    });
                    if (match === 'heuristic' && fragmentExecResult.missing) fragmentExecResult = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, fragmentExecResult), {
                        missing: fragmentExecResult.missing.map(function(info) {
                            return (0, $fKE23.__assign)((0, $fKE23.__assign)({}, info), {
                                tolerable: true
                            });
                        })
                    });
                    objectsToMerge.push(handleMissing(fragmentExecResult));
                }
            }
        });
        finalResult.result = (0, $42BH7.mergeDeepArray)(objectsToMerge);
        this.freezeResults;
        return finalResult;
    };
    StoreReader.prototype.executeField = function(object, typename, field, execContext) {
        var variables = execContext.variableValues, contextValue = execContext.contextValue;
        var fieldName = field.name.value;
        var args = (0, $42BH7.argumentsObjectFromField)(field, variables);
        var info = {
            resultKey: (0, $42BH7.resultKeyNameFromField)(field),
            directives: (0, $42BH7.getDirectiveInfoFromField)(field, variables)
        };
        var readStoreResult = $1d47cd4d9b8db33d$var$readStoreResolver(object, typename, fieldName, args, contextValue, info);
        if (Array.isArray(readStoreResult.result)) return this.combineExecResults(readStoreResult, this.executeSubSelectedArray({
            field: field,
            array: readStoreResult.result,
            execContext: execContext
        }));
        if (!field.selectionSet) {
            $1d47cd4d9b8db33d$var$assertSelectionSetForIdValue(field, readStoreResult.result);
            this.freezeResults;
            return readStoreResult;
        }
        if (readStoreResult.result == null) return readStoreResult;
        return this.combineExecResults(readStoreResult, this.executeSelectionSet({
            selectionSet: field.selectionSet,
            rootValue: readStoreResult.result,
            execContext: execContext
        }));
    };
    StoreReader.prototype.combineExecResults = function() {
        var execResults = [];
        for(var _i = 0; _i < arguments.length; _i++)execResults[_i] = arguments[_i];
        var missing;
        execResults.forEach(function(execResult) {
            if (execResult.missing) {
                missing = missing || [];
                missing.push.apply(missing, execResult.missing);
            }
        });
        return {
            result: execResults.pop().result,
            missing: missing
        };
    };
    StoreReader.prototype.executeSubSelectedArray = function(_a) {
        var _this = this;
        var field = _a.field, array = _a.array, execContext = _a.execContext;
        var missing;
        function handleMissing(childResult) {
            if (childResult.missing) {
                missing = missing || [];
                missing.push.apply(missing, childResult.missing);
            }
            return childResult.result;
        }
        array = array.map(function(item) {
            if (item === null) return null;
            if (Array.isArray(item)) return handleMissing(_this.executeSubSelectedArray({
                field: field,
                array: item,
                execContext: execContext
            }));
            if (field.selectionSet) return handleMissing(_this.executeSelectionSet({
                selectionSet: field.selectionSet,
                rootValue: item,
                execContext: execContext
            }));
            $1d47cd4d9b8db33d$var$assertSelectionSetForIdValue(field, item);
            return item;
        });
        this.freezeResults;
        return {
            result: array,
            missing: missing
        };
    };
    return StoreReader;
}();
function $1d47cd4d9b8db33d$var$assertSelectionSetForIdValue(field, value) {
    if (!field.selectionSet && (0, $42BH7.isIdValue)(value)) throw new (0, $8j2fP.InvariantError)(10);
}
function $1d47cd4d9b8db33d$var$defaultFragmentMatcher() {
    return true;
}
function $1d47cd4d9b8db33d$export$7a4899fe13f33235(idValue) {
    (0, $8j2fP.invariant)((0, $42BH7.isIdValue)(idValue), 11);
}
function $1d47cd4d9b8db33d$var$readStoreResolver(object, typename, fieldName, args, context, _a) {
    var resultKey = _a.resultKey, directives = _a.directives;
    var storeKeyName = fieldName;
    if (args || directives) storeKeyName = (0, $42BH7.getStoreKeyName)(storeKeyName, args, directives);
    var fieldValue = void 0;
    if (object) {
        fieldValue = object[storeKeyName];
        if (typeof fieldValue === 'undefined' && context.cacheRedirects && typeof typename === 'string') {
            var type = context.cacheRedirects[typename];
            if (type) {
                var resolver = type[fieldName];
                if (resolver) fieldValue = resolver(object, args, {
                    getCacheKey: function(storeObj) {
                        var id = context.dataIdFromObject(storeObj);
                        return id && (0, $42BH7.toIdValue)({
                            id: id,
                            typename: storeObj.__typename
                        });
                    }
                });
            }
        }
    }
    if (typeof fieldValue === 'undefined') return {
        result: fieldValue,
        missing: [
            {
                object: object,
                fieldName: storeKeyName,
                tolerable: false
            }
        ]
    };
    if ((0, $42BH7.isJsonValue)(fieldValue)) fieldValue = fieldValue.json;
    return {
        result: fieldValue
    };
}
var $1d47cd4d9b8db33d$export$ee7258b8691956a3 = function() {
    function ObjectCache(data) {
        if (data === void 0) data = Object.create(null);
        this.data = data;
    }
    ObjectCache.prototype.toObject = function() {
        return this.data;
    };
    ObjectCache.prototype.get = function(dataId) {
        return this.data[dataId];
    };
    ObjectCache.prototype.set = function(dataId, value) {
        this.data[dataId] = value;
    };
    ObjectCache.prototype.delete = function(dataId) {
        this.data[dataId] = void 0;
    };
    ObjectCache.prototype.clear = function() {
        this.data = Object.create(null);
    };
    ObjectCache.prototype.replace = function(newData) {
        this.data = newData || Object.create(null);
    };
    return ObjectCache;
}();
function $1d47cd4d9b8db33d$export$7e2b40d1002de152(seed) {
    return new $1d47cd4d9b8db33d$export$ee7258b8691956a3(seed);
}
var $1d47cd4d9b8db33d$export$de4e6870dc6ac801 = function(_super) {
    (0, $fKE23.__extends)(WriteError, _super);
    function WriteError() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = 'WriteError';
        return _this;
    }
    return WriteError;
}(Error);
function $1d47cd4d9b8db33d$export$fb86e3236e77e3(error, document) {
    var enhancedError = new $1d47cd4d9b8db33d$export$de4e6870dc6ac801("Error writing result to store for query:\n " + JSON.stringify(document));
    enhancedError.message += '\n' + error.message;
    enhancedError.stack = error.stack;
    return enhancedError;
}
var $1d47cd4d9b8db33d$export$eb8361c5d132fb8f = function() {
    function StoreWriter() {}
    StoreWriter.prototype.writeQueryToStore = function(_a) {
        var query = _a.query, result = _a.result, _b = _a.store, store = _b === void 0 ? $1d47cd4d9b8db33d$var$defaultNormalizedCacheFactory() : _b, variables = _a.variables, dataIdFromObject = _a.dataIdFromObject, fragmentMatcherFunction = _a.fragmentMatcherFunction;
        return this.writeResultToStore({
            dataId: 'ROOT_QUERY',
            result: result,
            document: query,
            store: store,
            variables: variables,
            dataIdFromObject: dataIdFromObject,
            fragmentMatcherFunction: fragmentMatcherFunction
        });
    };
    StoreWriter.prototype.writeResultToStore = function(_a) {
        var dataId = _a.dataId, result = _a.result, document = _a.document, _b = _a.store, store = _b === void 0 ? $1d47cd4d9b8db33d$var$defaultNormalizedCacheFactory() : _b, variables = _a.variables, dataIdFromObject = _a.dataIdFromObject, fragmentMatcherFunction = _a.fragmentMatcherFunction;
        var operationDefinition = (0, $42BH7.getOperationDefinition)(document);
        try {
            return this.writeSelectionSetToStore({
                result: result,
                dataId: dataId,
                selectionSet: operationDefinition.selectionSet,
                context: {
                    store: store,
                    processedData: {},
                    variables: (0, $42BH7.assign)({}, (0, $42BH7.getDefaultValues)(operationDefinition), variables),
                    dataIdFromObject: dataIdFromObject,
                    fragmentMap: (0, $42BH7.createFragmentMap)((0, $42BH7.getFragmentDefinitions)(document)),
                    fragmentMatcherFunction: fragmentMatcherFunction
                }
            });
        } catch (e) {
            throw $1d47cd4d9b8db33d$export$fb86e3236e77e3(e, document);
        }
    };
    StoreWriter.prototype.writeSelectionSetToStore = function(_a) {
        var _this = this;
        var result = _a.result, dataId = _a.dataId, selectionSet = _a.selectionSet, context = _a.context;
        var variables = context.variables, store = context.store, fragmentMap = context.fragmentMap;
        selectionSet.selections.forEach(function(selection) {
            var _a;
            if (!(0, $42BH7.shouldInclude)(selection, variables)) return;
            if ((0, $42BH7.isField)(selection)) {
                var resultFieldKey = (0, $42BH7.resultKeyNameFromField)(selection);
                var value = result[resultFieldKey];
                if (typeof value !== 'undefined') _this.writeFieldToStore({
                    dataId: dataId,
                    value: value,
                    field: selection,
                    context: context
                });
                else {
                    var isDefered = false;
                    var isClient = false;
                    if (selection.directives && selection.directives.length) {
                        isDefered = selection.directives.some(function(directive) {
                            return directive.name && directive.name.value === 'defer';
                        });
                        isClient = selection.directives.some(function(directive) {
                            return directive.name && directive.name.value === 'client';
                        });
                    }
                    !isDefered && !isClient && context.fragmentMatcherFunction;
                }
            } else {
                var fragment = void 0;
                if ((0, $42BH7.isInlineFragment)(selection)) fragment = selection;
                else {
                    fragment = (fragmentMap || {})[selection.name.value];
                    (0, $8j2fP.invariant)(fragment, 3);
                }
                var matches = true;
                if (context.fragmentMatcherFunction && fragment.typeCondition) {
                    var id = dataId || 'self';
                    var idValue = (0, $42BH7.toIdValue)({
                        id: id,
                        typename: undefined
                    });
                    var fakeContext = {
                        store: new $1d47cd4d9b8db33d$export$ee7258b8691956a3((_a = {}, _a[id] = result, _a)),
                        cacheRedirects: {}
                    };
                    var match = context.fragmentMatcherFunction(idValue, fragment.typeCondition.name.value, fakeContext);
                    !(0, $42BH7.isProduction)() && match;
                    matches = !!match;
                }
                if (matches) _this.writeSelectionSetToStore({
                    result: result,
                    selectionSet: fragment.selectionSet,
                    dataId: dataId,
                    context: context
                });
            }
        });
        return store;
    };
    StoreWriter.prototype.writeFieldToStore = function(_a) {
        var _b;
        var field = _a.field, value = _a.value, dataId = _a.dataId, context = _a.context;
        var variables = context.variables, dataIdFromObject = context.dataIdFromObject, store = context.store;
        var storeValue;
        var storeObject;
        var storeFieldName = (0, $42BH7.storeKeyNameFromField)(field, variables);
        if (!field.selectionSet || value === null) storeValue = value != null && typeof value === 'object' ? {
            type: 'json',
            json: value
        } : value;
        else if (Array.isArray(value)) {
            var generatedId = dataId + "." + storeFieldName;
            storeValue = this.processArrayValue(value, generatedId, field.selectionSet, context);
        } else {
            var valueDataId = dataId + "." + storeFieldName;
            var generated = true;
            if (!$1d47cd4d9b8db33d$var$isGeneratedId(valueDataId)) valueDataId = '$' + valueDataId;
            if (dataIdFromObject) {
                var semanticId = dataIdFromObject(value);
                (0, $8j2fP.invariant)(!semanticId || !$1d47cd4d9b8db33d$var$isGeneratedId(semanticId), 4);
                if (semanticId || typeof semanticId === 'number' && semanticId === 0) {
                    valueDataId = semanticId;
                    generated = false;
                }
            }
            if (!$1d47cd4d9b8db33d$var$isDataProcessed(valueDataId, field, context.processedData)) this.writeSelectionSetToStore({
                dataId: valueDataId,
                result: value,
                selectionSet: field.selectionSet,
                context: context
            });
            var typename = value.__typename;
            storeValue = (0, $42BH7.toIdValue)({
                id: valueDataId,
                typename: typename
            }, generated);
            storeObject = store.get(dataId);
            var escapedId = storeObject && storeObject[storeFieldName];
            if (escapedId !== storeValue && (0, $42BH7.isIdValue)(escapedId)) {
                var hadTypename = escapedId.typename !== undefined;
                var hasTypename = typename !== undefined;
                var typenameChanged = hadTypename && hasTypename && escapedId.typename !== typename;
                (0, $8j2fP.invariant)(!generated || escapedId.generated || typenameChanged, 5);
                (0, $8j2fP.invariant)(!hadTypename || hasTypename, 6);
                if (escapedId.generated) {
                    if (typenameChanged) {
                        if (!generated) store.delete(escapedId.id);
                    } else $1d47cd4d9b8db33d$var$mergeWithGenerated(escapedId.id, storeValue.id, store);
                }
            }
        }
        storeObject = store.get(dataId);
        if (!storeObject || !(0, $66hGB.equal)(storeValue, storeObject[storeFieldName])) store.set(dataId, (0, $fKE23.__assign)((0, $fKE23.__assign)({}, storeObject), (_b = {}, _b[storeFieldName] = storeValue, _b)));
    };
    StoreWriter.prototype.processArrayValue = function(value, generatedId, selectionSet, context) {
        var _this = this;
        return value.map(function(item, index) {
            if (item === null) return null;
            var itemDataId = generatedId + "." + index;
            if (Array.isArray(item)) return _this.processArrayValue(item, itemDataId, selectionSet, context);
            var generated = true;
            if (context.dataIdFromObject) {
                var semanticId = context.dataIdFromObject(item);
                if (semanticId) {
                    itemDataId = semanticId;
                    generated = false;
                }
            }
            if (!$1d47cd4d9b8db33d$var$isDataProcessed(itemDataId, selectionSet, context.processedData)) _this.writeSelectionSetToStore({
                dataId: itemDataId,
                result: item,
                selectionSet: selectionSet,
                context: context
            });
            return (0, $42BH7.toIdValue)({
                id: itemDataId,
                typename: item.__typename
            }, generated);
        });
    };
    return StoreWriter;
}();
function $1d47cd4d9b8db33d$var$isGeneratedId(id) {
    return id[0] === '$';
}
function $1d47cd4d9b8db33d$var$mergeWithGenerated(generatedKey, realKey, cache) {
    if (generatedKey === realKey) return false;
    var generated = cache.get(generatedKey);
    var real = cache.get(realKey);
    var madeChanges = false;
    Object.keys(generated).forEach(function(key) {
        var value = generated[key];
        var realValue = real[key];
        if ((0, $42BH7.isIdValue)(value) && $1d47cd4d9b8db33d$var$isGeneratedId(value.id) && (0, $42BH7.isIdValue)(realValue) && !(0, $66hGB.equal)(value, realValue) && $1d47cd4d9b8db33d$var$mergeWithGenerated(value.id, realValue.id, cache)) madeChanges = true;
    });
    cache.delete(generatedKey);
    var newRealValue = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, generated), real);
    if ((0, $66hGB.equal)(newRealValue, real)) return madeChanges;
    cache.set(realKey, newRealValue);
    return true;
}
function $1d47cd4d9b8db33d$var$isDataProcessed(dataId, field, processedData) {
    if (!processedData) return false;
    if (processedData[dataId]) {
        if (processedData[dataId].indexOf(field) >= 0) return true;
        else processedData[dataId].push(field);
    } else processedData[dataId] = [
        field
    ];
    return false;
}
var $1d47cd4d9b8db33d$var$defaultConfig = {
    fragmentMatcher: new $1d47cd4d9b8db33d$export$5d3fcf53267091de(),
    dataIdFromObject: $1d47cd4d9b8db33d$export$bd03c5a9c99d6bce,
    addTypename: true,
    resultCaching: true,
    freezeResults: false
};
function $1d47cd4d9b8db33d$export$bd03c5a9c99d6bce(result) {
    if (result.__typename) {
        if (result.id !== undefined) return result.__typename + ":" + result.id;
        if (result._id !== undefined) return result.__typename + ":" + result._id;
    }
    return null;
}
var $1d47cd4d9b8db33d$var$hasOwn$1 = Object.prototype.hasOwnProperty;
var $1d47cd4d9b8db33d$var$OptimisticCacheLayer = function(_super) {
    (0, $fKE23.__extends)(OptimisticCacheLayer, _super);
    function OptimisticCacheLayer(optimisticId, parent, transaction) {
        var _this = _super.call(this, Object.create(null)) || this;
        _this.optimisticId = optimisticId;
        _this.parent = parent;
        _this.transaction = transaction;
        return _this;
    }
    OptimisticCacheLayer.prototype.toObject = function() {
        return (0, $fKE23.__assign)((0, $fKE23.__assign)({}, this.parent.toObject()), this.data);
    };
    OptimisticCacheLayer.prototype.get = function(dataId) {
        return $1d47cd4d9b8db33d$var$hasOwn$1.call(this.data, dataId) ? this.data[dataId] : this.parent.get(dataId);
    };
    return OptimisticCacheLayer;
}($1d47cd4d9b8db33d$export$ee7258b8691956a3);
var $1d47cd4d9b8db33d$export$467265324939f47f = function(_super) {
    (0, $fKE23.__extends)(InMemoryCache, _super);
    function InMemoryCache(config) {
        if (config === void 0) config = {};
        var _this = _super.call(this) || this;
        _this.watches = new Set();
        _this.typenameDocumentCache = new Map();
        _this.cacheKeyRoot = new (0, $7xYai.KeyTrie)((0, $42BH7.canUseWeakMap));
        _this.silenceBroadcast = false;
        _this.config = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, $1d47cd4d9b8db33d$var$defaultConfig), config);
        if (_this.config.customResolvers) _this.config.cacheRedirects = _this.config.customResolvers;
        if (_this.config.cacheResolvers) _this.config.cacheRedirects = _this.config.cacheResolvers;
        _this.addTypename = !!_this.config.addTypename;
        _this.data = _this.config.resultCaching ? new $1d47cd4d9b8db33d$var$DepTrackingCache() : new $1d47cd4d9b8db33d$export$ee7258b8691956a3();
        _this.optimisticData = _this.data;
        _this.storeWriter = new $1d47cd4d9b8db33d$export$eb8361c5d132fb8f();
        _this.storeReader = new $1d47cd4d9b8db33d$export$628ef07ba8965f12({
            cacheKeyRoot: _this.cacheKeyRoot,
            freezeResults: config.freezeResults
        });
        var cache = _this;
        var maybeBroadcastWatch = cache.maybeBroadcastWatch;
        _this.maybeBroadcastWatch = (0, $7xYai.wrap)(function(c) {
            return maybeBroadcastWatch.call(_this, c);
        }, {
            makeCacheKey: function(c) {
                if (c.optimistic) return;
                if (c.previousResult) return;
                if (cache.data instanceof $1d47cd4d9b8db33d$var$DepTrackingCache) return cache.cacheKeyRoot.lookup(c.query, JSON.stringify(c.variables));
            }
        });
        return _this;
    }
    InMemoryCache.prototype.restore = function(data) {
        if (data) this.data.replace(data);
        return this;
    };
    InMemoryCache.prototype.extract = function(optimistic) {
        if (optimistic === void 0) optimistic = false;
        return (optimistic ? this.optimisticData : this.data).toObject();
    };
    InMemoryCache.prototype.read = function(options) {
        if (typeof options.rootId === 'string' && typeof this.data.get(options.rootId) === 'undefined') return null;
        var fragmentMatcher = this.config.fragmentMatcher;
        var fragmentMatcherFunction = fragmentMatcher && fragmentMatcher.match;
        return this.storeReader.readQueryFromStore({
            store: options.optimistic ? this.optimisticData : this.data,
            query: this.transformDocument(options.query),
            variables: options.variables,
            rootId: options.rootId,
            fragmentMatcherFunction: fragmentMatcherFunction,
            previousResult: options.previousResult,
            config: this.config
        }) || null;
    };
    InMemoryCache.prototype.write = function(write) {
        var fragmentMatcher = this.config.fragmentMatcher;
        var fragmentMatcherFunction = fragmentMatcher && fragmentMatcher.match;
        this.storeWriter.writeResultToStore({
            dataId: write.dataId,
            result: write.result,
            variables: write.variables,
            document: this.transformDocument(write.query),
            store: this.data,
            dataIdFromObject: this.config.dataIdFromObject,
            fragmentMatcherFunction: fragmentMatcherFunction
        });
        this.broadcastWatches();
    };
    InMemoryCache.prototype.diff = function(query) {
        var fragmentMatcher = this.config.fragmentMatcher;
        var fragmentMatcherFunction = fragmentMatcher && fragmentMatcher.match;
        return this.storeReader.diffQueryAgainstStore({
            store: query.optimistic ? this.optimisticData : this.data,
            query: this.transformDocument(query.query),
            variables: query.variables,
            returnPartialData: query.returnPartialData,
            previousResult: query.previousResult,
            fragmentMatcherFunction: fragmentMatcherFunction,
            config: this.config
        });
    };
    InMemoryCache.prototype.watch = function(watch) {
        var _this = this;
        this.watches.add(watch);
        return function() {
            _this.watches.delete(watch);
        };
    };
    InMemoryCache.prototype.evict = function(query) {
        throw new (0, $8j2fP.InvariantError)(7);
    };
    InMemoryCache.prototype.reset = function() {
        this.data.clear();
        this.broadcastWatches();
        return Promise.resolve();
    };
    InMemoryCache.prototype.removeOptimistic = function(idToRemove) {
        var toReapply = [];
        var removedCount = 0;
        var layer = this.optimisticData;
        while(layer instanceof $1d47cd4d9b8db33d$var$OptimisticCacheLayer){
            if (layer.optimisticId === idToRemove) ++removedCount;
            else toReapply.push(layer);
            layer = layer.parent;
        }
        if (removedCount > 0) {
            this.optimisticData = layer;
            while(toReapply.length > 0){
                var layer_1 = toReapply.pop();
                this.performTransaction(layer_1.transaction, layer_1.optimisticId);
            }
            this.broadcastWatches();
        }
    };
    InMemoryCache.prototype.performTransaction = function(transaction, optimisticId) {
        var _a = this, data = _a.data, silenceBroadcast = _a.silenceBroadcast;
        this.silenceBroadcast = true;
        if (typeof optimisticId === 'string') this.data = this.optimisticData = new $1d47cd4d9b8db33d$var$OptimisticCacheLayer(optimisticId, this.optimisticData, transaction);
        try {
            transaction(this);
        } finally{
            this.silenceBroadcast = silenceBroadcast;
            this.data = data;
        }
        this.broadcastWatches();
    };
    InMemoryCache.prototype.recordOptimisticTransaction = function(transaction, id) {
        return this.performTransaction(transaction, id);
    };
    InMemoryCache.prototype.transformDocument = function(document) {
        if (this.addTypename) {
            var result = this.typenameDocumentCache.get(document);
            if (!result) {
                result = (0, $42BH7.addTypenameToDocument)(document);
                this.typenameDocumentCache.set(document, result);
                this.typenameDocumentCache.set(result, result);
            }
            return result;
        }
        return document;
    };
    InMemoryCache.prototype.broadcastWatches = function() {
        var _this = this;
        if (!this.silenceBroadcast) this.watches.forEach(function(c) {
            return _this.maybeBroadcastWatch(c);
        });
    };
    InMemoryCache.prototype.maybeBroadcastWatch = function(c) {
        c.callback(this.diff({
            query: c.query,
            variables: c.variables,
            previousResult: c.previousResult && c.previousResult(),
            optimistic: c.optimistic
        }));
    };
    return InMemoryCache;
}((0, $bO1Qv.ApolloCache));

});
parcelRegister("bO1Qv", function(module, exports) {

$parcel$export(module.exports, "ApolloCache", () => $8985cbc47a37b971$export$5fc74f25506aa9c);

var $42BH7 = parcelRequire("42BH7");
function $8985cbc47a37b971$var$queryFromPojo(obj) {
    var op = {
        kind: 'OperationDefinition',
        operation: 'query',
        name: {
            kind: 'Name',
            value: 'GeneratedClientQuery'
        },
        selectionSet: $8985cbc47a37b971$var$selectionSetFromObj(obj)
    };
    var out = {
        kind: 'Document',
        definitions: [
            op
        ]
    };
    return out;
}
function $8985cbc47a37b971$var$fragmentFromPojo(obj, typename) {
    var frag = {
        kind: 'FragmentDefinition',
        typeCondition: {
            kind: 'NamedType',
            name: {
                kind: 'Name',
                value: typename || '__FakeType'
            }
        },
        name: {
            kind: 'Name',
            value: 'GeneratedClientQuery'
        },
        selectionSet: $8985cbc47a37b971$var$selectionSetFromObj(obj)
    };
    var out = {
        kind: 'Document',
        definitions: [
            frag
        ]
    };
    return out;
}
function $8985cbc47a37b971$var$selectionSetFromObj(obj) {
    if (typeof obj === 'number' || typeof obj === 'boolean' || typeof obj === 'string' || typeof obj === 'undefined' || obj === null) return null;
    if (Array.isArray(obj)) return $8985cbc47a37b971$var$selectionSetFromObj(obj[0]);
    var selections = [];
    Object.keys(obj).forEach(function(key) {
        var nestedSelSet = $8985cbc47a37b971$var$selectionSetFromObj(obj[key]);
        var field = {
            kind: 'Field',
            name: {
                kind: 'Name',
                value: key
            },
            selectionSet: nestedSelSet || undefined
        };
        selections.push(field);
    });
    var selectionSet = {
        kind: 'SelectionSet',
        selections: selections
    };
    return selectionSet;
}
var $8985cbc47a37b971$var$justTypenameQuery = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: null,
            variableDefinitions: null,
            directives: [],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        alias: null,
                        name: {
                            kind: 'Name',
                            value: '__typename'
                        },
                        arguments: [],
                        directives: [],
                        selectionSet: null
                    }
                ]
            }
        }
    ]
};
var $8985cbc47a37b971$export$5fc74f25506aa9c = function() {
    function ApolloCache() {}
    ApolloCache.prototype.transformDocument = function(document) {
        return document;
    };
    ApolloCache.prototype.transformForLink = function(document) {
        return document;
    };
    ApolloCache.prototype.readQuery = function(options, optimistic) {
        if (optimistic === void 0) optimistic = false;
        return this.read({
            query: options.query,
            variables: options.variables,
            optimistic: optimistic
        });
    };
    ApolloCache.prototype.readFragment = function(options, optimistic) {
        if (optimistic === void 0) optimistic = false;
        return this.read({
            query: (0, $42BH7.getFragmentQueryDocument)(options.fragment, options.fragmentName),
            variables: options.variables,
            rootId: options.id,
            optimistic: optimistic
        });
    };
    ApolloCache.prototype.writeQuery = function(options) {
        this.write({
            dataId: 'ROOT_QUERY',
            result: options.data,
            query: options.query,
            variables: options.variables
        });
    };
    ApolloCache.prototype.writeFragment = function(options) {
        this.write({
            dataId: options.id,
            result: options.data,
            variables: options.variables,
            query: (0, $42BH7.getFragmentQueryDocument)(options.fragment, options.fragmentName)
        });
    };
    ApolloCache.prototype.writeData = function(_a) {
        var id = _a.id, data = _a.data;
        if (typeof id !== 'undefined') {
            var typenameResult = null;
            try {
                typenameResult = this.read({
                    rootId: id,
                    optimistic: false,
                    query: $8985cbc47a37b971$var$justTypenameQuery
                });
            } catch (e) {}
            var __typename = typenameResult && typenameResult.__typename || '__ClientData';
            var dataToWrite = Object.assign({
                __typename: __typename
            }, data);
            this.writeFragment({
                id: id,
                fragment: $8985cbc47a37b971$var$fragmentFromPojo(dataToWrite, __typename),
                data: dataToWrite
            });
        } else this.writeQuery({
            query: $8985cbc47a37b971$var$queryFromPojo(data),
            data: data
        });
    };
    return ApolloCache;
}();
var $8985cbc47a37b971$export$94affb487e701bf2;
$8985cbc47a37b971$export$94affb487e701bf2 || ($8985cbc47a37b971$export$94affb487e701bf2 = {});

});
parcelRegister("42BH7", function(module, exports) {

$parcel$export(module.exports, "storeKeyNameFromField", () => $2f1496a7de754c2a$export$54be8689c65f3b56);
$parcel$export(module.exports, "getStoreKeyName", () => $2f1496a7de754c2a$export$3cdb6c178b88cabe);
$parcel$export(module.exports, "argumentsObjectFromField", () => $2f1496a7de754c2a$export$3f5a60fb6a781b4f);
$parcel$export(module.exports, "resultKeyNameFromField", () => $2f1496a7de754c2a$export$7d1ad22471852218);
$parcel$export(module.exports, "isField", () => $2f1496a7de754c2a$export$fb56ad75dd311c12);
$parcel$export(module.exports, "isInlineFragment", () => $2f1496a7de754c2a$export$22a1cdafaf27bcff);
$parcel$export(module.exports, "isIdValue", () => $2f1496a7de754c2a$export$e33b89a9aa87695);
$parcel$export(module.exports, "toIdValue", () => $2f1496a7de754c2a$export$b124f125e34d720a);
$parcel$export(module.exports, "isJsonValue", () => $2f1496a7de754c2a$export$226c1c6d1a5b660a);
$parcel$export(module.exports, "getDirectiveInfoFromField", () => $2f1496a7de754c2a$export$2a7f471142984a91);
$parcel$export(module.exports, "shouldInclude", () => $2f1496a7de754c2a$export$3dc388a5f013b4a5);
$parcel$export(module.exports, "hasDirectives", () => $2f1496a7de754c2a$export$2dafb573e282fe8d);
$parcel$export(module.exports, "hasClientExports", () => $2f1496a7de754c2a$export$8d1e9e5bbfa5d09a);
$parcel$export(module.exports, "getFragmentQueryDocument", () => $2f1496a7de754c2a$export$abbf37c7cf644e41);
$parcel$export(module.exports, "assign", () => $2f1496a7de754c2a$export$e6e34fd1f2686227);
$parcel$export(module.exports, "checkDocument", () => $2f1496a7de754c2a$export$a7d0d8111d2386df);
$parcel$export(module.exports, "getOperationDefinition", () => $2f1496a7de754c2a$export$7a5b1fa979d2c158);
$parcel$export(module.exports, "getOperationName", () => $2f1496a7de754c2a$export$41bca9dc6871dd4e);
$parcel$export(module.exports, "getFragmentDefinitions", () => $2f1496a7de754c2a$export$5320a7ba9466a3df);
$parcel$export(module.exports, "getQueryDefinition", () => $2f1496a7de754c2a$export$d96b2213c1b9d3a9);
$parcel$export(module.exports, "getMainDefinition", () => $2f1496a7de754c2a$export$f431198736b7f96d);
$parcel$export(module.exports, "createFragmentMap", () => $2f1496a7de754c2a$export$193789b4c8246dd4);
$parcel$export(module.exports, "getDefaultValues", () => $2f1496a7de754c2a$export$84c19026e616569e);
$parcel$export(module.exports, "removeDirectivesFromDocument", () => $2f1496a7de754c2a$export$e5ae0530da5fe96c);
$parcel$export(module.exports, "addTypenameToDocument", () => $2f1496a7de754c2a$export$43b332f87950a467);
$parcel$export(module.exports, "removeConnectionDirectiveFromDocument", () => $2f1496a7de754c2a$export$74985f3324559867);
$parcel$export(module.exports, "buildQueryFromSelectionSet", () => $2f1496a7de754c2a$export$57c368c23873f32b);
$parcel$export(module.exports, "removeClientSetsFromDocument", () => $2f1496a7de754c2a$export$8eae69e876ee321e);
$parcel$export(module.exports, "canUseWeakMap", () => $2f1496a7de754c2a$export$772fbc04a0ad4ce9);
$parcel$export(module.exports, "cloneDeep", () => $2f1496a7de754c2a$export$629a2bd3f5a49ecc);
$parcel$export(module.exports, "isProduction", () => $2f1496a7de754c2a$export$f15d00aa73aafac4);
$parcel$export(module.exports, "isTest", () => $2f1496a7de754c2a$export$410cbc2864fa25b5);
$parcel$export(module.exports, "tryFunctionOrLogError", () => $2f1496a7de754c2a$export$50a91acae4904909);
$parcel$export(module.exports, "graphQLResultHasError", () => $2f1496a7de754c2a$export$b4df399e879e53ab);
$parcel$export(module.exports, "mergeDeep", () => $2f1496a7de754c2a$export$dd702b3c8240390c);
$parcel$export(module.exports, "mergeDeepArray", () => $2f1496a7de754c2a$export$160070228be94b08);

var $961BR = parcelRequire("961BR");

var $8j2fP = parcelRequire("8j2fP");

var $fKE23 = parcelRequire("fKE23");

var $cGs0N = parcelRequire("cGs0N");

var $66hGB = parcelRequire("66hGB");

var $2fFJv = parcelRequire("2fFJv");
function $2f1496a7de754c2a$export$dc071f102752d0eb(value) {
    return [
        'StringValue',
        'BooleanValue',
        'EnumValue'
    ].indexOf(value.kind) > -1;
}
function $2f1496a7de754c2a$export$3ff5e9927c3257c6(value) {
    return [
        'IntValue',
        'FloatValue'
    ].indexOf(value.kind) > -1;
}
function $2f1496a7de754c2a$var$isStringValue(value) {
    return value.kind === 'StringValue';
}
function $2f1496a7de754c2a$var$isBooleanValue(value) {
    return value.kind === 'BooleanValue';
}
function $2f1496a7de754c2a$var$isIntValue(value) {
    return value.kind === 'IntValue';
}
function $2f1496a7de754c2a$var$isFloatValue(value) {
    return value.kind === 'FloatValue';
}
function $2f1496a7de754c2a$var$isVariable(value) {
    return value.kind === 'Variable';
}
function $2f1496a7de754c2a$var$isObjectValue(value) {
    return value.kind === 'ObjectValue';
}
function $2f1496a7de754c2a$var$isListValue(value) {
    return value.kind === 'ListValue';
}
function $2f1496a7de754c2a$var$isEnumValue(value) {
    return value.kind === 'EnumValue';
}
function $2f1496a7de754c2a$var$isNullValue(value) {
    return value.kind === 'NullValue';
}
function $2f1496a7de754c2a$export$a1dab82d368d6525(argObj, name, value, variables) {
    if ($2f1496a7de754c2a$var$isIntValue(value) || $2f1496a7de754c2a$var$isFloatValue(value)) argObj[name.value] = Number(value.value);
    else if ($2f1496a7de754c2a$var$isBooleanValue(value) || $2f1496a7de754c2a$var$isStringValue(value)) argObj[name.value] = value.value;
    else if ($2f1496a7de754c2a$var$isObjectValue(value)) {
        var nestedArgObj_1 = {};
        value.fields.map(function(obj) {
            return $2f1496a7de754c2a$export$a1dab82d368d6525(nestedArgObj_1, obj.name, obj.value, variables);
        });
        argObj[name.value] = nestedArgObj_1;
    } else if ($2f1496a7de754c2a$var$isVariable(value)) {
        var variableValue = (variables || {})[value.name.value];
        argObj[name.value] = variableValue;
    } else if ($2f1496a7de754c2a$var$isListValue(value)) argObj[name.value] = value.values.map(function(listValue) {
        var nestedArgArrayObj = {};
        $2f1496a7de754c2a$export$a1dab82d368d6525(nestedArgArrayObj, name, listValue, variables);
        return nestedArgArrayObj[name.value];
    });
    else if ($2f1496a7de754c2a$var$isEnumValue(value)) argObj[name.value] = value.value;
    else if ($2f1496a7de754c2a$var$isNullValue(value)) argObj[name.value] = null;
    else throw new (0, $8j2fP.InvariantError)(17);
}
function $2f1496a7de754c2a$export$54be8689c65f3b56(field, variables) {
    var directivesObj = null;
    if (field.directives) {
        directivesObj = {};
        field.directives.forEach(function(directive) {
            directivesObj[directive.name.value] = {};
            if (directive.arguments) directive.arguments.forEach(function(_a) {
                var name = _a.name, value = _a.value;
                return $2f1496a7de754c2a$export$a1dab82d368d6525(directivesObj[directive.name.value], name, value, variables);
            });
        });
    }
    var argObj = null;
    if (field.arguments && field.arguments.length) {
        argObj = {};
        field.arguments.forEach(function(_a) {
            var name = _a.name, value = _a.value;
            return $2f1496a7de754c2a$export$a1dab82d368d6525(argObj, name, value, variables);
        });
    }
    return $2f1496a7de754c2a$export$3cdb6c178b88cabe(field.name.value, argObj, directivesObj);
}
var $2f1496a7de754c2a$var$KNOWN_DIRECTIVES = [
    'connection',
    'include',
    'skip',
    'client',
    'rest',
    'export'
];
function $2f1496a7de754c2a$export$3cdb6c178b88cabe(fieldName, args, directives) {
    if (directives && directives['connection'] && directives['connection']['key']) {
        if (directives['connection']['filter'] && directives['connection']['filter'].length > 0) {
            var filterKeys = directives['connection']['filter'] ? directives['connection']['filter'] : [];
            filterKeys.sort();
            var queryArgs_1 = args;
            var filteredArgs_1 = {};
            filterKeys.forEach(function(key) {
                filteredArgs_1[key] = queryArgs_1[key];
            });
            return directives['connection']['key'] + "(" + JSON.stringify(filteredArgs_1) + ")";
        } else return directives['connection']['key'];
    }
    var completeFieldName = fieldName;
    if (args) {
        var stringifiedArgs = (0, (/*@__PURE__*/$parcel$interopDefault($cGs0N)))(args);
        completeFieldName += "(" + stringifiedArgs + ")";
    }
    if (directives) Object.keys(directives).forEach(function(key) {
        if ($2f1496a7de754c2a$var$KNOWN_DIRECTIVES.indexOf(key) !== -1) return;
        if (directives[key] && Object.keys(directives[key]).length) completeFieldName += "@" + key + "(" + JSON.stringify(directives[key]) + ")";
        else completeFieldName += "@" + key;
    });
    return completeFieldName;
}
function $2f1496a7de754c2a$export$3f5a60fb6a781b4f(field, variables) {
    if (field.arguments && field.arguments.length) {
        var argObj_1 = {};
        field.arguments.forEach(function(_a) {
            var name = _a.name, value = _a.value;
            return $2f1496a7de754c2a$export$a1dab82d368d6525(argObj_1, name, value, variables);
        });
        return argObj_1;
    }
    return null;
}
function $2f1496a7de754c2a$export$7d1ad22471852218(field) {
    return field.alias ? field.alias.value : field.name.value;
}
function $2f1496a7de754c2a$export$fb56ad75dd311c12(selection) {
    return selection.kind === 'Field';
}
function $2f1496a7de754c2a$export$22a1cdafaf27bcff(selection) {
    return selection.kind === 'InlineFragment';
}
function $2f1496a7de754c2a$export$e33b89a9aa87695(idObject) {
    return idObject && idObject.type === 'id' && typeof idObject.generated === 'boolean';
}
function $2f1496a7de754c2a$export$b124f125e34d720a(idConfig, generated) {
    if (generated === void 0) generated = false;
    return (0, $fKE23.__assign)({
        type: 'id',
        generated: generated
    }, typeof idConfig === 'string' ? {
        id: idConfig,
        typename: undefined
    } : idConfig);
}
function $2f1496a7de754c2a$export$226c1c6d1a5b660a(jsonObject) {
    return jsonObject != null && typeof jsonObject === 'object' && jsonObject.type === 'json';
}
function $2f1496a7de754c2a$var$defaultValueFromVariable(node) {
    throw new (0, $8j2fP.InvariantError)(18);
}
function $2f1496a7de754c2a$export$b3db129ed867b445(node, onVariable) {
    if (onVariable === void 0) onVariable = $2f1496a7de754c2a$var$defaultValueFromVariable;
    switch(node.kind){
        case 'Variable':
            return onVariable(node);
        case 'NullValue':
            return null;
        case 'IntValue':
            return parseInt(node.value, 10);
        case 'FloatValue':
            return parseFloat(node.value);
        case 'ListValue':
            return node.values.map(function(v) {
                return $2f1496a7de754c2a$export$b3db129ed867b445(v, onVariable);
            });
        case 'ObjectValue':
            var value = {};
            for(var _i = 0, _a = node.fields; _i < _a.length; _i++){
                var field = _a[_i];
                value[field.name.value] = $2f1496a7de754c2a$export$b3db129ed867b445(field.value, onVariable);
            }
            return value;
        default:
            return node.value;
    }
}
function $2f1496a7de754c2a$export$2a7f471142984a91(field, variables) {
    if (field.directives && field.directives.length) {
        var directiveObj_1 = {};
        field.directives.forEach(function(directive) {
            directiveObj_1[directive.name.value] = $2f1496a7de754c2a$export$3f5a60fb6a781b4f(directive, variables);
        });
        return directiveObj_1;
    }
    return null;
}
function $2f1496a7de754c2a$export$3dc388a5f013b4a5(selection, variables) {
    if (variables === void 0) variables = {};
    return $2f1496a7de754c2a$export$b7bdffb7e6f1ef53(selection.directives).every(function(_a) {
        var directive = _a.directive, ifArgument = _a.ifArgument;
        var evaledValue = false;
        if (ifArgument.value.kind === 'Variable') {
            evaledValue = variables[ifArgument.value.name.value];
            (0, $8j2fP.invariant)(evaledValue !== void 0, 13);
        } else evaledValue = ifArgument.value.value;
        return directive.name.value === 'skip' ? !evaledValue : evaledValue;
    });
}
function $2f1496a7de754c2a$export$1b217de6ce18b9a(doc) {
    var names = [];
    (0, $961BR.visit)(doc, {
        Directive: function(node) {
            names.push(node.name.value);
        }
    });
    return names;
}
function $2f1496a7de754c2a$export$2dafb573e282fe8d(names, doc) {
    return $2f1496a7de754c2a$export$1b217de6ce18b9a(doc).some(function(name) {
        return names.indexOf(name) > -1;
    });
}
function $2f1496a7de754c2a$export$8d1e9e5bbfa5d09a(document) {
    return document && $2f1496a7de754c2a$export$2dafb573e282fe8d([
        'client'
    ], document) && $2f1496a7de754c2a$export$2dafb573e282fe8d([
        'export'
    ], document);
}
function $2f1496a7de754c2a$var$isInclusionDirective(_a) {
    var value = _a.name.value;
    return value === 'skip' || value === 'include';
}
function $2f1496a7de754c2a$export$b7bdffb7e6f1ef53(directives) {
    return directives ? directives.filter($2f1496a7de754c2a$var$isInclusionDirective).map(function(directive) {
        var directiveArguments = directive.arguments;
        var directiveName = directive.name.value;
        (0, $8j2fP.invariant)(directiveArguments && directiveArguments.length === 1, 14);
        var ifArgument = directiveArguments[0];
        (0, $8j2fP.invariant)(ifArgument.name && ifArgument.name.value === 'if', 15);
        var ifValue = ifArgument.value;
        (0, $8j2fP.invariant)(ifValue && (ifValue.kind === 'Variable' || ifValue.kind === 'BooleanValue'), 16);
        return {
            directive: directive,
            ifArgument: ifArgument
        };
    }) : [];
}
function $2f1496a7de754c2a$export$abbf37c7cf644e41(document, fragmentName) {
    var actualFragmentName = fragmentName;
    var fragments = [];
    document.definitions.forEach(function(definition) {
        if (definition.kind === 'OperationDefinition') throw new (0, $8j2fP.InvariantError)(11);
        if (definition.kind === 'FragmentDefinition') fragments.push(definition);
    });
    if (typeof actualFragmentName === 'undefined') {
        (0, $8j2fP.invariant)(fragments.length === 1, 12);
        actualFragmentName = fragments[0].name.value;
    }
    var query = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, document), {
        definitions: (0, $fKE23.__spreadArrays)([
            {
                kind: 'OperationDefinition',
                operation: 'query',
                selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                        {
                            kind: 'FragmentSpread',
                            name: {
                                kind: 'Name',
                                value: actualFragmentName
                            }
                        }
                    ]
                }
            }
        ], document.definitions)
    });
    return query;
}
function $2f1496a7de754c2a$export$e6e34fd1f2686227(target) {
    var sources = [];
    for(var _i = 1; _i < arguments.length; _i++)sources[_i - 1] = arguments[_i];
    sources.forEach(function(source) {
        if (typeof source === 'undefined' || source === null) return;
        Object.keys(source).forEach(function(key) {
            target[key] = source[key];
        });
    });
    return target;
}
function $2f1496a7de754c2a$export$a92e7a440b22bdf0(doc) {
    $2f1496a7de754c2a$export$a7d0d8111d2386df(doc);
    var mutationDef = doc.definitions.filter(function(definition) {
        return definition.kind === 'OperationDefinition' && definition.operation === 'mutation';
    })[0];
    (0, $8j2fP.invariant)(mutationDef, 1);
    return mutationDef;
}
function $2f1496a7de754c2a$export$a7d0d8111d2386df(doc) {
    (0, $8j2fP.invariant)(doc && doc.kind === 'Document', 2);
    var operations = doc.definitions.filter(function(d) {
        return d.kind !== 'FragmentDefinition';
    }).map(function(definition) {
        if (definition.kind !== 'OperationDefinition') throw new (0, $8j2fP.InvariantError)(3);
        return definition;
    });
    (0, $8j2fP.invariant)(operations.length <= 1, 4);
    return doc;
}
function $2f1496a7de754c2a$export$7a5b1fa979d2c158(doc) {
    $2f1496a7de754c2a$export$a7d0d8111d2386df(doc);
    return doc.definitions.filter(function(definition) {
        return definition.kind === 'OperationDefinition';
    })[0];
}
function $2f1496a7de754c2a$export$78a8e95d8d43ad7f(document) {
    var def = $2f1496a7de754c2a$export$7a5b1fa979d2c158(document);
    (0, $8j2fP.invariant)(def, 5);
    return def;
}
function $2f1496a7de754c2a$export$41bca9dc6871dd4e(doc) {
    return doc.definitions.filter(function(definition) {
        return definition.kind === 'OperationDefinition' && definition.name;
    }).map(function(x) {
        return x.name.value;
    })[0] || null;
}
function $2f1496a7de754c2a$export$5320a7ba9466a3df(doc) {
    return doc.definitions.filter(function(definition) {
        return definition.kind === 'FragmentDefinition';
    });
}
function $2f1496a7de754c2a$export$d96b2213c1b9d3a9(doc) {
    var queryDef = $2f1496a7de754c2a$export$7a5b1fa979d2c158(doc);
    (0, $8j2fP.invariant)(queryDef && queryDef.operation === 'query', 6);
    return queryDef;
}
function $2f1496a7de754c2a$export$772111caef41b3f5(doc) {
    (0, $8j2fP.invariant)(doc.kind === 'Document', 7);
    (0, $8j2fP.invariant)(doc.definitions.length <= 1, 8);
    var fragmentDef = doc.definitions[0];
    (0, $8j2fP.invariant)(fragmentDef.kind === 'FragmentDefinition', 9);
    return fragmentDef;
}
function $2f1496a7de754c2a$export$f431198736b7f96d(queryDoc) {
    $2f1496a7de754c2a$export$a7d0d8111d2386df(queryDoc);
    var fragmentDefinition;
    for(var _i = 0, _a = queryDoc.definitions; _i < _a.length; _i++){
        var definition = _a[_i];
        if (definition.kind === 'OperationDefinition') {
            var operation = definition.operation;
            if (operation === 'query' || operation === 'mutation' || operation === 'subscription') return definition;
        }
        if (definition.kind === 'FragmentDefinition' && !fragmentDefinition) fragmentDefinition = definition;
    }
    if (fragmentDefinition) return fragmentDefinition;
    throw new (0, $8j2fP.InvariantError)(10);
}
function $2f1496a7de754c2a$export$193789b4c8246dd4(fragments) {
    if (fragments === void 0) fragments = [];
    var symTable = {};
    fragments.forEach(function(fragment) {
        symTable[fragment.name.value] = fragment;
    });
    return symTable;
}
function $2f1496a7de754c2a$export$84c19026e616569e(definition) {
    if (definition && definition.variableDefinitions && definition.variableDefinitions.length) {
        var defaultValues = definition.variableDefinitions.filter(function(_a) {
            var defaultValue = _a.defaultValue;
            return defaultValue;
        }).map(function(_a) {
            var variable = _a.variable, defaultValue = _a.defaultValue;
            var defaultValueObj = {};
            $2f1496a7de754c2a$export$a1dab82d368d6525(defaultValueObj, variable.name, defaultValue);
            return defaultValueObj;
        });
        return $2f1496a7de754c2a$export$e6e34fd1f2686227.apply(void 0, (0, $fKE23.__spreadArrays)([
            {}
        ], defaultValues));
    }
    return {};
}
function $2f1496a7de754c2a$export$55ead6c9e4eac970(operation) {
    var names = new Set();
    if (operation.variableDefinitions) for(var _i = 0, _a = operation.variableDefinitions; _i < _a.length; _i++){
        var definition = _a[_i];
        names.add(definition.variable.name.value);
    }
    return names;
}
function $2f1496a7de754c2a$var$filterInPlace(array, test, context) {
    var target = 0;
    array.forEach(function(elem, i) {
        if (test.call(this, elem, i, array)) array[target++] = elem;
    }, context);
    array.length = target;
    return array;
}
var $2f1496a7de754c2a$var$TYPENAME_FIELD = {
    kind: 'Field',
    name: {
        kind: 'Name',
        value: '__typename'
    }
};
function $2f1496a7de754c2a$var$isEmpty(op, fragments) {
    return op.selectionSet.selections.every(function(selection) {
        return selection.kind === 'FragmentSpread' && $2f1496a7de754c2a$var$isEmpty(fragments[selection.name.value], fragments);
    });
}
function $2f1496a7de754c2a$var$nullIfDocIsEmpty(doc) {
    return $2f1496a7de754c2a$var$isEmpty($2f1496a7de754c2a$export$7a5b1fa979d2c158(doc) || $2f1496a7de754c2a$export$772111caef41b3f5(doc), $2f1496a7de754c2a$export$193789b4c8246dd4($2f1496a7de754c2a$export$5320a7ba9466a3df(doc))) ? null : doc;
}
function $2f1496a7de754c2a$var$getDirectiveMatcher(directives) {
    return function directiveMatcher(directive) {
        return directives.some(function(dir) {
            return dir.name && dir.name === directive.name.value || dir.test && dir.test(directive);
        });
    };
}
function $2f1496a7de754c2a$export$e5ae0530da5fe96c(directives, doc) {
    var variablesInUse = Object.create(null);
    var variablesToRemove = [];
    var fragmentSpreadsInUse = Object.create(null);
    var fragmentSpreadsToRemove = [];
    var modifiedDoc = $2f1496a7de754c2a$var$nullIfDocIsEmpty((0, $961BR.visit)(doc, {
        Variable: {
            enter: function(node, _key, parent) {
                if (parent.kind !== 'VariableDefinition') variablesInUse[node.name.value] = true;
            }
        },
        Field: {
            enter: function(node) {
                if (directives && node.directives) {
                    var shouldRemoveField = directives.some(function(directive) {
                        return directive.remove;
                    });
                    if (shouldRemoveField && node.directives && node.directives.some($2f1496a7de754c2a$var$getDirectiveMatcher(directives))) {
                        if (node.arguments) node.arguments.forEach(function(arg) {
                            if (arg.value.kind === 'Variable') variablesToRemove.push({
                                name: arg.value.name.value
                            });
                        });
                        if (node.selectionSet) $2f1496a7de754c2a$var$getAllFragmentSpreadsFromSelectionSet(node.selectionSet).forEach(function(frag) {
                            fragmentSpreadsToRemove.push({
                                name: frag.name.value
                            });
                        });
                        return null;
                    }
                }
            }
        },
        FragmentSpread: {
            enter: function(node) {
                fragmentSpreadsInUse[node.name.value] = true;
            }
        },
        Directive: {
            enter: function(node) {
                if ($2f1496a7de754c2a$var$getDirectiveMatcher(directives)(node)) return null;
            }
        }
    }));
    if (modifiedDoc && $2f1496a7de754c2a$var$filterInPlace(variablesToRemove, function(v) {
        return !variablesInUse[v.name];
    }).length) modifiedDoc = $2f1496a7de754c2a$export$ecd5bb739c4a8b38(variablesToRemove, modifiedDoc);
    if (modifiedDoc && $2f1496a7de754c2a$var$filterInPlace(fragmentSpreadsToRemove, function(fs) {
        return !fragmentSpreadsInUse[fs.name];
    }).length) modifiedDoc = $2f1496a7de754c2a$export$7c9d17c333033c13(fragmentSpreadsToRemove, modifiedDoc);
    return modifiedDoc;
}
function $2f1496a7de754c2a$export$43b332f87950a467(doc) {
    return (0, $961BR.visit)($2f1496a7de754c2a$export$a7d0d8111d2386df(doc), {
        SelectionSet: {
            enter: function(node, _key, parent) {
                if (parent && parent.kind === 'OperationDefinition') return;
                var selections = node.selections;
                if (!selections) return;
                var skip = selections.some(function(selection) {
                    return $2f1496a7de754c2a$export$fb56ad75dd311c12(selection) && (selection.name.value === '__typename' || selection.name.value.lastIndexOf('__', 0) === 0);
                });
                if (skip) return;
                var field = parent;
                if ($2f1496a7de754c2a$export$fb56ad75dd311c12(field) && field.directives && field.directives.some(function(d) {
                    return d.name.value === 'export';
                })) return;
                return (0, $fKE23.__assign)((0, $fKE23.__assign)({}, node), {
                    selections: (0, $fKE23.__spreadArrays)(selections, [
                        $2f1496a7de754c2a$var$TYPENAME_FIELD
                    ])
                });
            }
        }
    });
}
var $2f1496a7de754c2a$var$connectionRemoveConfig = {
    test: function(directive) {
        var willRemove = directive.name.value === 'connection';
        if (willRemove) !directive.arguments || directive.arguments.some(function(arg) {
            return arg.name.value === 'key';
        });
        return willRemove;
    }
};
function $2f1496a7de754c2a$export$74985f3324559867(doc) {
    return $2f1496a7de754c2a$export$e5ae0530da5fe96c([
        $2f1496a7de754c2a$var$connectionRemoveConfig
    ], $2f1496a7de754c2a$export$a7d0d8111d2386df(doc));
}
function $2f1496a7de754c2a$var$hasDirectivesInSelectionSet(directives, selectionSet, nestedCheck) {
    if (nestedCheck === void 0) nestedCheck = true;
    return selectionSet && selectionSet.selections && selectionSet.selections.some(function(selection) {
        return $2f1496a7de754c2a$var$hasDirectivesInSelection(directives, selection, nestedCheck);
    });
}
function $2f1496a7de754c2a$var$hasDirectivesInSelection(directives, selection, nestedCheck) {
    if (nestedCheck === void 0) nestedCheck = true;
    if (!$2f1496a7de754c2a$export$fb56ad75dd311c12(selection)) return true;
    if (!selection.directives) return false;
    return selection.directives.some($2f1496a7de754c2a$var$getDirectiveMatcher(directives)) || nestedCheck && $2f1496a7de754c2a$var$hasDirectivesInSelectionSet(directives, selection.selectionSet, nestedCheck);
}
function $2f1496a7de754c2a$export$deed3420cb5d2e1d(directives, doc) {
    $2f1496a7de754c2a$export$a7d0d8111d2386df(doc);
    var parentPath;
    return $2f1496a7de754c2a$var$nullIfDocIsEmpty((0, $961BR.visit)(doc, {
        SelectionSet: {
            enter: function(node, _key, _parent, path) {
                var currentPath = path.join('-');
                if (!parentPath || currentPath === parentPath || !currentPath.startsWith(parentPath)) {
                    if (node.selections) {
                        var selectionsWithDirectives = node.selections.filter(function(selection) {
                            return $2f1496a7de754c2a$var$hasDirectivesInSelection(directives, selection);
                        });
                        if ($2f1496a7de754c2a$var$hasDirectivesInSelectionSet(directives, node, false)) parentPath = currentPath;
                        return (0, $fKE23.__assign)((0, $fKE23.__assign)({}, node), {
                            selections: selectionsWithDirectives
                        });
                    } else return null;
                }
            }
        }
    }));
}
function $2f1496a7de754c2a$var$getArgumentMatcher(config) {
    return function argumentMatcher(argument) {
        return config.some(function(aConfig) {
            return argument.value && argument.value.kind === 'Variable' && argument.value.name && (aConfig.name === argument.value.name.value || aConfig.test && aConfig.test(argument));
        });
    };
}
function $2f1496a7de754c2a$export$ecd5bb739c4a8b38(config, doc) {
    var argMatcher = $2f1496a7de754c2a$var$getArgumentMatcher(config);
    return $2f1496a7de754c2a$var$nullIfDocIsEmpty((0, $961BR.visit)(doc, {
        OperationDefinition: {
            enter: function(node) {
                return (0, $fKE23.__assign)((0, $fKE23.__assign)({}, node), {
                    variableDefinitions: node.variableDefinitions.filter(function(varDef) {
                        return !config.some(function(arg) {
                            return arg.name === varDef.variable.name.value;
                        });
                    })
                });
            }
        },
        Field: {
            enter: function(node) {
                var shouldRemoveField = config.some(function(argConfig) {
                    return argConfig.remove;
                });
                if (shouldRemoveField) {
                    var argMatchCount_1 = 0;
                    node.arguments.forEach(function(arg) {
                        if (argMatcher(arg)) argMatchCount_1 += 1;
                    });
                    if (argMatchCount_1 === 1) return null;
                }
            }
        },
        Argument: {
            enter: function(node) {
                if (argMatcher(node)) return null;
            }
        }
    }));
}
function $2f1496a7de754c2a$export$7c9d17c333033c13(config, doc) {
    function enter(node) {
        if (config.some(function(def) {
            return def.name === node.name.value;
        })) return null;
    }
    return $2f1496a7de754c2a$var$nullIfDocIsEmpty((0, $961BR.visit)(doc, {
        FragmentSpread: {
            enter: enter
        },
        FragmentDefinition: {
            enter: enter
        }
    }));
}
function $2f1496a7de754c2a$var$getAllFragmentSpreadsFromSelectionSet(selectionSet) {
    var allFragments = [];
    selectionSet.selections.forEach(function(selection) {
        if (($2f1496a7de754c2a$export$fb56ad75dd311c12(selection) || $2f1496a7de754c2a$export$22a1cdafaf27bcff(selection)) && selection.selectionSet) $2f1496a7de754c2a$var$getAllFragmentSpreadsFromSelectionSet(selection.selectionSet).forEach(function(frag) {
            return allFragments.push(frag);
        });
        else if (selection.kind === 'FragmentSpread') allFragments.push(selection);
    });
    return allFragments;
}
function $2f1496a7de754c2a$export$57c368c23873f32b(document) {
    var definition = $2f1496a7de754c2a$export$f431198736b7f96d(document);
    var definitionOperation = definition.operation;
    if (definitionOperation === 'query') return document;
    var modifiedDoc = (0, $961BR.visit)(document, {
        OperationDefinition: {
            enter: function(node) {
                return (0, $fKE23.__assign)((0, $fKE23.__assign)({}, node), {
                    operation: 'query'
                });
            }
        }
    });
    return modifiedDoc;
}
function $2f1496a7de754c2a$export$8eae69e876ee321e(document) {
    $2f1496a7de754c2a$export$a7d0d8111d2386df(document);
    var modifiedDoc = $2f1496a7de754c2a$export$e5ae0530da5fe96c([
        {
            test: function(directive) {
                return directive.name.value === 'client';
            },
            remove: true
        }
    ], document);
    if (modifiedDoc) modifiedDoc = (0, $961BR.visit)(modifiedDoc, {
        FragmentDefinition: {
            enter: function(node) {
                if (node.selectionSet) {
                    var isTypenameOnly = node.selectionSet.selections.every(function(selection) {
                        return $2f1496a7de754c2a$export$fb56ad75dd311c12(selection) && selection.name.value === '__typename';
                    });
                    if (isTypenameOnly) return null;
                }
            }
        }
    });
    return modifiedDoc;
}
var $2f1496a7de754c2a$export$772fbc04a0ad4ce9 = typeof WeakMap === 'function' && !(typeof navigator === 'object' && navigator.product === 'ReactNative');
var $2f1496a7de754c2a$var$toString = Object.prototype.toString;
function $2f1496a7de754c2a$export$629a2bd3f5a49ecc(value) {
    return $2f1496a7de754c2a$var$cloneDeepHelper(value, new Map());
}
function $2f1496a7de754c2a$var$cloneDeepHelper(val, seen) {
    switch($2f1496a7de754c2a$var$toString.call(val)){
        case "[object Array]":
            if (seen.has(val)) return seen.get(val);
            var copy_1 = val.slice(0);
            seen.set(val, copy_1);
            copy_1.forEach(function(child, i) {
                copy_1[i] = $2f1496a7de754c2a$var$cloneDeepHelper(child, seen);
            });
            return copy_1;
        case "[object Object]":
            if (seen.has(val)) return seen.get(val);
            var copy_2 = Object.create(Object.getPrototypeOf(val));
            seen.set(val, copy_2);
            Object.keys(val).forEach(function(key) {
                copy_2[key] = $2f1496a7de754c2a$var$cloneDeepHelper(val[key], seen);
            });
            return copy_2;
        default:
            return val;
    }
}
function $2f1496a7de754c2a$export$4bd44a2aa29d3d6e() {
    if (typeof $2fFJv !== 'undefined' && "production") return "production";
    return 'development';
}
function $2f1496a7de754c2a$export$f0cb0fda19c18b37(env) {
    return $2f1496a7de754c2a$export$4bd44a2aa29d3d6e() === env;
}
function $2f1496a7de754c2a$export$f15d00aa73aafac4() {
    return $2f1496a7de754c2a$export$f0cb0fda19c18b37('production') === true;
}
function $2f1496a7de754c2a$export$df77466336fe5355() {
    return $2f1496a7de754c2a$export$f0cb0fda19c18b37('development') === true;
}
function $2f1496a7de754c2a$export$410cbc2864fa25b5() {
    return $2f1496a7de754c2a$export$f0cb0fda19c18b37('test') === true;
}
function $2f1496a7de754c2a$export$50a91acae4904909(f) {
    try {
        return f();
    } catch (e) {
        if (console.error) console.error(e);
    }
}
function $2f1496a7de754c2a$export$b4df399e879e53ab(result) {
    return result.errors && result.errors.length;
}
function $2f1496a7de754c2a$var$deepFreeze(o) {
    Object.freeze(o);
    Object.getOwnPropertyNames(o).forEach(function(prop) {
        if (o[prop] !== null && (typeof o[prop] === 'object' || typeof o[prop] === 'function') && !Object.isFrozen(o[prop])) $2f1496a7de754c2a$var$deepFreeze(o[prop]);
    });
    return o;
}
function $2f1496a7de754c2a$export$7f9c177735b71f18(obj) {
    if ($2f1496a7de754c2a$export$df77466336fe5355() || $2f1496a7de754c2a$export$410cbc2864fa25b5()) {
        var symbolIsPolyfilled = typeof Symbol === 'function' && typeof Symbol('') === 'string';
        if (!symbolIsPolyfilled) return $2f1496a7de754c2a$var$deepFreeze(obj);
    }
    return obj;
}
var $2f1496a7de754c2a$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $2f1496a7de754c2a$export$dd702b3c8240390c() {
    var sources = [];
    for(var _i = 0; _i < arguments.length; _i++)sources[_i] = arguments[_i];
    return $2f1496a7de754c2a$export$160070228be94b08(sources);
}
function $2f1496a7de754c2a$export$160070228be94b08(sources) {
    var target = sources[0] || {};
    var count = sources.length;
    if (count > 1) {
        var pastCopies = [];
        target = $2f1496a7de754c2a$var$shallowCopyForMerge(target, pastCopies);
        for(var i = 1; i < count; ++i)target = $2f1496a7de754c2a$var$mergeHelper(target, sources[i], pastCopies);
    }
    return target;
}
function $2f1496a7de754c2a$var$isObject(obj) {
    return obj !== null && typeof obj === 'object';
}
function $2f1496a7de754c2a$var$mergeHelper(target, source, pastCopies) {
    if ($2f1496a7de754c2a$var$isObject(source) && $2f1496a7de754c2a$var$isObject(target)) {
        if (Object.isExtensible && !Object.isExtensible(target)) target = $2f1496a7de754c2a$var$shallowCopyForMerge(target, pastCopies);
        Object.keys(source).forEach(function(sourceKey) {
            var sourceValue = source[sourceKey];
            if ($2f1496a7de754c2a$var$hasOwnProperty.call(target, sourceKey)) {
                var targetValue = target[sourceKey];
                if (sourceValue !== targetValue) target[sourceKey] = $2f1496a7de754c2a$var$mergeHelper($2f1496a7de754c2a$var$shallowCopyForMerge(targetValue, pastCopies), sourceValue, pastCopies);
            } else target[sourceKey] = sourceValue;
        });
        return target;
    }
    return source;
}
function $2f1496a7de754c2a$var$shallowCopyForMerge(value, pastCopies) {
    if (value !== null && typeof value === 'object' && pastCopies.indexOf(value) < 0) {
        if (Array.isArray(value)) value = value.slice(0);
        else value = (0, $fKE23.__assign)({
            __proto__: Object.getPrototypeOf(value)
        }, value);
        pastCopies.push(value);
    }
    return value;
}
var $2f1496a7de754c2a$var$haveWarned = Object.create({});
function $2f1496a7de754c2a$export$49d47c8e549bfaf9(msg, type) {
    if (type === void 0) type = 'warn';
    if (!$2f1496a7de754c2a$export$f15d00aa73aafac4() && !$2f1496a7de754c2a$var$haveWarned[msg]) {
        if (!$2f1496a7de754c2a$export$410cbc2864fa25b5()) $2f1496a7de754c2a$var$haveWarned[msg] = true;
        if (type === 'error') console.error(msg);
        else console.warn(msg);
    }
}
function $2f1496a7de754c2a$export$c54efeba029d4fe8(data) {
    return JSON.parse(JSON.stringify(data));
}

});
parcelRegister("961BR", function(module, exports) {

$parcel$export(module.exports, "BREAK", () => $916291e3e456a050$export$a89c95c098ac2a58);
$parcel$export(module.exports, "visit", () => $916291e3e456a050$export$bf638b60ea8b89b7);
$parcel$export(module.exports, "getVisitFn", () => $916291e3e456a050$export$c9c25cca74db6e70);
$parcel$export(module.exports, "visitInParallel", () => $916291e3e456a050$export$728beebeea393478);

var $biK02 = parcelRequire("biK02");

var $c8MIO = parcelRequire("c8MIO");
var $916291e3e456a050$export$4fcd777a40ccf407 = {
    Name: [],
    Document: [
        'definitions'
    ],
    OperationDefinition: [
        'name',
        'variableDefinitions',
        'directives',
        'selectionSet'
    ],
    VariableDefinition: [
        'variable',
        'type',
        'defaultValue',
        'directives'
    ],
    Variable: [
        'name'
    ],
    SelectionSet: [
        'selections'
    ],
    Field: [
        'alias',
        'name',
        'arguments',
        'directives',
        'selectionSet'
    ],
    Argument: [
        'name',
        'value'
    ],
    FragmentSpread: [
        'name',
        'directives'
    ],
    InlineFragment: [
        'typeCondition',
        'directives',
        'selectionSet'
    ],
    FragmentDefinition: [
        'name',
        // or removed in the future.
        'variableDefinitions',
        'typeCondition',
        'directives',
        'selectionSet'
    ],
    IntValue: [],
    FloatValue: [],
    StringValue: [],
    BooleanValue: [],
    NullValue: [],
    EnumValue: [],
    ListValue: [
        'values'
    ],
    ObjectValue: [
        'fields'
    ],
    ObjectField: [
        'name',
        'value'
    ],
    Directive: [
        'name',
        'arguments'
    ],
    NamedType: [
        'name'
    ],
    ListType: [
        'type'
    ],
    NonNullType: [
        'type'
    ],
    SchemaDefinition: [
        'description',
        'directives',
        'operationTypes'
    ],
    OperationTypeDefinition: [
        'type'
    ],
    ScalarTypeDefinition: [
        'description',
        'name',
        'directives'
    ],
    ObjectTypeDefinition: [
        'description',
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    FieldDefinition: [
        'description',
        'name',
        'arguments',
        'type',
        'directives'
    ],
    InputValueDefinition: [
        'description',
        'name',
        'type',
        'defaultValue',
        'directives'
    ],
    InterfaceTypeDefinition: [
        'description',
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    UnionTypeDefinition: [
        'description',
        'name',
        'directives',
        'types'
    ],
    EnumTypeDefinition: [
        'description',
        'name',
        'directives',
        'values'
    ],
    EnumValueDefinition: [
        'description',
        'name',
        'directives'
    ],
    InputObjectTypeDefinition: [
        'description',
        'name',
        'directives',
        'fields'
    ],
    DirectiveDefinition: [
        'description',
        'name',
        'arguments',
        'locations'
    ],
    SchemaExtension: [
        'directives',
        'operationTypes'
    ],
    ScalarTypeExtension: [
        'name',
        'directives'
    ],
    ObjectTypeExtension: [
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    InterfaceTypeExtension: [
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    UnionTypeExtension: [
        'name',
        'directives',
        'types'
    ],
    EnumTypeExtension: [
        'name',
        'directives',
        'values'
    ],
    InputObjectTypeExtension: [
        'name',
        'directives',
        'fields'
    ]
};
var $916291e3e456a050$export$a89c95c098ac2a58 = Object.freeze({});
function $916291e3e456a050$export$bf638b60ea8b89b7(root, visitor) {
    var visitorKeys = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $916291e3e456a050$export$4fcd777a40ccf407;
    /* eslint-disable no-undef-init */ var stack = undefined;
    var inArray = Array.isArray(root);
    var keys = [
        root
    ];
    var index = -1;
    var edits = [];
    var node = undefined;
    var key = undefined;
    var parent = undefined;
    var path = [];
    var ancestors = [];
    var newRoot = root;
    /* eslint-enable no-undef-init */ do {
        index++;
        var isLeaving = index === keys.length;
        var isEdited = isLeaving && edits.length !== 0;
        if (isLeaving) {
            key = ancestors.length === 0 ? undefined : path[path.length - 1];
            node = parent;
            parent = ancestors.pop();
            if (isEdited) {
                if (inArray) node = node.slice();
                else {
                    var clone = {};
                    for(var _i2 = 0, _Object$keys2 = Object.keys(node); _i2 < _Object$keys2.length; _i2++){
                        var k = _Object$keys2[_i2];
                        clone[k] = node[k];
                    }
                    node = clone;
                }
                var editOffset = 0;
                for(var ii = 0; ii < edits.length; ii++){
                    var editKey = edits[ii][0];
                    var editValue = edits[ii][1];
                    if (inArray) editKey -= editOffset;
                    if (inArray && editValue === null) {
                        node.splice(editKey, 1);
                        editOffset++;
                    } else node[editKey] = editValue;
                }
            }
            index = stack.index;
            keys = stack.keys;
            edits = stack.edits;
            inArray = stack.inArray;
            stack = stack.prev;
        } else {
            key = parent ? inArray ? index : keys[index] : undefined;
            node = parent ? parent[key] : newRoot;
            if (node === null || node === undefined) continue;
            if (parent) path.push(key);
        }
        var result = void 0;
        if (!Array.isArray(node)) {
            if (!(0, $c8MIO.isNode)(node)) throw new Error("Invalid AST Node: ".concat((0, $biK02.default)(node), "."));
            var visitFn = $916291e3e456a050$export$c9c25cca74db6e70(visitor, node.kind, isLeaving);
            if (visitFn) {
                result = visitFn.call(visitor, node, key, parent, path, ancestors);
                if (result === $916291e3e456a050$export$a89c95c098ac2a58) break;
                if (result === false) {
                    if (!isLeaving) {
                        path.pop();
                        continue;
                    }
                } else if (result !== undefined) {
                    edits.push([
                        key,
                        result
                    ]);
                    if (!isLeaving) {
                        if ((0, $c8MIO.isNode)(result)) node = result;
                        else {
                            path.pop();
                            continue;
                        }
                    }
                }
            }
        }
        if (result === undefined && isEdited) edits.push([
            key,
            node
        ]);
        if (isLeaving) path.pop();
        else {
            var _visitorKeys$node$kin;
            stack = {
                inArray: inArray,
                index: index,
                keys: keys,
                edits: edits,
                prev: stack
            };
            inArray = Array.isArray(node);
            keys = inArray ? node : (_visitorKeys$node$kin = visitorKeys[node.kind]) !== null && _visitorKeys$node$kin !== void 0 ? _visitorKeys$node$kin : [];
            index = -1;
            edits = [];
            if (parent) ancestors.push(parent);
            parent = node;
        }
    }while (stack !== undefined);
    if (edits.length !== 0) newRoot = edits[edits.length - 1][1];
    return newRoot;
}
function $916291e3e456a050$export$728beebeea393478(visitors) {
    var skipping = new Array(visitors.length);
    return {
        enter: function enter(node) {
            for(var i = 0; i < visitors.length; i++)if (skipping[i] == null) {
                var fn = $916291e3e456a050$export$c9c25cca74db6e70(visitors[i], node.kind, /* isLeaving */ false);
                if (fn) {
                    var result = fn.apply(visitors[i], arguments);
                    if (result === false) skipping[i] = node;
                    else if (result === $916291e3e456a050$export$a89c95c098ac2a58) skipping[i] = $916291e3e456a050$export$a89c95c098ac2a58;
                    else if (result !== undefined) return result;
                }
            }
        },
        leave: function leave(node) {
            for(var i = 0; i < visitors.length; i++){
                if (skipping[i] == null) {
                    var fn = $916291e3e456a050$export$c9c25cca74db6e70(visitors[i], node.kind, /* isLeaving */ true);
                    if (fn) {
                        var result = fn.apply(visitors[i], arguments);
                        if (result === $916291e3e456a050$export$a89c95c098ac2a58) skipping[i] = $916291e3e456a050$export$a89c95c098ac2a58;
                        else if (result !== undefined && result !== false) return result;
                    }
                } else if (skipping[i] === node) skipping[i] = null;
            }
        }
    };
}
function $916291e3e456a050$export$c9c25cca74db6e70(visitor, kind, isLeaving) {
    var kindVisitor = visitor[kind];
    if (kindVisitor) {
        if (!isLeaving && typeof kindVisitor === 'function') // { Kind() {} }
        return kindVisitor;
        var kindSpecificVisitor = isLeaving ? kindVisitor.leave : kindVisitor.enter;
        if (typeof kindSpecificVisitor === 'function') // { Kind: { enter() {}, leave() {} } }
        return kindSpecificVisitor;
    } else {
        var specificVisitor = isLeaving ? visitor.leave : visitor.enter;
        if (specificVisitor) {
            if (typeof specificVisitor === 'function') // { enter() {}, leave() {} }
            return specificVisitor;
            var specificKindVisitor = specificVisitor[kind];
            if (typeof specificKindVisitor === 'function') // { enter: { Kind() {} }, leave: { Kind() {} } }
            return specificKindVisitor;
        }
    }
}

});
parcelRegister("biK02", function(module, exports) {

$parcel$export(module.exports, "default", () => $971870e72b5f63d8$export$2e2bcd8739ae039);

var $8Ygpi = parcelRequire("8Ygpi");
function $971870e72b5f63d8$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $971870e72b5f63d8$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $971870e72b5f63d8$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $971870e72b5f63d8$var$_typeof(obj);
}
var $971870e72b5f63d8$var$MAX_ARRAY_LENGTH = 10;
var $971870e72b5f63d8$var$MAX_RECURSIVE_DEPTH = 2;
function $971870e72b5f63d8$export$2e2bcd8739ae039(value) {
    return $971870e72b5f63d8$var$formatValue(value, []);
}
function $971870e72b5f63d8$var$formatValue(value, seenValues) {
    switch($971870e72b5f63d8$var$_typeof(value)){
        case 'string':
            return JSON.stringify(value);
        case 'function':
            return value.name ? "[function ".concat(value.name, "]") : '[function]';
        case 'object':
            if (value === null) return 'null';
            return $971870e72b5f63d8$var$formatObjectValue(value, seenValues);
        default:
            return String(value);
    }
}
function $971870e72b5f63d8$var$formatObjectValue(value, previouslySeenValues) {
    if (previouslySeenValues.indexOf(value) !== -1) return '[Circular]';
    var seenValues = [].concat(previouslySeenValues, [
        value
    ]);
    var customInspectFn = $971870e72b5f63d8$var$getCustomFn(value);
    if (customInspectFn !== undefined) {
        var customValue = customInspectFn.call(value); // check for infinite recursion
        if (customValue !== value) return typeof customValue === 'string' ? customValue : $971870e72b5f63d8$var$formatValue(customValue, seenValues);
    } else if (Array.isArray(value)) return $971870e72b5f63d8$var$formatArray(value, seenValues);
    return $971870e72b5f63d8$var$formatObject(value, seenValues);
}
function $971870e72b5f63d8$var$formatObject(object, seenValues) {
    var keys = Object.keys(object);
    if (keys.length === 0) return '{}';
    if (seenValues.length > $971870e72b5f63d8$var$MAX_RECURSIVE_DEPTH) return '[' + $971870e72b5f63d8$var$getObjectTag(object) + ']';
    var properties = keys.map(function(key) {
        var value = $971870e72b5f63d8$var$formatValue(object[key], seenValues);
        return key + ': ' + value;
    });
    return '{ ' + properties.join(', ') + ' }';
}
function $971870e72b5f63d8$var$formatArray(array, seenValues) {
    if (array.length === 0) return '[]';
    if (seenValues.length > $971870e72b5f63d8$var$MAX_RECURSIVE_DEPTH) return '[Array]';
    var len = Math.min($971870e72b5f63d8$var$MAX_ARRAY_LENGTH, array.length);
    var remaining = array.length - len;
    var items = [];
    for(var i = 0; i < len; ++i)items.push($971870e72b5f63d8$var$formatValue(array[i], seenValues));
    if (remaining === 1) items.push('... 1 more item');
    else if (remaining > 1) items.push("... ".concat(remaining, " more items"));
    return '[' + items.join(', ') + ']';
}
function $971870e72b5f63d8$var$getCustomFn(object) {
    var customInspectFn = object[String((0, $8Ygpi.default))];
    if (typeof customInspectFn === 'function') return customInspectFn;
    if (typeof object.inspect === 'function') return object.inspect;
}
function $971870e72b5f63d8$var$getObjectTag(object) {
    var tag = Object.prototype.toString.call(object).replace(/^\[object /, '').replace(/]$/, '');
    if (tag === 'Object' && typeof object.constructor === 'function') {
        var name = object.constructor.name;
        if (typeof name === 'string' && name !== '') return name;
    }
    return tag;
}

});
parcelRegister("8Ygpi", function(module, exports) {

$parcel$export(module.exports, "default", () => $02e19fa1ae734114$export$2e2bcd8739ae039);
// istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
var $02e19fa1ae734114$var$nodejsCustomInspectSymbol = typeof Symbol === 'function' && typeof Symbol.for === 'function' ? Symbol.for('nodejs.util.inspect.custom') : undefined;
var $02e19fa1ae734114$export$2e2bcd8739ae039 = $02e19fa1ae734114$var$nodejsCustomInspectSymbol;

});


parcelRegister("c8MIO", function(module, exports) {

$parcel$export(module.exports, "Location", () => $e2c0ca6f27c1fab3$export$18a2be9195644f38);
$parcel$export(module.exports, "Token", () => $e2c0ca6f27c1fab3$export$50792b0e93539fde);
$parcel$export(module.exports, "isNode", () => $e2c0ca6f27c1fab3$export$8ee0fc9ee280b4ee);

var $51GHS = parcelRequire("51GHS");
var $e2c0ca6f27c1fab3$export$18a2be9195644f38 = /*#__PURE__*/ function() {
    /**
   * The character offset at which this Node begins.
   */ /**
   * The character offset at which this Node ends.
   */ /**
   * The Token at which this Node begins.
   */ /**
   * The Token at which this Node ends.
   */ /**
   * The Source document the AST represents.
   */ function Location(startToken, endToken, source) {
        this.start = startToken.start;
        this.end = endToken.end;
        this.startToken = startToken;
        this.endToken = endToken;
        this.source = source;
    }
    var _proto = Location.prototype;
    _proto.toJSON = function toJSON() {
        return {
            start: this.start,
            end: this.end
        };
    };
    return Location;
}(); // Print a simplified form when appearing in `inspect` and `util.inspect`.
(0, $51GHS.default)($e2c0ca6f27c1fab3$export$18a2be9195644f38);
var $e2c0ca6f27c1fab3$export$50792b0e93539fde = /*#__PURE__*/ function() {
    /**
   * The kind of Token.
   */ /**
   * The character offset at which this Node begins.
   */ /**
   * The character offset at which this Node ends.
   */ /**
   * The 1-indexed line number on which this Token appears.
   */ /**
   * The 1-indexed column number at which this Token begins.
   */ /**
   * For non-punctuation tokens, represents the interpreted value of the token.
   */ /**
   * Tokens exist as nodes in a double-linked-list amongst all tokens
   * including ignored tokens. <SOF> is always the first node and <EOF>
   * the last.
   */ function Token(kind, start, end, line, column, prev, value) {
        this.kind = kind;
        this.start = start;
        this.end = end;
        this.line = line;
        this.column = column;
        this.value = value;
        this.prev = prev;
        this.next = null;
    }
    var _proto2 = Token.prototype;
    _proto2.toJSON = function toJSON() {
        return {
            kind: this.kind,
            value: this.value,
            line: this.line,
            column: this.column
        };
    };
    return Token;
}(); // Print a simplified form when appearing in `inspect` and `util.inspect`.
(0, $51GHS.default)($e2c0ca6f27c1fab3$export$50792b0e93539fde);
function $e2c0ca6f27c1fab3$export$8ee0fc9ee280b4ee(maybeNode) {
    return maybeNode != null && typeof maybeNode.kind === 'string';
} /**
 * The list of all possible AST node types.
 */ 

});
parcelRegister("51GHS", function(module, exports) {

$parcel$export(module.exports, "default", () => $01e114d2d62ce6bf$export$2e2bcd8739ae039);

var $43MJl = parcelRequire("43MJl");

var $8Ygpi = parcelRequire("8Ygpi");
function $01e114d2d62ce6bf$export$2e2bcd8739ae039(classObject) {
    var fn = classObject.prototype.toJSON;
    typeof fn === 'function' || (0, $43MJl.default)(0);
    classObject.prototype.inspect = fn; // istanbul ignore else (See: 'https://github.com/graphql/graphql-js/issues/2317')
    if (0, $8Ygpi.default) classObject.prototype[0, $8Ygpi.default] = fn;
}

});
parcelRegister("43MJl", function(module, exports) {

$parcel$export(module.exports, "default", () => $56486ec4c154c5f8$export$2e2bcd8739ae039);
function $56486ec4c154c5f8$export$2e2bcd8739ae039(condition, message) {
    var booleanCondition = Boolean(condition); // istanbul ignore else (See transformation done in './resources/inlineInvariant.js')
    if (!booleanCondition) throw new Error(message != null ? message : 'Unexpected invariant triggered.');
}

});




parcelRegister("8j2fP", function(module, exports) {

$parcel$export(module.exports, "InvariantError", () => $60c1d8bb20ac9f24$export$cea12affaee22fe8);
$parcel$export(module.exports, "invariant", () => $60c1d8bb20ac9f24$export$f5708dca728d7177);

var $fKE23 = parcelRequire("fKE23");

var $2fFJv = parcelRequire("2fFJv");
var $60c1d8bb20ac9f24$var$genericMessage = "Invariant Violation";
var $60c1d8bb20ac9f24$var$_a = Object.setPrototypeOf, $60c1d8bb20ac9f24$var$setPrototypeOf = $60c1d8bb20ac9f24$var$_a === void 0 ? function(obj, proto) {
    obj.__proto__ = proto;
    return obj;
} : $60c1d8bb20ac9f24$var$_a;
var $60c1d8bb20ac9f24$export$cea12affaee22fe8 = /** @class */ function(_super) {
    (0, $fKE23.__extends)(InvariantError, _super);
    function InvariantError(message) {
        if (message === void 0) message = $60c1d8bb20ac9f24$var$genericMessage;
        var _this = _super.call(this, typeof message === "number" ? $60c1d8bb20ac9f24$var$genericMessage + ": " + message + " (see https://github.com/apollographql/invariant-packages)" : message) || this;
        _this.framesToPop = 1;
        _this.name = $60c1d8bb20ac9f24$var$genericMessage;
        $60c1d8bb20ac9f24$var$setPrototypeOf(_this, InvariantError.prototype);
        return _this;
    }
    return InvariantError;
}(Error);
function $60c1d8bb20ac9f24$export$f5708dca728d7177(condition, message) {
    if (!condition) throw new $60c1d8bb20ac9f24$export$cea12affaee22fe8(message);
}
function $60c1d8bb20ac9f24$var$wrapConsoleMethod(method) {
    return function() {
        return console[method].apply(console, arguments);
    };
}
(function(invariant) {
    invariant.warn = $60c1d8bb20ac9f24$var$wrapConsoleMethod("warn");
    invariant.error = $60c1d8bb20ac9f24$var$wrapConsoleMethod("error");
})($60c1d8bb20ac9f24$export$f5708dca728d7177 || ($60c1d8bb20ac9f24$export$f5708dca728d7177 = {}));
// Code that uses ts-invariant with rollup-plugin-invariant may want to
// import this process stub to avoid errors evaluating process.env.NODE_ENV.
// However, because most ESM-to-CJS compilers will rewrite the process import
// as tsInvariant.process, which prevents proper replacement by minifiers, we
// also attempt to define the stub globally when it is not already defined.
var $60c1d8bb20ac9f24$export$e54fe5b0f43758f7 = {
    env: {}
};
if (typeof $2fFJv === "object") $60c1d8bb20ac9f24$export$e54fe5b0f43758f7 = $2fFJv;
else try {
    // Using Function to evaluate this assignment in global scope also escapes
    // the strict mode of the current module, thereby allowing the assignment.
    // Inspired by https://github.com/facebook/regenerator/pull/369.
    Function("stub", "process = stub")($60c1d8bb20ac9f24$export$e54fe5b0f43758f7);
} catch (atLeastWeTried) {
// The assignment can fail if a Content Security Policy heavy-handedly
// forbids Function usage. In those environments, developers should take
// extra care to replace process.env.NODE_ENV in their production builds,
// or define an appropriate global.process polyfill.
}
var $60c1d8bb20ac9f24$var$invariant$1 = $60c1d8bb20ac9f24$export$f5708dca728d7177;
var $60c1d8bb20ac9f24$export$2e2bcd8739ae039 = $60c1d8bb20ac9f24$var$invariant$1;

});

parcelRegister("cGs0N", function(module, exports) {
'use strict';
module.exports = function(data, opts) {
    if (!opts) opts = {};
    if (typeof opts === 'function') opts = {
        cmp: opts
    };
    var cycles = typeof opts.cycles === 'boolean' ? opts.cycles : false;
    var cmp = opts.cmp && function(f) {
        return function(node) {
            return function(a, b) {
                var aobj = {
                    key: a,
                    value: node[a]
                };
                var bobj = {
                    key: b,
                    value: node[b]
                };
                return f(aobj, bobj);
            };
        };
    }(opts.cmp);
    var seen = [];
    return function stringify(node) {
        if (node && node.toJSON && typeof node.toJSON === 'function') node = node.toJSON();
        if (node === undefined) return;
        if (typeof node == 'number') return isFinite(node) ? '' + node : 'null';
        if (typeof node !== 'object') return JSON.stringify(node);
        var i, out;
        if (Array.isArray(node)) {
            out = '[';
            for(i = 0; i < node.length; i++){
                if (i) out += ',';
                out += stringify(node[i]) || 'null';
            }
            return out + ']';
        }
        if (node === null) return 'null';
        if (seen.indexOf(node) !== -1) {
            if (cycles) return JSON.stringify('__cycle__');
            throw new TypeError('Converting circular structure to JSON');
        }
        var seenIndex = seen.push(node) - 1;
        var keys = Object.keys(node).sort(cmp && cmp(node));
        out = '';
        for(i = 0; i < keys.length; i++){
            var key = keys[i];
            var value = stringify(node[key]);
            if (!value) continue;
            if (out) out += ',';
            out += JSON.stringify(key) + ':' + value;
        }
        seen.splice(seenIndex, 1);
        return '{' + out + '}';
    }(data);
};

});

parcelRegister("66hGB", function(module, exports) {

$parcel$export(module.exports, "equal", () => $471105b2f2fd38f1$export$411ce8e5a71e3069);
var $471105b2f2fd38f1$var$_a = Object.prototype, $471105b2f2fd38f1$var$toString = $471105b2f2fd38f1$var$_a.toString, $471105b2f2fd38f1$var$hasOwnProperty = $471105b2f2fd38f1$var$_a.hasOwnProperty;
var $471105b2f2fd38f1$var$previousComparisons = new Map();
/**
 * Performs a deep equality check on two JavaScript values, tolerating cycles.
 */ function $471105b2f2fd38f1$export$411ce8e5a71e3069(a, b) {
    try {
        return $471105b2f2fd38f1$var$check(a, b);
    } finally{
        $471105b2f2fd38f1$var$previousComparisons.clear();
    }
}
function $471105b2f2fd38f1$var$check(a, b) {
    // If the two values are strictly equal, our job is easy.
    if (a === b) return true;
    // Object.prototype.toString returns a representation of the runtime type of
    // the given value that is considerably more precise than typeof.
    var aTag = $471105b2f2fd38f1$var$toString.call(a);
    var bTag = $471105b2f2fd38f1$var$toString.call(b);
    // If the runtime types of a and b are different, they could maybe be equal
    // under some interpretation of equality, but for simplicity and performance
    // we just return false instead.
    if (aTag !== bTag) return false;
    switch(aTag){
        case '[object Array]':
            // Arrays are a lot like other objects, but we can cheaply compare their
            // lengths as a short-cut before comparing their elements.
            if (a.length !== b.length) return false;
        // Fall through to object case...
        case '[object Object]':
            if ($471105b2f2fd38f1$var$previouslyCompared(a, b)) return true;
            var aKeys = Object.keys(a);
            var bKeys = Object.keys(b);
            // If `a` and `b` have a different number of enumerable keys, they
            // must be different.
            var keyCount = aKeys.length;
            if (keyCount !== bKeys.length) return false;
            // Now make sure they have the same keys.
            for(var k = 0; k < keyCount; ++k){
                if (!$471105b2f2fd38f1$var$hasOwnProperty.call(b, aKeys[k])) return false;
            }
            // Finally, check deep equality of all child properties.
            for(var k = 0; k < keyCount; ++k){
                var key = aKeys[k];
                if (!$471105b2f2fd38f1$var$check(a[key], b[key])) return false;
            }
            return true;
        case '[object Error]':
            return a.name === b.name && a.message === b.message;
        case '[object Number]':
            // Handle NaN, which is !== itself.
            if (a !== a) return b !== b;
        // Fall through to shared +a === +b case...
        case '[object Boolean]':
        case '[object Date]':
            return +a === +b;
        case '[object RegExp]':
        case '[object String]':
            return a == "" + b;
        case '[object Map]':
        case '[object Set]':
            if (a.size !== b.size) return false;
            if ($471105b2f2fd38f1$var$previouslyCompared(a, b)) return true;
            var aIterator = a.entries();
            var isMap = aTag === '[object Map]';
            while(true){
                var info = aIterator.next();
                if (info.done) break;
                // If a instanceof Set, aValue === aKey.
                var _a = info.value, aKey = _a[0], aValue = _a[1];
                // So this works the same way for both Set and Map.
                if (!b.has(aKey)) return false;
                // However, we care about deep equality of values only when dealing
                // with Map structures.
                if (isMap && !$471105b2f2fd38f1$var$check(aValue, b.get(aKey))) return false;
            }
            return true;
    }
    // Otherwise the values are not equal.
    return false;
}
function $471105b2f2fd38f1$var$previouslyCompared(a, b) {
    // Though cyclic references can make an object graph appear infinite from the
    // perspective of a depth-first traversal, the graph still contains a finite
    // number of distinct object references. We use the previousComparisons cache
    // to avoid comparing the same pair of object references more than once, which
    // guarantees termination (even if we end up comparing every object in one
    // graph to every object in the other graph, which is extremely unlikely),
    // while still allowing weird isomorphic structures (like rings with different
    // lengths) a chance to pass the equality test.
    var bSet = $471105b2f2fd38f1$var$previousComparisons.get(a);
    if (bSet) {
        // Return true here because we can be sure false will be returned somewhere
        // else if the objects are not equivalent.
        if (bSet.has(b)) return true;
    } else $471105b2f2fd38f1$var$previousComparisons.set(a, bSet = new Set);
    bSet.add(b);
    return false;
}
var $471105b2f2fd38f1$export$2e2bcd8739ae039 = $471105b2f2fd38f1$export$411ce8e5a71e3069;

});



parcelRegister("7xYai", function(module, exports) {

$parcel$export(module.exports, "KeyTrie", () => $57ea48f9f955816f$export$6bd8d8299be3ac82);
$parcel$export(module.exports, "wrap", () => $57ea48f9f955816f$export$4997ffc0176396a6);

var $182fv = parcelRequire("182fv");
function $57ea48f9f955816f$var$defaultDispose() {}
var $57ea48f9f955816f$var$Cache = /** @class */ function() {
    function Cache(max, dispose) {
        if (max === void 0) max = Infinity;
        if (dispose === void 0) dispose = $57ea48f9f955816f$var$defaultDispose;
        this.max = max;
        this.dispose = dispose;
        this.map = new Map();
        this.newest = null;
        this.oldest = null;
    }
    Cache.prototype.has = function(key) {
        return this.map.has(key);
    };
    Cache.prototype.get = function(key) {
        var entry = this.getEntry(key);
        return entry && entry.value;
    };
    Cache.prototype.getEntry = function(key) {
        var entry = this.map.get(key);
        if (entry && entry !== this.newest) {
            var older = entry.older, newer = entry.newer;
            if (newer) newer.older = older;
            if (older) older.newer = newer;
            entry.older = this.newest;
            entry.older.newer = entry;
            entry.newer = null;
            this.newest = entry;
            if (entry === this.oldest) this.oldest = newer;
        }
        return entry;
    };
    Cache.prototype.set = function(key, value) {
        var entry = this.getEntry(key);
        if (entry) return entry.value = value;
        entry = {
            key: key,
            value: value,
            newer: null,
            older: this.newest
        };
        if (this.newest) this.newest.newer = entry;
        this.newest = entry;
        this.oldest = this.oldest || entry;
        this.map.set(key, entry);
        return entry.value;
    };
    Cache.prototype.clean = function() {
        while(this.oldest && this.map.size > this.max)this.delete(this.oldest.key);
    };
    Cache.prototype.delete = function(key) {
        var entry = this.map.get(key);
        if (entry) {
            if (entry === this.newest) this.newest = entry.older;
            if (entry === this.oldest) this.oldest = entry.newer;
            if (entry.newer) entry.newer.older = entry.older;
            if (entry.older) entry.older.newer = entry.newer;
            this.map.delete(key);
            this.dispose(entry.value, key);
            return true;
        }
        return false;
    };
    return Cache;
}();
var $57ea48f9f955816f$var$parentEntrySlot = new (0, $182fv.Slot)();
var $57ea48f9f955816f$var$reusableEmptyArray = [];
var $57ea48f9f955816f$var$emptySetPool = [];
var $57ea48f9f955816f$var$POOL_TARGET_SIZE = 100;
// Since this package might be used browsers, we should avoid using the
// Node built-in assert module.
function $57ea48f9f955816f$var$assert(condition, optionalMessage) {
    if (!condition) throw new Error(optionalMessage || "assertion failure");
}
function $57ea48f9f955816f$var$valueIs(a, b) {
    var len = a.length;
    return(// Unknown values are not equal to each other.
    len > 0 && // Both values must be ordinary (or both exceptional) to be equal.
    len === b.length && // The underlying value or exception must be the same.
    a[len - 1] === b[len - 1]);
}
function $57ea48f9f955816f$var$valueGet(value) {
    switch(value.length){
        case 0:
            throw new Error("unknown value");
        case 1:
            return value[0];
        case 2:
            throw value[1];
    }
}
function $57ea48f9f955816f$var$valueCopy(value) {
    return value.slice(0);
}
var $57ea48f9f955816f$var$Entry = /** @class */ function() {
    function Entry(fn, args) {
        this.fn = fn;
        this.args = args;
        this.parents = new Set();
        this.childValues = new Map();
        // When this Entry has children that are dirty, this property becomes
        // a Set containing other Entry objects, borrowed from emptySetPool.
        // When the set becomes empty, it gets recycled back to emptySetPool.
        this.dirtyChildren = null;
        this.dirty = true;
        this.recomputing = false;
        this.value = [];
        ++Entry.count;
    }
    // This is the most important method of the Entry API, because it
    // determines whether the cached this.value can be returned immediately,
    // or must be recomputed. The overall performance of the caching system
    // depends on the truth of the following observations: (1) this.dirty is
    // usually false, (2) this.dirtyChildren is usually null/empty, and thus
    // (3) valueGet(this.value) is usually returned without recomputation.
    Entry.prototype.recompute = function() {
        $57ea48f9f955816f$var$assert(!this.recomputing, "already recomputing");
        if (!$57ea48f9f955816f$var$rememberParent(this) && $57ea48f9f955816f$var$maybeReportOrphan(this)) // The recipient of the entry.reportOrphan callback decided to dispose
        // of this orphan entry by calling entry.dispose(), so we don't need to
        // (and should not) proceed with the recomputation.
        return void 0;
        return $57ea48f9f955816f$var$mightBeDirty(this) ? $57ea48f9f955816f$var$reallyRecompute(this) : $57ea48f9f955816f$var$valueGet(this.value);
    };
    Entry.prototype.setDirty = function() {
        if (this.dirty) return;
        this.dirty = true;
        this.value.length = 0;
        $57ea48f9f955816f$var$reportDirty(this);
        // We can go ahead and unsubscribe here, since any further dirty
        // notifications we receive will be redundant, and unsubscribing may
        // free up some resources, e.g. file watchers.
        $57ea48f9f955816f$var$maybeUnsubscribe(this);
    };
    Entry.prototype.dispose = function() {
        var _this = this;
        $57ea48f9f955816f$var$forgetChildren(this).forEach($57ea48f9f955816f$var$maybeReportOrphan);
        $57ea48f9f955816f$var$maybeUnsubscribe(this);
        // Because this entry has been kicked out of the cache (in index.js),
        // we've lost the ability to find out if/when this entry becomes dirty,
        // whether that happens through a subscription, because of a direct call
        // to entry.setDirty(), or because one of its children becomes dirty.
        // Because of this loss of future information, we have to assume the
        // worst (that this entry might have become dirty very soon), so we must
        // immediately mark this entry's parents as dirty. Normally we could
        // just call entry.setDirty() rather than calling parent.setDirty() for
        // each parent, but that would leave this entry in parent.childValues
        // and parent.dirtyChildren, which would prevent the child from being
        // truly forgotten.
        this.parents.forEach(function(parent) {
            parent.setDirty();
            $57ea48f9f955816f$var$forgetChild(parent, _this);
        });
    };
    Entry.count = 0;
    return Entry;
}();
function $57ea48f9f955816f$var$rememberParent(child) {
    var parent = $57ea48f9f955816f$var$parentEntrySlot.getValue();
    if (parent) {
        child.parents.add(parent);
        if (!parent.childValues.has(child)) parent.childValues.set(child, []);
        if ($57ea48f9f955816f$var$mightBeDirty(child)) $57ea48f9f955816f$var$reportDirtyChild(parent, child);
        else $57ea48f9f955816f$var$reportCleanChild(parent, child);
        return parent;
    }
}
function $57ea48f9f955816f$var$reallyRecompute(entry) {
    // Since this recomputation is likely to re-remember some of this
    // entry's children, we forget our children here but do not call
    // maybeReportOrphan until after the recomputation finishes.
    var originalChildren = $57ea48f9f955816f$var$forgetChildren(entry);
    // Set entry as the parent entry while calling recomputeNewValue(entry).
    $57ea48f9f955816f$var$parentEntrySlot.withValue(entry, $57ea48f9f955816f$var$recomputeNewValue, [
        entry
    ]);
    if ($57ea48f9f955816f$var$maybeSubscribe(entry)) // If we successfully recomputed entry.value and did not fail to
    // (re)subscribe, then this Entry is no longer explicitly dirty.
    $57ea48f9f955816f$var$setClean(entry);
    // Now that we've had a chance to re-remember any children that were
    // involved in the recomputation, we can safely report any orphan
    // children that remain.
    originalChildren.forEach($57ea48f9f955816f$var$maybeReportOrphan);
    return $57ea48f9f955816f$var$valueGet(entry.value);
}
function $57ea48f9f955816f$var$recomputeNewValue(entry) {
    entry.recomputing = true;
    // Set entry.value as unknown.
    entry.value.length = 0;
    try {
        // If entry.fn succeeds, entry.value will become a normal Value.
        entry.value[0] = entry.fn.apply(null, entry.args);
    } catch (e) {
        // If entry.fn throws, entry.value will become exceptional.
        entry.value[1] = e;
    }
    // Either way, this line is always reached.
    entry.recomputing = false;
}
function $57ea48f9f955816f$var$mightBeDirty(entry) {
    return entry.dirty || !!(entry.dirtyChildren && entry.dirtyChildren.size);
}
function $57ea48f9f955816f$var$setClean(entry) {
    entry.dirty = false;
    if ($57ea48f9f955816f$var$mightBeDirty(entry)) // This Entry may still have dirty children, in which case we can't
    // let our parents know we're clean just yet.
    return;
    $57ea48f9f955816f$var$reportClean(entry);
}
function $57ea48f9f955816f$var$reportDirty(child) {
    child.parents.forEach(function(parent) {
        return $57ea48f9f955816f$var$reportDirtyChild(parent, child);
    });
}
function $57ea48f9f955816f$var$reportClean(child) {
    child.parents.forEach(function(parent) {
        return $57ea48f9f955816f$var$reportCleanChild(parent, child);
    });
}
// Let a parent Entry know that one of its children may be dirty.
function $57ea48f9f955816f$var$reportDirtyChild(parent, child) {
    // Must have called rememberParent(child) before calling
    // reportDirtyChild(parent, child).
    $57ea48f9f955816f$var$assert(parent.childValues.has(child));
    $57ea48f9f955816f$var$assert($57ea48f9f955816f$var$mightBeDirty(child));
    if (!parent.dirtyChildren) parent.dirtyChildren = $57ea48f9f955816f$var$emptySetPool.pop() || new Set;
    else if (parent.dirtyChildren.has(child)) // If we already know this child is dirty, then we must have already
    // informed our own parents that we are dirty, so we can terminate
    // the recursion early.
    return;
    parent.dirtyChildren.add(child);
    $57ea48f9f955816f$var$reportDirty(parent);
}
// Let a parent Entry know that one of its children is no longer dirty.
function $57ea48f9f955816f$var$reportCleanChild(parent, child) {
    // Must have called rememberChild(child) before calling
    // reportCleanChild(parent, child).
    $57ea48f9f955816f$var$assert(parent.childValues.has(child));
    $57ea48f9f955816f$var$assert(!$57ea48f9f955816f$var$mightBeDirty(child));
    var childValue = parent.childValues.get(child);
    if (childValue.length === 0) parent.childValues.set(child, $57ea48f9f955816f$var$valueCopy(child.value));
    else if (!$57ea48f9f955816f$var$valueIs(childValue, child.value)) parent.setDirty();
    $57ea48f9f955816f$var$removeDirtyChild(parent, child);
    if ($57ea48f9f955816f$var$mightBeDirty(parent)) return;
    $57ea48f9f955816f$var$reportClean(parent);
}
function $57ea48f9f955816f$var$removeDirtyChild(parent, child) {
    var dc = parent.dirtyChildren;
    if (dc) {
        dc.delete(child);
        if (dc.size === 0) {
            if ($57ea48f9f955816f$var$emptySetPool.length < $57ea48f9f955816f$var$POOL_TARGET_SIZE) $57ea48f9f955816f$var$emptySetPool.push(dc);
            parent.dirtyChildren = null;
        }
    }
}
// If the given entry has a reportOrphan method, and no remaining parents,
// call entry.reportOrphan and return true iff it returns true. The
// reportOrphan function should return true to indicate entry.dispose()
// has been called, and the entry has been removed from any other caches
// (see index.js for the only current example).
function $57ea48f9f955816f$var$maybeReportOrphan(entry) {
    return entry.parents.size === 0 && typeof entry.reportOrphan === "function" && entry.reportOrphan() === true;
}
// Removes all children from this entry and returns an array of the
// removed children.
function $57ea48f9f955816f$var$forgetChildren(parent) {
    var children = $57ea48f9f955816f$var$reusableEmptyArray;
    if (parent.childValues.size > 0) {
        children = [];
        parent.childValues.forEach(function(_value, child) {
            $57ea48f9f955816f$var$forgetChild(parent, child);
            children.push(child);
        });
    }
    // After we forget all our children, this.dirtyChildren must be empty
    // and therefore must have been reset to null.
    $57ea48f9f955816f$var$assert(parent.dirtyChildren === null);
    return children;
}
function $57ea48f9f955816f$var$forgetChild(parent, child) {
    child.parents.delete(parent);
    parent.childValues.delete(child);
    $57ea48f9f955816f$var$removeDirtyChild(parent, child);
}
function $57ea48f9f955816f$var$maybeSubscribe(entry) {
    if (typeof entry.subscribe === "function") try {
        $57ea48f9f955816f$var$maybeUnsubscribe(entry); // Prevent double subscriptions.
        entry.unsubscribe = entry.subscribe.apply(null, entry.args);
    } catch (e) {
        // If this Entry has a subscribe function and it threw an exception
        // (or an unsubscribe function it previously returned now throws),
        // return false to indicate that we were not able to subscribe (or
        // unsubscribe), and this Entry should remain dirty.
        entry.setDirty();
        return false;
    }
    // Returning true indicates either that there was no entry.subscribe
    // function or that it succeeded.
    return true;
}
function $57ea48f9f955816f$var$maybeUnsubscribe(entry) {
    var unsubscribe = entry.unsubscribe;
    if (typeof unsubscribe === "function") {
        entry.unsubscribe = void 0;
        unsubscribe();
    }
}
// A trie data structure that holds object keys weakly, yet can also hold
// non-object keys, unlike the native `WeakMap`.
var $57ea48f9f955816f$export$6bd8d8299be3ac82 = /** @class */ function() {
    function KeyTrie(weakness) {
        this.weakness = weakness;
    }
    KeyTrie.prototype.lookup = function() {
        var array = [];
        for(var _i = 0; _i < arguments.length; _i++)array[_i] = arguments[_i];
        return this.lookupArray(array);
    };
    KeyTrie.prototype.lookupArray = function(array) {
        var node = this;
        array.forEach(function(key) {
            return node = node.getChildTrie(key);
        });
        return node.data || (node.data = Object.create(null));
    };
    KeyTrie.prototype.getChildTrie = function(key) {
        var map = this.weakness && $57ea48f9f955816f$var$isObjRef(key) ? this.weak || (this.weak = new WeakMap()) : this.strong || (this.strong = new Map());
        var child = map.get(key);
        if (!child) map.set(key, child = new KeyTrie(this.weakness));
        return child;
    };
    return KeyTrie;
}();
function $57ea48f9f955816f$var$isObjRef(value) {
    switch(typeof value){
        case "object":
            if (value === null) break;
        // Fall through to return true...
        case "function":
            return true;
    }
    return false;
}
// The defaultMakeCacheKey function is remarkably powerful, because it gives
// a unique object for any shallow-identical list of arguments. If you need
// to implement a custom makeCacheKey function, you may find it helpful to
// delegate the final work to defaultMakeCacheKey, which is why we export it
// here. However, you may want to avoid defaultMakeCacheKey if your runtime
// does not support WeakMap, or you have the ability to return a string key.
// In those cases, just write your own custom makeCacheKey functions.
var $57ea48f9f955816f$var$keyTrie = new $57ea48f9f955816f$export$6bd8d8299be3ac82(typeof WeakMap === "function");
function $57ea48f9f955816f$export$cd3144f8dd136006() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    return $57ea48f9f955816f$var$keyTrie.lookupArray(args);
}
var $57ea48f9f955816f$var$caches = new Set();
function $57ea48f9f955816f$export$4997ffc0176396a6(originalFunction, options) {
    if (options === void 0) options = Object.create(null);
    var cache = new $57ea48f9f955816f$var$Cache(options.max || Math.pow(2, 16), function(entry) {
        return entry.dispose();
    });
    var disposable = !!options.disposable;
    var makeCacheKey = options.makeCacheKey || $57ea48f9f955816f$export$cd3144f8dd136006;
    function optimistic() {
        if (disposable && !$57ea48f9f955816f$var$parentEntrySlot.hasValue()) // If there's no current parent computation, and this wrapped
        // function is disposable (meaning we don't care about entry.value,
        // just dependency tracking), then we can short-cut everything else
        // in this function, because entry.recompute() is going to recycle
        // the entry object without recomputing anything, anyway.
        return void 0;
        var key = makeCacheKey.apply(null, arguments);
        if (key === void 0) return originalFunction.apply(null, arguments);
        var args = Array.prototype.slice.call(arguments);
        var entry = cache.get(key);
        if (entry) entry.args = args;
        else {
            entry = new $57ea48f9f955816f$var$Entry(originalFunction, args);
            cache.set(key, entry);
            entry.subscribe = options.subscribe;
            if (disposable) entry.reportOrphan = function() {
                return cache.delete(key);
            };
        }
        var value = entry.recompute();
        // Move this entry to the front of the least-recently used queue,
        // since we just finished computing its value.
        cache.set(key, entry);
        $57ea48f9f955816f$var$caches.add(cache);
        // Clean up any excess entries in the cache, but only if there is no
        // active parent entry, meaning we're not in the middle of a larger
        // computation that might be flummoxed by the cleaning.
        if (!$57ea48f9f955816f$var$parentEntrySlot.hasValue()) {
            $57ea48f9f955816f$var$caches.forEach(function(cache) {
                return cache.clean();
            });
            $57ea48f9f955816f$var$caches.clear();
        }
        // If options.disposable is truthy, the caller of wrap is telling us
        // they don't care about the result of entry.recompute(), so we should
        // avoid returning the value, so it won't be accidentally used.
        return disposable ? void 0 : value;
    }
    optimistic.dirty = function() {
        var key = makeCacheKey.apply(null, arguments);
        var child = key !== void 0 && cache.get(key);
        if (child) child.setDirty();
    };
    return optimistic;
}

});
parcelRegister("182fv", function(module, exports) {

$parcel$export(module.exports, "Slot", () => $0d28486785009faf$export$8c6ed5c666ac1360);
// This currentContext variable will only be used if the makeSlotClass
// function is called, which happens only if this is the first copy of the
// @wry/context package to be imported.
var $0d28486785009faf$var$currentContext = null;
// This unique internal object is used to denote the absence of a value
// for a given Slot, and is never exposed to outside code.
var $0d28486785009faf$var$MISSING_VALUE = {};
var $0d28486785009faf$var$idCounter = 1;
// Although we can't do anything about the cost of duplicated code from
// accidentally bundling multiple copies of the @wry/context package, we can
// avoid creating the Slot class more than once using makeSlotClass.
var $0d28486785009faf$var$makeSlotClass = function() {
    return /** @class */ function() {
        function Slot() {
            // If you have a Slot object, you can find out its slot.id, but you cannot
            // guess the slot.id of a Slot you don't have access to, thanks to the
            // randomized suffix.
            this.id = [
                "slot",
                $0d28486785009faf$var$idCounter++,
                Date.now(),
                Math.random().toString(36).slice(2)
            ].join(":");
        }
        Slot.prototype.hasValue = function() {
            for(var context_1 = $0d28486785009faf$var$currentContext; context_1; context_1 = context_1.parent)// We use the Slot object iself as a key to its value, which means the
            // value cannot be obtained without a reference to the Slot object.
            if (this.id in context_1.slots) {
                var value = context_1.slots[this.id];
                if (value === $0d28486785009faf$var$MISSING_VALUE) break;
                if (context_1 !== $0d28486785009faf$var$currentContext) // Cache the value in currentContext.slots so the next lookup will
                // be faster. This caching is safe because the tree of contexts and
                // the values of the slots are logically immutable.
                $0d28486785009faf$var$currentContext.slots[this.id] = value;
                return true;
            }
            if ($0d28486785009faf$var$currentContext) // If a value was not found for this Slot, it's never going to be found
            // no matter how many times we look it up, so we might as well cache
            // the absence of the value, too.
            $0d28486785009faf$var$currentContext.slots[this.id] = $0d28486785009faf$var$MISSING_VALUE;
            return false;
        };
        Slot.prototype.getValue = function() {
            if (this.hasValue()) return $0d28486785009faf$var$currentContext.slots[this.id];
        };
        Slot.prototype.withValue = function(value, callback, // Given the prevalence of arrow functions, specifying arguments is likely
        // to be much more common than specifying `this`, hence this ordering:
        args, thisArg) {
            var _a;
            var slots = (_a = {
                __proto__: null
            }, _a[this.id] = value, _a);
            var parent = $0d28486785009faf$var$currentContext;
            $0d28486785009faf$var$currentContext = {
                parent: parent,
                slots: slots
            };
            try {
                // Function.prototype.apply allows the arguments array argument to be
                // omitted or undefined, so args! is fine here.
                return callback.apply(thisArg, args);
            } finally{
                $0d28486785009faf$var$currentContext = parent;
            }
        };
        // Capture the current context and wrap a callback function so that it
        // reestablishes the captured context when called.
        Slot.bind = function(callback) {
            var context = $0d28486785009faf$var$currentContext;
            return function() {
                var saved = $0d28486785009faf$var$currentContext;
                try {
                    $0d28486785009faf$var$currentContext = context;
                    return callback.apply(this, arguments);
                } finally{
                    $0d28486785009faf$var$currentContext = saved;
                }
            };
        };
        // Immediately run a callback function without any captured context.
        Slot.noContext = function(callback, // Given the prevalence of arrow functions, specifying arguments is likely
        // to be much more common than specifying `this`, hence this ordering:
        args, thisArg) {
            if ($0d28486785009faf$var$currentContext) {
                var saved = $0d28486785009faf$var$currentContext;
                try {
                    $0d28486785009faf$var$currentContext = null;
                    // Function.prototype.apply allows the arguments array argument to be
                    // omitted or undefined, so args! is fine here.
                    return callback.apply(thisArg, args);
                } finally{
                    $0d28486785009faf$var$currentContext = saved;
                }
            } else return callback.apply(thisArg, args);
        };
        return Slot;
    }();
};
// We store a single global implementation of the Slot class as a permanent
// non-enumerable symbol property of the Array constructor. This obfuscation
// does nothing to prevent access to the Slot class, but at least it ensures
// the implementation (i.e. currentContext) cannot be tampered with, and all
// copies of the @wry/context package (hopefully just one) will share the
// same Slot implementation. Since the first copy of the @wry/context package
// to be imported wins, this technique imposes a very high cost for any
// future breaking changes to the Slot class.
var $0d28486785009faf$var$globalKey = "@wry/context:Slot";
var $0d28486785009faf$var$host = Array;
var $0d28486785009faf$export$8c6ed5c666ac1360 = $0d28486785009faf$var$host[$0d28486785009faf$var$globalKey] || function() {
    var Slot = $0d28486785009faf$var$makeSlotClass();
    try {
        Object.defineProperty($0d28486785009faf$var$host, $0d28486785009faf$var$globalKey, {
            value: $0d28486785009faf$var$host[$0d28486785009faf$var$globalKey] = Slot,
            enumerable: false,
            writable: false,
            configurable: false
        });
    } finally{
        return Slot;
    }
}();
var $0d28486785009faf$export$2385a24977818dd0 = $0d28486785009faf$export$8c6ed5c666ac1360.bind, $0d28486785009faf$export$9fa6f2e300a97f8 = $0d28486785009faf$export$8c6ed5c666ac1360.noContext;
function $0d28486785009faf$export$831dc9f2ab0a617b(callback, delay) {
    return setTimeout($0d28486785009faf$export$2385a24977818dd0(callback), delay);
}
// Turn any generator function into an async function (using yield instead
// of await), with context automatically preserved across yields.
function $0d28486785009faf$export$d5d7536e965c82da(genFn) {
    return function() {
        var gen = genFn.apply(this, arguments);
        var boundNext = $0d28486785009faf$export$2385a24977818dd0(gen.next);
        var boundThrow = $0d28486785009faf$export$2385a24977818dd0(gen.throw);
        return new Promise(function(resolve, reject) {
            function invoke(method, argument) {
                try {
                    var result = method.call(gen, argument);
                } catch (error) {
                    return reject(error);
                }
                var next = result.done ? resolve : invokeNext;
                if ($0d28486785009faf$var$isPromiseLike(result.value)) result.value.then(next, result.done ? reject : invokeThrow);
                else next(result.value);
            }
            var invokeNext = function(value) {
                return invoke(boundNext, value);
            };
            var invokeThrow = function(error) {
                return invoke(boundThrow, error);
            };
            invokeNext();
        });
    };
}
function $0d28486785009faf$var$isPromiseLike(value) {
    return value && typeof value.then === "function";
}
// If you use the fibers npm package to implement coroutines in Node.js,
// you should call this function at least once to ensure context management
// remains coherent across any yields.
var $0d28486785009faf$var$wrappedFibers = [];
function $0d28486785009faf$export$14794f6e0a4dc6a0(Fiber) {
    // There can be only one implementation of Fiber per process, so this array
    // should never grow longer than one element.
    if ($0d28486785009faf$var$wrappedFibers.indexOf(Fiber) < 0) {
        var wrap = function(obj, method) {
            var fn = obj[method];
            obj[method] = function() {
                return $0d28486785009faf$export$9fa6f2e300a97f8(fn, arguments, this);
            };
        };
        // These methods can yield, according to
        // https://github.com/laverdet/node-fibers/blob/ddebed9b8ae3883e57f822e2108e6943e5c8d2a8/fibers.js#L97-L100
        wrap(Fiber, "yield");
        wrap(Fiber.prototype, "run");
        wrap(Fiber.prototype, "throwInto");
        $0d28486785009faf$var$wrappedFibers.push(Fiber);
    }
    return Fiber;
}

});



parcelRegister("jlBDe", function(module, exports) {

$parcel$export(module.exports, "NetworkStatus", () => $03a288f5350d9e9d$export$bd096ddbd246c79c);
$parcel$export(module.exports, "ApolloError", () => $03a288f5350d9e9d$export$26a337512320b8c6);
$parcel$export(module.exports, "ApolloClient", () => $03a288f5350d9e9d$export$13f5a5f0f1dbab88);
$parcel$export(module.exports, "default", () => $03a288f5350d9e9d$export$2e2bcd8739ae039);

var $fKE23 = parcelRequire("fKE23");

var $42BH7 = parcelRequire("42BH7");
var $66hGB = parcelRequire("66hGB");

var $bvQX6 = parcelRequire("bvQX6");
var $5ECju = parcelRequire("5ECju");

var $6XJYy = parcelRequire("6XJYy");

var $8j2fP = parcelRequire("8j2fP");

var $961BR = parcelRequire("961BR");
var $03a288f5350d9e9d$export$bd096ddbd246c79c;
(function(NetworkStatus) {
    NetworkStatus[NetworkStatus["loading"] = 1] = "loading";
    NetworkStatus[NetworkStatus["setVariables"] = 2] = "setVariables";
    NetworkStatus[NetworkStatus["fetchMore"] = 3] = "fetchMore";
    NetworkStatus[NetworkStatus["refetch"] = 4] = "refetch";
    NetworkStatus[NetworkStatus["poll"] = 6] = "poll";
    NetworkStatus[NetworkStatus["ready"] = 7] = "ready";
    NetworkStatus[NetworkStatus["error"] = 8] = "error";
})($03a288f5350d9e9d$export$bd096ddbd246c79c || ($03a288f5350d9e9d$export$bd096ddbd246c79c = {}));
function $03a288f5350d9e9d$var$isNetworkRequestInFlight(networkStatus) {
    return networkStatus < 7;
}
var $03a288f5350d9e9d$var$Observable = function(_super) {
    (0, $fKE23.__extends)(Observable, _super);
    function Observable() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Observable.prototype[0, $6XJYy.default] = function() {
        return this;
    };
    Observable.prototype['@@observable'] = function() {
        return this;
    };
    return Observable;
}((0, $5ECju.default));
function $03a288f5350d9e9d$var$isNonEmptyArray(value) {
    return Array.isArray(value) && value.length > 0;
}
function $03a288f5350d9e9d$export$17f5e6bd290bb15d(err) {
    return err.hasOwnProperty('graphQLErrors');
}
var $03a288f5350d9e9d$var$generateErrorMessage = function(err) {
    var message = '';
    if ($03a288f5350d9e9d$var$isNonEmptyArray(err.graphQLErrors)) err.graphQLErrors.forEach(function(graphQLError) {
        var errorMessage = graphQLError ? graphQLError.message : 'Error message not found.';
        message += "GraphQL error: " + errorMessage + "\n";
    });
    if (err.networkError) message += 'Network error: ' + err.networkError.message + '\n';
    message = message.replace(/\n$/, '');
    return message;
};
var $03a288f5350d9e9d$export$26a337512320b8c6 = function(_super) {
    (0, $fKE23.__extends)(ApolloError, _super);
    function ApolloError(_a) {
        var graphQLErrors = _a.graphQLErrors, networkError = _a.networkError, errorMessage = _a.errorMessage, extraInfo = _a.extraInfo;
        var _this = _super.call(this, errorMessage) || this;
        _this.graphQLErrors = graphQLErrors || [];
        _this.networkError = networkError || null;
        if (!errorMessage) _this.message = $03a288f5350d9e9d$var$generateErrorMessage(_this);
        else _this.message = errorMessage;
        _this.extraInfo = extraInfo;
        _this.__proto__ = ApolloError.prototype;
        return _this;
    }
    return ApolloError;
}(Error);
var $03a288f5350d9e9d$export$160bafb6ac1e0641;
(function(FetchType) {
    FetchType[FetchType["normal"] = 1] = "normal";
    FetchType[FetchType["refetch"] = 2] = "refetch";
    FetchType[FetchType["poll"] = 3] = "poll";
})($03a288f5350d9e9d$export$160bafb6ac1e0641 || ($03a288f5350d9e9d$export$160bafb6ac1e0641 = {}));
var $03a288f5350d9e9d$var$hasError = function(storeValue, policy) {
    if (policy === void 0) policy = 'none';
    return storeValue && (storeValue.networkError || policy === 'none' && $03a288f5350d9e9d$var$isNonEmptyArray(storeValue.graphQLErrors));
};
var $03a288f5350d9e9d$export$6c1b56eac59c9584 = function(_super) {
    (0, $fKE23.__extends)(ObservableQuery, _super);
    function ObservableQuery(_a) {
        var queryManager = _a.queryManager, options = _a.options, _b = _a.shouldSubscribe, shouldSubscribe = _b === void 0 ? true : _b;
        var _this = _super.call(this, function(observer) {
            return _this.onSubscribe(observer);
        }) || this;
        _this.observers = new Set();
        _this.subscriptions = new Set();
        _this.isTornDown = false;
        _this.options = options;
        _this.variables = options.variables || {};
        _this.queryId = queryManager.generateQueryId();
        _this.shouldSubscribe = shouldSubscribe;
        var opDef = (0, $42BH7.getOperationDefinition)(options.query);
        _this.queryName = opDef && opDef.name && opDef.name.value;
        _this.queryManager = queryManager;
        return _this;
    }
    ObservableQuery.prototype.result = function() {
        var _this = this;
        return new Promise(function(resolve, reject) {
            var observer = {
                next: function(result) {
                    resolve(result);
                    _this.observers.delete(observer);
                    if (!_this.observers.size) _this.queryManager.removeQuery(_this.queryId);
                    setTimeout(function() {
                        subscription.unsubscribe();
                    }, 0);
                },
                error: reject
            };
            var subscription = _this.subscribe(observer);
        });
    };
    ObservableQuery.prototype.currentResult = function() {
        var result = this.getCurrentResult();
        if (result.data === undefined) result.data = {};
        return result;
    };
    ObservableQuery.prototype.getCurrentResult = function() {
        if (this.isTornDown) {
            var lastResult = this.lastResult;
            return {
                data: !this.lastError && lastResult && lastResult.data || void 0,
                error: this.lastError,
                loading: false,
                networkStatus: $03a288f5350d9e9d$export$bd096ddbd246c79c.error
            };
        }
        var _a = this.queryManager.getCurrentQueryResult(this), data = _a.data, partial = _a.partial;
        var queryStoreValue = this.queryManager.queryStore.get(this.queryId);
        var result;
        var fetchPolicy = this.options.fetchPolicy;
        var isNetworkFetchPolicy = fetchPolicy === 'network-only' || fetchPolicy === 'no-cache';
        if (queryStoreValue) {
            var networkStatus = queryStoreValue.networkStatus;
            if ($03a288f5350d9e9d$var$hasError(queryStoreValue, this.options.errorPolicy)) return {
                data: void 0,
                loading: false,
                networkStatus: networkStatus,
                error: new $03a288f5350d9e9d$export$26a337512320b8c6({
                    graphQLErrors: queryStoreValue.graphQLErrors,
                    networkError: queryStoreValue.networkError
                })
            };
            if (queryStoreValue.variables) {
                this.options.variables = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, this.options.variables), queryStoreValue.variables);
                this.variables = this.options.variables;
            }
            result = {
                data: data,
                loading: $03a288f5350d9e9d$var$isNetworkRequestInFlight(networkStatus),
                networkStatus: networkStatus
            };
            if (queryStoreValue.graphQLErrors && this.options.errorPolicy === 'all') result.errors = queryStoreValue.graphQLErrors;
        } else {
            var loading = isNetworkFetchPolicy || partial && fetchPolicy !== 'cache-only';
            result = {
                data: data,
                loading: loading,
                networkStatus: loading ? $03a288f5350d9e9d$export$bd096ddbd246c79c.loading : $03a288f5350d9e9d$export$bd096ddbd246c79c.ready
            };
        }
        if (!partial) this.updateLastResult((0, $fKE23.__assign)((0, $fKE23.__assign)({}, result), {
            stale: false
        }));
        return (0, $fKE23.__assign)((0, $fKE23.__assign)({}, result), {
            partial: partial
        });
    };
    ObservableQuery.prototype.isDifferentFromLastResult = function(newResult) {
        var snapshot = this.lastResultSnapshot;
        return !(snapshot && newResult && snapshot.networkStatus === newResult.networkStatus && snapshot.stale === newResult.stale && (0, $66hGB.equal)(snapshot.data, newResult.data));
    };
    ObservableQuery.prototype.getLastResult = function() {
        return this.lastResult;
    };
    ObservableQuery.prototype.getLastError = function() {
        return this.lastError;
    };
    ObservableQuery.prototype.resetLastResults = function() {
        delete this.lastResult;
        delete this.lastResultSnapshot;
        delete this.lastError;
        this.isTornDown = false;
    };
    ObservableQuery.prototype.resetQueryStoreErrors = function() {
        var queryStore = this.queryManager.queryStore.get(this.queryId);
        if (queryStore) {
            queryStore.networkError = null;
            queryStore.graphQLErrors = [];
        }
    };
    ObservableQuery.prototype.refetch = function(variables) {
        var fetchPolicy = this.options.fetchPolicy;
        if (fetchPolicy === 'cache-only') return Promise.reject(new (0, $8j2fP.InvariantError)(1));
        if (fetchPolicy !== 'no-cache' && fetchPolicy !== 'cache-and-network') fetchPolicy = 'network-only';
        if (!(0, $66hGB.equal)(this.variables, variables)) this.variables = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, this.variables), variables);
        if (!(0, $66hGB.equal)(this.options.variables, this.variables)) this.options.variables = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, this.options.variables), this.variables);
        return this.queryManager.fetchQuery(this.queryId, (0, $fKE23.__assign)((0, $fKE23.__assign)({}, this.options), {
            fetchPolicy: fetchPolicy
        }), $03a288f5350d9e9d$export$160bafb6ac1e0641.refetch);
    };
    ObservableQuery.prototype.fetchMore = function(fetchMoreOptions) {
        var _this = this;
        (0, $8j2fP.invariant)(fetchMoreOptions.updateQuery, 2);
        var combinedOptions = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, fetchMoreOptions.query ? fetchMoreOptions : (0, $fKE23.__assign)((0, $fKE23.__assign)((0, $fKE23.__assign)({}, this.options), fetchMoreOptions), {
            variables: (0, $fKE23.__assign)((0, $fKE23.__assign)({}, this.variables), fetchMoreOptions.variables)
        })), {
            fetchPolicy: 'network-only'
        });
        var qid = this.queryManager.generateQueryId();
        return this.queryManager.fetchQuery(qid, combinedOptions, $03a288f5350d9e9d$export$160bafb6ac1e0641.normal, this.queryId).then(function(fetchMoreResult) {
            _this.updateQuery(function(previousResult) {
                return fetchMoreOptions.updateQuery(previousResult, {
                    fetchMoreResult: fetchMoreResult.data,
                    variables: combinedOptions.variables
                });
            });
            _this.queryManager.stopQuery(qid);
            return fetchMoreResult;
        }, function(error) {
            _this.queryManager.stopQuery(qid);
            throw error;
        });
    };
    ObservableQuery.prototype.subscribeToMore = function(options) {
        var _this = this;
        var subscription = this.queryManager.startGraphQLSubscription({
            query: options.document,
            variables: options.variables
        }).subscribe({
            next: function(subscriptionData) {
                var updateQuery = options.updateQuery;
                if (updateQuery) _this.updateQuery(function(previous, _a) {
                    var variables = _a.variables;
                    return updateQuery(previous, {
                        subscriptionData: subscriptionData,
                        variables: variables
                    });
                });
            },
            error: function(err) {
                if (options.onError) {
                    options.onError(err);
                    return;
                }
            }
        });
        this.subscriptions.add(subscription);
        return function() {
            if (_this.subscriptions.delete(subscription)) subscription.unsubscribe();
        };
    };
    ObservableQuery.prototype.setOptions = function(opts) {
        var oldFetchPolicy = this.options.fetchPolicy;
        this.options = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, this.options), opts);
        if (opts.pollInterval) this.startPolling(opts.pollInterval);
        else if (opts.pollInterval === 0) this.stopPolling();
        var fetchPolicy = opts.fetchPolicy;
        return this.setVariables(this.options.variables, oldFetchPolicy !== fetchPolicy && (oldFetchPolicy === 'cache-only' || oldFetchPolicy === 'standby' || fetchPolicy === 'network-only'), opts.fetchResults);
    };
    ObservableQuery.prototype.setVariables = function(variables, tryFetch, fetchResults) {
        if (tryFetch === void 0) tryFetch = false;
        if (fetchResults === void 0) fetchResults = true;
        this.isTornDown = false;
        variables = variables || this.variables;
        if (!tryFetch && (0, $66hGB.equal)(variables, this.variables)) return this.observers.size && fetchResults ? this.result() : Promise.resolve();
        this.variables = this.options.variables = variables;
        if (!this.observers.size) return Promise.resolve();
        return this.queryManager.fetchQuery(this.queryId, this.options);
    };
    ObservableQuery.prototype.updateQuery = function(mapFn) {
        var queryManager = this.queryManager;
        var _a = queryManager.getQueryWithPreviousResult(this.queryId), previousResult = _a.previousResult, variables = _a.variables, document = _a.document;
        var newResult = (0, $42BH7.tryFunctionOrLogError)(function() {
            return mapFn(previousResult, {
                variables: variables
            });
        });
        if (newResult) {
            queryManager.dataStore.markUpdateQueryResult(document, variables, newResult);
            queryManager.broadcastQueries();
        }
    };
    ObservableQuery.prototype.stopPolling = function() {
        this.queryManager.stopPollingQuery(this.queryId);
        this.options.pollInterval = undefined;
    };
    ObservableQuery.prototype.startPolling = function(pollInterval) {
        $03a288f5350d9e9d$var$assertNotCacheFirstOrOnly(this);
        this.options.pollInterval = pollInterval;
        this.queryManager.startPollingQuery(this.options, this.queryId);
    };
    ObservableQuery.prototype.updateLastResult = function(newResult) {
        var previousResult = this.lastResult;
        this.lastResult = newResult;
        this.lastResultSnapshot = this.queryManager.assumeImmutableResults ? newResult : (0, $42BH7.cloneDeep)(newResult);
        return previousResult;
    };
    ObservableQuery.prototype.onSubscribe = function(observer) {
        var _this = this;
        try {
            var subObserver = observer._subscription._observer;
            if (subObserver && !subObserver.error) subObserver.error = $03a288f5350d9e9d$var$defaultSubscriptionObserverErrorCallback;
        } catch (_a) {}
        var first = !this.observers.size;
        this.observers.add(observer);
        if (observer.next && this.lastResult) observer.next(this.lastResult);
        if (observer.error && this.lastError) observer.error(this.lastError);
        if (first) this.setUpQuery();
        return function() {
            if (_this.observers.delete(observer) && !_this.observers.size) _this.tearDownQuery();
        };
    };
    ObservableQuery.prototype.setUpQuery = function() {
        var _this = this;
        var _a = this, queryManager = _a.queryManager, queryId = _a.queryId;
        if (this.shouldSubscribe) queryManager.addObservableQuery(queryId, this);
        if (this.options.pollInterval) {
            $03a288f5350d9e9d$var$assertNotCacheFirstOrOnly(this);
            queryManager.startPollingQuery(this.options, queryId);
        }
        var onError = function(error) {
            _this.updateLastResult((0, $fKE23.__assign)((0, $fKE23.__assign)({}, _this.lastResult), {
                errors: error.graphQLErrors,
                networkStatus: $03a288f5350d9e9d$export$bd096ddbd246c79c.error,
                loading: false
            }));
            $03a288f5350d9e9d$var$iterateObserversSafely(_this.observers, 'error', _this.lastError = error);
        };
        queryManager.observeQuery(queryId, this.options, {
            next: function(result) {
                if (_this.lastError || _this.isDifferentFromLastResult(result)) {
                    var previousResult_1 = _this.updateLastResult(result);
                    var _a = _this.options, query_1 = _a.query, variables = _a.variables, fetchPolicy_1 = _a.fetchPolicy;
                    if (queryManager.transform(query_1).hasClientExports) queryManager.getLocalState().addExportedVariables(query_1, variables).then(function(variables) {
                        var previousVariables = _this.variables;
                        _this.variables = _this.options.variables = variables;
                        if (!result.loading && previousResult_1 && fetchPolicy_1 !== 'cache-only' && queryManager.transform(query_1).serverQuery && !(0, $66hGB.equal)(previousVariables, variables)) _this.refetch();
                        else $03a288f5350d9e9d$var$iterateObserversSafely(_this.observers, 'next', result);
                    });
                    else $03a288f5350d9e9d$var$iterateObserversSafely(_this.observers, 'next', result);
                }
            },
            error: onError
        }).catch(onError);
    };
    ObservableQuery.prototype.tearDownQuery = function() {
        var queryManager = this.queryManager;
        this.isTornDown = true;
        queryManager.stopPollingQuery(this.queryId);
        this.subscriptions.forEach(function(sub) {
            return sub.unsubscribe();
        });
        this.subscriptions.clear();
        queryManager.removeObservableQuery(this.queryId);
        queryManager.stopQuery(this.queryId);
        this.observers.clear();
    };
    return ObservableQuery;
}($03a288f5350d9e9d$var$Observable);
function $03a288f5350d9e9d$var$defaultSubscriptionObserverErrorCallback(error) {}
function $03a288f5350d9e9d$var$iterateObserversSafely(observers, method, argument) {
    var observersWithMethod = [];
    observers.forEach(function(obs) {
        return obs[method] && observersWithMethod.push(obs);
    });
    observersWithMethod.forEach(function(obs) {
        return obs[method](argument);
    });
}
function $03a288f5350d9e9d$var$assertNotCacheFirstOrOnly(obsQuery) {
    var fetchPolicy = obsQuery.options.fetchPolicy;
    (0, $8j2fP.invariant)(fetchPolicy !== 'cache-first' && fetchPolicy !== 'cache-only', 3);
}
var $03a288f5350d9e9d$var$MutationStore = function() {
    function MutationStore() {
        this.store = {};
    }
    MutationStore.prototype.getStore = function() {
        return this.store;
    };
    MutationStore.prototype.get = function(mutationId) {
        return this.store[mutationId];
    };
    MutationStore.prototype.initMutation = function(mutationId, mutation, variables) {
        this.store[mutationId] = {
            mutation: mutation,
            variables: variables || {},
            loading: true,
            error: null
        };
    };
    MutationStore.prototype.markMutationError = function(mutationId, error) {
        var mutation = this.store[mutationId];
        if (mutation) {
            mutation.loading = false;
            mutation.error = error;
        }
    };
    MutationStore.prototype.markMutationResult = function(mutationId) {
        var mutation = this.store[mutationId];
        if (mutation) {
            mutation.loading = false;
            mutation.error = null;
        }
    };
    MutationStore.prototype.reset = function() {
        this.store = {};
    };
    return MutationStore;
}();
var $03a288f5350d9e9d$var$QueryStore = function() {
    function QueryStore() {
        this.store = {};
    }
    QueryStore.prototype.getStore = function() {
        return this.store;
    };
    QueryStore.prototype.get = function(queryId) {
        return this.store[queryId];
    };
    QueryStore.prototype.initQuery = function(query) {
        var previousQuery = this.store[query.queryId];
        (0, $8j2fP.invariant)(!previousQuery || previousQuery.document === query.document || (0, $66hGB.equal)(previousQuery.document, query.document), 19);
        var isSetVariables = false;
        var previousVariables = null;
        if (query.storePreviousVariables && previousQuery && previousQuery.networkStatus !== $03a288f5350d9e9d$export$bd096ddbd246c79c.loading) {
            if (!(0, $66hGB.equal)(previousQuery.variables, query.variables)) {
                isSetVariables = true;
                previousVariables = previousQuery.variables;
            }
        }
        var networkStatus;
        if (isSetVariables) networkStatus = $03a288f5350d9e9d$export$bd096ddbd246c79c.setVariables;
        else if (query.isPoll) networkStatus = $03a288f5350d9e9d$export$bd096ddbd246c79c.poll;
        else if (query.isRefetch) networkStatus = $03a288f5350d9e9d$export$bd096ddbd246c79c.refetch;
        else networkStatus = $03a288f5350d9e9d$export$bd096ddbd246c79c.loading;
        var graphQLErrors = [];
        if (previousQuery && previousQuery.graphQLErrors) graphQLErrors = previousQuery.graphQLErrors;
        this.store[query.queryId] = {
            document: query.document,
            variables: query.variables,
            previousVariables: previousVariables,
            networkError: null,
            graphQLErrors: graphQLErrors,
            networkStatus: networkStatus,
            metadata: query.metadata
        };
        if (typeof query.fetchMoreForQueryId === 'string' && this.store[query.fetchMoreForQueryId]) this.store[query.fetchMoreForQueryId].networkStatus = $03a288f5350d9e9d$export$bd096ddbd246c79c.fetchMore;
    };
    QueryStore.prototype.markQueryResult = function(queryId, result, fetchMoreForQueryId) {
        if (!this.store || !this.store[queryId]) return;
        this.store[queryId].networkError = null;
        this.store[queryId].graphQLErrors = $03a288f5350d9e9d$var$isNonEmptyArray(result.errors) ? result.errors : [];
        this.store[queryId].previousVariables = null;
        this.store[queryId].networkStatus = $03a288f5350d9e9d$export$bd096ddbd246c79c.ready;
        if (typeof fetchMoreForQueryId === 'string' && this.store[fetchMoreForQueryId]) this.store[fetchMoreForQueryId].networkStatus = $03a288f5350d9e9d$export$bd096ddbd246c79c.ready;
    };
    QueryStore.prototype.markQueryError = function(queryId, error, fetchMoreForQueryId) {
        if (!this.store || !this.store[queryId]) return;
        this.store[queryId].networkError = error;
        this.store[queryId].networkStatus = $03a288f5350d9e9d$export$bd096ddbd246c79c.error;
        if (typeof fetchMoreForQueryId === 'string') this.markQueryResultClient(fetchMoreForQueryId, true);
    };
    QueryStore.prototype.markQueryResultClient = function(queryId, complete) {
        var storeValue = this.store && this.store[queryId];
        if (storeValue) {
            storeValue.networkError = null;
            storeValue.previousVariables = null;
            if (complete) storeValue.networkStatus = $03a288f5350d9e9d$export$bd096ddbd246c79c.ready;
        }
    };
    QueryStore.prototype.stopQuery = function(queryId) {
        delete this.store[queryId];
    };
    QueryStore.prototype.reset = function(observableQueryIds) {
        var _this = this;
        Object.keys(this.store).forEach(function(queryId) {
            if (observableQueryIds.indexOf(queryId) < 0) _this.stopQuery(queryId);
            else _this.store[queryId].networkStatus = $03a288f5350d9e9d$export$bd096ddbd246c79c.loading;
        });
    };
    return QueryStore;
}();
function $03a288f5350d9e9d$var$capitalizeFirstLetter(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
}
var $03a288f5350d9e9d$var$LocalState = function() {
    function LocalState(_a) {
        var cache = _a.cache, client = _a.client, resolvers = _a.resolvers, fragmentMatcher = _a.fragmentMatcher;
        this.cache = cache;
        if (client) this.client = client;
        if (resolvers) this.addResolvers(resolvers);
        if (fragmentMatcher) this.setFragmentMatcher(fragmentMatcher);
    }
    LocalState.prototype.addResolvers = function(resolvers) {
        var _this = this;
        this.resolvers = this.resolvers || {};
        if (Array.isArray(resolvers)) resolvers.forEach(function(resolverGroup) {
            _this.resolvers = (0, $42BH7.mergeDeep)(_this.resolvers, resolverGroup);
        });
        else this.resolvers = (0, $42BH7.mergeDeep)(this.resolvers, resolvers);
    };
    LocalState.prototype.setResolvers = function(resolvers) {
        this.resolvers = {};
        this.addResolvers(resolvers);
    };
    LocalState.prototype.getResolvers = function() {
        return this.resolvers || {};
    };
    LocalState.prototype.runResolvers = function(_a) {
        var document = _a.document, remoteResult = _a.remoteResult, context = _a.context, variables = _a.variables, _b = _a.onlyRunForcedResolvers, onlyRunForcedResolvers = _b === void 0 ? false : _b;
        return (0, $fKE23.__awaiter)(this, void 0, void 0, function() {
            return (0, $fKE23.__generator)(this, function(_c) {
                if (document) return [
                    2,
                    this.resolveDocument(document, remoteResult.data, context, variables, this.fragmentMatcher, onlyRunForcedResolvers).then(function(localResult) {
                        return (0, $fKE23.__assign)((0, $fKE23.__assign)({}, remoteResult), {
                            data: localResult.result
                        });
                    })
                ];
                return [
                    2,
                    remoteResult
                ];
            });
        });
    };
    LocalState.prototype.setFragmentMatcher = function(fragmentMatcher) {
        this.fragmentMatcher = fragmentMatcher;
    };
    LocalState.prototype.getFragmentMatcher = function() {
        return this.fragmentMatcher;
    };
    LocalState.prototype.clientQuery = function(document) {
        if ((0, $42BH7.hasDirectives)([
            'client'
        ], document)) {
            if (this.resolvers) return document;
        }
        return null;
    };
    LocalState.prototype.serverQuery = function(document) {
        return this.resolvers ? (0, $42BH7.removeClientSetsFromDocument)(document) : document;
    };
    LocalState.prototype.prepareContext = function(context) {
        if (context === void 0) context = {};
        var cache = this.cache;
        var newContext = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, context), {
            cache: cache,
            getCacheKey: function(obj) {
                if (cache.config) return cache.config.dataIdFromObject(obj);
                else (0, $8j2fP.invariant)(false, 6);
            }
        });
        return newContext;
    };
    LocalState.prototype.addExportedVariables = function(document, variables, context) {
        if (variables === void 0) variables = {};
        if (context === void 0) context = {};
        return (0, $fKE23.__awaiter)(this, void 0, void 0, function() {
            return (0, $fKE23.__generator)(this, function(_a) {
                if (document) return [
                    2,
                    this.resolveDocument(document, this.buildRootValueFromCache(document, variables) || {}, this.prepareContext(context), variables).then(function(data) {
                        return (0, $fKE23.__assign)((0, $fKE23.__assign)({}, variables), data.exportedVariables);
                    })
                ];
                return [
                    2,
                    (0, $fKE23.__assign)({}, variables)
                ];
            });
        });
    };
    LocalState.prototype.shouldForceResolvers = function(document) {
        var forceResolvers = false;
        (0, $961BR.visit)(document, {
            Directive: {
                enter: function(node) {
                    if (node.name.value === 'client' && node.arguments) {
                        forceResolvers = node.arguments.some(function(arg) {
                            return arg.name.value === 'always' && arg.value.kind === 'BooleanValue' && arg.value.value === true;
                        });
                        if (forceResolvers) return 0, $961BR.BREAK;
                    }
                }
            }
        });
        return forceResolvers;
    };
    LocalState.prototype.buildRootValueFromCache = function(document, variables) {
        return this.cache.diff({
            query: (0, $42BH7.buildQueryFromSelectionSet)(document),
            variables: variables,
            returnPartialData: true,
            optimistic: false
        }).result;
    };
    LocalState.prototype.resolveDocument = function(document, rootValue, context, variables, fragmentMatcher, onlyRunForcedResolvers) {
        if (context === void 0) context = {};
        if (variables === void 0) variables = {};
        if (fragmentMatcher === void 0) fragmentMatcher = function() {
            return true;
        };
        if (onlyRunForcedResolvers === void 0) onlyRunForcedResolvers = false;
        return (0, $fKE23.__awaiter)(this, void 0, void 0, function() {
            var mainDefinition, fragments, fragmentMap, definitionOperation, defaultOperationType, _a, cache, client, execContext;
            return (0, $fKE23.__generator)(this, function(_b) {
                mainDefinition = (0, $42BH7.getMainDefinition)(document);
                fragments = (0, $42BH7.getFragmentDefinitions)(document);
                fragmentMap = (0, $42BH7.createFragmentMap)(fragments);
                definitionOperation = mainDefinition.operation;
                defaultOperationType = definitionOperation ? $03a288f5350d9e9d$var$capitalizeFirstLetter(definitionOperation) : 'Query';
                _a = this, cache = _a.cache, client = _a.client;
                execContext = {
                    fragmentMap: fragmentMap,
                    context: (0, $fKE23.__assign)((0, $fKE23.__assign)({}, context), {
                        cache: cache,
                        client: client
                    }),
                    variables: variables,
                    fragmentMatcher: fragmentMatcher,
                    defaultOperationType: defaultOperationType,
                    exportedVariables: {},
                    onlyRunForcedResolvers: onlyRunForcedResolvers
                };
                return [
                    2,
                    this.resolveSelectionSet(mainDefinition.selectionSet, rootValue, execContext).then(function(result) {
                        return {
                            result: result,
                            exportedVariables: execContext.exportedVariables
                        };
                    })
                ];
            });
        });
    };
    LocalState.prototype.resolveSelectionSet = function(selectionSet, rootValue, execContext) {
        return (0, $fKE23.__awaiter)(this, void 0, void 0, function() {
            var fragmentMap, context, variables, resultsToMerge, execute;
            var _this = this;
            return (0, $fKE23.__generator)(this, function(_a) {
                fragmentMap = execContext.fragmentMap, context = execContext.context, variables = execContext.variables;
                resultsToMerge = [
                    rootValue
                ];
                execute = function(selection) {
                    return (0, $fKE23.__awaiter)(_this, void 0, void 0, function() {
                        var fragment, typeCondition;
                        return (0, $fKE23.__generator)(this, function(_a) {
                            if (!(0, $42BH7.shouldInclude)(selection, variables)) return [
                                2
                            ];
                            if ((0, $42BH7.isField)(selection)) return [
                                2,
                                this.resolveField(selection, rootValue, execContext).then(function(fieldResult) {
                                    var _a;
                                    if (typeof fieldResult !== 'undefined') resultsToMerge.push((_a = {}, _a[(0, $42BH7.resultKeyNameFromField)(selection)] = fieldResult, _a));
                                })
                            ];
                            if ((0, $42BH7.isInlineFragment)(selection)) fragment = selection;
                            else {
                                fragment = fragmentMap[selection.name.value];
                                (0, $8j2fP.invariant)(fragment, 7);
                            }
                            if (fragment && fragment.typeCondition) {
                                typeCondition = fragment.typeCondition.name.value;
                                if (execContext.fragmentMatcher(rootValue, typeCondition, context)) return [
                                    2,
                                    this.resolveSelectionSet(fragment.selectionSet, rootValue, execContext).then(function(fragmentResult) {
                                        resultsToMerge.push(fragmentResult);
                                    })
                                ];
                            }
                            return [
                                2
                            ];
                        });
                    });
                };
                return [
                    2,
                    Promise.all(selectionSet.selections.map(execute)).then(function() {
                        return (0, $42BH7.mergeDeepArray)(resultsToMerge);
                    })
                ];
            });
        });
    };
    LocalState.prototype.resolveField = function(field, rootValue, execContext) {
        return (0, $fKE23.__awaiter)(this, void 0, void 0, function() {
            var variables, fieldName, aliasedFieldName, aliasUsed, defaultResult, resultPromise, resolverType, resolverMap, resolve;
            var _this = this;
            return (0, $fKE23.__generator)(this, function(_a) {
                variables = execContext.variables;
                fieldName = field.name.value;
                aliasedFieldName = (0, $42BH7.resultKeyNameFromField)(field);
                aliasUsed = fieldName !== aliasedFieldName;
                defaultResult = rootValue[aliasedFieldName] || rootValue[fieldName];
                resultPromise = Promise.resolve(defaultResult);
                if (!execContext.onlyRunForcedResolvers || this.shouldForceResolvers(field)) {
                    resolverType = rootValue.__typename || execContext.defaultOperationType;
                    resolverMap = this.resolvers && this.resolvers[resolverType];
                    if (resolverMap) {
                        resolve = resolverMap[aliasUsed ? fieldName : aliasedFieldName];
                        if (resolve) resultPromise = Promise.resolve(resolve(rootValue, (0, $42BH7.argumentsObjectFromField)(field, variables), execContext.context, {
                            field: field,
                            fragmentMap: execContext.fragmentMap
                        }));
                    }
                }
                return [
                    2,
                    resultPromise.then(function(result) {
                        if (result === void 0) result = defaultResult;
                        if (field.directives) field.directives.forEach(function(directive) {
                            if (directive.name.value === 'export' && directive.arguments) directive.arguments.forEach(function(arg) {
                                if (arg.name.value === 'as' && arg.value.kind === 'StringValue') execContext.exportedVariables[arg.value.value] = result;
                            });
                        });
                        if (!field.selectionSet) return result;
                        if (result == null) return result;
                        if (Array.isArray(result)) return _this.resolveSubSelectedArray(field, result, execContext);
                        if (field.selectionSet) return _this.resolveSelectionSet(field.selectionSet, result, execContext);
                    })
                ];
            });
        });
    };
    LocalState.prototype.resolveSubSelectedArray = function(field, result, execContext) {
        var _this = this;
        return Promise.all(result.map(function(item) {
            if (item === null) return null;
            if (Array.isArray(item)) return _this.resolveSubSelectedArray(field, item, execContext);
            if (field.selectionSet) return _this.resolveSelectionSet(field.selectionSet, item, execContext);
        }));
    };
    return LocalState;
}();
function $03a288f5350d9e9d$var$multiplex(inner) {
    var observers = new Set();
    var sub = null;
    return new $03a288f5350d9e9d$var$Observable(function(observer) {
        observers.add(observer);
        sub = sub || inner.subscribe({
            next: function(value) {
                observers.forEach(function(obs) {
                    return obs.next && obs.next(value);
                });
            },
            error: function(error) {
                observers.forEach(function(obs) {
                    return obs.error && obs.error(error);
                });
            },
            complete: function() {
                observers.forEach(function(obs) {
                    return obs.complete && obs.complete();
                });
            }
        });
        return function() {
            if (observers.delete(observer) && !observers.size && sub) {
                sub.unsubscribe();
                sub = null;
            }
        };
    });
}
function $03a288f5350d9e9d$var$asyncMap(observable, mapFn) {
    return new $03a288f5350d9e9d$var$Observable(function(observer) {
        var next = observer.next, error = observer.error, complete = observer.complete;
        var activeNextCount = 0;
        var completed = false;
        var handler = {
            next: function(value) {
                ++activeNextCount;
                new Promise(function(resolve) {
                    resolve(mapFn(value));
                }).then(function(result) {
                    --activeNextCount;
                    next && next.call(observer, result);
                    completed && handler.complete();
                }, function(e) {
                    --activeNextCount;
                    error && error.call(observer, e);
                });
            },
            error: function(e) {
                error && error.call(observer, e);
            },
            complete: function() {
                completed = true;
                if (!activeNextCount) complete && complete.call(observer);
            }
        };
        var sub = observable.subscribe(handler);
        return function() {
            return sub.unsubscribe();
        };
    });
}
var $03a288f5350d9e9d$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $03a288f5350d9e9d$var$QueryManager = function() {
    function QueryManager(_a) {
        var link = _a.link, _b = _a.queryDeduplication, queryDeduplication = _b === void 0 ? false : _b, store = _a.store, _c = _a.onBroadcast, onBroadcast = _c === void 0 ? function() {
            return undefined;
        } : _c, _d = _a.ssrMode, ssrMode = _d === void 0 ? false : _d, _e = _a.clientAwareness, clientAwareness = _e === void 0 ? {} : _e, localState = _a.localState, assumeImmutableResults = _a.assumeImmutableResults;
        this.mutationStore = new $03a288f5350d9e9d$var$MutationStore();
        this.queryStore = new $03a288f5350d9e9d$var$QueryStore();
        this.clientAwareness = {};
        this.idCounter = 1;
        this.queries = new Map();
        this.fetchQueryRejectFns = new Map();
        this.transformCache = new ((0, $42BH7.canUseWeakMap) ? WeakMap : Map)();
        this.inFlightLinkObservables = new Map();
        this.pollingInfoByQueryId = new Map();
        this.link = link;
        this.queryDeduplication = queryDeduplication;
        this.dataStore = store;
        this.onBroadcast = onBroadcast;
        this.clientAwareness = clientAwareness;
        this.localState = localState || new $03a288f5350d9e9d$var$LocalState({
            cache: store.getCache()
        });
        this.ssrMode = ssrMode;
        this.assumeImmutableResults = !!assumeImmutableResults;
    }
    QueryManager.prototype.stop = function() {
        var _this = this;
        this.queries.forEach(function(_info, queryId) {
            _this.stopQueryNoBroadcast(queryId);
        });
        this.fetchQueryRejectFns.forEach(function(reject) {
            reject(new (0, $8j2fP.InvariantError)(8));
        });
    };
    QueryManager.prototype.mutate = function(_a) {
        var mutation = _a.mutation, variables = _a.variables, optimisticResponse = _a.optimisticResponse, updateQueriesByName = _a.updateQueries, _b = _a.refetchQueries, refetchQueries = _b === void 0 ? [] : _b, _c = _a.awaitRefetchQueries, awaitRefetchQueries = _c === void 0 ? false : _c, updateWithProxyFn = _a.update, _d = _a.errorPolicy, errorPolicy = _d === void 0 ? 'none' : _d, fetchPolicy = _a.fetchPolicy, _e = _a.context, context = _e === void 0 ? {} : _e;
        return (0, $fKE23.__awaiter)(this, void 0, void 0, function() {
            var mutationId, generateUpdateQueriesInfo, self;
            var _this = this;
            return (0, $fKE23.__generator)(this, function(_f) {
                switch(_f.label){
                    case 0:
                        (0, $8j2fP.invariant)(mutation, 9);
                        (0, $8j2fP.invariant)(!fetchPolicy || fetchPolicy === 'no-cache', 10);
                        mutationId = this.generateQueryId();
                        mutation = this.transform(mutation).document;
                        this.setQuery(mutationId, function() {
                            return {
                                document: mutation
                            };
                        });
                        variables = this.getVariables(mutation, variables);
                        if (!this.transform(mutation).hasClientExports) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            this.localState.addExportedVariables(mutation, variables, context)
                        ];
                    case 1:
                        variables = _f.sent();
                        _f.label = 2;
                    case 2:
                        generateUpdateQueriesInfo = function() {
                            var ret = {};
                            if (updateQueriesByName) _this.queries.forEach(function(_a, queryId) {
                                var observableQuery = _a.observableQuery;
                                if (observableQuery) {
                                    var queryName = observableQuery.queryName;
                                    if (queryName && $03a288f5350d9e9d$var$hasOwnProperty.call(updateQueriesByName, queryName)) ret[queryId] = {
                                        updater: updateQueriesByName[queryName],
                                        query: _this.queryStore.get(queryId)
                                    };
                                }
                            });
                            return ret;
                        };
                        this.mutationStore.initMutation(mutationId, mutation, variables);
                        this.dataStore.markMutationInit({
                            mutationId: mutationId,
                            document: mutation,
                            variables: variables,
                            updateQueries: generateUpdateQueriesInfo(),
                            update: updateWithProxyFn,
                            optimisticResponse: optimisticResponse
                        });
                        this.broadcastQueries();
                        self = this;
                        return [
                            2,
                            new Promise(function(resolve, reject) {
                                var storeResult;
                                var error;
                                self.getObservableFromLink(mutation, (0, $fKE23.__assign)((0, $fKE23.__assign)({}, context), {
                                    optimisticResponse: optimisticResponse
                                }), variables, false).subscribe({
                                    next: function(result) {
                                        if ((0, $42BH7.graphQLResultHasError)(result) && errorPolicy === 'none') {
                                            error = new $03a288f5350d9e9d$export$26a337512320b8c6({
                                                graphQLErrors: result.errors
                                            });
                                            return;
                                        }
                                        self.mutationStore.markMutationResult(mutationId);
                                        if (fetchPolicy !== 'no-cache') self.dataStore.markMutationResult({
                                            mutationId: mutationId,
                                            result: result,
                                            document: mutation,
                                            variables: variables,
                                            updateQueries: generateUpdateQueriesInfo(),
                                            update: updateWithProxyFn
                                        });
                                        storeResult = result;
                                    },
                                    error: function(err) {
                                        self.mutationStore.markMutationError(mutationId, err);
                                        self.dataStore.markMutationComplete({
                                            mutationId: mutationId,
                                            optimisticResponse: optimisticResponse
                                        });
                                        self.broadcastQueries();
                                        self.setQuery(mutationId, function() {
                                            return {
                                                document: null
                                            };
                                        });
                                        reject(new $03a288f5350d9e9d$export$26a337512320b8c6({
                                            networkError: err
                                        }));
                                    },
                                    complete: function() {
                                        if (error) self.mutationStore.markMutationError(mutationId, error);
                                        self.dataStore.markMutationComplete({
                                            mutationId: mutationId,
                                            optimisticResponse: optimisticResponse
                                        });
                                        self.broadcastQueries();
                                        if (error) {
                                            reject(error);
                                            return;
                                        }
                                        if (typeof refetchQueries === 'function') refetchQueries = refetchQueries(storeResult);
                                        var refetchQueryPromises = [];
                                        if ($03a288f5350d9e9d$var$isNonEmptyArray(refetchQueries)) refetchQueries.forEach(function(refetchQuery) {
                                            if (typeof refetchQuery === 'string') self.queries.forEach(function(_a) {
                                                var observableQuery = _a.observableQuery;
                                                if (observableQuery && observableQuery.queryName === refetchQuery) refetchQueryPromises.push(observableQuery.refetch());
                                            });
                                            else {
                                                var queryOptions = {
                                                    query: refetchQuery.query,
                                                    variables: refetchQuery.variables,
                                                    fetchPolicy: 'network-only'
                                                };
                                                if (refetchQuery.context) queryOptions.context = refetchQuery.context;
                                                refetchQueryPromises.push(self.query(queryOptions));
                                            }
                                        });
                                        Promise.all(awaitRefetchQueries ? refetchQueryPromises : []).then(function() {
                                            self.setQuery(mutationId, function() {
                                                return {
                                                    document: null
                                                };
                                            });
                                            if (errorPolicy === 'ignore' && storeResult && (0, $42BH7.graphQLResultHasError)(storeResult)) delete storeResult.errors;
                                            resolve(storeResult);
                                        });
                                    }
                                });
                            })
                        ];
                }
            });
        });
    };
    QueryManager.prototype.fetchQuery = function(queryId, options, fetchType, fetchMoreForQueryId) {
        return (0, $fKE23.__awaiter)(this, void 0, void 0, function() {
            var _a, metadata, _b, fetchPolicy, _c, context, query, variables, storeResult, isNetworkOnly, needToFetch, _d, complete, result, shouldFetch, requestId, cancel, networkResult;
            var _this = this;
            return (0, $fKE23.__generator)(this, function(_e) {
                switch(_e.label){
                    case 0:
                        _a = options.metadata, metadata = _a === void 0 ? null : _a, _b = options.fetchPolicy, fetchPolicy = _b === void 0 ? 'cache-first' : _b, _c = options.context, context = _c === void 0 ? {} : _c;
                        query = this.transform(options.query).document;
                        variables = this.getVariables(query, options.variables);
                        if (!this.transform(query).hasClientExports) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            this.localState.addExportedVariables(query, variables, context)
                        ];
                    case 1:
                        variables = _e.sent();
                        _e.label = 2;
                    case 2:
                        options = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, options), {
                            variables: variables
                        });
                        isNetworkOnly = fetchPolicy === 'network-only' || fetchPolicy === 'no-cache';
                        needToFetch = isNetworkOnly;
                        if (!isNetworkOnly) {
                            _d = this.dataStore.getCache().diff({
                                query: query,
                                variables: variables,
                                returnPartialData: true,
                                optimistic: false
                            }), complete = _d.complete, result = _d.result;
                            needToFetch = !complete || fetchPolicy === 'cache-and-network';
                            storeResult = result;
                        }
                        shouldFetch = needToFetch && fetchPolicy !== 'cache-only' && fetchPolicy !== 'standby';
                        if ((0, $42BH7.hasDirectives)([
                            'live'
                        ], query)) shouldFetch = true;
                        requestId = this.idCounter++;
                        cancel = fetchPolicy !== 'no-cache' ? this.updateQueryWatch(queryId, query, options) : undefined;
                        this.setQuery(queryId, function() {
                            return {
                                document: query,
                                lastRequestId: requestId,
                                invalidated: true,
                                cancel: cancel
                            };
                        });
                        this.invalidate(fetchMoreForQueryId);
                        this.queryStore.initQuery({
                            queryId: queryId,
                            document: query,
                            storePreviousVariables: shouldFetch,
                            variables: variables,
                            isPoll: fetchType === $03a288f5350d9e9d$export$160bafb6ac1e0641.poll,
                            isRefetch: fetchType === $03a288f5350d9e9d$export$160bafb6ac1e0641.refetch,
                            metadata: metadata,
                            fetchMoreForQueryId: fetchMoreForQueryId
                        });
                        this.broadcastQueries();
                        if (shouldFetch) {
                            networkResult = this.fetchRequest({
                                requestId: requestId,
                                queryId: queryId,
                                document: query,
                                options: options,
                                fetchMoreForQueryId: fetchMoreForQueryId
                            }).catch(function(error) {
                                if ($03a288f5350d9e9d$export$17f5e6bd290bb15d(error)) throw error;
                                else {
                                    if (requestId >= _this.getQuery(queryId).lastRequestId) {
                                        _this.queryStore.markQueryError(queryId, error, fetchMoreForQueryId);
                                        _this.invalidate(queryId);
                                        _this.invalidate(fetchMoreForQueryId);
                                        _this.broadcastQueries();
                                    }
                                    throw new $03a288f5350d9e9d$export$26a337512320b8c6({
                                        networkError: error
                                    });
                                }
                            });
                            if (fetchPolicy !== 'cache-and-network') return [
                                2,
                                networkResult
                            ];
                            networkResult.catch(function() {});
                        }
                        this.queryStore.markQueryResultClient(queryId, !shouldFetch);
                        this.invalidate(queryId);
                        this.invalidate(fetchMoreForQueryId);
                        if (this.transform(query).hasForcedResolvers) return [
                            2,
                            this.localState.runResolvers({
                                document: query,
                                remoteResult: {
                                    data: storeResult
                                },
                                context: context,
                                variables: variables,
                                onlyRunForcedResolvers: true
                            }).then(function(result) {
                                _this.markQueryResult(queryId, result, options, fetchMoreForQueryId);
                                _this.broadcastQueries();
                                return result;
                            })
                        ];
                        this.broadcastQueries();
                        return [
                            2,
                            {
                                data: storeResult
                            }
                        ];
                }
            });
        });
    };
    QueryManager.prototype.markQueryResult = function(queryId, result, _a, fetchMoreForQueryId) {
        var fetchPolicy = _a.fetchPolicy, variables = _a.variables, errorPolicy = _a.errorPolicy;
        if (fetchPolicy === 'no-cache') this.setQuery(queryId, function() {
            return {
                newData: {
                    result: result.data,
                    complete: true
                }
            };
        });
        else this.dataStore.markQueryResult(result, this.getQuery(queryId).document, variables, fetchMoreForQueryId, errorPolicy === 'ignore' || errorPolicy === 'all');
    };
    QueryManager.prototype.queryListenerForObserver = function(queryId, options, observer) {
        var _this = this;
        function invoke(method, argument) {
            if (observer[method]) try {
                observer[method](argument);
            } catch (e) {}
            else method;
        }
        return function(queryStoreValue, newData) {
            _this.invalidate(queryId, false);
            if (!queryStoreValue) return;
            var _a = _this.getQuery(queryId), observableQuery = _a.observableQuery, document = _a.document;
            var fetchPolicy = observableQuery ? observableQuery.options.fetchPolicy : options.fetchPolicy;
            if (fetchPolicy === 'standby') return;
            var loading = $03a288f5350d9e9d$var$isNetworkRequestInFlight(queryStoreValue.networkStatus);
            var lastResult = observableQuery && observableQuery.getLastResult();
            var networkStatusChanged = !!(lastResult && lastResult.networkStatus !== queryStoreValue.networkStatus);
            var shouldNotifyIfLoading = options.returnPartialData || !newData && queryStoreValue.previousVariables || networkStatusChanged && options.notifyOnNetworkStatusChange || fetchPolicy === 'cache-only' || fetchPolicy === 'cache-and-network';
            if (loading && !shouldNotifyIfLoading) return;
            var hasGraphQLErrors = $03a288f5350d9e9d$var$isNonEmptyArray(queryStoreValue.graphQLErrors);
            var errorPolicy = observableQuery && observableQuery.options.errorPolicy || options.errorPolicy || 'none';
            if (errorPolicy === 'none' && hasGraphQLErrors || queryStoreValue.networkError) return invoke('error', new $03a288f5350d9e9d$export$26a337512320b8c6({
                graphQLErrors: queryStoreValue.graphQLErrors,
                networkError: queryStoreValue.networkError
            }));
            try {
                var data = void 0;
                var isMissing = void 0;
                if (newData) {
                    if (fetchPolicy !== 'no-cache' && fetchPolicy !== 'network-only') _this.setQuery(queryId, function() {
                        return {
                            newData: null
                        };
                    });
                    data = newData.result;
                    isMissing = !newData.complete;
                } else {
                    var lastError = observableQuery && observableQuery.getLastError();
                    var errorStatusChanged = errorPolicy !== 'none' && (lastError && lastError.graphQLErrors) !== queryStoreValue.graphQLErrors;
                    if (lastResult && lastResult.data && !errorStatusChanged) {
                        data = lastResult.data;
                        isMissing = false;
                    } else {
                        var diffResult = _this.dataStore.getCache().diff({
                            query: document,
                            variables: queryStoreValue.previousVariables || queryStoreValue.variables,
                            returnPartialData: true,
                            optimistic: true
                        });
                        data = diffResult.result;
                        isMissing = !diffResult.complete;
                    }
                }
                var stale = isMissing && !(options.returnPartialData || fetchPolicy === 'cache-only');
                var resultFromStore = {
                    data: stale ? lastResult && lastResult.data : data,
                    loading: loading,
                    networkStatus: queryStoreValue.networkStatus,
                    stale: stale
                };
                if (errorPolicy === 'all' && hasGraphQLErrors) resultFromStore.errors = queryStoreValue.graphQLErrors;
                invoke('next', resultFromStore);
            } catch (networkError) {
                invoke('error', new $03a288f5350d9e9d$export$26a337512320b8c6({
                    networkError: networkError
                }));
            }
        };
    };
    QueryManager.prototype.transform = function(document) {
        var transformCache = this.transformCache;
        if (!transformCache.has(document)) {
            var cache = this.dataStore.getCache();
            var transformed = cache.transformDocument(document);
            var forLink = (0, $42BH7.removeConnectionDirectiveFromDocument)(cache.transformForLink(transformed));
            var clientQuery = this.localState.clientQuery(transformed);
            var serverQuery = this.localState.serverQuery(forLink);
            var cacheEntry_1 = {
                document: transformed,
                hasClientExports: (0, $42BH7.hasClientExports)(transformed),
                hasForcedResolvers: this.localState.shouldForceResolvers(transformed),
                clientQuery: clientQuery,
                serverQuery: serverQuery,
                defaultVars: (0, $42BH7.getDefaultValues)((0, $42BH7.getOperationDefinition)(transformed))
            };
            var add = function(doc) {
                if (doc && !transformCache.has(doc)) transformCache.set(doc, cacheEntry_1);
            };
            add(document);
            add(transformed);
            add(clientQuery);
            add(serverQuery);
        }
        return transformCache.get(document);
    };
    QueryManager.prototype.getVariables = function(document, variables) {
        return (0, $fKE23.__assign)((0, $fKE23.__assign)({}, this.transform(document).defaultVars), variables);
    };
    QueryManager.prototype.watchQuery = function(options, shouldSubscribe) {
        if (shouldSubscribe === void 0) shouldSubscribe = true;
        (0, $8j2fP.invariant)(options.fetchPolicy !== 'standby', 11);
        options.variables = this.getVariables(options.query, options.variables);
        if (typeof options.notifyOnNetworkStatusChange === 'undefined') options.notifyOnNetworkStatusChange = false;
        var transformedOptions = (0, $fKE23.__assign)({}, options);
        return new $03a288f5350d9e9d$export$6c1b56eac59c9584({
            queryManager: this,
            options: transformedOptions,
            shouldSubscribe: shouldSubscribe
        });
    };
    QueryManager.prototype.query = function(options) {
        var _this = this;
        (0, $8j2fP.invariant)(options.query, 12);
        (0, $8j2fP.invariant)(options.query.kind === 'Document', 13);
        (0, $8j2fP.invariant)(!options.returnPartialData, 14);
        (0, $8j2fP.invariant)(!options.pollInterval, 15);
        return new Promise(function(resolve, reject) {
            var watchedQuery = _this.watchQuery(options, false);
            _this.fetchQueryRejectFns.set("query:" + watchedQuery.queryId, reject);
            watchedQuery.result().then(resolve, reject).then(function() {
                return _this.fetchQueryRejectFns.delete("query:" + watchedQuery.queryId);
            });
        });
    };
    QueryManager.prototype.generateQueryId = function() {
        return String(this.idCounter++);
    };
    QueryManager.prototype.stopQueryInStore = function(queryId) {
        this.stopQueryInStoreNoBroadcast(queryId);
        this.broadcastQueries();
    };
    QueryManager.prototype.stopQueryInStoreNoBroadcast = function(queryId) {
        this.stopPollingQuery(queryId);
        this.queryStore.stopQuery(queryId);
        this.invalidate(queryId);
    };
    QueryManager.prototype.addQueryListener = function(queryId, listener) {
        this.setQuery(queryId, function(_a) {
            var listeners = _a.listeners;
            listeners.add(listener);
            return {
                invalidated: false
            };
        });
    };
    QueryManager.prototype.updateQueryWatch = function(queryId, document, options) {
        var _this = this;
        var cancel = this.getQuery(queryId).cancel;
        if (cancel) cancel();
        var previousResult = function() {
            var previousResult = null;
            var observableQuery = _this.getQuery(queryId).observableQuery;
            if (observableQuery) {
                var lastResult = observableQuery.getLastResult();
                if (lastResult) previousResult = lastResult.data;
            }
            return previousResult;
        };
        return this.dataStore.getCache().watch({
            query: document,
            variables: options.variables,
            optimistic: true,
            previousResult: previousResult,
            callback: function(newData) {
                _this.setQuery(queryId, function() {
                    return {
                        invalidated: true,
                        newData: newData
                    };
                });
            }
        });
    };
    QueryManager.prototype.addObservableQuery = function(queryId, observableQuery) {
        this.setQuery(queryId, function() {
            return {
                observableQuery: observableQuery
            };
        });
    };
    QueryManager.prototype.removeObservableQuery = function(queryId) {
        var cancel = this.getQuery(queryId).cancel;
        this.setQuery(queryId, function() {
            return {
                observableQuery: null
            };
        });
        if (cancel) cancel();
    };
    QueryManager.prototype.clearStore = function() {
        this.fetchQueryRejectFns.forEach(function(reject) {
            reject(new (0, $8j2fP.InvariantError)(16));
        });
        var resetIds = [];
        this.queries.forEach(function(_a, queryId) {
            var observableQuery = _a.observableQuery;
            if (observableQuery) resetIds.push(queryId);
        });
        this.queryStore.reset(resetIds);
        this.mutationStore.reset();
        return this.dataStore.reset();
    };
    QueryManager.prototype.resetStore = function() {
        var _this = this;
        return this.clearStore().then(function() {
            return _this.reFetchObservableQueries();
        });
    };
    QueryManager.prototype.reFetchObservableQueries = function(includeStandby) {
        var _this = this;
        if (includeStandby === void 0) includeStandby = false;
        var observableQueryPromises = [];
        this.queries.forEach(function(_a, queryId) {
            var observableQuery = _a.observableQuery;
            if (observableQuery) {
                var fetchPolicy = observableQuery.options.fetchPolicy;
                observableQuery.resetLastResults();
                if (fetchPolicy !== 'cache-only' && (includeStandby || fetchPolicy !== 'standby')) observableQueryPromises.push(observableQuery.refetch());
                _this.setQuery(queryId, function() {
                    return {
                        newData: null
                    };
                });
                _this.invalidate(queryId);
            }
        });
        this.broadcastQueries();
        return Promise.all(observableQueryPromises);
    };
    QueryManager.prototype.observeQuery = function(queryId, options, observer) {
        this.addQueryListener(queryId, this.queryListenerForObserver(queryId, options, observer));
        return this.fetchQuery(queryId, options);
    };
    QueryManager.prototype.startQuery = function(queryId, options, listener) {
        this.addQueryListener(queryId, listener);
        this.fetchQuery(queryId, options).catch(function() {
            return undefined;
        });
        return queryId;
    };
    QueryManager.prototype.startGraphQLSubscription = function(_a) {
        var _this = this;
        var query = _a.query, fetchPolicy = _a.fetchPolicy, variables = _a.variables;
        query = this.transform(query).document;
        variables = this.getVariables(query, variables);
        var makeObservable = function(variables) {
            return _this.getObservableFromLink(query, {}, variables, false).map(function(result) {
                if (!fetchPolicy || fetchPolicy !== 'no-cache') {
                    _this.dataStore.markSubscriptionResult(result, query, variables);
                    _this.broadcastQueries();
                }
                if ((0, $42BH7.graphQLResultHasError)(result)) throw new $03a288f5350d9e9d$export$26a337512320b8c6({
                    graphQLErrors: result.errors
                });
                return result;
            });
        };
        if (this.transform(query).hasClientExports) {
            var observablePromise_1 = this.localState.addExportedVariables(query, variables).then(makeObservable);
            return new $03a288f5350d9e9d$var$Observable(function(observer) {
                var sub = null;
                observablePromise_1.then(function(observable) {
                    return sub = observable.subscribe(observer);
                }, observer.error);
                return function() {
                    return sub && sub.unsubscribe();
                };
            });
        }
        return makeObservable(variables);
    };
    QueryManager.prototype.stopQuery = function(queryId) {
        this.stopQueryNoBroadcast(queryId);
        this.broadcastQueries();
    };
    QueryManager.prototype.stopQueryNoBroadcast = function(queryId) {
        this.stopQueryInStoreNoBroadcast(queryId);
        this.removeQuery(queryId);
    };
    QueryManager.prototype.removeQuery = function(queryId) {
        this.fetchQueryRejectFns.delete("query:" + queryId);
        this.fetchQueryRejectFns.delete("fetchRequest:" + queryId);
        this.getQuery(queryId).subscriptions.forEach(function(x) {
            return x.unsubscribe();
        });
        this.queries.delete(queryId);
    };
    QueryManager.prototype.getCurrentQueryResult = function(observableQuery, optimistic) {
        if (optimistic === void 0) optimistic = true;
        var _a = observableQuery.options, variables = _a.variables, query = _a.query, fetchPolicy = _a.fetchPolicy, returnPartialData = _a.returnPartialData;
        var lastResult = observableQuery.getLastResult();
        var newData = this.getQuery(observableQuery.queryId).newData;
        if (newData && newData.complete) return {
            data: newData.result,
            partial: false
        };
        if (fetchPolicy === 'no-cache' || fetchPolicy === 'network-only') return {
            data: undefined,
            partial: false
        };
        var _b = this.dataStore.getCache().diff({
            query: query,
            variables: variables,
            previousResult: lastResult ? lastResult.data : undefined,
            returnPartialData: true,
            optimistic: optimistic
        }), result = _b.result, complete = _b.complete;
        return {
            data: complete || returnPartialData ? result : void 0,
            partial: !complete
        };
    };
    QueryManager.prototype.getQueryWithPreviousResult = function(queryIdOrObservable) {
        var observableQuery;
        if (typeof queryIdOrObservable === 'string') {
            var foundObserveableQuery = this.getQuery(queryIdOrObservable).observableQuery;
            (0, $8j2fP.invariant)(foundObserveableQuery, 17);
            observableQuery = foundObserveableQuery;
        } else observableQuery = queryIdOrObservable;
        var _a = observableQuery.options, variables = _a.variables, query = _a.query;
        return {
            previousResult: this.getCurrentQueryResult(observableQuery, false).data,
            variables: variables,
            document: query
        };
    };
    QueryManager.prototype.broadcastQueries = function() {
        var _this = this;
        this.onBroadcast();
        this.queries.forEach(function(info, id) {
            if (info.invalidated) info.listeners.forEach(function(listener) {
                if (listener) listener(_this.queryStore.get(id), info.newData);
            });
        });
    };
    QueryManager.prototype.getLocalState = function() {
        return this.localState;
    };
    QueryManager.prototype.getObservableFromLink = function(query, context, variables, deduplication) {
        var _this = this;
        if (deduplication === void 0) deduplication = this.queryDeduplication;
        var observable;
        var serverQuery = this.transform(query).serverQuery;
        if (serverQuery) {
            var _a = this, inFlightLinkObservables_1 = _a.inFlightLinkObservables, link = _a.link;
            var operation = {
                query: serverQuery,
                variables: variables,
                operationName: (0, $42BH7.getOperationName)(serverQuery) || void 0,
                context: this.prepareContext((0, $fKE23.__assign)((0, $fKE23.__assign)({}, context), {
                    forceFetch: !deduplication
                }))
            };
            context = operation.context;
            if (deduplication) {
                var byVariables_1 = inFlightLinkObservables_1.get(serverQuery) || new Map();
                inFlightLinkObservables_1.set(serverQuery, byVariables_1);
                var varJson_1 = JSON.stringify(variables);
                observable = byVariables_1.get(varJson_1);
                if (!observable) {
                    byVariables_1.set(varJson_1, observable = $03a288f5350d9e9d$var$multiplex((0, $bvQX6.execute)(link, operation)));
                    var cleanup = function() {
                        byVariables_1.delete(varJson_1);
                        if (!byVariables_1.size) inFlightLinkObservables_1.delete(serverQuery);
                        cleanupSub_1.unsubscribe();
                    };
                    var cleanupSub_1 = observable.subscribe({
                        next: cleanup,
                        error: cleanup,
                        complete: cleanup
                    });
                }
            } else observable = $03a288f5350d9e9d$var$multiplex((0, $bvQX6.execute)(link, operation));
        } else {
            observable = $03a288f5350d9e9d$var$Observable.of({
                data: {}
            });
            context = this.prepareContext(context);
        }
        var clientQuery = this.transform(query).clientQuery;
        if (clientQuery) observable = $03a288f5350d9e9d$var$asyncMap(observable, function(result) {
            return _this.localState.runResolvers({
                document: clientQuery,
                remoteResult: result,
                context: context,
                variables: variables
            });
        });
        return observable;
    };
    QueryManager.prototype.fetchRequest = function(_a) {
        var _this = this;
        var requestId = _a.requestId, queryId = _a.queryId, document = _a.document, options = _a.options, fetchMoreForQueryId = _a.fetchMoreForQueryId;
        var variables = options.variables, _b = options.errorPolicy, errorPolicy = _b === void 0 ? 'none' : _b, fetchPolicy = options.fetchPolicy;
        var resultFromStore;
        var errorsFromStore;
        return new Promise(function(resolve, reject) {
            var observable = _this.getObservableFromLink(document, options.context, variables);
            var fqrfId = "fetchRequest:" + queryId;
            _this.fetchQueryRejectFns.set(fqrfId, reject);
            var cleanup = function() {
                _this.fetchQueryRejectFns.delete(fqrfId);
                _this.setQuery(queryId, function(_a) {
                    var subscriptions = _a.subscriptions;
                    subscriptions.delete(subscription);
                });
            };
            var subscription = observable.map(function(result) {
                if (requestId >= _this.getQuery(queryId).lastRequestId) {
                    _this.markQueryResult(queryId, result, options, fetchMoreForQueryId);
                    _this.queryStore.markQueryResult(queryId, result, fetchMoreForQueryId);
                    _this.invalidate(queryId);
                    _this.invalidate(fetchMoreForQueryId);
                    _this.broadcastQueries();
                }
                if (errorPolicy === 'none' && $03a288f5350d9e9d$var$isNonEmptyArray(result.errors)) return reject(new $03a288f5350d9e9d$export$26a337512320b8c6({
                    graphQLErrors: result.errors
                }));
                if (errorPolicy === 'all') errorsFromStore = result.errors;
                if (fetchMoreForQueryId || fetchPolicy === 'no-cache') resultFromStore = result.data;
                else {
                    var _a = _this.dataStore.getCache().diff({
                        variables: variables,
                        query: document,
                        optimistic: false,
                        returnPartialData: true
                    }), result_1 = _a.result, complete = _a.complete;
                    if (complete || options.returnPartialData) resultFromStore = result_1;
                }
            }).subscribe({
                error: function(error) {
                    cleanup();
                    reject(error);
                },
                complete: function() {
                    cleanup();
                    resolve({
                        data: resultFromStore,
                        errors: errorsFromStore,
                        loading: false,
                        networkStatus: $03a288f5350d9e9d$export$bd096ddbd246c79c.ready,
                        stale: false
                    });
                }
            });
            _this.setQuery(queryId, function(_a) {
                var subscriptions = _a.subscriptions;
                subscriptions.add(subscription);
            });
        });
    };
    QueryManager.prototype.getQuery = function(queryId) {
        return this.queries.get(queryId) || {
            listeners: new Set(),
            invalidated: false,
            document: null,
            newData: null,
            lastRequestId: 1,
            observableQuery: null,
            subscriptions: new Set()
        };
    };
    QueryManager.prototype.setQuery = function(queryId, updater) {
        var prev = this.getQuery(queryId);
        var newInfo = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, prev), updater(prev));
        this.queries.set(queryId, newInfo);
    };
    QueryManager.prototype.invalidate = function(queryId, invalidated) {
        if (invalidated === void 0) invalidated = true;
        if (queryId) this.setQuery(queryId, function() {
            return {
                invalidated: invalidated
            };
        });
    };
    QueryManager.prototype.prepareContext = function(context) {
        if (context === void 0) context = {};
        var newContext = this.localState.prepareContext(context);
        return (0, $fKE23.__assign)((0, $fKE23.__assign)({}, newContext), {
            clientAwareness: this.clientAwareness
        });
    };
    QueryManager.prototype.checkInFlight = function(queryId) {
        var query = this.queryStore.get(queryId);
        return query && query.networkStatus !== $03a288f5350d9e9d$export$bd096ddbd246c79c.ready && query.networkStatus !== $03a288f5350d9e9d$export$bd096ddbd246c79c.error;
    };
    QueryManager.prototype.startPollingQuery = function(options, queryId, listener) {
        var _this = this;
        var pollInterval = options.pollInterval;
        (0, $8j2fP.invariant)(pollInterval, 18);
        if (!this.ssrMode) {
            var info = this.pollingInfoByQueryId.get(queryId);
            if (!info) this.pollingInfoByQueryId.set(queryId, info = {});
            info.interval = pollInterval;
            info.options = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, options), {
                fetchPolicy: 'network-only'
            });
            var maybeFetch_1 = function() {
                var info = _this.pollingInfoByQueryId.get(queryId);
                if (info) {
                    if (_this.checkInFlight(queryId)) poll_1();
                    else _this.fetchQuery(queryId, info.options, $03a288f5350d9e9d$export$160bafb6ac1e0641.poll).then(poll_1, poll_1);
                }
            };
            var poll_1 = function() {
                var info = _this.pollingInfoByQueryId.get(queryId);
                if (info) {
                    clearTimeout(info.timeout);
                    info.timeout = setTimeout(maybeFetch_1, info.interval);
                }
            };
            if (listener) this.addQueryListener(queryId, listener);
            poll_1();
        }
        return queryId;
    };
    QueryManager.prototype.stopPollingQuery = function(queryId) {
        this.pollingInfoByQueryId.delete(queryId);
    };
    return QueryManager;
}();
var $03a288f5350d9e9d$var$DataStore = function() {
    function DataStore(initialCache) {
        this.cache = initialCache;
    }
    DataStore.prototype.getCache = function() {
        return this.cache;
    };
    DataStore.prototype.markQueryResult = function(result, document, variables, fetchMoreForQueryId, ignoreErrors) {
        if (ignoreErrors === void 0) ignoreErrors = false;
        var writeWithErrors = !(0, $42BH7.graphQLResultHasError)(result);
        if (ignoreErrors && (0, $42BH7.graphQLResultHasError)(result) && result.data) writeWithErrors = true;
        if (!fetchMoreForQueryId && writeWithErrors) this.cache.write({
            result: result.data,
            dataId: 'ROOT_QUERY',
            query: document,
            variables: variables
        });
    };
    DataStore.prototype.markSubscriptionResult = function(result, document, variables) {
        if (!(0, $42BH7.graphQLResultHasError)(result)) this.cache.write({
            result: result.data,
            dataId: 'ROOT_SUBSCRIPTION',
            query: document,
            variables: variables
        });
    };
    DataStore.prototype.markMutationInit = function(mutation) {
        var _this = this;
        if (mutation.optimisticResponse) {
            var optimistic_1;
            if (typeof mutation.optimisticResponse === 'function') optimistic_1 = mutation.optimisticResponse(mutation.variables);
            else optimistic_1 = mutation.optimisticResponse;
            this.cache.recordOptimisticTransaction(function(c) {
                var orig = _this.cache;
                _this.cache = c;
                try {
                    _this.markMutationResult({
                        mutationId: mutation.mutationId,
                        result: {
                            data: optimistic_1
                        },
                        document: mutation.document,
                        variables: mutation.variables,
                        updateQueries: mutation.updateQueries,
                        update: mutation.update
                    });
                } finally{
                    _this.cache = orig;
                }
            }, mutation.mutationId);
        }
    };
    DataStore.prototype.markMutationResult = function(mutation) {
        var _this = this;
        if (!(0, $42BH7.graphQLResultHasError)(mutation.result)) {
            var cacheWrites_1 = [
                {
                    result: mutation.result.data,
                    dataId: 'ROOT_MUTATION',
                    query: mutation.document,
                    variables: mutation.variables
                }
            ];
            var updateQueries_1 = mutation.updateQueries;
            if (updateQueries_1) Object.keys(updateQueries_1).forEach(function(id) {
                var _a = updateQueries_1[id], query = _a.query, updater = _a.updater;
                var _b = _this.cache.diff({
                    query: query.document,
                    variables: query.variables,
                    returnPartialData: true,
                    optimistic: false
                }), currentQueryResult = _b.result, complete = _b.complete;
                if (complete) {
                    var nextQueryResult = (0, $42BH7.tryFunctionOrLogError)(function() {
                        return updater(currentQueryResult, {
                            mutationResult: mutation.result,
                            queryName: (0, $42BH7.getOperationName)(query.document) || undefined,
                            queryVariables: query.variables
                        });
                    });
                    if (nextQueryResult) cacheWrites_1.push({
                        result: nextQueryResult,
                        dataId: 'ROOT_QUERY',
                        query: query.document,
                        variables: query.variables
                    });
                }
            });
            this.cache.performTransaction(function(c) {
                cacheWrites_1.forEach(function(write) {
                    return c.write(write);
                });
                var update = mutation.update;
                if (update) (0, $42BH7.tryFunctionOrLogError)(function() {
                    return update(c, mutation.result);
                });
            });
        }
    };
    DataStore.prototype.markMutationComplete = function(_a) {
        var mutationId = _a.mutationId, optimisticResponse = _a.optimisticResponse;
        if (optimisticResponse) this.cache.removeOptimistic(mutationId);
    };
    DataStore.prototype.markUpdateQueryResult = function(document, variables, newResult) {
        this.cache.write({
            result: newResult,
            dataId: 'ROOT_QUERY',
            variables: variables,
            query: document
        });
    };
    DataStore.prototype.reset = function() {
        return this.cache.reset();
    };
    return DataStore;
}();
var $03a288f5350d9e9d$var$version = "2.6.10";
var $03a288f5350d9e9d$var$hasSuggestedDevtools = false;
var $03a288f5350d9e9d$export$13f5a5f0f1dbab88 = function() {
    function ApolloClient(options) {
        var _this = this;
        this.defaultOptions = {};
        this.resetStoreCallbacks = [];
        this.clearStoreCallbacks = [];
        var cache = options.cache, _a = options.ssrMode, ssrMode = _a === void 0 ? false : _a, _b = options.ssrForceFetchDelay, ssrForceFetchDelay = _b === void 0 ? 0 : _b, connectToDevTools = options.connectToDevTools, _c = options.queryDeduplication, queryDeduplication = _c === void 0 ? true : _c, defaultOptions = options.defaultOptions, _d = options.assumeImmutableResults, assumeImmutableResults = _d === void 0 ? false : _d, resolvers = options.resolvers, typeDefs = options.typeDefs, fragmentMatcher = options.fragmentMatcher, clientAwarenessName = options.name, clientAwarenessVersion = options.version;
        var link = options.link;
        if (!link && resolvers) link = (0, $bvQX6.ApolloLink).empty();
        if (!link || !cache) throw new (0, $8j2fP.InvariantError)(4);
        this.link = link;
        this.cache = cache;
        this.store = new $03a288f5350d9e9d$var$DataStore(cache);
        this.disableNetworkFetches = ssrMode || ssrForceFetchDelay > 0;
        this.queryDeduplication = queryDeduplication;
        this.defaultOptions = defaultOptions || {};
        this.typeDefs = typeDefs;
        if (ssrForceFetchDelay) setTimeout(function() {
            return _this.disableNetworkFetches = false;
        }, ssrForceFetchDelay);
        this.watchQuery = this.watchQuery.bind(this);
        this.query = this.query.bind(this);
        this.mutate = this.mutate.bind(this);
        this.resetStore = this.resetStore.bind(this);
        this.reFetchObservableQueries = this.reFetchObservableQueries.bind(this);
        var defaultConnectToDevTools = false;
        if (typeof connectToDevTools === 'undefined' ? defaultConnectToDevTools : connectToDevTools && typeof window !== 'undefined') window.__APOLLO_CLIENT__ = this;
        this.version = $03a288f5350d9e9d$var$version;
        this.localState = new $03a288f5350d9e9d$var$LocalState({
            cache: cache,
            client: this,
            resolvers: resolvers,
            fragmentMatcher: fragmentMatcher
        });
        this.queryManager = new $03a288f5350d9e9d$var$QueryManager({
            link: this.link,
            store: this.store,
            queryDeduplication: queryDeduplication,
            ssrMode: ssrMode,
            clientAwareness: {
                name: clientAwarenessName,
                version: clientAwarenessVersion
            },
            localState: this.localState,
            assumeImmutableResults: assumeImmutableResults,
            onBroadcast: function() {
                if (_this.devToolsHookCb) _this.devToolsHookCb({
                    action: {},
                    state: {
                        queries: _this.queryManager.queryStore.getStore(),
                        mutations: _this.queryManager.mutationStore.getStore()
                    },
                    dataWithOptimisticResults: _this.cache.extract(true)
                });
            }
        });
    }
    ApolloClient.prototype.stop = function() {
        this.queryManager.stop();
    };
    ApolloClient.prototype.watchQuery = function(options) {
        if (this.defaultOptions.watchQuery) options = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, this.defaultOptions.watchQuery), options);
        if (this.disableNetworkFetches && (options.fetchPolicy === 'network-only' || options.fetchPolicy === 'cache-and-network')) options = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, options), {
            fetchPolicy: 'cache-first'
        });
        return this.queryManager.watchQuery(options);
    };
    ApolloClient.prototype.query = function(options) {
        if (this.defaultOptions.query) options = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, this.defaultOptions.query), options);
        (0, $8j2fP.invariant)(options.fetchPolicy !== 'cache-and-network', 5);
        if (this.disableNetworkFetches && options.fetchPolicy === 'network-only') options = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, options), {
            fetchPolicy: 'cache-first'
        });
        return this.queryManager.query(options);
    };
    ApolloClient.prototype.mutate = function(options) {
        if (this.defaultOptions.mutate) options = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, this.defaultOptions.mutate), options);
        return this.queryManager.mutate(options);
    };
    ApolloClient.prototype.subscribe = function(options) {
        return this.queryManager.startGraphQLSubscription(options);
    };
    ApolloClient.prototype.readQuery = function(options, optimistic) {
        if (optimistic === void 0) optimistic = false;
        return this.cache.readQuery(options, optimistic);
    };
    ApolloClient.prototype.readFragment = function(options, optimistic) {
        if (optimistic === void 0) optimistic = false;
        return this.cache.readFragment(options, optimistic);
    };
    ApolloClient.prototype.writeQuery = function(options) {
        var result = this.cache.writeQuery(options);
        this.queryManager.broadcastQueries();
        return result;
    };
    ApolloClient.prototype.writeFragment = function(options) {
        var result = this.cache.writeFragment(options);
        this.queryManager.broadcastQueries();
        return result;
    };
    ApolloClient.prototype.writeData = function(options) {
        var result = this.cache.writeData(options);
        this.queryManager.broadcastQueries();
        return result;
    };
    ApolloClient.prototype.__actionHookForDevTools = function(cb) {
        this.devToolsHookCb = cb;
    };
    ApolloClient.prototype.__requestRaw = function(payload) {
        return (0, $bvQX6.execute)(this.link, payload);
    };
    ApolloClient.prototype.initQueryManager = function() {
        return this.queryManager;
    };
    ApolloClient.prototype.resetStore = function() {
        var _this = this;
        return Promise.resolve().then(function() {
            return _this.queryManager.clearStore();
        }).then(function() {
            return Promise.all(_this.resetStoreCallbacks.map(function(fn) {
                return fn();
            }));
        }).then(function() {
            return _this.reFetchObservableQueries();
        });
    };
    ApolloClient.prototype.clearStore = function() {
        var _this = this;
        return Promise.resolve().then(function() {
            return _this.queryManager.clearStore();
        }).then(function() {
            return Promise.all(_this.clearStoreCallbacks.map(function(fn) {
                return fn();
            }));
        });
    };
    ApolloClient.prototype.onResetStore = function(cb) {
        var _this = this;
        this.resetStoreCallbacks.push(cb);
        return function() {
            _this.resetStoreCallbacks = _this.resetStoreCallbacks.filter(function(c) {
                return c !== cb;
            });
        };
    };
    ApolloClient.prototype.onClearStore = function(cb) {
        var _this = this;
        this.clearStoreCallbacks.push(cb);
        return function() {
            _this.clearStoreCallbacks = _this.clearStoreCallbacks.filter(function(c) {
                return c !== cb;
            });
        };
    };
    ApolloClient.prototype.reFetchObservableQueries = function(includeStandby) {
        return this.queryManager.reFetchObservableQueries(includeStandby);
    };
    ApolloClient.prototype.extract = function(optimistic) {
        return this.cache.extract(optimistic);
    };
    ApolloClient.prototype.restore = function(serializedState) {
        return this.cache.restore(serializedState);
    };
    ApolloClient.prototype.addResolvers = function(resolvers) {
        this.localState.addResolvers(resolvers);
    };
    ApolloClient.prototype.setResolvers = function(resolvers) {
        this.localState.setResolvers(resolvers);
    };
    ApolloClient.prototype.getResolvers = function() {
        return this.localState.getResolvers();
    };
    ApolloClient.prototype.setLocalStateFragmentMatcher = function(fragmentMatcher) {
        this.localState.setFragmentMatcher(fragmentMatcher);
    };
    return ApolloClient;
}();
var $03a288f5350d9e9d$export$2e2bcd8739ae039 = $03a288f5350d9e9d$export$13f5a5f0f1dbab88;

});
parcelRegister("bvQX6", function(module, exports) {

$parcel$export(module.exports, "makePromise", () => makePromise);
$parcel$export(module.exports, "fromError", () => fromError);
$parcel$export(module.exports, "ApolloLink", () => ApolloLink);
$parcel$export(module.exports, "from", () => from);
$parcel$export(module.exports, "split", () => split);
$parcel$export(module.exports, "execute", () => execute);
$parcel$export(module.exports, "Observable", () => (parcelRequire("5ECju")).default);

var $5ECju = parcelRequire("5ECju");

var $8j2fP = parcelRequire("8j2fP");

var $fKE23 = parcelRequire("fKE23");

var $42BH7 = parcelRequire("42BH7");
function validateOperation(operation) {
    var OPERATION_FIELDS = [
        'query',
        'operationName',
        'variables',
        'extensions',
        'context'
    ];
    for(var _i = 0, _a = Object.keys(operation); _i < _a.length; _i++){
        var key = _a[_i];
        if (OPERATION_FIELDS.indexOf(key) < 0) throw new (0, $8j2fP.InvariantError)(2);
    }
    return operation;
}
var LinkError = function(_super) {
    (0, $fKE23.__extends)(LinkError, _super);
    function LinkError(message, link) {
        var _this = _super.call(this, message) || this;
        _this.link = link;
        return _this;
    }
    return LinkError;
}(Error);
function isTerminating(link) {
    return link.request.length <= 1;
}
function toPromise(observable) {
    var completed = false;
    return new Promise(function(resolve, reject) {
        observable.subscribe({
            next: function(data) {
                if (completed) ;
                else {
                    completed = true;
                    resolve(data);
                }
            },
            error: reject
        });
    });
}
var makePromise = toPromise;
function fromPromise(promise) {
    return new (0, $5ECju.default)(function(observer) {
        promise.then(function(value) {
            observer.next(value);
            observer.complete();
        }).catch(observer.error.bind(observer));
    });
}
function fromError(errorValue) {
    return new (0, $5ECju.default)(function(observer) {
        observer.error(errorValue);
    });
}
function transformOperation(operation) {
    var transformedOperation = {
        variables: operation.variables || {},
        extensions: operation.extensions || {},
        operationName: operation.operationName,
        query: operation.query
    };
    if (!transformedOperation.operationName) transformedOperation.operationName = typeof transformedOperation.query !== 'string' ? (0, $42BH7.getOperationName)(transformedOperation.query) : '';
    return transformedOperation;
}
function createOperation(starting, operation) {
    var context = (0, $fKE23.__assign)({}, starting);
    var setContext = function(next) {
        if (typeof next === 'function') context = (0, $fKE23.__assign)({}, context, next(context));
        else context = (0, $fKE23.__assign)({}, context, next);
    };
    var getContext = function() {
        return (0, $fKE23.__assign)({}, context);
    };
    Object.defineProperty(operation, 'setContext', {
        enumerable: false,
        value: setContext
    });
    Object.defineProperty(operation, 'getContext', {
        enumerable: false,
        value: getContext
    });
    Object.defineProperty(operation, 'toKey', {
        enumerable: false,
        value: function() {
            return getKey(operation);
        }
    });
    return operation;
}
function getKey(operation) {
    var query = operation.query, variables = operation.variables, operationName = operation.operationName;
    return JSON.stringify([
        operationName,
        query,
        variables
    ]);
}
function passthrough(op, forward) {
    return forward ? forward(op) : (0, $5ECju.default).of();
}
function toLink(handler) {
    return typeof handler === 'function' ? new ApolloLink(handler) : handler;
}
function empty() {
    return new ApolloLink(function() {
        return (0, $5ECju.default).of();
    });
}
function from(links) {
    if (links.length === 0) return empty();
    return links.map(toLink).reduce(function(x, y) {
        return x.concat(y);
    });
}
function split(test, left, right) {
    var leftLink = toLink(left);
    var rightLink = toLink(right || new ApolloLink(passthrough));
    if (isTerminating(leftLink) && isTerminating(rightLink)) return new ApolloLink(function(operation) {
        return test(operation) ? leftLink.request(operation) || (0, $5ECju.default).of() : rightLink.request(operation) || (0, $5ECju.default).of();
    });
    else return new ApolloLink(function(operation, forward) {
        return test(operation) ? leftLink.request(operation, forward) || (0, $5ECju.default).of() : rightLink.request(operation, forward) || (0, $5ECju.default).of();
    });
}
var concat = function(first, second) {
    var firstLink = toLink(first);
    if (isTerminating(firstLink)) return firstLink;
    var nextLink = toLink(second);
    if (isTerminating(nextLink)) return new ApolloLink(function(operation) {
        return firstLink.request(operation, function(op) {
            return nextLink.request(op) || (0, $5ECju.default).of();
        }) || (0, $5ECju.default).of();
    });
    else return new ApolloLink(function(operation, forward) {
        return firstLink.request(operation, function(op) {
            return nextLink.request(op, forward) || (0, $5ECju.default).of();
        }) || (0, $5ECju.default).of();
    });
};
var ApolloLink = function() {
    function ApolloLink(request) {
        if (request) this.request = request;
    }
    ApolloLink.prototype.split = function(test, left, right) {
        return this.concat(split(test, left, right || new ApolloLink(passthrough)));
    };
    ApolloLink.prototype.concat = function(next) {
        return concat(this, next);
    };
    ApolloLink.prototype.request = function(operation, forward) {
        throw new (0, $8j2fP.InvariantError)(1);
    };
    ApolloLink.empty = empty;
    ApolloLink.from = from;
    ApolloLink.split = split;
    ApolloLink.execute = execute;
    return ApolloLink;
}();
function execute(link, operation) {
    return link.request(createOperation(operation.context, transformOperation(validateOperation(operation)))) || (0, $5ECju.default).of();
}

});
parcelRegister("5ECju", function(module, exports) {

$parcel$export(module.exports, "default", () => $41de6865c2ff0290$export$2e2bcd8739ae039);

var $1eC02 = parcelRequire("1eC02");
var $41de6865c2ff0290$export$77cea355fa80b5f4 = (0, (/*@__PURE__*/$parcel$interopDefault($1eC02)));
var $41de6865c2ff0290$export$2e2bcd8739ae039 = $41de6865c2ff0290$export$77cea355fa80b5f4;

});
parcelRegister("1eC02", function(module, exports) {

module.exports = (parcelRequire("bhbKH")).Observable;

});
parcelRegister("bhbKH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Observable = void 0;
function $835a65fddbd60374$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $835a65fddbd60374$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $835a65fddbd60374$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $835a65fddbd60374$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $835a65fddbd60374$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
// === Symbol Support ===
var $835a65fddbd60374$var$hasSymbols = function() {
    return typeof Symbol === 'function';
};
var $835a65fddbd60374$var$hasSymbol = function(name) {
    return $835a65fddbd60374$var$hasSymbols() && Boolean(Symbol[name]);
};
var $835a65fddbd60374$var$getSymbol = function(name) {
    return $835a65fddbd60374$var$hasSymbol(name) ? Symbol[name] : '@@' + name;
};
if ($835a65fddbd60374$var$hasSymbols() && !$835a65fddbd60374$var$hasSymbol('observable')) Symbol.observable = Symbol('observable');
var $835a65fddbd60374$var$SymbolIterator = $835a65fddbd60374$var$getSymbol('iterator');
var $835a65fddbd60374$var$SymbolObservable = $835a65fddbd60374$var$getSymbol('observable');
var $835a65fddbd60374$var$SymbolSpecies = $835a65fddbd60374$var$getSymbol('species'); // === Abstract Operations ===
function $835a65fddbd60374$var$getMethod(obj, key) {
    var value = obj[key];
    if (value == null) return undefined;
    if (typeof value !== 'function') throw new TypeError(value + ' is not a function');
    return value;
}
function $835a65fddbd60374$var$getSpecies(obj) {
    var ctor = obj.constructor;
    if (ctor !== undefined) {
        ctor = ctor[$835a65fddbd60374$var$SymbolSpecies];
        if (ctor === null) ctor = undefined;
    }
    return ctor !== undefined ? ctor : $835a65fddbd60374$var$Observable;
}
function $835a65fddbd60374$var$isObservable(x) {
    return x instanceof $835a65fddbd60374$var$Observable; // SPEC: Brand check
}
function $835a65fddbd60374$var$hostReportError(e) {
    if ($835a65fddbd60374$var$hostReportError.log) $835a65fddbd60374$var$hostReportError.log(e);
    else setTimeout(function() {
        throw e;
    });
}
function $835a65fddbd60374$var$enqueue(fn) {
    Promise.resolve().then(function() {
        try {
            fn();
        } catch (e) {
            $835a65fddbd60374$var$hostReportError(e);
        }
    });
}
function $835a65fddbd60374$var$cleanupSubscription(subscription) {
    var cleanup = subscription._cleanup;
    if (cleanup === undefined) return;
    subscription._cleanup = undefined;
    if (!cleanup) return;
    try {
        if (typeof cleanup === 'function') cleanup();
        else {
            var unsubscribe = $835a65fddbd60374$var$getMethod(cleanup, 'unsubscribe');
            if (unsubscribe) unsubscribe.call(cleanup);
        }
    } catch (e) {
        $835a65fddbd60374$var$hostReportError(e);
    }
}
function $835a65fddbd60374$var$closeSubscription(subscription) {
    subscription._observer = undefined;
    subscription._queue = undefined;
    subscription._state = 'closed';
}
function $835a65fddbd60374$var$flushSubscription(subscription) {
    var queue = subscription._queue;
    if (!queue) return;
    subscription._queue = undefined;
    subscription._state = 'ready';
    for(var i = 0; i < queue.length; ++i){
        $835a65fddbd60374$var$notifySubscription(subscription, queue[i].type, queue[i].value);
        if (subscription._state === 'closed') break;
    }
}
function $835a65fddbd60374$var$notifySubscription(subscription, type, value) {
    subscription._state = 'running';
    var observer = subscription._observer;
    try {
        var m = $835a65fddbd60374$var$getMethod(observer, type);
        switch(type){
            case 'next':
                if (m) m.call(observer, value);
                break;
            case 'error':
                $835a65fddbd60374$var$closeSubscription(subscription);
                if (m) m.call(observer, value);
                else throw value;
                break;
            case 'complete':
                $835a65fddbd60374$var$closeSubscription(subscription);
                if (m) m.call(observer);
                break;
        }
    } catch (e) {
        $835a65fddbd60374$var$hostReportError(e);
    }
    if (subscription._state === 'closed') $835a65fddbd60374$var$cleanupSubscription(subscription);
    else if (subscription._state === 'running') subscription._state = 'ready';
}
function $835a65fddbd60374$var$onNotify(subscription, type, value) {
    if (subscription._state === 'closed') return;
    if (subscription._state === 'buffering') {
        subscription._queue.push({
            type: type,
            value: value
        });
        return;
    }
    if (subscription._state !== 'ready') {
        subscription._state = 'buffering';
        subscription._queue = [
            {
                type: type,
                value: value
            }
        ];
        $835a65fddbd60374$var$enqueue(function() {
            return $835a65fddbd60374$var$flushSubscription(subscription);
        });
        return;
    }
    $835a65fddbd60374$var$notifySubscription(subscription, type, value);
}
var $835a65fddbd60374$var$Subscription = /*#__PURE__*/ function() {
    function Subscription(observer, subscriber) {
        $835a65fddbd60374$var$_classCallCheck(this, Subscription);
        // ASSERT: observer is an object
        // ASSERT: subscriber is callable
        this._cleanup = undefined;
        this._observer = observer;
        this._queue = undefined;
        this._state = 'initializing';
        var subscriptionObserver = new $835a65fddbd60374$var$SubscriptionObserver(this);
        try {
            this._cleanup = subscriber.call(undefined, subscriptionObserver);
        } catch (e) {
            subscriptionObserver.error(e);
        }
        if (this._state === 'initializing') this._state = 'ready';
    }
    $835a65fddbd60374$var$_createClass(Subscription, [
        {
            key: "unsubscribe",
            value: function unsubscribe() {
                if (this._state !== 'closed') {
                    $835a65fddbd60374$var$closeSubscription(this);
                    $835a65fddbd60374$var$cleanupSubscription(this);
                }
            }
        },
        {
            key: "closed",
            get: function() {
                return this._state === 'closed';
            }
        }
    ]);
    return Subscription;
}();
var $835a65fddbd60374$var$SubscriptionObserver = /*#__PURE__*/ function() {
    function SubscriptionObserver(subscription) {
        $835a65fddbd60374$var$_classCallCheck(this, SubscriptionObserver);
        this._subscription = subscription;
    }
    $835a65fddbd60374$var$_createClass(SubscriptionObserver, [
        {
            key: "next",
            value: function next(value) {
                $835a65fddbd60374$var$onNotify(this._subscription, 'next', value);
            }
        },
        {
            key: "error",
            value: function error(value) {
                $835a65fddbd60374$var$onNotify(this._subscription, 'error', value);
            }
        },
        {
            key: "complete",
            value: function complete() {
                $835a65fddbd60374$var$onNotify(this._subscription, 'complete');
            }
        },
        {
            key: "closed",
            get: function() {
                return this._subscription._state === 'closed';
            }
        }
    ]);
    return SubscriptionObserver;
}();
var $835a65fddbd60374$var$Observable = /*#__PURE__*/ function() {
    function Observable(subscriber) {
        $835a65fddbd60374$var$_classCallCheck(this, Observable);
        if (!(this instanceof Observable)) throw new TypeError('Observable cannot be called as a function');
        if (typeof subscriber !== 'function') throw new TypeError('Observable initializer must be a function');
        this._subscriber = subscriber;
    }
    $835a65fddbd60374$var$_createClass(Observable, [
        {
            key: "subscribe",
            value: function subscribe(observer) {
                if (typeof observer !== 'object' || observer === null) observer = {
                    next: observer,
                    error: arguments[1],
                    complete: arguments[2]
                };
                return new $835a65fddbd60374$var$Subscription(observer, this._subscriber);
            }
        },
        {
            key: "forEach",
            value: function forEach(fn) {
                var _this = this;
                return new Promise(function(resolve, reject) {
                    if (typeof fn !== 'function') {
                        reject(new TypeError(fn + ' is not a function'));
                        return;
                    }
                    function done() {
                        subscription.unsubscribe();
                        resolve();
                    }
                    var subscription = _this.subscribe({
                        next: function(value) {
                            try {
                                fn(value, done);
                            } catch (e) {
                                reject(e);
                                subscription.unsubscribe();
                            }
                        },
                        error: reject,
                        complete: resolve
                    });
                });
            }
        },
        {
            key: "map",
            value: function map(fn) {
                var _this2 = this;
                if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
                var C = $835a65fddbd60374$var$getSpecies(this);
                return new C(function(observer) {
                    return _this2.subscribe({
                        next: function(value) {
                            try {
                                value = fn(value);
                            } catch (e) {
                                return observer.error(e);
                            }
                            observer.next(value);
                        },
                        error: function(e) {
                            observer.error(e);
                        },
                        complete: function() {
                            observer.complete();
                        }
                    });
                });
            }
        },
        {
            key: "filter",
            value: function filter(fn) {
                var _this3 = this;
                if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
                var C = $835a65fddbd60374$var$getSpecies(this);
                return new C(function(observer) {
                    return _this3.subscribe({
                        next: function(value) {
                            try {
                                if (!fn(value)) return;
                            } catch (e) {
                                return observer.error(e);
                            }
                            observer.next(value);
                        },
                        error: function(e) {
                            observer.error(e);
                        },
                        complete: function() {
                            observer.complete();
                        }
                    });
                });
            }
        },
        {
            key: "reduce",
            value: function reduce(fn) {
                var _this4 = this;
                if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
                var C = $835a65fddbd60374$var$getSpecies(this);
                var hasSeed = arguments.length > 1;
                var hasValue = false;
                var seed = arguments[1];
                var acc = seed;
                return new C(function(observer) {
                    return _this4.subscribe({
                        next: function(value) {
                            var first = !hasValue;
                            hasValue = true;
                            if (!first || hasSeed) try {
                                acc = fn(acc, value);
                            } catch (e) {
                                return observer.error(e);
                            }
                            else acc = value;
                        },
                        error: function(e) {
                            observer.error(e);
                        },
                        complete: function() {
                            if (!hasValue && !hasSeed) return observer.error(new TypeError('Cannot reduce an empty sequence'));
                            observer.next(acc);
                            observer.complete();
                        }
                    });
                });
            }
        },
        {
            key: "concat",
            value: function concat() {
                var _this5 = this;
                for(var _len = arguments.length, sources = new Array(_len), _key = 0; _key < _len; _key++)sources[_key] = arguments[_key];
                var C = $835a65fddbd60374$var$getSpecies(this);
                return new C(function(observer) {
                    var subscription;
                    var index = 0;
                    function startNext(next) {
                        subscription = next.subscribe({
                            next: function(v) {
                                observer.next(v);
                            },
                            error: function(e) {
                                observer.error(e);
                            },
                            complete: function() {
                                if (index === sources.length) {
                                    subscription = undefined;
                                    observer.complete();
                                } else startNext(C.from(sources[index++]));
                            }
                        });
                    }
                    startNext(_this5);
                    return function() {
                        if (subscription) {
                            subscription.unsubscribe();
                            subscription = undefined;
                        }
                    };
                });
            }
        },
        {
            key: "flatMap",
            value: function flatMap(fn) {
                var _this6 = this;
                if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
                var C = $835a65fddbd60374$var$getSpecies(this);
                return new C(function(observer) {
                    var subscriptions = [];
                    var outer = _this6.subscribe({
                        next: function(value) {
                            if (fn) try {
                                value = fn(value);
                            } catch (e) {
                                return observer.error(e);
                            }
                            var inner = C.from(value).subscribe({
                                next: function(value) {
                                    observer.next(value);
                                },
                                error: function(e) {
                                    observer.error(e);
                                },
                                complete: function() {
                                    var i = subscriptions.indexOf(inner);
                                    if (i >= 0) subscriptions.splice(i, 1);
                                    completeIfDone();
                                }
                            });
                            subscriptions.push(inner);
                        },
                        error: function(e) {
                            observer.error(e);
                        },
                        complete: function() {
                            completeIfDone();
                        }
                    });
                    function completeIfDone() {
                        if (outer.closed && subscriptions.length === 0) observer.complete();
                    }
                    return function() {
                        subscriptions.forEach(function(s) {
                            return s.unsubscribe();
                        });
                        outer.unsubscribe();
                    };
                });
            }
        },
        {
            key: $835a65fddbd60374$var$SymbolObservable,
            value: function() {
                return this;
            }
        }
    ], [
        {
            key: "from",
            value: function from(x) {
                var C = typeof this === 'function' ? this : Observable;
                if (x == null) throw new TypeError(x + ' is not an object');
                var method = $835a65fddbd60374$var$getMethod(x, $835a65fddbd60374$var$SymbolObservable);
                if (method) {
                    var observable = method.call(x);
                    if (Object(observable) !== observable) throw new TypeError(observable + ' is not an object');
                    if ($835a65fddbd60374$var$isObservable(observable) && observable.constructor === C) return observable;
                    return new C(function(observer) {
                        return observable.subscribe(observer);
                    });
                }
                if ($835a65fddbd60374$var$hasSymbol('iterator')) {
                    method = $835a65fddbd60374$var$getMethod(x, $835a65fddbd60374$var$SymbolIterator);
                    if (method) return new C(function(observer) {
                        $835a65fddbd60374$var$enqueue(function() {
                            if (observer.closed) return;
                            var _iteratorNormalCompletion = true;
                            var _didIteratorError = false;
                            var _iteratorError = undefined;
                            try {
                                for(var _iterator = method.call(x)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                    var _item = _step.value;
                                    observer.next(_item);
                                    if (observer.closed) return;
                                }
                            } catch (err) {
                                _didIteratorError = true;
                                _iteratorError = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) _iterator.return();
                                } finally{
                                    if (_didIteratorError) throw _iteratorError;
                                }
                            }
                            observer.complete();
                        });
                    });
                }
                if (Array.isArray(x)) return new C(function(observer) {
                    $835a65fddbd60374$var$enqueue(function() {
                        if (observer.closed) return;
                        for(var i = 0; i < x.length; ++i){
                            observer.next(x[i]);
                            if (observer.closed) return;
                        }
                        observer.complete();
                    });
                });
                throw new TypeError(x + ' is not observable');
            }
        },
        {
            key: "of",
            value: function of() {
                for(var _len2 = arguments.length, items = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)items[_key2] = arguments[_key2];
                var C = typeof this === 'function' ? this : Observable;
                return new C(function(observer) {
                    $835a65fddbd60374$var$enqueue(function() {
                        if (observer.closed) return;
                        for(var i = 0; i < items.length; ++i){
                            observer.next(items[i]);
                            if (observer.closed) return;
                        }
                        observer.complete();
                    });
                });
            }
        },
        {
            key: $835a65fddbd60374$var$SymbolSpecies,
            get: function() {
                return this;
            }
        }
    ]);
    return Observable;
}();
module.exports.Observable = $835a65fddbd60374$var$Observable;
if ($835a65fddbd60374$var$hasSymbols()) Object.defineProperty($835a65fddbd60374$var$Observable, Symbol('extensions'), {
    value: {
        symbol: $835a65fddbd60374$var$SymbolObservable,
        hostReportError: $835a65fddbd60374$var$hostReportError
    },
    configurable: true
});

});





parcelRegister("aqG9W", function(module, exports) {

$parcel$export(module.exports, "onError", () => $797d090cd04ee84b$export$2288787135a8f66e);

var $fKE23 = parcelRequire("fKE23");

var $bvQX6 = parcelRequire("bvQX6");
var $5ECju = parcelRequire("5ECju");
function $797d090cd04ee84b$export$2288787135a8f66e(errorHandler) {
    return new (0, $bvQX6.ApolloLink)(function(operation, forward) {
        return new (0, $5ECju.default)(function(observer) {
            var sub;
            var retriedSub;
            var retriedResult;
            try {
                sub = forward(operation).subscribe({
                    next: function(result) {
                        if (result.errors) {
                            retriedResult = errorHandler({
                                graphQLErrors: result.errors,
                                response: result,
                                operation: operation,
                                forward: forward
                            });
                            if (retriedResult) {
                                retriedSub = retriedResult.subscribe({
                                    next: observer.next.bind(observer),
                                    error: observer.error.bind(observer),
                                    complete: observer.complete.bind(observer)
                                });
                                return;
                            }
                        }
                        observer.next(result);
                    },
                    error: function(networkError) {
                        retriedResult = errorHandler({
                            operation: operation,
                            networkError: networkError,
                            graphQLErrors: networkError && networkError.result && networkError.result.errors,
                            forward: forward
                        });
                        if (retriedResult) {
                            retriedSub = retriedResult.subscribe({
                                next: observer.next.bind(observer),
                                error: observer.error.bind(observer),
                                complete: observer.complete.bind(observer)
                            });
                            return;
                        }
                        observer.error(networkError);
                    },
                    complete: function() {
                        if (!retriedResult) observer.complete.bind(observer)();
                    }
                });
            } catch (e) {
                errorHandler({
                    networkError: e,
                    operation: operation,
                    forward: forward
                });
                observer.error(e);
            }
            return function() {
                if (sub) sub.unsubscribe();
                if (retriedSub) sub.unsubscribe();
            };
        });
    });
}
var $797d090cd04ee84b$export$d2c8415987899609 = function(_super) {
    (0, $fKE23.__extends)(ErrorLink, _super);
    function ErrorLink(errorHandler) {
        var _this = _super.call(this) || this;
        _this.link = $797d090cd04ee84b$export$2288787135a8f66e(errorHandler);
        return _this;
    }
    ErrorLink.prototype.request = function(operation, forward) {
        return this.link.request(operation, forward);
    };
    return ErrorLink;
}((0, $bvQX6.ApolloLink));

});

parcelRegister("35Kb7", function(module, exports) {

$parcel$export(module.exports, "HttpLink", () => $2405a8c9bbd1579c$export$f4bbf1aec241cc1);

var $fKE23 = parcelRequire("fKE23");

var $bvQX6 = parcelRequire("bvQX6");
var $5ECju = parcelRequire("5ECju");

var $cp9eN = parcelRequire("cp9eN");
var $2405a8c9bbd1579c$export$95180a16573d6675 = function(linkOptions) {
    if (linkOptions === void 0) linkOptions = {};
    var _a = linkOptions.uri, uri = _a === void 0 ? '/graphql' : _a, fetcher = linkOptions.fetch, includeExtensions = linkOptions.includeExtensions, useGETForQueries = linkOptions.useGETForQueries, abortErrorDoesNotCauseError = linkOptions.abortErrorDoesNotCauseError, requestOptions = (0, $fKE23.__rest)(linkOptions, [
        "uri",
        "fetch",
        "includeExtensions",
        "useGETForQueries",
        "abortErrorDoesNotCauseError"
    ]);
    (0, $cp9eN.checkFetcher)(fetcher);
    if (!fetcher) fetcher = fetch;
    var linkConfig = {
        http: {
            includeExtensions: includeExtensions
        },
        options: requestOptions.fetchOptions,
        credentials: requestOptions.credentials,
        headers: requestOptions.headers
    };
    return new (0, $bvQX6.ApolloLink)(function(operation) {
        var chosenURI = (0, $cp9eN.selectURI)(operation, uri);
        var context = operation.getContext();
        var clientAwarenessHeaders = {};
        if (context.clientAwareness) {
            var _a = context.clientAwareness, name_1 = _a.name, version = _a.version;
            if (name_1) clientAwarenessHeaders['apollographql-client-name'] = name_1;
            if (version) clientAwarenessHeaders['apollographql-client-version'] = version;
        }
        var contextHeaders = (0, $fKE23.__assign)({}, clientAwarenessHeaders, context.headers);
        var contextConfig = {
            http: context.http,
            options: context.fetchOptions,
            credentials: context.credentials,
            headers: contextHeaders
        };
        var _b = (0, $cp9eN.selectHttpOptionsAndBody)(operation, (0, $cp9eN.fallbackHttpConfig), linkConfig, contextConfig), options = _b.options, body = _b.body;
        var controller;
        if (!options.signal) {
            var _c = (0, $cp9eN.createSignalIfSupported)(), _controller = _c.controller, signal = _c.signal;
            controller = _controller;
            if (controller) options.signal = signal;
        }
        var definitionIsMutation = function(d) {
            return d.kind === 'OperationDefinition' && d.operation === 'mutation';
        };
        if (useGETForQueries && !operation.query.definitions.some(definitionIsMutation)) options.method = 'GET';
        if (options.method === 'GET') {
            var _d = $2405a8c9bbd1579c$var$rewriteURIForGET(chosenURI, body), newURI = _d.newURI, parseError = _d.parseError;
            if (parseError) return (0, $bvQX6.fromError)(parseError);
            chosenURI = newURI;
        } else try {
            options.body = (0, $cp9eN.serializeFetchParameter)(body, 'Payload');
        } catch (parseError) {
            return (0, $bvQX6.fromError)(parseError);
        }
        return new (0, $5ECju.default)(function(observer) {
            fetcher(chosenURI, options).then(function(response) {
                operation.setContext({
                    response: response
                });
                return response;
            }).then((0, $cp9eN.parseAndCheckHttpResponse)(operation)).then(function(result) {
                observer.next(result);
                observer.complete();
                return result;
            }).catch(function(err) {
                if (err.name === 'AbortError' && !abortErrorDoesNotCauseError) return;
                if (err.result && err.result.errors && err.result.data) observer.next(err.result);
                observer.error(err);
            });
            return function() {
                if (controller) controller.abort();
            };
        });
    });
};
function $2405a8c9bbd1579c$var$rewriteURIForGET(chosenURI, body) {
    var queryParams = [];
    var addQueryParam = function(key, value) {
        queryParams.push(key + "=" + encodeURIComponent(value));
    };
    if ('query' in body) addQueryParam('query', body.query);
    if (body.operationName) addQueryParam('operationName', body.operationName);
    if (body.variables) {
        var serializedVariables = void 0;
        try {
            serializedVariables = (0, $cp9eN.serializeFetchParameter)(body.variables, 'Variables map');
        } catch (parseError) {
            return {
                parseError: parseError
            };
        }
        addQueryParam('variables', serializedVariables);
    }
    if (body.extensions) {
        var serializedExtensions = void 0;
        try {
            serializedExtensions = (0, $cp9eN.serializeFetchParameter)(body.extensions, 'Extensions map');
        } catch (parseError) {
            return {
                parseError: parseError
            };
        }
        addQueryParam('extensions', serializedExtensions);
    }
    var fragment = '', preFragment = chosenURI;
    var fragmentStart = chosenURI.indexOf('#');
    if (fragmentStart !== -1) {
        fragment = chosenURI.substr(fragmentStart);
        preFragment = chosenURI.substr(0, fragmentStart);
    }
    var queryParamsPrefix = preFragment.indexOf('?') === -1 ? '?' : '&';
    var newURI = preFragment + queryParamsPrefix + queryParams.join('&') + fragment;
    return {
        newURI: newURI
    };
}
var $2405a8c9bbd1579c$export$f4bbf1aec241cc1 = function(_super) {
    (0, $fKE23.__extends)(HttpLink, _super);
    function HttpLink(opts) {
        return _super.call(this, $2405a8c9bbd1579c$export$95180a16573d6675(opts).request) || this;
    }
    return HttpLink;
}((0, $bvQX6.ApolloLink));

});
parcelRegister("cp9eN", function(module, exports) {

$parcel$export(module.exports, "fallbackHttpConfig", () => $907efc3a22e8ac51$export$dd86f00dc866e75d);
$parcel$export(module.exports, "parseAndCheckHttpResponse", () => $907efc3a22e8ac51$export$d4051215bea0639f);
$parcel$export(module.exports, "checkFetcher", () => $907efc3a22e8ac51$export$8423f0cd3773115e);
$parcel$export(module.exports, "createSignalIfSupported", () => $907efc3a22e8ac51$export$f5853cd1fc39aea6);
$parcel$export(module.exports, "selectHttpOptionsAndBody", () => $907efc3a22e8ac51$export$a00ebfd5f1eebfb1);
$parcel$export(module.exports, "serializeFetchParameter", () => $907efc3a22e8ac51$export$5f8e80ac52052e28);
$parcel$export(module.exports, "selectURI", () => $907efc3a22e8ac51$export$63ccc2571850f81a);

var $fKE23 = parcelRequire("fKE23");

var $aKlnM = parcelRequire("aKlnM");

var $8j2fP = parcelRequire("8j2fP");
var $907efc3a22e8ac51$var$defaultHttpOptions = {
    includeQuery: true,
    includeExtensions: false
};
var $907efc3a22e8ac51$var$defaultHeaders = {
    accept: '*/*',
    'content-type': 'application/json'
};
var $907efc3a22e8ac51$var$defaultOptions = {
    method: 'POST'
};
var $907efc3a22e8ac51$export$dd86f00dc866e75d = {
    http: $907efc3a22e8ac51$var$defaultHttpOptions,
    headers: $907efc3a22e8ac51$var$defaultHeaders,
    options: $907efc3a22e8ac51$var$defaultOptions
};
var $907efc3a22e8ac51$export$c33ef9219f27efd7 = function(response, result, message) {
    var error = new Error(message);
    error.name = 'ServerError';
    error.response = response;
    error.statusCode = response.status;
    error.result = result;
    throw error;
};
var $907efc3a22e8ac51$export$d4051215bea0639f = function(operations) {
    return function(response) {
        return response.text().then(function(bodyText) {
            try {
                return JSON.parse(bodyText);
            } catch (err) {
                var parseError = err;
                parseError.name = 'ServerParseError';
                parseError.response = response;
                parseError.statusCode = response.status;
                parseError.bodyText = bodyText;
                return Promise.reject(parseError);
            }
        }).then(function(result) {
            if (response.status >= 300) $907efc3a22e8ac51$export$c33ef9219f27efd7(response, result, "Response not successful: Received status code " + response.status);
            if (!Array.isArray(result) && !result.hasOwnProperty('data') && !result.hasOwnProperty('errors')) $907efc3a22e8ac51$export$c33ef9219f27efd7(response, result, "Server response was missing for query '" + (Array.isArray(operations) ? operations.map(function(op) {
                return op.operationName;
            }) : operations.operationName) + "'.");
            return result;
        });
    };
};
var $907efc3a22e8ac51$export$8423f0cd3773115e = function(fetcher) {
    if (!fetcher && typeof fetch === 'undefined') {
        var library = 'unfetch';
        if (typeof window === 'undefined') library = 'node-fetch';
        throw new (0, $8j2fP.InvariantError)(1);
    }
};
var $907efc3a22e8ac51$export$f5853cd1fc39aea6 = function() {
    if (typeof AbortController === 'undefined') return {
        controller: false,
        signal: false
    };
    var controller = new AbortController();
    var signal = controller.signal;
    return {
        controller: controller,
        signal: signal
    };
};
var $907efc3a22e8ac51$export$a00ebfd5f1eebfb1 = function(operation, fallbackConfig) {
    var configs = [];
    for(var _i = 2; _i < arguments.length; _i++)configs[_i - 2] = arguments[_i];
    var options = (0, $fKE23.__assign)({}, fallbackConfig.options, {
        headers: fallbackConfig.headers,
        credentials: fallbackConfig.credentials
    });
    var http = fallbackConfig.http;
    configs.forEach(function(config) {
        options = (0, $fKE23.__assign)({}, options, config.options, {
            headers: (0, $fKE23.__assign)({}, options.headers, config.headers)
        });
        if (config.credentials) options.credentials = config.credentials;
        http = (0, $fKE23.__assign)({}, http, config.http);
    });
    var operationName = operation.operationName, extensions = operation.extensions, variables = operation.variables, query = operation.query;
    var body = {
        operationName: operationName,
        variables: variables
    };
    if (http.includeExtensions) body.extensions = extensions;
    if (http.includeQuery) body.query = (0, $aKlnM.print)(query);
    return {
        options: options,
        body: body
    };
};
var $907efc3a22e8ac51$export$5f8e80ac52052e28 = function(p, label) {
    var serialized;
    try {
        serialized = JSON.stringify(p);
    } catch (e) {
        var parseError = new (0, $8j2fP.InvariantError)(2);
        parseError.parseError = e;
        throw parseError;
    }
    return serialized;
};
var $907efc3a22e8ac51$export$63ccc2571850f81a = function(operation, fallbackURI) {
    var context = operation.getContext();
    var contextURI = context.uri;
    if (contextURI) return contextURI;
    else if (typeof fallbackURI === 'function') return fallbackURI(operation);
    else return fallbackURI || '/graphql';
};

});
parcelRegister("aKlnM", function(module, exports) {

$parcel$export(module.exports, "print", () => $1f94f8496a1ffd7f$export$c2d084dc44961371);

var $961BR = parcelRequire("961BR");

var $flA0a = parcelRequire("flA0a");
function $1f94f8496a1ffd7f$export$c2d084dc44961371(ast) {
    return (0, $961BR.visit)(ast, {
        leave: $1f94f8496a1ffd7f$var$printDocASTReducer
    });
}
var $1f94f8496a1ffd7f$var$MAX_LINE_LENGTH = 80; // TODO: provide better type coverage in future
var $1f94f8496a1ffd7f$var$printDocASTReducer = {
    Name: function Name(node) {
        return node.value;
    },
    Variable: function Variable(node) {
        return '$' + node.name;
    },
    // Document
    Document: function Document(node) {
        return $1f94f8496a1ffd7f$var$join(node.definitions, '\n\n') + '\n';
    },
    OperationDefinition: function OperationDefinition(node) {
        var op = node.operation;
        var name = node.name;
        var varDefs = $1f94f8496a1ffd7f$var$wrap('(', $1f94f8496a1ffd7f$var$join(node.variableDefinitions, ', '), ')');
        var directives = $1f94f8496a1ffd7f$var$join(node.directives, ' ');
        var selectionSet = node.selectionSet; // Anonymous queries with no directives or variable definitions can use
        // the query short form.
        return !name && !directives && !varDefs && op === 'query' ? selectionSet : $1f94f8496a1ffd7f$var$join([
            op,
            $1f94f8496a1ffd7f$var$join([
                name,
                varDefs
            ]),
            directives,
            selectionSet
        ], ' ');
    },
    VariableDefinition: function VariableDefinition(_ref) {
        var variable = _ref.variable, type = _ref.type, defaultValue = _ref.defaultValue, directives = _ref.directives;
        return variable + ': ' + type + $1f94f8496a1ffd7f$var$wrap(' = ', defaultValue) + $1f94f8496a1ffd7f$var$wrap(' ', $1f94f8496a1ffd7f$var$join(directives, ' '));
    },
    SelectionSet: function SelectionSet(_ref2) {
        var selections = _ref2.selections;
        return $1f94f8496a1ffd7f$var$block(selections);
    },
    Field: function Field(_ref3) {
        var alias = _ref3.alias, name = _ref3.name, args = _ref3.arguments, directives = _ref3.directives, selectionSet = _ref3.selectionSet;
        var prefix = $1f94f8496a1ffd7f$var$wrap('', alias, ': ') + name;
        var argsLine = prefix + $1f94f8496a1ffd7f$var$wrap('(', $1f94f8496a1ffd7f$var$join(args, ', '), ')');
        if (argsLine.length > $1f94f8496a1ffd7f$var$MAX_LINE_LENGTH) argsLine = prefix + $1f94f8496a1ffd7f$var$wrap('(\n', $1f94f8496a1ffd7f$var$indent($1f94f8496a1ffd7f$var$join(args, '\n')), '\n)');
        return $1f94f8496a1ffd7f$var$join([
            argsLine,
            $1f94f8496a1ffd7f$var$join(directives, ' '),
            selectionSet
        ], ' ');
    },
    Argument: function Argument(_ref4) {
        var name = _ref4.name, value = _ref4.value;
        return name + ': ' + value;
    },
    // Fragments
    FragmentSpread: function FragmentSpread(_ref5) {
        var name = _ref5.name, directives = _ref5.directives;
        return '...' + name + $1f94f8496a1ffd7f$var$wrap(' ', $1f94f8496a1ffd7f$var$join(directives, ' '));
    },
    InlineFragment: function InlineFragment(_ref6) {
        var typeCondition = _ref6.typeCondition, directives = _ref6.directives, selectionSet = _ref6.selectionSet;
        return $1f94f8496a1ffd7f$var$join([
            '...',
            $1f94f8496a1ffd7f$var$wrap('on ', typeCondition),
            $1f94f8496a1ffd7f$var$join(directives, ' '),
            selectionSet
        ], ' ');
    },
    FragmentDefinition: function FragmentDefinition(_ref7) {
        var name = _ref7.name, typeCondition = _ref7.typeCondition, variableDefinitions = _ref7.variableDefinitions, directives = _ref7.directives, selectionSet = _ref7.selectionSet;
        return(// or removed in the future.
        "fragment ".concat(name).concat($1f94f8496a1ffd7f$var$wrap('(', $1f94f8496a1ffd7f$var$join(variableDefinitions, ', '), ')'), " ") + "on ".concat(typeCondition, " ").concat($1f94f8496a1ffd7f$var$wrap('', $1f94f8496a1ffd7f$var$join(directives, ' '), ' ')) + selectionSet);
    },
    // Value
    IntValue: function IntValue(_ref8) {
        var value = _ref8.value;
        return value;
    },
    FloatValue: function FloatValue(_ref9) {
        var value = _ref9.value;
        return value;
    },
    StringValue: function StringValue(_ref10, key) {
        var value = _ref10.value, isBlockString = _ref10.block;
        return isBlockString ? (0, $flA0a.printBlockString)(value, key === 'description' ? '' : '  ') : JSON.stringify(value);
    },
    BooleanValue: function BooleanValue(_ref11) {
        var value = _ref11.value;
        return value ? 'true' : 'false';
    },
    NullValue: function NullValue() {
        return 'null';
    },
    EnumValue: function EnumValue(_ref12) {
        var value = _ref12.value;
        return value;
    },
    ListValue: function ListValue(_ref13) {
        var values = _ref13.values;
        return '[' + $1f94f8496a1ffd7f$var$join(values, ', ') + ']';
    },
    ObjectValue: function ObjectValue(_ref14) {
        var fields = _ref14.fields;
        return '{' + $1f94f8496a1ffd7f$var$join(fields, ', ') + '}';
    },
    ObjectField: function ObjectField(_ref15) {
        var name = _ref15.name, value = _ref15.value;
        return name + ': ' + value;
    },
    // Directive
    Directive: function Directive(_ref16) {
        var name = _ref16.name, args = _ref16.arguments;
        return '@' + name + $1f94f8496a1ffd7f$var$wrap('(', $1f94f8496a1ffd7f$var$join(args, ', '), ')');
    },
    // Type
    NamedType: function NamedType(_ref17) {
        var name = _ref17.name;
        return name;
    },
    ListType: function ListType(_ref18) {
        var type = _ref18.type;
        return '[' + type + ']';
    },
    NonNullType: function NonNullType(_ref19) {
        var type = _ref19.type;
        return type + '!';
    },
    // Type System Definitions
    SchemaDefinition: $1f94f8496a1ffd7f$var$addDescription(function(_ref20) {
        var directives = _ref20.directives, operationTypes = _ref20.operationTypes;
        return $1f94f8496a1ffd7f$var$join([
            'schema',
            $1f94f8496a1ffd7f$var$join(directives, ' '),
            $1f94f8496a1ffd7f$var$block(operationTypes)
        ], ' ');
    }),
    OperationTypeDefinition: function OperationTypeDefinition(_ref21) {
        var operation = _ref21.operation, type = _ref21.type;
        return operation + ': ' + type;
    },
    ScalarTypeDefinition: $1f94f8496a1ffd7f$var$addDescription(function(_ref22) {
        var name = _ref22.name, directives = _ref22.directives;
        return $1f94f8496a1ffd7f$var$join([
            'scalar',
            name,
            $1f94f8496a1ffd7f$var$join(directives, ' ')
        ], ' ');
    }),
    ObjectTypeDefinition: $1f94f8496a1ffd7f$var$addDescription(function(_ref23) {
        var name = _ref23.name, interfaces = _ref23.interfaces, directives = _ref23.directives, fields = _ref23.fields;
        return $1f94f8496a1ffd7f$var$join([
            'type',
            name,
            $1f94f8496a1ffd7f$var$wrap('implements ', $1f94f8496a1ffd7f$var$join(interfaces, ' & ')),
            $1f94f8496a1ffd7f$var$join(directives, ' '),
            $1f94f8496a1ffd7f$var$block(fields)
        ], ' ');
    }),
    FieldDefinition: $1f94f8496a1ffd7f$var$addDescription(function(_ref24) {
        var name = _ref24.name, args = _ref24.arguments, type = _ref24.type, directives = _ref24.directives;
        return name + ($1f94f8496a1ffd7f$var$hasMultilineItems(args) ? $1f94f8496a1ffd7f$var$wrap('(\n', $1f94f8496a1ffd7f$var$indent($1f94f8496a1ffd7f$var$join(args, '\n')), '\n)') : $1f94f8496a1ffd7f$var$wrap('(', $1f94f8496a1ffd7f$var$join(args, ', '), ')')) + ': ' + type + $1f94f8496a1ffd7f$var$wrap(' ', $1f94f8496a1ffd7f$var$join(directives, ' '));
    }),
    InputValueDefinition: $1f94f8496a1ffd7f$var$addDescription(function(_ref25) {
        var name = _ref25.name, type = _ref25.type, defaultValue = _ref25.defaultValue, directives = _ref25.directives;
        return $1f94f8496a1ffd7f$var$join([
            name + ': ' + type,
            $1f94f8496a1ffd7f$var$wrap('= ', defaultValue),
            $1f94f8496a1ffd7f$var$join(directives, ' ')
        ], ' ');
    }),
    InterfaceTypeDefinition: $1f94f8496a1ffd7f$var$addDescription(function(_ref26) {
        var name = _ref26.name, interfaces = _ref26.interfaces, directives = _ref26.directives, fields = _ref26.fields;
        return $1f94f8496a1ffd7f$var$join([
            'interface',
            name,
            $1f94f8496a1ffd7f$var$wrap('implements ', $1f94f8496a1ffd7f$var$join(interfaces, ' & ')),
            $1f94f8496a1ffd7f$var$join(directives, ' '),
            $1f94f8496a1ffd7f$var$block(fields)
        ], ' ');
    }),
    UnionTypeDefinition: $1f94f8496a1ffd7f$var$addDescription(function(_ref27) {
        var name = _ref27.name, directives = _ref27.directives, types = _ref27.types;
        return $1f94f8496a1ffd7f$var$join([
            'union',
            name,
            $1f94f8496a1ffd7f$var$join(directives, ' '),
            types && types.length !== 0 ? '= ' + $1f94f8496a1ffd7f$var$join(types, ' | ') : ''
        ], ' ');
    }),
    EnumTypeDefinition: $1f94f8496a1ffd7f$var$addDescription(function(_ref28) {
        var name = _ref28.name, directives = _ref28.directives, values = _ref28.values;
        return $1f94f8496a1ffd7f$var$join([
            'enum',
            name,
            $1f94f8496a1ffd7f$var$join(directives, ' '),
            $1f94f8496a1ffd7f$var$block(values)
        ], ' ');
    }),
    EnumValueDefinition: $1f94f8496a1ffd7f$var$addDescription(function(_ref29) {
        var name = _ref29.name, directives = _ref29.directives;
        return $1f94f8496a1ffd7f$var$join([
            name,
            $1f94f8496a1ffd7f$var$join(directives, ' ')
        ], ' ');
    }),
    InputObjectTypeDefinition: $1f94f8496a1ffd7f$var$addDescription(function(_ref30) {
        var name = _ref30.name, directives = _ref30.directives, fields = _ref30.fields;
        return $1f94f8496a1ffd7f$var$join([
            'input',
            name,
            $1f94f8496a1ffd7f$var$join(directives, ' '),
            $1f94f8496a1ffd7f$var$block(fields)
        ], ' ');
    }),
    DirectiveDefinition: $1f94f8496a1ffd7f$var$addDescription(function(_ref31) {
        var name = _ref31.name, args = _ref31.arguments, repeatable = _ref31.repeatable, locations = _ref31.locations;
        return 'directive @' + name + ($1f94f8496a1ffd7f$var$hasMultilineItems(args) ? $1f94f8496a1ffd7f$var$wrap('(\n', $1f94f8496a1ffd7f$var$indent($1f94f8496a1ffd7f$var$join(args, '\n')), '\n)') : $1f94f8496a1ffd7f$var$wrap('(', $1f94f8496a1ffd7f$var$join(args, ', '), ')')) + (repeatable ? ' repeatable' : '') + ' on ' + $1f94f8496a1ffd7f$var$join(locations, ' | ');
    }),
    SchemaExtension: function SchemaExtension(_ref32) {
        var directives = _ref32.directives, operationTypes = _ref32.operationTypes;
        return $1f94f8496a1ffd7f$var$join([
            'extend schema',
            $1f94f8496a1ffd7f$var$join(directives, ' '),
            $1f94f8496a1ffd7f$var$block(operationTypes)
        ], ' ');
    },
    ScalarTypeExtension: function ScalarTypeExtension(_ref33) {
        var name = _ref33.name, directives = _ref33.directives;
        return $1f94f8496a1ffd7f$var$join([
            'extend scalar',
            name,
            $1f94f8496a1ffd7f$var$join(directives, ' ')
        ], ' ');
    },
    ObjectTypeExtension: function ObjectTypeExtension(_ref34) {
        var name = _ref34.name, interfaces = _ref34.interfaces, directives = _ref34.directives, fields = _ref34.fields;
        return $1f94f8496a1ffd7f$var$join([
            'extend type',
            name,
            $1f94f8496a1ffd7f$var$wrap('implements ', $1f94f8496a1ffd7f$var$join(interfaces, ' & ')),
            $1f94f8496a1ffd7f$var$join(directives, ' '),
            $1f94f8496a1ffd7f$var$block(fields)
        ], ' ');
    },
    InterfaceTypeExtension: function InterfaceTypeExtension(_ref35) {
        var name = _ref35.name, interfaces = _ref35.interfaces, directives = _ref35.directives, fields = _ref35.fields;
        return $1f94f8496a1ffd7f$var$join([
            'extend interface',
            name,
            $1f94f8496a1ffd7f$var$wrap('implements ', $1f94f8496a1ffd7f$var$join(interfaces, ' & ')),
            $1f94f8496a1ffd7f$var$join(directives, ' '),
            $1f94f8496a1ffd7f$var$block(fields)
        ], ' ');
    },
    UnionTypeExtension: function UnionTypeExtension(_ref36) {
        var name = _ref36.name, directives = _ref36.directives, types = _ref36.types;
        return $1f94f8496a1ffd7f$var$join([
            'extend union',
            name,
            $1f94f8496a1ffd7f$var$join(directives, ' '),
            types && types.length !== 0 ? '= ' + $1f94f8496a1ffd7f$var$join(types, ' | ') : ''
        ], ' ');
    },
    EnumTypeExtension: function EnumTypeExtension(_ref37) {
        var name = _ref37.name, directives = _ref37.directives, values = _ref37.values;
        return $1f94f8496a1ffd7f$var$join([
            'extend enum',
            name,
            $1f94f8496a1ffd7f$var$join(directives, ' '),
            $1f94f8496a1ffd7f$var$block(values)
        ], ' ');
    },
    InputObjectTypeExtension: function InputObjectTypeExtension(_ref38) {
        var name = _ref38.name, directives = _ref38.directives, fields = _ref38.fields;
        return $1f94f8496a1ffd7f$var$join([
            'extend input',
            name,
            $1f94f8496a1ffd7f$var$join(directives, ' '),
            $1f94f8496a1ffd7f$var$block(fields)
        ], ' ');
    }
};
function $1f94f8496a1ffd7f$var$addDescription(cb) {
    return function(node) {
        return $1f94f8496a1ffd7f$var$join([
            node.description,
            cb(node)
        ], '\n');
    };
}
/**
 * Given maybeArray, print an empty string if it is null or empty, otherwise
 * print all items together separated by separator if provided
 */ function $1f94f8496a1ffd7f$var$join(maybeArray) {
    var _maybeArray$filter$jo;
    var separator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    return (_maybeArray$filter$jo = maybeArray === null || maybeArray === void 0 ? void 0 : maybeArray.filter(function(x) {
        return x;
    }).join(separator)) !== null && _maybeArray$filter$jo !== void 0 ? _maybeArray$filter$jo : '';
}
/**
 * Given array, print each item on its own line, wrapped in an
 * indented "{ }" block.
 */ function $1f94f8496a1ffd7f$var$block(array) {
    return $1f94f8496a1ffd7f$var$wrap('{\n', $1f94f8496a1ffd7f$var$indent($1f94f8496a1ffd7f$var$join(array, '\n')), '\n}');
}
/**
 * If maybeString is not null or empty, then wrap with start and end, otherwise print an empty string.
 */ function $1f94f8496a1ffd7f$var$wrap(start, maybeString) {
    var end = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    return maybeString != null && maybeString !== '' ? start + maybeString + end : '';
}
function $1f94f8496a1ffd7f$var$indent(str) {
    return $1f94f8496a1ffd7f$var$wrap('  ', str.replace(/\n/g, '\n  '));
}
function $1f94f8496a1ffd7f$var$isMultiline(str) {
    return str.indexOf('\n') !== -1;
}
function $1f94f8496a1ffd7f$var$hasMultilineItems(maybeArray) {
    return maybeArray != null && maybeArray.some($1f94f8496a1ffd7f$var$isMultiline);
}

});
parcelRegister("flA0a", function(module, exports) {

$parcel$export(module.exports, "dedentBlockStringValue", () => $06a65b237068075a$export$fd88c0b652c46ccc);
$parcel$export(module.exports, "printBlockString", () => $06a65b237068075a$export$adb6ca997eeb1f45);
/**
 * Produces the value of a block string from its parsed raw value, similar to
 * CoffeeScript's block string, Python's docstring trim or Ruby's strip_heredoc.
 *
 * This implements the GraphQL spec's BlockStringValue() static algorithm.
 *
 * @internal
 */ function $06a65b237068075a$export$fd88c0b652c46ccc(rawString) {
    // Expand a block string's raw value into independent lines.
    var lines = rawString.split(/\r\n|[\n\r]/g); // Remove common indentation from all lines but first.
    var commonIndent = $06a65b237068075a$export$3c95bfdc680af0c(rawString);
    if (commonIndent !== 0) for(var i = 1; i < lines.length; i++)lines[i] = lines[i].slice(commonIndent);
     // Remove leading and trailing blank lines.
    var startLine = 0;
    while(startLine < lines.length && $06a65b237068075a$var$isBlank(lines[startLine]))++startLine;
    var endLine = lines.length;
    while(endLine > startLine && $06a65b237068075a$var$isBlank(lines[endLine - 1]))--endLine;
     // Return a string of the lines joined with U+000A.
    return lines.slice(startLine, endLine).join('\n');
}
function $06a65b237068075a$var$isBlank(str) {
    for(var i = 0; i < str.length; ++i){
        if (str[i] !== ' ' && str[i] !== '\t') return false;
    }
    return true;
}
function $06a65b237068075a$export$3c95bfdc680af0c(value) {
    var _commonIndent;
    var isFirstLine = true;
    var isEmptyLine = true;
    var indent = 0;
    var commonIndent = null;
    for(var i = 0; i < value.length; ++i)switch(value.charCodeAt(i)){
        case 13:
            //  \r
            if (value.charCodeAt(i + 1) === 10) ++i; // skip \r\n as one symbol
        // falls through
        case 10:
            //  \n
            isFirstLine = false;
            isEmptyLine = true;
            indent = 0;
            break;
        case 9:
        case 32:
            //  <space>
            ++indent;
            break;
        default:
            if (isEmptyLine && !isFirstLine && (commonIndent === null || indent < commonIndent)) commonIndent = indent;
            isEmptyLine = false;
    }
    return (_commonIndent = commonIndent) !== null && _commonIndent !== void 0 ? _commonIndent : 0;
}
function $06a65b237068075a$export$adb6ca997eeb1f45(value) {
    var indentation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var preferMultipleLines = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var isSingleLine = value.indexOf('\n') === -1;
    var hasLeadingSpace = value[0] === ' ' || value[0] === '\t';
    var hasTrailingQuote = value[value.length - 1] === '"';
    var hasTrailingSlash = value[value.length - 1] === '\\';
    var printAsMultipleLines = !isSingleLine || hasTrailingQuote || hasTrailingSlash || preferMultipleLines;
    var result = ''; // Format a multi-line block quote to account for leading space.
    if (printAsMultipleLines && !(isSingleLine && hasLeadingSpace)) result += '\n' + indentation;
    result += indentation ? value.replace(/\n/g, '\n' + indentation) : value;
    if (printAsMultipleLines) result += '\n';
    return '"""' + result.replace(/"""/g, '\\"""') + '"""';
}

});




parcelRegister("kcwGc", function(module, exports) {

$parcel$export(module.exports, "RetryLink", () => $eb4e47225b0a9c93$export$943d544ad120494a);

var $fKE23 = parcelRequire("fKE23");

var $bvQX6 = parcelRequire("bvQX6");
var $5ECju = parcelRequire("5ECju");
function $eb4e47225b0a9c93$var$buildDelayFunction(delayOptions) {
    var _a = delayOptions || {}, _b = _a.initial, initial = _b === void 0 ? 300 : _b, _c = _a.jitter, jitter = _c === void 0 ? true : _c, _d = _a.max, max = _d === void 0 ? Infinity : _d;
    var baseDelay = jitter ? initial : initial / 2;
    return function delayFunction(count) {
        var delay = Math.min(max, baseDelay * Math.pow(2, count));
        if (jitter) delay = Math.random() * delay;
        return delay;
    };
}
function $eb4e47225b0a9c93$var$buildRetryFunction(retryOptions) {
    var _a = retryOptions || {}, retryIf = _a.retryIf, _b = _a.max, max = _b === void 0 ? 5 : _b;
    return function retryFunction(count, operation, error) {
        if (count >= max) return false;
        return retryIf ? retryIf(error, operation) : !!error;
    };
}
var $eb4e47225b0a9c93$var$RetryableOperation = function() {
    function RetryableOperation(operation, nextLink, delayFor, retryIf) {
        var _this = this;
        this.operation = operation;
        this.nextLink = nextLink;
        this.delayFor = delayFor;
        this.retryIf = retryIf;
        this.retryCount = 0;
        this.values = [];
        this.complete = false;
        this.canceled = false;
        this.observers = [];
        this.currentSubscription = null;
        this.onNext = function(value) {
            _this.values.push(value);
            for(var _i = 0, _a = _this.observers; _i < _a.length; _i++){
                var observer = _a[_i];
                if (!observer) continue;
                observer.next(value);
            }
        };
        this.onComplete = function() {
            _this.complete = true;
            for(var _i = 0, _a = _this.observers; _i < _a.length; _i++){
                var observer = _a[_i];
                if (!observer) continue;
                observer.complete();
            }
        };
        this.onError = function(error) {
            return (0, $fKE23.__awaiter)(_this, void 0, void 0, function() {
                var shouldRetry, _i, _a, observer;
                return (0, $fKE23.__generator)(this, function(_b) {
                    switch(_b.label){
                        case 0:
                            this.retryCount += 1;
                            return [
                                4,
                                this.retryIf(this.retryCount, this.operation, error)
                            ];
                        case 1:
                            shouldRetry = _b.sent();
                            if (shouldRetry) {
                                this.scheduleRetry(this.delayFor(this.retryCount, this.operation, error));
                                return [
                                    2
                                ];
                            }
                            this.error = error;
                            for(_i = 0, _a = this.observers; _i < _a.length; _i++){
                                observer = _a[_i];
                                if (!observer) continue;
                                observer.error(error);
                            }
                            return [
                                2
                            ];
                    }
                });
            });
        };
    }
    RetryableOperation.prototype.subscribe = function(observer) {
        if (this.canceled) throw new Error("Subscribing to a retryable link that was canceled is not supported");
        this.observers.push(observer);
        for(var _i = 0, _a = this.values; _i < _a.length; _i++){
            var value = _a[_i];
            observer.next(value);
        }
        if (this.complete) observer.complete();
        else if (this.error) observer.error(this.error);
    };
    RetryableOperation.prototype.unsubscribe = function(observer) {
        var index = this.observers.indexOf(observer);
        if (index < 0) throw new Error("RetryLink BUG! Attempting to unsubscribe unknown observer!");
        this.observers[index] = null;
        if (this.observers.every(function(o) {
            return o === null;
        })) this.cancel();
    };
    RetryableOperation.prototype.start = function() {
        if (this.currentSubscription) return;
        this.try();
    };
    RetryableOperation.prototype.cancel = function() {
        if (this.currentSubscription) this.currentSubscription.unsubscribe();
        clearTimeout(this.timerId);
        this.timerId = null;
        this.currentSubscription = null;
        this.canceled = true;
    };
    RetryableOperation.prototype.try = function() {
        this.currentSubscription = this.nextLink(this.operation).subscribe({
            next: this.onNext,
            error: this.onError,
            complete: this.onComplete
        });
    };
    RetryableOperation.prototype.scheduleRetry = function(delay) {
        var _this = this;
        if (this.timerId) throw new Error("RetryLink BUG! Encountered overlapping retries");
        this.timerId = setTimeout(function() {
            _this.timerId = null;
            _this.try();
        }, delay);
    };
    return RetryableOperation;
}();
var $eb4e47225b0a9c93$export$943d544ad120494a = function(_super) {
    (0, $fKE23.__extends)(RetryLink, _super);
    function RetryLink(options) {
        var _this = _super.call(this) || this;
        var _a = options || {}, attempts = _a.attempts, delay = _a.delay;
        _this.delayFor = typeof delay === 'function' ? delay : $eb4e47225b0a9c93$var$buildDelayFunction(delay);
        _this.retryIf = typeof attempts === 'function' ? attempts : $eb4e47225b0a9c93$var$buildRetryFunction(attempts);
        return _this;
    }
    RetryLink.prototype.request = function(operation, nextLink) {
        var retryable = new $eb4e47225b0a9c93$var$RetryableOperation(operation, nextLink, this.delayFor, this.retryIf);
        retryable.start();
        return new (0, $5ECju.default)(function(observer) {
            retryable.subscribe(observer);
            return function() {
                retryable.unsubscribe(observer);
            };
        });
    };
    return RetryLink;
}((0, $bvQX6.ApolloLink));

});

parcelRegister("10n8H", function(module, exports) {

$parcel$export(module.exports, "fragmentCacheRedirect", () => $0bb7bd86ef08f58c$export$5133c88128301697);
$parcel$export(module.exports, "fragmentLinkState", () => $0bb7bd86ef08f58c$export$3f9ecfb4d42ab23d);

var $42BH7 = parcelRequire("42BH7");

var $hiwGV = parcelRequire("hiwGV");

var $2vRh6 = parcelRequire("2vRh6");
function $0bb7bd86ef08f58c$export$5133c88128301697(dataIdFromObject) {
    if (dataIdFromObject === void 0) dataIdFromObject = (0, $2vRh6.defaultDataIdFromObject);
    return {
        getFragment: function(_, _a) {
            var id = _a.id, __typename = _a.__typename;
            return (0, $42BH7.toIdValue)(dataIdFromObject({
                __typename: __typename,
                id: id
            }));
        }
    };
}
function $0bb7bd86ef08f58c$export$3f9ecfb4d42ab23d(apolloCache) {
    return (0, $hiwGV.withClientState)({
        cache: apolloCache,
        resolvers: {
            Query: {
                getFragment: function(_, _a, _b) {
                    var __typename = _a.__typename, id = _a.id;
                    var cache = _b.cache;
                    var fragmentId = cache.config.dataIdFromObject({
                        __typename: __typename,
                        id: id
                    });
                    return cache.data.data[fragmentId];
                }
            }
        }
    });
}

});
parcelRegister("hiwGV", function(module, exports) {

$parcel$export(module.exports, "withClientState", () => $c97d79f1a0a9adb8$export$a13f755900e15d9e);

var $bvQX6 = parcelRequire("bvQX6");
var $5ECju = parcelRequire("5ECju");

var $42BH7 = parcelRequire("42BH7");

var $77JSu = parcelRequire("77JSu");

var $fl4NX = parcelRequire("fl4NX");
var $c97d79f1a0a9adb8$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $c97d79f1a0a9adb8$var$graphql = $77JSu.graphql;
var $c97d79f1a0a9adb8$var$capitalizeFirstLetter = function(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
};
var $c97d79f1a0a9adb8$export$a13f755900e15d9e = function(clientStateConfig) {
    if (clientStateConfig === void 0) clientStateConfig = {
        resolvers: {},
        defaults: {}
    };
    var defaults = clientStateConfig.defaults, cache = clientStateConfig.cache, typeDefs = clientStateConfig.typeDefs, fragmentMatcher = clientStateConfig.fragmentMatcher;
    if (cache && defaults) cache.writeData({
        data: defaults
    });
    return new (function(_super) {
        $c97d79f1a0a9adb8$var$__extends(StateLink, _super);
        function StateLink() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        StateLink.prototype.writeDefaults = function() {
            if (cache && defaults) cache.writeData({
                data: defaults
            });
        };
        StateLink.prototype.request = function(operation, forward) {
            if (forward === void 0) forward = function() {
                return (0, $5ECju.default).of({
                    data: {}
                });
            };
            if (typeDefs) {
                var directives_1 = 'directive @client on FIELD';
                var definition_1 = (0, $fl4NX.normalizeTypeDefs)(typeDefs);
                operation.setContext(function(_a) {
                    var _b = _a.schemas, schemas = _b === void 0 ? [] : _b;
                    return {
                        schemas: schemas.concat([
                            {
                                definition: definition_1,
                                directives: directives_1
                            }
                        ])
                    };
                });
            }
            var isClient = (0, $42BH7.hasDirectives)([
                'client'
            ], operation.query);
            if (!isClient) return forward(operation);
            var resolvers = typeof clientStateConfig.resolvers === 'function' ? clientStateConfig.resolvers() : clientStateConfig.resolvers;
            var server = (0, $fl4NX.removeClientSetsFromDocument)(operation.query);
            var query = operation.query;
            var type = $c97d79f1a0a9adb8$var$capitalizeFirstLetter(((0, $42BH7.getMainDefinition)(query) || {}).operation) || 'Query';
            var resolver = function(fieldName, rootValue, args, context, info) {
                if (rootValue === void 0) rootValue = {};
                var resultKey = info.resultKey;
                var aliasedNode = rootValue[resultKey];
                var preAliasingNode = rootValue[fieldName];
                var aliasNeeded = resultKey !== fieldName;
                if (aliasedNode !== undefined || preAliasingNode !== undefined) return aliasedNode || preAliasingNode;
                var resolverMap = resolvers[rootValue.__typename || type];
                if (resolverMap) {
                    var resolve = resolverMap[fieldName];
                    if (resolve) return resolve(rootValue, args, context, info);
                }
                return (aliasNeeded ? aliasedNode : preAliasingNode) || (defaults || {})[fieldName];
            };
            if (server) operation.query = server;
            var obs = server && forward ? forward(operation) : (0, $5ECju.default).of({
                data: {}
            });
            return new (0, $5ECju.default)(function(observer) {
                var complete = false;
                var handlingNext = false;
                obs.subscribe({
                    next: function(_a) {
                        var data = _a.data, errors = _a.errors;
                        var observerErrorHandler = observer.error.bind(observer);
                        var context = operation.getContext();
                        handlingNext = true;
                        $c97d79f1a0a9adb8$var$graphql(resolver, query, data, context, operation.variables, {
                            fragmentMatcher: fragmentMatcher
                        }).then(function(nextData) {
                            observer.next({
                                data: nextData,
                                errors: errors
                            });
                            if (complete) observer.complete();
                            handlingNext = false;
                        }).catch(observerErrorHandler);
                    },
                    error: observer.error.bind(observer),
                    complete: function() {
                        if (!handlingNext) observer.complete();
                        complete = true;
                    }
                });
            });
        };
        return StateLink;
    }((0, $bvQX6.ApolloLink)))();
};

});
parcelRegister("77JSu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $fKE23 = parcelRequire("fKE23");

var $42BH7 = parcelRequire("42BH7");

var $1BuKE = parcelRequire("1BuKE");
function $52fcc63cc3cd9b23$var$graphql(resolver, document, rootValue, contextValue, variableValues, execOptions) {
    if (execOptions === void 0) execOptions = {};
    var mainDefinition = $42BH7.getMainDefinition(document);
    var fragments = $42BH7.getFragmentDefinitions(document);
    var fragmentMap = $42BH7.createFragmentMap(fragments);
    var resultMapper = execOptions.resultMapper;
    var fragmentMatcher = execOptions.fragmentMatcher || function() {
        return true;
    };
    var execContext = {
        fragmentMap: fragmentMap,
        contextValue: contextValue,
        variableValues: variableValues,
        resultMapper: resultMapper,
        resolver: resolver,
        fragmentMatcher: fragmentMatcher
    };
    return $52fcc63cc3cd9b23$var$executeSelectionSet(mainDefinition.selectionSet, rootValue, execContext);
}
module.exports.graphql = $52fcc63cc3cd9b23$var$graphql;
function $52fcc63cc3cd9b23$var$executeSelectionSet(selectionSet, rootValue, execContext) {
    return $fKE23.__awaiter(this, void 0, void 0, function() {
        var fragmentMap, contextValue, variables, result, execute;
        var _this = this;
        return $fKE23.__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    fragmentMap = execContext.fragmentMap, contextValue = execContext.contextValue, variables = execContext.variableValues;
                    result = {};
                    execute = function(selection) {
                        return $fKE23.__awaiter(_this, void 0, void 0, function() {
                            var fieldResult, resultFieldKey, fragment, typeCondition, fragmentResult;
                            return $fKE23.__generator(this, function(_a) {
                                switch(_a.label){
                                    case 0:
                                        if (!$42BH7.shouldInclude(selection, variables)) return [
                                            2
                                        ];
                                        if (!$42BH7.isField(selection)) return [
                                            3,
                                            2
                                        ];
                                        return [
                                            4,
                                            $52fcc63cc3cd9b23$var$executeField(selection, rootValue, execContext)
                                        ];
                                    case 1:
                                        fieldResult = _a.sent();
                                        resultFieldKey = $42BH7.resultKeyNameFromField(selection);
                                        if (fieldResult !== undefined) {
                                            if (result[resultFieldKey] === undefined) result[resultFieldKey] = fieldResult;
                                            else $1BuKE.merge(result[resultFieldKey], fieldResult);
                                        }
                                        return [
                                            2
                                        ];
                                    case 2:
                                        if ($42BH7.isInlineFragment(selection)) fragment = selection;
                                        else {
                                            fragment = fragmentMap[selection.name.value];
                                            if (!fragment) throw new Error("No fragment named " + selection.name.value);
                                        }
                                        typeCondition = fragment.typeCondition.name.value;
                                        if (!execContext.fragmentMatcher(rootValue, typeCondition, contextValue)) return [
                                            3,
                                            4
                                        ];
                                        return [
                                            4,
                                            $52fcc63cc3cd9b23$var$executeSelectionSet(fragment.selectionSet, rootValue, execContext)
                                        ];
                                    case 3:
                                        fragmentResult = _a.sent();
                                        $1BuKE.merge(result, fragmentResult);
                                        _a.label = 4;
                                    case 4:
                                        return [
                                            2
                                        ];
                                }
                            });
                        });
                    };
                    return [
                        4,
                        Promise.all(selectionSet.selections.map(execute))
                    ];
                case 1:
                    _a.sent();
                    if (execContext.resultMapper) return [
                        2,
                        execContext.resultMapper(result, rootValue)
                    ];
                    return [
                        2,
                        result
                    ];
            }
        });
    });
}
function $52fcc63cc3cd9b23$var$executeField(field, rootValue, execContext) {
    return $fKE23.__awaiter(this, void 0, void 0, function() {
        var variables, contextValue, resolver, fieldName, args, info, result;
        return $fKE23.__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    variables = execContext.variableValues, contextValue = execContext.contextValue, resolver = execContext.resolver;
                    fieldName = field.name.value;
                    args = $42BH7.argumentsObjectFromField(field, variables);
                    info = {
                        isLeaf: !field.selectionSet,
                        resultKey: $42BH7.resultKeyNameFromField(field),
                        directives: $42BH7.getDirectiveInfoFromField(field, variables),
                        field: field
                    };
                    return [
                        4,
                        resolver(fieldName, rootValue, args, contextValue, info)
                    ];
                case 1:
                    result = _a.sent();
                    if (!field.selectionSet) return [
                        2,
                        result
                    ];
                    if (result == null) return [
                        2,
                        result
                    ];
                    if (Array.isArray(result)) return [
                        2,
                        $52fcc63cc3cd9b23$var$executeSubSelectedArray(field, result, execContext)
                    ];
                    return [
                        2,
                        $52fcc63cc3cd9b23$var$executeSelectionSet(field.selectionSet, result, execContext)
                    ];
            }
        });
    });
}
function $52fcc63cc3cd9b23$var$executeSubSelectedArray(field, result, execContext) {
    return Promise.all(result.map(function(item) {
        if (item === null) return null;
        if (Array.isArray(item)) return $52fcc63cc3cd9b23$var$executeSubSelectedArray(field, item, execContext);
        return $52fcc63cc3cd9b23$var$executeSelectionSet(field.selectionSet, item, execContext);
    }));
}

});
parcelRegister("1BuKE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $42BH7 = parcelRequire("42BH7");
function $12b119b85c2553d1$var$graphql(resolver, document, rootValue, contextValue, variableValues, execOptions) {
    if (variableValues === void 0) variableValues = {};
    if (execOptions === void 0) execOptions = {};
    var mainDefinition = $42BH7.getMainDefinition(document);
    var fragments = $42BH7.getFragmentDefinitions(document);
    var fragmentMap = $42BH7.createFragmentMap(fragments);
    var resultMapper = execOptions.resultMapper;
    var fragmentMatcher = execOptions.fragmentMatcher || function() {
        return true;
    };
    var execContext = {
        fragmentMap: fragmentMap,
        contextValue: contextValue,
        variableValues: variableValues,
        resultMapper: resultMapper,
        resolver: resolver,
        fragmentMatcher: fragmentMatcher
    };
    return $12b119b85c2553d1$var$executeSelectionSet(mainDefinition.selectionSet, rootValue, execContext);
}
module.exports.graphql = $12b119b85c2553d1$var$graphql;
function $12b119b85c2553d1$var$executeSelectionSet(selectionSet, rootValue, execContext) {
    var fragmentMap = execContext.fragmentMap, contextValue = execContext.contextValue, variables = execContext.variableValues;
    var result = {};
    selectionSet.selections.forEach(function(selection) {
        if (variables && !$42BH7.shouldInclude(selection, variables)) return;
        if ($42BH7.isField(selection)) {
            var fieldResult = $12b119b85c2553d1$var$executeField(selection, rootValue, execContext);
            var resultFieldKey = $42BH7.resultKeyNameFromField(selection);
            if (fieldResult !== undefined) {
                if (result[resultFieldKey] === undefined) result[resultFieldKey] = fieldResult;
                else $12b119b85c2553d1$var$merge(result[resultFieldKey], fieldResult);
            }
        } else {
            var fragment = void 0;
            if ($42BH7.isInlineFragment(selection)) fragment = selection;
            else {
                fragment = fragmentMap[selection.name.value];
                if (!fragment) throw new Error("No fragment named " + selection.name.value);
            }
            var typeCondition = fragment.typeCondition.name.value;
            if (execContext.fragmentMatcher(rootValue, typeCondition, contextValue)) {
                var fragmentResult = $12b119b85c2553d1$var$executeSelectionSet(fragment.selectionSet, rootValue, execContext);
                $12b119b85c2553d1$var$merge(result, fragmentResult);
            }
        }
    });
    if (execContext.resultMapper) return execContext.resultMapper(result, rootValue);
    return result;
}
function $12b119b85c2553d1$var$executeField(field, rootValue, execContext) {
    var variables = execContext.variableValues, contextValue = execContext.contextValue, resolver = execContext.resolver;
    var fieldName = field.name.value;
    var args = $42BH7.argumentsObjectFromField(field, variables);
    var info = {
        isLeaf: !field.selectionSet,
        resultKey: $42BH7.resultKeyNameFromField(field),
        directives: $42BH7.getDirectiveInfoFromField(field, variables),
        field: field
    };
    var result = resolver(fieldName, rootValue, args, contextValue, info);
    if (!field.selectionSet) return result;
    if (result == null) return result;
    if (Array.isArray(result)) return $12b119b85c2553d1$var$executeSubSelectedArray(field, result, execContext);
    return $12b119b85c2553d1$var$executeSelectionSet(field.selectionSet, result, execContext);
}
function $12b119b85c2553d1$var$executeSubSelectedArray(field, result, execContext) {
    return result.map(function(item) {
        if (item === null) return null;
        if (Array.isArray(item)) return $12b119b85c2553d1$var$executeSubSelectedArray(field, item, execContext);
        return $12b119b85c2553d1$var$executeSelectionSet(field.selectionSet, item, execContext);
    });
}
var $12b119b85c2553d1$var$hasOwn = Object.prototype.hasOwnProperty;
function $12b119b85c2553d1$var$merge(dest, src) {
    if (src !== null && typeof src === 'object') Object.keys(src).forEach(function(key) {
        var srcVal = src[key];
        if (!$12b119b85c2553d1$var$hasOwn.call(dest, key)) dest[key] = srcVal;
        else $12b119b85c2553d1$var$merge(dest[key], srcVal);
    });
}
module.exports.merge = $12b119b85c2553d1$var$merge;

});


parcelRegister("fl4NX", function(module, exports) {

$parcel$export(module.exports, "removeClientSetsFromDocument", () => $b2ac8b51e1cafdcd$export$8eae69e876ee321e);
$parcel$export(module.exports, "normalizeTypeDefs", () => $b2ac8b51e1cafdcd$export$467f9c465e4ace4e);

var $aKlnM = parcelRequire("aKlnM");

var $42BH7 = parcelRequire("42BH7");
var $b2ac8b51e1cafdcd$var$connectionRemoveConfig = {
    test: function(directive) {
        return directive.name.value === 'client';
    },
    remove: true
};
var $b2ac8b51e1cafdcd$var$removed = new Map();
function $b2ac8b51e1cafdcd$export$8eae69e876ee321e(query) {
    var cached = $b2ac8b51e1cafdcd$var$removed.get(query);
    if (cached) return cached;
    (0, $42BH7.checkDocument)(query);
    var docClone = (0, $42BH7.removeDirectivesFromDocument)([
        $b2ac8b51e1cafdcd$var$connectionRemoveConfig
    ], query);
    $b2ac8b51e1cafdcd$var$removed.set(query, docClone);
    return docClone;
}
function $b2ac8b51e1cafdcd$export$467f9c465e4ace4e(typeDefs) {
    var defs = Array.isArray(typeDefs) ? typeDefs : [
        typeDefs
    ];
    return defs.map(function(typeDef) {
        return typeof typeDef === 'string' ? typeDef : (0, $aKlnM.print)(typeDef);
    }).map(function(str) {
        return str.trim();
    }).join('\n');
}

});



parcelRegister("aXA7t", function(module, exports) {

$parcel$export(module.exports, "UFOLoggerLink", () => $2f1700194c3d8ae8$export$fb326ed954631f3f);

var $bvQX6 = parcelRequire("bvQX6");

var $fVaJL = parcelRequire("fVaJL");
const $2f1700194c3d8ae8$export$fb326ed954631f3f = new (0, $bvQX6.ApolloLink)((operation, forward)=>{
    const networkStart = performance.now();
    return forward(operation).map((response)=>{
        const networkComplete = performance.now();
        const operationName = operation.operationName ?? 'unnamed';
        (0, $fVaJL.addSpanToAll)('graphql', operationName, [
            {
                name: 'network'
            }
        ], networkStart, networkComplete);
        return response;
    });
});

});

parcelRegister("iV2Ac", function(module, exports) {
module.exports = JSON.parse("{\"__schema\":{\"types\":[{\"kind\":\"UNION\",\"name\":\"AllActivityFeedItemUnion\",\"possibleTypes\":[{\"name\":\"HistoryItem\"},{\"name\":\"CommentItem\"},{\"name\":\"WorklogItem\"},{\"name\":\"IncidentItem\"},{\"name\":\"ApprovalItem\"},{\"name\":\"HiddenCommentItem\"}]},{\"kind\":\"UNION\",\"name\":\"ApprovalActivityValueUnion\",\"possibleTypes\":[{\"name\":\"ApprovalCreated\"},{\"name\":\"ApproverDecision\"},{\"name\":\"ApprovalCompleted\"}]},{\"kind\":\"UNION\",\"name\":\"ConfluencePageUnion\",\"possibleTypes\":[{\"name\":\"ConfluencePage\"},{\"name\":\"FailedRemoteLink\"}]},{\"kind\":\"UNION\",\"name\":\"GQLCategorizedField\",\"possibleTypes\":[{\"name\":\"GQLSortableField\"},{\"name\":\"GQLSearchableField\"}]},{\"kind\":\"UNION\",\"name\":\"GadgetParameters\",\"possibleTypes\":[{\"name\":\"VotedGadgetParameters\"},{\"name\":\"AssignedToMeGadgetParameters\"},{\"name\":\"WatchedGadgetParameters\"},{\"name\":\"InProgressGadgetParameters\"},{\"name\":\"FilterResultsGadgetParameters\"},{\"name\":\"TwoDimensionalStatisticsParameters\"},{\"name\":\"PieChartParameters\"},{\"name\":\"IssueStatisticsParameters\"},{\"name\":\"WorkloadPieChartParameters\"},{\"name\":\"ActivityStreamGadgetParameters\"},{\"name\":\"CreatedVsResolvedGadgetParameters\"},{\"name\":\"SprintGadgetParameters\"},{\"name\":\"ProjectsGadgetParameters\"},{\"name\":\"ConnectGadgetParameters\"},{\"name\":\"NotConfiguredGadgetParameters\"},{\"name\":\"UnsupportedGadgetParameters\"}]},{\"kind\":\"UNION\",\"name\":\"GroupByFieldUnion\",\"possibleTypes\":[{\"name\":\"PriorityField\"},{\"name\":\"StatusField\"},{\"name\":\"UserField\"},{\"name\":\"LabelsField\"},{\"name\":\"SelectCustomField\"},{\"name\":\"JWMCategoryCustomField\"},{\"name\":\"IssueTypeField\"},{\"name\":\"StoryPointsField\"},{\"name\":\"SprintCustomField\"},{\"name\":\"FloatCustomField\"}]},{\"kind\":\"UNION\",\"name\":\"GroupSectionItem\",\"possibleTypes\":[{\"name\":\"FieldSectionItem\"},{\"name\":\"EcosystemSectionItem\"},{\"name\":\"ForgeSectionItem\"},{\"name\":\"PanelSectionItem\"}]},{\"kind\":\"UNION\",\"name\":\"HistoryValue\",\"possibleTypes\":[{\"name\":\"AssigneeFieldValue\"},{\"name\":\"PriorityFieldValue\"},{\"name\":\"StatusFieldValue\"},{\"name\":\"WorkLogFieldValue\"},{\"name\":\"RespondersFieldValue\"},{\"name\":\"GenericFieldValue\"}]},{\"kind\":\"UNION\",\"name\":\"IncidentActivityValueUnion\",\"possibleTypes\":[{\"name\":\"ResponderAlertAssignedValue\"},{\"name\":\"AlertValue\"},{\"name\":\"ResponderAlertPriorityChangedValue\"},{\"name\":\"IccSessionValue\"},{\"name\":\"IccSessionInvitationValue\"},{\"name\":\"StakeholderUpdatedValue\"},{\"name\":\"IncidentStakeholderActionValue\"}]},{\"kind\":\"UNION\",\"name\":\"IssueFieldUnion\",\"possibleTypes\":[{\"name\":\"PriorityField\"},{\"name\":\"StatusField\"},{\"name\":\"IssueTypeField\"},{\"name\":\"ProjectComponentsField\"},{\"name\":\"LabelsField\"},{\"name\":\"WatchersField\"},{\"name\":\"UserField\"},{\"name\":\"TextField\"},{\"name\":\"VersionsField\"},{\"name\":\"DateField\"},{\"name\":\"DateTimeField\"},{\"name\":\"IssueKeyField\"},{\"name\":\"ProjectField\"},{\"name\":\"ResolutionField\"},{\"name\":\"TimeTrackingField\"},{\"name\":\"TimeOriginalEstimateField\"},{\"name\":\"TimeEstimateField\"},{\"name\":\"TimeSpentField\"},{\"name\":\"StoryPointsField\"},{\"name\":\"EpicLinkField\"},{\"name\":\"EpicNameField\"},{\"name\":\"ColorField\"},{\"name\":\"EpicColorField\"},{\"name\":\"SprintCustomField\"},{\"name\":\"SelectCustomField\"},{\"name\":\"FlaggedCustomField\"},{\"name\":\"UserPickerCustomField\"},{\"name\":\"TextAreaCustomField\"},{\"name\":\"FloatCustomField\"},{\"name\":\"DatePickerCustomField\"},{\"name\":\"TextFieldCustomField\"},{\"name\":\"MultiSelectCustomField\"},{\"name\":\"LabelsCustomField\"},{\"name\":\"MultiUserPickerCustomField\"},{\"name\":\"PeopleCustomField\"},{\"name\":\"UrlCustomField\"},{\"name\":\"VersionCustomField\"},{\"name\":\"GroupPickerCustomField\"},{\"name\":\"MultiVersionCustomField\"},{\"name\":\"MultiGroupPickerCustomField\"},{\"name\":\"CheckBoxesCustomField\"},{\"name\":\"RadioButtonsCustomField\"},{\"name\":\"DateTimeCustomField\"},{\"name\":\"SeverityField\"},{\"name\":\"AffectedServicesField\"},{\"name\":\"TechLeadField\"},{\"name\":\"AttachmentsField\"},{\"name\":\"GlancesField\"},{\"name\":\"SecurityLevelField\"},{\"name\":\"IssueLinksField\"},{\"name\":\"IssuesInEpicField\"},{\"name\":\"SubtasksField\"},{\"name\":\"ChildIssuesField\"},{\"name\":\"CascadingSelectCustomField\"},{\"name\":\"CmdbField\"},{\"name\":\"SLACustomField\"},{\"name\":\"ProjectCustomField\"},{\"name\":\"EpicStatusField\"},{\"name\":\"ParentField\"},{\"name\":\"JWMCategoryCustomField\"},{\"name\":\"CommentSummaryField\"}]},{\"kind\":\"UNION\",\"name\":\"IssueSections\",\"possibleTypes\":[{\"name\":\"PrimarySecondaryContextSections\"},{\"name\":\"JsdSections\"}]},{\"kind\":\"UNION\",\"name\":\"JiraActiveBackgroundDetailsResult\",\"possibleTypes\":[{\"name\":\"JiraColorBackground\"},{\"name\":\"JiraGradientBackground\"},{\"name\":\"JiraMediaBackground\"},{\"name\":\"JiraAttachmentBackground\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraAtlassianIntelligenceAction\",\"possibleTypes\":[{\"name\":\"JiraAccessAtlassianIntelligenceFeature\"},{\"name\":\"JiraEnableAtlassianIntelligenceDeepLink\"},{\"name\":\"JiraContactOrgAdminToEnableAtlassianIntelligence\"}]},{\"kind\":\"UNION\",\"name\":\"JiraBackgroundUploadTokenResult\",\"possibleTypes\":[{\"name\":\"JiraBackgroundUploadToken\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraChildIssues\",\"possibleTypes\":[{\"name\":\"JiraChildIssuesWithinLimit\"},{\"name\":\"JiraChildIssuesExceedingLimit\"}]},{\"kind\":\"UNION\",\"name\":\"JiraCommentVisibility\",\"possibleTypes\":[{\"name\":\"JiraRoleVisibility\"},{\"name\":\"JiraGroupVisibility\"}]},{\"kind\":\"UNION\",\"name\":\"JiraContainerNavigationResult\",\"possibleTypes\":[{\"name\":\"JiraContainerNavigation\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraFavourite\",\"possibleTypes\":[{\"name\":\"JiraProject\"},{\"name\":\"JiraSystemFilter\"},{\"name\":\"JiraCustomFilter\"},{\"name\":\"JiraDashboard\"},{\"name\":\"JiraPlan\"},{\"name\":\"JiraBoard\"},{\"name\":\"JiraServiceManagementQueue\"}]},{\"kind\":\"UNION\",\"name\":\"JiraFormattingExpression\",\"possibleTypes\":[{\"name\":\"JiraFormattingSingleValueOperand\"},{\"name\":\"JiraFormattingTwoValueOperand\"},{\"name\":\"JiraFormattingMultipleValueOperand\"},{\"name\":\"JiraFormattingNoValueOperand\"}]},{\"kind\":\"UNION\",\"name\":\"JiraGlobalPermissionGrantsResult\",\"possibleTypes\":[{\"name\":\"JiraGlobalPermissionGrantsList\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraGrantTypeValue\",\"possibleTypes\":[{\"name\":\"JiraDefaultGrantTypeValue\"},{\"name\":\"JiraUserGrantTypeValue\"},{\"name\":\"JiraProjectRoleGrantTypeValue\"},{\"name\":\"JiraGroupGrantTypeValue\"},{\"name\":\"JiraIssueFieldGrantTypeValue\"}]},{\"kind\":\"UNION\",\"name\":\"JiraGroupLayoutItem\",\"possibleTypes\":[{\"name\":\"JiraFieldLayoutItem\"},{\"name\":\"JiraEcosystemLayoutItem\"},{\"name\":\"JiraForgeLayoutItem\"},{\"name\":\"JiraPanelLayoutItem\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueCreateAdditionalServicesResult\",\"possibleTypes\":[{\"name\":\"JiraIssueCreateAdditionalServices\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueCreateFieldsResult\",\"possibleTypes\":[{\"name\":\"JiraIssueCreateFields\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueCreateLayoutResult\",\"possibleTypes\":[{\"name\":\"JiraIssueCreateLayout\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueItemContainerItem\",\"possibleTypes\":[{\"name\":\"JiraIssueItemFieldItem\"},{\"name\":\"JiraIssueItemPanelItem\"},{\"name\":\"JiraIssueItemGroupContainer\"},{\"name\":\"JiraIssueItemTabContainer\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueItemContainersResult\",\"possibleTypes\":[{\"name\":\"JiraIssueItemContainers\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueItemGroupContainerItem\",\"possibleTypes\":[{\"name\":\"JiraIssueItemFieldItem\"},{\"name\":\"JiraIssueItemPanelItem\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueItemTabContainerItem\",\"possibleTypes\":[{\"name\":\"JiraIssueItemFieldItem\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayout\",\"possibleTypes\":[{\"name\":\"JiraDefaultIssueLayout\"},{\"name\":\"JiraIssueCreateLayout\"},{\"name\":\"JiraLegacyIssueLayout\"},{\"name\":\"JsdDefaultIssueLayout\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayoutConfiguration\",\"possibleTypes\":[{\"name\":\"JiraIssueLayoutConfigurationResult\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayoutFieldConfigurationHiddenIn\",\"possibleTypes\":[{\"name\":\"JiraIssueLayoutFieldConfigurationHiddenInGlobal\"},{\"name\":\"JiraIssueLayoutFieldConfigurationHiddenInLayoutOwner\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayoutFieldPanelItemConfiguration\",\"possibleTypes\":[{\"name\":\"JiraIssueLayoutFieldItemConfiguration\"},{\"name\":\"JiraIssueLayoutPanelItemConfiguration\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayoutItemConfiguration\",\"possibleTypes\":[{\"name\":\"JiraIssueLayoutContainerConfiguration\"},{\"name\":\"JiraIssueLayoutFieldItemConfiguration\"},{\"name\":\"JiraIssueLayoutGroupContainerConfiguration\"},{\"name\":\"JiraIssueLayoutTabContainerConfiguration\"},{\"name\":\"JiraIssueLayoutPanelItemConfiguration\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayoutOwner\",\"possibleTypes\":[{\"name\":\"JiraIssueLayoutIssueTypeOwner\"},{\"name\":\"JiraIssueLayoutRequestTypeOwner\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayoutOwners\",\"possibleTypes\":[{\"name\":\"JiraIssueLayoutOwnersResult\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueResult\",\"possibleTypes\":[{\"name\":\"JiraIssue\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueSearchByFilterResult\",\"possibleTypes\":[{\"name\":\"JiraIssueSearchByFilter\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueSearchByJqlResult\",\"possibleTypes\":[{\"name\":\"JiraIssueSearchByJql\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueSearchError\",\"possibleTypes\":[{\"name\":\"JiraInvalidJqlError\"},{\"name\":\"JiraInvalidSyntaxError\"},{\"name\":\"JiraServerError\"},{\"name\":\"JiraCustomIssueSearchError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueSearchViewResult\",\"possibleTypes\":[{\"name\":\"JiraIssueSearchView\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJQLGenerationError\",\"possibleTypes\":[{\"name\":\"JiraInvalidJqlError\"},{\"name\":\"JiraInvalidSyntaxError\"},{\"name\":\"JiraServerError\"},{\"name\":\"JiraUIExposedError\"},{\"name\":\"JiraUsageLimitExceededError\"},{\"name\":\"JiraUnsupportedLanguageError\"},{\"name\":\"JiraGeneratedJqlInvalidError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJqlFieldConnectionResult\",\"possibleTypes\":[{\"name\":\"JiraJqlFieldConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJqlHydratedQueryResult\",\"possibleTypes\":[{\"name\":\"JiraJqlHydratedQuery\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJqlQueryHydratedFieldResult\",\"possibleTypes\":[{\"name\":\"JiraJqlQueryHydratedField\"},{\"name\":\"JiraJqlQueryHydratedError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJqlQueryHydratedValueResult\",\"possibleTypes\":[{\"name\":\"JiraJqlQueryHydratedValue\"},{\"name\":\"JiraJqlQueryHydratedError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraMediaUploadTokenResult\",\"possibleTypes\":[{\"name\":\"JiraMediaUploadToken\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraNavigationItemResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementSavedView\"},{\"name\":\"JiraSoftwareBuiltInNavigationItem\"},{\"name\":\"JiraAppNavigationItem\"},{\"name\":\"JiraShortcutNavigationItem\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraOnSuggestedChildIssueResult\",\"possibleTypes\":[{\"name\":\"JiraSuggestedIssue\"},{\"name\":\"JiraSuggestedChildIssueStatus\"},{\"name\":\"JiraSuggestedChildIssueError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraOverviewPlanMigrationStateResult\",\"possibleTypes\":[{\"name\":\"JiraOverviewPlanMigrationState\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraPermissionSchemeViewResult\",\"possibleTypes\":[{\"name\":\"JiraPermissionSchemeView\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraProjectConfiguration\",\"possibleTypes\":[{\"name\":\"JiraProjectConfigurationResult\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraProjectNavigationMetadata\",\"possibleTypes\":[{\"name\":\"JiraSoftwareProjectNavigationMetadata\"},{\"name\":\"JiraServiceManagementProjectNavigationMetadata\"},{\"name\":\"JiraWorkManagementProjectNavigationMetadata\"}]},{\"kind\":\"UNION\",\"name\":\"JiraProjectsUsingField\",\"possibleTypes\":[{\"name\":\"JiraProjectsUsingFieldResult\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraRemoteIssueLink\",\"possibleTypes\":[{\"name\":\"JiraIssueRemoteIssueLink\"},{\"name\":\"JiraConfluenceRemoteIssueLink\"},{\"name\":\"JiraWebRemoteIssueLink\"},{\"name\":\"JiraCustomRemoteIssueLink\"}]},{\"kind\":\"UNION\",\"name\":\"JiraSearchableEntity\",\"possibleTypes\":[{\"name\":\"JiraProject\"},{\"name\":\"JiraSystemFilter\"},{\"name\":\"JiraCustomFilter\"},{\"name\":\"JiraBoard\"},{\"name\":\"JiraDashboard\"},{\"name\":\"JiraIssue\"},{\"name\":\"JiraServiceManagementQueue\"},{\"name\":\"JiraPlan\"}]},{\"kind\":\"UNION\",\"name\":\"JiraSectionLayoutItem\",\"possibleTypes\":[{\"name\":\"JiraGroupLayout\"},{\"name\":\"JiraTabLayout\"},{\"name\":\"JiraFieldLayoutItem\"},{\"name\":\"JiraEcosystemLayoutItem\"},{\"name\":\"JiraForgeLayoutItem\"},{\"name\":\"JiraPanelLayoutItem\"}]},{\"kind\":\"UNION\",\"name\":\"JiraServiceManagementApproverPrincipal\",\"possibleTypes\":[{\"name\":\"JiraServiceManagementUserApproverPrincipal\"},{\"name\":\"JiraServiceManagementGroupApproverPrincipal\"}]},{\"kind\":\"UNION\",\"name\":\"JiraServiceManagementEntitledEntity\",\"possibleTypes\":[{\"name\":\"JiraServiceManagementEntitlementCustomer\"},{\"name\":\"JiraServiceManagementEntitlementOrganization\"}]},{\"kind\":\"UNION\",\"name\":\"JiraServiceManagementRequestTypePreviewField\",\"possibleTypes\":[{\"name\":\"JiraServiceManagementTextPreviewField\"},{\"name\":\"JiraServiceManagementTextAreaPreviewField\"},{\"name\":\"JiraServiceManagementDueDatePreviewField\"},{\"name\":\"JiraServiceManagementDatePreviewField\"},{\"name\":\"JiraServiceManagementDateTimePreviewField\"},{\"name\":\"JiraServiceManagementAttachmentPreviewField\"},{\"name\":\"JiraServiceManagementSelectPreviewField\"},{\"name\":\"JiraServiceManagementMultiSelectPreviewField\"},{\"name\":\"JiraServiceManagementMultiUserPickerPreviewField\"},{\"name\":\"JiraServiceManagementMultiServicePickerPreviewField\"},{\"name\":\"JiraServiceManagementMultiCheckboxesPreviewField\"},{\"name\":\"JiraServiceManagementPeoplePreviewField\"},{\"name\":\"JiraServiceManagementUnknownPreviewField\"}]},{\"kind\":\"UNION\",\"name\":\"JiraServiceManagementResponder\",\"possibleTypes\":[{\"name\":\"JiraServiceManagementUserResponder\"},{\"name\":\"JiraServiceManagementTeamResponder\"}]},{\"kind\":\"UNION\",\"name\":\"JiraShareableEntityEditGrant\",\"possibleTypes\":[{\"name\":\"JiraShareableEntityGroupGrant\"},{\"name\":\"JiraShareableEntityProjectRoleGrant\"},{\"name\":\"JiraShareableEntityUserGrant\"},{\"name\":\"JiraShareableEntityProjectGrant\"},{\"name\":\"JiraShareableEntityUnknownProjectGrant\"}]},{\"kind\":\"UNION\",\"name\":\"JiraShareableEntityShareGrant\",\"possibleTypes\":[{\"name\":\"JiraShareableEntityGroupGrant\"},{\"name\":\"JiraShareableEntityProjectRoleGrant\"},{\"name\":\"JiraShareableEntityProjectGrant\"},{\"name\":\"JiraShareableEntityAnonymousAccessGrant\"},{\"name\":\"JiraShareableEntityAnyLoggedInUserGrant\"},{\"name\":\"JiraShareableEntityUnknownProjectGrant\"},{\"name\":\"JiraShareableEntityUserGrant\"}]},{\"kind\":\"UNION\",\"name\":\"JiraVersionConnectionResult\",\"possibleTypes\":[{\"name\":\"JiraVersionConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraVersionResult\",\"possibleTypes\":[{\"name\":\"JiraVersion\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementActiveBackgroundDetailsResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementColorBackground\"},{\"name\":\"JiraWorkManagementGradientBackground\"},{\"name\":\"JiraWorkManagementMediaBackground\"},{\"name\":\"JiraWorkManagementAttachmentBackground\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementBackgroundUploadTokenResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementBackgroundUploadToken\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementCategoryOptionConnectionResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementCategoryOptionConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementFieldConfigurationConnectionResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementFieldConfigurationConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementFilterConnectionResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementFilterConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementGiraOverviewResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementGiraOverview\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementSavedViewResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementSavedView\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementViewItemConnectionResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementViewItemConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JqlFieldConnectionResult\",\"possibleTypes\":[{\"name\":\"JqlFieldConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JqlHydratedQueryResult\",\"possibleTypes\":[{\"name\":\"JqlHydratedQuery\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JqlQueryHydratedFieldResult\",\"possibleTypes\":[{\"name\":\"JqlQueryHydratedField\"},{\"name\":\"JqlQueryHydratedError\"}]},{\"kind\":\"UNION\",\"name\":\"JqlQueryHydratedValueResult\",\"possibleTypes\":[{\"name\":\"JqlQueryHydratedValue\"},{\"name\":\"JqlQueryHydratedError\"}]},{\"kind\":\"UNION\",\"name\":\"LayoutDefiner\",\"possibleTypes\":[{\"name\":\"FieldLayoutScreen\"},{\"name\":\"JiraRequestType\"}]},{\"kind\":\"UNION\",\"name\":\"MediaUploadTokenUnion\",\"possibleTypes\":[{\"name\":\"MediaUploadToken\"},{\"name\":\"FailedMediaUploadToken\"}]},{\"kind\":\"UNION\",\"name\":\"MergedFieldUnion\",\"possibleTypes\":[{\"name\":\"IssueTypeField\"},{\"name\":\"StatusField\"}]},{\"kind\":\"UNION\",\"name\":\"ProjectCategoryGadgetUnion\",\"possibleTypes\":[{\"name\":\"ProjectsGadgetItem\"},{\"name\":\"CategoriesGadgetItem\"}]},{\"kind\":\"UNION\",\"name\":\"RemoteIssueDetailsUnion\",\"possibleTypes\":[{\"name\":\"AssociatedIssueWrapper\"},{\"name\":\"FailedRemoteIssue\"}]},{\"kind\":\"UNION\",\"name\":\"SectionItem\",\"possibleTypes\":[{\"name\":\"GroupLayout\"},{\"name\":\"TabLayout\"},{\"name\":\"FieldSectionItem\"},{\"name\":\"EcosystemSectionItem\"},{\"name\":\"ForgeSectionItem\"},{\"name\":\"PanelSectionItem\"}]},{\"kind\":\"UNION\",\"name\":\"TimeSeriesChartAdditionalPropertiesUnion\",\"possibleTypes\":[{\"name\":\"CreatedVsResolvedProperties\"}]}]}}");

});

parcelRegister("1ZkL6", function(module, exports) {

$parcel$export(module.exports, "getErrorAnalyticsContext", () => $a205b903a47dbc85$export$bd030713895ed5e2);
$parcel$export(module.exports, "reportErrors", () => $a205b903a47dbc85$export$a78ebe1911f50d41);

var $illlw = parcelRequire("illlw");

var $jlBDe = parcelRequire("jlBDe");

var $guiFP = parcelRequire("guiFP");
const $a205b903a47dbc85$export$15d632fe38832073 = 'giraErrorAnalytics';
const $a205b903a47dbc85$export$fc6a71db0f9a33f9 = (errorAnalytics, context = {})=>({
        ...context,
        [$a205b903a47dbc85$export$15d632fe38832073]: errorAnalytics
    });
const $a205b903a47dbc85$export$bd030713895ed5e2 = (context)=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const errorAnalytics = (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(context, [
        $a205b903a47dbc85$export$15d632fe38832073
    ], undefined);
    if (typeof errorAnalytics === 'object' && typeof errorAnalytics.id === 'string' && (errorAnalytics.packageName === undefined || typeof errorAnalytics.packageName === 'string') && (errorAnalytics.teamName === undefined || typeof errorAnalytics.teamName === 'string') && (errorAnalytics.attributes === undefined || typeof errorAnalytics.attributes === 'object') && (errorAnalytics.sendToPrivacyUnsafeSplunk === undefined || typeof errorAnalytics.sendToPrivacyUnsafeSplunk === 'boolean')) return {
        id: errorAnalytics.id,
        packageName: errorAnalytics.packageName,
        teamName: errorAnalytics.teamName,
        attributes: errorAnalytics.attributes,
        sendToPrivacyUnsafeSplunk: errorAnalytics.sendToPrivacyUnsafeSplunk
    };
    return undefined;
};
const $a205b903a47dbc85$export$a78ebe1911f50d41 = ({ graphQLErrors: graphQLErrors, networkError: networkError, operation: operation })=>{
    const errorAnalytics = $a205b903a47dbc85$export$bd030713895ed5e2(operation.getContext());
    // Refine mixed type to Array | void
    if (graphQLErrors !== undefined && !Array.isArray(graphQLErrors)) return;
    const hasGraphQLError = graphQLErrors !== undefined && graphQLErrors.length > 0;
    const hasNetworkError = networkError !== undefined;
    // Only report errors using the JFE analytics pipeline if analytics context data is defined for the query.
    if (errorAnalytics === undefined || !hasGraphQLError && !hasNetworkError) return;
    const { id: id, packageName: packageName, teamName: teamName, attributes: attributes, sendToPrivacyUnsafeSplunk: sendToPrivacyUnsafeSplunk } = errorAnalytics;
    const error = new (0, $jlBDe.ApolloError)({
        // Above Array.isArray check will refine the type to a read-only array. We need this spread to keep flow happy.
        graphQLErrors: graphQLErrors ? [
            ...graphQLErrors
        ] : undefined,
        networkError: networkError
    });
    const attributesWithOperationName = {
        ...attributes,
        operationName: operation.operationName,
        hasGraphQLError: hasGraphQLError,
        hasNetworkError: hasNetworkError
    };
    (0, $guiFP.default)({
        error: error,
        meta: {
            id: id,
            packageName: packageName,
            teamName: teamName
        },
        attributes: attributesWithOperationName,
        sendToPrivacyUnsafeSplunk: sendToPrivacyUnsafeSplunk
    });
};

});

parcelRegister("9ypom", function(module, exports) {

$parcel$export(module.exports, "default", () => $6f4afc5439e22f0a$export$2e2bcd8739ae039);

var $fKE23 = parcelRequire("fKE23");

var $6ds0g = parcelRequire("6ds0g");
var $6f4afc5439e22f0a$var$docCache = new Map();
var $6f4afc5439e22f0a$var$fragmentSourceMap = new Map();
var $6f4afc5439e22f0a$var$printFragmentWarnings = true;
var $6f4afc5439e22f0a$var$experimentalFragmentVariables = false;
function $6f4afc5439e22f0a$var$normalize(string) {
    return string.replace(/[\s,]+/g, ' ').trim();
}
function $6f4afc5439e22f0a$var$cacheKeyFromLoc(loc) {
    return $6f4afc5439e22f0a$var$normalize(loc.source.body.substring(loc.start, loc.end));
}
function $6f4afc5439e22f0a$var$processFragments(ast) {
    var seenKeys = new Set();
    var definitions = [];
    ast.definitions.forEach(function(fragmentDefinition) {
        if (fragmentDefinition.kind === 'FragmentDefinition') {
            var fragmentName = fragmentDefinition.name.value;
            var sourceKey = $6f4afc5439e22f0a$var$cacheKeyFromLoc(fragmentDefinition.loc);
            var sourceKeySet = $6f4afc5439e22f0a$var$fragmentSourceMap.get(fragmentName);
            if (sourceKeySet && !sourceKeySet.has(sourceKey)) {
                if ($6f4afc5439e22f0a$var$printFragmentWarnings) console.warn("Warning: fragment with name " + fragmentName + " already exists.\n" + "graphql-tag enforces all fragment names across your application to be unique; read more about\n" + "this in the docs: http://dev.apollodata.com/core/fragments.html#unique-names");
            } else if (!sourceKeySet) $6f4afc5439e22f0a$var$fragmentSourceMap.set(fragmentName, sourceKeySet = new Set);
            sourceKeySet.add(sourceKey);
            if (!seenKeys.has(sourceKey)) {
                seenKeys.add(sourceKey);
                definitions.push(fragmentDefinition);
            }
        } else definitions.push(fragmentDefinition);
    });
    return (0, $fKE23.__assign)((0, $fKE23.__assign)({}, ast), {
        definitions: definitions
    });
}
function $6f4afc5439e22f0a$var$stripLoc(doc) {
    var workSet = new Set(doc.definitions);
    workSet.forEach(function(node) {
        if (node.loc) delete node.loc;
        Object.keys(node).forEach(function(key) {
            var value = node[key];
            if (value && typeof value === 'object') workSet.add(value);
        });
    });
    var loc = doc.loc;
    if (loc) {
        delete loc.startToken;
        delete loc.endToken;
    }
    return doc;
}
function $6f4afc5439e22f0a$var$parseDocument(source) {
    var cacheKey = $6f4afc5439e22f0a$var$normalize(source);
    if (!$6f4afc5439e22f0a$var$docCache.has(cacheKey)) {
        var parsed = (0, $6ds0g.parse)(source, {
            experimentalFragmentVariables: $6f4afc5439e22f0a$var$experimentalFragmentVariables,
            allowLegacyFragmentVariables: $6f4afc5439e22f0a$var$experimentalFragmentVariables
        });
        if (!parsed || parsed.kind !== 'Document') throw new Error('Not a valid GraphQL document.');
        $6f4afc5439e22f0a$var$docCache.set(cacheKey, $6f4afc5439e22f0a$var$stripLoc($6f4afc5439e22f0a$var$processFragments(parsed)));
    }
    return $6f4afc5439e22f0a$var$docCache.get(cacheKey);
}
function $6f4afc5439e22f0a$export$72e4926bf8358653(literals) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    if (typeof literals === 'string') literals = [
        literals
    ];
    var result = literals[0];
    args.forEach(function(arg, i) {
        if (arg && arg.kind === 'Document') result += arg.loc.source.body;
        else result += arg;
        result += literals[i + 1];
    });
    return $6f4afc5439e22f0a$var$parseDocument(result);
}
function $6f4afc5439e22f0a$export$657554ef4dc7ac2d() {
    $6f4afc5439e22f0a$var$docCache.clear();
    $6f4afc5439e22f0a$var$fragmentSourceMap.clear();
}
function $6f4afc5439e22f0a$export$e4294e638636c6ab() {
    $6f4afc5439e22f0a$var$printFragmentWarnings = false;
}
function $6f4afc5439e22f0a$export$78cf889af350c840() {
    $6f4afc5439e22f0a$var$experimentalFragmentVariables = true;
}
function $6f4afc5439e22f0a$export$5290df9bbbd3cfa() {
    $6f4afc5439e22f0a$var$experimentalFragmentVariables = false;
}
var $6f4afc5439e22f0a$var$extras = {
    gql: $6f4afc5439e22f0a$export$72e4926bf8358653,
    resetCaches: $6f4afc5439e22f0a$export$657554ef4dc7ac2d,
    disableFragmentWarnings: $6f4afc5439e22f0a$export$e4294e638636c6ab,
    enableExperimentalFragmentVariables: $6f4afc5439e22f0a$export$78cf889af350c840,
    disableExperimentalFragmentVariables: $6f4afc5439e22f0a$export$5290df9bbbd3cfa
};
(function(gql_1) {
    gql_1.gql = $6f4afc5439e22f0a$var$extras.gql, gql_1.resetCaches = $6f4afc5439e22f0a$var$extras.resetCaches, gql_1.disableFragmentWarnings = $6f4afc5439e22f0a$var$extras.disableFragmentWarnings, gql_1.enableExperimentalFragmentVariables = $6f4afc5439e22f0a$var$extras.enableExperimentalFragmentVariables, gql_1.disableExperimentalFragmentVariables = $6f4afc5439e22f0a$var$extras.disableExperimentalFragmentVariables;
})($6f4afc5439e22f0a$export$72e4926bf8358653 || ($6f4afc5439e22f0a$export$72e4926bf8358653 = {}));
$6f4afc5439e22f0a$export$72e4926bf8358653["default"] = $6f4afc5439e22f0a$export$72e4926bf8358653;
var $6f4afc5439e22f0a$export$2e2bcd8739ae039 = $6f4afc5439e22f0a$export$72e4926bf8358653;

});
parcelRegister("6ds0g", function(module, exports) {

$parcel$export(module.exports, "parse", () => $d396d90054ce02d1$export$98e6a39c04603d36);
$parcel$export(module.exports, "parseValue", () => $d396d90054ce02d1$export$5303528d1070ff6f);

var $l48s6 = parcelRequire("l48s6");

var $1c4hI = parcelRequire("1c4hI");

var $c8MIO = parcelRequire("c8MIO");

var $hFu5F = parcelRequire("hFu5F");

var $7vqrl = parcelRequire("7vqrl");

var $5hGV7 = parcelRequire("5hGV7");

var $b5rqB = parcelRequire("b5rqB");
function $d396d90054ce02d1$export$98e6a39c04603d36(source, options) {
    var parser = new $d396d90054ce02d1$export$7acfa6ed01010e37(source, options);
    return parser.parseDocument();
}
function $d396d90054ce02d1$export$5303528d1070ff6f(source, options) {
    var parser = new $d396d90054ce02d1$export$7acfa6ed01010e37(source, options);
    parser.expectToken((0, $hFu5F.TokenKind).SOF);
    var value = parser.parseValueLiteral(false);
    parser.expectToken((0, $hFu5F.TokenKind).EOF);
    return value;
}
function $d396d90054ce02d1$export$28b8f402ccc88182(source, options) {
    var parser = new $d396d90054ce02d1$export$7acfa6ed01010e37(source, options);
    parser.expectToken((0, $hFu5F.TokenKind).SOF);
    var type = parser.parseTypeReference();
    parser.expectToken((0, $hFu5F.TokenKind).EOF);
    return type;
}
var $d396d90054ce02d1$export$7acfa6ed01010e37 = /*#__PURE__*/ function() {
    function Parser(source, options) {
        var sourceObj = (0, $7vqrl.isSource)(source) ? source : new (0, $7vqrl.Source)(source);
        this._lexer = new (0, $b5rqB.Lexer)(sourceObj);
        this._options = options;
    }
    /**
   * Converts a name lex token into a name parse node.
   */ var _proto = Parser.prototype;
    _proto.parseName = function parseName() {
        var token = this.expectToken((0, $hFu5F.TokenKind).NAME);
        return {
            kind: (0, $1c4hI.Kind).NAME,
            value: token.value,
            loc: this.loc(token)
        };
    } // Implements the parsing rules in the Document section.
     /**
   * Document : Definition+
   */ ;
    _proto.parseDocument = function parseDocument() {
        var start = this._lexer.token;
        return {
            kind: (0, $1c4hI.Kind).DOCUMENT,
            definitions: this.many((0, $hFu5F.TokenKind).SOF, this.parseDefinition, (0, $hFu5F.TokenKind).EOF),
            loc: this.loc(start)
        };
    } /**
   * Definition :
   *   - ExecutableDefinition
   *   - TypeSystemDefinition
   *   - TypeSystemExtension
   *
   * ExecutableDefinition :
   *   - OperationDefinition
   *   - FragmentDefinition
   */ ;
    _proto.parseDefinition = function parseDefinition() {
        if (this.peek((0, $hFu5F.TokenKind).NAME)) switch(this._lexer.token.value){
            case 'query':
            case 'mutation':
            case 'subscription':
                return this.parseOperationDefinition();
            case 'fragment':
                return this.parseFragmentDefinition();
            case 'schema':
            case 'scalar':
            case 'type':
            case 'interface':
            case 'union':
            case 'enum':
            case 'input':
            case 'directive':
                return this.parseTypeSystemDefinition();
            case 'extend':
                return this.parseTypeSystemExtension();
        }
        else if (this.peek((0, $hFu5F.TokenKind).BRACE_L)) return this.parseOperationDefinition();
        else if (this.peekDescription()) return this.parseTypeSystemDefinition();
        throw this.unexpected();
    } // Implements the parsing rules in the Operations section.
     /**
   * OperationDefinition :
   *  - SelectionSet
   *  - OperationType Name? VariableDefinitions? Directives? SelectionSet
   */ ;
    _proto.parseOperationDefinition = function parseOperationDefinition() {
        var start = this._lexer.token;
        if (this.peek((0, $hFu5F.TokenKind).BRACE_L)) return {
            kind: (0, $1c4hI.Kind).OPERATION_DEFINITION,
            operation: 'query',
            name: undefined,
            variableDefinitions: [],
            directives: [],
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
        var operation = this.parseOperationType();
        var name;
        if (this.peek((0, $hFu5F.TokenKind).NAME)) name = this.parseName();
        return {
            kind: (0, $1c4hI.Kind).OPERATION_DEFINITION,
            operation: operation,
            name: name,
            variableDefinitions: this.parseVariableDefinitions(),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
    } /**
   * OperationType : one of query mutation subscription
   */ ;
    _proto.parseOperationType = function parseOperationType() {
        var operationToken = this.expectToken((0, $hFu5F.TokenKind).NAME);
        switch(operationToken.value){
            case 'query':
                return 'query';
            case 'mutation':
                return 'mutation';
            case 'subscription':
                return 'subscription';
        }
        throw this.unexpected(operationToken);
    } /**
   * VariableDefinitions : ( VariableDefinition+ )
   */ ;
    _proto.parseVariableDefinitions = function parseVariableDefinitions() {
        return this.optionalMany((0, $hFu5F.TokenKind).PAREN_L, this.parseVariableDefinition, (0, $hFu5F.TokenKind).PAREN_R);
    } /**
   * VariableDefinition : Variable : Type DefaultValue? Directives[Const]?
   */ ;
    _proto.parseVariableDefinition = function parseVariableDefinition() {
        var start = this._lexer.token;
        return {
            kind: (0, $1c4hI.Kind).VARIABLE_DEFINITION,
            variable: this.parseVariable(),
            type: (this.expectToken((0, $hFu5F.TokenKind).COLON), this.parseTypeReference()),
            defaultValue: this.expectOptionalToken((0, $hFu5F.TokenKind).EQUALS) ? this.parseValueLiteral(true) : undefined,
            directives: this.parseDirectives(true),
            loc: this.loc(start)
        };
    } /**
   * Variable : $ Name
   */ ;
    _proto.parseVariable = function parseVariable() {
        var start = this._lexer.token;
        this.expectToken((0, $hFu5F.TokenKind).DOLLAR);
        return {
            kind: (0, $1c4hI.Kind).VARIABLE,
            name: this.parseName(),
            loc: this.loc(start)
        };
    } /**
   * SelectionSet : { Selection+ }
   */ ;
    _proto.parseSelectionSet = function parseSelectionSet() {
        var start = this._lexer.token;
        return {
            kind: (0, $1c4hI.Kind).SELECTION_SET,
            selections: this.many((0, $hFu5F.TokenKind).BRACE_L, this.parseSelection, (0, $hFu5F.TokenKind).BRACE_R),
            loc: this.loc(start)
        };
    } /**
   * Selection :
   *   - Field
   *   - FragmentSpread
   *   - InlineFragment
   */ ;
    _proto.parseSelection = function parseSelection() {
        return this.peek((0, $hFu5F.TokenKind).SPREAD) ? this.parseFragment() : this.parseField();
    } /**
   * Field : Alias? Name Arguments? Directives? SelectionSet?
   *
   * Alias : Name :
   */ ;
    _proto.parseField = function parseField() {
        var start = this._lexer.token;
        var nameOrAlias = this.parseName();
        var alias;
        var name;
        if (this.expectOptionalToken((0, $hFu5F.TokenKind).COLON)) {
            alias = nameOrAlias;
            name = this.parseName();
        } else name = nameOrAlias;
        return {
            kind: (0, $1c4hI.Kind).FIELD,
            alias: alias,
            name: name,
            arguments: this.parseArguments(false),
            directives: this.parseDirectives(false),
            selectionSet: this.peek((0, $hFu5F.TokenKind).BRACE_L) ? this.parseSelectionSet() : undefined,
            loc: this.loc(start)
        };
    } /**
   * Arguments[Const] : ( Argument[?Const]+ )
   */ ;
    _proto.parseArguments = function parseArguments(isConst) {
        var item = isConst ? this.parseConstArgument : this.parseArgument;
        return this.optionalMany((0, $hFu5F.TokenKind).PAREN_L, item, (0, $hFu5F.TokenKind).PAREN_R);
    } /**
   * Argument[Const] : Name : Value[?Const]
   */ ;
    _proto.parseArgument = function parseArgument() {
        var start = this._lexer.token;
        var name = this.parseName();
        this.expectToken((0, $hFu5F.TokenKind).COLON);
        return {
            kind: (0, $1c4hI.Kind).ARGUMENT,
            name: name,
            value: this.parseValueLiteral(false),
            loc: this.loc(start)
        };
    };
    _proto.parseConstArgument = function parseConstArgument() {
        var start = this._lexer.token;
        return {
            kind: (0, $1c4hI.Kind).ARGUMENT,
            name: this.parseName(),
            value: (this.expectToken((0, $hFu5F.TokenKind).COLON), this.parseValueLiteral(true)),
            loc: this.loc(start)
        };
    } // Implements the parsing rules in the Fragments section.
     /**
   * Corresponds to both FragmentSpread and InlineFragment in the spec.
   *
   * FragmentSpread : ... FragmentName Directives?
   *
   * InlineFragment : ... TypeCondition? Directives? SelectionSet
   */ ;
    _proto.parseFragment = function parseFragment() {
        var start = this._lexer.token;
        this.expectToken((0, $hFu5F.TokenKind).SPREAD);
        var hasTypeCondition = this.expectOptionalKeyword('on');
        if (!hasTypeCondition && this.peek((0, $hFu5F.TokenKind).NAME)) return {
            kind: (0, $1c4hI.Kind).FRAGMENT_SPREAD,
            name: this.parseFragmentName(),
            directives: this.parseDirectives(false),
            loc: this.loc(start)
        };
        return {
            kind: (0, $1c4hI.Kind).INLINE_FRAGMENT,
            typeCondition: hasTypeCondition ? this.parseNamedType() : undefined,
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
    } /**
   * FragmentDefinition :
   *   - fragment FragmentName on TypeCondition Directives? SelectionSet
   *
   * TypeCondition : NamedType
   */ ;
    _proto.parseFragmentDefinition = function parseFragmentDefinition() {
        var _this$_options;
        var start = this._lexer.token;
        this.expectKeyword('fragment'); // Experimental support for defining variables within fragments changes
        // the grammar of FragmentDefinition:
        //   - fragment FragmentName VariableDefinitions? on TypeCondition Directives? SelectionSet
        if (((_this$_options = this._options) === null || _this$_options === void 0 ? void 0 : _this$_options.experimentalFragmentVariables) === true) return {
            kind: (0, $1c4hI.Kind).FRAGMENT_DEFINITION,
            name: this.parseFragmentName(),
            variableDefinitions: this.parseVariableDefinitions(),
            typeCondition: (this.expectKeyword('on'), this.parseNamedType()),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
        return {
            kind: (0, $1c4hI.Kind).FRAGMENT_DEFINITION,
            name: this.parseFragmentName(),
            typeCondition: (this.expectKeyword('on'), this.parseNamedType()),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
    } /**
   * FragmentName : Name but not `on`
   */ ;
    _proto.parseFragmentName = function parseFragmentName() {
        if (this._lexer.token.value === 'on') throw this.unexpected();
        return this.parseName();
    } // Implements the parsing rules in the Values section.
     /**
   * Value[Const] :
   *   - [~Const] Variable
   *   - IntValue
   *   - FloatValue
   *   - StringValue
   *   - BooleanValue
   *   - NullValue
   *   - EnumValue
   *   - ListValue[?Const]
   *   - ObjectValue[?Const]
   *
   * BooleanValue : one of `true` `false`
   *
   * NullValue : `null`
   *
   * EnumValue : Name but not `true`, `false` or `null`
   */ ;
    _proto.parseValueLiteral = function parseValueLiteral(isConst) {
        var token = this._lexer.token;
        switch(token.kind){
            case (0, $hFu5F.TokenKind).BRACKET_L:
                return this.parseList(isConst);
            case (0, $hFu5F.TokenKind).BRACE_L:
                return this.parseObject(isConst);
            case (0, $hFu5F.TokenKind).INT:
                this._lexer.advance();
                return {
                    kind: (0, $1c4hI.Kind).INT,
                    value: token.value,
                    loc: this.loc(token)
                };
            case (0, $hFu5F.TokenKind).FLOAT:
                this._lexer.advance();
                return {
                    kind: (0, $1c4hI.Kind).FLOAT,
                    value: token.value,
                    loc: this.loc(token)
                };
            case (0, $hFu5F.TokenKind).STRING:
            case (0, $hFu5F.TokenKind).BLOCK_STRING:
                return this.parseStringLiteral();
            case (0, $hFu5F.TokenKind).NAME:
                this._lexer.advance();
                switch(token.value){
                    case 'true':
                        return {
                            kind: (0, $1c4hI.Kind).BOOLEAN,
                            value: true,
                            loc: this.loc(token)
                        };
                    case 'false':
                        return {
                            kind: (0, $1c4hI.Kind).BOOLEAN,
                            value: false,
                            loc: this.loc(token)
                        };
                    case 'null':
                        return {
                            kind: (0, $1c4hI.Kind).NULL,
                            loc: this.loc(token)
                        };
                    default:
                        return {
                            kind: (0, $1c4hI.Kind).ENUM,
                            value: token.value,
                            loc: this.loc(token)
                        };
                }
            case (0, $hFu5F.TokenKind).DOLLAR:
                if (!isConst) return this.parseVariable();
                break;
        }
        throw this.unexpected();
    };
    _proto.parseStringLiteral = function parseStringLiteral() {
        var token = this._lexer.token;
        this._lexer.advance();
        return {
            kind: (0, $1c4hI.Kind).STRING,
            value: token.value,
            block: token.kind === (0, $hFu5F.TokenKind).BLOCK_STRING,
            loc: this.loc(token)
        };
    } /**
   * ListValue[Const] :
   *   - [ ]
   *   - [ Value[?Const]+ ]
   */ ;
    _proto.parseList = function parseList(isConst) {
        var _this = this;
        var start = this._lexer.token;
        var item = function item() {
            return _this.parseValueLiteral(isConst);
        };
        return {
            kind: (0, $1c4hI.Kind).LIST,
            values: this.any((0, $hFu5F.TokenKind).BRACKET_L, item, (0, $hFu5F.TokenKind).BRACKET_R),
            loc: this.loc(start)
        };
    } /**
   * ObjectValue[Const] :
   *   - { }
   *   - { ObjectField[?Const]+ }
   */ ;
    _proto.parseObject = function parseObject(isConst) {
        var _this2 = this;
        var start = this._lexer.token;
        var item = function item() {
            return _this2.parseObjectField(isConst);
        };
        return {
            kind: (0, $1c4hI.Kind).OBJECT,
            fields: this.any((0, $hFu5F.TokenKind).BRACE_L, item, (0, $hFu5F.TokenKind).BRACE_R),
            loc: this.loc(start)
        };
    } /**
   * ObjectField[Const] : Name : Value[?Const]
   */ ;
    _proto.parseObjectField = function parseObjectField(isConst) {
        var start = this._lexer.token;
        var name = this.parseName();
        this.expectToken((0, $hFu5F.TokenKind).COLON);
        return {
            kind: (0, $1c4hI.Kind).OBJECT_FIELD,
            name: name,
            value: this.parseValueLiteral(isConst),
            loc: this.loc(start)
        };
    } // Implements the parsing rules in the Directives section.
     /**
   * Directives[Const] : Directive[?Const]+
   */ ;
    _proto.parseDirectives = function parseDirectives(isConst) {
        var directives = [];
        while(this.peek((0, $hFu5F.TokenKind).AT))directives.push(this.parseDirective(isConst));
        return directives;
    } /**
   * Directive[Const] : @ Name Arguments[?Const]?
   */ ;
    _proto.parseDirective = function parseDirective(isConst) {
        var start = this._lexer.token;
        this.expectToken((0, $hFu5F.TokenKind).AT);
        return {
            kind: (0, $1c4hI.Kind).DIRECTIVE,
            name: this.parseName(),
            arguments: this.parseArguments(isConst),
            loc: this.loc(start)
        };
    } // Implements the parsing rules in the Types section.
     /**
   * Type :
   *   - NamedType
   *   - ListType
   *   - NonNullType
   */ ;
    _proto.parseTypeReference = function parseTypeReference() {
        var start = this._lexer.token;
        var type;
        if (this.expectOptionalToken((0, $hFu5F.TokenKind).BRACKET_L)) {
            type = this.parseTypeReference();
            this.expectToken((0, $hFu5F.TokenKind).BRACKET_R);
            type = {
                kind: (0, $1c4hI.Kind).LIST_TYPE,
                type: type,
                loc: this.loc(start)
            };
        } else type = this.parseNamedType();
        if (this.expectOptionalToken((0, $hFu5F.TokenKind).BANG)) return {
            kind: (0, $1c4hI.Kind).NON_NULL_TYPE,
            type: type,
            loc: this.loc(start)
        };
        return type;
    } /**
   * NamedType : Name
   */ ;
    _proto.parseNamedType = function parseNamedType() {
        var start = this._lexer.token;
        return {
            kind: (0, $1c4hI.Kind).NAMED_TYPE,
            name: this.parseName(),
            loc: this.loc(start)
        };
    } // Implements the parsing rules in the Type Definition section.
     /**
   * TypeSystemDefinition :
   *   - SchemaDefinition
   *   - TypeDefinition
   *   - DirectiveDefinition
   *
   * TypeDefinition :
   *   - ScalarTypeDefinition
   *   - ObjectTypeDefinition
   *   - InterfaceTypeDefinition
   *   - UnionTypeDefinition
   *   - EnumTypeDefinition
   *   - InputObjectTypeDefinition
   */ ;
    _proto.parseTypeSystemDefinition = function parseTypeSystemDefinition() {
        // Many definitions begin with a description and require a lookahead.
        var keywordToken = this.peekDescription() ? this._lexer.lookahead() : this._lexer.token;
        if (keywordToken.kind === (0, $hFu5F.TokenKind).NAME) switch(keywordToken.value){
            case 'schema':
                return this.parseSchemaDefinition();
            case 'scalar':
                return this.parseScalarTypeDefinition();
            case 'type':
                return this.parseObjectTypeDefinition();
            case 'interface':
                return this.parseInterfaceTypeDefinition();
            case 'union':
                return this.parseUnionTypeDefinition();
            case 'enum':
                return this.parseEnumTypeDefinition();
            case 'input':
                return this.parseInputObjectTypeDefinition();
            case 'directive':
                return this.parseDirectiveDefinition();
        }
        throw this.unexpected(keywordToken);
    };
    _proto.peekDescription = function peekDescription() {
        return this.peek((0, $hFu5F.TokenKind).STRING) || this.peek((0, $hFu5F.TokenKind).BLOCK_STRING);
    } /**
   * Description : StringValue
   */ ;
    _proto.parseDescription = function parseDescription() {
        if (this.peekDescription()) return this.parseStringLiteral();
    } /**
   * SchemaDefinition : Description? schema Directives[Const]? { OperationTypeDefinition+ }
   */ ;
    _proto.parseSchemaDefinition = function parseSchemaDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('schema');
        var directives = this.parseDirectives(true);
        var operationTypes = this.many((0, $hFu5F.TokenKind).BRACE_L, this.parseOperationTypeDefinition, (0, $hFu5F.TokenKind).BRACE_R);
        return {
            kind: (0, $1c4hI.Kind).SCHEMA_DEFINITION,
            description: description,
            directives: directives,
            operationTypes: operationTypes,
            loc: this.loc(start)
        };
    } /**
   * OperationTypeDefinition : OperationType : NamedType
   */ ;
    _proto.parseOperationTypeDefinition = function parseOperationTypeDefinition() {
        var start = this._lexer.token;
        var operation = this.parseOperationType();
        this.expectToken((0, $hFu5F.TokenKind).COLON);
        var type = this.parseNamedType();
        return {
            kind: (0, $1c4hI.Kind).OPERATION_TYPE_DEFINITION,
            operation: operation,
            type: type,
            loc: this.loc(start)
        };
    } /**
   * ScalarTypeDefinition : Description? scalar Name Directives[Const]?
   */ ;
    _proto.parseScalarTypeDefinition = function parseScalarTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('scalar');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        return {
            kind: (0, $1c4hI.Kind).SCALAR_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            loc: this.loc(start)
        };
    } /**
   * ObjectTypeDefinition :
   *   Description?
   *   type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition?
   */ ;
    _proto.parseObjectTypeDefinition = function parseObjectTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('type');
        var name = this.parseName();
        var interfaces = this.parseImplementsInterfaces();
        var directives = this.parseDirectives(true);
        var fields = this.parseFieldsDefinition();
        return {
            kind: (0, $1c4hI.Kind).OBJECT_TYPE_DEFINITION,
            description: description,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    } /**
   * ImplementsInterfaces :
   *   - implements `&`? NamedType
   *   - ImplementsInterfaces & NamedType
   */ ;
    _proto.parseImplementsInterfaces = function parseImplementsInterfaces() {
        var _this$_options2;
        if (!this.expectOptionalKeyword('implements')) return [];
        if (((_this$_options2 = this._options) === null || _this$_options2 === void 0 ? void 0 : _this$_options2.allowLegacySDLImplementsInterfaces) === true) {
            var types = []; // Optional leading ampersand
            this.expectOptionalToken((0, $hFu5F.TokenKind).AMP);
            do types.push(this.parseNamedType());
            while (this.expectOptionalToken((0, $hFu5F.TokenKind).AMP) || this.peek((0, $hFu5F.TokenKind).NAME));
            return types;
        }
        return this.delimitedMany((0, $hFu5F.TokenKind).AMP, this.parseNamedType);
    } /**
   * FieldsDefinition : { FieldDefinition+ }
   */ ;
    _proto.parseFieldsDefinition = function parseFieldsDefinition() {
        var _this$_options3;
        // Legacy support for the SDL?
        if (((_this$_options3 = this._options) === null || _this$_options3 === void 0 ? void 0 : _this$_options3.allowLegacySDLEmptyFields) === true && this.peek((0, $hFu5F.TokenKind).BRACE_L) && this._lexer.lookahead().kind === (0, $hFu5F.TokenKind).BRACE_R) {
            this._lexer.advance();
            this._lexer.advance();
            return [];
        }
        return this.optionalMany((0, $hFu5F.TokenKind).BRACE_L, this.parseFieldDefinition, (0, $hFu5F.TokenKind).BRACE_R);
    } /**
   * FieldDefinition :
   *   - Description? Name ArgumentsDefinition? : Type Directives[Const]?
   */ ;
    _proto.parseFieldDefinition = function parseFieldDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        var name = this.parseName();
        var args = this.parseArgumentDefs();
        this.expectToken((0, $hFu5F.TokenKind).COLON);
        var type = this.parseTypeReference();
        var directives = this.parseDirectives(true);
        return {
            kind: (0, $1c4hI.Kind).FIELD_DEFINITION,
            description: description,
            name: name,
            arguments: args,
            type: type,
            directives: directives,
            loc: this.loc(start)
        };
    } /**
   * ArgumentsDefinition : ( InputValueDefinition+ )
   */ ;
    _proto.parseArgumentDefs = function parseArgumentDefs() {
        return this.optionalMany((0, $hFu5F.TokenKind).PAREN_L, this.parseInputValueDef, (0, $hFu5F.TokenKind).PAREN_R);
    } /**
   * InputValueDefinition :
   *   - Description? Name : Type DefaultValue? Directives[Const]?
   */ ;
    _proto.parseInputValueDef = function parseInputValueDef() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        var name = this.parseName();
        this.expectToken((0, $hFu5F.TokenKind).COLON);
        var type = this.parseTypeReference();
        var defaultValue;
        if (this.expectOptionalToken((0, $hFu5F.TokenKind).EQUALS)) defaultValue = this.parseValueLiteral(true);
        var directives = this.parseDirectives(true);
        return {
            kind: (0, $1c4hI.Kind).INPUT_VALUE_DEFINITION,
            description: description,
            name: name,
            type: type,
            defaultValue: defaultValue,
            directives: directives,
            loc: this.loc(start)
        };
    } /**
   * InterfaceTypeDefinition :
   *   - Description? interface Name Directives[Const]? FieldsDefinition?
   */ ;
    _proto.parseInterfaceTypeDefinition = function parseInterfaceTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('interface');
        var name = this.parseName();
        var interfaces = this.parseImplementsInterfaces();
        var directives = this.parseDirectives(true);
        var fields = this.parseFieldsDefinition();
        return {
            kind: (0, $1c4hI.Kind).INTERFACE_TYPE_DEFINITION,
            description: description,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    } /**
   * UnionTypeDefinition :
   *   - Description? union Name Directives[Const]? UnionMemberTypes?
   */ ;
    _proto.parseUnionTypeDefinition = function parseUnionTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('union');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var types = this.parseUnionMemberTypes();
        return {
            kind: (0, $1c4hI.Kind).UNION_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            types: types,
            loc: this.loc(start)
        };
    } /**
   * UnionMemberTypes :
   *   - = `|`? NamedType
   *   - UnionMemberTypes | NamedType
   */ ;
    _proto.parseUnionMemberTypes = function parseUnionMemberTypes() {
        return this.expectOptionalToken((0, $hFu5F.TokenKind).EQUALS) ? this.delimitedMany((0, $hFu5F.TokenKind).PIPE, this.parseNamedType) : [];
    } /**
   * EnumTypeDefinition :
   *   - Description? enum Name Directives[Const]? EnumValuesDefinition?
   */ ;
    _proto.parseEnumTypeDefinition = function parseEnumTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('enum');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var values = this.parseEnumValuesDefinition();
        return {
            kind: (0, $1c4hI.Kind).ENUM_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            values: values,
            loc: this.loc(start)
        };
    } /**
   * EnumValuesDefinition : { EnumValueDefinition+ }
   */ ;
    _proto.parseEnumValuesDefinition = function parseEnumValuesDefinition() {
        return this.optionalMany((0, $hFu5F.TokenKind).BRACE_L, this.parseEnumValueDefinition, (0, $hFu5F.TokenKind).BRACE_R);
    } /**
   * EnumValueDefinition : Description? EnumValue Directives[Const]?
   *
   * EnumValue : Name
   */ ;
    _proto.parseEnumValueDefinition = function parseEnumValueDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        return {
            kind: (0, $1c4hI.Kind).ENUM_VALUE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            loc: this.loc(start)
        };
    } /**
   * InputObjectTypeDefinition :
   *   - Description? input Name Directives[Const]? InputFieldsDefinition?
   */ ;
    _proto.parseInputObjectTypeDefinition = function parseInputObjectTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('input');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var fields = this.parseInputFieldsDefinition();
        return {
            kind: (0, $1c4hI.Kind).INPUT_OBJECT_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    } /**
   * InputFieldsDefinition : { InputValueDefinition+ }
   */ ;
    _proto.parseInputFieldsDefinition = function parseInputFieldsDefinition() {
        return this.optionalMany((0, $hFu5F.TokenKind).BRACE_L, this.parseInputValueDef, (0, $hFu5F.TokenKind).BRACE_R);
    } /**
   * TypeSystemExtension :
   *   - SchemaExtension
   *   - TypeExtension
   *
   * TypeExtension :
   *   - ScalarTypeExtension
   *   - ObjectTypeExtension
   *   - InterfaceTypeExtension
   *   - UnionTypeExtension
   *   - EnumTypeExtension
   *   - InputObjectTypeDefinition
   */ ;
    _proto.parseTypeSystemExtension = function parseTypeSystemExtension() {
        var keywordToken = this._lexer.lookahead();
        if (keywordToken.kind === (0, $hFu5F.TokenKind).NAME) switch(keywordToken.value){
            case 'schema':
                return this.parseSchemaExtension();
            case 'scalar':
                return this.parseScalarTypeExtension();
            case 'type':
                return this.parseObjectTypeExtension();
            case 'interface':
                return this.parseInterfaceTypeExtension();
            case 'union':
                return this.parseUnionTypeExtension();
            case 'enum':
                return this.parseEnumTypeExtension();
            case 'input':
                return this.parseInputObjectTypeExtension();
        }
        throw this.unexpected(keywordToken);
    } /**
   * SchemaExtension :
   *  - extend schema Directives[Const]? { OperationTypeDefinition+ }
   *  - extend schema Directives[Const]
   */ ;
    _proto.parseSchemaExtension = function parseSchemaExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('schema');
        var directives = this.parseDirectives(true);
        var operationTypes = this.optionalMany((0, $hFu5F.TokenKind).BRACE_L, this.parseOperationTypeDefinition, (0, $hFu5F.TokenKind).BRACE_R);
        if (directives.length === 0 && operationTypes.length === 0) throw this.unexpected();
        return {
            kind: (0, $1c4hI.Kind).SCHEMA_EXTENSION,
            directives: directives,
            operationTypes: operationTypes,
            loc: this.loc(start)
        };
    } /**
   * ScalarTypeExtension :
   *   - extend scalar Name Directives[Const]
   */ ;
    _proto.parseScalarTypeExtension = function parseScalarTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('scalar');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        if (directives.length === 0) throw this.unexpected();
        return {
            kind: (0, $1c4hI.Kind).SCALAR_TYPE_EXTENSION,
            name: name,
            directives: directives,
            loc: this.loc(start)
        };
    } /**
   * ObjectTypeExtension :
   *  - extend type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend type Name ImplementsInterfaces? Directives[Const]
   *  - extend type Name ImplementsInterfaces
   */ ;
    _proto.parseObjectTypeExtension = function parseObjectTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('type');
        var name = this.parseName();
        var interfaces = this.parseImplementsInterfaces();
        var directives = this.parseDirectives(true);
        var fields = this.parseFieldsDefinition();
        if (interfaces.length === 0 && directives.length === 0 && fields.length === 0) throw this.unexpected();
        return {
            kind: (0, $1c4hI.Kind).OBJECT_TYPE_EXTENSION,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    } /**
   * InterfaceTypeExtension :
   *  - extend interface Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend interface Name ImplementsInterfaces? Directives[Const]
   *  - extend interface Name ImplementsInterfaces
   */ ;
    _proto.parseInterfaceTypeExtension = function parseInterfaceTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('interface');
        var name = this.parseName();
        var interfaces = this.parseImplementsInterfaces();
        var directives = this.parseDirectives(true);
        var fields = this.parseFieldsDefinition();
        if (interfaces.length === 0 && directives.length === 0 && fields.length === 0) throw this.unexpected();
        return {
            kind: (0, $1c4hI.Kind).INTERFACE_TYPE_EXTENSION,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    } /**
   * UnionTypeExtension :
   *   - extend union Name Directives[Const]? UnionMemberTypes
   *   - extend union Name Directives[Const]
   */ ;
    _proto.parseUnionTypeExtension = function parseUnionTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('union');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var types = this.parseUnionMemberTypes();
        if (directives.length === 0 && types.length === 0) throw this.unexpected();
        return {
            kind: (0, $1c4hI.Kind).UNION_TYPE_EXTENSION,
            name: name,
            directives: directives,
            types: types,
            loc: this.loc(start)
        };
    } /**
   * EnumTypeExtension :
   *   - extend enum Name Directives[Const]? EnumValuesDefinition
   *   - extend enum Name Directives[Const]
   */ ;
    _proto.parseEnumTypeExtension = function parseEnumTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('enum');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var values = this.parseEnumValuesDefinition();
        if (directives.length === 0 && values.length === 0) throw this.unexpected();
        return {
            kind: (0, $1c4hI.Kind).ENUM_TYPE_EXTENSION,
            name: name,
            directives: directives,
            values: values,
            loc: this.loc(start)
        };
    } /**
   * InputObjectTypeExtension :
   *   - extend input Name Directives[Const]? InputFieldsDefinition
   *   - extend input Name Directives[Const]
   */ ;
    _proto.parseInputObjectTypeExtension = function parseInputObjectTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('input');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var fields = this.parseInputFieldsDefinition();
        if (directives.length === 0 && fields.length === 0) throw this.unexpected();
        return {
            kind: (0, $1c4hI.Kind).INPUT_OBJECT_TYPE_EXTENSION,
            name: name,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    } /**
   * DirectiveDefinition :
   *   - Description? directive @ Name ArgumentsDefinition? `repeatable`? on DirectiveLocations
   */ ;
    _proto.parseDirectiveDefinition = function parseDirectiveDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('directive');
        this.expectToken((0, $hFu5F.TokenKind).AT);
        var name = this.parseName();
        var args = this.parseArgumentDefs();
        var repeatable = this.expectOptionalKeyword('repeatable');
        this.expectKeyword('on');
        var locations = this.parseDirectiveLocations();
        return {
            kind: (0, $1c4hI.Kind).DIRECTIVE_DEFINITION,
            description: description,
            name: name,
            arguments: args,
            repeatable: repeatable,
            locations: locations,
            loc: this.loc(start)
        };
    } /**
   * DirectiveLocations :
   *   - `|`? DirectiveLocation
   *   - DirectiveLocations | DirectiveLocation
   */ ;
    _proto.parseDirectiveLocations = function parseDirectiveLocations() {
        return this.delimitedMany((0, $hFu5F.TokenKind).PIPE, this.parseDirectiveLocation);
    } /*
   * DirectiveLocation :
   *   - ExecutableDirectiveLocation
   *   - TypeSystemDirectiveLocation
   *
   * ExecutableDirectiveLocation : one of
   *   `QUERY`
   *   `MUTATION`
   *   `SUBSCRIPTION`
   *   `FIELD`
   *   `FRAGMENT_DEFINITION`
   *   `FRAGMENT_SPREAD`
   *   `INLINE_FRAGMENT`
   *
   * TypeSystemDirectiveLocation : one of
   *   `SCHEMA`
   *   `SCALAR`
   *   `OBJECT`
   *   `FIELD_DEFINITION`
   *   `ARGUMENT_DEFINITION`
   *   `INTERFACE`
   *   `UNION`
   *   `ENUM`
   *   `ENUM_VALUE`
   *   `INPUT_OBJECT`
   *   `INPUT_FIELD_DEFINITION`
   */ ;
    _proto.parseDirectiveLocation = function parseDirectiveLocation() {
        var start = this._lexer.token;
        var name = this.parseName();
        if ((0, $5hGV7.DirectiveLocation)[name.value] !== undefined) return name;
        throw this.unexpected(start);
    } // Core parsing utility functions
     /**
   * Returns a location object, used to identify the place in the source that created a given parsed object.
   */ ;
    _proto.loc = function loc(startToken) {
        var _this$_options4;
        if (((_this$_options4 = this._options) === null || _this$_options4 === void 0 ? void 0 : _this$_options4.noLocation) !== true) return new (0, $c8MIO.Location)(startToken, this._lexer.lastToken, this._lexer.source);
    } /**
   * Determines if the next token is of a given kind
   */ ;
    _proto.peek = function peek(kind) {
        return this._lexer.token.kind === kind;
    } /**
   * If the next token is of the given kind, return that token after advancing the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */ ;
    _proto.expectToken = function expectToken(kind) {
        var token = this._lexer.token;
        if (token.kind === kind) {
            this._lexer.advance();
            return token;
        }
        throw (0, $l48s6.syntaxError)(this._lexer.source, token.start, "Expected ".concat($d396d90054ce02d1$var$getTokenKindDesc(kind), ", found ").concat($d396d90054ce02d1$var$getTokenDesc(token), "."));
    } /**
   * If the next token is of the given kind, return that token after advancing the lexer.
   * Otherwise, do not change the parser state and return undefined.
   */ ;
    _proto.expectOptionalToken = function expectOptionalToken(kind) {
        var token = this._lexer.token;
        if (token.kind === kind) {
            this._lexer.advance();
            return token;
        }
        return undefined;
    } /**
   * If the next token is a given keyword, advance the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */ ;
    _proto.expectKeyword = function expectKeyword(value) {
        var token = this._lexer.token;
        if (token.kind === (0, $hFu5F.TokenKind).NAME && token.value === value) this._lexer.advance();
        else throw (0, $l48s6.syntaxError)(this._lexer.source, token.start, "Expected \"".concat(value, "\", found ").concat($d396d90054ce02d1$var$getTokenDesc(token), "."));
    } /**
   * If the next token is a given keyword, return "true" after advancing the lexer.
   * Otherwise, do not change the parser state and return "false".
   */ ;
    _proto.expectOptionalKeyword = function expectOptionalKeyword(value) {
        var token = this._lexer.token;
        if (token.kind === (0, $hFu5F.TokenKind).NAME && token.value === value) {
            this._lexer.advance();
            return true;
        }
        return false;
    } /**
   * Helper function for creating an error when an unexpected lexed token is encountered.
   */ ;
    _proto.unexpected = function unexpected(atToken) {
        var token = atToken !== null && atToken !== void 0 ? atToken : this._lexer.token;
        return (0, $l48s6.syntaxError)(this._lexer.source, token.start, "Unexpected ".concat($d396d90054ce02d1$var$getTokenDesc(token), "."));
    } /**
   * Returns a possibly empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */ ;
    _proto.any = function any(openKind, parseFn, closeKind) {
        this.expectToken(openKind);
        var nodes = [];
        while(!this.expectOptionalToken(closeKind))nodes.push(parseFn.call(this));
        return nodes;
    } /**
   * Returns a list of parse nodes, determined by the parseFn.
   * It can be empty only if open token is missing otherwise it will always return non-empty list
   * that begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */ ;
    _proto.optionalMany = function optionalMany(openKind, parseFn, closeKind) {
        if (this.expectOptionalToken(openKind)) {
            var nodes = [];
            do nodes.push(parseFn.call(this));
            while (!this.expectOptionalToken(closeKind));
            return nodes;
        }
        return [];
    } /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */ ;
    _proto.many = function many(openKind, parseFn, closeKind) {
        this.expectToken(openKind);
        var nodes = [];
        do nodes.push(parseFn.call(this));
        while (!this.expectOptionalToken(closeKind));
        return nodes;
    } /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list may begin with a lex token of delimiterKind followed by items separated by lex tokens of tokenKind.
   * Advances the parser to the next lex token after last item in the list.
   */ ;
    _proto.delimitedMany = function delimitedMany(delimiterKind, parseFn) {
        this.expectOptionalToken(delimiterKind);
        var nodes = [];
        do nodes.push(parseFn.call(this));
        while (this.expectOptionalToken(delimiterKind));
        return nodes;
    };
    return Parser;
}();
/**
 * A helper function to describe a token as a string for debugging.
 */ function $d396d90054ce02d1$var$getTokenDesc(token) {
    var value = token.value;
    return $d396d90054ce02d1$var$getTokenKindDesc(token.kind) + (value != null ? " \"".concat(value, "\"") : '');
}
/**
 * A helper function to describe a token kind as a string for debugging.
 */ function $d396d90054ce02d1$var$getTokenKindDesc(kind) {
    return (0, $b5rqB.isPunctuatorTokenKind)(kind) ? "\"".concat(kind, "\"") : kind;
}

});
parcelRegister("l48s6", function(module, exports) {

$parcel$export(module.exports, "syntaxError", () => $6cdd0c9c097dfc31$export$bbee0c6176c019d4);

var $9fgMZ = parcelRequire("9fgMZ");
function $6cdd0c9c097dfc31$export$bbee0c6176c019d4(source, position, description) {
    return new (0, $9fgMZ.GraphQLError)("Syntax Error: ".concat(description), undefined, source, [
        position
    ]);
}

});
parcelRegister("9fgMZ", function(module, exports) {

$parcel$export(module.exports, "GraphQLError", () => $20ec348cfe64bfcc$export$92d6ed0888e7cb7f);

var $fbtyx = parcelRequire("fbtyx");

var $gwa3m = parcelRequire("gwa3m");

var $cBRMW = parcelRequire("cBRMW");

var $5LGuP = parcelRequire("5LGuP");
function $20ec348cfe64bfcc$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $20ec348cfe64bfcc$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $20ec348cfe64bfcc$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $20ec348cfe64bfcc$var$_typeof(obj);
}
function $20ec348cfe64bfcc$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $20ec348cfe64bfcc$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $20ec348cfe64bfcc$var$ownKeys(Object(source), true).forEach(function(key) {
            $20ec348cfe64bfcc$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $20ec348cfe64bfcc$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $20ec348cfe64bfcc$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $20ec348cfe64bfcc$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $20ec348cfe64bfcc$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $20ec348cfe64bfcc$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $20ec348cfe64bfcc$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $20ec348cfe64bfcc$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $20ec348cfe64bfcc$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $20ec348cfe64bfcc$var$_setPrototypeOf(subClass, superClass);
}
function $20ec348cfe64bfcc$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $20ec348cfe64bfcc$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $20ec348cfe64bfcc$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $20ec348cfe64bfcc$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $20ec348cfe64bfcc$var$_possibleConstructorReturn(this, result);
    };
}
function $20ec348cfe64bfcc$var$_possibleConstructorReturn(self, call) {
    if (call && ($20ec348cfe64bfcc$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $20ec348cfe64bfcc$var$_assertThisInitialized(self);
}
function $20ec348cfe64bfcc$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $20ec348cfe64bfcc$var$_wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $20ec348cfe64bfcc$var$_wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !$20ec348cfe64bfcc$var$_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return $20ec348cfe64bfcc$var$_construct(Class, arguments, $20ec348cfe64bfcc$var$_getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return $20ec348cfe64bfcc$var$_setPrototypeOf(Wrapper, Class);
    };
    return $20ec348cfe64bfcc$var$_wrapNativeSuper(Class);
}
function $20ec348cfe64bfcc$var$_construct(Parent, args, Class) {
    if ($20ec348cfe64bfcc$var$_isNativeReflectConstruct()) $20ec348cfe64bfcc$var$_construct = Reflect.construct;
    else $20ec348cfe64bfcc$var$_construct = function _construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) $20ec348cfe64bfcc$var$_setPrototypeOf(instance, Class.prototype);
        return instance;
    };
    return $20ec348cfe64bfcc$var$_construct.apply(null, arguments);
}
function $20ec348cfe64bfcc$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $20ec348cfe64bfcc$var$_isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function $20ec348cfe64bfcc$var$_setPrototypeOf(o, p) {
    $20ec348cfe64bfcc$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $20ec348cfe64bfcc$var$_setPrototypeOf(o, p);
}
function $20ec348cfe64bfcc$var$_getPrototypeOf(o) {
    $20ec348cfe64bfcc$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $20ec348cfe64bfcc$var$_getPrototypeOf(o);
}
var $20ec348cfe64bfcc$export$92d6ed0888e7cb7f = /*#__PURE__*/ function(_Error) {
    $20ec348cfe64bfcc$var$_inherits(GraphQLError, _Error);
    var _super = $20ec348cfe64bfcc$var$_createSuper(GraphQLError);
    /**
   * An array of { line, column } locations within the source GraphQL document
   * which correspond to this error.
   *
   * Errors during validation often contain multiple locations, for example to
   * point out two things with the same name. Errors during execution include a
   * single location, the field which produced the error.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */ /**
   * An array describing the JSON-path into the execution response which
   * corresponds to this error. Only included for errors during execution.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */ /**
   * An array of GraphQL AST Nodes corresponding to this error.
   */ /**
   * The source GraphQL document for the first location of this error.
   *
   * Note that if this Error represents more than one node, the source may not
   * represent nodes after the first node.
   */ /**
   * An array of character offsets within the source GraphQL document
   * which correspond to this error.
   */ /**
   * The original error thrown from a field resolver during execution.
   */ /**
   * Extension fields to add to the formatted error.
   */ function GraphQLError(message, nodes, source, positions, path, originalError, extensions) {
        var _nodeLocations, _nodeLocations2, _nodeLocations3;
        var _this;
        $20ec348cfe64bfcc$var$_classCallCheck(this, GraphQLError);
        _this = _super.call(this, message);
        _this.name = 'GraphQLError';
        _this.originalError = originalError !== null && originalError !== void 0 ? originalError : undefined; // Compute list of blame nodes.
        _this.nodes = $20ec348cfe64bfcc$var$undefinedIfEmpty(Array.isArray(nodes) ? nodes : nodes ? [
            nodes
        ] : undefined);
        var nodeLocations = [];
        for(var _i2 = 0, _ref3 = (_this$nodes = _this.nodes) !== null && _this$nodes !== void 0 ? _this$nodes : []; _i2 < _ref3.length; _i2++){
            var _this$nodes;
            var _ref4 = _ref3[_i2];
            var loc = _ref4.loc;
            if (loc != null) nodeLocations.push(loc);
        }
        nodeLocations = $20ec348cfe64bfcc$var$undefinedIfEmpty(nodeLocations); // Compute locations in the source for the given nodes/positions.
        _this.source = source !== null && source !== void 0 ? source : (_nodeLocations = nodeLocations) === null || _nodeLocations === void 0 ? void 0 : _nodeLocations[0].source;
        _this.positions = positions !== null && positions !== void 0 ? positions : (_nodeLocations2 = nodeLocations) === null || _nodeLocations2 === void 0 ? void 0 : _nodeLocations2.map(function(loc) {
            return loc.start;
        });
        _this.locations = positions && source ? positions.map(function(pos) {
            return (0, $cBRMW.getLocation)(source, pos);
        }) : (_nodeLocations3 = nodeLocations) === null || _nodeLocations3 === void 0 ? void 0 : _nodeLocations3.map(function(loc) {
            return (0, $cBRMW.getLocation)(loc.source, loc.start);
        });
        _this.path = path !== null && path !== void 0 ? path : undefined;
        var originalExtensions = originalError === null || originalError === void 0 ? void 0 : originalError.extensions;
        if (extensions == null && (0, $fbtyx.default)(originalExtensions)) _this.extensions = $20ec348cfe64bfcc$var$_objectSpread({}, originalExtensions);
        else _this.extensions = extensions !== null && extensions !== void 0 ? extensions : {};
         // By being enumerable, JSON.stringify will include bellow properties in the resulting output.
        // This ensures that the simplest possible GraphQL service adheres to the spec.
        Object.defineProperties($20ec348cfe64bfcc$var$_assertThisInitialized(_this), {
            message: {
                enumerable: true
            },
            locations: {
                enumerable: _this.locations != null
            },
            path: {
                enumerable: _this.path != null
            },
            extensions: {
                enumerable: _this.extensions != null && Object.keys(_this.extensions).length > 0
            },
            name: {
                enumerable: false
            },
            nodes: {
                enumerable: false
            },
            source: {
                enumerable: false
            },
            positions: {
                enumerable: false
            },
            originalError: {
                enumerable: false
            }
        }); // Include (non-enumerable) stack trace.
        if (originalError !== null && originalError !== void 0 && originalError.stack) {
            Object.defineProperty($20ec348cfe64bfcc$var$_assertThisInitialized(_this), 'stack', {
                value: originalError.stack,
                writable: true,
                configurable: true
            });
            return $20ec348cfe64bfcc$var$_possibleConstructorReturn(_this);
        } // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
        if (Error.captureStackTrace) Error.captureStackTrace($20ec348cfe64bfcc$var$_assertThisInitialized(_this), GraphQLError);
        else Object.defineProperty($20ec348cfe64bfcc$var$_assertThisInitialized(_this), 'stack', {
            value: Error().stack,
            writable: true,
            configurable: true
        });
        return _this;
    }
    $20ec348cfe64bfcc$var$_createClass(GraphQLError, [
        {
            key: "toString",
            value: function toString() {
                return $20ec348cfe64bfcc$export$55ee1551a3f962e6(this);
            } // FIXME: workaround to not break chai comparisons, should be remove in v16
        },
        {
            key: (0, $gwa3m.SYMBOL_TO_STRING_TAG),
            get: function get() {
                return 'Object';
            }
        }
    ]);
    return GraphQLError;
}(/*#__PURE__*/ $20ec348cfe64bfcc$var$_wrapNativeSuper(Error));
function $20ec348cfe64bfcc$var$undefinedIfEmpty(array) {
    return array === undefined || array.length === 0 ? undefined : array;
}
function $20ec348cfe64bfcc$export$55ee1551a3f962e6(error) {
    var output = error.message;
    if (error.nodes) for(var _i4 = 0, _error$nodes2 = error.nodes; _i4 < _error$nodes2.length; _i4++){
        var node = _error$nodes2[_i4];
        if (node.loc) output += '\n\n' + (0, $5LGuP.printLocation)(node.loc);
    }
    else if (error.source && error.locations) for(var _i6 = 0, _error$locations2 = error.locations; _i6 < _error$locations2.length; _i6++){
        var location = _error$locations2[_i6];
        output += '\n\n' + (0, $5LGuP.printSourceLocation)(error.source, location);
    }
    return output;
}

});
parcelRegister("fbtyx", function(module, exports) {

$parcel$export(module.exports, "default", () => $700b00a777571467$export$2e2bcd8739ae039);
function $700b00a777571467$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $700b00a777571467$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $700b00a777571467$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $700b00a777571467$var$_typeof(obj);
}
function $700b00a777571467$export$2e2bcd8739ae039(value) {
    return $700b00a777571467$var$_typeof(value) == 'object' && value !== null;
}

});

parcelRegister("gwa3m", function(module, exports) {

$parcel$export(module.exports, "SYMBOL_ITERATOR", () => $84dde8096e41b064$export$f6cdee3c26d6da57);
$parcel$export(module.exports, "SYMBOL_ASYNC_ITERATOR", () => $84dde8096e41b064$export$8d0083df0471478e);
$parcel$export(module.exports, "SYMBOL_TO_STRING_TAG", () => $84dde8096e41b064$export$5deadc579ccc7c9c);
// In ES2015 (or a polyfilled) environment, this will be Symbol.iterator
// istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
var $84dde8096e41b064$export$f6cdee3c26d6da57 = typeof Symbol === 'function' && Symbol.iterator != null ? Symbol.iterator : '@@iterator'; // In ES2017 (or a polyfilled) environment, this will be Symbol.asyncIterator
var $84dde8096e41b064$export$8d0083df0471478e = typeof Symbol === 'function' && Symbol.asyncIterator != null ? Symbol.asyncIterator : '@@asyncIterator'; // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
var $84dde8096e41b064$export$5deadc579ccc7c9c = typeof Symbol === 'function' && Symbol.toStringTag != null ? Symbol.toStringTag : '@@toStringTag';

});

parcelRegister("cBRMW", function(module, exports) {

$parcel$export(module.exports, "getLocation", () => $d7d707e8e9ee9fd6$export$e7fd20fad3cf4b5f);
/**
 * Represents a location in a Source.
 */ /**
 * Takes a Source and a UTF-8 character offset, and returns the corresponding
 * line and column as a SourceLocation.
 */ function $d7d707e8e9ee9fd6$export$e7fd20fad3cf4b5f(source, position) {
    var lineRegexp = /\r\n|[\n\r]/g;
    var line = 1;
    var column = position + 1;
    var match;
    while((match = lineRegexp.exec(source.body)) && match.index < position){
        line += 1;
        column = position + 1 - (match.index + match[0].length);
    }
    return {
        line: line,
        column: column
    };
}

});

parcelRegister("5LGuP", function(module, exports) {

$parcel$export(module.exports, "printLocation", () => $66f0d94dee1ae1b2$export$96a9681e539deed);
$parcel$export(module.exports, "printSourceLocation", () => $66f0d94dee1ae1b2$export$867940333fd9f869);

var $cBRMW = parcelRequire("cBRMW");
function $66f0d94dee1ae1b2$export$96a9681e539deed(location) {
    return $66f0d94dee1ae1b2$export$867940333fd9f869(location.source, (0, $cBRMW.getLocation)(location.source, location.start));
}
function $66f0d94dee1ae1b2$export$867940333fd9f869(source, sourceLocation) {
    var firstLineColumnOffset = source.locationOffset.column - 1;
    var body = $66f0d94dee1ae1b2$var$whitespace(firstLineColumnOffset) + source.body;
    var lineIndex = sourceLocation.line - 1;
    var lineOffset = source.locationOffset.line - 1;
    var lineNum = sourceLocation.line + lineOffset;
    var columnOffset = sourceLocation.line === 1 ? firstLineColumnOffset : 0;
    var columnNum = sourceLocation.column + columnOffset;
    var locationStr = "".concat(source.name, ":").concat(lineNum, ":").concat(columnNum, "\n");
    var lines = body.split(/\r\n|[\n\r]/g);
    var locationLine = lines[lineIndex]; // Special case for minified documents
    if (locationLine.length > 120) {
        var subLineIndex = Math.floor(columnNum / 80);
        var subLineColumnNum = columnNum % 80;
        var subLines = [];
        for(var i = 0; i < locationLine.length; i += 80)subLines.push(locationLine.slice(i, i + 80));
        return locationStr + $66f0d94dee1ae1b2$var$printPrefixedLines([
            [
                "".concat(lineNum),
                subLines[0]
            ]
        ].concat(subLines.slice(1, subLineIndex + 1).map(function(subLine) {
            return [
                '',
                subLine
            ];
        }), [
            [
                ' ',
                $66f0d94dee1ae1b2$var$whitespace(subLineColumnNum - 1) + '^'
            ],
            [
                '',
                subLines[subLineIndex + 1]
            ]
        ]));
    }
    return locationStr + $66f0d94dee1ae1b2$var$printPrefixedLines([
        [
            "".concat(lineNum - 1),
            lines[lineIndex - 1]
        ],
        [
            "".concat(lineNum),
            locationLine
        ],
        [
            '',
            $66f0d94dee1ae1b2$var$whitespace(columnNum - 1) + '^'
        ],
        [
            "".concat(lineNum + 1),
            lines[lineIndex + 1]
        ]
    ]);
}
function $66f0d94dee1ae1b2$var$printPrefixedLines(lines) {
    var existingLines = lines.filter(function(_ref) {
        var _ = _ref[0], line = _ref[1];
        return line !== undefined;
    });
    var padLen = Math.max.apply(Math, existingLines.map(function(_ref2) {
        var prefix = _ref2[0];
        return prefix.length;
    }));
    return existingLines.map(function(_ref3) {
        var prefix = _ref3[0], line = _ref3[1];
        return $66f0d94dee1ae1b2$var$leftPad(padLen, prefix) + (line ? ' | ' + line : ' |');
    }).join('\n');
}
function $66f0d94dee1ae1b2$var$whitespace(len) {
    return Array(len + 1).join(' ');
}
function $66f0d94dee1ae1b2$var$leftPad(len, str) {
    return $66f0d94dee1ae1b2$var$whitespace(len - str.length) + str;
}

});



parcelRegister("1c4hI", function(module, exports) {

$parcel$export(module.exports, "Kind", () => $1bf9b417a1cf9d08$export$a84bdc57c5122798);
/**
 * The set of allowed kind values for AST nodes.
 */ var $1bf9b417a1cf9d08$export$a84bdc57c5122798 = Object.freeze({
    // Name
    NAME: 'Name',
    // Document
    DOCUMENT: 'Document',
    OPERATION_DEFINITION: 'OperationDefinition',
    VARIABLE_DEFINITION: 'VariableDefinition',
    SELECTION_SET: 'SelectionSet',
    FIELD: 'Field',
    ARGUMENT: 'Argument',
    // Fragments
    FRAGMENT_SPREAD: 'FragmentSpread',
    INLINE_FRAGMENT: 'InlineFragment',
    FRAGMENT_DEFINITION: 'FragmentDefinition',
    // Values
    VARIABLE: 'Variable',
    INT: 'IntValue',
    FLOAT: 'FloatValue',
    STRING: 'StringValue',
    BOOLEAN: 'BooleanValue',
    NULL: 'NullValue',
    ENUM: 'EnumValue',
    LIST: 'ListValue',
    OBJECT: 'ObjectValue',
    OBJECT_FIELD: 'ObjectField',
    // Directives
    DIRECTIVE: 'Directive',
    // Types
    NAMED_TYPE: 'NamedType',
    LIST_TYPE: 'ListType',
    NON_NULL_TYPE: 'NonNullType',
    // Type System Definitions
    SCHEMA_DEFINITION: 'SchemaDefinition',
    OPERATION_TYPE_DEFINITION: 'OperationTypeDefinition',
    // Type Definitions
    SCALAR_TYPE_DEFINITION: 'ScalarTypeDefinition',
    OBJECT_TYPE_DEFINITION: 'ObjectTypeDefinition',
    FIELD_DEFINITION: 'FieldDefinition',
    INPUT_VALUE_DEFINITION: 'InputValueDefinition',
    INTERFACE_TYPE_DEFINITION: 'InterfaceTypeDefinition',
    UNION_TYPE_DEFINITION: 'UnionTypeDefinition',
    ENUM_TYPE_DEFINITION: 'EnumTypeDefinition',
    ENUM_VALUE_DEFINITION: 'EnumValueDefinition',
    INPUT_OBJECT_TYPE_DEFINITION: 'InputObjectTypeDefinition',
    // Directive Definitions
    DIRECTIVE_DEFINITION: 'DirectiveDefinition',
    // Type System Extensions
    SCHEMA_EXTENSION: 'SchemaExtension',
    // Type Extensions
    SCALAR_TYPE_EXTENSION: 'ScalarTypeExtension',
    OBJECT_TYPE_EXTENSION: 'ObjectTypeExtension',
    INTERFACE_TYPE_EXTENSION: 'InterfaceTypeExtension',
    UNION_TYPE_EXTENSION: 'UnionTypeExtension',
    ENUM_TYPE_EXTENSION: 'EnumTypeExtension',
    INPUT_OBJECT_TYPE_EXTENSION: 'InputObjectTypeExtension'
}); /**
 * The enum type representing the possible kind values of AST nodes.
 */ 

});

parcelRegister("hFu5F", function(module, exports) {

$parcel$export(module.exports, "TokenKind", () => $7350b511ab98151f$export$8b9d26ab11394711);
/**
 * An exported enum describing the different kinds of tokens that the
 * lexer emits.
 */ var $7350b511ab98151f$export$8b9d26ab11394711 = Object.freeze({
    SOF: '<SOF>',
    EOF: '<EOF>',
    BANG: '!',
    DOLLAR: '$',
    AMP: '&',
    PAREN_L: '(',
    PAREN_R: ')',
    SPREAD: '...',
    COLON: ':',
    EQUALS: '=',
    AT: '@',
    BRACKET_L: '[',
    BRACKET_R: ']',
    BRACE_L: '{',
    PIPE: '|',
    BRACE_R: '}',
    NAME: 'Name',
    INT: 'Int',
    FLOAT: 'Float',
    STRING: 'String',
    BLOCK_STRING: 'BlockString',
    COMMENT: 'Comment'
}); /**
 * The enum type representing the token kinds values.
 */ 

});

parcelRegister("7vqrl", function(module, exports) {

$parcel$export(module.exports, "Source", () => $0269dc101dba4337$export$1d2df86270c81ecb);
$parcel$export(module.exports, "isSource", () => $0269dc101dba4337$export$75135ee9ed6e435b);

var $gwa3m = parcelRequire("gwa3m");

var $biK02 = parcelRequire("biK02");

var $fZdRY = parcelRequire("fZdRY");

var $aVhwC = parcelRequire("aVhwC");
function $0269dc101dba4337$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $0269dc101dba4337$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $0269dc101dba4337$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $0269dc101dba4337$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
var $0269dc101dba4337$export$1d2df86270c81ecb = /*#__PURE__*/ function() {
    function Source(body) {
        var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'GraphQL request';
        var locationOffset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
            line: 1,
            column: 1
        };
        typeof body === 'string' || (0, $fZdRY.default)(0, "Body must be a string. Received: ".concat((0, $biK02.default)(body), "."));
        this.body = body;
        this.name = name;
        this.locationOffset = locationOffset;
        this.locationOffset.line > 0 || (0, $fZdRY.default)(0, 'line in locationOffset is 1-indexed and must be positive.');
        this.locationOffset.column > 0 || (0, $fZdRY.default)(0, 'column in locationOffset is 1-indexed and must be positive.');
    } // $FlowFixMe[unsupported-syntax] Flow doesn't support computed properties yet
    $0269dc101dba4337$var$_createClass(Source, [
        {
            key: (0, $gwa3m.SYMBOL_TO_STRING_TAG),
            get: function get() {
                return 'Source';
            }
        }
    ]);
    return Source;
}();
function $0269dc101dba4337$export$75135ee9ed6e435b(source) {
    return (0, $aVhwC.default)(source, $0269dc101dba4337$export$1d2df86270c81ecb);
}

});
parcelRegister("fZdRY", function(module, exports) {

$parcel$export(module.exports, "default", () => $b04eb23f905f9ab5$export$2e2bcd8739ae039);
function $b04eb23f905f9ab5$export$2e2bcd8739ae039(condition, message) {
    var booleanCondition = Boolean(condition); // istanbul ignore else (See transformation done in './resources/inlineInvariant.js')
    if (!booleanCondition) throw new Error(message);
}

});

parcelRegister("aVhwC", function(module, exports) {

$parcel$export(module.exports, "default", () => $ef14998e21195a05$export$2e2bcd8739ae039);

function $ef14998e21195a05$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $ef14998e21195a05$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $ef14998e21195a05$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $ef14998e21195a05$var$_typeof(obj);
}
var /**
 * A replacement for instanceof which includes an error warning when multi-realm
 * constructors are detected.
 */ // See: https://expressjs.com/en/advanced/best-practice-performance.html#set-node_env-to-production
// See: https://webpack.js.org/guides/production/
$ef14998e21195a05$export$2e2bcd8739ae039 = // eslint-disable-next-line no-shadow
function instanceOf(value, constructor) {
    return value instanceof constructor;
};

});


parcelRegister("5hGV7", function(module, exports) {

$parcel$export(module.exports, "DirectiveLocation", () => $d7161a38006ba9b3$export$b45ffd2948484c41);
/**
 * The set of allowed directive location values.
 */ var $d7161a38006ba9b3$export$b45ffd2948484c41 = Object.freeze({
    // Request Definitions
    QUERY: 'QUERY',
    MUTATION: 'MUTATION',
    SUBSCRIPTION: 'SUBSCRIPTION',
    FIELD: 'FIELD',
    FRAGMENT_DEFINITION: 'FRAGMENT_DEFINITION',
    FRAGMENT_SPREAD: 'FRAGMENT_SPREAD',
    INLINE_FRAGMENT: 'INLINE_FRAGMENT',
    VARIABLE_DEFINITION: 'VARIABLE_DEFINITION',
    // Type System Definitions
    SCHEMA: 'SCHEMA',
    SCALAR: 'SCALAR',
    OBJECT: 'OBJECT',
    FIELD_DEFINITION: 'FIELD_DEFINITION',
    ARGUMENT_DEFINITION: 'ARGUMENT_DEFINITION',
    INTERFACE: 'INTERFACE',
    UNION: 'UNION',
    ENUM: 'ENUM',
    ENUM_VALUE: 'ENUM_VALUE',
    INPUT_OBJECT: 'INPUT_OBJECT',
    INPUT_FIELD_DEFINITION: 'INPUT_FIELD_DEFINITION'
}); /**
 * The enum type representing the directive location values.
 */ 

});

parcelRegister("b5rqB", function(module, exports) {

$parcel$export(module.exports, "Lexer", () => $a5d33b5906ae43cc$export$6168dc8908a6c652);
$parcel$export(module.exports, "isPunctuatorTokenKind", () => $a5d33b5906ae43cc$export$59ac0f4da287406a);

var $l48s6 = parcelRequire("l48s6");

var $c8MIO = parcelRequire("c8MIO");

var $hFu5F = parcelRequire("hFu5F");

var $flA0a = parcelRequire("flA0a");
var $a5d33b5906ae43cc$export$6168dc8908a6c652 = /*#__PURE__*/ function() {
    /**
   * The previously focused non-ignored token.
   */ /**
   * The currently focused non-ignored token.
   */ /**
   * The (1-indexed) line containing the current token.
   */ /**
   * The character offset at which the current line begins.
   */ function Lexer(source) {
        var startOfFileToken = new (0, $c8MIO.Token)((0, $hFu5F.TokenKind).SOF, 0, 0, 0, 0, null);
        this.source = source;
        this.lastToken = startOfFileToken;
        this.token = startOfFileToken;
        this.line = 1;
        this.lineStart = 0;
    }
    /**
   * Advances the token stream to the next non-ignored token.
   */ var _proto = Lexer.prototype;
    _proto.advance = function advance() {
        this.lastToken = this.token;
        var token = this.token = this.lookahead();
        return token;
    } /**
   * Looks ahead and returns the next non-ignored token, but does not change
   * the state of Lexer.
   */ ;
    _proto.lookahead = function lookahead() {
        var token = this.token;
        if (token.kind !== (0, $hFu5F.TokenKind).EOF) do {
            var _token$next;
            // Note: next is only mutable during parsing, so we cast to allow this.
            token = (_token$next = token.next) !== null && _token$next !== void 0 ? _token$next : token.next = $a5d33b5906ae43cc$var$readToken(this, token);
        }while (token.kind === (0, $hFu5F.TokenKind).COMMENT);
        return token;
    };
    return Lexer;
}();
function $a5d33b5906ae43cc$export$59ac0f4da287406a(kind) {
    return kind === (0, $hFu5F.TokenKind).BANG || kind === (0, $hFu5F.TokenKind).DOLLAR || kind === (0, $hFu5F.TokenKind).AMP || kind === (0, $hFu5F.TokenKind).PAREN_L || kind === (0, $hFu5F.TokenKind).PAREN_R || kind === (0, $hFu5F.TokenKind).SPREAD || kind === (0, $hFu5F.TokenKind).COLON || kind === (0, $hFu5F.TokenKind).EQUALS || kind === (0, $hFu5F.TokenKind).AT || kind === (0, $hFu5F.TokenKind).BRACKET_L || kind === (0, $hFu5F.TokenKind).BRACKET_R || kind === (0, $hFu5F.TokenKind).BRACE_L || kind === (0, $hFu5F.TokenKind).PIPE || kind === (0, $hFu5F.TokenKind).BRACE_R;
}
function $a5d33b5906ae43cc$var$printCharCode(code) {
    return isNaN(code) ? (0, $hFu5F.TokenKind).EOF : code < 0x007f ? JSON.stringify(String.fromCharCode(code)) : "\"\\u".concat(('00' + code.toString(16).toUpperCase()).slice(-4), "\"");
}
/**
 * Gets the next token from the source starting at the given position.
 *
 * This skips over whitespace until it finds the next lexable token, then lexes
 * punctuators immediately or calls the appropriate helper function for more
 * complicated tokens.
 */ function $a5d33b5906ae43cc$var$readToken(lexer, prev) {
    var source = lexer.source;
    var body = source.body;
    var bodyLength = body.length;
    var pos = prev.end;
    while(pos < bodyLength){
        var code = body.charCodeAt(pos);
        var _line = lexer.line;
        var _col = 1 + pos - lexer.lineStart; // SourceCharacter
        switch(code){
            case 0xfeff:
            case 9:
            case 32:
            case 44:
                //  ,
                ++pos;
                continue;
            case 10:
                //  \n
                ++pos;
                ++lexer.line;
                lexer.lineStart = pos;
                continue;
            case 13:
                //  \r
                if (body.charCodeAt(pos + 1) === 10) pos += 2;
                else ++pos;
                ++lexer.line;
                lexer.lineStart = pos;
                continue;
            case 33:
                //  !
                return new (0, $c8MIO.Token)((0, $hFu5F.TokenKind).BANG, pos, pos + 1, _line, _col, prev);
            case 35:
                //  #
                return $a5d33b5906ae43cc$var$readComment(source, pos, _line, _col, prev);
            case 36:
                //  $
                return new (0, $c8MIO.Token)((0, $hFu5F.TokenKind).DOLLAR, pos, pos + 1, _line, _col, prev);
            case 38:
                //  &
                return new (0, $c8MIO.Token)((0, $hFu5F.TokenKind).AMP, pos, pos + 1, _line, _col, prev);
            case 40:
                //  (
                return new (0, $c8MIO.Token)((0, $hFu5F.TokenKind).PAREN_L, pos, pos + 1, _line, _col, prev);
            case 41:
                //  )
                return new (0, $c8MIO.Token)((0, $hFu5F.TokenKind).PAREN_R, pos, pos + 1, _line, _col, prev);
            case 46:
                //  .
                if (body.charCodeAt(pos + 1) === 46 && body.charCodeAt(pos + 2) === 46) return new (0, $c8MIO.Token)((0, $hFu5F.TokenKind).SPREAD, pos, pos + 3, _line, _col, prev);
                break;
            case 58:
                //  :
                return new (0, $c8MIO.Token)((0, $hFu5F.TokenKind).COLON, pos, pos + 1, _line, _col, prev);
            case 61:
                //  =
                return new (0, $c8MIO.Token)((0, $hFu5F.TokenKind).EQUALS, pos, pos + 1, _line, _col, prev);
            case 64:
                //  @
                return new (0, $c8MIO.Token)((0, $hFu5F.TokenKind).AT, pos, pos + 1, _line, _col, prev);
            case 91:
                //  [
                return new (0, $c8MIO.Token)((0, $hFu5F.TokenKind).BRACKET_L, pos, pos + 1, _line, _col, prev);
            case 93:
                //  ]
                return new (0, $c8MIO.Token)((0, $hFu5F.TokenKind).BRACKET_R, pos, pos + 1, _line, _col, prev);
            case 123:
                // {
                return new (0, $c8MIO.Token)((0, $hFu5F.TokenKind).BRACE_L, pos, pos + 1, _line, _col, prev);
            case 124:
                // |
                return new (0, $c8MIO.Token)((0, $hFu5F.TokenKind).PIPE, pos, pos + 1, _line, _col, prev);
            case 125:
                // }
                return new (0, $c8MIO.Token)((0, $hFu5F.TokenKind).BRACE_R, pos, pos + 1, _line, _col, prev);
            case 34:
                //  "
                if (body.charCodeAt(pos + 1) === 34 && body.charCodeAt(pos + 2) === 34) return $a5d33b5906ae43cc$var$readBlockString(source, pos, _line, _col, prev, lexer);
                return $a5d33b5906ae43cc$var$readString(source, pos, _line, _col, prev);
            case 45:
            case 48:
            case 49:
            case 50:
            case 51:
            case 52:
            case 53:
            case 54:
            case 55:
            case 56:
            case 57:
                //  9
                return $a5d33b5906ae43cc$var$readNumber(source, pos, code, _line, _col, prev);
            case 65:
            case 66:
            case 67:
            case 68:
            case 69:
            case 70:
            case 71:
            case 72:
            case 73:
            case 74:
            case 75:
            case 76:
            case 77:
            case 78:
            case 79:
            case 80:
            case 81:
            case 82:
            case 83:
            case 84:
            case 85:
            case 86:
            case 87:
            case 88:
            case 89:
            case 90:
            case 95:
            case 97:
            case 98:
            case 99:
            case 100:
            case 101:
            case 102:
            case 103:
            case 104:
            case 105:
            case 106:
            case 107:
            case 108:
            case 109:
            case 110:
            case 111:
            case 112:
            case 113:
            case 114:
            case 115:
            case 116:
            case 117:
            case 118:
            case 119:
            case 120:
            case 121:
            case 122:
                // z
                return $a5d33b5906ae43cc$var$readName(source, pos, _line, _col, prev);
        }
        throw (0, $l48s6.syntaxError)(source, pos, $a5d33b5906ae43cc$var$unexpectedCharacterMessage(code));
    }
    var line = lexer.line;
    var col = 1 + pos - lexer.lineStart;
    return new (0, $c8MIO.Token)((0, $hFu5F.TokenKind).EOF, bodyLength, bodyLength, line, col, prev);
}
/**
 * Report a message that an unexpected character was encountered.
 */ function $a5d33b5906ae43cc$var$unexpectedCharacterMessage(code) {
    if (code < 0x0020 && code !== 0x0009 && code !== 0x000a && code !== 0x000d) return "Cannot contain the invalid character ".concat($a5d33b5906ae43cc$var$printCharCode(code), ".");
    if (code === 39) // '
    return 'Unexpected single quote character (\'), did you mean to use a double quote (")?';
    return "Cannot parse the unexpected character ".concat($a5d33b5906ae43cc$var$printCharCode(code), ".");
}
/**
 * Reads a comment token from the source file.
 *
 * #[\u0009\u0020-\uFFFF]*
 */ function $a5d33b5906ae43cc$var$readComment(source, start, line, col, prev) {
    var body = source.body;
    var code;
    var position = start;
    do code = body.charCodeAt(++position);
    while (!isNaN(code) && (code > 0x001f || code === 0x0009));
    return new (0, $c8MIO.Token)((0, $hFu5F.TokenKind).COMMENT, start, position, line, col, prev, body.slice(start + 1, position));
}
/**
 * Reads a number token from the source file, either a float
 * or an int depending on whether a decimal point appears.
 *
 * Int:   -?(0|[1-9][0-9]*)
 * Float: -?(0|[1-9][0-9]*)(\.[0-9]+)?((E|e)(+|-)?[0-9]+)?
 */ function $a5d33b5906ae43cc$var$readNumber(source, start, firstCode, line, col, prev) {
    var body = source.body;
    var code = firstCode;
    var position = start;
    var isFloat = false;
    if (code === 45) // -
    code = body.charCodeAt(++position);
    if (code === 48) {
        // 0
        code = body.charCodeAt(++position);
        if (code >= 48 && code <= 57) throw (0, $l48s6.syntaxError)(source, position, "Invalid number, unexpected digit after 0: ".concat($a5d33b5906ae43cc$var$printCharCode(code), "."));
    } else {
        position = $a5d33b5906ae43cc$var$readDigits(source, position, code);
        code = body.charCodeAt(position);
    }
    if (code === 46) {
        // .
        isFloat = true;
        code = body.charCodeAt(++position);
        position = $a5d33b5906ae43cc$var$readDigits(source, position, code);
        code = body.charCodeAt(position);
    }
    if (code === 69 || code === 101) {
        // E e
        isFloat = true;
        code = body.charCodeAt(++position);
        if (code === 43 || code === 45) // + -
        code = body.charCodeAt(++position);
        position = $a5d33b5906ae43cc$var$readDigits(source, position, code);
        code = body.charCodeAt(position);
    } // Numbers cannot be followed by . or NameStart
    if (code === 46 || $a5d33b5906ae43cc$var$isNameStart(code)) throw (0, $l48s6.syntaxError)(source, position, "Invalid number, expected digit but got: ".concat($a5d33b5906ae43cc$var$printCharCode(code), "."));
    return new (0, $c8MIO.Token)(isFloat ? (0, $hFu5F.TokenKind).FLOAT : (0, $hFu5F.TokenKind).INT, start, position, line, col, prev, body.slice(start, position));
}
/**
 * Returns the new position in the source after reading digits.
 */ function $a5d33b5906ae43cc$var$readDigits(source, start, firstCode) {
    var body = source.body;
    var position = start;
    var code = firstCode;
    if (code >= 48 && code <= 57) {
        // 0 - 9
        do code = body.charCodeAt(++position);
        while (code >= 48 && code <= 57); // 0 - 9
        return position;
    }
    throw (0, $l48s6.syntaxError)(source, position, "Invalid number, expected digit but got: ".concat($a5d33b5906ae43cc$var$printCharCode(code), "."));
}
/**
 * Reads a string token from the source file.
 *
 * "([^"\\\u000A\u000D]|(\\(u[0-9a-fA-F]{4}|["\\/bfnrt])))*"
 */ function $a5d33b5906ae43cc$var$readString(source, start, line, col, prev) {
    var body = source.body;
    var position = start + 1;
    var chunkStart = position;
    var code = 0;
    var value = '';
    while(position < body.length && !isNaN(code = body.charCodeAt(position)) && // not LineTerminator
    code !== 0x000a && code !== 0x000d){
        // Closing Quote (")
        if (code === 34) {
            value += body.slice(chunkStart, position);
            return new (0, $c8MIO.Token)((0, $hFu5F.TokenKind).STRING, start, position + 1, line, col, prev, value);
        } // SourceCharacter
        if (code < 0x0020 && code !== 0x0009) throw (0, $l48s6.syntaxError)(source, position, "Invalid character within String: ".concat($a5d33b5906ae43cc$var$printCharCode(code), "."));
        ++position;
        if (code === 92) {
            // \
            value += body.slice(chunkStart, position - 1);
            code = body.charCodeAt(position);
            switch(code){
                case 34:
                    value += '"';
                    break;
                case 47:
                    value += '/';
                    break;
                case 92:
                    value += '\\';
                    break;
                case 98:
                    value += '\b';
                    break;
                case 102:
                    value += '\f';
                    break;
                case 110:
                    value += '\n';
                    break;
                case 114:
                    value += '\r';
                    break;
                case 116:
                    value += '\t';
                    break;
                case 117:
                    // uXXXX
                    var charCode = $a5d33b5906ae43cc$var$uniCharCode(body.charCodeAt(position + 1), body.charCodeAt(position + 2), body.charCodeAt(position + 3), body.charCodeAt(position + 4));
                    if (charCode < 0) {
                        var invalidSequence = body.slice(position + 1, position + 5);
                        throw (0, $l48s6.syntaxError)(source, position, "Invalid character escape sequence: \\u".concat(invalidSequence, "."));
                    }
                    value += String.fromCharCode(charCode);
                    position += 4;
                    break;
                default:
                    throw (0, $l48s6.syntaxError)(source, position, "Invalid character escape sequence: \\".concat(String.fromCharCode(code), "."));
            }
            ++position;
            chunkStart = position;
        }
    }
    throw (0, $l48s6.syntaxError)(source, position, 'Unterminated string.');
}
/**
 * Reads a block string token from the source file.
 *
 * """("?"?(\\"""|\\(?!=""")|[^"\\]))*"""
 */ function $a5d33b5906ae43cc$var$readBlockString(source, start, line, col, prev, lexer) {
    var body = source.body;
    var position = start + 3;
    var chunkStart = position;
    var code = 0;
    var rawValue = '';
    while(position < body.length && !isNaN(code = body.charCodeAt(position))){
        // Closing Triple-Quote (""")
        if (code === 34 && body.charCodeAt(position + 1) === 34 && body.charCodeAt(position + 2) === 34) {
            rawValue += body.slice(chunkStart, position);
            return new (0, $c8MIO.Token)((0, $hFu5F.TokenKind).BLOCK_STRING, start, position + 3, line, col, prev, (0, $flA0a.dedentBlockStringValue)(rawValue));
        } // SourceCharacter
        if (code < 0x0020 && code !== 0x0009 && code !== 0x000a && code !== 0x000d) throw (0, $l48s6.syntaxError)(source, position, "Invalid character within String: ".concat($a5d33b5906ae43cc$var$printCharCode(code), "."));
        if (code === 10) {
            // new line
            ++position;
            ++lexer.line;
            lexer.lineStart = position;
        } else if (code === 13) {
            // carriage return
            if (body.charCodeAt(position + 1) === 10) position += 2;
            else ++position;
            ++lexer.line;
            lexer.lineStart = position;
        } else if (code === 92 && body.charCodeAt(position + 1) === 34 && body.charCodeAt(position + 2) === 34 && body.charCodeAt(position + 3) === 34) {
            rawValue += body.slice(chunkStart, position) + '"""';
            position += 4;
            chunkStart = position;
        } else ++position;
    }
    throw (0, $l48s6.syntaxError)(source, position, 'Unterminated string.');
}
/**
 * Converts four hexadecimal chars to the integer that the
 * string represents. For example, uniCharCode('0','0','0','f')
 * will return 15, and uniCharCode('0','0','f','f') returns 255.
 *
 * Returns a negative number on error, if a char was invalid.
 *
 * This is implemented by noting that char2hex() returns -1 on error,
 * which means the result of ORing the char2hex() will also be negative.
 */ function $a5d33b5906ae43cc$var$uniCharCode(a, b, c, d) {
    return $a5d33b5906ae43cc$var$char2hex(a) << 12 | $a5d33b5906ae43cc$var$char2hex(b) << 8 | $a5d33b5906ae43cc$var$char2hex(c) << 4 | $a5d33b5906ae43cc$var$char2hex(d);
}
/**
 * Converts a hex character to its integer value.
 * '0' becomes 0, '9' becomes 9
 * 'A' becomes 10, 'F' becomes 15
 * 'a' becomes 10, 'f' becomes 15
 *
 * Returns -1 on error.
 */ function $a5d33b5906ae43cc$var$char2hex(a) {
    return a >= 48 && a <= 57 ? a - 48 // 0-9
     : a >= 65 && a <= 70 ? a - 55 // A-F
     : a >= 97 && a <= 102 ? a - 87 // a-f
     : -1;
}
/**
 * Reads an alphanumeric + underscore name from the source.
 *
 * [_A-Za-z][_0-9A-Za-z]*
 */ function $a5d33b5906ae43cc$var$readName(source, start, line, col, prev) {
    var body = source.body;
    var bodyLength = body.length;
    var position = start + 1;
    var code = 0;
    while(position !== bodyLength && !isNaN(code = body.charCodeAt(position)) && (code === 95 || // _
    code >= 48 && code <= 57 || // 0-9
    code >= 65 && code <= 90 || // A-Z
    code >= 97 && code <= 122 // a-z
    ))++position;
    return new (0, $c8MIO.Token)((0, $hFu5F.TokenKind).NAME, start, position, line, col, prev, body.slice(start, position));
} // _ A-Z a-z
function $a5d33b5906ae43cc$var$isNameStart(code) {
    return code === 95 || code >= 65 && code <= 90 || code >= 97 && code <= 122;
}

});




parcelRegister("yuXsW", function(module, exports) {

$parcel$export(module.exports, "resetCache", () => $343a391851b41a38$export$6e5dca841bdf93e3);
$parcel$export(module.exports, "getClient", () => $343a391851b41a38$export$6bb76d6eba7e258c);
$parcel$export(module.exports, "ApolloClientProvider", () => $343a391851b41a38$export$8e363dbef886ff17);

var $eUqFw = parcelRequire("eUqFw");

var $illlw = parcelRequire("illlw");

var $4ErPU = parcelRequire("4ErPU");

var $gd0Sp = parcelRequire("gd0Sp");
const $343a391851b41a38$var$CLIENTS_CACHE = {};
const $343a391851b41a38$export$6e5dca841bdf93e3 = (clientId)=>{
    // we need to `clearStore` directly to the InMemoryCache instance
    $343a391851b41a38$var$CLIENTS_CACHE[clientId]?.clearStore();
    delete $343a391851b41a38$var$CLIENTS_CACHE[clientId];
};
const $343a391851b41a38$export$44dd3e9494f887fc = ()=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    Object.keys($343a391851b41a38$var$CLIENTS_CACHE).reduce((acc, key)=>Object.assign(acc, {
            [`apollo-cache/${key}`]: $343a391851b41a38$var$CLIENTS_CACHE[key].extract()
        }), {});
const $343a391851b41a38$export$6bb76d6eba7e258c = (baseUrl, { clientId: clientId, clientCreator: clientCreator }, xsrfToken)=>{
    let client = $343a391851b41a38$var$CLIENTS_CACHE[clientId];
    if (!client) {
        client = clientCreator(baseUrl, xsrfToken);
        $343a391851b41a38$var$CLIENTS_CACHE[clientId] = client;
    }
    return client;
};
class $343a391851b41a38$export$8e363dbef886ff17 extends (0, $eUqFw.Component) {
    getClient(baseUrl, xsrfToken) {
        return $343a391851b41a38$export$6bb76d6eba7e258c(baseUrl, this.props.client, xsrfToken != null ? xsrfToken : undefined);
    }
    render() {
        const { children: children } = this.props;
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(this.props, 'client.clientId')) throw new Error('Please provide a client configuration');
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gd0Sp.TenantContextSubscriber), null, ({ tenantContext: tenantContext })=>{
            const client = this.getClient(tenantContext.baseUrl, tenantContext.xsrfToken);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4ErPU.ApolloProvider), {
                client: client
            }, children);
        });
    }
}

});
parcelRegister("4ErPU", function(module, exports) {

$parcel$export(module.exports, "getApolloContext", () => $36307d91b5e24fba$export$a47505d961ee3a1);
$parcel$export(module.exports, "ApolloProvider", () => $36307d91b5e24fba$export$c16b04c8a9956446);
$parcel$export(module.exports, "DocumentType", () => $36307d91b5e24fba$export$d1d99cf900472499);
$parcel$export(module.exports, "operationName", () => $36307d91b5e24fba$export$5db520940cf00715);
$parcel$export(module.exports, "parser", () => $36307d91b5e24fba$export$8f49e4af10703ce3);

var $eUqFw = parcelRequire("eUqFw");

var $8j2fP = parcelRequire("8j2fP");
var $36307d91b5e24fba$var$apolloContext;
function $36307d91b5e24fba$export$a47505d961ee3a1() {
    if (!$36307d91b5e24fba$var$apolloContext) $36307d91b5e24fba$var$apolloContext = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createContext({});
    return $36307d91b5e24fba$var$apolloContext;
}
function $36307d91b5e24fba$export$c2ee824bcc89ca6a() {
    $36307d91b5e24fba$var$apolloContext = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createContext({});
}
var $36307d91b5e24fba$export$c16b04c8a9956446 = function(_a) {
    var client = _a.client, children = _a.children;
    var ApolloContext = $36307d91b5e24fba$export$a47505d961ee3a1();
    return (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ApolloContext.Consumer, null, function(context) {
        if (context === void 0) context = {};
        if (client && context.client !== client) context = Object.assign({}, context, {
            client: client
        });
        (0, $8j2fP.invariant)(context.client, 5);
        return (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ApolloContext.Provider, {
            value: context
        }, children);
    });
};
var $36307d91b5e24fba$export$ed5ceab8c2bb5ce4 = function(props) {
    var ApolloContext = $36307d91b5e24fba$export$a47505d961ee3a1();
    return (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ApolloContext.Consumer, null, function(context) {
        (0, $8j2fP.invariant)(context && context.client, 6);
        return props.children(context.client);
    });
};
var $36307d91b5e24fba$export$d1d99cf900472499;
(function(DocumentType) {
    DocumentType[DocumentType["Query"] = 0] = "Query";
    DocumentType[DocumentType["Mutation"] = 1] = "Mutation";
    DocumentType[DocumentType["Subscription"] = 2] = "Subscription";
})($36307d91b5e24fba$export$d1d99cf900472499 || ($36307d91b5e24fba$export$d1d99cf900472499 = {}));
var $36307d91b5e24fba$var$cache = new Map();
function $36307d91b5e24fba$export$5db520940cf00715(type) {
    var name;
    switch(type){
        case $36307d91b5e24fba$export$d1d99cf900472499.Query:
            name = 'Query';
            break;
        case $36307d91b5e24fba$export$d1d99cf900472499.Mutation:
            name = 'Mutation';
            break;
        case $36307d91b5e24fba$export$d1d99cf900472499.Subscription:
            name = 'Subscription';
            break;
    }
    return name;
}
function $36307d91b5e24fba$export$8f49e4af10703ce3(document) {
    var cached = $36307d91b5e24fba$var$cache.get(document);
    if (cached) return cached;
    var variables, type, name;
    (0, $8j2fP.invariant)(!!document && !!document.kind, 1);
    var fragments = document.definitions.filter(function(x) {
        return x.kind === 'FragmentDefinition';
    });
    var queries = document.definitions.filter(function(x) {
        return x.kind === 'OperationDefinition' && x.operation === 'query';
    });
    var mutations = document.definitions.filter(function(x) {
        return x.kind === 'OperationDefinition' && x.operation === 'mutation';
    });
    var subscriptions = document.definitions.filter(function(x) {
        return x.kind === 'OperationDefinition' && x.operation === 'subscription';
    });
    (0, $8j2fP.invariant)(!fragments.length || queries.length || mutations.length || subscriptions.length, 2);
    (0, $8j2fP.invariant)(queries.length + mutations.length + subscriptions.length <= 1, 3);
    type = queries.length ? $36307d91b5e24fba$export$d1d99cf900472499.Query : $36307d91b5e24fba$export$d1d99cf900472499.Mutation;
    if (!queries.length && !mutations.length) type = $36307d91b5e24fba$export$d1d99cf900472499.Subscription;
    var definitions = queries.length ? queries : mutations.length ? mutations : subscriptions;
    (0, $8j2fP.invariant)(definitions.length === 1, 4);
    var definition = definitions[0];
    variables = definition.variableDefinitions || [];
    if (definition.name && definition.name.kind === 'Name') name = definition.name.value;
    else name = 'data';
    var payload = {
        name: name,
        type: type,
        variables: variables
    };
    $36307d91b5e24fba$var$cache.set(document, payload);
    return payload;
}

});


parcelRegister("7e8pf", function(module, exports) {

$parcel$export(module.exports, "default", () => $3ed5a3ae63b1b20d$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $kar7l = parcelRequire("kar7l");

var $1ybV0 = parcelRequire("1ybV0");


var $hSCS8 = parcelRequire("hSCS8");

var $eUu4u = parcelRequire("eUu4u");

var $2ESAZ = parcelRequire("2ESAZ");
// This wrapper should be agnostic, please don't add any project or overview logic here.
const $3ed5a3ae63b1b20d$var$BusinessAppWrapper = ({ children: children, className: className, header: header, sidebarTheme: sidebarTheme, shouldAddPadding: shouldAddPadding = true, withSidebar: withSidebar = false, withDynamicHeight: withDynamicHeight = false, withOverflow: withOverflow = false })=>{
    const [{ content: sidebarContent, sidebarWidth: sidebarWidth }] = (0, $hSCS8.useSidebar)();
    const isSidebarOpen = withSidebar && sidebarContent != null;
    let content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, header, children);
    if (withSidebar) content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eUu4u.SidebarLayout), {
        theme: sidebarTheme
    }, (0, $1ybV0.ff)('jsw.list.sidebar-layout-update') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: [
            $3ed5a3ae63b1b20d$var$contentWrapperStyles,
            isSidebarOpen && $3ed5a3ae63b1b20d$var$sidebarOpenContentWrapperStyles
        ]
    }, content) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2ESAZ.ContentWrapper), {
        isSidebarOpen: isSidebarOpen,
        sidebarWidth: sidebarWidth
    }, content));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2ESAZ.ThemedContainer), {
        shouldAddPadding: shouldAddPadding,
        isSidebarOpen: isSidebarOpen,
        withSidebar: withSidebar,
        withDynamicHeight: withDynamicHeight,
        withOverflow: withOverflow,
        id: (0, $d02be44255a1478f$export$e5e75ff4daca6597),
        // Used for styling
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: className
    }, content);
};
const $3ed5a3ae63b1b20d$var$contentWrapperStyles = (0, $1ZAYh.xcss)({
    // @ts-expect-error - we need to use Tokens to correctly set the color value using CSS variables
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    color: (0, $kar7l.Tokens).COLOR_TEXT,
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    flexShrink: 1,
    maxWidth: '100%',
    minWidth: '0',
    width: 'auto'
});
const $3ed5a3ae63b1b20d$var$sidebarOpenContentWrapperStyles = (0, $1ZAYh.xcss)({
    paddingRight: 'space.300',
    paddingBottom: 'space.300'
});
var $3ed5a3ae63b1b20d$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($3ed5a3ae63b1b20d$var$BusinessAppWrapper);

});
const $d02be44255a1478f$export$e5e75ff4daca6597 = 'jwm-container';

parcelRegister("hSCS8", function(module, exports) {

$parcel$export(module.exports, "getSidebarQueryParams", () => $cda1eebb5d053035$export$ddc11e4d41e7cf62);
$parcel$export(module.exports, "useSidebar", () => $cda1eebb5d053035$export$54c70f22f548bff8);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");

var $jGcn0 = parcelRequire("jGcn0");

var $iclz4 = parcelRequire("iclz4");

var $l0jym = parcelRequire("l0jym");
const $cda1eebb5d053035$export$86880b4b2e1a2384 = 'jwm.sidebar';
const $cda1eebb5d053035$export$b16f75f2e0c3c029 = 360;
const $cda1eebb5d053035$export$ddc11e4d41e7cf62 = ()=>[
        (0, $jGcn0.SELECTED_ISSUE_PARAM),
        (0, $jGcn0.SELECTED_COMMENT_PARAM)
    ];
const $cda1eebb5d053035$var$setSidebarContent = (content)=>({ setState: setState, getState: getState })=>{
        const state = getState();
        setState({
            ...state,
            content: content
        });
    };
const $cda1eebb5d053035$var$setSidebarWidth = (width)=>({ setState: setState, getState: getState })=>{
        const state = getState();
        const newWidth = Math.max(width, $cda1eebb5d053035$export$b16f75f2e0c3c029);
        if (newWidth === state.sidebarWidth) return;
        setState({
            ...state,
            sidebarWidth: newWidth
        });
        (0, $l0jym.localStorage).set($cda1eebb5d053035$export$86880b4b2e1a2384, newWidth);
    };
const $cda1eebb5d053035$var$setSidebarOnClose = (onSidebarClose)=>({ setState: setState, getState: getState })=>{
        const state = getState();
        setState({
            ...state,
            onSidebarClose: onSidebarClose
        });
    };
const $cda1eebb5d053035$var$closeSidebar = ()=>({ setState: setState, getState: getState })=>{
        const state = getState();
        state.onSidebarClose();
        setState({
            ...state,
            content: null,
            onSidebarClose: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
        });
    };
const $cda1eebb5d053035$var$actions = {
    setSidebarContent: $cda1eebb5d053035$var$setSidebarContent,
    setSidebarWidth: $cda1eebb5d053035$var$setSidebarWidth,
    setSidebarOnClose: $cda1eebb5d053035$var$setSidebarOnClose,
    closeSidebar: $cda1eebb5d053035$var$closeSidebar
};
const $cda1eebb5d053035$var$Store = (0, $a61MH.createStore)({
    initialState: {
        content: null,
        sidebarWidth: (0, $l0jym.localStorage).get($cda1eebb5d053035$export$86880b4b2e1a2384) || $cda1eebb5d053035$export$b16f75f2e0c3c029,
        onSidebarClose: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
    },
    actions: $cda1eebb5d053035$var$actions,
    name: 'JWMSidebarStore'
});
const $cda1eebb5d053035$var$useHook = (0, $ggKAj.createHook)($cda1eebb5d053035$var$Store);
const $cda1eebb5d053035$export$54c70f22f548bff8 = ()=>{
    const [state, hookActions] = $cda1eebb5d053035$var$useHook();
    const sidebarQueryParams = $cda1eebb5d053035$export$ddc11e4d41e7cf62();
    const [, setQueryParams] = (0, $iclz4.useQueryParams)(...sidebarQueryParams);
    const resetSidebarQueryParams = (0, $eUqFw.useCallback)(()=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const newQueryParams = sidebarQueryParams.reduce((acc, param)=>Object.assign(acc, {
                [param]: undefined
            }), {});
        setQueryParams(newQueryParams);
    }, [
        setQueryParams,
        sidebarQueryParams
    ]);
    return [
        state,
        {
            ...hookActions,
            resetSidebarQueryParams: resetSidebarQueryParams
        }
    ];
};

});
parcelRegister("l0jym", function(module, exports) {

$parcel$export(module.exports, "localStorage", () => $9c968063af1d87e8$export$c2ed3351cac403d1);

var $aZaPn = parcelRequire("aZaPn");
const $9c968063af1d87e8$export$c2ed3351cac403d1 = (0, $aZaPn.createLocalStorageProvider)('jira_business_common');

});


parcelRegister("eUu4u", function(module, exports) {

$parcel$export(module.exports, "SidebarLayout", () => $b41642a7c0ef06fe$export$8295a33ab8a36876);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $1ybV0 = parcelRequire("1ybV0");

var $h585o = parcelRequire("h585o");

var $h5BJf = parcelRequire("h5BJf");

var $hSCS8 = parcelRequire("hSCS8");

var $lRBAz = parcelRequire("lRBAz");
const $b41642a7c0ef06fe$var$Sidebar = ({ children: children, sidebarWidth: sidebarWidth, theme: theme })=>(0, $1ybV0.ff)('jsw.list.sidebar-layout-update') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: [
            (0, $1ybV0.ff)('jwm-sidebar-resizer-limit_4m1km') ? $b41642a7c0ef06fe$var$sidebarStyles : $b41642a7c0ef06fe$var$oldSidebarStyles,
            theme === 'business' && $b41642a7c0ef06fe$var$businessSidebarStyles
        ],
        // eslint-disable-next-line jira/react/no-style-attribute
        style: {
            width: sidebarWidth
        }
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lRBAz.SidebarOld), {
        sidebarWidth: sidebarWidth
    }, children);
const $b41642a7c0ef06fe$export$8295a33ab8a36876 = ({ children: children, theme: theme = 'business' })=>{
    (0, $h585o.useSidebarQueryParams)();
    const [{ content: content, sidebarWidth: sidebarWidth }, { setSidebarContent: setSidebarContent }] = (0, $hSCS8.useSidebar)();
    const { onMouseDown: onMouseDown, isResizing: isResizing } = (0, $h5BJf.useResizer)();
    // reset sidebar content on view unmount
    (0, $eUqFw.useEffect)(()=>()=>{
            setSidebarContent(null);
        }, [
        setSidebarContent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lRBAz.Wrapper), {
        isResizing: isResizing,
        "data-testid": "business-app-wrapper.ui.app-wrapper.sidebar-layout.sidebar-layout-wrapper"
    }, children, content && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b41642a7c0ef06fe$var$Sidebar, {
        sidebarWidth: sidebarWidth,
        theme: theme
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lRBAz.ResizeHandle), {
        onMouseDown: onMouseDown
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lRBAz.SidebarContent), null, content)));
};
const $b41642a7c0ef06fe$var$oldSidebarStyles = (0, $1ZAYh.xcss)({
    backgroundColor: 'elevation.surface',
    flexGrow: 0,
    flexShrink: 0,
    position: 'relative',
    zIndex: 'card'
});
const $b41642a7c0ef06fe$var$sidebarStyles = (0, $1ZAYh.xcss)({
    backgroundColor: 'elevation.surface',
    flexGrow: 0,
    flexShrink: 0,
    position: 'relative',
    zIndex: 'card',
    maxWidth: '75%'
});
const $b41642a7c0ef06fe$var$businessSidebarStyles = (0, $1ZAYh.xcss)({
    borderTopLeftRadius: 'border.radius.200',
    borderTopRightRadius: 'border.radius.200',
    boxShadow: 'elevation.shadow.overlay',
    marginRight: 'space.300',
    marginTop: 'space.300'
});

});
parcelRegister("h585o", function(module, exports) {

$parcel$export(module.exports, "useSidebarQueryParams", () => $357741b682c79613$export$34adbeffbeceba68);

var $eUqFw = parcelRequire("eUqFw");

var $jGcn0 = parcelRequire("jGcn0");

var $41WOo = parcelRequire("41WOo");

var $eI5EY = parcelRequire("eI5EY");

var $hzcvF = parcelRequire("hzcvF");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $iclz4 = parcelRequire("iclz4");

var $hSCS8 = parcelRequire("hSCS8");
const $357741b682c79613$var$isEscapeEvent = (e)=>e.key === 'Escape' || e.key === 'Esc' || e.keyCode === 27;
const $357741b682c79613$export$34adbeffbeceba68 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [{ content: content }, { setSidebarContent: setSidebarContent, resetSidebarQueryParams: resetSidebarQueryParams }] = (0, $hSCS8.useSidebar)();
    const sidebarQueryParams = (0, $hSCS8.getSidebarQueryParams)();
    const [queryParams, setQueryParams] = (0, $iclz4.useQueryParams)(...sidebarQueryParams);
    const prevQueryParams = (0, $hzcvF.usePreviousWithInitial)(queryParams);
    const closeSidebar = (0, $eUqFw.useCallback)(()=>{
        // reset sidebar query params (IssueApp, Comments)
        if ((0, $41WOo.isJwmInlineFieldCreateEnabled)()) resetSidebarQueryParams();
        else setQueryParams({
            [(0, $jGcn0.SELECTED_ISSUE_PARAM)]: undefined,
            [(0, $jGcn0.SELECTED_COMMENT_PARAM)]: undefined
        });
        // reset sidebar content
        setSidebarContent(null);
    }, [
        resetSidebarQueryParams,
        setQueryParams,
        setSidebarContent
    ]);
    // keep only one sidebar-related query param at the time
    (0, $eUqFw.useEffect)(()=>{
        if ((0, $41WOo.isJwmInlineFieldCreateEnabled)()) sidebarQueryParams.forEach((queryParam)=>{
            if (!prevQueryParams[queryParam] && queryParams[queryParam]) {
                const newQueryParams = sidebarQueryParams.filter((param)=>param !== queryParam).reduce((acc, param)=>Object.assign(acc, {
                        [param]: undefined
                    }), {});
                setQueryParams(newQueryParams);
            }
        });
        else {
            // clear "selectedComment=X" query param when IssueApp Sidebar is open
            if (!prevQueryParams[0, $jGcn0.SELECTED_ISSUE_PARAM] && queryParams[0, $jGcn0.SELECTED_ISSUE_PARAM]) setQueryParams({
                [(0, $jGcn0.SELECTED_COMMENT_PARAM)]: undefined
            });
            // clear "selectedIssue=X" query param when Comments sidebar is open
            if (!prevQueryParams[0, $jGcn0.SELECTED_COMMENT_PARAM] && queryParams[0, $jGcn0.SELECTED_COMMENT_PARAM]) setQueryParams({
                [(0, $jGcn0.SELECTED_ISSUE_PARAM)]: undefined
            });
        }
    }, [
        prevQueryParams,
        queryParams,
        setQueryParams,
        sidebarQueryParams
    ]);
    // handle closing sidebar on Escape
    (0, $eUqFw.useEffect)(()=>{
        const handleKeydown = (event)=>{
            if (!queryParams[0, $jGcn0.SELECTED_ISSUE_PARAM] && (0, $eI5EY.fg)('jira_list_keyboard_nav')) // sidebar is not open, exit
            return;
            if (queryParams[0, $jGcn0.SELECTED_ISSUE_PARAM] && content?.key === 'unscheduledSidebar') // should not close the sidebar if the sidebar and modal is open
            return;
            if ($357741b682c79613$var$isEscapeEvent(event)) {
                (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'sidebar closed', 'esc');
                closeSidebar();
            }
        };
        document.addEventListener('keydown', handleKeydown);
        return ()=>{
            document.removeEventListener('keydown', handleKeydown);
        };
    }, [
        closeSidebar,
        content?.key,
        createAnalyticsEvent,
        queryParams
    ]);
};

});

parcelRegister("h5BJf", function(module, exports) {

$parcel$export(module.exports, "useResizer", () => $2c653e9e7bda86ce$export$faede3f1542958fc);

var $eUqFw = parcelRequire("eUqFw");

var $a576Y = parcelRequire("a576Y");

var $hSCS8 = parcelRequire("hSCS8");
const $2c653e9e7bda86ce$var$THROTTLE_TIME = 16;
const $2c653e9e7bda86ce$export$faede3f1542958fc = ()=>{
    const [{ sidebarWidth: sidebarWidth }, { setSidebarWidth: setSidebarWidth }] = (0, $hSCS8.useSidebar)();
    const startRef = (0, $eUqFw.useRef)(0);
    // storing width in a ref to avoid re-creating onMouseMove handler during resize
    const width = (0, $eUqFw.useRef)(0);
    const [isResizing, setIsResizing] = (0, $eUqFw.useState)(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const resize = (0, $eUqFw.useCallback)((0, (/*@__PURE__*/$parcel$interopDefault($a576Y)))((clientX)=>{
        const proposedWidth = width.current + startRef.current - clientX;
        setSidebarWidth(proposedWidth);
    }, $2c653e9e7bda86ce$var$THROTTLE_TIME), [
        setSidebarWidth
    ]);
    const onMouseMove = (0, $eUqFw.useCallback)((event)=>{
        event.preventDefault();
        resize(event.clientX);
    }, [
        resize
    ]);
    const onMouseUp = (0, $eUqFw.useCallback)(()=>{
        startRef.current = 0;
        width.current = 0;
        setIsResizing(false);
        document.removeEventListener('mousemove', onMouseMove);
        document.removeEventListener('mouseup', onMouseUp);
    }, [
        onMouseMove
    ]);
    (0, $eUqFw.useEffect)(()=>()=>{
            document.removeEventListener('mousemove', onMouseMove);
            document.removeEventListener('mouseup', onMouseUp);
        }, [
        onMouseMove,
        onMouseUp
    ]);
    const onMouseDown = (0, $eUqFw.useCallback)((event)=>{
        startRef.current = event.clientX;
        width.current = sidebarWidth;
        setIsResizing(true);
        document.addEventListener('mousemove', onMouseMove);
        document.addEventListener('mouseup', onMouseUp);
    }, [
        onMouseMove,
        onMouseUp,
        sidebarWidth
    ]);
    return {
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        onMouseMove: onMouseMove,
        isResizing: isResizing
    };
};

});

parcelRegister("lRBAz", function(module, exports) {

$parcel$export(module.exports, "Wrapper", () => $8c2051301c5af547$export$e6dfd72ab29f8598);
$parcel$export(module.exports, "SidebarOld", () => $8c2051301c5af547$export$3c45ed53a787e357);
$parcel$export(module.exports, "SidebarContent", () => $8c2051301c5af547$export$49e8f7b58a4df4ea);
$parcel$export(module.exports, "ResizeHandle", () => $8c2051301c5af547$export$33f2411a0ad35be7);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");
const $8c2051301c5af547$var$SIDEBAR_Z_INDEX = 10;
const $8c2051301c5af547$export$e6dfd72ab29f8598 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isResizing: isResizing, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _16jlkb7n _1o9zkb7n _i0dlf1ug _4cvr1fhb _4t3i1osq",
            __cmplp.isResizing ? "_80omuf7j" : "_80om73ad",
            __cmplp.className
        ])
    });
});
const $8c2051301c5af547$export$3c45ed53a787e357 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { sidebarWidth: sidebarWidth, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_99zgm9": (0, $9t7rW.default)(`${__cmplp.sidebarWidth}px`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsbge8f _1o9zidpf _11q7vuon _2rko15h0 _kqswh2mm _18s8hhfb _16qszotn _1pbyzo7u",
            __cmplp.className
        ])
    });
});
const $8c2051301c5af547$export$49e8f7b58a4df4ea = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18m91wug _13wustnw _1igsidpf _184nidpf _bhl91osq _1j101bpf _134m1txw _sojr1h6o",
            __cmplp.className
        ])
    });
});
const $8c2051301c5af547$export$33f2411a0ad35be7 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1bsb1tcg _80omuf7j _kqswh2mm _1wpz1fhb _1pbybfng _1ltvxmi2 _4t3i1osq _aetrb3bt _16r2glyw _qc5othzt _18postnw _z0aiyh40 _15l2idpf _19doutpp _1qdg1osq _1jju194a _5u1r194a",
            __cmplp.className
        ])
    });
});

});


parcelRegister("2ESAZ", function(module, exports) {

$parcel$export(module.exports, "ThemedContainer", () => $c8a88c0524c1629a$export$2a4209ec8a7db359);
$parcel$export(module.exports, "ContentWrapper", () => $c8a88c0524c1629a$export$6ce170286acaa8d3);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ // eslint-disable-next-line jira/restricted/@atlassian+jira-common-styles

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $c9TLT = parcelRequire("c9TLT");
const $c8a88c0524c1629a$var$SIDEBAR_PADDING_HORIZONTAL_LEFT = (0, $c9TLT.gridSize) * 3;
const $c8a88c0524c1629a$var$SIDEBAR_PADDING_HORIZONTAL_RIGHT = (0, $c9TLT.gridSize);
const $c8a88c0524c1629a$export$2a4209ec8a7db359 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { withSidebar: withSidebar, withDynamicHeight: withDynamicHeight, shouldAddPadding: shouldAddPadding, isSidebarOpen: isSidebarOpen, withOverflow: withOverflow, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_vchhusvi _1e0c1txw _2lx21bp4 _1n261q9c _1bah1y6m _ca0qidpf",
            !__cmplp.withSidebar && "_syaz1c2q",
            __cmplp.withDynamicHeight ? "_4t3i1wug" : "_4t3i1osq",
            __cmplp.withDynamicHeight ? "_1tke1osq" : "_1tke1wug",
            !__cmplp.shouldAddPadding || __cmplp.isSidebarOpen ? "_u5f3idpf" : "_u5f31ejb",
            !__cmplp.shouldAddPadding || __cmplp.isSidebarOpen ? "_n3tdidpf" : "_n3td1ejb",
            __cmplp.shouldAddPadding ? "_19bv1ejb" : "_19bvidpf",
            __cmplp.withOverflow ? "_1reo1wug _18m91wug" : "_1reoewfl _18m9ewfl",
            __cmplp.className
        ])
    });
});
const $c8a88c0524c1629a$export$6ce170286acaa8d3 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isSidebarOpen: isSidebarOpen, sidebarWidth: sidebarWidth, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_k62x1i": (0, $9t7rW.default)(__cmplp.sidebarWidth + $c8a88c0524c1629a$var$SIDEBAR_PADDING_HORIZONTAL_LEFT + $c8a88c0524c1629a$var$SIDEBAR_PADDING_HORIZONTAL_RIGHT, "px")
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1c2q _1e0c1txw _2lx21bp4 _ca0qidpf _19bvidpf",
            __cmplp.isSidebarOpen ? "_1bsb1izx" : "_1bsb1osq",
            __cmplp.isSidebarOpen ? "_u5f31tcg" : "_u5f3idpf",
            __cmplp.isSidebarOpen ? "_n3td1ejb" : "_n3tdidpf",
            __cmplp.className
        ])
    });
});

});


parcelRegister("cWd72", function(module, exports) {

$parcel$export(module.exports, "IssueTypesAndFieldsContext", () => $c6421b4581e45226$export$31eaf35dc72d0fa0);

var $eUqFw = parcelRequire("eUqFw");

var $iZuDo = parcelRequire("iZuDo");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $gEmpR = parcelRequire("gEmpR");
// Replace with lodash/noop
// eslint-disable-next-line @typescript-eslint/no-empty-function
const $c6421b4581e45226$var$noop = ()=>{};
// track Apollo cache watchers 1 sec after availableFields query finishes to make sure UI is fully rendered
const $c6421b4581e45226$var$TRACKING_TIMEOUT = 1000;
const $c6421b4581e45226$export$31eaf35dc72d0fa0 = ({ children: children })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const client = (0, $iZuDo.useApolloClient)();
    const IssueTypesAndFieldsViewContextProps = (0, $gEmpR.useIssueTypesAndFieldsService)({
        issueOperation: 'VIEW'
    });
    const IssueTypesAndFieldsCreateContextProps = (0, $gEmpR.useIssueTypesAndFieldsService)({
        issueOperation: 'CREATE'
    });
    const loading = IssueTypesAndFieldsViewContextProps.loading || IssueTypesAndFieldsCreateContextProps.loading;
    (0, $eUqFw.useEffect)(()=>{
        if (loading) return $c6421b4581e45226$var$noop;
        const timeoutId = setTimeout(()=>{
            // tracking the number of Apollo cache watches
            // the lower the number, the faster UI
            (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'apolloCacheWatches created', {
                // @ts-expect-error - TS2551 - Property 'watches' does not exist on type 'ApolloCache<object>'. Did you mean 'watch'?
                watches: client?.cache?.watches?.size
            });
        }, $c6421b4581e45226$var$TRACKING_TIMEOUT);
        return ()=>{
            if (timeoutId) clearTimeout(timeoutId);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        createAnalyticsEvent,
        loading
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gEmpR.IssueTypesAndFieldsContextView).Provider, {
        value: IssueTypesAndFieldsViewContextProps
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gEmpR.IssueTypesAndFieldsContextCreate).Provider, {
        value: IssueTypesAndFieldsCreateContextProps
    }, children));
};

});
parcelRegister("iZuDo", function(module, exports) {

$parcel$export(module.exports, "useQuery", () => $dd35afdbf6e72e7e$export$dd0a697e1782aedd);
$parcel$export(module.exports, "useLazyQuery", () => $dd35afdbf6e72e7e$export$fd83eea6ecd2d8fa);
$parcel$export(module.exports, "useMutation", () => $dd35afdbf6e72e7e$export$609860bf8b0084c);
$parcel$export(module.exports, "useApolloClient", () => $dd35afdbf6e72e7e$export$eb9a56e7a29e494);

var $4ErPU = parcelRequire("4ErPU");

var $fKE23 = parcelRequire("fKE23");

var $eUqFw = parcelRequire("eUqFw");

var $jlBDe = parcelRequire("jlBDe");

var $66hGB = parcelRequire("66hGB");

var $8j2fP = parcelRequire("8j2fP");
var $dd35afdbf6e72e7e$var$OperationData = function() {
    function OperationData(options, context) {
        this.isMounted = false;
        this.previousOptions = {};
        this.context = {};
        this.options = {};
        this.options = options || {};
        this.context = context || {};
    }
    OperationData.prototype.getOptions = function() {
        return this.options;
    };
    OperationData.prototype.setOptions = function(newOptions, storePrevious) {
        if (storePrevious === void 0) storePrevious = false;
        if (storePrevious && !(0, $66hGB.equal)(this.options, newOptions)) this.previousOptions = this.options;
        this.options = newOptions;
    };
    OperationData.prototype.unmount = function() {
        this.isMounted = false;
    };
    OperationData.prototype.refreshClient = function() {
        var client = this.options && this.options.client || this.context && this.context.client;
        (0, $8j2fP.invariant)(!!client, 2);
        var isNew = false;
        if (client !== this.client) {
            isNew = true;
            this.client = client;
            this.cleanup();
        }
        return {
            client: this.client,
            isNew: isNew
        };
    };
    OperationData.prototype.verifyDocumentType = function(document, type) {
        var operation = (0, $4ErPU.parser)(document);
        var requiredOperationName = (0, $4ErPU.operationName)(type);
        var usedOperationName = (0, $4ErPU.operationName)(operation.type);
        (0, $8j2fP.invariant)(operation.type === type, 3);
    };
    return OperationData;
}();
var $dd35afdbf6e72e7e$var$QueryData = function(_super) {
    (0, $fKE23.__extends)(QueryData, _super);
    function QueryData(_a) {
        var options = _a.options, context = _a.context, forceUpdate = _a.forceUpdate;
        var _this = _super.call(this, options, context) || this;
        _this.previousData = {};
        _this.currentObservable = {};
        _this.runLazy = false;
        _this.runLazyQuery = function(options) {
            _this.cleanup();
            _this.runLazy = true;
            _this.lazyOptions = options;
            _this.forceUpdate();
        };
        _this.getExecuteResult = function() {
            var result = _this.getQueryResult();
            _this.startQuerySubscription();
            return result;
        };
        _this.obsRefetch = function(variables) {
            return _this.currentObservable.query.refetch(variables);
        };
        _this.obsFetchMore = function(fetchMoreOptions) {
            return _this.currentObservable.query.fetchMore(fetchMoreOptions);
        };
        _this.obsUpdateQuery = function(mapFn) {
            return _this.currentObservable.query.updateQuery(mapFn);
        };
        _this.obsStartPolling = function(pollInterval) {
            _this.currentObservable && _this.currentObservable.query && _this.currentObservable.query.startPolling(pollInterval);
        };
        _this.obsStopPolling = function() {
            _this.currentObservable && _this.currentObservable.query && _this.currentObservable.query.stopPolling();
        };
        _this.obsSubscribeToMore = function(options) {
            return _this.currentObservable.query.subscribeToMore(options);
        };
        _this.forceUpdate = forceUpdate;
        return _this;
    }
    QueryData.prototype.execute = function() {
        this.refreshClient();
        var _a = this.getOptions(), skip = _a.skip, query = _a.query;
        if (skip || query !== this.previousData.query) {
            this.removeQuerySubscription();
            this.previousData.query = query;
        }
        this.updateObservableQuery();
        if (this.isMounted) this.startQuerySubscription();
        return this.getExecuteSsrResult() || this.getExecuteResult();
    };
    QueryData.prototype.executeLazy = function() {
        return !this.runLazy ? [
            this.runLazyQuery,
            {
                loading: false,
                networkStatus: (0, $jlBDe.NetworkStatus).ready,
                called: false,
                data: undefined
            }
        ] : [
            this.runLazyQuery,
            this.execute()
        ];
    };
    QueryData.prototype.fetchData = function() {
        var options = this.getOptions();
        if (options.skip || options.ssr === false) return false;
        var obs = this.currentObservable.query;
        var currentResult = obs.getCurrentResult();
        return currentResult.loading ? obs.result() : false;
    };
    QueryData.prototype.afterExecute = function(_a) {
        var _this = this;
        var _b = (_a === void 0 ? {} : _a).lazy, lazy = _b === void 0 ? false : _b;
        this.isMounted = true;
        if (!lazy || this.runLazy) {
            this.handleErrorOrCompleted();
            setTimeout(function() {
                _this.currentObservable.query && _this.currentObservable.query.resetQueryStoreErrors();
            });
        }
        this.previousOptions = this.getOptions();
        return this.unmount.bind(this);
    };
    QueryData.prototype.cleanup = function() {
        this.removeQuerySubscription();
        delete this.currentObservable.query;
        delete this.previousData.result;
    };
    QueryData.prototype.getOptions = function() {
        var options = _super.prototype.getOptions.call(this);
        if (this.lazyOptions) {
            options.variables = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, options.variables), this.lazyOptions.variables);
            options.context = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, options.context), this.lazyOptions.context);
        }
        if (this.runLazy) delete options.skip;
        return options;
    };
    QueryData.prototype.getExecuteSsrResult = function() {
        var treeRenderingInitiated = this.context && this.context.renderPromises;
        var ssrDisabled = this.getOptions().ssr === false;
        var fetchDisabled = this.refreshClient().client.disableNetworkFetches;
        var ssrLoading = {
            loading: true,
            networkStatus: (0, $jlBDe.NetworkStatus).loading,
            called: true,
            data: undefined
        };
        if (ssrDisabled && (treeRenderingInitiated || fetchDisabled)) return ssrLoading;
        var result;
        if (treeRenderingInitiated) result = this.context.renderPromises.addQueryPromise(this, this.getExecuteResult) || ssrLoading;
        return result;
    };
    QueryData.prototype.prepareObservableQueryOptions = function() {
        var options = this.getOptions();
        this.verifyDocumentType(options.query, (0, $4ErPU.DocumentType).Query);
        var displayName = options.displayName || 'Query';
        if (this.context && this.context.renderPromises && (options.fetchPolicy === 'network-only' || options.fetchPolicy === 'cache-and-network')) options.fetchPolicy = 'cache-first';
        return (0, $fKE23.__assign)((0, $fKE23.__assign)({}, options), {
            displayName: displayName,
            context: options.context,
            metadata: {
                reactComponent: {
                    displayName: displayName
                }
            }
        });
    };
    QueryData.prototype.initializeObservableQuery = function() {
        if (this.context && this.context.renderPromises) this.currentObservable.query = this.context.renderPromises.getSSRObservable(this.getOptions());
        if (!this.currentObservable.query) {
            var observableQueryOptions = this.prepareObservableQueryOptions();
            this.previousData.observableQueryOptions = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, observableQueryOptions), {
                children: null
            });
            this.currentObservable.query = this.refreshClient().client.watchQuery((0, $fKE23.__assign)({}, observableQueryOptions));
            if (this.context && this.context.renderPromises) this.context.renderPromises.registerSSRObservable(this.currentObservable.query, observableQueryOptions);
        }
    };
    QueryData.prototype.updateObservableQuery = function() {
        if (!this.currentObservable.query) {
            this.initializeObservableQuery();
            return;
        }
        var newObservableQueryOptions = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, this.prepareObservableQueryOptions()), {
            children: null
        });
        if (!(0, $66hGB.equal)(newObservableQueryOptions, this.previousData.observableQueryOptions)) {
            this.previousData.observableQueryOptions = newObservableQueryOptions;
            this.currentObservable.query.setOptions(newObservableQueryOptions).catch(function() {});
        }
    };
    QueryData.prototype.startQuerySubscription = function() {
        var _this = this;
        if (this.currentObservable.subscription || this.getOptions().skip) return;
        var obsQuery = this.currentObservable.query;
        this.currentObservable.subscription = obsQuery.subscribe({
            next: function(_a) {
                var loading = _a.loading, networkStatus = _a.networkStatus, data = _a.data;
                var previousResult = _this.previousData.result;
                if (previousResult && previousResult.loading === loading && previousResult.networkStatus === networkStatus && (0, $66hGB.equal)(previousResult.data, data)) return;
                _this.forceUpdate();
            },
            error: function(error) {
                _this.resubscribeToQuery();
                if (!error.hasOwnProperty('graphQLErrors')) throw error;
                var previousResult = _this.previousData.result;
                if (previousResult && previousResult.loading || !(0, $66hGB.equal)(error, _this.previousData.error)) {
                    _this.previousData.error = error;
                    _this.forceUpdate();
                }
            }
        });
    };
    QueryData.prototype.resubscribeToQuery = function() {
        this.removeQuerySubscription();
        var lastError = this.currentObservable.query.getLastError();
        var lastResult = this.currentObservable.query.getLastResult();
        this.currentObservable.query.resetLastResults();
        this.startQuerySubscription();
        Object.assign(this.currentObservable.query, {
            lastError: lastError,
            lastResult: lastResult
        });
    };
    QueryData.prototype.getQueryResult = function() {
        var result = this.observableQueryFields();
        var options = this.getOptions();
        if (options.skip) result = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, result), {
            data: undefined,
            error: undefined,
            loading: false,
            called: true
        });
        else {
            var currentResult = this.currentObservable.query.getCurrentResult();
            var loading = currentResult.loading, partial = currentResult.partial, networkStatus = currentResult.networkStatus, errors = currentResult.errors;
            var error = currentResult.error, data = currentResult.data;
            if (errors && errors.length > 0) error = new (0, $jlBDe.ApolloError)({
                graphQLErrors: errors
            });
            result = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, result), {
                loading: loading,
                networkStatus: networkStatus,
                error: error,
                called: true
            });
            if (loading) {
                var previousData = this.previousData.result && this.previousData.result.data;
                result.data = previousData && data ? (0, $fKE23.__assign)((0, $fKE23.__assign)({}, previousData), data) : previousData || data;
            } else if (error) Object.assign(result, {
                data: (this.currentObservable.query.getLastResult() || {}).data
            });
            else {
                var fetchPolicy = this.currentObservable.query.options.fetchPolicy;
                var partialRefetch = options.partialRefetch;
                if (partialRefetch && !data && partial && fetchPolicy !== 'cache-only') {
                    Object.assign(result, {
                        loading: true,
                        networkStatus: (0, $jlBDe.NetworkStatus).loading
                    });
                    result.refetch();
                    return result;
                }
                result.data = data;
            }
        }
        result.client = this.client;
        this.previousData.loading = this.previousData.result && this.previousData.result.loading || false;
        this.previousData.result = result;
        return result;
    };
    QueryData.prototype.handleErrorOrCompleted = function() {
        var obsQuery = this.currentObservable.query;
        if (!obsQuery) return;
        var _a = obsQuery.getCurrentResult(), data = _a.data, loading = _a.loading, error = _a.error;
        if (!loading) {
            var _b = this.getOptions(), query = _b.query, variables = _b.variables, onCompleted = _b.onCompleted, onError = _b.onError;
            if (this.previousOptions && !this.previousData.loading && (0, $66hGB.equal)(this.previousOptions.query, query) && (0, $66hGB.equal)(this.previousOptions.variables, variables)) return;
            if (onCompleted && !error) onCompleted(data);
            else if (onError && error) onError(error);
        }
    };
    QueryData.prototype.removeQuerySubscription = function() {
        if (this.currentObservable.subscription) {
            this.currentObservable.subscription.unsubscribe();
            delete this.currentObservable.subscription;
        }
    };
    QueryData.prototype.observableQueryFields = function() {
        var observable = this.currentObservable.query;
        return {
            variables: observable.variables,
            refetch: this.obsRefetch,
            fetchMore: this.obsFetchMore,
            updateQuery: this.obsUpdateQuery,
            startPolling: this.obsStartPolling,
            stopPolling: this.obsStopPolling,
            subscribeToMore: this.obsSubscribeToMore
        };
    };
    return QueryData;
}($dd35afdbf6e72e7e$var$OperationData);
function $dd35afdbf6e72e7e$var$useDeepMemo(memoFn, key) {
    var ref = (0, $eUqFw.useRef)();
    if (!ref.current || !(0, $66hGB.equal)(key, ref.current.key)) ref.current = {
        key: key,
        value: memoFn()
    };
    return ref.current.value;
}
function $dd35afdbf6e72e7e$var$useBaseQuery(query, options, lazy) {
    if (lazy === void 0) lazy = false;
    var context = (0, $eUqFw.useContext)((0, $4ErPU.getApolloContext)());
    var _a = (0, $eUqFw.useReducer)(function(x) {
        return x + 1;
    }, 0), tick = _a[0], forceUpdate = _a[1];
    var updatedOptions = options ? (0, $fKE23.__assign)((0, $fKE23.__assign)({}, options), {
        query: query
    }) : {
        query: query
    };
    var queryDataRef = (0, $eUqFw.useRef)();
    if (!queryDataRef.current) queryDataRef.current = new $dd35afdbf6e72e7e$var$QueryData({
        options: updatedOptions,
        context: context,
        forceUpdate: forceUpdate
    });
    var queryData = queryDataRef.current;
    queryData.setOptions(updatedOptions);
    queryData.context = context;
    var memo = {
        options: (0, $fKE23.__assign)((0, $fKE23.__assign)({}, updatedOptions), {
            onError: undefined,
            onCompleted: undefined
        }),
        context: context,
        tick: tick
    };
    var result = $dd35afdbf6e72e7e$var$useDeepMemo(function() {
        return lazy ? queryData.executeLazy() : queryData.execute();
    }, memo);
    var queryResult = lazy ? result[1] : result;
    (0, $eUqFw.useEffect)(function() {
        return queryData.afterExecute({
            lazy: lazy
        });
    }, [
        queryResult.loading,
        queryResult.networkStatus,
        queryResult.error,
        queryResult.data
    ]);
    (0, $eUqFw.useEffect)(function() {
        return function() {
            return queryData.cleanup();
        };
    }, []);
    return result;
}
function $dd35afdbf6e72e7e$export$dd0a697e1782aedd(query, options) {
    return $dd35afdbf6e72e7e$var$useBaseQuery(query, options, false);
}
function $dd35afdbf6e72e7e$export$fd83eea6ecd2d8fa(query, options) {
    return $dd35afdbf6e72e7e$var$useBaseQuery(query, options, true);
}
var $dd35afdbf6e72e7e$var$MutationData = function(_super) {
    (0, $fKE23.__extends)(MutationData, _super);
    function MutationData(_a) {
        var options = _a.options, context = _a.context, result = _a.result, setResult = _a.setResult;
        var _this = _super.call(this, options, context) || this;
        _this.runMutation = function(mutationFunctionOptions) {
            if (mutationFunctionOptions === void 0) mutationFunctionOptions = {};
            _this.onMutationStart();
            var mutationId = _this.generateNewMutationId();
            return _this.mutate(mutationFunctionOptions).then(function(response) {
                _this.onMutationCompleted(response, mutationId);
                return response;
            }).catch(function(error) {
                _this.onMutationError(error, mutationId);
                if (!_this.getOptions().onError) throw error;
            });
        };
        _this.verifyDocumentType(options.mutation, (0, $4ErPU.DocumentType).Mutation);
        _this.result = result;
        _this.setResult = setResult;
        _this.mostRecentMutationId = 0;
        return _this;
    }
    MutationData.prototype.execute = function(result) {
        this.isMounted = true;
        this.verifyDocumentType(this.getOptions().mutation, (0, $4ErPU.DocumentType).Mutation);
        result.client = this.refreshClient().client;
        return [
            this.runMutation,
            result
        ];
    };
    MutationData.prototype.afterExecute = function() {
        this.isMounted = true;
        return this.unmount.bind(this);
    };
    MutationData.prototype.cleanup = function() {};
    MutationData.prototype.mutate = function(mutationFunctionOptions) {
        var _a = this.getOptions(), mutation = _a.mutation, variables = _a.variables, optimisticResponse = _a.optimisticResponse, update = _a.update, _b = _a.context, mutationContext = _b === void 0 ? {} : _b, _c = _a.awaitRefetchQueries, awaitRefetchQueries = _c === void 0 ? false : _c, fetchPolicy = _a.fetchPolicy;
        var mutateOptions = (0, $fKE23.__assign)({}, mutationFunctionOptions);
        var mutateVariables = Object.assign({}, variables, mutateOptions.variables);
        delete mutateOptions.variables;
        return this.refreshClient().client.mutate((0, $fKE23.__assign)({
            mutation: mutation,
            optimisticResponse: optimisticResponse,
            refetchQueries: mutateOptions.refetchQueries || this.getOptions().refetchQueries,
            awaitRefetchQueries: awaitRefetchQueries,
            update: update,
            context: mutationContext,
            fetchPolicy: fetchPolicy,
            variables: mutateVariables
        }, mutateOptions));
    };
    MutationData.prototype.onMutationStart = function() {
        if (!this.result.loading && !this.getOptions().ignoreResults) this.updateResult({
            loading: true,
            error: undefined,
            data: undefined,
            called: true
        });
    };
    MutationData.prototype.onMutationCompleted = function(response, mutationId) {
        var _a = this.getOptions(), onCompleted = _a.onCompleted, ignoreResults = _a.ignoreResults;
        var data = response.data, errors = response.errors;
        var error = errors && errors.length > 0 ? new (0, $jlBDe.ApolloError)({
            graphQLErrors: errors
        }) : undefined;
        var callOncomplete = function() {
            return onCompleted ? onCompleted(data) : null;
        };
        if (this.isMostRecentMutation(mutationId) && !ignoreResults) this.updateResult({
            called: true,
            loading: false,
            data: data,
            error: error
        });
        callOncomplete();
    };
    MutationData.prototype.onMutationError = function(error, mutationId) {
        var onError = this.getOptions().onError;
        if (this.isMostRecentMutation(mutationId)) this.updateResult({
            loading: false,
            error: error,
            data: undefined,
            called: true
        });
        if (onError) onError(error);
    };
    MutationData.prototype.generateNewMutationId = function() {
        return ++this.mostRecentMutationId;
    };
    MutationData.prototype.isMostRecentMutation = function(mutationId) {
        return this.mostRecentMutationId === mutationId;
    };
    MutationData.prototype.updateResult = function(result) {
        if (this.isMounted && (!this.previousResult || !(0, $66hGB.equal)(this.previousResult, result))) {
            this.setResult(result);
            this.previousResult = result;
        }
    };
    return MutationData;
}($dd35afdbf6e72e7e$var$OperationData);
function $dd35afdbf6e72e7e$export$609860bf8b0084c(mutation, options) {
    var context = (0, $eUqFw.useContext)((0, $4ErPU.getApolloContext)());
    var _a = (0, $eUqFw.useState)({
        called: false,
        loading: false
    }), result = _a[0], setResult = _a[1];
    var updatedOptions = options ? (0, $fKE23.__assign)((0, $fKE23.__assign)({}, options), {
        mutation: mutation
    }) : {
        mutation: mutation
    };
    var mutationDataRef = (0, $eUqFw.useRef)();
    function getMutationDataRef() {
        if (!mutationDataRef.current) mutationDataRef.current = new $dd35afdbf6e72e7e$var$MutationData({
            options: updatedOptions,
            context: context,
            result: result,
            setResult: setResult
        });
        return mutationDataRef.current;
    }
    var mutationData = getMutationDataRef();
    mutationData.setOptions(updatedOptions);
    mutationData.context = context;
    (0, $eUqFw.useEffect)(function() {
        return mutationData.afterExecute();
    });
    return mutationData.execute(result);
}
var $dd35afdbf6e72e7e$var$SubscriptionData = function(_super) {
    (0, $fKE23.__extends)(SubscriptionData, _super);
    function SubscriptionData(_a) {
        var options = _a.options, context = _a.context, setResult = _a.setResult;
        var _this = _super.call(this, options, context) || this;
        _this.currentObservable = {};
        _this.setResult = setResult;
        _this.initialize(options);
        return _this;
    }
    SubscriptionData.prototype.execute = function(result) {
        if (this.getOptions().skip === true) {
            this.cleanup();
            return {
                loading: false,
                error: undefined,
                data: undefined,
                variables: this.getOptions().variables
            };
        }
        var currentResult = result;
        if (this.refreshClient().isNew) currentResult = this.getLoadingResult();
        var shouldResubscribe = this.getOptions().shouldResubscribe;
        if (typeof shouldResubscribe === 'function') shouldResubscribe = !!shouldResubscribe(this.getOptions());
        if (shouldResubscribe !== false && this.previousOptions && Object.keys(this.previousOptions).length > 0 && (this.previousOptions.subscription !== this.getOptions().subscription || !(0, $66hGB.equal)(this.previousOptions.variables, this.getOptions().variables) || this.previousOptions.skip !== this.getOptions().skip)) {
            this.cleanup();
            currentResult = this.getLoadingResult();
        }
        this.initialize(this.getOptions());
        this.startSubscription();
        this.previousOptions = this.getOptions();
        return (0, $fKE23.__assign)((0, $fKE23.__assign)({}, currentResult), {
            variables: this.getOptions().variables
        });
    };
    SubscriptionData.prototype.afterExecute = function() {
        this.isMounted = true;
    };
    SubscriptionData.prototype.cleanup = function() {
        this.endSubscription();
        delete this.currentObservable.query;
    };
    SubscriptionData.prototype.initialize = function(options) {
        if (this.currentObservable.query || this.getOptions().skip === true) return;
        this.currentObservable.query = this.refreshClient().client.subscribe({
            query: options.subscription,
            variables: options.variables,
            fetchPolicy: options.fetchPolicy
        });
    };
    SubscriptionData.prototype.startSubscription = function() {
        if (this.currentObservable.subscription) return;
        this.currentObservable.subscription = this.currentObservable.query.subscribe({
            next: this.updateCurrentData.bind(this),
            error: this.updateError.bind(this),
            complete: this.completeSubscription.bind(this)
        });
    };
    SubscriptionData.prototype.getLoadingResult = function() {
        return {
            loading: true,
            error: undefined,
            data: undefined
        };
    };
    SubscriptionData.prototype.updateResult = function(result) {
        if (this.isMounted) this.setResult(result);
    };
    SubscriptionData.prototype.updateCurrentData = function(result) {
        var onSubscriptionData = this.getOptions().onSubscriptionData;
        this.updateResult({
            data: result.data,
            loading: false,
            error: undefined
        });
        if (onSubscriptionData) onSubscriptionData({
            client: this.refreshClient().client,
            subscriptionData: result
        });
    };
    SubscriptionData.prototype.updateError = function(error) {
        this.updateResult({
            error: error,
            loading: false
        });
    };
    SubscriptionData.prototype.completeSubscription = function() {
        var onSubscriptionComplete = this.getOptions().onSubscriptionComplete;
        if (onSubscriptionComplete) onSubscriptionComplete();
        this.endSubscription();
    };
    SubscriptionData.prototype.endSubscription = function() {
        if (this.currentObservable.subscription) {
            this.currentObservable.subscription.unsubscribe();
            delete this.currentObservable.subscription;
        }
    };
    return SubscriptionData;
}($dd35afdbf6e72e7e$var$OperationData);
function $dd35afdbf6e72e7e$export$368b4214baeb914c(subscription, options) {
    var context = (0, $eUqFw.useContext)((0, $4ErPU.getApolloContext)());
    var updatedOptions = options ? (0, $fKE23.__assign)((0, $fKE23.__assign)({}, options), {
        subscription: subscription
    }) : {
        subscription: subscription
    };
    var _a = (0, $eUqFw.useState)({
        loading: !updatedOptions.skip,
        error: undefined,
        data: undefined
    }), result = _a[0], setResult = _a[1];
    var subscriptionDataRef = (0, $eUqFw.useRef)();
    function getSubscriptionDataRef() {
        if (!subscriptionDataRef.current) subscriptionDataRef.current = new $dd35afdbf6e72e7e$var$SubscriptionData({
            options: updatedOptions,
            context: context,
            setResult: setResult
        });
        return subscriptionDataRef.current;
    }
    var subscriptionData = getSubscriptionDataRef();
    subscriptionData.setOptions(updatedOptions, true);
    subscriptionData.context = context;
    (0, $eUqFw.useEffect)(function() {
        return subscriptionData.afterExecute();
    });
    (0, $eUqFw.useEffect)(function() {
        return subscriptionData.cleanup.bind(subscriptionData);
    }, []);
    return subscriptionData.execute(result);
}
function $dd35afdbf6e72e7e$export$eb9a56e7a29e494() {
    var client = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useContext((0, $4ErPU.getApolloContext)()).client;
    (0, $8j2fP.invariant)(client, 1);
    return client;
}
function $dd35afdbf6e72e7e$var$makeDefaultQueryInfo() {
    return {
        seen: false,
        observable: null
    };
}
var $dd35afdbf6e72e7e$export$260e90e395a79974 = function() {
    function RenderPromises() {
        this.queryPromises = new Map();
        this.queryInfoTrie = new Map();
    }
    RenderPromises.prototype.registerSSRObservable = function(observable, props) {
        this.lookupQueryInfo(props).observable = observable;
    };
    RenderPromises.prototype.getSSRObservable = function(props) {
        return this.lookupQueryInfo(props).observable;
    };
    RenderPromises.prototype.addQueryPromise = function(queryInstance, finish) {
        var info = this.lookupQueryInfo(queryInstance.getOptions());
        if (!info.seen) {
            this.queryPromises.set(queryInstance.getOptions(), new Promise(function(resolve) {
                resolve(queryInstance.fetchData());
            }));
            return null;
        }
        return finish();
    };
    RenderPromises.prototype.hasPromises = function() {
        return this.queryPromises.size > 0;
    };
    RenderPromises.prototype.consumeAndAwaitPromises = function() {
        var _this = this;
        var promises = [];
        this.queryPromises.forEach(function(promise, queryInstance) {
            _this.lookupQueryInfo(queryInstance).seen = true;
            promises.push(promise);
        });
        this.queryPromises.clear();
        return Promise.all(promises);
    };
    RenderPromises.prototype.lookupQueryInfo = function(props) {
        var queryInfoTrie = this.queryInfoTrie;
        var query = props.query, variables = props.variables;
        var varMap = queryInfoTrie.get(query) || new Map();
        if (!queryInfoTrie.has(query)) queryInfoTrie.set(query, varMap);
        var variablesString = JSON.stringify(variables);
        var info = varMap.get(variablesString) || $dd35afdbf6e72e7e$var$makeDefaultQueryInfo();
        if (!varMap.has(variablesString)) varMap.set(variablesString, info);
        return info;
    };
    return RenderPromises;
}();

});

parcelRegister("gEmpR", function(module, exports) {

$parcel$export(module.exports, "useIssueTypesAndFieldsService", () => $0655e80332547c29$export$3ef3324b7f7d6a38);
$parcel$export(module.exports, "IssueTypesAndFieldsContextView", () => $0655e80332547c29$export$77937175321fab39);
$parcel$export(module.exports, "IssueTypesAndFieldsContextCreate", () => $0655e80332547c29$export$fbd286e14113bfc);
$parcel$export(module.exports, "useIssueTypesAndFields", () => $0655e80332547c29$export$d2121b02f0b65782);

var $eUqFw = parcelRequire("eUqFw");

var $iZuDo = parcelRequire("iZuDo");

var $ZvXTS = parcelRequire("ZvXTS");

var $guiFP = parcelRequire("guiFP");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $kJlBc = parcelRequire("kJlBc");

var $9zYls = parcelRequire("9zYls");

var $i2apV = parcelRequire("i2apV");

var $2RZxj = parcelRequire("2RZxj");

const $0655e80332547c29$export$d7241b17c19f0a9c = 'PROJECT_NOT_FOUND';
const $0655e80332547c29$export$4c72baf45fce4585 = 'VIEW_PROJECT_PERMISSION_ERROR';
const $0655e80332547c29$var$isProjectPermissionError = (error)=>error.message.indexOf($0655e80332547c29$export$d7241b17c19f0a9c) > -1 || error.message.indexOf($0655e80332547c29$export$4c72baf45fce4585) > -1 || // @ts-expect-error TS2339 - Property 'extensions' does not exist on type 'ApolloError'
    error.extensions?.statusCode === 403 || // @ts-expect-error TS2339 - Property 'extensions' does not exist on type 'ApolloError'
    error.extensions?.statusCode === 404;
const $0655e80332547c29$export$6b9bc8a33ade0736 = (input)=>{
    const [routerState] = (0, $kJlBc.useRouter)();
    const { projectKey: projectKey } = (0, $9zYls.getProjectKeyId)(routerState?.match, routerState?.query);
    const variables = (0, $eUqFw.useMemo)(()=>({
            projectKey: projectKey,
            issueOperation: // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            input.issueOperation,
            first: 100
        }), [
        input.issueOperation,
        projectKey
    ]);
    const { query: query, view: view } = // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly "classic-business-form": { readonly view: "Form"; readonly query: DocumentNode; }; readonly "classic-business-form-submit": { readonly view: "FormSubmit"; readonly query: DocumentNode; }; ... 8 more ...; readonly default: { ...; }; }'.
    (0, $2RZxj.JWMQueryByRouteMap)?.[routerState?.route?.name] ?? (0, $2RZxj.JWMQueryByRouteMap)[0, $i2apV.DEFAULT];
    return (0, $eUqFw.useMemo)(()=>({
            loading: false,
            query: query,
            view: view,
            variables: variables
        }), [
        query,
        view,
        variables
    ]);
};
const $0655e80332547c29$export$1768f0a0f85b4de9 = (input)=>{
    const client = (0, $iZuDo.useApolloClient)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { variables: queryVariables, query: query } = $0655e80332547c29$export$6b9bc8a33ade0736(input);
    const analyticsTaskName = 'useIssueTypesAndFieldsCacheApolloCacheActions';
    return (0, $eUqFw.useCallback)(({ findField: findField, updateItem: updateItem })=>{
        const getCacheData = ()=>{
            try {
                const read = client.readQuery({
                    query: query,
                    variables: queryVariables
                });
                (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), 'apolloCacheRead taskSuccess', {
                    task: analyticsTaskName
                });
                return read;
            } catch (e) {
                (0, $guiFP.default)({
                    error: e instanceof Error ? e : new Error('Unknown cache read error'),
                    meta: {
                        id: 'useIssueTypesAndFieldsCache',
                        packageName: 'jiraBusinessEntityProject',
                        teamName: 'wanjel'
                    },
                    sendToPrivacyUnsafeSplunk: true,
                    skipSentry: true,
                    attributes: {
                        task: analyticsTaskName,
                        query: JSON.stringify(query),
                        variables: JSON.stringify(queryVariables),
                        eventName: 'apolloCacheRead taskFail',
                        error: JSON.stringify(e)
                    }
                });
                return null;
            }
        };
        const cacheData = getCacheData();
        const existingEdges = cacheData?.jiraBusinessAvailableFields?.edges;
        if (existingEdges == null) return;
        let shouldUpdate = false;
        const newEdges = existingEdges.map((edge)=>{
            const existingFields = edge?.node?.fields?.edges;
            if (existingFields == null) return edge;
            const itemToUpdateIndex = existingFields.findIndex((fieldEdge)=>findField ? findField(fieldEdge?.node) : false) ?? undefined;
            const existingField = existingFields[itemToUpdateIndex]?.node;
            if (itemToUpdateIndex === undefined || itemToUpdateIndex === -1 || existingField == null) return edge;
            const itemOverride = updateItem(existingField);
            if (itemOverride === undefined) return edge;
            const newFields = [
                ...existingFields
            ];
            newFields[itemToUpdateIndex] = {
                node: itemOverride,
                __typename: 'JiraIssueFieldEdge'
            };
            shouldUpdate = true;
            return {
                ...edge,
                node: {
                    ...edge?.node || {},
                    fields: {
                        edges: newFields,
                        __typename: 'JiraIssueFieldConnection'
                    }
                }
            };
        });
        if (!shouldUpdate) return;
        const newData = {
            ...cacheData,
            jiraBusinessAvailableFields: {
                ...cacheData?.jiraBusinessAvailableFields || {},
                edges: newEdges
            }
        };
        try {
            client.writeQuery({
                query: query,
                variables: queryVariables,
                // @ts-expect-error - TS2345 - Argument of type '{ query: any; variables: { projectId: number | undefined; issueOperation: IssueOperation; first: number; } | undefined; notifyOnNetworkStatusChange: boolean; data: { jiraBusinessAvailableFields: { ...; }; }; }' is not assignable to parameter of type 'WriteQueryOptions<{ jiraBusinessAvailableFields: { edges: (JiraBusinessAvailableFieldsListView_jiraBusinessAvailableFields_edges | { ...; } | null)[]; __typename?: "JiraBusinessAvailableFieldsConnection" | undefined; }; }, { ...; }>'.
                notifyOnNetworkStatusChange: true,
                data: newData
            });
            (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), 'apolloCacheWrite taskSuccess', {
                task: analyticsTaskName
            });
        } catch (e) {
            (0, $guiFP.default)({
                error: e instanceof Error ? e : new Error('Unknown cache write error'),
                meta: {
                    id: 'useIssueTypesAndFieldsCache',
                    packageName: 'jiraBusinessEntityProject',
                    teamName: 'wanjel'
                },
                sendToPrivacyUnsafeSplunk: true,
                skipSentry: true,
                attributes: {
                    task: analyticsTaskName,
                    query: JSON.stringify(query),
                    variables: JSON.stringify(queryVariables),
                    eventName: 'apolloCacheWrite taskFail',
                    error: JSON.stringify(e)
                }
            });
        }
    }, [
        client,
        createAnalyticsEvent,
        query,
        queryVariables
    ]);
};
const $0655e80332547c29$export$3ef3324b7f7d6a38 = (input)=>{
    const [hasStartedFetchingFields, setHasStartedFetchingFields] = (0, $eUqFw.useState)(false);
    const fetchAttempts = (0, $eUqFw.useRef)(0);
    const { variables: queryVariables, loading: isQueryLoading, query: query, view: view } = $0655e80332547c29$export$6b9bc8a33ade0736(input);
    const [getAvailableFields, { data: data, called: called, loading: loading, error: error, refetch: refetchQuery }] = (0, $iZuDo.useLazyQuery)(query, {
        variables: queryVariables,
        fetchPolicy: 'cache-first',
        onError: (apolloError)=>{
            (0, $ZvXTS.markViewMetric)(view.toLowerCase(), (0, $78bb8734d7176028$export$ac953882305d6102));
            // do not fire error if user doesn't have project permissions
            if ($0655e80332547c29$var$isProjectPermissionError(apolloError)) return;
            (0, $guiFP.default)({
                meta: {
                    id: `availableFields${view}ViewQuery`,
                    packageName: 'jiraBusinessEntityProject',
                    teamName: 'wanjel'
                },
                attributes: {
                    message: `Failed to fetch available fields in ${view} view`
                },
                error: apolloError,
                sendToPrivacyUnsafeSplunk: true
            });
        },
        onCompleted: (onCompletedData)=>{
            (0, $ZvXTS.markViewMetric)(view.toLowerCase(), (0, $78bb8734d7176028$export$ac953882305d6102));
            onCompletedData?.jiraBusinessAvailableFields?.edges?.forEach((e)=>{
                const fieldEdges = e?.node?.fields?.edges;
                if (fieldEdges == null || fieldEdges?.length === 0) {
                    const emptyMessage = fieldEdges == null ? 'null fields' : '0 length fields';
                    const emptyFieldsError = new Error(`availableFieldsAPI is returning ${emptyMessage} for issueType ${e?.node?.issueType.name ?? 'UNKNOWN'}`);
                    // retrying due to intermittent error related to new projects: FUN-570
                    if (fetchAttempts.current < 1) {
                        fetchAttempts.current += 1;
                        refetch();
                    } else throw emptyFieldsError;
                }
            });
        }
    });
    (0, $eUqFw.useEffect)(()=>{
        if (queryVariables && !hasStartedFetchingFields && !error) {
            setHasStartedFetchingFields(true);
            (0, $ZvXTS.markViewMetric)(view.toLowerCase(), (0, $78bb8734d7176028$export$7b887ee35f2b465e));
            getAvailableFields();
        }
    }, [
        error,
        getAvailableFields,
        hasStartedFetchingFields,
        queryVariables,
        view
    ]);
    const refetch = (0, $eUqFw.useCallback)(()=>{
        if (called && typeof refetchQuery === 'function') return refetchQuery(queryVariables);
        const err = new Error('availableFields refetch is undefined because the service has not been called yet');
        (0, $guiFP.default)({
            meta: {
                id: 'availableFieldsRefetchIsUndefined',
                packageName: 'jiraBusinessEntityProject',
                teamName: 'wanjel'
            },
            error: err,
            sendToPrivacyUnsafeSplunk: true
        });
        throw err;
    }, [
        called,
        refetchQuery,
        queryVariables
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (hasStartedFetchingFields && error) setHasStartedFetchingFields(false);
    }, [
        hasStartedFetchingFields,
        error
    ]);
    const result = (0, $eUqFw.useMemo)(()=>(0, $2RZxj.transformResult)(data), [
        data
    ]);
    const typesWithFields = (0, $eUqFw.useMemo)(()=>(0, $2RZxj.transformResultToTypesWithFields)(data), [
        data
    ]);
    const hierarchyLevels = (0, $eUqFw.useMemo)(()=>result.issueTypes.map((issueType)=>({
                level: issueType.hierarchyLevel,
                name: issueType.name,
                id: issueType.id
            })).sort((a, b)=>a.level !== b.level ? b.level - a.level : a.name.localeCompare(b.name)), [
        result.issueTypes
    ]);
    // make sure "loading" flag starts from "true"
    const isFieldsLoading = hasStartedFetchingFields ? loading : true;
    return {
        error: error,
        loading: error ? false : isQueryLoading || isFieldsLoading,
        data: result,
        typesWithFields: typesWithFields,
        hierarchyLevels: hierarchyLevels,
        refetch: refetch
    };
};
const $0655e80332547c29$var$issueTypesAndFieldsContextDefaultValue = {
    data: {
        fields: [],
        issueTypes: []
    },
    loading: false,
    error: undefined,
    typesWithFields: [],
    hierarchyLevels: []
};
const $0655e80332547c29$export$77937175321fab39 = /*#__PURE__*/ (0, $eUqFw.createContext)({
    ...$0655e80332547c29$var$issueTypesAndFieldsContextDefaultValue
});
const $0655e80332547c29$export$fbd286e14113bfc = /*#__PURE__*/ (0, $eUqFw.createContext)({
    ...$0655e80332547c29$var$issueTypesAndFieldsContextDefaultValue
});
const $0655e80332547c29$export$d2121b02f0b65782 = (input)=>{
    const issueTypesAndFieldsViewData = (0, $eUqFw.useContext)($0655e80332547c29$export$77937175321fab39);
    const issueTypesAndFieldsCreateData = (0, $eUqFw.useContext)($0655e80332547c29$export$fbd286e14113bfc);
    if (!input || input.issueOperation === 'VIEW') return issueTypesAndFieldsViewData;
    return issueTypesAndFieldsCreateData;
};

});
const $78bb8734d7176028$export$747aad128920134d = 3000;
const $78bb8734d7176028$export$e4f8d353742c04ac = 4000;
const $78bb8734d7176028$export$540ffd289e5e0562 = 'timeWaitingForBackendData';
const $78bb8734d7176028$export$23e322eb7c526958 = 'REQUEST_START';
const $78bb8734d7176028$export$83ca21a50372ea3b = 'REQUEST_END';
const $78bb8734d7176028$export$821ca6ff41f300ec = 'jwm-availableFieldsQuery';
const $78bb8734d7176028$export$7b887ee35f2b465e = 'AVAILABLE_FIELDS_QUERY_START';
const $78bb8734d7176028$export$ac953882305d6102 = 'AVAILABLE_FIELDS_QUERY_END';
const $78bb8734d7176028$export$7f7f60b5526c5ee3 = 'jwm-ui-render-time';
const $78bb8734d7176028$export$b78f0bbf209e5f4 = 'UI_RENDER_START';
const $78bb8734d7176028$export$88ea1e280513690f = 'UI_RENDER_END';

parcelRegister("i2apV", function(module, exports) {

$parcel$export(module.exports, "DEFAULT", () => $3bfdf44128ce0634$export$e6952b12ade67489);
$parcel$export(module.exports, "HierarchyLevel", () => $3bfdf44128ce0634$export$7faaf3222dfd10db);
const $3bfdf44128ce0634$export$e6952b12ade67489 = 'default';
const $3bfdf44128ce0634$export$7faaf3222dfd10db = Object.freeze({
    EPIC: 1,
    BASE: 0,
    SUBTASK: -1
});

});

parcelRegister("2RZxj", function(module, exports) {

$parcel$export(module.exports, "transformResult", () => $36ea36a72d22859a$export$f13b29f9ed0c5a03);
$parcel$export(module.exports, "transformResultToTypesWithFields", () => $36ea36a72d22859a$export$55ab7865f91ba09b);
$parcel$export(module.exports, "JWMQueryByRouteMap", () => $36ea36a72d22859a$export$7188da46161cbb8f);

var $41WOo = parcelRequire("41WOo");

var $exb0h = parcelRequire("exb0h");

var $lO4Or = parcelRequire("lO4Or");

var $i2apV = parcelRequire("i2apV");

var $fEf9a = parcelRequire("fEf9a");
const $36ea36a72d22859a$export$b07b0d8dc0894ecf = {
    fields: [],
    issueTypes: []
};
const $36ea36a72d22859a$var$emptyArray = [];
const $36ea36a72d22859a$export$bffa388e20165996 = (node, issueType)=>{
    const fieldConfig = {
        isRequired: !!node.fieldConfig?.isRequired,
        isEditable: !!node.fieldConfig?.isEditable
    };
    if (node.type === 'priority') {
        fieldConfig.options = node.priorities.nodes;
        // Set middle priority as default if backend doesn't return any
        if (node.priority) fieldConfig.defaultPriorityId = node.priority.priorityId;
        else if (fieldConfig.options.length > 0) fieldConfig.defaultPriorityId = // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
        node.priorities.nodes[Math.floor(fieldConfig.options.length / 2)].priorityId;
    }
    if (node.type === 'issuetype') {
        fieldConfig.options = node.issueTypes.nodes;
        fieldConfig.avatarId = issueType.avatarId;
        fieldConfig.avatarUrl = issueType.avatar?.medium;
    }
    if (node.type === 'issuelinks') // 'is blocked by' / 'blocks' is used as the default issue link type
    fieldConfig.defaultIssueLinkTypeId = node.issueLinkTypeRelations.nodes.find(// @ts-expect-error - TS7006 - Parameter 'linkNode' implicitly has an 'any' type.
    (linkNode)=>linkNode.relationName === 'is blocked by')?.linkTypeId || // take the first awailable otherwise
    node.issueLinkTypeRelations.nodes[0]?.linkTypeId;
    if (node.type === (0, $lO4Or.MULTI_SELECT_CF_TYPE) || node.type === (0, $lO4Or.SELECT_CF_TYPE)) {
        // @ts-expect-error - TS2304 - Cannot find name 'SelectOption'.
        const fieldOptions = [];
        // convert so that it can be used by the select field
        if ((0, $41WOo.isJwmInlineFieldCreateEnabled)()) // @ts-expect-error - TS7031 - Binding element 'value' implicitly has an 'any' type. | TS7031 - Binding element 'optionId' implicitly has an 'any' type.
        node.fieldOptions.nodes.forEach(({ value: value, optionId: optionId })=>{
            fieldOptions.push({
                value: value,
                label: value,
                optionId: optionId
            });
        });
        else // @ts-expect-error - TS7031 - Binding element 'value' implicitly has an 'any' type.
        node.fieldOptions.nodes.forEach(({ value: value })=>{
            fieldOptions.push({
                value: value,
                label: value
            });
        });
        fieldConfig.selectOptions = fieldOptions;
    }
    if (node.type === (0, $lO4Or.MULTI_CHECKBOXES_CF_TYPE)) {
        // @ts-expect-error - TS2304 - Cannot find name 'SelectOption'.
        const fieldOptions = [];
        // convert so that it can be used by the select field
        // @ts-expect-error - TS7031 - Binding element 'value' implicitly has an 'any' type. | TS7031 - Binding element 'optionId' implicitly has an 'any' type.
        node.fieldOptions.nodes.forEach(({ value: value, optionId: optionId })=>{
            fieldOptions.push({
                value: value,
                label: value,
                optionId: optionId
            });
        });
        fieldConfig.selectOptions = fieldOptions;
    }
    if (node.type === (0, $lO4Or.CATEGORY_TYPE)) {
        // @ts-expect-error - TS2304 - Cannot find name 'SelectOption'.
        const fieldOptions = [];
        // convert so that it can be used by the select field
        // @ts-expect-error - TS7031 - Binding element 'value' implicitly has an 'any' type. | TS7031 - Binding element 'optionId' implicitly has an 'any' type.
        node.fieldOptions.nodes.forEach(({ value: value, optionId: optionId, color: color })=>{
            fieldOptions.push({
                value: value,
                label: value,
                optionId: optionId,
                color: color?.colorKey ?? null
            });
        });
        fieldConfig.selectOptions = fieldOptions;
    }
    return {
        id: node.fieldId,
        aliasFieldId: node.aliasFieldId,
        name: node.name,
        type: node.type,
        fieldConfig: fieldConfig,
        issueTypes: [],
        __typename: node.__typename
    };
};
const $36ea36a72d22859a$export$f13b29f9ed0c5a03 = (data)=>{
    if (data && data.jiraBusinessAvailableFields && data.jiraBusinessAvailableFields.edges) {
        const issueFieldsById = {};
        const issueTypesById = {};
        data.jiraBusinessAvailableFields.edges.map((edge)=>edge && edge.node || {}).forEach(// @ts-expect-error - TS2345 - Argument of type '({ issueType, fields, isDefaultIssueType, }: { issueType: {    name: string;    issueTypeId: string;    type: string;    avatarId: string;    hierarchy?: {        level: number;    };}; fields: {    edges: {        nodes: [];    }[];}; isDefaultIssueType: boolean; }) => void' is not assignable to parameter of type '(value: {}, index: number, array: {}[]) => void'.
        ({ issueType: issueType, fields: fields, isDefaultIssueType: isDefaultIssueType })=>{
            issueTypesById[issueType.issueTypeId] = {
                id: issueType.issueTypeId,
                isDefault: isDefaultIssueType,
                name: issueType.name,
                subtask: issueType.type === 'SUB_TASK',
                avatarId: issueType.avatarId,
                avatarUrl: issueType.avatar?.medium ?? null,
                hierarchyLevel: issueType.hierarchy?.level ?? 0
            };
            fields.edges// @ts-expect-error - TS2551 - Property 'node' does not exist on type '{ nodes: []; }'. Did you mean 'nodes'?
            .map((edge)=>edge && edge.node || {}).forEach((node)=>{
                if (node.fieldId) {
                    if (!issueFieldsById[node.fieldId]) issueFieldsById[node.fieldId] = $36ea36a72d22859a$export$bffa388e20165996(node, issueType);
                    issueFieldsById[node.fieldId].issueTypes = issueFieldsById[node.fieldId].issueTypes || [];
                    // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
                    issueFieldsById[node.fieldId].issueTypes.push(issueType.issueTypeId);
                }
            });
        });
        return {
            fields: Object.keys(issueFieldsById).map((id)=>issueFieldsById[id]),
            issueTypes: Object.keys(issueTypesById).map((id)=>issueTypesById[id])
        };
    }
    // @ts-expect-error - TS2322 - Type '{ readonly fields: readonly []; readonly issueTypes: readonly []; }' is not assignable to type '{ fields: BusinessIssueField[]; issueTypes: BusinessIssueType[]; }'.
    return $36ea36a72d22859a$export$b07b0d8dc0894ecf;
};
const $36ea36a72d22859a$export$55ab7865f91ba09b = (data)=>{
    if (data && data.jiraBusinessAvailableFields && data.jiraBusinessAvailableFields.edges) return data.jiraBusinessAvailableFields.edges.map((edge)=>edge && edge.node || {}).map(// @ts-expect-error - TS2345 - Argument of type '({ issueType, fields, isDefaultIssueType, }: { issueType: {    name: string;    issueTypeId: string;    type: string;    avatarId: string;    hierarchy?: {        level: number;    };}; fields: {    edges: {        nodes: [];    }[];}; isDefaultIssueType: boolean; }) => { issueType: { id: string; isDefault: boolean;...' is not assignable to parameter of type '(value: {}, index: number, array: {}[]) => { issueType: { id: string; isDefault: boolean; name: string; subtask: boolean; avatarId: string; hierarchyLevel: number; }; fields: BusinessIssueField[]; }'.
    ({ issueType: issueType, fields: fields, isDefaultIssueType: isDefaultIssueType })=>({
            issueType: {
                id: issueType.issueTypeId,
                isDefault: isDefaultIssueType,
                name: issueType.name,
                subtask: issueType.type === 'SUB_TASK',
                avatarId: issueType.avatarId,
                avatarUrl: issueType.avatar?.medium ?? '',
                hierarchyLevel: issueType.hierarchy?.level ?? 0
            },
            fields: fields.edges// @ts-expect-error - TS2551 - Property 'node' does not exist on type '{ nodes: []; }'. Did you mean 'nodes'?
            .map((edge)=>edge && edge.node || {}).map((node)=>$36ea36a72d22859a$export$bffa388e20165996(node, issueType))
        }));
    return $36ea36a72d22859a$var$emptyArray;
};
const $36ea36a72d22859a$export$7188da46161cbb8f = {
    [(0, $exb0h.ROUTE_NAMES).CLASSIC_BUSINESS_PROJECT_FORM]: {
        view: 'Form',
        query: (0, $fEf9a.ISSUE_TYPES_AND_FIELDS_FORM_QUERY)
    },
    [(0, $exb0h.ROUTE_NAMES).CLASSIC_BUSINESS_PROJECT_FORM_SUBMIT]: {
        view: 'FormSubmit',
        query: (0, $fEf9a.ISSUE_TYPES_AND_FIELDS_FORM_SUBMIT_QUERY)
    },
    [(0, $exb0h.ROUTE_NAMES).CLASSIC_BUSINESS_PROJECT_CALENDAR]: {
        view: 'Calendar',
        query: (0, $fEf9a.ISSUE_TYPES_AND_FIELDS_CALENDAR_QUERY)
    },
    [(0, $exb0h.ROUTE_NAMES).CLASSIC_BUSINESS_PROJECT_CALENDAR_EMBED]: {
        view: 'CalendarEmbed',
        query: (0, $fEf9a.ISSUE_TYPES_AND_FIELDS_CALENDAR_QUERY)
    },
    [(0, $exb0h.ROUTE_NAMES).CLASSIC_BUSINESS_PROJECT_LIST]: {
        view: 'List',
        query: (0, $fEf9a.ISSUE_TYPES_AND_FIELDS_LIST_QUERY)
    },
    [(0, $exb0h.ROUTE_NAMES).CLASSIC_BUSINESS_PROJECT_LIST_EMBED]: {
        view: 'ListEmbed',
        query: (0, $fEf9a.ISSUE_TYPES_AND_FIELDS_LIST_QUERY)
    },
    [(0, $exb0h.ROUTE_NAMES).CLASSIC_BUSINESS_PROJECT_TIMELINE]: {
        view: 'Timeline',
        query: (0, $fEf9a.ISSUE_TYPES_AND_FIELDS_TIMELINE_QUERY)
    },
    [(0, $exb0h.ROUTE_NAMES).CLASSIC_BUSINESS_PROJECT_TIMELINE_EMBED]: {
        view: 'TimelineEmbed',
        query: (0, $fEf9a.ISSUE_TYPES_AND_FIELDS_TIMELINE_QUERY)
    },
    [(0, $exb0h.ROUTE_NAMES).CLASSIC_BUSINESS_PROJECT_BOARD]: {
        view: 'Board',
        query: (0, $fEf9a.ISSUE_TYPES_AND_FIELDS_BOARD_QUERY)
    },
    [(0, $exb0h.ROUTE_NAMES).CLASSIC_BUSINESS_PROJECT_BOARD_EMBED]: {
        view: 'BoardEmbed',
        query: (0, $fEf9a.ISSUE_TYPES_AND_FIELDS_BOARD_QUERY)
    },
    [(0, $i2apV.DEFAULT)]: {
        view: 'Common',
        query: (0, $fEf9a.ISSUE_TYPES_AND_FIELDS_LIST_QUERY)
    }
};

});
parcelRegister("fEf9a", function(module, exports) {

$parcel$export(module.exports, "ISSUE_TYPES_AND_FIELDS_LIST_QUERY", () => $546f0d2a9095de4c$export$ba5f98a8d6136727);
$parcel$export(module.exports, "ISSUE_TYPES_AND_FIELDS_CALENDAR_QUERY", () => $546f0d2a9095de4c$export$cba408dff1091b60);
$parcel$export(module.exports, "ISSUE_TYPES_AND_FIELDS_TIMELINE_QUERY", () => $546f0d2a9095de4c$export$363435cea078aa93);
$parcel$export(module.exports, "ISSUE_TYPES_AND_FIELDS_BOARD_QUERY", () => $546f0d2a9095de4c$export$1641a42cf2cdb09a);
$parcel$export(module.exports, "ISSUE_TYPES_AND_FIELDS_FORM_QUERY", () => $546f0d2a9095de4c$export$7903c43b0ec55315);
$parcel$export(module.exports, "ISSUE_TYPES_AND_FIELDS_FORM_SUBMIT_QUERY", () => $546f0d2a9095de4c$export$79304c172f5555ae);

var $9ypom = parcelRequire("9ypom");
const $546f0d2a9095de4c$export$ec2562ca5badac3b = (0, $9ypom.default)`
  fragment GetIssueTypesAndFields on JiraBusinessAvailableFields {
    issueType {
      issueTypeId
      name
      type
      avatarId
      avatar {
        medium
      }
      hierarchy {
        level
      }
    }
    isDefaultIssueType
    fields {
      edges {
        node {
          fieldId
          type
          name
          aliasFieldId
          ... on GenericIssueField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraIssueTypeField {
            fieldConfig {
              isRequired
              isEditable
            }
            issueTypes {
              nodes {
                name
                id
              }
            }
          }
          ... on JiraPriorityField {
            fieldConfig {
              isRequired
              isEditable
            }
            priority {
              priorityId
            }
            priorities {
              nodes {
                priorityId
                name
                iconUrl
              }
            }
          }
          ... on JiraLabelsField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraSingleSelectUserPickerField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraSingleLineTextField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraDatePickerField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraAffectedServicesField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraAttachmentsField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraCMDBField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraCascadingSelectField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraCheckboxesField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraColorField {
            fieldConfig {
              isRequired
              isEditable
            }
            color {
              colorKey
            }
          }
          ... on JiraComponentsField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraDateTimePickerField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraEpicLinkField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraIssueLinkField {
            fieldConfig {
              isRequired
              isEditable
            }
            issueLinkTypeRelations(first: 10) {
              nodes {
                linkTypeId
                relationName
              }
            }
          }
          ... on JiraIssueRestrictionField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraMultipleGroupPickerField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraMultipleSelectField {
            fieldConfig {
              isRequired
              isEditable
            }
            fieldOptions {
              nodes {
                id
                optionId
                value
              }
            }
          }
          ... on JiraMultipleSelectUserPickerField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraMultipleVersionPickerField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraNumberField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraPeopleField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraProjectField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraRadioSelectField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraResolutionField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraRichTextField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraSecurityLevelField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraSingleGroupPickerField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraSingleSelectField {
            fieldConfig {
              isRequired
              isEditable
            }
            fieldOptions {
              nodes {
                id
                optionId
                value
              }
            }
          }
          ... on JiraSingleVersionPickerField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraSprintField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraTeamField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraUrlField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JsmRequestTypeField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JWMCategoryField {
            fieldConfig {
              isRequired
              isEditable
            }
            fieldOptions {
              nodes {
                id
                optionId
                value
                color {
                    colorKey
                }
              }
            }
          }
          ... on JiraCheckboxesField {
            fieldConfig {
              isRequired
              isEditable
            }
            fieldOptions {
              nodes {
                id
                optionId
                value
              }
            }
          }
          ... on JiraAtlassianTeamField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraGoalsField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
        }
      }
    }
  }
`;
const $546f0d2a9095de4c$export$ba5f98a8d6136727 = (0, $9ypom.default)`
  query JiraBusinessAvailableFieldsListView ($projectKey: String!, $issueOperation: JiraBusinessIssueOperation, $first: Int, $last: Int, $before: String, $after: String) {
      jiraBusinessAvailableFields(projectKey: $projectKey, issueOperation: $issueOperation, first: $first, last: $last, before: $before, after: $after) {
        edges {
          node {
            ...GetIssueTypesAndFields
          }
        }
      }
  }
  ${$546f0d2a9095de4c$export$ec2562ca5badac3b}
`;
const $546f0d2a9095de4c$export$cba408dff1091b60 = (0, $9ypom.default)`
  query JiraBusinessAvailableFieldsCalendarView ($projectKey: String!, $issueOperation: JiraBusinessIssueOperation, $first: Int, $last: Int, $before: String, $after: String) {
      jiraBusinessAvailableFields(projectKey: $projectKey, issueOperation: $issueOperation, first: $first, last: $last, before: $before, after: $after) {
        edges {
          node {
            ...GetIssueTypesAndFields
          }
        }
      }
  }
  ${$546f0d2a9095de4c$export$ec2562ca5badac3b}
`;
const $546f0d2a9095de4c$export$363435cea078aa93 = (0, $9ypom.default)`
  query JiraBusinessAvailableFieldsTimelineView ($projectKey: String!, $issueOperation: JiraBusinessIssueOperation, $first: Int, $last: Int, $before: String, $after: String) {
      jiraBusinessAvailableFields(projectKey: $projectKey, issueOperation: $issueOperation, first: $first, last: $last, before: $before, after: $after) {
        edges {
          node {
            ...GetIssueTypesAndFields
          }
        }
      }
  }
  ${$546f0d2a9095de4c$export$ec2562ca5badac3b}
`;
const $546f0d2a9095de4c$export$1641a42cf2cdb09a = (0, $9ypom.default)`
  query JiraBusinessAvailableFieldsBoardView ($projectKey: String!, $issueOperation: JiraBusinessIssueOperation, $first: Int, $last: Int, $before: String, $after: String) {
      jiraBusinessAvailableFields(projectKey: $projectKey, issueOperation: $issueOperation, first: $first, last: $last, before: $before, after: $after) {
        edges {
          node {
            ...GetIssueTypesAndFields
          }
        }
      }
  }
  ${$546f0d2a9095de4c$export$ec2562ca5badac3b}
`;
const $546f0d2a9095de4c$export$7903c43b0ec55315 = (0, $9ypom.default)`
  query JiraBusinessAvailableFieldsFormView ($projectKey: String!, $issueOperation: JiraBusinessIssueOperation, $first: Int, $last: Int, $before: String, $after: String) {
      jiraBusinessAvailableFields(projectKey: $projectKey, issueOperation: $issueOperation, first: $first, last: $last, before: $before, after: $after) {
        edges {
          node {
            ...GetIssueTypesAndFields
          }
        }
      }
  }
  ${$546f0d2a9095de4c$export$ec2562ca5badac3b}
`;
const $546f0d2a9095de4c$export$79304c172f5555ae = (0, $9ypom.default)`
  query JiraBusinessAvailableFieldsFormSubmitView ($projectKey: String!, $issueOperation: JiraBusinessIssueOperation, $first: Int, $last: Int, $before: String, $after: String) {
      jiraBusinessAvailableFields(projectKey: $projectKey, issueOperation: $issueOperation, first: $first, last: $last, before: $before, after: $after) {
        edges {
          node {
            ...GetIssueTypesAndFields
          }
        }
      }
  }
  ${$546f0d2a9095de4c$export$ec2562ca5badac3b}
`;

});




parcelRegister("d3C6e", function(module, exports) {

$parcel$export(module.exports, "IssueCreateProvider", () => $167db4325906604f$export$a975cd9627cdf4b6);
$parcel$export(module.exports, "useCreateIssue", () => $167db4325906604f$export$8af2d18142c8506c);
$parcel$export(module.exports, "isOptimisticIssue", () => $167db4325906604f$export$8512029c7fc94e58);
$parcel$export(module.exports, "useIsHighlighted", () => $167db4325906604f$export$2ecca9d8a7f031af);
/* eslint-disable @typescript-eslint/no-explicit-any */ 
var $eUqFw = parcelRequire("eUqFw");

var $lskA1 = parcelRequire("lskA1");

var $cWiVr = parcelRequire("cWiVr");

var $kjzom = parcelRequire("kjzom");

var $frfm9 = parcelRequire("frfm9");
class $167db4325906604f$var$IssueCreateJob {
    constructor(createParams){
        this.createParams = createParams;
        this.promise = new Promise((resolve, reject)=>{
            this.reject = reject;
            this.resolve = resolve;
        });
    }
}
const $167db4325906604f$var$IssueCreateContext = /*#__PURE__*/ (0, $eUqFw.createContext)(null);
const $167db4325906604f$var$reducer = (state, action)=>{
    switch(action.type){
        case 'enqueue':
            return {
                ...state,
                jobQueue: [
                    ...state.jobQueue,
                    action.job
                ]
            };
        case 'start-job':
            return {
                ...state,
                runningJob: state.jobQueue[0],
                jobQueue: state.jobQueue.slice(1)
            };
        case 'end-job':
            return {
                ...state,
                runningJob: null
            };
        case 'highlight':
            return {
                ...state,
                highlightedIssues: new Set([
                    ...state.highlightedIssues,
                    action.issueId
                ])
            };
        case 'unhighlight':
            return {
                ...state,
                highlightedIssues: new Set([
                    ...state.highlightedIssues
                ].filter((id)=>id !== action.issueId))
            };
        case 'save-summary':
            return {
                ...state,
                summary: action.summary
            };
        default:
            return state;
    }
};
const $167db4325906604f$var$initialState = {
    jobQueue: [],
    runningJob: null,
    highlightedIssues: new Set(),
    summary: ''
};
const $167db4325906604f$export$a975cd9627cdf4b6 = ({ mutation: mutation, query: query, ignoreFiltersContext: ignoreFiltersContext = false, children: children })=>{
    const { data: { user: user } } = (0, $cWiVr.useCurrentUser)();
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const currentUser = user;
    // optimistic issue ids are negative numbers to distinguish them from real issue ids
    const nextIssueId = (0, $eUqFw.useRef)(-1);
    const [{ jobQueue: jobQueue, runningJob: runningJob, highlightedIssues: highlightedIssues, summary: summary }, dispatch] = (0, $eUqFw.useReducer)($167db4325906604f$var$reducer, $167db4325906604f$var$initialState);
    const createIssueController = (0, $kjzom.useCreateIssue)(mutation, query);
    const highlightIssue = (0, $eUqFw.useCallback)((issueId)=>dispatch({
            type: 'highlight',
            issueId: issueId
        }), []);
    const unhighlightIssue = (0, $eUqFw.useCallback)((issueId)=>setTimeout(()=>{
            dispatch({
                type: 'unhighlight',
                issueId: issueId
            });
        }, 2000), []);
    const createIssue = (0, $eUqFw.useCallback)((createParams)=>{
        const job = new $167db4325906604f$var$IssueCreateJob(createParams);
        dispatch({
            type: 'enqueue',
            job: job
        });
        let rank;
        if (createParams.input.rankAfter) rank = (0, $lskA1.getNextRank)(createParams.input.rankAfter.rank);
        else if (createParams.input.rankBefore) rank = (0, $lskA1.getPreviousRank)(createParams.input.rankBefore.rank);
        const reporter = {
            accountId: currentUser.accountId,
            avatarUrl: currentUser.avatarUrls['48x48'],
            displayName: currentUser.displayName
        };
        const optimisticIssuePayload = {
            issueId: nextIssueId.current--,
            rank: rank,
            reporter: reporter,
            ...createParams.input
        };
        return {
            optimisticIssuePayload: optimisticIssuePayload,
            promise: job.promise
        };
    }, [
        currentUser
    ]);
    (0, $eUqFw.useEffect)(()=>{
        // dequeue and run the next job if there is one and there is no running job
        if (jobQueue.length > 0 && !runningJob) {
            const job = jobQueue[0];
            dispatch({
                type: 'start-job'
            });
            createIssueController({
                createParams: job.createParams,
                highlightIssue: highlightIssue,
                unhighlightIssue: unhighlightIssue,
                ignoreFiltersContext: ignoreFiltersContext
            }).then(job.resolve).catch(job.reject).finally(()=>dispatch({
                    type: 'end-job'
                }));
        }
    }, [
        createIssueController,
        highlightedIssues,
        jobQueue,
        runningJob,
        highlightIssue,
        unhighlightIssue,
        ignoreFiltersContext
    ]);
    (0, $frfm9.useCreateParamHandler)();
    const saveSummary = (0, $eUqFw.useCallback)((newSummary)=>{
        dispatch({
            type: 'save-summary',
            summary: newSummary
        });
    }, []);
    const value = (0, $eUqFw.useMemo)(()=>({
            createIssue: createIssue,
            highlightedIssues: highlightedIssues,
            summary: summary,
            saveSummary: saveSummary
        }), [
        createIssue,
        highlightedIssues,
        summary,
        saveSummary
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($167db4325906604f$var$IssueCreateContext.Provider, {
        value: value
    }, children);
};
const $167db4325906604f$export$8af2d18142c8506c = (onSubmit, onBlur)=>{
    const context = (0, $eUqFw.useContext)($167db4325906604f$var$IssueCreateContext);
    if (!context) throw new Error('useCreateIssue must be used within an IssueCreateProvider');
    const { createIssue: createIssue, summary: summary, saveSummary: saveSummary } = context;
    const summaryRef = (0, $eUqFw.useRef)(summary);
    const hasExitedWithoutUserAction = (0, $eUqFw.useRef)(true);
    const submit = (0, $eUqFw.useCallback)((createParams)=>{
        const result = createIssue(createParams);
        onSubmit(result);
        hasExitedWithoutUserAction.current = false;
        setTimeout(()=>{
            // reset the value as the form can stay open after submitting
            hasExitedWithoutUserAction.current = true;
        }, 100);
        return result;
    }, [
        createIssue,
        onSubmit
    ]);
    const blur = (0, $eUqFw.useCallback)(()=>{
        onBlur?.();
        hasExitedWithoutUserAction.current = false;
    }, [
        onBlur
    ]);
    (0, $eUqFw.useEffect)(()=>()=>{
            // if the component has exited without the user blurring the form or submitting,
            // then save the summary value so it can be reapplied
            saveSummary(hasExitedWithoutUserAction.current ? summaryRef.current : '');
        }, [
        saveSummary
    ]);
    return {
        summaryRef: summaryRef,
        submit: submit,
        blur: blur
    };
};
const $167db4325906604f$export$8512029c7fc94e58 = (issueId)=>issueId < 0;
const $167db4325906604f$export$2ecca9d8a7f031af = ()=>{
    const context = (0, $eUqFw.useContext)($167db4325906604f$var$IssueCreateContext);
    if (!context) throw new Error('useIsHighlighted must be used within an IssueCreateProvider');
    const { highlightedIssues: highlightedIssues } = context;
    return (0, $eUqFw.useCallback)((issueId)=>$167db4325906604f$export$8512029c7fc94e58(issueId) || highlightedIssues.has(issueId), [
        highlightedIssues
    ]);
};

});
parcelRegister("lskA1", function(module, exports) {

$parcel$export(module.exports, "getNextRank", () => $7b4071d915fd0829$export$5c16a8b7eebff4b8);
$parcel$export(module.exports, "getPreviousRank", () => $7b4071d915fd0829$export$e2047b3433d9f565);
const $7b4071d915fd0829$export$5c16a8b7eebff4b8 = (s)=>`${s}0`;
const $7b4071d915fd0829$export$e2047b3433d9f565 = (s)=>{
    const lastCharCode = s.charCodeAt(s.length - 1);
    const previousLastChar = String.fromCharCode(lastCharCode - 1);
    if (lastCharCode === 0) return $7b4071d915fd0829$export$e2047b3433d9f565(s.substring(0, s.length - 1));
    return `${s.substring(0, s.length - 1)}${previousLastChar}99`;
};

});

parcelRegister("kjzom", function(module, exports) {

$parcel$export(module.exports, "useCreateIssue", () => $b3543cf4b0365df5$export$8af2d18142c8506c);

var $eUqFw = parcelRequire("eUqFw");

var $gEmpR = parcelRequire("gEmpR");

var $c7wtc = parcelRequire("c7wtc");

var $7byHA = parcelRequire("7byHA");

var $k8Qyf = parcelRequire("k8Qyf");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $iNULk = parcelRequire("iNULk");

var $fop6E = parcelRequire("fop6E");

var $5ujax = parcelRequire("5ujax");

var $auegK = parcelRequire("auegK");

var $fOAem = parcelRequire("fOAem");

var $9Y2JR = parcelRequire("9Y2JR");
const $b3543cf4b0365df5$export$8edbb6d449614942 = ()=>{
    const workflows = (0, $c7wtc.useWorkflows)();
    return (0, $eUqFw.useCallback)((createInput)=>{
        if (createInput.status && workflows != null) {
            // find the workflow for the input issue type
            const workflow = workflows.find((w)=>w.issueTypes.some((it)=>it.issueTypeId === createInput.issueType.id));
            // find the first transition to the input status that is initial, or global but not conditional
            const { statusId: statusId } = createInput.status;
            const transition = workflow?.transitions.find((t)=>t.to.statusId === statusId && (t.isInitial || t.isGlobal && !t.isConditional));
            return transition?.transitionId;
        }
    }, [
        workflows
    ]);
};
const $b3543cf4b0365df5$export$8af2d18142c8506c = (mutation, query)=>{
    const createIssue = (0, $iNULk.useCreateIssue)(mutation);
    const refetchIssue = (0, $fop6E.useRefetchIssue)(query);
    const showCreateSuccessFlag = (0, $fOAem.useShowCreateSuccessFlag)();
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagsService)();
    const { typesWithFields: typesWithFields } = (0, $gEmpR.useIssueTypesAndFields)({
        issueOperation: 'CREATE'
    });
    const getTransitionId = $b3543cf4b0365df5$export$8edbb6d449614942();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const showCreateIssueDialog = (0, $auegK.useCreateIssueDialog)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    return (0, $eUqFw.useCallback)(async ({ createParams: createParams, highlightIssue: highlightIssue, unhighlightIssue: unhighlightIssue, ignoreFiltersContext: ignoreFiltersContext })=>{
        const transitionId = getTransitionId(createParams.input);
        try {
            if (!(0, $5ujax.hasAllRequiredFields)({
                issueType: typesWithFields.find(({ issueType: issueType })=>issueType.id === createParams.input.issueType.id),
                createInput: createParams.input
            })) throw new (0, $7byHA.ValidationError)('Missing required fields');
            const response = await createIssue(createParams, {
                transitionId: transitionId
            });
            highlightIssue(response.itemIdentifiers.issueId);
            if (createParams.showSuccessFlag) showCreateSuccessFlag(response.itemIdentifiers.issueKey);
            (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'issue created', String(response.itemIdentifiers.issueId), {
                location: createParams.location
            });
            unhighlightIssue(response.itemIdentifiers.issueId);
            return response.item;
        } catch (error) {
            let finalError = error;
            try {
                if (error instanceof (0, $7byHA.ValidationError)) {
                    const { issueId: issueId, issueKey: issueKey } = await showCreateIssueDialog(createParams.input, {
                        transitionId: transitionId
                    });
                    highlightIssue(issueId);
                    const issue = await refetchIssue(issueId, createParams.fieldIdsToReturn, !ignoreFiltersContext);
                    if (createParams.showSuccessFlag) showCreateSuccessFlag(issueKey);
                    unhighlightIssue(issueId);
                    return issue;
                }
            } catch (refetchError) {
                finalError = refetchError;
            }
            if (finalError instanceof (0, $auegK.CancelledError)) return null;
            showFlag({
                type: 'error',
                title: formatMessage((0, $9Y2JR.default).errorFlagTitle),
                description: formatMessage((0, $9Y2JR.default).errorFlagDescription)
            });
            throw finalError;
        }
    }, [
        getTransitionId,
        typesWithFields,
        createIssue,
        createAnalyticsEvent,
        showCreateSuccessFlag,
        showFlag,
        formatMessage,
        showCreateIssueDialog,
        refetchIssue
    ]);
};

});
parcelRegister("c7wtc", function(module, exports) {

$parcel$export(module.exports, "WorkflowsProvider", () => $0662fc67a6d31ad1$export$80a1d3130ff3ec75);
$parcel$export(module.exports, "useWorkflows", () => $0662fc67a6d31ad1$export$437f9bd807b88beb);

var $eUqFw = parcelRequire("eUqFw");

var $eI5EY = parcelRequire("eI5EY");

var $eo17r = parcelRequire("eo17r");
var $k8Qyf = parcelRequire("k8Qyf");

var $6LdZl = parcelRequire("6LdZl");

var $8xqyO = parcelRequire("8xqyO");
const $0662fc67a6d31ad1$var$FETCH_WORKFLOW_FLAG_ID = (0, $eo17r.toFlagId)('fetch-board-error-flag');
const $0662fc67a6d31ad1$var$WorkflowsContext = /*#__PURE__*/ (0, $eUqFw.createContext)(undefined);
const $0662fc67a6d31ad1$export$80a1d3130ff3ec75 = ({ children: children, enabled: enabled = true, workflows: workflows })=>{
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagsService)();
    const { fetch: fetch, data: data, error: error } = (0, $6LdZl.useFetchWorkflows)();
    (0, $eUqFw.useEffect)(()=>{
        if ((!(0, $eI5EY.fg)('jwm_conditional_workflow_data_loading') || enabled) && workflows == null) fetch();
    }, [
        enabled,
        fetch,
        workflows
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (error) showFlag({
            id: $0662fc67a6d31ad1$var$FETCH_WORKFLOW_FLAG_ID,
            type: 'error',
            title: (0, $8xqyO.default).workflowsErrorTitle,
            description: (0, $8xqyO.default).workflowsErrorDescription
        });
    }, [
        error,
        showFlag
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0662fc67a6d31ad1$var$WorkflowsContext.Provider, {
        value: workflows ?? data
    }, children);
};
const $0662fc67a6d31ad1$export$437f9bd807b88beb = ()=>(0, $eUqFw.useContext)($0662fc67a6d31ad1$var$WorkflowsContext);

});
parcelRegister("6LdZl", function(module, exports) {

$parcel$export(module.exports, "useFetchWorkflows", () => $999083320983ea8a$export$41ba56ef14d1b9b1);
/* eslint-disable @typescript-eslint/no-non-null-assertion */ 
var $eUqFw = parcelRequire("eUqFw");

var $iZuDo = parcelRequire("iZuDo");

var $kQAZu = parcelRequire("kQAZu");

var $guiFP = parcelRequire("guiFP");

var $5Hc99 = parcelRequire("5Hc99");
const $999083320983ea8a$export$41ba56ef14d1b9b1 = ()=>{
    const project = (0, $kQAZu.useProject)();
    const [fetch, { data: data, loading: loading, error: error }] = (0, $iZuDo.useLazyQuery)((0, $5Hc99.WORKFLOWS_QUERY), {
        variables: {
            projectId: project.id,
            first: 100
        },
        onError: (apolloError)=>{
            (0, $guiFP.default)({
                meta: {
                    id: 'jwmFetchWorkflows',
                    packageName: 'jiraBusinessWorkflows',
                    teamName: 'wanjel'
                },
                attributes: {
                    message: 'Failed to fetch workflows'
                },
                error: apolloError,
                sendToPrivacyUnsafeSplunk: true
            });
        }
    });
    const workflowsDetails = (0, $eUqFw.useMemo)(()=>data?.jwmWorkflowWithIssueTypes?.edges?.map((edge)=>{
            const { workflow: workflow, issueTypes: issueTypes } = edge?.node || {};
            return {
                workflowId: workflow.workflowId,
                name: workflow?.name ?? undefined,
                transitions: workflow.transitions.edges.map((transitionEdge)=>({
                        transitionId: transitionEdge.node.transitionId,
                        name: transitionEdge.node.name ?? undefined,
                        isInitial: transitionEdge.node.isInitial,
                        isGlobal: transitionEdge.node.isGlobal,
                        isConditional: transitionEdge.node.isConditional,
                        to: {
                            statusId: transitionEdge.node.to.statusId
                        }
                    })),
                issueTypes: issueTypes.edges.map((issueTypeEdge)=>({
                        issueTypeId: issueTypeEdge.node.issueTypeId,
                        name: issueTypeEdge.node.name,
                        avatarUrl: issueTypeEdge.node.avatar.medium,
                        hierarchyLevel: issueTypeEdge.node.hierarchy.level
                    }))
            };
        }), [
        data
    ]);
    return {
        fetch: fetch,
        data: workflowsDetails,
        loading: loading,
        error: error
    };
};

});
parcelRegister("5Hc99", function(module, exports) {

$parcel$export(module.exports, "WORKFLOWS_QUERY", () => $d1ebb9e47bb48695$export$d54deb6c2b9695b7);

var $9ypom = parcelRequire("9ypom");
const $d1ebb9e47bb48695$export$d54deb6c2b9695b7 = (0, $9ypom.default)`
    query JWMWorkflowWithIssueTypes($projectId: Long!, $filter: JWMWorkflowWithIssueTypesFilter, $first: Int, $after: String, $last: Int, $before: String) {
        jwmWorkflowWithIssueTypes(projectId: $projectId, filter: $filter, first: $first, after: $after, last: $last, before: $before) {
            edges {
                node {
                    workflow {
                        workflowId
                        name
                        transitions(first: $first) {
                            edges {
                                node {
                                    transitionId
                                    name
                                    isInitial
                                    isGlobal
                                    isConditional
                                    to {
                                        statusId
                                    }
                                }
                            }
                        }
                    }
                    issueTypes(first: $first) {
                        edges {
                            node {
                                issueTypeId
                                name
                                avatar {
                                  medium
                                }
                              	hierarchy {
                              	  level
                              	}
                            }
                        }
                    }
                }
            }
        }
    }
`;

});


parcelRegister("8xqyO", function(module, exports) {

$parcel$export(module.exports, "default", () => $5f2d03bd6919e7a8$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $5f2d03bd6919e7a8$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    workflowsErrorTitle: {
        "id": "business-workflows.controllers.workflows-context.workflows-error-title",
        "defaultMessage": "Failed to load workflows details"
    },
    workflowsErrorDescription: {
        "id": "business-workflows.controllers.workflows-context.workflows-error-description",
        "defaultMessage": "We couldn't load your workflow details, try refreshing the page or try again later."
    }
});

});


parcelRegister("iNULk", function(module, exports) {

$parcel$export(module.exports, "useCreateIssue", () => $7f9682590ce5c99c$export$8af2d18142c8506c);

var $eUqFw = parcelRequire("eUqFw");

var $iZuDo = parcelRequire("iZuDo");

var $jGcn0 = parcelRequire("jGcn0");

var $e4qlg = parcelRequire("e4qlg");
var $4S5hf = parcelRequire("4S5hf");

var $kkYfO = parcelRequire("kkYfO");

var $dlVOn = parcelRequire("dlVOn");

var $guiFP = parcelRequire("guiFP");

var $79xbN = parcelRequire("79xbN");

var $1ybV0 = parcelRequire("1ybV0");

var $eI5EY = parcelRequire("eI5EY");

var $7byHA = parcelRequire("7byHA");

var $lO4Or = parcelRequire("lO4Or");

var $fD1Hq = parcelRequire("fD1Hq");

var $4xHig = parcelRequire("4xHig");


var $iWGMH = parcelRequire("iWGMH");
const $7f9682590ce5c99c$var$storyPointEstimateFieldPredicate = (field)=>field.type === (0, $lO4Or.STORY_POINT_ESTIMATE_CF_TYPE);
const $7f9682590ce5c99c$var$storyPointsFieldPredicate = (field)=>field.type === (0, $lO4Or.NUMBER_CF_TYPE) && field.aliasFieldId === (0, $jGcn0.STORY_POINTS_ALIAS_FIELD_ID);
const $7f9682590ce5c99c$var$sprintFieldPredicate = (field)=>field.type === (0, $lO4Or.SPRINT_TYPE);
const $7f9682590ce5c99c$export$8af2d18142c8506c = (mutation)=>{
    const locale = (0, $4xHig.useLocale)();
    const { data: categoryField } = (0, $e4qlg.useCategoryField)();
    const { data: startDateField } = (0, $fD1Hq.useStartDateField)();
    const { data: storyPointEstimateField } = (0, $4S5hf.useFindField)($7f9682590ce5c99c$var$storyPointEstimateFieldPredicate);
    const { data: storyPointsField } = (0, $4S5hf.useFindField)($7f9682590ce5c99c$var$storyPointsFieldPredicate);
    const { data: sprintField } = (0, $4S5hf.useFindField)($7f9682590ce5c99c$var$sprintFieldPredicate);
    const isLinkingEnabled = (0, $fD1Hq.useIsLinkingEnabled)();
    const [createIssue] = (0, $iZuDo.useMutation)(mutation);
    return (0, $eUqFw.useCallback)(async (createParams, extraPayload)=>{
        try {
            const input = (0, $iWGMH.buildInput)(createParams.input, locale, extraPayload, categoryField, startDateField, sprintField, storyPointEstimateField, storyPointsField);
            const fieldIdsSet = new Set(createParams.fieldIdsToReturn);
            let isParentFieldVisible = false;
            let isDevSummaryFieldVisible = false;
            if ((0, $eI5EY.fg)('jsw_list_view_-_all_the_fields')) {
                isDevSummaryFieldVisible = fieldIdsSet.has((0, $908924b2d198da78$export$20b3b4741b8cfb64));
                isParentFieldVisible = fieldIdsSet.has((0, $908924b2d198da78$export$bf9df74e065af482));
                fieldIdsSet.delete((0, $908924b2d198da78$export$20b3b4741b8cfb64));
                fieldIdsSet.delete((0, $908924b2d198da78$export$bf9df74e065af482));
            }
            const withIssueLinks = fieldIdsSet.has((0, $lO4Or.ISSUE_LINKS_TYPE)) && isLinkingEnabled && (0, $79xbN.expValEquals)('jwm_linked_issues_on_the_board_milestone_1', 'cohort', 'variation');
            fieldIdsSet.delete((0, $lO4Or.ISSUE_LINKS_TYPE));
            const withCoverMedia = fieldIdsSet.has((0, $jGcn0.CARD_COVERS_TYPE));
            fieldIdsSet.delete((0, $jGcn0.CARD_COVERS_TYPE));
            const fieldIds = Array.from(fieldIdsSet);
            const { data: data, errors: errors } = await createIssue({
                variables: {
                    input: input,
                    fieldIds: fieldIds,
                    withCoverMedia: withCoverMedia,
                    withExtendedParentField: (0, $1ybV0.ff)('jwm_board_parent_field'),
                    withChildrenCount: false,
                    isParentFieldVisible: isParentFieldVisible,
                    isDevSummaryFieldVisible: isDevSummaryFieldVisible,
                    withIssueLinks: withIssueLinks,
                    withParentIssueId: (0, $eI5EY.fg)('jsw_list_view_-_all_the_fields')
                },
                // @ts-expect-error - errorPolicy is not in the types but does work
                errorPolicy: 'all'
            });
            const result = data?.createJiraBusinessIssue;
            if (result?.success !== true || !result?.item) {
                const firstMutationError = result?.errors?.[0];
                if (firstMutationError) {
                    const statusCode = firstMutationError.extensions?.statusCode;
                    if (statusCode && statusCode >= 400 && statusCode < 500) throw new (0, $7byHA.ValidationError)(firstMutationError.message ?? 'Failed to create issue');
                    throw new (0, $kkYfO.MutationError)(firstMutationError);
                }
                throw new (0, $dlVOn.GraphQLErrors)(errors);
            }
            return {
                item: result.item,
                itemIdentifiers: {
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    issueId: result.itemIdentifiers.issueId,
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-non-null-assertion
                    issueKey: result.itemIdentifiers.issueKey[0].text
                }
            };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            if (!(error instanceof (0, $7byHA.ValidationError))) (0, $guiFP.default)({
                meta: {
                    id: 'JWMCreateIssueInline',
                    packageName: 'jiraBusinessIssueCreate',
                    teamName: 'wanjel'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            throw error;
        }
    }, [
        categoryField,
        createIssue,
        locale,
        sprintField,
        startDateField,
        storyPointEstimateField,
        storyPointsField,
        isLinkingEnabled
    ]);
};

});
parcelRegister("e4qlg", function(module, exports) {

$parcel$export(module.exports, "useCategoryField", () => $ce9b32995a7706e8$export$f7ac7f1f12b4c794);

var $lO4Or = parcelRequire("lO4Or");

var $gEmpR = parcelRequire("gEmpR");
const $ce9b32995a7706e8$export$f7ac7f1f12b4c794 = ()=>{
    const { data: { fields: fields }, loading: loading, error: error } = (0, $gEmpR.useIssueTypesAndFields)({
        issueOperation: 'VIEW'
    });
    const categoryField = fields.find((field)=>field.type === (0, $lO4Or.CATEGORY_TYPE)) ?? null;
    return {
        data: categoryField,
        loading: loading,
        error: error
    };
};

});

parcelRegister("4S5hf", function(module, exports) {

$parcel$export(module.exports, "useFindField", () => $8ce2e5c1390595df$export$4b0b80fa50e6b4be);

var $gEmpR = parcelRequire("gEmpR");
const $8ce2e5c1390595df$export$4b0b80fa50e6b4be = (predicate)=>{
    const { data: { fields: fields }, loading: loading, error: error } = (0, $gEmpR.useIssueTypesAndFields)({
        issueOperation: 'VIEW'
    });
    const field = fields.find(predicate) ?? null;
    return {
        data: field,
        loading: loading,
        error: error
    };
};

});

parcelRegister("kkYfO", function(module, exports) {

$parcel$export(module.exports, "MutationError", () => $f83939e5f3c23160$export$10c788363424e94e);
const $f83939e5f3c23160$export$bd0568a021288e41 = 'MutationError';
class $f83939e5f3c23160$export$10c788363424e94e extends Error {
    constructor(payload){
        super(payload.message ?? undefined);
        this.message = payload.message ?? '';
        this.extensions = payload.extensions;
        this.statusCode = payload.extensions?.statusCode ?? null;
    }
}

});

parcelRegister("4xHig", function(module, exports) {

$parcel$export(module.exports, "useLocale", () => $d8981c42d4d07028$export$43bb16f9c6d9e3f7);
$parcel$export(module.exports, "useNativeLocale", () => $d8981c42d4d07028$export$31652d9c30d7d3f3);

var $eUqFw = parcelRequire("eUqFw");

var $ao0hp = parcelRequire("ao0hp");

var $ao0hp = parcelRequire("ao0hp");

var $gd0Sp = parcelRequire("gd0Sp");
const $d8981c42d4d07028$export$43bb16f9c6d9e3f7 = ()=>{
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    return tenantContext && tenantContext.locale || (0, $ao0hp.defaultLocale);
};
const $d8981c42d4d07028$export$31652d9c30d7d3f3 = ()=>{
    const locale = $d8981c42d4d07028$export$43bb16f9c6d9e3f7();
    const standardizedLocale = (0, $eUqFw.useMemo)(()=>(0, $ao0hp.standardizeLocale)(locale), [
        locale
    ]);
    return standardizedLocale;
};

});

const $908924b2d198da78$export$41b6c9f5441c22c5 = 'rankBefore';
const $908924b2d198da78$export$d564e563c2ee8c4f = 'rankAfter';
const $908924b2d198da78$export$20b3b4741b8cfb64 = 'devSummaryField';
const $908924b2d198da78$export$bf9df74e065af482 = 'parentField';

parcelRegister("iWGMH", function(module, exports) {

$parcel$export(module.exports, "buildInput", () => $6cba527c033852df$export$f4db126e014728a3);

var $lO4Or = parcelRequire("lO4Or");

var $8K9kM = parcelRequire("8K9kM");

const $6cba527c033852df$export$f4db126e014728a3 = (input, locale, extraPayload, categoryField, startDateField, sprintField, storyPointEstimateField, storyPointsField)=>{
    const result = {
        projectId: input.projectId,
        issueType: input.issueType.id,
        fields: {
            singleLineTextFields: [
                {
                    fieldId: (0, $lO4Or.SUMMARY_TYPE),
                    text: input.summary
                }
            ],
            singleSelectUserPickerFields: [],
            datePickerFields: [],
            numberFields: []
        },
        rank: {}
    };
    if (input.category && categoryField?.id) result.fields.singleLineTextFields.push({
        fieldId: categoryField.id,
        text: input.category.optionId
    });
    if (input.assignee) result.fields.singleSelectUserPickerFields.push({
        fieldId: (0, $lO4Or.ASSIGNEE_TYPE),
        user: {
            accountId: input.assignee.accountId
        }
    });
    if (input.startDate && startDateField?.id) result.fields.datePickerFields.push({
        fieldId: startDateField?.id,
        date: {
            formattedDate: (0, $8K9kM.formatTimezonedWithLocale)(input.startDate, 'dd/MMM/yy', locale, 'UTC')
        }
    });
    if (input.dueDate) result.fields.datePickerFields.push({
        fieldId: (0, $lO4Or.DUE_DATE_TYPE),
        date: {
            formattedDate: (0, $8K9kM.formatTimezonedWithLocale)(input.dueDate, 'dd/MMM/yy', locale, 'UTC')
        }
    });
    if (input.priority) result.fields.priority = {
        priorityId: input.priority.priorityId
    };
    if (input.parentIssueId) result.fields.parentField = {
        issueId: input.parentIssueId
    };
    if (input.rankBefore) result.rank.before = {
        id: (0, $908924b2d198da78$export$41b6c9f5441c22c5),
        issueId: input.rankBefore.issueId
    };
    if (input.rankAfter) result.rank.after = {
        id: (0, $908924b2d198da78$export$d564e563c2ee8c4f),
        issueId: input.rankAfter.issueId
    };
    if (extraPayload.transitionId) result.transitionId = extraPayload.transitionId;
    if (input.storyPointEstimate != null && storyPointEstimateField?.id) result.fields.numberFields.push({
        fieldId: storyPointEstimateField.id,
        value: input.storyPointEstimate
    });
    if (input.storyPoints != null && storyPointsField?.id) result.fields.numberFields.push({
        fieldId: storyPointsField.id,
        value: input.storyPoints
    });
    if (input.sprint && sprintField?.id) result.fields.sprintsField = {
        fieldId: sprintField.id,
        sprints: [
            {
                sprintId: input.sprint.id
            }
        ]
    };
    return result;
};

});


parcelRegister("fop6E", function(module, exports) {

$parcel$export(module.exports, "useRefetchIssue", () => $afeef06c89f9a563$export$8bf876d423f9293d);

var $eUqFw = parcelRequire("eUqFw");

var $iZuDo = parcelRequire("iZuDo");

var $i3K0B = parcelRequire("i3K0B");

var $jGcn0 = parcelRequire("jGcn0");

var $eZbpk = parcelRequire("eZbpk");

var $lGxgz = parcelRequire("lGxgz");

var $79xbN = parcelRequire("79xbN");

var $1ybV0 = parcelRequire("1ybV0");

var $eI5EY = parcelRequire("eI5EY");

var $lO4Or = parcelRequire("lO4Or");

var $fD1Hq = parcelRequire("fD1Hq");

var $dWLk9 = parcelRequire("dWLk9");
function $afeef06c89f9a563$export$fd83eea6ecd2d8fa(query) {
    const client = (0, $iZuDo.useApolloClient)();
    return (0, $eUqFw.useCallback)((variables)=>client.query({
            query: query,
            variables: variables,
            errorPolicy: 'all'
        }), [
        client,
        query
    ]);
}
const $afeef06c89f9a563$export$8bf876d423f9293d = (query)=>{
    const cloudId = (0, $dWLk9.useCloudId)();
    const jqlContext = (0, $eZbpk.useJqlContext)();
    const filtersJQL = (0, $lGxgz.useFilteredViewJQL)();
    const isLinkingEnabled = (0, $fD1Hq.useIsLinkingEnabled)();
    const refetchIssue = $afeef06c89f9a563$export$fd83eea6ecd2d8fa(query);
    return (0, $eUqFw.useCallback)(async (issueId, fieldIds, withFiltersContext)=>{
        const jql = (0, $i3K0B.generateJql)({
            jqlContext: jqlContext,
            quickFiltersJql: withFiltersContext ? filtersJQL : undefined,
            issueIds: [
                issueId
            ]
        });
        const fieldIdsSet = new Set(fieldIds);
        const withIssueLinks = fieldIdsSet.has((0, $lO4Or.ISSUE_LINKS_TYPE)) && isLinkingEnabled && (0, $79xbN.expValEquals)('jwm_linked_issues_on_the_board_milestone_1', 'cohort', 'variation');
        fieldIdsSet.delete((0, $lO4Or.ISSUE_LINKS_TYPE));
        const withCoverMedia = fieldIdsSet.has((0, $jGcn0.CARD_COVERS_TYPE));
        const fieldIdsToRequest = Array.from(fieldIdsSet);
        const { data: data } = await refetchIssue({
            jql: jql,
            fieldIds: fieldIdsToRequest,
            cloudId: cloudId,
            first: 1,
            withCoverMedia: withCoverMedia,
            withExtendedParentField: (0, $1ybV0.ff)('jwm_board_parent_field'),
            withChildrenCount: false,
            isParentFieldVisible: false,
            isDevSummaryFieldVisible: false,
            withIssueLinks: withIssueLinks,
            withParentIssueId: (0, $eI5EY.fg)('jsw_list_view_-_all_the_fields')
        });
        const viewItems = data?.jira?.jwmViewItems;
        if (!viewItems || viewItems.__typename === 'QueryError') throw new Error('Issue not found');
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const issue = viewItems.edges?.[0]?.node;
        return issue ?? null;
    }, [
        cloudId,
        filtersJQL,
        jqlContext,
        refetchIssue,
        isLinkingEnabled
    ]);
};

});
parcelRegister("i3K0B", function(module, exports) {

$parcel$export(module.exports, "generateJql", () => $6bd61e247d9e0007$export$d43e55153d6948c0);
$parcel$export(module.exports, "getVariables", () => $6bd61e247d9e0007$export$a39eddd73bba62c1);

var $jGcn0 = parcelRequire("jGcn0");

var $1ybV0 = parcelRequire("1ybV0");

var $eI5EY = parcelRequire("eI5EY");


var $lF3sI = parcelRequire("lF3sI");
const $6bd61e247d9e0007$var$DEFAULT_CHILDREN_PER_PAGE = (0, $jGcn0.DEFAULT_PAGE_SIZE);
const $6bd61e247d9e0007$var$IS_EMPTY = 'IS EMPTY';
const $6bd61e247d9e0007$var$IS_NOT_EMPTY = 'IS NOT EMPTY';
const $6bd61e247d9e0007$export$d43e55153d6948c0 = (input, parentIssueForJql)=>{
    const { groupQuery: groupQuery, hierarchyLevel: hierarchyLevel, hierarchyParent: hierarchyParent, issueIds: issueIds, jqlContext: jqlContext, projectIdOrKey: projectIdOrKey, quickFiltersJql: quickFiltersJql, sorting: sorting } = input;
    const defaultSorting = `ORDER BY Rank ${(0, $jGcn0.DEFAULT_RANK_SORTING_DIRECTION)}`;
    const jql = [];
    // Check if sorting direction is valid, the direction possible passed from the URL params which can be invalid
    const isValidDirection = (0, $1ybV0.ff)('jwm.fix-list-view-jql-query-errors_5jp7y') ? sorting?.direction?.toUpperCase() === 'ASC' || sorting?.direction?.toUpperCase() === 'DESC' : true;
    const sortByClause = sorting != null && sorting.sortBy != null && sorting.direction != null && isValidDirection ? `ORDER By ${(0, $lF3sI.getJqlTerm)(sorting.sortBy)} ${sorting.direction}, Rank ${sorting.direction}` : defaultSorting;
    if (Array.isArray(issueIds) && issueIds.length > 0) jql.push(`(${issueIds.map((id)=>`id = ${id}`).join(' or ')})`);
    if (jqlContext) jql.push(jqlContext);
    else if (typeof projectIdOrKey !== 'undefined') jql.push(`project = '${projectIdOrKey}'`);
    if (typeof hierarchyLevel === 'number' && hierarchyParent === (0, $2a7b21c0842403e6$export$9355e489ad16f98e)) {
        // fetch items by hierarchyLevel + any item that doesn't have a parent (e.g. tasks that don't belong to any Epic)
        if ((0, $1ybV0.ff)('list-uses-new-jql-parent-project-directive_v5gfs') && typeof projectIdOrKey !== 'undefined') jql.push(`(hierarchyLevel = ${hierarchyLevel} OR parent ${$6bd61e247d9e0007$var$IS_EMPTY} OR (parent ${$6bd61e247d9e0007$var$IS_NOT_EMPTY} AND parentProject != '${projectIdOrKey}'))`);
        else jql.push(`(hierarchyLevel = ${hierarchyLevel} OR parent ${$6bd61e247d9e0007$var$IS_EMPTY})`);
    }
    if (hierarchyParent === (0, $2a7b21c0842403e6$export$9355e489ad16f98e)) jql.push('type in standardIssueTypes()');
    // Controls the query to get all children for a single parent
    if (parentIssueForJql && parentIssueForJql.hierarchyType === (0, $2a7b21c0842403e6$export$9355e489ad16f98e)) jql.push(`parent = '${parentIssueForJql.issueId}'`);
    // Controls the query to get group items
    if (groupQuery) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const { jqlTerm: jqlTerm, value: value } = groupQuery;
        if (!value) jql.push(`${jqlTerm} ${$6bd61e247d9e0007$var$IS_EMPTY}`);
        else jql.push(`${jqlTerm} = ${value}`);
        if (hierarchyParent === (0, $2a7b21c0842403e6$export$9355e489ad16f98e)) {
            if ((0, $1ybV0.ff)('list-uses-new-jql-parent-project-directive_v5gfs') && typeof projectIdOrKey !== 'undefined') jql.push(`(parent ${$6bd61e247d9e0007$var$IS_EMPTY} OR (parent ${$6bd61e247d9e0007$var$IS_NOT_EMPTY} AND parentProject != '${projectIdOrKey}'))`);
            else jql.push(`parent ${$6bd61e247d9e0007$var$IS_EMPTY}`);
        }
    }
    if (quickFiltersJql != null) jql.push(`(${quickFiltersJql})`);
    return `${jql.join(' AND ')} ${sortByClause}`;
};
const $6bd61e247d9e0007$export$a39eddd73bba62c1 = (input)=>{
    const { fieldIds: fieldIds, parentIssue: parentIssue } = input;
    const singleQueryJql = {
        jql: $6bd61e247d9e0007$export$d43e55153d6948c0(input, parentIssue)
    };
    // REMOTE_ISSUE_LINKS_TYPE should not be part of the fieldIds as it is only used to determine
    // whether legacyConfluenceLinks(JIS2) is fetched
    const newFieldIds = Array.isArray(fieldIds) ? [
        ...fieldIds
    ] : [];
    const remoteIssueLinksIndex = newFieldIds.indexOf((0, $jGcn0.REMOTE_ISSUE_LINKS_TYPE));
    const hasConfluenceLinks = remoteIssueLinksIndex > -1;
    if (hasConfluenceLinks) newFieldIds.splice(remoteIssueLinksIndex, 1);
    return {
        ...singleQueryJql,
        first: parentIssue ? $6bd61e247d9e0007$var$DEFAULT_CHILDREN_PER_PAGE : (0, $jGcn0.DEFAULT_PAGE_SIZE),
        fieldIds: newFieldIds,
        withConfluenceLinks: hasConfluenceLinks,
        includeDoneItems: input.isHidingDoneItems === false,
        isParentFieldVisible: input.isParentFieldVisible ?? false,
        isDevSummaryFieldVisible: input.isDevSummaryFieldVisible ?? false,
        withParentRank: (0, $1ybV0.ff)('jwm-timeline-sort-parent-rank-first_waal4'),
        withParentIssueId: (0, $eI5EY.fg)('jsw_list_view_-_all_the_fields')
    };
};

});
const $2a7b21c0842403e6$export$9355e489ad16f98e = 'TASK';
const $2a7b21c0842403e6$export$3cb4a99a332e4186 = 'EPIC';

parcelRegister("lF3sI", function(module, exports) {

$parcel$export(module.exports, "getJqlTerm", () => $74367c535f0c8550$export$43330b5a5235b231);
const $74367c535f0c8550$export$43330b5a5235b231 = (fieldId)=>{
    // custom fields are indexed by their ids and only work with JQL when referenced as such `cf[id]`.
    if (fieldId.indexOf('customfield_') === 0) {
        const customFieldId = fieldId.split('customfield_')[1];
        return `cf[${customFieldId}]`;
    }
    return fieldId;
};

});


parcelRegister("lGxgz", function(module, exports) {

$parcel$export(module.exports, "useFilteredViewJQL", () => $6fc881cfc8a36877$export$a50cc7c1087f7d9b);
$parcel$export(module.exports, "useFilteredViewContextInput", () => $6fc881cfc8a36877$export$d566b5d8a729afa0);

var $eUqFw = parcelRequire("eUqFw");


var $eZbpk = parcelRequire("eZbpk");

var $1ybV0 = parcelRequire("1ybV0");

var $eI5EY = parcelRequire("eI5EY");

var $lO4Or = parcelRequire("lO4Or");

var $iaCjO = parcelRequire("iaCjO");

var $gZpkQ = parcelRequire("gZpkQ");

var $lEWmB = parcelRequire("lEWmB");

var $96etS = parcelRequire("96etS");

var $jQFcD = parcelRequire("jQFcD");
const $6fc881cfc8a36877$export$a50cc7c1087f7d9b = ()=>{
    const { addSimpleSearchToJQL: addSimpleSearchToJQL } = (0, $96etS.useSimpleSearchJQL)();
    const { jql: jql } = (0, $lEWmB.useFilters)();
    const [isHidingDoneItems] = (0, $gZpkQ.useHideDoneItems)();
    // ensure views recieve filters jql that will not cause a page crash
    const jqlSanitised = (0, $eUqFw.useMemo)(()=>(0, $jQFcD.sanitiseJql)(jql), [
        jql
    ]);
    const filtersJQL = (0, $eUqFw.useMemo)(()=>{
        if (isHidingDoneItems) {
            const filtersJql = [
                jqlSanitised,
                "StatusCategory != 'Complete'"
            ].filter(Boolean).join(' AND ');
            return addSimpleSearchToJQL(filtersJql);
        }
        return addSimpleSearchToJQL(jqlSanitised || null);
    }, [
        jqlSanitised,
        addSimpleSearchToJQL,
        isHidingDoneItems
    ]);
    return filtersJQL;
};
const $6fc881cfc8a36877$var$FIX_VERSION_SORTING_JQL = 'fixVersion';
const $6fc881cfc8a36877$export$d566b5d8a729afa0 = ({ view: view })=>{
    const filtersJQL = $6fc881cfc8a36877$export$a50cc7c1087f7d9b();
    const { isSearching: isSearching } = (0, $96etS.useSimpleSearchJQL)();
    const [sortingBy] = (0, $iaCjO.useSorting)();
    const { jql: jql } = (0, $lEWmB.useFilters)();
    const isFiltering = jql != null || isSearching;
    const [isHidingDoneItems] = (0, $gZpkQ.useHideDoneItems)();
    const jqlContext = (0, $eZbpk.useJqlContext)();
    const hierarchyParent = (view === 'list' || view === 'timeline') && !isFiltering ? (0, $2a7b21c0842403e6$export$9355e489ad16f98e) : undefined;
    const jqlErrors = (0, $eUqFw.useMemo)(()=>{
        if ((0, $1ybV0.ff)('jwm.filters.handle-invalid-jql')) return (0, $jQFcD.getJqlErrors)(jql);
        return [];
    }, [
        jql
    ]);
    const sorting = (0, $eUqFw.useMemo)(()=>{
        /*
			When sorting by a specific field, we use the fieldId in the JQL query.
			For the fix version field, the fieldId doesn’t work in JQL must be “fixVersion”.
			Apparently, "fixVersion" is the clause name. It's a legacy choice that was made from the very beginning, and now we're unable to change it.
		*/ if (sortingBy.sortBy === (0, $lO4Or.FIX_VERSIONS_TYPE) && (0, $eI5EY.fg)('jsw_list_view_-_all_the_fields')) return {
            ...sortingBy,
            sortBy: $6fc881cfc8a36877$var$FIX_VERSION_SORTING_JQL
        };
        return sortingBy;
    }, [
        sortingBy
    ]);
    return {
        jqlContext: jqlContext,
        quickFiltersJql: filtersJQL,
        sorting: sorting,
        isFiltering: isFiltering,
        hierarchyParent: hierarchyParent,
        isHidingDoneItems: isHidingDoneItems,
        jqlErrors: jqlErrors
    };
};

});
parcelRegister("iaCjO", function(module, exports) {

$parcel$export(module.exports, "useSorting", () => $35b6a42c26975572$export$21ebc1ba2b2bee67);
$parcel$export(module.exports, "useSorter", () => $35b6a42c26975572$export$f161a6f9d84a6fea);

var $eUqFw = parcelRequire("eUqFw");

var $35jYz = parcelRequire("35jYz");
var $gEmpR = parcelRequire("gEmpR");

var $2i84A = parcelRequire("2i84A");

var $ji3xf = parcelRequire("ji3xf");
var $7c3W1 = parcelRequire("7c3W1");

var $1ybV0 = parcelRequire("1ybV0");

var $a75Ge = parcelRequire("a75Ge");

var $a6BBe = parcelRequire("a6BBe");

var $iP9h2 = parcelRequire("iP9h2");
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
const $35b6a42c26975572$var$EMPTY_SORTING_ATTRIBUTE = {};
const $35b6a42c26975572$export$21ebc1ba2b2bee67 = ()=>{
    const [sorting, setSorting] = (0, $7c3W1.useViewPreference)((0, $ji3xf.SORTING_PREFERENCE));
    return [
        sorting || $35b6a42c26975572$var$EMPTY_SORTING_ATTRIBUTE,
        setSorting
    ];
};
const $35b6a42c26975572$var$emptyArray = [];
const $35b6a42c26975572$export$f161a6f9d84a6fea = ()=>{
    const [sorting] = $35b6a42c26975572$export$21ebc1ba2b2bee67();
    const [sortingFieldConfig] = (0, $35jYz.useIssueTypeFieldConfig)({
        screen: 'VIEW',
        issueTypeId: 'default',
        fieldId: sorting.sortBy
    });
    const [priorityFieldConfig] = (0, $35jYz.useIssueTypeFieldConfig)({
        screen: 'VIEW',
        issueTypeId: 'default',
        fieldId: 'priority'
    });
    const { data: data } = (0, $gEmpR.useIssueTypesAndFields)({
        issueOperation: 'VIEW'
    });
    const sortingFieldConfigFieldType = sortingFieldConfig?.fieldType ?? data?.fields?.find((field)=>field?.id === sorting.sortBy)?.type;
    const { statuses: statuses } = (0, $1ybV0.ff)('jwm.list.filters.sort-by-project-statuses') ? (0, $a75Ge.useProjectStatuses)() : (0, $2i84A.useGlobalStatuses)();
    const priorities = priorityFieldConfig?.options || $35b6a42c26975572$var$emptyArray;
    const sortFunction = (0, $eUqFw.useCallback)((issues)=>{
        const getPrioritiesSortedList = ()=>[
                ...priorities
            ].reverse().reduce((acc, next, index)=>{
                acc[next.priorityId] = index;
                return acc;
            }, {});
        const getIssueTypesSortedList = ()=>[
                ...data.issueTypes
            ].sort((a, b)=>a.name.localeCompare(b.name)).reduce((acc, next, index)=>{
                acc[next.name] = index;
                return acc;
            }, {});
        const getStatusSortOrder = (key)=>{
            if (key in (0, $a6BBe.STATUS_SORT_ORDER)) return (0, $a6BBe.STATUS_SORT_ORDER)[key];
            return -1;
        };
        const getStatusesSortedList = ()=>[
                ...statuses
            ].sort((a, b)=>{
                const orderComparison = getStatusSortOrder(a.statusCategory.key) - getStatusSortOrder(b.statusCategory.key);
                if (orderComparison !== 0) return orderComparison;
                // If the status category order is the same, then sort alphabetically by name.
                return a.name.localeCompare(b.name);
            }).reduce((acc, next, index)=>{
                acc[next.name] = index;
                return acc;
            }, {});
        const sortedLists = {
            priorities: getPrioritiesSortedList(),
            issueTypes: getIssueTypesSortedList(),
            statuses: getStatusesSortedList()
        };
        const { getters: getters, orders: orders } = (0, $iP9h2.createSortingGettersAndOrders)(sorting, sortingFieldConfigFieldType, sortedLists);
        return (0, $iP9h2.sortListBy)(issues, getters, orders);
    }, [
        sorting,
        sortingFieldConfigFieldType,
        priorities,
        data.issueTypes,
        statuses
    ]);
    return {
        sort: sortFunction
    };
};

});
parcelRegister("35jYz", function(module, exports) {

$parcel$export(module.exports, "useIssueTypeFieldConfig", () => $81e81ebd14cd3d82$export$42e875bfb69ded2);

var $eUqFw = parcelRequire("eUqFw");

var $illlw = parcelRequire("illlw");

var $ggKAj = parcelRequire("ggKAj");
var $bj4JM = parcelRequire("bj4JM");
var $a61MH = parcelRequire("a61MH");

var $gEmpR = parcelRequire("gEmpR");
const $81e81ebd14cd3d82$var$merge = (screen, issueTypeId, configs)=>({ setState: setState, getState: getState })=>{
        setState({
            ...getState(),
            [screen]: {
                ...(0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(getState(), [
                    screen
                ], {}),
                [issueTypeId]: configs
            }
        });
    };
const $81e81ebd14cd3d82$var$actions = {
    merge: $81e81ebd14cd3d82$var$merge
};
const $81e81ebd14cd3d82$export$cbf0f7fe9ca42a65 = (0, $a61MH.createStore)({
    initialState: {},
    actions: $81e81ebd14cd3d82$var$actions,
    name: 'issueTypeFieldConfig'
});
const $81e81ebd14cd3d82$var$getIssueTypeFieldConfigSelector = (0, $bj4JM.createSelector)((state)=>state, (_, props)=>props?.screen ?? undefined, (_, props)=>props?.issueTypeId ?? undefined, (_, props)=>props?.fieldId ?? undefined, (state, screen, issueTypeId, fieldId)=>{
    if (screen === undefined || issueTypeId === undefined || fieldId === undefined) return null;
    return (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(state, [
        screen,
        issueTypeId,
        fieldId
    ], null);
});
const $81e81ebd14cd3d82$export$47647eb426e85a25 = (0, $ggKAj.createHook)($81e81ebd14cd3d82$export$cbf0f7fe9ca42a65, {
    selector: $81e81ebd14cd3d82$var$getIssueTypeFieldConfigSelector
});
const $81e81ebd14cd3d82$export$42e875bfb69ded2 = (props)=>{
    const [state, fieldsConfigActions] = $81e81ebd14cd3d82$export$47647eb426e85a25(props);
    const screen = props?.screen || 'VIEW';
    const { data: data, loading: loading, error: error } = (0, $gEmpR.useIssueTypesAndFields)({
        issueOperation: screen
    });
    // store field config to be consumed at the cell level
    return (0, $eUqFw.useMemo)(()=>{
        if (state != null) return [
            state,
            fieldsConfigActions,
            {
                loading: false,
                error: undefined
            }
        ];
        if (loading === false && (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(data, [
            'issueTypes'
        ], []).length > 0) data.issueTypes.forEach((issueType)=>{
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const config = {};
            data.fields.forEach((field)=>{
                if ((field.issueTypes || []).includes(issueType.id) && field.id != null) config[field.id] = {
                    ...field.fieldConfig,
                    fieldType: field.type
                };
            });
            fieldsConfigActions.merge(screen, issueType.id, config);
            if (issueType.isDefault) fieldsConfigActions.merge(screen, 'default', config);
        });
        return [
            state,
            fieldsConfigActions,
            {
                loading: loading,
                error: error
            }
        ];
    }, [
        data,
        error,
        fieldsConfigActions,
        loading,
        screen,
        state
    ]);
};

});

parcelRegister("2i84A", function(module, exports) {

$parcel$export(module.exports, "useGlobalStatuses", () => $6dcdae727178c9b6$export$96ca88c93202037);

var $eUqFw = parcelRequire("eUqFw");

var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");

var $gUUjF = parcelRequire("gUUjF");
const $6dcdae727178c9b6$var$PACKAGE_LOCATION = 'jira-business.common.services.global-statuses';
const $6dcdae727178c9b6$var$MAX_RETRIES = 3;
const $6dcdae727178c9b6$var$set = (statuses)=>({ setState: setState })=>setState({
            statuses: statuses
        });
const $6dcdae727178c9b6$var$actions = {
    set: $6dcdae727178c9b6$var$set
};
const $6dcdae727178c9b6$var$GlobalStatusesStore = (0, $a61MH.createStore)({
    initialState: {
        statuses: []
    },
    actions: $6dcdae727178c9b6$var$actions,
    name: 'globalStatuses'
});
const $6dcdae727178c9b6$export$d8357dfc5f272b90 = (0, $ggKAj.createHook)($6dcdae727178c9b6$var$GlobalStatusesStore);
const $6dcdae727178c9b6$var$emptyArray = [];
const $6dcdae727178c9b6$export$96ca88c93202037 = ()=>{
    const [isLoading, setIsLoading] = (0, $eUqFw.useState)(false);
    const [hasLoaded, setHasLoaded] = (0, $eUqFw.useState)(false);
    const [retriesCount, setRetriesCount] = (0, $eUqFw.useState)(0);
    const [state, statusActions] = $6dcdae727178c9b6$export$d8357dfc5f272b90();
    const retry = ()=>{
        setRetriesCount(retriesCount + 1);
        setIsLoading(false);
        setHasLoaded(false);
    };
    if (Array.isArray(state.statuses) && state.statuses.length > 0) return {
        statuses: state.statuses,
        loading: isLoading
    };
    if (!isLoading && !hasLoaded) {
        fetch('/rest/api/3/status').then((response)=>response.json()).then((statuses)=>{
            statusActions.set(statuses);
            setIsLoading(false);
            setHasLoaded(true);
        }).catch(()=>{
            (0, $gUUjF.default).safeErrorWithoutCustomerData($6dcdae727178c9b6$var$PACKAGE_LOCATION, `Failed to retrieve global statuses - Retry #${retriesCount}`);
            if (retriesCount < $6dcdae727178c9b6$var$MAX_RETRIES) retry();
        });
        setIsLoading(true);
    }
    return {
        statuses: $6dcdae727178c9b6$var$emptyArray,
        loading: isLoading
    };
};

});

parcelRegister("a75Ge", function(module, exports) {

$parcel$export(module.exports, "useProjectStatuses", () => $342d49f1f4fd71f7$export$11ff6a520db76faf);

var $eUqFw = parcelRequire("eUqFw");

var $3G3gn = parcelRequire("3G3gn");

var $lyOYo = parcelRequire("lyOYo");

var $ggKAj = parcelRequire("ggKAj");
var $bj4JM = parcelRequire("bj4JM");
var $a61MH = parcelRequire("a61MH");

var $kQAZu = parcelRequire("kQAZu");

var $gUUjF = parcelRequire("gUUjF");
const $342d49f1f4fd71f7$var$PACKAGE_LOCATION = 'jira-business.common.services.project-statuses';
const $342d49f1f4fd71f7$var$MAX_RETRIES = 3;
const $342d49f1f4fd71f7$var$set = (projectKey, statuses)=>({ setState: setState })=>setState({
            [projectKey]: statuses
        });
const $342d49f1f4fd71f7$var$actions = {
    set: $342d49f1f4fd71f7$var$set
};
const $342d49f1f4fd71f7$var$ProjectStatusesStore = (0, $a61MH.createStore)({
    initialState: {},
    actions: $342d49f1f4fd71f7$var$actions,
    name: 'projectStatuses'
});
const $342d49f1f4fd71f7$var$getProjectStatusesSelector = (0, $bj4JM.createSelector)((state)=>state, (_, props)=>props?.projectKey ?? undefined, (state, projectKey)=>{
    if (projectKey === undefined || state[projectKey] == null) return [];
    return state[projectKey];
});
const $342d49f1f4fd71f7$export$482f388228eef22c = (0, $ggKAj.createHook)($342d49f1f4fd71f7$var$ProjectStatusesStore, {
    selector: $342d49f1f4fd71f7$var$getProjectStatusesSelector
});
const $342d49f1f4fd71f7$var$emptyArray = [];
const $342d49f1f4fd71f7$export$11ff6a520db76faf = ()=>{
    const [isLoading, setIsLoading] = (0, $eUqFw.useState)(false);
    const [hasLoaded, setHasLoaded] = (0, $eUqFw.useState)(false);
    const [retriesCount, setRetriesCount] = (0, $eUqFw.useState)(0);
    const projectData = (0, $kQAZu.useProject)();
    const projectKey = projectData.key;
    const [statuses, statusActions] = $342d49f1f4fd71f7$export$482f388228eef22c({
        projectKey: projectKey
    });
    const retry = ()=>{
        setRetriesCount(retriesCount + 1);
        setIsLoading(false);
        setHasLoaded(false);
    };
    if (projectKey != null && Array.isArray(statuses) && statuses.length > 0) return {
        statuses: statuses,
        loading: isLoading
    };
    if (!isLoading && !hasLoaded) {
        fetch(`/rest/api/3/project/${projectKey}/statuses`).then((response)=>response.json()).then((issueTypes)=>{
            const allStatuses = issueTypes.reduce(// @ts-expect-error - TS7006 - Parameter 'acc' implicitly has an 'any' type. | TS7006 - Parameter 'next' implicitly has an 'any' type.
            (acc, next)=>acc.concat(next.statuses), []);
            const dedupedResults = (0, (/*@__PURE__*/$parcel$interopDefault($lyOYo)))(allStatuses, 'id');
            return (0, (/*@__PURE__*/$parcel$interopDefault($3G3gn)))(dedupedResults, [
                'name'
            ]);
        }).then((uniqueStatuses)=>{
            statusActions.set(projectKey, uniqueStatuses);
            setIsLoading(false);
            setHasLoaded(true);
        }).catch(()=>{
            (0, $gUUjF.default).safeErrorWithoutCustomerData($342d49f1f4fd71f7$var$PACKAGE_LOCATION, `Failed to retrieve project statuses - Retry #${retriesCount}`);
            if (retriesCount < $342d49f1f4fd71f7$var$MAX_RETRIES) retry();
        });
        setIsLoading(true);
    }
    return {
        statuses: $342d49f1f4fd71f7$var$emptyArray,
        loading: isLoading
    };
};

});

parcelRegister("a6BBe", function(module, exports) {

$parcel$export(module.exports, "STATUS_SORT_ORDER", () => $4f70cf7d8b2e6b0e$export$de9c103e53e690d1);
const $4f70cf7d8b2e6b0e$export$de9c103e53e690d1 = {
    new: 1,
    indeterminate: 2,
    done: 3
};

});

parcelRegister("iP9h2", function(module, exports) {

$parcel$export(module.exports, "sortListBy", () => $61a5cf2a87fc48eb$export$3793ed28be8699ad);
$parcel$export(module.exports, "createSortingGettersAndOrders", () => $61a5cf2a87fc48eb$export$b3fdfcb601c683c3);

var $bDIST = parcelRequire("bDIST");

var $jGcn0 = parcelRequire("jGcn0");

var $6imc4 = parcelRequire("6imc4");

var $iJbbQ = parcelRequire("iJbbQ");

var $3uSNh = parcelRequire("3uSNh");

var $8Qd0L = parcelRequire("8Qd0L");

var $1ybV0 = parcelRequire("1ybV0");

var $eI5EY = parcelRequire("eI5EY");

var $lO4Or = parcelRequire("lO4Or");

var $90Dtq = parcelRequire("90Dtq");
const $61a5cf2a87fc48eb$var$DEFAULT_HIGHER_RANKING_VALUE = 'Z';
const $61a5cf2a87fc48eb$var$DEFAULT_LOWER_RANKING_VALUE = '~~';
const $61a5cf2a87fc48eb$var$DEFAULT_LOWER_RANKING_NUMBER_VALUE = 0;
const $61a5cf2a87fc48eb$var$toAcceptedOrder = (order)=>order != null && order.toLowerCase() === 'asc' ? 'asc' : 'desc';
const $61a5cf2a87fc48eb$export$3793ed28be8699ad = (nodes, getters, orders)=>(0, (/*@__PURE__*/$parcel$interopDefault($bDIST)))(nodes, getters, orders.map($61a5cf2a87fc48eb$var$toAcceptedOrder));
const $61a5cf2a87fc48eb$var$getValueMapAndJoin = (fields, fieldKey, attributeName, defaultValue, // eslint-disable-next-line @typescript-eslint/no-explicit-any
getMapValueCb)=>{
    // join array with space so alphabetical order can be applied.
    // @ts-expect-error - TS2345 - Argument of type 'string | null | undefined' is not assignable to parameter of type 'string | undefined'.
    const fieldValue = (0, $3uSNh.safeGetValue)(fields, fieldKey, attributeName, defaultValue) ?? defaultValue;
    return fieldValue.map(getMapValueCb).join(' ') || $61a5cf2a87fc48eb$var$DEFAULT_LOWER_RANKING_VALUE;
};
/* eslint-enable complexity */ const $61a5cf2a87fc48eb$var$resolvePriorityOrder = (fields, priorities)=>{
    const priorityId = (0, $3uSNh.safeGetValue)(fields, 'priority', 'priorityId', '');
    const priorityOrder = priorities[priorityId];
    if (priorityOrder == null) return -1;
    return priorityOrder;
};
const $61a5cf2a87fc48eb$var$resolveStatusOrder = (fields, statuses)=>{
    const statusName = (0, $3uSNh.safeGetValue)(fields, 'status', 'name', '');
    const statusOrder = statuses[statusName];
    if (statusOrder == null) return -1;
    return statusOrder;
};
const $61a5cf2a87fc48eb$var$resolveTypeOrder = (fields, types)=>{
    const typeName = (0, $3uSNh.safeGetValue)(fields, 'issuetype', 'value', '');
    const typeOrder = types[typeName];
    if (typeOrder == null) return -1;
    return typeOrder;
};
const $61a5cf2a87fc48eb$var$resolveIssueKeyOrder = (fields)=>{
    const [, issueKeyNumber = 0] = (0, $3uSNh.safeGetValue)(fields, 'issuekey', 'value', '').split('-');
    return Number(issueKeyNumber);
};
const $61a5cf2a87fc48eb$var$resolveCustomTextFieldOrder = (fields, sortingField)=>{
    // wiki value will be null when empty
    const value = (0, $3uSNh.safeGetValue)(fields, sortingField, 'value', null);
    return value != null ? value.toLowerCase() : $61a5cf2a87fc48eb$var$DEFAULT_LOWER_RANKING_VALUE; // empty values should rank lower
};
/* eslint-disable complexity */ const $61a5cf2a87fc48eb$var$createSortableGetter = (fieldType, sortingField, sortedList)=>(node)=>{
        const { rank: rank, fields: fields = [] } = node;
        if (fieldType != null && (0, $6imc4.isSortingSupportedFieldTypePredicated)(fieldType) && (0, $6imc4.isSortingSupported)(fieldType) && (0, $eI5EY.fg)('jsw_list_view_-_all_the_fields')) {
            const field = (0, $3uSNh.getFieldValue)(fields, sortingField);
            if ((0, $iJbbQ.isNewTransformedFieldPredicated)(field)) return (0, $6imc4.getSorting)(fieldType, field) || $61a5cf2a87fc48eb$var$DEFAULT_LOWER_RANKING_VALUE;
            return $61a5cf2a87fc48eb$var$DEFAULT_LOWER_RANKING_VALUE;
        }
        switch(fieldType){
            case 0, $lO4Or.LABELS_TYPE:
            case 0, $lO4Or.LABELS_CF_TYPE:
                // The backend will return [''] when it's empty so our default value might not be applied so we force return ~~ when it happens so empty items are ordered properly
                return $61a5cf2a87fc48eb$var$getValueMapAndJoin(fields, sortingField, 'value', [
                    ''
                ], (label)=>label.toLowerCase());
            case 0, $lO4Or.PRIORITY_TYPE:
                return $61a5cf2a87fc48eb$var$resolvePriorityOrder(fields, sortedList != null && sortedList.priorities || {});
            case 0, $lO4Or.STATUS_TYPE:
                return $61a5cf2a87fc48eb$var$resolveStatusOrder(fields, sortedList != null && sortedList.statuses || {});
            case 0, $lO4Or.ISSUE_TYPE:
                return $61a5cf2a87fc48eb$var$resolveTypeOrder(fields, sortedList != null && sortedList.issueTypes || {});
            case 0, $lO4Or.ASSIGNEE_TYPE:
            case 0, $lO4Or.REPORTER_TYPE:
                return (0, $3uSNh.safeGetValue)(fields, sortingField, 'value.name', // unassigned items are ranked higher than the ones with an user :shrug:
                $61a5cf2a87fc48eb$var$DEFAULT_LOWER_RANKING_VALUE).toLowerCase();
            case 0, $lO4Or.USER_CF_TYPE:
                return (0, $3uSNh.safeGetValue)(fields, sortingField, 'value.name', // unassigned items are ranked higher than the ones with an user :shrug:
                $61a5cf2a87fc48eb$var$DEFAULT_LOWER_RANKING_VALUE).toLowerCase();
            case 'issuekey':
                return $61a5cf2a87fc48eb$var$resolveIssueKeyOrder(fields);
            case 0, $lO4Or.CREATED:
            case 0, $lO4Or.UPDATED:
                return (0, $3uSNh.safeGetValue)(fields, sortingField, 'value', '');
            case 0, $lO4Or.DATE_CF_TYPE:
                return (0, $3uSNh.safeGetValue)(fields, sortingField, 'value', $61a5cf2a87fc48eb$var$DEFAULT_HIGHER_RANKING_VALUE);
            case 0, $lO4Or.DUE_DATE_TYPE:
                return (0, $3uSNh.safeGetValue)(fields, sortingField, 'value', // empty dates are ranked higher than the ones with set date :shrug:
                $61a5cf2a87fc48eb$var$DEFAULT_HIGHER_RANKING_VALUE);
            case 0, $lO4Or.DATETIME_CF_TYPE:
                return (0, $3uSNh.safeGetValue)(fields, sortingField, 'value', $61a5cf2a87fc48eb$var$DEFAULT_HIGHER_RANKING_VALUE);
            case 0, $jGcn0.RANK_ALIAS_FIELD_ID:
                if ((0, $1ybV0.ff)('list-uses-new-jql-parent-project-directive_v5gfs')) {
                    // We want to check for l-1 if the new jql parent is on
                    if ((0, $3uSNh.safeGetValue)(fields, 'issuetype', 'level', undefined) === -1) return (0, $90Dtq.resolveRank)((0, $3uSNh.safeGetValue)(fields, 'parent', 'value', undefined), rank ?? '');
                } else return (0, $90Dtq.resolveRank)((0, $3uSNh.safeGetValue)(fields, 'parent', 'value', undefined), rank ?? '');
                return rank ?? '';
            case 0, $lO4Or.SUMMARY_TYPE:
                return (0, $3uSNh.safeGetValue)(fields, sortingField, 'value', '').toLowerCase();
            case 0, $lO4Or.TEXT_CF_TYPE:
                return $61a5cf2a87fc48eb$var$resolveCustomTextFieldOrder(fields, sortingField);
            case 0, $lO4Or.SELECT_CF_TYPE:
            case 0, $lO4Or.CATEGORY_TYPE:
                return (0, $3uSNh.safeGetValue)(fields, sortingField, 'value.value', $61a5cf2a87fc48eb$var$DEFAULT_LOWER_RANKING_VALUE);
            case 0, $lO4Or.MULTI_SELECT_CF_TYPE:
            case 0, $lO4Or.MULTI_CHECKBOXES_CF_TYPE:
                return $61a5cf2a87fc48eb$var$getValueMapAndJoin(fields, sortingField, 'value', [], (selectedValue)=>selectedValue?.value.toLowerCase());
            case 0, $lO4Or.TIME_ESTIMATE_TYPE:
                return (0, $3uSNh.safeGetValue)(fields, sortingField, 'value.timeInSeconds', $61a5cf2a87fc48eb$var$DEFAULT_LOWER_RANKING_NUMBER_VALUE);
            case 0, $lO4Or.URL_CF_TYPE:
                return (0, $3uSNh.safeGetValue)(fields, sortingField, 'value', $61a5cf2a87fc48eb$var$DEFAULT_LOWER_RANKING_VALUE);
            case 0, $lO4Or.NUMBER_CF_TYPE:
            case 0, $lO4Or.STORY_POINTS_TYPE:
            case 0, $lO4Or.STORY_POINT_ESTIMATE_CF_TYPE:
                return (0, $3uSNh.safeGetValue)(fields, sortingField, 'value', $61a5cf2a87fc48eb$var$DEFAULT_LOWER_RANKING_NUMBER_VALUE);
            case 0, $lO4Or.COMPONENTS_TYPE:
                return $61a5cf2a87fc48eb$var$getValueMapAndJoin(fields, sortingField, 'value', [], (component)=>component?.name.toLowerCase());
            case 0, $lO4Or.SPRINT_TYPE:
                {
                    const sprintValue = (0, $3uSNh.safeGetValue)(fields, sortingField, 'value', $61a5cf2a87fc48eb$var$DEFAULT_LOWER_RANKING_VALUE);
                    if (Array.isArray(sprintValue) && sprintValue.length) {
                        const { name: name, state: state } = sprintValue[0];
                        if (state === 'CLOSED') {
                            const statusId = (0, $3uSNh.safeGetValue)(fields, 'status', 'value', '');
                            // closed sprints should not be shown if the status is not done
                            // means that this ticket is on the backlog
                            if (statusId?.toString() !== (0, $8Qd0L.StatusCategoryIds)[(0, $8Qd0L.StatusCategoryTypes).DONE].toString()) return $61a5cf2a87fc48eb$var$DEFAULT_LOWER_RANKING_VALUE;
                        }
                        return name.toLowerCase();
                    }
                    return $61a5cf2a87fc48eb$var$DEFAULT_LOWER_RANKING_VALUE;
                }
            default:
                return (0, $3uSNh.safeGetValue)(fields, (0, $jGcn0.RANK_ALIAS_FIELD_ID), 'value', '');
        }
    };
const $61a5cf2a87fc48eb$export$b3fdfcb601c683c3 = (sorting, fieldType, sortedLists)=>{
    const getters = [];
    const orders = [];
    let sortFieldType = fieldType;
    // fieldType for key is not returned from useIssueTypeFieldConfig
    if (sorting?.sortBy === 'key') sortFieldType = 'issuekey';
    if (sorting != null && sorting.sortBy != null) {
        orders.push(sorting.direction, sorting.direction);
        getters.push($61a5cf2a87fc48eb$var$createSortableGetter(sortFieldType, sorting.sortBy, sortedLists));
        getters.push($61a5cf2a87fc48eb$var$createSortableGetter((0, $jGcn0.RANK_ALIAS_FIELD_ID), (0, $jGcn0.RANK_ALIAS_FIELD_ID)));
    } else {
        orders.push((0, $jGcn0.DEFAULT_RANK_SORTING_DIRECTION));
        getters.push($61a5cf2a87fc48eb$var$createSortableGetter((0, $jGcn0.RANK_ALIAS_FIELD_ID), (0, $jGcn0.RANK_ALIAS_FIELD_ID)));
    }
    return {
        getters: getters,
        orders: orders
    };
};

});
parcelRegister("bDIST", function(module, exports) {

var $943C2 = parcelRequire("943C2");

var $1c8hB = parcelRequire("1c8hB");
/**
 * This method is like `_.sortBy` except that it allows specifying the sort
 * orders of the iteratees to sort by. If `orders` is unspecified, all values
 * are sorted in ascending order. Otherwise, specify an order of "desc" for
 * descending or "asc" for ascending sort order of corresponding values.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
 *  The iteratees to sort by.
 * @param {string[]} [orders] The sort orders of `iteratees`.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
 * @returns {Array} Returns the new sorted array.
 * @example
 *
 * var users = [
 *   { 'user': 'fred',   'age': 48 },
 *   { 'user': 'barney', 'age': 34 },
 *   { 'user': 'fred',   'age': 40 },
 *   { 'user': 'barney', 'age': 36 }
 * ];
 *
 * // Sort by `user` in ascending order and by `age` in descending order.
 * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
 */ function $8796275107b9d4d1$var$orderBy(collection, iteratees, orders, guard) {
    if (collection == null) return [];
    if (!$1c8hB(iteratees)) iteratees = iteratees == null ? [] : [
        iteratees
    ];
    orders = guard ? undefined : orders;
    if (!$1c8hB(orders)) orders = orders == null ? [] : [
        orders
    ];
    return $943C2(collection, iteratees, orders);
}
module.exports = $8796275107b9d4d1$var$orderBy;

});

parcelRegister("6imc4", function(module, exports) {

$parcel$export(module.exports, "getSorting", () => $5172533d88399045$export$654dceec98f3061f);
$parcel$export(module.exports, "isSortingSupported", () => $5172533d88399045$export$c6c6084d02f37d7e);
$parcel$export(module.exports, "isSortingSupportedFieldTypePredicated", () => $5172533d88399045$export$190ed2ad153b150b);
$parcel$export(module.exports, "getSortingDisabledFields", () => $5172533d88399045$export$56c924491e5617ad);

var $5iWql = parcelRequire("5iWql");

var $hPNnE = parcelRequire("hPNnE");

var $6Kxnm = parcelRequire("6Kxnm");

var $4dn6Q = parcelRequire("4dn6Q");

var $fgDTb = parcelRequire("fgDTb");

var $4kOft = parcelRequire("4kOft");

var $dnGVZ = parcelRequire("dnGVZ");

var $5GKSf = parcelRequire("5GKSf");

var $4ACib = parcelRequire("4ACib");

var $8DMfR = parcelRequire("8DMfR");

var $77PMd = parcelRequire("77PMd");

var $fGEjz = parcelRequire("fGEjz");
const $5172533d88399045$var$createSortingHandlers = (0, $5iWql.default)(()=>({
        ...(0, $4kOft.parentSortingHandler),
        ...(0, $fGEjz.versionSortingHandler),
        ...(0, $4ACib.resolutionSortingHandler),
        ...(0, $fgDTb.groupSortingHandler),
        ...(0, $5GKSf.radioSelectSortingHandler),
        ...(0, $hPNnE.cascadingSelectSortingHandler),
        ...(0, $dnGVZ.projectSortingHandler)
    }));
const $5172533d88399045$export$654dceec98f3061f = (fieldType, ...args)=>{
    const handlers = $5172533d88399045$var$createSortingHandlers();
    if (handlers[fieldType] == null) return;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return handlers[fieldType]?.(...args);
};
const $5172533d88399045$export$c6c6084d02f37d7e = (fieldType)=>{
    const handlers = $5172533d88399045$var$createSortingHandlers();
    return handlers[fieldType] != null;
};
const $5172533d88399045$export$190ed2ad153b150b = (fieldType)=>true;
const $5172533d88399045$export$56c924491e5617ad = (0, $5iWql.default)(()=>({
        ...(0, $6Kxnm.devSummaryDisabledSorting),
        ...(0, $77PMd.teamDisabledSorting),
        ...(0, $8DMfR.statusCategoryDisabledSorting),
        ...(0, $4dn6Q.goalsDisabledSorting)
    }));

});
parcelRegister("hPNnE", function(module, exports) {

$parcel$export(module.exports, "cascadingSelectSortingHandler", () => $9006c1312190fa14$export$7b0bfc6838ff3257);

var $lO4Or = parcelRequire("lO4Or");

var $yTRlI = parcelRequire("yTRlI");
const $9006c1312190fa14$var$getCascadingSelectSorting = (field)=>(0, $yTRlI.getCascadingSelectStringValue)(field.value);
const $9006c1312190fa14$export$7b0bfc6838ff3257 = {
    [(0, $lO4Or.CASCADING_SELECT_CF_TYPE)]: $9006c1312190fa14$var$getCascadingSelectSorting
};

});
parcelRegister("yTRlI", function(module, exports) {

$parcel$export(module.exports, "getCascadingSelectStringValue", () => $501644a5d0f27e91$export$f110a74eb752aa7e);
$parcel$export(module.exports, "cascadingSelectStringValueHandler", () => $501644a5d0f27e91$export$f39c163ada81742a);
$parcel$export(module.exports, "cascadingSelectRichValueHandler", () => $501644a5d0f27e91$export$af92c160980c340f);

var $lO4Or = parcelRequire("lO4Or");
const $501644a5d0f27e91$export$f110a74eb752aa7e = (fieldValue)=>{
    if (fieldValue && fieldValue.parentOptionValue) {
        if (fieldValue.childOptionValue) return `${fieldValue.parentOptionValue.value} - ${fieldValue.childOptionValue.value}`;
        return `${fieldValue.parentOptionValue.value}`;
    }
    return '';
};
const $501644a5d0f27e91$var$getCascadingSelectValue = (field)=>$501644a5d0f27e91$export$f110a74eb752aa7e(field.value);
const $501644a5d0f27e91$var$getCascadingSelectRichValue = (field)=>field.value ?? null;
const $501644a5d0f27e91$export$f39c163ada81742a = {
    [(0, $lO4Or.CASCADING_SELECT_CF_TYPE)]: $501644a5d0f27e91$var$getCascadingSelectValue
};
const $501644a5d0f27e91$export$af92c160980c340f = {
    [(0, $lO4Or.CASCADING_SELECT_CF_TYPE)]: $501644a5d0f27e91$var$getCascadingSelectRichValue
};

});


parcelRegister("6Kxnm", function(module, exports) {

$parcel$export(module.exports, "devSummaryDisabledSorting", () => $13cd49fb2f12cee8$export$8cf683615a3ccf77);

var $lO4Or = parcelRequire("lO4Or");
const $13cd49fb2f12cee8$export$8cf683615a3ccf77 = {
    [(0, $lO4Or.DEV_SUMMARY_CF_TYPE)]: false
};

});

parcelRegister("4dn6Q", function(module, exports) {

$parcel$export(module.exports, "goalsDisabledSorting", () => $e609dcddc34139db$export$60ff70c996f5c362);

var $lO4Or = parcelRequire("lO4Or");
const $e609dcddc34139db$export$60ff70c996f5c362 = {
    [(0, $lO4Or.GOALS_CF_TYPE)]: false
};

});

parcelRegister("fgDTb", function(module, exports) {

$parcel$export(module.exports, "groupSortingHandler", () => $2965094b1aff09d1$export$a577fd60fa30451d);

var $lO4Or = parcelRequire("lO4Or");
const $2965094b1aff09d1$var$getSingleGroupSorting = (field)=>field.value?.name ?? '';
const $2965094b1aff09d1$var$getMultipleGroupSorting = (field)=>field.value == null ? '' : field.value.map((v)=>v.name).join(',');
const $2965094b1aff09d1$export$a577fd60fa30451d = {
    [(0, $lO4Or.GROUP_CF_TYPE)]: $2965094b1aff09d1$var$getSingleGroupSorting,
    [(0, $lO4Or.MULTI_GROUP_CF_TYPE)]: $2965094b1aff09d1$var$getMultipleGroupSorting
};

});

parcelRegister("4kOft", function(module, exports) {

$parcel$export(module.exports, "parentSortingHandler", () => $b1645a5228930c15$export$20dbdacc158507c9);

var $lO4Or = parcelRequire("lO4Or");
const $b1645a5228930c15$var$getParentSorting = (field)=>field.value ? field.value.issueKey : '';
const $b1645a5228930c15$export$20dbdacc158507c9 = {
    [(0, $lO4Or.PARENT_TYPE)]: $b1645a5228930c15$var$getParentSorting
};

});

parcelRegister("dnGVZ", function(module, exports) {

$parcel$export(module.exports, "projectSortingHandler", () => $b535da34585ea13f$export$18c888fa7805bbf9);

var $lO4Or = parcelRequire("lO4Or");
const $b535da34585ea13f$var$getProjectSorting = (field)=>field.value?.name ?? '';
const $b535da34585ea13f$export$18c888fa7805bbf9 = {
    [(0, $lO4Or.PROJECT_PICKER_CF_TYPE)]: $b535da34585ea13f$var$getProjectSorting
};

});

parcelRegister("5GKSf", function(module, exports) {

$parcel$export(module.exports, "radioSelectSortingHandler", () => $090676a3e9c576f9$export$d622730346571a2b);

var $lO4Or = parcelRequire("lO4Or");
const $090676a3e9c576f9$var$getRadioSelectSorting = (field)=>field.value ? field.value.label : '';
const $090676a3e9c576f9$export$d622730346571a2b = {
    [(0, $lO4Or.RADIO_BUTTONS_CF_TYPE)]: $090676a3e9c576f9$var$getRadioSelectSorting
};

});

parcelRegister("4ACib", function(module, exports) {

$parcel$export(module.exports, "resolutionSortingHandler", () => $2a63ab07413670f0$export$596a643f093db9a7);

var $lO4Or = parcelRequire("lO4Or");
const $2a63ab07413670f0$var$getResolutionSorting = (field)=>field.value?.name ?? '';
const $2a63ab07413670f0$export$596a643f093db9a7 = {
    [(0, $lO4Or.RESOLUTION_TYPE)]: $2a63ab07413670f0$var$getResolutionSorting
};

});

parcelRegister("8DMfR", function(module, exports) {

$parcel$export(module.exports, "statusCategoryDisabledSorting", () => $14c4f6b294c727dd$export$117cb43589655b27);

var $lO4Or = parcelRequire("lO4Or");
const $14c4f6b294c727dd$export$117cb43589655b27 = {
    [(0, $lO4Or.STATUS_CATEGORY_TYPE)]: false
};

});

parcelRegister("77PMd", function(module, exports) {

$parcel$export(module.exports, "teamDisabledSorting", () => $4318536e894fadd9$export$1626c947db580b0f);

var $lO4Or = parcelRequire("lO4Or");
const $4318536e894fadd9$export$1626c947db580b0f = {
    [(0, $lO4Or.TEAMS_PLATFORM_CF_TYPE)]: false
};

});

parcelRegister("fGEjz", function(module, exports) {

$parcel$export(module.exports, "versionSortingHandler", () => $478431d0e41552b9$export$f2894a637a250eaa);

var $lO4Or = parcelRequire("lO4Or");
const $478431d0e41552b9$var$getSingleVersionSorting = (field)=>field.value?.name ?? '';
const $478431d0e41552b9$var$getMultipleVersionSorting = (field)=>field.value == null ? '' : field.value.map((v)=>v.name).join(',');
const $478431d0e41552b9$export$f2894a637a250eaa = {
    [(0, $lO4Or.VERSION_CF_TYPE)]: $478431d0e41552b9$var$getSingleVersionSorting,
    [(0, $lO4Or.MULTI_VERSION_CF_TYPE)]: $478431d0e41552b9$var$getMultipleVersionSorting,
    [(0, $lO4Or.FIX_VERSIONS_TYPE)]: $478431d0e41552b9$var$getMultipleVersionSorting,
    [(0, $lO4Or.AFFECTS_VERSIONS_TYPE)]: $478431d0e41552b9$var$getMultipleVersionSorting
};

});


parcelRegister("iJbbQ", function(module, exports) {

$parcel$export(module.exports, "isNewTransformedFieldPredicated", () => $1f6d8e2cada4a475$export$b018c2b58ea7e0de);

var $edHli = parcelRequire("edHli");
const $1f6d8e2cada4a475$export$b018c2b58ea7e0de = (field)=>field != null;

});
parcelRegister("edHli", function(module, exports) {

$parcel$export(module.exports, "isJiraBusinessFields", () => $58b3a50c72d1bd9f$export$257745f9c8865601);
const $58b3a50c72d1bd9f$export$257745f9c8865601 = (_)=>true;

});


parcelRegister("3uSNh", function(module, exports) {

$parcel$export(module.exports, "getFieldValue", () => $0a411223ee962893$export$2e85048acc9aea83);
$parcel$export(module.exports, "safeGetValue", () => $0a411223ee962893$export$f17a5eaf5fe57cff);
$parcel$export(module.exports, "safeGetTransformedFieldValue", () => $0a411223ee962893$export$16456470899ab77f);
$parcel$export(module.exports, "safeGetTransformedValue", () => $0a411223ee962893$export$c1cc7bc9b4953394);

var $illlw = parcelRequire("illlw");
const $0a411223ee962893$export$2e85048acc9aea83 = (fields, fieldKey)=>{
    if (fields && fieldKey != null) return fields.find((field)=>field?.fieldKey && field.fieldKey === fieldKey || field?.fieldId && field.fieldId === fieldKey || field?.aliasFieldId && field.aliasFieldId === fieldKey);
    return undefined;
};
const $0a411223ee962893$export$f17a5eaf5fe57cff = (fields, fieldKey, attributeName, defaultValue)=>{
    const field = $0a411223ee962893$export$2e85048acc9aea83(fields, fieldKey);
    return (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(field, attributeName, defaultValue);
};
const $0a411223ee962893$export$16456470899ab77f = (fields, fieldKey, attributeName, defaultValue)=>{
    const field = $0a411223ee962893$export$2e85048acc9aea83(fields, fieldKey);
    return $0a411223ee962893$export$c1cc7bc9b4953394(field, defaultValue);
};
const $0a411223ee962893$export$c1cc7bc9b4953394 = (field, defaultValue)=>(0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(field, 'value', defaultValue);

});

parcelRegister("90Dtq", function(module, exports) {

$parcel$export(module.exports, "resolveRank", () => $668a01cc7ea88012$export$992090b26f7c7f11);
const $668a01cc7ea88012$export$992090b26f7c7f11 = (parentIssue, rank)=>{
    // for the Sub-task issue types, sorting based on rank considers the parent rank first, then sorts based on item rank
    // concatenating (parentRank + rank) would do that for us!
    const parentRank = parentIssue?.rank ?? '';
    return parentRank.concat(rank);
};

});



parcelRegister("gZpkQ", function(module, exports) {

$parcel$export(module.exports, "useHideDoneItems", () => $0e65969a09396197$export$c2cb7b17819b92d4);
$parcel$export(module.exports, "useInferHideDoneItemsWithFilters", () => $0e65969a09396197$export$a14bc8305f71e469);

var $eUqFw = parcelRequire("eUqFw");

var $ji3xf = parcelRequire("ji3xf");
var $7c3W1 = parcelRequire("7c3W1");

var $8Qd0L = parcelRequire("8Qd0L");

var $9GlEj = parcelRequire("9GlEj");
const $0e65969a09396197$export$c2cb7b17819b92d4 = ()=>{
    const [hideDoneItems, persistHideDoneItems] = (0, $7c3W1.useViewPreference)((0, $ji3xf.HIDE_DONE_ITEMS_PREFERENCE));
    const setHideDoneItems = (0, $eUqFw.useCallback)((hide, action = 'push')=>persistHideDoneItems(hide ? 'true' : undefined, action), [
        persistHideDoneItems
    ]);
    return [
        hideDoneItems === 'true',
        setHideDoneItems
    ];
};
const $0e65969a09396197$export$a14bc8305f71e469 = ({ filters: filters })=>{
    const [hideDoneItems, setHideDoneItems] = $0e65969a09396197$export$c2cb7b17819b92d4();
    const { quickFilters: quickFilters } = (0, $9GlEj.useQuickFilters)();
    (0, $eUqFw.useEffect)(()=>{
        if (hideDoneItems) {
            const isFilteringByDoneStatus = // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            (filters && filters.status)?.find((status)=>Number(status.categoryId) === (0, $8Qd0L.StatusCategoryIds)[(0, $8Qd0L.StatusCategoryTypes).DONE]);
            if (isFilteringByDoneStatus || quickFilters?.DONE) setHideDoneItems(false, 'replace');
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        filters,
        quickFilters?.DONE
    ]);
};

});
parcelRegister("9GlEj", function(module, exports) {

$parcel$export(module.exports, "useQuickFilters", () => $20c7583d02c9250e$export$3dae1bb95b659fd4);

var $eUqFw = parcelRequire("eUqFw");

var $ji3xf = parcelRequire("ji3xf");
var $7c3W1 = parcelRequire("7c3W1");

var $lO4Or = parcelRequire("lO4Or");

var $kMmsu = parcelRequire("kMmsu");
const $20c7583d02c9250e$var$quickFilterToJQLMapOld = {
    ASSIGNED_TO_ME: 'assignee = currentUser()',
    DONE: "StatusCategory = 'Complete'",
    DUE_THIS_WEEK: 'duedate <= endOfWeek() and duedate > startOfWeek()'
};
const $20c7583d02c9250e$export$808f76242d61e1a5 = (sprintJQLTerm)=>{
    if (sprintJQLTerm == null) return $20c7583d02c9250e$var$quickFilterToJQLMapOld;
    return {
        ...$20c7583d02c9250e$var$quickFilterToJQLMapOld,
        ACTIVE_SPRINTS: `${sprintJQLTerm} in openSprints()`
    };
};
const $20c7583d02c9250e$var$buildJQLFromQuickFilters = (quickFilters, { quickFilterToJQLMap: quickFilterToJQLMap = $20c7583d02c9250e$var$quickFilterToJQLMapOld } = {})=>{
    const jqlClauses = Object.entries(quickFilters).map(// @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'any' can't be used to index type '{ readonly ASSIGNED_TO_ME: "assignee = currentUser()"; readonly DONE: "StatusCategory = 'Complete'"; readonly DUE_THIS_WEEK: "duedate <= endOfWeek() and duedate > startOfWeek()"; }'.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ([key, isEnabled])=>isEnabled === true && quickFilterToJQLMap[key]);
    const enabledFilters = jqlClauses.filter((jql)=>jql);
    return enabledFilters.join(' AND ') || null;
};
const $20c7583d02c9250e$export$9294471da4d3c33f = {
    ASSIGNED_TO_ME: false,
    DONE: false,
    DUE_THIS_WEEK: false,
    ACTIVE_SPRINTS: false
};
const $20c7583d02c9250e$export$9692fc1a2fd983f5 = (jql, { quickFilterToJQLMap: quickFilterToJQLMap = $20c7583d02c9250e$var$quickFilterToJQLMapOld } = {})=>{
    const quickFilters = {
        ...$20c7583d02c9250e$export$9294471da4d3c33f
    };
    if (!jql) return quickFilters;
    if (jql.includes(quickFilterToJQLMap.ASSIGNED_TO_ME)) quickFilters.ASSIGNED_TO_ME = true;
    if (jql.includes(quickFilterToJQLMap.DONE)) quickFilters.DONE = true;
    if (jql.includes(quickFilterToJQLMap.DUE_THIS_WEEK)) quickFilters.DUE_THIS_WEEK = true;
    if (quickFilterToJQLMap.ACTIVE_SPRINTS && jql.includes(quickFilterToJQLMap.ACTIVE_SPRINTS)) quickFilters.ACTIVE_SPRINTS = true;
    return quickFilters;
};
const $20c7583d02c9250e$var$useSprintFieldJQLTerm = ()=>{
    const { data: fields } = (0, $kMmsu.useFieldsResource)();
    return (0, $eUqFw.useMemo)(()=>{
        if (fields == null) return undefined;
        const sprintField = fields.find((field)=>field.type === (0, $lO4Or.SPRINT_TYPE));
        return sprintField != null ? sprintField.jqlTerm : undefined;
    }, [
        fields
    ]);
};
const $20c7583d02c9250e$export$3dae1bb95b659fd4 = ()=>{
    const sprintFieldJQLTerm = $20c7583d02c9250e$var$useSprintFieldJQLTerm();
    const quickFilterToJQLMap = (0, $eUqFw.useMemo)(()=>$20c7583d02c9250e$export$808f76242d61e1a5(sprintFieldJQLTerm), [
        sprintFieldJQLTerm
    ]);
    const [filters, setFilters] = (0, $7c3W1.useViewPreference)((0, $ji3xf.FILTER_PREFERENCE));
    const setQuickFilters = (0, $eUqFw.useCallback)((newQuickFilters)=>{
        if (newQuickFilters) {
            const jql = $20c7583d02c9250e$var$buildJQLFromQuickFilters(newQuickFilters, {
                quickFilterToJQLMap: quickFilterToJQLMap
            });
            if (jql == null) setFilters(undefined);
            else setFilters(jql);
        } else setFilters(undefined);
    }, [
        quickFilterToJQLMap,
        setFilters
    ]);
    const quickFilters = (0, $eUqFw.useMemo)(()=>$20c7583d02c9250e$export$9692fc1a2fd983f5(filters, {
            quickFilterToJQLMap: quickFilterToJQLMap
        }), [
        filters,
        quickFilterToJQLMap
    ]);
    return {
        quickFilters: quickFilters,
        persistQuickFilters: setQuickFilters,
        quickFiltersJql: $20c7583d02c9250e$var$buildJQLFromQuickFilters(quickFilters, {
            quickFilterToJQLMap: quickFilterToJQLMap
        })
    };
};

});


parcelRegister("lEWmB", function(module, exports) {

$parcel$export(module.exports, "useFilters", () => $2972841342234906$export$973ca22476b0e05f);

var $eUqFw = parcelRequire("eUqFw");

var $ji3xf = parcelRequire("ji3xf");
var $7c3W1 = parcelRequire("7c3W1");

var $1ybV0 = parcelRequire("1ybV0");

var $8aCHU = parcelRequire("8aCHU");
const $2972841342234906$export$973ca22476b0e05f = ()=>{
    const [jql, saveFilters] = (0, $7c3W1.useViewPreference)((0, $ji3xf.FILTER_PREFERENCE));
    const serialiseJql = (0, $1ybV0.ff)('migrate-business-filters-serialising-to-jql-ast_j6qj6') ? (0, $8aCHU.serialiseJql) : (0, $8aCHU.serialiseJqlOld);
    const setFilter = (0, $eUqFw.useCallback)((filters)=>{
        const serialisedJql = serialiseJql(filters);
        saveFilters(serialisedJql !== '' ? serialisedJql : undefined);
    }, [
        saveFilters,
        serialiseJql
    ]);
    return {
        setFilter: setFilter,
        jql: jql
    };
};

});
parcelRegister("8aCHU", function(module, exports) {

$parcel$export(module.exports, "serialiseJql", () => $0e700551905b00b3$export$e1718e1e441cb0f6);
$parcel$export(module.exports, "serialiseJqlOld", () => $0e700551905b00b3$export$5bd6a523f48a18cd);
$parcel$export(module.exports, "extractAnalyticsFilterDataFromJQL", () => $0e700551905b00b3$export$9ee6085825c9cbfa);

var $8blac = parcelRequire("8blac");

var $27QuD = parcelRequire("27QuD");

var $6wqPF = parcelRequire("6wqPF");

var $6x1NF = parcelRequire("6x1NF");

var $ehDeP = parcelRequire("ehDeP");
var $k85ht = parcelRequire("k85ht");
var $lmIUR = parcelRequire("lmIUR");

var $dG4cR = parcelRequire("dG4cR");
const $0e700551905b00b3$var$START_DATE_JQL = 'Start date[Date]';
const $0e700551905b00b3$var$EMPTY = 'EMPTY';
const $0e700551905b00b3$var$getQuotedFieldName = (fieldName)=>`"${fieldName}"`;
const $0e700551905b00b3$var$getFieldNameForJqlRaw = (fieldName)=>{
    // custom fields are indexed by their ids and only work with JQL when referenced as such `cf[id]`.
    if (fieldName.indexOf('customfield_') === 0) {
        const customFieldId = fieldName.split('customfield_')[1];
        return `cf[${customFieldId}]`;
    }
    // date range jql will be formatted to e.g. "Start date[Date]" >= "2021-12-01" AND due < "2021-12-31"
    // the "to" fieldName for the date range will be transformed to "due" in the "serialiseJql" function
    // where "const toFieldName = fieldId === 'dateRange' ? 'due' : fieldName;"
    if (fieldName === 'dateRange') return $0e700551905b00b3$var$START_DATE_JQL;
    return fieldName;
};
const $0e700551905b00b3$var$getFieldNameForJql = (fieldName)=>$0e700551905b00b3$var$getQuotedFieldName($0e700551905b00b3$var$getFieldNameForJqlRaw(fieldName));
const $0e700551905b00b3$var$getFieldIdFromJql = (rawFieldName, getShouldConvertCustomField)=>{
    const fieldName = (0, (/*@__PURE__*/$parcel$interopDefault($27QuD)))(rawFieldName, '"');
    const shouldConvertCustomField = getShouldConvertCustomField ? getShouldConvertCustomField(fieldName) : true;
    // `cf[id]` -> `customfield_${id}`.
    if (fieldName.indexOf('cf[') === 0 && shouldConvertCustomField) {
        const extraction = new RegExp(/cf\[(.+)\]/).exec(fieldName);
        if (!extraction) return fieldName;
        const fieldId = extraction[1];
        return `customfield_${fieldId}`;
    }
    const startDateJql = $0e700551905b00b3$var$START_DATE_JQL;
    // update this if we add a start date or due date filter
    if (fieldName === startDateJql || fieldName === 'due') return 'dateRange';
    return fieldName;
};
const $0e700551905b00b3$var$sanitizeWord = (word)=>word.replace(/(["\\])/g, '\\$1');
const $0e700551905b00b3$var$sanitizeWordOld = (word)=>word.replace(/'/g, "\\'");
const $0e700551905b00b3$export$e1718e1e441cb0f6 = (filters)=>{
    const jqlQuery = (0, $ehDeP.default).query();
    Object.entries(filters).filter(([, options])=>options != null && (Array.isArray(options) && options.length > 0 || !Array.isArray(options) && typeof options === 'object' && (options.value == null || !(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(options.value)))).forEach(([fieldId, options])=>{
        const fieldName = $0e700551905b00b3$var$getFieldNameForJqlRaw(fieldId);
        if (!Array.isArray(options) && typeof options === 'object' && !(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(options?.value)) {
            // one additional day will be added to jql 'to' date based on selected date, e.g. when due date is "2021-12-30"
            // date range jql will be formatted to e.g. "Start date[Date]" >= "2021-12-01" AND due < "2021-12-31"
            const toFieldName = fieldId === 'dateRange' ? 'due' : fieldName;
            if (options.value.to != null) {
                const toDate = (0, $6x1NF.default)((0, $6wqPF.default)(new Date(options.value.to), 1), 'UTC', 'yyyy-MM-dd');
                jqlQuery.appendClause((0, $ehDeP.default).terminalClause((0, $ehDeP.default).field(toFieldName), (0, $ehDeP.default).operator((0, $k85ht.OPERATOR_LT)), (0, $ehDeP.default).valueOperand(toDate)), (0, $e5bc650799ce4838$export$6d6d48d210d3ca97));
            }
            if (options.value.from != null) jqlQuery.appendClause((0, $ehDeP.default).terminalClause((0, $ehDeP.default).field(fieldName), (0, $ehDeP.default).operator((0, $k85ht.OPERATOR_GT_EQUALS)), (0, $ehDeP.default).valueOperand(options.value.from)), (0, $e5bc650799ce4838$export$6d6d48d210d3ca97));
            return;
        }
        if (Array.isArray(options)) {
            const operands = options.map((option)=>{
                if (option.isEmptyOption) return (0, $ehDeP.default).valueOperand((0, $807962b43ef03b56$export$1c46dca02aac24dd));
                if (option.value) // Currently, the AST does not sanatize all values correctly (no \ or JQL keywords), so we need to manually wrap in quotes
                // We can remove this once https://jplat.jira.atlassian.cloud/browse/EM-6563 is implemented
                return (0, $ehDeP.default).byText.valueOperand(`"${$0e700551905b00b3$var$sanitizeWord(option.value)}"`);
                return null;
            }).filter((operand)=>operand != null);
            if (operands.length === 1) jqlQuery.appendClause((0, $ehDeP.default).terminalClause((0, $ehDeP.default).field(fieldName), (0, $ehDeP.default).operator((0, $k85ht.OPERATOR_EQUALS)), operands[0]), (0, $e5bc650799ce4838$export$6d6d48d210d3ca97));
            else if (operands.length > 1) jqlQuery.appendClause((0, $ehDeP.default).terminalClause((0, $ehDeP.default).field(fieldName), (0, $ehDeP.default).operator((0, $k85ht.OPERATOR_IN)), (0, $ehDeP.default).listOperand(operands)), (0, $e5bc650799ce4838$export$6d6d48d210d3ca97));
        }
    });
    const jast = (0, $ehDeP.default).jast(jqlQuery);
    return (0, $lmIUR.print)(jast, {
        operatorCase: 'upper',
        printWidth: null
    });
};
const $0e700551905b00b3$export$5bd6a523f48a18cd = (filters)=>{
    const pairs = Object.entries(filters).filter(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    ([, options])=>options != null && (Array.isArray(options) && options.length > 0 || !Array.isArray(options) && typeof options === 'object' && (options.value == null || !(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(options.value)))) // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .map(([fieldId, options])=>{
        const fieldName = $0e700551905b00b3$var$getFieldNameForJql(fieldId);
        if (!Array.isArray(options) && typeof options === 'object' && !(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(options?.value)) {
            // one additional day will be added to jql 'to' date based on selected date, e.g. when due date is "2021-12-30"
            // date range jql will be formatted to e.g. "Start date[Date]" >= "2021-12-01" AND due < "2021-12-31"
            const toFieldName = fieldId === 'dateRange' ? $0e700551905b00b3$var$getQuotedFieldName('due') : fieldName;
            let toDate;
            if (options.value.to) toDate = (0, $6x1NF.default)((0, $6wqPF.default)(new Date(options.value.to), 1), 'UTC', 'yyyy-MM-dd');
            else toDate = options.value.to;
            if (options.value.from != null && options.value.to != null) return `${fieldName} >= ${options.value.from} AND ${toFieldName} < ${toDate}`;
            if (options.value.from != null) return `${fieldName} >= ${options.value.from}`;
            return `${toFieldName} < ${toDate}`;
        }
        if (Array.isArray(options)) {
            const values = options.map((option)=>// make sure we don't wrap EMPTY with quotation marks
                option.value === (0, $dG4cR.EMPTY_FILTER_VALUE) ? $0e700551905b00b3$var$EMPTY : `'${$0e700551905b00b3$var$sanitizeWordOld(option.value)}'`).join(',');
            if (options.length > 1) return `${fieldName} in (${values})`;
            if (options.length === 1) return `${fieldName} = ${values}`;
        }
        return null;
    });
    return pairs.join(' AND ');
};
const $0e700551905b00b3$var$extractField = (statement)=>{
    let fieldId;
    const dateOperatorRegex = />=|</;
    if (dateOperatorRegex.test(statement)) {
        const operator = statement.includes('>=') ? ' >= ' : ' < ';
        [fieldId] = statement.split(operator);
    }
    if (statement.includes(' = ')) [fieldId] = statement.split(/ = /);
    if (statement.includes(' in ')) [fieldId] = statement.split(' in ');
    if (fieldId) return $0e700551905b00b3$var$getFieldIdFromJql(fieldId);
};
const $0e700551905b00b3$export$9ee6085825c9cbfa = (jql)=>{
    if (!jql) return {};
    return jql.split(/ AND | OR /).map($0e700551905b00b3$var$extractField).reduce((acc, curr)=>{
        if (curr) acc[curr] = true;
        return acc;
    }, {});
};

});
parcelRegister("27QuD", function(module, exports) {

var $TLr3n = parcelRequire("TLr3n");

var $2cjNq = parcelRequire("2cjNq");

var $8SGvQ = parcelRequire("8SGvQ");

var $1qE1i = parcelRequire("1qE1i");

var $3Muqa = parcelRequire("3Muqa");

var $aSldm = parcelRequire("aSldm");

var $1uqnh = parcelRequire("1uqnh");
/**
 * Removes leading and trailing whitespace or specified characters from `string`.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to trim.
 * @param {string} [chars=whitespace] The characters to trim.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {string} Returns the trimmed string.
 * @example
 *
 * _.trim('  abc  ');
 * // => 'abc'
 *
 * _.trim('-_-abc-_-', '_-');
 * // => 'abc'
 *
 * _.map(['  foo  ', '  bar  '], _.trim);
 * // => ['foo', 'bar']
 */ function $18c4f43cd593e3cf$var$trim(string, chars, guard) {
    string = $1uqnh(string);
    if (string && (guard || chars === undefined)) return $2cjNq(string);
    if (!string || !(chars = $TLr3n(chars))) return string;
    var strSymbols = $aSldm(string), chrSymbols = $aSldm(chars), start = $3Muqa(strSymbols, chrSymbols), end = $1qE1i(strSymbols, chrSymbols) + 1;
    return $8SGvQ(strSymbols, start, end).join('');
}
module.exports = $18c4f43cd593e3cf$var$trim;

});
parcelRegister("1qE1i", function(module, exports) {

var $jkhuN = parcelRequire("jkhuN");
/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
 * that is not found in the character symbols.
 *
 * @private
 * @param {Array} strSymbols The string symbols to inspect.
 * @param {Array} chrSymbols The character symbols to find.
 * @returns {number} Returns the index of the last unmatched string symbol.
 */ function $10a7434ada2e55c3$var$charsEndIndex(strSymbols, chrSymbols) {
    var index = strSymbols.length;
    while(index-- && $jkhuN(chrSymbols, strSymbols[index], 0) > -1);
    return index;
}
module.exports = $10a7434ada2e55c3$var$charsEndIndex;

});

parcelRegister("3Muqa", function(module, exports) {

var $jkhuN = parcelRequire("jkhuN");
/**
 * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
 * that is not found in the character symbols.
 *
 * @private
 * @param {Array} strSymbols The string symbols to inspect.
 * @param {Array} chrSymbols The character symbols to find.
 * @returns {number} Returns the index of the first unmatched string symbol.
 */ function $2c0d73c17288fd42$var$charsStartIndex(strSymbols, chrSymbols) {
    var index = -1, length = strSymbols.length;
    while(++index < length && $jkhuN(chrSymbols, strSymbols[index], 0) > -1);
    return index;
}
module.exports = $2c0d73c17288fd42$var$charsStartIndex;

});


const $e5bc650799ce4838$export$6d6d48d210d3ca97 = 'and';
const $e5bc650799ce4838$export$7b8f0a728d79a753 = 'or';

const $807962b43ef03b56$export$38accfc5a5d1c113 = 'value';
const $807962b43ef03b56$export$f6049126fd97001f = 'keyword';
const $807962b43ef03b56$export$19c7c729db381f9d = 'function';
const $807962b43ef03b56$export$fabec4aebba3f4df = 'list';
const $807962b43ef03b56$export$1c46dca02aac24dd = 'empty';

parcelRegister("lmIUR", function(module, exports) {

$parcel$export(module.exports, "print", () => $a9625f5ea61b2ada$export$c2d084dc44961371);

var $8dloj = parcelRequire("8dloj");

var $8VPLp = parcelRequire("8VPLp");

var $gGtGU = parcelRequire("gGtGU");
const $a9625f5ea61b2ada$export$c2d084dc44961371 = (jast, options = {})=>{
    return (0, $gGtGU.printDocToString)((0, $8VPLp.printAstToDoc)(jast, (0, (/*@__PURE__*/$parcel$interopDefault($8dloj)))(options, [
        'operatorCase'
    ])), (0, (/*@__PURE__*/$parcel$interopDefault($8dloj)))(options, [
        'printWidth'
    ]));
};

});
parcelRegister("8VPLp", function(module, exports) {

$parcel$export(module.exports, "printAstToDoc", () => $d301c3605dc18477$export$f0ef38932978952);


var $6RWCB = parcelRequire("6RWCB");

var $6l51o = parcelRequire("6l51o");
const $d301c3605dc18477$var$formatOperator = (operator, operatorCase)=>{
    switch(operatorCase){
        case 'lower':
            return operator.toLowerCase();
        case 'upper':
            return operator.toUpperCase();
        case 'preserve':
            return operator;
    }
};
class $d301c3605dc18477$export$27a275559a5c8102 extends (0, $6RWCB.AbstractJastVisitor) {
    constructor({ operatorCase: operatorCase } = {}){
        super();
        this.operatorCase = operatorCase || 'preserve';
    }
    visitArgument(argument) {
        return argument.text;
    }
    /**
	 * Visit each of the provided nodes and form a new array with each `Doc` joined by the provided separator.
	 */ joinNodes(nodes, separator) {
        const docs = [];
        nodes.forEach((node)=>{
            if (separator !== undefined && docs.length > 0) docs.push(separator);
            docs.push(node.accept(this));
        });
        return docs;
    }
    visitCompoundClause(compoundClause) {
        const operatorDoc = compoundClause.operator.accept(this);
        const clauseDocs = [];
        compoundClause.clauses.forEach((clause)=>{
            if (clauseDocs.length > 0) clauseDocs.push((0, $6l51o.ifBreak)((0, $6l51o.newLine)(), ' '), operatorDoc, ' ');
            // Wrap nested compound clauses in parentheses
            if (clause.clauseType === (0, $35634e4e5a46f5ae$export$7a58b23488ea076b)) clauseDocs.push('(', clause.accept(this), ')');
            else clauseDocs.push(clause.accept(this));
        });
        return (0, $6l51o.group)(clauseDocs);
    }
    visitCompoundOperator(compoundOperator) {
        return $d301c3605dc18477$var$formatOperator(compoundOperator.value, this.operatorCase);
    }
    visitField(field) {
        const propertyDocs = field.properties ? this.joinNodes(field.properties) : [];
        return (0, $6l51o.group)([
            field.text,
            ...propertyDocs
        ]);
    }
    visitFunction(functionString) {
        return functionString.text;
    }
    visitFunctionOperand(functionOperand) {
        const argumentDocs = this.joinNodes(functionOperand.arguments, ', ');
        return (0, $6l51o.group)([
            functionOperand.function.accept(this),
            '(',
            ...argumentDocs,
            ')'
        ]);
    }
    visitKeywordOperand(keywordOperand) {
        return keywordOperand.value;
    }
    visitListOperand(listOperand) {
        const operandDocs = this.joinNodes(listOperand.values, ', ');
        return (0, $6l51o.group)([
            '(',
            ...operandDocs,
            ')'
        ]);
    }
    visitOperator(operator) {
        return $d301c3605dc18477$var$formatOperator(operator.text, this.operatorCase);
    }
    visitOrderBy(orderBy) {
        const fieldDocs = this.joinNodes(orderBy.fields, ', ');
        return (0, $6l51o.group)([
            orderBy.operator.accept(this),
            ' ',
            ...fieldDocs
        ]);
    }
    visitOrderByDirection(orderByDirection) {
        return orderByDirection.value;
    }
    visitOrderByField(orderByField) {
        const docs = [
            orderByField.field.accept(this)
        ];
        if (orderByField.direction) docs.push(' ', orderByField.direction.accept(this));
        return (0, $6l51o.group)(docs);
    }
    visitOrderByOperator(orderByOperator) {
        return $d301c3605dc18477$var$formatOperator(orderByOperator.value, this.operatorCase);
    }
    visitPredicate(predicate) {
        const docs = [
            predicate.operator.accept(this)
        ];
        if (predicate.operand) docs.push(' ', predicate.operand.accept(this));
        return (0, $6l51o.group)(docs);
    }
    visitPredicateOperator(predicateOperator) {
        return $d301c3605dc18477$var$formatOperator(predicateOperator.text, this.operatorCase);
    }
    visitProperty(property) {
        const docs = [];
        if (property.key) docs.push('[', property.key.accept(this), ']');
        if (property.path) {
            const pathDocs = this.joinNodes(property.path, ' ');
            docs.push(...pathDocs);
        }
        return (0, $6l51o.group)(docs);
    }
    visitQuery(query) {
        if (query.where && query.orderBy) return (0, $6l51o.group)([
            query.where.accept(this),
            (0, $6l51o.ifBreak)((0, $6l51o.newLine)(), ' '),
            query.orderBy.accept(this)
        ]);
        else if (query.where) return query.where.accept(this);
        else if (query.orderBy) return query.orderBy.accept(this);
        return '';
    }
    visitTerminalClause(terminalClause) {
        const docs = [
            terminalClause.field.accept(this)
        ];
        if (terminalClause.operator) docs.push(' ', terminalClause.operator.accept(this));
        if (terminalClause.operand) docs.push(' ', terminalClause.operand.accept(this));
        terminalClause.predicates.forEach((predicate)=>{
            docs.push(' ', predicate.accept(this));
        });
        return (0, $6l51o.group)(docs);
    }
    visitValueOperand(valueOperand) {
        return valueOperand.text;
    }
    visitNotClause(notClause) {
        const clauseDocs = [];
        // Wrap nested compound clauses in parentheses
        if (notClause.clause.clauseType === (0, $35634e4e5a46f5ae$export$7a58b23488ea076b)) clauseDocs.push('(', notClause.clause.accept(this), ')');
        else clauseDocs.push(notClause.clause.accept(this));
        return (0, $6l51o.group)([
            notClause.operator.accept(this),
            ' ',
            ...clauseDocs
        ]);
    }
    visitNotClauseOperator(notClauseOperator) {
        return notClauseOperator.value;
    }
    visitChildren() {
        throw new Error('Required visit method not implemented for node');
    }
    defaultResult() {
        return '';
    }
}
const $d301c3605dc18477$export$f0ef38932978952 = (jast, options)=>{
    const astToDocVisitor = new $d301c3605dc18477$export$27a275559a5c8102(options);
    return jast.query ? jast.query.accept(astToDocVisitor) : '';
};

});
const $35634e4e5a46f5ae$export$7a58b23488ea076b = 'compound';
const $35634e4e5a46f5ae$export$ae56b4ef248a2b6a = 'terminal';
const $35634e4e5a46f5ae$export$e356b89f8c8d2fcb = 'not';

parcelRegister("6RWCB", function(module, exports) {

$parcel$export(module.exports, "AbstractJastVisitor", () => $17ed1e3c7a9e2333$export$51be62b46ee668fd);
class $17ed1e3c7a9e2333$export$51be62b46ee668fd {
    /**
	 * The default implementation calls AstNode#accept on the specified node.
	 * @param node
	 */ visit(node) {
        return node.accept(this);
    }
    /**
	 * The default implementation initializes the aggregate result to defaultResult(). Before visiting each child, it
	 * calls shouldVisitNextChild; if the result is false no more children are visited and the current aggregate result is
	 * returned. After visiting a child, the aggregate result is updated by calling aggregateResult with the previous
	 * aggregate result and the result of visiting the child.
	 */ visitChildren(node) {
        let result = this.defaultResult();
        const children = node.getChildren();
        for(let i = 0; i < children.length; i++){
            if (!this.shouldVisitNextChild(node, result)) break;
            const childResult = children[i].accept(this);
            result = this.aggregateResult(result, childResult);
        }
        return result;
    }
    /**
	 * Aggregates the results of visiting multiple children of a node.
	 *
	 * The default implementation returns `nextResult`, meaning
	 * {@link #visitChildren} will return the result of the last child visited
	 * (or return the initial value if the node has no children).
	 *
	 * @param aggregate The previous aggregate value. In the default
	 * implementation, the aggregate value is initialized to
	 * {@link #defaultResult}, which is passed as the `aggregate` argument
	 * to this method after the first child node is visited.
	 * @param nextResult The result of the immediately preceeding call to visit
	 * a child node.
	 *
	 * @returns The updated aggregate result.
	 */ aggregateResult(aggregate, nextResult) {
        return nextResult;
    }
    /**
	 * This method is called before visiting each child in
	 * {@link #visitChildren}. When the method is first called\ `currentResult`
	 * will be the initial value (in the default implementation, the initial value
	 * is returned by a call to {@link #defaultResult}).
	 *
	 * The default implementation always returns `true`, indicating that
	 * `visitChildren` should only return after all children are visited.
	 * One reason to override this method is to provide a "short circuit"
	 * evaluation option for situations where the result of visiting a single
	 * child has the potential to determine the result of the visit operation as
	 * a whole.
	 *
	 * @param node The {@link AstNode} whose children are currently being
	 * visited.
	 * @param currentResult The current aggregate result of the children visited
	 * to the current point.
	 *
	 * @returns `true` to continue visiting children. Otherwise return
	 * `false` to stop visiting children and immediately return the
	 * current aggregate result from {@link #visitChildren}.
	 */ shouldVisitNextChild(node, currentResult) {
        return true;
    }
}

});

parcelRegister("6l51o", function(module, exports) {

$parcel$export(module.exports, "group", () => $505bf572d8c2f20e$export$e5e25fbcc1f7affe);
$parcel$export(module.exports, "ifBreak", () => $505bf572d8c2f20e$export$1db8e61901dcb0fa);
$parcel$export(module.exports, "newLine", () => $505bf572d8c2f20e$export$dc84f6841f96b7da);
const $505bf572d8c2f20e$export$e5e25fbcc1f7affe = (contents)=>{
    return {
        type: 'group',
        contents: contents
    };
};
const $505bf572d8c2f20e$export$1db8e61901dcb0fa = (breakContents, flatContents)=>{
    return {
        type: 'if-break',
        breakContents: breakContents,
        flatContents: flatContents
    };
};
const $505bf572d8c2f20e$export$dc84f6841f96b7da = ()=>{
    return {
        type: 'new-line'
    };
};

});


parcelRegister("gGtGU", function(module, exports) {

$parcel$export(module.exports, "printDocToString", () => $1adbb8b7e9dc2aa6$export$316fc7e94b95b118);
const $1adbb8b7e9dc2aa6$var$computeFlatWidth = (doc)=>{
    if (typeof doc === 'string') return doc.length;
    if (Array.isArray(doc)) return doc.reduce((result, innerDoc)=>result + $1adbb8b7e9dc2aa6$var$computeFlatWidth(innerDoc), 0);
    switch(doc.type){
        case 'group':
            return $1adbb8b7e9dc2aa6$var$computeFlatWidth(doc.contents);
        case 'if-break':
            return $1adbb8b7e9dc2aa6$var$computeFlatWidth(doc.flatContents);
        case 'new-line':
            // TODO This probably represents a bug as we don't expect new lines in the flat path
            return 0;
        default:
            throw new Error('Unrecognised doc type.');
    }
};
const $1adbb8b7e9dc2aa6$var$printDoc = (doc, context)=>{
    if (typeof doc === 'string') return {
        result: doc,
        endIndex: context.startIndex + doc.length
    };
    switch(doc.type){
        case 'group':
            return $1adbb8b7e9dc2aa6$var$printGroup(doc, context);
        case 'if-break':
            return $1adbb8b7e9dc2aa6$var$printIfBreak(doc, context);
        case 'new-line':
            return $1adbb8b7e9dc2aa6$var$printNewLine();
        default:
            throw new Error('Unrecognised doc type.');
    }
};
const $1adbb8b7e9dc2aa6$var$printGroup = (doc, context)=>{
    const docWidth = context.startIndex + $1adbb8b7e9dc2aa6$var$computeFlatWidth(doc);
    const breakContents = context.printWidth !== null && docWidth > context.printWidth;
    return doc.contents.reduce((agg, innerDoc)=>{
        const innerContext = {
            ...context,
            startIndex: agg.endIndex,
            breakContents: breakContents
        };
        const output = $1adbb8b7e9dc2aa6$var$printDoc(innerDoc, innerContext);
        return {
            result: agg.result + output.result,
            endIndex: output.endIndex
        };
    }, {
        result: '',
        endIndex: context.startIndex
    });
};
const $1adbb8b7e9dc2aa6$var$printIfBreak = (doc, context)=>{
    if (context.breakContents) return $1adbb8b7e9dc2aa6$var$printDoc(doc.breakContents, context);
    return $1adbb8b7e9dc2aa6$var$printDoc(doc.flatContents, context);
};
const $1adbb8b7e9dc2aa6$var$printNewLine = ()=>{
    return {
        result: '\n',
        // Reset our end index as a new line is being output.
        endIndex: 0
    };
};
// TODO Tweak this number with design
const $1adbb8b7e9dc2aa6$var$defaultPrintWidth = 100;
const $1adbb8b7e9dc2aa6$export$316fc7e94b95b118 = (doc, options = {})=>{
    const { printWidth: printWidth = $1adbb8b7e9dc2aa6$var$defaultPrintWidth } = options;
    const output = $1adbb8b7e9dc2aa6$var$printDoc(doc, {
        printWidth: printWidth,
        startIndex: 0,
        breakContents: false
    });
    return output.result;
};

});


parcelRegister("dG4cR", function(module, exports) {

$parcel$export(module.exports, "OPTIMISTIC_ID", () => $36a0671262b022c0$export$6e40821019289c70);
$parcel$export(module.exports, "CREATE_FILTER_EXPERIENCE", () => $36a0671262b022c0$export$d6ceedee35ae2c19);
$parcel$export(module.exports, "UPDATE_FILTER_EXPERIENCE", () => $36a0671262b022c0$export$ca3691ea47eec823);
$parcel$export(module.exports, "DELETE_FILTER_EXPERIENCE", () => $36a0671262b022c0$export$2a5fce320f18ac6c);
$parcel$export(module.exports, "STAR_FILTER_EXPERIENCE", () => $36a0671262b022c0$export$b0ec8deb6068dc3b);
$parcel$export(module.exports, "SAVED_FILTER_EXPERIENCE", () => $36a0671262b022c0$export$6c99c87a0ac0052a);
$parcel$export(module.exports, "EMPTY_FILTER_VALUE", () => $36a0671262b022c0$export$9ebaf9fe814731d3);
$parcel$export(module.exports, "SIMPLE_SEARCH_PARAM", () => $36a0671262b022c0$export$9b72011e2eb8d7d0);
const $36a0671262b022c0$export$b8b9d90f9e5bd72b = 'jiraBusinessFilters';
const $36a0671262b022c0$export$6e40821019289c70 = 'optimistic-filter-id';
const $36a0671262b022c0$export$d6ceedee35ae2c19 = {
    experience: 'filtersCreateSavedFilters',
    packageName: $36a0671262b022c0$export$b8b9d90f9e5bd72b,
    teamName: 'wanjel'
};
const $36a0671262b022c0$export$ca3691ea47eec823 = {
    experience: 'filtersUpdateSavedFilters',
    packageName: $36a0671262b022c0$export$b8b9d90f9e5bd72b,
    teamName: 'wanjel'
};
const $36a0671262b022c0$export$2a5fce320f18ac6c = {
    experience: 'filtersDeleteSavedFilters',
    packageName: $36a0671262b022c0$export$b8b9d90f9e5bd72b,
    teamName: 'wanjel'
};
const $36a0671262b022c0$export$b0ec8deb6068dc3b = {
    experience: 'filtersStarSavedFilters',
    packageName: $36a0671262b022c0$export$b8b9d90f9e5bd72b,
    teamName: 'wanjel'
};
const $36a0671262b022c0$export$6c99c87a0ac0052a = {
    experience: 'filtersLoadSavedFilters',
    packageName: $36a0671262b022c0$export$b8b9d90f9e5bd72b,
    teamName: 'wanjel'
};
const $36a0671262b022c0$export$9ebaf9fe814731d3 = null;
const $36a0671262b022c0$export$9b72011e2eb8d7d0 = 'text';

});



parcelRegister("96etS", function(module, exports) {

$parcel$export(module.exports, "useSimpleSearch", () => $70f3d6a365372dbd$export$b549f44e7ca96280);
$parcel$export(module.exports, "useSimpleSearchHighlight", () => $70f3d6a365372dbd$export$fd04dfca01137d2);
$parcel$export(module.exports, "useSearchText", () => $70f3d6a365372dbd$export$119186efd4186c93);
$parcel$export(module.exports, "useSimpleSearchJQL", () => $70f3d6a365372dbd$export$42b8d8a5ec5bc873);

var $eUqFw = parcelRequire("eUqFw");

var $6GXx9 = parcelRequire("6GXx9");

var $kJlBc = parcelRequire("kJlBc");

var $dG4cR = parcelRequire("dG4cR");
const $70f3d6a365372dbd$var$sanitize = (value)=>value.replace(/\\/g, '\\\\').replace(/'/g, "\\'").replace(/\t/g, ' ');
const $70f3d6a365372dbd$var$issueKeyRegex = new RegExp(`^${(0, $6GXx9.ISSUEKEY_REGEX)}$`);
const $70f3d6a365372dbd$var$japaneseAndChineseRegex = /[\p{Script_Extensions=Hiragana}\p{Script_Extensions=Katakana}\p{Script_Extensions=Han}]/u;
const $70f3d6a365372dbd$export$b549f44e7ca96280 = ()=>{
    const [simpleSearch, persistSimpleSearch] = (0, $kJlBc.useQueryParam)((0, $dG4cR.SIMPLE_SEARCH_PARAM));
    const setSimpleSearch = (0, $eUqFw.useCallback)((searchText)=>{
        searchText != null && searchText.trim() !== '' ? persistSimpleSearch(searchText) : persistSimpleSearch(undefined);
    }, [
        persistSimpleSearch
    ]);
    return [
        simpleSearch ?? '',
        setSimpleSearch
    ];
};
const $70f3d6a365372dbd$export$72839f749ccf76b2 = (text)=>{
    if (text == null) return [];
    return text.split(' ').filter((word)=>word !== '');
};
const $70f3d6a365372dbd$export$fd04dfca01137d2 = ()=>{
    const [simpleSearch] = $70f3d6a365372dbd$export$b549f44e7ca96280();
    return (0, $eUqFw.useMemo)(()=>$70f3d6a365372dbd$export$72839f749ccf76b2(simpleSearch), [
        simpleSearch
    ]);
};
const $70f3d6a365372dbd$export$abb78553baf1cfac = (text)=>{
    if (text == null || text.trim() === '') return '';
    let search = $70f3d6a365372dbd$var$sanitize(text);
    if ($70f3d6a365372dbd$var$issueKeyRegex.test(text)) return `(summary ~ '${search}*' OR description ~ '${search}*' OR key = '${search}')`;
    // if the text does not contain Chinese or Japanese characters (which are not tokenized),
    // and does not end with a space character
    // make it a wildcard search
    if (!$70f3d6a365372dbd$var$japaneseAndChineseRegex.test(text) && !text.endsWith(' ')) search = `${search}*`;
    return `(summary ~ '${search}' OR description ~ '${search}')`;
};
const $70f3d6a365372dbd$export$119186efd4186c93 = (text)=>{
    const jql = (0, $eUqFw.useMemo)(()=>$70f3d6a365372dbd$export$abb78553baf1cfac(text), [
        text
    ]);
    const highlight = (0, $eUqFw.useMemo)(()=>$70f3d6a365372dbd$export$72839f749ccf76b2(text), [
        text
    ]);
    return {
        jql: jql,
        highlight: highlight
    };
};
const $70f3d6a365372dbd$export$42b8d8a5ec5bc873 = ()=>{
    const [simpleSearch] = $70f3d6a365372dbd$export$b549f44e7ca96280();
    const jql = (0, $eUqFw.useMemo)(()=>$70f3d6a365372dbd$export$abb78553baf1cfac(simpleSearch), [
        simpleSearch
    ]);
    const addSimpleSearchToJQL = (0, $eUqFw.useCallback)((currentJQL)=>{
        if (jql === '') return currentJQL;
        if (currentJQL == null) return jql;
        return `${currentJQL} AND ${jql}`;
    }, [
        jql
    ]);
    return {
        jql: jql,
        isSearching: jql !== '',
        addSimpleSearchToJQL: addSimpleSearchToJQL
    };
};
var $70f3d6a365372dbd$export$2e2bcd8739ae039 = $70f3d6a365372dbd$export$b549f44e7ca96280;

});
parcelRegister("6GXx9", function(module, exports) {

$parcel$export(module.exports, "ISSUEKEY_REGEX", () => $2bd12f0fe8e9dce1$export$b52c9cee589449a8);
$parcel$export(module.exports, "default", () => $2bd12f0fe8e9dce1$export$2e2bcd8739ae039);

var $k4nIh = parcelRequire("k4nIh");
const $2bd12f0fe8e9dce1$export$b52c9cee589449a8 = '([A-Z][A-Z0-9_]+-\\d+)';
var /**
 * Returns the issue key if the URL is a valid full page Jira issue URL. It may also include a trailing
 * hash fragment. A matching URL must look like:
 * <host><baseurl>/browse/<issuekey><#hash?>
 * e.g. https://my-jira-instance.atlassian.net/browse/FOO-123#xyz
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$2bd12f0fe8e9dce1$export$2e2bcd8739ae039 = (url, host)=>{
    const parsedUrl = (0, (/*@__PURE__*/$parcel$interopDefault($k4nIh)))(url, {});
    const isMatchingProtocol = parsedUrl.protocol === 'http:' || parsedUrl.protocol === 'https:';
    const isMatchingHost = parsedUrl.host === host;
    const matches = parsedUrl.pathname.match(new RegExp(`^\\/browse\\/${$2bd12f0fe8e9dce1$export$b52c9cee589449a8}\\/?$`));
    const issueKey = matches && matches.length > 1 ? matches[1] : null;
    return isMatchingProtocol && isMatchingHost && issueKey || null;
};

});


parcelRegister("jQFcD", function(module, exports) {

$parcel$export(module.exports, "sanitiseJql", () => $fea50252d29e77ce$export$78c9a06ab18996fc);
$parcel$export(module.exports, "getJqlErrors", () => $fea50252d29e77ce$export$cc387523b0acb16d);

var $bXcc5 = parcelRequire("bXcc5");
var $lmIUR = parcelRequire("lmIUR");

var $1ybV0 = parcelRequire("1ybV0");
const $fea50252d29e77ce$export$78c9a06ab18996fc = (jql)=>{
    if (!jql) return jql;
    const builder = new (0, $bXcc5.JastBuilder)();
    const jast = builder.build(jql);
    if (jast.query && jast.query.orderBy) jast.query.orderBy = undefined;
    return (0, $lmIUR.print)(jast, (0, $1ybV0.ff)('migrate-business-filters-serialising-to-jql-ast_j6qj6') ? {
        operatorCase: 'upper',
        printWidth: null
    } : undefined);
};
const $fea50252d29e77ce$export$cc387523b0acb16d = (jql)=>{
    if (!jql) return [];
    const builder = new (0, $bXcc5.JastBuilder)();
    const jast = builder.build(jql);
    return jast.errors;
};

});



parcelRegister("5ujax", function(module, exports) {

$parcel$export(module.exports, "hasAllRequiredFields", () => $52d6130341d650ac$export$146976a1cbd99cd0);

var $jGcn0 = parcelRequire("jGcn0");

var $lO4Or = parcelRequire("lO4Or");
const $52d6130341d650ac$export$146976a1cbd99cd0 = ({ issueType: issueType, createInput: createInput })=>{
    if (!issueType) return false;
    return issueType.fields.every((field)=>{
        if (!field.fieldConfig?.isRequired) return true;
        if (!field.type && !field.aliasFieldId) return false;
        if (field.aliasFieldId && field.aliasFieldId === (0, $jGcn0.START_DATE_ALIAS_FIELD_ID)) return Boolean(createInput.startDate);
        if (field.aliasFieldId === (0, $jGcn0.STORY_POINTS_ALIAS_FIELD_ID)) return createInput.storyPoints != null;
        if (field.type) switch(field.type){
            case 0, $lO4Or.ISSUE_TYPE:
            case 0, $lO4Or.REPORTER_TYPE:
                return true;
            case 0, $lO4Or.SUMMARY_TYPE:
                return Boolean(createInput.summary);
            case 0, $lO4Or.PRIORITY_TYPE:
                return Boolean(createInput.priority);
            case 0, $lO4Or.ASSIGNEE_TYPE:
                return Boolean(createInput.assignee);
            case 0, $lO4Or.DUE_DATE_TYPE:
                return Boolean(createInput.dueDate);
            case 0, $lO4Or.CATEGORY_TYPE:
                return Boolean(createInput.category);
            case 0, $lO4Or.STORY_POINT_ESTIMATE_CF_TYPE:
                return createInput.storyPointEstimate != null;
            case 0, $lO4Or.SPRINT_TYPE:
                return Boolean(createInput.sprint);
            default:
                break;
        }
        return false;
    });
};

});

parcelRegister("auegK", function(module, exports) {

$parcel$export(module.exports, "CancelledError", () => $3e371496a660187a$export$a8430ed4188f35a9);
$parcel$export(module.exports, "useCreateIssueDialog", () => $3e371496a660187a$export$8254d39962ec7361);

var $eUqFw = parcelRequire("eUqFw");

var $gEmpR = parcelRequire("gEmpR");

var $ctR9z = parcelRequire("ctR9z");

var $dNWQB = parcelRequire("dNWQB");
var $2gOs4 = parcelRequire("2gOs4");


var $fD1Hq = parcelRequire("fD1Hq");

var $l1Cux = parcelRequire("l1Cux");
class $3e371496a660187a$export$a8430ed4188f35a9 extends Error {
}
const $3e371496a660187a$export$8d1d8a0d2a7917ac = ()=>{
    const { typesWithFields: typesWithFields } = (0, $gEmpR.useIssueTypesAndFields)({
        issueOperation: 'CREATE'
    });
    return (0, $eUqFw.useCallback)((issueType, predicate)=>{
        if (!issueType) return undefined;
        const issueTypeWithFields = typesWithFields.find((typeWithFields)=>typeWithFields.issueType.id === issueType.id);
        return issueTypeWithFields?.fields.find(predicate);
    }, [
        typesWithFields
    ]);
};
const $3e371496a660187a$export$8254d39962ec7361 = ()=>{
    const [, { openIssueCreateModal: openIssueCreateModal }] = (0, $ctR9z.useTriggerIssueCreateModal)();
    const { subscribe: subscribe } = (0, $2gOs4.useGICLifeCycleEvents)();
    const getField = $3e371496a660187a$export$8d1d8a0d2a7917ac();
    // rank field is handled separately as it's not returned by the available fields API
    const { data: rankField } = (0, $fD1Hq.useRankField)();
    return (0, $eUqFw.useCallback)((createInput, extraPayload)=>new Promise((resolve, reject)=>{
            const unsubscribe = subscribe((0, $dNWQB.GIC_LIFECYCLE_EVENTS).MODAL_KEEP_EDITING_EXISTING_ISSUE, ()=>{
                // the user cancelled editing
                onClose(null);
            });
            // resolve the promise once the GIC has been closed or reject it if cancelled
            const onClose = (data)=>{
                const result = data?.[0];
                if (result) resolve(result);
                else // adding a delay upon user cancelling because of a bug in the GIC's state management logic ICO-303
                setTimeout(()=>{
                    reject(new $3e371496a660187a$export$a8430ed4188f35a9('User cancelled'));
                }, 100);
                unsubscribe();
            };
            const { payload: payload, submitApiData: submitApiData } = (0, $l1Cux.buildGICPayload)({
                createInput: createInput,
                extraPayload: extraPayload,
                rankField: rankField,
                getField: getField
            });
            const isSubTaskCreationOpen = createInput.issueType?.hierarchyLevel === -1;
            openIssueCreateModal({
                id: 'jwm-create-issue-dialog',
                onClose: onClose,
                payload: payload,
                context: {
                    projectId: createInput.projectId,
                    submitApiData: submitApiData
                },
                isSubTaskCreationOpen: isSubTaskCreationOpen,
                triggerPointKey: (0, $33ffe55cb7bcdadc$export$145eb8935a34e85e),
                disableProjectDropdown: true,
                disableIssueTypeDropdown: Boolean(payload.issueType?.issueTypeId),
                disableCreationSuccessFlag: true,
                displayCreateAnotherIssueToggle: false,
                minimizableModalView: 'mini'
            });
        }), [
        getField,
        openIssueCreateModal,
        rankField,
        subscribe
    ]);
};

});
parcelRegister("ctR9z", function(module, exports) {

$parcel$export(module.exports, "useTriggerIssueCreateModal", () => $bd445758cecbab8c$export$71e0eb7b8a91a156);
$parcel$export(module.exports, "useOpenIssueCreateModal", () => $bd445758cecbab8c$export$47cf258b1046080b);
$parcel$export(module.exports, "withNewGICProvider", () => $bd445758cecbab8c$export$558a195c5bfe3787);

var $eUqFw = parcelRequire("eUqFw");

var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");
var $dYfll = parcelRequire("dYfll");

var $hompL = parcelRequire("hompL");

var $1ybV0 = parcelRequire("1ybV0");

var $dfh7z = parcelRequire("dfh7z");

var $dEMIg = parcelRequire("dEMIg");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $3HCkE = parcelRequire("3HCkE");

var $ellXt = parcelRequire("ellXt");


var $dgsxZ = parcelRequire("dgsxZ");
const $bd445758cecbab8c$export$d4c72bab9d6cc13a = {
    inProgressIssueID: undefined,
    isModalOpen: false,
    isSubsequentLoad: false,
    // isSubTaskCreationOpen is used for creating subtasks with new GIC
    isSubTaskCreationOpen: false,
    // isCreateLinkedIssue is used for creating linked issues with new GIC
    isCreateLinkedIssue: false,
    wasStateRestored: false,
    // payload can be used to control the initial values displayed in the GIC Modal
    payload: null,
    // id for the GIC Modal component
    id: 'create-issue-dialog',
    // title for the GIC modal
    title: null,
    // sectionMessage is used to show an info banner at the top of the GIC modal
    sectionMessage: null,
    // submitErrorMessage is used to show an error banner at the top of the GIC modal
    submitErrorMessage: undefined,
    // globalEventNamespaces is the list of event namespaces to which data of created issues will be published
    globalEventNamespaces: [
        (0, $dEMIg.GLOBAL_EVENT_NAMESPACE)
    ],
    // fieldsToAddInPublishedData: list of additioanl fields that should be appended in the data published for
    // created issues. By default we publish summary, status, assignee, duedate, project, issuetype & priority
    fieldsToAddInPublishedData: [],
    // Used on Create Incident from Alerts functionality. Only relevant for Opsgenie alert pages
    alertsToBeLinked: undefined,
    // if onIssueCreate is passed for every issue created in the session onIssueCreate is called with
    // the data of each issue created
    onIssueCreate: null,
    onClose: null,
    // only show required fields
    displayOnlyRequiredFields: false,
    // disables the success flag
    disableCreationSuccessFlag: false,
    // toggle the 'create another issue' checkbox
    displayCreateAnotherIssueToggle: true,
    // toggle display of site picker field.
    displaySitePicker: false,
    // do not allow user to change issue project
    disableProjectDropdown: false,
    // do not allow user to change issue type
    disableIssueTypeDropdown: false,
    // triggerPoinKey can be used to identify specific trigger point of new GIC
    triggerPointKey: (0, $33ffe55cb7bcdadc$export$8d987f6e80b74000),
    // context can be used to pass data like rank/board data which will be used as payload for issue creation
    context: undefined,
    // the view state for the minimizable modal
    minimizableModalView: 'modal',
    // the modal view maybe persistent depending on conditions, if this value is present, it may override the `minimizableModalView` during `openIssueCreateModal`.
    persistentModalView: undefined,
    // whether we should display mini modal by default for the first time. If this is true, it will override the view state to `mini` during `openIssueCreateModal`.
    shouldPushMiniModalDiscoverability: undefined,
    // whether we should display mini modal spotlight for the first time.
    shouldShowMiniModalSpotlight: undefined,
    // modal was attempted to be opened when already opened
    wasModalRetriggered: false,
    // if there is an existing gic open - we only apply the next state if they discard their current issue
    openIssueCreateModalNextState: {},
    // when an issue is discarded we will reinitialise the gic modal
    shouldInitFetchConfig: false,
    interactedWithModalChangerButtons: false,
    // open modal for the jql board trigger point
    isModalLoadInContext: false,
    // opt-out of the minimizable GIC modal
    disableMinimizableModal: false,
    // switch to control the hide and display of minimizable buttons
    displayMinimizableButtons: true,
    // switch to control the hide and display of header action container
    displayHeaderActionContainer: true,
    // do not override "use request type fields" toggle state
    overrideUseRequestTypeFieldsToggleState: undefined,
    /**
	 * this is for applying the container styles on the GIC containers except modal view
	 */ containerStyle: {},
    // this flag is for enable the minidesign for a trigger point without being in mini view
    isMiniDesignEnabled: false,
    // this flag is for the GIC multiple layout experiment by Makkuro
    isEnrolledAndTargetedForGicMultipleLayouts: false,
    // optional sessionId used for the current issue creation session
    sessionId: undefined,
    // optional component - when supplied, this wraps every field as children within the GIC modal
    FieldWrapperComponent: undefined,
    // Analytics property for board with custom filter and icc enabled
    isCustomBoardWithIcc: false,
    // optional ID of the jql swimlane we are creating issues in
    jqlSwimlaneId: undefined,
    // Analytics property for board with swimlane enabled
    swimlaneMode: undefined
};
const $bd445758cecbab8c$export$e324594224ef24da = {
    restoreState: (stateToRestore)=>({ setState: setState, getState: getState })=>{
            const { isSubsequentLoad: isSubsequentLoad, isModalOpen: isModalOpen } = getState();
            if (!isModalOpen && stateToRestore.isModalOpen) (0, $dgsxZ.startGlobalIssueCreateMetrics)(isSubsequentLoad);
            setState(stateToRestore);
        },
    openIssueCreateModal: (nextState)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            if (currentState.isModalOpen) /* If there is an existing gic open then we will defer the state change to prevent
                       clashing with the issue in creation. */ setState({
                wasModalRetriggered: true,
                openIssueCreateModalNextState: nextState
            });
            else {
                (0, $dgsxZ.startGlobalIssueCreateMetrics)(currentState.isSubsequentLoad);
                const isDiscoverabilityPushEnabled = !currentState.isEnrolledAndTargetedForGicMultipleLayouts;
                const isDiscoPushTriggerPoint = isDiscoverabilityPushEnabled && (0, $dgsxZ.isPartOfDiscoverabilityTriggers)(nextState?.triggerPointKey);
                const nextModalView = isDiscoverabilityPushEnabled ? (0, $dgsxZ.getNextModalView)(isDiscoPushTriggerPoint, currentState.persistentModalView, $bd445758cecbab8c$export$d4c72bab9d6cc13a.minimizableModalView) : 'modal';
                setState({
                    ...$bd445758cecbab8c$export$d4c72bab9d6cc13a,
                    ...isDiscoverabilityPushEnabled && {
                        minimizableModalView: nextModalView,
                        persistentModalView: currentState.persistentModalView,
                        ...(0, $dgsxZ.discoverabilityPushModalViewOverride)(currentState.shouldPushMiniModalDiscoverability, isDiscoPushTriggerPoint, nextModalView)
                    },
                    inProgressIssueID: (0, (/*@__PURE__*/$parcel$interopDefault($hompL))).v4(),
                    isSubsequentLoad: currentState.isSubsequentLoad,
                    isModalOpen: true,
                    wasModalRetriggered: currentState.isModalOpen,
                    ...nextState
                });
            }
        },
    closeIssueCreateModal: (hasIssueCreated)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            const isDiscoverabilityPushEnabled = !currentState.isEnrolledAndTargetedForGicMultipleLayouts;
            const isValidDiscoPushTriggerPoint = isDiscoverabilityPushEnabled && (0, $dgsxZ.isPartOfDiscoverabilityTriggers)(currentState.triggerPointKey);
            const shouldUpdatePersistentModalView = isDiscoverabilityPushEnabled && hasIssueCreated && isValidDiscoPushTriggerPoint;
            const shouldPersistDiscoverabilityState = isDiscoverabilityPushEnabled && currentState.shouldPushMiniModalDiscoverability && !isValidDiscoPushTriggerPoint;
            setState({
                ...$bd445758cecbab8c$export$d4c72bab9d6cc13a,
                ...(0, $1ybV0.ff)('jira-ai-work-breakdown-new-ui_z0inn') && {
                    callbackPayload: undefined
                },
                ...shouldPersistDiscoverabilityState && {
                    shouldPushMiniModalDiscoverability: true
                },
                ...isDiscoverabilityPushEnabled && {
                    persistentModalView: currentState.persistentModalView
                },
                ...shouldUpdatePersistentModalView && {
                    persistentModalView: currentState.minimizableModalView === 'mini' ? 'mini' : 'modal'
                },
                isModalOpen: false,
                isSubsequentLoad: true
            });
            (0, $dfh7z.CreateIssueUFOExperience).abort({
                metadata: {
                    wasStateRestored: getState().wasStateRestored
                }
            });
        },
    clearSectionMessage: ()=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            setState({
                ...currentState,
                sectionMessage: null
            });
        },
    setDisplayOnlyRequiredFields: (nextState)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            setState({
                ...currentState,
                displayOnlyRequiredFields: nextState
            });
        },
    setMinimizableModalView: (minimizableModalView)=>({ setState: setState })=>{
            setState({
                minimizableModalView: minimizableModalView,
                interactedWithModalChangerButtons: true
            });
        },
    resetWasModalRetriggered: (applyNextState = false)=>({ setState: setState, getState: getState })=>{
            if (applyNextState) {
                const currentState = getState();
                (0, $dgsxZ.startGlobalIssueCreateMetrics)(currentState.isSubsequentLoad);
                setState({
                    ...$bd445758cecbab8c$export$d4c72bab9d6cc13a,
                    ...!currentState.isEnrolledAndTargetedForGicMultipleLayouts && {
                        persistentModalView: currentState.persistentModalView
                    },
                    inProgressIssueID: currentState.inProgressIssueID,
                    isSubsequentLoad: currentState.isSubsequentLoad,
                    isModalOpen: true,
                    wasModalRetriggered: false,
                    minimizableModalView: 'modal',
                    openIssueCreateModalNextState: {},
                    shouldInitFetchConfig: true,
                    ...currentState.openIssueCreateModalNextState
                });
            } else setState({
                minimizableModalView: 'modal',
                wasModalRetriggered: false,
                openIssueCreateModalNextState: {}
            });
        },
    resetShouldInitFetchConfig: ()=>({ setState: setState })=>{
            setState({
                shouldInitFetchConfig: false
            });
        },
    setCallbackPayload: (callbackPayload)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            setState({
                callbackPayload: {
                    id: currentState.callbackPayload?.id ?? '',
                    data: callbackPayload
                }
            });
        },
    setShouldPushMiniModalDiscoverability: (shouldPushMiniModalDiscoverability)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            if (currentState.isEnrolledAndTargetedForGicMultipleLayouts) return;
            setState({
                shouldPushMiniModalDiscoverability: shouldPushMiniModalDiscoverability
            });
        },
    dismissModalSpotlight: ()=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            if (currentState.isEnrolledAndTargetedForGicMultipleLayouts) return;
            setState({
                shouldShowMiniModalSpotlight: false
            });
        },
    setPersistentModalView: (persistentModalView)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            if (currentState.isEnrolledAndTargetedForGicMultipleLayouts) return;
            setState({
                persistentModalView: persistentModalView
            });
        },
    removeAlertFromAlertsToBeLinked: (alertId)=>({ setState: setState, getState: getState })=>{
            if (!(0, $1ybV0.ff)('linked-alerts-in-gic_onvr6')) return;
            const currentState = getState();
            const alertsToBeLinked = currentState.alertsToBeLinked?.filter((entry)=>entry !== alertId);
            setState({
                alertsToBeLinked: alertsToBeLinked
            });
        },
    setSessionId: (sessionId)=>({ setState: setState })=>{
            setState({
                sessionId: sessionId
            });
        }
};
const $bd445758cecbab8c$var$store = (0, $a61MH.createStore)({
    name: 'issue-create.issue-create-form.use-trigger-issue-create-modal',
    initialState: $bd445758cecbab8c$export$d4c72bab9d6cc13a,
    actions: $bd445758cecbab8c$export$e324594224ef24da
});
const $bd445758cecbab8c$var$useTriggerIssueCreateModalState = (0, $ggKAj.createStateHook)($bd445758cecbab8c$var$store);
const $bd445758cecbab8c$var$useTriggerIssueCreateModalActions = (0, $ggKAj.createActionsHook)($bd445758cecbab8c$var$store);
const $bd445758cecbab8c$export$71e0eb7b8a91a156 = ()=>{
    const createState = $bd445758cecbab8c$var$useTriggerIssueCreateModalState();
    const createActions = $bd445758cecbab8c$var$useTriggerIssueCreateModalActions();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { openIssueCreateModal: openIssueCreateModal, ...otherActions } = createActions;
    const openIssueCreateModalWithAnalytics = (0, $eUqFw.useCallback)((nextState)=>{
        const analyticsEvent = createAnalyticsEvent({});
        const attributes = {
            gicViewState: nextState?.minimizableModalView,
            isSubtask: nextState?.isSubTaskCreationOpen,
            triggerPointKey: nextState?.triggerPointKey
        };
        (0, $jMP2a.fireTrackAnalyticsDeferred)(analyticsEvent, 'issueCreateModal triggered', attributes);
        openIssueCreateModal(nextState);
    }, [
        createAnalyticsEvent,
        openIssueCreateModal
    ]);
    return [
        createState,
        {
            ...otherActions,
            openIssueCreateModal: openIssueCreateModalWithAnalytics
        }
    ];
};
const $bd445758cecbab8c$export$47cf258b1046080b = ()=>{
    const { openIssueCreateModal: openIssueCreateModal } = $bd445758cecbab8c$var$useTriggerIssueCreateModalActions();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    return (0, $eUqFw.useCallback)((nextState)=>{
        const analyticsEvent = createAnalyticsEvent({});
        const attributes = {
            gicViewState: nextState?.minimizableModalView,
            isSubtask: nextState?.isSubTaskCreationOpen,
            triggerPointKey: nextState?.triggerPointKey
        };
        (0, $jMP2a.fireTrackAnalyticsDeferred)(analyticsEvent, 'issueCreateModal triggered', attributes);
        openIssueCreateModal(nextState);
    }, [
        createAnalyticsEvent,
        openIssueCreateModal
    ]);
};
const $bd445758cecbab8c$export$4c674fe824b8f278 = (0, $dYfll.createSubscriber)($bd445758cecbab8c$var$store);
function $bd445758cecbab8c$export$558a195c5bfe3787(WrappedComponent) {
    return (props)=>{
        const [, { openIssueCreateModal: openIssueCreateModal, closeIssueCreateModal: closeIssueCreateModal }] = $bd445758cecbab8c$export$71e0eb7b8a91a156();
        const { data: data } = (0, $3HCkE.useResource)((0, $ellXt.gicOptInStatusResources));
        const currentIssueCreateVisibility = data && data?.gicOptInStatus;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, {
            openIssueCreateModal: openIssueCreateModal,
            closeIssueCreateModal: closeIssueCreateModal,
            currentIssueCreateVisibility: currentIssueCreateVisibility?.isEnabled || false,
            ...props
        });
    };
}

});
parcelRegister("dfh7z", function(module, exports) {

$parcel$export(module.exports, "CreateIssueUFOExperience", () => $5fd686e53a19cbe0$export$cd75c112ac11a83b);
$parcel$export(module.exports, "StatusFieldLoad", () => $5fd686e53a19cbe0$export$e890e797a25e655c);
$parcel$export(module.exports, "GlobalIssueCreateModalSubmitUFOExperience", () => $5fd686e53a19cbe0$export$70208657c8d471a7);

var $12kyE = parcelRequire("12kyE");
var $kDfSL = parcelRequire("kDfSL");
const $5fd686e53a19cbe0$export$cd75c112ac11a83b = new (0, $kDfSL.UFOExperience)('global-issue-create.create-issue', {
    type: (0, $12kyE.ExperienceTypes).Experience,
    performanceType: (0, $12kyE.ExperiencePerformanceTypes).Custom,
    category: 'global-issue-create.create-issue'
});
const $5fd686e53a19cbe0$export$e890e797a25e655c = new (0, $kDfSL.UFOExperience)('global-issue-create.create-issue.status-field', {
    type: (0, $12kyE.ExperienceTypes).Load,
    performanceType: (0, $12kyE.ExperiencePerformanceTypes).PageSegmentLoad
});
const $5fd686e53a19cbe0$export$70208657c8d471a7 = new (0, $kDfSL.UFOExperience)('modern-global-issue-create.modal.issue-submit', {
    type: (0, $12kyE.ExperienceTypes).Experience,
    performanceType: (0, $12kyE.ExperiencePerformanceTypes).Custom,
    category: 'modern-global-issue-create.modal.issue-submit'
});

});

parcelRegister("dEMIg", function(module, exports) {

$parcel$export(module.exports, "REQUIRED", () => $dd9f36fe091541c8$export$b1c05b34d317c074);
$parcel$export(module.exports, "FORM_DROPZONE_CONTAINER_ID", () => $dd9f36fe091541c8$export$1a020bd73f33e5a);
$parcel$export(module.exports, "MINIMISED_DROPZONE_CONTAINER_ID", () => $dd9f36fe091541c8$export$9eadc594a5383580);
$parcel$export(module.exports, "LOG_WORK_TIME_SPENT_ERROR_KEY", () => $dd9f36fe091541c8$export$a1a7caa1e4a73c9f);
$parcel$export(module.exports, "LOG_WORK_TIME_REMAINING_ERROR_KEY", () => $dd9f36fe091541c8$export$cf70f9220e6a2f50);
$parcel$export(module.exports, "LOG_WORK_DATE_ERROR_KEY", () => $dd9f36fe091541c8$export$aac4661200ba4104);
$parcel$export(module.exports, "LOG_WORK_DESCRIPTION_ERROR_KEY", () => $dd9f36fe091541c8$export$a23c32d5cf54cba0);
$parcel$export(module.exports, "COMMON_LOG_WORK_ERROR_KEYS", () => $dd9f36fe091541c8$export$74ab3898ae683660);
$parcel$export(module.exports, "MULTI_INPUT_FIELDS_ERROR_KEYS", () => $dd9f36fe091541c8$export$983715bb9b0f9b2c);
$parcel$export(module.exports, "DEFAULT_SCROLL_OPTIONS", () => $dd9f36fe091541c8$export$40f6793dd75f4e52);
$parcel$export(module.exports, "UNSUPPORTED_FIELD_TYPES_IN_GIC", () => $dd9f36fe091541c8$export$3bf5bce483cc2c30);
$parcel$export(module.exports, "ISSUE_CREATE_TYPE", () => $dd9f36fe091541c8$export$30cc1fd33e7c7258);
$parcel$export(module.exports, "GLOBAL_EVENT_NAMESPACE", () => $dd9f36fe091541c8$export$8170252f0ea43511);

const $dd9f36fe091541c8$export$17bcab948893a9ba = 'worklog';
const $dd9f36fe091541c8$export$b1c05b34d317c074 = 'REQUIRED';
const $dd9f36fe091541c8$export$f10b32dfda12e96e = 'unknown';
const $dd9f36fe091541c8$export$e5e4b8c32e68dd0b = 'networkError';
const $dd9f36fe091541c8$export$2d06efb8146cd043 = 'graphQLError';
const $dd9f36fe091541c8$export$1a020bd73f33e5a = 'issue-create-modal-dropzone-container';
const $dd9f36fe091541c8$export$9eadc594a5383580 = 'minimised-issue-create-dropzone-container';
const $dd9f36fe091541c8$export$a1a7caa1e4a73c9f = 'worklog_timeLogged';
const $dd9f36fe091541c8$export$cf70f9220e6a2f50 = 'worklog_newEstimate';
const $dd9f36fe091541c8$export$aac4661200ba4104 = 'worklog_startDate';
const $dd9f36fe091541c8$export$a23c32d5cf54cba0 = 'worklog_description';
const $dd9f36fe091541c8$export$74ab3898ae683660 = [
    'worklog_adjustmentAmount',
    'worklog_adjustEstimate',
    'worklog_activate'
];
const $dd9f36fe091541c8$export$63fd567c1d0aca19 = [
    ...$dd9f36fe091541c8$export$74ab3898ae683660,
    $dd9f36fe091541c8$export$a1a7caa1e4a73c9f,
    $dd9f36fe091541c8$export$cf70f9220e6a2f50,
    $dd9f36fe091541c8$export$aac4661200ba4104,
    $dd9f36fe091541c8$export$a23c32d5cf54cba0
];
const $dd9f36fe091541c8$export$983715bb9b0f9b2c = {
    [$dd9f36fe091541c8$export$17bcab948893a9ba]: $dd9f36fe091541c8$export$63fd567c1d0aca19
};
const $dd9f36fe091541c8$export$40f6793dd75f4e52 = {
    behavior: 'auto',
    scrollMode: 'if-needed',
    block: 'start'
};
const $dd9f36fe091541c8$export$3bf5bce483cc2c30 = [
    'com.atlassian.servicedesk:sd-request-participants'
];
const $dd9f36fe091541c8$export$30cc1fd33e7c7258 = {
    linkedIssue: 'LINKED_ISSUE_CREATE',
    standard: 'STANDARD'
};
const $dd9f36fe091541c8$export$8170252f0ea43511 = 'QuickCreateIssue';

});
// error types
const $8b8bfa076f313cc4$export$6c8cb487d6ffc522 = 'QueryError';
const $8b8bfa076f313cc4$export$b171488d52070cb3 = 'JiraIssueFieldUnsupportedErrorExtension';
const $8b8bfa076f313cc4$export$14b50ab9fbf2d370 = 'JiraIssueFieldValueValidationErrorExtension';
const $8b8bfa076f313cc4$export$3d1cda9bd50505e8 = 'SERVICE_REQUEST';
const $8b8bfa076f313cc4$export$48c144830383423 = 'INCIDENT_MANAGEMENT';
const $8b8bfa076f313cc4$export$1ea6ead7bcee4494 = 'PROBLEM_MANAGEMENT';
const $8b8bfa076f313cc4$export$b92ccb6dc3cdb548 = 'CHANGE_MANAGEMENT';
const $8b8bfa076f313cc4$export$a4a741b969f6509c = 'POST_INCIDENT_REVIEW';
const $8b8bfa076f313cc4$export$81e62964cc725098 = 'DEVELOPER_ESCALATION';
const $8b8bfa076f313cc4$export$92ab80c1dc9baf44 = 'REQUEST_TYPE';
const $8b8bfa076f313cc4$export$ebb48b08205007c5 = 'ISSUE_TYPE';
const $8b8bfa076f313cc4$export$c835df30ebbd529d = 'UNASSIGNED_REQUEST_TYPE';


const $33ffe55cb7bcdadc$export$a05673a22505d5ee = 'forge-open-issue-create';
const $33ffe55cb7bcdadc$export$c78d329777576aa0 = 'global-create-button';
const $33ffe55cb7bcdadc$export$affdc3af7a9a4677 = 'keyboard-shortcut';
const $33ffe55cb7bcdadc$export$7e9cfd1f59e60910 = 'jsw-issue-view-create-issue-in-epic';
const $33ffe55cb7bcdadc$export$708499dcd016e5e9 = 'jsw-issue-view-create-subtask';
const $33ffe55cb7bcdadc$export$e1c8789144c4c810 = 'jsw-issue-view-ai-breakdown-child-issue';
const $33ffe55cb7bcdadc$export$c5afabb7a17e802 = 'jsw-issue-view-ai-breakdown-subtask';
const $33ffe55cb7bcdadc$export$2086a63173b79b56 = 'jsw-releases-create-issue';
const $33ffe55cb7bcdadc$export$fe1e5e4597147709 = 'jsw-roadmap-create-issue';
const $33ffe55cb7bcdadc$export$9bc326812a93707 = 'jsw-security-create-issue';
const $33ffe55cb7bcdadc$export$f352934e06f44599 = 'jsm-calendar-create-change-request';
const $33ffe55cb7bcdadc$export$6ae07c77acc64360 = 'jsm-create-incident-from-alert-detail';
const $33ffe55cb7bcdadc$export$b41d0684e4b6ab1 = 'jsm-create-incident-from-alert-list';
const $33ffe55cb7bcdadc$export$be9b2b1329ff7ec9 = 'jsm-empty-queue-create-request';
const $33ffe55cb7bcdadc$export$235b856f54db8916 = 'jwm-board-create-issue';
const $33ffe55cb7bcdadc$export$ebbb81a0a3406bcb = 'jwm-calendar-create-issue';
const $33ffe55cb7bcdadc$export$8e135b62470e5f9a = 'jwm-list-create-issue';
const $33ffe55cb7bcdadc$export$21ea58e7361c33ba = 'jwm-list-create-subtask';
const $33ffe55cb7bcdadc$export$d2cf44b8c67cca33 = 'jwm-timeline-create-issue';
const $33ffe55cb7bcdadc$export$894285d6d13375fd = 'jwm-timeline-create-subtask';
const $33ffe55cb7bcdadc$export$aa348159181703a0 = 'software-create-issue-dialog';
const $33ffe55cb7bcdadc$export$f90eec3841adf619 = 'create-linked-issue-issue-view';
const $33ffe55cb7bcdadc$export$718822a309bffada = 'create-linked-issue-command-palette';
const $33ffe55cb7bcdadc$export$2753dafac81e805c = 'service-desk-linked-issue-trigger';
const $33ffe55cb7bcdadc$export$7c4d5cc5711d9294 = 'jsw-incidents-create-jsm-pir-trigger';
const $33ffe55cb7bcdadc$export$6eb7318fea2f8ce0 = 'jsw-incidents-create-issue-trigger';
const $33ffe55cb7bcdadc$export$998dfc72404b9e14 = 'jpo-dialogs-jira-create-issue';
const $33ffe55cb7bcdadc$export$fc180a4b5785d2f4 = 'jsw-adapted-global-issue-create-trigger';
const $33ffe55cb7bcdadc$export$946ec0b21cb84fd0 = 'jsw-create-epic-issue';
const $33ffe55cb7bcdadc$export$dba86c91ec4fdbf0 = 'create-issue-backlog-trigger';
const $33ffe55cb7bcdadc$export$b5cdfd7f3bb79a7 = 'create-epic-issue-backlog-trigger';
const $33ffe55cb7bcdadc$export$a8199da3cfab0e8 = 'create-issue-in-epic-backlog-trigger';
const $33ffe55cb7bcdadc$export$5b97e2844e620e54 = 'create-issue-active-sprint-empty-view-trigger';
const $33ffe55cb7bcdadc$export$569f5ff8afa08896 = 'create-linked-issue-issue-navigator-trigger';
const $33ffe55cb7bcdadc$export$bafd52474e9ff4e = 'jwm-summary-create-first-issue-trigger';
const $33ffe55cb7bcdadc$export$87f86192eaf0fdf = 'create-subtask-issue-navigator-trigger';
const $33ffe55cb7bcdadc$export$b99842c2cf46f6be = 'create-subtask-new-issue-navigator-trigger';
const $33ffe55cb7bcdadc$export$1e467d0a3f53a410 = 'jwm-board-embed-issue-create';
const $33ffe55cb7bcdadc$export$8d987f6e80b74000 = 'trigger-point-key-not-defined';
const $33ffe55cb7bcdadc$export$867e9a641a3c1457 = 'jwm-list-embed-issue-create';
const $33ffe55cb7bcdadc$export$8de9fa43731c4b5b = 'issue-parent-switcher-field-create-issue';
const $33ffe55cb7bcdadc$export$87249ccbfd10fb78 = 'polaris-create-delivery-issue';
const $33ffe55cb7bcdadc$export$c0eeeb31d264de76 = 'home-page-default-open-gic';
const $33ffe55cb7bcdadc$export$f546e18e46478c84 = 'issue-create-embed-trigger';
const $33ffe55cb7bcdadc$export$1784e634ba79f1f9 = 'developer-escalations-issue-create-trigger';
const $33ffe55cb7bcdadc$export$145eb8935a34e85e = 'jwm-inline-create';
const $33ffe55cb7bcdadc$export$32648b574a536c8b = 'polaris-global-submit-idea-switch-project-trigger';
const $33ffe55cb7bcdadc$export$818f24c6c32e18a = 'jira-calendar-create-issue';

parcelRegister("dgsxZ", function(module, exports) {

$parcel$export(module.exports, "startGlobalIssueCreateMetrics", () => $b8d8e5356c7976a6$export$550b19803bc962ec);
$parcel$export(module.exports, "isPartOfDiscoverabilityTriggers", () => $b8d8e5356c7976a6$export$f6bc17a4d9120156);
$parcel$export(module.exports, "discoverabilityPushModalViewOverride", () => $b8d8e5356c7976a6$export$8d246e5e04f0b424);
$parcel$export(module.exports, "getNextModalView", () => $b8d8e5356c7976a6$export$720579602bb055a2);

var $dfh7z = parcelRequire("dfh7z");
var $fqKjL = parcelRequire("fqKjL");

var $hBkQt = parcelRequire("hBkQt");

var $duQ8C = parcelRequire("duQ8C");
const $b8d8e5356c7976a6$export$550b19803bc962ec = (isSubsequentLoad)=>{
    (0, $dfh7z.CreateIssueUFOExperience).start();
    const globalIssueCreateModalLoadMetric = isSubsequentLoad ? (0, $fqKjL.globalIssueCreateModalLoadSubsequent) : (0, $fqKjL.globalIssueCreateModalLoad);
    if (isSubsequentLoad) (0, $duQ8C.default)('global-issue.create-modal-subsequent');
    else (0, $duQ8C.default)('global-issue.create-modal');
    globalIssueCreateModalLoadMetric.start();
    (0, $hBkQt.startGlobalIssueCreateTTIWithAdjustments)();
};
const $b8d8e5356c7976a6$export$f6bc17a4d9120156 = (triggerPoint)=>{
    if (!triggerPoint) return false;
    const acceptedTriggerPoints = [
        'global-create-button',
        'keyboard-shortcut'
    ];
    return acceptedTriggerPoints.includes(triggerPoint);
};
const $b8d8e5356c7976a6$export$8d246e5e04f0b424 = (shouldPushDiscoverability, isTriggerAccepted, defaultView = 'modal')=>{
    if (!shouldPushDiscoverability) return undefined;
    return {
        minimizableModalView: isTriggerAccepted ? 'mini' : defaultView,
        shouldPushMiniModalDiscoverability: true,
        shouldShowMiniModalSpotlight: isTriggerAccepted
    };
};
const $b8d8e5356c7976a6$export$720579602bb055a2 = (isTriggerAccepted, persistentView, defaultView = 'modal')=>{
    if (isTriggerAccepted) return persistentView || defaultView;
    return defaultView;
};

});
parcelRegister("fqKjL", function(module, exports) {

$parcel$export(module.exports, "globalIssueCreateModalLoad", () => $de2993c8c3fea479$export$5a01a7fa84b239c8);
$parcel$export(module.exports, "globalIssueCreateModalLoadSubsequent", () => $de2993c8c3fea479$export$c50ad3c31b6fcfc6);
$parcel$export(module.exports, "successFlagDisplay", () => $de2993c8c3fea479$export$4b2382574525bb0f);
$parcel$export(module.exports, "successFlagAddToSprintAction", () => $de2993c8c3fea479$export$7839bdaa2f6a2385);
$parcel$export(module.exports, "successFlagClearFiltersAction", () => $de2993c8c3fea479$export$c1592e4d8d98963e);

var $lNfG4 = parcelRequire("lNfG4");
const $de2993c8c3fea479$export$5a01a7fa84b239c8 = (0, $lNfG4.metrics).interaction({
    key: 'global-issue-create-modal'
});
const $de2993c8c3fea479$export$c50ad3c31b6fcfc6 = (0, $lNfG4.metrics).interaction({
    key: 'global-issue-create-modal-subsequent'
});
const $de2993c8c3fea479$export$4b2382574525bb0f = (0, $lNfG4.metrics).interaction({
    key: 'global-issue-create-dynamic-success-flag-display'
});
const $de2993c8c3fea479$export$7839bdaa2f6a2385 = (0, $lNfG4.metrics).interaction({
    key: 'global-issue-create-dynamic-success-flag-add-to-sprint-action'
});
const $de2993c8c3fea479$export$c1592e4d8d98963e = (0, $lNfG4.metrics).interaction({
    key: 'global-issue-create-dynamic-success-flag-clear-filters-action'
});

});

parcelRegister("hBkQt", function(module, exports) {

$parcel$export(module.exports, "globalIssueCreateTTIWithAdjustments", () => $362542d6dd943f24$export$9f3d6f17e1da7874);
$parcel$export(module.exports, "startGlobalIssueCreateTTIWithAdjustments", () => $362542d6dd943f24$export$457c9fb71ad5b3a9);
$parcel$export(module.exports, "markGicTti", () => $362542d6dd943f24$export$ef664dac649a716c);
$parcel$export(module.exports, "stopTTI", () => $362542d6dd943f24$export$30ca4c461fab486c);
$parcel$export(module.exports, "cancelTTI", () => $362542d6dd943f24$export$27f2445288b528c);
$parcel$export(module.exports, "markIframeLoad", () => $362542d6dd943f24$export$7a2709fc1e33401a);
$parcel$export(module.exports, "markFieldsRegistered", () => $362542d6dd943f24$export$cf3893335c93e33b);
$parcel$export(module.exports, "markOnInitResolved", () => $362542d6dd943f24$export$d86f4868694f2aa7);

var $lNfG4 = parcelRequire("lNfG4");

var $gGRYc = parcelRequire("gGRYc");
const $362542d6dd943f24$export$9f3d6f17e1da7874 = (0, $lNfG4.metrics).interaction({
    key: 'global-issue-create-tti-with-adjustments',
    timings: [
        {
            key: 'gic-tti-delta',
            startMark: 'gic-tti'
        },
        {
            key: 'script-execution',
            startMark: 'iframe-load'
        },
        {
            key: 'loading-indicators-visibility',
            startMark: 'fields-registered'
        },
        {
            key: 'time-until-oninit-resolved',
            endMark: 'oninit-resolved'
        },
        {
            key: 'gic-all-fields-tti',
            endMark: 'gic-all-fields-loaded'
        }
    ],
    featureFlags: (0, $gGRYc.TTIFFs)
});
const $362542d6dd943f24$export$457c9fb71ad5b3a9 = ()=>{
    $362542d6dd943f24$export$9f3d6f17e1da7874.start();
};
const $362542d6dd943f24$export$ef664dac649a716c = ()=>$362542d6dd943f24$export$9f3d6f17e1da7874.mark('gic-tti');
const $362542d6dd943f24$export$30ca4c461fab486c = (customData)=>{
    $362542d6dd943f24$export$9f3d6f17e1da7874.stop({
        customData: customData
    });
};
const $362542d6dd943f24$export$27f2445288b528c = ()=>{
    $362542d6dd943f24$export$9f3d6f17e1da7874.cancel();
};
const $362542d6dd943f24$export$7a2709fc1e33401a = ()=>{
    $362542d6dd943f24$export$9f3d6f17e1da7874.mark('iframe-load');
};
const $362542d6dd943f24$export$cf3893335c93e33b = ()=>{
    $362542d6dd943f24$export$9f3d6f17e1da7874.mark('fields-registered');
};
const $362542d6dd943f24$export$d86f4868694f2aa7 = ()=>{
    $362542d6dd943f24$export$9f3d6f17e1da7874.mark('oninit-resolved');
};

});
parcelRegister("gGRYc", function(module, exports) {

$parcel$export(module.exports, "TTIFFs", () => $05ae9ccc47102fc0$export$c396ba1504d97f3f);
const $05ae9ccc47102fc0$export$c396ba1504d97f3f = [
    'uim-1689-gql-fetch-ui-adjustments_zbqgh'
];

});




parcelRegister("dNWQB", function(module, exports) {

$parcel$export(module.exports, "GIC_LIFECYCLE_EVENTS", () => $21eb2e23e0bf69c0$export$876003a5b887f37e);
const $21eb2e23e0bf69c0$export$876003a5b887f37e = {
    MODAL_OPENED: 'MODAL_OPENED',
    MODAL_CLOSED: 'MODAL_CLOSED',
    MODAL_KEEP_EDITING_EXISTING_ISSUE: 'MODAL_KEEP_EDITING',
    MODAL_DISCARD_EXISTING_IN_PROGRESS_ISSUE: 'MODAL_DISCARD',
    MODAL_DISCARD_SUGGESTED_ISSUE: 'MODAL_DISCARD_SUGGESTED_ISSUE',
    MODAL_DISCARD_SUGGESTED_ISSUE_CHANGES: 'MODAL_DISCARD_SUGGESTED_ISSUE_CHANGES',
    MODAL_DISCARD_ALL_SUGGESTED_ISSUES: 'MODAL_DISCARD_ALL_SUGGESTED_ISSUES',
    CREATE_FORM_FIELD_CONFIG_UPDATE: 'CREATE_FORM_FIELD_CONFIG_UPDATE',
    CREATE_FORM_FIELD_VALUE_CHANGE: 'CREATE_FORM_FIELD_VALUE_CHANGE',
    ISSUE_CREATE_SUCCESS: 'ISSUE_CREATE_SUCCESS',
    PROJECT_FIELD_VALUE_CHANGE: 'PROJECT_FIELD_VALUE_CHANGE',
    ISSUE_TYPE_FIELD_VALUE_CHANGE: 'ISSUE_TYPE_FIELD_VALUE_CHANGE',
    RESET_FORM_FIELDS_FOR_CREATE_ANOTHER: 'RESET_FORM_FIELDS_FOR_CREATE_ANOTHER',
    USE_TRIGGER_ISSUE_CREATE_MODAL_STATE_CHANGE: 'USE_TRIGGER_ISSUE_CREATE_MODAL_STATE_CHANGE',
    STATUS_FIELD_STATE_CHANGE: 'STATUS_FIELD_STATE_CHANGE',
    CREATE_FORM_FIELD_BLUR: 'CREATE_FORM_FIELD_BLUR',
    CLASSIFICATION_LEVEL_FIELD_CHANGE: 'CLASSIFICATION_LEVEL_FIELD_CHANGE',
    FORM_CONTEXT_STATE_CHANGE: 'FORM_CONTEXT_STATE_CHANGE'
};

});

parcelRegister("2gOs4", function(module, exports) {

$parcel$export(module.exports, "useGICLifeCycleEvents", () => $c9d12900db50c35b$export$e3ff72f196296fcc);

var $jcERi = parcelRequire("jcERi");
const $c9d12900db50c35b$var$GICLifeCycleEventsService = new (0, $jcERi.PubSubHub)();
const $c9d12900db50c35b$export$e3ff72f196296fcc = ()=>({
        ...$c9d12900db50c35b$var$GICLifeCycleEventsService
    });

});
parcelRegister("jcERi", function(module, exports) {

$parcel$export(module.exports, "PubSubHub", () => $a1db2e8ca1046c74$export$e3607828f8f2c01e);
class $a1db2e8ca1046c74$export$e3607828f8f2c01e {
    constructor(){
        this.subscribers = {};
        this.subscribe = (event, subscriber)=>{
            let subs = this.subscribers[event];
            if (!subs) {
                subs = [];
                this.subscribers[event] = subs;
            }
            subs?.push(subscriber);
            return ()=>this.unsubscribe(event, subscriber);
        };
        this.unsubscribe = (event, subscriber)=>{
            const subs = this.subscribers[event];
            if (subs) this.subscribers[event] = subs.filter((subscription)=>subscription !== subscriber);
        };
        this.publish = (event, data)=>{
            const subs = this.subscribers[event];
            if (subs?.length) subs?.forEach((subscriber)=>subscriber(data));
        };
        this.clearAll = ()=>{
            this.subscribers = {};
        };
    }
}

});


parcelRegister("l1Cux", function(module, exports) {

$parcel$export(module.exports, "buildGICPayload", () => $3b44adbb66991c12$export$eb18ffe6388f217a);
/* eslint-disable @typescript-eslint/no-non-null-assertion */ /* eslint-disable complexity */ 
var $6x1NF = parcelRequire("6x1NF");

var $jGcn0 = parcelRequire("jGcn0");

var $lO4Or = parcelRequire("lO4Or");
const $3b44adbb66991c12$var$assigneeFieldPredicate = (field)=>field.type === (0, $lO4Or.ASSIGNEE_TYPE);
const $3b44adbb66991c12$var$categoryFieldPredicate = (field)=>field.type === (0, $lO4Or.CATEGORY_TYPE);
const $3b44adbb66991c12$var$dueDateFieldPredicate = (field)=>field.type === (0, $lO4Or.DUE_DATE_TYPE);
const $3b44adbb66991c12$var$priorityFieldPredicate = (field)=>field.type === (0, $lO4Or.PRIORITY_TYPE);
const $3b44adbb66991c12$var$startDateFieldPredicate = (field)=>field.aliasFieldId === (0, $jGcn0.START_DATE_ALIAS_FIELD_ID);
const $3b44adbb66991c12$var$storyPointEstimateFieldPredicate = (field)=>field.type === (0, $lO4Or.STORY_POINT_ESTIMATE_CF_TYPE);
const $3b44adbb66991c12$var$storyPointsFieldPredicate = (field)=>field.type === (0, $lO4Or.NUMBER_CF_TYPE) && field.aliasFieldId === (0, $jGcn0.STORY_POINTS_ALIAS_FIELD_ID);
const $3b44adbb66991c12$var$sprintFieldPredicate = (field)=>field.type === (0, $lO4Or.SPRINT_TYPE);
const $3b44adbb66991c12$export$eb18ffe6388f217a = ({ createInput: createInput, extraPayload: extraPayload, rankField: rankField, getField: getField })=>{
    const payload = {
        defaultValues: {
            singleLineTextFields: [],
            singleSelectUserPickerFields: [],
            numberFields: [],
            datePickerFields: []
        },
        project: {
            projectId: createInput.projectId
        }
    };
    const additionalFields = {};
    let transition;
    if (createInput.summary) payload.defaultValues.singleLineTextFields.push({
        fieldId: (0, $lO4Or.SUMMARY_TYPE),
        text: createInput.summary
    });
    if (createInput.issueType) payload.issueType = {
        issueTypeId: createInput.issueType.id
    };
    if (createInput.dueDate && getField(createInput.issueType, $3b44adbb66991c12$var$dueDateFieldPredicate)) {
        const formattedDueDate = (0, $6x1NF.default)(createInput.dueDate, 'UTC', 'yyyy-MM-dd');
        payload.defaultValues.datePickerFields.push({
            fieldId: (0, $lO4Or.DUE_DATE_TYPE),
            date: {
                formattedDate: formattedDueDate
            }
        });
        additionalFields.duedate = formattedDueDate;
    }
    const startDateField = getField(createInput.issueType, $3b44adbb66991c12$var$startDateFieldPredicate);
    if (createInput.startDate && startDateField) {
        const formattedStartDate = (0, $6x1NF.default)(createInput.startDate, 'UTC', 'yyyy-MM-dd');
        payload.defaultValues.datePickerFields.push({
            fieldId: startDateField.id,
            date: {
                formattedDate: formattedStartDate
            }
        });
        additionalFields[startDateField.id] = formattedStartDate;
    }
    if (createInput.assignee && getField(createInput.issueType, $3b44adbb66991c12$var$assigneeFieldPredicate)) {
        payload.defaultValues.singleSelectUserPickerFields.push({
            fieldId: (0, $lO4Or.ASSIGNEE_TYPE),
            user: {
                accountId: createInput.assignee.accountId
            }
        });
        additionalFields[0, $lO4Or.ASSIGNEE_TYPE] = {
            id: createInput.assignee.accountId
        };
    }
    if (createInput.priority && getField(createInput.issueType, $3b44adbb66991c12$var$priorityFieldPredicate)) {
        payload.defaultValues.priority = {
            priorityId: createInput.priority.priorityId
        };
        additionalFields[0, $lO4Or.PRIORITY_TYPE] = {
            id: createInput.priority.priorityId
        };
    }
    const categoryField = getField(createInput.issueType, $3b44adbb66991c12$var$categoryFieldPredicate);
    if (createInput.category && categoryField) {
        payload.defaultValues.singleSelectFields = [
            {
                fieldId: categoryField.id,
                option: {
                    id: createInput.category.optionId,
                    optionId: createInput.category.optionId
                }
            }
        ];
        additionalFields[categoryField.id] = {
            id: createInput.category.optionId,
            value: createInput.category.value
        };
    }
    const storyPointEstimateField = getField(createInput.issueType, $3b44adbb66991c12$var$storyPointEstimateFieldPredicate);
    if (createInput.storyPointEstimate && storyPointEstimateField) {
        payload.defaultValues.numberFields.push({
            fieldId: storyPointEstimateField.id,
            value: createInput.storyPointEstimate
        });
        additionalFields[storyPointEstimateField.id] = {
            id: storyPointEstimateField.id,
            value: createInput.storyPointEstimate
        };
    }
    const storyPointsField = getField(createInput.issueType, $3b44adbb66991c12$var$storyPointsFieldPredicate);
    if (createInput.storyPoints && storyPointsField) {
        payload.defaultValues.numberFields.push({
            fieldId: storyPointsField.id,
            value: createInput.storyPoints
        });
        additionalFields[storyPointsField.id] = {
            id: storyPointsField.id,
            value: createInput.storyPoints
        };
    }
    const sprintField = getField(createInput.issueType, $3b44adbb66991c12$var$sprintFieldPredicate);
    if (createInput.sprint && sprintField) {
        payload.defaultValues.sprintsField = {
            fieldId: sprintField.id,
            sprints: [
                {
                    sprintId: createInput.sprint.id
                }
            ]
        };
        additionalFields[sprintField.id] = {
            id: sprintField.id,
            value: createInput.sprint.id
        };
    }
    if (createInput.parentIssueId) {
        payload.parentId = {
            parentId: createInput.parentIssueId
        };
        payload.defaultValues.parentField = {
            issueId: createInput.parentIssueId
        };
    }
    if (createInput.status && extraPayload?.transitionId) {
        payload.status = {
            statusId: createInput.status.statusId
        };
        transition = {
            id: extraPayload.transitionId
        };
    }
    if (rankField && (createInput.rankAfter || createInput.rankBefore)) // rank is always passed as additional field
    additionalFields[rankField.id] = {
        ...createInput.rankAfter ? {
            rankAfterIssue: createInput.rankAfter.issueId
        } : {},
        ...createInput.rankBefore ? {
            rankBeforeIssue: createInput.rankBefore.issueId
        } : {}
    };
    return {
        payload: payload,
        submitApiData: {
            additionalFields: additionalFields,
            transition: transition
        }
    };
};

});


parcelRegister("fOAem", function(module, exports) {

$parcel$export(module.exports, "useShowCreateSuccessFlag", () => $96a3689a6bc73ef9$export$dfe953d11a91d407);

var $eUqFw = parcelRequire("eUqFw");

var $jGcn0 = parcelRequire("jGcn0");

var $hIxFu = parcelRequire("hIxFu");

var $k8Qyf = parcelRequire("k8Qyf");

var $5JgJ2 = parcelRequire("5JgJ2");

var $kJlBc = parcelRequire("kJlBc");

var $jb0p7 = parcelRequire("jb0p7");
const $96a3689a6bc73ef9$export$dfe953d11a91d407 = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, $k8Qyf.useFlagsService)();
    const [, setSelectedIssueKey] = (0, $kJlBc.useQueryParam)((0, $jGcn0.SELECTED_ISSUE_PARAM));
    return (0, $eUqFw.useCallback)((issueKey)=>{
        const flagId = `jwm-create-success-flag-${issueKey}`;
        showFlag({
            id: flagId,
            isAutoDismiss: true,
            type: 'success',
            title: formatMessage((0, $jb0p7.default).createSuccessFlagTitle, {
                issueKey: issueKey
            }),
            actions: [
                {
                    content: (0, $jb0p7.default).viewIssueLinkText,
                    href: `/browse/${issueKey}`,
                    onClick: (event)=>{
                        if (event && !(0, $hIxFu.isModifiedEvent)(event)) {
                            setSelectedIssueKey(issueKey);
                            event.preventDefault();
                            event.stopPropagation();
                        }
                        dismissFlag(flagId);
                    }
                }
            ]
        });
    }, [
        dismissFlag,
        formatMessage,
        setSelectedIssueKey,
        showFlag
    ]);
};

});
parcelRegister("hIxFu", function(module, exports) {

$parcel$export(module.exports, "isModifiedEvent", () => $b3eda05a90faeae0$export$642c6f14f6d4bbd5);
const $b3eda05a90faeae0$export$642c6f14f6d4bbd5 = (event)=>Boolean(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);

});

parcelRegister("jb0p7", function(module, exports) {

$parcel$export(module.exports, "default", () => $82d4475055050609$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $82d4475055050609$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    createSuccessFlagTitle: {
        "id": "business-issue-create.controllers.show-create-success-flag.create-success-flag-title",
        "defaultMessage": "You've created issue \"{issueKey}\""
    },
    viewIssueLinkText: {
        "id": "business-issue-create.controllers.show-create-success-flag.view-issue-link-text",
        "defaultMessage": "View issue"
    }
});

});


parcelRegister("9Y2JR", function(module, exports) {

$parcel$export(module.exports, "default", () => $bd43750acdd7824c$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $bd43750acdd7824c$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    errorFlagTitle: {
        "id": "business-issue-create.controllers.create-issue.error-flag-title",
        "defaultMessage": "We weren't able to create an issue"
    },
    errorFlagDescription: {
        "id": "business-issue-create.controllers.create-issue.error-flag-description",
        "defaultMessage": "Refresh the page and try again."
    }
});

});


parcelRegister("frfm9", function(module, exports) {

$parcel$export(module.exports, "useCreateParamHandler", () => $6b54e991d48bd90a$export$294bf5b0ba86140);

var $eUqFw = parcelRequire("eUqFw");

var $jGcn0 = parcelRequire("jGcn0");

var $kQAZu = parcelRequire("kQAZu");

var $kJlBc = parcelRequire("kJlBc");

var $auegK = parcelRequire("auegK");
const $6b54e991d48bd90a$export$294bf5b0ba86140 = ()=>{
    const [inlineCreateParam, setInlineCreateParam] = (0, $kJlBc.useQueryParam)((0, $jGcn0.INLINE_CREATE_PARAM));
    const showCreateIssueDialog = (0, $auegK.useCreateIssueDialog)();
    const project = (0, $kQAZu.useProject)();
    (0, $eUqFw.useEffect)(()=>{
        if (inlineCreateParam != null) {
            showCreateIssueDialog({
                projectId: String(project.id)
            }).catch(()=>{
            // we don't care about the error in this scenario
            });
            setInlineCreateParam(undefined);
        }
    }, [
        inlineCreateParam,
        project,
        setInlineCreateParam,
        showCreateIssueDialog
    ]);
};

});


parcelRegister("2nzpw", function(module, exports) {

$parcel$export(module.exports, "TIMELINE_PARENT_LEVEL", () => $269524b59d05b9d7$export$6e8d55b449655862);
$parcel$export(module.exports, "TIMELINE_CHILD_LEVEL", () => $269524b59d05b9d7$export$f6acdc1bda8a6425);
$parcel$export(module.exports, "TIMELINE_EPIC_HIERARCHY_LEVEL", () => $269524b59d05b9d7$export$24a7d783c2bdcbc2);
$parcel$export(module.exports, "TIMELINE_SUBTASK_HIERARCHY_LEVEL", () => $269524b59d05b9d7$export$dc01266f5a500c9e);
$parcel$export(module.exports, "TIMELINE_ROOT_DEPTH", () => $269524b59d05b9d7$export$35b86881ab3777f7);
$parcel$export(module.exports, "TIMELINE_PAGE_SIZE_ARGS", () => $269524b59d05b9d7$export$423ce7c5516f157c);
$parcel$export(module.exports, "fieldIds", () => $269524b59d05b9d7$export$b5b496642be4236d);
$parcel$export(module.exports, "DEPENDENCY_DRAG_ITEM_ID", () => $269524b59d05b9d7$export$48a2b55760ce2355);
$parcel$export(module.exports, "MAIN_EXPERIENCE", () => $269524b59d05b9d7$export$b3d8a68bfc68a411);
$parcel$export(module.exports, "LINK_ISSUES_EXPERIENCE", () => $269524b59d05b9d7$export$aea4881e85e2e4d9);
$parcel$export(module.exports, "UNLINK_ISSUES_EXPERIENCE", () => $269524b59d05b9d7$export$1225c124f186defa);
$parcel$export(module.exports, "LOAD_CHILD_ISSUES_EXPERIENCE", () => $269524b59d05b9d7$export$372aa8438498eb82);
$parcel$export(module.exports, "LOAD_MORE_EXPERIENCE", () => $269524b59d05b9d7$export$a435f2d9a52cd0ab);
$parcel$export(module.exports, "VIEW_DEPENDENCY_EXPERIENCE", () => $269524b59d05b9d7$export$f3ca7df6171335d1);
$parcel$export(module.exports, "SCHEDULE_ITEM_EXPERIENCE", () => $269524b59d05b9d7$export$1f9cf4c341d296a1);
$parcel$export(module.exports, "RANK_ISSUE_EXPERIENCE", () => $269524b59d05b9d7$export$1cc6cf3582688fdd);
$parcel$export(module.exports, "EXPORT_IMAGE_EXPERIENCE", () => $269524b59d05b9d7$export$8cc7d26eb8be8d4b);
const $269524b59d05b9d7$var$PACKAGE_NAME = 'jiraBusinessTimeline';
const $269524b59d05b9d7$export$6e8d55b449655862 = 1;
const $269524b59d05b9d7$export$f6acdc1bda8a6425 = 0;
const $269524b59d05b9d7$export$24a7d783c2bdcbc2 = 1;
const $269524b59d05b9d7$export$dc01266f5a500c9e = -1;
const $269524b59d05b9d7$export$35b86881ab3777f7 = 0;
const $269524b59d05b9d7$export$423ce7c5516f157c = {
    first: 25
};
const $269524b59d05b9d7$export$b5b496642be4236d = [
    'issuekey',
    'issuetype',
    'summary',
    'status',
    'assignee',
    'startdate',
    'duedate',
    'rank',
    'subtasks',
    'childIssues',
    'issuelinks',
    'parent'
];
const $269524b59d05b9d7$export$48a2b55760ce2355 = 'dependency-drag-id';
const $269524b59d05b9d7$export$c330e9be73819573 = 'dependencies-drop-target';
const $269524b59d05b9d7$export$b3d8a68bfc68a411 = {
    experience: 'timelineView',
    packageName: $269524b59d05b9d7$var$PACKAGE_NAME,
    teamName: 'jira-yurree'
};
const $269524b59d05b9d7$export$aea4881e85e2e4d9 = {
    experience: 'linkIssues',
    packageName: $269524b59d05b9d7$var$PACKAGE_NAME,
    teamName: 'jira-yurree'
};
const $269524b59d05b9d7$export$1225c124f186defa = {
    experience: 'unlinkIssues',
    packageName: $269524b59d05b9d7$var$PACKAGE_NAME,
    teamName: 'jira-yurree'
};
const $269524b59d05b9d7$export$372aa8438498eb82 = {
    experience: 'loadChildIssues',
    packageName: $269524b59d05b9d7$var$PACKAGE_NAME,
    teamName: 'jira-yurree'
};
const $269524b59d05b9d7$export$a435f2d9a52cd0ab = {
    experience: 'loadMore',
    packageName: $269524b59d05b9d7$var$PACKAGE_NAME,
    teamName: 'jira-yurree'
};
const $269524b59d05b9d7$export$f3ca7df6171335d1 = {
    experience: 'viewDependency',
    packageName: $269524b59d05b9d7$var$PACKAGE_NAME,
    teamName: 'jira-yurree'
};
const $269524b59d05b9d7$export$1f9cf4c341d296a1 = {
    experience: 'scheduleItem',
    packageName: $269524b59d05b9d7$var$PACKAGE_NAME,
    teamName: 'jira-yurree'
};
const $269524b59d05b9d7$export$1cc6cf3582688fdd = {
    experience: 'rankIssue',
    packageName: $269524b59d05b9d7$var$PACKAGE_NAME,
    teamName: 'jira-yurree'
};
const $269524b59d05b9d7$export$8cc7d26eb8be8d4b = {
    experience: 'exportImage',
    packageName: $269524b59d05b9d7$var$PACKAGE_NAME,
    teamName: 'jira-yurree'
};
const $269524b59d05b9d7$export$8d823d9dee471765 = {
    experience: 'updateParentIssue',
    packageName: $269524b59d05b9d7$var$PACKAGE_NAME,
    teamName: 'jira-yurree'
};

});

parcelRegister("203kY", function(module, exports) {

$parcel$export(module.exports, "useTimelineFeatures", () => $287f0e744b358dbe$export$e3e1501a9c056805);
$parcel$export(module.exports, "default", () => $287f0e744b358dbe$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
const $287f0e744b358dbe$var$defaultFeaturesContext = {
    featureView: 'timeline',
    hasExportButton: true,
    hasInlineCreate: true,
    hasCreateSubtask: true,
    hasInviteButton: true,
    hasIssueLinking: true,
    hasOnboarding: true,
    hasPresence: true,
    hasScheduleIssues: true,
    hasShareButton: true,
    inlineCreateInteraction: 'default',
    inviteButtonInteraction: 'default',
    issueViewInteraction: 'default',
    stickyInlineCreateInteraction: 'default',
    hasFilterCustomFields: true
};
const $287f0e744b358dbe$var$TimelineFeaturesContext = /*#__PURE__*/ (0, $eUqFw.createContext)($287f0e744b358dbe$var$defaultFeaturesContext);
const $287f0e744b358dbe$export$e3e1501a9c056805 = ()=>(0, $eUqFw.useContext)($287f0e744b358dbe$var$TimelineFeaturesContext);
const $287f0e744b358dbe$var$TimelineFeaturesProvider = ({ children: children, ...props })=>{
    const value = (0, $eUqFw.useMemo)(()=>({
            ...$287f0e744b358dbe$var$defaultFeaturesContext,
            ...props
        }), [
        props
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($287f0e744b358dbe$var$TimelineFeaturesContext.Provider, {
        value: value
    }, children);
};
var $287f0e744b358dbe$export$2e2bcd8739ae039 = $287f0e744b358dbe$var$TimelineFeaturesProvider;

});

parcelRegister("eTH8y", function(module, exports) {

$parcel$export(module.exports, "useTimelineUI", () => $de73899d56aacbf6$export$ea99d7f13ae5e9bd);

var $eUqFw = parcelRequire("eUqFw");

var $ji3xf = parcelRequire("ji3xf");
var $7c3W1 = parcelRequire("7c3W1");

var $gf0vG = parcelRequire("gf0vG");

var $lfgcv = parcelRequire("lfgcv");

var $25Ymt = parcelRequire("25Ymt");
const $de73899d56aacbf6$var$validTimelineModes = new Set([
    (0, $gf0vG.WEEKS),
    (0, $gf0vG.MONTHS),
    (0, $gf0vG.QUARTERS)
]);
const $de73899d56aacbf6$var$useRangeMode = ()=>{
    const [rangeModePreference, setRangeModePreference] = (0, $7c3W1.useViewPreference)((0, $ji3xf.RANGE_MODE_PREFERENCE));
    const setRangeMode = (0, $eUqFw.useCallback)((newTimelineMode)=>{
        if (newTimelineMode === (0, $gf0vG.MONTHS)) return setRangeModePreference(undefined);
        return setRangeModePreference(newTimelineMode.toLowerCase());
    }, [
        setRangeModePreference
    ]);
    const rangeMode = (0, $eUqFw.useMemo)(()=>{
        if (rangeModePreference != null && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        $de73899d56aacbf6$var$validTimelineModes.has(rangeModePreference.toUpperCase())) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return rangeModePreference.toUpperCase();
        return 0, $gf0vG.MONTHS;
    }, [
        rangeModePreference
    ]);
    return [
        rangeMode,
        setRangeMode
    ];
};
const $de73899d56aacbf6$export$f9b761e26377fb1f = (queryParam)=>// @ts-expect-error - TS2322 - Type 'string' is not assignable to type 'TimelineMode'. | TS2345 - Argument of type 'string' is not assignable to parameter of type 'TimelineMode'.
    queryParam !== undefined && $de73899d56aacbf6$var$validTimelineModes.has(queryParam) ? queryParam : (0, $gf0vG.MONTHS);
const $de73899d56aacbf6$export$ea99d7f13ae5e9bd = ()=>{
    const [rangeModeQueryParam, setRangeMode] = $de73899d56aacbf6$var$useRangeMode();
    const timelineMode = $de73899d56aacbf6$export$f9b761e26377fb1f(rangeModeQueryParam);
    const today = (0, $lfgcv.getToday)();
    const timelineDuration = (0, $25Ymt.getTimelineDurationFromDate)(timelineMode, today);
    const timelineOrigin = (0, $25Ymt.getTimelineOriginForToday)(today, timelineMode);
    const todayPosition = (0, $25Ymt.getDefaultTimelinePositionFromDate)(today, timelineMode, timelineDuration);
    return [
        {
            today: today,
            timelineMode: timelineMode,
            timelineDuration: timelineDuration,
            timelineOrigin: timelineOrigin,
            todayPosition: todayPosition
        },
        {
            setTimelineMode: setRangeMode
        }
    ];
};

});
parcelRegister("gf0vG", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_DEPTH", () => $007c33d2f693bd63$export$7f882bb969de14a3);
$parcel$export(module.exports, "DEFAULT_LEVEL", () => $007c33d2f693bd63$export$480df663967f228c);
$parcel$export(module.exports, "RESIZE_DEBOUNCE_MS", () => $007c33d2f693bd63$export$747901c4619ea19c);
$parcel$export(module.exports, "BASE_LEVEL", () => $007c33d2f693bd63$export$d5993e01b9439be4);
$parcel$export(module.exports, "PARENT_LEVEL", () => $007c33d2f693bd63$export$6c5e715ac831956e);
$parcel$export(module.exports, "BASE_HEADER_HEIGHT", () => $007c33d2f693bd63$export$bf0adf7b400249e1);
$parcel$export(module.exports, "HEADER_CONTENT_HEIGHT", () => $007c33d2f693bd63$export$46c78f5f070f677a);
$parcel$export(module.exports, "DEFAULT_SUBHEADER_HEIGHT", () => $007c33d2f693bd63$export$29ae8fa7fd1c9a2f);
$parcel$export(module.exports, "DEFAULT_ITEM_HEIGHT", () => $007c33d2f693bd63$export$f898a7479a35465b);
$parcel$export(module.exports, "BASE_LEVEL_ITEM_HEIGHT", () => $007c33d2f693bd63$export$c4ca1a8adb6a9f07);
$parcel$export(module.exports, "MINIMUM_LIST_WIDTH", () => $007c33d2f693bd63$export$6bb070ef26ec48d9);
$parcel$export(module.exports, "DEFAULT_LIST_WIDTH", () => $007c33d2f693bd63$export$58590494eb7f9f92);
$parcel$export(module.exports, "DEFAULT_HEADER_ROW_ID", () => $007c33d2f693bd63$export$b24bdd4190312b9);
$parcel$export(module.exports, "UP", () => $007c33d2f693bd63$export$b29f845fa4b57508);
$parcel$export(module.exports, "DOWN", () => $007c33d2f693bd63$export$c7c029a231f98d34);
$parcel$export(module.exports, "ROW_DRAG_AND_DROP_ID", () => $007c33d2f693bd63$export$ac3c20c079db2388);
$parcel$export(module.exports, "LIST_DRAG_AND_DROP", () => $007c33d2f693bd63$export$3c4f97ccd236019);
$parcel$export(module.exports, "CHILD_LIST_DRAG_AND_DROP", () => $007c33d2f693bd63$export$d3793ebc963c3515);
$parcel$export(module.exports, "LIST_RESIZE_DRAG_AND_DROP", () => $007c33d2f693bd63$export$ea4843d184267eb1);
$parcel$export(module.exports, "DELAY_EXPAND_TIME", () => $007c33d2f693bd63$export$d165800dfbec11d6);
$parcel$export(module.exports, "BEFORE", () => $007c33d2f693bd63$export$4cff6e48b6cc73b5);
$parcel$export(module.exports, "INSIDE", () => $007c33d2f693bd63$export$48ea0cac79c83ca8);
$parcel$export(module.exports, "LAST", () => $007c33d2f693bd63$export$5514f5adc70fa605);
$parcel$export(module.exports, "TIMELINE_ID", () => $007c33d2f693bd63$export$80a4040613c38228);
$parcel$export(module.exports, "WEEKS", () => $007c33d2f693bd63$export$ae0be2880fd1f23e);
$parcel$export(module.exports, "MONTHS", () => $007c33d2f693bd63$export$f9a766aa2475e8ba);
$parcel$export(module.exports, "QUARTERS", () => $007c33d2f693bd63$export$6bd120b531154c2a);
$parcel$export(module.exports, "HALF_INLINE_CREATE_ICON_WIDTH", () => $007c33d2f693bd63$export$6d29db963a7e29b9);
$parcel$export(module.exports, "zIndex", () => $007c33d2f693bd63$export$56446adcecbeec34);
$parcel$export(module.exports, "DEFAULT_CREATE_KEY", () => $007c33d2f693bd63$export$b9c79d675b03c1af);
$parcel$export(module.exports, "ITEM_TYPE", () => $007c33d2f693bd63$export$e0a522cf395aec9b);
$parcel$export(module.exports, "CHILD_ITEM_TYPE", () => $007c33d2f693bd63$export$a0e7fecde97f31f9);
$parcel$export(module.exports, "CREATE_ITEM_TYPE", () => $007c33d2f693bd63$export$69cd3b48cdf4b6f0);
$parcel$export(module.exports, "SCROLLED", () => $007c33d2f693bd63$export$9402ce0d1e070b14);
$parcel$export(module.exports, "ITEMS_COUNT_OFFSET", () => $007c33d2f693bd63$export$86fd0995f2783921);
/* Default depth for an item in the table hierarchy.
 * despite the level, the depth is increasing when we go deeper in the hierarchy.
 * depth is starting from 0.
 */ const $007c33d2f693bd63$export$7f882bb969de14a3 = 0;
const $007c33d2f693bd63$export$480df663967f228c = 1;
const $007c33d2f693bd63$export$747901c4619ea19c = 250;
const $007c33d2f693bd63$export$622879065498b1e = 15;
const $007c33d2f693bd63$export$d5993e01b9439be4 = 0;
const $007c33d2f693bd63$export$6c5e715ac831956e = 1;
const $007c33d2f693bd63$export$bf0adf7b400249e1 = 48;
const $007c33d2f693bd63$export$46c78f5f070f677a = 16;
const $007c33d2f693bd63$export$29ae8fa7fd1c9a2f = 36;
const $007c33d2f693bd63$export$f898a7479a35465b = 40;
const $007c33d2f693bd63$export$c4ca1a8adb6a9f07 = 32;
const $007c33d2f693bd63$export$6bb070ef26ec48d9 = 320;
const $007c33d2f693bd63$export$58590494eb7f9f92 = 360;
const $007c33d2f693bd63$export$b24bdd4190312b9 = 'DEFAULT_HEADER_ROW';
const $007c33d2f693bd63$export$b29f845fa4b57508 = 'UP';
const $007c33d2f693bd63$export$c7c029a231f98d34 = 'DOWN';
const $007c33d2f693bd63$export$ac3c20c079db2388 = 'row-dnd-type-id';
const $007c33d2f693bd63$export$3c4f97ccd236019 = 'listDnd';
const $007c33d2f693bd63$export$d3793ebc963c3515 = 'childListDnd';
const $007c33d2f693bd63$export$ea4843d184267eb1 = 'listResizeDnd';
const $007c33d2f693bd63$export$d165800dfbec11d6 = 500;
const $007c33d2f693bd63$export$4cff6e48b6cc73b5 = 'BEFORE';
const $007c33d2f693bd63$export$48ea0cac79c83ca8 = 'INSIDE';
const $007c33d2f693bd63$export$5514f5adc70fa605 = 'LAST';
const $007c33d2f693bd63$export$80a4040613c38228 = 'sr-timeline';
const $007c33d2f693bd63$export$ae0be2880fd1f23e = 'WEEKS';
const $007c33d2f693bd63$export$f9a766aa2475e8ba = 'MONTHS';
const $007c33d2f693bd63$export$6bd120b531154c2a = 'QUARTERS';
const $007c33d2f693bd63$export$1041e95163fc373b = 20;
const $007c33d2f693bd63$export$6d29db963a7e29b9 = $007c33d2f693bd63$export$1041e95163fc373b / 2;
// =============== //
// === Z-INDEX === //
// =============== //
const $007c33d2f693bd63$var$CHART = 1;
const $007c33d2f693bd63$var$TODAY_MARKER = 6;
const $007c33d2f693bd63$var$HEADER = 7;
const $007c33d2f693bd63$var$LIST_COVER = 8;
const $007c33d2f693bd63$var$LIST = 9;
const $007c33d2f693bd63$var$LIST_CREATE_ITEM = 10;
const $007c33d2f693bd63$var$INLINE_INDICATOR_OLD = 10;
const $007c33d2f693bd63$var$INLINE_INDICATOR = 11;
const $007c33d2f693bd63$var$SCROLLBAR = 11;
const $007c33d2f693bd63$var$ROW_HEADER = 12;
const $007c33d2f693bd63$var$BORDER = 12;
const $007c33d2f693bd63$var$LIST_RESIZER = 13;
const $007c33d2f693bd63$var$DRAGGABLE = 13;
const $007c33d2f693bd63$var$PORTAL = 13;
const $007c33d2f693bd63$var$HIGHEST = 14;
const $007c33d2f693bd63$export$56446adcecbeec34 = {
    CHART: $007c33d2f693bd63$var$CHART,
    BORDER: $007c33d2f693bd63$var$BORDER,
    TODAY_MARKER: $007c33d2f693bd63$var$TODAY_MARKER,
    LIST_COVER: $007c33d2f693bd63$var$LIST_COVER,
    HEADER: $007c33d2f693bd63$var$HEADER,
    LIST: $007c33d2f693bd63$var$LIST,
    LIST_CREATE_ITEM: $007c33d2f693bd63$var$LIST_CREATE_ITEM,
    INLINE_INDICATOR: $007c33d2f693bd63$var$INLINE_INDICATOR,
    INLINE_INDICATOR_OLD: $007c33d2f693bd63$var$INLINE_INDICATOR_OLD,
    SCROLLBAR: $007c33d2f693bd63$var$SCROLLBAR,
    ROW_HEADER: $007c33d2f693bd63$var$ROW_HEADER,
    LIST_RESIZER: $007c33d2f693bd63$var$LIST_RESIZER,
    DRAGGABLE: $007c33d2f693bd63$var$DRAGGABLE,
    PORTAL: $007c33d2f693bd63$var$PORTAL,
    HIGHEST: $007c33d2f693bd63$var$HIGHEST
};
const $007c33d2f693bd63$export$b9c79d675b03c1af = 'create-default';
const $007c33d2f693bd63$export$e0a522cf395aec9b = 'ITEM_TYPE';
const $007c33d2f693bd63$export$a0e7fecde97f31f9 = 'CHILD_ITEM_TYPE';
const $007c33d2f693bd63$export$69cd3b48cdf4b6f0 = 'CREATE_ITEM_TYPE';
const $007c33d2f693bd63$export$9402ce0d1e070b14 = 'scrolled';
const $007c33d2f693bd63$export$86fd0995f2783921 = 1; // The column header row at the top of the table for dates

});

parcelRegister("lfgcv", function(module, exports) {

$parcel$export(module.exports, "getToday", () => $e3fa822dabb3902d$export$883228a582a7567d);
$parcel$export(module.exports, "getStartOfDay", () => $e3fa822dabb3902d$export$acfb4d8d6f22913c);
$parcel$export(module.exports, "getClosestStartOfDay", () => $e3fa822dabb3902d$export$3b10530a2652517a);
$parcel$export(module.exports, "getEndOfDay", () => $e3fa822dabb3902d$export$ba913d97bab95922);
$parcel$export(module.exports, "getClosestEndOfDay", () => $e3fa822dabb3902d$export$15bcb0122f94fe73);
$parcel$export(module.exports, "getDateFromTimestamp", () => $e3fa822dabb3902d$export$f268c901e7fab1f4);

var $5iWql = parcelRequire("5iWql");

var $jJwwt = parcelRequire("jJwwt");

const $e3fa822dabb3902d$var$HALF_DAY_IN_MS = (0, $4975412c8fcbfa24$export$1f04624003d2da7d) / 2;
const $e3fa822dabb3902d$export$883228a582a7567d = (0, $5iWql.default)(()=>{
    const now = new Date();
    const date = (0, (/*@__PURE__*/$parcel$interopDefault($jJwwt))).utc().startOf('day');
    date.set({
        year: now.getFullYear(),
        month: now.getMonth(),
        date: now.getDate()
    });
    return date.valueOf();
});
const $e3fa822dabb3902d$export$acfb4d8d6f22913c = (date)=>(0, (/*@__PURE__*/$parcel$interopDefault($jJwwt))).utc(date).startOf('day').valueOf();
const $e3fa822dabb3902d$export$3b10530a2652517a = (date)=>{
    const newValue = $e3fa822dabb3902d$export$acfb4d8d6f22913c(date);
    if (date - newValue > $e3fa822dabb3902d$var$HALF_DAY_IN_MS) return newValue + $e3fa822dabb3902d$var$HALF_DAY_IN_MS * 2;
    return newValue;
};
const $e3fa822dabb3902d$export$ba913d97bab95922 = (date)=>(0, (/*@__PURE__*/$parcel$interopDefault($jJwwt))).utc(date).endOf('day').valueOf();
const $e3fa822dabb3902d$export$15bcb0122f94fe73 = (date)=>{
    const newValue = $e3fa822dabb3902d$export$ba913d97bab95922(date);
    if (newValue - date > $e3fa822dabb3902d$var$HALF_DAY_IN_MS) return newValue - $e3fa822dabb3902d$var$HALF_DAY_IN_MS * 2;
    return newValue;
};
const $e3fa822dabb3902d$export$b6b0beaf88b31f31 = (date)=>Math.round(date / (0, $4975412c8fcbfa24$export$1f04624003d2da7d)) * (0, $4975412c8fcbfa24$export$1f04624003d2da7d);
const $e3fa822dabb3902d$export$f268c901e7fab1f4 = (timestamp, format = (0, $4975412c8fcbfa24$export$45c85543ba71221d))=>(0, (/*@__PURE__*/$parcel$interopDefault($jJwwt))).utc(timestamp).format(format);

});
parcelRegister("jJwwt", function(module, exports) {
//! moment.js
//! version : 2.30.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com
(function(global, factory) {
    module.exports = factory();
})(this, function() {
    'use strict';
    var hookCallback;
    function hooks() {
        return hookCallback.apply(null, arguments);
    }
    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }
    function isArray(input) {
        return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
    }
    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return input != null && Object.prototype.toString.call(input) === '[object Object]';
    }
    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }
    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) return Object.getOwnPropertyNames(obj).length === 0;
        else {
            var k;
            for(k in obj){
                if (hasOwnProp(obj, k)) return false;
            }
            return true;
        }
    }
    function isUndefined(input) {
        return input === void 0;
    }
    function isNumber(input) {
        return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
    }
    function isDate(input) {
        return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
    }
    function map(arr, fn) {
        var res = [], i, arrLen = arr.length;
        for(i = 0; i < arrLen; ++i)res.push(fn(arr[i], i));
        return res;
    }
    function extend(a, b) {
        for(var i in b)if (hasOwnProp(b, i)) a[i] = b[i];
        if (hasOwnProp(b, 'toString')) a.toString = b.toString;
        if (hasOwnProp(b, 'valueOf')) a.valueOf = b.valueOf;
        return a;
    }
    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }
    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false
        };
    }
    function getParsingFlags(m) {
        if (m._pf == null) m._pf = defaultParsingFlags();
        return m._pf;
    }
    var some;
    if (Array.prototype.some) some = Array.prototype.some;
    else some = function(fun) {
        var t = Object(this), len = t.length >>> 0, i;
        for(i = 0; i < len; i++){
            if (i in t && fun.call(this, t[i], i, t)) return true;
        }
        return false;
    };
    function isValid(m) {
        var flags = null, parsedParts = false, isNowValid = m._d && !isNaN(m._d.getTime());
        if (isNowValid) {
            flags = getParsingFlags(m);
            parsedParts = some.call(flags.parsedDateParts, function(i) {
                return i != null;
            });
            isNowValid = flags.overflow < 0 && !flags.empty && !flags.invalidEra && !flags.invalidMonth && !flags.invalidWeekday && !flags.weekdayMismatch && !flags.nullInput && !flags.invalidFormat && !flags.userInvalidated && (!flags.meridiem || flags.meridiem && parsedParts);
            if (m._strict) isNowValid = isNowValid && flags.charsLeftOver === 0 && flags.unusedTokens.length === 0 && flags.bigHour === undefined;
        }
        if (Object.isFrozen == null || !Object.isFrozen(m)) m._isValid = isNowValid;
        else return isNowValid;
        return m._isValid;
    }
    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) extend(getParsingFlags(m), flags);
        else getParsingFlags(m).userInvalidated = true;
        return m;
    }
    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = hooks.momentProperties = [], updateInProgress = false;
    function copyConfig(to, from) {
        var i, prop, val, momentPropertiesLen = momentProperties.length;
        if (!isUndefined(from._isAMomentObject)) to._isAMomentObject = from._isAMomentObject;
        if (!isUndefined(from._i)) to._i = from._i;
        if (!isUndefined(from._f)) to._f = from._f;
        if (!isUndefined(from._l)) to._l = from._l;
        if (!isUndefined(from._strict)) to._strict = from._strict;
        if (!isUndefined(from._tzm)) to._tzm = from._tzm;
        if (!isUndefined(from._isUTC)) to._isUTC = from._isUTC;
        if (!isUndefined(from._offset)) to._offset = from._offset;
        if (!isUndefined(from._pf)) to._pf = getParsingFlags(from);
        if (!isUndefined(from._locale)) to._locale = from._locale;
        if (momentPropertiesLen > 0) for(i = 0; i < momentPropertiesLen; i++){
            prop = momentProperties[i];
            val = from[prop];
            if (!isUndefined(val)) to[prop] = val;
        }
        return to;
    }
    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) this._d = new Date(NaN);
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }
    function isMoment(obj) {
        return obj instanceof Moment || obj != null && obj._isAMomentObject != null;
    }
    function warn(msg) {
        if (hooks.suppressDeprecationWarnings === false && typeof console !== 'undefined' && console.warn) console.warn('Deprecation warning: ' + msg);
    }
    function deprecate(msg, fn) {
        var firstTime = true;
        return extend(function() {
            if (hooks.deprecationHandler != null) hooks.deprecationHandler(null, msg);
            if (firstTime) {
                var args = [], arg, i, key, argLen = arguments.length;
                for(i = 0; i < argLen; i++){
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for(key in arguments[0])if (hasOwnProp(arguments[0], key)) arg += key + ': ' + arguments[0][key] + ', ';
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else arg = arguments[i];
                    args.push(arg);
                }
                warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + new Error().stack);
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }
    var deprecations = {};
    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) hooks.deprecationHandler(name, msg);
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }
    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;
    function isFunction(input) {
        return typeof Function !== 'undefined' && input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
    }
    function set(config) {
        var prop, i;
        for(i in config)if (hasOwnProp(config, i)) {
            prop = config[i];
            if (isFunction(prop)) this[i] = prop;
            else this['_' + i] = prop;
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp((this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + '|' + /\d{1,2}/.source);
    }
    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig), prop;
        for(prop in childConfig)if (hasOwnProp(childConfig, prop)) {
            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                res[prop] = {};
                extend(res[prop], parentConfig[prop]);
                extend(res[prop], childConfig[prop]);
            } else if (childConfig[prop] != null) res[prop] = childConfig[prop];
            else delete res[prop];
        }
        for(prop in parentConfig)if (hasOwnProp(parentConfig, prop) && !hasOwnProp(childConfig, prop) && isObject(parentConfig[prop])) // make sure changes to properties don't modify parent config
        res[prop] = extend({}, res[prop]);
        return res;
    }
    function Locale(config) {
        if (config != null) this.set(config);
    }
    var keys;
    if (Object.keys) keys = Object.keys;
    else keys = function(obj) {
        var i, res = [];
        for(i in obj)if (hasOwnProp(obj, i)) res.push(i);
        return res;
    };
    var defaultCalendar = {
        sameDay: '[Today at] LT',
        nextDay: '[Tomorrow at] LT',
        nextWeek: 'dddd [at] LT',
        lastDay: '[Yesterday at] LT',
        lastWeek: '[Last] dddd [at] LT',
        sameElse: 'L'
    };
    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }
    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number), zerosToFill = targetLength - absNumber.length, sign = number >= 0;
        return (sign ? forceSign ? '+' : '' : '-') + Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }
    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g, localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, formatFunctions = {}, formatTokenFunctions = {};
    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') func = function() {
            return this[callback]();
        };
        if (token) formatTokenFunctions[token] = func;
        if (padded) formatTokenFunctions[padded[0]] = function() {
            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
        };
        if (ordinal) formatTokenFunctions[ordinal] = function() {
            return this.localeData().ordinal(func.apply(this, arguments), token);
        };
    }
    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) return input.replace(/^\[|\]$/g, '');
        return input.replace(/\\/g, '');
    }
    function makeFormatFunction(format) {
        var array = format.match(formattingTokens), i, length;
        for(i = 0, length = array.length; i < length; i++)if (formatTokenFunctions[array[i]]) array[i] = formatTokenFunctions[array[i]];
        else array[i] = removeFormattingTokens(array[i]);
        return function(mom) {
            var output = '', i;
            for(i = 0; i < length; i++)output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
            return output;
        };
    }
    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) return m.localeData().invalidDate();
        format = expandFormat(format, m.localeData());
        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
        return formatFunctions[format](m);
    }
    function expandFormat(format, locale) {
        var i = 5;
        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }
        localFormattingTokens.lastIndex = 0;
        while(i >= 0 && localFormattingTokens.test(format)){
            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }
        return format;
    }
    var defaultLongDateFormat = {
        LTS: 'h:mm:ss A',
        LT: 'h:mm A',
        L: 'MM/DD/YYYY',
        LL: 'MMMM D, YYYY',
        LLL: 'MMMM D, YYYY h:mm A',
        LLLL: 'dddd, MMMM D, YYYY h:mm A'
    };
    function longDateFormat(key) {
        var format = this._longDateFormat[key], formatUpper = this._longDateFormat[key.toUpperCase()];
        if (format || !formatUpper) return format;
        this._longDateFormat[key] = formatUpper.match(formattingTokens).map(function(tok) {
            if (tok === 'MMMM' || tok === 'MM' || tok === 'DD' || tok === 'dddd') return tok.slice(1);
            return tok;
        }).join('');
        return this._longDateFormat[key];
    }
    var defaultInvalidDate = 'Invalid date';
    function invalidDate() {
        return this._invalidDate;
    }
    var defaultOrdinal = '%d', defaultDayOfMonthOrdinalParse = /\d{1,2}/;
    function ordinal(number) {
        return this._ordinal.replace('%d', number);
    }
    var defaultRelativeTime = {
        future: 'in %s',
        past: '%s ago',
        s: 'a few seconds',
        ss: '%d seconds',
        m: 'a minute',
        mm: '%d minutes',
        h: 'an hour',
        hh: '%d hours',
        d: 'a day',
        dd: '%d days',
        w: 'a week',
        ww: '%d weeks',
        M: 'a month',
        MM: '%d months',
        y: 'a year',
        yy: '%d years'
    };
    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output) ? output(number, withoutSuffix, string, isFuture) : output.replace(/%d/i, number);
    }
    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }
    var aliases = {
        D: 'date',
        dates: 'date',
        date: 'date',
        d: 'day',
        days: 'day',
        day: 'day',
        e: 'weekday',
        weekdays: 'weekday',
        weekday: 'weekday',
        E: 'isoWeekday',
        isoweekdays: 'isoWeekday',
        isoweekday: 'isoWeekday',
        DDD: 'dayOfYear',
        dayofyears: 'dayOfYear',
        dayofyear: 'dayOfYear',
        h: 'hour',
        hours: 'hour',
        hour: 'hour',
        ms: 'millisecond',
        milliseconds: 'millisecond',
        millisecond: 'millisecond',
        m: 'minute',
        minutes: 'minute',
        minute: 'minute',
        M: 'month',
        months: 'month',
        month: 'month',
        Q: 'quarter',
        quarters: 'quarter',
        quarter: 'quarter',
        s: 'second',
        seconds: 'second',
        second: 'second',
        gg: 'weekYear',
        weekyears: 'weekYear',
        weekyear: 'weekYear',
        GG: 'isoWeekYear',
        isoweekyears: 'isoWeekYear',
        isoweekyear: 'isoWeekYear',
        w: 'week',
        weeks: 'week',
        week: 'week',
        W: 'isoWeek',
        isoweeks: 'isoWeek',
        isoweek: 'isoWeek',
        y: 'year',
        years: 'year',
        year: 'year'
    };
    function normalizeUnits(units) {
        return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }
    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {}, normalizedProp, prop;
        for(prop in inputObject)if (hasOwnProp(inputObject, prop)) {
            normalizedProp = normalizeUnits(prop);
            if (normalizedProp) normalizedInput[normalizedProp] = inputObject[prop];
        }
        return normalizedInput;
    }
    var priorities = {
        date: 9,
        day: 11,
        weekday: 11,
        isoWeekday: 11,
        dayOfYear: 4,
        hour: 13,
        millisecond: 16,
        minute: 14,
        month: 8,
        quarter: 7,
        second: 15,
        weekYear: 1,
        isoWeekYear: 1,
        week: 5,
        isoWeek: 5,
        year: 1
    };
    function getPrioritizedUnits(unitsObj) {
        var units = [], u;
        for(u in unitsObj)if (hasOwnProp(unitsObj, u)) units.push({
            unit: u,
            priority: priorities[u]
        });
        units.sort(function(a, b) {
            return a.priority - b.priority;
        });
        return units;
    }
    var match1 = /\d/, match2 = /\d\d/, match3 = /\d{3}/, match4 = /\d{4}/, match6 = /[+-]?\d{6}/, match1to2 = /\d\d?/, match3to4 = /\d\d\d\d?/, match5to6 = /\d\d\d\d\d\d?/, match1to3 = /\d{1,3}/, match1to4 = /\d{1,4}/, match1to6 = /[+-]?\d{1,6}/, matchUnsigned = /\d+/, matchSigned = /[+-]?\d+/, matchOffset = /Z|[+-]\d\d:?\d\d/gi, matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // any word (or two) characters or numbers including two/three word month in arabic.
    // includes scottish gaelic two word and hyphenated months
    matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i, match1to2NoLeadingZero = /^[1-9]\d?/, match1to2HasZero = /^([1-9]\d|\d)/, regexes;
    regexes = {};
    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex) ? regex : function(isStrict, localeData) {
            return isStrict && strictRegex ? strictRegex : regex;
        };
    }
    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) return new RegExp(unescapeFormat(token));
        return regexes[token](config._strict, config._locale);
    }
    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function(matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
        }));
    }
    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }
    function absFloor(number) {
        if (number < 0) // -0 -> 0
        return Math.ceil(number) || 0;
        else return Math.floor(number);
    }
    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion, value = 0;
        if (coercedNumber !== 0 && isFinite(coercedNumber)) value = absFloor(coercedNumber);
        return value;
    }
    var tokens = {};
    function addParseToken(token, callback) {
        var i, func = callback, tokenLen;
        if (typeof token === 'string') token = [
            token
        ];
        if (isNumber(callback)) func = function(input, array) {
            array[callback] = toInt(input);
        };
        tokenLen = token.length;
        for(i = 0; i < tokenLen; i++)tokens[token[i]] = func;
    }
    function addWeekParseToken(token, callback) {
        addParseToken(token, function(input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }
    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) tokens[token](input, config._a, config, token);
    }
    function isLeapYear(year) {
        return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
    }
    var YEAR = 0, MONTH = 1, DATE = 2, HOUR = 3, MINUTE = 4, SECOND = 5, MILLISECOND = 6, WEEK = 7, WEEKDAY = 8;
    // FORMATTING
    addFormatToken('Y', 0, 0, function() {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
    });
    addFormatToken(0, [
        'YY',
        2
    ], 0, function() {
        return this.year() % 100;
    });
    addFormatToken(0, [
        'YYYY',
        4
    ], 0, 'year');
    addFormatToken(0, [
        'YYYYY',
        5
    ], 0, 'year');
    addFormatToken(0, [
        'YYYYYY',
        6,
        true
    ], 0, 'year');
    // PARSING
    addRegexToken('Y', matchSigned);
    addRegexToken('YY', match1to2, match2);
    addRegexToken('YYYY', match1to4, match4);
    addRegexToken('YYYYY', match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);
    addParseToken([
        'YYYYY',
        'YYYYYY'
    ], YEAR);
    addParseToken('YYYY', function(input, array) {
        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function(input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function(input, array) {
        array[YEAR] = parseInt(input, 10);
    });
    // HELPERS
    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }
    // HOOKS
    hooks.parseTwoDigitYear = function(input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };
    // MOMENTS
    var getSetYear = makeGetSet('FullYear', true);
    function getIsLeapYear() {
        return isLeapYear(this.year());
    }
    function makeGetSet(unit, keepTime) {
        return function(value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else return get(this, unit);
        };
    }
    function get(mom, unit) {
        if (!mom.isValid()) return NaN;
        var d = mom._d, isUTC = mom._isUTC;
        switch(unit){
            case 'Milliseconds':
                return isUTC ? d.getUTCMilliseconds() : d.getMilliseconds();
            case 'Seconds':
                return isUTC ? d.getUTCSeconds() : d.getSeconds();
            case 'Minutes':
                return isUTC ? d.getUTCMinutes() : d.getMinutes();
            case 'Hours':
                return isUTC ? d.getUTCHours() : d.getHours();
            case 'Date':
                return isUTC ? d.getUTCDate() : d.getDate();
            case 'Day':
                return isUTC ? d.getUTCDay() : d.getDay();
            case 'Month':
                return isUTC ? d.getUTCMonth() : d.getMonth();
            case 'FullYear':
                return isUTC ? d.getUTCFullYear() : d.getFullYear();
            default:
                return NaN; // Just in case
        }
    }
    function set$1(mom, unit, value) {
        var d, isUTC, year, month, date;
        if (!mom.isValid() || isNaN(value)) return;
        d = mom._d;
        isUTC = mom._isUTC;
        switch(unit){
            case 'Milliseconds':
                return void (isUTC ? d.setUTCMilliseconds(value) : d.setMilliseconds(value));
            case 'Seconds':
                return void (isUTC ? d.setUTCSeconds(value) : d.setSeconds(value));
            case 'Minutes':
                return void (isUTC ? d.setUTCMinutes(value) : d.setMinutes(value));
            case 'Hours':
                return void (isUTC ? d.setUTCHours(value) : d.setHours(value));
            case 'Date':
                return void (isUTC ? d.setUTCDate(value) : d.setDate(value));
            // case 'Day': // Not real
            //    return void (isUTC ? d.setUTCDay(value) : d.setDay(value));
            // case 'Month': // Not used because we need to pass two variables
            //     return void (isUTC ? d.setUTCMonth(value) : d.setMonth(value));
            case 'FullYear':
                break; // See below ...
            default:
                return; // Just in case
        }
        year = value;
        month = mom.month();
        date = mom.date();
        date = date === 29 && month === 1 && !isLeapYear(year) ? 28 : date;
        isUTC ? d.setUTCFullYear(year, month, date) : d.setFullYear(year, month, date);
    }
    // MOMENTS
    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) return this[units]();
        return this;
    }
    function stringSet(units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units), i, prioritizedLen = prioritized.length;
            for(i = 0; i < prioritizedLen; i++)this[prioritized[i].unit](units[prioritized[i].unit]);
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) return this[units](value);
        }
        return this;
    }
    function mod(n, x) {
        return (n % x + x) % x;
    }
    var indexOf;
    if (Array.prototype.indexOf) indexOf = Array.prototype.indexOf;
    else indexOf = function(o) {
        // I know
        var i;
        for(i = 0; i < this.length; ++i){
            if (this[i] === o) return i;
        }
        return -1;
    };
    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) return NaN;
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1 ? isLeapYear(year) ? 29 : 28 : 31 - modMonth % 7 % 2;
    }
    // FORMATTING
    addFormatToken('M', [
        'MM',
        2
    ], 'Mo', function() {
        return this.month() + 1;
    });
    addFormatToken('MMM', 0, 0, function(format) {
        return this.localeData().monthsShort(this, format);
    });
    addFormatToken('MMMM', 0, 0, function(format) {
        return this.localeData().months(this, format);
    });
    // PARSING
    addRegexToken('M', match1to2, match1to2NoLeadingZero);
    addRegexToken('MM', match1to2, match2);
    addRegexToken('MMM', function(isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function(isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });
    addParseToken([
        'M',
        'MM'
    ], function(input, array) {
        array[MONTH] = toInt(input) - 1;
    });
    addParseToken([
        'MMM',
        'MMMM'
    ], function(input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) array[MONTH] = month;
        else getParsingFlags(config).invalidMonth = input;
    });
    // LOCALES
    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'), defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'), MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/, defaultMonthsShortRegex = matchWord, defaultMonthsRegex = matchWord;
    function localeMonths(m, format) {
        if (!m) return isArray(this._months) ? this._months : this._months['standalone'];
        return isArray(this._months) ? this._months[m.month()] : this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
    }
    function localeMonthsShort(m, format) {
        if (!m) return isArray(this._monthsShort) ? this._monthsShort : this._monthsShort['standalone'];
        return isArray(this._monthsShort) ? this._monthsShort[m.month()] : this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
    }
    function handleStrictParse(monthName, format, strict) {
        var i, ii, mom, llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for(i = 0; i < 12; ++i){
                mom = createUTC([
                    2000,
                    i
                ]);
                this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else if (format === 'MMM') {
            ii = indexOf.call(this._shortMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._longMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;
        if (this._monthsParseExact) return handleStrictParse.call(this, monthName, format, strict);
        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }
        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
            }
            if (!strict && !this._monthsParse[i]) {
                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) return i;
            else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) return i;
            else if (!strict && this._monthsParse[i].test(monthName)) return i;
        }
    }
    // MOMENTS
    function setMonth(mom, value) {
        if (!mom.isValid()) // No op
        return mom;
        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) value = toInt(value);
            else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) return mom;
            }
        }
        var month = value, date = mom.date();
        date = date < 29 ? date : Math.min(date, daysInMonth(mom.year(), month));
        mom._isUTC ? mom._d.setUTCMonth(month, date) : mom._d.setMonth(month, date);
        return mom;
    }
    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else return get(this, 'Month');
    }
    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }
    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) computeMonthsParse.call(this);
            if (isStrict) return this._monthsShortStrictRegex;
            else return this._monthsShortRegex;
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) this._monthsShortRegex = defaultMonthsShortRegex;
            return this._monthsShortStrictRegex && isStrict ? this._monthsShortStrictRegex : this._monthsShortRegex;
        }
    }
    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) computeMonthsParse.call(this);
            if (isStrict) return this._monthsStrictRegex;
            else return this._monthsRegex;
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) this._monthsRegex = defaultMonthsRegex;
            return this._monthsStrictRegex && isStrict ? this._monthsStrictRegex : this._monthsRegex;
        }
    }
    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var shortPieces = [], longPieces = [], mixedPieces = [], i, mom, shortP, longP;
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            shortP = regexEscape(this.monthsShort(mom, ''));
            longP = regexEscape(this.months(mom, ''));
            shortPieces.push(shortP);
            longPieces.push(longP);
            mixedPieces.push(longP);
            mixedPieces.push(shortP);
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    }
    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) date.setFullYear(y);
        } else date = new Date(y, m, d, h, M, s, ms);
        return date;
    }
    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) date.setUTCFullYear(y);
        } else date = new Date(Date.UTC.apply(null, arguments));
        return date;
    }
    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var fwd = 7 + dow - doy, // first-week day local weekday -- which local weekday is fwd
        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
        return -fwdlw + fwd - 1;
    }
    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7, weekOffset = firstWeekOffset(year, dow, doy), dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset, resYear, resDayOfYear;
        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }
        return {
            year: resYear,
            dayOfYear: resDayOfYear
        };
    }
    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy), week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1, resWeek, resYear;
        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }
        return {
            week: resWeek,
            year: resYear
        };
    }
    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy), weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }
    // FORMATTING
    addFormatToken('w', [
        'ww',
        2
    ], 'wo', 'week');
    addFormatToken('W', [
        'WW',
        2
    ], 'Wo', 'isoWeek');
    // PARSING
    addRegexToken('w', match1to2, match1to2NoLeadingZero);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W', match1to2, match1to2NoLeadingZero);
    addRegexToken('WW', match1to2, match2);
    addWeekParseToken([
        'w',
        'ww',
        'W',
        'WW'
    ], function(input, week, config, token) {
        week[token.substr(0, 1)] = toInt(input);
    });
    // HELPERS
    // LOCALES
    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }
    var defaultLocaleWeek = {
        dow: 0,
        doy: 6
    };
    function localeFirstDayOfWeek() {
        return this._week.dow;
    }
    function localeFirstDayOfYear() {
        return this._week.doy;
    }
    // MOMENTS
    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }
    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }
    // FORMATTING
    addFormatToken('d', 0, 'do', 'day');
    addFormatToken('dd', 0, 0, function(format) {
        return this.localeData().weekdaysMin(this, format);
    });
    addFormatToken('ddd', 0, 0, function(format) {
        return this.localeData().weekdaysShort(this, format);
    });
    addFormatToken('dddd', 0, 0, function(format) {
        return this.localeData().weekdays(this, format);
    });
    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');
    // PARSING
    addRegexToken('d', match1to2);
    addRegexToken('e', match1to2);
    addRegexToken('E', match1to2);
    addRegexToken('dd', function(isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd', function(isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd', function(isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });
    addWeekParseToken([
        'dd',
        'ddd',
        'dddd'
    ], function(input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) week.d = weekday;
        else getParsingFlags(config).invalidWeekday = input;
    });
    addWeekParseToken([
        'd',
        'e',
        'E'
    ], function(input, week, config, token) {
        week[token] = toInt(input);
    });
    // HELPERS
    function parseWeekday(input, locale) {
        if (typeof input !== 'string') return input;
        if (!isNaN(input)) return parseInt(input, 10);
        input = locale.weekdaysParse(input);
        if (typeof input === 'number') return input;
        return null;
    }
    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') return locale.weekdaysParse(input) % 7 || 7;
        return isNaN(input) ? null : input;
    }
    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }
    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'), defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'), defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'), defaultWeekdaysRegex = matchWord, defaultWeekdaysShortRegex = matchWord, defaultWeekdaysMinRegex = matchWord;
    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays) ? this._weekdays : this._weekdays[m && m !== true && this._weekdays.isFormat.test(format) ? 'format' : 'standalone'];
        return m === true ? shiftWeekdays(weekdays, this._week.dow) : m ? weekdays[m.day()] : weekdays;
    }
    function localeWeekdaysShort(m) {
        return m === true ? shiftWeekdays(this._weekdaysShort, this._week.dow) : m ? this._weekdaysShort[m.day()] : this._weekdaysShort;
    }
    function localeWeekdaysMin(m) {
        return m === true ? shiftWeekdays(this._weekdaysMin, this._week.dow) : m ? this._weekdaysMin[m.day()] : this._weekdaysMin;
    }
    function handleStrictParse$1(weekdayName, format, strict) {
        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];
            for(i = 0; i < 7; ++i){
                mom = createUTC([
                    2000,
                    1
                ]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }
    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;
        if (this._weekdaysParseExact) return handleStrictParse$1.call(this, weekdayName, format, strict);
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\\.?') + '$', 'i');
                this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$', 'i');
                this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$', 'i');
            }
            if (!this._weekdaysParse[i]) {
                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) return i;
            else if (!strict && this._weekdaysParse[i].test(weekdayName)) return i;
        }
    }
    // MOMENTS
    function getSetDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var day = get(this, 'Day');
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else return day;
    }
    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }
    function getSetISODayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.
        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else return this.day() || 7;
    }
    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysStrictRegex;
            else return this._weekdaysRegex;
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) this._weekdaysRegex = defaultWeekdaysRegex;
            return this._weekdaysStrictRegex && isStrict ? this._weekdaysStrictRegex : this._weekdaysRegex;
        }
    }
    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysShortStrictRegex;
            else return this._weekdaysShortRegex;
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            return this._weekdaysShortStrictRegex && isStrict ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
        }
    }
    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysMinStrictRegex;
            else return this._weekdaysMinRegex;
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            return this._weekdaysMinStrictRegex && isStrict ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
        }
    }
    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [], i, mom, minp, shortp, longp;
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ''));
            shortp = regexEscape(this.weekdaysShort(mom, ''));
            longp = regexEscape(this.weekdays(mom, ''));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;
        this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
        this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
    }
    // FORMATTING
    function hFormat() {
        return this.hours() % 12 || 12;
    }
    function kFormat() {
        return this.hours() || 24;
    }
    addFormatToken('H', [
        'HH',
        2
    ], 0, 'hour');
    addFormatToken('h', [
        'hh',
        2
    ], 0, hFormat);
    addFormatToken('k', [
        'kk',
        2
    ], 0, kFormat);
    addFormatToken('hmm', 0, 0, function() {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });
    addFormatToken('hmmss', 0, 0, function() {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    addFormatToken('Hmm', 0, 0, function() {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });
    addFormatToken('Hmmss', 0, 0, function() {
        return '' + this.hours() + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function() {
            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
        });
    }
    meridiem('a', true);
    meridiem('A', false);
    // PARSING
    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }
    addRegexToken('a', matchMeridiem);
    addRegexToken('A', matchMeridiem);
    addRegexToken('H', match1to2, match1to2HasZero);
    addRegexToken('h', match1to2, match1to2NoLeadingZero);
    addRegexToken('k', match1to2, match1to2NoLeadingZero);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);
    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);
    addParseToken([
        'H',
        'HH'
    ], HOUR);
    addParseToken([
        'k',
        'kk'
    ], function(input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken([
        'a',
        'A'
    ], function(input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken([
        'h',
        'hh'
    ], function(input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });
    // LOCALES
    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + '').toLowerCase().charAt(0) === 'p';
    }
    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i, // Setting the hour should keep the time, because the user explicitly
    // specified which hour they want. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    getSetHour = makeGetSet('Hours', true);
    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) return isLower ? 'pm' : 'PM';
        else return isLower ? 'am' : 'AM';
    }
    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,
        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,
        week: defaultLocaleWeek,
        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,
        meridiemParse: defaultLocaleMeridiemParse
    };
    // internal storage for locale config files
    var locales = {}, localeFamilies = {}, globalLocale;
    function commonPrefix(arr1, arr2) {
        var i, minl = Math.min(arr1.length, arr2.length);
        for(i = 0; i < minl; i += 1){
            if (arr1[i] !== arr2[i]) return i;
        }
        return minl;
    }
    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }
    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0, j, next, locale, split;
        while(i < names.length){
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while(j > 0){
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) return locale;
                if (next && next.length >= j && commonPrefix(split, next) >= j - 1) break;
                j--;
            }
            i++;
        }
        return globalLocale;
    }
    function isLocaleNameSane(name) {
        // Prevent names that look like filesystem paths, i.e contain '/' or '\'
        // Ensure name is available and function returns boolean
        return !!(name && name.match('^[^/\\\\]*$'));
    }
    function loadLocale(name) {
        var oldLocale = null, aliasedRequire;
        // TODO: Find a better way to register and load all the locales in Node
        if (locales[name] === undefined && true && module && module.exports && isLocaleNameSane(name)) try {
            oldLocale = globalLocale._abbr;
            aliasedRequire = undefined;
            aliasedRequire('./locale/' + name);
            getSetGlobalLocale(oldLocale);
        } catch (e) {
            // mark as not found to avoid repeating expensive file require call causing high CPU
            // when trying to find en-US, en_US, en-us for every format call
            locales[name] = null; // null means not found
        }
        return locales[name];
    }
    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) data = getLocale(key);
            else data = defineLocale(key, values);
            if (data) // moment.duration._locale = moment._locale = data;
            globalLocale = data;
            else if (typeof console !== 'undefined' && console.warn) //warn user if arguments are passed but the locale could not be set
            console.warn('Locale ' + key + ' not found. Did you forget to load it?');
        }
        return globalLocale._abbr;
    }
    function defineLocale(name, config) {
        if (config !== null) {
            var locale, parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple('defineLocaleOverride', "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info.");
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) parentConfig = locales[config.parentLocale]._config;
                else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) parentConfig = locale._config;
                    else {
                        if (!localeFamilies[config.parentLocale]) localeFamilies[config.parentLocale] = [];
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));
            if (localeFamilies[name]) localeFamilies[name].forEach(function(x) {
                defineLocale(x.name, x.config);
            });
            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);
            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }
    function updateLocale(name, config) {
        if (config != null) {
            var locale, tmpLocale, parentConfig = baseConfig;
            if (locales[name] != null && locales[name].parentLocale != null) // Update existing child locale in-place to avoid memory-leaks
            locales[name].set(mergeConfigs(locales[name]._config, config));
            else {
                // MERGE
                tmpLocale = loadLocale(name);
                if (tmpLocale != null) parentConfig = tmpLocale._config;
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) // updateLocale is called for creating a new locale
                // Set abbr so it will have a name (getters return
                // undefined otherwise).
                config.abbr = name;
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }
            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else // pass null for config to unupdate, useful for tests
        if (locales[name] != null) {
            if (locales[name].parentLocale != null) {
                locales[name] = locales[name].parentLocale;
                if (name === getSetGlobalLocale()) getSetGlobalLocale(name);
            } else if (locales[name] != null) delete locales[name];
        }
        return locales[name];
    }
    // returns locale data
    function getLocale(key) {
        var locale;
        if (key && key._locale && key._locale._abbr) key = key._locale._abbr;
        if (!key) return globalLocale;
        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) return locale;
            key = [
                key
            ];
        }
        return chooseLocale(key);
    }
    function listLocales() {
        return keys(locales);
    }
    function checkOverflow(m) {
        var overflow, a = m._a;
        if (a && getParsingFlags(m).overflow === -2) {
            overflow = a[MONTH] < 0 || a[MONTH] > 11 ? MONTH : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH]) ? DATE : a[HOUR] < 0 || a[HOUR] > 24 || a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0) ? HOUR : a[MINUTE] < 0 || a[MINUTE] > 59 ? MINUTE : a[SECOND] < 0 || a[SECOND] > 59 ? SECOND : a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND : -1;
            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) overflow = DATE;
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) overflow = WEEK;
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) overflow = WEEKDAY;
            getParsingFlags(m).overflow = overflow;
        }
        return m;
    }
    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, tzRegex = /Z|[+-]\d\d(?::?\d\d)?/, isoDates = [
        [
            'YYYYYY-MM-DD',
            /[+-]\d{6}-\d\d-\d\d/
        ],
        [
            'YYYY-MM-DD',
            /\d{4}-\d\d-\d\d/
        ],
        [
            'GGGG-[W]WW-E',
            /\d{4}-W\d\d-\d/
        ],
        [
            'GGGG-[W]WW',
            /\d{4}-W\d\d/,
            false
        ],
        [
            'YYYY-DDD',
            /\d{4}-\d{3}/
        ],
        [
            'YYYY-MM',
            /\d{4}-\d\d/,
            false
        ],
        [
            'YYYYYYMMDD',
            /[+-]\d{10}/
        ],
        [
            'YYYYMMDD',
            /\d{8}/
        ],
        [
            'GGGG[W]WWE',
            /\d{4}W\d{3}/
        ],
        [
            'GGGG[W]WW',
            /\d{4}W\d{2}/,
            false
        ],
        [
            'YYYYDDD',
            /\d{7}/
        ],
        [
            'YYYYMM',
            /\d{6}/,
            false
        ],
        [
            'YYYY',
            /\d{4}/,
            false
        ]
    ], // iso time formats and regexes
    isoTimes = [
        [
            'HH:mm:ss.SSSS',
            /\d\d:\d\d:\d\d\.\d+/
        ],
        [
            'HH:mm:ss,SSSS',
            /\d\d:\d\d:\d\d,\d+/
        ],
        [
            'HH:mm:ss',
            /\d\d:\d\d:\d\d/
        ],
        [
            'HH:mm',
            /\d\d:\d\d/
        ],
        [
            'HHmmss.SSSS',
            /\d\d\d\d\d\d\.\d+/
        ],
        [
            'HHmmss,SSSS',
            /\d\d\d\d\d\d,\d+/
        ],
        [
            'HHmmss',
            /\d\d\d\d\d\d/
        ],
        [
            'HHmm',
            /\d\d\d\d/
        ],
        [
            'HH',
            /\d\d/
        ]
    ], aspNetJsonRegex = /^\/?Date\((-?\d+)/i, // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
    rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/, obsOffsets = {
        UT: 0,
        GMT: 0,
        EDT: -240,
        EST: -300,
        CDT: -300,
        CST: -360,
        MDT: -360,
        MST: -420,
        PDT: -420,
        PST: -480
    };
    // date from iso format
    function configFromISO(config) {
        var i, l, string = config._i, match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string), allowTime, dateFormat, timeFormat, tzFormat, isoDatesLen = isoDates.length, isoTimesLen = isoTimes.length;
        if (match) {
            getParsingFlags(config).iso = true;
            for(i = 0, l = isoDatesLen; i < l; i++)if (isoDates[i][1].exec(match[1])) {
                dateFormat = isoDates[i][0];
                allowTime = isoDates[i][2] !== false;
                break;
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for(i = 0, l = isoTimesLen; i < l; i++)if (isoTimes[i][1].exec(match[3])) {
                    // match[2] should be 'T' or space
                    timeFormat = (match[2] || ' ') + isoTimes[i][0];
                    break;
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) tzFormat = 'Z';
                else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else config._isValid = false;
    }
    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10)
        ];
        if (secondStr) result.push(parseInt(secondStr, 10));
        return result;
    }
    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) return 2000 + year;
        else if (year <= 999) return 1900 + year;
        return year;
    }
    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s.replace(/\([^()]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').replace(/^\s\s*/, '').replace(/\s\s*$/, '');
    }
    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr), weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }
    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) return obsOffsets[obsOffset];
        else if (militaryOffset) // the only allowed military tz is Z
        return 0;
        else {
            var hm = parseInt(numOffset, 10), m = hm % 100, h = (hm - m) / 100;
            return h * 60 + m;
        }
    }
    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)), parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
            if (!checkWeekday(match[1], parsedArray, config)) return;
            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);
            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
            getParsingFlags(config).rfc2822 = true;
        } else config._isValid = false;
    }
    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }
        configFromISO(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        configFromRFC2822(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        if (config._strict) config._isValid = false;
        else // Final attempt, use Input Fallback
        hooks.createFromInputFallback(config);
    }
    hooks.createFromInputFallback = deprecate("value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.", function(config) {
        config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
    });
    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) return a;
        if (b != null) return b;
        return c;
    }
    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) return [
            nowValue.getUTCFullYear(),
            nowValue.getUTCMonth(),
            nowValue.getUTCDate()
        ];
        return [
            nowValue.getFullYear(),
            nowValue.getMonth(),
            nowValue.getDate()
        ];
    }
    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i, date, input = [], currentDate, expectedWeekday, yearToUse;
        if (config._d) return;
        currentDate = currentDateArray(config);
        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) dayOfYearFromWeekInfo(config);
        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) getParsingFlags(config)._overflowDayOfYear = true;
            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }
        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for(i = 0; i < 3 && config._a[i] == null; ++i)config._a[i] = input[i] = currentDate[i];
        // Zero out whatever was not defaulted, including time
        for(; i < 7; i++)config._a[i] = input[i] = config._a[i] == null ? i === 2 ? 1 : 0 : config._a[i];
        // Check for 24:00:00.000
        if (config._a[HOUR] === 24 && config._a[MINUTE] === 0 && config._a[SECOND] === 0 && config._a[MILLISECOND] === 0) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }
        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();
        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        if (config._nextDay) config._a[HOUR] = 24;
        // check for mismatching day of week
        if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) getParsingFlags(config).weekdayMismatch = true;
    }
    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;
        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;
            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) weekdayOverflow = true;
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;
            curWeek = weekOfYear(createLocal(), dow, doy);
            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
            // Default to current week.
            week = defaults(w.w, curWeek.week);
            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) weekdayOverflow = true;
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) weekdayOverflow = true;
            } else // default to beginning of week
            weekday = dow;
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) getParsingFlags(config)._overflowWeeks = true;
        else if (weekdayOverflow != null) getParsingFlags(config)._overflowWeekday = true;
        else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }
    // constant that refers to the ISO standard
    hooks.ISO_8601 = function() {};
    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function() {};
    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;
        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i, i, parsedInput, tokens, token, skipped, stringLength = string.length, totalParsedInputLength = 0, era, tokenLen;
        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
        tokenLen = tokens.length;
        for(i = 0; i < tokenLen; i++){
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) getParsingFlags(config).unusedInput.push(skipped);
                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) getParsingFlags(config).empty = false;
                else getParsingFlags(config).unusedTokens.push(token);
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) getParsingFlags(config).unusedTokens.push(token);
        }
        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
        if (string.length > 0) getParsingFlags(config).unusedInput.push(string);
        // clear _12h flag if hour is <= 12
        if (config._a[HOUR] <= 12 && getParsingFlags(config).bigHour === true && config._a[HOUR] > 0) getParsingFlags(config).bigHour = undefined;
        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        configFromArray(config);
        checkOverflow(config);
    }
    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;
        if (meridiem == null) // nothing to do
        return hour;
        if (locale.meridiemHour != null) return locale.meridiemHour(hour, meridiem);
        else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) hour += 12;
            if (!isPm && hour === 12) hour = 0;
            return hour;
        } else // this is not supposed to happen
        return hour;
    }
    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig, bestMoment, scoreToBeat, i, currentScore, validFormatFound, bestFormatIsValid = false, configfLen = config._f.length;
        if (configfLen === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }
        for(i = 0; i < configfLen; i++){
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) tempConfig._useUTC = config._useUTC;
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);
            if (isValid(tempConfig)) validFormatFound = true;
            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;
            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
            getParsingFlags(tempConfig).score = currentScore;
            if (!bestFormatIsValid) {
                if (scoreToBeat == null || currentScore < scoreToBeat || validFormatFound) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) bestFormatIsValid = true;
                }
            } else if (currentScore < scoreToBeat) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
            }
        }
        extend(config, bestMoment || tempConfig);
    }
    function configFromObject(config) {
        if (config._d) return;
        var i = normalizeObjectUnits(config._i), dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map([
            i.year,
            i.month,
            dayOrDate,
            i.hour,
            i.minute,
            i.second,
            i.millisecond
        ], function(obj) {
            return obj && parseInt(obj, 10);
        });
        configFromArray(config);
    }
    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }
        return res;
    }
    function prepareConfig(config) {
        var input = config._i, format = config._f;
        config._locale = config._locale || getLocale(config._l);
        if (input === null || format === undefined && input === '') return createInvalid({
            nullInput: true
        });
        if (typeof input === 'string') config._i = input = config._locale.preparse(input);
        if (isMoment(input)) return new Moment(checkOverflow(input));
        else if (isDate(input)) config._d = input;
        else if (isArray(format)) configFromStringAndArray(config);
        else if (format) configFromStringAndFormat(config);
        else configFromInput(config);
        if (!isValid(config)) config._d = null;
        return config;
    }
    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) config._d = new Date(hooks.now());
        else if (isDate(input)) config._d = new Date(input.valueOf());
        else if (typeof input === 'string') configFromString(config);
        else if (isArray(input)) {
            config._a = map(input.slice(0), function(obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) configFromObject(config);
        else if (isNumber(input)) // from milliseconds
        config._d = new Date(input);
        else hooks.createFromInputFallback(config);
    }
    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};
        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }
        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }
        if (isObject(input) && isObjectEmpty(input) || isArray(input) && input.length === 0) input = undefined;
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;
        return createFromConfig(c);
    }
    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }
    var prototypeMin = deprecate('moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/', function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other < this ? this : other;
        else return createInvalid();
    }), prototypeMax = deprecate('moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/', function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other > this ? this : other;
        else return createInvalid();
    });
    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) moments = moments[0];
        if (!moments.length) return createLocal();
        res = moments[0];
        for(i = 1; i < moments.length; ++i)if (!moments[i].isValid() || moments[i][fn](res)) res = moments[i];
        return res;
    }
    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);
        return pickBy('isBefore', args);
    }
    function max() {
        var args = [].slice.call(arguments, 0);
        return pickBy('isAfter', args);
    }
    var now = function() {
        return Date.now ? Date.now() : +new Date();
    };
    var ordering = [
        'year',
        'quarter',
        'month',
        'week',
        'day',
        'hour',
        'minute',
        'second',
        'millisecond'
    ];
    function isDurationValid(m) {
        var key, unitHasDecimal = false, i, orderLen = ordering.length;
        for(key in m){
            if (hasOwnProp(m, key) && !(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) return false;
        }
        for(i = 0; i < orderLen; ++i)if (m[ordering[i]]) {
            if (unitHasDecimal) return false; // only allow non-integers for smallest unit
            if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) unitHasDecimal = true;
        }
        return true;
    }
    function isValid$1() {
        return this._isValid;
    }
    function createInvalid$1() {
        return createDuration(NaN);
    }
    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration), years = normalizedInput.year || 0, quarters = normalizedInput.quarter || 0, months = normalizedInput.month || 0, weeks = normalizedInput.week || normalizedInput.isoWeek || 0, days = normalizedInput.day || 0, hours = normalizedInput.hour || 0, minutes = normalizedInput.minute || 0, seconds = normalizedInput.second || 0, milliseconds = normalizedInput.millisecond || 0;
        this._isValid = isDurationValid(normalizedInput);
        // representation for dateAddRemove
        this._milliseconds = +milliseconds + seconds * 1e3 + // 1000
        minutes * 6e4 + // 1000 * 60
        hours * 3600000; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;
        this._data = {};
        this._locale = getLocale();
        this._bubble();
    }
    function isDuration(obj) {
        return obj instanceof Duration;
    }
    function absRound(number) {
        if (number < 0) return Math.round(-1 * number) * -1;
        else return Math.round(number);
    }
    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length), lengthDiff = Math.abs(array1.length - array2.length), diffs = 0, i;
        for(i = 0; i < len; i++)if (dontConvert && array1[i] !== array2[i] || !dontConvert && toInt(array1[i]) !== toInt(array2[i])) diffs++;
        return diffs + lengthDiff;
    }
    // FORMATTING
    function offset(token, separator) {
        addFormatToken(token, 0, 0, function() {
            var offset = this.utcOffset(), sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~offset % 60, 2);
        });
    }
    offset('Z', ':');
    offset('ZZ', '');
    // PARSING
    addRegexToken('Z', matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken([
        'Z',
        'ZZ'
    ], function(input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });
    // HELPERS
    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;
    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher), chunk, parts, minutes;
        if (matches === null) return null;
        chunk = matches[matches.length - 1] || [];
        parts = (chunk + '').match(chunkOffset) || [
            '-',
            0,
            0
        ];
        minutes = +(parts[1] * 60) + toInt(parts[2]);
        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
    }
    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else return createLocal(input).local();
    }
    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }
    // HOOKS
    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function() {};
    // MOMENTS
    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0, localAdjust;
        if (!this.isValid()) return input != null ? this : NaN;
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) return this;
            } else if (Math.abs(input) < 16 && !keepMinutes) input = input * 60;
            if (!this._isUTC && keepLocalTime) localAdjust = getDateOffset(this);
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) this.add(localAdjust, 'm');
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) addSubtract(this, createDuration(input - offset, 'm'), 1, false);
                else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else return this._isUTC ? offset : getDateOffset(this);
    }
    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') input = -input;
            this.utcOffset(input, keepLocalTime);
            return this;
        } else return -this.utcOffset();
    }
    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }
    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;
            if (keepLocalTime) this.subtract(getDateOffset(this), 'm');
        }
        return this;
    }
    function setOffsetToParsedOffset() {
        if (this._tzm != null) this.utcOffset(this._tzm, false, true);
        else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) this.utcOffset(tZone);
            else this.utcOffset(0, true);
        }
        return this;
    }
    function hasAlignedHourOffset(input) {
        if (!this.isValid()) return false;
        input = input ? createLocal(input).utcOffset() : 0;
        return (this.utcOffset() - input) % 60 === 0;
    }
    function isDaylightSavingTime() {
        return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
    }
    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) return this._isDSTShifted;
        var c = {}, other;
        copyConfig(c, this);
        c = prepareConfig(c);
        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted = this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else this._isDSTShifted = false;
        return this._isDSTShifted;
    }
    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }
    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }
    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }
    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/, // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    // and further modified to allow for strings containing both week and day
    isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
    function createDuration(input, key) {
        var duration = input, // matching against regexp is expensive, do it on demand
        match = null, sign, ret, diffRes;
        if (isDuration(input)) duration = {
            ms: input._milliseconds,
            d: input._days,
            M: input._months
        };
        else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) duration[key] = +input;
            else duration.milliseconds = +input;
        } else if (match = aspNetRegex.exec(input)) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign
            };
        } else if (match = isoRegex.exec(input)) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign)
            };
        } else if (duration == null) // checks for null or undefined
        duration = {};
        else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }
        ret = new Duration(duration);
        if (isDuration(input) && hasOwnProp(input, '_locale')) ret._locale = input._locale;
        if (isDuration(input) && hasOwnProp(input, '_isValid')) ret._isValid = input._isValid;
        return ret;
    }
    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;
    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }
    function positiveMomentsDifference(base, other) {
        var res = {};
        res.months = other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) --res.months;
        res.milliseconds = +other - +base.clone().add(res.months, 'M');
        return res;
    }
    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) return {
            milliseconds: 0,
            months: 0
        };
        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) res = positiveMomentsDifference(base, other);
        else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }
        return res;
    }
    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function(val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(name, 'moment().' + name + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' + 'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
                tmp = val;
                val = period;
                period = tmp;
            }
            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }
    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds, days = absRound(duration._days), months = absRound(duration._months);
        if (!mom.isValid()) // No op
        return;
        updateOffset = updateOffset == null ? true : updateOffset;
        if (months) setMonth(mom, get(mom, 'Month') + months * isAdding);
        if (days) set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        if (milliseconds) mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        if (updateOffset) hooks.updateOffset(mom, days || months);
    }
    var add = createAdder(1, 'add'), subtract = createAdder(-1, 'subtract');
    function isString(input) {
        return typeof input === 'string' || input instanceof String;
    }
    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return isMoment(input) || isDate(input) || isString(input) || isNumber(input) || isNumberOrStringArray(input) || isMomentInputObject(input) || input === null || input === undefined;
    }
    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            'years',
            'year',
            'y',
            'months',
            'month',
            'M',
            'days',
            'day',
            'd',
            'dates',
            'date',
            'D',
            'hours',
            'hour',
            'h',
            'minutes',
            'minute',
            'm',
            'seconds',
            'second',
            's',
            'milliseconds',
            'millisecond',
            'ms'
        ], i, property, propertyLen = properties.length;
        for(i = 0; i < propertyLen; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input), dataTypeTest = false;
        if (arrayTest) dataTypeTest = input.filter(function(item) {
            return !isNumber(item) && isString(input);
        }).length === 0;
        return arrayTest && dataTypeTest;
    }
    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            'sameDay',
            'nextDay',
            'lastDay',
            'nextWeek',
            'lastWeek',
            'sameElse'
        ], i, property;
        for(i = 0; i < properties.length; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6 ? 'sameElse' : diff < -1 ? 'lastWeek' : diff < 0 ? 'lastDay' : diff < 1 ? 'sameDay' : diff < 2 ? 'nextDay' : diff < 7 ? 'nextWeek' : 'sameElse';
    }
    function calendar$1(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (!arguments[0]) {
                time = undefined;
                formats = undefined;
            } else if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(), sod = cloneWithOffset(now, this).startOf('day'), format = hooks.calendarFormat(this, sod) || 'sameElse', output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
    }
    function clone() {
        return new Moment(this);
    }
    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') return this.valueOf() > localInput.valueOf();
        else return localInput.valueOf() < this.clone().startOf(units).valueOf();
    }
    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') return this.valueOf() < localInput.valueOf();
        else return this.clone().endOf(units).valueOf() < localInput.valueOf();
    }
    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from), localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) return false;
        inclusivity = inclusivity || '()';
        return (inclusivity[0] === '(' ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) && (inclusivity[1] === ')' ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
    }
    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input), inputMs;
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') return this.valueOf() === localInput.valueOf();
        else {
            inputMs = localInput.valueOf();
            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
        }
    }
    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }
    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }
    function diff(input, units, asFloat) {
        var that, zoneDelta, output;
        if (!this.isValid()) return NaN;
        that = cloneWithOffset(input, this);
        if (!that.isValid()) return NaN;
        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
        units = normalizeUnits(units);
        switch(units){
            case 'year':
                output = monthDiff(this, that) / 12;
                break;
            case 'month':
                output = monthDiff(this, that);
                break;
            case 'quarter':
                output = monthDiff(this, that) / 3;
                break;
            case 'second':
                output = (this - that) / 1e3;
                break; // 1000
            case 'minute':
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case 'hour':
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case 'day':
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case 'week':
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }
        return asFloat ? output : absFloor(output);
    }
    function monthDiff(a, b) {
        if (a.date() < b.date()) // end-of-month calculations work correct when the start month has more
        // days than the end month.
        return -monthDiff(b, a);
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()), // b is in (anchor - 1 month, anchor + 1 month)
        anchor = a.clone().add(wholeMonthDiff, 'months'), anchor2, adjust;
        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }
        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }
    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
    function toString() {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }
    function toISOString(keepOffset) {
        if (!this.isValid()) return null;
        var utc = keepOffset !== true, m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) return this.toDate().toISOString();
            else return new Date(this.valueOf() + this.utcOffset() * 60000).toISOString().replace('Z', formatMoment(m, 'Z'));
        }
        return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
    }
    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */ function inspect() {
        if (!this.isValid()) return 'moment.invalid(/* ' + this._i + ' */)';
        var func = 'moment', zone = '', prefix, year, datetime, suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        prefix = '[' + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
        datetime = '-MM-DD[T]HH:mm:ss.SSS';
        suffix = zone + '[")]';
        return this.format(prefix + year + datetime + suffix);
    }
    function format(inputString) {
        if (!inputString) inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }
    function from(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            to: this,
            from: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }
    function to(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            from: this,
            to: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }
    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;
        if (key === undefined) return this._locale._abbr;
        else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) this._locale = newLocaleData;
            return this;
        }
    }
    var lang = deprecate('moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.', function(key) {
        if (key === undefined) return this.localeData();
        else return this.locale(key);
    });
    function localeData() {
        return this._locale;
    }
    var MS_PER_SECOND = 1000, MS_PER_MINUTE = 60 * MS_PER_SECOND, MS_PER_HOUR = 60 * MS_PER_MINUTE, MS_PER_400_YEARS = 3506328 * MS_PER_HOUR;
    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return (dividend % divisor + divisor) % divisor;
    }
    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        else return new Date(y, m, d).valueOf();
    }
    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        else return Date.UTC(y, m, d);
    }
    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case 'year':
                time = startOfDate(this.year(), 0, 1);
                break;
            case 'quarter':
                time = startOfDate(this.year(), this.month() - this.month() % 3, 1);
                break;
            case 'month':
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case 'week':
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday());
                break;
            case 'isoWeek':
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case 'hour':
                time = this._d.valueOf();
                time -= mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR);
                break;
            case 'minute':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case 'second':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case 'year':
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case 'quarter':
                time = startOfDate(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
                break;
            case 'month':
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case 'week':
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
                break;
            case 'isoWeek':
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case 'hour':
                time = this._d.valueOf();
                time += MS_PER_HOUR - mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR) - 1;
                break;
            case 'minute':
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case 'second':
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }
    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }
    function toDate() {
        return new Date(this.valueOf());
    }
    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond()
        ];
    }
    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds()
        };
    }
    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }
    function isValid$2() {
        return isValid(this);
    }
    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }
    function invalidAt() {
        return getParsingFlags(this).overflow;
    }
    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict
        };
    }
    addFormatToken('N', 0, 0, 'eraAbbr');
    addFormatToken('NN', 0, 0, 'eraAbbr');
    addFormatToken('NNN', 0, 0, 'eraAbbr');
    addFormatToken('NNNN', 0, 0, 'eraName');
    addFormatToken('NNNNN', 0, 0, 'eraNarrow');
    addFormatToken('y', [
        'y',
        1
    ], 'yo', 'eraYear');
    addFormatToken('y', [
        'yy',
        2
    ], 0, 'eraYear');
    addFormatToken('y', [
        'yyy',
        3
    ], 0, 'eraYear');
    addFormatToken('y', [
        'yyyy',
        4
    ], 0, 'eraYear');
    addRegexToken('N', matchEraAbbr);
    addRegexToken('NN', matchEraAbbr);
    addRegexToken('NNN', matchEraAbbr);
    addRegexToken('NNNN', matchEraName);
    addRegexToken('NNNNN', matchEraNarrow);
    addParseToken([
        'N',
        'NN',
        'NNN',
        'NNNN',
        'NNNNN'
    ], function(input, array, config, token) {
        var era = config._locale.erasParse(input, token, config._strict);
        if (era) getParsingFlags(config).era = era;
        else getParsingFlags(config).invalidEra = input;
    });
    addRegexToken('y', matchUnsigned);
    addRegexToken('yy', matchUnsigned);
    addRegexToken('yyy', matchUnsigned);
    addRegexToken('yyyy', matchUnsigned);
    addRegexToken('yo', matchEraYearOrdinal);
    addParseToken([
        'y',
        'yy',
        'yyy',
        'yyyy'
    ], YEAR);
    addParseToken([
        'yo'
    ], function(input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) match = input.match(config._locale._eraYearOrdinalRegex);
        if (config._locale.eraYearOrdinalParse) array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        else array[YEAR] = parseInt(input, 10);
    });
    function localeEras(m, format) {
        var i, l, date, eras = this._eras || getLocale('en')._eras;
        for(i = 0, l = eras.length; i < l; ++i){
            switch(typeof eras[i].since){
                case 'string':
                    // truncate time
                    date = hooks(eras[i].since).startOf('day');
                    eras[i].since = date.valueOf();
                    break;
            }
            switch(typeof eras[i].until){
                case 'undefined':
                    eras[i].until = Infinity;
                    break;
                case 'string':
                    // truncate time
                    date = hooks(eras[i].until).startOf('day').valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }
    function localeErasParse(eraName, format, strict) {
        var i, l, eras = this.eras(), name, abbr, narrow;
        eraName = eraName.toUpperCase();
        for(i = 0, l = eras.length; i < l; ++i){
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();
            if (strict) switch(format){
                case 'N':
                case 'NN':
                case 'NNN':
                    if (abbr === eraName) return eras[i];
                    break;
                case 'NNNN':
                    if (name === eraName) return eras[i];
                    break;
                case 'NNNNN':
                    if (narrow === eraName) return eras[i];
                    break;
            }
            else if ([
                name,
                abbr,
                narrow
            ].indexOf(eraName) >= 0) return eras[i];
        }
    }
    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? 1 : -1;
        if (year === undefined) return hooks(era.since).year();
        else return hooks(era.since).year() + (year - era.offset) * dir;
    }
    function getEraName() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].name;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].name;
        }
        return '';
    }
    function getEraNarrow() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].narrow;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].narrow;
        }
        return '';
    }
    function getEraAbbr() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].abbr;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].abbr;
        }
        return '';
    }
    function getEraYear() {
        var i, l, dir, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            dir = eras[i].since <= eras[i].until ? 1 : -1;
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until || eras[i].until <= val && val <= eras[i].since) return (this.year() - hooks(eras[i].since).year()) * dir + eras[i].offset;
        }
        return this.year();
    }
    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNameRegex')) computeErasParse.call(this);
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }
    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, '_erasAbbrRegex')) computeErasParse.call(this);
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }
    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNarrowRegex')) computeErasParse.call(this);
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }
    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }
    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }
    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }
    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }
    function computeErasParse() {
        var abbrPieces = [], namePieces = [], narrowPieces = [], mixedPieces = [], i, l, erasName, erasAbbr, erasNarrow, eras = this.eras();
        for(i = 0, l = eras.length; i < l; ++i){
            erasName = regexEscape(eras[i].name);
            erasAbbr = regexEscape(eras[i].abbr);
            erasNarrow = regexEscape(eras[i].narrow);
            namePieces.push(erasName);
            abbrPieces.push(erasAbbr);
            narrowPieces.push(erasNarrow);
            mixedPieces.push(erasName);
            mixedPieces.push(erasAbbr);
            mixedPieces.push(erasNarrow);
        }
        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
        this._erasNarrowRegex = new RegExp('^(' + narrowPieces.join('|') + ')', 'i');
    }
    // FORMATTING
    addFormatToken(0, [
        'gg',
        2
    ], 0, function() {
        return this.weekYear() % 100;
    });
    addFormatToken(0, [
        'GG',
        2
    ], 0, function() {
        return this.isoWeekYear() % 100;
    });
    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [
            token,
            token.length
        ], 0, getter);
    }
    addWeekYearFormatToken('gggg', 'weekYear');
    addWeekYearFormatToken('ggggg', 'weekYear');
    addWeekYearFormatToken('GGGG', 'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');
    // ALIASES
    // PARSING
    addRegexToken('G', matchSigned);
    addRegexToken('g', matchSigned);
    addRegexToken('GG', match1to2, match2);
    addRegexToken('gg', match1to2, match2);
    addRegexToken('GGGG', match1to4, match4);
    addRegexToken('gggg', match1to4, match4);
    addRegexToken('GGGGG', match1to6, match6);
    addRegexToken('ggggg', match1to6, match6);
    addWeekParseToken([
        'gggg',
        'ggggg',
        'GGGG',
        'GGGGG'
    ], function(input, week, config, token) {
        week[token.substr(0, 2)] = toInt(input);
    });
    addWeekParseToken([
        'gg',
        'GG'
    ], function(input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });
    // MOMENTS
    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.week(), this.weekday() + this.localeData()._week.dow, this.localeData()._week.dow, this.localeData()._week.doy);
    }
    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }
    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }
    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }
    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }
    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }
    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) return weekOfYear(this, dow, doy).year;
        else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) week = weeksTarget;
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }
    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy), date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }
    // FORMATTING
    addFormatToken('Q', 0, 'Qo', 'quarter');
    // PARSING
    addRegexToken('Q', match1);
    addParseToken('Q', function(input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });
    // MOMENTS
    function getSetQuarter(input) {
        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }
    // FORMATTING
    addFormatToken('D', [
        'DD',
        2
    ], 'Do', 'date');
    // PARSING
    addRegexToken('D', match1to2, match1to2NoLeadingZero);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function(isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict ? locale._dayOfMonthOrdinalParse || locale._ordinalParse : locale._dayOfMonthOrdinalParseLenient;
    });
    addParseToken([
        'D',
        'DD'
    ], DATE);
    addParseToken('Do', function(input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });
    // MOMENTS
    var getSetDayOfMonth = makeGetSet('Date', true);
    // FORMATTING
    addFormatToken('DDD', [
        'DDDD',
        3
    ], 'DDDo', 'dayOfYear');
    // PARSING
    addRegexToken('DDD', match1to3);
    addRegexToken('DDDD', match3);
    addParseToken([
        'DDD',
        'DDDD'
    ], function(input, array, config) {
        config._dayOfYear = toInt(input);
    });
    // HELPERS
    // MOMENTS
    function getSetDayOfYear(input) {
        var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
    }
    // FORMATTING
    addFormatToken('m', [
        'mm',
        2
    ], 0, 'minute');
    // PARSING
    addRegexToken('m', match1to2, match1to2HasZero);
    addRegexToken('mm', match1to2, match2);
    addParseToken([
        'm',
        'mm'
    ], MINUTE);
    // MOMENTS
    var getSetMinute = makeGetSet('Minutes', false);
    // FORMATTING
    addFormatToken('s', [
        'ss',
        2
    ], 0, 'second');
    // PARSING
    addRegexToken('s', match1to2, match1to2HasZero);
    addRegexToken('ss', match1to2, match2);
    addParseToken([
        's',
        'ss'
    ], SECOND);
    // MOMENTS
    var getSetSecond = makeGetSet('Seconds', false);
    // FORMATTING
    addFormatToken('S', 0, 0, function() {
        return ~~(this.millisecond() / 100);
    });
    addFormatToken(0, [
        'SS',
        2
    ], 0, function() {
        return ~~(this.millisecond() / 10);
    });
    addFormatToken(0, [
        'SSS',
        3
    ], 0, 'millisecond');
    addFormatToken(0, [
        'SSSS',
        4
    ], 0, function() {
        return this.millisecond() * 10;
    });
    addFormatToken(0, [
        'SSSSS',
        5
    ], 0, function() {
        return this.millisecond() * 100;
    });
    addFormatToken(0, [
        'SSSSSS',
        6
    ], 0, function() {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, [
        'SSSSSSS',
        7
    ], 0, function() {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, [
        'SSSSSSSS',
        8
    ], 0, function() {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, [
        'SSSSSSSSS',
        9
    ], 0, function() {
        return this.millisecond() * 1000000;
    });
    // PARSING
    addRegexToken('S', match1to3, match1);
    addRegexToken('SS', match1to3, match2);
    addRegexToken('SSS', match1to3, match3);
    var token, getSetMillisecond;
    for(token = 'SSSS'; token.length <= 9; token += 'S')addRegexToken(token, matchUnsigned);
    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }
    for(token = 'S'; token.length <= 9; token += 'S')addParseToken(token, parseMs);
    getSetMillisecond = makeGetSet('Milliseconds', false);
    // FORMATTING
    addFormatToken('z', 0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');
    // MOMENTS
    function getZoneAbbr() {
        return this._isUTC ? 'UTC' : '';
    }
    function getZoneName() {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }
    var proto = Moment.prototype;
    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== 'undefined' && Symbol.for != null) proto[Symbol.for('nodejs.util.inspect.custom')] = function() {
        return 'Moment<' + this.format() + '>';
    };
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
    proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
    proto.years = deprecate('years accessor is deprecated. Use year instead', getSetYear);
    proto.zone = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
    proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);
    function createUnix(input) {
        return createLocal(input * 1000);
    }
    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }
    function preParsePostFormat(string) {
        return string;
    }
    var proto$1 = Locale.prototype;
    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;
    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;
    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;
    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;
    function get$1(format, index, field, setter) {
        var locale = getLocale(), utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }
    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }
        format = format || '';
        if (index != null) return get$1(format, index, field, 'month');
        var i, out = [];
        for(i = 0; i < 12; i++)out[i] = get$1(format, i, field, 'month');
        return out;
    }
    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || '';
        }
        var locale = getLocale(), shift = localeSorted ? locale._week.dow : 0, i, out = [];
        if (index != null) return get$1(format, (index + shift) % 7, field, 'day');
        for(i = 0; i < 7; i++)out[i] = get$1(format, (i + shift) % 7, field, 'day');
        return out;
    }
    function listMonths(format, index) {
        return listMonthsImpl(format, index, 'months');
    }
    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }
    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }
    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }
    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }
    getSetGlobalLocale('en', {
        eras: [
            {
                since: '0001-01-01',
                until: Infinity,
                offset: 1,
                name: 'Anno Domini',
                narrow: 'AD',
                abbr: 'AD'
            },
            {
                since: '0000-12-31',
                until: -Infinity,
                offset: 1,
                name: 'Before Christ',
                narrow: 'BC',
                abbr: 'BC'
            }
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function(number) {
            var b = number % 10, output = toInt(number % 100 / 10) === 1 ? 'th' : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
            return number + output;
        }
    });
    // Side effect imports
    hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
    hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);
    var mathAbs = Math.abs;
    function abs() {
        var data = this._data;
        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);
        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);
        return this;
    }
    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);
        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;
        return duration._bubble();
    }
    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }
    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }
    function absCeil(number) {
        if (number < 0) return Math.floor(number);
        else return Math.ceil(number);
    }
    function bubble() {
        var milliseconds = this._milliseconds, days = this._days, months = this._months, data = this._data, seconds, minutes, hours, years, monthsFromDays;
        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (!(milliseconds >= 0 && days >= 0 && months >= 0 || milliseconds <= 0 && days <= 0 && months <= 0)) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }
        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;
        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;
        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;
        hours = absFloor(minutes / 60);
        data.hours = hours % 24;
        days += absFloor(hours / 24);
        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        data.days = days;
        data.months = months;
        data.years = years;
        return this;
    }
    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return days * 4800 / 146097;
    }
    function monthsToDays(months) {
        // the reverse of daysToMonths
        return months * 146097 / 4800;
    }
    function as(units) {
        if (!this.isValid()) return NaN;
        var days, months, milliseconds = this._milliseconds;
        units = normalizeUnits(units);
        if (units === 'month' || units === 'quarter' || units === 'year') {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch(units){
                case 'month':
                    return months;
                case 'quarter':
                    return months / 3;
                case 'year':
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch(units){
                case 'week':
                    return days / 7 + milliseconds / 6048e5;
                case 'day':
                    return days + milliseconds / 864e5;
                case 'hour':
                    return days * 24 + milliseconds / 36e5;
                case 'minute':
                    return days * 1440 + milliseconds / 6e4;
                case 'second':
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond':
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error('Unknown unit ' + units);
            }
        }
    }
    function makeAs(alias) {
        return function() {
            return this.as(alias);
        };
    }
    var asMilliseconds = makeAs('ms'), asSeconds = makeAs('s'), asMinutes = makeAs('m'), asHours = makeAs('h'), asDays = makeAs('d'), asWeeks = makeAs('w'), asMonths = makeAs('M'), asQuarters = makeAs('Q'), asYears = makeAs('y'), valueOf$1 = asMilliseconds;
    function clone$1() {
        return createDuration(this);
    }
    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }
    function makeGetter(name) {
        return function() {
            return this.isValid() ? this._data[name] : NaN;
        };
    }
    var milliseconds = makeGetter('milliseconds'), seconds = makeGetter('seconds'), minutes = makeGetter('minutes'), hours = makeGetter('hours'), days = makeGetter('days'), months = makeGetter('months'), years = makeGetter('years');
    function weeks() {
        return absFloor(this.days() / 7);
    }
    var round = Math.round, thresholds = {
        ss: 44,
        s: 45,
        m: 45,
        h: 22,
        d: 26,
        w: null,
        M: 11
    };
    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }
    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(), seconds = round(duration.as('s')), minutes = round(duration.as('m')), hours = round(duration.as('h')), days = round(duration.as('d')), months = round(duration.as('M')), weeks = round(duration.as('w')), years = round(duration.as('y')), a = seconds <= thresholds.ss && [
            's',
            seconds
        ] || seconds < thresholds.s && [
            'ss',
            seconds
        ] || minutes <= 1 && [
            'm'
        ] || minutes < thresholds.m && [
            'mm',
            minutes
        ] || hours <= 1 && [
            'h'
        ] || hours < thresholds.h && [
            'hh',
            hours
        ] || days <= 1 && [
            'd'
        ] || days < thresholds.d && [
            'dd',
            days
        ];
        if (thresholds.w != null) a = a || weeks <= 1 && [
            'w'
        ] || weeks < thresholds.w && [
            'ww',
            weeks
        ];
        a = a || months <= 1 && [
            'M'
        ] || months < thresholds.M && [
            'MM',
            months
        ] || years <= 1 && [
            'y'
        ] || [
            'yy',
            years
        ];
        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }
    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) return round;
        if (typeof roundingFunction === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }
    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) return false;
        if (limit === undefined) return thresholds[threshold];
        thresholds[threshold] = limit;
        if (threshold === 's') thresholds.ss = limit - 1;
        return true;
    }
    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) return this.localeData().invalidDate();
        var withSuffix = false, th = thresholds, locale, output;
        if (typeof argWithSuffix === 'object') {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === 'boolean') withSuffix = argWithSuffix;
        if (typeof argThresholds === 'object') {
            th = Object.assign({}, thresholds, argThresholds);
            if (argThresholds.s != null && argThresholds.ss == null) th.ss = argThresholds.s - 1;
        }
        locale = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, locale);
        if (withSuffix) output = locale.pastFuture(+this, output);
        return locale.postformat(output);
    }
    var abs$1 = Math.abs;
    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }
    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) return this.localeData().invalidDate();
        var seconds = abs$1(this._milliseconds) / 1000, days = abs$1(this._days), months = abs$1(this._months), minutes, hours, years, s, total = this.asSeconds(), totalSign, ymSign, daysSign, hmsSign;
        if (!total) // this is the same as C#'s (Noda) and python (isodate)...
        // but not other JS (goog.date)
        return 'P0D';
        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
        totalSign = total < 0 ? '-' : '';
        ymSign = sign(this._months) !== sign(total) ? '-' : '';
        daysSign = sign(this._days) !== sign(total) ? '-' : '';
        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';
        return totalSign + 'P' + (years ? ymSign + years + 'Y' : '') + (months ? ymSign + months + 'M' : '') + (days ? daysSign + days + 'D' : '') + (hours || minutes || seconds ? 'T' : '') + (hours ? hmsSign + hours + 'H' : '') + (minutes ? hmsSign + minutes + 'M' : '') + (seconds ? hmsSign + s + 'S' : '');
    }
    var proto$2 = Duration.prototype;
    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;
    proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
    proto$2.lang = lang;
    // FORMATTING
    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');
    // PARSING
    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function(input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken('x', function(input, array, config) {
        config._d = new Date(toInt(input));
    });
    //! moment.js
    hooks.version = '2.30.1';
    setHookCallback(createLocal);
    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;
    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',
        DATE: 'YYYY-MM-DD',
        TIME: 'HH:mm',
        TIME_SECONDS: 'HH:mm:ss',
        TIME_MS: 'HH:mm:ss.SSS',
        WEEK: 'GGGG-[W]WW',
        MONTH: 'YYYY-MM'
    };
    return hooks;
});

});

const $4975412c8fcbfa24$export$e63e1e1c17a0e8b = 'YYYY-MM-DD';
const $4975412c8fcbfa24$export$45c85543ba71221d = 'YYYY/MM/DD';
const $4975412c8fcbfa24$export$1f04624003d2da7d = 86400000;


parcelRegister("25Ymt", function(module, exports) {

$parcel$export(module.exports, "getTimelineDurationFromDate", () => $a5219a4c66752b37$export$844e598264c96110);
$parcel$export(module.exports, "getTimelineOriginForToday", () => $a5219a4c66752b37$export$afef567e98d0d2bb);
$parcel$export(module.exports, "getDefaultTimelinePositionFromDate", () => $a5219a4c66752b37$export$96eeb91a52b83f6d);

var $5iWql = parcelRequire("5iWql");

var $jJwwt = parcelRequire("jJwwt");

var $1QJt8 = parcelRequire("1QJt8");
var $gf0vG = parcelRequire("gf0vG");
const $a5219a4c66752b37$export$844e598264c96110 = (0, $5iWql.default)((timelineMode, date)=>{
    let startMoment = (0, (/*@__PURE__*/$parcel$interopDefault($jJwwt))).utc(date).subtract(1, 'year');
    let endMoment = (0, (/*@__PURE__*/$parcel$interopDefault($jJwwt))).utc(date).add(2, 'year');
    if (timelineMode === (0, $gf0vG.QUARTERS)) {
        startMoment = startMoment.startOf('quarter');
        endMoment = endMoment.endOf('quarter');
    } else if (timelineMode === (0, $gf0vG.MONTHS)) {
        startMoment = startMoment.startOf('month');
        endMoment = endMoment.endOf('month');
    } else {
        /* We are using ISO week to match column calculations.
			 * See getColumnDurations below for additional info.
			 */ startMoment = startMoment.startOf('isoWeek');
        endMoment = endMoment.endOf('isoWeek');
    }
    return {
        startMilliseconds: startMoment.valueOf(),
        endMilliseconds: endMoment.valueOf(),
        totalMilliseconds: endMoment.diff(startMoment, 'milliseconds')
    };
});
const $a5219a4c66752b37$export$afef567e98d0d2bb = (0, $5iWql.default)((today, timelineMode)=>{
    const todayMoment = (0, (/*@__PURE__*/$parcel$interopDefault($jJwwt))).utc(today);
    if (timelineMode === (0, $gf0vG.QUARTERS)) return todayMoment.startOf('quarter').subtract(45, 'days').valueOf();
    if (timelineMode === (0, $gf0vG.MONTHS)) return todayMoment.startOf('month').subtract(15, 'days').valueOf();
    return todayMoment.startOf('isoWeek').subtract(4, 'days').valueOf();
});
const $a5219a4c66752b37$export$96eeb91a52b83f6d = (0, $5iWql.default)((date, timelineMode, timelineDuration)=>{
    const millisecondPosition = $a5219a4c66752b37$export$afef567e98d0d2bb(date, timelineMode);
    const relativePosition = (millisecondPosition - timelineDuration.startMilliseconds) / timelineDuration.totalMilliseconds;
    return relativePosition * (0, $1QJt8.getTimelineWidth)(timelineMode, timelineDuration.totalMilliseconds);
});

});
parcelRegister("1QJt8", function(module, exports) {

$parcel$export(module.exports, "getTimelineWidth", () => $c56c41b2f09e0567$export$87113eddf3515c00);
$parcel$export(module.exports, "getTimelinePositionFromDate", () => $c56c41b2f09e0567$export$3d733aa4507a88f8);
$parcel$export(module.exports, "getDateFromTimelinePosition", () => $c56c41b2f09e0567$export$2dd9c7d371d81aa3);

var $5iWql = parcelRequire("5iWql");

var $jJwwt = parcelRequire("jJwwt");

var $gf0vG = parcelRequire("gf0vG");
// Size in pixels a column should ideally represent for any timeline mode
const $c56c41b2f09e0567$var$COLUMN_BASELINE = 255;
const $c56c41b2f09e0567$export$893f7447303d5bc0 = {
    [(0, $gf0vG.WEEKS)]: $c56c41b2f09e0567$var$COLUMN_BASELINE / (0, (/*@__PURE__*/$parcel$interopDefault($jJwwt))).duration(7, 'day').asMilliseconds(),
    [(0, $gf0vG.MONTHS)]: $c56c41b2f09e0567$var$COLUMN_BASELINE / (0, (/*@__PURE__*/$parcel$interopDefault($jJwwt))).duration(30, 'day').asMilliseconds(),
    [(0, $gf0vG.QUARTERS)]: $c56c41b2f09e0567$var$COLUMN_BASELINE / (0, (/*@__PURE__*/$parcel$interopDefault($jJwwt))).duration(91, 'day').asMilliseconds()
};
const $c56c41b2f09e0567$export$87113eddf3515c00 = (0, $5iWql.default)((timelineMode, totalDuration)=>Math.round(totalDuration * $c56c41b2f09e0567$export$893f7447303d5bc0[timelineMode]));
const $c56c41b2f09e0567$export$3d733aa4507a88f8 = ({ startMilliseconds: startMilliseconds, totalMilliseconds: totalMilliseconds }, timelineWidth, date)=>timelineWidth * ((date - startMilliseconds) / totalMilliseconds);
const $c56c41b2f09e0567$export$2dd9c7d371d81aa3 = ({ startMilliseconds: startMilliseconds, totalMilliseconds: totalMilliseconds }, timelineWidth, position)=>Math.round(startMilliseconds + position / timelineWidth * totalMilliseconds);

});



parcelRegister("f4bDW", function(module, exports) {

$parcel$export(module.exports, "CREATE_ISSUE_MUTATION", () => $78971d387c851705$export$f5c1cac020b22be4);
$parcel$export(module.exports, "ISSUE_REFETCH_QUERY", () => $78971d387c851705$export$834c81726d4c51eb);

var $9ypom = parcelRequire("9ypom");

var $7Pw84 = parcelRequire("7Pw84");

var $dLnS7 = parcelRequire("dLnS7");
const $78971d387c851705$var$CREATED_ITEM_FRAGMENT = (0, $9ypom.default)`
fragment CreatedTimelineItemFragment on JiraWorkManagementViewItem {
    id
    issueId
    childSummary {
        hasChildren
    }
    issueLinks(first: 10) {
        edges {
            node {
                issue {
                    issueId
                }
                issueLinkId
                relationName
                direction
            }
        }
    }
    ... JWMTimelineViewItem
}
${(0, $dLnS7.TIMELINE_VIEW_ITEM_FRAGMENT)}
`;
const $78971d387c851705$export$f5c1cac020b22be4 = (0, $9ypom.default)`
mutation JWMTimelineInlineCreateIssue($input: JiraCreateIssueInput!, $fieldIds: [String]!, $withParentRank: Boolean = false) {
    createJiraBusinessIssue(input: $input, fieldIdsToReturn: $fieldIds) {
        item {
            ...CreatedTimelineItemFragment
        }
        ...CreateIssueFragment
    }
}
${(0, $7Pw84.CREATE_ISSUE_FRAGMENT)}
${$78971d387c851705$var$CREATED_ITEM_FRAGMENT}
`;
const $78971d387c851705$export$834c81726d4c51eb = (0, $9ypom.default)`
query JWMTimelineInlineCreateRefetchQuery($cloudId: ID!, $jql: String!, $fieldIds: [String]!, $first: Int, $withParentRank: Boolean = false) {
    jira {
        jwmViewItems(cloudId: $cloudId, jql: $jql, first: $first) {
            ... on JiraWorkManagementViewItemConnection {
                edges {
                    node {
                        ...CreatedTimelineItemFragment
                    }
                }
            }
        }
    }
}
${$78971d387c851705$var$CREATED_ITEM_FRAGMENT}
`;

});
parcelRegister("7Pw84", function(module, exports) {

$parcel$export(module.exports, "CREATE_ISSUE_FRAGMENT", () => $33f8e9ac12479c3a$export$47232071d0e9dfb);

var $9ypom = parcelRequire("9ypom");
const $33f8e9ac12479c3a$export$47232071d0e9dfb = (0, $9ypom.default)`
fragment CreateIssueFragment on JiraBusinessCreateIssuePayload {
  itemIdentifiers: item @connection (key: "issue-create-ids") {
    issueId
    issueKey: fieldsByIdOrAlias(idsOrAliases: ["issuekey"]) {
      ... on JiraSingleLineTextField {
          text
      }
    }
  }
  success
  errors {
    message
    extensions {
      ...on MutationErrorExtension {
        statusCode
        errorType
      }
    }
  }
}`;

});

parcelRegister("dLnS7", function(module, exports) {

$parcel$export(module.exports, "TIMELINE_VIEW_ITEM_FRAGMENT", () => $7d44d2d00a6644a2$export$b3df6971b0b88fa5);
$parcel$export(module.exports, "TIMELINE_VIEW_ITEMS_QUERY", () => $7d44d2d00a6644a2$export$bd866b553c924711);

var $9ypom = parcelRequire("9ypom");
const $7d44d2d00a6644a2$export$b3df6971b0b88fa5 = (0, $9ypom.default)`
    fragment JWMTimelineViewItem on JiraWorkManagementViewItem {
        fields: fieldsByIdOrAlias(idsOrAliases: $fieldIds, ignoreMissingFields: true) @connection (key: "fields") {
            fieldId
            aliasFieldId
            type
            ... on JiraSingleLineTextField {
                text
            }
            ... on JiraStatusField {
                status {
                    name
                    statusId
                    statusCategory {
                        statusCategoryId
                    }
                }
            }
            ... on JiraIssueTypeField {
                issueType {
                    issueTypeId
                    name
                    avatar {
                        medium
                    }
                    hierarchy {
                        level
                    }
                }
            }
            ... on JiraSingleSelectUserPickerField {
                user {
                    accountId
                    picture
                    name
                }
            }
            ... on JiraDatePickerField {
                date
            }
            ... on JiraParentIssueField {
                parentIssue {
                    issueId
                    key
                    rankField: fieldsByIdOrAlias(idsOrAliases: ["rank"], ignoreMissingFields: true) @connection (key: "parentRankField") @include(if: $withParentRank) {
						... on JiraSingleLineTextField {
							text
						}
					}
                }
            }
        }
    }
`;
const $7d44d2d00a6644a2$export$bd866b553c924711 = (0, $9ypom.default)`
    query JWMTimelineViewItems ($cloudId: ID!, $jql: String!, $includeDoneItems: Boolean!, $fieldIds: [String]!, $first: Int, $after: String, $withParentRank: Boolean = false) {
        jira {
            list: jwmViewItems(
                cloudId: $cloudId,
                jql: $jql,
                first: $first,
                after: $after,
                ) @connection (key: "timelineList", filter:["jql"]) {
                ... on JiraWorkManagementViewItemConnection {
                    edges {
                        node {
                            id
                            issueId
                            childSummary(includeDone: $includeDoneItems) {
                                hasChildren
                            }
                            issueLinks(first: 10) {
                                edges {
                                    node {
                                        issue {
                                            issueId
                                        }
                                        issueLinkId
                                        relationName
                                        direction
                                    }
                                }
                            }
                            ... JWMTimelineViewItem
                        }
                    }
                    pageInfo {
                        hasNextPage
                        endCursor
                    }
                }
            }
        }
    }
    ${$7d44d2d00a6644a2$export$b3df6971b0b88fa5}
`;

});


parcelRegister("haDkv", function(module, exports) {

$parcel$export(module.exports, "default", () => $e73b1e81eb93ab23$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $PdmhA = parcelRequire("PdmhA");

var $jGcn0 = parcelRequire("jGcn0");

var $hJYsP = parcelRequire("hJYsP");

var $gEmpR = parcelRequire("gEmpR");

var $4G5xU = parcelRequire("4G5xU");

var $lGxgz = parcelRequire("lGxgz");

var $kHnEs = parcelRequire("kHnEs");
var $9u6Jh = parcelRequire("9u6Jh");

var $5I9Im = parcelRequire("5I9Im");

var $nxBOY = parcelRequire("nxBOY");

var $6L1pn = parcelRequire("6L1pn");

var $eDPHg = parcelRequire("eDPHg");

var $f0s5n = parcelRequire("f0s5n");

var $bcWyL = parcelRequire("bcWyL");
var $6HWvN = parcelRequire("6HWvN");

var $eRpjy = parcelRequire("eRpjy");


var $1ybV0 = parcelRequire("1ybV0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $hJ992 = parcelRequire("hJ992");

var $kJlBc = parcelRequire("kJlBc");

var $fD1Hq = parcelRequire("fD1Hq");

var $6vrw7 = parcelRequire("6vrw7");

var $2lQYS = parcelRequire("2lQYS");
var $gf0vG = parcelRequire("gf0vG");
var $VrUCp = parcelRequire("VrUCp");

var $gB4dC = parcelRequire("gB4dC");

var $jK1pm = parcelRequire("jK1pm");

var $84CBi = parcelRequire("84CBi");

var $2nzpw = parcelRequire("2nzpw");

var $ijZnZ = parcelRequire("ijZnZ");

var $6ELMa = parcelRequire("6ELMa");
var $J1Q43 = parcelRequire("J1Q43");

var $1Pl9B = parcelRequire("1Pl9B");

var $hsBO5 = parcelRequire("hsBO5");

var $211Np = parcelRequire("211Np");

var $duAPu = parcelRequire("duAPu");

var $bvug1 = parcelRequire("bvug1");

var $lwlVZ = parcelRequire("lwlVZ");

var $203kY = parcelRequire("203kY");

var $a2d2y = parcelRequire("a2d2y");

var $eTH8y = parcelRequire("eTH8y");

var $kO3mo = parcelRequire("kO3mo");

var $91m2x = parcelRequire("91m2x");

var $6plCc = parcelRequire("6plCc");

var $ixHL5 = parcelRequire("ixHL5");

var $2ElAN = parcelRequire("2ElAN");

var $dxylj = parcelRequire("dxylj");

var $hZat9 = parcelRequire("hZat9");

var $3gNlI = parcelRequire("3gNlI");

var $lpABi = parcelRequire("lpABi");

var $gzr66 = parcelRequire("gzr66");

var $7Szg9 = parcelRequire("7Szg9");

var $53aAp = parcelRequire("53aAp");

var $brx5D = parcelRequire("brx5D");

var $fP9K4 = parcelRequire("fP9K4");

var $aPHtc = parcelRequire("aPHtc");

var $eow9N = parcelRequire("eow9N");

var $4vChJ = parcelRequire("4vChJ");

var $e1P9V = parcelRequire("e1P9V");

var $bKIjS = parcelRequire("bKIjS");

var $hvTT6 = parcelRequire("hvTT6");
const $e73b1e81eb93ab23$var$getTimelineRenderers = ({ childrenQueryData: childrenQueryData = {}, dependencies: dependencies, hasScheduleIssues: hasScheduleIssues, interactiveChartItems: interactiveChartItems, isExportTable: isExportTable, issuesMap: issuesMap, items: items, onCreateClick: onCreateClick, onItemUpdate: onItemUpdate, setInfiniteScrollerRef: setInfiniteScrollerRef, setSelectedIssueKey: setSelectedIssueKey })=>{
    // do not initialise the renderers for SSR
    if (false) return {};
    return {
        // @ts-expect-error - TS7031 - Binding element 'id' implicitly has an 'any' type.
        renderListHeaderItem: ({ id: id })=>id === (0, $gf0vG.DEFAULT_HEADER_ROW_ID) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $brx5D.ListHeader), null) : null,
        // @ts-expect-error - TS7006 - Parameter 'state' implicitly has an 'any' type.
        renderListItemContent: ({ id: id }, state)=>{
            if ((0, $211Np.isItemSkeleton)(id)) return(// @ts-expect-error - TS2741 - Property 'backgroundColor' is missing in type '{}' but required in type 'Readonly<ThemedOuterStyledProps<ClassAttributes<HTMLDivElement> & HTMLAttributes<HTMLDivElement> & { backgroundColor: string; }, any>>'.
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ijZnZ.LoadingItem), {
                "data-testid": "business-timeline.ui.timeline-view.loading-icon"
            }));
            const issue = issuesMap.get(id);
            if (!issue) return null;
            const { summary: summary, ...issueProps } = issue;
            const isFirstItem = id === issuesMap.values().next().value?.issueId;
            const isLastItem = id === Array.from(issuesMap.values()).pop()?.issueId;
            if (state?.isVirtual) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gB4dC.RoadmapListItemContentLite), {
                title: summary || '',
                iconUrl: issue.issueType.iconUrl,
                itemKey: issue.key
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fP9K4.ListItemContent), {
                isFirstItem: isFirstItem,
                isLastItem: isLastItem,
                title: summary,
                issue: issueProps,
                setSelectedIssueKey: setSelectedIssueKey,
                onCreateClick: onCreateClick,
                setInfiniteScrollerRef: setInfiniteScrollerRef
            });
        },
        renderListItemCreate: ({ anchorId: anchorId, level: level, canCreateChildOverride: canCreateChildOverride })=>{
            /*
       * Renders an empty placeholder row after all other issue rows.
       * This is a workaround to ensure that our custom sticky
       * inline create component doesn't overlap the last
       * issue in the table.
       *
       * Instead, the sticky inline create component will
       * overlap the empty placeholder row.
       */ if ((0, $1ybV0.ff)('jwm.visual-hierarchy-milestone-1')) {
                if (!anchorId && !canCreateChildOverride) return null;
            } else if (!anchorId && level === 1) return null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bKIjS.TimelineTableInlineCreate), {
                childrenQueryData: childrenQueryData,
                issuesMap: issuesMap,
                items: items
            });
        },
        renderChartItemContent: ({ id: id }, state)=>{
            if ((0, $211Np.isItemSkeleton)(id)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hZat9.ChartItemContentSkeleton), null);
            const issue = issuesMap.get(id);
            if (!issue) return null;
            const interactiveItem = interactiveChartItems.find((item)=>item.id === id);
            if (!interactiveItem) // interactiveItem will always be defined.
            return null;
            if (state?.isVirtual) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dxylj.ChartItemContentLite), {
                issue: issue,
                startDate: interactiveItem.startDate,
                dueDate: interactiveItem.dueDate,
                level: interactiveItem.level
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2ElAN.ChartItemContent), {
                dueDate: interactiveItem.dueDate,
                isExportTable: isExportTable,
                isHovered: Boolean(state?.isHovered),
                isReadOnly: !hasScheduleIssues,
                issue: issue,
                level: interactiveItem.level,
                onItemUpdate: onItemUpdate,
                placeholder: interactiveItem.placeholder,
                setSelectedIssueKey: setSelectedIssueKey,
                startDate: interactiveItem.startDate
            });
        },
        renderChartTimelineOverlay: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lpABi.ChartTimelineOverlay), {
                issuesMap: issuesMap,
                dependencies: dependencies
            }),
        ...!isExportTable ? {
            // @ts-expect-error - TS7006 - Parameter 'props' implicitly has an 'any' type.
            renderProvider: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $e1P9V.TableProvider), {
                    ...props,
                    items: interactiveChartItems
                }),
            renderChartOverlay: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3gNlI.ChartOverlay), {
                    issuesMap: issuesMap
                })
        } : {}
    };
};
const $e73b1e81eb93ab23$export$4e254246a3a175f9 = /*#__PURE__*/ (0, $eUqFw.memo)(()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const pageHeading = formatMessage((0, $aPHtc.default).timelineHeading);
    const timelineRef = (0, $eUqFw.useRef)(null);
    const { childrenQueryData: childrenQueryData, expandedItems: expandedItems, setChildrenQueryData: setChildrenQueryData, setIssueExpanded: setIssueExpanded } = (0, $a2d2y.useHierarchy)();
    const { data: { items: items, issuesMap: issuesMap, issueParentMap: issueParentMap, dependencies: dependencies, interactiveChartItems: interactiveChartItems }, error: error, loading: loading, rankIssue: rankIssue, updateItemsInCache: updateItemsInCache, loadNextPage: loadNextPage, isLoadingNextPage: isLoadingNextPage, isLinkingEnabled: isLinkingEnabled, updateIssueParent: updateIssueParent } = (0, $91m2x.useTimelineViewIssues)({
        childrenQueryData: childrenQueryData,
        expandedItems: expandedItems
    });
    const { isFiltering: isFiltering } = (0, $lGxgz.useFilteredViewContextInput)({
        view: 'timeline'
    });
    const onItemDrop = (0, $eUqFw.useCallback)((id, payload, analyticsEvent)=>{
        const { parentId: parentId, rankRequest: rankRequest } = payload;
        const isUpdateParent = 'parentId' in payload;
        if (isFiltering || !isUpdateParent && rankRequest) return rankIssue(id, payload, analyticsEvent);
        if (parentId && !expandedItems[parentId]) setIssueExpanded(parentId, true);
        return updateIssueParent(id, payload, analyticsEvent);
    }, [
        expandedItems,
        isFiltering,
        rankIssue,
        setIssueExpanded,
        updateIssueParent
    ]);
    const { loading: startDateFieldLoading } = (0, $fD1Hq.useStartDateField)();
    const viewMode = (0, $hJ992.useViewMode)();
    const isViewModeSideBar = viewMode === (0, $935e771f19f8ea28$export$705305d6da432040);
    const [{ createItemAnchor: createItemAnchor }, { setCreateItemAnchor: setCreateItemAnchor }] = (0, $bvug1.useCreateItemAnchor)();
    const { data: { issueTypes: issueTypes } } = (0, $gEmpR.useIssueTypesAndFields)({
        issueOperation: 'CREATE'
    });
    const { hasInlineCreate: hasInlineCreate, hasCreateSubtask: hasCreateSubtask, hasOnboarding: hasOnboarding, featureView: featureView, hasScheduleIssues: hasScheduleIssues } = (0, $203kY.useTimelineFeatures)();
    const interactionMetrics = (0, $hsBO5.useInteractionMetrics)();
    const [{ timelineMode: timelineMode, today: today, timelineDuration: timelineDuration, timelineOrigin: timelineOrigin }] = (0, $eTH8y.useTimelineUI)();
    const [selectedIssueKey, setSelectedIssueKey] = (0, $kJlBc.useQueryParam)((0, $jGcn0.SELECTED_ISSUE_PARAM));
    const [listWidth, setListWidth] = (0, $eUqFw.useState)((0, $gf0vG.DEFAULT_LIST_WIDTH) + 40);
    const selectedItemIds = (0, $eUqFw.useMemo)(()=>{
        if (!selectedIssueKey) return [];
        const selectedIssueId = Array.from(issuesMap.values()).find((issue)=>issue.key === selectedIssueKey)?.issueId;
        return selectedIssueId ? [
            selectedIssueId
        ] : []; // Cannot use issuesMap in the dependency array because it remains stable
    // even when issuesMap changes.
    // This happens because issuesMap is mutated directly in toTimelineData().
    // Instead we use items as a proxy for issuesMap.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        items,
        selectedIssueKey
    ]);
    const setRef = (0, $ixHL5.useIntersectionObserver)(loadNextPage);
    const setInfiniteScrollerRef = (0, $eUqFw.useCallback)((element)=>setRef(element), [
        setRef
    ]);
    const hasSubtasks = issueTypes.some((issueType)=>issueType.hierarchyLevel === -1);
    const { onBentoChange: onBentoChange, onBentoDelete: onBentoDelete } = (0, $lwlVZ.useDependencyUpdater)({
        childrenQueryData: childrenQueryData
    });
    const { onItemUpdate: onItemUpdate } = (0, $6plCc.useUpdateItem)({
        issuesMap: issuesMap,
        updateItemsInCache: updateItemsInCache,
        childrenQueryData: childrenQueryData
    });
    const onBentoClose = (0, $eUqFw.useCallback)(()=>{
        setSelectedIssueKey(undefined);
    }, [
        setSelectedIssueKey
    ]);
    const onDeleteSuccess = (0, $eUqFw.useCallback)(// This may show up as "unused ts-expect-error" locally, but fails in pipelines
    // @ts-expect-error - TS7031 -  Binding element 'issueId' implicitly has an 'any' type.
    ({ issueId: issueId })=>{
        const parentId = issueParentMap.get(issueId);
        onBentoDelete({
            issueId: Number(issueId),
            parentId: Number(parentId)
        });
    }, [
        onBentoDelete,
        issueParentMap
    ]); // this needs to be memoised otherwise it re-renders when the table changes causing some elements to blink
    // a common reason for the table to change while this is open is the realtime implementation
    const bentoView = (0, $eUqFw.useMemo)(()=>selectedIssueKey != null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kHnEs.default), {
            issueKey: (0, $6vrw7.toIssueKey)(selectedIssueKey),
            onClose: onBentoClose,
            onChange: onBentoChange,
            onDeleteSuccess: onDeleteSuccess,
            analyticsSource: (0, $0100842672acae20$export$f6cf06aaaeb58a54)
        }), [
        onBentoChange,
        selectedIssueKey,
        onBentoClose,
        onDeleteSuccess
    ]);
    const onItemExpandChanged = (0, $eUqFw.useCallback)((issueId, isExpanded)=>{
        interactionMetrics[0, $hsBO5.EXPAND_CHANGED].start();
        setIssueExpanded(issueId, !isExpanded);
    }, [
        interactionMetrics,
        setIssueExpanded
    ]);
    const onCreateClick = (0, $eUqFw.useCallback)((anchor)=>{
        interactionMetrics[0, $hsBO5.ADD_ITEM_CLICKED].start();
        if (anchor?.position === (0, $gf0vG.INSIDE) && anchor?.parentId) setIssueExpanded(anchor.parentId, true);
        setCreateItemAnchor(anchor);
    }, [
        interactionMetrics,
        setCreateItemAnchor,
        setIssueExpanded
    ]);
    const itemsProp = (0, $eUqFw.useMemo)(()=>{
        /*
          We add a dummy {} item when the child inline create is open to replace the empty row otherwise rendered by the
          renderListItemCreate renderer. This addresses the bug reported in https://jbusiness.atlassian.net/browse/ICO-275
          */ const extendedItems = createItemAnchor != null ? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        [
            ...items,
            {}
        ] : items;
        return loading ? (0, $211Np.LOADING_ITEMS) : extendedItems;
    }, [
        createItemAnchor,
        items,
        loading
    ]);
    const getRenderers = (0, $eUqFw.useCallback)(({ isExportTable: isExportTable })=>$e73b1e81eb93ab23$var$getTimelineRenderers({
            childrenQueryData: childrenQueryData,
            dependencies: loading ? [] : dependencies,
            hasScheduleIssues: hasScheduleIssues,
            interactiveChartItems: interactiveChartItems,
            isExportTable: isExportTable,
            issuesMap: issuesMap,
            items: items,
            onCreateClick: onCreateClick,
            onItemUpdate: onItemUpdate,
            setInfiniteScrollerRef: setInfiniteScrollerRef,
            setSelectedIssueKey: setSelectedIssueKey
        }), [
        items,
        issuesMap,
        loading,
        dependencies,
        interactiveChartItems,
        setSelectedIssueKey,
        childrenQueryData,
        onCreateClick,
        onItemUpdate,
        setInfiniteScrollerRef,
        hasScheduleIssues
    ]);
    const [{ headerHeight: headerHeight }] = (0, $VrUCp.useHeaderState)();
    const listHeight = (0, $1Pl9B.getTimelineTableItemsHeight)(itemsProp, expandedItems) + headerHeight;
    const exportToImageButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $53aAp.ExportToImage), {
        tableProps: {
            items: itemsProp,
            expandedItems: expandedItems,
            listWidth: listWidth,
            listHeight: listHeight,
            itemHeight: (0, $gzr66.timelineProps).itemHeight,
            today: today,
            renderers: getRenderers({
                isExportTable: true
            })
        }
    });
    const isReady = !loading && !error;
    const shouldShowDependenciesOnboarding = selectedIssueKey == null && hasOnboarding && !!isLinkingEnabled;
    const shouldShowEmbedOnboarding = selectedIssueKey == null && hasOnboarding && !!isLinkingEnabled;
    const isCreateChildEnabled = !isFiltering && hasInlineCreate === true && hasSubtasks && hasCreateSubtask;
    let stickyInlineCreate;
    if (hasInlineCreate) stickyInlineCreate = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eow9N.StickyInlineCreate), {
        expandedItems: expandedItems,
        height: (0, $gzr66.timelineProps).itemHeight,
        issuesMap: issuesMap,
        items: items,
        listWidth: listWidth,
        loading: loading,
        timelineRef: timelineRef.current
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, !isFiltering && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $nxBOY.ChildrenController), {
        expandedItemIssueIds: Object.keys(expandedItems),
        setChildrenQueryData: setChildrenQueryData,
        ChildQueryController: (0, $duAPu.TimelineViewChildQueryController)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $84CBi.default), {
        name: "timeline-view",
        hold: loading
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6HWvN.RenderStartMark), {
        view: featureView,
        loading: loading
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hJYsP.BusinessDocumentTitle), {
        pageHeading: pageHeading
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hvTT6.default), {
        exportToImageButton: exportToImageButton
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e73b1e81eb93ab23$export$bbea409da9cbdc02, {
        ref: timelineRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jK1pm.default), {
        name: "business-timeline-table"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2lQYS.default), {
        ...(0, $gzr66.timelineProps),
        isDragEnabled: !startDateFieldLoading,
        createItemAnchor: createItemAnchor,
        DndLongTaskMetric: (0, $6ELMa.DndLongTaskMetric),
        expandedItems: expandedItems,
        isCreateChildEnabled: isCreateChildEnabled,
        // See: https://jbusiness.atlassian.net/browse/XPROJ-250
        isCreateLastEnabled: hasInlineCreate,
        isCreateSiblingEnabled: hasInlineCreate === true,
        isSelectEnabled: true,
        isVirtualiseEnabled: true,
        items: itemsProp,
        listWidth: listWidth,
        onCreateClick: onCreateClick,
        onItemDrop: (0, $1ybV0.ff)('jwm.visual-hierarchy-dnd') ? onItemDrop : rankIssue,
        onItemExpandChanged: onItemExpandChanged,
        onSetListWidth: setListWidth,
        renderers: getRenderers({
            isExportTable: false
        }),
        selectedItemIds: selectedItemIds,
        marshalOptions: (0, $7Szg9.marshalOptions),
        timelineDuration: timelineDuration,
        timelineMode: timelineMode,
        timelineOrigin: timelineOrigin,
        today: today,
        isTreeDrag: (0, $1ybV0.ff)('jwm.visual-hierarchy-dnd')
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4vChJ.StickyInlineNudge), {
        height: (0, $gzr66.timelineProps).itemHeight,
        isEmpty: items.length === 0,
        listWidth: listWidth,
        loading: loading,
        timelineRef: timelineRef.current
    }), stickyInlineCreate, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6L1pn.LoadingMoreSpinner), {
        isLoading: isLoadingNextPage,
        loadingMessage: formatMessage((0, $aPHtc.default).loadingMoreItems)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bcWyL.PerformanceAnalytics), {
        view: featureView,
        loading: loading,
        itemsCount: items.length
    }), !loading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eRpjy.JWMSpaStatePageReady), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $J1Q43.InteractionMetrics), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kO3mo.TimelineViewUpdater), {
        childrenQueryData: childrenQueryData
    }), shouldShowDependenciesOnboarding && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eDPHg.default), null), shouldShowEmbedOnboarding && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $f0s5n.default), {
        items: interactiveChartItems
    }), isViewModeSideBar ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9u6Jh.SidebarIssueView), {
        issueKey: selectedIssueKey,
        onClose: onBentoClose,
        onChange: onBentoChange,
        onIssueDeleteSuccess: onDeleteSuccess,
        analyticsSource: (0, $0100842672acae20$export$f6cf06aaaeb58a54)
    }) : bentoView, isReady && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4G5xU.ExperienceSuccess), {
        experience: (0, $2nzpw.MAIN_EXPERIENCE)
    }), error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4G5xU.ExperienceFailed), {
        experience: (0, $2nzpw.MAIN_EXPERIENCE),
        error: error
    }), (0, $1ybV0.ff)('jwm.preload-issue-view-critical-data') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5I9Im.PrefetchIssueDataController), null));
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$e73b1e81eb93ab23$export$2e2bcd8739ae039 // border-radius set on the TimelineContainer cuts off the timeline border, so this hack brings it back
 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kO3mo.TimelineViewUpdaterProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e73b1e81eb93ab23$export$4e254246a3a175f9, null));
const $e73b1e81eb93ab23$var$fakeBorder = {
    content: '',
    background: 'transparent',
    border: `1px solid ${`var(--ds-border, ${(0, $PdmhA).N40})`}`,
    borderBottom: 'none',
    width: "var(--ds-space-100, 8px)",
    height: "var(--ds-space-100, 8px)",
    position: 'absolute',
    display: 'block',
    top: 0,
    zIndex: (0, $gf0vG.zIndex).HIGHEST
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $e73b1e81eb93ab23$export$bbea409da9cbdc02 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_bfhkvuon _2rkopd34 _1s7zqvwq _n7zlqvwq _syaz1fxt _16jlkb7n _1o9zkb7n _i0dl1wug _1reo15vq _18m915vq _vchhusvi _kqswh2mm _1yt4u2gc _aetrb3bt _1hfk18uv _eq43h6cr _2kncglyw _z0aiu2gc _1qdgu2gc _18postnw _1ywu1ule _15l2idpf _1bqq1o8a _qzgtglyw _14mjqssn _19doidpf _1kt9b3bt _1rus18uv _14h8h6cr _4k1cglyw _1mp4u2gc _kfgtu2gc _1cs8stnw _cfu11ule _1aukidpf _1g0v1o8a _1n1jglyw _rfx3eg5i _oounze3t _7rifglyw",
            __cmplp.className
        ])
    });
});

});
parcelRegister("hJYsP", function(module, exports) {

$parcel$export(module.exports, "BusinessDocumentTitle", () => $08e74678968dfe67$export$416064ba09d98e69);

var $eUqFw = parcelRequire("eUqFw");

var $heNSb = parcelRequire("heNSb");

var $fDLFb = parcelRequire("fDLFb");
const $08e74678968dfe67$export$416064ba09d98e69 = /*#__PURE__*/ (0, $eUqFw.memo)(({ pageHeading: pageHeading })=>{
    const { data: entity } = (0, $fDLFb.useBusinessEntity)();
    const documentTitle = entity?.name ? `${pageHeading} - ${entity.name}` : pageHeading;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $heNSb.DocumentTitle), {
        title: documentTitle
    });
});

});
parcelRegister("heNSb", function(module, exports) {

$parcel$export(module.exports, "DocumentTitle", () => $44af95caa6ad02db$export$dd5ad0b65cf665da);

var $eUqFw = parcelRequire("eUqFw");

var $1TtYL = parcelRequire("1TtYL");

var $3fq1f = parcelRequire("3fq1f");
class $44af95caa6ad02db$export$dd5ad0b65cf665da extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            TitleSubscriber: (0, $1TtYL.DocumentTitleSubscriber)
        };
    }
    shouldComponentUpdate(nextProps) {
        return nextProps.title !== this.props.title;
    }
    render() {
        const { title: title, TitleSubscriber: TitleSubscriber } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(TitleSubscriber, null, ({ contextArray: contextArray }, { setTitle: setTitle, addDocumentTitle: addDocumentTitle, removeDocumentTitle: removeDocumentTitle })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1TtYL.DocumentTitleHelper), {
                title: title,
                setTitle: setTitle,
                addDocumentTitle: addDocumentTitle,
                contextArray: contextArray,
                removeDocumentTitle: removeDocumentTitle,
                TitleSubscriber: TitleSubscriber
            }));
    }
}

});


parcelRegister("kHnEs", function(module, exports) {

$parcel$export(module.exports, "default", () => $f3cc12293a50ce22$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $hSCS8 = parcelRequire("hSCS8");

var $jGcn0 = parcelRequire("jGcn0");


var $hJ992 = parcelRequire("hJ992");

var $cyVXS = parcelRequire("cyVXS");

var $gGtKh = parcelRequire("gGtKh");

var $8WuJm = parcelRequire("8WuJm");
var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $kJlBc = parcelRequire("kJlBc");

var $jK1pm = parcelRequire("jK1pm");

const $f3cc12293a50ce22$export$843a6e93936e3b60 = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("6nr1o")), {
    ssr: false,
    moduleId: "./src/packages/issue/issue-view/src/views/issue-details/modal-issue-app.tsx"
});
const $f3cc12293a50ce22$var$ModalIssueAppWrapper = ({ issueKey: issueKey, onClose: onClose, onChange: onChange, onDeleteSuccess: onDeleteSuccess, analyticsSource: analyticsSource = (0, $0100842672acae20$export$82540942fb014b0a), viewModeSwitchDisabled: viewModeSwitchDisabled, isSoftwareProject: isSoftwareProject })=>{
    const [, setSelectedIssue] = (0, $kJlBc.useQueryParam)((0, $jGcn0.SELECTED_ISSUE_PARAM));
    const onIssueKeyChange = (0, $eUqFw.useCallback)(({ toIssueKey: toIssueKey })=>setSelectedIssue(toIssueKey), [
        setSelectedIssue
    ]);
    const [, { setSidebarContent: setSidebarContent }] = (0, $hSCS8.useSidebar)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [, { setDetailViewAsSidebar: setDetailViewAsSidebar, setDetailViewAsModal: setDetailViewAsModal }] = (0, $hJ992.useIssueContextActions)();
    const onSwitchToModal = (0, $eUqFw.useCallback)(()=>{
        setDetailViewAsModal();
        setSidebarContent(null);
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'issueAppMenuItem clicked', 'switchToModal');
    }, [
        createAnalyticsEvent,
        setDetailViewAsModal,
        setSidebarContent
    ]);
    const onSwitchToSidebar = (0, $eUqFw.useCallback)(()=>{
        setSidebarContent(null);
        setDetailViewAsSidebar();
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'issueAppMenuItem clicked', 'switchToSidebar');
    }, [
        createAnalyticsEvent,
        setDetailViewAsSidebar,
        setSidebarContent
    ]);
    const viewModeOptions = (0, $eUqFw.useMemo)(()=>!viewModeSwitchDisabled ? {
            viewModeSwitchEnabled: true,
            onSwitchToModal: onSwitchToModal,
            onSwitchToSidebar: onSwitchToSidebar
        } : undefined, [
        onSwitchToModal,
        onSwitchToSidebar,
        viewModeSwitchDisabled
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jK1pm.default), {
        name: "business-modal-issue-app"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a),
        sourceName: isSoftwareProject ? 'jswModalIssueApp' : 'jwmModalIssueApp'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cyVXS.ModalBoundary), {
        packageName: isSoftwareProject ? 'software' : 'business',
        id: "issue-modal"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "modal-issue-app",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f3cc12293a50ce22$export$843a6e93936e3b60, {
        analyticsSource: analyticsSource,
        issueKey: issueKey,
        onClose: onClose,
        onChange: onChange,
        onIssueDeleteSuccess: onDeleteSuccess,
        onIssueKeyChange: onIssueKeyChange,
        viewModeOptions: viewModeOptions
    })))));
};
var $f3cc12293a50ce22$export$2e2bcd8739ae039 = $f3cc12293a50ce22$var$ModalIssueAppWrapper;

});
const $0100842672acae20$export$53d41ff2666118e1 = 'agility-backlog';
const $0100842672acae20$export$7552fe2669628499 = 'bitbucket-issue';
const $0100842672acae20$export$41a718da0a8636f4 = 'connect-issue';
const $0100842672acae20$export$cebf0bc8b2ccaf57 = 'core-issue';
const $0100842672acae20$export$5e91e17726e54450 = 'jiraCalendar';
const $0100842672acae20$export$82540942fb014b0a = 'business-calendar';
const $0100842672acae20$export$7ca28938a07e0c33 = 'business-list';
const $0100842672acae20$export$f6cf06aaaeb58a54 = 'business-timeline';
const $0100842672acae20$export$b2c0462ff17aa26e = 'business-board';
const $0100842672acae20$export$a607850ebccd28ac = 'business-approvals';
const $0100842672acae20$export$1da6cede3561048f = 'business-files';
const $0100842672acae20$export$b19f949fb9713614 = 'full-issue';
const $0100842672acae20$export$a5132300c5214280 = 'embed-issue';
const $0100842672acae20$export$710114090a811b37 = 'global-issue-navigator-issue';
const $0100842672acae20$export$ce88447986394f2d = 'mobile-issue';
const $0100842672acae20$export$6a90d9196d330040 = 'project-issue-navigator';
const $0100842672acae20$export$2247c9059c171db1 = 'roadmap-issue';
const $0100842672acae20$export$cd16d39c55c569d0 = 'simple-software-board';
const $0100842672acae20$export$f72626bf0d75dfad = 'software-backlog-issue';
const $0100842672acae20$export$778b4609e784cb27 = 'software-deployments-issue';
const $0100842672acae20$export$5b73d694a6048002 = 'version-detail-issue';
const $0100842672acae20$export$accce97178e4e049 = 'software-cycle-time-report-issue';
const $0100842672acae20$export$21b5b7189add7861 = 'software-incidents-issue';
const $0100842672acae20$export$9c5d81b901471b27 = 'software-issue';
const $0100842672acae20$export$1735f6ad917dc411 = 'change-calendar';
const $0100842672acae20$export$7063ee6d0035a982 = 'queues-issue-view';
const $0100842672acae20$export$5bd5011b6596a0e7 = 'reports-issue-view';
const $0100842672acae20$export$9dfa9e993d3e0520 = 'forge-full-page-extension';
const $0100842672acae20$export$14a8072f422804fd = 'issue-navigator-next';

parcelRegister("hJ992", function(module, exports) {

$parcel$export(module.exports, "useChildIssuesLimit", () => $7e3614f655e5103c$export$8d75f312eaa63aec);
$parcel$export(module.exports, "useChildIssuesIssueLimitUrl", () => $7e3614f655e5103c$export$65a59acd1ffc5bba);
$parcel$export(module.exports, "useIsModal", () => $7e3614f655e5103c$export$9ce8428ff198804a);
$parcel$export(module.exports, "useIssueKey", () => $7e3614f655e5103c$export$22108eca27445997);
$parcel$export(module.exports, "useIssueId", () => $7e3614f655e5103c$export$9df8176b5ffce5ab);
$parcel$export(module.exports, "useIsArchived", () => $7e3614f655e5103c$export$7cd1821433aafaee);
$parcel$export(module.exports, "useIsClassifyEditEnabled", () => $7e3614f655e5103c$export$b23b36ed5c42e920);
$parcel$export(module.exports, "useProjectKey", () => $7e3614f655e5103c$export$f87be37f8e8be65);
$parcel$export(module.exports, "useAnalyticsSource", () => $7e3614f655e5103c$export$aad3917152559b87);
$parcel$export(module.exports, "useIssueContextActions", () => $7e3614f655e5103c$export$d6ec1293313f49ac);
$parcel$export(module.exports, "useRapidViewMap", () => $7e3614f655e5103c$export$4d204e800e4e0be7);
$parcel$export(module.exports, "useEstimationStatistic", () => $7e3614f655e5103c$export$5b20e30ee6db56e9);
$parcel$export(module.exports, "useViewMode", () => $7e3614f655e5103c$export$3a7c3e259b6adb93);
$parcel$export(module.exports, "useBackButtonUrl", () => $7e3614f655e5103c$export$cfe64a334903927c);
$parcel$export(module.exports, "useIssueNavigatorData", () => $7e3614f655e5103c$export$aa008a00bae7e7ab);
$parcel$export(module.exports, "useOnIssueKeyChange", () => $7e3614f655e5103c$export$52c975cf0b623556);
$parcel$export(module.exports, "useRapidViewId", () => $7e3614f655e5103c$export$b34d0ea0bf41fee);
$parcel$export(module.exports, "useViewScreenId", () => $7e3614f655e5103c$export$7c142b5701b4c3f9);
$parcel$export(module.exports, "useHasSoftwareAccess", () => $7e3614f655e5103c$export$dcc0d1c3cd4bd9fb);
$parcel$export(module.exports, "useIsFullPageIssueView", () => $7e3614f655e5103c$export$2e131fc4108f9106);
$parcel$export(module.exports, "useIsEmbedPageIssueView", () => $7e3614f655e5103c$export$4596c26005fbb859);
$parcel$export(module.exports, "useIsAiOptInEnabled", () => $7e3614f655e5103c$export$b131d9f6da853161);

var $eUqFw = parcelRequire("eUqFw");


var $e91YZ = parcelRequire("e91YZ");

var $7HKaW = parcelRequire("7HKaW");
var $6vrw7 = parcelRequire("6vrw7");

var $j3FUN = parcelRequire("j3FUN");
var $jBTMs = parcelRequire("jBTMs");

var $hWdjG = parcelRequire("hWdjG");
const $7e3614f655e5103c$export$8d75f312eaa63aec = ()=>{
    const [childIssuesLimit] = (0, $hWdjG.useIssueContextStoreChildIssuesLimit)();
    return childIssuesLimit;
};
const $7e3614f655e5103c$export$cc6e0a43a2a9b17a = ()=>{
    const [childIssuesIssueLimitUrls] = (0, $hWdjG.useIssueContextStoreChildIssuesIssueLimitUrls)();
    return childIssuesIssueLimitUrls;
};
const $7e3614f655e5103c$export$65a59acd1ffc5bba = (fieldId)=>{
    const childIssuesIssueLimitUrls = $7e3614f655e5103c$export$cc6e0a43a2a9b17a();
    return childIssuesIssueLimitUrls?.[fieldId];
};
const $7e3614f655e5103c$export$9ce8428ff198804a = ()=>{
    const [isModal] = (0, $hWdjG.useIssueContextStoreIsModal)();
    return isModal;
};
const $7e3614f655e5103c$export$22108eca27445997 = ()=>{
    const [issueKey] = (0, $hWdjG.useIssueContextStoreIssueKey)();
    return issueKey;
};
const $7e3614f655e5103c$export$9df8176b5ffce5ab = ()=>{
    const [issueId] = (0, $hWdjG.useIssueContextStoreIssueId)();
    return issueId;
};
const $7e3614f655e5103c$export$7cd1821433aafaee = ()=>{
    const [isArchived] = (0, $hWdjG.useIssueContextStoreIsArchived)();
    return isArchived;
};
const $7e3614f655e5103c$export$b23b36ed5c42e920 = ()=>{
    const [isClassifyEditEnabled] = (0, $hWdjG.useIssueContextStoreIsClassifyEditEnabled)();
    return isClassifyEditEnabled;
};
const $7e3614f655e5103c$export$f87be37f8e8be65 = ()=>{
    const [issueKey] = (0, $hWdjG.useIssueContextStoreIssueKey)();
    return (0, $6vrw7.toProjectKey)(issueKey.split('-')[0]);
};
const $7e3614f655e5103c$export$aad3917152559b87 = ()=>{
    const [analyticsSource] = (0, $hWdjG.useIssueContextStoreAnalyticsSource)();
    return analyticsSource;
};
const $7e3614f655e5103c$export$d6ec1293313f49ac = ()=>{
    const [, { setIssueContext: setIssueContext, mergeIssueContext: mergeIssueContext, getChildIssuesLimit: getChildIssuesLimit, getMaxTokenLength: getMaxTokenLength, getIsLoadedWithPage: getIsLoadedWithPage, getBackButtonUrl: getBackButtonUrl, getIsSpaEnabled: getIsSpaEnabled, getIssueKey: getIssueKey, setDetailViewAsModal: setDetailViewAsModal, setDetailViewAsSidebar: setDetailViewAsSidebar, resetDetailView: resetDetailView }] = (0, $hWdjG.useIssueContextStoreActions)();
    const actions = (0, $eUqFw.useMemo)(()=>({
            setIssueContext: setIssueContext,
            mergeIssueContext: mergeIssueContext,
            getChildIssuesLimit: getChildIssuesLimit,
            getMaxTokenLength: getMaxTokenLength,
            getIsLoadedWithPage: getIsLoadedWithPage,
            getBackButtonUrl: getBackButtonUrl,
            getIsSpaEnabled: getIsSpaEnabled,
            getIssueKey: getIssueKey,
            setDetailViewAsModal: setDetailViewAsModal,
            setDetailViewAsSidebar: setDetailViewAsSidebar,
            resetDetailView: resetDetailView
        }), [
        setIssueContext,
        mergeIssueContext,
        getChildIssuesLimit,
        getMaxTokenLength,
        getIsLoadedWithPage,
        getBackButtonUrl,
        getIsSpaEnabled,
        getIssueKey,
        setDetailViewAsModal,
        setDetailViewAsSidebar,
        resetDetailView
    ]);
    return [
        undefined,
        actions
    ];
};
const $7e3614f655e5103c$export$4d204e800e4e0be7 = ()=>{
    const [rapidViewMap] = (0, $hWdjG.useIssueContextRapidViewMap)();
    return rapidViewMap;
};
const $7e3614f655e5103c$export$e0d7666ae716c88a = ()=>{
    const [maxTokenLength] = (0, $hWdjG.useIssueContextStoreMaxTokenLength)();
    return maxTokenLength;
};
const $7e3614f655e5103c$export$b4199f923267161e = ()=>{
    const [isLoadedWithPage] = (0, $hWdjG.useIssueContextStoreIsLoadedWithPage)();
    return isLoadedWithPage;
};
const $7e3614f655e5103c$export$5b20e30ee6db56e9 = ()=>{
    const [estimationStatistic] = (0, $hWdjG.useIssueContextStoreEstimationStatistic)();
    return estimationStatistic;
};
const $7e3614f655e5103c$export$4dface15d86304a4 = ()=>{
    const [isLoading] = (0, $hWdjG.useIssueContextStoreIsLoading)();
    return isLoading;
};
const $7e3614f655e5103c$export$3a7c3e259b6adb93 = ()=>{
    const [viewMode] = (0, $hWdjG.useIssueContextStoreViewMode)();
    return viewMode;
};
const $7e3614f655e5103c$export$cfe64a334903927c = ()=>{
    const [backButtonUrl] = (0, $hWdjG.useIssueContextStoreBackButtonUrl)();
    return backButtonUrl;
};
const $7e3614f655e5103c$export$aa008a00bae7e7ab = ()=>{
    const [issueNavigatorData] = (0, $hWdjG.useIssueContextStoreIssueNavigatorData)();
    return issueNavigatorData;
};
const $7e3614f655e5103c$export$b49754504c41149f = ()=>{
    const [boardId] = (0, $hWdjG.useIssueContextStoreBoardId)();
    return boardId;
};
const $7e3614f655e5103c$export$91aab984882a2a2c = ()=>{
    const [boardType] = (0, $hWdjG.useIssueContextStoreBoardType)();
    return boardType;
};
const $7e3614f655e5103c$export$dbad9dbd4871f2e9 = ()=>{
    const [isSpaEnabled] = (0, $hWdjG.useIssueContextStoreIsSpaEnabled)();
    return isSpaEnabled;
};
const $7e3614f655e5103c$export$7be495880d433ab9 = ()=>{
    const [loginRedirectUrl] = (0, $hWdjG.useIssueContextStoreLoginRedirctUrl)();
    return loginRedirectUrl;
};
const $7e3614f655e5103c$export$52c975cf0b623556 = ()=>{
    const [onIssueKeyChange] = (0, $hWdjG.useIssueContextStoreOnIssueKeyChange)();
    return onIssueKeyChange;
};
const $7e3614f655e5103c$export$b34d0ea0bf41fee = ()=>{
    const [rapidViewId] = (0, $hWdjG.useIssueContextStoreRapidViewId)();
    return rapidViewId;
};
const $7e3614f655e5103c$export$7c142b5701b4c3f9 = ()=>{
    const [viewScreenId] = (0, $hWdjG.useIssueContextStoreViewScreenId)();
    return viewScreenId;
};
const $7e3614f655e5103c$export$dcc0d1c3cd4bd9fb = ()=>{
    const licensedProducts = (0, $j3FUN.useLicensedProducts)();
    const licenseStates = (0, $jBTMs.useLicenseStates)();
    const isJiraSoftwareLicenseActive = licenseStates && licenseStates.software === (0, $7HKaW.LICENSE_STATE_ACTIVE);
    return licensedProducts[(0, $e91YZ.LICENSED_PRODUCTS).JIRA_SOFTWARE] && isJiraSoftwareLicenseActive;
};
const $7e3614f655e5103c$export$2e131fc4108f9106 = ()=>{
    const analyticsSource = $7e3614f655e5103c$export$aad3917152559b87();
    return analyticsSource === (0, $0100842672acae20$export$b19f949fb9713614);
};
const $7e3614f655e5103c$export$4596c26005fbb859 = ()=>{
    const analyticsSource = $7e3614f655e5103c$export$aad3917152559b87();
    return analyticsSource === (0, $0100842672acae20$export$a5132300c5214280);
};
const $7e3614f655e5103c$export$b131d9f6da853161 = ()=>{
    const [isAiOptInEnabled] = (0, $hWdjG.useIssueContextIsAiOptInEnabled)();
    return isAiOptInEnabled;
};

});
parcelRegister("j3FUN", function(module, exports) {

$parcel$export(module.exports, "useLicensedProducts", () => $02df0e5ac33ae573$export$54d534cc91e54850);

var $gd0Sp = parcelRequire("gd0Sp");
const $02df0e5ac33ae573$export$54d534cc91e54850 = ()=>{
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    return tenantContext && tenantContext.licensedProducts || {};
};

});

parcelRegister("jBTMs", function(module, exports) {

$parcel$export(module.exports, "useLicenseStates", () => $0a5df676eadd90b5$export$268651a63abe408a);

var $gd0Sp = parcelRequire("gd0Sp");
const $0a5df676eadd90b5$export$268651a63abe408a = ()=>{
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    return tenantContext && tenantContext.licenseStates;
};

});

parcelRegister("hWdjG", function(module, exports) {

$parcel$export(module.exports, "useIssueContextStoreChildIssuesLimit", () => $c495211a89197754$export$abdbea56d86b4aac);
$parcel$export(module.exports, "useIssueContextStoreChildIssuesIssueLimitUrls", () => $c495211a89197754$export$326ff2b963d51c5c);
$parcel$export(module.exports, "useIssueContextStoreIssueKey", () => $c495211a89197754$export$44bcaaabb74e402b);
$parcel$export(module.exports, "useIssueContextStoreIssueId", () => $c495211a89197754$export$332dcee0cf9f4e45);
$parcel$export(module.exports, "useIssueContextStoreIsArchived", () => $c495211a89197754$export$c940355b1fc6e1c4);
$parcel$export(module.exports, "useIssueContextStoreIsClassifyEditEnabled", () => $c495211a89197754$export$b9eebaa1da421997);
$parcel$export(module.exports, "useIssueContextStoreIsModal", () => $c495211a89197754$export$daa47fd600e43a32);
$parcel$export(module.exports, "useIssueContextStoreViewScreenId", () => $c495211a89197754$export$ba2e9546ab5ba6f);
$parcel$export(module.exports, "useIssueContextStoreAnalyticsSource", () => $c495211a89197754$export$74d38d6c437efc1b);
$parcel$export(module.exports, "useIssueContextRapidViewMap", () => $c495211a89197754$export$2092528ee170d9e7);
$parcel$export(module.exports, "useIssueContextStoreMaxTokenLength", () => $c495211a89197754$export$57898374e6239a5a);
$parcel$export(module.exports, "useIssueContextStoreIsLoadedWithPage", () => $c495211a89197754$export$ff0264ec4c015dc1);
$parcel$export(module.exports, "useIssueContextStoreEstimationStatistic", () => $c495211a89197754$export$6c8b81f6dca8c23d);
$parcel$export(module.exports, "useIssueContextStoreIsLoading", () => $c495211a89197754$export$fe7085456138f0fc);
$parcel$export(module.exports, "useIssueContextStoreViewMode", () => $c495211a89197754$export$c339e36468c12443);
$parcel$export(module.exports, "useIssueContextStoreBackButtonUrl", () => $c495211a89197754$export$ef3bfa2642bb98cd);
$parcel$export(module.exports, "useIssueContextStoreIssueNavigatorData", () => $c495211a89197754$export$8accd063c74cd455);
$parcel$export(module.exports, "useIssueContextStoreBoardId", () => $c495211a89197754$export$e7edffc2a20027e7);
$parcel$export(module.exports, "useIssueContextStoreBoardType", () => $c495211a89197754$export$48aaa3a6bc2085d7);
$parcel$export(module.exports, "useIssueContextStoreIsSpaEnabled", () => $c495211a89197754$export$4a4b96bcf5166327);
$parcel$export(module.exports, "useIssueContextStoreLoginRedirctUrl", () => $c495211a89197754$export$bbd8ba0180545556);
$parcel$export(module.exports, "useIssueContextStoreOnIssueKeyChange", () => $c495211a89197754$export$aaa89627762c7d00);
$parcel$export(module.exports, "useIssueContextStoreRapidViewId", () => $c495211a89197754$export$796589b0ec52848a);
$parcel$export(module.exports, "useIssueContextIsAiOptInEnabled", () => $c495211a89197754$export$7e70ee570119a0a7);
$parcel$export(module.exports, "IssueContextContainer", () => $c495211a89197754$export$93db6a8f3342dddf);
$parcel$export(module.exports, "useIssueContextStoreActions", () => $c495211a89197754$export$965360ae27fcae98);

var $heB5U = parcelRequire("heB5U");
var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");

var $6vrw7 = parcelRequire("6vrw7");

var $8d785 = parcelRequire("8d785");

var $hHM8F = parcelRequire("hHM8F");

var $fhgeS = parcelRequire("fhgeS");
const $c495211a89197754$export$d4c72bab9d6cc13a = {
    childIssuesLimit: undefined,
    childIssuesIssueLimitUrls: undefined,
    issueKey: (0, $6vrw7.toIssueKey)(''),
    isArchived: false,
    isClassifyEditEnabled: false,
    isModal: false,
    maxTokenLength: 0,
    isLoadedWithPage: false,
    rapidViewMap: undefined,
    estimationStatistic: undefined,
    isLoading: false,
    // initialise viewMode with the value stored in local storage
    viewMode: (0, $fhgeS.getViewModeFromLocalStorage)(),
    analyticsSource: undefined,
    backButtonUrl: undefined,
    issueNavigatorData: undefined,
    boardId: undefined,
    boardType: undefined,
    isSpaEnabled: false,
    loginRedirectUrl: undefined,
    onIssueKeyChange: undefined,
    rapidViewId: undefined,
    viewScreenId: undefined,
    isAiOptInEnabled: false
};
const $c495211a89197754$export$6f57813fe9f31bf9 = (0, $a61MH.createStore)({
    name: 'issue-context',
    initialState: $c495211a89197754$export$d4c72bab9d6cc13a,
    actions: $8d785.actions
});
const $c495211a89197754$var$getIssueContext = (state)=>state;
const $c495211a89197754$var$getIsModal = (state)=>state.isModal;
const $c495211a89197754$var$getIssueKey = (state)=>state.issueKey;
const $c495211a89197754$var$getIsArchived = (state)=>state.isArchived;
const $c495211a89197754$var$getIsClassifyEditEnabled = (state)=>state.isClassifyEditEnabled;
const $c495211a89197754$var$getIssueId = (state)=>state.issueId;
// @ts-expect-error - TS7006 - Parameter 'state' implicitly has an 'any' type.
const $c495211a89197754$var$getAnalyticsSource = (state)=>state.analyticsSource !== undefined ? state.analyticsSource : undefined;
const $c495211a89197754$var$getRapidViewMap = (state)=>state.rapidViewMap;
const $c495211a89197754$var$getMaxTokenLength = (state)=>state.maxTokenLength;
const $c495211a89197754$var$getIsLoadedWithPage = (state)=>state.isLoadedWithPage;
const $c495211a89197754$var$getEstimationStatistic = (state)=>state.estimationStatistic;
const $c495211a89197754$var$getIsLoading = (state)=>state.isLoading;
const $c495211a89197754$var$getViewMode = (state)=>state.viewMode;
const $c495211a89197754$var$getBackButtonUrl = (state)=>state.backButtonUrl;
const $c495211a89197754$var$getIssueNavigatorData = (state)=>state.issueNavigatorData;
const $c495211a89197754$var$getBoardId = (state)=>state.boardId;
const $c495211a89197754$var$getBoardType = (state)=>state.boardType;
const $c495211a89197754$var$getIsSpaEnabled = (state)=>state.isSpaEnabled;
const $c495211a89197754$var$getLoginRedirectUrl = (state)=>state.loginRedirectUrl;
const $c495211a89197754$var$getOnIssueKeyChange = (state)=>state.onIssueKeyChange;
const $c495211a89197754$var$getRapidViewId = (state)=>state.rapidViewId;
const $c495211a89197754$var$getViewScreenId = (state)=>state.viewScreenId;
const $c495211a89197754$var$getIsAiOptInEnabled = (state)=>Boolean(state.isAiOptInEnabled);
const $c495211a89197754$export$f6e0a3ee03299fbc = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getIssueContext
});
const $c495211a89197754$export$abdbea56d86b4aac = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: (0, $hHM8F.getChildIssuesLimit)
});
const $c495211a89197754$export$326ff2b963d51c5c = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: (0, $hHM8F.getChildIssuesIssueLimitUrls)
});
const $c495211a89197754$export$44bcaaabb74e402b = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getIssueKey
});
const $c495211a89197754$export$332dcee0cf9f4e45 = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getIssueId
});
const $c495211a89197754$export$c940355b1fc6e1c4 = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getIsArchived
});
const $c495211a89197754$export$b9eebaa1da421997 = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getIsClassifyEditEnabled
});
const $c495211a89197754$export$daa47fd600e43a32 = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getIsModal
});
const $c495211a89197754$export$ba2e9546ab5ba6f = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getViewScreenId
});
const $c495211a89197754$export$74d38d6c437efc1b = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getAnalyticsSource
});
const $c495211a89197754$export$2092528ee170d9e7 = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getRapidViewMap
});
const $c495211a89197754$export$57898374e6239a5a = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getMaxTokenLength
});
const $c495211a89197754$export$ff0264ec4c015dc1 = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getIsLoadedWithPage
});
const $c495211a89197754$export$6c8b81f6dca8c23d = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getEstimationStatistic
});
const $c495211a89197754$export$fe7085456138f0fc = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getIsLoading
});
const $c495211a89197754$export$c339e36468c12443 = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getViewMode
});
const $c495211a89197754$export$ef3bfa2642bb98cd = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getBackButtonUrl
});
const $c495211a89197754$export$8accd063c74cd455 = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getIssueNavigatorData
});
const $c495211a89197754$export$e7edffc2a20027e7 = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getBoardId
});
const $c495211a89197754$export$48aaa3a6bc2085d7 = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getBoardType
});
const $c495211a89197754$export$4a4b96bcf5166327 = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getIsSpaEnabled
});
const $c495211a89197754$export$bbd8ba0180545556 = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getLoginRedirectUrl
});
const $c495211a89197754$export$aaa89627762c7d00 = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getOnIssueKeyChange
});
const $c495211a89197754$export$796589b0ec52848a = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getRapidViewId
});
const $c495211a89197754$export$7e70ee570119a0a7 = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getIsAiOptInEnabled
});
const $c495211a89197754$export$93db6a8f3342dddf = (0, $heB5U.createContainer)($c495211a89197754$export$6f57813fe9f31bf9);
const $c495211a89197754$export$965360ae27fcae98 = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: null
});

});
parcelRegister("8d785", function(module, exports) {

$parcel$export(module.exports, "actions", () => $0a3f8ba487c482e8$export$e324594224ef24da);

var $7LyiF = parcelRequire("7LyiF");

var $hHM8F = parcelRequire("hHM8F");


var $fhgeS = parcelRequire("fhgeS");
const $0a3f8ba487c482e8$export$784a03c4b74da53e = (issueContext)=>({ setState: setState, getState: getState })=>{
        const { issueKey: currentIssueKey, issueId: currentIssueId } = getState();
        // ARKEN-792: reset issueId on issueKey change if issueId isn't provided
        if (currentIssueId && currentIssueKey && !issueContext.issueId && issueContext.issueKey !== currentIssueKey) setState({
            ...issueContext,
            issueId: undefined,
            viewMode: issueContext.viewMode || getState().viewMode
        });
        else setState({
            ...issueContext,
            viewMode: issueContext.viewMode || getState().viewMode
        });
    };
const $0a3f8ba487c482e8$export$666ee48e0eaf4f13 = (partialIssueContext)=>({ getState: getState, setState: setState })=>{
        const { issueKey: currentIssueKey, issueId: currentIssueId } = getState();
        // ARKEN-792: reset issueId on issueKey change if issueId isn't provided
        if (currentIssueId && currentIssueKey && !partialIssueContext.issueId && partialIssueContext.issueKey && partialIssueContext.issueKey !== currentIssueKey) setState({
            ...getState(),
            ...partialIssueContext,
            issueId: undefined
        });
        else setState({
            ...getState(),
            ...partialIssueContext
        });
    };
const $0a3f8ba487c482e8$export$89b6937a83edcaa6 = ()=>({ getState: getState })=>(0, $hHM8F.getChildIssuesLimit)(getState());
const $0a3f8ba487c482e8$export$e40f2acaf1a50b00 = ()=>({ getState: getState })=>getState().maxTokenLength;
const $0a3f8ba487c482e8$export$2fe981b90be13483 = ()=>({ getState: getState })=>getState().isLoadedWithPage;
const $0a3f8ba487c482e8$export$afce556782490aae = ()=>({ getState: getState })=>getState().backButtonUrl;
const $0a3f8ba487c482e8$export$711dfa096bf81f2d = ()=>({ getState: getState })=>getState().isSpaEnabled;
const $0a3f8ba487c482e8$export$4a030f6192bebe03 = ()=>({ getState: getState })=>getState().issueKey;
const $0a3f8ba487c482e8$export$b41341ac6c74ca6 = ()=>({ getState: getState })=>getState().isArchived;
const $0a3f8ba487c482e8$export$77ec0de2f63f10c4 = (willSave = true)=>({ setState: setState })=>{
        if (willSave) (0, $7LyiF.localStorage).set((0, $7LyiF.VIEW_MODE_STORAGE_KEY), (0, $935e771f19f8ea28$export$98c0ebc22792f04));
        setState({
            viewMode: (0, $935e771f19f8ea28$export$98c0ebc22792f04)
        });
    };
const $0a3f8ba487c482e8$export$b303af51de56a0e = (willSave = true)=>({ setState: setState })=>{
        if (willSave) (0, $7LyiF.localStorage).set((0, $7LyiF.VIEW_MODE_STORAGE_KEY), (0, $935e771f19f8ea28$export$705305d6da432040));
        setState({
            viewMode: (0, $935e771f19f8ea28$export$705305d6da432040)
        });
    };
const $0a3f8ba487c482e8$export$75007d125f198b78 = ()=>({ setState: setState })=>{
        setState({
            viewMode: (0, $fhgeS.getViewModeFromLocalStorage)()
        });
    };
const $0a3f8ba487c482e8$export$e324594224ef24da = {
    setIssueContext: $0a3f8ba487c482e8$export$784a03c4b74da53e,
    mergeIssueContext: $0a3f8ba487c482e8$export$666ee48e0eaf4f13,
    getChildIssuesLimit: $0a3f8ba487c482e8$export$89b6937a83edcaa6,
    getMaxTokenLength: $0a3f8ba487c482e8$export$e40f2acaf1a50b00,
    getIsLoadedWithPage: $0a3f8ba487c482e8$export$2fe981b90be13483,
    getBackButtonUrl: $0a3f8ba487c482e8$export$afce556782490aae,
    getIsSpaEnabled: $0a3f8ba487c482e8$export$711dfa096bf81f2d,
    getIssueKey: $0a3f8ba487c482e8$export$4a030f6192bebe03,
    getIsArchived: $0a3f8ba487c482e8$export$b41341ac6c74ca6,
    setDetailViewAsModal: $0a3f8ba487c482e8$export$77ec0de2f63f10c4,
    setDetailViewAsSidebar: $0a3f8ba487c482e8$export$b303af51de56a0e,
    resetDetailView: $0a3f8ba487c482e8$export$75007d125f198b78
};

});
parcelRegister("7LyiF", function(module, exports) {

$parcel$export(module.exports, "LOG_LOCATION", () => $7643f341d271ccc9$export$25a759e49d5049db);
$parcel$export(module.exports, "localStorage", () => $7643f341d271ccc9$export$c2ed3351cac403d1);
$parcel$export(module.exports, "VIEW_MODE_STORAGE_KEY", () => $7643f341d271ccc9$export$a13f7f627010bccd);

var $aZaPn = parcelRequire("aZaPn");
const $7643f341d271ccc9$export$25a759e49d5049db = 'issue.issue-context-service';
const $7643f341d271ccc9$export$c2ed3351cac403d1 = (0, $aZaPn.createLocalStorageProvider)('jira_issue_view');
const $7643f341d271ccc9$export$a13f7f627010bccd = 'view-mode';

});

parcelRegister("hHM8F", function(module, exports) {

$parcel$export(module.exports, "getChildIssuesLimit", () => $a9a8c93b5bcca8ab$export$89b6937a83edcaa6);
$parcel$export(module.exports, "getChildIssuesIssueLimitUrls", () => $a9a8c93b5bcca8ab$export$8f43520910e8128c);

var $gUUjF = parcelRequire("gUUjF");

var $7LyiF = parcelRequire("7LyiF");
// This is here solely as a last resort option if the backend for some reason
// is unable to propagate the limit. Or if somehow the code that populates
// this store is broken.
// 500 is the current limit reflected in the backend at the time of writing.
const $a9a8c93b5bcca8ab$var$FALLBACK_CHILD_ISSUES_LIMIT = 500;
const $a9a8c93b5bcca8ab$var$getFallbackChildIssuesLimitAndLogAsUnexpected = ()=>{
    (0, $gUUjF.default).safeErrorWithoutCustomerData(`${(0, $7LyiF.LOG_LOCATION)}.selectors.getChildIssuesLimit`, 'The child issues limit is undefined using the fallback child issues limit');
    return $a9a8c93b5bcca8ab$var$FALLBACK_CHILD_ISSUES_LIMIT;
};
const $a9a8c93b5bcca8ab$export$89b6937a83edcaa6 = (state)=>state.childIssuesLimit ?? $a9a8c93b5bcca8ab$var$getFallbackChildIssuesLimitAndLogAsUnexpected();
const $a9a8c93b5bcca8ab$export$8f43520910e8128c = (state)=>state.childIssuesIssueLimitUrls;

});

const $935e771f19f8ea28$export$98c0ebc22792f04 = 'MODAL';
const $935e771f19f8ea28$export$705305d6da432040 = 'SIDEBAR';
const $935e771f19f8ea28$export$2d037fdba4f67558 = 'DEFAULT';
const $935e771f19f8ea28$export$8bcece6b344db0b9 = 'FIELD';
const $935e771f19f8ea28$export$f65dd83d96b675ee = 'DEV_SUMMARY';
const $935e771f19f8ea28$export$971ccedc18d35178 = 'RELEASES_PANEL';
const $935e771f19f8ea28$export$18e4c648db363204 = 'PANEL';
const $935e771f19f8ea28$export$7f66491e43ca5015 = 'TAB';

parcelRegister("fhgeS", function(module, exports) {

$parcel$export(module.exports, "getViewModeFromLocalStorage", () => $49ad189ccd6ad8c9$export$cae7c4c591dcc261);

var $7LyiF = parcelRequire("7LyiF");

const $49ad189ccd6ad8c9$export$cae7c4c591dcc261 = ()=>(0, $7LyiF.localStorage).get((0, $7LyiF.VIEW_MODE_STORAGE_KEY)) || (0, $935e771f19f8ea28$export$2d037fdba4f67558);

});




parcelRegister("cyVXS", function(module, exports) {

$parcel$export(module.exports, "ModalBoundary", () => $f96d169c5da11246$export$c3f500e812fb1bb3);

var $eUqFw = parcelRequire("eUqFw");

var $h97Af = parcelRequire("h97Af");

var $ciZ8Y = parcelRequire("ciZ8Y");

var $fee69 = parcelRequire("fee69");

var $gGtKh = parcelRequire("gGtKh");
const $f96d169c5da11246$export$c3f500e812fb1bb3 = ({ children: children, id: id, metricKey: metricKey, packageName: packageName, onError: onError })=>{
    const ErrorState = (0, $eUqFw.useCallback)((args)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fee69.ErrorFlagRenderer), {
            id: id,
            error: args.error
        }), [
        id
    ]);
    const fallback = typeof metricKey === 'string' && metricKey.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h97Af.default), {
        metricKey: metricKey
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ciZ8Y.ErrorBoundary), {
        id: id,
        packageName: packageName,
        render: ErrorState,
        onError: onError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: id,
        fallback: fallback
    }, children));
};

});

parcelRegister("6nr1o", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('kWrFZ'),
            load('h2MrD'),
            load('bYT2S'),
            load('2hmUs'),
            load('bCeK4'),
            load('aTMMU')
        ]);
        const value = parcelRequire('kjWxV');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("kWrFZ"),
        load("h2MrD"),
        load("bYT2S"),
        load("2hmUs"),
        load("bCeK4"),
        load("aTMMU")
    ]).then(()=>parcelRequire('kjWxV'));
}

});


parcelRegister("9u6Jh", function(module, exports) {

$parcel$export(module.exports, "SidebarIssueView", () => $134113658c67db96$export$ccdf533f42a8d6f8);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $hSCS8 = parcelRequire("hSCS8");

var $hzcvF = parcelRequire("hzcvF");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $6vrw7 = parcelRequire("6vrw7");

var $bw53Y = parcelRequire("bw53Y");

var $4LhhW = parcelRequire("4LhhW");
const $134113658c67db96$var$ISSUE_VIEW_SIDEBAR_CONTENT_KEY = 'issueViewSidebar';
const $134113658c67db96$var$callWhenIdle = (callback)=>{
    if (typeof window.requestIdleCallback === 'function') window.requestIdleCallback(callback);
    else setTimeout(callback, 3000);
};
const $134113658c67db96$export$ccdf533f42a8d6f8 = /*#__PURE__*/ (0, $eUqFw.memo)(({ issueKey: issueKey, onClose: onClose, analyticsSource: analyticsSource, onChange: onChange, onIssueDeleteSuccess: onIssueDeleteSuccess, isSoftwareProject: isSoftwareProject })=>{
    const [{ content: content }, { setSidebarContent: setSidebarContent }] = (0, $hSCS8.useSidebar)();
    const prevIssueKey = (0, $hzcvF.usePreviousWithInitial)(issueKey);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    (0, $4LhhW.useSetSidebarStyleVar)();
    const onCloseSidebar = (0, $eUqFw.useCallback)(()=>{
        onClose();
    }, [
        onClose
    ]);
    (0, $eUqFw.useEffect)(()=>{
        // avoid re-rendering in case props aren't memoised
        if (issueKey === prevIssueKey && !!content) return;
        if (issueKey) {
            const newContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($134113658c67db96$var$CSSAntiCorruptionLayer, {
                key: $134113658c67db96$var$ISSUE_VIEW_SIDEBAR_CONTENT_KEY
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bw53Y.SidebarIssueApp), {
                issueKey: (0, $6vrw7.toIssueKey)(issueKey),
                onClose: onCloseSidebar,
                analyticsSource: analyticsSource,
                onChange: onChange,
                onIssueDeleteSuccess: onIssueDeleteSuccess,
                isSoftwareProject: isSoftwareProject
            }));
            setSidebarContent(newContent);
            (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'sidebarIssueApp opened');
        } else {
            if (content?.key === $134113658c67db96$var$ISSUE_VIEW_SIDEBAR_CONTENT_KEY) setSidebarContent(null);
            (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'sidebarIssueApp closed');
        }
    }, [
        analyticsSource,
        content,
        createAnalyticsEvent,
        isSoftwareProject,
        issueKey,
        onChange,
        onCloseSidebar,
        onIssueDeleteSuccess,
        prevIssueKey,
        setSidebarContent
    ]);
    (0, $eUqFw.useEffect)(()=>{
        // Preload IssueApp here, otherwise it'd be loaded when Sidebar opens up for the first time, which is a bit slow
        $134113658c67db96$var$callWhenIdle(()=>{
            (0, $bw53Y.IssueApp).preload();
        });
    }, []);
    return null;
});
// put an extra div around issue view to "adopt" styles from `SidebarContent` (`> div`)
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $134113658c67db96$var$CSSAntiCorruptionLayer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i1osq _vchhusvi",
            __cmplp.className
        ])
    });
});

});
parcelRegister("bw53Y", function(module, exports) {

$parcel$export(module.exports, "IssueApp", () => $1d0bd87d82d1f36e$export$35dd9ab573b87c3f);
$parcel$export(module.exports, "SidebarIssueApp", () => $1d0bd87d82d1f36e$export$e402f7c18d4d7f37);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $7rh0R = parcelRequire("7rh0R");

var $hSCS8 = parcelRequire("hSCS8");

var $hJ992 = parcelRequire("hJ992");

var $gJYxu = parcelRequire("gJYxu");

var $gGtKh = parcelRequire("gGtKh");

var $hzcvF = parcelRequire("hzcvF");

var $8WuJm = parcelRequire("8WuJm");
var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $c4qEZ = parcelRequire("c4qEZ");

var $jK1pm = parcelRequire("jK1pm");

const $1d0bd87d82d1f36e$export$35dd9ab573b87c3f = (0, $7rh0R.lazy)(()=>(parcelRequire("hicnb")), {
    moduleId: "./src/packages/issue/issue-view/src/views/issue-details/issue-app.tsx"
});
const $1d0bd87d82d1f36e$export$e402f7c18d4d7f37 = ({ analyticsSource: analyticsSource, issueKey: issueKey, onClose: onClose, onIssueDeleteSuccess: onIssueDeleteSuccess, onChange: onChange, isSoftwareProject: isSoftwareProject })=>{
    const [currentIssueKey, setCurrentIssueKey] = (0, $eUqFw.useState)(issueKey);
    const prevIssueKey = (0, $hzcvF.usePreviousWithInitial)(issueKey);
    // @ts-expect-error - TS7031 - Binding element 'nextIssueKey' implicitly has an 'any' type.
    const onIssueKeyChange = (0, $eUqFw.useCallback)(({ toIssueKey: nextIssueKey })=>{
        setCurrentIssueKey(nextIssueKey);
    }, []);
    const [, { setDetailViewAsSidebar: setDetailViewAsSidebar, setDetailViewAsModal: setDetailViewAsModal }] = (0, $hJ992.useIssueContextActions)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [, { setSidebarContent: setSidebarContent }] = (0, $hSCS8.useSidebar)();
    (0, $eUqFw.useEffect)(()=>{
        if (prevIssueKey !== issueKey) setCurrentIssueKey(issueKey);
    }, [
        currentIssueKey,
        issueKey,
        prevIssueKey
    ]);
    const onSwitchToModal = (0, $eUqFw.useCallback)(()=>{
        setDetailViewAsModal();
        setSidebarContent(null);
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'issueAppMenuItem clicked', 'switchToModal');
    }, [
        createAnalyticsEvent,
        setDetailViewAsModal,
        setSidebarContent
    ]);
    const onSwitchToSidebar = (0, $eUqFw.useCallback)(()=>{
        setDetailViewAsSidebar();
        setSidebarContent(null);
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'issueAppMenuItem clicked', 'switchToSidebar');
    }, [
        createAnalyticsEvent,
        setDetailViewAsSidebar,
        setSidebarContent
    ]);
    const PACKAGE_NAME = (0, $eUqFw.useMemo)(()=>isSoftwareProject ? 'jswSidebarIssueApp' : 'jwmSidebarIssueApp', [
        isSoftwareProject
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jK1pm.default), {
        name: "business-sidebar-issue-app"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a),
        sourceName: PACKAGE_NAME
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "issue-app",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c4qEZ.IssueViewSkeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gJYxu.IssueBoundary), {
        packageName: PACKAGE_NAME
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1d0bd87d82d1f36e$export$35dd9ab573b87c3f, {
        viewModeOptions: {
            viewMode: (0, $935e771f19f8ea28$export$705305d6da432040),
            viewModeSwitchEnabled: true,
            onSwitchToModal: onSwitchToModal,
            onSwitchToSidebar: onSwitchToSidebar
        },
        issueKey: currentIssueKey,
        analyticsSource: analyticsSource,
        shouldShowCloseButton: true,
        onClose: onClose,
        onIssueKeyChange: onIssueKeyChange,
        shouldSetInitialFocus: true,
        shouldShowRootProjectsBreadcrumb: true,
        onIssueDeleteSuccess: onIssueDeleteSuccess,
        onIssueDeleteFailure: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
        isSpaEnabled: false,
        isLoadedWithPage: false,
        onChange: onChange
    })))));
};

});
parcelRegister("gJYxu", function(module, exports) {

$parcel$export(module.exports, "IssueBoundary", () => $47dde6f657625382$export$fbf48ede0cf52b5a);
$parcel$export(module.exports, "IssueModalBoundary", () => $47dde6f657625382$export$74d408982642a541);
// eslint-disable-next-line jira/restricted/react-component-props

var $eUqFw = parcelRequire("eUqFw");

var $ciZ8Y = parcelRequire("ciZ8Y");

var $cyVXS = parcelRequire("cyVXS");

var $gGtKh = parcelRequire("gGtKh");

var $c4qEZ = parcelRequire("c4qEZ");
const $47dde6f657625382$export$fbf48ede0cf52b5a = ({ children: children, isEmbedView: isEmbedView = true, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ciZ8Y.ErrorBoundary), {
        id: "issue",
        ...props
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "issue-boundary",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c4qEZ.IssueViewSkeleton), {
            isEmbedView: isEmbedView
        })
    }, children));
const $47dde6f657625382$export$74d408982642a541 = ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cyVXS.ModalBoundary), {
        id: "issue-modal",
        ...props
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "issue-modal-boundary",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c4qEZ.IssueViewSkeleton), {
            isModalView: true
        })
    }, children));

});

parcelRegister("hicnb", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('kWrFZ'),
            load('92sUi'),
            load('i5RRW'),
            load('dsiAd'),
            load('2hmUs'),
            load('bCeK4'),
            load('hPzOn'),
            load('h2MrD'),
            load('bYT2S'),
            load('kMAKK')
        ]);
        const value = parcelRequire('9zAkH');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("kWrFZ"),
        load("92sUi"),
        load("i5RRW"),
        load("dsiAd"),
        load("2hmUs"),
        load("bCeK4"),
        load("hPzOn"),
        load("h2MrD"),
        load("bYT2S"),
        load("kMAKK")
    ]).then(()=>parcelRequire('9zAkH'));
}

});


parcelRegister("4LhhW", function(module, exports) {

$parcel$export(module.exports, "useSetSidebarStyleVar", () => $94858a1aa5f6a192$export$70b20cd72362e39d);

var $eUqFw = parcelRequire("eUqFw");

var $hSCS8 = parcelRequire("hSCS8");


var $53ucm = parcelRequire("53ucm");
const $94858a1aa5f6a192$var$MARGIN = 24;
const $94858a1aa5f6a192$export$70b20cd72362e39d = ()=>{
    const [{ content: content, sidebarWidth: sidebarWidth }] = (0, $hSCS8.useSidebar)();
    const { setWidth: setWidth } = (0, $53ucm.useDetailPanelActions)();
    (0, $eUqFw.useEffect)(()=>{
        if (content !== null) {
            document.documentElement?.style.setProperty((0, $29bf8722faf6f5bf$export$c83c5cba188418d8), `${sidebarWidth}px`);
            setWidth(sidebarWidth + $94858a1aa5f6a192$var$MARGIN);
        } else document.documentElement?.style.removeProperty((0, $29bf8722faf6f5bf$export$c83c5cba188418d8));
        return ()=>{
            setWidth(0);
        };
    }, [
        content,
        setWidth,
        sidebarWidth
    ]);
};

});
const $29bf8722faf6f5bf$export$c83c5cba188418d8 = '--detailPanelWidth';



parcelRegister("5I9Im", function(module, exports) {

$parcel$export(module.exports, "PrefetchIssueDataController", () => $1fd41398a8791bc6$export$1e95fb877713bf5e);

var $eUqFw = parcelRequire("eUqFw");

var $jGcn0 = parcelRequire("jGcn0");

var $hzcvF = parcelRequire("hzcvF");

var $kJlBc = parcelRequire("kJlBc");

var $hYeSy = parcelRequire("hYeSy");

var $1SYbt = parcelRequire("1SYbt");
const $1fd41398a8791bc6$var$IssueDataLoader = /*#__PURE__*/ (0, $eUqFw.memo)(({ issues: issues })=>issues.map((issueKey)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1SYbt.AsyncIssueViewCriticalDataLoader), {
            key: issueKey,
            issueKey: issueKey
        })));
const $1fd41398a8791bc6$export$1e95fb877713bf5e = ()=>{
    const { prefetchedIssues: prefetchedIssues } = (0, $hYeSy.usePrefetchIssueViewData)();
    const { clearCache: clearCache } = (0, $hYeSy.usePrefetchIssueViewDataActions)();
    const [selectedIssueKey] = (0, $kJlBc.useQueryParam)((0, $jGcn0.SELECTED_ISSUE_PARAM));
    const prevSelectedIssueKey = (0, $hzcvF.usePreviousWithInitial)(selectedIssueKey);
    (0, $eUqFw.useEffect)(()=>{
        const isIssueAppClosed = prevSelectedIssueKey && !selectedIssueKey;
        const isIssueKeyUpdated = selectedIssueKey && prevSelectedIssueKey && selectedIssueKey !== prevSelectedIssueKey;
        // clear cache when user closes Issue modal or opens another issue without closing it (ie via breadcrumbs)
        if (isIssueAppClosed || isIssueKeyUpdated) clearCache();
    }, [
        clearCache,
        prevSelectedIssueKey,
        selectedIssueKey
    ]);
    (0, $eUqFw.useEffect)(()=>()=>{
            // clear cache on unmount
            clearCache();
        }, [
        clearCache
    ]);
    const issues = (0, $eUqFw.useMemo)(()=>Object.keys(prefetchedIssues), [
        prefetchedIssues
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1fd41398a8791bc6$var$IssueDataLoader, {
        issues: issues
    });
};

});
parcelRegister("hYeSy", function(module, exports) {

$parcel$export(module.exports, "usePrefetchIssueViewData", () => $1367707b89dd09e1$export$519e056a921d9691);
$parcel$export(module.exports, "usePrefetchIssueViewDataActions", () => $1367707b89dd09e1$export$fee97ccc4dadacbb);

var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");
/**
 * The minimum allowed time between two consecutive issue data prefetches.
 */ const $1367707b89dd09e1$var$ALLOWED_TIME_BETWEEN_PREFETCHES = 500;
const $1367707b89dd09e1$var$MAX_DELAY = 300;
const $1367707b89dd09e1$var$MIN_DELAY = 0;
const $1367707b89dd09e1$export$a87749ac92873cf7 = ()=>100;
const $1367707b89dd09e1$var$actions = {
    // prefetches issue view data on hover
    prefetchIssue: (issueKey)=>({ getState: getState, setState: setState })=>{
            const { timestampOfTheLastPrefetch: timestampOfTheLastPrefetch, prefetchedIssues: prefetchedIssues } = getState();
            const currentTimestamp = Date.now();
            const delay = timestampOfTheLastPrefetch !== null && currentTimestamp - timestampOfTheLastPrefetch < $1367707b89dd09e1$var$ALLOWED_TIME_BETWEEN_PREFETCHES ? $1367707b89dd09e1$var$MAX_DELAY : $1367707b89dd09e1$var$MIN_DELAY;
            // clear cache if it exceeds the limit so that it doesn't grow indefinitely
            const nextPrefetchedIssues = Object.keys(prefetchedIssues).length === $1367707b89dd09e1$export$a87749ac92873cf7() ? {} : prefetchedIssues;
            setState({
                // prefetch the issue only if the time from the last prefetch is greater than ALLOWED_TIME_BETWEEN_PREFETCHES
                prefetchedIssues: delay === $1367707b89dd09e1$var$MIN_DELAY && !prefetchedIssues[issueKey] ? {
                    ...nextPrefetchedIssues,
                    [issueKey]: true
                } : prefetchedIssues,
                timestampOfTheLastPrefetch: currentTimestamp
            });
        },
    // clears cached issues (ie on view unmount)
    clearCache: ()=>({ setState: setState })=>{
            setState({
                timestampOfTheLastPrefetch: null,
                prefetchedIssues: {}
            });
        }
};
const $1367707b89dd09e1$var$PrefetchIssueViewStore = (0, $a61MH.createStore)({
    initialState: {
        timestampOfTheLastPrefetch: null,
        prefetchedIssues: {}
    },
    actions: $1367707b89dd09e1$var$actions,
    name: 'JWMPrefetchIssueViewStore'
});
const $1367707b89dd09e1$export$519e056a921d9691 = (0, $ggKAj.createStateHook)($1367707b89dd09e1$var$PrefetchIssueViewStore);
const $1367707b89dd09e1$export$fee97ccc4dadacbb = (0, $ggKAj.createActionsHook)($1367707b89dd09e1$var$PrefetchIssueViewStore);

});

parcelRegister("1SYbt", function(module, exports) {

$parcel$export(module.exports, "AsyncIssueViewCriticalDataLoader", () => $b758d168c0275aa2$export$15a49d6c068f7356);

var $eUqFw = parcelRequire("eUqFw");

var $6j4bv = parcelRequire("6j4bv");

var $1HzcR = parcelRequire("1HzcR");

var $72NCz = parcelRequire("72NCz");
const $b758d168c0275aa2$var$entryPointParams = {};
const $b758d168c0275aa2$export$15a49d6c068f7356 = /*#__PURE__*/ (0, $eUqFw.memo)((props)=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $6j4bv.useEntryPoint)((0, $72NCz.asyncIssueViewCriticalDataLoaderEntrypoint), $b758d168c0275aa2$var$entryPointParams);
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $eUqFw.useEffect)(()=>{
        entryPointActions.load();
    }, [
        entryPointActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1HzcR.JiraEntryPointContainer), {
        entryPointReferenceSubject: entryPointReferenceSubject,
        id: "jwm-issue-view-critical-data-loader",
        packageName: "jiraBusinessIssueViewCriticalDataLoader",
        runtimeProps: props
    });
});

});
parcelRegister("72NCz", function(module, exports) {

$parcel$export(module.exports, "asyncIssueViewCriticalDataLoaderEntrypoint", () => $80aa607d47f3d3ce$export$6254258f84be452a);

var $53Hxw = parcelRequire("53Hxw");

var $artI2 = parcelRequire("artI2");

const $80aa607d47f3d3ce$export$6254258f84be452a = (0, $artI2.createEntryPoint)({
    root: (0, $53Hxw.JSResourceForInteraction)(()=>(parcelRequire("B8xwO")), {
        moduleId: "1f53773a"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("B8xwO", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('apZDm');
        const value = parcelRequire('2rxqz');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("apZDm").then(()=>parcelRequire('2rxqz'));
}

});




parcelRegister("nxBOY", function(module, exports) {

$parcel$export(module.exports, "ChildrenController", () => $f44a906179e22f72$export$8c3512dd18e9e8f);

var $eUqFw = parcelRequire("eUqFw");

const $f44a906179e22f72$export$8c3512dd18e9e8f = /*#__PURE__*/ (0, $eUqFw.memo)(({ expandedItemIssueIds: expandedItemIssueIds, setChildrenQueryData: setChildrenQueryData, ChildQueryController: ChildQueryController, getHierarchyLevel: getHierarchyLevel })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, expandedItemIssueIds.map((expandedItemIssueId)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ChildQueryController, {
            parentIssueId: expandedItemIssueId,
            parentHierarchyType: (0, $2a7b21c0842403e6$export$9355e489ad16f98e),
            parentHierarchyLevel: getHierarchyLevel ? getHierarchyLevel(expandedItemIssueId) : undefined,
            onDataChange: setChildrenQueryData,
            key: expandedItemIssueId
        }))), (prevProps, nextProps)=>{
    const prevIssueIds = prevProps.expandedItemIssueIds.sort();
    const nextIssueIds = nextProps.expandedItemIssueIds.sort();
    const prevLoadingIssueIds = prevProps.loadingIssueIds?.sort();
    const nextLoadingIssueIds = nextProps.loadingIssueIds?.sort();
    let loadingIssuesMatch = true;
    if (prevLoadingIssueIds === undefined || nextLoadingIssueIds === undefined) loadingIssuesMatch = prevLoadingIssueIds === nextLoadingIssueIds;
    else loadingIssuesMatch = prevLoadingIssueIds?.length === nextLoadingIssueIds?.length && prevLoadingIssueIds.every((_, id)=>prevLoadingIssueIds[id] === nextLoadingIssueIds[id]);
    return prevProps.setChildrenQueryData === nextProps.setChildrenQueryData && prevIssueIds.length === nextIssueIds.length && prevIssueIds.every((_, id)=>prevIssueIds[id] === nextIssueIds[id]) && loadingIssuesMatch;
});

});

parcelRegister("6L1pn", function(module, exports) {

$parcel$export(module.exports, "LoadingMoreSpinner", () => $9689edca3ab1687a$export$3b637ef4fd5e113c);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $4Bees = parcelRequire("4Bees");
const $9689edca3ab1687a$export$3b637ef4fd5e113c = ({ isLoading: isLoading, loadingMessage: loadingMessage })=>{
    // isVisible will wait for the animation to complete before turning false
    const [isVisible, setIsVisible] = (0, $eUqFw.useState)(false);
    (0, $eUqFw.useEffect)(()=>{
        if (isLoading) setIsVisible(true);
    }, [
        isLoading
    ]);
    const onAnimationEnd = ()=>{
        if (!isLoading) setIsVisible(false);
    };
    if (!isVisible) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9689edca3ab1687a$var$SpinnerContainer, {
        "data-testid": "business-load-more-spinner"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9689edca3ab1687a$var$SpinnerWrapper, {
        isVisible: isLoading,
        onAnimationEnd: onAnimationEnd
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), {
        appearance: "invert",
        size: "small"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $9689edca3ab1687a$var$spinnerTextStyles
    }, loadingMessage)));
};
const $9689edca3ab1687a$var$appear = null;
const $9689edca3ab1687a$var$disappear = null;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9689edca3ab1687a$var$SpinnerContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswstnw _94n5xncg _1e0c1txw _4cvr1h6o _1bah1h6o _1bsb1osq _1pbyb4wl",
            __cmplp.className
        ])
    });
});
const $9689edca3ab1687a$var$SpinnerWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isVisible: isVisible, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1b1v _1yt42uwm _11q7gkf6 _syaz15cr _2rko1sit _k48pbfng _1wyb1skh _16qsozdn",
            __cmplp.isVisible && "",
            __cmplp.isVisible && "_y44v1d47",
            !__cmplp.isVisible && "",
            !__cmplp.isVisible && "_y44vj404",
            __cmplp.className
        ])
    });
});
const $9689edca3ab1687a$var$spinnerTextStyles = (0, $1ZAYh.xcss)({
    marginLeft: 'space.100'
});

});

parcelRegister("eDPHg", function(module, exports) {

$parcel$export(module.exports, "default", () => $00aba31d6c0cebb8$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $ciZ8Y = parcelRequire("ciZ8Y");

var $gGtKh = parcelRequire("gGtKh");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $00aba31d6c0cebb8$var$DependenciesOnBoarding = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("38jfS")), {
    ssr: false,
    moduleId: "./src/packages/business/shared/onboarding/dependencies/src/ui/main.tsx"
});
const $00aba31d6c0cebb8$var$DependenciesOnBoardingAsync = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ciZ8Y.ErrorBoundary), {
        id: "async.jira-business.onboarding.dependencies",
        packageName: "jira-business.onboarding.dependencies"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "dependencies-onboarding",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($00aba31d6c0cebb8$var$DependenciesOnBoarding, null)));
var $00aba31d6c0cebb8$export$2e2bcd8739ae039 = $00aba31d6c0cebb8$var$DependenciesOnBoardingAsync;

});
parcelRegister("38jfS", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('df4ol')
        ]);
        const value = parcelRequire('c1EKB');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("df4ol")
    ]).then(()=>parcelRequire('c1EKB'));
}

});


parcelRegister("f0s5n", function(module, exports) {

$parcel$export(module.exports, "default", () => $0ca4248679e63937$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $ciZ8Y = parcelRequire("ciZ8Y");

var $gGtKh = parcelRequire("gGtKh");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $0ca4248679e63937$var$TimelineEmbedOnboarding = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("1N4il")), {
    ssr: false,
    moduleId: "./src/packages/business/shared/onboarding/timeline-embed/src/ui/main.tsx"
});
const $0ca4248679e63937$var$TimelineEmbedOnboardingAsync = ({ items: items })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ciZ8Y.ErrorBoundary), {
        id: "async.jira-business.onboarding.timeline-embed",
        packageName: "jira-business.onboarding.timeline-embed"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "timeline-embed-onboarding",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0ca4248679e63937$var$TimelineEmbedOnboarding, {
        items: items
    })));
var $0ca4248679e63937$export$2e2bcd8739ae039 = $0ca4248679e63937$var$TimelineEmbedOnboardingAsync;

});
parcelRegister("1N4il", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('3GV4R')
        ]);
        const value = parcelRequire('7okzk');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("3GV4R")
    ]).then(()=>parcelRequire('7okzk'));
}

});


parcelRegister("bcWyL", function(module, exports) {

$parcel$export(module.exports, "PerformanceAnalytics", () => $44db5e6179f04fcc$export$ec3c3b39c046a620);

var $eUqFw = parcelRequire("eUqFw");


var $axxSm = parcelRequire("axxSm");

var $84CBi = parcelRequire("84CBi");

var $bDGTl = parcelRequire("bDGTl");

var $6HWvN = parcelRequire("6HWvN");
const $44db5e6179f04fcc$export$ec3c3b39c046a620 = /*#__PURE__*/ (0, $eUqFw.memo)(({ view: view, loading: loading, itemsCount: itemsCount, attributes: attributes })=>{
    const loadingRef = (0, $eUqFw.useRef)(loading);
    loadingRef.current = loading;
    if (loading === true) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $84CBi.default), {
        name: "performance-analytics-loading"
    });
    const scrollElement = false ? null : document.getElementById((0, $d02be44255a1478f$export$e5e75ff4daca6597));
    const product = view.startsWith('software') ? 'jsw' : 'jwm';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6HWvN.PageLoadMetrics), {
        view: view,
        attributes: attributes,
        product: product
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bDGTl.FirstInteractionMetric), {
        view: view,
        product: product
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $axxSm.default), {
        viewId: `${product}.${view}`,
        scrollElement: scrollElement,
        itemsCount: itemsCount,
        attributes: attributes
    }));
});

});
parcelRegister("axxSm", function(module, exports) {

$parcel$export(module.exports, "default", () => $ed3b6e522e859da6$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

const $ed3b6e522e859da6$export$df7175b69b5630dd = (frames, elapsedMs)=>Math.min(Math.floor(1000 * (frames / elapsedMs)), (0, $083bae7fff0f430d$export$9d3e6d8a99023567));
const $ed3b6e522e859da6$export$46962be62755f053 = /*#__PURE__*/ (0, $eUqFw.memo)(({ viewId: viewId, itemsCount: itemsCount, samplingRate: samplingRate = (0, $083bae7fff0f430d$export$71d024136796e395), scrollElement: scrollElement, attributes: attributes })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const samplingCount = (0, $eUqFw.useRef)(0);
    const frames = (0, $eUqFw.useRef)(0);
    const rafId = (0, $eUqFw.useRef)(null);
    const start = (0, $eUqFw.useRef)(0);
    (0, $eUqFw.useEffect)(()=>{
        const container = scrollElement ?? document;
        const hasScrollCapture = true;
        const tick = ()=>{
            if (frames.current < (0, $083bae7fff0f430d$export$299249b1dad3b14a)) {
                frames.current += 1;
                rafId.current = requestAnimationFrame(tick);
            } else {
                const stopTime = performance.now();
                const elapsedMs = stopTime - start.current;
                const fps = $ed3b6e522e859da6$export$df7175b69b5630dd(frames.current, elapsedMs);
                const avgFrameDuration = Math.floor(elapsedMs / frames.current);
                frames.current = 0;
                const attr = {
                    ...attributes || {},
                    itemsCount: itemsCount,
                    avgFrameDuration: avgFrameDuration,
                    fps: fps
                };
                (0, $jMP2a.fireOperationalAnalyticsDeferred)(createAnalyticsEvent({}), `${viewId} scrolled`, attr);
            }
        };
        const handleOnScroll = ()=>{
            samplingCount.current += 1;
            if (samplingCount.current !== samplingRate) return;
            samplingCount.current = 0;
            // start counting frames
            start.current = performance.now();
            tick();
        };
        container.addEventListener('scroll', handleOnScroll, hasScrollCapture);
        return ()=>{
            container.removeEventListener('scroll', handleOnScroll, hasScrollCapture);
            if (rafId.current) cancelAnimationFrame(rafId.current);
        };
    }, [
        scrollElement,
        createAnalyticsEvent,
        itemsCount,
        samplingRate,
        viewId,
        attributes
    ]);
    return null;
});
var $ed3b6e522e859da6$export$2e2bcd8739ae039 = $ed3b6e522e859da6$export$46962be62755f053;

});
// how often do we measure, e.g. every 100th scroll
const $083bae7fff0f430d$export$71d024136796e395 = 100;
const $083bae7fff0f430d$export$299249b1dad3b14a = 20;
const $083bae7fff0f430d$export$9d3e6d8a99023567 = 60;


parcelRegister("bDGTl", function(module, exports) {

$parcel$export(module.exports, "FirstInteractionMetric", () => $f0bbcfda9127146c$export$70b569bf2edd0b7f);

var $eUqFw = parcelRequire("eUqFw");


var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");
const $f0bbcfda9127146c$export$70b569bf2edd0b7f = ({ view: view, product: product = 'jwm' })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    (0, $eUqFw.useEffect)(()=>{
        const container = document.getElementById((0, $d02be44255a1478f$export$e5e75ff4daca6597)) ?? document;
        const hasScrollCapture = true;
        const startTime = performance.now();
        const handleFirstClick = ()=>{
            (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), `${product}.${view}.first-interaction clicked`, {
                duration: performance.now() - startTime
            });
            container.removeEventListener('click', handleFirstClick);
        };
        const handleFirstScroll = ()=>{
            (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), `${product}.${view}.first-interaction scrolled`, {
                duration: performance.now() - startTime
            });
            container.removeEventListener('scroll', handleFirstScroll, hasScrollCapture);
        };
        container.addEventListener('click', handleFirstClick);
        container.addEventListener('scroll', handleFirstScroll, hasScrollCapture);
        return ()=>{
            container.removeEventListener('click', handleFirstClick);
            container.removeEventListener('scroll', handleFirstScroll, hasScrollCapture);
        };
    }, [
        createAnalyticsEvent,
        view,
        product
    ]);
    return null;
};

});

parcelRegister("6HWvN", function(module, exports) {

$parcel$export(module.exports, "RenderStartMark", () => $ebb8060987b09135$export$2128f295d6adb861);
$parcel$export(module.exports, "PageLoadMetrics", () => $ebb8060987b09135$export$66b33c055cbb625e);

var $eUqFw = parcelRequire("eUqFw");

var $7vf5z = parcelRequire("7vf5z");


var $ZvXTS = parcelRequire("ZvXTS");
const $ebb8060987b09135$export$2128f295d6adb861 = ({ view: view, loading: loading })=>{
    if (loading === true) return null;
    (0, $ZvXTS.markViewMetric)(view, (0, $78bb8734d7176028$export$b78f0bbf209e5f4));
    return null;
};
const $ebb8060987b09135$export$66b33c055cbb625e = /*#__PURE__*/ (0, $eUqFw.memo)(({ view: view, attributes: attributes, product: product = 'jwm' })=>{
    // set UI_RENDER_END mark to indicate the end of UI render
    (0, $ZvXTS.markViewMetric)(view, (0, $78bb8734d7176028$export$88ea1e280513690f));
    const metric = (0, $ZvXTS.pageLoadMetrics)[view];
    return metric && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7vf5z.default), {
        appName: `${product}.${view}`,
        metric: metric,
        extra: attributes
    });
});

});
parcelRegister("7vf5z", function(module, exports) {

$parcel$export(module.exports, "checkAndEmitApdexSignal", () => $074ba9858fda469d$export$3082c88b693a5230);
$parcel$export(module.exports, "default", () => $074ba9858fda469d$export$2e2bcd8739ae039);
$parcel$export(module.exports, "baseDefaultProps", () => $074ba9858fda469d$export$9b3029ee6188a41f);

var $eUqFw = parcelRequire("eUqFw");

var $1ybV0 = parcelRequire("1ybV0");

var $4nnPJ = parcelRequire("4nnPJ");

var $1QVWH = parcelRequire("1QVWH");

var $j2Yjr = parcelRequire("j2Yjr");

var $gnIbC = parcelRequire("gnIbC");

var $22iQy = parcelRequire("22iQy");

var $brm1D = parcelRequire("brm1D");

var $ifyPR = parcelRequire("ifyPR");

var $aS0xb = parcelRequire("aS0xb");

var $45wsB = parcelRequire("45wsB");
const $074ba9858fda469d$export$3082c88b693a5230 = (appName, metricKey)=>{
    var emitSignal;
};
class $074ba9858fda469d$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            isExpectedToHaveSsr: false,
            withMarks: [],
            extra: {},
            emitOnAnimationFrame: false
        };
    }
    render() {
        const { appName: appName, metricKey: metricKey, extra: extra, metric: metric, emitOnAnimationFrame: emitOnAnimationFrame, waitForLongTaskIdleTTI: waitForLongTaskIdleTTI } = this.props;
        $074ba9858fda469d$export$3082c88b693a5230(appName, metricKey);
        const isUFODefined = (0, $1ybV0.ff)('uip.ufo') && (0, $4nnPJ.GlobalPageLoadExperience).loadingPageLoadId !== 'UNKNOWN';
        if (isUFODefined) (0, $aS0xb.addUFOSSRDoneAsFMPToInteraction)();
        if (metric) {
            // https://product-fabric.atlassian.net/browse/UFO-323
            (0, $ifyPR.addBM3SSRDoneAsFMPToInteraction)(metric);
            (0, $45wsB.trackBM3FeatureFlagsAccessed)(metric);
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1QVWH.default), {
            data: extra
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j2Yjr.UFOBM3TimingsToUFO), {
            marks: metric?.getData()?.marks,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            timings: metric?.getData()?.config?.timings
        }), isUFODefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $brm1D.StopUfo), {
            appName: appName,
            customData: extra,
            key: (0, $gnIbC.getInteractionId)().current
        }) : metric && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $22iQy.StopBrowserMetrics3), {
            metric: metric,
            customData: extra,
            emitOnAnimationFrame: emitOnAnimationFrame,
            waitForLongTaskIdleTTI: waitForLongTaskIdleTTI
        }));
    }
}
const $074ba9858fda469d$export$9b3029ee6188a41f = $074ba9858fda469d$export$2e2bcd8739ae039.defaultProps;

});
parcelRegister("1QVWH", function(module, exports) {

$parcel$export(module.exports, "default", () => $a4fbf7a0879450da$export$2e2bcd8739ae039);
$parcel$export(module.exports, "addUFOCustomData", () => $a4fbf7a0879450da$export$d12f56a472cdbe6c);

var $eUqFw = parcelRequire("eUqFw");

var $5iuyH = parcelRequire("5iuyH");

var $gnIbC = parcelRequire("gnIbC");

var $fVaJL = parcelRequire("fVaJL");
function $a4fbf7a0879450da$export$2e2bcd8739ae039({ data: data }) {
    const interactionContext = (0, $eUqFw.useContext)((0, $5iuyH.default));
    (0, $eUqFw.useMemo)(()=>{
        if (!interactionContext) return;
        interactionContext.addCustomData(data);
    }, [
        data,
        interactionContext
    ]);
    return null;
}
function $a4fbf7a0879450da$export$d12f56a472cdbe6c(data) {
    const interactionId = (0, $gnIbC.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    (0, $fVaJL.addCustomData)(currentInteractionId, [], data);
}

});

parcelRegister("j2Yjr", function(module, exports) {

$parcel$export(module.exports, "getBm3Timings", () => $9cfce24b860b88bd$export$f02972da195a43bb);
$parcel$export(module.exports, "UFOBM3TimingsToUFO", () => $9cfce24b860b88bd$export$30f0b5e5acd268bf);
$parcel$export(module.exports, "addBM3TimingsToUFO", () => $9cfce24b860b88bd$export$d93d677ef2f33c5c);

var $eUqFw = parcelRequire("eUqFw");

var $5iuyH = parcelRequire("5iuyH");

var $gnIbC = parcelRequire("gnIbC");

var $fVaJL = parcelRequire("fVaJL");
function $9cfce24b860b88bd$export$f02972da195a43bb(marks, timingConfigs) {
    const bm3Timings = {};
    if (!marks || !timingConfigs) return bm3Timings;
    timingConfigs.forEach((item)=>{
        if (!item.startMark || !item.endMark) return;
        const startTime = marks[item.startMark];
        if (!startTime) return;
        const endTime = marks[item.endMark];
        if (!endTime) return;
        bm3Timings[item.key] = {
            startTime: startTime,
            endTime: endTime
        };
    });
    return bm3Timings;
}
function $9cfce24b860b88bd$export$30f0b5e5acd268bf({ marks: marks, timings: timings }) {
    const interactionContext = (0, $eUqFw.useContext)((0, $5iuyH.default));
    const interactionId = (0, $gnIbC.getInteractionId)().current;
    (0, $eUqFw.useMemo)(()=>{
        if (interactionContext != null && interactionId != null && marks != null && timings != null) {
            const interactionType = (0, $fVaJL.getCurrentInteractionType)(interactionId);
            if (interactionType === 'press') return;
            const bm3Timings = $9cfce24b860b88bd$export$f02972da195a43bb(marks, timings);
            interactionContext.addCustomTimings(bm3Timings);
        }
    }, [
        interactionContext,
        interactionId,
        marks,
        timings
    ]);
    return null;
}
function $9cfce24b860b88bd$export$d93d677ef2f33c5c(marks, timingsConfig) {
    const interactionId = (0, $gnIbC.getInteractionId)().current;
    if (interactionId) {
        const interactionType = (0, $fVaJL.getCurrentInteractionType)(interactionId);
        if (interactionType === 'press') return;
        const bm3Timings = $9cfce24b860b88bd$export$f02972da195a43bb(marks, timingsConfig);
        (0, $fVaJL.addCustomTiming)(interactionId, [], bm3Timings);
    }
}

});

parcelRegister("22iQy", function(module, exports) {

$parcel$export(module.exports, "StopBrowserMetrics3", () => $c48b51f586335ad5$export$575e93c0f9905999);

var $eUqFw = parcelRequire("eUqFw");

var $acbV3 = parcelRequire("acbV3");

var $6iz4v = parcelRequire("6iz4v");

var $6xYPC = parcelRequire("6xYPC");

var $1ybV0 = parcelRequire("1ybV0");

var $cNlZD = parcelRequire("cNlZD");

var $cNlZD = parcelRequire("cNlZD");

var $6M8Uw = parcelRequire("6M8Uw");
var $2B87Z = parcelRequire("2B87Z");

var $87isp = parcelRequire("87isp");

var $5iuyH = parcelRequire("5iuyH");

const $c48b51f586335ad5$var$emitMetrics = (metric, customData, stopTime)=>{
    !(0, $1ybV0.ff)('bm3.emit-on-raf.top-experiences') && (0, $2B87Z.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $6M8Uw.PRODUCT_START_MARK), true);
    (0, $2B87Z.setInitialPageLoadTimingFromPerformanceMarks)('batch-js-heritage.eval', 'jira.heritage_batch_file_eval:start', 'jira.heritage_batch_file_eval:end');
    if (stopTime !== undefined) {
        if (!(0, $1ybV0.ff)('bm3.wait-for-long-task')) {
            metric.mark((0, $37f655a4e4d5690e$export$99c08ec92759c71c));
            (0, $6iz4v.setMark)((0, $37f655a4e4d5690e$export$99c08ec92759c71c));
            (0, $6iz4v.setMeasure)('BROWSER_METRICS_TTI_RAF', 'BROWSER_METRICS_TTI_START', (0, $37f655a4e4d5690e$export$99c08ec92759c71c));
        }
        metric.stop({
            customData: customData,
            stopTime: stopTime
        });
    } else metric.stop({
        customData: customData
    });
    if ((0, $87isp.isAutomaticExposureCollectionEnabled)()) (0, $6xYPC.stopLowPriorityEventDelay)();
};
class $c48b51f586335ad5$export$575e93c0f9905999 extends (0, $eUqFw.Component) {
    componentDidMount() {
        const { metric: metric, customData: customData, emitOnAnimationFrame: emitOnAnimationFrame } = this.props;
        if (!metric) return;
        const start = (0, $1ybV0.ff)('bm3.wait-for-long-task') ? (0, $acbV3.browserMetrics).getPageLoadMetric().getData()?.start || 0 : 0;
        (0, $6iz4v.setMark)('BROWSER_METRICS_TTI_START', {
            startTime: start
        });
        (0, $6iz4v.setMark)('BROWSER_METRICS_TTI_END');
        (0, $6iz4v.setMeasure)('BROWSER_METRICS_TTI', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_TTI_END');
        const bm3Data = metric.getData();
        if (this.props.waitForLongTaskIdleTTI) {
            const stopTime = performance.now();
            (0, $1ybV0.ff)('bm3.emit-on-raf.top-experiences') && (0, $2B87Z.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $6M8Uw.PRODUCT_START_MARK), true);
            (0, $cNlZD.getTTIValue)().then((tti)=>{
                (0, $cNlZD.resetTTIObserver)();
                (0, $6iz4v.setMark)('BROWSER_METRICS_LONG_TASK_TTI_END', {
                    startTime: tti
                });
                (0, $6iz4v.setMeasure)('BROWSER_METRICS_LONG_TASK_TTI', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_LONG_TASK_TTI_END');
                $c48b51f586335ad5$var$emitMetrics(metric, customData, stopTime);
            });
            if (bm3Data) this.context?.addApdex({
                key: bm3Data.key,
                startTime: bm3Data.start,
                stopTime: stopTime
            });
        } else if (emitOnAnimationFrame) {
            const stopTime = performance.now();
            (0, $1ybV0.ff)('bm3.emit-on-raf.top-experiences') && (0, $2B87Z.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $6M8Uw.PRODUCT_START_MARK), true);
            if (bm3Data) this.context?.addApdex({
                key: bm3Data.key,
                startTime: bm3Data.start,
                stopTime: stopTime
            });
            if (typeof queueMicrotask !== 'undefined') queueMicrotask(()=>{
                (0, $6iz4v.setMark)('BROWSER_METRICS_TTI_TASK_END');
                (0, $6iz4v.setMeasure)('BROWSER_METRICS_TTI_TASK', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_TTI_TASK_END');
            });
            requestAnimationFrame(()=>{
                if ((0, $1ybV0.ff)('bm3.wait-for-long-task')) {
                    metric.mark((0, $37f655a4e4d5690e$export$99c08ec92759c71c));
                    (0, $6iz4v.setMark)((0, $37f655a4e4d5690e$export$99c08ec92759c71c));
                    (0, $6iz4v.setMeasure)('BROWSER_METRICS_TTI_RAF', 'BROWSER_METRICS_TTI_START', (0, $37f655a4e4d5690e$export$99c08ec92759c71c));
                }
                if ((0, $1ybV0.ff)('bm3.wait-for-long-task')) setTimeout(()=>{
                    $c48b51f586335ad5$var$emitMetrics(metric, customData, stopTime);
                }, 500);
                else $c48b51f586335ad5$var$emitMetrics(metric, customData, stopTime);
            });
        } else {
            if (bm3Data) this.context?.addApdex({
                key: bm3Data.key,
                startTime: bm3Data.start,
                stopTime: performance.now()
            });
            (0, $1ybV0.ff)('bm3.emit-on-raf.top-experiences') && (0, $2B87Z.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $6M8Uw.PRODUCT_START_MARK), true);
            $c48b51f586335ad5$var$emitMetrics(metric, customData);
        }
    }
    static{
        this.contextType = (0, $5iuyH.default);
    }
    render() {
        return null;
    }
}

});
parcelRegister("cNlZD", function(module, exports) {

$parcel$export(module.exports, "resetTTIObserver", () => $2134fd1f8b4ec9b6$export$1250c0c41b64ee5c);
$parcel$export(module.exports, "startTTIObserver", () => $2134fd1f8b4ec9b6$export$d2209a9a3184ff99);
$parcel$export(module.exports, "getTTIValue", () => $2134fd1f8b4ec9b6$export$e67176cf000b0a2e);

var $ba8ih = parcelRequire("ba8ih");
// Replace with lodash/noop
// eslint-disable-next-line @typescript-eslint/no-empty-function
let $2134fd1f8b4ec9b6$var$resolveTti = (_v)=>{};
let $2134fd1f8b4ec9b6$var$observerStarted = false;
/**
 * Initialize module state and return the promise a consumer can use to wait
 * for the TTI event.
 */ function $2134fd1f8b4ec9b6$var$initTtiPromise() {
    return new Promise((resolve)=>{
        let hasResolved = false;
        const callback = (ttiResult)=>{
            if (hasResolved) return;
            hasResolved = true;
            resolve(ttiResult);
        };
        $2134fd1f8b4ec9b6$var$resolveTti = callback;
    });
}
let $2134fd1f8b4ec9b6$var$ttiPromise = $2134fd1f8b4ec9b6$var$initTtiPromise();
function $2134fd1f8b4ec9b6$export$1250c0c41b64ee5c() {
    $2134fd1f8b4ec9b6$var$ttiPromise = $2134fd1f8b4ec9b6$var$initTtiPromise();
    $2134fd1f8b4ec9b6$var$observerStarted = false;
}
function $2134fd1f8b4ec9b6$export$d2209a9a3184ff99() {
    $2134fd1f8b4ec9b6$var$observerStarted = true;
    let cleanupObserver = null;
    let lastSeenEventTime = performance.now();
    const callback = ()=>{
        cleanupObserver?.();
        $2134fd1f8b4ec9b6$var$resolveTti(lastSeenEventTime);
    };
    let timeoutId = setTimeout(callback, 5000);
    cleanupObserver = (0, $ba8ih.startLongTaskObserver)(()=>{
        lastSeenEventTime = performance.now();
        clearTimeout(timeoutId);
        timeoutId = setTimeout(callback, 5000);
    });
}
function $2134fd1f8b4ec9b6$export$e67176cf000b0a2e() {
    const promise = $2134fd1f8b4ec9b6$var$ttiPromise ?? $2134fd1f8b4ec9b6$var$initTtiPromise();
    if (!$2134fd1f8b4ec9b6$var$observerStarted) $2134fd1f8b4ec9b6$export$d2209a9a3184ff99();
    return promise;
}

});
parcelRegister("ba8ih", function(module, exports) {

$parcel$export(module.exports, "startLongTaskObserver", () => $c3f66a1c0c2d8c9c$export$af412d3da3bf848a);
/**
 * Starts a long-task observer that will call `cb` on each observation.
 * Returns a disposal function
 */ function $c3f66a1c0c2d8c9c$export$af412d3da3bf848a(cb) {
    const observer = new PerformanceObserver(()=>{
        cb();
    });
    observer.observe({
        type: 'longtask'
    });
    return ()=>{
        observer.disconnect();
    };
}

});


parcelRegister("6M8Uw", function(module, exports) {

$parcel$export(module.exports, "PRODUCT_START_MARK", () => $e57b25b6033962a3$export$8e54fca0a680fdfd);
$parcel$export(module.exports, "MarkProductStart", () => $e57b25b6033962a3$export$2a999c5f84501025);

var $6iz4v = parcelRequire("6iz4v");
const $e57b25b6033962a3$export$8e54fca0a680fdfd = 'PRODUCT_START';
const $e57b25b6033962a3$export$2a999c5f84501025 = ()=>{
    if (!false) {
        performance.clearMarks($e57b25b6033962a3$export$8e54fca0a680fdfd);
        (0, $6iz4v.setMark)($e57b25b6033962a3$export$8e54fca0a680fdfd);
    }
    return null;
};

});

const $37f655a4e4d5690e$export$56940a9488e85199 = 'jira.fe.spa-';
const $37f655a4e4d5690e$export$45c4b6bf7935c69a = `${$37f655a4e4d5690e$export$56940a9488e85199}start`;
const $37f655a4e4d5690e$export$135c96ab5afee429 = 'ssr.spa.rendered';
const $37f655a4e4d5690e$export$ff834eccc35b9089 = 'appBundleReady';
const $37f655a4e4d5690e$export$86b05e34d462ead8 = 'prefetchApiReady';
const $37f655a4e4d5690e$export$d6a604a7d9a390fb = 'prefetchApiStart';
const $37f655a4e4d5690e$export$1211adfff27a31fe = 'issueViewInitialDataReady';
const $37f655a4e4d5690e$export$3ae43cc1782d058f = 'jswRenderStart';
const $37f655a4e4d5690e$export$363f6703ffa600be = 'jswCreateReduxStoreStart';
const $37f655a4e4d5690e$export$e87b74567b79c8 = 'jswCreateReduxStoreEnd';
const $37f655a4e4d5690e$export$99fe642459a8b02 = 'jswTransformCriticalDataStart';
const $37f655a4e4d5690e$export$ab1f5705fc8e0571 = 'jswTransformCriticalDataEnd';
const $37f655a4e4d5690e$export$8c3a9046da692c35 = 'jswReduxSoftwareAppLoadedStart';
const $37f655a4e4d5690e$export$5aa497d1efdcc5bf = 'jswReduxSoftwareAppLoadedEnd';
const $37f655a4e4d5690e$export$99c08ec92759c71c = 'tti-raf-mark';
const $37f655a4e4d5690e$export$48552baa9db8ce1d = 'tti-raf';


parcelRegister("brm1D", function(module, exports) {

$parcel$export(module.exports, "StopUfo", () => $aa08c3eb931d9705$export$d91154f099475c5);

var $eUqFw = parcelRequire("eUqFw");

var $4nnPJ = parcelRequire("4nnPJ");

var $5iuyH = parcelRequire("5iuyH");
class $aa08c3eb931d9705$export$d91154f099475c5 extends (0, $eUqFw.Component) {
    componentDidMount() {
        const { customData: customData, appName: appName } = this.props;
        (0, $4nnPJ.GlobalPageLoadExperience).success({
            force: true,
            metadata: customData
        });
        const name = appName || (0, $4nnPJ.GlobalPageLoadExperience).loadingPageLoadId;
        if (name) this.context?.addApdex({
            key: name,
            stopTime: performance.now()
        });
    }
    static{
        this.contextType = (0, $5iuyH.default);
    }
    render() {
        return null;
    }
}

});

parcelRegister("ifyPR", function(module, exports) {

$parcel$export(module.exports, "addBM3SSRDoneAsFMPToInteraction", () => $d6714c8d166fb68b$export$bf239ac2bfb04967);

var $gnIbC = parcelRequire("gnIbC");

var $fVaJL = parcelRequire("fVaJL");
function $d6714c8d166fb68b$export$bf239ac2bfb04967(metric) {
    const interactionId = (0, $gnIbC.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    const data = metric.getData();
    // Use BM3 SSR mark as FMP config for UFO if it exists, temporarily.
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const config = data?.config;
    if (config && data?.isInitial) (0, $fVaJL.addMetadata)(currentInteractionId, {
        __legacy__bm3ConfigSSRDoneAsFmp: config.ssr?.doneAsFmp || false
    });
}

});

parcelRegister("aS0xb", function(module, exports) {

$parcel$export(module.exports, "addUFOSSRDoneAsFMPToInteraction", () => $714e33db0dc77e43$export$e63862cd888fe05a);

var $4nnPJ = parcelRequire("4nnPJ");
var $aPkDp = parcelRequire("aPkDp");

var $gnIbC = parcelRequire("gnIbC");

var $fVaJL = parcelRequire("fVaJL");
async function $714e33db0dc77e43$export$e63862cd888fe05a() {
    const interactionId = (0, $gnIbC.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    // Use UFO SSR mark as FMP config for rUFO if it exists, temporarily.
    const data = await (0, $4nnPJ.GlobalPageLoadExperience).exportData();
    const fmpMark = data.metrics.marks.find((mark)=>mark.name === 'fmp') || (0, $aPkDp.payloadPublisher).ssr?.getDoneMark();
    if (data.initial && fmpMark) (0, $fVaJL.addMetadata)(currentInteractionId, {
        __legacy__ufoConfigSSRDoneAsFmp: true
    });
}

});

parcelRegister("45wsB", function(module, exports) {

$parcel$export(module.exports, "trackBM3FeatureFlagsAccessed", () => $58cb476ec3ec20ed$export$f00f1e874ce869e9);

var $aWbzA = parcelRequire("aWbzA");

var $gnIbC = parcelRequire("gnIbC");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $58cb476ec3ec20ed$var$startsAsObject = (value)=>{
    try {
        if (value.charAt(0) === '{') return true;
    } catch (e) {
        return false;
    }
    return false;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $58cb476ec3ec20ed$var$isObject = (value)=>value && typeof value === 'object' && value.constructor === Object;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $58cb476ec3ec20ed$var$isString = (input)=>{
    let result;
    try {
        result = typeof input === 'string' || input instanceof String;
    } catch (err) {
        // swallow any errors
        result = false;
    }
    return result;
};
const $58cb476ec3ec20ed$export$7b4abba432e57989 = (value)=>$58cb476ec3ec20ed$var$isString(value) && $58cb476ec3ec20ed$var$startsAsObject(value) || $58cb476ec3ec20ed$var$isObject(value);
const $58cb476ec3ec20ed$export$fcc03ee4c944962f = (featureFlagValue)=>$58cb476ec3ec20ed$export$7b4abba432e57989(featureFlagValue) ? 'non_boolean' : featureFlagValue;
const $58cb476ec3ec20ed$export$d2818866b4acbea4 = new Map();
const $58cb476ec3ec20ed$export$f00f1e874ce869e9 = (metric)=>{
    const interactionId = (0, $gnIbC.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    const data = metric.getData();
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const config = data?.config;
    if (config && config?.featureFlags?.length) {
        const allFeatureFlags = (0, $aWbzA.default)();
        config.featureFlags.forEach((featureFlagName)=>{
            const value = allFeatureFlags[featureFlagName];
            if (value === undefined) return;
            const featureFlagValue = $58cb476ec3ec20ed$export$fcc03ee4c944962f(value);
            $58cb476ec3ec20ed$export$d2818866b4acbea4.set(featureFlagName, featureFlagValue);
        });
    }
};

});




parcelRegister("eRpjy", function(module, exports) {

$parcel$export(module.exports, "JWMSpaStatePageReady", () => $beaa0dc8e8f2a3dd$export$d54524c142a057f);

var $eUqFw = parcelRequire("eUqFw");

var $iJHZm = parcelRequire("iJHZm");
const $beaa0dc8e8f2a3dd$export$d54524c142a057f = ()=>{
    const [isReady, setIsReady] = (0, $eUqFw.useState)(false);
    (0, $eUqFw.useEffect)(()=>{
        /**
		 * Waiting for 2 animation frames is equivalent to waiting for react to paint the DOM.
		 */ let id = window.requestAnimationFrame(()=>{
            id = window.requestAnimationFrame(()=>{
                setIsReady(true);
            });
        });
        return ()=>{
            window.cancelAnimationFrame(id);
        };
    }, []);
    if (!isReady) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJHZm.SpaStatePageReady), null);
};

});

parcelRegister("2lQYS", function(module, exports) {

$parcel$export(module.exports, "default", () => $e3e162de3b3bb687$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $gf0vG = parcelRequire("gf0vG");

var $9WNLk = parcelRequire("9WNLk");
var $VrUCp = parcelRequire("VrUCp");
var $lSR7G = parcelRequire("lSR7G");
var $nH3p1 = parcelRequire("nH3p1");
var $lvr5h = parcelRequire("lvr5h");
var $3XwA1 = parcelRequire("3XwA1");
var $cZkk1 = parcelRequire("cZkk1");

var $bwj1b = parcelRequire("bwj1b");

var $kzPj3 = parcelRequire("kzPj3");
const $e3e162de3b3bb687$var$EMPTY_ARRAY = [];
function $e3e162de3b3bb687$export$2e2bcd8739ae039(props) {
    const { marshalOptions: marshalOptions, isCreateLastEnabled: isCreateLastEnabled, isCreateChildEnabled: isCreateChildEnabled, isCreateSiblingEnabled: isCreateSiblingEnabled, isDragEnabled: isDragEnabled, isSelectEnabled: isSelectEnabled, isHighlightToday: isHighlightToday, listWidth: listWidth, items: items, headerItems: headerItems, itemHeight: itemHeight, selectedItemIds: selectedItemIds, expandedItems: expandedItems, today: today, timelineMode: timelineMode, timelineDuration: timelineDuration, timelineOrigin: timelineOrigin, createItemAnchor: createItemAnchor, ariaRowCount: ariaRowCount, ariaLabel: ariaLabel, ariaReadOnly: ariaReadOnly, ariaMultiselectable: ariaMultiselectable, isTreeDrag: isTreeDrag = false, ...mainProps } = props;
    const safeSelectedItemIds = isSelectEnabled ? selectedItemIds : $e3e162de3b3bb687$var$EMPTY_ARRAY;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lvr5h.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cZkk1.TimelineViewportProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9WNLk.EnablementProvider), {
        isDragEnabled: isDragEnabled,
        isSelectEnabled: isSelectEnabled,
        isCreateLastEnabled: isCreateLastEnabled,
        isCreateSiblingEnabled: isCreateSiblingEnabled,
        isCreateChildEnabled: isCreateChildEnabled,
        isHighlightToday: isHighlightToday,
        isTreeDrag: isTreeDrag
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lSR7G.ItemsProvider), {
        items: items,
        createItemAnchor: createItemAnchor,
        isCreateLastEnabled: isCreateLastEnabled,
        isCreateSiblingEnabled: isCreateSiblingEnabled,
        isCreateChildEnabled: isCreateChildEnabled,
        expandedItems: expandedItems,
        selectedItemIdsWithPermission: isSelectEnabled ? selectedItemIds : undefined,
        itemHeight: itemHeight,
        ariaRowOffset: ariaRowCount === -1 ? undefined : (0, $gf0vG.ITEMS_COUNT_OFFSET) + headerItems.length
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3XwA1.TimelineProviderSweetState), {
        timelineMode: timelineMode,
        timelineDuration: timelineDuration,
        timelineOrigin: timelineOrigin,
        today: today
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $VrUCp.default), {
        headerItems: headerItems,
        isRowCountKnown: ariaRowCount !== -1
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $nH3p1.default), {
        listWidth: listWidth
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bwj1b.default), {
        scope: mainProps.scope,
        ariaLabel: ariaLabel,
        ariaReadOnly: ariaReadOnly,
        ariaMultiselectable: isSelectEnabled ? ariaMultiselectable : undefined,
        ...marshalOptions
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kzPj3.default), {
        ...mainProps,
        selectedItemIds: safeSelectedItemIds
    })))))))));
}
$e3e162de3b3bb687$export$2e2bcd8739ae039.defaultProps = {
    isVirtualiseEnabled: false,
    isCreateLastEnabled: true,
    isCreateSiblingEnabled: true,
    isCreateChildEnabled: true,
    isDragEnabled: true,
    isSelectEnabled: true,
    isResizeEnabled: true,
    isHighlightToday: true,
    isHideScrollbar: false,
    items: [],
    headerItems: [],
    expandedItems: {},
    renderers: {},
    marshalOptions: {},
    createItemAnchor: undefined,
    selectedItemIds: [],
    itemHeight: (0, $gf0vG.DEFAULT_ITEM_HEIGHT),
    listWidth: (0, $gf0vG.DEFAULT_LIST_WIDTH),
    DndLongTaskMetric: undefined,
    onItemSelect: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    onItemDrop: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    onCreateClick: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    onItemExpandChanged: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    onSetListWidth: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    ariaRowCount: undefined,
    ariaLabel: undefined,
    ariaReadOnly: undefined,
    ariaMultiselectable: undefined
};

});
parcelRegister("9WNLk", function(module, exports) {

$parcel$export(module.exports, "useEnablements", () => $bc1114de86d96336$export$f6bfb0ec6efae17b);
$parcel$export(module.exports, "EnablementProvider", () => $bc1114de86d96336$export$221a50e4a5e2cf12);

var $heB5U = parcelRequire("heB5U");
var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");

var $jlV0M = parcelRequire("jlV0M");
const $bc1114de86d96336$var$initialState = {
    isDragEnabled: false,
    isSelectEnabled: false,
    isCreateLastEnabled: false,
    isCreateSiblingEnabled: false,
    isCreateChildEnabled: false,
    isHighlightToday: true,
    isTreeDrag: false
};
const $bc1114de86d96336$export$faca84be7efd165 = (0, $a61MH.createStore)({
    initialState: $bc1114de86d96336$var$initialState,
    actions: $jlV0M.actions,
    name: 'timeline-table.enablements'
});
const $bc1114de86d96336$export$f6bfb0ec6efae17b = (0, $ggKAj.createHook)($bc1114de86d96336$export$faca84be7efd165);
const $bc1114de86d96336$export$221a50e4a5e2cf12 = (0, $heB5U.createContainer)($bc1114de86d96336$export$faca84be7efd165, {
    onInit: ()=>({ setState: setState }, enablements)=>{
            setState({
                ...enablements
            });
        },
    onUpdate: ()=>({ setState: setState }, enablements)=>{
            setState({
                ...enablements
            });
        }
});

});
parcelRegister("jlV0M", function(module, exports) {

$parcel$export(module.exports, "actions", () => $00517908b6a93b84$export$e324594224ef24da);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $00517908b6a93b84$export$e324594224ef24da = {};

});


parcelRegister("VrUCp", function(module, exports) {

$parcel$export(module.exports, "useHeaderState", () => $8886d03b4d1abdd7$export$704ca874967743c3);
$parcel$export(module.exports, "default", () => $8886d03b4d1abdd7$export$2e2bcd8739ae039);

var $heB5U = parcelRequire("heB5U");
var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");

var $gf0vG = parcelRequire("gf0vG");

var $eubl3 = parcelRequire("eubl3");
const $8886d03b4d1abdd7$var$initialState = {
    headerItems: [],
    headerHeight: (0, $gf0vG.BASE_HEADER_HEIGHT),
    headerItemsOffsetTop: {},
    isRowCountKnown: true
};
const $8886d03b4d1abdd7$export$52342bdf89fb39e7 = (0, $a61MH.createStore)({
    initialState: $8886d03b4d1abdd7$var$initialState,
    actions: $eubl3.actions,
    name: 'timeline-table.header'
});
const $8886d03b4d1abdd7$export$704ca874967743c3 = (0, $ggKAj.createHook)($8886d03b4d1abdd7$export$52342bdf89fb39e7);
const $8886d03b4d1abdd7$var$handleState = ()=>({ setState: setState }, { headerItems: headerItems, isRowCountKnown: isRowCountKnown })=>{
        let offsetTop = (0, $gf0vG.BASE_HEADER_HEIGHT);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const headerItemsOffsetTop = {};
        const headerHeight = headerItems.reduce((total, { id: id, height: height })=>{
            headerItemsOffsetTop[id] = offsetTop;
            offsetTop += height !== undefined ? height : (0, $gf0vG.DEFAULT_SUBHEADER_HEIGHT);
            return total + (height ?? (0, $gf0vG.DEFAULT_SUBHEADER_HEIGHT));
        }, (0, $gf0vG.BASE_HEADER_HEIGHT));
        setState({
            headerItems: headerItems,
            headerItemsOffsetTop: headerItemsOffsetTop,
            headerHeight: headerHeight,
            isRowCountKnown: isRowCountKnown
        });
    };
const $8886d03b4d1abdd7$var$HeaderProvider = (0, $heB5U.createContainer)($8886d03b4d1abdd7$export$52342bdf89fb39e7, {
    onInit: $8886d03b4d1abdd7$var$handleState,
    onUpdate: $8886d03b4d1abdd7$var$handleState
});
var $8886d03b4d1abdd7$export$2e2bcd8739ae039 = $8886d03b4d1abdd7$var$HeaderProvider;

});
parcelRegister("eubl3", function(module, exports) {

$parcel$export(module.exports, "actions", () => $ba9887bf83781838$export$e324594224ef24da);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $ba9887bf83781838$export$e324594224ef24da = {};

});


parcelRegister("lSR7G", function(module, exports) {

$parcel$export(module.exports, "useItems", () => $bde75a318eddaba8$export$7bfdd97581ca93c);
$parcel$export(module.exports, "useIsItemSelected", () => $bde75a318eddaba8$export$3d9fe48014f19d8a);
$parcel$export(module.exports, "useIsTableEmpty", () => $bde75a318eddaba8$export$ad9c09bad4bdddda);
$parcel$export(module.exports, "useItemsCount", () => $bde75a318eddaba8$export$29409325c4d1aa3a);
$parcel$export(module.exports, "useAriaRowCount", () => $bde75a318eddaba8$export$35cd36afbcd5e208);
$parcel$export(module.exports, "useItemHeight", () => $bde75a318eddaba8$export$1d47b041c6ce1962);
$parcel$export(module.exports, "useItemsContainerStyles", () => $bde75a318eddaba8$export$4d54f7a51148a517);
$parcel$export(module.exports, "useCreateItemAnchor", () => $bde75a318eddaba8$export$79c0b16424e10cdb);
$parcel$export(module.exports, "ItemsProvider", () => $bde75a318eddaba8$export$dab1678cbe62d3ff);

var $heB5U = parcelRequire("heB5U");
var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");

var $1ybV0 = parcelRequire("1ybV0");

var $gf0vG = parcelRequire("gf0vG");

var $1sAbG = parcelRequire("1sAbG");
var $8zane = parcelRequire("8zane");
var $kTIHV = parcelRequire("kTIHV");

var $2qMqD = parcelRequire("2qMqD");

var $dHiyA = parcelRequire("dHiyA");
const $bde75a318eddaba8$var$DEFAULT_STATE = {
    items: [],
    itemsSelectionState: {},
    ariaRowCount: 0,
    isTableEmpty: false,
    itemsBackground: 'none',
    totalHeight: 0,
    itemHeight: (0, $gf0vG.DEFAULT_ITEM_HEIGHT),
    createItemAnchor: undefined
};
const $bde75a318eddaba8$var$store = (0, $a61MH.createStore)({
    initialState: $bde75a318eddaba8$var$DEFAULT_STATE,
    actions: $2qMqD.actions,
    name: 'timeline-table.items'
});
const $bde75a318eddaba8$export$fbd09c28377f1868 = (0, $ggKAj.createHook)($bde75a318eddaba8$var$store);
const $bde75a318eddaba8$export$7bfdd97581ca93c = (0, $ggKAj.createHook)($bde75a318eddaba8$var$store, {
    selector: (0, $dHiyA.getItems)
});
const $bde75a318eddaba8$export$3d9fe48014f19d8a = (0, $ggKAj.createHook)($bde75a318eddaba8$var$store, {
    selector: (0, $dHiyA.getIsItemSelected)
});
const $bde75a318eddaba8$export$ad9c09bad4bdddda = (0, $ggKAj.createHook)($bde75a318eddaba8$var$store, {
    selector: (0, $dHiyA.getIsTableEmpty)
});
const $bde75a318eddaba8$export$29409325c4d1aa3a = (0, $ggKAj.createHook)($bde75a318eddaba8$var$store, {
    selector: (0, $dHiyA.getItemsCount)
});
const $bde75a318eddaba8$export$35cd36afbcd5e208 = (0, $ggKAj.createHook)($bde75a318eddaba8$var$store, {
    selector: (0, $dHiyA.getAriaRowCount)
});
const $bde75a318eddaba8$export$1d47b041c6ce1962 = (0, $ggKAj.createHook)($bde75a318eddaba8$var$store, {
    selector: (0, $dHiyA.getItemHeight)
});
const $bde75a318eddaba8$export$4d54f7a51148a517 = (0, $ggKAj.createHook)($bde75a318eddaba8$var$store, {
    selector: (0, $dHiyA.getItemsContainerStyles)
});
const $bde75a318eddaba8$export$79c0b16424e10cdb = (0, $ggKAj.createHook)($bde75a318eddaba8$var$store, {
    selector: (0, $dHiyA.getCreateItemAnchor)
});
const $bde75a318eddaba8$export$51a276b6d0945af7 = (0, $ggKAj.createHook)($bde75a318eddaba8$var$store, {
    selector: (0, $dHiyA.getHasActiveCreate)
});
const $bde75a318eddaba8$var$updateState = ()=>({ setState: setState }, { items: items, createItemAnchor: createItemAnchor, expandedItems: expandedItems, selectedItemIdsWithPermission: selectedItemIdsWithPermission, isCreateLastEnabled: isCreateLastEnabled, isCreateSiblingEnabled: isCreateSiblingEnabled, isCreateChildEnabled: isCreateChildEnabled, itemHeight: itemHeight, ariaRowOffset: ariaRowOffset })=>{
        const { flatItems: flatItems, ariaRowCount: ariaRowCount } = (0, $1ybV0.ff)('jwm.visual-hierarchy-milestone-1') ? (0, $1sAbG.getHierarchyEnrichedItems)(items, createItemAnchor, expandedItems, isCreateLastEnabled, isCreateSiblingEnabled, isCreateChildEnabled, itemHeight, ariaRowOffset) : (0, $1sAbG.getHierarchyEnrichedItemsOld)(items, createItemAnchor, expandedItems, isCreateLastEnabled, isCreateSiblingEnabled, isCreateChildEnabled, itemHeight, ariaRowOffset);
        const itemsSelectionState = (0, $kTIHV.getSelectedItemIdsHash)(selectedItemIdsWithPermission);
        const { itemsBackground: itemsBackground, totalHeight: totalHeight } = (0, $8zane.getItemsContainerStyle)(flatItems, itemHeight);
        setState({
            items: flatItems,
            itemsSelectionState: itemsSelectionState,
            ariaRowCount: ariaRowCount,
            isTableEmpty: items.length === 0,
            itemsBackground: itemsBackground,
            totalHeight: totalHeight,
            itemHeight: itemHeight,
            createItemAnchor: createItemAnchor
        });
    };
const $bde75a318eddaba8$export$dab1678cbe62d3ff = (0, $heB5U.createContainer)($bde75a318eddaba8$var$store, {
    onInit: $bde75a318eddaba8$var$updateState,
    onUpdate: $bde75a318eddaba8$var$updateState
});

});
parcelRegister("1sAbG", function(module, exports) {

$parcel$export(module.exports, "isRoot", () => $f8b6334e2bcb5845$export$e3140dc7d0c35e48);
$parcel$export(module.exports, "isBaseLevel", () => $f8b6334e2bcb5845$export$3f3fbf12338c09a4);
$parcel$export(module.exports, "isParentLevel", () => $f8b6334e2bcb5845$export$dbfe1bb564ec5b98);
$parcel$export(module.exports, "getHierarchyEnrichedItems", () => $f8b6334e2bcb5845$export$29090c866cb2cf07);
$parcel$export(module.exports, "getHierarchyEnrichedItemsOld", () => $f8b6334e2bcb5845$export$f1d7e5a31b3073cc);

var $5iWql = parcelRequire("5iWql");

var $PdmhA = parcelRequire("PdmhA");

var $1ybV0 = parcelRequire("1ybV0");

var $eI5EY = parcelRequire("eI5EY");

var $gf0vG = parcelRequire("gf0vG");
const $f8b6334e2bcb5845$export$e3140dc7d0c35e48 = (depth)=>depth === (0, $gf0vG.DEFAULT_DEPTH);
const $f8b6334e2bcb5845$export$3f3fbf12338c09a4 = (level)=>level === (0, $gf0vG.BASE_LEVEL);
const $f8b6334e2bcb5845$export$dbfe1bb564ec5b98 = (level)=>level === (0, $gf0vG.PARENT_LEVEL);
const $f8b6334e2bcb5845$var$shouldCreateBeforeItem = (createItemAnchor, id)=>createItemAnchor !== undefined && createItemAnchor.position === (0, $gf0vG.BEFORE) && createItemAnchor.beforeId === id;
const $f8b6334e2bcb5845$var$shouldCreateInsideItem = (createItemAnchor, id)=>{
    if (createItemAnchor === undefined) return false;
    const createChildLast = createItemAnchor.position === (0, $gf0vG.INSIDE) && createItemAnchor.parentId === id;
    const createChildSibling = createItemAnchor.position === (0, $gf0vG.BEFORE) && createItemAnchor.parentId === id;
    return createChildLast || createChildSibling;
};
const $f8b6334e2bcb5845$var$shouldCreateLast = (createItemAnchor)=>createItemAnchor === undefined || createItemAnchor.position === (0, $gf0vG.LAST);
/* The rootIndex is the position of the item at depth 0.
 * For parent items this will be its position, excluding any children.
 * For child items, this will be its parents position, as defined by the above.
 */ const $f8b6334e2bcb5845$var$getItemBackgroundColor = (rootIndex)=>rootIndex % 2 === 0 ? `var(--ds-surface, ${0, $PdmhA.N0})` : `var(--ds-surface-sunken, ${0, $PdmhA.N20})`;
// To make sure the create item can be properly reconciled, we need a stable key.
const $f8b6334e2bcb5845$var$getStableCreateKey = (createItemAnchor)=>{
    if (createItemAnchor === undefined) return 0, $gf0vG.DEFAULT_CREATE_KEY;
    /**
   * We want to keep default key for the item at the end of the list
   * otherwise new key generation will unmount and then mount component again
   * which breaks empty list lifecycle
   */ if (!('beforeId' in createItemAnchor) && createItemAnchor.position === (0, $gf0vG.LAST)) return 0, $gf0vG.DEFAULT_CREATE_KEY;
    if (createItemAnchor.position === (0, $gf0vG.INSIDE) && createItemAnchor.parentId) return `create-${createItemAnchor.position}${createItemAnchor.parentId}`;
    return `create-${createItemAnchor.position}${'beforeId' in createItemAnchor && createItemAnchor.beforeId ? createItemAnchor.beforeId : ''}`;
};
/* When creating last, it was always be on the same level as the root items.
 * When creating before, it will be on the same level as its anchor item.
 * When creating inside, it will be one level lower than its anchor item.
 */ const $f8b6334e2bcb5845$var$getCreateLevel = (createItemAnchor, anchorItem)=>{
    if (anchorItem === undefined) return 0, $gf0vG.DEFAULT_LEVEL;
    // If not a create before, it will be a create inside
    const { id: id, level: level } = anchorItem;
    return $f8b6334e2bcb5845$var$shouldCreateBeforeItem(createItemAnchor, id) ? level : level - 1;
};
const $f8b6334e2bcb5845$var$getCreateDepth = (createItemAnchor, anchorItem)=>{
    if (anchorItem === undefined) return 0, $gf0vG.DEFAULT_DEPTH;
    // If not a create before, it will be a create inside
    const { id: id, depth: depth = 0 } = anchorItem;
    return $f8b6334e2bcb5845$var$shouldCreateBeforeItem(createItemAnchor, id) ? depth : depth + 1;
};
const $f8b6334e2bcb5845$var$enrichCreateItem = ({ anchorItem: anchorItem, parentId: parentId, createItemAnchor: createItemAnchor, rootIndex: rootIndex, ariaRowIndex: ariaRowIndex, startOffset: startOffset, parentStartOffset: parentStartOffset, parentChartItemsTopOffset: parentChartItemsTopOffset, flatIndex: flatIndex })=>({
        type: (0, $gf0vG.CREATE_ITEM_TYPE),
        anchorItem: anchorItem,
        meta: {
            key: $f8b6334e2bcb5845$var$getStableCreateKey(createItemAnchor),
            level: $f8b6334e2bcb5845$var$getCreateLevel(createItemAnchor, anchorItem),
            isActive: createItemAnchor !== undefined,
            backgroundColor: $f8b6334e2bcb5845$var$getItemBackgroundColor(rootIndex),
            parentId: parentId,
            ariaRowIndex: ariaRowIndex,
            startOffset: startOffset,
            parentStartOffset: parentStartOffset,
            ...(0, $1ybV0.ff)('jwm.visual-hierarchy-milestone-1') && {
                depth: $f8b6334e2bcb5845$var$getCreateDepth(createItemAnchor, anchorItem),
                chartItemsTopOffset: (parentChartItemsTopOffset ?? 0) + startOffset,
                flatIndex: flatIndex
            }
        }
    });
const $f8b6334e2bcb5845$var$countDescendants = (item)=>{
    const { childItems: childItems = [] } = item;
    return childItems.length + childItems.reduce((acc, child)=>acc + $f8b6334e2bcb5845$var$countDescendants(child), 0);
};
// once feature flag `jwm.visual-hierarchy-milestone-1` is removed, we can remove this function
const $f8b6334e2bcb5845$var$enrichChildItem = ({ item: item, parentItem: parentItem, rootIndex: rootIndex, flatIndex: flatIndex, ariaRowIndex: ariaRowIndex, startOffset: startOffset, parentStartOffset: parentStartOffset })=>({
        type: (0, $gf0vG.CHILD_ITEM_TYPE),
        item: item,
        meta: {
            parentId: parentItem.id,
            backgroundColor: $f8b6334e2bcb5845$var$getItemBackgroundColor(rootIndex),
            isParent: false,
            isExpanded: false,
            ariaRowIndex: ariaRowIndex,
            startOffset: startOffset,
            parentStartOffset: parentStartOffset
        },
        flatIndex: flatIndex
    });
const $f8b6334e2bcb5845$var$enrichItem = ({ item: item, expandedItems: expandedItems, rootIndex: rootIndex, flatIndex: flatIndex, ariaRowIndex: ariaRowIndex, isParent: isParent, numChildren: numChildren, startOffset: startOffset, childItemsHeight: childItemsHeight, parentItem: parentItem, ariaControls: ariaControls })=>({
        type: (0, $gf0vG.ITEM_TYPE),
        item: item,
        meta: {
            parentId: parentItem?.item.id,
            backgroundColor: $f8b6334e2bcb5845$var$getItemBackgroundColor(rootIndex),
            isParent: isParent,
            isExpanded: Boolean(expandedItems[item.id]),
            ariaRowIndex: ariaRowIndex,
            numChildren: numChildren,
            startOffset: startOffset,
            childItemsHeight: childItemsHeight,
            // once feature flag `jwm.visual-hierarchy-milestone-1` is removed, we can remove parentStartOffset
            // which is replaced by chartItemsTopOffset
            parentStartOffset: parentItem?.meta.startOffset ?? undefined,
            ...(0, $1ybV0.ff)('jwm.visual-hierarchy-milestone-1') && {
                rootIndex: rootIndex,
                chartItemsTopOffset: (parentItem?.meta.chartItemsTopOffset ?? 0) + startOffset
            },
            ...(0, $eI5EY.fg)('jsw_roadmaps_timeline_table_hierarchy_a11y') && {
                ariaControls: ariaControls
            }
        },
        flatIndex: flatIndex
    });
const $f8b6334e2bcb5845$export$29090c866cb2cf07 = (0, $5iWql.default)((items, createItemAnchor, expandedItems, isCreateLastEnabled, isCreateSiblingEnabled, isCreateChildEnabled, rootItemHeight, ariaRowOffset, lastFlatIndex = 0, parentItem)=>{
    // the height of any item is set depending on its depth
    // - root items have a height of rootItemHeight
    // - nested items have a height of nestedItemHeight
    const depth = parentItem ? (parentItem.item.depth ?? 0) + 1 : 0;
    // if the parent item is root (has no parent), then the offset should be 0 otherwise it should be the parent's height
    // as the item is positioned relative to its parent's container
    let offset = 0;
    if (depth > 0) // add the parent's height to the offset
    offset += depth > 1 ? (0, $gf0vG.BASE_LEVEL_ITEM_HEIGHT) : rootItemHeight;
    let flatIndex = lastFlatIndex;
    const isRowCountKnown = ariaRowOffset !== undefined;
    let ariaRowIndex = (ariaRowOffset ?? 0) + 1; // NOTE: aria-rowindex starts from 1 instead of 0
    const flattenedItems = [];
    items.forEach((item, index)=>{
        const rootIndex = parentItem?.meta.rootIndex ?? index;
        const itemHeight = depth > 0 ? (0, $gf0vG.BASE_LEVEL_ITEM_HEIGHT) : rootItemHeight;
        const { id: id, level: level = (0, $gf0vG.DEFAULT_LEVEL), isInTransition: isInTransition, canCreateChildOverride: canCreateChildOverride = true, childItems: childItems = [] } = item;
        const itemProps = {
            id: id,
            level: level,
            depth: depth,
            isInTransition: isInTransition,
            canCreateChildOverride: canCreateChildOverride
        };
        if (isCreateSiblingEnabled && $f8b6334e2bcb5845$var$shouldCreateBeforeItem(createItemAnchor, id)) {
            const createItem = $f8b6334e2bcb5845$var$enrichCreateItem({
                anchorItem: itemProps,
                parentId: parentItem?.item.id,
                createItemAnchor: createItemAnchor,
                rootIndex: rootIndex,
                ariaRowIndex: isRowCountKnown ? ariaRowIndex : undefined,
                startOffset: offset,
                parentStartOffset: parentItem?.meta?.startOffset ?? 0,
                parentChartItemsTopOffset: parentItem?.meta?.chartItemsTopOffset,
                flatIndex: flatIndex
            });
            flattenedItems.push(createItem);
            ariaRowIndex += 1;
            // create item has always height of the root level
            offset += rootItemHeight;
            // we need to increase the flat index to account for the create item
            flatIndex += 1;
        }
        // this is to find out if there is a create item inside the item to count it in the children count
        const isChildCreate = isCreateChildEnabled && canCreateChildOverride && $f8b6334e2bcb5845$var$shouldCreateInsideItem(createItemAnchor, id);
        // this is to create child is being created using the plus button next to the item
        const isChildCreateInside = Boolean(isChildCreate && createItemAnchor && createItemAnchor.position === (0, $gf0vG.INSIDE));
        // ItemsRenderer uses this count to find the child items in the flattened items
        const numChildren = childItems.length + (isChildCreate ? 1 : 0);
        const flattenedItem = $f8b6334e2bcb5845$var$enrichItem({
            item: itemProps,
            expandedItems: expandedItems,
            rootIndex: rootIndex,
            flatIndex: flatIndex,
            ariaRowIndex: isRowCountKnown ? ariaRowIndex : undefined,
            isParent: childItems.length > 0,
            numChildren: numChildren,
            // will be calculated after recursively created child items
            startOffset: offset,
            childItemsHeight: 0,
            parentItem: // will be calculated after recursively created child items
            parentItem,
            ...childItems.length > 0 && (0, $eI5EY.fg)('jsw_roadmaps_timeline_table_hierarchy_a11y') && {
                ariaControls: childItems.map((child)=>child.id).join(' ')
            }
        });
        // Increase the index to account for the parent item, which will be inserted first
        flatIndex += 1;
        ariaRowIndex += 1;
        // consider the item itself is added to calculate the offset
        offset += itemHeight;
        let innerHierarchyEnrichedItems;
        let itemsHeight = 0;
        let childEnrichedItems = [];
        if (expandedItems[id]) {
            // for the children the offset is relative the parent
            // so we should reset the offset to parentsHeight
            innerHierarchyEnrichedItems = $f8b6334e2bcb5845$export$29090c866cb2cf07(childItems, createItemAnchor, expandedItems, isCreateLastEnabled, isCreateSiblingEnabled, isCreateChildEnabled, rootItemHeight, isRowCountKnown ? ariaRowIndex - 1 : -1, flatIndex, flattenedItem);
            ariaRowIndex = innerHierarchyEnrichedItems?.ariaRowIndex ?? 0;
            // the height of the parent shouldn't be included in the children height
            itemsHeight = (innerHierarchyEnrichedItems?.offset ?? itemHeight) - itemHeight;
            childEnrichedItems = innerHierarchyEnrichedItems?.flatItems ?? [];
            flatIndex = innerHierarchyEnrichedItems?.flatIndex ?? flatIndex;
            // Creating an item inside a parent will always be in last position
            if (isChildCreateInside) {
                const createChildItem = $f8b6334e2bcb5845$var$enrichCreateItem({
                    anchorItem: itemProps,
                    parentId: id,
                    createItemAnchor: createItemAnchor,
                    rootIndex: rootIndex,
                    ariaRowIndex: isRowCountKnown ? ariaRowIndex : undefined,
                    // offset of the create item would be the height of prior children plus the parent height,
                    startOffset: itemsHeight + itemHeight,
                    // current item would be the parent
                    parentStartOffset: flattenedItem?.meta?.startOffset ?? 0,
                    parentChartItemsTopOffset: flattenedItem?.meta?.chartItemsTopOffset
                });
                childEnrichedItems.push(createChildItem);
                // offset will be calculated based on the itemsHeight so we don't need to increase it here
                itemsHeight += rootItemHeight;
                ariaRowIndex += 1;
                flatIndex += 1;
            }
        } else ariaRowIndex += $f8b6334e2bcb5845$var$countDescendants(item);
        flattenedItems.push(...[
            {
                ...flattenedItem,
                meta: {
                    ...flattenedItem.meta,
                    childItemsHeight: itemsHeight
                }
            },
            ...childEnrichedItems
        ]);
        offset += itemsHeight;
    });
    if (depth === (0, $gf0vG.DEFAULT_DEPTH) && isCreateLastEnabled && $f8b6334e2bcb5845$var$shouldCreateLast(createItemAnchor)) {
        const createItem = $f8b6334e2bcb5845$var$enrichCreateItem({
            anchorItem: undefined,
            parentId: undefined,
            createItemAnchor: createItemAnchor,
            rootIndex: items.length,
            ariaRowIndex: isRowCountKnown ? ariaRowIndex : undefined,
            startOffset: offset,
            parentStartOffset: parentItem?.meta?.startOffset ?? 0,
            parentChartItemsTopOffset: parentItem?.meta?.chartItemsTopOffset,
            flatIndex: flatIndex
        });
        flattenedItems.push(createItem);
        ariaRowIndex += 1;
        offset += rootItemHeight;
        flatIndex += 1;
    }
    return {
        flatItems: flattenedItems,
        ariaRowCount: isRowCountKnown ? ariaRowIndex - 1 : -1,
        offset: offset,
        flatIndex: flatIndex,
        ariaRowIndex: ariaRowIndex
    };
});
const $f8b6334e2bcb5845$export$f1d7e5a31b3073cc = (0, $5iWql.default)((items, createItemAnchor, expandedItems, isCreateLastEnabled, isCreateSiblingEnabled, isCreateChildEnabled, itemHeight, ariaRowOffset)=>{
    let offset = 0;
    let flatIndex = 0;
    const isRowCountKnown = ariaRowOffset !== undefined;
    let ariaRowIndex = (ariaRowOffset ?? 0) + 1; // NOTE: aria-rowindex starts from 1 instead of 0
    const flattenedItems = [];
    items.forEach((item, rootIndex)=>{
        let childOffset = 0;
        const { id: id, level: level = (0, $gf0vG.DEFAULT_LEVEL), isInTransition: isInTransition, canCreateChildOverride: canCreateChildOverride = true, childItems: childItems = [] } = item;
        const itemProps = {
            id: id,
            level: level,
            isInTransition: isInTransition,
            canCreateChildOverride: canCreateChildOverride
        };
        if (isCreateSiblingEnabled && $f8b6334e2bcb5845$var$shouldCreateBeforeItem(createItemAnchor, id)) {
            const createItem = $f8b6334e2bcb5845$var$enrichCreateItem({
                anchorItem: itemProps,
                parentId: undefined,
                createItemAnchor: createItemAnchor,
                rootIndex: rootIndex,
                ariaRowIndex: isRowCountKnown ? ariaRowIndex : undefined,
                startOffset: offset,
                parentStartOffset: 0
            });
            flattenedItems.push(createItem);
            ariaRowIndex += 1;
            offset += itemHeight;
        }
        const flatParentIndex = flatIndex;
        const isChildCreate = isCreateChildEnabled && Boolean(canCreateChildOverride) && $f8b6334e2bcb5845$var$shouldCreateInsideItem(createItemAnchor, id);
        // ItemsRenderer uses this count to find the child items in the flattened items
        const numChildren = childItems.length + (isChildCreate ? 1 : 0);
        const childItemsHeight = childItems.length * (0, $gf0vG.BASE_LEVEL_ITEM_HEIGHT) + (isChildCreate ? itemHeight : 0);
        const flattenedItem = $f8b6334e2bcb5845$var$enrichItem({
            item: itemProps,
            expandedItems: expandedItems,
            rootIndex: rootIndex,
            flatIndex: flatParentIndex,
            ariaRowIndex: isRowCountKnown ? ariaRowIndex : undefined,
            isParent: childItems.length > 0,
            numChildren: numChildren,
            startOffset: offset,
            childItemsHeight: childItemsHeight
        });
        flattenedItems.push(flattenedItem);
        // Increase the index to account for the parent item, which will be inserted first
        flatIndex += 1;
        ariaRowIndex += 1;
        if (expandedItems[id]) {
            childOffset = itemHeight;
            childItems.forEach(({ id: childId, level: childLevel = (0, $gf0vG.DEFAULT_LEVEL) - 1, isInTransition: childIsInTransition })=>{
                const childItemProps = {
                    id: childId,
                    level: childLevel,
                    isInTransition: childIsInTransition
                };
                if (isCreateSiblingEnabled && $f8b6334e2bcb5845$var$shouldCreateBeforeItem(createItemAnchor, childId)) {
                    const createChildItem = $f8b6334e2bcb5845$var$enrichCreateItem({
                        anchorItem: childItemProps,
                        parentId: id,
                        createItemAnchor: createItemAnchor,
                        rootIndex: rootIndex,
                        ariaRowIndex: isRowCountKnown ? ariaRowIndex : undefined,
                        startOffset: childOffset,
                        parentStartOffset: offset
                    });
                    flattenedItems.push(createChildItem);
                    ariaRowIndex += 1;
                    childOffset += itemHeight;
                }
                const flattenedChildItem = $f8b6334e2bcb5845$var$enrichChildItem({
                    item: childItemProps,
                    parentItem: itemProps,
                    rootIndex: rootIndex,
                    flatIndex: flatIndex,
                    ariaRowIndex: isRowCountKnown ? ariaRowIndex : undefined,
                    startOffset: childOffset,
                    parentStartOffset: offset
                });
                flattenedItems.push(flattenedChildItem);
                flatIndex += 1;
                ariaRowIndex += 1;
                childOffset += (0, $gf0vG.BASE_LEVEL_ITEM_HEIGHT);
            });
            // Creating an item inside a parent will always be in last position
            if (isChildCreate && createItemAnchor && createItemAnchor.position === (0, $gf0vG.INSIDE)) {
                const createChildItem = $f8b6334e2bcb5845$var$enrichCreateItem({
                    anchorItem: itemProps,
                    parentId: id,
                    createItemAnchor: createItemAnchor,
                    rootIndex: rootIndex,
                    ariaRowIndex: isRowCountKnown ? ariaRowIndex : undefined,
                    startOffset: childOffset,
                    parentStartOffset: offset
                });
                flattenedItems.push(createChildItem);
                ariaRowIndex += 1;
            }
            offset += childItemsHeight;
        } else ariaRowIndex += childItems.length;
        offset += itemHeight;
    });
    if (isCreateLastEnabled && $f8b6334e2bcb5845$var$shouldCreateLast(createItemAnchor)) {
        const createItem = $f8b6334e2bcb5845$var$enrichCreateItem({
            anchorItem: undefined,
            parentId: undefined,
            createItemAnchor: createItemAnchor,
            rootIndex: items.length,
            ariaRowIndex: isRowCountKnown ? ariaRowIndex : undefined,
            startOffset: offset,
            parentStartOffset: 0
        });
        flattenedItems.push(createItem);
        ariaRowIndex += 1;
    }
    return {
        flatItems: flattenedItems,
        ariaRowCount: isRowCountKnown ? ariaRowIndex - 1 : -1
    };
});

});

parcelRegister("8zane", function(module, exports) {

$parcel$export(module.exports, "getItemsContainerStyle", () => $8aefd92011664154$export$30f72c856f253ec5);

var $5iWql = parcelRequire("5iWql");

var $PdmhA = parcelRequire("PdmhA");

var $1ybV0 = parcelRequire("1ybV0");

var $gf0vG = parcelRequire("gf0vG");
const $8aefd92011664154$export$38a59fc64a33c476 = (0, $5iWql.default)((items, itemHeight)=>{
    if (!items.length) return [];
    const rows = [];
    if ((0, $1ybV0.ff)('jwm.visual-hierarchy-milestone-1')) {
        // we should only iterate on the top level items (depth === 0)
        // Only the root items alternate the bg color ¯\_(ツ)_/¯
        let createItemIndex = -1;
        items.filter(({ meta: meta })=>meta?.parentId === undefined).forEach((item, index)=>{
            // Row height includes child items' height which is already calculated,
            // and the item's height itself in meta
            // Only the last create-item row alternates bg color ¯\_(ツ)_/¯
            if (item.type === (0, $gf0vG.CREATE_ITEM_TYPE)) {
                if (index === items.length - 1) rows.push(itemHeight);
                else // save the create index, so we could add it up to the previous (or next) row after calculation
                createItemIndex = index;
            } else // This is an ITEM_TYPE,
            // childItemsHeight would be zero if the item is not expanded
            rows.push((item.meta?.childItemsHeight || 0) + itemHeight);
        });
        // if there is a create item at the top level but not last item, add it to the previous row
        // if the create item is the first item, it'll add it to the first ITEM_TYPE
        if (createItemIndex !== -1) rows[Math.max(0, createItemIndex - 1)] += itemHeight;
        return rows;
    }
    /**
   * Generate rows of height, child items' height will be combined into parent item's entry
   * Each entry is a new alternate row
   */ let total = 0;
    // Reverse iteration is more efficient to check when should the row alternates because the first item is always parent
    const reversedItems = [
        ...items
    ].reverse();
    reversedItems.forEach((item, index)=>{
        const rowHeight = item.type === (0, $gf0vG.CHILD_ITEM_TYPE) ? (0, $gf0vG.BASE_LEVEL_ITEM_HEIGHT) : itemHeight;
        total += rowHeight;
        // Row height include child item and child create-item
        if (// Only the last create-item row alternates bg color ¯\_(ツ)_/¯
        index === 0 && item.type === (0, $gf0vG.CREATE_ITEM_TYPE) && item.meta.level === 1 || // All parent item alternates bg color
        item.type === (0, $gf0vG.ITEM_TYPE)) {
            rows.push(total);
            total = 0;
        }
    });
    return rows.reverse();
});
const $8aefd92011664154$export$115273ef5e87cd0c = (0, $5iWql.default)((rows)=>{
    if (!rows.length) return {
        itemsBackground: (0, $1ybV0.ff)('jsw.roadmaps.gridification-markup') ? `var(--ds-background-neutral, ${0, $PdmhA.N50A})` : '',
        totalHeight: 0
    };
    const prefix = 'linear-gradient(to bottom,';
    let position = 0;
    /**
   * Split rows background into smaller chunks due to a bug in Chrome browser
   * Chrome renders blurry edges when there are more than ~6 entries
   * https://bugs.chromium.org/p/chromium/issues/detail?id=1103863
   */ let count = 0;
    const chunkSize = 4;
    const rowsBackground = rows.reduce((accum, curr, index)=>{
        const bgColor = index % 2 === 0 ? `var(--ds-surface, ${0, $PdmhA.N0})` : `var(--ds-surface-sunken, ${0, $PdmhA.N20})`;
        let rowStyle = `${bgColor} ${position}px ${position + curr}px`;
        if (count === chunkSize || index === rows.length - 1) {
            count = 0;
            rowStyle += `,transparent ${position + curr}px)`;
            rowStyle += index !== rows.length - 1 ? `,${prefix}` : '';
        } else {
            count += 1;
            rowStyle += ',';
        }
        position += curr;
        return accum + rowStyle;
    }, prefix);
    return {
        itemsBackground: rowsBackground,
        totalHeight: position
    };
});
const $8aefd92011664154$export$30f72c856f253ec5 = (0, $5iWql.default)((items, itemHeight)=>{
    const rows = $8aefd92011664154$export$38a59fc64a33c476(items, itemHeight);
    return $8aefd92011664154$export$115273ef5e87cd0c(rows);
});

});

parcelRegister("kTIHV", function(module, exports) {

$parcel$export(module.exports, "getSelectedItemIdsHash", () => $86097d83f4a1cde3$export$6147ec740e92f913);

var $5iWql = parcelRequire("5iWql");
const $86097d83f4a1cde3$export$6147ec740e92f913 = (0, $5iWql.default)((selectedItemIdsWithPermission)=>selectedItemIdsWithPermission ? selectedItemIdsWithPermission.reduce((itemsSelectionState, selectedItemId)=>{
        Object.assign(itemsSelectionState, {
            [selectedItemId]: true
        });
        return itemsSelectionState;
    }, {}) : undefined);

});

parcelRegister("2qMqD", function(module, exports) {

$parcel$export(module.exports, "actions", () => $e6389b14b83cdc8f$export$e324594224ef24da);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $e6389b14b83cdc8f$export$e324594224ef24da = {};

});

parcelRegister("dHiyA", function(module, exports) {

$parcel$export(module.exports, "getIsTableEmpty", () => $5aeacb85a3bf5ed2$export$b8347bf00a122737);
$parcel$export(module.exports, "getIsItemSelected", () => $5aeacb85a3bf5ed2$export$eacf042ab4fde4a7);
$parcel$export(module.exports, "getItems", () => $5aeacb85a3bf5ed2$export$d2f92acf417bbf5d);
$parcel$export(module.exports, "getItemsContainerStyles", () => $5aeacb85a3bf5ed2$export$cc1469a0793758e9);
$parcel$export(module.exports, "getItemHeight", () => $5aeacb85a3bf5ed2$export$ddd834f23fa82fc4);
$parcel$export(module.exports, "getItemsCount", () => $5aeacb85a3bf5ed2$export$dd01a43948d7de86);
$parcel$export(module.exports, "getAriaRowCount", () => $5aeacb85a3bf5ed2$export$3d62f784b6f09127);
$parcel$export(module.exports, "getHasActiveCreate", () => $5aeacb85a3bf5ed2$export$37a764c3aa026241);
$parcel$export(module.exports, "getCreateItemAnchor", () => $5aeacb85a3bf5ed2$export$136936d41252875f);
const $5aeacb85a3bf5ed2$export$b8347bf00a122737 = (state)=>state.isTableEmpty;
const $5aeacb85a3bf5ed2$export$eacf042ab4fde4a7 = ({ itemsSelectionState: itemsSelectionState }, id)=>itemsSelectionState ? itemsSelectionState[id] ?? false : undefined;
const $5aeacb85a3bf5ed2$export$d2f92acf417bbf5d = (state)=>state.items;
const $5aeacb85a3bf5ed2$export$cc1469a0793758e9 = (state)=>({
        itemsBackground: state.itemsBackground,
        totalHeight: state.totalHeight
    });
const $5aeacb85a3bf5ed2$export$ddd834f23fa82fc4 = (state)=>state.itemHeight;
const $5aeacb85a3bf5ed2$export$dd01a43948d7de86 = (state)=>state.items.length;
const $5aeacb85a3bf5ed2$export$3d62f784b6f09127 = (state)=>state.ariaRowCount;
const $5aeacb85a3bf5ed2$export$37a764c3aa026241 = (state)=>state.createItemAnchor !== undefined;
const $5aeacb85a3bf5ed2$export$136936d41252875f = (state)=>state.createItemAnchor;

});


parcelRegister("nH3p1", function(module, exports) {

$parcel$export(module.exports, "useListWidth", () => $2277c74ed4fc72bd$export$55c090d16aa0f75d);
$parcel$export(module.exports, "default", () => $2277c74ed4fc72bd$export$2e2bcd8739ae039);

var $ggKAj = parcelRequire("ggKAj");
var $heB5U = parcelRequire("heB5U");
var $a61MH = parcelRequire("a61MH");

var $gf0vG = parcelRequire("gf0vG");

var $3bfJ7 = parcelRequire("3bfJ7");

var $6Tyrm = parcelRequire("6Tyrm");
const $2277c74ed4fc72bd$var$initialState = {
    listWidth: (0, $gf0vG.DEFAULT_LIST_WIDTH)
};
const $2277c74ed4fc72bd$export$3e2081a696ef1795 = (0, $a61MH.createStore)({
    initialState: $2277c74ed4fc72bd$var$initialState,
    actions: $3bfJ7.actions,
    name: 'timeline-table.list'
});
const $2277c74ed4fc72bd$export$469df0dd4929d037 = (0, $ggKAj.createActionsHook)($2277c74ed4fc72bd$export$3e2081a696ef1795);
const $2277c74ed4fc72bd$export$55c090d16aa0f75d = (0, $ggKAj.createHook)($2277c74ed4fc72bd$export$3e2081a696ef1795, {
    selector: (0, $6Tyrm.getListWidth)
});
const $2277c74ed4fc72bd$export$2f645645f7bca764 = (0, $ggKAj.createHook)($2277c74ed4fc72bd$export$3e2081a696ef1795);
const $2277c74ed4fc72bd$export$9b0a72e5d41d62ec = (0, $heB5U.createContainer)($2277c74ed4fc72bd$export$3e2081a696ef1795, {
    onInit: ()=>({ setState: setState }, listState)=>{
            setState({
                ...listState
            });
        },
    onUpdate: ()=>({ setState: setState }, listState)=>{
            setState({
                ...listState
            });
        }
});
var $2277c74ed4fc72bd$export$2e2bcd8739ae039 = $2277c74ed4fc72bd$export$9b0a72e5d41d62ec;

});
parcelRegister("3bfJ7", function(module, exports) {

$parcel$export(module.exports, "actions", () => $e783548ea8558ac8$export$e324594224ef24da);

var $03mdU = parcelRequire("03mdU");
const $e783548ea8558ac8$export$e324594224ef24da = {
    setListWidth: $03mdU.setListWidth
};

});
parcelRegister("03mdU", function(module, exports) {

$parcel$export(module.exports, "setListWidth", () => $fcfdb1ed0089906c$export$e9fd6c0c57a999a3);
const $fcfdb1ed0089906c$export$e9fd6c0c57a999a3 = (listWidth)=>({ setState: setState })=>{
        setState({
            listWidth: listWidth
        });
    };

});


parcelRegister("6Tyrm", function(module, exports) {

$parcel$export(module.exports, "getListWidth", () => $93450cad8350d7e0$export$546faffca0a891d);
const $93450cad8350d7e0$export$546faffca0a891d = (state)=>state.listWidth;

});


parcelRegister("lvr5h", function(module, exports) {

$parcel$export(module.exports, "default", () => $2edc8d12ea3b81e2$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $h829Y = parcelRequire("h829Y");
const $2edc8d12ea3b81e2$var$TablePortalProvider = (props)=>{
    const [portalContainerElement, setPortalContainerElement] = (0, $eUqFw.useState)(null);
    const portalState = (0, $eUqFw.useMemo)(()=>({
            setPortalContainerElement: setPortalContainerElement,
            portalContainerElement: portalContainerElement
        }), [
        portalContainerElement
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h829Y.PortalScopeContext).Provider, {
        value: portalState
    }, props.children);
};
var $2edc8d12ea3b81e2$export$2e2bcd8739ae039 = $2edc8d12ea3b81e2$var$TablePortalProvider;

});
parcelRegister("h829Y", function(module, exports) {

$parcel$export(module.exports, "PortalScopeContext", () => $36a2c3edf9c222be$export$c9ecc14d092a6ed0);
$parcel$export(module.exports, "usePortalScope", () => $36a2c3edf9c222be$export$ed9db44bbd000055);

var $eUqFw = parcelRequire("eUqFw");
const $36a2c3edf9c222be$export$c9ecc14d092a6ed0 = /*#__PURE__*/ (0, $eUqFw.createContext)({
    setPortalContainerElement: ()=>undefined,
    portalContainerElement: null
});
const $36a2c3edf9c222be$export$ed9db44bbd000055 = ()=>(0, $eUqFw.useContext)($36a2c3edf9c222be$export$c9ecc14d092a6ed0);

});


parcelRegister("3XwA1", function(module, exports) {

$parcel$export(module.exports, "useTimelineState", () => $7f456431cfda2d7a$export$f92f0bc83b35c17b);
$parcel$export(module.exports, "TimelineProviderSweetState", () => $7f456431cfda2d7a$export$4f33ace85fd289c5);

var $heB5U = parcelRequire("heB5U");
var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");

var $gf0vG = parcelRequire("gf0vG");

var $l2CBN = parcelRequire("l2CBN");
var $1QJt8 = parcelRequire("1QJt8");

var $7ymwE = parcelRequire("7ymwE");
const $7f456431cfda2d7a$var$initialState = {
    /* Raw data */ today: 0,
    timelineMode: (0, $gf0vG.MONTHS),
    timelineDuration: {
        startMilliseconds: 0,
        endMilliseconds: 0,
        totalMilliseconds: 0
    },
    timelineOrigin: 0,
    /* Derived data */ timelineWidth: 0,
    timelineOriginPosition: 0,
    columnDurations: [],
    columnPositions: []
};
const $7f456431cfda2d7a$export$2ce7f0e10391f4 = (0, $a61MH.createStore)({
    initialState: $7f456431cfda2d7a$var$initialState,
    actions: $7ymwE.actions,
    name: 'timeline-table.timeline'
});
const $7f456431cfda2d7a$export$f92f0bc83b35c17b = (0, $ggKAj.createHook)($7f456431cfda2d7a$export$2ce7f0e10391f4);
const $7f456431cfda2d7a$var$handleState = ()=>({ setState: setState }, timelineData)=>{
        const { timelineMode: timelineMode, timelineDuration: timelineDuration, timelineOrigin: timelineOrigin } = timelineData;
        const timelineWidth = (0, $1QJt8.getTimelineWidth)(timelineMode, timelineDuration.totalMilliseconds);
        const columnDurations = (0, $l2CBN.getColumnDurations)(timelineMode, timelineDuration);
        const columnPositions = (0, $l2CBN.getColumnPositions)(timelineDuration, columnDurations);
        const timelineOriginPosition = (0, $1QJt8.getTimelinePositionFromDate)(timelineDuration, timelineWidth, timelineOrigin);
        setState({
            ...timelineData,
            timelineWidth: timelineWidth,
            timelineOriginPosition: timelineOriginPosition,
            columnDurations: columnDurations,
            columnPositions: columnPositions
        });
    };
const $7f456431cfda2d7a$export$4f33ace85fd289c5 = (0, $heB5U.createContainer)($7f456431cfda2d7a$export$2ce7f0e10391f4, {
    onInit: $7f456431cfda2d7a$var$handleState,
    onUpdate: $7f456431cfda2d7a$var$handleState
});

});
parcelRegister("l2CBN", function(module, exports) {

$parcel$export(module.exports, "getColumnDurations", () => $c923ac3e953c0bb6$export$97c232fe861416fb);
$parcel$export(module.exports, "getColumnPositions", () => $c923ac3e953c0bb6$export$1f04562dc761554b);
$parcel$export(module.exports, "getTodayColumnIndex", () => $c923ac3e953c0bb6$export$ce237023318dfe05);

var $5iWql = parcelRequire("5iWql");

var $jJwwt = parcelRequire("jJwwt");

var $gf0vG = parcelRequire("gf0vG");
const $c923ac3e953c0bb6$var$getColumnDurationsForMode = (timelineDuration, momentIdentifier)=>{
    const columnDurations = [];
    const { startMilliseconds: startMilliseconds, endMilliseconds: endMilliseconds } = timelineDuration;
    // Sanitize. We still want to *round* to an ISO week, but you can't *add* an ISO week (it fails silently).
    const momentAddIdentifier = momentIdentifier === 'isoWeek' ? 'week' : momentIdentifier;
    const startMoment = (0, (/*@__PURE__*/$parcel$interopDefault($jJwwt))).utc(startMilliseconds).startOf(momentIdentifier);
    while(startMoment.valueOf() < endMilliseconds){
        const endMoment = startMoment.clone().endOf(momentIdentifier);
        columnDurations.push({
            startMilliseconds: startMoment.valueOf(),
            endMilliseconds: endMoment.valueOf(),
            totalMilliseconds: endMoment.diff(startMoment, 'milliseconds')
        });
        startMoment.add(1, momentAddIdentifier);
    }
    return columnDurations;
};
const $c923ac3e953c0bb6$export$97c232fe861416fb = (0, $5iWql.default)((timelineMode, timelineDuration)=>{
    if (timelineMode === (0, $gf0vG.QUARTERS)) return $c923ac3e953c0bb6$var$getColumnDurationsForMode(timelineDuration, 'quarter');
    if (timelineMode === (0, $gf0vG.MONTHS)) return $c923ac3e953c0bb6$var$getColumnDurationsForMode(timelineDuration, 'month');
    /* We always want a week column to start on Monday. The 'week' parameter is locale aware which could start on Sunday.
		 * An ISO week on the other hand always starts on the Monday.
		 */ return $c923ac3e953c0bb6$var$getColumnDurationsForMode(timelineDuration, 'isoWeek');
});
const $c923ac3e953c0bb6$export$1f04562dc761554b = (0, $5iWql.default)((timelineDuration, columnDurations)=>{
    let left = 0;
    if (columnDurations.length > 0) // Column start can be earlier than the timeline start. This means the first column left can be a negative value.
    // Example where this can happen is in the export table where the timeline duration is clamped to the selected date range.
    left = (columnDurations[0].startMilliseconds - timelineDuration.startMilliseconds) / timelineDuration.totalMilliseconds * 100;
    return columnDurations.map((columnDuration)=>{
        const width = columnDuration.totalMilliseconds / timelineDuration.totalMilliseconds * 100;
        left += width;
        return [
            left - width,
            100 - left
        ];
    });
});
const $c923ac3e953c0bb6$export$ce237023318dfe05 = (0, $5iWql.default)((today, columnDurations)=>{
    let todayColumnIndex = 0;
    columnDurations.some(({ startMilliseconds: startMilliseconds, endMilliseconds: endMilliseconds })=>{
        if (today >= startMilliseconds && today <= endMilliseconds) return true;
        todayColumnIndex += 1;
        return false;
    });
    return todayColumnIndex;
});

});

parcelRegister("7ymwE", function(module, exports) {

$parcel$export(module.exports, "actions", () => $a4619ff803e39c87$export$e324594224ef24da);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $a4619ff803e39c87$export$e324594224ef24da = {};

});


parcelRegister("cZkk1", function(module, exports) {

$parcel$export(module.exports, "useTimelineViewportActions", () => $5caed9027b519818$export$93c2697e07ec9389);
$parcel$export(module.exports, "useTimelineViewport", () => $5caed9027b519818$export$408aa890bc70d3dc);
$parcel$export(module.exports, "TimelineViewportProvider", () => $5caed9027b519818$export$f521cde558624422);

var $ggKAj = parcelRequire("ggKAj");
var $heB5U = parcelRequire("heB5U");
var $a61MH = parcelRequire("a61MH");

var $ggROF = parcelRequire("ggROF");
const $5caed9027b519818$var$initialState = {
    left: 0,
    clientWidth: 0,
    indicatorLineOffset: 0
};
const $5caed9027b519818$export$d474af741f65a5d3 = (0, $a61MH.createStore)({
    initialState: $5caed9027b519818$var$initialState,
    actions: $ggROF.actions,
    name: 'timeline-table.timeline-viewport'
});
const $5caed9027b519818$export$93c2697e07ec9389 = (0, $ggKAj.createActionsHook)($5caed9027b519818$export$d474af741f65a5d3);
const $5caed9027b519818$export$408aa890bc70d3dc = (0, $ggKAj.createHook)($5caed9027b519818$export$d474af741f65a5d3);
const $5caed9027b519818$export$f521cde558624422 = (0, $heB5U.createContainer)($5caed9027b519818$export$d474af741f65a5d3);

});
parcelRegister("ggROF", function(module, exports) {

$parcel$export(module.exports, "actions", () => $53e68ca006939e1d$export$e324594224ef24da);

var $dBS6z = parcelRequire("dBS6z");
const $53e68ca006939e1d$export$e324594224ef24da = {
    onResize: $dBS6z.onResize
};

});
parcelRegister("dBS6z", function(module, exports) {

$parcel$export(module.exports, "onResize", () => $22d5f79b2e1b025c$export$45b39e67d4ce4921);
const $22d5f79b2e1b025c$export$45b39e67d4ce4921 = (params)=>({ setState: setState })=>{
        setState({
            ...params
        });
    };

});



parcelRegister("bwj1b", function(module, exports) {

$parcel$export(module.exports, "default", () => $738cfeea76ad64b7$export$2e2bcd8739ae039);
$parcel$export(module.exports, "useSideEffectMarshal", () => $738cfeea76ad64b7$export$b2476fd3df1b06b6);

var $eUqFw = parcelRequire("eUqFw");

var $XHGTv = parcelRequire("XHGTv");

var $1ybV0 = parcelRequire("1ybV0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $lSR7G = parcelRequire("lSR7G");

var $8iXXr = parcelRequire("8iXXr");

var $1rnzH = parcelRequire("1rnzH");
parcelRequire("2PgrC");
var $jPGXT = parcelRequire("jPGXT");
var $2PgrC = parcelRequire("2PgrC");

var $fhdOI = parcelRequire("fhdOI");

var $1UVbw = parcelRequire("1UVbw");

var $fTs8H = parcelRequire("fTs8H");
const $738cfeea76ad64b7$var$SideEffectMarshal = ({ scope: scope, customActions: customActions, overrideActions: overrideActions, ariaLabel: ariaLabel, ariaReadOnly: ariaReadOnly, ariaMultiselectable: ariaMultiselectable, children: children })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const styleAPI = (0, $fhdOI.useStyleMarshal)(scope);
    const rowState = (0, $2PgrC.useRowState)();
    const [ariaRowCount] = (0, $lSR7G.useAriaRowCount)();
    /* Rather than wrap every function in useCallback, we can encapsulate everything into one useMemo.
   * Subjectively, this ended up being the more readable approach given the number of functions.
   */ const defaultActions = (0, $eUqFw.useMemo)(()=>{
        const onRowMouseEnter = (id)=>{
            if (rowState.get(id) || rowState.isAnyRowDragging()) return;
            styleAPI.hoverRow(id);
        };
        const onRowMouseLeave = (id)=>{
            if (rowState.get(id) || rowState.isAnyRowDragging()) return;
            styleAPI.leaveRow(id);
        };
        const onRowSelect = (ids)=>{
            ids.forEach((id)=>rowState.set(id, (0, $jPGXT.ROW_STATES).SELECTED));
            styleAPI.selectRow(ids);
        };
        const onRowDeselect = (ids)=>{
            ids.forEach((id)=>rowState.clear(id));
            styleAPI.deselectRow();
        };
        const onRowGenerateDragPreview = ()=>{
            styleAPI.hideChildCreate();
        };
        const onRowDragStart = (id)=>{
            rowState.set(id, (0, $jPGXT.ROW_STATES).DRAGGED);
            styleAPI.dragRow(id);
        };
        const onRowDragEnd = (id)=>{
            const wasRowSelected = rowState.wasRowSelected(id);
            wasRowSelected ? rowState.set(id, (0, $jPGXT.ROW_STATES).SELECTED) : rowState.clear(id);
            styleAPI.dropRow(id, wasRowSelected);
        };
        /**
     *
     * @param id
     * @param top
     * @param left: Left offset when dragging at nested levels
     */ const onRowDragOver = (id, top, left)=>{
            rowState.set(id, (0, $jPGXT.ROW_STATES).DRAGGED_OVER);
            if ((0, $1ybV0.ff)('jwm.visual-hierarchy-dnd')) styleAPI.showDragIndicator(top, left);
            else styleAPI.showDragIndicator(top);
        };
        const onRowDragChildOverParent = (id, parentId)=>{
            rowState.set(id, (0, $jPGXT.ROW_STATES).DRAGGED_OVER);
            styleAPI.dragOverParent(parentId, rowState.get(parentId) === (0, $jPGXT.ROW_STATES).SELECTED);
        };
        /**
     * Clear the background color of the parent row when dragging child over parent ends
     * @param parentId
     */ const onRowDragChildOverParentEnd = (parentId)=>{
            styleAPI.leaveRow(parentId);
        };
        const onRowDragOutOfBounds = (id)=>{
            rowState.set(id, (0, $jPGXT.ROW_STATES).DRAGGED_OUT);
            styleAPI.dragOutOfBounds();
        };
        const onAddButtonMouseEnter = (top, tabFocused)=>{
            if (rowState.isAnyRowDragging()) return;
            if ((0, $XHGTv.fg)('jsw_roadmaps_timeline-issue-creation-ally')) styleAPI.showInlineCreate(top, tabFocused);
            else styleAPI.showInlineCreate(top);
        };
        const onAddButtonMouseLeave = ()=>{
            if (rowState.isAnyRowDragging()) return;
            styleAPI.hideInlineCreate();
        };
        const onScrollStateChanged = (isScrolling)=>{
            if (rowState.isAnyRowDragging()) return;
            isScrolling ? styleAPI.blockPointerEvents() : styleAPI.allowPointerEvents();
        };
        return {
            onRowMouseEnter: onRowMouseEnter,
            onRowMouseLeave: onRowMouseLeave,
            onRowSelect: onRowSelect,
            onRowDeselect: onRowDeselect,
            onRowGenerateDragPreview: onRowGenerateDragPreview,
            onRowDragStart: onRowDragStart,
            onRowDragEnd: onRowDragEnd,
            onRowDragOver: onRowDragOver,
            onRowDragChildOverParent: onRowDragChildOverParent,
            onRowDragChildOverParentEnd: onRowDragChildOverParentEnd,
            onRowDragOutOfBounds: onRowDragOutOfBounds,
            onAddButtonMouseEnter: onAddButtonMouseEnter,
            onAddButtonMouseLeave: onAddButtonMouseLeave,
            onScrollStateChanged: onScrollStateChanged
        };
    }, [
        rowState,
        styleAPI
    ]);
    const combinedActions = (0, $eUqFw.useMemo)(()=>({
            ...(0, $1UVbw.bindOverrideActions)(defaultActions, overrideActions, styleAPI),
            custom: (0, $1UVbw.bindCustomActions)(customActions, styleAPI)
        }), [
        defaultActions,
        customActions,
        overrideActions,
        styleAPI
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8iXXr.SideEffectContext).Provider, {
        value: combinedActions
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        role: "grid",
        "aria-rowcount": ariaRowCount,
        "aria-multiselectable": ariaMultiselectable,
        "aria-label": ariaLabel ?? formatMessage((0, $1rnzH.default).defaultLabel),
        "aria-readonly": ariaReadOnly,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: scope
    }, children));
};
$738cfeea76ad64b7$var$SideEffectMarshal.defaultProps = {
    customActions: {},
    overrideActions: {},
    ariaLabel: undefined,
    ariaReadOnly: undefined,
    ariaMultiselectable: undefined
};
var $738cfeea76ad64b7$export$2e2bcd8739ae039 = $738cfeea76ad64b7$var$SideEffectMarshal;
const $738cfeea76ad64b7$export$b2476fd3df1b06b6 = ()=>(0, $eUqFw.useContext)((0, $8iXXr.SideEffectContext));

});
parcelRegister("8iXXr", function(module, exports) {

$parcel$export(module.exports, "SideEffectContext", () => $72c565eee22cabad$export$f87600ce6f9a1288);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");
const $72c565eee22cabad$export$f87600ce6f9a1288 = /*#__PURE__*/ (0, $eUqFw.createContext)({
    custom: {},
    onRowMouseEnter: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    onRowMouseLeave: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    onRowSelect: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    onRowDeselect: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    onRowGenerateDragPreview: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    onRowDragStart: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    onRowDragEnd: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    onRowDragOver: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    onRowDragChildOverParent: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    onRowDragChildOverParentEnd: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    onRowDragOutOfBounds: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    onAddButtonMouseEnter: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    onAddButtonMouseLeave: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    onScrollStateChanged: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
});

});

parcelRegister("1rnzH", function(module, exports) {

$parcel$export(module.exports, "default", () => $661a9b5df5329cff$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $661a9b5df5329cff$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    defaultLabel: {
        "id": "roadmap.timeline-table.common.context.side-effect-marshal.default-label",
        "defaultMessage": "Timeline"
    }
});

});

parcelRegister("2PgrC", function(module, exports) {

$parcel$export(module.exports, "useRowState", () => $2c1d650abeae86aa$export$b2440517e54eabc);
$parcel$export(module.exports, "ROW_STATES", () => (parcelRequire("jPGXT")).ROW_STATES);

var $eUqFw = parcelRequire("eUqFw");

var $gUUjF = parcelRequire("gUUjF");

var $jPGXT = parcelRequire("jPGXT");
const $2c1d650abeae86aa$export$b2440517e54eabc = ()=>{
    const rowState = (0, $eUqFw.useRef)({});
    const stateCount = (0, $eUqFw.useRef)({
        ...(0, $jPGXT.DEFAULT_COUNTS)
    });
    const previouslySelected = (0, $eUqFw.useRef)({});
    // ================ //
    // === METADATA === //
    // ================ //
    // Doing this for each `set` and `clear` operation stops this from becoming an O(N) problem
    const updateStateCount = (0, $eUqFw.useCallback)((currentState, nextState)=>{
        if (currentState) stateCount.current[currentState] -= 1;
        if (nextState) stateCount.current[nextState] += 1;
    }, []);
    const isAnyRowDragging = (0, $eUqFw.useCallback)(()=>stateCount.current[(0, $jPGXT.ROW_STATES).DRAGGED] > 0 || stateCount.current[(0, $jPGXT.ROW_STATES).DRAGGED_OVER] > 0 || stateCount.current[(0, $jPGXT.ROW_STATES).DRAGGED_OUT] > 0, []);
    // Helps with interactions that rely on restoring the selection state
    const updatePreviouslySelected = (0, $eUqFw.useCallback)((id, currentState, nextState)=>{
        if (nextState && currentState === (0, $jPGXT.ROW_STATES).SELECTED) previouslySelected.current[id] = true;
        if (!nextState || nextState === (0, $jPGXT.ROW_STATES).SELECTED) delete previouslySelected.current[id];
    }, []);
    const wasRowSelected = (0, $eUqFw.useCallback)((id)=>previouslySelected.current[id] ?? false, []);
    // ================= //
    // === GET / SET === //
    // ================= //
    const get = (0, $eUqFw.useCallback)((id)=>rowState.current[id], []);
    const set = (0, $eUqFw.useCallback)((id, nextState)=>{
        const currentState = get(id);
        if (!currentState && (0, $jPGXT.VALID_INITIAL_STATES)[nextState] || currentState && (0, $jPGXT.VALID_TRANSITIONS)[currentState][nextState]) {
            updateStateCount(currentState, nextState);
            updatePreviouslySelected(id, currentState, nextState);
            rowState.current[id] = nextState;
        } else if (currentState !== nextState) (0, $gUUjF.default).safeWarnWithoutCustomerData('timeline-table.side-effect-marshal', `Warning: invalid row transition from ${currentState} to ${nextState}`);
    }, [
        get,
        updateStateCount,
        updatePreviouslySelected
    ]);
    const clear = (0, $eUqFw.useCallback)((id)=>{
        const currentState = get(id);
        if (currentState) {
            updateStateCount(currentState);
            updatePreviouslySelected(id, currentState);
            delete rowState.current[id];
        } else (0, $gUUjF.default).safeWarnWithoutCustomerData('timeline-table.side-effect-marshal', 'Warning: there is no row entry to remove');
    }, [
        get,
        updateStateCount,
        updatePreviouslySelected
    ]);
    return (0, $eUqFw.useMemo)(()=>({
            get: get,
            set: set,
            clear: clear,
            isAnyRowDragging: isAnyRowDragging,
            wasRowSelected: wasRowSelected
        }), [
        get,
        set,
        clear,
        isAnyRowDragging,
        wasRowSelected
    ]);
};

});
parcelRegister("jPGXT", function(module, exports) {

$parcel$export(module.exports, "ROW_STATES", () => $7a092798de03dbbf$export$d17c451ccb229dcb);
$parcel$export(module.exports, "VALID_INITIAL_STATES", () => $7a092798de03dbbf$export$43acf26460204930);
$parcel$export(module.exports, "VALID_TRANSITIONS", () => $7a092798de03dbbf$export$682b071fc4ac4b0c);
$parcel$export(module.exports, "DEFAULT_COUNTS", () => $7a092798de03dbbf$export$ccc216ff57ae82b9);
const $7a092798de03dbbf$export$d17c451ccb229dcb = {
    SELECTED: 'SELECTED',
    DRAGGED: 'DRAGGED',
    DRAGGED_OUT: 'DRAGGED_OUT',
    DRAGGED_OVER: 'DRAGGED_OVER'
};
const $7a092798de03dbbf$export$43acf26460204930 = {
    SELECTED: true,
    DRAGGED: true,
    DRAGGED_OUT: false,
    DRAGGED_OVER: false
};
const $7a092798de03dbbf$export$682b071fc4ac4b0c = {
    SELECTED: {
        DRAGGED: true
    },
    DRAGGED: {
        SELECTED: true,
        DRAGGED_OUT: true,
        DRAGGED_OVER: true
    },
    DRAGGED_OUT: {
        SELECTED: true,
        DRAGGED_OVER: true
    },
    DRAGGED_OVER: {
        SELECTED: true,
        DRAGGED_OUT: true
    }
};
const $7a092798de03dbbf$export$ccc216ff57ae82b9 = {
    SELECTED: 0,
    DRAGGED: 0,
    DRAGGED_OUT: 0,
    DRAGGED_OVER: 0
};

});


parcelRegister("fhdOI", function(module, exports) {

$parcel$export(module.exports, "useStyleMarshal", () => $10bb96204b760a96$export$984a1617ce4cc44b);

var $eUqFw = parcelRequire("eUqFw");

var $XHGTv = parcelRequire("XHGTv");

var $fTs8H = parcelRequire("fTs8H");
/* This hook can be used to style components outside the React lifecycle, and without the aid
 * of libraries like compiled. It is achieved by inserting styles directly into a `<style>` tag
 * in the `<head>` of the document (similar to popular CSS-in-JS frameworks).
 *
 * This is necessary to provide a performant experience for high-frequency interactions that need
 * to be synchronised across the table. E.g. setting the hover state across the same row in all columns
 * is not be viable with prop drilling, since reconciliation is too expensive.
 */ const $10bb96204b760a96$export$984a1617ce4cc44b = (scope)=>{
    const styleEl = (0, $eUqFw.useRef)();
    (0, $eUqFw.useLayoutEffect)(()=>{
        if (typeof document !== 'undefined') {
            styleEl.current = document.createElement('style');
            styleEl.current.id = 'roadmap-data-styles';
            const head = document.querySelector('head');
            head && head.appendChild(styleEl.current);
        }
        return ()=>{
            styleEl.current?.parentNode?.removeChild(styleEl.current);
        };
    }, []);
    // The primitive utils to manipulate our custom style element
    const styleUtils = (0, $eUqFw.useMemo)(()=>{
        const insertStyle = (className, rule)=>{
            removeStyle(className);
            addToStylesheet((0, $fTs8H.toSelector)(className), rule);
        };
        const removeStyle = (className)=>{
            if (!styleEl.current || !styleEl.current.sheet) return;
            const ruleIndex = (0, $fTs8H.getIndexBySelector)(scope, styleEl.current.sheet.cssRules, (0, $fTs8H.toSelector)(className));
            if (ruleIndex !== -1) styleEl.current.sheet.deleteRule(ruleIndex);
        };
        const updateStyle = (targetClassNames, style)=>{
            if (!styleEl.current || !styleEl.current.sheet) return;
            const ruleIndex = (0, $fTs8H.getIndexByRule)(styleEl.current.sheet.cssRules, style);
            const selectors = (0, $fTs8H.toSelectors)(targetClassNames, scope);
            ruleIndex !== -1 && styleEl.current.sheet.deleteRule(ruleIndex);
            if (selectors.length > 0) styleEl.current.sheet.insertRule(`${selectors.join(', ')} {${(0, $fTs8H.toRule)(style)}}`, styleEl.current.sheet.cssRules.length);
        };
        const addToStylesheet = (selector, rule)=>{
            styleEl.current?.sheet?.insertRule(`.${scope} ${String(selector)} {${rule.replace('\n', ' ')}}`, styleEl.current.sheet.cssRules.length);
        };
        return {
            insertStyle: insertStyle,
            removeStyle: removeStyle,
            updateStyle: updateStyle
        };
    }, [
        scope
    ]);
    // The view specific utils to manipulate our marshalled elements
    const styleAPI = (0, $eUqFw.useMemo)(()=>{
        const hoverRow = (id)=>{
            styleUtils.insertStyle((0, $fTs8H.classNames).row(id), (0, $fTs8H.styles).itemHover);
        };
        const leaveRow = (id)=>{
            styleUtils.removeStyle((0, $fTs8H.classNames).row(id));
        };
        const selectRow = (ids)=>{
            const selectedClasses = ids.map((id)=>(0, $fTs8H.classNames).row(id));
            styleUtils.updateStyle([], (0, $fTs8H.styles).itemHover);
            styleUtils.updateStyle(selectedClasses, (0, $fTs8H.styles).itemSelected);
        };
        const deselectRow = ()=>{
            styleUtils.updateStyle([], (0, $fTs8H.styles).itemSelected);
        };
        const dragRow = (id)=>{
            styleUtils.removeStyle((0, $fTs8H.classNames).inlineCreate);
            styleUtils.insertStyle((0, $fTs8H.classNames).row(id), (0, $fTs8H.styles).itemDragging);
            styleUtils.insertStyle((0, $fTs8H.classNames).rowChild(id), (0, $fTs8H.styles).itemDragging);
            styleUtils.insertStyle((0, $fTs8H.classNames).itemsContainer, (0, $fTs8H.styles).itemsContainerDragging);
        };
        const dropRow = (id, wasSelected)=>{
            styleUtils.removeStyle((0, $fTs8H.classNames).createChild);
            styleUtils.removeStyle((0, $fTs8H.classNames).row(id));
            styleUtils.removeStyle((0, $fTs8H.classNames).rowChild(id));
            styleUtils.removeStyle((0, $fTs8H.classNames).dragIndicator);
            styleUtils.removeStyle((0, $fTs8H.classNames).itemsContainer);
            wasSelected && styleUtils.insertStyle((0, $fTs8H.classNames).row(id), (0, $fTs8H.styles).itemSelected);
        };
        const showDragIndicator = (top, left)=>{
            styleUtils.insertStyle((0, $fTs8H.classNames).dragIndicator, (0, $fTs8H.styles).getDragIndicator(top, left));
        };
        const dragOverParent = (parentId, isSelected)=>{
            styleUtils.removeStyle((0, $fTs8H.classNames).dragIndicator);
            const style = isSelected ? (0, $fTs8H.styles).selectedItemCanBeCombined : (0, $fTs8H.styles).itemCanBeCombined;
            styleUtils.updateStyle([
                (0, $fTs8H.classNames).row(parentId)
            ], style);
        };
        const dragOutOfBounds = ()=>{
            styleUtils.removeStyle((0, $fTs8H.classNames).dragIndicator);
        };
        const showInlineCreate = (top, tabFocused)=>{
            styleUtils.insertStyle((0, $fTs8H.classNames).inlineCreate, (0, $fTs8H.styles).getInlineCreateButton(top));
            if ((0, $XHGTv.fg)('jsw_roadmaps_timeline-issue-creation-ally') && tabFocused) styleUtils.insertStyle((0, $fTs8H.classNames).inlineCreateIcon, (0, $fTs8H.styles).getInlineCreateIcon());
        };
        const hideInlineCreate = ()=>{
            styleUtils.removeStyle((0, $fTs8H.classNames).inlineCreate);
            if ((0, $XHGTv.fg)('jsw_roadmaps_timeline-issue-creation-ally')) styleUtils.removeStyle((0, $fTs8H.classNames).inlineCreateIcon);
        };
        const hideChildCreate = ()=>{
            styleUtils.insertStyle((0, $fTs8H.classNames).createChild, (0, $fTs8H.styles).itemDragging);
        };
        const blockPointerEvents = ()=>{
            styleUtils.insertStyle((0, $fTs8H.classNames).itemsContainer, (0, $fTs8H.styles).itemsContainerScrolling);
        };
        const allowPointerEvents = ()=>{
            styleAPI.removeStyle((0, $fTs8H.classNames).itemsContainer);
        };
        return {
            ...styleUtils,
            hoverRow: hoverRow,
            leaveRow: leaveRow,
            selectRow: selectRow,
            deselectRow: deselectRow,
            dragRow: dragRow,
            dropRow: dropRow,
            showDragIndicator: showDragIndicator,
            dragOverParent: dragOverParent,
            dragOutOfBounds: dragOutOfBounds,
            showInlineCreate: showInlineCreate,
            hideInlineCreate: hideInlineCreate,
            hideChildCreate: hideChildCreate,
            blockPointerEvents: blockPointerEvents,
            allowPointerEvents: allowPointerEvents
        };
    }, [
        styleUtils
    ]);
    return styleAPI;
};

});
parcelRegister("fTs8H", function(module, exports) {

$parcel$export(module.exports, "getIndexBySelector", () => $94099e6ff79fd880$export$531566c459a9453);
$parcel$export(module.exports, "getIndexByRule", () => $94099e6ff79fd880$export$5e88903c48b9b53);
$parcel$export(module.exports, "toRule", () => $94099e6ff79fd880$export$f9a10e11cef4ed80);
$parcel$export(module.exports, "toSelector", () => $94099e6ff79fd880$export$fef48429545ba792);
$parcel$export(module.exports, "toSelectors", () => $94099e6ff79fd880$export$fea3972019a1b6b0);
$parcel$export(module.exports, "classNames", () => $94099e6ff79fd880$export$ce4ab0c55987d1ff);
$parcel$export(module.exports, "styles", () => $94099e6ff79fd880$export$9dd6ff9ea0189349);
$parcel$export(module.exports, "getDragIndicatorClassName", () => $94099e6ff79fd880$export$5295be4f68791c03);
$parcel$export(module.exports, "getInlineCreateButtonClassName", () => $94099e6ff79fd880$export$c6b1c9f0aaabd326);
$parcel$export(module.exports, "getInlineCreateIconClassName", () => $94099e6ff79fd880$export$36993ff9ff59e588);
$parcel$export(module.exports, "getItemsBackgroundClassName", () => $94099e6ff79fd880$export$db96af0fdcbdbc30);
$parcel$export(module.exports, "getCreateChildButtonClassName", () => $94099e6ff79fd880$export$30e1e4b30ec4d53);
$parcel$export(module.exports, "getRowClassName", () => $94099e6ff79fd880$export$d435f2dd2e4838a0);

var $PdmhA = parcelRequire("PdmhA");

var $c7RR5 = parcelRequire("c7RR5");
const $94099e6ff79fd880$export$307b18b61172f7ed = (className)=>({
        className: Array.isArray(className) ? className.join(' ') : className
    });
const $94099e6ff79fd880$export$531566c459a9453 = (scope, cssRules, target)=>Array.from(cssRules || []).findIndex((cssRule)=>'selectorText' in cssRule && cssRule.selectorText === `.${scope} ${target}`);
const $94099e6ff79fd880$export$5e88903c48b9b53 = (cssRules, target)=>Array.from(cssRules || []).findIndex(({ cssText: cssText })=>$94099e6ff79fd880$export$f9a10e11cef4ed80(cssText).endsWith(`{${$94099e6ff79fd880$export$f9a10e11cef4ed80(target)}}`));
const $94099e6ff79fd880$export$fef48429545ba792 = (className)=>`.${className}`;
const $94099e6ff79fd880$export$fea3972019a1b6b0 = (targetClassNames, scope)=>targetClassNames.map((className)=>`.${scope} .${className}`);
const $94099e6ff79fd880$export$f9a10e11cef4ed80 = (style)=>style.replace(/#\w+/g, (hexColor)=>(0, $c7RR5.default)(hexColor)).replace(/[\r\n\s]/g, '');
// =============== //
// === CLASSES === //
// =============== //
const $94099e6ff79fd880$var$row = (id)=>`row-${id}`;
const $94099e6ff79fd880$var$rowChild = (id)=>`row-child-${id}`;
const $94099e6ff79fd880$var$inlineCreate = 'inline-create-button';
const $94099e6ff79fd880$var$inlineCreateIcon = 'inline-create-button-icon';
const $94099e6ff79fd880$var$dragIndicator = 'inline-drag-indicator';
const $94099e6ff79fd880$var$dragIndicatorTop = 'inline-drag-indicator-top';
const $94099e6ff79fd880$var$itemsContainer = 'items-container';
const $94099e6ff79fd880$var$createChild = 'create-child-button';
const $94099e6ff79fd880$export$ce4ab0c55987d1ff = {
    row: $94099e6ff79fd880$var$row,
    rowChild: $94099e6ff79fd880$var$rowChild,
    inlineCreate: $94099e6ff79fd880$var$inlineCreate,
    inlineCreateIcon: $94099e6ff79fd880$var$inlineCreateIcon,
    dragIndicator: $94099e6ff79fd880$var$dragIndicator,
    dragIndicatorTop: $94099e6ff79fd880$var$dragIndicatorTop,
    itemsContainer: $94099e6ff79fd880$var$itemsContainer,
    createChild: $94099e6ff79fd880$var$createChild
};
// =============== //
// === STYLES ==== //
// =============== //
const $94099e6ff79fd880$var$itemHover = `
    background-color: ${`var(--ds-background-neutral-subtle-hovered, ${(0, $PdmhA.N30)})`} !important;
`;
const $94099e6ff79fd880$var$itemSelected = `
    background-color: ${`var(--ds-background-selected, ${(0, $PdmhA.B50)})`} !important;
`;
const $94099e6ff79fd880$var$itemDragging = `
    opacity: 0;
`;
const $94099e6ff79fd880$var$itemsContainerDragging = `
    background: ${`var(--ds-surface-pressed, ${(0, $PdmhA.N50)})`} !important;
`;
const $94099e6ff79fd880$var$itemsContainerScrolling = `
    pointer-events: none;
`;
const $94099e6ff79fd880$var$itemCanBeCombined = `
    background-color: ${`var(--ds-background-selected, ${(0, $PdmhA.N30)})`} !important;
`;
const $94099e6ff79fd880$var$selectedItemCanBeCombined = `
    background-color: ${`var(--ds-background-selected-hovered, ${(0, $PdmhA.N30)})`} !important;
`;
const $94099e6ff79fd880$var$getDragIndicator = (top, left)=>`
    display: block;
    position: fixed;
    right: 0;
    transform: ${left ? `translate(${left}px, ${top}px)` : `translateY(${top}px)`};
    pointer-events: none;
`;
const $94099e6ff79fd880$var$getInlineCreateButton = (top)=>`
    display: block;
    position: fixed;
    right: 0;
    transform: translateY(${top}px);
    pointer-events: none;
`;
const $94099e6ff79fd880$var$getInlineCreateIcon = ()=>`
	outline: 2px solid ${`var(--ds-border-focused, ${0, $PdmhA.B300})`};
	outline-offset: 2px;
`;
const $94099e6ff79fd880$export$9dd6ff9ea0189349 = {
    itemHover: $94099e6ff79fd880$var$itemHover,
    itemSelected: $94099e6ff79fd880$var$itemSelected,
    itemDragging: $94099e6ff79fd880$var$itemDragging,
    itemsContainerDragging: $94099e6ff79fd880$var$itemsContainerDragging,
    itemsContainerScrolling: $94099e6ff79fd880$var$itemsContainerScrolling,
    itemCanBeCombined: $94099e6ff79fd880$var$itemCanBeCombined,
    selectedItemCanBeCombined: $94099e6ff79fd880$var$selectedItemCanBeCombined,
    getDragIndicator: $94099e6ff79fd880$var$getDragIndicator,
    getInlineCreateButton: $94099e6ff79fd880$var$getInlineCreateButton,
    getInlineCreateIcon: $94099e6ff79fd880$var$getInlineCreateIcon
};
const $94099e6ff79fd880$export$5295be4f68791c03 = ()=>$94099e6ff79fd880$export$307b18b61172f7ed([
        $94099e6ff79fd880$var$dragIndicator,
        $94099e6ff79fd880$var$dragIndicatorTop
    ]);
const $94099e6ff79fd880$export$c6b1c9f0aaabd326 = ()=>$94099e6ff79fd880$export$307b18b61172f7ed($94099e6ff79fd880$var$inlineCreate);
const $94099e6ff79fd880$export$36993ff9ff59e588 = ()=>$94099e6ff79fd880$export$307b18b61172f7ed($94099e6ff79fd880$var$inlineCreateIcon);
const $94099e6ff79fd880$export$db96af0fdcbdbc30 = ()=>$94099e6ff79fd880$export$307b18b61172f7ed($94099e6ff79fd880$var$itemsContainer);
const $94099e6ff79fd880$export$30e1e4b30ec4d53 = ()=>$94099e6ff79fd880$export$307b18b61172f7ed($94099e6ff79fd880$var$createChild);
const $94099e6ff79fd880$export$d435f2dd2e4838a0 = (id, parentId)=>{
    const classes = parentId !== undefined ? [
        $94099e6ff79fd880$var$row(id),
        $94099e6ff79fd880$var$rowChild(parentId)
    ] : $94099e6ff79fd880$var$row(id);
    return $94099e6ff79fd880$export$307b18b61172f7ed(classes);
};

});
parcelRegister("c7RR5", function(module, exports) {

$parcel$export(module.exports, "default", () => $196091f9e464f019$export$2e2bcd8739ae039);
// Can be used to transform the hex values from @atlaskit/theme into rgb/rgba
// eslint-disable-next-line jira/import/no-anonymous-default-export
var $196091f9e464f019$export$2e2bcd8739ae039 = (hexColor, alpha = 1)=>{
    const parsed = hexColor.match(/[a-f0-9]{2}/gi);
    if (!parsed || parsed && parsed.length !== 3 || hexColor.indexOf('#') < 0) return hexColor;
    const rgb = parsed.map((hex)=>parseInt(hex, 16));
    if (alpha < 1 && alpha >= 0) return `rgba(${rgb.concat(alpha).join(',')})`;
    return `rgb(${rgb.join()})`;
};

});



parcelRegister("1UVbw", function(module, exports) {

$parcel$export(module.exports, "bindCustomActions", () => $dba1bdcc37b5dc97$export$85d352c410f2eb84);
$parcel$export(module.exports, "bindOverrideActions", () => $dba1bdcc37b5dc97$export$d27110202ae8442b);
/* We only want to expose the primitive style utils for consumers.
 * Everything else is an internal abstraction, which should remain private.
 */ const $dba1bdcc37b5dc97$var$getPublicStyleAPI = (styleAPI)=>({
        insertStyle: styleAPI.insertStyle,
        removeStyle: styleAPI.removeStyle,
        updateStyle: styleAPI.updateStyle
    });
const $dba1bdcc37b5dc97$export$85d352c410f2eb84 = (customActions, styleAPI)=>Object.keys(customActions).reduce((acc, key)=>{
        acc[key] = customActions[key].bind(null, {
            styleAPI: $dba1bdcc37b5dc97$var$getPublicStyleAPI(styleAPI)
        });
        return acc;
    }, {});
/* Takes two action functions and combines them into a single function.
 * The aforementioned actions will be called in order, with the parameters of the first.
 *
 * Getting stricter generic types was impractical, but we ultimately still have good type
 * safety due to the calling function being strictly typed.
 */ const $dba1bdcc37b5dc97$var$combineActions = (actionOne, actionTwo, styleAPI)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (...args)=>{
        actionOne(...args);
        actionTwo?.bind(null, {
            styleAPI: $dba1bdcc37b5dc97$var$getPublicStyleAPI(styleAPI)
        })(...args);
    };
const $dba1bdcc37b5dc97$export$d27110202ae8442b = (defaultActions, overrideActions, styleAPI)=>Object.keys(defaultActions).reduce((acc, key)=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const defaults = defaultActions[key];
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const overrides = overrideActions[key];
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        acc[key] = $dba1bdcc37b5dc97$var$combineActions(defaults, overrides, styleAPI);
        return acc;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    }, {});

});


parcelRegister("kzPj3", function(module, exports) {

$parcel$export(module.exports, "default", () => $7578ed892fee29bc$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $apXyS = parcelRequire("apXyS");

var $9NRea = parcelRequire("9NRea");

var $8ftWh = parcelRequire("8ftWh");

var $gPBP5 = parcelRequire("gPBP5");

var $jV7n9 = parcelRequire("jV7n9");

var $76ouJ = parcelRequire("76ouJ");

var $dqHZ6 = parcelRequire("dqHZ6");

var $4d1OI = parcelRequire("4d1OI");
var $ibHnm = parcelRequire("ibHnm");

var $4YDQS = parcelRequire("4YDQS");
const $7578ed892fee29bc$var$containerStyles = null;
const $7578ed892fee29bc$var$TableMain = ({ isVirtualiseEnabled: isVirtualiseEnabled, isResizeEnabled: isResizeEnabled, isHideScrollbar: isHideScrollbar, scope: scope, selectedItemIds: selectedItemIds, onItemDrop: onItemDrop, onItemSelect: onItemSelect, onItemExpandChanged: onItemExpandChanged, onCreateClick: onCreateClick, onSetListWidth: onSetListWidth, DndLongTaskMetric: DndLongTaskMetric, renderers: renderers })=>{
    const { listRenderers: listRenderers, chartRenderers: chartRenderers, renderProvider: renderProvider } = (0, $4YDQS.getRenderersWithDefaults)(renderers);
    const { renderListEmptyContent: renderListEmptyContent, renderListHeaderItem: renderListHeaderItem, renderListItemContent: renderListItemContent, renderListItemSecondaryContent: renderListItemSecondaryContent, renderListItemCreate: renderListItemCreate } = listRenderers;
    const { renderChartHeaderItem: renderChartHeaderItem, renderChartItemContent: renderChartItemContent, renderChartOverlay: renderChartOverlay, renderChartTimelineOverlay: renderChartTimelineOverlay } = chartRenderers;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gPBP5.default), {
        isHideScrollbar: isHideScrollbar
    }, ({ scrollElement: scrollElement, onContentResize: onContentResize })=>{
        const containerContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: (0, $7JEyt.default)([
                "_kqswh2mm _1e0c1txw _2lx21bp4 _16jlkb7n _1o9zkb7n _i0dl1wug _1bsb1ns9 _4t3i1ns9 _1tke1osq"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $76ouJ.default), {
            renderListHeaderItem: renderListHeaderItem,
            renderChartHeaderItem: renderChartHeaderItem
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8ftWh.default), {
            isResizeEnabled: isResizeEnabled,
            DndLongTaskMetric: DndLongTaskMetric,
            onItemDrop: onItemDrop,
            onItemSelect: onItemSelect,
            onItemExpandChanged: onItemExpandChanged,
            onCreateClick: onCreateClick,
            onSetListWidth: onSetListWidth,
            onContentResize: onContentResize,
            renderListEmptyContent: renderListEmptyContent,
            renderListItemContent: renderListItemContent,
            renderListItemSecondaryContent: renderListItemSecondaryContent,
            renderListItemCreate: renderListItemCreate,
            renderChartItemContent: renderChartItemContent,
            renderChartTimelineOverlay: renderChartTimelineOverlay
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4d1OI.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jV7n9.default), {
            DndLongTaskMetric: DndLongTaskMetric
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dqHZ6.default), {
            selectedItemIds: selectedItemIds
        }));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $apXyS.default), {
            scope: scope,
            scrollElement: scrollElement
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9NRea.default), {
            scrollElement: scrollElement,
            isEnabled: isVirtualiseEnabled
        }, renderProvider({
            children: containerContent
        })));
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ibHnm.default), {
        renderChartOverlay: renderChartOverlay
    }));
};
$7578ed892fee29bc$var$TableMain.displayName = 'TableMain';
$7578ed892fee29bc$var$TableMain.whyDidYouRender = true;
var $7578ed892fee29bc$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($7578ed892fee29bc$var$TableMain);

});
parcelRegister("apXyS", function(module, exports) {

$parcel$export(module.exports, "default", () => $b2ebfbe13a12bdc2$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $511uv = parcelRequire("511uv");

var $oVkDS = parcelRequire("oVkDS");

var $62mlw = parcelRequire("62mlw");

var $gf0vG = parcelRequire("gf0vG");

var $hxnNZ = parcelRequire("hxnNZ");
var $VrUCp = parcelRequire("VrUCp");
var $lSR7G = parcelRequire("lSR7G");
var $bwj1b = parcelRequire("bwj1b");

var $ccgw3 = parcelRequire("ccgw3");

var $gCa9e = parcelRequire("gCa9e");

var $kqGqd = parcelRequire("kqGqd");
const $b2ebfbe13a12bdc2$var$start = (scope)=>{
    (0, $511uv.getLongTasksMetrics)((0, $gf0vG.SCROLLED)).start(scope);
};
const $b2ebfbe13a12bdc2$var$stop = (scope)=>{
    let reporter = (0, $oVkDS.genericReporter);
    reporter = (0, $62mlw.scrollReporterWithSlo)();
    (0, $511uv.getLongTasksMetrics)(scope).stop(reporter);
};
/**
 * SCROLL LONG TASK SLO METRIC
 */ const $b2ebfbe13a12bdc2$var$SCROLL_COUNT_THRESHOLD = 5;
const $b2ebfbe13a12bdc2$var$Container = ({ scope: scope, scrollElement: scrollElement })=>{
    const [{ headerHeight: headerHeight }] = (0, $VrUCp.useHeaderState)();
    const { onScrollStateChanged: onScrollStateChanged } = (0, $bwj1b.useSideEffectMarshal)();
    const [, { updateScrollMeta: updateScrollMeta, updateScrollPosition: updateScrollPosition }] = (0, $hxnNZ.useScrollMetaActions)();
    const [{ totalHeight: totalHeight }] = (0, $lSR7G.useItemsContainerStyles)();
    const isScrolling = (0, $eUqFw.useRef)(false);
    const scrollCount = (0, $eUqFw.useRef)(0);
    const getAndUpdateScrollPosition = (0, $eUqFw.useCallback)(()=>{
        const { scrollTop: scrollTop, clientHeight: clientHeight } = scrollElement;
        const tableHeight = totalHeight + headerHeight;
        const scrollBottom = Math.max(0, tableHeight - (scrollTop + clientHeight));
        updateScrollPosition({
            scrollTop: scrollTop,
            scrollBottom: scrollBottom
        });
    }, [
        scrollElement,
        totalHeight,
        updateScrollPosition,
        headerHeight
    ]);
    const onScrollChange = (0, $eUqFw.useCallback)((scrollingState)=>{
        if (isScrolling.current !== scrollingState.isScrollingY) {
            if (// Send metric on every Nth scroll interaction
            scrollCount.current === $b2ebfbe13a12bdc2$var$SCROLL_COUNT_THRESHOLD) {
                if (scrollingState.isScrollingY) $b2ebfbe13a12bdc2$var$start(scope);
                else {
                    $b2ebfbe13a12bdc2$var$stop(scope);
                    scrollCount.current = 0;
                }
                isScrolling.current = scrollingState.isScrollingY;
            } else scrollCount.current += 1;
        }
        updateScrollMeta(scrollingState);
        if (!scrollingState.isScrollingY) getAndUpdateScrollPosition();
        onScrollStateChanged(scrollingState.isScrollingY);
    }, [
        updateScrollMeta,
        getAndUpdateScrollPosition,
        onScrollStateChanged,
        scope
    ]);
    (0, $kqGqd.useIsScrolling)(scrollElement, onScrollChange);
    (0, $ccgw3.useResizeObserver)(scrollElement, getAndUpdateScrollPosition);
    return null;
};
const $b2ebfbe13a12bdc2$var$ScrollMetaContainer = ({ scope: scope, scrollElement: scrollElement, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hxnNZ.ScrollMetaProviderSweetState), null, scrollElement && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b2ebfbe13a12bdc2$var$Container, {
        scope: scope,
        scrollElement: scrollElement
    }), scrollElement && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gCa9e.default), {
        scope: scope,
        scrollElement: scrollElement
    }), children);
var $b2ebfbe13a12bdc2$export$2e2bcd8739ae039 = $b2ebfbe13a12bdc2$var$ScrollMetaContainer;

});
parcelRegister("511uv", function(module, exports) {

$parcel$export(module.exports, "getLongTasksMetrics", () => $6e4a680496b7cbbf$export$b092a8653a66aa5e);

var $jqvCZ = parcelRequire("jqvCZ");

var $8uNQc = parcelRequire("8uNQc");
var $6iz4v = parcelRequire("6iz4v");

var $7tZw9 = parcelRequire("7tZw9");
let $6e4a680496b7cbbf$var$observer = null;
const $6e4a680496b7cbbf$var$stopObserver = ()=>{
    if ($6e4a680496b7cbbf$var$observer) {
        $6e4a680496b7cbbf$var$observer.disconnect();
        $6e4a680496b7cbbf$var$observer = null;
    }
};
const $6e4a680496b7cbbf$export$b092a8653a66aa5e = (0, (/*@__PURE__*/$parcel$interopDefault($jqvCZ)))((type)=>{
    const clearData = {
        type: type
    };
    let isStarted = false;
    let observationData = {
        ...clearData
    };
    const isDnd = /dnd$/.test(type.toLowerCase());
    return {
        start: (appName, startPerformanceMark, // eslint-disable-next-line @typescript-eslint/no-explicit-any
        extra = {})=>{
            if (window.PerformanceObserver && !isStarted) try {
                const startTimestamp = (0, $8uNQc.default).now();
                observationData = {
                    type: observationData.type,
                    startTimestamp: startTimestamp,
                    dragStartEndTimestamp: startTimestamp,
                    eventStartPerformanceMark: startPerformanceMark,
                    events: [],
                    appName: appName,
                    extra: extra
                };
                isStarted = true;
                $6e4a680496b7cbbf$var$stopObserver();
                $6e4a680496b7cbbf$var$observer = new window.PerformanceObserver((list)=>{
                    list.getEntries().forEach((entry)=>{
                        if (entry.entryType === 'longtask') {
                            if (!(0, $7tZw9.isExpandedObservationData)(observationData) || observationData.events.find((item)=>item.timestamp === entry.startTime && item.duration === entry.duration)) return;
                            observationData.events.push({
                                timestamp: entry.startTime,
                                duration: entry.duration
                            });
                        } else if (entry.entryType === 'event' && entry.name === 'dragstart') /**
								 * Use the observed event to compute the "end" timestamp of the dragstart event,
								 * which will be used for splitting the long tasks for dragstart and dragmove.
								 */ observationData.dragStartEndTimestamp = entry.startTime + entry.duration;
                    });
                });
                $6e4a680496b7cbbf$var$observer.observe({
                    type: 'longtask'
                });
                if (isDnd) /**
						 * Observe events with >48ms duration.
						 * https://developer.mozilla.org/en-US/docs/Web/API/PerformanceObserver/observe
						 */ // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                $6e4a680496b7cbbf$var$observer.observe({
                    type: 'event',
                    durationThreshold: 48
                });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any, no-empty
            } catch (e) {}
        },
        stop: (callback, // eslint-disable-next-line @typescript-eslint/no-explicit-any
        extra = {})=>{
            if ((0, $8uNQc.default).now && isStarted) {
                const stopTimestamp = (0, $8uNQc.default).now();
                setTimeout(()=>{
                    $6e4a680496b7cbbf$var$stopObserver();
                    callback({
                        ...observationData
                    }, extra, stopTimestamp);
                    observationData = {
                        ...clearData
                    };
                    isStarted = false;
                });
            }
        },
        stopIfNoMark: (performanceMark)=>{
            if ($6e4a680496b7cbbf$var$observer && performanceMark) {
                const perfMark = (0, $6iz4v.getMark)(performanceMark);
                if (!perfMark) {
                    $6e4a680496b7cbbf$var$stopObserver();
                    observationData = {
                        ...clearData
                    };
                    isStarted = false;
                }
            }
        }
    };
});

});
parcelRegister("7tZw9", function(module, exports) {

$parcel$export(module.exports, "isExpandedObservationData", () => $e45a8242e5c0159d$export$3d38a87309e205a4);
const $e45a8242e5c0159d$export$3d38a87309e205a4 = (observationData)=>observationData !== undefined && 'events' in observationData && observationData.events !== undefined;

});


parcelRegister("oVkDS", function(module, exports) {

$parcel$export(module.exports, "genericReporter", () => $11a01d8fc8c2c9e1$export$bf7963bc28dd02c2);

var $7tZw9 = parcelRequire("7tZw9");

var $fPUXl = parcelRequire("fPUXl");
const $11a01d8fc8c2c9e1$export$bf7963bc28dd02c2 = (observationData, // eslint-disable-next-line @typescript-eslint/no-explicit-any
featureFlags = {})=>{
    if ((0, $7tZw9.isExpandedObservationData)(observationData)) {
        const triggerSoftwareAnalytics = (0, $fPUXl.triggerAnalytics)(`software.${observationData.appName}`);
        const startTime = observationData.events.map((event)=>event.timestamp);
        const analyticsData = {
            ...(0, $fPUXl.generateLongTaskAnalyticsSummary)(`${observationData.type}`, observationData.events),
            measureTimespan: performance.now() - Math.min(observationData.startTimestamp, ...startTime),
            ...featureFlags
        };
        triggerSoftwareAnalytics(`long-tasks-${observationData.type}`, analyticsData);
    }
};

});
parcelRegister("fPUXl", function(module, exports) {

$parcel$export(module.exports, "triggerAnalytics", () => $9e8129e894f8b784$export$2c57de8a70f64057);
$parcel$export(module.exports, "generateLongTaskAnalyticsSummary", () => $9e8129e894f8b784$export$2be2635781d23aab);
$parcel$export(module.exports, "generateLongTaskAnalyticsSummaryWithSlo", () => $9e8129e894f8b784$export$c674a20081e82c6a);
$parcel$export(module.exports, "getAverageResultsFromContinuousActions", () => $9e8129e894f8b784$export$c36fdc326d0c207c);
$parcel$export(module.exports, "generateLongTaskAnalyticsContinuousActionSummary", () => $9e8129e894f8b784$export$7e5f2df95eca342a);

var $x71UL = parcelRequire("x71UL");

var $4YjDD = parcelRequire("4YjDD");

var $9HwDQ = parcelRequire("9HwDQ");
const $9e8129e894f8b784$export$2c57de8a70f64057 = (_appName)=>(_eventNameSuffix, _eventData)=>Promise.resolve(undefined);
const $9e8129e894f8b784$export$2be2635781d23aab = (prefix, longTasks)=>{
    const durations = longTasks.map((task)=>task.duration);
    return {
        [`${prefix}LongTaskCount`]: longTasks.length,
        [`${prefix}LongTaskAvg`]: longTasks.length > 0 ? durations.reduce((sumAcc, duration)=>sumAcc + duration, 0) / longTasks.length : 0,
        [`${prefix}LongTaskMax`]: longTasks.length > 0 ? Math.max(...durations) : 0
    };
};
const $9e8129e894f8b784$export$c674a20081e82c6a = (prefix, longTasks, sloSettings)=>{
    const summary = $9e8129e894f8b784$export$2be2635781d23aab(prefix, longTasks);
    if (!sloSettings) return summary;
    const framerate = summary[`${prefix}LongTaskCount`] === 0 ? 20 : 1000 / summary[`${prefix}LongTaskAvg`];
    const blocktime = summary[`${prefix}LongTaskCount`] === 0 ? 0 : summary[`${prefix}LongTaskCount`] * summary[`${prefix}LongTaskAvg`];
    const isSuccess = framerate >= sloSettings.framerateThreshold && blocktime < sloSettings.blocktimeThreshold;
    return {
        [`${prefix}LongTaskSloIsSuccess`]: isSuccess,
        ...summary
    };
};
const $9e8129e894f8b784$export$c36fdc326d0c207c = (prefix, data)=>({
        [`${prefix}ClusterCount`]: (0, (/*@__PURE__*/$parcel$interopDefault($9HwDQ)))(data, `${prefix}ClusterCount`) || 0,
        [`${prefix}ClusterCountAvg`]: (0, (/*@__PURE__*/$parcel$interopDefault($x71UL)))(data, `${prefix}ClusterCount`) || 0,
        [`${prefix}ClusterAvg`]: (0, (/*@__PURE__*/$parcel$interopDefault($x71UL)))(data, `${prefix}ClusterAvg`) || 0,
        [`${prefix}ClusterDistanceAvg`]: (0, (/*@__PURE__*/$parcel$interopDefault($x71UL)))(data, `${prefix}ClusterDistanceAvg`) || 0,
        [`${prefix}ClusterAvgLongTaskCount`]: (0, (/*@__PURE__*/$parcel$interopDefault($x71UL)))(data, `${prefix}ClusterAvgLongTaskCount`) || 0,
        [`${prefix}ClusterAvgLongTaskAvg`]: data.length > 0 ? (0, (/*@__PURE__*/$parcel$interopDefault($4YjDD)))(data.map((entry)=>entry[`${prefix}ClusterAvgLongTaskCount`] * entry[`${prefix}ClusterAvgLongTaskAvg`])) / (0, (/*@__PURE__*/$parcel$interopDefault($9HwDQ)))(data, `${prefix}ClusterAvgLongTaskCount`) : 0,
        [`${prefix}Count`]: data.length
    });
const $9e8129e894f8b784$export$7e5f2df95eca342a = (prefix, longTasks)=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const clusters = longTasks.reduce((foundClusters, task)=>{
        if (foundClusters.length === 0) foundClusters.push({
            tasks: [],
            start: 0,
            stop: 0
        });
        const prevCluster = foundClusters[foundClusters.length - 1];
        const taskEnd = task.timestamp + task.duration;
        if (prevCluster.tasks.length === 0) {
            prevCluster.tasks.push(task);
            prevCluster.start = task.timestamp;
            prevCluster.stop = taskEnd;
        } else if (task.timestamp - prevCluster.stop < 100) {
            prevCluster.tasks.push(task);
            prevCluster.stop = taskEnd;
        } else foundClusters.push({
            tasks: [
                task
            ],
            start: task.timestamp,
            stop: taskEnd
        });
        return foundClusters;
    }, []);
    const clusterDurations = clusters.map((cluster)=>cluster.stop - cluster.start);
    const tasksDurations = longTasks.map((task)=>task.duration);
    const gapsBetweenClusters = clusters.length > 1 ? clusters // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .reduce((gaps, cluster, i)=>{
        if (gaps.length === 0) {
            gaps.push({
                start: cluster.stop,
                stop: null
            });
            return gaps;
        }
        // eslint-disable-next-line no-param-reassign
        gaps[gaps.length - 1].stop = cluster.start;
        if (i !== clusters.length - 1) gaps.push({
            start: cluster.stop,
            stop: null
        });
        return gaps;
    }, []).map((gap)=>gap.stop - gap.start) : [];
    return {
        [`${prefix}ClusterCount`]: clusters.length,
        [`${prefix}ClusterAvg`]: clusters.length > 0 ? clusterDurations.reduce((sumAcc, duration)=>sumAcc + duration, 0) / clusters.length : 0,
        [`${prefix}ClusterDistanceAvg`]: gapsBetweenClusters.length > 0 ? gapsBetweenClusters.reduce((sumAcc, duration)=>sumAcc + duration, 0) / gapsBetweenClusters.length : 0,
        [`${prefix}ClusterAvgLongTaskCount`]: clusters.length > 0 ? clusters.map((cluster)=>cluster.tasks.length).reduce((sumAcc, count)=>sumAcc + count, 0) / clusters.length : 0,
        [`${prefix}ClusterAvgLongTaskAvg`]: longTasks.length > 0 ? tasksDurations.reduce((sumAcc, duration)=>sumAcc + duration, 0) / longTasks.length : 0
    };
};

});
parcelRegister("x71UL", function(module, exports) {

var $7qARj = parcelRequire("7qARj");

var $6P7TZ = parcelRequire("6P7TZ");
/**
 * This method is like `_.mean` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the value to be averaged.
 * The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.7.0
 * @category Math
 * @param {Array} array The array to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {number} Returns the mean.
 * @example
 *
 * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
 *
 * _.meanBy(objects, function(o) { return o.n; });
 * // => 5
 *
 * // The `_.property` iteratee shorthand.
 * _.meanBy(objects, 'n');
 * // => 5
 */ function $0638892b8ae22890$var$meanBy(array, iteratee) {
    return $6P7TZ(array, $7qARj(iteratee, 2));
}
module.exports = $0638892b8ae22890$var$meanBy;

});
parcelRegister("6P7TZ", function(module, exports) {

var $835ZM = parcelRequire("835ZM");
/** Used as references for various `Number` constants. */ var $4f7da2b12e23c1f3$var$NAN = 0 / 0;
/**
 * The base implementation of `_.mean` and `_.meanBy` without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {number} Returns the mean.
 */ function $4f7da2b12e23c1f3$var$baseMean(array, iteratee) {
    var length = array == null ? 0 : array.length;
    return length ? $835ZM(array, iteratee) / length : $4f7da2b12e23c1f3$var$NAN;
}
module.exports = $4f7da2b12e23c1f3$var$baseMean;

});
parcelRegister("835ZM", function(module, exports) {
/**
 * The base implementation of `_.sum` and `_.sumBy` without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {number} Returns the sum.
 */ function $5dc3411db180ba2c$var$baseSum(array, iteratee) {
    var result, index = -1, length = array.length;
    while(++index < length){
        var current = iteratee(array[index]);
        if (current !== undefined) result = result === undefined ? current : result + current;
    }
    return result;
}
module.exports = $5dc3411db180ba2c$var$baseSum;

});



parcelRegister("4YjDD", function(module, exports) {

var $835ZM = parcelRequire("835ZM");

var $3QMTK = parcelRequire("3QMTK");
/**
 * Computes the sum of the values in `array`.
 *
 * @static
 * @memberOf _
 * @since 3.4.0
 * @category Math
 * @param {Array} array The array to iterate over.
 * @returns {number} Returns the sum.
 * @example
 *
 * _.sum([4, 2, 8, 6]);
 * // => 20
 */ function $39ebffc448745d7b$var$sum(array) {
    return array && array.length ? $835ZM(array, $3QMTK) : 0;
}
module.exports = $39ebffc448745d7b$var$sum;

});

parcelRegister("9HwDQ", function(module, exports) {

var $7qARj = parcelRequire("7qARj");

var $835ZM = parcelRequire("835ZM");
/**
 * This method is like `_.sum` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the value to be summed.
 * The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Math
 * @param {Array} array The array to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {number} Returns the sum.
 * @example
 *
 * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
 *
 * _.sumBy(objects, function(o) { return o.n; });
 * // => 20
 *
 * // The `_.property` iteratee shorthand.
 * _.sumBy(objects, 'n');
 * // => 20
 */ function $7101732f00f14013$var$sumBy(array, iteratee) {
    return array && array.length ? $835ZM(array, $7qARj(iteratee, 2)) : 0;
}
module.exports = $7101732f00f14013$var$sumBy;

});



parcelRegister("62mlw", function(module, exports) {

$parcel$export(module.exports, "scrollReporterWithSlo", () => $e70267f7a45c6c80$export$4cfca7ce0b67bede);

var $3FyZ4 = parcelRequire("3FyZ4");

var $7tZw9 = parcelRequire("7tZw9");

var $fPUXl = parcelRequire("fPUXl");
const $e70267f7a45c6c80$export$4cfca7ce0b67bede = (sloSettings)=>(observationData, extraProps)=>{
        if (!(0, $7tZw9.isExpandedObservationData)(observationData) || sloSettings === undefined) return;
        const startTime = observationData.events.map((event)=>event.timestamp);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const analyticsData = {
            ...extraProps,
            ...(0, $fPUXl.generateLongTaskAnalyticsSummaryWithSlo)('scroll', observationData.events, sloSettings),
            type: observationData.type || 'unknown',
            measureTimespan: performance.now() - Math.min(observationData.startTimestamp, ...startTime)
        };
        const attributes = {
            ...extraProps,
            type: observationData.type || 'unknown',
            isSuccess: analyticsData.scrollLongTaskSloIsSuccess,
            ...sloSettings
        };
        (0, $3FyZ4.getAnalyticsWebClientPromise)().then((client)=>{
            const payload = {
                source: observationData.appName,
                action: 'complete',
                actionSubject: 'scroll operation',
                attributes: attributes
            };
            client.getInstance().sendOperationalEvent(payload);
        });
    };

});

parcelRegister("hxnNZ", function(module, exports) {

$parcel$export(module.exports, "useScrollMetaActions", () => $df3dd5163f10b99b$export$ad4800a08d9776a3);
$parcel$export(module.exports, "ScrollMetaProviderSweetState", () => $df3dd5163f10b99b$export$e0f28de8d4016f86);
$parcel$export(module.exports, "isScrollToTop", () => $df3dd5163f10b99b$export$5a36b1e9643b5cf2);
$parcel$export(module.exports, "useIsScrollingY", () => $df3dd5163f10b99b$export$b4e5a0824bff5bca);
$parcel$export(module.exports, "useIsScrollingX", () => $df3dd5163f10b99b$export$b8a077e56392e785);

var $heB5U = parcelRequire("heB5U");
var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");

var $amX2C = parcelRequire("amX2C");

var $2qEZ6 = parcelRequire("2qEZ6");
const $df3dd5163f10b99b$var$DEFAULT_STATE = {
    isScrollingX: false,
    isScrollingY: false,
    positions: {
        top: 0,
        bottom: 0
    }
};
const $df3dd5163f10b99b$var$store = (0, $a61MH.createStore)({
    initialState: $df3dd5163f10b99b$var$DEFAULT_STATE,
    actions: (0, $amX2C.scrollMetaActions),
    name: 'timeline-table.scroll-meta'
});
const $df3dd5163f10b99b$export$ad4800a08d9776a3 = (0, $ggKAj.createHook)($df3dd5163f10b99b$var$store, {
    selector: null
});
const $df3dd5163f10b99b$export$e0f28de8d4016f86 = (0, $heB5U.createContainer)($df3dd5163f10b99b$var$store);
const $df3dd5163f10b99b$export$5a36b1e9643b5cf2 = (0, $ggKAj.createHook)($df3dd5163f10b99b$var$store, {
    selector: (0, $2qEZ6.getIsScrollToTop)
});
const $df3dd5163f10b99b$export$b4e5a0824bff5bca = (0, $ggKAj.createHook)($df3dd5163f10b99b$var$store, {
    selector: (0, $2qEZ6.getIsScrollingY)
});
const $df3dd5163f10b99b$export$b8a077e56392e785 = (0, $ggKAj.createHook)($df3dd5163f10b99b$var$store, {
    selector: (0, $2qEZ6.getIsScrollingX)
});

});
parcelRegister("amX2C", function(module, exports) {

$parcel$export(module.exports, "scrollMetaActions", () => $0fc5c6f60818c9eb$export$a0445084aaf6bbad);
const $0fc5c6f60818c9eb$var$updateScrollMeta = ({ isScrollingX: isScrollingX, isScrollingY: isScrollingY })=>({ setState: setState })=>{
        setState({
            isScrollingX: isScrollingX,
            isScrollingY: isScrollingY
        });
    };
const $0fc5c6f60818c9eb$var$updateScrollPosition = ({ scrollTop: scrollTop, scrollBottom: scrollBottom })=>({ setState: setState })=>{
        const positions = {
            top: scrollTop,
            bottom: scrollBottom
        };
        setState({
            positions: positions
        });
    };
const $0fc5c6f60818c9eb$export$a0445084aaf6bbad = {
    updateScrollMeta: $0fc5c6f60818c9eb$var$updateScrollMeta,
    updateScrollPosition: $0fc5c6f60818c9eb$var$updateScrollPosition
};

});

parcelRegister("2qEZ6", function(module, exports) {

$parcel$export(module.exports, "getIsScrollingX", () => $4bbf8949d8c46326$export$1b889f4869aca117);
$parcel$export(module.exports, "getIsScrollingY", () => $4bbf8949d8c46326$export$ca3dc64117d091c8);
$parcel$export(module.exports, "getIsScrollToTop", () => $4bbf8949d8c46326$export$2119597e6872810a);
const $4bbf8949d8c46326$export$1b889f4869aca117 = (state)=>state.isScrollingX;
const $4bbf8949d8c46326$export$ca3dc64117d091c8 = (state)=>state.isScrollingY;
const $4bbf8949d8c46326$export$2119597e6872810a = (state)=>state.positions.top === 0;

});


parcelRegister("ccgw3", function(module, exports) {

$parcel$export(module.exports, "useResizeObserver", () => $d09aad1c949941e8$export$683480f191c0e3ea);

var $eUqFw = parcelRequire("eUqFw");

var $1DUdw = parcelRequire("1DUdw");
let $d09aad1c949941e8$var$resizeObserver;
const $d09aad1c949941e8$export$683480f191c0e3ea = (element, // !! Important - The callback parameter must be referentially stable to avoid an infinite render loop !!
callback)=>{
    (0, $eUqFw.useLayoutEffect)(()=>{
        if (typeof ResizeObserver !== 'undefined') {
            if (!$d09aad1c949941e8$var$resizeObserver) $d09aad1c949941e8$var$resizeObserver = new ResizeObserver((0, $1DUdw.runCallbacks));
            element && (0, $1DUdw.observeElement)($d09aad1c949941e8$var$resizeObserver, element, callback);
        }
        return ()=>{
            if (element && $d09aad1c949941e8$var$resizeObserver) (0, $1DUdw.unobserveElement)($d09aad1c949941e8$var$resizeObserver, element, callback);
        };
    }, [
        element,
        callback
    ]);
};

});
parcelRegister("1DUdw", function(module, exports) {

$parcel$export(module.exports, "runCallbacks", () => $9f6a3ce1a557e93b$export$4219acf616175acb);
$parcel$export(module.exports, "observeElement", () => $9f6a3ce1a557e93b$export$9137ee61fe58d50e);
$parcel$export(module.exports, "unobserveElement", () => $9f6a3ce1a557e93b$export$4d125402ac99f1b);
const $9f6a3ce1a557e93b$var$elementsForCallback = new Map();
const $9f6a3ce1a557e93b$export$4219acf616175acb = (entries)=>{
    $9f6a3ce1a557e93b$var$elementsForCallback.forEach((elements, callback)=>{
        const relevantEntries = [];
        entries.forEach((entry)=>{
            if (elements.includes(entry.target)) relevantEntries.push(entry);
        });
        if (relevantEntries.length > 0) callback(relevantEntries);
    });
};
const $9f6a3ce1a557e93b$export$9137ee61fe58d50e = (resizeObserver, element, callback)=>{
    const existingElements = $9f6a3ce1a557e93b$var$elementsForCallback.get(callback);
    if (existingElements) $9f6a3ce1a557e93b$var$elementsForCallback.set(callback, [
        ...existingElements,
        element
    ]);
    else $9f6a3ce1a557e93b$var$elementsForCallback.set(callback, [
        element
    ]);
    resizeObserver.observe(element);
};
const $9f6a3ce1a557e93b$export$4d125402ac99f1b = (resizeObserver, element, callback)=>{
    $9f6a3ce1a557e93b$var$elementsForCallback.delete(callback);
    resizeObserver.unobserve(element);
};

});


parcelRegister("gCa9e", function(module, exports) {

$parcel$export(module.exports, "default", () => $1c4fa5f2557ea2e5$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $1ybV0 = parcelRequire("1ybV0");

var $axxSm = parcelRequire("axxSm");

var $lSR7G = parcelRequire("lSR7G");
const $1c4fa5f2557ea2e5$var$TimelineTableScrollFPSMetric = ({ scope: scope, scrollElement: scrollElement })=>{
    const [itemsCount] = (0, $lSR7G.useItemsCount)();
    const attributes = {
        isVisualHierarchyM1Enabled: (0, $1ybV0.ff)('jwm.visual-hierarchy-milestone-1')
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $axxSm.default), {
        viewId: scope,
        itemsCount: itemsCount,
        scrollElement: scrollElement,
        attributes: attributes
    });
};
var $1c4fa5f2557ea2e5$export$2e2bcd8739ae039 = $1c4fa5f2557ea2e5$var$TimelineTableScrollFPSMetric;

});

parcelRegister("kqGqd", function(module, exports) {

$parcel$export(module.exports, "useIsScrolling", () => $8d0556823ad10214$export$fde36fcfab14caba);

var $eUqFw = parcelRequire("eUqFw");

var $iH5dw = parcelRequire("iH5dw");

var $kTNWN = parcelRequire("kTNWN");
/* This hook is used to notify when either horizontal or vertical scrolling is in progress.
 * The notification will only fire for *changes* to this state, and not for every scroll event.
 */ const $8d0556823ad10214$export$fde36fcfab14caba = (scrollElement, onScrollChange)=>{
    const rafId = (0, $eUqFw.useRef)(null);
    const startTime = (0, $eUqFw.useRef)(-1);
    const isScrolling = (0, $eUqFw.useRef)(false);
    const lastPosition = (0, $eUqFw.useRef)({
        x: 0,
        y: 0
    });
    const lastScrollState = (0, $eUqFw.useRef)((0, $iH5dw.DEFAULT_STATE));
    const scrollEnd = (0, $eUqFw.useCallback)(()=>{
        if (isScrolling.current) {
            startTime.current = -1;
            isScrolling.current = false;
            lastScrollState.current = (0, $iH5dw.DEFAULT_STATE);
            onScrollChange((0, $iH5dw.DEFAULT_STATE));
        }
        if (rafId.current !== null) {
            cancelAnimationFrame(rafId.current);
            rafId.current = null;
        }
    }, [
        onScrollChange
    ]);
    /* Update the state and recursively schedule animation frames until the user
	 * stops scrolling (indicated by no scroll events over a small time period).
	 * -
	 * To determine which axis is scrolling, we compare the previous scroll offset with the
	 * the current offset. This is imperfect, since it's possible to get identical offsets
	 * even while scrolling. To minimise the number of updates, which also cause UI flickering,
	 * we assert that the scrolling state can only be fully reset on scroll end.
	 */ const tick = (0, $eUqFw.useCallback)(()=>{
        if (isScrolling.current) {
            const stopTime = performance.now();
            const time = stopTime - startTime.current;
            const { scrollTop: scrollTop, scrollLeft: scrollLeft } = scrollElement;
            const scrollState = {
                ...lastScrollState.current
            };
            if (scrollTop !== lastPosition.current.y) scrollState.isScrollingY = true;
            if (scrollLeft !== lastPosition.current.x) scrollState.isScrollingX = true;
            lastPosition.current = {
                x: scrollLeft,
                y: scrollTop
            };
            if (time >= (0, $iH5dw.IDLE_THRESHOLD)) scrollEnd();
            else {
                if ((0, $kTNWN.hasStateChanged)(lastScrollState.current, scrollState)) {
                    lastScrollState.current = {
                        ...scrollState
                    };
                    onScrollChange(scrollState);
                }
                rafId.current = requestAnimationFrame(tick);
            }
        }
    }, [
        scrollElement,
        scrollEnd,
        onScrollChange
    ]);
    const onScroll = (0, $eUqFw.useCallback)(()=>{
        isScrolling.current = true;
        startTime.current = performance.now();
        if (!rafId.current) rafId.current = requestAnimationFrame(tick);
    }, [
        tick
    ]);
    (0, $eUqFw.useEffect)(()=>{
        scrollElement.addEventListener('scroll', onScroll);
        return ()=>{
            scrollElement.removeEventListener('scroll', onScroll);
            if (rafId.current !== null) {
                cancelAnimationFrame(rafId.current);
                rafId.current = null;
            }
        };
    }, [
        scrollElement,
        onScroll
    ]);
};

});
parcelRegister("iH5dw", function(module, exports) {

$parcel$export(module.exports, "IDLE_THRESHOLD", () => $3f5b655fccdcb829$export$a9b912713512229e);
$parcel$export(module.exports, "DEFAULT_STATE", () => $3f5b655fccdcb829$export$a3a6a28ae8823b06);
const $3f5b655fccdcb829$export$a9b912713512229e = 150;
const $3f5b655fccdcb829$export$a3a6a28ae8823b06 = {
    isScrollingX: false,
    isScrollingY: false
};

});

parcelRegister("kTNWN", function(module, exports) {

$parcel$export(module.exports, "hasStateChanged", () => $8df4e4326a8e391c$export$ba6070bd39de76e0);
const $8df4e4326a8e391c$export$ba6070bd39de76e0 = (oldState, newState)=>!oldState.isScrollingX && newState.isScrollingX || !oldState.isScrollingY && newState.isScrollingY;

});



parcelRegister("9NRea", function(module, exports) {

$parcel$export(module.exports, "default", () => $7dc571431d1c2120$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $6ki0E = parcelRequire("6ki0E");

var $gf0vG = parcelRequire("gf0vG");

var $VrUCp = parcelRequire("VrUCp");
var $lSR7G = parcelRequire("lSR7G");
var $bmsPo = parcelRequire("bmsPo");

var $2eorI = parcelRequire("2eorI");
const $7dc571431d1c2120$var$useVirtualItems = ({ scrollElement: scrollElement, itemHeights: itemHeights })=>{
    const [, { generateVirtualMeta: generateVirtualMeta }] = (0, $bmsPo.useVirtualisedActions)();
    const parentRef = (0, $eUqFw.useRef)(scrollElement);
    const getRowHeight = (0, $eUqFw.useCallback)((index)=>itemHeights[index], [
        itemHeights
    ]);
    const [{ headerHeight: headerHeight }] = (0, $VrUCp.useHeaderState)();
    const virtualizer = (0, $6ki0E.useVirtualizer)({
        count: itemHeights.length,
        getScrollElement: ()=>parentRef.current,
        estimateSize: getRowHeight,
        overscan: 0,
        paddingStart: headerHeight
    });
    (0, $eUqFw.useLayoutEffect)(()=>{
        const virtualItems = virtualizer.getVirtualItems();
        if (virtualizer.getVirtualItems().length > 0) {
            const { index: startIndex } = virtualItems[0];
            const { index: endIndex } = virtualItems[virtualItems.length - 1];
            const visibleItemCount = endIndex - startIndex;
            const roundedStart = Math.round(startIndex / 5) * 5;
            generateVirtualMeta(roundedStart, Math.min(roundedStart + visibleItemCount, endIndex));
        } else // Unset start and end index to disable virtualisation
        generateVirtualMeta(0, itemHeights.length - 1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        generateVirtualMeta,
        virtualizer.getVirtualItems(),
        itemHeights
    ]);
};
const $7dc571431d1c2120$var$Container = ({ itemHeights: itemHeights, scrollElement: scrollElement })=>{
    $7dc571431d1c2120$var$useVirtualItems({
        itemHeights: itemHeights,
        scrollElement: scrollElement
    });
    return null;
};
const $7dc571431d1c2120$var$VirtualiseContainer = ({ isEnabled: isEnabled, children: children, scrollElement: scrollElement })=>{
    const [items] = (0, $lSR7G.useItems)();
    const [itemHeight] = (0, $lSR7G.useItemHeight)();
    const itemHeights = (0, $eUqFw.useMemo)(()=>(0, $2eorI.getItemHeights)(items, itemHeight), [
        items,
        itemHeight
    ]);
    const createItemIndex = (0, $eUqFw.useMemo)(()=>items.findIndex((item)=>item.type === (0, $gf0vG.CREATE_ITEM_TYPE)), [
        items
    ]);
    if (// react-virtual uses ResizeObserver to get parentRef's dimension
    typeof ResizeObserver === 'undefined') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bmsPo.VirtualiseProviderSweetState), {
        itemHeights: itemHeights,
        createItemIndex: createItemIndex,
        isEnabled: isEnabled,
        items: items
    }, scrollElement && isEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7dc571431d1c2120$var$Container, {
        itemHeights: itemHeights,
        scrollElement: scrollElement
    }), children);
};
var $7dc571431d1c2120$export$2e2bcd8739ae039 = $7dc571431d1c2120$var$VirtualiseContainer;

});
parcelRegister("6ki0E", function(module, exports) {

$parcel$export(module.exports, "useVirtualizer", () => $49b294a7a914c493$export$dd6d526d88b5a137);

var $eUqFw = parcelRequire("eUqFw");

var $lEfVV = parcelRequire("lEfVV");

var $2N9zU = parcelRequire("2N9zU");
const $49b294a7a914c493$var$useIsomorphicLayoutEffect = typeof document !== "undefined" ? $eUqFw.useLayoutEffect : $eUqFw.useEffect;
function $49b294a7a914c493$var$useVirtualizerBase(options) {
    const rerender = $eUqFw.useReducer(()=>({}), {})[1];
    const resolvedOptions = {
        ...options,
        onChange: (instance2, sync)=>{
            var _a;
            if (sync) (0, $lEfVV.flushSync)(rerender);
            else rerender();
            (_a = options.onChange) == null || _a.call(options, instance2, sync);
        }
    };
    const [instance] = $eUqFw.useState(()=>new (0, $2N9zU.Virtualizer)(resolvedOptions));
    instance.setOptions(resolvedOptions);
    $eUqFw.useEffect(()=>{
        return instance._didMount();
    }, []);
    $49b294a7a914c493$var$useIsomorphicLayoutEffect(()=>{
        return instance._willUpdate();
    });
    return instance;
}
function $49b294a7a914c493$export$dd6d526d88b5a137(options) {
    return $49b294a7a914c493$var$useVirtualizerBase({
        observeElementRect: $2N9zU.observeElementRect,
        observeElementOffset: $2N9zU.observeElementOffset,
        scrollToFn: (0, $2N9zU.elementScroll),
        ...options
    });
}
function $49b294a7a914c493$export$645722dcac657cb9(options) {
    return $49b294a7a914c493$var$useVirtualizerBase({
        getScrollElement: ()=>typeof document !== "undefined" ? window : null,
        observeElementRect: (0, $2N9zU.observeWindowRect),
        observeElementOffset: (0, $2N9zU.observeWindowOffset),
        scrollToFn: (0, $2N9zU.windowScroll),
        initialOffset: ()=>typeof document !== "undefined" ? window.scrollY : 0,
        ...options
    });
}

});
parcelRegister("2N9zU", function(module, exports) {

$parcel$export(module.exports, "observeElementRect", () => $20879669f8b1eab4$export$5a50ff2cde8c3802);
$parcel$export(module.exports, "observeWindowRect", () => $20879669f8b1eab4$export$e911b82c7a99311);
$parcel$export(module.exports, "observeElementOffset", () => $20879669f8b1eab4$export$fbc040aee017375a);
$parcel$export(module.exports, "observeWindowOffset", () => $20879669f8b1eab4$export$518998f8c5d09287);
$parcel$export(module.exports, "windowScroll", () => $20879669f8b1eab4$export$2162c5b3eeedd27);
$parcel$export(module.exports, "elementScroll", () => $20879669f8b1eab4$export$1cdb988e5ab69fe7);
$parcel$export(module.exports, "Virtualizer", () => $20879669f8b1eab4$export$89be5a243e59c4b2);

var $5oCQ9 = parcelRequire("5oCQ9");
const $20879669f8b1eab4$export$76974b428a49f15b = (index)=>index;
const $20879669f8b1eab4$export$7eb7cb13fd21e5e1 = (range)=>{
    const start = Math.max(range.startIndex - range.overscan, 0);
    const end = Math.min(range.endIndex + range.overscan, range.count - 1);
    const arr = [];
    for(let i = start; i <= end; i++)arr.push(i);
    return arr;
};
const $20879669f8b1eab4$export$5a50ff2cde8c3802 = (instance, cb)=>{
    const element = instance.scrollElement;
    if (!element) return;
    const handler = (rect)=>{
        const { width: width, height: height } = rect;
        cb({
            width: Math.round(width),
            height: Math.round(height)
        });
    };
    handler(element.getBoundingClientRect());
    if (typeof ResizeObserver === "undefined") return ()=>{};
    const observer = new ResizeObserver((entries)=>{
        const entry = entries[0];
        if (entry == null ? void 0 : entry.borderBoxSize) {
            const box = entry.borderBoxSize[0];
            if (box) {
                handler({
                    width: box.inlineSize,
                    height: box.blockSize
                });
                return;
            }
        }
        handler(element.getBoundingClientRect());
    });
    observer.observe(element, {
        box: "border-box"
    });
    return ()=>{
        observer.unobserve(element);
    };
};
const $20879669f8b1eab4$var$addEventListenerOptions = {
    passive: true
};
const $20879669f8b1eab4$export$e911b82c7a99311 = (instance, cb)=>{
    const element = instance.scrollElement;
    if (!element) return;
    const handler = ()=>{
        cb({
            width: element.innerWidth,
            height: element.innerHeight
        });
    };
    handler();
    element.addEventListener("resize", handler, $20879669f8b1eab4$var$addEventListenerOptions);
    return ()=>{
        element.removeEventListener("resize", handler);
    };
};
const $20879669f8b1eab4$var$supportsScrollend = typeof window == "undefined" ? true : "onscrollend" in window;
const $20879669f8b1eab4$export$fbc040aee017375a = (instance, cb)=>{
    const element = instance.scrollElement;
    if (!element) return;
    let offset = 0;
    const fallback = $20879669f8b1eab4$var$supportsScrollend ? ()=>void 0 : (0, $5oCQ9.debounce)(()=>{
        cb(offset, false);
    }, 150);
    const createHandler = (isScrolling)=>()=>{
            offset = element[instance.options.horizontal ? "scrollLeft" : "scrollTop"];
            fallback();
            cb(offset, isScrolling);
        };
    const handler = createHandler(true);
    const endHandler = createHandler(false);
    endHandler();
    element.addEventListener("scroll", handler, $20879669f8b1eab4$var$addEventListenerOptions);
    element.addEventListener("scrollend", endHandler, $20879669f8b1eab4$var$addEventListenerOptions);
    return ()=>{
        element.removeEventListener("scroll", handler);
        element.removeEventListener("scrollend", endHandler);
    };
};
const $20879669f8b1eab4$export$518998f8c5d09287 = (instance, cb)=>{
    const element = instance.scrollElement;
    if (!element) return;
    let offset = 0;
    const fallback = $20879669f8b1eab4$var$supportsScrollend ? ()=>void 0 : (0, $5oCQ9.debounce)(()=>{
        cb(offset, false);
    }, 150);
    const createHandler = (isScrolling)=>()=>{
            offset = element[instance.options.horizontal ? "scrollX" : "scrollY"];
            fallback();
            cb(offset, isScrolling);
        };
    const handler = createHandler(true);
    const endHandler = createHandler(false);
    endHandler();
    element.addEventListener("scroll", handler, $20879669f8b1eab4$var$addEventListenerOptions);
    element.addEventListener("scrollend", endHandler, $20879669f8b1eab4$var$addEventListenerOptions);
    return ()=>{
        element.removeEventListener("scroll", handler);
        element.removeEventListener("scrollend", endHandler);
    };
};
const $20879669f8b1eab4$export$6aa9c23c0f5932af = (element, entry, instance)=>{
    if (entry == null ? void 0 : entry.borderBoxSize) {
        const box = entry.borderBoxSize[0];
        if (box) {
            const size = Math.round(box[instance.options.horizontal ? "inlineSize" : "blockSize"]);
            return size;
        }
    }
    return Math.round(element.getBoundingClientRect()[instance.options.horizontal ? "width" : "height"]);
};
const $20879669f8b1eab4$export$2162c5b3eeedd27 = (offset, { adjustments: adjustments = 0, behavior: behavior }, instance)=>{
    var _a, _b;
    const toOffset = offset + adjustments;
    (_b = (_a = instance.scrollElement) == null ? void 0 : _a.scrollTo) == null || _b.call(_a, {
        [instance.options.horizontal ? "left" : "top"]: toOffset,
        behavior: behavior
    });
};
const $20879669f8b1eab4$export$1cdb988e5ab69fe7 = (offset, { adjustments: adjustments = 0, behavior: behavior }, instance)=>{
    var _a, _b;
    const toOffset = offset + adjustments;
    (_b = (_a = instance.scrollElement) == null ? void 0 : _a.scrollTo) == null || _b.call(_a, {
        [instance.options.horizontal ? "left" : "top"]: toOffset,
        behavior: behavior
    });
};
class $20879669f8b1eab4$export$89be5a243e59c4b2 {
    constructor(opts){
        this.unsubs = [];
        this.scrollElement = null;
        this.isScrolling = false;
        this.scrollToIndexTimeoutId = null;
        this.measurementsCache = [];
        this.itemSizeCache = /* @__PURE__ */ new Map();
        this.pendingMeasuredCacheIndexes = [];
        this.scrollDirection = null;
        this.scrollAdjustments = 0;
        this.measureElementCache = /* @__PURE__ */ new Map();
        this.observer = /* @__PURE__ */ (()=>{
            let _ro = null;
            const get = ()=>{
                if (_ro) return _ro;
                else if (typeof ResizeObserver !== "undefined") return _ro = new ResizeObserver((entries)=>{
                    entries.forEach((entry)=>{
                        this._measureElement(entry.target, entry);
                    });
                });
                else return null;
            };
            return {
                disconnect: ()=>{
                    var _a;
                    return (_a = get()) == null ? void 0 : _a.disconnect();
                },
                observe: (target)=>{
                    var _a;
                    return (_a = get()) == null ? void 0 : _a.observe(target, {
                        box: "border-box"
                    });
                },
                unobserve: (target)=>{
                    var _a;
                    return (_a = get()) == null ? void 0 : _a.unobserve(target);
                }
            };
        })();
        this.range = null;
        this.setOptions = (opts2)=>{
            Object.entries(opts2).forEach(([key, value])=>{
                if (typeof value === "undefined") delete opts2[key];
            });
            this.options = {
                debug: false,
                initialOffset: 0,
                overscan: 1,
                paddingStart: 0,
                paddingEnd: 0,
                scrollPaddingStart: 0,
                scrollPaddingEnd: 0,
                horizontal: false,
                getItemKey: $20879669f8b1eab4$export$76974b428a49f15b,
                rangeExtractor: $20879669f8b1eab4$export$7eb7cb13fd21e5e1,
                onChange: ()=>{},
                measureElement: $20879669f8b1eab4$export$6aa9c23c0f5932af,
                initialRect: {
                    width: 0,
                    height: 0
                },
                scrollMargin: 0,
                gap: 0,
                indexAttribute: "data-index",
                initialMeasurementsCache: [],
                lanes: 1,
                ...opts2
            };
        };
        this.notify = (force, sync)=>{
            var _a, _b;
            const { startIndex: startIndex, endIndex: endIndex } = this.range ?? {
                startIndex: void 0,
                endIndex: void 0
            };
            const range = this.calculateRange();
            if (force || startIndex !== (range == null ? void 0 : range.startIndex) || endIndex !== (range == null ? void 0 : range.endIndex)) (_b = (_a = this.options).onChange) == null || _b.call(_a, this, sync);
        };
        this.cleanup = ()=>{
            this.unsubs.filter(Boolean).forEach((d)=>d());
            this.unsubs = [];
            this.scrollElement = null;
        };
        this._didMount = ()=>{
            this.measureElementCache.forEach(this.observer.observe);
            return ()=>{
                this.observer.disconnect();
                this.cleanup();
            };
        };
        this._willUpdate = ()=>{
            const scrollElement = this.options.getScrollElement();
            if (this.scrollElement !== scrollElement) {
                this.cleanup();
                this.scrollElement = scrollElement;
                this._scrollToOffset(this.scrollOffset, {
                    adjustments: void 0,
                    behavior: void 0
                });
                this.unsubs.push(this.options.observeElementRect(this, (rect)=>{
                    this.scrollRect = rect;
                    this.notify(false, false);
                }));
                this.unsubs.push(this.options.observeElementOffset(this, (offset, isScrolling)=>{
                    this.scrollAdjustments = 0;
                    this.scrollDirection = isScrolling ? this.scrollOffset < offset ? "forward" : "backward" : null;
                    this.scrollOffset = offset;
                    const prevIsScrolling = this.isScrolling;
                    this.isScrolling = isScrolling;
                    this.notify(prevIsScrolling !== isScrolling, isScrolling);
                }));
            }
        };
        this.getSize = ()=>{
            return this.scrollRect[this.options.horizontal ? "width" : "height"];
        };
        this.getMeasurementOptions = (0, $5oCQ9.memo)(()=>[
                this.options.count,
                this.options.paddingStart,
                this.options.scrollMargin,
                this.options.getItemKey
            ], (count, paddingStart, scrollMargin, getItemKey)=>{
            this.pendingMeasuredCacheIndexes = [];
            return {
                count: count,
                paddingStart: paddingStart,
                scrollMargin: scrollMargin,
                getItemKey: getItemKey
            };
        }, {
            key: false
        });
        this.getFurthestMeasurement = (measurements, index)=>{
            const furthestMeasurementsFound = /* @__PURE__ */ new Map();
            const furthestMeasurements = /* @__PURE__ */ new Map();
            for(let m = index - 1; m >= 0; m--){
                const measurement = measurements[m];
                if (furthestMeasurementsFound.has(measurement.lane)) continue;
                const previousFurthestMeasurement = furthestMeasurements.get(measurement.lane);
                if (previousFurthestMeasurement == null || measurement.end > previousFurthestMeasurement.end) furthestMeasurements.set(measurement.lane, measurement);
                else if (measurement.end < previousFurthestMeasurement.end) furthestMeasurementsFound.set(measurement.lane, true);
                if (furthestMeasurementsFound.size === this.options.lanes) break;
            }
            return furthestMeasurements.size === this.options.lanes ? Array.from(furthestMeasurements.values()).sort((a, b)=>{
                if (a.end === b.end) return a.index - b.index;
                return a.end - b.end;
            })[0] : void 0;
        };
        this.getMeasurements = (0, $5oCQ9.memo)(()=>[
                this.getMeasurementOptions(),
                this.itemSizeCache
            ], ({ count: count, paddingStart: paddingStart, scrollMargin: scrollMargin, getItemKey: getItemKey }, itemSizeCache)=>{
            const min = this.pendingMeasuredCacheIndexes.length > 0 ? Math.min(...this.pendingMeasuredCacheIndexes) : 0;
            this.pendingMeasuredCacheIndexes = [];
            const measurements = this.measurementsCache.slice(0, min);
            for(let i = min; i < count; i++){
                const key = getItemKey(i);
                const furthestMeasurement = this.options.lanes === 1 ? measurements[i - 1] : this.getFurthestMeasurement(measurements, i);
                const start = furthestMeasurement ? furthestMeasurement.end + this.options.gap : paddingStart + scrollMargin;
                const measuredSize = itemSizeCache.get(key);
                const size = typeof measuredSize === "number" ? measuredSize : this.options.estimateSize(i);
                const end = start + size;
                const lane = furthestMeasurement ? furthestMeasurement.lane : i % this.options.lanes;
                measurements[i] = {
                    index: i,
                    start: start,
                    size: size,
                    end: end,
                    key: key,
                    lane: lane
                };
            }
            this.measurementsCache = measurements;
            return measurements;
        }, {
            key: false,
            debug: ()=>this.options.debug
        });
        this.calculateRange = (0, $5oCQ9.memo)(()=>[
                this.getMeasurements(),
                this.getSize(),
                this.scrollOffset
            ], (measurements, outerSize, scrollOffset)=>{
            return this.range = measurements.length > 0 && outerSize > 0 ? $20879669f8b1eab4$var$calculateRange({
                measurements: measurements,
                outerSize: outerSize,
                scrollOffset: scrollOffset
            }) : null;
        }, {
            key: false,
            debug: ()=>this.options.debug
        });
        this.getIndexes = (0, $5oCQ9.memo)(()=>[
                this.options.rangeExtractor,
                this.calculateRange(),
                this.options.overscan,
                this.options.count
            ], (rangeExtractor, range, overscan, count)=>{
            return range === null ? [] : rangeExtractor({
                startIndex: range.startIndex,
                endIndex: range.endIndex,
                overscan: overscan,
                count: count
            });
        }, {
            key: false,
            debug: ()=>this.options.debug
        });
        this.indexFromElement = (node)=>{
            const attributeName = this.options.indexAttribute;
            const indexStr = node.getAttribute(attributeName);
            if (!indexStr) {
                console.warn(`Missing attribute name '${attributeName}={index}' on measured element.`);
                return -1;
            }
            return parseInt(indexStr, 10);
        };
        this._measureElement = (node, entry)=>{
            const item = this.measurementsCache[this.indexFromElement(node)];
            if (!item || !node.isConnected) {
                this.measureElementCache.forEach((cached, key)=>{
                    if (cached === node) {
                        this.observer.unobserve(node);
                        this.measureElementCache.delete(key);
                    }
                });
                return;
            }
            const prevNode = this.measureElementCache.get(item.key);
            if (prevNode !== node) {
                if (prevNode) this.observer.unobserve(prevNode);
                this.observer.observe(node);
                this.measureElementCache.set(item.key, node);
            }
            const measuredItemSize = this.options.measureElement(node, entry, this);
            this.resizeItem(item, measuredItemSize);
        };
        this.resizeItem = (item, size)=>{
            const itemSize = this.itemSizeCache.get(item.key) ?? item.size;
            const delta = size - itemSize;
            if (delta !== 0) {
                if (this.shouldAdjustScrollPositionOnItemSizeChange !== void 0 ? this.shouldAdjustScrollPositionOnItemSizeChange(item, delta, this) : item.start < this.scrollOffset + this.scrollAdjustments) this._scrollToOffset(this.scrollOffset, {
                    adjustments: this.scrollAdjustments += delta,
                    behavior: void 0
                });
                this.pendingMeasuredCacheIndexes.push(item.index);
                this.itemSizeCache = new Map(this.itemSizeCache.set(item.key, size));
                this.notify(true, false);
            }
        };
        this.measureElement = (node)=>{
            if (!node) return;
            this._measureElement(node, void 0);
        };
        this.getVirtualItems = (0, $5oCQ9.memo)(()=>[
                this.getIndexes(),
                this.getMeasurements()
            ], (indexes, measurements)=>{
            const virtualItems = [];
            for(let k = 0, len = indexes.length; k < len; k++){
                const i = indexes[k];
                const measurement = measurements[i];
                virtualItems.push(measurement);
            }
            return virtualItems;
        }, {
            key: false,
            debug: ()=>this.options.debug
        });
        this.getVirtualItemForOffset = (offset)=>{
            const measurements = this.getMeasurements();
            return (0, $5oCQ9.notUndefined)(measurements[$20879669f8b1eab4$var$findNearestBinarySearch(0, measurements.length - 1, (index)=>(0, $5oCQ9.notUndefined)(measurements[index]).start, offset)]);
        };
        this.getOffsetForAlignment = (toOffset, align)=>{
            const size = this.getSize();
            if (align === "auto") {
                if (toOffset <= this.scrollOffset) align = "start";
                else if (toOffset >= this.scrollOffset + size) align = "end";
                else align = "start";
            }
            if (align === "start") toOffset;
            else if (align === "end") toOffset = toOffset - size;
            else if (align === "center") toOffset = toOffset - size / 2;
            const scrollSizeProp = this.options.horizontal ? "scrollWidth" : "scrollHeight";
            const scrollSize = this.scrollElement ? "document" in this.scrollElement ? this.scrollElement.document.documentElement[scrollSizeProp] : this.scrollElement[scrollSizeProp] : 0;
            const maxOffset = scrollSize - this.getSize();
            return Math.max(Math.min(maxOffset, toOffset), 0);
        };
        this.getOffsetForIndex = (index, align = "auto")=>{
            index = Math.max(0, Math.min(index, this.options.count - 1));
            const measurement = (0, $5oCQ9.notUndefined)(this.getMeasurements()[index]);
            if (align === "auto") {
                if (measurement.end >= this.scrollOffset + this.getSize() - this.options.scrollPaddingEnd) align = "end";
                else if (measurement.start <= this.scrollOffset + this.options.scrollPaddingStart) align = "start";
                else return [
                    this.scrollOffset,
                    align
                ];
            }
            const toOffset = align === "end" ? measurement.end + this.options.scrollPaddingEnd : measurement.start - this.options.scrollPaddingStart;
            return [
                this.getOffsetForAlignment(toOffset, align),
                align
            ];
        };
        this.isDynamicMode = ()=>this.measureElementCache.size > 0;
        this.cancelScrollToIndex = ()=>{
            if (this.scrollToIndexTimeoutId !== null) {
                clearTimeout(this.scrollToIndexTimeoutId);
                this.scrollToIndexTimeoutId = null;
            }
        };
        this.scrollToOffset = (toOffset, { align: align = "start", behavior: behavior } = {})=>{
            this.cancelScrollToIndex();
            if (behavior === "smooth" && this.isDynamicMode()) console.warn("The `smooth` scroll behavior is not fully supported with dynamic size.");
            this._scrollToOffset(this.getOffsetForAlignment(toOffset, align), {
                adjustments: void 0,
                behavior: behavior
            });
        };
        this.scrollToIndex = (index, { align: initialAlign = "auto", behavior: behavior } = {})=>{
            index = Math.max(0, Math.min(index, this.options.count - 1));
            this.cancelScrollToIndex();
            if (behavior === "smooth" && this.isDynamicMode()) console.warn("The `smooth` scroll behavior is not fully supported with dynamic size.");
            const [toOffset, align] = this.getOffsetForIndex(index, initialAlign);
            this._scrollToOffset(toOffset, {
                adjustments: void 0,
                behavior: behavior
            });
            if (behavior !== "smooth" && this.isDynamicMode()) this.scrollToIndexTimeoutId = setTimeout(()=>{
                this.scrollToIndexTimeoutId = null;
                const elementInDOM = this.measureElementCache.has(this.options.getItemKey(index));
                if (elementInDOM) {
                    const [toOffset2] = this.getOffsetForIndex(index, align);
                    if (!(0, $5oCQ9.approxEqual)(toOffset2, this.scrollOffset)) this.scrollToIndex(index, {
                        align: align,
                        behavior: behavior
                    });
                } else this.scrollToIndex(index, {
                    align: align,
                    behavior: behavior
                });
            });
        };
        this.scrollBy = (delta, { behavior: behavior } = {})=>{
            this.cancelScrollToIndex();
            if (behavior === "smooth" && this.isDynamicMode()) console.warn("The `smooth` scroll behavior is not fully supported with dynamic size.");
            this._scrollToOffset(this.scrollOffset + delta, {
                adjustments: void 0,
                behavior: behavior
            });
        };
        this.getTotalSize = ()=>{
            var _a;
            const measurements = this.getMeasurements();
            let end;
            if (measurements.length === 0) end = this.options.paddingStart;
            else end = this.options.lanes === 1 ? ((_a = measurements[measurements.length - 1]) == null ? void 0 : _a.end) ?? 0 : Math.max(...measurements.slice(-this.options.lanes).map((m)=>m.end));
            return end - this.options.scrollMargin + this.options.paddingEnd;
        };
        this._scrollToOffset = (offset, { adjustments: adjustments, behavior: behavior })=>{
            this.options.scrollToFn(offset, {
                behavior: behavior,
                adjustments: adjustments
            }, this);
        };
        this.measure = ()=>{
            var _a, _b;
            this.itemSizeCache = /* @__PURE__ */ new Map();
            (_b = (_a = this.options).onChange) == null || _b.call(_a, this, false);
        };
        this.setOptions(opts);
        this.scrollRect = this.options.initialRect;
        this.scrollOffset = typeof this.options.initialOffset === "function" ? this.options.initialOffset() : this.options.initialOffset;
        this.measurementsCache = this.options.initialMeasurementsCache;
        this.measurementsCache.forEach((item)=>{
            this.itemSizeCache.set(item.key, item.size);
        });
        this.notify(false, false);
    }
}
const $20879669f8b1eab4$var$findNearestBinarySearch = (low, high, getCurrentValue, value)=>{
    while(low <= high){
        const middle = (low + high) / 2 | 0;
        const currentValue = getCurrentValue(middle);
        if (currentValue < value) low = middle + 1;
        else if (currentValue > value) high = middle - 1;
        else return middle;
    }
    if (low > 0) return low - 1;
    else return 0;
};
function $20879669f8b1eab4$var$calculateRange({ measurements: measurements, outerSize: outerSize, scrollOffset: scrollOffset }) {
    const count = measurements.length - 1;
    const getOffset = (index)=>measurements[index].start;
    const startIndex = $20879669f8b1eab4$var$findNearestBinarySearch(0, count, getOffset, scrollOffset);
    let endIndex = startIndex;
    while(endIndex < count && measurements[endIndex].end < scrollOffset + outerSize)endIndex++;
    return {
        startIndex: startIndex,
        endIndex: endIndex
    };
}

});
parcelRegister("5oCQ9", function(module, exports) {

$parcel$export(module.exports, "memo", () => $3edd5277c0f8707b$export$7c73462e0d25e514);
$parcel$export(module.exports, "notUndefined", () => $3edd5277c0f8707b$export$9a1adf421b69c6a);
$parcel$export(module.exports, "approxEqual", () => $3edd5277c0f8707b$export$8a4f1dcc58a69dbd);
$parcel$export(module.exports, "debounce", () => $3edd5277c0f8707b$export$61fc7d43ac8f84b0);
function $3edd5277c0f8707b$export$7c73462e0d25e514(getDeps, fn, opts) {
    let deps = opts.initialDeps ?? [];
    let result;
    return ()=>{
        var _a, _b, _c, _d;
        let depTime;
        if (opts.key && ((_a = opts.debug) == null ? void 0 : _a.call(opts))) depTime = Date.now();
        const newDeps = getDeps();
        const depsChanged = newDeps.length !== deps.length || newDeps.some((dep, index)=>deps[index] !== dep);
        if (!depsChanged) return result;
        deps = newDeps;
        let resultTime;
        if (opts.key && ((_b = opts.debug) == null ? void 0 : _b.call(opts))) resultTime = Date.now();
        result = fn(...newDeps);
        if (opts.key && ((_c = opts.debug) == null ? void 0 : _c.call(opts))) {
            const depEndTime = Math.round((Date.now() - depTime) * 100) / 100;
            const resultEndTime = Math.round((Date.now() - resultTime) * 100) / 100;
            const resultFpsPercentage = resultEndTime / 16;
            const pad = (str, num)=>{
                str = String(str);
                while(str.length < num)str = " " + str;
                return str;
            };
            console.info(`%c\u{23F1} ${pad(resultEndTime, 5)} /${pad(depEndTime, 5)} ms`, `
            font-size: .6rem;
            font-weight: bold;
            color: hsl(${Math.max(0, Math.min(120 - 120 * resultFpsPercentage, 120))}deg 100% 31%);`, opts == null ? void 0 : opts.key);
        }
        (_d = opts == null ? void 0 : opts.onChange) == null || _d.call(opts, result);
        return result;
    };
}
function $3edd5277c0f8707b$export$9a1adf421b69c6a(value, msg) {
    if (value === void 0) throw new Error(`Unexpected undefined${msg ? `: ${msg}` : ""}`);
    else return value;
}
const $3edd5277c0f8707b$export$8a4f1dcc58a69dbd = (a, b)=>Math.abs(a - b) < 1;
const $3edd5277c0f8707b$export$61fc7d43ac8f84b0 = (fn, ms)=>{
    let timeoutId;
    return function(...args) {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(()=>fn.apply(this, args), ms);
    };
};

});



parcelRegister("bmsPo", function(module, exports) {

$parcel$export(module.exports, "useVirtualisedActions", () => $333854ad01b5b46b$export$affb102126dcde2a);
$parcel$export(module.exports, "useVirtualisedItems", () => $333854ad01b5b46b$export$a4da365e237701e3);
$parcel$export(module.exports, "VirtualiseProviderSweetState", () => $333854ad01b5b46b$export$6754b86f75c8ce1a);

var $heB5U = parcelRequire("heB5U");
var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");

var $gf0vG = parcelRequire("gf0vG");

var $5spST = parcelRequire("5spST");
var $gXVpd = parcelRequire("gXVpd");

var $02RQg = parcelRequire("02RQg");
const $333854ad01b5b46b$var$store = (0, $a61MH.createStore)({
    initialState: (0, $5spST.DEFAULT_VALUE),
    actions: (0, $gXVpd.virtualiserActions),
    name: 'timeline-table.virtualise'
});
const $333854ad01b5b46b$export$affb102126dcde2a = (0, $ggKAj.createHook)($333854ad01b5b46b$var$store, {
    selector: null
});
const $333854ad01b5b46b$export$a4da365e237701e3 = (0, $ggKAj.createHook)($333854ad01b5b46b$var$store, {
    selector: (0, $02RQg.getVirtualisedItems)
});
const $333854ad01b5b46b$export$34f4621b58d3fbc8 = ()=>({ dispatch: dispatch }, { itemHeights: itemHeights, isEnabled: isEnabled })=>{
        if (isEnabled) {
            // Set a reasonable default value for items components before useVirtual hook produces meta data
            const fallbackItemsCount = Math.round(window.innerHeight / (0, $gf0vG.DEFAULT_ITEM_HEIGHT));
            const fallbackEnd = Math.min(itemHeights.length - 1, fallbackItemsCount);
            dispatch((0, $gXVpd.virtualiserActions).generateVirtualMeta(0, fallbackEnd));
        } else dispatch((0, $gXVpd.virtualiserActions).generateVirtualMeta(0, itemHeights.length - 1));
    };
const $333854ad01b5b46b$export$ab8f0de40a3a2d2d = ()=>({ dispatch: dispatch }, { itemHeights: itemHeights, isEnabled: isEnabled })=>{
        /**
		 * Update the virtualised meta data When the items are updated when virtualisation is disabled.
		 * This step is not required when virtualisation is enabled because useVirtual handles that.
		 */ if (!isEnabled) dispatch((0, $gXVpd.virtualiserActions).generateVirtualMeta(0, itemHeights.length - 1));
    };
const $333854ad01b5b46b$export$6754b86f75c8ce1a = (0, $heB5U.createContainer)($333854ad01b5b46b$var$store, {
    onInit: $333854ad01b5b46b$export$34f4621b58d3fbc8,
    onUpdate: $333854ad01b5b46b$export$ab8f0de40a3a2d2d
});

});
parcelRegister("5spST", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_VALUE", () => $285b02195cb12660$export$66a151256d4631f5);
$parcel$export(module.exports, "generateVirtualMeta", () => $285b02195cb12660$export$ac5dd8f3ecc3f3f9);


var $iulwX = parcelRequire("iulwX");
const $285b02195cb12660$export$66a151256d4631f5 = {
    createPosition: undefined,
    createItem: undefined,
    orphanIndexOffset: 0,
    orphanParent: undefined,
    visibleItems: [],
    overscan: (0, $2cdd987d900949d8$export$def0e365218ffa1e),
    requiredItems: [],
    overscanRange: {
        start: 0,
        end: 0
    }
};
const $285b02195cb12660$export$ac5dd8f3ecc3f3f9 = (startIndex, endIndex)=>({ setState: setState }, { createItemIndex: createItemIndex, itemHeights: itemHeights, items: items })=>{
        if (startIndex !== undefined && endIndex !== undefined) {
            const virtualMeta = (0, $iulwX.getVisibleItemsFromIndexes)({
                createItemIndex: createItemIndex,
                itemHeights: itemHeights,
                startIndex: startIndex,
                endIndex: endIndex,
                items: items
            });
            setState(virtualMeta);
        } else setState($285b02195cb12660$export$66a151256d4631f5);
    };

});
const $2cdd987d900949d8$export$793ed84f5e13fedc = 'TOP';
const $2cdd987d900949d8$export$84e1549b474f1b93 = 'BOTTOM';
const $2cdd987d900949d8$export$def0e365218ffa1e = 5;

parcelRegister("iulwX", function(module, exports) {

$parcel$export(module.exports, "getVisibleItemsFromIndexes", () => $61003e8553e9916f$export$aefb967ef9d43391);

var $5iWql = parcelRequire("5iWql");

var $1ybV0 = parcelRequire("1ybV0");

var $gf0vG = parcelRequire("gf0vG");

const $61003e8553e9916f$var$getAccumulateHeight = (0, $5iWql.default)((itemHeights)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    itemHeights.reduce((acc, current, index)=>{
        acc.push(current + (index > 0 ? acc[index - 1] : 0));
        return acc;
    }, []));
const $61003e8553e9916f$export$b55fce277fa0884f = (startIndex, endIndex, itemHeights)=>{
    if (endIndex <= startIndex) return 0;
    const accumHeight = $61003e8553e9916f$var$getAccumulateHeight(itemHeights);
    return accumHeight[endIndex - 1] - (startIndex === 0 ? 0 : accumHeight[startIndex - 1]);
};
const $61003e8553e9916f$export$1101758ce03ba6b1 = (index, itemHeights, start, end)=>{
    // Get row height for the items before index
    const before = $61003e8553e9916f$export$b55fce277fa0884f(start, index, itemHeights);
    const after = $61003e8553e9916f$export$b55fce277fa0884f(index + 1, end, itemHeights);
    return {
        before: before,
        after: after
    };
};
const $61003e8553e9916f$export$5267b7ac5b1283d5 = (items, startIndex)=>{
    const firstItem = items[startIndex];
    if (firstItem !== undefined && firstItem.type !== (0, $gf0vG.ITEM_TYPE)) {
        let parentId;
        if (firstItem.type === (0, $gf0vG.CREATE_ITEM_TYPE) && firstItem.anchorItem !== undefined) parentId = firstItem.anchorItem.id;
        else if (firstItem.type === (0, $gf0vG.CHILD_ITEM_TYPE)) parentId = firstItem.meta.parentId;
        if (parentId !== undefined) {
            const parentItem = items.find((enrichedItem)=>'item' in enrichedItem && enrichedItem.item.id === parentId);
            if (parentItem !== undefined && parentItem.type === (0, $gf0vG.ITEM_TYPE)) return parentItem;
        }
    }
    return undefined;
};
const $61003e8553e9916f$export$c6fd3ab3f44300d0 = (items, item)=>{
    const ancestors = [];
    if (item) {
        let currentParentId = item.meta.parentId;
        // once cleaning up jwm.visual-hierarchy-milestone-1, we can remove the below conditional assignment as the flatIndex will be a required prop
        const startingIndex = item.flatIndex === undefined ? items.length - 1 : item.flatIndex - 1;
        // we can iterate through the earlier objects to find all the ancestors
        for(let i = startingIndex; i >= 0 && currentParentId; i--){
            // had to introduce this 'currentItem' variable here to overcome typescript error
            const currentItem = items[i];
            if (currentItem.type === (0, $gf0vG.ITEM_TYPE) && currentItem.item.id === currentParentId) {
                ancestors.push(currentItem);
                currentParentId = items[i].meta.parentId;
            }
        }
    }
    return ancestors.reverse();
};
const $61003e8553e9916f$export$7adcff1c9f66e792 = (items, createItemIndex)=>{
    const createItem = items[createItemIndex];
    if (createItem === undefined || createItem.type !== (0, $gf0vG.CREATE_ITEM_TYPE)) return undefined;
    return createItem;
};
const $61003e8553e9916f$export$5f4c06c23bef7b9f = (visibleItems, orphanParent, createItemIndex)=>{
    if (orphanParent !== undefined && visibleItems.length > 0) {
        const firstVisibleOrphan = visibleItems[0];
        const orphanIndex = firstVisibleOrphan.type === (0, $gf0vG.CREATE_ITEM_TYPE) ? createItemIndex : firstVisibleOrphan.flatIndex || 0;
        const offset = orphanIndex - ('flatIndex' in orphanParent && orphanParent.flatIndex ? orphanParent.flatIndex : 0);
        return Math.max(offset - 1, 0);
    }
    return 0;
};
const $61003e8553e9916f$export$aefb967ef9d43391 = ({ startIndex: startIndex, endIndex: endIndex, itemHeights: itemHeights, createItemIndex: createItemIndex, items: items, overscan: overscan = (0, $2cdd987d900949d8$export$def0e365218ffa1e) })=>{
    // Overscan indexes
    const totalCount = itemHeights.length;
    const overscanStart = Math.max(startIndex - overscan, 0);
    const overscanEnd = Math.min(endIndex + overscan, totalCount - 1);
    let createPosition;
    // Check if create-item is rendered before visible items
    if (createItemIndex > -1 && createItemIndex < overscanStart) createPosition = (0, $2cdd987d900949d8$export$793ed84f5e13fedc);
    else if (createItemIndex > overscanEnd) createPosition = (0, $2cdd987d900949d8$export$84e1549b474f1b93);
    const createItem = $61003e8553e9916f$export$7adcff1c9f66e792(items, createItemIndex);
    const visibleItems = items.slice(overscanStart, overscanEnd + 1);
    const orphanParent = $61003e8553e9916f$export$5267b7ac5b1283d5(items, overscanStart);
    const orphanIndexOffset = $61003e8553e9916f$export$5f4c06c23bef7b9f(visibleItems, orphanParent, createItemIndex);
    let requiredItems;
    if ((0, $1ybV0.ff)('jwm.visual-hierarchy-milestone-1')) {
        // the ancestors of the first visible item are invisible.
        // this is needed to make sure all the children of the invisible ancestors are rendered
        const invisibleAncestors = $61003e8553e9916f$export$c6fd3ab3f44300d0(items, items[overscanStart]);
        // we need to keep the createItem and its ancestors always in the rendered list
        // this is to prevent the createItem from being rendered when it enters in the visible range
        // If we render the createItem everytime by scrolling,
        // it will cause a scroll jump to the createItem input fields which is a bad user xp
        // so, we keep it always rendered to stop this scroll jump
        // if the createItem is in the visible range, its parents are included in invisibleAncestors,
        // otherwise we should double-check the createItemAncestors
        const createItemAncestors = createPosition && createItem ? $61003e8553e9916f$export$c6fd3ab3f44300d0(items, createItem) : [];
        requiredItems = items.filter((item, index)=>index >= overscanStart && index <= overscanEnd || // we need to keep the createItem always in the rendered list
            index === createItemIndex || // to fix type error
            item.type === (0, $gf0vG.ITEM_TYPE) && // we need to render the create item if it is active, even it is beyond the visible items
            (createItemAncestors?.includes(item) || // the invisible ancestors are needed for their children to get rendered
            invisibleAncestors?.includes(item)));
    }
    return {
        createItem: createItem,
        orphanParent: orphanParent,
        ...(0, $1ybV0.ff)('jwm.visual-hierarchy-milestone-1') && {
            requiredItems: requiredItems,
            overscanRange: {
                start: overscanStart,
                end: overscanEnd
            }
        },
        orphanIndexOffset: orphanIndexOffset,
        visibleItems: visibleItems,
        overscan: overscan,
        createPosition: createPosition
    };
};

});


parcelRegister("gXVpd", function(module, exports) {

$parcel$export(module.exports, "virtualiserActions", () => $2fcc15370fc6853a$export$e8a8e63a5a7f1929);

var $5spST = parcelRequire("5spST");
const $2fcc15370fc6853a$export$e8a8e63a5a7f1929 = {
    generateVirtualMeta: $5spST.generateVirtualMeta
};

});

parcelRegister("02RQg", function(module, exports) {

$parcel$export(module.exports, "getVirtualisedItems", () => $4c8db53a14d64a4f$export$fab83018e0db4fa8);
const $4c8db53a14d64a4f$export$fab83018e0db4fa8 = (state)=>state;

});


parcelRegister("2eorI", function(module, exports) {

$parcel$export(module.exports, "getItemHeights", () => $80e5679b4cb84d23$export$b0c1b33ea0acf206);

var $1ybV0 = parcelRequire("1ybV0");

var $gf0vG = parcelRequire("gf0vG");
const $80e5679b4cb84d23$export$b0c1b33ea0acf206 = (items, itemHeight)=>(0, $1ybV0.ff)('jwm.visual-hierarchy-milestone-1') ? items.map((item)=>{
        const depth = item.type === (0, $gf0vG.ITEM_TYPE) && item?.item?.depth;
        // depth shouldn't be undefined
        if (item.type === (0, $gf0vG.ITEM_TYPE) && depth === 0) return itemHeight;
        if (item.type === (0, $gf0vG.CREATE_ITEM_TYPE)) return itemHeight;
        return 0, $gf0vG.BASE_LEVEL_ITEM_HEIGHT;
    }) : items.map((item)=>item.type === (0, $gf0vG.CHILD_ITEM_TYPE) ? (0, $gf0vG.BASE_LEVEL_ITEM_HEIGHT) : itemHeight);

});


parcelRegister("8ftWh", function(module, exports) {

$parcel$export(module.exports, "default", () => $6d0367e82596afd4$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $1ybV0 = parcelRequire("1ybV0");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $jK1pm = parcelRequire("jK1pm");

var $lnM6x = parcelRequire("lnM6x");

var $lSR7G = parcelRequire("lSR7G");
var $9WNLk = parcelRequire("9WNLk");

var $ccgw3 = parcelRequire("ccgw3");

var $agwqh = parcelRequire("agwqh");

var $lSZKO = parcelRequire("lSZKO");
var $6N43q = parcelRequire("6N43q");
var $kbPV8 = parcelRequire("kbPV8");

var $f3dMv = parcelRequire("f3dMv");

var $htzwR = parcelRequire("htzwR");
var $hkIxH = parcelRequire("hkIxH");
var $dG2Eg = parcelRequire("dG2Eg");
var $l4yFR = parcelRequire("l4yFR");
var $a3v1C = parcelRequire("a3v1C");
var $8uivF = parcelRequire("8uivF");
var $9OCIr = parcelRequire("9OCIr");
var $dAVGZ = parcelRequire("dAVGZ");
const $6d0367e82596afd4$var$contentContainerStyles = null;
const $6d0367e82596afd4$var$Content = ({ isResizeEnabled: isResizeEnabled, DndLongTaskMetric: DndLongTaskMetric, onItemDrop: onItemDrop, onItemSelect: onItemSelect, onItemExpandChanged: onItemExpandChanged, onCreateClick: onCreateClick, onSetListWidth: onSetListWidth, onContentResize: onContentResize, renderListEmptyContent: renderListEmptyContent, renderListItemContent: renderListItemContent, renderListItemSecondaryContent: renderListItemSecondaryContent, renderListItemCreate: renderListItemCreate, renderChartItemContent: renderChartItemContent, renderChartTimelineOverlay: renderChartTimelineOverlay })=>{
    const contentContainerRef = (0, $eUqFw.useRef)(null);
    const [{ isDragEnabled: isDragEnabled, isSelectEnabled: isSelectEnabled, isCreateSiblingEnabled: isCreateSiblingEnabled, isCreateChildEnabled: isCreateChildEnabled }] = (0, $9WNLk.useEnablements)();
    const [createItemAnchor] = (0, $lSR7G.useCreateItemAnchor)();
    const [itemHeight] = (0, $lSR7G.useItemHeight)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const isGridMarkupEnabled = (0, $1ybV0.ff)('jsw.roadmaps.gridification-markup');
    const onSelect = (0, $eUqFw.useCallback)((id, payload)=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'listItem'
        });
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'issueListItem', payload);
        onItemSelect(id, payload, analyticsEvent);
    }, [
        onItemSelect,
        createAnalyticsEvent
    ]);
    const onExpandChanged = (0, $eUqFw.useCallback)((id, isItemExpanded)=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'expansionStateChanged',
            actionSubject: 'listItem'
        });
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'issueListItem', {
            type: isItemExpanded ? 'collapsed' : 'expanded'
        });
        onItemExpandChanged(id, isItemExpanded);
    }, [
        onItemExpandChanged,
        createAnalyticsEvent
    ]);
    const onDrop = (0, $eUqFw.useCallback)((id, payload)=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'dragEnded',
            actionSubject: 'listItem'
        });
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'issueListItem', {
            level: payload.level,
            isReparent: Boolean(payload.parentId)
        });
        onItemDrop(id, payload, analyticsEvent);
    }, [
        onItemDrop,
        createAnalyticsEvent
    ]);
    const renderCreateItem = (anchorItem, { key: key, level: level, depth: depth = 0, backgroundColor: backgroundColor, isActive: isActive, ariaRowIndex: ariaRowIndex, startOffset: startOffset })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hkIxH.default), {
            key: `create-item-${key}`,
            level: level,
            canCreateChildOverride: Boolean(anchorItem?.canCreateChildOverride),
            depth: depth,
            anchorId: anchorItem?.id,
            itemHeight: itemHeight,
            backgroundColor: backgroundColor,
            isActive: isActive,
            ariaRowIndex: ariaRowIndex,
            startOffset: startOffset,
            onCreateClick: onCreateClick,
            renderListItemCreate: renderListItemCreate
        });
    const renderItem = ({ id: id, level: level, isInTransition: isInTransition, canCreateChildOverride: canCreateChildOverride = true, depth: depth = 0 }, { parentId: parentId, backgroundColor: backgroundColor, isParent: isParent, isExpanded: isExpanded, ariaControls: ariaControls }, index, isVirtual = false)=>{
        if (isVirtual) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uivF.default), {
            key: `list-item-lite-${id}`,
            id: id,
            level: level,
            depth: depth,
            itemHeight: itemHeight,
            backgroundColor: backgroundColor,
            renderListItemContent: renderListItemContent,
            renderListItemSecondaryContent: renderListItemSecondaryContent
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6N43q.default), {
            id: id,
            key: `chart-item-lite-${id}`,
            level: level,
            depth: depth,
            itemHeight: itemHeight,
            backgroundColor: backgroundColor,
            renderChartItemContent: renderChartItemContent
        }));
        const canCreateChild = (0, $1ybV0.ff)('jwm.visual-hierarchy-milestone-1') ? (0, $htzwR.canItemCreateChild)({
            id: id,
            createItemAnchor: createItemAnchor,
            isInTransition: isInTransition,
            isCreateChildEnabled: isCreateChildEnabled,
            canCreateChildOverride: canCreateChildOverride
        }) : (0, $htzwR.canItemCreateChildOld)({
            id: id,
            level: level,
            createItemAnchor: createItemAnchor,
            isInTransition: isInTransition,
            isCreateChildEnabled: isCreateChildEnabled && canCreateChildOverride
        });
        const canCreateSibling = (0, $1ybV0.ff)('jwm.visual-hierarchy-milestone-1') ? (0, $htzwR.canItemCreateSibling)({
            id: id,
            index: index,
            depth: depth,
            createItemAnchor: createItemAnchor,
            isInTransition: isInTransition,
            isCreateChildEnabled: isCreateChildEnabled,
            isCreateSiblingEnabled: isCreateSiblingEnabled
        }) : (0, $htzwR.canItemCreateSiblingOld)({
            id: id,
            index: index,
            level: level,
            createItemAnchor: createItemAnchor,
            isInTransition: isInTransition,
            isCreateChildEnabled: isCreateChildEnabled,
            isCreateSiblingEnabled: isCreateSiblingEnabled
        });
        const ListComponent = isGridMarkupEnabled ? (0, $a3v1C.default) : (0, $9OCIr.default);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ListComponent, {
            ariaControls: ariaControls,
            key: `list-item-${id}`,
            id: id,
            parentId: parentId,
            level: level,
            depth: depth,
            itemHeight: itemHeight,
            backgroundColor: backgroundColor,
            isParent: isParent,
            isExpanded: isExpanded,
            isDragEnabled: isDragEnabled,
            isInTransition: isInTransition,
            isSelectEnabled: isSelectEnabled,
            isCreateChildEnabled: canCreateChild,
            isCreateSiblingEnabled: canCreateSibling,
            onSelect: onSelect,
            onExpandChanged: onExpandChanged,
            onInlineCreateClicked: onCreateClick,
            renderListItemContent: renderListItemContent,
            renderListItemSecondaryContent: renderListItemSecondaryContent
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lSZKO.default), {
            id: id,
            key: `chart-item-${id}`,
            level: level,
            depth: depth,
            parentId: parentId,
            itemHeight: itemHeight,
            backgroundColor: backgroundColor,
            renderChartItemContent: renderChartItemContent
        }));
    };
    const renderItemContainer = ({ parentId: parentId, isExpanded: isExpanded, isParent: isParent, id: id, level: level, depth: depth = 0, startOffset: startOffset, ariaRowIndex: ariaRowIndex, childItemsHeight: childItemsHeight, isInTransition: isInTransition }, index, children)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dG2Eg.default), {
            id: id,
            key: `drop-target-${id}`,
            ariaRowIndex: ariaRowIndex,
            startOffset: startOffset,
            level: level,
            depth: depth,
            parentId: parentId,
            isExpanded: isExpanded,
            isParent: isParent,
            itemHeight: itemHeight,
            childItemsHeight: childItemsHeight,
            isInTransition: isInTransition,
            onDrop: onDrop,
            onExpandChanged: onExpandChanged
        }, children);
    (0, $ccgw3.useResizeObserver)(contentContainerRef.current, onContentResize);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jK1pm.default), {
        name: "timeline-table-content"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        role: "rowgroup",
        ref: contentContainerRef,
        className: (0, $7JEyt.default)([
            "_kqswh2mm"
        ])
    }, isGridMarkupEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $f3dMv.ItemsBackground), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kbPV8.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lnM6x.default), {
        renderItem: renderItem,
        renderItemContainer: renderItemContainer,
        renderCreateItem: renderCreateItem
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $l4yFR.default), {
        renderListEmptyContent: renderListEmptyContent
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $agwqh.default), {
        renderChartTimelineOverlay: renderChartTimelineOverlay
    }), isResizeEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dAVGZ.default), {
        DndLongTaskMetric: DndLongTaskMetric,
        onSetListWidth: onSetListWidth
    }));
};
$6d0367e82596afd4$var$Content.defaultProps = {
    isResizeEnabled: true,
    onItemDrop: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    onItemSelect: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    onItemExpandChanged: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    onCreateClick: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    onSetListWidth: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    onContentResize: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
};
$6d0367e82596afd4$var$Content.displayName = 'Content';
$6d0367e82596afd4$var$Content.whyDidYouRender = true;
var $6d0367e82596afd4$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($6d0367e82596afd4$var$Content);

});
parcelRegister("lnM6x", function(module, exports) {

$parcel$export(module.exports, "default", () => $3d6d314a1e882138$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $1ybV0 = parcelRequire("1ybV0");

var $gf0vG = parcelRequire("gf0vG");

var $hxnNZ = parcelRequire("hxnNZ");
var $bmsPo = parcelRequire("bmsPo");

var $gdw0F = parcelRequire("gdw0F");

var $2HCaQ = parcelRequire("2HCaQ");
const $3d6d314a1e882138$var$ItemsRenderer = ({ renderItem: renderItem, renderItemContainer: renderItemContainer, renderCreateItem: renderCreateItem })=>(0, $1ybV0.ff)('jwm.visual-hierarchy-milestone-1') ? $3d6d314a1e882138$var$ItemsRendererRecursive({
        renderItem: renderItem,
        renderItemContainer: renderItemContainer,
        renderCreateItem: renderCreateItem
    }) : $3d6d314a1e882138$var$ItemsRendererOld({
        renderItem: renderItem,
        renderItemContainer: renderItemContainer,
        renderCreateItem: renderCreateItem
    });
const $3d6d314a1e882138$var$ItemsRendererRecursive = ({ renderItem: renderItem, renderItemContainer: renderItemContainer, renderCreateItem: renderCreateItem })=>{
    const [virtualisedData] = (0, $bmsPo.useVirtualisedItems)();
    const { requiredItems: requiredItems = [], overscanRange: overscanRange } = virtualisedData;
    // if the item is beyond the visible and overscan range, then it's not visible
    // remove overscanRange undefined checking when cleaning up jwm.visual-hierarchy-milestone-1
    const getIsVirtual = (flatIndex)=>overscanRange ? flatIndex < overscanRange.start || flatIndex > overscanRange.end : false;
    const renderedItems = $3d6d314a1e882138$var$renderList({
        items: requiredItems,
        getIsVirtual: getIsVirtual,
        parentItem: undefined,
        renderItem: renderItem,
        renderItemContainer: renderItemContainer,
        renderCreateItem: renderCreateItem
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, renderedItems);
};
const $3d6d314a1e882138$var$renderList = ({ items: items, getIsVirtual: getIsVirtual, parentItem: parentItem, renderItem: renderItem, renderItemContainer: renderItemContainer, renderCreateItem: renderCreateItem })=>{
    // Start iterate flat items
    const flatItemElements = [];
    const getItemsToRender = (parentFlatItem, flatItems)=>{
        if (parentFlatItem === undefined) return flatItems.filter(({ meta: meta })=>!meta.parentId);
        return flatItems.filter(({ meta: meta })=>meta.parentId === parentFlatItem.item.id);
    };
    const itemsToRender = getItemsToRender(parentItem, items);
    // Generate items
    itemsToRender?.forEach((enrichedItem)=>{
        if (enrichedItem.type === (0, $gf0vG.ITEM_TYPE)) {
            const itemContainerChildren = [];
            // remove flatIndex initial value when cleaning up jwm.visual-hierarchy-milestone-1
            const { item: item, meta: meta, flatIndex: flatIndex = 0 } = enrichedItem;
            // If it is an invisible sibling or ancestor we render it as virtual,
            itemContainerChildren.push(renderItem(item, meta, flatIndex, getIsVirtual(flatIndex)));
            const { isExpanded: isExpanded, isParent: isParent, numChildren: numChildren = 0, ariaRowIndex: ariaRowIndex, startOffset: startOffset, childItemsHeight: childItemsHeight } = meta;
            if (isExpanded && numChildren > 0) {
                const renderedChildItems = $3d6d314a1e882138$var$renderList({
                    items: items,
                    getIsVirtual: getIsVirtual,
                    parentItem: enrichedItem,
                    renderItem: renderItem,
                    renderItemContainer: renderItemContainer,
                    renderCreateItem: renderCreateItem
                });
                itemContainerChildren.push(renderedChildItems);
            }
            const parentItemContainerMeta = {
                parentId: parentItem?.item.id,
                isExpanded: isExpanded,
                isParent: isParent,
                id: item.id,
                level: item.level,
                depth: item.depth,
                ariaRowIndex: ariaRowIndex,
                startOffset: startOffset,
                childItemsHeight: childItemsHeight,
                isInTransition: item.isInTransition
            };
            flatItemElements.push(renderItemContainer(parentItemContainerMeta, 0, itemContainerChildren));
        } else if (enrichedItem.type === (0, $gf0vG.CREATE_ITEM_TYPE)) // Render visible create item
        flatItemElements.push(renderCreateItem(enrichedItem.anchorItem, enrichedItem.meta));
    });
    return flatItemElements;
};
const $3d6d314a1e882138$var$ItemsRendererOld = ({ renderItem: renderItem, renderItemContainer: renderItemContainer, renderCreateItem: renderCreateItem })=>{
    const [virtualisedData] = (0, $bmsPo.useVirtualisedItems)();
    const [isScrollingY] = (0, $hxnNZ.useIsScrollingY)();
    const { createItem: createItem, visibleItems: visibleItems, overscan: overscan, orphanIndexOffset: orphanIndexOffset, orphanParent: orphanParent, createPosition: createPosition } = virtualisedData;
    const getIsVirtual = (index)=>isScrollingY && index < overscan && index >= visibleItems.length - overscan - 1;
    const items = orphanParent !== undefined ? [
        orphanParent,
        ...visibleItems
    ] : visibleItems;
    const totalVisibleItems = items.length;
    const childCreatePosition = (0, $gdw0F.getChildCreateMetaIfContainerVisible)(createPosition, createItem, items);
    const placeholderCreateItem = (0, $2HCaQ.getPlaceholderCreateItem)(createPosition !== undefined && childCreatePosition === undefined, createItem, renderItemContainer, renderCreateItem);
    // Start iterate flat items
    const flatItemElements = [];
    if (createPosition !== undefined && childCreatePosition === undefined) flatItemElements.push(placeholderCreateItem);
    // Generate items
    items.forEach((enrichedItem, index)=>{
        const isVirtual = getIsVirtual(index);
        if (enrichedItem.type === (0, $gf0vG.ITEM_TYPE)) {
            const isItemOrphanChild = orphanParent === enrichedItem;
            const parentItem = isItemOrphanChild && orphanParent !== undefined ? orphanParent : enrichedItem;
            const { item: item, meta: meta, flatIndex: flatIndex } = parentItem;
            const itemContainerChildren = isItemOrphanChild ? [] // Do not render the actual parent item if it is an orphan item
             : [
                renderItem(item, meta, flatIndex, isVirtual)
            ];
            const { isExpanded: isExpanded, isParent: isParent, numChildren: numChildren = 0, ariaRowIndex: ariaRowIndex, startOffset: startOffset, childItemsHeight: childItemsHeight } = meta;
            if (isExpanded) {
                const childStartIndex = index + 1;
                const childEndIndex = childStartIndex + numChildren - (isItemOrphanChild ? orphanIndexOffset : 0);
                // Get child items from flattened items with the flat index and number of children
                const childItems = items.slice(childStartIndex, Math.min(childEndIndex, totalVisibleItems));
                if (childCreatePosition !== undefined && childCreatePosition?.parentId === item.id && placeholderCreateItem !== undefined) itemContainerChildren.push(placeholderCreateItem);
                childItems.forEach((childItem, childIndex)=>{
                    const isChildVirtual = getIsVirtual(childStartIndex + childIndex);
                    const childRenderItem = (0, $gdw0F.getChildItem)(childItem, isChildVirtual, renderItem, renderItemContainer, renderCreateItem);
                    if (childRenderItem !== undefined) itemContainerChildren.push(childRenderItem);
                });
            }
            const parentItemContainerMeta = {
                parentId: undefined,
                isExpanded: isExpanded,
                isParent: isParent,
                id: item.id,
                level: item.level,
                ariaRowIndex: ariaRowIndex,
                startOffset: startOffset,
                childItemsHeight: childItemsHeight,
                isInTransition: item.isInTransition
            };
            flatItemElements.push(renderItemContainer(parentItemContainerMeta, flatIndex, itemContainerChildren));
        } else if (enrichedItem.type === (0, $gf0vG.CREATE_ITEM_TYPE) && (0, $gdw0F.isParentCreateItem)(enrichedItem)) flatItemElements.push(renderCreateItem(enrichedItem.anchorItem, enrichedItem.meta));
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, flatItemElements);
};
var $3d6d314a1e882138$export$2e2bcd8739ae039 = $3d6d314a1e882138$var$ItemsRenderer;

});
parcelRegister("gdw0F", function(module, exports) {

$parcel$export(module.exports, "isParentCreateItem", () => $c71a91b13c78031b$export$3527b5d9fbc62095);
$parcel$export(module.exports, "getChildItem", () => $c71a91b13c78031b$export$d701b1f8ef0a409d);
$parcel$export(module.exports, "getChildCreateMetaIfContainerVisible", () => $c71a91b13c78031b$export$39e9dc1185e3b3a4);

var $5iWql = parcelRequire("5iWql");

var $1ybV0 = parcelRequire("1ybV0");

var $gf0vG = parcelRequire("gf0vG");

var $1sAbG = parcelRequire("1sAbG");
const $c71a91b13c78031b$export$3527b5d9fbc62095 = (item)=>item.type === (0, $gf0vG.CREATE_ITEM_TYPE) && !(0, $1sAbG.isBaseLevel)(item.meta.level);
const $c71a91b13c78031b$export$d701b1f8ef0a409d = (childItem, isVirtual, renderItem, renderItemContainer, renderCreateItem)=>{
    if (childItem.type === (0, $gf0vG.CREATE_ITEM_TYPE) && (0, $1sAbG.isBaseLevel)(childItem.meta.level)) return renderCreateItem(childItem.anchorItem, childItem.meta);
    if (childItem.type === (0, $gf0vG.CHILD_ITEM_TYPE)) {
        const { meta: meta, item: item, flatIndex: flatIndex } = childItem;
        const child = renderItem(item, meta, flatIndex, isVirtual);
        const childItemContainerMeta = {
            parentId: meta.parentId,
            isExpanded: meta.isExpanded,
            isParent: meta.isParent,
            id: item.id,
            level: item.level,
            ariaRowIndex: meta.ariaRowIndex,
            startOffset: meta.startOffset,
            parentStartOffset: meta.parentStartOffset,
            isInTransition: item.isInTransition
        };
        return renderItemContainer(childItemContainerMeta, childItem.flatIndex, child);
    }
    // this will never happen, item type check was necessary for union item type
    return undefined;
};
const $c71a91b13c78031b$export$39e9dc1185e3b3a4 = (0, $5iWql.default)((createPosition, enrichedCreateItem, visibleItems)=>{
    const isCreateItemNested = enrichedCreateItem && ((0, $1ybV0.ff)('jwm.visual-hierarchy-milestone-1') ? !(0, $1sAbG.isRoot)(enrichedCreateItem?.meta.depth ?? 0) : (0, $1sAbG.isBaseLevel)(enrichedCreateItem.meta.level));
    if (createPosition !== undefined && enrichedCreateItem?.type === (0, $gf0vG.CREATE_ITEM_TYPE) && enrichedCreateItem?.anchorItem && isCreateItemNested) {
        // anchor item is not the parent, it could be the next child issue
        const { anchorItem: anchorItem, meta: meta } = enrichedCreateItem;
        let parentId;
        if ((0, $1ybV0.ff)('jwm.visual-hierarchy-milestone-1') ? (0, $1sAbG.isRoot)(anchorItem.depth ?? 0) : !(0, $1sAbG.isBaseLevel)(anchorItem.level)) // create child last
        parentId = anchorItem.id;
        else // create inline child
        parentId = meta.parentId;
        const isAnchorChildItemVisible = visibleItems.find((visibleItem)=>visibleItem.type === (0, $gf0vG.ITEM_TYPE) && visibleItem.item?.id === parentId);
        if (isAnchorChildItemVisible && parentId) return {
            position: createPosition,
            parentId: parentId
        };
    }
    return undefined;
});

});

parcelRegister("2HCaQ", function(module, exports) {

$parcel$export(module.exports, "getPlaceholderCreateItem", () => $4fa95de81eec4f6b$export$33db4c70bb6d20e1);

var $gf0vG = parcelRequire("gf0vG");

var $1sAbG = parcelRequire("1sAbG");

var $gdw0F = parcelRequire("gdw0F");
const $4fa95de81eec4f6b$export$33db4c70bb6d20e1 = (shouldRenderContainer, enrichedCreateItem, renderItemContainer, renderCreateItem)=>{
    // if shouldRenderContainer is true, it means the createPosition has a value which means it's out of view
    if (enrichedCreateItem !== undefined && enrichedCreateItem.type === (0, $gf0vG.CREATE_ITEM_TYPE)) {
        const createItem = renderCreateItem(enrichedCreateItem.anchorItem, enrichedCreateItem.meta);
        if (shouldRenderContainer && !(0, $gdw0F.isParentCreateItem)(enrichedCreateItem) && enrichedCreateItem.anchorItem !== undefined) {
            const { anchorItem: anchorItem, meta: meta } = enrichedCreateItem;
            const parentId = !(0, $1sAbG.isBaseLevel)(anchorItem.level) ? anchorItem.id : meta.parentId;
            if (parentId !== undefined) // render the create child item in a container if it is a child and the parent item is not visible
            return renderItemContainer({
                parentId: undefined,
                isExpanded: true,
                isParent: true,
                id: parentId,
                level: 1,
                startOffset: meta.parentStartOffset,
                ariaRowIndex: meta.ariaRowIndex,
                isInTransition: false
            }, 0, createItem);
        }
        return createItem;
    }
    return undefined;
};

});


parcelRegister("agwqh", function(module, exports) {

$parcel$export(module.exports, "default", () => $d439ece8f8255508$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $9WNLk = parcelRequire("9WNLk");
var $VrUCp = parcelRequire("VrUCp");
var $3XwA1 = parcelRequire("3XwA1");

var $dm0Lt = parcelRequire("dm0Lt");

var $daOnD = parcelRequire("daOnD");

var $hajSy = parcelRequire("hajSy");
const $d439ece8f8255508$var$containerStyles = null;
const $d439ece8f8255508$var$chartContainerStyles = null;
const $d439ece8f8255508$var$ScrollableOverlay = ({ isOverlayInHeader: isOverlayInHeader, renderChartTimelineOverlay: renderChartTimelineOverlay })=>{
    const columnsOverlayElementsRef = (0, $eUqFw.useRef)({});
    const [{ today: today, timelineMode: timelineMode, timelineDuration: timelineDuration, columnDurations: columnDurations, timelineWidth: timelineWidth }] = (0, $3XwA1.useTimelineState)();
    const [{ headerHeight: headerHeight }] = (0, $VrUCp.useHeaderState)();
    const [{ isHighlightToday: isHighlightToday }] = (0, $9WNLk.useEnablements)();
    // NOTE: Optimisation! There are enough columns that caching the generated elements is worth it.
    if (!columnsOverlayElementsRef.current[timelineMode]) columnsOverlayElementsRef.current[timelineMode] = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dm0Lt.default), {
        isHighlightToday: isHighlightToday,
        today: today,
        timelineDuration: timelineDuration,
        columnDurations: columnDurations
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: (0, $7JEyt.default)([
            "_kqswstnw _1e0c1txw _154iidpf _94n5idpf _1ltvidpf _1bsb1osq _lcxvglyw"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $daOnD.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            ...isOverlayInHeader ? {
                position: 'sticky',
                top: 0
            } : {
                position: 'relative',
                top: `${headerHeight}px`,
                height: `calc(100% - ${headerHeight}px)`
            },
            width: `${timelineWidth}px`
        },
        className: (0, $7JEyt.default)([
            "_16jlidpf _1o9zidpf _i0dl1wug"
        ])
    }, columnsOverlayElementsRef.current[timelineMode], !isOverlayInHeader && renderChartTimelineOverlay(), !isOverlayInHeader && isHighlightToday && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hajSy.default), {
        today: today,
        timelineMode: timelineMode,
        timelineDuration: timelineDuration
    })));
};
var $d439ece8f8255508$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($d439ece8f8255508$var$ScrollableOverlay);

});
parcelRegister("dm0Lt", function(module, exports) {

$parcel$export(module.exports, "default", () => $5b8503552a2b5515$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $l2CBN = parcelRequire("l2CBN");

var $b1n3v = parcelRequire("b1n3v");
const $5b8503552a2b5515$var$ColumnsOverlay = ({ isHighlightToday: isHighlightToday, today: today, timelineDuration: timelineDuration, columnDurations: columnDurations })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b1n3v.default), {
        isHighlightToday: isHighlightToday,
        columnPositions: (0, $l2CBN.getColumnPositions)(timelineDuration, columnDurations),
        todayColumnIndex: (0, $l2CBN.getTodayColumnIndex)(today, columnDurations)
    });
var $5b8503552a2b5515$export$2e2bcd8739ae039 = $5b8503552a2b5515$var$ColumnsOverlay;

});
parcelRegister("b1n3v", function(module, exports) {

$parcel$export(module.exports, "default", () => $47f2d4f3b5e63737$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $eUqFw = parcelRequire("eUqFw");

var $dWSuJ = parcelRequire("dWSuJ");
const $47f2d4f3b5e63737$var$containerStyles = null;
const $47f2d4f3b5e63737$var$columnStyles = null;
const $47f2d4f3b5e63737$var$todayColumnStyles = null;
const $47f2d4f3b5e63737$var$Columns = ({ isHighlightToday: isHighlightToday, todayColumnIndex: todayColumnIndex, columnPositions: columnPositions })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: (0, $7JEyt.default)([
            "_kqswstnw _1e0c1txw _154iidpf _1bsb1osq _4t3i1osq _lcxvglyw"
        ])
    }, columnPositions.map(([left, right], index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            key: `column-position-${index}`,
            className: (0, $7JEyt.default)([
                "_kqswstnw _vchhusvi _16jlidpf _1o9zidpf _i0dl1wug _154iidpf _94n5idpf _1s7z1hum"
            ]),
            style: {
                left: `${left}%`,
                right: `${right}%`,
                "--_1p5ufam": (0, $9t7rW.default)((0, $dWSuJ.secondaryBorder))
            }
        }, todayColumnIndex === index && isHighlightToday ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: (0, $7JEyt.default)([
                "_kqswstnw _vchhusvi _154iidpf _1xi21n1a _1ltv1n1a _4t3i1osq _bfhkiw92 _1kl71xde _1s7z1xde"
            ])
        }) : null)));
var $47f2d4f3b5e63737$export$2e2bcd8739ae039 = $47f2d4f3b5e63737$var$Columns;

});
parcelRegister("dWSuJ", function(module, exports) {

$parcel$export(module.exports, "secondaryBorderColor", () => $6d8ea27a206d991f$export$95d9e829dbec7e8b);
$parcel$export(module.exports, "secondaryBorder", () => $6d8ea27a206d991f$export$a84a730095edc78);
$parcel$export(module.exports, "headerShadow", () => $6d8ea27a206d991f$export$19ba7d589adf57bd);
/* timeline.tsx generated by @compiled/babel-plugin v0.29.1 */ parcelRequire("eUqFw");

var $PdmhA = parcelRequire("PdmhA");

var $gf0vG = parcelRequire("gf0vG");
const $6d8ea27a206d991f$export$12879c7697ed953d = 1;
const $6d8ea27a206d991f$export$e52f31604d98c866 = `${$6d8ea27a206d991f$export$12879c7697ed953d}px solid ${`var(--ds-border, ${(0, $PdmhA.N50)})`}`;
const $6d8ea27a206d991f$export$95d9e829dbec7e8b = `var(--ds-border, ${(0, $PdmhA.N40)})`;
const $6d8ea27a206d991f$export$a84a730095edc78 = `${$6d8ea27a206d991f$export$12879c7697ed953d}px solid ${$6d8ea27a206d991f$export$95d9e829dbec7e8b}`;
const $6d8ea27a206d991f$export$d1cf5418fbd2830d = 'background-color 100ms linear';
const $6d8ea27a206d991f$export$a1582ed7fc14858d = {
    width: '100%',
    boxSizing: 'border-box',
    position: 'sticky',
    top: '0px',
    background: `var(--ds-surface, ${(0, $PdmhA.N0)})`
};
const $6d8ea27a206d991f$export$19ba7d589adf57bd = {
    boxShadow: `${`var(--ds-shadow-overflow, ${`0 ${"var(--ds-space-050, 4px)"} ${"var(--ds-space-050, 4px)"} -${"var(--ds-space-025, 2px)"} ${(0, $PdmhA.N40A)}`})`}`
};
const $6d8ea27a206d991f$export$26349e45c0066143 = {
    width: '100%',
    height: `${(0, $gf0vG.BASE_HEADER_HEIGHT)}px`,
    boxSizing: 'border-box',
    borderBottom: $6d8ea27a206d991f$export$a84a730095edc78,
    backgroundColor: `var(--ds-background-neutral, ${(0, $PdmhA.N20)})`
};

});



parcelRegister("daOnD", function(module, exports) {

$parcel$export(module.exports, "default", () => $c52642cbcc28bb6d$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $nH3p1 = parcelRequire("nH3p1");
// NOTE: The scrollable overlay for content will extend to be outside the content container when items are filtered
// The styling here covers the scrollable overlay (e.g. columns overlay, today marker, etc.) when it goes beneath the list part (e.g. scrolling or virtualisation)
const $c52642cbcc28bb6d$var$containerStyles = null;
const $c52642cbcc28bb6d$var$ListCover = ()=>{
    const [listWidth] = (0, $nH3p1.useListWidth)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        style: {
            width: `${listWidth}px`
        },
        className: (0, $7JEyt.default)([
            "_kqsw1if8 _16jlidpf _1o9zidpf _i0dl1wug _1ltvidpf _11q7vuon _1pby37uc"
        ])
    });
};
var $c52642cbcc28bb6d$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($c52642cbcc28bb6d$var$ListCover);

});

parcelRegister("hajSy", function(module, exports) {

$parcel$export(module.exports, "default", () => $92c8d18545bff169$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $1QJt8 = parcelRequire("1QJt8");

var $6Bu0e = parcelRequire("6Bu0e");

var $lmTNg = parcelRequire("lmTNg");
const $92c8d18545bff169$var$TodayMarker = ({ today: today, timelineMode: timelineMode, timelineDuration: timelineDuration })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lmTNg.default), {
        todayPosition: (0, $6Bu0e.getTodayPosition)(today, timelineDuration, (0, $1QJt8.getTimelineWidth)(timelineMode, timelineDuration.totalMilliseconds))
    });
var $92c8d18545bff169$export$2e2bcd8739ae039 = $92c8d18545bff169$var$TodayMarker;

});
parcelRegister("6Bu0e", function(module, exports) {

$parcel$export(module.exports, "getTodayPosition", () => $b56fa76d5d9318b3$export$1c4a20ec05eb2ad0);
// eslint-disable-next-line jira/restricted/moment

var $jJwwt = parcelRequire("jJwwt");
const $b56fa76d5d9318b3$export$1c4a20ec05eb2ad0 = (today, timelineDuration, timelineWidth)=>{
    // We want to present "today" as the middle of the day.
    const middleOfToday = (0, (/*@__PURE__*/$parcel$interopDefault($jJwwt))).utc(today).add(12, 'hour').valueOf();
    const relativePosition = (middleOfToday - timelineDuration.startMilliseconds) / timelineDuration.totalMilliseconds;
    /* Some number magic.
	 * -1 to offset for the width of the today marker.
	 * -1 to offset for the visual weight of the column right border
	 */ return relativePosition * timelineWidth - 2;
};

});

parcelRegister("lmTNg", function(module, exports) {

$parcel$export(module.exports, "default", () => $75b567ebaf80764d$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $VrUCp = parcelRequire("VrUCp");
const $75b567ebaf80764d$var$MARKER_LINE_WIDTH = 2;
const $75b567ebaf80764d$var$POINTER_WIDTH = 4;
const $75b567ebaf80764d$var$containerStyles = null;
const $75b567ebaf80764d$var$markerStyles = null;
const $75b567ebaf80764d$var$pointerStyles = null;
const $75b567ebaf80764d$var$TodayMarkerLine = ({ todayPosition: todayPosition })=>{
    const [{ headerHeight: headerHeight }] = (0, $VrUCp.useHeaderState)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        "data-testid": "roadmap.timeline-table.main.scrollable-overlay.today-marker.container",
        style: {
            left: `${todayPosition}px`
        },
        className: (0, $7JEyt.default)([
            "_kqswstnw _1e0c1txw _154iidpf _94n5idpf _1pbyouyt _lcxvglyw"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: (0, $7JEyt.default)([
            "_1bsbyh40 _4t3i1osq _bfhk1sn9"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        style: {
            top: `${headerHeight}px`
        },
        className: (0, $7JEyt.default)([
            "_kqsw1if8 _1bsbidpf _4t3iidpf _18u0j39m _x3dom65w _1s7z12me _1kl712me"
        ])
    })));
};
var $75b567ebaf80764d$export$2e2bcd8739ae039 = $75b567ebaf80764d$var$TodayMarkerLine;

});



parcelRegister("lSZKO", function(module, exports) {

$parcel$export(module.exports, "default", () => $0bdf41337f165301$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $3XwA1 = parcelRequire("3XwA1");

var $fTs8H = parcelRequire("fTs8H");
var $bwj1b = parcelRequire("bwj1b");

var $22Yy6 = parcelRequire("22Yy6");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $0bdf41337f165301$var$itemBaseStyles = null;
const $0bdf41337f165301$var$chartItemContainer = null;
const $0bdf41337f165301$var$ChartItem = ({ id: id, parentId: parentId, level: level, depth: depth, itemHeight: itemHeight, backgroundColor: backgroundColor, renderChartItemContent: renderChartItemContent })=>{
    const [isHovered, setIsHovered] = (0, $eUqFw.useState)(false);
    const { onRowMouseEnter: onRowMouseEnter, onRowMouseLeave: onRowMouseLeave } = (0, $bwj1b.useSideEffectMarshal)();
    const [{ timelineWidth: timelineWidth }] = (0, $3XwA1.useTimelineState)();
    const onMouseEnter = (0, $eUqFw.useCallback)(()=>{
        onRowMouseEnter(id);
        setIsHovered(true);
    }, [
        id,
        onRowMouseEnter
    ]);
    const onMouseLeave = (0, $eUqFw.useCallback)(()=>{
        onRowMouseLeave(id);
        setIsHovered(false);
    }, [
        id,
        onRowMouseLeave
    ]);
    const rendererProps = {
        id: id
    };
    const rendererState = {
        isVirtual: false,
        isHovered: isHovered
    };
    const height = (0, $22Yy6.getContainerHeight)({
        level: level,
        itemHeight: itemHeight,
        depth: depth
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        role: "gridcell",
        tabIndex: -1,
        "data-testid": `roadmap.timeline-table.components.chart-item.container-${id}`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _v564lfip",
            "_kqswh2mm _1reo15vq _18m915vq",
            (0, $fTs8H.getRowClassName)(id, parentId).className
        ]),
        style: {
            width: `${timelineWidth}px`,
            height: `${height}`,
            backgroundColor: backgroundColor
        },
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave
    }, renderChartItemContent(rendererProps, rendererState));
};
$0bdf41337f165301$var$ChartItem.displayName = 'ChartItem';
$0bdf41337f165301$var$ChartItem.whyDidYouRender = true;
var $0bdf41337f165301$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($0bdf41337f165301$var$ChartItem);

});
parcelRegister("22Yy6", function(module, exports) {

$parcel$export(module.exports, "getContainerHeight", () => $3cf25319336ca480$export$cf6292b4985d86a5);

var $1ybV0 = parcelRequire("1ybV0");

var $1sAbG = parcelRequire("1sAbG");
const $3cf25319336ca480$export$cf6292b4985d86a5 = ({ level: level, itemHeight: itemHeight, depth: depth })=>{
    const isBaseLevel = (0, $1sAbG.isBaseLevel)(level);
    let height = isBaseLevel ? "var(--ds-space-400, 32px)" : `${itemHeight}px`;
    if ((0, $1ybV0.ff)('jwm.visual-hierarchy-milestone-1')) height = depth > 0 ? "var(--ds-space-400, 32px)" : `${itemHeight}px`;
    return height;
};

});


parcelRegister("6N43q", function(module, exports) {

$parcel$export(module.exports, "default", () => $2ee99853e2a8e5c7$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $3XwA1 = parcelRequire("3XwA1");

var $22Yy6 = parcelRequire("22Yy6");
/* A non interactive version of the chart-item with lightweight styles.
 * Leveraged during virtualisation to improve scroll performance.
 */ const $2ee99853e2a8e5c7$var$ChartItemLite = ({ id: id, level: level, depth: depth, itemHeight: itemHeight, backgroundColor: backgroundColor, renderChartItemContent: renderChartItemContent })=>{
    const rendererProps = {
        id: id
    };
    const rendererState = {
        isVirtual: true,
        isHovered: false
    };
    const [{ timelineWidth: timelineWidth }] = (0, $3XwA1.useTimelineState)();
    const height = (0, $22Yy6.getContainerHeight)({
        level: level,
        itemHeight: itemHeight,
        depth: depth
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        role: "gridcell",
        tabIndex: -1,
        xcss: $2ee99853e2a8e5c7$var$chartItemLiteContainerStyles,
        style: {
            width: `${timelineWidth}px`,
            height: height,
            backgroundColor: backgroundColor
        }
    }, renderChartItemContent(rendererProps, rendererState));
};
const $2ee99853e2a8e5c7$var$chartItemLiteContainerStyles = (0, $1ZAYh.xcss)({
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    overflow: 'hidden'
});
var $2ee99853e2a8e5c7$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($2ee99853e2a8e5c7$var$ChartItemLite);

});

parcelRegister("kbPV8", function(module, exports) {

$parcel$export(module.exports, "default", () => $a4f52d3a94411029$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $PdmhA = parcelRequire("PdmhA");

var $lSR7G = parcelRequire("lSR7G");

var $fTs8H = parcelRequire("fTs8H");
const $a4f52d3a94411029$var$containerStyles = null;
/* Generates a complex background that imitates the row structure.
 * This means that when scrolling through the virtual list, a user won't see just
 * empty space even when the browser is struggling to keep up row rendering.
 *
 * WARNING: When the area (w x h) of this background gets too large, it can cause
 * awful bottlenecks in the browser rendering. For that reason, we don't use the
 * full table width, but rather a width just large enough to cover the viewport.
 */ const $a4f52d3a94411029$var$ItemsBackground = ()=>{
    const [{ itemsBackground: itemsBackground, totalHeight: totalHeight }] = (0, $lSR7G.useItemsContainerStyles)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $7JEyt.default)([
            "_kqsw1if8 _1bsbauwl _1ltvidpf _lcxvglyw",
            (0, $fTs8H.getItemsBackgroundClassName)().className
        ]),
        style: {
            background: itemsBackground || `var(--ds-background-neutral, ${0, $PdmhA.N50A})`,
            height: `${totalHeight}px`
        }
    });
};
var $a4f52d3a94411029$export$2e2bcd8739ae039 = $a4f52d3a94411029$var$ItemsBackground;

});

parcelRegister("f3dMv", function(module, exports) {

$parcel$export(module.exports, "ItemsBackground", () => $6fae78434b3aa5c8$export$2473dc1b5c75a4f);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $gf0vG = parcelRequire("gf0vG");

var $lSR7G = parcelRequire("lSR7G");
var $nH3p1 = parcelRequire("nH3p1");

var $fTs8H = parcelRequire("fTs8H");
const $6fae78434b3aa5c8$var$container = null;
const $6fae78434b3aa5c8$var$sticky = null;
/**
 * Use "100vw" as the width of the background rather than using the viewport dimension.
 * The accurate dimension does not matter here, as long as it covers the viewport.
 */ const $6fae78434b3aa5c8$var$widthApproximation = null;
/* Generates a complex background that imitates the row structure.
 * This means that when scrolling through the virtual list, a user won't see just
 * empty space even when the browser is struggling to keep up row rendering.
 *
 * WARNING: When the area (w x h) of this background gets too large, it can cause
 * awful bottlenecks in the browser rendering. For that reason, we don't use the
 * full table width, but rather a width just large enough to cover the viewport.
 */ const $6fae78434b3aa5c8$export$2473dc1b5c75a4f = ()=>{
    const [{ itemsBackground: itemsBackground, totalHeight: totalHeight }] = (0, $lSR7G.useItemsContainerStyles)();
    const [listWidth] = (0, $nH3p1.useListWidth)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        role: "presentation",
        style: {
            height: `${totalHeight}px`
        },
        className: (0, $7JEyt.default)([
            "_1e0c1txw"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $7JEyt.default)([
            "_kqsw1if8 _1ltvidpf _lcxvglyw",
            (0, $fTs8H.getItemsBackgroundClassName)().className
        ]),
        style: {
            background: itemsBackground,
            width: listWidth,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            zIndex: (0, $gf0vG.zIndex).LIST
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $7JEyt.default)([
            "_kqsw1if8 _1ltvidpf _lcxvglyw",
            "_1bsbauwl",
            (0, $fTs8H.getItemsBackgroundClassName)().className
        ]),
        style: {
            background: itemsBackground
        }
    }));
};

});

parcelRegister("htzwR", function(module, exports) {

$parcel$export(module.exports, "canItemCreateSiblingOld", () => $3568a10fcb9b3083$export$33765c6881b7ef35);
$parcel$export(module.exports, "canItemCreateSibling", () => $3568a10fcb9b3083$export$a638fd397c012b84);
$parcel$export(module.exports, "canItemCreateChildOld", () => $3568a10fcb9b3083$export$2619aca5e3e6a71e);
$parcel$export(module.exports, "canItemCreateChild", () => $3568a10fcb9b3083$export$8d944d58a048c0d4);

var $gf0vG = parcelRequire("gf0vG");

var $1sAbG = parcelRequire("1sAbG");
const $3568a10fcb9b3083$var$isItemAlreadyInCreate = (id, createItemAnchor)=>createItemAnchor && (createItemAnchor.position === (0, $gf0vG.BEFORE) || createItemAnchor.position === (0, $gf0vG.INSIDE)) && (createItemAnchor.beforeId === id || createItemAnchor.parentId === id);
const $3568a10fcb9b3083$var$canItemCreate = ({ id: id, createItemAnchor: createItemAnchor, isInTransition: isInTransition })=>!isInTransition && !$3568a10fcb9b3083$var$isItemAlreadyInCreate(id, createItemAnchor);
const $3568a10fcb9b3083$export$33765c6881b7ef35 = ({ index: index, isCreateChildEnabled: isCreateChildEnabled, isCreateSiblingEnabled: isCreateSiblingEnabled, level: level, ...createCheckParams })=>isCreateSiblingEnabled && $3568a10fcb9b3083$var$canItemCreate(createCheckParams) && (!(0, $1sAbG.isBaseLevel)(level) && index !== 0 || (0, $1sAbG.isBaseLevel)(level) && isCreateChildEnabled);
const $3568a10fcb9b3083$export$a638fd397c012b84 = ({ index: index, isCreateChildEnabled: isCreateChildEnabled, isCreateSiblingEnabled: isCreateSiblingEnabled, depth: depth, ...createCheckParams })=>isCreateSiblingEnabled && $3568a10fcb9b3083$var$canItemCreate(createCheckParams) && ((0, $1sAbG.isRoot)(depth) && index !== 0 || !(0, $1sAbG.isRoot)(depth) && isCreateChildEnabled);
const $3568a10fcb9b3083$export$2619aca5e3e6a71e = ({ isCreateChildEnabled: isCreateChildEnabled, level: level, ...createCheckParams })=>isCreateChildEnabled && !(0, $1sAbG.isBaseLevel)(level) && $3568a10fcb9b3083$var$canItemCreate(createCheckParams);
const $3568a10fcb9b3083$export$8d944d58a048c0d4 = ({ isCreateChildEnabled: isCreateChildEnabled, canCreateChildOverride: canCreateChildOverride, ...createCheckParams })=>isCreateChildEnabled && canCreateChildOverride && $3568a10fcb9b3083$var$canItemCreate(createCheckParams);

});

parcelRegister("hkIxH", function(module, exports) {

$parcel$export(module.exports, "default", () => $b7bf03b0a8ad75d1$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $PdmhA = parcelRequire("PdmhA");

var $1ybV0 = parcelRequire("1ybV0");

var $3XwA1 = parcelRequire("3XwA1");

var $1sAbG = parcelRequire("1sAbG");

var $8uT0K = parcelRequire("8uT0K");
const $b7bf03b0a8ad75d1$var$itemBaseStyles = null;
const $b7bf03b0a8ad75d1$var$containerStyles = null;
const $b7bf03b0a8ad75d1$var$chartCreateItemStyles = null;
const $b7bf03b0a8ad75d1$var$CreateItem = ({ level: level, depth: depth, anchorId: anchorId, canCreateChildOverride: canCreateChildOverride, itemHeight: itemHeight, startOffset: startOffset, ariaRowIndex: ariaRowIndex, backgroundColor: backgroundColor, isActive: isActive, onCreateClick: onCreateClick, renderListItemCreate: renderListItemCreate })=>{
    const [{ timelineWidth: timelineWidth }] = (0, $3XwA1.useTimelineState)();
    const createItemBackgroundColor = isActive && ((0, $1ybV0.ff)('jwm.visual-hierarchy-milestone-1') ? (0, $1sAbG.isRoot)(depth) : (0, $1sAbG.isParentLevel)(level)) ? `var(--ds-surface-pressed, ${0, $PdmhA.N40})` : backgroundColor;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        "data-testid": "roadmap.timeline-table.main.content.list.create-item.button",
        role: "row",
        "aria-rowindex": ariaRowIndex,
        style: {
            top: `${startOffset}px`,
            height: `${itemHeight}px`
        },
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _v564lfip",
            "_kqswstnw _1bsb1osq"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uT0K.default), {
        isActive: isActive,
        anchorId: anchorId,
        canCreateChildOverride: canCreateChildOverride,
        level: level,
        depth: depth,
        itemHeight: itemHeight,
        backgroundColor: backgroundColor,
        onCreateClick: onCreateClick,
        renderListItemCreate: renderListItemCreate
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        style: {
            width: `${timelineWidth}px`,
            height: `${itemHeight}px`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            backgroundColor: createItemBackgroundColor
        },
        className: (0, $7JEyt.default)([
            "_kqswh2mm _16jlidpf _1o9zidpf _i0dl1wug"
        ])
    }));
};
var $b7bf03b0a8ad75d1$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($b7bf03b0a8ad75d1$var$CreateItem);

});
parcelRegister("8uT0K", function(module, exports) {

$parcel$export(module.exports, "default", () => $2743d2c7621dfa9d$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $PdmhA = parcelRequire("PdmhA");

var $1ybV0 = parcelRequire("1ybV0");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $duQ8C = parcelRequire("duQ8C");

var $gf0vG = parcelRequire("gf0vG");

var $lSR7G = parcelRequire("lSR7G");
var $nH3p1 = parcelRequire("nH3p1");

var $kmplh = parcelRequire("kmplh");

var $1sAbG = parcelRequire("1sAbG");
const $2743d2c7621dfa9d$var$listCreateItemCellStyles = null;
const $2743d2c7621dfa9d$var$ListCreateItem = ({ isActive: isActive, anchorId: anchorId, level: level, depth: depth, itemHeight: itemHeight, backgroundColor: backgroundColor, onCreateClick: onCreateClick, renderListItemCreate: renderListItemCreate, canCreateChildOverride: canCreateChildOverride })=>{
    const [isListEmpty] = (0, $lSR7G.useIsTableEmpty)();
    const [listWidth] = (0, $nH3p1.useListWidth)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    // If there are no items, we want to promote users to create one.
    (0, $eUqFw.useEffect)(()=>{
        if (isListEmpty) onCreateClick({
            position: (0, $gf0vG.LAST)
        });
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    const onClick = (0, $eUqFw.useCallback)(()=>{
        (0, $duQ8C.default)('timeline-add-item-clicked');
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        });
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'issueCreateButton', {
            position: (0, $gf0vG.LAST)
        });
        onCreateClick({
            position: (0, $gf0vG.LAST)
        });
    }, [
        onCreateClick,
        createAnalyticsEvent
    ]);
    const createItemBackgroundColor = isActive && ((0, $1ybV0.ff)('jwm.visual-hierarchy-milestone-1') ? (0, $1sAbG.isRoot)(depth) : (0, $1sAbG.isParentLevel)(level)) ? `var(--ds-surface-pressed, ${0, $PdmhA.N40})` : backgroundColor;
    let paddingLeft = (0, $1sAbG.isBaseLevel)(level) ? '36px' : undefined;
    if ((0, $1ybV0.ff)('jwm.visual-hierarchy-milestone-1')) paddingLeft = !(0, $1sAbG.isRoot)(depth) ? `${(0, $kmplh.getListContentPaddingLeft)({
        depth: depth,
        isBaseLevel: false,
        // isBaseLevel isn't necessary for our calculations and can be removed as part of the 'jwm.visual-hierarchy-milestone-1' clean up
        isCreate: true,
        isParent: false
    })}px` : undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        role: "gridcell",
        tabIndex: -1,
        style: {
            width: `${listWidth}px`,
            height: `${itemHeight}px`,
            paddingLeft: paddingLeft,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            backgroundColor: createItemBackgroundColor
        },
        className: (0, $7JEyt.default)([
            "_kqsw1if8 _1e0c1txw _4cvr1h6o _16jlidpf _1o9zidpf _i0dl1wug _vchhusvi _1ltvidpf _1yt4s8vo _1pbyzo7u"
        ])
    }, renderListItemCreate({
        anchorId: anchorId,
        level: level,
        onClick: onClick,
        canCreateChildOverride: canCreateChildOverride
    }, {
        isActive: isActive
    }));
};
var $2743d2c7621dfa9d$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($2743d2c7621dfa9d$var$ListCreateItem);

});
parcelRegister("kmplh", function(module, exports) {

$parcel$export(module.exports, "getListContentPaddingLeft", () => $96940d50fa50b6d9$export$ca5712918dfd7d6b);

var $1ybV0 = parcelRequire("1ybV0");
const $96940d50fa50b6d9$var$GRID_SIZE = 8;
const $96940d50fa50b6d9$var$DEFAULT_LIST_CONTENT_PADDING = $96940d50fa50b6d9$var$GRID_SIZE * 3;
const $96940d50fa50b6d9$var$BASE_LEVEL_LIST_CONTENT_PADDING = $96940d50fa50b6d9$var$GRID_SIZE * 6;
const $96940d50fa50b6d9$var$NON_BASE_LEVEL_LIST_CONTENT_PADDING = 0;
const $96940d50fa50b6d9$var$DEFAULT_LIST_CREATE_OFFSET = -12;
const $96940d50fa50b6d9$export$ca5712918dfd7d6b = ({ isBaseLevel: isBaseLevel, isCreate: isCreate = false, depth: depth, isParent: isParent })=>{
    if ((0, $1ybV0.ff)('jwm.visual-hierarchy-milestone-1')) {
        let result = depth * $96940d50fa50b6d9$var$DEFAULT_LIST_CONTENT_PADDING;
        if (isParent) result += $96940d50fa50b6d9$var$NON_BASE_LEVEL_LIST_CONTENT_PADDING;
        else result += $96940d50fa50b6d9$var$DEFAULT_LIST_CONTENT_PADDING;
        if (isCreate) result += $96940d50fa50b6d9$var$DEFAULT_LIST_CREATE_OFFSET;
        return result;
    }
    if (isParent) return $96940d50fa50b6d9$var$NON_BASE_LEVEL_LIST_CONTENT_PADDING;
    if (isBaseLevel) return $96940d50fa50b6d9$var$BASE_LEVEL_LIST_CONTENT_PADDING;
    return $96940d50fa50b6d9$var$DEFAULT_LIST_CONTENT_PADDING;
};

});



parcelRegister("dG2Eg", function(module, exports) {

$parcel$export(module.exports, "default", () => $9e710ae2f70d253d$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $1ybV0 = parcelRequire("1ybV0");

var $gf0vG = parcelRequire("gf0vG");

var $9WNLk = parcelRequire("9WNLk");

var $lSR7G = parcelRequire("lSR7G");

var $1sAbG = parcelRequire("1sAbG");

var $8cMB7 = parcelRequire("8cMB7");
const $9e710ae2f70d253d$var$containerStyles = null;
const $9e710ae2f70d253d$var$DropTarget = ({ id: id, parentId: parentId, level: level, depth: depth, ariaRowIndex: ariaRowIndex, startOffset: startOffset, children: children, itemHeight: itemHeight, childItemsHeight: childItemsHeight, isParent: isParent, isExpanded: isExpanded, isInTransition: isInTransition, onDrop: onDrop, onExpandChanged: onExpandChanged })=>{
    const [{ isTreeDrag: isTreeDrag }] = (0, $9WNLk.useEnablements)();
    const [setDropRef, clearDropRef] = (0, $8cMB7.useListDropTarget)({
        id: id,
        level: level,
        depth: depth,
        parentId: parentId,
        isParent: isParent,
        isExpanded: isExpanded,
        isInTransition: isInTransition,
        isTreeDrag: isTreeDrag,
        onDrop: onDrop,
        onExpandChanged: onExpandChanged
    });
    const [isItemSelected] = (0, $lSR7G.useIsItemSelected)(id);
    // Effects //
    (0, $eUqFw.useEffect)(()=>()=>{
            // drop connections will be unsubscribed if NULL was passed to drop handler.
            clearDropRef();
        }, [
        clearDropRef
    ]);
    let height = (0, $1sAbG.isBaseLevel)(level) ? (0, $gf0vG.BASE_LEVEL_ITEM_HEIGHT) : itemHeight + (isExpanded ? childItemsHeight ?? 0 : 0);
    if ((0, $1ybV0.ff)('jwm.visual-hierarchy-milestone-1')) // the childItemsHeight equals to zero when the item is not expanded
    height = (depth > 0 ? (0, $gf0vG.BASE_LEVEL_ITEM_HEIGHT) : itemHeight) + (childItemsHeight ?? 0);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        role: "row",
        "aria-rowindex": ariaRowIndex,
        "aria-selected": isItemSelected,
        ref: setDropRef,
        style: {
            top: `${startOffset}px`,
            height: `${height}px`
        },
        className: (0, $7JEyt.default)([
            "_kqswstnw _1e0c1txw _1bsb1osq"
        ])
    }, children);
};
var $9e710ae2f70d253d$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($9e710ae2f70d253d$var$DropTarget);

});
parcelRegister("8cMB7", function(module, exports) {

$parcel$export(module.exports, "useListDropTarget", () => $051429adcc0ba945$export$4aeed369644ffdbb);

var $eUqFw = parcelRequire("eUqFw");

var $dLGEC = parcelRequire("dLGEC");
parcelRequire("3f2za");
var $jFl9L = parcelRequire("jFl9L");

var $eo9PV = parcelRequire("eo9PV");

var $1ybV0 = parcelRequire("1ybV0");

var $gf0vG = parcelRequire("gf0vG");

var $bwj1b = parcelRequire("bwj1b");
var $cZkk1 = parcelRequire("cZkk1");

var $kmplh = parcelRequire("kmplh");

var $1sAbG = parcelRequire("1sAbG");

var $jTR63 = parcelRequire("jTR63");
const $051429adcc0ba945$export$4aeed369644ffdbb = ({ id: id, level: level, depth: depth, parentId: parentId, isParent: isParent, isExpanded: isExpanded, isInTransition: isInTransition, isTreeDrag: isTreeDrag, onDrop: onDrop, onExpandChanged: onExpandChanged })=>{
    const directionRef = (0, $eUqFw.useRef)((0, $gf0vG.DOWN));
    const cleanupDragAndDrop = (0, $eUqFw.useRef)(null);
    const isDraggedOver = (0, $eUqFw.useRef)(false);
    const timerRef = (0, $eUqFw.useRef)(undefined);
    const instructionRef = (0, $eUqFw.useRef)(null);
    const { onResize: onResize } = (0, $cZkk1.useTimelineViewportActions)();
    const isDragChildOverParent = (0, $eUqFw.useRef)(false);
    const { onRowDragOver: onRowDragOver, onRowDragChildOverParent: onRowDragChildOverParent, onRowDragChildOverParentEnd: onRowDragChildOverParentEnd } = (0, $bwj1b.useSideEffectMarshal)();
    const makeDroppable = (0, $eUqFw.useCallback)((dragElement)=>{
        const el = dragElement;
        if (el === null) return;
        const getData = ()=>({
                id: id,
                level: level,
                isInTransition: isInTransition
            });
        const canDrop = ({ source: source })=>{
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const item = source.data;
            return item.type === (0, $gf0vG.ROW_DRAG_AND_DROP_ID) && !(0, $jTR63.getIsDragParentOverChild)(item.level, level) && isInTransition !== true;
        };
        const onDragEnter = ({ source: source })=>{
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const item = source.data;
            if (item.type === (0, $gf0vG.ROW_DRAG_AND_DROP_ID) && item.id !== id) {
                isDraggedOver.current = true;
                // expand parent
                if ((0, $jTR63.getIsDragChildOverParent)(item.level, level)) {
                    // set the drag over parent styles
                    onRowDragChildOverParent(item.id, id);
                    if (isParent && !isExpanded) {
                        // expand if it is a collapsed parent
                        timerRef.current && clearTimeout(timerRef.current);
                        timerRef.current = setTimeout(()=>{
                            onExpandChanged(id, false);
                            clearTimeout(timerRef.current);
                            timerRef.current = undefined;
                        }, (0, $gf0vG.DELAY_EXPAND_TIME));
                    }
                }
            }
        };
        const onDrag = ({ source: source, location: location })=>{
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const item = source.data;
            const { current: { input: current } } = location;
            if (isDraggedOver.current && // not dragging child over parent
            !(0, $jTR63.getIsDragChildOverParent)(item.level, level)) {
                // calculate drop position
                const { top: top, bottom: bottom } = el.getBoundingClientRect();
                const midpoint = top + (bottom - top) / 2;
                directionRef.current = current.pageY <= midpoint ? (0, $gf0vG.UP) : (0, $gf0vG.DOWN);
                const relativeTop = directionRef.current === (0, $gf0vG.DOWN) ? bottom : top;
                onRowDragOver(item.id, relativeTop);
            }
        };
        const onItemDrop = ({ source: source, location: { current: { dropTargets: dropTargets } } })=>{
            /**
				 * Check whether the drop happens over only the current target,
				 * or over a nested one.
				 * The first item in dropTargets is always the inner most dropTarget.
				 */ const isShallowDrop = dropTargets.length > 0 && dropTargets[0].data.id === id;
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const item = source.data;
            if (item.id !== id && isShallowDrop) {
                const rankRequest = directionRef.current === (0, $gf0vG.DOWN) ? {
                    rankAfterId: id
                } : {
                    rankBeforeId: id
                };
                const updateType = (0, $jTR63.getUpdateType)({
                    level: item.level,
                    parentId: item.parentId,
                    id: item.id,
                    depth: item.depth
                }, {
                    level: level,
                    parentId: parentId,
                    id: id,
                    depth: depth
                });
                switch(updateType){
                    case 0, $jTR63.UPDATE_RANK:
                        onDrop(item.id, {
                            level: item.level,
                            rankRequest: rankRequest
                        });
                        break;
                    case 0, $jTR63.UPDATE_PARENT:
                        onDrop(item.id, {
                            level: item.level,
                            parentId: id
                        });
                        break;
                    case 0, $jTR63.UPDATE_RANK_AND_PARENT:
                        onDrop(item.id, {
                            level: item.level,
                            parentId: parentId,
                            rankRequest: rankRequest
                        });
                        break;
                    default:
                        break;
                }
            }
        };
        const treeGetData = ({ source: source, input: input, element: element })=>{
            const data = {
                id: id,
                level: level,
                isInTransition: isInTransition
            };
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const draggedItem = source.data;
            const dropTarget = {
                id: id,
                parentId: parentId,
                level: level,
                depth: depth
            };
            const blockedInstructions = (0, $jTR63.getBlockedInstructions)({
                dropTarget: dropTarget,
                draggedItem: draggedItem
            });
            return (0, $dLGEC.attachInstruction)(data, {
                input: input,
                element: element,
                indentPerLevel: (0, $jTR63.INDENT_PER_LEVEL),
                currentLevel: depth || 0,
                mode: isParent && isExpanded ? 'expanded' : 'standard',
                block: blockedInstructions
            });
        };
        const treeCanDrop = ({ source: source })=>source.data.type === (0, $gf0vG.ROW_DRAG_AND_DROP_ID) && isInTransition !== true;
        const onTreeDrag = ({ source: source, self: self, location: location })=>{
            const { dropTargets: dropTargets } = location.current;
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const item = source.data;
            const dropTarget = dropTargets[0];
            if (dropTarget.data.id === id) {
                const extractedInstruction = (0, $dLGEC.extractInstruction)(self.data);
                if (extractedInstruction?.type !== 'instruction-blocked') {
                    // show indicator line only when rerank issue
                    if (extractedInstruction?.type === 'reorder-above' || extractedInstruction?.type === 'reorder-below') {
                        const { top: top, bottom: bottom } = el.getBoundingClientRect();
                        const relativeTop = extractedInstruction?.type === 'reorder-below' ? bottom : top;
                        const paddingLeft = (0, $kmplh.getListContentPaddingLeft)({
                            isBaseLevel: (0, $1sAbG.isBaseLevel)(level),
                            isParent: true,
                            depth: depth
                        });
                        onResize({
                            indicatorLineOffset: paddingLeft
                        });
                        onRowDragOver(item.id, relativeTop, paddingLeft);
                        // Clear the background when a child is dragged over a parent and transitions to the state of reordering above or below.
                        if (isDragChildOverParent.current) {
                            onRowDragChildOverParentEnd(parentId ?? id);
                            isDragChildOverParent.current = false;
                        }
                    }
                    // show indicator background
                    if (extractedInstruction?.type === 'make-child') {
                        onRowDragChildOverParent(item.id, id);
                        isDragChildOverParent.current = true;
                    }
                    instructionRef.current = extractedInstruction;
                }
            }
        };
        const onTreeDrop = ({ source: source, location: { current: { dropTargets: dropTargets } } })=>{
            const isShallowDrop = dropTargets.length > 0 && dropTargets[0].data.id === id;
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const item = source.data;
            if (instructionRef.current && item.id !== id && isShallowDrop) {
                // const isUnlinkParent = item.parentId && !parentId;
                const isReparent = item.parentId !== parentId;
                switch(instructionRef.current.type){
                    case 'make-child':
                        onDrop(item.id, {
                            level: item.level,
                            parentId: id
                        });
                        // Clear the parent's background after a child is dragged over the parent and dropped onto it
                        if (isDragChildOverParent.current) {
                            onRowDragChildOverParentEnd(id);
                            isDragChildOverParent.current = false;
                        }
                        break;
                    case 'reorder-above':
                    case 'reorder-below':
                        onDrop(item.id, {
                            level: item.level,
                            rankRequest: instructionRef.current.type === 'reorder-above' ? {
                                rankBeforeId: id
                            } : {
                                rankAfterId: id
                            },
                            ...isReparent ? {
                                parentId: parentId
                            } : {}
                        });
                        break;
                    default:
                        break;
                }
            }
            instructionRef.current = null;
        };
        const onTreeDragEnter = ({ source: source })=>{
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const item = source.data;
            if (item.type === (0, $gf0vG.ROW_DRAG_AND_DROP_ID) && item.id !== id) {
                isDraggedOver.current = true;
                // expand parent
                if ((0, $jTR63.getTreeItemIsDragChildOverParent)(item.level, level)) {
                    if (isParent && !isExpanded) {
                        // expand if it is a collapsed parent
                        timerRef.current && clearTimeout(timerRef.current);
                        timerRef.current = setTimeout(()=>{
                            onExpandChanged(id, false);
                            clearTimeout(timerRef.current);
                            timerRef.current = undefined;
                        }, (0, $gf0vG.DELAY_EXPAND_TIME));
                    }
                }
            }
        };
        const onTreeDropTargetChange = ({ location: location })=>{
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const previousDropTargetId = location.previous?.dropTargets[0]?.data.id;
            if (isDragChildOverParent.current && previousDropTargetId) {
                onRowDragChildOverParentEnd(previousDropTargetId);
                isDragChildOverParent.current = false;
            }
        };
        cleanupDragAndDrop.current = (0, $jFl9L.combine)((0, $eo9PV.dropTargetForElements)({
            element: el,
            getData: (0, $1ybV0.ff)('jwm.visual-hierarchy-dnd') && isTreeDrag ? treeGetData : getData,
            canDrop: (0, $1ybV0.ff)('jwm.visual-hierarchy-dnd') && isTreeDrag ? treeCanDrop : canDrop,
            onDragEnter: (0, $1ybV0.ff)('jwm.visual-hierarchy-dnd') && isTreeDrag ? onTreeDragEnter : onDragEnter,
            onDrag: (0, $1ybV0.ff)('jwm.visual-hierarchy-dnd') && isTreeDrag ? onTreeDrag : onDrag,
            onDrop: (0, $1ybV0.ff)('jwm.visual-hierarchy-dnd') && isTreeDrag ? onTreeDrop : onItemDrop,
            onDragLeave: ()=>{
                if (isDraggedOver.current || timerRef.current) {
                    isDraggedOver.current = false;
                    clearTimeout(timerRef.current);
                    timerRef.current = undefined;
                }
            },
            ...(0, $1ybV0.ff)('jwm.visual-hierarchy-dnd') && isTreeDrag ? {
                onDropTargetChange: onTreeDropTargetChange
            } : {}
        }));
    }, [
        isTreeDrag,
        id,
        level,
        isInTransition,
        onRowDragChildOverParent,
        isParent,
        isExpanded,
        onExpandChanged,
        onRowDragOver,
        parentId,
        depth,
        onDrop,
        onResize,
        onRowDragChildOverParentEnd
    ]);
    const cleanupDroppable = (0, $eUqFw.useCallback)(()=>{
        cleanupDragAndDrop.current?.();
    }, []);
    return [
        makeDroppable,
        cleanupDroppable
    ];
};

});
parcelRegister("dLGEC", function(module, exports) {

$parcel$export(module.exports, "attachInstruction", () => $f50fe4e2820f93ae$export$267ad49d812c2c7f);
$parcel$export(module.exports, "extractInstruction", () => $f50fe4e2820f93ae$export$c8ffecbe249dc8f8);
// using a symbol so we can guarantee a key with a unique value
const $f50fe4e2820f93ae$var$uniqueKey = Symbol('tree-item-instruction');
function $f50fe4e2820f93ae$var$getCenter(rect) {
    return {
        x: (rect.right + rect.left) / 2,
        y: (rect.bottom + rect.top) / 2
    };
}
function $f50fe4e2820f93ae$var$standardHitbox({ client: client, borderBox: borderBox }) {
    const quarterOfHeight = borderBox.height / 4;
    // In the top 1/4: reorder-above
    // On the line = in the top 1/4 to give this zone a bit more space
    if (client.y <= borderBox.top + quarterOfHeight) return 'reorder-above';
    // In the bottom 1/4: reorder-below
    // On the line = in the bottom 1/4 to give this zone a bit more space
    if (client.y >= borderBox.bottom - quarterOfHeight) return 'reorder-below';
    return 'make-child';
}
function $f50fe4e2820f93ae$var$getInstruction({ element: element, input: input, currentLevel: currentLevel, indentPerLevel: indentPerLevel, mode: mode }) {
    const client = {
        x: input.clientX,
        y: input.clientY
    };
    const borderBox = element.getBoundingClientRect();
    if (mode === 'standard') {
        const type = $f50fe4e2820f93ae$var$standardHitbox({
            borderBox: borderBox,
            client: client
        });
        return {
            type: type,
            indentPerLevel: indentPerLevel,
            currentLevel: currentLevel
        };
    }
    const center = $f50fe4e2820f93ae$var$getCenter(borderBox);
    if (mode === 'expanded') {
        // leveraging "standard" hitbox to ensure that the 'reorder-above' hit zone is
        // exactly the same for "standard" and "expanded" items
        const type = $f50fe4e2820f93ae$var$standardHitbox({
            borderBox: borderBox,
            client: client
        });
        return {
            // Use the "standard" hitbox for "reorder above",
            // The rest of the item is "make-child"
            type: type === 'reorder-above' ? type : 'make-child',
            indentPerLevel: indentPerLevel,
            currentLevel: currentLevel
        };
    }
    // `mode` is "last-in-group"
    const visibleInset = indentPerLevel * currentLevel;
    // Before the left edge of the visible item
    if (client.x < borderBox.left + visibleInset) {
        // Above the center: `reorder-above`
        if (client.y < center.y) return {
            type: 'reorder-above',
            indentPerLevel: indentPerLevel,
            currentLevel: currentLevel
        };
        // On or below the center: `reparent`
        // On the center = `reparent` as we are giving a slightly bigger hitbox to this
        // action as it is the only place a user can do it
        const rawLevel = (client.x - borderBox.left) / indentPerLevel;
        // We can get sub pixel negative numbers as getBoundingClientRect gives sub-pixel accuracy,
        // where as clientX is rounded to the nearest pixel.
        // Using Math.max() ensures we can never get a negative level
        const desiredLevel = Math.max(Math.floor(rawLevel), 0);
        return {
            type: 'reparent',
            desiredLevel: desiredLevel,
            indentPerLevel: indentPerLevel,
            currentLevel: currentLevel
        };
    }
    // On the visible item
    return {
        type: $f50fe4e2820f93ae$var$standardHitbox({
            borderBox: borderBox,
            client: client
        }),
        indentPerLevel: indentPerLevel,
        currentLevel: currentLevel
    };
}
function $f50fe4e2820f93ae$var$isShallowEqual(a, b) {
    const aKeys = Object.keys(a).sort();
    const bKeys = Object.keys(b).sort();
    if (aKeys.length !== bKeys.length) return false;
    return aKeys.every((key)=>a[key] === b[key]);
}
function $f50fe4e2820f93ae$var$areInstructionsEqual(a, b) {
    // Shortcut
    if (a.type !== b.type) return false;
    if (a.type === 'instruction-blocked' && b.type === 'instruction-blocked') return $f50fe4e2820f93ae$var$areInstructionsEqual(a.desired, b.desired);
    return $f50fe4e2820f93ae$var$isShallowEqual(a, b);
}
// Note: not using `memoize-one` as all we need is a cached value.
// We do not need to avoid executing an expensive function.
const $f50fe4e2820f93ae$var$memoizeInstruction = (()=>{
    let last = null;
    return (instruction)=>{
        if (last && $f50fe4e2820f93ae$var$areInstructionsEqual(last, instruction)) return last;
        last = instruction;
        return instruction;
    };
})();
function $f50fe4e2820f93ae$var$applyInstructionBlock({ desired: desired, block: block }) {
    if (block?.includes(desired.type) && desired.type !== 'instruction-blocked') {
        const blocked = {
            type: 'instruction-blocked',
            desired: desired
        };
        return blocked;
    }
    return desired;
}
function $f50fe4e2820f93ae$export$267ad49d812c2c7f(userData, { block: block, ...rest }) {
    const desired = $f50fe4e2820f93ae$var$getInstruction(rest);
    const withBlock = $f50fe4e2820f93ae$var$applyInstructionBlock({
        desired: desired,
        block: block
    });
    const memoized = $f50fe4e2820f93ae$var$memoizeInstruction(withBlock);
    return {
        ...userData,
        [$f50fe4e2820f93ae$var$uniqueKey]: memoized
    };
}
function $f50fe4e2820f93ae$export$c8ffecbe249dc8f8(userData) {
    return userData[$f50fe4e2820f93ae$var$uniqueKey] ?? null;
}

});

parcelRegister("3f2za", function(module, exports) {

$parcel$export(module.exports, "combine", () => (parcelRequire("jFl9L")).combine);

var $jFl9L = parcelRequire("jFl9L");

});

parcelRegister("jTR63", function(module, exports) {

$parcel$export(module.exports, "UPDATE_RANK", () => $3f3ccce096253b63$export$576ea426c903d7e1);
$parcel$export(module.exports, "UPDATE_PARENT", () => $3f3ccce096253b63$export$44bc1fe1c2a61c81);
$parcel$export(module.exports, "UPDATE_RANK_AND_PARENT", () => $3f3ccce096253b63$export$14628ae53fe631c7);
$parcel$export(module.exports, "INDENT_PER_LEVEL", () => $3f3ccce096253b63$export$130b26c73bb9d040);
$parcel$export(module.exports, "getUpdateType", () => $3f3ccce096253b63$export$df2aa842dc5172b0);
$parcel$export(module.exports, "getIsDragChildOverParent", () => $3f3ccce096253b63$export$64e82cf96e63ddf2);
$parcel$export(module.exports, "getIsDragParentOverChild", () => $3f3ccce096253b63$export$fa3830d8bd814624);
$parcel$export(module.exports, "getTreeItemIsDragChildOverParent", () => $3f3ccce096253b63$export$466f5fb38504576b);
$parcel$export(module.exports, "getBlockedInstructions", () => $3f3ccce096253b63$export$44539271c2e3abc8);

var $1sAbG = parcelRequire("1sAbG");
const $3f3ccce096253b63$export$576ea426c903d7e1 = 'UPDATE_RANK';
const $3f3ccce096253b63$export$44bc1fe1c2a61c81 = 'UPDATE_PARENT';
const $3f3ccce096253b63$export$14628ae53fe631c7 = 'UPDATE_RANK_AND_PARENT';
const $3f3ccce096253b63$export$5b388ccfa29be01 = -1;
const $3f3ccce096253b63$export$130b26c73bb9d040 = 25;
const $3f3ccce096253b63$export$df2aa842dc5172b0 = (draggedItem, dropTarget)=>{
    if (draggedItem.level === dropTarget.level) {
        if ((0, $1sAbG.isBaseLevel)(draggedItem.level) && dropTarget.parentId !== draggedItem.parentId) // Update parent and rank if drop child to another expanded epic
        return $3f3ccce096253b63$export$14628ae53fe631c7;
        // Update rank if drop issue in the same level
        return $3f3ccce096253b63$export$576ea426c903d7e1;
    }
    if ((0, $1sAbG.isBaseLevel)(draggedItem.level) && !(0, $1sAbG.isBaseLevel)(dropTarget.level) && dropTarget.id !== draggedItem.parentId) // Update parentId when drop child issue to epic directly
    return $3f3ccce096253b63$export$44bc1fe1c2a61c81;
    return undefined;
};
const $3f3ccce096253b63$export$64e82cf96e63ddf2 = (itemLevel, overItemLevel)=>(0, $1sAbG.isBaseLevel)(itemLevel) && !(0, $1sAbG.isBaseLevel)(overItemLevel);
const $3f3ccce096253b63$export$fa3830d8bd814624 = (itemLevel, overItemLevel)=>!(0, $1sAbG.isBaseLevel)(itemLevel) && (0, $1sAbG.isBaseLevel)(overItemLevel);
const $3f3ccce096253b63$export$466f5fb38504576b = (draggedItemLevel, dropTargetLevel)=>dropTargetLevel - draggedItemLevel === 1;
const $3f3ccce096253b63$export$244c1f40d1decdb6 = (draggedItemLevel, dropTargetLevel)=>dropTargetLevel - draggedItemLevel === 0 || dropTargetLevel - draggedItemLevel === 1;
const $3f3ccce096253b63$export$98df7fcf26a10604 = (draggedItemLevel, dropTargetLevel)=>dropTargetLevel === draggedItemLevel;
const $3f3ccce096253b63$export$df097d1d7a83adbb = (draggedItemLevel, dropTargetLevel)=>dropTargetLevel - draggedItemLevel === 1;
const $3f3ccce096253b63$export$44539271c2e3abc8 = ({ dropTarget: dropTarget, draggedItem: draggedItem })=>{
    const { level: dropTargetLevel, parentId: dropTargetParentId } = dropTarget;
    const { level: draggedItemLevel } = draggedItem;
    const isOnSameLevel = $3f3ccce096253b63$export$98df7fcf26a10604(draggedItemLevel, dropTargetLevel);
    const isWithinOneLevel = $3f3ccce096253b63$export$244c1f40d1decdb6(draggedItemLevel, dropTargetLevel);
    const isOneLevelBelow = $3f3ccce096253b63$export$df097d1d7a83adbb(draggedItemLevel, dropTargetLevel);
    const isSubTask = draggedItemLevel === $3f3ccce096253b63$export$5b388ccfa29be01;
    // Should not reparent when drop on same level
    if (isOnSameLevel) return [
        'make-child'
    ];
    // When dropTargetLevel -  draggedItemLevel > 1 or dropTargetLevel < draggedItemLevel
    if (!isWithinOneLevel) {
        if (dropTargetParentId || isSubTask) // Should block all instructions when dropTarget has parent
        return [
            'make-child',
            'reorder-below',
            'reorder-above'
        ];
        // Should allow re-rank when dropTarget is root level
        return [
            'make-child'
        ];
    }
    // When drag item to one level below
    if (isOneLevelBelow) {
        if (isSubTask) // Should allow reparent when drop one level below
        return [
            'reorder-below',
            'reorder-above'
        ];
        if (dropTargetParentId) // Should allow re-parent when dropTarget has parent
        return [
            'reorder-below',
            'reorder-above'
        ];
    }
    return [];
};

});



parcelRegister("l4yFR", function(module, exports) {

$parcel$export(module.exports, "default", () => $d21706d0a7e65258$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $eUqFw = parcelRequire("eUqFw");

var $lSR7G = parcelRequire("lSR7G");
var $nH3p1 = parcelRequire("nH3p1");
var $3XwA1 = parcelRequire("3XwA1");

var $dWSuJ = parcelRequire("dWSuJ");
const $d21706d0a7e65258$var$listEmptyContentStyles = null;
const $d21706d0a7e65258$var$bottomBorderContainerStyles = null;
const $d21706d0a7e65258$var$listBottomBorderStyles = null;
const $d21706d0a7e65258$var$chartBottomBorderStyles = null;
const $d21706d0a7e65258$var$Footer = ({ renderListEmptyContent: renderListEmptyContent })=>{
    const [isTableEmpty] = (0, $lSR7G.useIsTableEmpty)();
    const [{ timelineWidth: timelineWidth }] = (0, $3XwA1.useTimelineState)();
    const [listWidth] = (0, $nH3p1.useListWidth)();
    return isTableEmpty ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        style: {
            width: `${listWidth}px`
        },
        className: (0, $7JEyt.default)([
            "_kqsw1if8 _1ltvidpf _1pby1406"
        ])
    }, renderListEmptyContent()) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: (0, $7JEyt.default)([
            "_kqswh2mm _1e0c1txw _1bsb1osq _4t3it94y"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: (0, $7JEyt.default)([
            "_kqsw1if8 _16jlidpf _1o9zidpf _i0dl1wug _1ltvidpf _4t3it94y _bfhk14l7 _1pby1406"
        ]),
        style: {
            width: `${listWidth}px`,
            "--_drom5x": (0, $9t7rW.default)((0, $dWSuJ.secondaryBorderColor))
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: (0, $7JEyt.default)([
            "_kqswh2mm _16jlidpf _1o9zidpf _i0dl1wug _4t3it94y _bfhk14l7"
        ]),
        style: {
            width: `${timelineWidth}px`,
            "--_drom5x": (0, $9t7rW.default)((0, $dWSuJ.secondaryBorderColor))
        }
    }));
};
var $d21706d0a7e65258$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($d21706d0a7e65258$var$Footer);

});

parcelRegister("a3v1C", function(module, exports) {

$parcel$export(module.exports, "default", () => $bf19009c34dbb8d6$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $4Bees = parcelRequire("4Bees");

var $1ybV0 = parcelRequire("1ybV0");

var $eI5EY = parcelRequire("eI5EY");

var $5JgJ2 = parcelRequire("5JgJ2");

var $duQ8C = parcelRequire("duQ8C");

var $gf0vG = parcelRequire("gf0vG");

var $nH3p1 = parcelRequire("nH3p1");
var $bwj1b = parcelRequire("bwj1b");

var $fTs8H = parcelRequire("fTs8H");

var $kmplh = parcelRequire("kmplh");

var $lqJW5 = parcelRequire("lqJW5");

var $1sAbG = parcelRequire("1sAbG");

var $3UUug = parcelRequire("3UUug");

var $4nEH9 = parcelRequire("4nEH9");

var $hQQ6H = parcelRequire("hQQ6H");

var $bt6fG = parcelRequire("bt6fG");

var $cLle4 = parcelRequire("cLle4");

var $9OCIr = parcelRequire("9OCIr");
const $bf19009c34dbb8d6$var$secondaryContentStyles = null;
const $bf19009c34dbb8d6$var$listItemContainerStyles = null;
const $bf19009c34dbb8d6$var$getCursor = (isInTransition, isSelectEnabled)=>{
    if (isInTransition) return 'not-allowed';
    if (isSelectEnabled) return 'pointer';
    return 'default';
};
const $bf19009c34dbb8d6$var$ListItem = ({ id: id, parentId: parentId, level: level, depth: depth, itemHeight: itemHeight, backgroundColor: backgroundColor, ariaControls: ariaControls, isParent: isParent, isExpanded: isExpanded, isDragEnabled: isDragEnabled, isInTransition: isInTransition, isSelectEnabled: isSelectEnabled, isCreateChildEnabled: isCreateChildEnabled, isCreateSiblingEnabled: isCreateSiblingEnabled, onSelect: onSelect, onExpandChanged: onExpandChanged, onInlineCreateClicked: onInlineCreateClicked, renderListItemContent: renderListItemContent, renderListItemSecondaryContent: renderListItemSecondaryContent })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const sideEffectMarshal = (0, $bwj1b.useSideEffectMarshal)();
    const [listWidth] = (0, $nH3p1.useListWidth)();
    const [isHoveredOrFocused, setIsHoveredOrFocused] = (0, $eUqFw.useState)(false);
    const isContainerInFocus = (0, $eUqFw.useRef)(false);
    const element = (0, $eUqFw.useRef)(null);
    const { onRowMouseEnter: onRowMouseEnter, onRowMouseLeave: onRowMouseLeave } = sideEffectMarshal;
    const isBaseLevel = (0, $1sAbG.isBaseLevel)(level);
    const canDrag = isDragEnabled && !isInTransition;
    const [makeDraggable, cleanupDraggable] = (0, $cLle4.default)({
        id: id,
        level: level,
        depth: depth,
        parentId: parentId,
        canDrag: canDrag,
        sideEffectMarshal: sideEffectMarshal
    }); // Effects //
    (0, $eUqFw.useEffect)(()=>{
        makeDraggable(element.current);
        return ()=>{
            // drag connections will be unsubscribed if NULL was passed to drag handler.
            cleanupDraggable();
        };
    }, [
        makeDraggable,
        cleanupDraggable
    ]); // Callbacks //
    const onHoverOrFocus = (0, $eUqFw.useCallback)(()=>{
        onRowMouseEnter(id);
        setIsHoveredOrFocused(true);
    }, [
        id,
        onRowMouseEnter
    ]);
    const onStopHoverOrFocus = (0, $eUqFw.useCallback)(()=>{
        onRowMouseLeave(id);
        setIsHoveredOrFocused(false);
    }, [
        id,
        onRowMouseLeave
    ]);
    const onContainerBlur = (0, $eUqFw.useCallback)(({ relatedTarget: relatedTarget })=>{
        if ((0, $1ybV0.ff)('jwm.visual-hierarchy-milestone-1')) {
            if (!element.current?.contains(relatedTarget) && !isContainerInFocus.current) onStopHoverOrFocus();
            isContainerInFocus.current = false;
        } else if (element.current && relatedTarget instanceof Node && !element.current.contains(relatedTarget)) onStopHoverOrFocus();
    }, [
        onStopHoverOrFocus
    ]);
    const onContainerClick = (0, $eUqFw.useCallback)((event)=>{
        const { timeStamp: timeStamp, metaKey: metaKey, ctrlKey: ctrlKey, shiftKey: shiftKey } = event;
        (0, $duQ8C.default)('timeline-item-clicked', timeStamp);
        const withCmd = ctrlKey || metaKey;
        const withShift = shiftKey;
        onSelect(id, {
            level: level,
            withCmd: withCmd,
            withShift: withShift,
            ...(0, $1ybV0.ff)('jwm.visual-hierarchy-milestone-1') && {
                depth: depth
            }
        });
    }, [
        id,
        level,
        depth,
        onSelect
    ]);
    const onContainerMouseDown = (0, $eUqFw.useCallback)(()=>{
        isContainerInFocus.current = true;
    }, []);
    const onContainerKeyDown = (0, $eUqFw.useCallback)((event)=>{
        if ((0, $lqJW5.isEnterOrSpaceKey)(event) && !(0, $lqJW5.isBubbledEvent)(event)) {
            // Stops default behaviour of scrolling the parent container
            event.preventDefault();
            onContainerClick(event);
        }
    }, [
        onContainerClick
    ]);
    const setItemRef = (ref)=>{
        element.current = ref;
    }; // Render //
    const rendererProps = {
        id: id
    };
    const rendererState = {
        isVirtual: false,
        isHoveredOrFocused: isHoveredOrFocused
    };
    const renderSecondaryContent = ()=>{
        let innerElement;
        if (isInTransition) innerElement = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), {
            size: "small",
            testId: `roadmap.timeline-table.components.list-item.spinner.${id}`
        });
        else if (isHoveredOrFocused && isCreateChildEnabled && (!isBaseLevel || (0, $1ybV0.ff)('jwm.visual-hierarchy-milestone-1'))) innerElement = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3UUug.default), {
            parentId: id,
            label: formatMessage((0, $bt6fG.default).createChild),
            onInlineCreateClicked: onInlineCreateClicked
        });
         // Consumer secondary content should only be visible when internal secondary content is not
        if (innerElement) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: (0, $7JEyt.default)([
                "_1e0c116y _4cvr1h6o _18u01b66"
            ])
        }, innerElement);
        return renderListItemSecondaryContent(rendererProps, rendererState);
    };
    let height = isBaseLevel ? (0, $gf0vG.BASE_LEVEL_ITEM_HEIGHT) : itemHeight;
    if ((0, $1ybV0.ff)('jwm.visual-hierarchy-milestone-1')) height = depth > 0 ? (0, $gf0vG.BASE_LEVEL_ITEM_HEIGHT) : itemHeight;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        ...(0, $eI5EY.fg)('jsw_roadmaps_timeline_table_hierarchy_a11y') && {
            id: id
        },
        "data-testid": `roadmap.timeline-table.components.list-item.container-${id}`,
        role: "gridcell",
        tabIndex: -1,
        ref: setItemRef,
        className: (0, $7JEyt.default)([
            "_kqsw1if8 _1ltvidpf _1e0c1txw _4cvr1h6o _vchhusvi _u5f3u2gc _1pby1406 _v564lfip _nt751r31 _49pcglyw _1hvw1o36 _1ejj168b",
            (0, $fTs8H.getRowClassName)(id, parentId).className
        ]),
        style: {
            width: `${listWidth}px`,
            height: `${height}px`,
            backgroundColor: backgroundColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingLeft: `${(0, $kmplh.getListContentPaddingLeft)({
                isBaseLevel: isBaseLevel,
                isParent: isParent,
                depth: depth
            })}px`,
            cursor: $bf19009c34dbb8d6$var$getCursor(isInTransition, isSelectEnabled)
        },
        onClick: isSelectEnabled && !isInTransition ? onContainerClick : undefined,
        onKeyDown: isSelectEnabled && !isInTransition ? onContainerKeyDown : undefined,
        onMouseEnter: onHoverOrFocus,
        onMouseLeave: onStopHoverOrFocus,
        onMouseDown: onContainerMouseDown,
        onFocus: onHoverOrFocus,
        onBlur: onContainerBlur
    }, isCreateSiblingEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4nEH9.default), {
        id: id,
        level: level,
        depth: depth,
        parentId: parentId,
        label: formatMessage((0, $bt6fG.default).createSibling),
        onInlineCreateClicked: onInlineCreateClicked
    }), isParent && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hQQ6H.default), {
        id: id,
        label: isExpanded ? formatMessage((0, $bt6fG.default).collapse) : formatMessage((0, $bt6fG.default).expand),
        isExpanded: isExpanded,
        isRichContentEnabled: isHoveredOrFocused,
        onExpandChanged: onExpandChanged,
        ariaControls: ariaControls
    }), renderListItemContent(rendererProps, rendererState), renderSecondaryContent());
};
$bf19009c34dbb8d6$var$ListItem.defaultProps = {
    isInTransition: false
};
$bf19009c34dbb8d6$var$ListItem.displayName = 'ListItem';
$bf19009c34dbb8d6$var$ListItem.whyDidYouRender = true;
var $bf19009c34dbb8d6$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($bf19009c34dbb8d6$var$ListItem);

});
parcelRegister("lqJW5", function(module, exports) {

$parcel$export(module.exports, "isEnterOrSpaceKey", () => $1bb1d72f44e9530b$export$f6deda1cc2672a2e);
$parcel$export(module.exports, "isBubbledEvent", () => $1bb1d72f44e9530b$export$6cc56ae238ebd443);
const $1bb1d72f44e9530b$export$f6deda1cc2672a2e = (event)=>event.keyCode === 13 || event.keyCode === 32;
const $1bb1d72f44e9530b$export$a6587fe901c3baf7 = (event)=>event.key === 'Escape' || event.key === 'Esc' || event.keyCode === 27;
const $1bb1d72f44e9530b$export$6cc56ae238ebd443 = (event)=>event.currentTarget !== event.target;
const $1bb1d72f44e9530b$export$9c580eee50acd9e2 = (e)=>{
    const event = e || window.event;
    if ('buttons' in event) return event.buttons === 1;
    if (event) {
        const { button: button } = event;
        return button === 1;
    }
    return false;
};

});

parcelRegister("3UUug", function(module, exports) {

$parcel$export(module.exports, "default", () => $e1f7e6411b398368$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $bkIGg = parcelRequire("bkIGg");

var $8cU5f = parcelRequire("8cU5f");

var $eI5EY = parcelRequire("eI5EY");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $duQ8C = parcelRequire("duQ8C");

var $gf0vG = parcelRequire("gf0vG");

var $fTs8H = parcelRequire("fTs8H");
const $e1f7e6411b398368$var$buttonStyles = null;
const $e1f7e6411b398368$var$CreateChildButton = ({ parentId: parentId, label: label, onInlineCreateClicked: onInlineCreateClicked })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const onClick = (0, $eUqFw.useCallback)((event)=>{
        // Do not consider clicking this as also clicking on the list item itself
        event.stopPropagation();
        (0, $duQ8C.default)('timeline-add-item-clicked', event.timeStamp);
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        });
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'childIssueCreateButton', {
            position: (0, $gf0vG.INSIDE)
        });
        onInlineCreateClicked({
            parentId: parentId,
            position: (0, $gf0vG.INSIDE)
        });
    }, [
        createAnalyticsEvent,
        parentId,
        onInlineCreateClicked
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: label
    }, (0, $eI5EY.fg)('jsw_roadmaps_timeline-issue-creation-ally') ? (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("button", {
            ...tooltipProps,
            "data-testid": `roadmap.timeline-table.components.list-item.create-child-button.container-${parentId}`,
            "aria-label": label,
            onClick: onClick,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, $7JEyt.default)([
                "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _19itglyw _80omtlke _1bsb1ejb _4t3i1ejb _2rko1sit _s7n4jp4b _bfhklecj _syazjjyb _12ji1r31 _1qu2glyw _12y31o36 _nt751r31 _49pcglyw _1hvw1o36 _1ejj168b _jomrfj8p _irr3fj8p _1di61elt _9h8h85f4",
                (0, $fTs8H.getCreateChildButtonClassName)().className
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bkIGg))), {
            label: "",
            size: "medium"
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("button", {
        "data-testid": `roadmap.timeline-table.components.list-item.create-child-button.container-${parentId}`,
        "aria-label": label,
        onClick: onClick,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $7JEyt.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _19itglyw _80omtlke _1bsb1ejb _4t3i1ejb _2rko1sit _s7n4jp4b _bfhklecj _syazjjyb _12ji1r31 _1qu2glyw _12y31o36 _nt751r31 _49pcglyw _1hvw1o36 _1ejj168b _jomrfj8p _irr3fj8p _1di61elt _9h8h85f4",
            (0, $fTs8H.getCreateChildButtonClassName)().className
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bkIGg))), {
        label: "",
        size: "medium"
    })));
};
var $e1f7e6411b398368$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($e1f7e6411b398368$var$CreateChildButton);

});

parcelRegister("4nEH9", function(module, exports) {

$parcel$export(module.exports, "default", () => $cfebf2624394b8c9$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $jaTu3 = parcelRequire("jaTu3");

var $8cU5f = parcelRequire("8cU5f");

var $1ybV0 = parcelRequire("1ybV0");

var $eI5EY = parcelRequire("eI5EY");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $duQ8C = parcelRequire("duQ8C");

var $gf0vG = parcelRequire("gf0vG");

var $bwj1b = parcelRequire("bwj1b");
const $cfebf2624394b8c9$var$buttonStyles = null;
const $cfebf2624394b8c9$var$buttonStylesOld = null;
// move zIndex inside buttonStyles when cleaning up jwm.visual-hierarchy-dnd
const $cfebf2624394b8c9$var$zIndexStyleOld = null;
const $cfebf2624394b8c9$var$zIndexStyle = null;
const $cfebf2624394b8c9$var$CreateSiblingButton = ({ id: id, level: level, depth: depth, parentId: parentId, label: label, onInlineCreateClicked: onInlineCreateClicked })=>{
    const element = (0, $eUqFw.useRef)(null);
    const { onAddButtonMouseEnter: onAddButtonMouseEnter, onAddButtonMouseLeave: onAddButtonMouseLeave } = (0, $bwj1b.useSideEffectMarshal)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const onClick = (0, $eUqFw.useCallback)((event)=>{
        // Do not consider clicking this as also clicking on the list item itself
        (0, $1ybV0.ff)('jsw.roadmaps.gridification-markup') && event.stopPropagation();
        (0, $duQ8C.default)('timeline-add-item-clicked', event.timeStamp);
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        });
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'issueCreateButton', {
            position: (0, $gf0vG.BEFORE),
            level: level,
            ...(0, $1ybV0.ff)('jwm.visual-hierarchy-milestone-1') && {
                depth: depth
            }
        });
        // Hide the button after activating the input
        onAddButtonMouseLeave();
        onInlineCreateClicked({
            beforeId: id,
            parentId: parentId,
            position: (0, $gf0vG.BEFORE)
        });
    }, [
        id,
        level,
        depth,
        parentId,
        createAnalyticsEvent,
        onAddButtonMouseLeave,
        onInlineCreateClicked
    ]);
    const onActiveOld = (0, $eUqFw.useCallback)(()=>{
        if (element.current) {
            const { top: top } = element.current.getBoundingClientRect();
            onAddButtonMouseEnter(top);
        }
    }, [
        onAddButtonMouseEnter
    ]);
    const onActiveHandler = (0, $eUqFw.useCallback)((tabFocused)=>{
        if (element.current) {
            const { top: top } = element.current.getBoundingClientRect();
            onAddButtonMouseEnter(top, tabFocused);
        }
    }, [
        onAddButtonMouseEnter
    ]);
    const onActive = (0, $eUqFw.useCallback)(()=>{
        onActiveHandler(false);
    }, [
        onActiveHandler
    ]);
    const onActiveFocus = (0, $eUqFw.useCallback)(()=>{
        onActiveHandler(true);
    }, [
        onActiveHandler
    ]);
    const onInactive = (0, $eUqFw.useCallback)(()=>{
        onAddButtonMouseLeave();
    }, [
        onAddButtonMouseLeave
    ]);
    const createOnFocus = (tooltipCallback)=>(e)=>{
            onActiveFocus();
            tooltipCallback(e);
        };
    const createOnBlur = (tooltipCallback)=>(e)=>{
            onInactive();
            tooltipCallback(e);
        };
    return (0, $eI5EY.fg)('jsw_roadmaps_timeline-issue-creation-ally') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: label,
        position: "left"
    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("button", {
            ...tooltipProps,
            ref: (0, $jaTu3.mergeRefs)([
                tooltipProps.ref,
                element
            ]),
            "data-testid": `roadmap.timeline-table.components.list-item.create-sibling-button.container-${id}`,
            "aria-label": label,
            onMouseEnter: onActive,
            onMouseLeave: onInactive,
            onClick: onClick,
            onFocus: createOnFocus(tooltipProps.onFocus),
            onBlur: createOnBlur(tooltipProps.onBlur),
            className: (0, $7JEyt.default)([
                "_kqswstnw _154i1lpd _1ltv14id _1bsb1r7l _4t3i19bv _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _bfhk18uv _19itglyw _80omtlke _nt751r31 _49pcglyw _1hvw1o36",
                (0, $1ybV0.ff)('jwm.visual-hierarchy-dnd') ? "_1pbyibnn" : "_1pbyzo7u"
            ])
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("button", {
        ref: element,
        "data-testid": `roadmap.timeline-table.components.list-item.create-sibling-button.container-${id}`,
        "aria-label": label,
        onClick: onClick,
        onMouseEnter: onActiveOld,
        onMouseLeave: onInactive,
        onFocus: onActiveOld,
        onBlur: onInactive,
        className: (0, $7JEyt.default)([
            "_kqswstnw _154i196n _1ltvx0bf _1bsb1r7l _4t3iutpp _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _bfhk18uv _19itglyw _12ji1r31 _1qu2glyw _12y31o36 _80omtlke _nt751r31 _49pcglyw _1hvw1o36",
            (0, $1ybV0.ff)('jwm.visual-hierarchy-dnd') ? "_1pbyibnn" : "_1pbyzo7u"
        ])
    });
};
var $cfebf2624394b8c9$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($cfebf2624394b8c9$var$CreateSiblingButton);

});
parcelRegister("jaTu3", function(module, exports) {

$parcel$export(module.exports, "mergeRefs", () => $df59fd64c73fe87e$export$c9058316764c140e);

var $iYh9J = parcelRequire("iYh9J");

var $37WxO = parcelRequire("37WxO");
function $df59fd64c73fe87e$export$c9058316764c140e(refs) {
    return (0, $37WxO.createCallbackRef)((newValue)=>refs.forEach((ref)=>(0, $iYh9J.assignRef)(ref, newValue)));
}

});
parcelRegister("37WxO", function(module, exports) {

$parcel$export(module.exports, "createCallbackRef", () => $246f7040b169dc51$export$35a19128eb4acba4);
/**
 * creates a Ref object with on change callback
 * @param callback
 * @returns {RefObject}
 *
 * @see {@link useCallbackRef}
 * @see https://reactjs.org/docs/refs-and-the-dom.html#creating-refs
 */ function $246f7040b169dc51$export$35a19128eb4acba4(callback) {
    let current = null;
    return {
        get current () {
            return current;
        },
        set current (value){
            const last = current;
            if (last !== value) {
                current = value;
                callback(value, last);
            }
        }
    };
}

});



parcelRegister("hQQ6H", function(module, exports) {

$parcel$export(module.exports, "default", () => $a7211de5e63c01c6$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $86Ndv = parcelRequire("86Ndv");

var $dtaN9 = parcelRequire("dtaN9");

var $PdmhA = parcelRequire("PdmhA");

var $eI5EY = parcelRequire("eI5EY");

var $duQ8C = parcelRequire("duQ8C");
const $a7211de5e63c01c6$var$buttonStyles = null;
const $a7211de5e63c01c6$var$ExpandButton = ({ id: id, label: label, isRichContentEnabled: isRichContentEnabled, isExpanded: isExpanded, ariaControls: ariaControls, onExpandChanged: onExpandChanged })=>{
    const onClick = (0, $eUqFw.useCallback)((event)=>{
        // Do not consider clicking this as also clicking on the list item itself
        event.stopPropagation();
        (0, $duQ8C.default)('timeline-expand-changed', event.timeStamp);
        onExpandChanged(id, isExpanded);
    }, [
        id,
        isExpanded,
        onExpandChanged
    ]);
    const Chevron = isExpanded ? (0, (/*@__PURE__*/$parcel$interopDefault($86Ndv))) : (0, (/*@__PURE__*/$parcel$interopDefault($dtaN9)));
    const chevronElement = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Chevron, {
        testId: `roadmap.timeline-table.components.list-item.expand-button.container-${id}`,
        primaryColor: `var(--ds-icon, ${(0, $PdmhA.N500)})`,
        label: label
    });
    // Performance optimisation - only render interactive button upon proxy interactions
    if (!isRichContentEnabled) return chevronElement;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("button", {
        onClick: onClick,
        "aria-expanded": isExpanded,
        ...(0, $eI5EY.fg)('jsw_roadmaps_timeline_table_hierarchy_a11y') && {
            'aria-label': label
        },
        ...isExpanded && ariaControls && (0, $eI5EY.fg)('jsw_roadmaps_timeline_table_hierarchy_a11y') && {
            'aria-controls': ariaControls
        },
        className: (0, $7JEyt.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _19itglyw _bfhk18uv _80omtlke _1e0c1txw _16jlidpf _1o9zidpf _i0dl1wug _12ji1r31 _1qu2glyw _12y31o36 _nt751r31 _49pcglyw _1hvw1o36 _1ejj168b"
        ])
    }, chevronElement);
};
var $a7211de5e63c01c6$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($a7211de5e63c01c6$var$ExpandButton);

});

parcelRegister("bt6fG", function(module, exports) {

$parcel$export(module.exports, "default", () => $c86f8e9d8cd16bb3$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $c86f8e9d8cd16bb3$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    expand: {
        "id": "roadmap.timeline-table.main.content.list.list-item.expand",
        "defaultMessage": "Show child issues"
    },
    collapse: {
        "id": "roadmap.timeline-table.main.content.list.list-item.collapse",
        "defaultMessage": "Hide child issues"
    },
    createSibling: {
        "id": "roadmap.timeline-table.main.content.list.list-item.create-sibling",
        "defaultMessage": "Create issue"
    },
    createChild: {
        "id": "roadmap.timeline-table.main.content.list.list-item.create-child",
        "defaultMessage": "Create child issue"
    },
    done: {
        "id": "roadmap.timeline-table.main.content.list.list-item.done",
        "defaultMessage": "Done"
    }
});

});

parcelRegister("cLle4", function(module, exports) {

$parcel$export(module.exports, "default", () => $91ac22c8e1e4ed5f$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
parcelRequire("3f2za");
var $jFl9L = parcelRequire("jFl9L");

var $eo9PV = parcelRequire("eo9PV");

var $gf0vG = parcelRequire("gf0vG");
const $91ac22c8e1e4ed5f$var$useListItemDrag = ({ id: id, level: level, depth: depth, parentId: parentId, canDrag: canDrag, sideEffectMarshal: sideEffectMarshal })=>{
    const cleanupDragAndDrop = (0, $eUqFw.useRef)(null);
    const { onRowGenerateDragPreview: onRowGenerateDragPreview } = sideEffectMarshal;
    const makeDraggable = (0, $eUqFw.useCallback)((dragElement)=>{
        const el = dragElement;
        if (el === null) return;
        cleanupDragAndDrop.current = (0, $jFl9L.combine)((0, $eo9PV.draggable)({
            element: el,
            canDrag: ()=>canDrag,
            getInitialData: ()=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                ({
                    type: (0, $gf0vG.ROW_DRAG_AND_DROP_ID),
                    id: id,
                    level: level,
                    depth: depth,
                    parentId: parentId
                }),
            onGenerateDragPreview: ()=>{
                onRowGenerateDragPreview();
            }
        }));
    }, [
        canDrag,
        id,
        level,
        depth,
        parentId,
        onRowGenerateDragPreview
    ]);
    const cleanupDraggable = (0, $eUqFw.useCallback)(()=>{
        cleanupDragAndDrop.current?.();
    }, []);
    return [
        makeDraggable,
        cleanupDraggable
    ];
};
var $91ac22c8e1e4ed5f$export$2e2bcd8739ae039 = $91ac22c8e1e4ed5f$var$useListItemDrag;

});

parcelRegister("9OCIr", function(module, exports) {

$parcel$export(module.exports, "default", () => $39ed6456e64aa415$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $4Bees = parcelRequire("4Bees");

var $1ybV0 = parcelRequire("1ybV0");

var $eI5EY = parcelRequire("eI5EY");

var $5JgJ2 = parcelRequire("5JgJ2");

var $duQ8C = parcelRequire("duQ8C");

var $gf0vG = parcelRequire("gf0vG");

var $nH3p1 = parcelRequire("nH3p1");
var $bwj1b = parcelRequire("bwj1b");

var $fTs8H = parcelRequire("fTs8H");

var $kmplh = parcelRequire("kmplh");

var $lqJW5 = parcelRequire("lqJW5");

var $1sAbG = parcelRequire("1sAbG");

var $3UUug = parcelRequire("3UUug");

var $4nEH9 = parcelRequire("4nEH9");

var $hQQ6H = parcelRequire("hQQ6H");

var $bt6fG = parcelRequire("bt6fG");

var $cLle4 = parcelRequire("cLle4");
const $39ed6456e64aa415$var$secondaryContentStyles = null;
const $39ed6456e64aa415$var$listItemContainerStyles = null;
const $39ed6456e64aa415$var$listItemCellStyles = null;
const $39ed6456e64aa415$var$getCursor = (isInTransition, isSelectEnabled)=>{
    if (isInTransition) return 'not-allowed';
    if (isSelectEnabled) return 'pointer';
    return 'default';
};
const $39ed6456e64aa415$var$ListItem = ({ id: id, parentId: parentId, level: level, depth: depth, itemHeight: itemHeight, backgroundColor: backgroundColor, ariaControls: ariaControls, isParent: isParent, isExpanded: isExpanded, isDragEnabled: isDragEnabled, isInTransition: isInTransition, isSelectEnabled: isSelectEnabled, isCreateChildEnabled: isCreateChildEnabled, isCreateSiblingEnabled: isCreateSiblingEnabled, onSelect: onSelect, onExpandChanged: onExpandChanged, onInlineCreateClicked: onInlineCreateClicked, renderListItemContent: renderListItemContent, renderListItemSecondaryContent: renderListItemSecondaryContent })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const sideEffectMarshal = (0, $bwj1b.useSideEffectMarshal)();
    const [listWidth] = (0, $nH3p1.useListWidth)();
    const [isHoveredOrFocused, setIsHoveredOrFocused] = (0, $eUqFw.useState)(false);
    const isContainerInFocus = (0, $eUqFw.useRef)(false);
    const element = (0, $eUqFw.useRef)(null);
    const { onRowMouseEnter: onRowMouseEnter, onRowMouseLeave: onRowMouseLeave } = sideEffectMarshal;
    const isBaseLevel = (0, $1sAbG.isBaseLevel)(level);
    const canDrag = isDragEnabled && !isInTransition;
    const [makeDraggable, cleanupDraggable] = (0, $cLle4.default)({
        id: id,
        level: level,
        depth: depth,
        parentId: parentId,
        canDrag: canDrag,
        sideEffectMarshal: sideEffectMarshal
    }); // Effects //
    (0, $eUqFw.useEffect)(()=>{
        makeDraggable(element.current);
        return ()=>{
            // drag connections will be unsubscribed if NULL was passed to drag handler.
            cleanupDraggable();
        };
    }, [
        makeDraggable,
        cleanupDraggable
    ]); // Callbacks //
    const onHoverOrFocus = (0, $eUqFw.useCallback)(()=>{
        onRowMouseEnter(id);
        setIsHoveredOrFocused(true);
    }, [
        id,
        onRowMouseEnter
    ]);
    const onStopHoverOrFocus = (0, $eUqFw.useCallback)(()=>{
        onRowMouseLeave(id);
        setIsHoveredOrFocused(false);
    }, [
        id,
        onRowMouseLeave
    ]);
    const onContainerBlur = (0, $eUqFw.useCallback)(({ relatedTarget: relatedTarget })=>{
        if ((0, $1ybV0.ff)('jwm.visual-hierarchy-milestone-1')) {
            if (!element.current?.contains(relatedTarget) && !isContainerInFocus.current) onStopHoverOrFocus();
            isContainerInFocus.current = false;
        } else if (element.current && relatedTarget instanceof Node && !element.current.contains(relatedTarget)) onStopHoverOrFocus();
    }, [
        onStopHoverOrFocus
    ]);
    const onContainerClick = (0, $eUqFw.useCallback)((event)=>{
        const { timeStamp: timeStamp, metaKey: metaKey, ctrlKey: ctrlKey, shiftKey: shiftKey } = event;
        (0, $duQ8C.default)('timeline-item-clicked', timeStamp);
        const withCmd = ctrlKey || metaKey;
        const withShift = shiftKey;
        onSelect(id, {
            level: level,
            withCmd: withCmd,
            withShift: withShift,
            ...(0, $1ybV0.ff)('jwm.visual-hierarchy-milestone-1') && {
                depth: depth
            }
        });
    }, [
        id,
        level,
        depth,
        onSelect
    ]);
    const onContainerMouseDown = (0, $eUqFw.useCallback)(()=>{
        isContainerInFocus.current = true;
    }, []);
    const onContainerKeyDown = (0, $eUqFw.useCallback)((event)=>{
        if ((0, $lqJW5.isEnterOrSpaceKey)(event) && !(0, $lqJW5.isBubbledEvent)(event)) {
            // Stops default behaviour of scrolling the parent container
            event.preventDefault();
            onContainerClick(event);
        }
    }, [
        onContainerClick
    ]);
    const setItemRef = (ref)=>{
        element.current = ref;
    }; // Render //
    const rendererProps = {
        id: id
    };
    const rendererState = {
        isVirtual: false,
        isHoveredOrFocused: isHoveredOrFocused
    };
    const renderSecondaryContent = ()=>{
        let innerElement;
        if (isInTransition) innerElement = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), {
            size: "small",
            testId: `roadmap.timeline-table.components.list-item.spinner.${id}`
        });
        else if (isHoveredOrFocused && isCreateChildEnabled && (!isBaseLevel || (0, $1ybV0.ff)('jwm.visual-hierarchy-milestone-1'))) innerElement = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3UUug.default), {
            parentId: id,
            label: formatMessage((0, $bt6fG.default).createChild),
            onInlineCreateClicked: onInlineCreateClicked
        }));
         // Consumer secondary content should only be visible when internal secondary content is not
        if (innerElement) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: (0, $7JEyt.default)([
                "_1e0c116y _4cvr1h6o _18u01b66"
            ])
        }, innerElement);
        return renderListItemSecondaryContent(rendererProps, rendererState);
    };
    let height = isBaseLevel ? (0, $gf0vG.BASE_LEVEL_ITEM_HEIGHT) : itemHeight;
    if ((0, $1ybV0.ff)('jwm.visual-hierarchy-milestone-1')) height = depth > 0 ? (0, $gf0vG.BASE_LEVEL_ITEM_HEIGHT) : itemHeight;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        role: "gridcell" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        ,
        className: (0, $7JEyt.default)([
            "_kqsw1if8 _1ltvidpf _1pby1406",
            (0, $fTs8H.getItemsBackgroundClassName)().className
        ]),
        style: {
            width: `${listWidth}px`,
            height: `${height}px`,
            backgroundColor: backgroundColor
        }
    }, isCreateSiblingEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4nEH9.default), {
        id: id,
        level: level,
        depth: depth,
        parentId: parentId,
        label: formatMessage((0, $bt6fG.default).createSibling),
        onInlineCreateClicked: onInlineCreateClicked
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        ...(0, $eI5EY.fg)('jsw_roadmaps_timeline_table_hierarchy_a11y') && {
            id: id
        },
        ref: setItemRef,
        role: "button",
        "data-testid": `roadmap.timeline-table.components.list-item.container-${id}`,
        tabIndex: 0,
        className: (0, $7JEyt.default)([
            "_kqswh2mm _1e0c1txw _vchhusvi _4cvr1h6o _16jlidpf _1o9zidpf _i0dl1wug _1bsb1osq _4t3i1osq _u5f3u2gc _12ji1r31 _1qu2glyw _12y31o36 _1reo15vq _18m915vq _v564lfip _nt751r31 _49pcglyw _1hvw1o36 _1ejj168b",
            (0, $fTs8H.getRowClassName)(id, parentId).className
        ]),
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingLeft: `${(0, $kmplh.getListContentPaddingLeft)({
                isBaseLevel: isBaseLevel,
                isParent: isParent,
                depth: depth
            })}px`,
            backgroundColor: backgroundColor,
            cursor: $39ed6456e64aa415$var$getCursor(isInTransition, isSelectEnabled)
        },
        onClick: isSelectEnabled && !isInTransition ? onContainerClick : undefined,
        onKeyDown: isSelectEnabled && !isInTransition ? onContainerKeyDown : undefined,
        onMouseEnter: onHoverOrFocus,
        onMouseLeave: onStopHoverOrFocus,
        onMouseDown: onContainerMouseDown,
        onFocus: onHoverOrFocus,
        onBlur: onContainerBlur
    }, isParent && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hQQ6H.default), {
        id: id,
        ariaControls: ariaControls,
        label: isExpanded ? formatMessage((0, $bt6fG.default).collapse) : formatMessage((0, $bt6fG.default).expand),
        isExpanded: isExpanded,
        isRichContentEnabled: isHoveredOrFocused,
        onExpandChanged: onExpandChanged
    }), renderListItemContent(rendererProps, rendererState), renderSecondaryContent()));
};
$39ed6456e64aa415$var$ListItem.defaultProps = {
    isInTransition: false
};
$39ed6456e64aa415$var$ListItem.displayName = 'ListItem';
$39ed6456e64aa415$var$ListItem.whyDidYouRender = true;
var $39ed6456e64aa415$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($39ed6456e64aa415$var$ListItem);

});


parcelRegister("8uivF", function(module, exports) {

$parcel$export(module.exports, "default", () => $7e44c4abc3631a0b$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $1ybV0 = parcelRequire("1ybV0");

var $gf0vG = parcelRequire("gf0vG");

var $nH3p1 = parcelRequire("nH3p1");

var $kmplh = parcelRequire("kmplh");

var $1sAbG = parcelRequire("1sAbG");
const $7e44c4abc3631a0b$var$listItemLiteCellStyles = null;
/* A non interactive version of the list-item with lightweight styles.
 * Leveraged during virtualisation to improve scroll performance.
 */ const $7e44c4abc3631a0b$var$ListItemLite = ({ id: id, depth: depth, level: level, itemHeight: itemHeight, backgroundColor: backgroundColor, renderListItemContent: renderListItemContent, renderListItemSecondaryContent: renderListItemSecondaryContent })=>{
    const [listWidth] = (0, $nH3p1.useListWidth)();
    const isBaseLevel = (0, $1sAbG.isBaseLevel)(level);
    const rendererProps = {
        id: id
    };
    const rendererState = {
        isVirtual: true,
        isHoveredOrFocused: false
    };
    let height = isBaseLevel ? (0, $gf0vG.BASE_LEVEL_ITEM_HEIGHT) : itemHeight;
    if ((0, $1ybV0.ff)('jwm.visual-hierarchy-milestone-1')) height = depth > 0 ? (0, $gf0vG.BASE_LEVEL_ITEM_HEIGHT) : itemHeight;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        role: "gridcell",
        tabIndex: -1,
        style: {
            width: `${listWidth}px`,
            height: `${height}px`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingLeft: `${(0, $kmplh.getListContentPaddingLeft)({
                isBaseLevel: isBaseLevel,
                isParent: false,
                depth: depth
            })}px`,
            backgroundColor: backgroundColor
        },
        className: (0, $7JEyt.default)([
            "_kqsw1if8 _1e0c1txw _vchhusvi _4cvr1h6o _16jlidpf _1o9zidpf _i0dl1wug _1ltvidpf _u5f3u2gc _1reo15vq _18m915vq _1pby1406"
        ])
    }, renderListItemContent(rendererProps, rendererState), renderListItemSecondaryContent(rendererProps, rendererState));
};
var $7e44c4abc3631a0b$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($7e44c4abc3631a0b$var$ListItemLite);

});

parcelRegister("dAVGZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $0ab7d89e241a016e$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $nH3p1 = parcelRequire("nH3p1");

var $7K2X3 = parcelRequire("7K2X3");
const $0ab7d89e241a016e$var$containerStyles = null;
const $0ab7d89e241a016e$var$listResizerContainerStyles = null;
const $0ab7d89e241a016e$var$ListResizer = ({ DndLongTaskMetric: DndLongTaskMetric, onSetListWidth: onSetListWidth })=>{
    const [listWidth, { setListWidth: setListWidth }] = (0, $nH3p1.useListWidth)();
    const onResize = (0, $eUqFw.useCallback)((width)=>{
        setListWidth(width);
    }, [
        setListWidth
    ]);
    const onResizeEnd = (0, $eUqFw.useCallback)(()=>{
        onSetListWidth(listWidth);
    }, [
        listWidth,
        onSetListWidth
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: (0, $7JEyt.default)([
            "_kqswstnw _1e0c1txw _154iidpf _94n5idpf _1ltvidpf _1bsb1osq _lcxvglyw"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        style: {
            width: `${listWidth}px`
        },
        className: (0, $7JEyt.default)([
            "_kqsw1if8 _1ltvidpf _1pbyilow"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7K2X3.default), {
        width: listWidth,
        DndLongTaskMetric: DndLongTaskMetric,
        onResize: onResize,
        onResizeEnd: onResizeEnd
    })));
};
var $0ab7d89e241a016e$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($0ab7d89e241a016e$var$ListResizer);

});
parcelRegister("7K2X3", function(module, exports) {

$parcel$export(module.exports, "default", () => $b4d185fce0fa3f9b$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $kn6GU = parcelRequire("kn6GU");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $gf0vG = parcelRequire("gf0vG");

var $2XRKY = parcelRequire("2XRKY");

var $b6Urp = parcelRequire("b6Urp");
const $b4d185fce0fa3f9b$var$Resizer = ({ width: width, DndLongTaskMetric: DndLongTaskMetric, onResize: onResize, onResizeEnd: onResizeEnd })=>{
    const initialWidth = (0, $eUqFw.useRef)(width);
    const [isDragging, setIsDragging] = (0, $eUqFw.useState)(false);
    const maxWidth = (0, $b6Urp.useMaxWidth)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    (0, $eUqFw.useEffect)(()=>{
        width > maxWidth && onResize(maxWidth);
    }, [
        width,
        maxWidth,
        onResize
    ]);
    const onDragStart = (0, $eUqFw.useCallback)(()=>{
        initialWidth.current = width;
        setIsDragging(true);
    }, [
        width
    ]);
    const onDrag = (0, $eUqFw.useCallback)((from, to, start)=>{
        const newWidth = Math.round(initialWidth.current + to.x - start.x);
        const saneWidth = (0, (/*@__PURE__*/$parcel$interopDefault($kn6GU)))(newWidth, (0, $gf0vG.MINIMUM_LIST_WIDTH), maxWidth);
        onResize(saneWidth);
    }, [
        maxWidth,
        onResize
    ]);
    const onDragEnd = (0, $eUqFw.useCallback)((from, to)=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'resized',
            actionSubject: 'list'
        });
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'resizedList', {
            didExpand: to.x > from.x
        });
        setIsDragging(false);
        onResizeEnd(initialWidth.current);
    }, [
        createAnalyticsEvent,
        onResizeEnd
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2XRKY.default), {
        onDragStart: onDragStart,
        onDrag: onDrag,
        onDragEnd: onDragEnd
    }), DndLongTaskMetric !== undefined && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(DndLongTaskMetric, {
        isDragging: isDragging,
        metricType: (0, $gf0vG.LIST_RESIZE_DRAG_AND_DROP)
    }));
};
var $b4d185fce0fa3f9b$export$2e2bcd8739ae039 = $b4d185fce0fa3f9b$var$Resizer;

});
parcelRegister("kn6GU", function(module, exports) {

var $1ImyS = parcelRequire("1ImyS");

var $7kP6w = parcelRequire("7kP6w");
/**
 * Clamps `number` within the inclusive `lower` and `upper` bounds.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Number
 * @param {number} number The number to clamp.
 * @param {number} [lower] The lower bound.
 * @param {number} upper The upper bound.
 * @returns {number} Returns the clamped number.
 * @example
 *
 * _.clamp(-10, -5, 5);
 * // => -5
 *
 * _.clamp(10, -5, 5);
 * // => 5
 */ function $ed4b255301b8301f$var$clamp(number, lower, upper) {
    if (upper === undefined) {
        upper = lower;
        lower = undefined;
    }
    if (upper !== undefined) {
        upper = $7kP6w(upper);
        upper = upper === upper ? upper : 0;
    }
    if (lower !== undefined) {
        lower = $7kP6w(lower);
        lower = lower === lower ? lower : 0;
    }
    return $1ImyS($7kP6w(number), lower, upper);
}
module.exports = $ed4b255301b8301f$var$clamp;

});
parcelRegister("1ImyS", function(module, exports) {
/**
 * The base implementation of `_.clamp` which doesn't coerce arguments.
 *
 * @private
 * @param {number} number The number to clamp.
 * @param {number} [lower] The lower bound.
 * @param {number} upper The upper bound.
 * @returns {number} Returns the clamped number.
 */ function $13fb66c0c405b8c7$var$baseClamp(number, lower, upper) {
    if (number === number) {
        if (upper !== undefined) number = number <= upper ? number : upper;
        if (lower !== undefined) number = number >= lower ? number : lower;
    }
    return number;
}
module.exports = $13fb66c0c405b8c7$var$baseClamp;

});


parcelRegister("2XRKY", function(module, exports) {

$parcel$export(module.exports, "default", () => $fb761b5c173f7074$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $3R70n = parcelRequire("3R70n");
const $fb761b5c173f7074$var$ResizeHandler = ({ isDragging: isDragging, children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        ...props,
        className: (0, $7JEyt.default)([
            "_kqswstnw _154iidpf _1xi21i6y _1bsbu2gc _4t3i1osq _1pbyilow _v564ryu7 _lcxv1rj4 _80omuf7j _18postnw _1ywu1ule _aetrb3bt _15l2idpf _32rxv77o _z0aiv77o _1qdg1osq _16r21can _11fnglyw",
            isDragging ? "_tzy4kb7n" : "_tzy4idpf _16l4kb7n"
        ])
    }, children);
var $fb761b5c173f7074$export$2e2bcd8739ae039 = (0, $3R70n.withDragObserver)($fb761b5c173f7074$var$ResizeHandler);
const $fb761b5c173f7074$var$resizeHandlerStyles = null;
const $fb761b5c173f7074$var$staticStyles = null;
const $fb761b5c173f7074$var$draggingStyles = null;

});
parcelRegister("3R70n", function(module, exports) {

$parcel$export(module.exports, "withDragObserver", () => $e0abf553c8271478$export$a0ae95ab2800c7f2);
// Allow PureComponent
// eslint-disable-next-line jira/restricted/react

var $eUqFw = parcelRequire("eUqFw");

var $lEfVV = parcelRequire("lEfVV");

var $kFGm5 = parcelRequire("kFGm5");

var $jRGmr = parcelRequire("jRGmr");
const $e0abf553c8271478$export$13171b62aaa278f9 = 3;
const $e0abf553c8271478$var$DISABLED_DRAG_PROPS = [
    'onMouseDown',
    'onDragStart',
    'onDrag',
    'onDragEnd'
];
const $e0abf553c8271478$var$ENABLED_DRAG_PROPS = [
    'onMouseDown',
    'onClick',
    'onDragStart',
    'onDrag',
    'onDragEnd'
];
const $e0abf553c8271478$var$getMousePosition = (event)=>({
        x: event.pageX,
        y: event.pageY
    });
const $e0abf553c8271478$var$requestAnimationFrame = (0, $jRGmr.createRaf)();
const $e0abf553c8271478$export$a0ae95ab2800c7f2 = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
WrappedComponent, threshold = $e0abf553c8271478$export$13171b62aaa278f9)=>{
    // eslint-disable-next-line jira/react/no-class-components
    class DragObserver extends (0, $eUqFw.PureComponent) {
        static{
            this.defaultProps = {
                isDisabled: false,
                onMouseDown: undefined,
                onDragStart: undefined,
                onDrag: undefined,
                onDragEnd: undefined,
                onClick: undefined
            };
        }
        constructor(props){
            super(props);
            this.onChildMouseDown = (event)=>{
                // Do not start dragging if mouse down with right click
                if (this.props.isDisabled || event.button !== 0) return;
                event.preventDefault();
                event.stopPropagation();
                this.addWindowEventListeners();
                const dragStart = $e0abf553c8271478$var$getMousePosition(event);
                this.setState({
                    isDragging: false,
                    dragStart: dragStart,
                    previousDragPosition: dragStart
                }, ()=>this.onMouseDown(event));
            };
            this.onWindowMouseMove = (event)=>{
                event.preventDefault();
                const mouse = $e0abf553c8271478$var$getMousePosition(event);
                const { isDragging: isDragging, dragStart: dragStart, previousDragPosition: previousDragPosition } = this.state;
                if (!isDragging) {
                    if (Math.abs(mouse.x - dragStart.x) > threshold || Math.abs(mouse.y - dragStart.y) > threshold) {
                        this.setState({
                            isDragging: true
                        });
                        this.onDragStart(dragStart);
                    }
                } else {
                    const from = previousDragPosition;
                    const to = mouse;
                    this.setState({
                        previousDragPosition: mouse
                    });
                    this.onDrag(from, to, dragStart);
                }
            };
            this.onWindowMouseUp = (event)=>{
                const { isDragging: isDragging, dragStart: dragStart } = this.state;
                if (isDragging) {
                    const mouse = $e0abf553c8271478$var$getMousePosition(event);
                    const start = dragStart;
                    const end = mouse;
                    if (this.mounted) this.setState({
                        isDragging: false
                    });
                    this.onDragEnd(start, end);
                } else if (event.button === 0 && ((navigator?.userAgent ?? '').includes('Mac') ? !event.ctrlKey : true)) // Trigger onClick on left clicks only. Checking ctrlKey as ctrl + click could emulate right-click on Mac
                this.onClick(event);
                this.removeWindowEventListeners();
            };
            this.animationId = undefined;
            this.mounted = false;
            this.state = {
                isDragging: false,
                dragStart: {
                    x: 0,
                    y: 0
                },
                previousDragPosition: {
                    x: 0,
                    y: 0
                }
            };
        }
        componentDidMount() {
            this.mounted = true;
            // eslint-disable-next-line react/no-find-dom-node
            this.ref = (0, (/*@__PURE__*/$parcel$interopDefault($lEfVV))).findDOMNode(this);
            if (this.ref) // @ts-expect-error - TS2345 - Argument of type '(event: MouseEvent) => void' is not assignable to parameter of type 'EventListenerOrEventListenerObject'.
            this.ref.addEventListener('mousedown', this.onChildMouseDown);
        }
        componentWillUnmount() {
            if (this.ref) // @ts-expect-error - TS2345 - Argument of type '(event: MouseEvent) => void' is not assignable to parameter of type 'EventListenerOrEventListenerObject'.
            this.ref.removeEventListener('mousedown', this.onChildMouseDown);
            this.removeWindowEventListeners();
            if (this.animationId !== undefined) {
                cancelAnimationFrame(this.animationId);
                this.animationId = undefined;
            }
            this.mounted = false;
        }
        addWindowEventListeners() {
            window.addEventListener('mousemove', this.onWindowMouseMove);
            window.addEventListener('mouseup', this.onWindowMouseUp);
        }
        removeWindowEventListeners() {
            window.removeEventListener('mousemove', this.onWindowMouseMove);
            window.removeEventListener('mouseup', this.onWindowMouseUp);
        }
        onMouseDown(event) {
            if (this.props.onMouseDown) this.props.onMouseDown(event);
        }
        onDragStart(from) {
            if (this.props.onDragStart) this.props.onDragStart(from);
        }
        onDrag(from, to, start) {
            if (this.props.onDrag) this.animationId = $e0abf553c8271478$var$requestAnimationFrame(()=>{
                if (this.props.onDrag && this.state.isDragging) this.props.onDrag(from, to, start);
            });
        }
        onDragEnd(from, to) {
            if (this.props.onDragEnd) this.props.onDragEnd(from, to);
        }
        onClick(event) {
            if (this.props.onClick) this.props.onClick(event);
        }
        render() {
            const { isDisabled: isDisabled } = this.props;
            const { isDragging: isDragging } = this.state;
            /* When dragging is disabled, clicking should still be enabled.
			 * Rather than try handle onClick in this HOC, we instead just allow
			 * the onClick passed in to make it to the underlying component.
			 */ const safeProps = (0, (/*@__PURE__*/$parcel$interopDefault($kFGm5)))(this.props, isDisabled ? $e0abf553c8271478$var$DISABLED_DRAG_PROPS : $e0abf553c8271478$var$ENABLED_DRAG_PROPS);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, {
                isDragging: isDragging,
                ...safeProps
            });
        }
    }
    return DragObserver;
};

});
parcelRegister("jRGmr", function(module, exports) {

$parcel$export(module.exports, "createRaf", () => $bfe88abdc2d8eafe$export$adfe8e38eaee509d);
/* The browser can attempt to schedule more than one animation frame on the same tick of the event loop.
 * In this case, we should cancel the already scheduled one to avoid redundant work.
 * The createRaf utility encapsulates this behaviour.
 */ const $bfe88abdc2d8eafe$export$adfe8e38eaee509d = ()=>{
    let frameId = null;
    return (callback)=>{
        if (frameId) cancelAnimationFrame(frameId);
        frameId = requestAnimationFrame(callback);
        return frameId;
    };
};

});



parcelRegister("b6Urp", function(module, exports) {

$parcel$export(module.exports, "useMaxWidth", () => $ec797c92d78f585a$export$f8d842793af60bfe);

var $eUqFw = parcelRequire("eUqFw");

var $dxIU5 = parcelRequire("dxIU5");

var $gf0vG = parcelRequire("gf0vG");

var $6TBpb = parcelRequire("6TBpb");

var $72o82 = parcelRequire("72o82");
/** The list's maximum width is relative to the table width. Since the table width is dynamic,
 * and influenced by external factors (e.g. screen resolution), it cannot be known ahead of render.
 * Thus, the value returned here is used constrain the current list width, either retroactively,
 * or during a resize operation.
 */ const $ec797c92d78f585a$export$f8d842793af60bfe = ()=>{
    const [maxWidth, setMaxWidth] = (0, $eUqFw.useState)(Infinity);
    const { requestViewportBoundingClient: requestViewportBoundingClient } = (0, $6TBpb.useViewport)();
    const setMaxWidthFromViewport = (0, $eUqFw.useCallback)(()=>{
        const viewportBoundingClient = requestViewportBoundingClient({
            withTimelineOffset: false
        });
        if (viewportBoundingClient) {
            const newMaxWidth = (0, $72o82.getMaxListWidth)(viewportBoundingClient.width);
            setMaxWidth(newMaxWidth);
        }
    }, [
        requestViewportBoundingClient
    ]);
    (0, $eUqFw.useEffect)(()=>{
        setMaxWidthFromViewport();
    }, [
        setMaxWidthFromViewport
    ]);
    (0, $eUqFw.useEffect)(()=>{
        const onWindowResize = (0, (/*@__PURE__*/$parcel$interopDefault($dxIU5)))(()=>{
            setMaxWidthFromViewport();
        }, (0, $gf0vG.RESIZE_DEBOUNCE_MS));
        window.addEventListener('resize', onWindowResize);
        return ()=>{
            window.removeEventListener('resize', onWindowResize);
            onWindowResize.cancel();
        };
    }, [
        setMaxWidthFromViewport
    ]);
    return maxWidth;
};

});
parcelRegister("6TBpb", function(module, exports) {

$parcel$export(module.exports, "useViewport", () => $e467fe7c3b8a4e47$export$297ec8eb77d6211d);
$parcel$export(module.exports, "default", () => $e467fe7c3b8a4e47$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $3defo = parcelRequire("3defo");
const $e467fe7c3b8a4e47$var$ViewportContext = /*#__PURE__*/ (0, $eUqFw.createContext)({
    requestViewportBoundingClient: ()=>(0, $3defo.DEFAULT_BOUNDING_CLIENT),
    requestViewportScrollBounding: ()=>(0, $3defo.DEFAULT_SCROLL_BOUNDING),
    listenToViewportScroll: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    stopListeningToViewportScroll: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    setViewportScroll: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
});
const $e467fe7c3b8a4e47$export$297ec8eb77d6211d = ()=>(0, $eUqFw.useContext)($e467fe7c3b8a4e47$var$ViewportContext);
var $e467fe7c3b8a4e47$export$2e2bcd8739ae039 = $e467fe7c3b8a4e47$var$ViewportContext;

});
parcelRegister("3defo", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_BOUNDING_CLIENT", () => $534c582ade2276d4$export$2b0ecbff0a0d633b);
$parcel$export(module.exports, "DEFAULT_SCROLL_BOUNDING", () => $534c582ade2276d4$export$2f9f19f71eef1ceb);
const $534c582ade2276d4$export$2b0ecbff0a0d633b = {
    width: 0,
    height: 0,
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
};
const $534c582ade2276d4$export$2f9f19f71eef1ceb = {
    scrollTop: 0,
    scrollLeft: 0,
    scrollRight: 0,
    scrollBottom: 0,
    scrollHeight: 0,
    scrollWidth: 0,
    isOverflowY: false
};

});


parcelRegister("72o82", function(module, exports) {

$parcel$export(module.exports, "getMaxListWidth", () => $d74088e260cdc398$export$5db3ad0238a5a9b3);

var $gf0vG = parcelRequire("gf0vG");
const $d74088e260cdc398$var$MAX_WIDTH_RATIO = 0.9;
const $d74088e260cdc398$export$5db3ad0238a5a9b3 = (viewportWidth)=>{
    const tableLimitedWidth = Math.round(viewportWidth * $d74088e260cdc398$var$MAX_WIDTH_RATIO);
    return Math.max((0, $gf0vG.MINIMUM_LIST_WIDTH), tableLimitedWidth);
};

});





parcelRegister("gPBP5", function(module, exports) {

$parcel$export(module.exports, "default", () => $a9dafa7dc650fca8$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $gf0vG = parcelRequire("gf0vG");

var $VrUCp = parcelRequire("VrUCp");
var $nH3p1 = parcelRequire("nH3p1");
var $3XwA1 = parcelRequire("3XwA1");
var $cZkk1 = parcelRequire("cZkk1");

var $ldtYx = parcelRequire("ldtYx");

var $9uHe2 = parcelRequire("9uHe2");

var $ccgw3 = parcelRequire("ccgw3");

var $srCMJ = parcelRequire("srCMJ");

var $7KPyi = parcelRequire("7KPyi");

var $4RNyl = parcelRequire("4RNyl");
const $a9dafa7dc650fca8$var$containerStyles = null;
const $a9dafa7dc650fca8$var$hiddenScrollbarPanelStyles = null;
const $a9dafa7dc650fca8$var$HiddenScrollbarPanel = ({ scrollbarSize: scrollbarSize, innerRef: innerRef, children: children, ...rest })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        ref: innerRef,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: scrollbarSize > 0 ? {
            right: `-${scrollbarSize}px`,
            bottom: `-${scrollbarSize}px`
        } : undefined,
        ...rest,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _kqswstnw _154iidpf _1xi2idpf _94n5idpf _1ltvidpf _1reo15zi _18m915zi"
        ])
    }, children);
const $a9dafa7dc650fca8$var$requestAnimationFrame = (0, $9uHe2.createRaf)();
const $a9dafa7dc650fca8$var$Viewport = (0, $ldtYx.default)(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
$a9dafa7dc650fca8$var$HiddenScrollbarPanel);
/*
 * !! Changes here should be made with extreme caution !!
 * This component exists to create scrollbars that have a browser/OS agnostic look and feel, while still respecting user settings.
 * The context this component provides is used by dozens of leaf nodes and is accessible to external consumers. Additionally, performance
 * optimisations here are nuanced, which if regressed can easily cause bottlenecks to our virtual scrolling and TTI.
 * ---
 * Some points of interest:
 * - We rely heavily on accessing the DOM directly, skipping as much work as possible in the React lifecycle.
 * - In the local system (we cannot guarantee this globally), we look to minimise layout thrashing by batching DOM reads and writes.
 * - We translate measurements between two coordinate systems to decouple the scrollbar ref from our custom element refs (see ./thumb-tracks).
 */ const $a9dafa7dc650fca8$var$CustomScrollbars = ({ isHideScrollbar: isHideScrollbar, children: children })=>{
    const [{ timelineOriginPosition: timelineOriginPosition }] = (0, $3XwA1.useTimelineState)();
    const [{ headerHeight: headerHeight }] = (0, $VrUCp.useHeaderState)();
    const [listWidth] = (0, $nH3p1.useListWidth)();
    const [scrollbarSize, setScrollbarSize] = (0, $eUqFw.useState)(-1);
    const viewportRef = (0, $eUqFw.useRef)(null);
    const thumbTracksRef = (0, $eUqFw.useRef)(null);
    const lastScrollY = (0, $eUqFw.useRef)(0);
    const lastScrollX = (0, $eUqFw.useRef)(0);
    const frameId = (0, $eUqFw.useRef)();
    const [setupDragScroller, teardownDragScroller] = (0, $srCMJ.useDragScroller)(headerHeight);
    const { onResize: onResize } = (0, $cZkk1.useTimelineViewportActions)();
    // ====================== //
    // === EVENT HANDLING === //
    // ====================== //
    const onSetViewportRef = (elem)=>{
        viewportRef.current = elem;
        setupDragScroller(elem);
    };
    // Set the scroll left on the real scrollbar based on a position from clicking/dragging the track
    const onSetScrollLeft = (0, $eUqFw.useCallback)((relativePosition)=>{
        if (!viewportRef.current || !thumbTracksRef.current) throw new Error('An element required to set the scroll left position was null');
        const { scrollWidth: scrollWidth } = viewportRef.current;
        viewportRef.current.scrollLeft = relativePosition * scrollWidth;
    }, []);
    // Set the scroll top on the real scrollbar based on a position from from clicking/dragging the track
    const onSetScrollTop = (0, $eUqFw.useCallback)((relativePosition)=>{
        if (!viewportRef.current || !thumbTracksRef.current) throw new Error('An element required to set the scroll top position was null');
        const { scrollHeight: scrollHeight } = viewportRef.current;
        viewportRef.current.scrollTop = relativePosition * scrollHeight;
    }, []);
    /* Update the custom thumb positions to reflect the "real" ones that we've hidden.
   * To minimise the number of updates, we check whether the scroll position has changed
   * before mutating the DOM, e.g. don't change vertical position when only scrolling horizontally.
   */ const onScroll = ({ currentTarget: currentTarget })=>{
        frameId.current = $a9dafa7dc650fca8$var$requestAnimationFrame(()=>{
            // DOM reads //
            const { scrollLeft: scrollLeft, scrollTop: scrollTop, scrollWidth: scrollWidth, scrollHeight: scrollHeight, clientWidth: clientWidth, clientHeight: clientHeight } = currentTarget;
            let horizontalScrollRatio = -1;
            let verticalScrollRatio = -1;
            if (lastScrollX.current !== scrollLeft) {
                lastScrollX.current = scrollLeft;
                horizontalScrollRatio = (0, $4RNyl.getScrollOffsetRatio)(scrollLeft, scrollWidth, clientWidth);
            }
            if (lastScrollY.current !== scrollTop) {
                lastScrollY.current = scrollTop;
                verticalScrollRatio = (0, $4RNyl.getScrollOffsetRatio)(scrollTop, scrollHeight, clientHeight);
            }
            // DOM reads then writes //
            thumbTracksRef.current?.setThumbPositions({
                horizontalScrollRatio: horizontalScrollRatio,
                verticalScrollRatio: verticalScrollRatio
            });
        });
    };
    /* This should be called in response to anything that would affect the dimensions of the viewport
   * or its content. As a result, the relevant custom properties are updated, e.g. thumb position and size.
   */ const updateScrollbars = (0, $eUqFw.useCallback)(()=>{
        if (!viewportRef.current || !thumbTracksRef.current) throw new Error('An element required to set the custom scroll parameters was null');
        // DOM reads //
        const { scrollWidth: scrollWidth, scrollHeight: scrollHeight, clientWidth: clientWidth, clientHeight: clientHeight, scrollLeft: scrollLeft, scrollTop: scrollTop } = viewportRef.current;
        const { left: left } = viewportRef.current.getBoundingClientRect();
        onResize({
            left: left,
            clientWidth: clientWidth
        });
        const horizontalScrollRatio = (0, $4RNyl.getScrollOffsetRatio)(scrollLeft, scrollWidth, clientWidth);
        const verticalScrollRatio = (0, $4RNyl.getScrollOffsetRatio)(scrollTop, scrollHeight, clientHeight);
        const horizontalContentRatio = (0, $4RNyl.getContentToViewportRatio)(scrollWidth, clientWidth);
        const verticalContentRatio = (0, $4RNyl.getContentToViewportRatio)(scrollHeight, clientHeight);
        // DOM reads then writes //
        thumbTracksRef.current?.update({
            horizontalScrollRatio: horizontalScrollRatio,
            verticalScrollRatio: verticalScrollRatio
        }, {
            horizontalContentRatio: horizontalContentRatio,
            verticalContentRatio: verticalContentRatio
        });
    }, [
        onResize
    ]);
    // If a scrollbar is not measured, we don't need to handle updating the custom parameters.
    const onContentResize = scrollbarSize > 0 ? updateScrollbars : (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)));
    // =============== //
    // === EFFECTS === //
    // =============== //
    /* Step 1: Initialize the fundamental custom scrollbar properties.
   *
   * Some OS settings hide scrollbars or display them as overlays. In these cases the
   * scrollbar size will be measured as 0, and we will fallback to using the browser built-ins.
   * Regardless, given how often these settings change, we only ever set the scrollbar size once.
   */ (0, $eUqFw.useLayoutEffect)(()=>{
        if (!viewportRef.current) throw new Error('An element required to initialise the custom scrollbars was null');
        const initialScrollbarSize = (0, $4RNyl.getScrollbarSize)(viewportRef.current);
        // Browsers will convert scrollLeft to an integer, and we want to compare these two values later
        const integerTimelineDefaultPosition = Math.round(timelineOriginPosition);
        viewportRef.current.scrollLeft = integerTimelineDefaultPosition;
        lastScrollX.current = integerTimelineDefaultPosition;
        setScrollbarSize(initialScrollbarSize);
    }, [
        timelineOriginPosition
    ]);
    /* Step 2: Construct the resize observer *after* initialization so DOM is stable.
   *
   * This handles updating the scrollbar properties whenever the *viewport* changes size,
   * e.g. resizing the window or collapsing a sidebar. As we have no direct way to observe
   * content changes, this will be handled by a callback (see the render).
   */ (0, $ccgw3.useResizeObserver)(viewportRef.current, onContentResize);
    // Step 3: Don't forget to cleanup!!
    (0, $eUqFw.useEffect)(()=>()=>{
            frameId.current && cancelAnimationFrame(frameId.current);
            teardownDragScroller(null);
        }, [
        teardownDragScroller
    ]);
    // ============== //
    // === RENDER === //
    // ============== //
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: (0, $7JEyt.default)([
            "_kqswstnw _154iidpf _1xi2idpf _94n5idpf _1ltvidpf _1reo15vq _18m915vq _2rkoo8o8"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a9dafa7dc650fca8$var$Viewport, {
        id: (0, $gf0vG.TIMELINE_ID),
        "data-testid": (0, $gf0vG.TIMELINE_ID),
        innerRef: onSetViewportRef,
        scrollbarSize: scrollbarSize,
        offsets: (0, $4RNyl.getViewportOffsets)(scrollbarSize, listWidth, headerHeight),
        onScroll: scrollbarSize > 0 ? onScroll : undefined
    }, children({
        scrollElement: viewportRef.current,
        onContentResize: onContentResize
    })), scrollbarSize > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7KPyi.default), {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        ref: thumbTracksRef,
        listWidth: listWidth,
        timelineTop: headerHeight,
        isHideScrollbar: isHideScrollbar,
        onSetScrollLeft: onSetScrollLeft,
        onSetScrollTop: onSetScrollTop
    }));
};
var $a9dafa7dc650fca8$export$2e2bcd8739ae039 = $a9dafa7dc650fca8$var$CustomScrollbars;

});
parcelRegister("ldtYx", function(module, exports) {

$parcel$export(module.exports, "default", () => $3dab9cb41199266e$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $6TBpb = parcelRequire("6TBpb");

var $a5UGF = parcelRequire("a5UGF");

var $iukCv = parcelRequire("iukCv");
const $3dab9cb41199266e$var$withViewportProvider = (WrappedComponent)=>{
    /* eslint-disable jira/react-arrow-function-property-naming */ // eslint-disable-next-line jira/react/no-class-components
    class WithViewportProvider extends (0, $eUqFw.Component) {
        static{
            this.defaultProps = {
                offsets: (0, $a5UGF.DEFAULT_OFFSETS),
                innerRef: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
            };
        }
        constructor(props){
            super(props);
            this.requestBoundingClient = ({ withTimelineOffset: withTimelineOffset } = (0, $a5UGF.DEFAULT_BOUNDING_OPTIONS))=>{
                if (!this.ref) throw new Error((0, $a5UGF.MISSING_REF_ERROR_MESSAGE));
                return (0, $iukCv.calculateClientBounding)({
                    element: this.ref,
                    offsets: this.props.offsets,
                    withTimelineOffset: withTimelineOffset
                });
            };
            this.requestScrollBounding = ({ withTimelineOffset: withTimelineOffset } = (0, $a5UGF.DEFAULT_BOUNDING_OPTIONS))=>{
                if (!this.ref) throw new Error((0, $a5UGF.MISSING_REF_ERROR_MESSAGE));
                return (0, $iukCv.calculateScrollBounding)({
                    element: this.ref,
                    offsets: this.props.offsets,
                    withTimelineOffset: withTimelineOffset
                });
            };
            this.listenToScroll = (callback)=>{
                if (!this.ref) throw new Error((0, $a5UGF.MISSING_REF_ERROR_MESSAGE));
                this.ref.addEventListener('scroll', callback);
            };
            this.stopListeningToScroll = (callback)=>{
                if (this.ref) this.ref.removeEventListener('scroll', callback);
            };
            this.setScroll = ({ scrollLeft: scrollLeft, scrollTop: scrollTop })=>{
                if (!this.ref) throw new Error((0, $a5UGF.MISSING_REF_ERROR_MESSAGE));
                if (scrollLeft !== undefined) this.ref.scrollLeft = scrollLeft;
                if (scrollTop !== undefined) this.ref.scrollTop = scrollTop;
            };
            this.onSetRef = (elem)=>{
                const { innerRef: innerRef } = this.props;
                this.ref = elem;
                innerRef(elem);
            };
            this.ref = null;
            // It is being used, but only as a whole state object and the linter does not recognize that
            /* eslint-disable react/no-unused-state */ this.state = {
                requestViewportBoundingClient: this.requestBoundingClient,
                requestViewportScrollBounding: this.requestScrollBounding,
                listenToViewportScroll: this.listenToScroll,
                stopListeningToViewportScroll: this.stopListeningToScroll,
                setViewportScroll: this.setScroll
            };
        /* eslint-enable react/no-unused-state */ }
        render() {
            const { children: children, ...props } = this.props;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6TBpb.default).Provider, {
                value: this.state
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, {
                ...props,
                innerRef: this.onSetRef
            }, children));
        }
    }
    /* eslint-enable jira/react-arrow-function-property-naming */ return WithViewportProvider;
};
var $3dab9cb41199266e$export$2e2bcd8739ae039 = $3dab9cb41199266e$var$withViewportProvider;

});
parcelRegister("a5UGF", function(module, exports) {

$parcel$export(module.exports, "MISSING_REF_ERROR_MESSAGE", () => $ecb8126a31f8e57d$export$a374b3d597cc8a2f);
$parcel$export(module.exports, "DEFAULT_BOUNDING_OPTIONS", () => $ecb8126a31f8e57d$export$411ca18ef48ec0a9);
$parcel$export(module.exports, "DEFAULT_OFFSETS", () => $ecb8126a31f8e57d$export$86c907556a515793);
const $ecb8126a31f8e57d$export$a374b3d597cc8a2f = 'Viewport element was null. Only make this request when it is certain to be available (e.g. not in componentDidMount)';
const $ecb8126a31f8e57d$export$411ca18ef48ec0a9 = {
    withTimelineOffset: true
};
const $ecb8126a31f8e57d$export$86c907556a515793 = {
    scrollbar: 0,
    timelineTop: 0,
    timelineLeft: 0
};

});

parcelRegister("iukCv", function(module, exports) {

$parcel$export(module.exports, "calculateClientBounding", () => $6abb6d96f4886613$export$787a1f452b87b38);
$parcel$export(module.exports, "calculateScrollBounding", () => $6abb6d96f4886613$export$7bc284cde09cb25);
/* Transforms the viewport's raw bounding client rectangle.
 * At a minimum, we need to manually exclude the offsets used to hide the native scrollbars.
 * Without it, logic that relies on the viewport boundaries would be slightly off.
 */ const $6abb6d96f4886613$export$787a1f452b87b38 = ({ element: element, offsets: offsets, withTimelineOffset: withTimelineOffset })=>{
    const { width: width, height: height, right: right, bottom: bottom, left: left, top: top } = element.getBoundingClientRect();
    const { timelineTop: timelineTop, timelineLeft: timelineLeft, scrollbar: scrollbar } = offsets;
    const effectiveTimelineTop = withTimelineOffset ? timelineTop : 0;
    const effectiveTimelineLeft = withTimelineOffset ? timelineLeft : 0;
    return {
        width: width - scrollbar - effectiveTimelineLeft,
        height: height - scrollbar - effectiveTimelineTop,
        right: right - scrollbar,
        bottom: bottom - scrollbar,
        left: left + effectiveTimelineLeft,
        top: top + effectiveTimelineTop
    };
};
/* Transforms the viewport's raw scroll attributes.
 * Unlike the bounding client rectangle, these attributes are not affected by the scrollbar offsets.
 * This is because they effectively measure the viewport's content (e.g. scrollWidth, scrollHeight).
 */ const $6abb6d96f4886613$export$7bc284cde09cb25 = ({ element: element, offsets: offsets, withTimelineOffset: withTimelineOffset })=>{
    const { scrollTop: scrollTop, scrollLeft: scrollLeft, scrollHeight: scrollHeight, scrollWidth: scrollWidth, clientWidth: clientWidth, clientHeight: clientHeight } = element;
    const { timelineTop: timelineTop, timelineLeft: timelineLeft } = offsets;
    const effectiveTimelineTop = withTimelineOffset ? timelineTop : 0;
    const effectiveTimelineLeft = withTimelineOffset ? timelineLeft : 0;
    return {
        scrollTop: scrollTop,
        scrollLeft: scrollLeft,
        scrollRight: Math.max(scrollWidth - clientWidth - scrollLeft, 0),
        scrollBottom: Math.max(scrollHeight - clientHeight - scrollTop, 0),
        scrollHeight: scrollHeight - effectiveTimelineTop,
        scrollWidth: scrollWidth - effectiveTimelineLeft,
        isOverflowY: scrollHeight > clientHeight
    };
};

});


parcelRegister("9uHe2", function(module, exports) {

$parcel$export(module.exports, "createRaf", () => $812c3705f52197ec$export$adfe8e38eaee509d);
/* The browser can attempt to schedule more than one animation frame on the same tick of the event loop.
 * In this case, we should cancel the already scheduled one to avoid redundant work.
 * The createRaf utility encapsulates this behaviour.
 */ const $812c3705f52197ec$export$adfe8e38eaee509d = ()=>{
    let frameId = null;
    return (callback)=>{
        if (frameId) cancelAnimationFrame(frameId);
        frameId = requestAnimationFrame(callback);
        return frameId;
    };
};

});

parcelRegister("srCMJ", function(module, exports) {

$parcel$export(module.exports, "useDragScroller", () => $9b3cff6912a4c4da$export$ef7372695b4ed2f3);

var $eUqFw = parcelRequire("eUqFw");

var $5Pwiq = parcelRequire("5Pwiq");
parcelRequire("3f2za");
var $jFl9L = parcelRequire("jFl9L");

var $eo9PV = parcelRequire("eo9PV");

var $gf0vG = parcelRequire("gf0vG");
const $9b3cff6912a4c4da$export$ef7372695b4ed2f3 = (timelineTop)=>{
    const cleanupDragAndDrop = (0, $eUqFw.useRef)(null);
    const clientXPos = (0, $eUqFw.useRef)(0);
    const thresholdTop = (0, $eUqFw.useRef)(0);
    const setupDragScroller = (0, $eUqFw.useCallback)((viewportElement)=>{
        cleanupDragAndDrop.current = (0, $jFl9L.combine)((0, $eo9PV.monitorForElements)({
            onDragStart: ({ source: source, location: location })=>{
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                const item = source.data;
                if (item.type === (0, $gf0vG.ROW_DRAG_AND_DROP_ID) && viewportElement !== null) {
                    const viewportBoundingRect = viewportElement?.getBoundingClientRect();
                    const offsetTop = viewportBoundingRect?.top ?? 0;
                    clientXPos.current = (viewportBoundingRect?.left ?? 0) + (viewportBoundingRect?.width ?? 0) / 2;
                    thresholdTop.current = offsetTop / 2 + timelineTop + offsetTop;
                    (0, $5Pwiq.autoScroller).start({
                        input: {
                            ...location.current.input,
                            // lock the x axis
                            pageX: clientXPos.current,
                            clientX: clientXPos.current
                        }
                    });
                }
            },
            onDrop: ({ source: source })=>{
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                const item = source.data;
                if (item.type === (0, $gf0vG.ROW_DRAG_AND_DROP_ID) && viewportElement !== null) (0, $5Pwiq.autoScroller).stop();
            },
            onDrag: ({ source: source, location: location })=>{
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                const item = source.data;
                if (item.type === (0, $gf0vG.ROW_DRAG_AND_DROP_ID) && viewportElement !== null) {
                    const { clientY: clientY, pageX: pageX, clientX: clientX, pageY: pageY, ...restInputs } = location.current.input;
                    const newClientY = clientY < thresholdTop.current ? clientY - timelineTop : clientY;
                    const input = {
                        ...restInputs,
                        // lock the x axis
                        pageX: clientXPos.current,
                        clientX: clientXPos.current,
                        pageY: newClientY,
                        clientY: newClientY
                    };
                    (0, $5Pwiq.autoScroller).updateInput({
                        input: input
                    });
                }
            }
        }));
    }, [
        timelineTop
    ]);
    const teardownDragScroller = (0, $eUqFw.useCallback)(()=>{
        cleanupDragAndDrop.current?.();
    }, []);
    return [
        setupDragScroller,
        teardownDragScroller
    ];
};

});
parcelRegister("5Pwiq", function(module, exports) {

$parcel$export(module.exports, "createAutoScroller", () => $bde649c1e39b5c8c$export$fbda4b72e803ec38);
$parcel$export(module.exports, "autoScroller", () => $bde649c1e39b5c8c$export$d19940cfc7560cd8);

var $dEKnA = parcelRequire("dEKnA");
const $bde649c1e39b5c8c$var$scrollElement = (element, change)=>{
    element.scrollBy(change.x, change.y);
};
const $bde649c1e39b5c8c$var$scrollWindow = (change)=>{
    window.scrollBy(change.x, change.y);
};
const $bde649c1e39b5c8c$export$fbda4b72e803ec38 = ()=>{
    let dragging = null;
    function tryScroll(fakeScrollCallback) {
        if (dragging == null) return;
        (0, $dEKnA.scroll)({
            input: dragging.latestInput,
            dragStartTime: dragging.dragStartTime,
            shouldUseTimeDampening: dragging.shouldUseTimeDampening,
            behavior: dragging.behavior,
            scrollElement: fakeScrollCallback ?? $bde649c1e39b5c8c$var$scrollElement,
            scrollWindow: fakeScrollCallback ?? $bde649c1e39b5c8c$var$scrollWindow
        });
    }
    // Every animation frame use the latest user input to scroll
    // We do this loop manually rather than in response to `onDrag`
    // events as `onDrag` can drop to 50-100ms between events when
    // the user is not actively moving their pointer
    function loop() {
        if (!dragging) return;
        dragging.loopFrameId = requestAnimationFrame(()=>{
            tryScroll();
            loop();
        });
    }
    const start = ({ input: input, behavior: behavior = 'window-then-container' })=>{
        const dragStartTime = Date.now();
        dragging = {
            dragStartTime: dragStartTime,
            latestInput: input,
            loopFrameId: null,
            shouldUseTimeDampening: false,
            behavior: behavior
        };
        // we only use time dampening when auto scrolling starts on lift.
        const fakeScrollCallback = ()=>{
            if (dragging) dragging.shouldUseTimeDampening = true;
        };
        tryScroll(fakeScrollCallback);
        loop();
    };
    function updateInput({ input: input }) {
        if (!dragging) return;
        dragging.latestInput = input;
    }
    const stop = ()=>{
        // can be called defensively
        if (!dragging) return;
        if (dragging.loopFrameId) cancelAnimationFrame(dragging.loopFrameId);
        dragging = null;
    };
    return {
        start: start,
        updateInput: updateInput,
        stop: stop
    };
};
const $bde649c1e39b5c8c$export$d19940cfc7560cd8 = $bde649c1e39b5c8c$export$fbda4b72e803ec38();

});
parcelRegister("dEKnA", function(module, exports) {

$parcel$export(module.exports, "scroll", () => $704cec92194d31d8$export$209876d7b1ac8f3);
parcelRequire("5K1lL");
var $cHW1B = parcelRequire("cHW1B");

var $7E9sF = parcelRequire("7E9sF");

var $1s8mQ = parcelRequire("1s8mQ");

var $cmR18 = parcelRequire("cmR18");

var $91kec = parcelRequire("91kec");

var $2kKFy = parcelRequire("2kKFy");
const $704cec92194d31d8$export$209876d7b1ac8f3 = ({ input: input, dragStartTime: dragStartTime, shouldUseTimeDampening: shouldUseTimeDampening, scrollElement: scrollElement, scrollWindow: scrollWindow, behavior: behavior })=>{
    const tryScrollWindow = ()=>{
        const viewport = (0, $2kKFy.default)();
        const windowScrollChange = (0, $91kec.default)({
            dragStartTime: dragStartTime,
            viewport: viewport,
            center: {
                x: input.clientX + viewport.scroll.current.x,
                y: input.clientY + viewport.scroll.current.y
            },
            shouldUseTimeDampening: shouldUseTimeDampening
        });
        if (windowScrollChange) {
            scrollWindow(windowScrollChange);
            return true;
        }
        return false;
    };
    const tryScrollContainer = ()=>{
        const over = (0, $cHW1B.getElementFromPointWithoutHoneypot)({
            x: input.clientX,
            y: input.clientY
        });
        const closestScrollable = (0, $7E9sF.getClosestScrollableElement)(over);
        if (!closestScrollable) return false;
        const scrollable = (0, $1s8mQ.getScrollable)({
            closestScrollable: closestScrollable
        });
        const scrollableScrollChange = (0, $cmR18.default)({
            dragStartTime: dragStartTime,
            scrollable: scrollable,
            center: {
                x: input.clientX,
                y: input.clientY
            },
            shouldUseTimeDampening: shouldUseTimeDampening
        });
        if (scrollableScrollChange) {
            scrollElement(closestScrollable, scrollableScrollChange);
            return true;
        }
        return false;
    };
    if (behavior === 'container-only') tryScrollContainer();
    if (behavior === 'window-only') tryScrollWindow();
    if (behavior === 'container-then-window') tryScrollContainer() || tryScrollWindow();
    if (behavior === 'window-then-container') tryScrollWindow() || tryScrollContainer();
};

});
parcelRegister("5K1lL", function(module, exports) {

$parcel$export(module.exports, "getElementFromPointWithoutHoneypot", () => (parcelRequire("cHW1B")).getElementFromPointWithoutHoneypot);

var $cHW1B = parcelRequire("cHW1B");

});

parcelRegister("7E9sF", function(module, exports) {

$parcel$export(module.exports, "getClosestScrollableElement", () => $f466e08163ab9741$export$f39f407dd5a0ebdb);
// Source: https://github.com/atlassian/react-beautiful-dnd
const $f466e08163ab9741$var$isEqual = (base)=>(value)=>base === value;
const $f466e08163ab9741$var$isScroll = $f466e08163ab9741$var$isEqual('scroll');
const $f466e08163ab9741$var$isAuto = $f466e08163ab9741$var$isEqual('auto');
const $f466e08163ab9741$var$isEither = (overflow, fn)=>fn(overflow.overflowX) || fn(overflow.overflowY);
const $f466e08163ab9741$var$isElementScrollable = (el)=>{
    const style = window.getComputedStyle(el);
    const overflow = {
        overflowX: style.overflowX,
        overflowY: style.overflowY
    };
    return $f466e08163ab9741$var$isEither(overflow, $f466e08163ab9741$var$isScroll) || $f466e08163ab9741$var$isEither(overflow, $f466e08163ab9741$var$isAuto);
};
const $f466e08163ab9741$export$f39f407dd5a0ebdb = (el)=>{
    // cannot do anything else!
    if (!el) return null;
    // not allowing us to go higher then body
    if (el === document.body || el === document.documentElement) return null;
    if (!$f466e08163ab9741$var$isElementScrollable(el)) // keep recursing
    return $f466e08163ab9741$export$f39f407dd5a0ebdb(el.parentElement);
    // success!
    return el;
};

});

parcelRegister("1s8mQ", function(module, exports) {

$parcel$export(module.exports, "getScrollable", () => $6652de0133f228e0$export$9b7238c949d126e9);

var $bn5nT = parcelRequire("bn5nT");
const $6652de0133f228e0$export$9b7238c949d126e9 = ({ closestScrollable: closestScrollable })=>{
    const rect = closestScrollable.getBoundingClientRect();
    const scrollPosition = {
        x: closestScrollable.scrollLeft,
        y: closestScrollable.scrollTop
    };
    return {
        container: (0, $bn5nT.getRect)(rect),
        scroll: {
            current: scrollPosition,
            max: {
                x: closestScrollable.scrollWidth - closestScrollable.clientWidth,
                y: closestScrollable.scrollHeight - closestScrollable.clientHeight
            }
        }
    };
};

});
parcelRegister("bn5nT", function(module, exports) {

$parcel$export(module.exports, "getRect", () => $847604ea52819b67$export$4b834cebd9e5cebe);
$parcel$export(module.exports, "expand", () => $847604ea52819b67$export$9f77e0932fb78f72);
$parcel$export(module.exports, "createBox", () => $847604ea52819b67$export$6459fc9e86be362e);
$parcel$export(module.exports, "offset", () => $847604ea52819b67$export$cc800923e997bb8);
$parcel$export(module.exports, "withScroll", () => $847604ea52819b67$export$1d0caec378d7d0ae);
$parcel$export(module.exports, "calculateBox", () => $847604ea52819b67$export$b8dfc5d4e552b8e1);
$parcel$export(module.exports, "getBox", () => $847604ea52819b67$export$34928e660d2a8702);

var $8ynlC = parcelRequire("8ynlC");
var $847604ea52819b67$export$4b834cebd9e5cebe = function getRect(_ref) {
    var top = _ref.top, right = _ref.right, bottom = _ref.bottom, left = _ref.left;
    var width = right - left;
    var height = bottom - top;
    var rect = {
        top: top,
        right: right,
        bottom: bottom,
        left: left,
        width: width,
        height: height,
        x: left,
        y: top,
        center: {
            x: (right + left) / 2,
            y: (bottom + top) / 2
        }
    };
    return rect;
};
var $847604ea52819b67$export$9f77e0932fb78f72 = function expand(target, expandBy) {
    return {
        top: target.top - expandBy.top,
        left: target.left - expandBy.left,
        bottom: target.bottom + expandBy.bottom,
        right: target.right + expandBy.right
    };
};
var $847604ea52819b67$export$8b1f3092f5e28575 = function shrink(target, shrinkBy) {
    return {
        top: target.top + shrinkBy.top,
        left: target.left + shrinkBy.left,
        bottom: target.bottom - shrinkBy.bottom,
        right: target.right - shrinkBy.right
    };
};
var $847604ea52819b67$var$shift = function shift(target, shiftBy) {
    return {
        top: target.top + shiftBy.y,
        left: target.left + shiftBy.x,
        bottom: target.bottom + shiftBy.y,
        right: target.right + shiftBy.x
    };
};
var $847604ea52819b67$var$noSpacing = {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
};
var $847604ea52819b67$export$6459fc9e86be362e = function createBox(_ref2) {
    var borderBox = _ref2.borderBox, _ref2$margin = _ref2.margin, margin = _ref2$margin === void 0 ? $847604ea52819b67$var$noSpacing : _ref2$margin, _ref2$border = _ref2.border, border = _ref2$border === void 0 ? $847604ea52819b67$var$noSpacing : _ref2$border, _ref2$padding = _ref2.padding, padding = _ref2$padding === void 0 ? $847604ea52819b67$var$noSpacing : _ref2$padding;
    var marginBox = $847604ea52819b67$export$4b834cebd9e5cebe($847604ea52819b67$export$9f77e0932fb78f72(borderBox, margin));
    var paddingBox = $847604ea52819b67$export$4b834cebd9e5cebe($847604ea52819b67$export$8b1f3092f5e28575(borderBox, border));
    var contentBox = $847604ea52819b67$export$4b834cebd9e5cebe($847604ea52819b67$export$8b1f3092f5e28575(paddingBox, padding));
    return {
        marginBox: marginBox,
        borderBox: $847604ea52819b67$export$4b834cebd9e5cebe(borderBox),
        paddingBox: paddingBox,
        contentBox: contentBox,
        margin: margin,
        border: border,
        padding: padding
    };
};
var $847604ea52819b67$var$parse = function parse(raw) {
    var value = raw.slice(0, -2);
    var suffix = raw.slice(-2);
    if (suffix !== 'px') return 0;
    var result = Number(value);
    !!isNaN(result) && (0, $8ynlC.default)(false);
    return result;
};
var $847604ea52819b67$var$getWindowScroll = function getWindowScroll() {
    return {
        x: window.pageXOffset,
        y: window.pageYOffset
    };
};
var $847604ea52819b67$export$cc800923e997bb8 = function offset(original, change) {
    var borderBox = original.borderBox, border = original.border, margin = original.margin, padding = original.padding;
    var shifted = $847604ea52819b67$var$shift(borderBox, change);
    return $847604ea52819b67$export$6459fc9e86be362e({
        borderBox: shifted,
        border: border,
        margin: margin,
        padding: padding
    });
};
var $847604ea52819b67$export$1d0caec378d7d0ae = function withScroll(original, scroll) {
    if (scroll === void 0) scroll = $847604ea52819b67$var$getWindowScroll();
    return $847604ea52819b67$export$cc800923e997bb8(original, scroll);
};
var $847604ea52819b67$export$b8dfc5d4e552b8e1 = function calculateBox(borderBox, styles) {
    var margin = {
        top: $847604ea52819b67$var$parse(styles.marginTop),
        right: $847604ea52819b67$var$parse(styles.marginRight),
        bottom: $847604ea52819b67$var$parse(styles.marginBottom),
        left: $847604ea52819b67$var$parse(styles.marginLeft)
    };
    var padding = {
        top: $847604ea52819b67$var$parse(styles.paddingTop),
        right: $847604ea52819b67$var$parse(styles.paddingRight),
        bottom: $847604ea52819b67$var$parse(styles.paddingBottom),
        left: $847604ea52819b67$var$parse(styles.paddingLeft)
    };
    var border = {
        top: $847604ea52819b67$var$parse(styles.borderTopWidth),
        right: $847604ea52819b67$var$parse(styles.borderRightWidth),
        bottom: $847604ea52819b67$var$parse(styles.borderBottomWidth),
        left: $847604ea52819b67$var$parse(styles.borderLeftWidth)
    };
    return $847604ea52819b67$export$6459fc9e86be362e({
        borderBox: borderBox,
        margin: margin,
        padding: padding,
        border: border
    });
};
var $847604ea52819b67$export$34928e660d2a8702 = function getBox(el) {
    var borderBox = el.getBoundingClientRect();
    var styles = window.getComputedStyle(el);
    return $847604ea52819b67$export$b8dfc5d4e552b8e1(borderBox, styles);
};

});


parcelRegister("cmR18", function(module, exports) {

$parcel$export(module.exports, "default", () => $f31ebcd079c503fc$export$2e2bcd8739ae039);
// Source: https://github.com/atlassian/react-beautiful-dnd

var $kuXkS = parcelRequire("kuXkS");

var $h3yff = parcelRequire("h3yff");
var $f31ebcd079c503fc$export$2e2bcd8739ae039 = ({ scrollable: scrollable, center: center, dragStartTime: dragStartTime, shouldUseTimeDampening: shouldUseTimeDampening })=>{
    const scroll = (0, $h3yff.default)({
        dragStartTime: dragStartTime,
        container: scrollable.container,
        center: center,
        shouldUseTimeDampening: shouldUseTimeDampening
    });
    return scroll && (0, $kuXkS.canScrollScrollable)(scrollable, scroll) ? scroll : null;
};

});
parcelRegister("kuXkS", function(module, exports) {

$parcel$export(module.exports, "canScrollWindow", () => $ed7d2bc081cd70a2$export$cbd1e6fd5e887f10);
$parcel$export(module.exports, "canScrollScrollable", () => $ed7d2bc081cd70a2$export$57c21b61d76c9819);
// Source: https://github.com/atlassian/react-beautiful-dnd

var $6cABY = parcelRequire("6cABY");
const $ed7d2bc081cd70a2$var$smallestSigned = (0, $6cABY.apply)((value)=>{
    if (value === 0) return 0;
    return value > 0 ? 1 : -1;
});
const $ed7d2bc081cd70a2$export$6b13012b06f8f95b = (()=>{
    const getRemainder = (target, max)=>{
        if (target < 0) return target;
        if (target > max) return target - max;
        return 0;
    };
    return ({ current: current, max: max, change: change })=>{
        const targetScroll = (0, $6cABY.add)(current, change);
        const overlap = {
            x: getRemainder(targetScroll.x, max.x),
            y: getRemainder(targetScroll.y, max.y)
        };
        if ((0, $6cABY.isEqual)(overlap, (0, $6cABY.origin))) return null;
        return overlap;
    };
})();
const $ed7d2bc081cd70a2$export$dbc3ad6130556cf6 = ({ max: rawMax, current: current, change: change })=>{
    // It is possible for the max scroll to be greater than the current scroll
    // when there are scrollbars on the cross axis. We adjust for this by
    // increasing the max scroll point if needed
    // This will allow movements backwards even if the current scroll is greater than the max scroll
    const max = {
        x: Math.max(current.x, rawMax.x),
        y: Math.max(current.y, rawMax.y)
    };
    // Only need to be able to move the smallest amount in the desired direction
    const smallestChange = $ed7d2bc081cd70a2$var$smallestSigned(change);
    const overlap = $ed7d2bc081cd70a2$export$6b13012b06f8f95b({
        max: max,
        current: current,
        change: smallestChange
    });
    // no overlap at all - we can move there!
    if (!overlap) return true;
    // if there was an x value, but there is no x overlap - then we can scroll on the x!
    if (smallestChange.x !== 0 && overlap.x === 0) return true;
    // if there was an y value, but there is no y overlap - then we can scroll on the y!
    if (smallestChange.y !== 0 && overlap.y === 0) return true;
    return false;
};
const $ed7d2bc081cd70a2$export$cbd1e6fd5e887f10 = (viewport, change)=>$ed7d2bc081cd70a2$export$dbc3ad6130556cf6({
        current: viewport.scroll.current,
        max: viewport.scroll.max,
        change: change
    });
const $ed7d2bc081cd70a2$export$2f1f3b9e315c6096 = (viewport, change)=>{
    if (!$ed7d2bc081cd70a2$export$cbd1e6fd5e887f10(viewport, change)) return null;
    const max = viewport.scroll.max;
    const current = viewport.scroll.current;
    return $ed7d2bc081cd70a2$export$6b13012b06f8f95b({
        current: current,
        max: max,
        change: change
    });
};
const $ed7d2bc081cd70a2$export$57c21b61d76c9819 = (scrollable, change)=>{
    return $ed7d2bc081cd70a2$export$dbc3ad6130556cf6({
        current: scrollable.scroll.current,
        max: scrollable.scroll.max,
        change: change
    });
};
const $ed7d2bc081cd70a2$export$d88a6b2979421049 = (scrollable, change)=>{
    if (!$ed7d2bc081cd70a2$export$57c21b61d76c9819(scrollable, change)) return null;
    return $ed7d2bc081cd70a2$export$6b13012b06f8f95b({
        current: scrollable.scroll.current,
        max: scrollable.scroll.max,
        change: change
    });
};

});
parcelRegister("6cABY", function(module, exports) {

$parcel$export(module.exports, "origin", () => $bbb11b5c60935496$export$f710a83a91838a36);
$parcel$export(module.exports, "apply", () => $bbb11b5c60935496$export$5635d7ef4b8fee1c);
$parcel$export(module.exports, "isEqual", () => $bbb11b5c60935496$export$248d38f6296296c5);
$parcel$export(module.exports, "add", () => $bbb11b5c60935496$export$e16d8520af44a096);
$parcel$export(module.exports, "subtract", () => $bbb11b5c60935496$export$4e2d2ead65e5f7e3);
// Source: https://github.com/atlassian/react-beautiful-dnd
const $bbb11b5c60935496$export$f710a83a91838a36 = {
    x: 0,
    y: 0
};
const $bbb11b5c60935496$export$5635d7ef4b8fee1c = (fn)=>(point)=>({
            x: fn(point.x),
            y: fn(point.y)
        });
const $bbb11b5c60935496$export$248d38f6296296c5 = (point1, point2)=>point1.x === point2.x && point1.y === point2.y;
const $bbb11b5c60935496$export$e16d8520af44a096 = (point1, point2)=>({
        x: point1.x + point2.x,
        y: point1.y + point2.y
    });
const $bbb11b5c60935496$export$4e2d2ead65e5f7e3 = (point1, point2)=>({
        x: point1.x - point2.x,
        y: point1.y - point2.y
    });

});


parcelRegister("h3yff", function(module, exports) {

$parcel$export(module.exports, "default", () => $04403a563aa15b3f$export$2e2bcd8739ae039);
// Source: https://github.com/atlassian/react-beautiful-dnd

var $1FJBN = parcelRequire("1FJBN");

var $6cABY = parcelRequire("6cABY");

var $gaAYU = parcelRequire("gaAYU");
// will replace -0 and replace with +0
const $04403a563aa15b3f$var$clean = (0, $6cABY.apply)((value)=>value === 0 ? 0 : value);
var $04403a563aa15b3f$export$2e2bcd8739ae039 = ({ dragStartTime: dragStartTime, container: container, center: center, shouldUseTimeDampening: shouldUseTimeDampening })=>{
    // get distance to each edge
    const distanceToEdges = {
        top: center.y - container.top,
        right: container.right - center.x,
        bottom: container.bottom - center.y,
        left: center.x - container.left
    };
    // 1. Figure out which x,y values are the best target
    // 2. Can the container scroll in that direction at all?
    // If no for both directions, then return null
    // 3. Is the center close enough to a edge to start a drag?
    // 4. Based on the distance, calculate the speed at which a scroll should occur
    // The lower distance value the faster the scroll should be.
    // Maximum speed value should be hit before the distance is 0
    // Negative values to not continue to increase the speed
    const y = (0, $gaAYU.default)({
        container: container,
        distanceToEdges: distanceToEdges,
        dragStartTime: dragStartTime,
        axis: (0, $1FJBN.vertical),
        shouldUseTimeDampening: shouldUseTimeDampening
    });
    const x = (0, $gaAYU.default)({
        container: container,
        distanceToEdges: distanceToEdges,
        dragStartTime: dragStartTime,
        axis: (0, $1FJBN.horizontal),
        shouldUseTimeDampening: shouldUseTimeDampening
    });
    const required = $04403a563aa15b3f$var$clean({
        x: x,
        y: y
    });
    // nothing required
    if ((0, $6cABY.isEqual)(required, (0, $6cABY.origin))) return null;
    return required;
};

});
parcelRegister("1FJBN", function(module, exports) {

$parcel$export(module.exports, "minScroll", () => $68996f5601ae722f$export$67e2de1e1e796844);
$parcel$export(module.exports, "vertical", () => $68996f5601ae722f$export$32f8a6eb41d46820);
$parcel$export(module.exports, "horizontal", () => $68996f5601ae722f$export$641ecd0b2bc39508);
const $68996f5601ae722f$export$67e2de1e1e796844 = 1;
const $68996f5601ae722f$export$32f8a6eb41d46820 = {
    direction: 'vertical',
    start: 'top',
    end: 'bottom',
    size: 'height',
    scrollAxis: 'scrollTop'
};
const $68996f5601ae722f$export$641ecd0b2bc39508 = {
    direction: 'horizontal',
    start: 'left',
    end: 'right',
    size: 'width',
    scrollAxis: 'scrollLeft'
};
const $68996f5601ae722f$export$1a8fc111f6979e7a = [
    $68996f5601ae722f$export$641ecd0b2bc39508.direction,
    $68996f5601ae722f$export$32f8a6eb41d46820.direction
];

});

parcelRegister("gaAYU", function(module, exports) {

$parcel$export(module.exports, "default", () => $9042b92424eff0cb$export$2e2bcd8739ae039);
// Source: https://github.com/atlassian/react-beautiful-dnd

var $8Yq8R = parcelRequire("8Yq8R");

var $j3mW5 = parcelRequire("j3mW5");
var $9042b92424eff0cb$export$2e2bcd8739ae039 = ({ container: container, distanceToEdges: distanceToEdges, dragStartTime: dragStartTime, axis: axis, shouldUseTimeDampening: shouldUseTimeDampening })=>{
    const thresholds = (0, $8Yq8R.default)(container, axis);
    const isCloserToEnd = distanceToEdges[axis.end] < distanceToEdges[axis.start];
    if (isCloserToEnd) return (0, $j3mW5.default)({
        distanceToEdge: distanceToEdges[axis.end],
        thresholds: thresholds,
        dragStartTime: dragStartTime,
        shouldUseTimeDampening: shouldUseTimeDampening
    });
    return -1 * (0, $j3mW5.default)({
        distanceToEdge: distanceToEdges[axis.start],
        thresholds: thresholds,
        dragStartTime: dragStartTime,
        shouldUseTimeDampening: shouldUseTimeDampening
    });
};

});
parcelRegister("8Yq8R", function(module, exports) {

$parcel$export(module.exports, "default", () => $6206878988e06aa9$export$2e2bcd8739ae039);
// Source: https://github.com/atlassian/react-beautiful-dnd

var $CBqIn = parcelRequire("CBqIn");
const $6206878988e06aa9$export$79446fee27934459 = (container, axis)=>{
    const startScrollingFrom = container[axis.size] * (0, $CBqIn.default).startFromPercentage;
    const maxScrollValueAt = container[axis.size] * (0, $CBqIn.default).maxScrollAtPercentage;
    const thresholds = {
        startScrollingFrom: startScrollingFrom,
        maxScrollValueAt: maxScrollValueAt
    };
    return thresholds;
};
var $6206878988e06aa9$export$2e2bcd8739ae039 = $6206878988e06aa9$export$79446fee27934459;

});
parcelRegister("CBqIn", function(module, exports) {

$parcel$export(module.exports, "default", () => $22e1c26e7adafc61$export$2e2bcd8739ae039);
// Source: https://github.com/atlassian/react-beautiful-dnd
// Values used to control how the fluid auto scroll feels
const $22e1c26e7adafc61$var$config = {
    // percentage distance from edge of container:
    startFromPercentage: 0.25,
    maxScrollAtPercentage: 0.05,
    // pixels per frame
    maxPixelScroll: 28,
    // A function used to ease a percentage value
    // A simple linear function would be: (percentage) => percentage;
    // percentage is between 0 and 1
    // result must be between 0 and 1
    ease: (percentage)=>Math.pow(percentage, 2),
    durationDampening: {
        // ms: how long to dampen the speed of an auto scroll from the start of a drag
        stopDampeningAt: 1200,
        // ms: when to start accelerating the reduction of duration dampening
        accelerateAt: 360
    }
};
var $22e1c26e7adafc61$export$2e2bcd8739ae039 = $22e1c26e7adafc61$var$config;

});


parcelRegister("j3mW5", function(module, exports) {

$parcel$export(module.exports, "default", () => $4138cfd10b8d6cb6$export$2e2bcd8739ae039);
// Source: https://github.com/atlassian/react-beautiful-dnd

var $1FJBN = parcelRequire("1FJBN");

var $GGnA2 = parcelRequire("GGnA2");

var $i7kxC = parcelRequire("i7kxC");
const $4138cfd10b8d6cb6$export$bf7199a9ebcb84a9 = ({ distanceToEdge: distanceToEdge, thresholds: thresholds, dragStartTime: dragStartTime, shouldUseTimeDampening: shouldUseTimeDampening })=>{
    const scroll = (0, $i7kxC.getValueFromDistance)(distanceToEdge, thresholds);
    // not enough distance to trigger a minimum scroll
    // we can bail here
    if (scroll === 0) return 0;
    // Dampen an auto scroll speed based on duration of drag
    if (!shouldUseTimeDampening) return scroll;
    // Once we know an auto scroll should occur based on distance,
    // we must let at least 1px through to trigger a scroll event an
    // another auto scroll call
    return Math.max((0, $GGnA2.dampenValueByTime)(scroll, dragStartTime), (0, $1FJBN.minScroll));
};
var $4138cfd10b8d6cb6$export$2e2bcd8739ae039 = $4138cfd10b8d6cb6$export$bf7199a9ebcb84a9;

});
parcelRegister("GGnA2", function(module, exports) {

$parcel$export(module.exports, "dampenValueByTime", () => $09e5877382e55f91$export$2fe468ff7a999ed6);
// Source: https://github.com/atlassian/react-beautiful-dnd

var $CBqIn = parcelRequire("CBqIn");

var $1FJBN = parcelRequire("1FJBN");

var $gYLmt = parcelRequire("gYLmt");
const $09e5877382e55f91$var$accelerateAt = (0, $CBqIn.default).durationDampening.accelerateAt;
const $09e5877382e55f91$var$stopAt = (0, $CBqIn.default).durationDampening.stopDampeningAt;
const $09e5877382e55f91$export$2fe468ff7a999ed6 = (proposedScroll, dragStartTime)=>{
    const startOfRange = dragStartTime;
    const endOfRange = $09e5877382e55f91$var$stopAt;
    const now = Date.now();
    const runTime = now - startOfRange;
    // we have finished the time dampening period
    if (runTime >= $09e5877382e55f91$var$stopAt) return proposedScroll;
    // Up to this point we know there is a proposed scroll
    // but we have not reached our accelerate point
    // Return the minimum amount of scroll
    if (runTime < $09e5877382e55f91$var$accelerateAt) return 0, $1FJBN.minScroll;
    const betweenAccelerateAtAndStopAtPercentage = (0, $gYLmt.getPercentage)({
        startOfRange: $09e5877382e55f91$var$accelerateAt,
        endOfRange: endOfRange,
        current: runTime
    });
    const scroll = proposedScroll * (0, $CBqIn.default).ease(betweenAccelerateAtAndStopAtPercentage);
    return Math.ceil(scroll);
};

});
parcelRegister("gYLmt", function(module, exports) {

$parcel$export(module.exports, "getPercentage", () => $ee56cf2a5b618f47$export$6712e0f6cd0ea03);
// Source: https://github.com/atlassian/react-beautiful-dnd
const $ee56cf2a5b618f47$export$6712e0f6cd0ea03 = ({ startOfRange: startOfRange, endOfRange: endOfRange, current: current })=>{
    const range = endOfRange - startOfRange;
    if (range === 0) /**
		 * Detected distance range of 0 in the auto scroller
		 * This is unexpected and would cause a divide by 0 issue.
		 * Not allowing an auto scroll
		 */ return 0;
    const currentInRange = current - startOfRange;
    const percentage = currentInRange / range;
    return percentage;
};

});


parcelRegister("i7kxC", function(module, exports) {

$parcel$export(module.exports, "getValueFromDistance", () => $6739aefbd53be9fe$export$f3e495573a199c91);
// Source: https://github.com/atlassian/react-beautiful-dnd

var $CBqIn = parcelRequire("CBqIn");

var $1FJBN = parcelRequire("1FJBN");

var $gYLmt = parcelRequire("gYLmt");
const $6739aefbd53be9fe$export$f3e495573a199c91 = (distanceToEdge, thresholds)=>{
    /*
  // This function only looks at the distance to one edge
  // Example: looking at bottom edge
  |----------------------------------|
  |                                  |
  |                                  |
  |                                  |
  |                                  |
  |                                  | => no scroll in this range
  |                                  |
  |                                  |
  |  startScrollingFrom (eg 100px)   |
  |                                  |
  |                                  | => increased scroll value the closer to maxScrollValueAt
  |  maxScrollValueAt (eg 10px)      |
  |                                  | => max scroll value in this range
  |----------------------------------|
  */ // too far away to auto scroll
    if (distanceToEdge > thresholds.startScrollingFrom) return 0;
    // use max speed when on or over boundary
    if (distanceToEdge <= thresholds.maxScrollValueAt) return (0, $CBqIn.default).maxPixelScroll;
    // when just going on the boundary return the minimum integer
    if (distanceToEdge === thresholds.startScrollingFrom) return 0, $1FJBN.minScroll;
    // to get the % past startScrollingFrom we will calculate
    // the % the value is from maxScrollValueAt and then invert it
    const percentageFromMaxScrollValueAt = (0, $gYLmt.getPercentage)({
        startOfRange: thresholds.maxScrollValueAt,
        endOfRange: thresholds.startScrollingFrom,
        current: distanceToEdge
    });
    const percentageFromStartScrollingFrom = 1 - percentageFromMaxScrollValueAt;
    const scroll = (0, $CBqIn.default).maxPixelScroll * (0, $CBqIn.default).ease(percentageFromStartScrollingFrom);
    // scroll will always be a positive integer
    return Math.ceil(scroll);
};

});





parcelRegister("91kec", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb7d3871adca53b5$export$2e2bcd8739ae039);
// Source: https://github.com/atlassian/react-beautiful-dnd

var $kuXkS = parcelRequire("kuXkS");

var $h3yff = parcelRequire("h3yff");
var $eb7d3871adca53b5$export$2e2bcd8739ae039 = ({ viewport: viewport, center: center, dragStartTime: dragStartTime, shouldUseTimeDampening: shouldUseTimeDampening })=>{
    const scroll = (0, $h3yff.default)({
        dragStartTime: dragStartTime,
        container: viewport.container,
        center: center,
        shouldUseTimeDampening: shouldUseTimeDampening
    });
    return scroll && (0, $kuXkS.canScrollWindow)(viewport, scroll) ? scroll : null;
};

});

parcelRegister("2kKFy", function(module, exports) {

$parcel$export(module.exports, "default", () => $02749ab18659f739$export$2e2bcd8739ae039);

var $bn5nT = parcelRequire("bn5nT");

var $iWYOC = parcelRequire("iWYOC");

var $bRP67 = parcelRequire("bRP67");
var $02749ab18659f739$export$2e2bcd8739ae039 = ()=>{
    const scroll = (0, $bRP67.default)();
    const maxScroll = (0, $iWYOC.default)();
    const top = scroll.y;
    const left = scroll.x;
    // window.innerHeight: includes scrollbars (not what we want)
    // document.clientHeight gives us the correct value when using the html5 doctype
    const doc = document.documentElement;
    // Using these values as they do not consider scrollbars
    // padding box, without scrollbar
    const width = doc.clientWidth;
    const height = doc.clientHeight;
    // Computed
    const right = left + width;
    const bottom = top + height;
    const container = (0, $bn5nT.getRect)({
        top: top,
        left: left,
        right: right,
        bottom: bottom
    });
    const viewport = {
        container: container,
        scroll: {
            current: scroll,
            max: maxScroll
        }
    };
    return viewport;
};

});
parcelRegister("iWYOC", function(module, exports) {

$parcel$export(module.exports, "default", () => $bb903add7ce77d90$export$2e2bcd8739ae039);

var $geSJi = parcelRequire("geSJi");
var $bb903add7ce77d90$export$2e2bcd8739ae039 = ()=>{
    const doc = document.documentElement;
    const maxScroll = (0, $geSJi.default)({
        // unclipped padding box, with scrollbar
        scrollHeight: doc.scrollHeight,
        scrollWidth: doc.scrollWidth,
        // clipped padding box, without scrollbar
        width: doc.clientWidth,
        height: doc.clientHeight
    });
    return maxScroll;
};

});
parcelRegister("geSJi", function(module, exports) {

$parcel$export(module.exports, "default", () => $b6c38d3b19198398$export$2e2bcd8739ae039);

var $6cABY = parcelRequire("6cABY");
var $b6c38d3b19198398$export$2e2bcd8739ae039 = ({ scrollHeight: scrollHeight, scrollWidth: scrollWidth, height: height, width: width })=>{
    const maxScroll = (0, $6cABY.subtract)(// full size
    {
        x: scrollWidth,
        y: scrollHeight
    }, // viewport size
    {
        x: width,
        y: height
    });
    const adjustedMaxScroll = {
        x: Math.max(0, maxScroll.x),
        y: Math.max(0, maxScroll.y)
    };
    return adjustedMaxScroll;
};

});


parcelRegister("bRP67", function(module, exports) {

$parcel$export(module.exports, "default", () => $a7d8599f91bb8874$export$2e2bcd8739ae039);
var // The browsers update document.documentElement.scrollTop and window.pageYOffset
// differently as the window scrolls.
// Webkit
// documentElement.scrollTop: no update. Stays at 0
// window.pageYOffset: updates to whole number
// Chrome
// documentElement.scrollTop: update with fractional value
// window.pageYOffset: update with fractional value
// FireFox
// documentElement.scrollTop: updates to whole number
// window.pageYOffset: updates to whole number
// IE11 (same as firefox)
// documentElement.scrollTop: updates to whole number
// window.pageYOffset: updates to whole number
// Edge (same as webkit)
// documentElement.scrollTop: no update. Stays at 0
// window.pageYOffset: updates to whole number
$a7d8599f91bb8874$export$2e2bcd8739ae039 = ()=>({
        x: window.pageXOffset,
        y: window.pageYOffset
    });

});





parcelRegister("7KPyi", function(module, exports) {

$parcel$export(module.exports, "default", () => $4944521059702c22$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ /* eslint-disable jsx-a11y/no-static-element-interactions */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $3R70n = parcelRequire("3R70n");

var $7Wjpo = parcelRequire("7Wjpo");

var $5ZQjJ = parcelRequire("5ZQjJ");
const $4944521059702c22$var$baseTrackStyles = null;
const $4944521059702c22$var$baseThumbStyles = null;
const $4944521059702c22$var$visibleStyles = null;
const $4944521059702c22$var$notVisibleStyles = null;
const $4944521059702c22$var$verticalTrackStyles = null;
const $4944521059702c22$var$horizontalTrackStyles = null;
const $4944521059702c22$var$verticalThumbStyles = null;
const $4944521059702c22$var$horizontalThumbStyles = null;
const $4944521059702c22$var$HorizontalThumb = ({ size: size, innerRef: innerRef, children: children, ...rest })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        "data-testid": "roadmap.timeline-table.main.custom-scrollbars.thumb-tracks.horizontal-thumb",
        ref: innerRef,
        style: {
            width: `${size}px`
        },
        ...rest,
        className: (0, $7JEyt.default)([
            "_kqswh2mm _2rko19bv _bfhkvrk4",
            "_4t3i1osq"
        ])
    }, children);
const $4944521059702c22$var$VerticalThumb = ({ size: size, innerRef: innerRef, children: children, ...rest })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        "data-testid": "roadmap.timeline-table.main.custom-scrollbars.thumb-tracks.vertical-thumb",
        ref: innerRef,
        style: {
            height: `${size}px`
        },
        ...rest,
        className: (0, $7JEyt.default)([
            "_kqswh2mm _2rko19bv _bfhkvrk4",
            "_1bsb1osq"
        ])
    }, children);
const $4944521059702c22$var$DraggableHorizontalThumb = (0, $3R70n.withDragObserver)($4944521059702c22$var$HorizontalThumb, (0, $7Wjpo.THUMB_DRAG_THRESHOLD));
const $4944521059702c22$var$DraggableVerticalThumb = (0, $3R70n.withDragObserver)($4944521059702c22$var$VerticalThumb, (0, $7Wjpo.THUMB_DRAG_THRESHOLD));
/* This component is responsible for displaying the custom track and thumb.
 *
 * Responding to user actions (e.g. clicking or dragging) are handled internally, while syncing with changes from external
 * sources (e.g. window resizes) are managed by the parent component via a custom ref. The track dimensions are not a 1:1
 * recreation of the real track, since it is only displayed over the timeline, and so all parameters from the parent are
 * "viewport relative" and translated internally to "track relative" coordinate system.
 */ const $4944521059702c22$var$ScrollbarThumbTracks = ({ listWidth: listWidth, isHideScrollbar: isHideScrollbar, timelineTop: timelineTop, onSetScrollLeft: onSetScrollLeft, onSetScrollTop: onSetScrollTop }, ref)=>{
    const horizontalTrackRef = (0, $eUqFw.useRef)(null);
    const horizontalThumbRef = (0, $eUqFw.useRef)(null);
    const verticalTrackRef = (0, $eUqFw.useRef)(null);
    const verticalThumbRef = (0, $eUqFw.useRef)(null);
    const dragCache = (0, $eUqFw.useRef)((0, $7Wjpo.DEFAULT_DRAG_CACHE));
    // State updates are not batched outside React synthetic events so we consolidate the data here
    const [{ horizontalThumbSize: horizontalThumbSize, verticalThumbSize: verticalThumbSize }, setThumbSizes] = (0, $eUqFw.useState)({
        horizontalThumbSize: 0,
        verticalThumbSize: 0
    });
    // ========================= //
    // === IMPERATIVE EFFECT === //
    // ========================= //
    const setHorizontalThumbPosition = (0, $eUqFw.useCallback)((trackSize, scrollRatio, thumbSize)=>{
        if (scrollRatio >= 0) {
            const position = (0, $5ZQjJ.getThumbPosition)(scrollRatio, trackSize, thumbSize);
            if (horizontalThumbRef.current) horizontalThumbRef.current.style.transform = `translateX(${position}px)`;
        }
    }, []);
    const setVerticalThumbPosition = (0, $eUqFw.useCallback)((trackSize, scrollRatio, thumbSize)=>{
        if (scrollRatio >= 0) {
            const position = (0, $5ZQjJ.getThumbPosition)(scrollRatio, trackSize, thumbSize);
            if (verticalThumbRef.current) verticalThumbRef.current.style.transform = `translateY(${position}px)`;
        }
    }, []);
    (0, $eUqFw.useImperativeHandle)(ref, ()=>({
            setThumbPositions: ({ horizontalScrollRatio: horizontalScrollRatio, verticalScrollRatio: verticalScrollRatio })=>{
                if (!horizontalTrackRef.current || !verticalTrackRef.current) throw new Error('An element required to set the thumb positions were null');
                // DOM reads //
                const { clientWidth: clientWidth } = horizontalTrackRef.current;
                const { clientHeight: clientHeight } = verticalTrackRef.current;
                // DOM writes //
                setHorizontalThumbPosition(clientWidth, horizontalScrollRatio, horizontalThumbSize);
                setVerticalThumbPosition(clientHeight, verticalScrollRatio, verticalThumbSize);
            },
            update: ({ horizontalScrollRatio: horizontalScrollRatio, verticalScrollRatio: verticalScrollRatio }, { horizontalContentRatio: horizontalContentRatio, verticalContentRatio: verticalContentRatio })=>{
                if (!horizontalTrackRef.current || !verticalTrackRef.current) throw new Error('An element required to update the thumb tracks were null');
                // DOM reads //
                const { clientWidth: clientWidth } = horizontalTrackRef.current;
                const { clientHeight: clientHeight } = verticalTrackRef.current;
                let hThumbSize = 0;
                let vThumbSize = 0;
                // DOM writes //
                if (horizontalContentRatio < 1) {
                    hThumbSize = (0, $5ZQjJ.getThumbSize)(horizontalContentRatio, clientWidth);
                    setHorizontalThumbPosition(clientWidth, horizontalScrollRatio, hThumbSize);
                }
                if (verticalContentRatio < 1) {
                    vThumbSize = (0, $5ZQjJ.getThumbSize)(verticalContentRatio, clientHeight);
                    setVerticalThumbPosition(clientHeight, verticalScrollRatio, vThumbSize);
                }
                setThumbSizes((0, $5ZQjJ.getMemoisedThumbState)(hThumbSize, vThumbSize));
            }
        }), [
        horizontalThumbSize,
        verticalThumbSize,
        setHorizontalThumbPosition,
        setVerticalThumbPosition
    ]);
    // ===================================== //
    // ==== EVENT HANDLING - HORIZONTAL ==== //
    // ===================================== //
    const onStartDragHorizontalThumb = ({ x: x })=>{
        if (!horizontalTrackRef.current || !horizontalThumbRef.current) throw new Error('An element required to drag the horizontal scroll thumb was null');
        const { left: left, width: width } = horizontalTrackRef.current.getBoundingClientRect();
        const thumbClientRect = horizontalThumbRef.current.getBoundingClientRect();
        const relativeMousePosition = x - thumbClientRect.left;
        dragCache.current = {
            thumbOrigin: Math.round(horizontalThumbSize / 2 - relativeMousePosition),
            trackPosition: left,
            trackSize: width
        };
    };
    const onDragHorizontalThumb = (from, to)=>{
        const { thumbOrigin: thumbOrigin, trackPosition: trackPosition, trackSize: trackSize } = dragCache.current;
        const relativeScrollPosition = (0, $5ZQjJ.getRelativeScrollPosition)({
            thumbPosition: thumbOrigin + to.x,
            thumbSize: horizontalThumbSize,
            trackPosition: trackPosition,
            trackSize: trackSize
        });
        onSetScrollLeft(relativeScrollPosition);
    };
    const onMouseDownHorizontalTrack = (event)=>{
        const { left: left, width: width } = event.currentTarget.getBoundingClientRect();
        const relativeScrollPosition = (0, $5ZQjJ.getRelativeScrollPosition)({
            thumbPosition: event.pageX,
            thumbSize: horizontalThumbSize,
            trackPosition: left,
            trackSize: width
        });
        onSetScrollLeft(relativeScrollPosition);
    };
    // =================================== //
    // ==== EVENT HANDLING - VERTICAL ==== //
    // =================================== //
    const onStartDragVerticalThumb = ({ y: y })=>{
        if (!verticalTrackRef.current || !verticalThumbRef.current) throw new Error('An element required to drag the vertical scroll thumb was null');
        const { top: top, height: height } = verticalTrackRef.current.getBoundingClientRect();
        const thumbClientRect = verticalThumbRef.current.getBoundingClientRect();
        const relativeMousePosition = y - thumbClientRect.top;
        dragCache.current = {
            thumbOrigin: Math.round(verticalThumbSize / 2 - relativeMousePosition),
            trackPosition: top,
            trackSize: height
        };
    };
    const onDragVerticalThumb = (from, to)=>{
        const { thumbOrigin: thumbOrigin, trackPosition: trackPosition, trackSize: trackSize } = dragCache.current;
        const relativeScrollPosition = (0, $5ZQjJ.getRelativeScrollPosition)({
            thumbPosition: thumbOrigin + to.y,
            thumbSize: verticalThumbSize,
            trackPosition: trackPosition,
            trackSize: trackSize
        });
        onSetScrollTop(relativeScrollPosition);
    };
    const onMouseDownVerticalTrack = (event)=>{
        const { top: top, height: height } = event.currentTarget.getBoundingClientRect();
        const relativeScrollPosition = (0, $5ZQjJ.getRelativeScrollPosition)({
            thumbPosition: event.pageY,
            thumbSize: verticalThumbSize,
            trackPosition: top,
            trackSize: height
        });
        onSetScrollTop(relativeScrollPosition);
    };
    // ================ //
    // ==== RENDER ==== //
    // ================ //
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        ref: horizontalTrackRef,
        "data-testid": "roadmap.timeline-table.main.custom-scrollbars.thumb-tracks.horizontal-track",
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            left: `${listWidth + (0, $7Wjpo.SCROLLBAR_OFFSET)}px`
        },
        onMouseDown: onMouseDownHorizontalTrack,
        className: (0, $7JEyt.default)([
            "_kqswstnw _2rko19bv _1pbyibnn _o7ks1fkz _irr31409 _1di61409",
            horizontalThumbSize > 0 && !isHideScrollbar ? "_3um0ewfl" : "_3um015vq",
            "_1xi21v6z _4t3i19bv _94n5idpf"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4944521059702c22$var$DraggableHorizontalThumb, {
        // TODO: Not sure how to type innerRef when it's not an styled component. Is it due to DraggableHorizontalThumb being a class component?
        // @ts-expect-error - TS2322 - Type '{ innerRef: MutableRefObject<unknown>; size: number; onDrag: OnDrag; onDragStart: OnDragStart; }' is not assignable to type 'IntrinsicAttributes & IntrinsicClassAttributes<DragObserver> & Pick<Readonly<Props> & Readonly<...>, "children"> & Partial<...> & Partial<...>'.
        innerRef: horizontalThumbRef,
        size: horizontalThumbSize,
        onDrag: onDragHorizontalThumb,
        onDragStart: onStartDragHorizontalThumb
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        ref: verticalTrackRef,
        "data-testid": "roadmap.timeline-table.main.custom-scrollbars.thumb-tracks.vertical-track",
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            top: `${timelineTop + (0, $7Wjpo.SCROLLBAR_OFFSET)}px`
        },
        onMouseDown: onMouseDownVerticalTrack,
        className: (0, $7JEyt.default)([
            "_kqswstnw _2rko19bv _1pbyibnn _o7ks1fkz _irr31409 _1di61409",
            verticalThumbSize > 0 && !isHideScrollbar ? "_3um0ewfl" : "_3um015vq",
            "_94n51v6z _1bsb19bv _1xi2idpf"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4944521059702c22$var$DraggableVerticalThumb, {
        // TODO: Not sure how to type innerRef when it's not an styled component. Is it due to DraggableHorizontalThumb being a class component?
        // @ts-expect-error - TS2322 - Type '{ innerRef: MutableRefObject<unknown>; size: number; onDrag: OnDrag; onDragStart: OnDragStart; }' is not assignable to type 'IntrinsicAttributes & IntrinsicClassAttributes<DragObserver> & Pick<Readonly<Props> & Readonly<...>, "children"> & Partial<...> & Partial<...>'.
        innerRef: verticalThumbRef,
        size: verticalThumbSize,
        onDrag: onDragVerticalThumb,
        onDragStart: onStartDragVerticalThumb
    })));
};
var $4944521059702c22$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.forwardRef)($4944521059702c22$var$ScrollbarThumbTracks);

});
parcelRegister("7Wjpo", function(module, exports) {

$parcel$export(module.exports, "THUMB_DRAG_THRESHOLD", () => $aff5bb37216db935$export$e42a8c8f5541f7b0);
$parcel$export(module.exports, "THUMB_MINIMUM_SIZE", () => $aff5bb37216db935$export$e68be48bcc227668);
$parcel$export(module.exports, "SCROLLBAR_OFFSET", () => $aff5bb37216db935$export$b902a3a0053e40b);
$parcel$export(module.exports, "DEFAULT_DRAG_CACHE", () => $aff5bb37216db935$export$1580f12b2bee9a05);
const $aff5bb37216db935$export$e42a8c8f5541f7b0 = 0.1;
const $aff5bb37216db935$export$e68be48bcc227668 = 20;
const $aff5bb37216db935$export$d83d7e5e215aa7f9 = 10;
const $aff5bb37216db935$export$b902a3a0053e40b = 7;
const $aff5bb37216db935$export$1580f12b2bee9a05 = {
    thumbOrigin: 0,
    trackPosition: 0,
    trackSize: 0
};

});

parcelRegister("5ZQjJ", function(module, exports) {

$parcel$export(module.exports, "getRelativeScrollPosition", () => $f982f1b365577dba$export$2bc8e9ae2ef96ba4);
$parcel$export(module.exports, "getThumbPosition", () => $f982f1b365577dba$export$1bcd41904c090870);
$parcel$export(module.exports, "getThumbSize", () => $f982f1b365577dba$export$7b14c3f3cc4d1eca);
$parcel$export(module.exports, "getMemoisedThumbState", () => $f982f1b365577dba$export$1c021ba4dc4fcf31);

var $5iWql = parcelRequire("5iWql");

var $7Wjpo = parcelRequire("7Wjpo");
const $f982f1b365577dba$export$2bc8e9ae2ef96ba4 = ({ thumbPosition: thumbPosition, thumbSize: thumbSize, trackPosition: trackPosition, trackSize: trackSize })=>{
    const relativePosition = thumbPosition - trackPosition;
    const newThumbOffset = relativePosition - thumbSize / 2;
    return newThumbOffset / trackSize;
};
const $f982f1b365577dba$export$1bcd41904c090870 = (scrollOffsetRatio, trackSize, thumbSize)=>scrollOffsetRatio * (trackSize - thumbSize);
const $f982f1b365577dba$export$7b14c3f3cc4d1eca = (contentToViewportRatio, trackSize)=>{
    const size = Math.round(contentToViewportRatio * trackSize);
    return Math.max((0, $7Wjpo.THUMB_MINIMUM_SIZE), size);
};
const $f982f1b365577dba$export$1c021ba4dc4fcf31 = (0, $5iWql.default)((horizontalThumbSize, verticalThumbSize)=>({
        horizontalThumbSize: horizontalThumbSize,
        verticalThumbSize: verticalThumbSize
    }));

});


parcelRegister("4RNyl", function(module, exports) {

$parcel$export(module.exports, "getScrollbarSize", () => $4d5d7e886d05d40e$export$728dbf35b325565b);
$parcel$export(module.exports, "getScrollOffsetRatio", () => $4d5d7e886d05d40e$export$1fb2953abd799768);
$parcel$export(module.exports, "getContentToViewportRatio", () => $4d5d7e886d05d40e$export$e27ceda66fe97870);
$parcel$export(module.exports, "getViewportOffsets", () => $4d5d7e886d05d40e$export$af20ae2261e1a891);

var $5iWql = parcelRequire("5iWql");
const $4d5d7e886d05d40e$export$728dbf35b325565b = (scrollElement)=>scrollElement.offsetWidth - scrollElement.clientWidth;
const $4d5d7e886d05d40e$export$1fb2953abd799768 = (scrollOffset, scrollSize, clientSize)=>scrollOffset / (scrollSize - clientSize);
const $4d5d7e886d05d40e$export$e27ceda66fe97870 = (scrollSize, clientSize)=>clientSize / scrollSize;
const $4d5d7e886d05d40e$export$af20ae2261e1a891 = (0, $5iWql.default)((scrollbarSize, listWidth, timelineTop)=>({
        scrollbar: scrollbarSize,
        timelineLeft: listWidth,
        timelineTop: timelineTop
    }));

});


parcelRegister("jV7n9", function(module, exports) {

$parcel$export(module.exports, "default", () => $a2c727e6f00ceb62$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
parcelRequire("3f2za");
var $jFl9L = parcelRequire("jFl9L");

var $eo9PV = parcelRequire("eo9PV");

var $1ybV0 = parcelRequire("1ybV0");

var $gf0vG = parcelRequire("gf0vG");

var $9WNLk = parcelRequire("9WNLk");
var $cZkk1 = parcelRequire("cZkk1");

var $bwj1b = parcelRequire("bwj1b");

var $1sAbG = parcelRequire("1sAbG");
const $a2c727e6f00ceb62$var$DragMonitor = ({ DndLongTaskMetric: DndLongTaskMetric })=>{
    const [{ isTreeDrag: isTreeDrag }] = (0, $9WNLk.useEnablements)();
    const [dragState, setDragState] = (0, $eUqFw.useState)({
        level: (0, $gf0vG.DEFAULT_LEVEL),
        isDragging: false
    });
    const { onRowDragStart: onRowDragStart, onRowDragEnd: onRowDragEnd, onRowDragOutOfBounds: onRowDragOutOfBounds } = (0, $bwj1b.useSideEffectMarshal)();
    const { onResize: onResize } = (0, $cZkk1.useTimelineViewportActions)();
    // Effects //
    (0, $eUqFw.useEffect)(()=>(0, $jFl9L.combine)((0, $eo9PV.monitorForElements)({
            onDragStart: ({ source: source })=>{
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                const item = source.data;
                if (item.type === (0, $gf0vG.ROW_DRAG_AND_DROP_ID)) {
                    onRowDragStart(item.id);
                    setDragState({
                        level: item.level,
                        isDragging: true
                    });
                }
            },
            onDropTargetChange: ({ source: source, location: location })=>{
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                const item = source.data;
                if (item.type === (0, $gf0vG.ROW_DRAG_AND_DROP_ID)) {
                    const { dropTargets: dropTargets } = location.current;
                    if (dropTargets.length === 0) onRowDragOutOfBounds(item.id);
                }
            },
            onDrop: ({ source: source })=>{
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                const item = source.data;
                if (item.type === (0, $gf0vG.ROW_DRAG_AND_DROP_ID)) {
                    onRowDragEnd(item.id);
                    setDragState({
                        level: item.level,
                        isDragging: false
                    });
                    if ((0, $1ybV0.ff)('jwm.visual-hierarchy-dnd') && isTreeDrag) onResize({
                        indicatorLineOffset: 0
                    });
                }
            }
        })), [
        onRowDragStart,
        onRowDragEnd,
        onRowDragOutOfBounds,
        onResize,
        isTreeDrag
    ]);
    return DndLongTaskMetric ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(DndLongTaskMetric, {
        isDragging: dragState.isDragging,
        metricType: (0, $1sAbG.isBaseLevel)(dragState.level) ? (0, $gf0vG.CHILD_LIST_DRAG_AND_DROP) : (0, $gf0vG.LIST_DRAG_AND_DROP)
    }) : null;
};
const $a2c727e6f00ceb62$var$DragMonitorEnabler = (props)=>{
    const [{ isDragEnabled: isDragEnabled }] = (0, $9WNLk.useEnablements)();
    return isDragEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a2c727e6f00ceb62$var$DragMonitor, props) : null;
};
var $a2c727e6f00ceb62$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($a2c727e6f00ceb62$var$DragMonitorEnabler);

});

parcelRegister("76ouJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $0304c9169ced0897$export$2e2bcd8739ae039);

var $kwce8 = parcelRequire("kwce8");

var $eUqFw = parcelRequire("eUqFw");

var $jK1pm = parcelRequire("jK1pm");

var $gf0vG = parcelRequire("gf0vG");

var $hxnNZ = parcelRequire("hxnNZ");
var $9WNLk = parcelRequire("9WNLk");
var $VrUCp = parcelRequire("VrUCp");
var $3XwA1 = parcelRequire("3XwA1");

var $dWSuJ = parcelRequire("dWSuJ");

var $agwqh = parcelRequire("agwqh");

var $ffuBS = parcelRequire("ffuBS");

var $kbEZf = parcelRequire("kbEZf");

var $lYwpo = parcelRequire("lYwpo");
var $0304c9169ced0897$var$_StyledDiv = /*#__PURE__*/ (0, $kwce8.default)("div").withConfig({
    componentId: "zgn784-0"
})`${(p)=>p._css}`;
var $0304c9169ced0897$var$_StyledDiv2 = /*#__PURE__*/ (0, $kwce8.default)("div").withConfig({
    componentId: "zgn784-1"
})`${(p)=>p._css2}`;
var $0304c9169ced0897$var$_StyledDiv3 = /*#__PURE__*/ (0, $kwce8.default)("div").withConfig({
    componentId: "zgn784-2"
})`${(0, $lYwpo.dateHeaderCellsContainerStyles)}`;
var $0304c9169ced0897$var$_StyledDiv4 = /*#__PURE__*/ (0, $kwce8.default)("div").withConfig({
    componentId: "zgn784-3"
})`${(0, $lYwpo.headerRowStyles)}`;
var $0304c9169ced0897$var$_StyledDiv5 = /*#__PURE__*/ (0, $kwce8.default)("div").withConfig({
    componentId: "zgn784-4"
})`${(0, $lYwpo.subHeaderCellsContainerStyles)}`;
const $0304c9169ced0897$var$Header = ({ renderListHeaderItem: renderListHeaderItem, renderChartHeaderItem: renderChartHeaderItem })=>{
    const [{ headerItems: headerItems, headerHeight: headerHeight, isRowCountKnown: isRowCountKnown }] = (0, $VrUCp.useHeaderState)();
    const [{ timelineWidth: timelineWidth, timelineMode: timelineMode, timelineDuration: timelineDuration, columnDurations: columnDurations, today: today }] = (0, $3XwA1.useTimelineState)();
    const [isAtTop] = (0, $hxnNZ.isScrollToTop)();
    const [{ isHighlightToday: isHighlightToday }] = (0, $9WNLk.useEnablements)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jK1pm.default), {
        name: "timeline-table-header"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0304c9169ced0897$var$_StyledDiv, {
        role: "rowgroup",
        // @ts-expect-error Property 'css' does not exist on type 'DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>'.ts(2322)
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        style: {
            height: `${headerHeight}px`
        },
        _css: [
            (0, $lYwpo.headerContainerStyles),
            !isAtTop && (0, $dWSuJ.headerShadow)
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0304c9169ced0897$var$_StyledDiv2, {
        role: "row",
        "aria-rowindex": isRowCountKnown ? (0, $gf0vG.ITEMS_COUNT_OFFSET) : undefined,
        // @ts-expect-error Property 'css' does not exist on type 'DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>'.ts(2322)
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        _css2: [
            (0, $lYwpo.headerRowStyles),
            (0, $lYwpo.dateHeaderRowStyles)
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kbEZf.default), {
        id: (0, $gf0vG.DEFAULT_HEADER_ROW_ID),
        itemHeight: (0, $gf0vG.BASE_HEADER_HEIGHT),
        renderListHeaderItem: renderListHeaderItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0304c9169ced0897$var$_StyledDiv3, {
        style: {
            width: `${timelineWidth}px`
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffuBS.default), {
        today: today,
        timelineMode: timelineMode,
        timelineDuration: timelineDuration,
        columnDurations: columnDurations,
        isHighlightToday: isHighlightToday
    }))), headerItems.map(({ height: height = (0, $gf0vG.DEFAULT_SUBHEADER_HEIGHT), id: id }, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0304c9169ced0897$var$_StyledDiv4, {
            key: `sub-header-row-${id}`,
            "data-testid": `roadmap.timeline-table.main.header.sub-header-${id.toLowerCase()}`,
            role: "row",
            "aria-rowindex": isRowCountKnown ? (0, $gf0vG.ITEMS_COUNT_OFFSET) + index + 1 : undefined,
            // @ts-expect-error Property 'css' does not exist on type 'DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>'.ts(2322)
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            style: {
                height: `${height}px`
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kbEZf.default), {
            id: id,
            itemHeight: height,
            renderListHeaderItem: renderListHeaderItem
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0304c9169ced0897$var$_StyledDiv5, {
            role: "gridcell",
            tabIndex: -1,
            // @ts-expect-error Property 'css' does not exist on type 'DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>'.ts(2322)
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            style: {
                width: `${timelineWidth}px`,
                height: `${height}px`
            }
        }, renderChartHeaderItem({
            id: id
        })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $agwqh.default), {
        isOverlayInHeader: true
    })));
};
$0304c9169ced0897$var$Header.displayName = 'Header';
$0304c9169ced0897$var$Header.whyDidYouRender = true;
var $0304c9169ced0897$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($0304c9169ced0897$var$Header);

});
parcelRegister("ffuBS", function(module, exports) {

$parcel$export(module.exports, "default", () => $fb06481ff45031bb$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $gf0vG = parcelRequire("gf0vG");

var $l2CBN = parcelRequire("l2CBN");

var $dIvdb = parcelRequire("dIvdb");

var $83EWE = parcelRequire("83EWE");

var $7cCTq = parcelRequire("7cCTq");

var $ha3hq = parcelRequire("ha3hq");
const $fb06481ff45031bb$var$containerStyles = null;
const $fb06481ff45031bb$var$ChartCalendarCells = ({ isHighlightToday: isHighlightToday, today: today, timelineMode: timelineMode, timelineDuration: timelineDuration, columnDurations: columnDurations })=>{
    const renderWeekCells = (0, $eUqFw.useCallback)((columnPositions)=>{
        const todayCoordinates = isHighlightToday ? (0, $dIvdb.getTodayCoordinates)(today, columnDurations) : undefined;
        const columnWeekNumbers = (0, $dIvdb.getColumnWeekNumbers)(columnDurations);
        const yearCaptions = (0, $dIvdb.getColumnYearCaptions)(today, columnDurations);
        return columnPositions.map(([left, right], index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
                role: "columnheader",
                tabIndex: -1,
                key: `week-cell-${index}`,
                xcss: $fb06481ff45031bb$var$cellStylesNew,
                style: {
                    left: `${left}%`,
                    right: `${right}%`
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ha3hq.default), {
                columnIndex: index,
                isHighlightToday: isHighlightToday,
                todayCoordinates: todayCoordinates,
                weekNumbers: columnWeekNumbers[index],
                yearCaption: yearCaptions[index]
            })));
    }, [
        isHighlightToday,
        today,
        columnDurations
    ]);
    const renderMonthCells = (0, $eUqFw.useCallback)((columnPositions)=>{
        const columnMonthNumbers = (0, $dIvdb.getColumnMonthNumbers)(columnDurations);
        const yearCaptions = (0, $dIvdb.getColumnYearCaptions)(today, columnDurations);
        return columnPositions.map(([left, right], index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
                role: "columnheader",
                tabIndex: -1,
                key: `month-cell-${index}`,
                xcss: $fb06481ff45031bb$var$cellStylesNew,
                style: {
                    left: `${left}%`,
                    right: `${right}%`
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $83EWE.default), {
                monthNumber: columnMonthNumbers[index],
                yearCaption: yearCaptions[index]
            })));
    }, [
        today,
        columnDurations
    ]);
    const renderQuarterCells = (0, $eUqFw.useCallback)((columnPositions)=>{
        const columnQuarterNumbers = (0, $dIvdb.getColumnQuarterNumbers)(columnDurations);
        const yearCaptions = (0, $dIvdb.getColumnYearCaptions)(today, columnDurations);
        return columnPositions.map(([left, right], index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
                role: "columnheader",
                tabIndex: -1,
                key: `quarter-cell-${index}`,
                xcss: $fb06481ff45031bb$var$cellStylesNew,
                style: {
                    left: `${left}%`,
                    right: `${right}%`
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7cCTq.default), {
                quarterNumber: columnQuarterNumbers[index],
                yearCaption: yearCaptions[index]
            })));
    }, [
        today,
        columnDurations
    ]);
    const renderColumnsForMode = (0, $eUqFw.useCallback)(()=>{
        const columnPositions = (0, $l2CBN.getColumnPositions)(timelineDuration, columnDurations);
        if (timelineMode === (0, $gf0vG.WEEKS)) return renderWeekCells(columnPositions);
        if (timelineMode === (0, $gf0vG.MONTHS)) return renderMonthCells(columnPositions);
        return renderQuarterCells(columnPositions);
    }, [
        timelineMode,
        columnDurations,
        timelineDuration,
        renderWeekCells,
        renderMonthCells,
        renderQuarterCells
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: (0, $7JEyt.default)([
            "_kqswh2mm _1bsb1osq _4t3i1osq"
        ])
    }, renderColumnsForMode());
};
$fb06481ff45031bb$var$ChartCalendarCells.displayName = 'ChartCalendarCells';
$fb06481ff45031bb$var$ChartCalendarCells.whyDidYouRender = true;
var $fb06481ff45031bb$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($fb06481ff45031bb$var$ChartCalendarCells);
const $fb06481ff45031bb$var$cellStylesNew = (0, $1ZAYh.xcss)({
    position: 'absolute',
    top: "var(--ds-space-0, 0)",
    bottom: "var(--ds-space-0, 0)",
    flex: '0 0 auto',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    boxSizing: 'border-box'
});

});
parcelRegister("dIvdb", function(module, exports) {

$parcel$export(module.exports, "getColumnMonthNumbers", () => $fc19ef0a671248fd$export$2db9691736ad99a0);
$parcel$export(module.exports, "getColumnQuarterNumbers", () => $fc19ef0a671248fd$export$f8f2585f7189f116);
$parcel$export(module.exports, "getColumnYearCaptions", () => $fc19ef0a671248fd$export$318e116da7ff1363);
$parcel$export(module.exports, "getColumnWeekNumbers", () => $fc19ef0a671248fd$export$a1fb8a69eea17cba);
$parcel$export(module.exports, "getTodayCoordinates", () => $fc19ef0a671248fd$export$1c186d1bc45d38b7);

var $5iWql = parcelRequire("5iWql");

var $jJwwt = parcelRequire("jJwwt");

var $l2CBN = parcelRequire("l2CBN");
const $fc19ef0a671248fd$export$2db9691736ad99a0 = (0, $5iWql.default)((columnDurations)=>columnDurations.map((columnDuration)=>(0, (/*@__PURE__*/$parcel$interopDefault($jJwwt))).utc(columnDuration.startMilliseconds).month()));
const $fc19ef0a671248fd$export$f8f2585f7189f116 = (0, $5iWql.default)((columnDurations)=>columnDurations.map((columnDuration)=>(0, (/*@__PURE__*/$parcel$interopDefault($jJwwt))).utc(columnDuration.startMilliseconds).quarter() - 1));
const $fc19ef0a671248fd$export$318e116da7ff1363 = (0, $5iWql.default)((today, columnDurations)=>{
    const startOfCurrentYear = (0, (/*@__PURE__*/$parcel$interopDefault($jJwwt))).utc(today).startOf('year').valueOf();
    const endOfCurrentYear = (0, (/*@__PURE__*/$parcel$interopDefault($jJwwt))).utc(today).endOf('year').valueOf();
    let cachedYear;
    let nextYear;
    /* Optimisation! Only calculate a caption when the year changes and interpolate the remaining values.
		 * This makes a substantial difference for granular timeline modes (e.g. weeks). */ return columnDurations.map(({ startMilliseconds: startMilliseconds })=>{
        if (startMilliseconds < startOfCurrentYear || startMilliseconds > endOfCurrentYear) {
            if (!cachedYear || startMilliseconds >= nextYear) {
                const columnMoment = (0, (/*@__PURE__*/$parcel$interopDefault($jJwwt))).utc(startMilliseconds);
                cachedYear = `'${columnMoment.year().toString().slice(2)}`;
                nextYear = columnMoment.add(1, 'year').startOf('year').valueOf();
            }
            return cachedYear;
        }
        return undefined;
    });
});
const $fc19ef0a671248fd$export$a1fb8a69eea17cba = (0, $5iWql.default)((columnDurations)=>{
    const daysArray = [
        ...new Array(7)
    ];
    /* Optimisation! By leveraging moment's mutative paradigm we can avoid creating an
	 * expensive moment object for every inner loop - or O(N) vs O(N^2) work. */ return columnDurations.map(({ startMilliseconds: startMilliseconds })=>{
        const columnMoment = (0, (/*@__PURE__*/$parcel$interopDefault($jJwwt))).utc(startMilliseconds);
        const weekNumbers = daysArray.map(()=>{
            const data = {
                day: columnMoment.date(),
                month: columnMoment.month()
            };
            columnMoment.add(1, 'day');
            return data;
        });
        return weekNumbers;
    });
});
const $fc19ef0a671248fd$export$1c186d1bc45d38b7 = (0, $5iWql.default)((today, columnDurations)=>{
    let todayDayIndex = 0;
    const todayNumber = (0, (/*@__PURE__*/$parcel$interopDefault($jJwwt))).utc(today).date();
    const todayColumnIndex = (0, $l2CBN.getTodayColumnIndex)(today, columnDurations);
    const weekNumbers = $fc19ef0a671248fd$export$a1fb8a69eea17cba(columnDurations);
    const weekOfToday = weekNumbers[todayColumnIndex];
    weekOfToday.forEach((weekNumber, index)=>{
        if (weekNumber.day === todayNumber) todayDayIndex = index;
    });
    return [
        todayColumnIndex,
        todayDayIndex
    ];
});

});

parcelRegister("83EWE", function(module, exports) {

$parcel$export(module.exports, "default", () => $88d1318684ce6754$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $b3wt4 = parcelRequire("b3wt4");
const $88d1318684ce6754$var$headerStyles = null;
const $88d1318684ce6754$var$MonthCell = ({ monthNumber: monthNumber, yearCaption: yearCaption })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("small", {
        className: (0, $7JEyt.default)([
            "_1wyb1crf _syaz1rc1 _1p1dangw _19pkidpf"
        ])
    }, formatMessage((0, $b3wt4.inMonthOrder)[monthNumber]), " ", yearCaption);
};
$88d1318684ce6754$var$MonthCell.defaultProps = {
    yearCaption: null
};
var $88d1318684ce6754$export$2e2bcd8739ae039 = $88d1318684ce6754$var$MonthCell;

});
parcelRegister("b3wt4", function(module, exports) {

$parcel$export(module.exports, "inMonthOrder", () => $b9974530de653741$export$12c2656d1700ed6e);
$parcel$export(module.exports, "inQuarterOrder", () => $b9974530de653741$export$62f5e462247f69c8);

var $90IgZ = parcelRequire("90IgZ");
const $b9974530de653741$var$messages = (0, $90IgZ.defineMessages)({
    january: {
        "id": "roadmap.timeline-table.main.header.chart.calendar-cells.january",
        "defaultMessage": "Jan"
    },
    february: {
        "id": "roadmap.timeline-table.main.header.chart.calendar-cells.february",
        "defaultMessage": "Feb"
    },
    march: {
        "id": "roadmap.timeline-table.main.header.chart.calendar-cells.march",
        "defaultMessage": "Mar"
    },
    april: {
        "id": "roadmap.timeline-table.main.header.chart.calendar-cells.april",
        "defaultMessage": "Apr"
    },
    may: {
        "id": "roadmap.timeline-table.main.header.chart.calendar-cells.may",
        "defaultMessage": "May"
    },
    june: {
        "id": "roadmap.timeline-table.main.header.chart.calendar-cells.june",
        "defaultMessage": "Jun"
    },
    july: {
        "id": "roadmap.timeline-table.main.header.chart.calendar-cells.july",
        "defaultMessage": "Jul"
    },
    august: {
        "id": "roadmap.timeline-table.main.header.chart.calendar-cells.august",
        "defaultMessage": "Aug"
    },
    september: {
        "id": "roadmap.timeline-table.main.header.chart.calendar-cells.september",
        "defaultMessage": "Sep"
    },
    october: {
        "id": "roadmap.timeline-table.main.header.chart.calendar-cells.october",
        "defaultMessage": "Oct"
    },
    november: {
        "id": "roadmap.timeline-table.main.header.chart.calendar-cells.november",
        "defaultMessage": "Nov"
    },
    december: {
        "id": "roadmap.timeline-table.main.header.chart.calendar-cells.december",
        "defaultMessage": "Dec"
    },
    monday: {
        "id": "roadmap.timeline-table.main.header.chart.calendar-cells.monday",
        "defaultMessage": "M"
    },
    tuesday: {
        "id": "roadmap.timeline-table.main.header.chart.calendar-cells.tuesday",
        "defaultMessage": "T"
    },
    wednesday: {
        "id": "roadmap.timeline-table.main.header.chart.calendar-cells.wednesday",
        "defaultMessage": "W"
    },
    thursday: {
        "id": "roadmap.timeline-table.main.header.chart.calendar-cells.thursday",
        "defaultMessage": "T"
    },
    friday: {
        "id": "roadmap.timeline-table.main.header.chart.calendar-cells.friday",
        "defaultMessage": "F"
    },
    saturday: {
        "id": "roadmap.timeline-table.main.header.chart.calendar-cells.saturday",
        "defaultMessage": "S"
    },
    sunday: {
        "id": "roadmap.timeline-table.main.header.chart.calendar-cells.sunday",
        "defaultMessage": "S"
    }
});
const $b9974530de653741$export$b7dd7c64470aa506 = [
    $b9974530de653741$var$messages.monday,
    $b9974530de653741$var$messages.tuesday,
    $b9974530de653741$var$messages.wednesday,
    $b9974530de653741$var$messages.thursday,
    $b9974530de653741$var$messages.friday,
    $b9974530de653741$var$messages.saturday,
    $b9974530de653741$var$messages.sunday
];
const $b9974530de653741$export$12c2656d1700ed6e = [
    $b9974530de653741$var$messages.january,
    $b9974530de653741$var$messages.february,
    $b9974530de653741$var$messages.march,
    $b9974530de653741$var$messages.april,
    $b9974530de653741$var$messages.may,
    $b9974530de653741$var$messages.june,
    $b9974530de653741$var$messages.july,
    $b9974530de653741$var$messages.august,
    $b9974530de653741$var$messages.september,
    $b9974530de653741$var$messages.october,
    $b9974530de653741$var$messages.november,
    $b9974530de653741$var$messages.december
];
const $b9974530de653741$export$62f5e462247f69c8 = [
    {
        startMonth: $b9974530de653741$var$messages.january,
        endMonth: $b9974530de653741$var$messages.march
    },
    {
        startMonth: $b9974530de653741$var$messages.april,
        endMonth: $b9974530de653741$var$messages.june
    },
    {
        startMonth: $b9974530de653741$var$messages.july,
        endMonth: $b9974530de653741$var$messages.september
    },
    {
        startMonth: $b9974530de653741$var$messages.october,
        endMonth: $b9974530de653741$var$messages.december
    }
];
var $b9974530de653741$export$2e2bcd8739ae039 = $b9974530de653741$var$messages;

});


parcelRegister("7cCTq", function(module, exports) {

$parcel$export(module.exports, "default", () => $4bb700532c8612db$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $b3wt4 = parcelRequire("b3wt4");
const $4bb700532c8612db$var$headerStyles = null;
const $4bb700532c8612db$var$QuarterCell = ({ quarterNumber: quarterNumber, yearCaption: yearCaption })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { startMonth: startMonth, endMonth: endMonth } = (0, $b3wt4.inQuarterOrder)[quarterNumber];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("small", {
        className: (0, $7JEyt.default)([
            "_1wyb1crf _syaz1rc1 _1p1dangw _19pkidpf"
        ])
    }, `${formatMessage(startMonth)} \u{2013} ${formatMessage(endMonth)}`, " ", yearCaption);
};
$4bb700532c8612db$var$QuarterCell.defaultProps = {
    yearCaption: null
};
var $4bb700532c8612db$export$2e2bcd8739ae039 = $4bb700532c8612db$var$QuarterCell;

});

parcelRegister("ha3hq", function(module, exports) {

$parcel$export(module.exports, "default", () => $bedf6d784f14c050$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $b3wt4 = parcelRequire("b3wt4");
// Each day is 1/7th of a Week Cell in width
const $bedf6d784f14c050$var$dayWidth = 1 / 7 * 100;
const $bedf6d784f14c050$var$headerStyles = null;
const $bedf6d784f14c050$var$dayContainerStyles = null;
const $bedf6d784f14c050$var$dayChildTodayStyles = null;
const $bedf6d784f14c050$var$WeekCell = ({ columnIndex: columnIndex, weekNumbers: weekNumbers, todayCoordinates: todayCoordinates, yearCaption: yearCaption, isHighlightToday: isHighlightToday })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)(); // For the weeks granularity, the 4th day of the week determines the month that week falls in
    const monthNumber = weekNumbers[3].month;
    const todayIndex = weekNumbers.findIndex((element, i)=>isHighlightToday && todayCoordinates && todayCoordinates[0] === columnIndex && todayCoordinates[1] === i);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("small", {
        className: (0, $7JEyt.default)([
            "_1p1dangw _19pk1b66 _1wyb1skh _syaz1rc1"
        ])
    }, formatMessage((0, $b3wt4.inMonthOrder)[monthNumber]), " ", yearCaption), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: (0, $7JEyt.default)([
            "_1e0c1txw _16jlkb7n _1o9zkb7n _i0dl1wug _4cvr1h6o _1bsb1osq _4t3i1y7b _e2oo14zn _nzz51skh _13t319ii _15ai1h6o _c8i51hna _k907c5fp _kgm11nxw _1tjq1rc1 _1e85hkel _1pzyhkel _1fl41sit _u2op1sit"
        ])
    }, weekNumbers.map(({ day: day }, dayIndex)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
            key: `week-number-${dayIndex}`,
            className: (0, $7JEyt.default)([
                todayIndex === dayIndex && "_2rko1sit _bfhk1hdx _syazkmhu"
            ])
        }, day))));
};
$bedf6d784f14c050$var$WeekCell.defaultProps = {
    yearCaption: null
};
var $bedf6d784f14c050$export$2e2bcd8739ae039 = $bedf6d784f14c050$var$WeekCell;

});


parcelRegister("kbEZf", function(module, exports) {

$parcel$export(module.exports, "default", () => $1b6403bd5b4e1a95$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $eUqFw = parcelRequire("eUqFw");

var $gf0vG = parcelRequire("gf0vG");

var $nH3p1 = parcelRequire("nH3p1");

var $dWSuJ = parcelRequire("dWSuJ");
const $1b6403bd5b4e1a95$var$rowHeaderCellStyles = null;
const $1b6403bd5b4e1a95$var$dateRowHeaderContainerStyles = null;
const $1b6403bd5b4e1a95$var$subRowHeaderContainerStyles = null;
const $1b6403bd5b4e1a95$var$ListHeaderCell = ({ id: id, itemHeight: itemHeight, renderListHeaderItem: renderListHeaderItem })=>{
    const [listWidth] = (0, $nH3p1.useListWidth)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        role: "rowheader",
        tabIndex: -1,
        style: {
            width: `${listWidth}px`,
            height: `${itemHeight}px`
        },
        className: (0, $7JEyt.default)([
            "_kqsw1if8 _16jlidpf _1o9zidpf _i0dl1wug _1ltvidpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _bfhkvuon _2rkoo8o8 _1pby1ial"
        ])
    }, id === (0, $gf0vG.DEFAULT_HEADER_ROW_ID) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: (0, $7JEyt.default)([
            "_kqswstnw _vchhusvi _1bsb1osq _4t3i1osq _bfhk1s4m _x3do1hum _n7zl1hum _2rkoo8o8"
        ]),
        style: {
            "--_1p5ufam": (0, $9t7rW.default)((0, $dWSuJ.secondaryBorder))
        }
    }, renderListHeaderItem({
        id: id
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: (0, $7JEyt.default)([
            "_kqswstnw _1e0c1txw _16jlidpf _1o9zidpf _i0dl1wug _4cvr1h6o _vchhusvi _1bsb1osq _4t3i1osq _1yt4pn94 _n7zl1hum"
        ]),
        style: {
            "--_1p5ufam": (0, $9t7rW.default)((0, $dWSuJ.secondaryBorder))
        }
    }, renderListHeaderItem({
        id: id
    })));
};
var $1b6403bd5b4e1a95$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($1b6403bd5b4e1a95$var$ListHeaderCell);

});

parcelRegister("lYwpo", function(module, exports) {

$parcel$export(module.exports, "headerContainerStyles", () => $330b3430c925039b$export$80622f765113c5a3);
$parcel$export(module.exports, "headerRowStyles", () => $330b3430c925039b$export$ac13ea2b97aa033c);
$parcel$export(module.exports, "dateHeaderRowStyles", () => $330b3430c925039b$export$437be966288ab570);
$parcel$export(module.exports, "dateHeaderCellsContainerStyles", () => $330b3430c925039b$export$3fd06332d34fc8be);
$parcel$export(module.exports, "subHeaderCellsContainerStyles", () => $330b3430c925039b$export$58e1d2e8a54a1eec);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ parcelRequire("eUqFw");

var $PdmhA = parcelRequire("PdmhA");

var $gf0vG = parcelRequire("gf0vG");

var $dWSuJ = parcelRequire("dWSuJ");
const $330b3430c925039b$export$80622f765113c5a3 = {
    position: 'sticky',
    boxSizing: 'border-box',
    width: '100%',
    top: 0,
    background: `var(--ds-surface, ${(0, $PdmhA.N0)})`,
    borderRadius: `${"var(--ds-border-radius, 3px)"} 0 0 0`,
    zIndex: (0, $gf0vG.zIndex).ROW_HEADER
};
const $330b3430c925039b$export$ac13ea2b97aa033c = {
    position: 'relative',
    display: 'flex'
};
const $330b3430c925039b$export$437be966288ab570 = {
    height: `${(0, $gf0vG.BASE_HEADER_HEIGHT)}px`,
    backgroundColor: `var(--ds-background-neutral, ${(0, $PdmhA.N20)})`
};
const $330b3430c925039b$export$3fd06332d34fc8be = {
    position: 'relative',
    boxSizing: 'border-box',
    height: `${(0, $gf0vG.BASE_HEADER_HEIGHT)}px`,
    borderTop: (0, $dWSuJ.secondaryBorder),
    borderBottom: (0, $dWSuJ.secondaryBorder),
    zIndex: (0, $gf0vG.zIndex).HEADER
};
const $330b3430c925039b$export$58e1d2e8a54a1eec = {
    position: 'relative',
    boxSizing: 'border-box',
    display: 'flex',
    alignItems: 'center',
    padding: 0,
    borderBottom: (0, $dWSuJ.secondaryBorder),
    zIndex: (0, $gf0vG.zIndex).HEADER
};

});


parcelRegister("dqHZ6", function(module, exports) {

$parcel$export(module.exports, "default", () => $08d889c63df7e66d$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $iVIEg = parcelRequire("iVIEg");

var $hTLlD = parcelRequire("hTLlD");

var $bwj1b = parcelRequire("bwj1b");
/* Item selection styles are orchestrated via the style marshal since it has to
 * be synchronised across a row. As such, there is no need for an item component
 * to even know about whether it is selected, allowing us to maintain the selection
 * state without going deep into the tree. This also has performance benefits.
 */ const $08d889c63df7e66d$var$ItemsSelector = ({ selectedItemIds: selectedItemIds })=>{
    const { onRowSelect: onRowSelect, onRowDeselect: onRowDeselect } = (0, $bwj1b.useSideEffectMarshal)();
    const previousSelectedItemIds = (0, $eUqFw.useRef)(selectedItemIds);
    (0, $eUqFw.useEffect)(()=>{
        const unselectedItemIds = (0, (/*@__PURE__*/$parcel$interopDefault($iVIEg)))(previousSelectedItemIds.current, selectedItemIds);
        onRowDeselect(unselectedItemIds);
        onRowSelect(selectedItemIds);
    }, [
        previousSelectedItemIds,
        selectedItemIds,
        onRowSelect,
        onRowDeselect
    ]);
    (0, $eUqFw.useEffect)(()=>{
        previousSelectedItemIds.current = selectedItemIds;
    }, [
        selectedItemIds
    ]);
    return null;
};
var /* Having this update unnecessarily contributes to an unexpected lifecycle in the side-effect-marshal.
 * The simplest remedy for now is to deep compare the selected item ids. In future, we may want to integrate
 * the selection into the side-effect-marshal itself.
 */ $08d889c63df7e66d$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($08d889c63df7e66d$var$ItemsSelector, (0, (/*@__PURE__*/$parcel$interopDefault($hTLlD))));

});

parcelRegister("4d1OI", function(module, exports) {

$parcel$export(module.exports, "default", () => $acec9e8136ed9a63$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $eUqFw = parcelRequire("eUqFw");

var $nH3p1 = parcelRequire("nH3p1");

var $dWSuJ = parcelRequire("dWSuJ");
const $acec9e8136ed9a63$var$containerStyles = null;
const $acec9e8136ed9a63$var$listContainerStyles = null;
// NOTE: The borders here by nature are static overlay as they do not scroll with the Timeline
// However in Firefox / Safari, the elastic over-scroll feature needs the scrolling context to produce the bounce-back effect
// As a result, this component needs to be rendered inside the custom scrollbar instead of being rendered together with other static overlays
const $acec9e8136ed9a63$var$Borders = ()=>{
    const [listWidth] = (0, $nH3p1.useListWidth)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: (0, $7JEyt.default)([
            "_kqswstnw _154iidpf _94n5idpf _1ltvidpf _1bsb1osq _1pby1ial _lcxvglyw"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: (0, $7JEyt.default)([
            "_kqsw1if8 _vchhusvi _1ltvidpf _4t3i1osq _1s7z9fei _1kl71hum _2rkoo8o8"
        ]),
        style: {
            width: `${listWidth}px`,
            "--_drom5x": (0, $9t7rW.default)((0, $dWSuJ.secondaryBorderColor)),
            "--_1p5ufam": (0, $9t7rW.default)((0, $dWSuJ.secondaryBorder))
        }
    }));
};
var $acec9e8136ed9a63$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($acec9e8136ed9a63$var$Borders);

});

parcelRegister("ibHnm", function(module, exports) {

$parcel$export(module.exports, "default", () => $8098b08c293182fb$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $nH3p1 = parcelRequire("nH3p1");

var $bPBuf = parcelRequire("bPBuf");

var $jSCla = parcelRequire("jSCla");

var $4d1OI = parcelRequire("4d1OI");
const $8098b08c293182fb$var$StaticOverlay = ({ renderChartOverlay: renderChartOverlay })=>{
    const [listWidth] = (0, $nH3p1.useListWidth)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jSCla.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bPBuf.default), {
        listWidth: listWidth,
        renderChartOverlay: renderChartOverlay
    }));
};
$8098b08c293182fb$var$StaticOverlay.displayName = 'StaticOverlay';
$8098b08c293182fb$var$StaticOverlay.whyDidYouRender = true;
var $8098b08c293182fb$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($8098b08c293182fb$var$StaticOverlay);

});
parcelRegister("bPBuf", function(module, exports) {

$parcel$export(module.exports, "default", () => $f437bae228570065$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $iS6tD = parcelRequire("iS6tD");
const $f437bae228570065$var$containerStyles = null;
const $f437bae228570065$var$ChartOverlay = ({ listWidth: listWidth, renderChartOverlay: renderChartOverlay })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        style: {
            left: `${listWidth}px`
        },
        className: (0, $7JEyt.default)([
            "_kqswstnw _154iidpf _1xi2idpf _94n5idpf _1pby1o8a _lcxvglyw"
        ])
    }, renderChartOverlay(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iS6tD.default), null));
var $f437bae228570065$export$2e2bcd8739ae039 = $f437bae228570065$var$ChartOverlay;

});
parcelRegister("iS6tD", function(module, exports) {

$parcel$export(module.exports, "default", () => $7ba381a29a5fe79a$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $h829Y = parcelRequire("h829Y");
const $7ba381a29a5fe79a$var$containerStyles = null;
const $7ba381a29a5fe79a$var$PortalContainer = ()=>{
    const { setPortalContainerElement: setPortalContainerElement } = (0, $h829Y.usePortalScope)();
    const containerRef = (0, $eUqFw.useRef)(null);
    (0, $eUqFw.useEffect)(()=>{
        setPortalContainerElement(containerRef.current);
        return ()=>{
            setPortalContainerElement(null);
        };
    }, [
        setPortalContainerElement
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        ref: containerRef,
        className: (0, $7JEyt.default)([
            "_kqswstnw _lcxvglyw _1ltvidpf _154iidpf _94n5idpf _1xi2idpf _1pbyilow _ogto1994 _mkrz1fck"
        ])
    });
};
var $7ba381a29a5fe79a$export$2e2bcd8739ae039 = $7ba381a29a5fe79a$var$PortalContainer;

});


parcelRegister("jSCla", function(module, exports) {

$parcel$export(module.exports, "default", () => $2d43c05cb6501952$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $9WNLk = parcelRequire("9WNLk");
var $hxnNZ = parcelRequire("hxnNZ");

var $i0fOp = parcelRequire("i0fOp");

var $kvIXk = parcelRequire("kvIXk");

var $kQRc0 = parcelRequire("kQRc0");
const $2d43c05cb6501952$var$InlineIndicators = ()=>{
    const [{ isCreateSiblingEnabled: isCreateSiblingEnabled, isDragEnabled: isDragEnabled }] = (0, $9WNLk.useEnablements)();
    const [isScrollingY] = (0, $hxnNZ.useIsScrollingY)();
    const inlineIndicatorParams = (0, $kQRc0.useInlineIndicator)();
    if (isScrollingY) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, isCreateSiblingEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $i0fOp.default), inlineIndicatorParams), isDragEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kvIXk.default), inlineIndicatorParams));
};
var $2d43c05cb6501952$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($2d43c05cb6501952$var$InlineIndicators);

});
parcelRegister("i0fOp", function(module, exports) {

$parcel$export(module.exports, "default", () => $d6d8009549d23840$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $bkIGg = parcelRequire("bkIGg");

var $XHGTv = parcelRequire("XHGTv");

var $1ybV0 = parcelRequire("1ybV0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $gf0vG = parcelRequire("gf0vG");

var $fTs8H = parcelRequire("fTs8H");

var $fTs8H = parcelRequire("fTs8H");

var $fQIE0 = parcelRequire("fQIE0");
const $d6d8009549d23840$var$appear = null;
const $d6d8009549d23840$var$opacityTransitionStyles = null;
const $d6d8009549d23840$var$appearStyles = null;
const $d6d8009549d23840$var$opacityTransitionStylesOld = null;
const $d6d8009549d23840$var$iconWrapperStyles = null;
const $d6d8009549d23840$var$iconWrapperStylesOld = null;
const $d6d8009549d23840$var$iconContainerStyles = null;
const $d6d8009549d23840$var$lineStyles = null;
const $d6d8009549d23840$var$containerStylesOld = null;
const $d6d8009549d23840$var$containerStyles = null;
const $d6d8009549d23840$var$outerButtonStyles = null;
const $d6d8009549d23840$var$InlineCreateIndicator = ({ left: left, width: width })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    , {
        className: (0, $7JEyt.default)([
            (0, $1ybV0.ff)('jwm.visual-hierarchy-dnd') ? "_1e0cglyw _kqswstnw _154iidpf _1bsb1osq _1pbyibnn" : "_1e0cglyw _kqswstnw _154iidpf _1bsb1osq _1pbyzo7u",
            (0, $XHGTv.fg)('jsw_roadmaps_timeline-issue-creation-ally') && "",
            (0, $XHGTv.fg)('jsw_roadmaps_timeline-issue-creation-ally') && "_j7hq1wwu _tzy4idpf _5sagfnf5 _ju25188d _1o51q7pw",
            (0, $fTs8H.getInlineCreateButtonClassName)().className
        ]),
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            left: `${(0, $XHGTv.fg)('jsw_roadmaps_timeline-issue-creation-ally') ? left : left - (0, $gf0vG.HALF_INLINE_CREATE_ICON_WIDTH)}px`
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: (0, $7JEyt.default)([
            "_kqswh2mm _154i1lpd _1ltvidpf _4t3igktf _1bsb1r7l _80omtlke _7momkb7n _b59ukb7n"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        "data-component-selector": "line",
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            width: `${(0, $XHGTv.fg)('jsw_roadmaps_timeline-issue-creation-ally') ? width : width + (0, $gf0vG.HALF_INLINE_CREATE_ICON_WIDTH)}px`
        },
        className: (0, $7JEyt.default)([
            "_kqswh2mm _154irdoj _4t3iyh40 _bfhki2p0",
            !(0, $XHGTv.fg)('jsw_roadmaps_timeline-issue-creation-ally') && "_tzy4idpf _5sagfnf5 _ju25188d _1o51q7pw",
            !(0, $XHGTv.fg)('jsw_roadmaps_timeline-issue-creation-ally') && "",
            !(0, $XHGTv.fg)('jsw_roadmaps_timeline-issue-creation-ally') && "_j7hq1wwu"
        ])
    }), (0, $XHGTv.fg)('jsw_roadmaps_timeline-issue-creation-ally') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    , {
        className: (0, $7JEyt.default)([
            "_kqswstnw _4t3igktf _1bsbgktf _154iidpf _1ltv14id _bfhk1ffm _syaz15cr _2rko1sit",
            (0, $fTs8H.getInlineCreateIconClassName)().className
        ]),
        "data-component-selector": "icon-wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: (0, $7JEyt.default)([
            "_4t3i1tcg _1bsb1tcg _kqswh2mm _18u01i6y _19pk1i6y"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bkIGg))), {
        label: formatMessage((0, $fQIE0.default).label)
    }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        "data-component-selector": "icon-wrapper",
        className: (0, $7JEyt.default)([
            "_kqswstnw _4t3igktf _1bsbgktf _154iidpf _1ltvidpf _bfhk1ffm _syaz15cr _2rko1sit",
            "_tzy4idpf _5sagfnf5 _ju25188d _1o51q7pw",
            "_j7hq1wwu"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: (0, $7JEyt.default)([
            "_4t3i1tcg _1bsb1tcg _kqswh2mm _18u01i6y _19pk1i6y"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bkIGg))), {
        label: formatMessage((0, $fQIE0.default).label)
    })))));
};
var $d6d8009549d23840$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($d6d8009549d23840$var$InlineCreateIndicator);

});
parcelRegister("fQIE0", function(module, exports) {

$parcel$export(module.exports, "default", () => $491c28f451895164$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $491c28f451895164$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    label: {
        "id": "roadmap.timeline-table.main.static-overlay.inline-indicators.create.label",
        "defaultMessage": "What needs to be done?"
    }
});

});


parcelRegister("kvIXk", function(module, exports) {

$parcel$export(module.exports, "default", () => $e29ef442f38b9d95$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $fTs8H = parcelRequire("fTs8H");
const $e29ef442f38b9d95$var$containerStyles = null;
const $e29ef442f38b9d95$var$lineStyles = null;
const $e29ef442f38b9d95$var$InlineDragIndicator = ({ left: left, width: width })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        "data-testid": "roadmap.timeline-table.main.static-overlay.inline-indicators.drag.inline-drag-indicator",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $7JEyt.default)([
            "_1e0cglyw _kqswstnw _154iidpf _1bsb1osq _1pbyibnn",
            (0, $fTs8H.getDragIndicatorClassName)().className
        ]),
        style: {
            left: `${left}px`
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        style: {
            width: `${width}px`
        },
        className: (0, $7JEyt.default)([
            "_4t3iyh40 _bfhk1r2e _1kt9b3bt _1cs8stnw _kfgtidpf _1mp4idpf _1aukj39m _qnec1lpd _1pq812me _4k1c12me _1n1j18is"
        ])
    }));
var $e29ef442f38b9d95$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($e29ef442f38b9d95$var$InlineDragIndicator);

});

parcelRegister("kQRc0", function(module, exports) {

$parcel$export(module.exports, "useInlineIndicator", () => $f5c7298f96de85d5$export$27583fc2bcba0ca1);

var $eUqFw = parcelRequire("eUqFw");

var $1ybV0 = parcelRequire("1ybV0");

var $gf0vG = parcelRequire("gf0vG");

var $cZkk1 = parcelRequire("cZkk1");

var $ccgw3 = parcelRequire("ccgw3");
const $f5c7298f96de85d5$export$27583fc2bcba0ca1 = ()=>{
    const [{ left: left, clientWidth: clientWidth, indicatorLineOffset: indicatorLineOffset }] = (0, $cZkk1.useTimelineViewport)();
    const [params, setParams] = (0, $eUqFw.useState)({
        left: 0,
        width: 0
    });
    const viewportRef = (0, $eUqFw.useRef)(null);
    const setInlineIndicatorParams = (viewport)=>{
        if (viewport) setParams({
            left: viewport.getBoundingClientRect().left,
            width: viewport.clientWidth
        });
    };
    (0, $eUqFw.useEffect)(()=>{
        if (!clientWidth) {
            const viewport = document.getElementById((0, $gf0vG.TIMELINE_ID));
            viewportRef.current = viewport;
            setInlineIndicatorParams(viewport);
        }
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    const onContentResize = (0, $eUqFw.useCallback)(()=>{
        setInlineIndicatorParams(viewportRef.current);
    }, []);
    (0, $ccgw3.useResizeObserver)(viewportRef.current, onContentResize);
    const inlineIndicatorParams = (0, $eUqFw.useMemo)(()=>({
            left: viewportRef.current ? params.left : left,
            width: viewportRef.current ? params.width - indicatorLineOffset : clientWidth - indicatorLineOffset
        }), [
        params.left,
        params.width,
        left,
        indicatorLineOffset,
        clientWidth
    ]);
    const inlineIndicatorParamsOld = (0, $eUqFw.useMemo)(()=>({
            left: viewportRef.current ? params.left : left,
            width: viewportRef.current ? params.width : clientWidth
        }), [
        left,
        clientWidth,
        params.left,
        params.width
    ]);
    return (0, $1ybV0.ff)('jwm.visual-hierarchy-dnd') ? inlineIndicatorParams : inlineIndicatorParamsOld;
};

});



parcelRegister("4YDQS", function(module, exports) {

$parcel$export(module.exports, "getRenderersWithDefaults", () => $c832d37b3500f29e$export$59f24ad0cf4048d7);

var $5iWql = parcelRequire("5iWql");

var $dnP9l = parcelRequire("dnP9l");
const $c832d37b3500f29e$export$59f24ad0cf4048d7 = (0, $5iWql.default)((customRenderers)=>{
    const safeRenderers = {
        ...(0, $dnP9l.defaultRenderers),
        ...customRenderers
    };
    return {
        listRenderers: {
            renderListEmptyContent: safeRenderers.renderListEmptyContent,
            renderListItemContent: safeRenderers.renderListItemContent,
            renderListItemSecondaryContent: safeRenderers.renderListItemSecondaryContent,
            renderListItemCreate: safeRenderers.renderListItemCreate,
            renderListHeaderItem: safeRenderers.renderListHeaderItem
        },
        chartRenderers: {
            renderChartOverlay: safeRenderers.renderChartOverlay,
            renderChartItemContent: safeRenderers.renderChartItemContent,
            renderChartTimelineOverlay: safeRenderers.renderChartTimelineOverlay,
            renderChartHeaderItem: safeRenderers.renderChartHeaderItem
        },
        renderProvider: safeRenderers.renderProvider
    };
});

});
parcelRegister("dnP9l", function(module, exports) {

$parcel$export(module.exports, "defaultRenderers", () => $2c1666ebf6271bd8$export$2d95bc3f1f7b3d23);
// A renderer is effectively a no-op until it gets overridden
const $2c1666ebf6271bd8$var$DEFAULT_RENDERER = ()=>null;
const $2c1666ebf6271bd8$export$2d95bc3f1f7b3d23 = {
    renderListHeaderItem: $2c1666ebf6271bd8$var$DEFAULT_RENDERER,
    renderListEmptyContent: $2c1666ebf6271bd8$var$DEFAULT_RENDERER,
    renderListItemContent: $2c1666ebf6271bd8$var$DEFAULT_RENDERER,
    renderListItemSecondaryContent: $2c1666ebf6271bd8$var$DEFAULT_RENDERER,
    renderListItemCreate: $2c1666ebf6271bd8$var$DEFAULT_RENDERER,
    renderChartHeaderItem: $2c1666ebf6271bd8$var$DEFAULT_RENDERER,
    renderChartOverlay: $2c1666ebf6271bd8$var$DEFAULT_RENDERER,
    renderChartItemContent: $2c1666ebf6271bd8$var$DEFAULT_RENDERER,
    renderChartTimelineOverlay: $2c1666ebf6271bd8$var$DEFAULT_RENDERER,
    renderProvider: ({ children: children })=>children
};

});




parcelRegister("gB4dC", function(module, exports) {

$parcel$export(module.exports, "RoadmapListItemContentLite", () => $d3ebda59fb1111bb$export$6049b0f2a203677);

var $eUqFw = parcelRequire("eUqFw");

var $bScYc = parcelRequire("bScYc");
const $d3ebda59fb1111bb$export$6049b0f2a203677 = ({ title: title, iconUrl: iconUrl, itemKey: itemKey, isDone: isDone })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bScYc.SummaryContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bScYc.SummaryIcon), {
        src: iconUrl,
        alt: ""
    }), itemKey && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bScYc.SummaryKeyLabel), {
        isDone: isDone
    }, itemKey), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bScYc.SummaryTitle), {
        type: "div"
    }, title));
$d3ebda59fb1111bb$export$6049b0f2a203677.defaultProps = {
    iconUrl: '',
    isDone: false
};

});
parcelRegister("bScYc", function(module, exports) {

$parcel$export(module.exports, "SummaryContainer", () => $547057acf71ea9b7$export$bd55427d3650a1b0);
$parcel$export(module.exports, "SummaryIcon", () => $547057acf71ea9b7$export$ced6452f422b797e);
$parcel$export(module.exports, "SummaryKeyLink", () => $547057acf71ea9b7$export$a0a8cbd1a9f0ffc8);
$parcel$export(module.exports, "SummaryKeyLabel", () => $547057acf71ea9b7$export$f769aedd3eaca4c3);
$parcel$export(module.exports, "SummaryTitle", () => $547057acf71ea9b7$export$ec39b3a5dbed0806);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $8cU5f = parcelRequire("8cU5f");

var $bKxX9 = parcelRequire("bKxX9");

var $5JgJ2 = parcelRequire("5JgJ2");

var $dqhN0 = parcelRequire("dqhN0");
const $547057acf71ea9b7$var$containerStylesCompiledStyles = null;
const $547057acf71ea9b7$var$iconStylesCompiledStyles = null;
const $547057acf71ea9b7$var$keyStylesCompiledStyles = null;
const $547057acf71ea9b7$var$doneStylesCompiledStyles = null;
const $547057acf71ea9b7$var$titleStylesCompiledStyles = null;
const $547057acf71ea9b7$export$bd55427d3650a1b0 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx2vrvc _1reo15vq _18m915vq _4cvr1h6o _1bto1l2s _1bsb1osq _1yt4swc3"
        ])
    }, children); // these styles are reusable, so created in a shared component
const $547057acf71ea9b7$export$ced6452f422b797e = ({ alt: alt, src: src })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    if ((0, $bKxX9.ff)('jsw.roadmaps.timeline-issue-contextual-info-a11y_30v9')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: alt
    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("img", {
            src: src,
            alt: alt,
            "aria-label": formatMessage((0, $dqhN0.default).iconLabel, {
                issueType: alt
            }),
            "data-testid": "roadmap.timeline-table-kit.common.ui.summary.icon",
            ...tooltipProps,
            className: (0, $7JEyt.default)([
                "_1bsbpxbi _4t3ipxbi _2rko1l7b _16jlidpf _1o9zidpf _i0dl1wug"
            ])
        }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("img", {
        src: src,
        alt: alt,
        className: (0, $7JEyt.default)([
            "_1bsbpxbi _4t3ipxbi _2rko1l7b _16jlidpf _1o9zidpf _i0dl1wug"
        ])
    });
}; // https://github.com/facebook/react/issues/1881 (replaces previous implementation of !important not working in React)
const $547057acf71ea9b7$export$a0a8cbd1a9f0ffc8 = ({ children: children, isDone: isDone, testId: testId, ...rest })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("a", {
        "data-testid": testId,
        ...rest,
        className: (0, $7JEyt.default)([
            "_1wybdlk8 _12ji1r31 _1qu2glyw _12y31o36 _18s8171m _o5721q9c _syaz1rc1 _9h8h1rc1 _f8pj1rc1 _30l31rc1 _4bfu18uv _1nrm18uv _1a3b18uv _9oik18uv _1hmsglyw _c2waglyw _4fprglyw _1bnxglyw _ajmmnqa1 _1iohnqa1 _5goinqa1 _jf4cnqa1",
            isDone && "_4bfu18uv _1nrm18uv _1a3b18uv _9oik18uv _1hms1911 _c2wa1911 _4fpr1911 _1bnx1911 _ajmmnqa1 _1iohnqa1 _5goinqa1 _jf4cnqa1"
        ])
    }, children); // https://github.com/facebook/react/issues/1881 (replaces previous implementation of !important not working in React)
const $547057acf71ea9b7$export$f769aedd3eaca4c3 = ({ children: children, isDone: isDone, testId: testId, ...rest })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        "data-testid": testId,
        ...rest,
        className: (0, $7JEyt.default)([
            "_1wybdlk8 _12ji1r31 _1qu2glyw _12y31o36 _18s8171m _o5721q9c _syaz1rc1 _9h8h1rc1 _f8pj1rc1 _30l31rc1 _4bfu18uv _1nrm18uv _1a3b18uv _9oik18uv _1hmsglyw _c2waglyw _4fprglyw _1bnxglyw _ajmmnqa1 _1iohnqa1 _5goinqa1 _jf4cnqa1",
            isDone && "_4bfu18uv _1nrm18uv _1a3b18uv _9oik18uv _1hms1911 _c2wa1911 _4fpr1911 _1bnx1911 _ajmmnqa1 _1iohnqa1 _5goinqa1 _jf4cnqa1"
        ])
    }, children); // these styles are reusable, so created in a shared component (currently used to render as `div` and `a` elements in the codebase)
const $547057acf71ea9b7$export$ec39b3a5dbed0806 = ({ type: type, testId: testId, children: children })=>{
    switch(type){
        case 'div':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                "data-testid": testId,
                className: (0, $7JEyt.default)([
                    "_18s8171m _1reo15vq _18m915vq _1bto1l2s _o5721q9c _16jlkb7n"
                ])
            }, children);
        case 'p':
        default:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", {
                "data-testid": testId,
                className: (0, $7JEyt.default)([
                    "_18s8171m _1reo15vq _18m915vq _1bto1l2s _o5721q9c _16jlkb7n"
                ])
            }, children);
    }
};

});
parcelRegister("dqhN0", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c338c694fff6ad3$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $7c338c694fff6ad3$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    iconLabel: {
        "id": "roadmap.timeline-table-kit.common.summary.icon-label",
        "defaultMessage": "issue type {issueType}"
    }
});

});



parcelRegister("ijZnZ", function(module, exports) {

$parcel$export(module.exports, "LoadingBar", () => $e0e9de02feca2efc$export$6665614bc5d690f6);
$parcel$export(module.exports, "LoadingItem", () => $e0e9de02feca2efc$export$a16bfd7fb92e211d);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $PdmhA = parcelRequire("PdmhA");
const $e0e9de02feca2efc$export$6665614bc5d690f6 = ({ itemHeight: itemHeight, leftPosition: leftPosition, rightPosition: rightPosition })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        // eslint-disable-next-line jira/react/no-style-attribute
        style: {
            height: `${itemHeight - 16}px`,
            left: `${leftPosition}px`,
            right: `${rightPosition}px`
        },
        className: (0, $7JEyt.default)([
            "_kqswstnw _1e0c1txw _4cvr1h6o _1bahesu3 _2rko1sit _1reo15vq _18m915vq",
            "_aetrf705 _1kt9f705 _z0ai1osq _1mp41osq _1qdg1osq _kfgt1osq _1ywu1ule _cfu11ule _1rus1yrq _3p6mguu2 _clh3jq3t _46ts1wl4 _18postnw _15l21ob8"
        ])
    });
const $e0e9de02feca2efc$var$shimmer = null;
const $e0e9de02feca2efc$var$loadingBarBaseStyles = null;
const $e0e9de02feca2efc$var$loadingAnimationStyles = null;
const $e0e9de02feca2efc$var$loadingAnimation = {
    '::before, ::after': {
        content: ' ',
        width: '100%',
        height: '100%',
        display: 'block'
    },
    '::before': {
        backgroundColor: `var(--ds-background-neutral, ${(0, $PdmhA).N30})`
    },
    '::after': {
        backgroundImage: `
        linear-gradient(
            90deg,
            ${`var(--ds-surface, ${(0, $PdmhA).N0})`} 0,
            ${"var(--ds-skeleton-subtle, rgba(255, 255, 255, 0.2))"} 20%,
            ${"var(--ds-skeleton-subtle, rgba(255, 255, 255, 0.5))"} 60%,
            ${`var(--ds-surface, ${(0, $PdmhA).N0})`}
        )
        `,
        transform: 'translateX(-100%)',
        animation: `${$e0e9de02feca2efc$var$shimmer} 2s infinite`,
        position: 'absolute',
        top: 0
    }
};
const $e0e9de02feca2efc$export$a16bfd7fb92e211d = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { backgroundColor: backgroundColor, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1hphqkz": (0, $9t7rW.default)(__cmplp.backgroundColor)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i11dc _1bsb1osq _bfhk3qkl _kqswh2mm _1reo15vq _18m915vq _2rko1sit _aetrf705 _1kt9f705 _z0ai1osq _1mp41osq _1qdg1osq _kfgt1osq _1ywu1ule _cfu11ule _1rus1yrq _3p6mw01n _clh3jq3t _46ts1wl4 _18postnw _15l2idpf",
            __cmplp.className
        ])
    });
});
$e0e9de02feca2efc$export$a16bfd7fb92e211d.displayName = 'LoadingItem';

});

parcelRegister("6ELMa", function(module, exports) {

$parcel$export(module.exports, "DndLongTaskMetric", () => $be9f83f113bec470$export$5e5ce79ba08a39a0);

var $eUqFw = parcelRequire("eUqFw");

var $lNfG4 = parcelRequire("lNfG4");

var $gf0vG = parcelRequire("gf0vG");

const $be9f83f113bec470$var$camelCaseToKebabCase = (str)=>str.replace(/([a-z0-9])([A-Z])/g, '$1-$2').toLowerCase();
const $be9f83f113bec470$export$cc578d681954a356 = {
    [(0, $028d5637f56fe710$export$2475592765cae5b0)]: (0, $lNfG4.metrics).interaction({
        key: `jwm.timeline.${$be9f83f113bec470$var$camelCaseToKebabCase((0, $028d5637f56fe710$export$2475592765cae5b0))}`
    }),
    [(0, $gf0vG.LIST_RESIZE_DRAG_AND_DROP)]: (0, $lNfG4.metrics).interaction({
        key: `jwm.timeline.${$be9f83f113bec470$var$camelCaseToKebabCase((0, $gf0vG.LIST_RESIZE_DRAG_AND_DROP))}`
    }),
    [(0, $gf0vG.LIST_DRAG_AND_DROP)]: (0, $lNfG4.metrics).interaction({
        key: `jwm.timeline.${$be9f83f113bec470$var$camelCaseToKebabCase((0, $gf0vG.LIST_DRAG_AND_DROP))}`
    }),
    [(0, $gf0vG.CHILD_LIST_DRAG_AND_DROP)]: (0, $lNfG4.metrics).interaction({
        key: `jwm.timeline.${$be9f83f113bec470$var$camelCaseToKebabCase((0, $gf0vG.CHILD_LIST_DRAG_AND_DROP))}`
    }),
    [(0, $028d5637f56fe710$export$3ac90e7f239a7193)]: (0, $lNfG4.metrics).interaction({
        key: `jwm.timeline.${$be9f83f113bec470$var$camelCaseToKebabCase((0, $028d5637f56fe710$export$3ac90e7f239a7193))}`
    })
};
const $be9f83f113bec470$export$5e5ce79ba08a39a0 = ({ isDragging: isDragging, metricType: metricType })=>{
    (0, $eUqFw.useEffect)(()=>{
        if (!$be9f83f113bec470$export$cc578d681954a356[metricType]) return;
        if (isDragging) $be9f83f113bec470$export$cc578d681954a356[metricType].start();
        else $be9f83f113bec470$export$cc578d681954a356[metricType].stop({
            stopTime: performance.now()
        });
    }, [
        isDragging,
        metricType
    ]);
    return null;
};

});
const $028d5637f56fe710$export$3ac90e7f239a7193 = 'dependencyDnd';
const $028d5637f56fe710$export$eedef6333f320132 = 'issueViewResizeDnd';
const $028d5637f56fe710$export$2475592765cae5b0 = 'chartBarResize';
const $028d5637f56fe710$export$2afae5ee414caffb = 'persistItem';
const $028d5637f56fe710$export$26d8759f6f1c8e13 = 'exportImageGenerated';
const $028d5637f56fe710$export$e04dc5133fcac555 = 'issueUpdated';
const $028d5637f56fe710$export$5913ec3a0f9505fe = 'dependencyAdded';
const $028d5637f56fe710$export$488a6fa9078615df = 'dependencyRemoved';
const $028d5637f56fe710$export$315e0cbd8c7bfbd4 = 'bulkIssuesScheduled';
const $028d5637f56fe710$export$f096bf13c1d89b91 = 'resolveHealthcheck';
const $028d5637f56fe710$export$12daf7ce2c179397 = 'criticalData';
const $028d5637f56fe710$export$ede40e627a0cbf14 = 'versionDetails';
const $028d5637f56fe710$export$1df1eb270f208354 = 'sprintDetails';
const $028d5637f56fe710$export$bd4cd00ee0750c9a = 'filterConfiguration';
const $028d5637f56fe710$export$9e57feecc7b4c365 = 'deriveFields';
const $028d5637f56fe710$export$d21f08c0570f92f7 = 'filterRoadmapItems';
const $028d5637f56fe710$export$72305db43681d1de = 'getIssueIds';
const $028d5637f56fe710$export$51617034fb6f2e3a = 'getItemsByIds';
const $028d5637f56fe710$export$d959a123e6ceb778 = 'getSubtasks';
const $028d5637f56fe710$export$2e07b3a26c033d37 = 'healthcheckIssueTypes';
const $028d5637f56fe710$export$a0d61e9ea4ad5a05 = 'jqlFiltersReapply';
const $028d5637f56fe710$export$57a4171901f1c15b = 'getGoals';


parcelRegister("J1Q43", function(module, exports) {

$parcel$export(module.exports, "InteractionMetrics", () => $e04a4c49941ea52e$export$341b330828bd3906);

var $hsBO5 = parcelRequire("hsBO5");
const $e04a4c49941ea52e$export$341b330828bd3906 = ()=>{
    const interactionMetrics = (0, $hsBO5.useInteractionMetrics)();
    if (interactionMetrics[0, $hsBO5.ADD_ITEM_CLICKED].state === 'started') // the time between add item clicked and inline create input is rendered in timeline
    interactionMetrics[0, $hsBO5.ADD_ITEM_CLICKED].stop({
        stopTime: Math.floor(performance.now())
    });
    if (interactionMetrics[0, $hsBO5.TIMELINE_MODE_CHANGED].state === 'started') // the time between timescale button clicked and timeline re-rendered
    interactionMetrics[0, $hsBO5.TIMELINE_MODE_CHANGED].stop({
        stopTime: Math.floor(performance.now())
    });
    if (interactionMetrics[0, $hsBO5.EXPAND_CHANGED].state === 'started') // the time between expand button clicked and timeline re-rendered
    interactionMetrics[0, $hsBO5.EXPAND_CHANGED].stop({
        stopTime: Math.floor(performance.now())
    });
    return null;
};

});
parcelRegister("hsBO5", function(module, exports) {

$parcel$export(module.exports, "EXPAND_CHANGED", () => $279661fdc1d93909$export$715f6df7460cc565);
$parcel$export(module.exports, "ADD_ITEM_CLICKED", () => $279661fdc1d93909$export$d9bd7736120cba41);
$parcel$export(module.exports, "TIMELINE_MODE_CHANGED", () => $279661fdc1d93909$export$993f98b1d13f512);
$parcel$export(module.exports, "TODAY_BUTTON_CLICKED", () => $279661fdc1d93909$export$9d8c4a3386e395f0);
$parcel$export(module.exports, "EXPORT_IMAGE_GENERATED", () => $279661fdc1d93909$export$26d8759f6f1c8e13);
$parcel$export(module.exports, "useInteractionMetrics", () => $279661fdc1d93909$export$6f239bf5d81555c8);

var $jG2Eu = parcelRequire("jG2Eu");

var $lNfG4 = parcelRequire("lNfG4");
const $279661fdc1d93909$export$715f6df7460cc565 = 'expand-changed';
const $279661fdc1d93909$export$d9bd7736120cba41 = 'add-item-clicked';
const $279661fdc1d93909$export$993f98b1d13f512 = 'timeline-mode-changed';
const $279661fdc1d93909$export$9d8c4a3386e395f0 = 'today-clicked';
const $279661fdc1d93909$export$26d8759f6f1c8e13 = 'exportImageGenerated';
const $279661fdc1d93909$var$interactionMetrics = {
    [$279661fdc1d93909$export$715f6df7460cc565]: (0, $lNfG4.metrics).interaction({
        key: `jwm.timeline.${$279661fdc1d93909$export$715f6df7460cc565}`
    }),
    [$279661fdc1d93909$export$d9bd7736120cba41]: (0, $lNfG4.metrics).interaction({
        key: `jwm.timeline.${$279661fdc1d93909$export$d9bd7736120cba41}`
    }),
    [$279661fdc1d93909$export$993f98b1d13f512]: (0, $lNfG4.metrics).interaction({
        key: `jwm.timeline.${$279661fdc1d93909$export$993f98b1d13f512}`
    }),
    [$279661fdc1d93909$export$9d8c4a3386e395f0]: (0, $lNfG4.metrics).interaction({
        key: `jwm.timeline.${$279661fdc1d93909$export$9d8c4a3386e395f0}`
    }),
    [$279661fdc1d93909$export$26d8759f6f1c8e13]: (0, $lNfG4.metrics).interaction({
        key: `jwm.timeline.${$279661fdc1d93909$export$26d8759f6f1c8e13}`
    })
};
const $279661fdc1d93909$export$6f239bf5d81555c8 = ()=>$279661fdc1d93909$var$interactionMetrics;
const $279661fdc1d93909$var$interactionMock = {
    start: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    stop: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
};
const $279661fdc1d93909$export$3b262e78c27d1154 = ()=>({
        [$279661fdc1d93909$export$715f6df7460cc565]: $279661fdc1d93909$var$interactionMock,
        [$279661fdc1d93909$export$d9bd7736120cba41]: $279661fdc1d93909$var$interactionMock,
        [$279661fdc1d93909$export$993f98b1d13f512]: $279661fdc1d93909$var$interactionMock,
        [$279661fdc1d93909$export$9d8c4a3386e395f0]: $279661fdc1d93909$var$interactionMock,
        [$279661fdc1d93909$export$26d8759f6f1c8e13]: $279661fdc1d93909$var$interactionMock
    });

});


parcelRegister("1Pl9B", function(module, exports) {

$parcel$export(module.exports, "getTimelineTableItemsHeight", () => $33324de6e1b435e5$export$ff45b5996f11b55d);

var $5iWql = parcelRequire("5iWql");

var $gf0vG = parcelRequire("gf0vG");
const $33324de6e1b435e5$export$ff45b5996f11b55d = (0, $5iWql.default)((siblingItems, expandedItems, rootItemHeight = (0, $gf0vG.DEFAULT_ITEM_HEIGHT), isRoot = true)=>(siblingItems || []).reduce((sum, { childItems: childItems, id: id })=>// if it is the root level, we want to add the height of the item
        (isRoot ? rootItemHeight : (0, $gf0vG.BASE_LEVEL_ITEM_HEIGHT)) + sum + (expandedItems[id] ? $33324de6e1b435e5$export$ff45b5996f11b55d(childItems, expandedItems, rootItemHeight, false) : 0), 0));

});

parcelRegister("211Np", function(module, exports) {

$parcel$export(module.exports, "isItemSkeleton", () => $b6c2f7b36d9e588e$export$121c11fd7ecbe3e1);
$parcel$export(module.exports, "createItemSkeleton", () => $b6c2f7b36d9e588e$export$ac4443ed642486ab);
$parcel$export(module.exports, "LOADING_ITEMS", () => $b6c2f7b36d9e588e$export$1398abf6030da1ab);

var $6vrw7 = parcelRequire("6vrw7");

var $2nzpw = parcelRequire("2nzpw");
const $b6c2f7b36d9e588e$export$8764542593218704 = 'SKELETON-ITEM-';
const $b6c2f7b36d9e588e$export$121c11fd7ecbe3e1 = (issueId)=>String(issueId).startsWith($b6c2f7b36d9e588e$export$8764542593218704);
const $b6c2f7b36d9e588e$export$ac4443ed642486ab = ({ id: id, level: level })=>({
        id: (0, $6vrw7.toIssueId)(`${$b6c2f7b36d9e588e$export$8764542593218704}${id}`),
        level: level
    });
const $b6c2f7b36d9e588e$export$1398abf6030da1ab = Array.from({
    length: 20
}, (_, i)=>({
        id: (0, $6vrw7.toIssueId)(`${$b6c2f7b36d9e588e$export$8764542593218704}${i}`),
        level: (0, $2nzpw.TIMELINE_PARENT_LEVEL),
        isInTransition: false,
        childItems: undefined
    }));

});

parcelRegister("duAPu", function(module, exports) {

$parcel$export(module.exports, "TimelineViewChildQueryController", () => $d64f37d5edcb56e6$export$ccc3e15517bf984c);

var $eUqFw = parcelRequire("eUqFw");

var $4G5xU = parcelRequire("4G5xU");

var $lGxgz = parcelRequire("lGxgz");

var $1ybV0 = parcelRequire("1ybV0");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $2nzpw = parcelRequire("2nzpw");

var $eXeLp = parcelRequire("eXeLp");
const $d64f37d5edcb56e6$export$ccc3e15517bf984c = ({ parentHierarchyType: parentHierarchyType, parentIssueId: parentIssueId, onDataChange: onDataChange, parentHierarchyLevel: parentHierarchyLevel })=>{
    const startExperience = (0, $4G5xU.useExperienceStart)((0, $2nzpw.LOAD_CHILD_ISSUES_EXPERIENCE));
    const markExperienceSuccess = (0, $4G5xU.useExperienceSuccess)((0, $2nzpw.LOAD_CHILD_ISSUES_EXPERIENCE));
    const markExperienceFailed = (0, $4G5xU.useExperienceFail)((0, $2nzpw.LOAD_CHILD_ISSUES_EXPERIENCE));
    startExperience();
    const { quickFiltersJql: quickFiltersJql, jqlContext: jqlContext } = (0, $lGxgz.useFilteredViewContextInput)({
        view: 'timeline'
    });
    const { data: data, rankIssue: rankIssue, updateInCache: updateInCache, updateItemsInCache: updateItemsInCache, loading: loading, error: error, loadNextPage: loadNextPage, isLoadingNextPage: isLoadingNextPage } = (0, $eXeLp.useTimelineViewIssues)({
        input: {
            jqlContext: jqlContext,
            fieldIds: $2nzpw.fieldIds,
            quickFiltersJql: quickFiltersJql,
            parentIssue: {
                hierarchyType: parentHierarchyType,
                ...(0, $1ybV0.ff)('jwm.visual-hierarchy-milestone-1') && {
                    hierarchyLevel: parentHierarchyLevel
                },
                issueId: parentIssueId
            }
        }
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const totalIssues = data?.issues.length;
    (0, $eUqFw.useEffect)(()=>{
        if (loading) return;
        if (error || typeof totalIssues !== 'number') {
            markExperienceFailed('timeline children query controller', error || Error('data.issues.length is not a number'));
            return;
        }
        markExperienceSuccess();
        (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'timelineChildrenData fetched', {
            totalChildren: totalIssues,
            parentIssueId: parentIssueId,
            parentHierarchyLevel: parentHierarchyLevel
        });
    }, [
        loading,
        createAnalyticsEvent,
        totalIssues,
        parentIssueId,
        error,
        markExperienceSuccess,
        markExperienceFailed,
        parentHierarchyLevel
    ]);
    (0, $eUqFw.useEffect)(()=>{
        onDataChange(parentIssueId, {
            data: data,
            updateInCache: updateInCache,
            rankIssue: rankIssue,
            updateItemsInCache: updateItemsInCache,
            loading: loading,
            error: error,
            loadNextPage: loadNextPage,
            isLoadingNextPage: isLoadingNextPage
        });
    }, [
        data,
        error,
        isLoadingNextPage,
        loadNextPage,
        loading,
        onDataChange,
        parentIssueId,
        updateInCache,
        rankIssue,
        updateItemsInCache
    ]);
    return null;
};

});
parcelRegister("eXeLp", function(module, exports) {

$parcel$export(module.exports, "useTimelineViewIssues", () => $d7c2f74e65ab1ca0$export$66a1bd5ceb40f186);
/* eslint-disable camelcase */ 
var $eUqFw = parcelRequire("eUqFw");

var $3G3gn = parcelRequire("3G3gn");

var $iZuDo = parcelRequire("iZuDo");

var $053h2 = parcelRequire("053h2");

var $4G5xU = parcelRequire("4G5xU");

var $lGxgz = parcelRequire("lGxgz");

var $aVwtE = parcelRequire("aVwtE");
var $hTnQu = parcelRequire("hTnQu");
var $12sJv = parcelRequire("12sJv");

var $ZvXTS = parcelRequire("ZvXTS");

var $guiFP = parcelRequire("guiFP");

var $1ybV0 = parcelRequire("1ybV0");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $dWLk9 = parcelRequire("dWLk9");

var $2nzpw = parcelRequire("2nzpw");

var $hszK4 = parcelRequire("hszK4");

var $2wbrs = parcelRequire("2wbrs");

var $dLnS7 = parcelRequire("dLnS7");

var $1IC6t = parcelRequire("1IC6t");
const $d7c2f74e65ab1ca0$var$getIndexById = (list, issueId)=>{
    if (list == null || !Array.isArray(list?.edges)) return -1;
    return list.edges.findIndex(({ node: node })=>node?.issueId === Number(issueId));
};
const $d7c2f74e65ab1ca0$var$emptyArray = [];
const $d7c2f74e65ab1ca0$export$66a1bd5ceb40f186 = ({ input: input, onComplete: onComplete })=>{
    const analyticsTaskName = 'useTimelineViewIssuesApolloCacheActions';
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const cloudId = (0, $dWLk9.useCloudId)();
    const { isHidingDoneItems: isHidingDoneItems } = (0, $lGxgz.useFilteredViewContextInput)({
        view: 'timeline'
    });
    /**
	 * We only want to recompute variables when input is NOT deep equal
	 * We need to retain the referential equality of the queryVariable to prevent recreating some functions unnecessarily
	 *
	 * At the same time we want to give flexibility for the consumer to inline the object parameter
	 * when consuming this hook
	 */ const queryVariables = (0, $eUqFw.useMemo)(()=>{
        const pageSize = input.parentIssue ? null : (0, $2nzpw.TIMELINE_PAGE_SIZE_ARGS);
        return {
            ...(0, $hszK4.getVariables)({
                ...input,
                isHidingDoneItems: isHidingDoneItems
            }),
            cloudId: cloudId,
            ...pageSize,
            withParentRank: (0, $1ybV0.ff)('jwm-timeline-sort-parent-rank-first_waal4')
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        JSON.stringify(input)
    ]);
    const [hasLoadingStarted, setHasLoadingStarted] = (0, $eUqFw.useState)(false);
    const client = (0, $iZuDo.useApolloClient)();
    const { updateItemsInCache: updateItemsInCacheAction } = (0, $hTnQu.useCacheActions)();
    const startExperience = (0, $4G5xU.useExperienceStart)((0, $2nzpw.LOAD_MORE_EXPERIENCE));
    const markExperienceSuccess = (0, $4G5xU.useExperienceSuccess)((0, $2nzpw.LOAD_MORE_EXPERIENCE));
    const markExperienceFailed = (0, $4G5xU.useExperienceFail)((0, $2nzpw.LOAD_MORE_EXPERIENCE));
    const { rankIssue: rankIssue } = (0, $2wbrs.useRankTimelineIssue)({
        query: (0, $dLnS7.TIMELINE_VIEW_ITEMS_QUERY),
        queryVariables: queryVariables
    });
    const onNextPageLoaded = (0, $eUqFw.useCallback)(()=>{
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'timelineMoreItems loaded');
        markExperienceSuccess();
    }, [
        createAnalyticsEvent,
        markExperienceSuccess
    ]);
    const onPaginationError = (0, $eUqFw.useCallback)((apolloError)=>{
        if (!(0, $053h2.shouldHandleTheError)(apolloError)) return;
        (0, $guiFP.default)({
            meta: {
                id: 'timelineViewPaginationQuery',
                packageName: 'jiraBusinessTimeline',
                teamName: 'jira-yurree'
            },
            attributes: {
                message: 'Failed to fetch more issues in timeline view'
            },
            error: apolloError,
            sendToPrivacyUnsafeSplunk: true
        });
        markExperienceFailed('get timeline view issues service', apolloError);
    }, [
        markExperienceFailed
    ]);
    const { data: data, loadFirstPage: loadFirstPage, loading: loading, error: error, loadNextPage: loadNextPage, isLoadingNextPage: isLoadingNextPage } = (0, $12sJv.useJqlPagination)({
        variables: queryVariables,
        query: (0, $dLnS7.TIMELINE_VIEW_ITEMS_QUERY),
        // setting error policy to all here to deal with partial failures (https://hello.atlassian.net/wiki/spaces/JBus/pages/3148433025/RFC-080+Partial+data+apollo-client+and+JWM)
        errorPolicy: 'all',
        onCompleted: ()=>{
            (0, $ZvXTS.markViewMetric)('timeline', (0, $78bb8734d7176028$export$83ca21a50372ea3b));
            if (onComplete) onComplete();
        },
        onError: (apolloError)=>{
            (0, $ZvXTS.markViewMetric)('timeline', (0, $78bb8734d7176028$export$83ca21a50372ea3b));
            if (!(0, $053h2.shouldHandleTheError)(apolloError)) return;
            (0, $guiFP.default)({
                meta: {
                    id: 'timelineViewItemsQuery',
                    packageName: 'jiraBusinessTimeline',
                    teamName: 'jira-yurree'
                },
                attributes: {
                    message: 'Failed to fetch issues in timeline view'
                },
                error: apolloError,
                sendToPrivacyUnsafeSplunk: true
            });
        },
        onPaginationError: onPaginationError,
        onNextPageLoaded: onNextPageLoaded
    });
    (0, $eUqFw.useEffect)(()=>{
        (0, $ZvXTS.markViewMetric)('timeline', (0, $78bb8734d7176028$export$23e322eb7c526958));
        loadFirstPage(); // fetch issues once on mount
        setHasLoadingStarted(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // TODO remove this function and reuse the useCacheActions https://jbusiness.atlassian.net/browse/JET-1548
    const updateInCache = (0, $eUqFw.useCallback)(({ id: id, fields: { startDate: startDate, dueDate: dueDate } })=>{
        const getCachedListData = ()=>{
            try {
                const read = client.readQuery({
                    query: (0, $dLnS7.TIMELINE_VIEW_ITEMS_QUERY),
                    variables: queryVariables
                });
                (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), 'apolloCacheRead taskSuccess', {
                    task: analyticsTaskName
                });
                return read;
            } catch (e) {
                (0, $guiFP.default)({
                    error: e instanceof Error ? e : new Error('Unknown cache read error'),
                    meta: {
                        id: 'updateInCache',
                        packageName: 'jiraBusinessTimeline',
                        teamName: 'jira-yurree'
                    },
                    sendToPrivacyUnsafeSplunk: true,
                    skipSentry: true,
                    attributes: {
                        task: analyticsTaskName,
                        query: JSON.stringify((0, $dLnS7.TIMELINE_VIEW_ITEMS_QUERY)),
                        variables: JSON.stringify(queryVariables),
                        eventName: 'apolloCacheRead taskFail',
                        error: JSON.stringify(e)
                    }
                });
                return null;
            }
        };
        const listData = getCachedListData();
        const _list = (0, $aVwtE.getAGGCompliantData)(listData ?? undefined, 'list');
        const index = $d7c2f74e65ab1ca0$var$getIndexById(_list ?? undefined, id);
        if (index === -1 || index == null) return;
        const edges = [
            ..._list?.edges || []
        ].map((edge)=>{
            if (edge?.node?.issueId === Number(id)) {
                const { node: node } = edge;
                return {
                    node: {
                        ...node,
                        fields: (node?.fields || []).map((field)=>{
                            // eslint-disable-next-line @typescript-eslint/no-explicit-any
                            const newField = {};
                            if (field != null && 'aliasFieldId' in field) {
                                if (startDate != null && field?.aliasFieldId === 'startdate') newField.date = startDate;
                            }
                            if (field != null && 'fieldId' in field) {
                                if (dueDate != null && field?.fieldId === 'duedate') newField.date = dueDate;
                            }
                            return {
                                ...field,
                                ...newField
                            };
                        })
                    }
                };
            }
            return edge;
        });
        try {
            client.writeQuery({
                query: (0, $dLnS7.TIMELINE_VIEW_ITEMS_QUERY),
                variables: queryVariables,
                data: {
                    ...listData,
                    jira: {
                        ...listData?.jira,
                        list: {
                            ...listData?.jira?.list || {},
                            edges: edges
                        }
                    }
                }
            });
            (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), 'apolloCacheWrite taskSuccess', {
                task: analyticsTaskName
            });
        } catch (e) {
            (0, $guiFP.default)({
                error: e instanceof Error ? e : new Error('Unknown cache write error'),
                meta: {
                    id: 'updateInCache',
                    packageName: 'jiraBusinessTimeline',
                    teamName: 'jira-yurree'
                },
                sendToPrivacyUnsafeSplunk: true,
                skipSentry: true,
                attributes: {
                    task: analyticsTaskName,
                    query: JSON.stringify((0, $dLnS7.TIMELINE_VIEW_ITEMS_QUERY)),
                    variables: JSON.stringify(queryVariables),
                    eventName: 'apolloCacheWrite taskFail',
                    error: JSON.stringify(e)
                }
            });
        }
    }, [
        client,
        createAnalyticsEvent,
        queryVariables
    ]);
    const updateItemsInCache = (0, $eUqFw.useCallback)((updates)=>{
        updateItemsInCacheAction({
            query: (0, $dLnS7.TIMELINE_VIEW_ITEMS_QUERY),
            variables: queryVariables,
            issueIds: updates.map((i)=>i.id),
            updateItem: (existingIssue)=>{
                const update = updates.find((i)=>Number(i.id) === existingIssue.issueId);
                if (!update) return existingIssue;
                const { fields: { startDate: startDate, dueDate: dueDate } } = update;
                const fields = existingIssue.fields?.map((field)=>{
                    if (field != null && 'aliasFieldId' in field) {
                        if (startDate != null && field.aliasFieldId === 'startdate') return {
                            ...field,
                            date: startDate
                        };
                    }
                    if (field != null && 'fieldId' in field) {
                        if (dueDate != null && field.fieldId === 'duedate') return {
                            ...field,
                            date: dueDate
                        };
                    }
                    return field;
                }) ?? null;
                return {
                    ...existingIssue,
                    fields: fields
                };
            }
        });
    }, [
        queryVariables,
        updateItemsInCacheAction
    ]);
    const _data = (0, $aVwtE.getAGGCompliantData)(data, 'list');
    const edges = _data?.edges || $d7c2f74e65ab1ca0$var$emptyArray;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const result = (0, $eUqFw.useMemo)(()=>(0, $1IC6t.transformResult)((0, (/*@__PURE__*/$parcel$interopDefault($3G3gn)))(edges, (0, $1IC6t.rankSorter))), [
        edges
    ]);
    const loadNextPageWithExperienceMetrics = (0, $eUqFw.useCallback)(()=>{
        startExperience();
        loadNextPage();
    }, [
        loadNextPage,
        startExperience
    ]);
    return {
        data: result,
        updateInCache: updateInCache,
        updateItemsInCache: updateItemsInCache,
        // Make sure to return loading=true until items are loaded.
        loading: hasLoadingStarted ? loading : true,
        // return undefined to ignore so the UI won't try to show a flag
        error: (0, $053h2.shouldHandleTheError)(error) ? error : undefined,
        loadNextPage: loadNextPageWithExperienceMetrics,
        isLoadingNextPage: isLoadingNextPage,
        rankIssue: rankIssue
    };
};

});
parcelRegister("053h2", function(module, exports) {

$parcel$export(module.exports, "shouldHandleTheError", () => $26bb3a81152c05d0$export$47770c8b6d645cdb);

var $1ybV0 = parcelRequire("1ybV0");
const $26bb3a81152c05d0$var$errorWhitelist = [
    'EXPERIENCE_UNAVAILABLE',
    'FIELD_UNAVAILABLE'
];
const $26bb3a81152c05d0$export$47770c8b6d645cdb = (error)=>{
    if (error?.networkError) return true;
    // when issue links are disabled at the instance level and we request it, it throws an error but we still get the whole response
    // There is a issue links perm check that happens after loading the list so the UI already deals with this properly and we can ignore it
    // similarly, even when issue links are enabled, but the field itself is hidden in every screen it will throw an error but we'll still get the whole response
    const filterIssueLinksDisabledErrors = (graphQLError)=>{
        if ((0, $1ybV0.ff)('jwm.timeline.ignore-field-unavailable-errors')) {
            const isWhitelisted = $26bb3a81152c05d0$var$errorWhitelist.includes(graphQLError?.extensions?.errorType);
            return !isWhitelisted;
        }
        return graphQLError?.extensions?.errorType !== 'EXPERIENCE_UNAVAILABLE';
    };
    const errorsToShow = (error?.graphQLErrors || []).filter(filterIssueLinksDisabledErrors);
    return errorsToShow.length > 0;
};

});

parcelRegister("aVwtE", function(module, exports) {

$parcel$export(module.exports, "useFetchMore", () => $4a89f8875e643360$export$d84f34af2f3f5d9f);
$parcel$export(module.exports, "getAGGCompliantData", () => $4a89f8875e643360$export$5a178cf599565b50);

var $iZuDo = parcelRequire("iZuDo");

var $jlBDe = parcelRequire("jlBDe");

var $90pMD = parcelRequire("90pMD");

var $6gPph = parcelRequire("6gPph");

var $1ybV0 = parcelRequire("1ybV0");

var $eI5EY = parcelRequire("eI5EY");

var $4X5wI = parcelRequire("4X5wI");
function $4a89f8875e643360$export$2b602b4ab6fde7b6({ after: after, onError: onError, errorPolicy: errorPolicy = 'none', updateQuery: updateQuery, query: query, variables: variables, client: client }) {
    const variablesWithAfter = {
        ...variables,
        after: after
    };
    return client.query({
        query: query,
        variables: variablesWithAfter,
        fetchPolicy: 'no-cache',
        errorPolicy: errorPolicy
    }).then((response)=>{
        if (!response) return;
        if (response.errors) {
            onError && onError(new (0, $jlBDe.ApolloError)({
                graphQLErrors: response.errors
            }));
            if (errorPolicy === 'none') return;
        }
        if (response.data == null) return;
        // Update cache based on updateQuery method
        const prevData = client.readQuery({
            query: query,
            variables: variables
        });
        if (prevData == null) // It should not happened, adding the check just to make flow happpy
        return;
        const newData = updateQuery(prevData, {
            fetchMoreResult: response.data,
            variables: variablesWithAfter
        });
        client.writeQuery({
            query: query,
            variables: variables,
            // @ts-expect-error - TS2345 - Argument of type '{ query: DocumentNode; variables: TVariables; notifyOnNetworkStatusChange: boolean; data: TData; }' is not assignable to parameter of type 'WriteQueryOptions<TData, TVariables>'.
            notifyOnNetworkStatusChange: true,
            data: newData
        });
    }).catch((err)=>{
        onError && onError(err);
    });
}
function $4a89f8875e643360$export$d84f34af2f3f5d9f({ variables: variables, query: query }) {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const client = (0, $iZuDo.useApolloClient)();
    // We're using `useDeepMemo` instead of `useCallback`/`useMemo` as it's very
    // likely that the `variables` dependency will change with each render even
    // though its contents will remain the same. Doing this stops us from
    // unnecessarily returning a new callback, as this could trigger unnecessary
    // rerenders or side-effects.
    return (0, $90pMD.useDeepMemo)(()=>(options)=>$4a89f8875e643360$export$2b602b4ab6fde7b6({
                ...options,
                variables: variables,
                query: query,
                client: client
            }), [
        client,
        variables,
        query
    ]);
}
function $4a89f8875e643360$export$5a178cf599565b50(data, listName, onError) {
    if (listName && data?.jira?.[listName]) {
        const _data = data.jira[listName];
        if (_data?.__typename === 'QueryError') {
            const queryError = new (0, $6gPph.QueryError)(_data);
            if (queryError.extensions?.find((ex)=>ex.statusCode === 401) && (0, $eI5EY.fg)('jira_list_add_401_error_handling')) throw new (0, $4X5wI.AuthenticationError)(_data.message);
            if ((0, $1ybV0.ff)('fix-sentry-unhandled-error-for-list-handler')) {
                onError && onError(_data);
                return undefined;
            }
            throw new (0, $6gPph.QueryError)(_data);
        }
        return _data;
    }
    return undefined;
}

});
parcelRegister("90pMD", function(module, exports) {

$parcel$export(module.exports, "useDeepMemo", () => $aa834e9231a22e71$export$722debc0e56fea39);

var $eUqFw = parcelRequire("eUqFw");

var $hTLlD = parcelRequire("hTLlD");
const $aa834e9231a22e71$export$722debc0e56fea39 = (memoFn, deps)=>{
    const ref = (0, $eUqFw.useRef)();
    if (!ref.current || !(0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))(ref.current.deps, deps)) ref.current = {
        value: memoFn(),
        deps: deps
    };
    return ref.current.value;
};

});

parcelRegister("6gPph", function(module, exports) {

$parcel$export(module.exports, "QueryError", () => $cba33ea5171f294f$export$83dcbdfe8cbc1e17);
const $cba33ea5171f294f$export$f215947b3d76a6b7 = 'QueryError';
class $cba33ea5171f294f$export$83dcbdfe8cbc1e17 extends Error {
    constructor(payload){
        super(payload.message ?? undefined);
        this.extensions = payload.extensions;
        this.message = payload.message ?? '';
        this.statusCode = payload.extensions?.[0]?.statusCode ?? -1;
    }
}

});

parcelRegister("4X5wI", function(module, exports) {

$parcel$export(module.exports, "AuthenticationError", () => $9c4d4fc947b6f0a7$export$cf0c46b07324e9c5);
class $9c4d4fc947b6f0a7$export$cf0c46b07324e9c5 extends Error {
    constructor(message){
        super(message);
        this.name = 'AuthenticationError';
        this.skipSentry = true;
        this.statusCode = 401;
    }
}

});


parcelRegister("hTnQu", function(module, exports) {

$parcel$export(module.exports, "useCacheActions", () => $018dc286559ccf2c$export$f79bd85e41a6298f);

var $eUqFw = parcelRequire("eUqFw");

var $illlw = parcelRequire("illlw");

var $iZuDo = parcelRequire("iZuDo");

var $jGcn0 = parcelRequire("jGcn0");

var $3uSNh = parcelRequire("3uSNh");

var $guiFP = parcelRequire("guiFP");

var $kmr29 = parcelRequire("kmr29");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $kJlBc = parcelRequire("kJlBc");

var $6vrw7 = parcelRequire("6vrw7");

var $7Sz8O = parcelRequire("7Sz8O");

var $4oWxH = parcelRequire("4oWxH");

var $aVwtE = parcelRequire("aVwtE");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $018dc286559ccf2c$var$getIssueKey = (fields)=>(0, $3uSNh.safeGetValue)(fields, 'issuekey', 'text', '');
const $018dc286559ccf2c$var$getIndexById = (listData, issueId)=>{
    if (listData == null || listData.edges == null) return -1;
    const { edges: edges } = listData;
    return edges.findIndex((edge)=>edge != null && edge.node != null && edge.node.issueId != null && edge.node.issueId === issueId);
};
const $018dc286559ccf2c$export$f79bd85e41a6298f = ()=>{
    const analyticsTaskName = 'useCacheActionsApolloCacheActions';
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const client = (0, $iZuDo.useApolloClient)();
    const [, extractedFieldValueActions] = (0, $kmr29.useFieldsValuesActions)();
    const [currentIssueKey] = (0, $kJlBc.useQueryParam)((0, $jGcn0.SELECTED_ISSUE_PARAM));
    const removeIssueFromExtractedFieldsCache = (0, $eUqFw.useCallback)(({ currentIssueId: currentIssueId, issueKey: issueKey, parentIssueId: parentIssueId })=>{
        issueKey != null && // do not clean the cache if the issue is currently visible in bento (that would show blank fields)
        issueKey !== currentIssueKey && `${parentIssueId}` !== `${currentIssueId}` && extractedFieldValueActions.setIssue((0, $6vrw7.toIssueKey)(issueKey), {});
    }, [
        currentIssueKey,
        extractedFieldValueActions
    ]);
    const addToCache = (0, $eUqFw.useCallback)(({ query: query, variables: variables, newNodes: newNodes })=>{
        const getCachedListData = ()=>{
            try {
                const read = client.readQuery({
                    query: query,
                    variables: variables
                });
                (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), 'apolloCacheRead taskSuccess', {
                    task: analyticsTaskName
                });
                return read;
            } catch (e) {
                (0, $guiFP.default)({
                    error: e instanceof Error ? e : new Error('Unknown cache read error'),
                    meta: {
                        id: 'addToCache',
                        packageName: 'jiraBusinessListHandlers',
                        teamName: 'keystone'
                    },
                    sendToPrivacyUnsafeSplunk: true,
                    skipSentry: true,
                    attributes: {
                        task: analyticsTaskName,
                        query: JSON.stringify(query),
                        variables: JSON.stringify(variables),
                        eventName: 'apolloCacheRead taskFail',
                        error: JSON.stringify(e)
                    }
                });
                return null;
            }
        };
        const data = getCachedListData();
        const listData = (0, $aVwtE.getAGGCompliantData)(data ?? undefined, 'list');
        if (listData == null || listData.edges == null || !Array.isArray(newNodes) || newNodes.length === 0) return;
        try {
            const newIssueIds = new Set(newNodes.map((item)=>{
                if (item != null && item.issueId != null) return item.issueId;
                return undefined;
            }).filter(Boolean));
            newNodes.forEach((item)=>{
                if (item == null || item.fields == null) return;
                const issueKey = $018dc286559ccf2c$var$getIssueKey(item.fields);
                if (issueKey != null && issueKey !== '') {
                    const parentIssueId = (0, $4oWxH.getParentIssueId)(item);
                    const currentIssueId = item.issueId;
                    removeIssueFromExtractedFieldsCache({
                        currentIssueId: currentIssueId,
                        issueKey: issueKey,
                        parentIssueId: parentIssueId
                    });
                }
            });
            const isOptimisticIssueWithRealIssueInNewNodes = (issue)=>{
                // check whether an issue is an optimisticIssue that has the real data coming in
                // summary should give us a second check to replace the right optimistic issue with the new one
                // we are using summary instead of issueKey or issueId
                // since it's the only field that will contain the same value to identify
                // the correlation between real issue and optimistic issue
                const issueSummary = issue.fields?.find((field)=>field.fieldId === 'summary');
                const newNodeWithSameSummary = newNodes.find((newNode)=>newNode.fields?.find((field)=>field.fieldId === 'summary' && issueSummary != null && field.text === issueSummary.text));
                return issue.id.toString().startsWith((0, $7Sz8O.OPTIMISTIC_ID_PREFIX)) && newNodeWithSameSummary != null;
            };
            const newIssues = listData.edges.filter((edge)=>edge != null && edge.node != null && edge.node.issueId != null && !newIssueIds.has(edge.node.issueId) && !isOptimisticIssueWithRealIssueInNewNodes(edge.node)).concat(newNodes.map((node)=>({
                    node: node,
                    __typename: 'JiraWorkManagementViewItemEdge'
                }))) ?? [];
            client.writeQuery({
                query: query,
                variables: variables,
                data: {
                    ...data,
                    jira: {
                        ...data?.jira ?? {},
                        list: {
                            ...listData,
                            edges: newIssues,
                            totalCount: newIssues.length
                        }
                    }
                }
            });
            (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), 'apolloCacheWrite taskSuccess', {
                task: analyticsTaskName
            });
            (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), 'apolloAddToCache taskSuccess', {
                task: analyticsTaskName
            });
        } catch (e) {
            (0, $guiFP.default)({
                error: e instanceof Error ? e : new Error('Unknown cache write error'),
                meta: {
                    id: 'addToCache',
                    packageName: 'jiraBusinessListHandlers',
                    teamName: 'keystone'
                },
                sendToPrivacyUnsafeSplunk: true,
                skipSentry: true,
                attributes: {
                    task: analyticsTaskName,
                    query: JSON.stringify(query),
                    variables: JSON.stringify(variables),
                    eventName: 'apolloCacheWrite taskFail',
                    error: JSON.stringify(e)
                }
            });
        }
    }, [
        client,
        createAnalyticsEvent,
        removeIssueFromExtractedFieldsCache
    ]);
    const removeFromCache = (0, $eUqFw.useCallback)(({ query: query, variables: variables, issueId: issueId })=>{
        const issueIds = Array.isArray(issueId) ? issueId : [
            issueId
        ];
        const getCachedListData = ()=>{
            try {
                const read = client.readQuery({
                    query: query,
                    variables: variables
                });
                (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), 'apolloCacheRead taskSuccess', {
                    task: analyticsTaskName
                });
                return read;
            } catch (e) {
                (0, $guiFP.default)({
                    error: e instanceof Error ? e : new Error('Unknown cache read error'),
                    meta: {
                        id: 'removeFromCache',
                        packageName: 'jiraBusinessListHandlers',
                        teamName: 'keystone'
                    },
                    sendToPrivacyUnsafeSplunk: true,
                    skipSentry: true,
                    attributes: {
                        task: analyticsTaskName,
                        query: JSON.stringify(query),
                        variables: JSON.stringify(variables),
                        eventName: 'apolloCacheRead taskFail',
                        error: JSON.stringify(e)
                    }
                });
                return null;
            }
        };
        const data = getCachedListData();
        const listData = (0, $aVwtE.getAGGCompliantData)(data ?? undefined, 'list');
        if (!listData?.edges || !Array.isArray(listData.edges)) return;
        try {
            const updatedEdges = listData.edges?.filter((edge)=>edge?.node && !issueIds.includes(edge.node.issueId));
            client.writeQuery({
                query: query,
                variables: variables,
                data: {
                    ...data,
                    jira: {
                        ...data?.jira ?? {},
                        list: {
                            ...listData,
                            edges: updatedEdges,
                            totalCount: updatedEdges.length
                        }
                    }
                }
            });
            (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), 'apolloCacheWrite taskSuccess', {
                task: analyticsTaskName
            });
            issueIds.forEach((issue)=>{
                const index = $018dc286559ccf2c$var$getIndexById(listData ?? undefined, issue);
                const item = updatedEdges[index];
                const issueKey = $018dc286559ccf2c$var$getIssueKey(item?.node?.fields ?? []);
                const currentIssueId = (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(item, 'issueId', 0);
                if (issueKey !== '') removeIssueFromExtractedFieldsCache({
                    currentIssueId: currentIssueId,
                    issueKey: issueKey
                });
            });
            (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), 'apolloRemoveFromCache taskSuccess', {
                task: analyticsTaskName
            });
        } catch (e) {
            (0, $guiFP.default)({
                error: e instanceof Error ? e : new Error('Unknown cache Write error'),
                meta: {
                    id: 'removeFromCache',
                    packageName: 'jiraBusinessListHandlers',
                    teamName: 'keystone'
                },
                sendToPrivacyUnsafeSplunk: true,
                skipSentry: true,
                attributes: {
                    task: analyticsTaskName,
                    query: JSON.stringify(query),
                    variables: JSON.stringify(variables),
                    eventName: 'apolloCacheWrite taskFail',
                    error: JSON.stringify(e)
                }
            });
        }
    }, [
        client,
        createAnalyticsEvent,
        removeIssueFromExtractedFieldsCache
    ]);
    const getCachedIssueById = (0, $eUqFw.useCallback)(({ query: query, variables: variables, issueId: issueId })=>{
        const getCachedListData = ()=>{
            try {
                const read = client.readQuery({
                    query: query,
                    variables: variables
                });
                (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), 'apolloCacheRead taskSuccess', {
                    task: analyticsTaskName
                });
                return read;
            } catch (e) {
                (0, $guiFP.default)({
                    error: e instanceof Error ? e : new Error('Unknown cache read error'),
                    meta: {
                        id: 'getCachedIssueById',
                        packageName: 'jiraBusinessListHandlers',
                        teamName: 'keystone'
                    },
                    sendToPrivacyUnsafeSplunk: true,
                    skipSentry: true,
                    attributes: {
                        task: analyticsTaskName,
                        query: JSON.stringify(query),
                        variables: JSON.stringify(variables),
                        eventName: 'apolloCacheRead taskFail',
                        error: JSON.stringify(e)
                    }
                });
                return null;
            }
        };
        const data = getCachedListData();
        const listData = (0, $aVwtE.getAGGCompliantData)(data ?? undefined, 'list');
        (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), 'apolloGetCachedIssueById taskSuccess', {
            task: analyticsTaskName
        });
        return listData?.edges?.find((issue)=>issue?.node?.issueId === Number(issueId))?.node ?? null;
    }, [
        client,
        createAnalyticsEvent
    ]);
    const updateItemsInCache = (0, $eUqFw.useCallback)(({ query: query, variables: variables, issueIds: issueIds, updateItem: updateItem })=>{
        const getCachedListData = ()=>{
            try {
                const read = client.readQuery({
                    query: query,
                    variables: variables
                });
                (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), 'apolloCacheRead taskSuccess', {
                    task: analyticsTaskName
                });
                return read;
            } catch (e) {
                (0, $guiFP.default)({
                    error: e instanceof Error ? e : new Error('Unknown cache read error'),
                    meta: {
                        id: 'updateItemsInCache',
                        packageName: 'jiraBusinessListHandlers',
                        teamName: 'keystone'
                    },
                    sendToPrivacyUnsafeSplunk: true,
                    skipSentry: true,
                    attributes: {
                        task: analyticsTaskName,
                        query: JSON.stringify(query),
                        variables: JSON.stringify(variables),
                        eventName: 'apolloCacheRead taskFail',
                        error: JSON.stringify(e)
                    }
                });
                return null;
            }
        };
        const data = getCachedListData();
        const listData = (0, $aVwtE.getAGGCompliantData)(data ?? undefined, 'list');
        const existingEdges = listData?.edges;
        if (existingEdges == null) return;
        try {
            const newEdges = [
                ...existingEdges
            ];
            let hasItemOverride = false;
            issueIds.forEach((issueId)=>{
                const issueToUpdateIndex = existingEdges.findIndex((issue)=>issue?.node?.issueId === Number(issueId)) ?? undefined;
                const existingIssue = existingEdges[issueToUpdateIndex];
                if (existingIssue?.node == null || issueToUpdateIndex === undefined || issueToUpdateIndex === -1 || existingIssue == null) return;
                const itemOverride = updateItem(existingIssue.node);
                if (itemOverride === undefined) return;
                hasItemOverride = true;
                newEdges[issueToUpdateIndex] = {
                    node: itemOverride,
                    __typename: 'JiraWorkManagementViewItemEdge'
                };
            });
            if (!hasItemOverride) return;
            client.writeQuery({
                query: query,
                variables: variables,
                data: {
                    ...data,
                    jira: {
                        ...data?.jira ?? {},
                        list: {
                            ...listData,
                            edges: newEdges,
                            totalCount: newEdges.length
                        }
                    }
                }
            });
            (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), 'apolloCacheWrite taskSuccess', {
                task: analyticsTaskName
            });
            (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), 'apolloUpdateItemsInCache taskSuccess', {
                task: analyticsTaskName
            });
        } catch (e) {
            (0, $guiFP.default)({
                error: e instanceof Error ? e : new Error('Unknown cache write error'),
                meta: {
                    id: 'updateItemsInCache',
                    packageName: 'jiraBusinessListHandlers',
                    teamName: 'keystone'
                },
                sendToPrivacyUnsafeSplunk: true,
                skipSentry: true,
                attributes: {
                    task: analyticsTaskName,
                    query: JSON.stringify(query),
                    variables: JSON.stringify(variables),
                    eventName: 'apolloCacheWrite taskFail',
                    error: JSON.stringify(e)
                }
            });
        }
    }, [
        client,
        createAnalyticsEvent
    ]);
    return {
        addToCache: addToCache,
        removeFromCache: removeFromCache,
        getCachedIssueById: getCachedIssueById,
        updateItemsInCache: updateItemsInCache
    };
};

});
parcelRegister("kmr29", function(module, exports) {

$parcel$export(module.exports, "useFieldValue", () => $da19d1ee706d4a81$export$b79fae7fbe3ac392);
$parcel$export(module.exports, "useFieldsValues", () => $da19d1ee706d4a81$export$25b73e671fe7a8fa);
$parcel$export(module.exports, "useFieldValuesForIssues", () => $da19d1ee706d4a81$export$ac289b84121829df);
$parcel$export(module.exports, "useMultiFieldValuesForIssues", () => $da19d1ee706d4a81$export$915cdeec521b54f7);
$parcel$export(module.exports, "FieldValueSubscriber", () => $da19d1ee706d4a81$export$4e5f1f4ed08d155e);
$parcel$export(module.exports, "useFieldsValuesActions", () => $da19d1ee706d4a81$export$612d9bcb0c9d8976);

var $eUqFw = parcelRequire("eUqFw");

var $2vzCR = parcelRequire("2vzCR");

var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");
var $dYfll = parcelRequire("dYfll");
const $da19d1ee706d4a81$var$setIssue = (issueKey, fields)=>({ setState: setState })=>{
        setState({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [issueKey]: fields
        });
    };
const $da19d1ee706d4a81$var$setIssues = (issues)=>({ setState: setState })=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const newIssues = {};
        issues.forEach((issue)=>{
            Object.assign(newIssues, issue);
        });
        setState(newIssues);
    };
const $da19d1ee706d4a81$var$setFieldValue = (issueKey, fieldKey, value)=>({ setState: setState, getState: getState })=>{
        setState({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [issueKey]: {
                ...getState()[issueKey],
                [fieldKey]: value
            }
        });
    };
const $da19d1ee706d4a81$var$getFieldValue = (issueKey, fieldKey)=>({ getState: getState })=>{
        const issueFieldValues = getState()[issueKey];
        return issueFieldValues && issueFieldValues[fieldKey];
    };
const $da19d1ee706d4a81$var$mergeIssue = (issueKey, fields)=>({ setState: setState, getState: getState })=>{
        setState({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [issueKey]: (0, (/*@__PURE__*/$parcel$interopDefault($2vzCR)))({}, getState()[issueKey], fields)
        });
    };
const $da19d1ee706d4a81$export$11aa02e14fdf7753 = (issues)=>({ setState: setState, getState: getState })=>{
        if (issues.length === 0) return;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const newIssues = {};
        issues.forEach((issue)=>{
            Object.assign(newIssues, issue);
        });
        setState((0, (/*@__PURE__*/$parcel$interopDefault($2vzCR)))({}, getState(), newIssues));
    };
const $da19d1ee706d4a81$var$actions = {
    setFieldValue: $da19d1ee706d4a81$var$setFieldValue,
    getFieldValue: $da19d1ee706d4a81$var$getFieldValue,
    setIssue: $da19d1ee706d4a81$var$setIssue,
    mergeIssue: $da19d1ee706d4a81$var$mergeIssue,
    setIssues: $da19d1ee706d4a81$var$setIssues,
    mergeIssues: $da19d1ee706d4a81$export$11aa02e14fdf7753
};
// this is a global store
const $da19d1ee706d4a81$var$store = (0, $a61MH.createStore)({
    name: 'issue-fields',
    initialState: {},
    actions: $da19d1ee706d4a81$var$actions
});
const $da19d1ee706d4a81$var$getFieldValueSelector = (state, { issueKey: issueKey, fieldKey: fieldKey })=>{
    const issueFieldValues = state[issueKey];
    return issueFieldValues && issueFieldValues[fieldKey];
};
const $da19d1ee706d4a81$var$getFieldValuesForIssuesSelector = (state, { issueKeys: issueKeys, fieldKey: fieldKey })=>(issueKeys || []).map((issueKey)=>$da19d1ee706d4a81$var$getFieldValueSelector(state, {
            fieldKey: fieldKey,
            issueKey: issueKey
        }));
const $da19d1ee706d4a81$var$getMultiFieldValuesForIssuesSelector = (state, { issueKeys: issueKeys, fieldKeys: fieldKeys })=>(issueKeys || []).reduce((accumulator, issueKey)=>{
        if (!state[issueKey]) return accumulator;
        const fieldValue = fieldKeys.reduce((acc, fieldKey)=>{
            acc[fieldKey] = $da19d1ee706d4a81$var$getFieldValueSelector(state, {
                fieldKey: fieldKey,
                issueKey: issueKey
            });
            return acc;
        }, {});
        accumulator[issueKey] = fieldValue;
        return accumulator;
    }, {});
const $da19d1ee706d4a81$var$getAllFields = (state, issueKey)=>state[issueKey];
const $da19d1ee706d4a81$export$b79fae7fbe3ac392 = (0, $ggKAj.createHook)($da19d1ee706d4a81$var$store, {
    selector: $da19d1ee706d4a81$var$getFieldValueSelector
});
const $da19d1ee706d4a81$export$25b73e671fe7a8fa = (0, $ggKAj.createHook)($da19d1ee706d4a81$var$store, {
    selector: $da19d1ee706d4a81$var$getAllFields
});
const $da19d1ee706d4a81$export$ac289b84121829df = (0, $ggKAj.createHook)($da19d1ee706d4a81$var$store, {
    selector: $da19d1ee706d4a81$var$getFieldValuesForIssuesSelector
});
const $da19d1ee706d4a81$export$915cdeec521b54f7 = (0, $ggKAj.createHook)($da19d1ee706d4a81$var$store, {
    selector: $da19d1ee706d4a81$var$getMultiFieldValuesForIssuesSelector
});
const $da19d1ee706d4a81$export$4e5f1f4ed08d155e = (0, $dYfll.createSubscriber)($da19d1ee706d4a81$var$store, {
    selector: $da19d1ee706d4a81$var$getFieldValueSelector
});
const $da19d1ee706d4a81$var$useFieldValueStoreActions = (0, $ggKAj.createHook)($da19d1ee706d4a81$var$store, {
    selector: null
});
const $da19d1ee706d4a81$export$612d9bcb0c9d8976 = ()=>{
    const [, fieldValueStoreActions] = $da19d1ee706d4a81$var$useFieldValueStoreActions();
    const fieldsValuesActions = (0, $eUqFw.useMemo)(()=>{
        const setIssueAction = (issueKey, fields)=>fieldValueStoreActions.setIssue(issueKey, fields);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const setFieldValueAction = (issueKey, fieldKey, value)=>fieldValueStoreActions.setFieldValue(issueKey, fieldKey, value);
        const getFieldValueAction = (issueKey, fieldKey)=>fieldValueStoreActions.getFieldValue(issueKey, fieldKey);
        const mergeIssueAction = (issueKey, fields)=>fieldValueStoreActions.mergeIssue(issueKey, fields);
        const setIssuesAction = (issues)=>fieldValueStoreActions.setIssues(issues);
        const mergeIssuesAction = (issues)=>fieldValueStoreActions.mergeIssues(issues);
        return {
            setIssue: setIssueAction,
            setFieldValue: setFieldValueAction,
            getFieldValue: getFieldValueAction,
            mergeIssue: mergeIssueAction,
            setIssues: setIssuesAction,
            mergeIssues: mergeIssuesAction
        };
    }, [
        fieldValueStoreActions
    ]);
    return [
        null,
        fieldsValuesActions
    ];
};

});

parcelRegister("7Sz8O", function(module, exports) {

$parcel$export(module.exports, "OPTIMISTIC_ID_PREFIX", () => $f5561e29bb49c6a7$export$a76c6afcd77fffd8);
$parcel$export(module.exports, "OPTIMISTIC_ISSUE_ID", () => $f5561e29bb49c6a7$export$2bc461aaabcabfc9);
$parcel$export(module.exports, "ROOT_LEVEL", () => $f5561e29bb49c6a7$export$d24bbd23c8a5d65e);
$parcel$export(module.exports, "GROUP_ITEM_PREFIX", () => $f5561e29bb49c6a7$export$b29b9e70f9850100);
const $f5561e29bb49c6a7$export$a76c6afcd77fffd8 = '-optimistic';
const $f5561e29bb49c6a7$export$2bc461aaabcabfc9 = -1;
const $f5561e29bb49c6a7$export$d24bbd23c8a5d65e = 'rootLevel';
const $f5561e29bb49c6a7$export$b29b9e70f9850100 = 'GROUP_BY';

});

parcelRegister("4oWxH", function(module, exports) {

$parcel$export(module.exports, "getParentIssueId", () => $f8cd47f415fc2d3e$export$846a0afb93794223);
$parcel$export(module.exports, "isGroupItem", () => $f8cd47f415fc2d3e$export$dcc23ed179776a3b);
$parcel$export(module.exports, "getGroupItemId", () => $f8cd47f415fc2d3e$export$4f6368343f5d1a95);
$parcel$export(module.exports, "isRootLevel", () => $f8cd47f415fc2d3e$export$7044e84e19490c29);

var $3uSNh = parcelRequire("3uSNh");

var $1ybV0 = parcelRequire("1ybV0");

var $7Sz8O = parcelRequire("7Sz8O");
const $f8cd47f415fc2d3e$export$3ba5d152e044664d = (parentIssue, subtaskFieldIssue)=>{
    const parentIssueFields = parentIssue.fields || [];
    const subtasksFieldIndex = parentIssueFields.findIndex((field)=>field?.fieldKey === 'subtasks');
    const subtasksField = typeof subtasksFieldIndex === 'number' && subtasksFieldIndex !== -1 ? parentIssueFields[subtasksFieldIndex] : undefined;
    if (subtasksFieldIndex === -1 || subtasksField == null) // there should be a subtask field always in the code
    // since it's declared in the gql
    return parentIssue;
    const updatedFields = [
        ...parentIssueFields
    ];
    updatedFields[subtasksFieldIndex] = {
        ...updatedFields[subtasksFieldIndex],
        issues: [
            subtaskFieldIssue,
            ...subtasksField?.issues || []
        ].filter((issue, index, issueArray)=>issueArray.findIndex((current)=>current.issueId === issue.issueId) === index)
    };
    return {
        ...parentIssue,
        // we're updating just the subtasks field, but flow doesn't understand that because the union type of fields
        fields: updatedFields
    };
};
const $f8cd47f415fc2d3e$export$30019f8058090ccb = (isFiltering, id)=>{
    if (id === (0, $7Sz8O.OPTIMISTIC_ISSUE_ID)) return false;
    return !isFiltering;
};
const $f8cd47f415fc2d3e$export$d9893aac42f29b60 = (node)=>{
    const issueKey = (0, $3uSNh.safeGetValue)(node.fields, 'issuekey', 'text', undefined);
    const parentIssue = (0, $3uSNh.safeGetValue)(node.fields, 'parent', 'parentIssue', undefined);
    const projectKey1 = (issueKey ?? '').split('-')[0];
    const projectKey2 = (parentIssue?.key ?? '').split('-')[0];
    const sameProject = projectKey1 && projectKey2 ? projectKey1 === projectKey2 : false;
    return sameProject ? parentIssue?.issueId : undefined;
};
const $f8cd47f415fc2d3e$export$846a0afb93794223 = (node)=>{
    if ((0, $1ybV0.ff)('list-uses-new-jql-parent-project-directive_v5gfs')) return $f8cd47f415fc2d3e$export$d9893aac42f29b60(node);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const parentIssue = (0, $3uSNh.safeGetValue)(node.fields, 'parent', 'parentIssue', undefined);
    if (parentIssue?.issueId) return parentIssue?.issueId;
    return undefined;
};
const $f8cd47f415fc2d3e$export$dcc23ed179776a3b = (issueId = '')=>typeof issueId === 'string' && issueId.startsWith((0, $7Sz8O.GROUP_ITEM_PREFIX));
const $f8cd47f415fc2d3e$export$4f6368343f5d1a95 = (issueId)=>{
    const [_, groupItemId] = issueId.split(`${(0, $7Sz8O.GROUP_ITEM_PREFIX)}_`);
    return groupItemId ?? issueId;
};
const $f8cd47f415fc2d3e$export$7044e84e19490c29 = (issueId)=>{
    if ((0, $1ybV0.ff)('jwm-list-view-update-group-count_36voh')) return issueId === (0, $7Sz8O.ROOT_LEVEL);
    if (!issueId) return false;
    return issueId === (0, $7Sz8O.ROOT_LEVEL) || $f8cd47f415fc2d3e$export$dcc23ed179776a3b(issueId);
};

});


parcelRegister("12sJv", function(module, exports) {

$parcel$export(module.exports, "useIssuePagination", () => $f9609ccfe0ed4e32$export$b49565a42289e6b);
$parcel$export(module.exports, "useJqlPagination", () => $f9609ccfe0ed4e32$export$9408824d9baedabc);
$parcel$export(module.exports, "useRefreshInterval", () => $f9609ccfe0ed4e32$export$7cfdc4e3bbeb1790);

var $eUqFw = parcelRequire("eUqFw");

var $lyOYo = parcelRequire("lyOYo");

var $iZuDo = parcelRequire("iZuDo");

var $1ybV0 = parcelRequire("1ybV0");

var $aVwtE = parcelRequire("aVwtE");
const $f9609ccfe0ed4e32$var$paginationOptionsForIssuesByJql = {
    uniqueId: 'issueId',
    filter: 'jql'
};
function $f9609ccfe0ed4e32$export$f80c710216eae131({ data: data, variables: variables, listName: listName, query: query, onError: onError, errorPolicy: errorPolicy = 'none', uniqueId: uniqueId, filter: filter }) {
    const [isLoadingNextPage, setIsLoadingNextPage] = (0, $eUqFw.useState)(false);
    const _data = data && (0, $aVwtE.getAGGCompliantData)(data, listName, onError);
    const hasNextPage = _data?.pageInfo?.hasNextPage || false;
    const endCursor = _data?.pageInfo?.endCursor || '';
    const fetchMore = (0, $aVwtE.useFetchMore)({
        query: query,
        variables: variables
    });
    /**
	 * creating a useRef for onError so that we don't regenerate the `next` function every time `onError` changes.
	 * - This will make the `next` reference to be more resistant to reference changes in case consumer inline the `onError` function
	 * - Moreover, `onError` is not affecting the data that we fetch, since it will be only called in in-need basis
	 * - Additionally in apollo repository, `onError` is also excluded from memoization list  (check the useQuery)
	 */ const onErrorRef = (0, $eUqFw.useRef)();
    onErrorRef.current = onError;
    const resetWhenChanged = filter ? variables[filter] : variables;
    (0, $eUqFw.useEffect)(()=>{
        // reset next page state
        setIsLoadingNextPage(false);
    }, [
        resetWhenChanged
    ]);
    const updateQueryAGGCompliant = (0, $eUqFw.useCallback)(// @ts-expect-error TS2345 - Argument of type '(prev: TData, { fetchMoreResult }: { fetchMoreResult?: TData | undefined; variables: TVariables; }) => TData | { jira: { [x: string]: any; }; }' is not assignable to parameter of type '(prev: TData, options: { fetchMoreResult?: TData | undefined; variables: TVariables; }) => TData'.
    (prev, { fetchMoreResult: fetchMoreResult })=>{
        setIsLoadingNextPage(false);
        if (!fetchMoreResult) return prev;
        const edges = [
            ...(0, $aVwtE.getAGGCompliantData)(prev, listName)?.edges || [],
            ...(0, $aVwtE.getAGGCompliantData)(fetchMoreResult, listName)?.edges || []
        ];
        return {
            jira: {
                ...fetchMoreResult.jira,
                [listName]: {
                    ...(0, $aVwtE.getAGGCompliantData)(fetchMoreResult, listName),
                    edges: (0, (/*@__PURE__*/$parcel$interopDefault($lyOYo)))(edges, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    (edge)=>edge?.node && edge.node[uniqueId])
                }
            }
        };
    }, [
        setIsLoadingNextPage,
        listName,
        uniqueId
    ]);
    const next = (0, $eUqFw.useCallback)((after)=>{
        setIsLoadingNextPage(true);
        fetchMore({
            after: after,
            onError: onErrorRef.current,
            errorPolicy: errorPolicy,
            updateQuery: updateQueryAGGCompliant
        });
    }, [
        fetchMore,
        updateQueryAGGCompliant,
        errorPolicy
    ]);
    return {
        hasNextPage: hasNextPage,
        endCursor: endCursor,
        isLoadingNextPage: isLoadingNextPage,
        next: next
    };
}
const $f9609ccfe0ed4e32$export$b49565a42289e6b = (options)=>$f9609ccfe0ed4e32$export$f80c710216eae131({
        ...options,
        ...$f9609ccfe0ed4e32$var$paginationOptionsForIssuesByJql
    });
const $f9609ccfe0ed4e32$export$ea10f704343077db = ({ variables: variables, query: query, onCompleted: onCompleted, onError: onError, onPaginationError: onPaginationError, onNextPageLoaded: onNextPageLoaded, uniqueId: uniqueId, filter: filter, fetchPolicy: fetchPolicy, errorPolicy: errorPolicy = 'none' })=>{
    const [inFlightPage, setInFlightPage] = (0, $eUqFw.useState)();
    const resetWhenChanged = filter ? variables[filter] : variables;
    (0, $eUqFw.useEffect)(()=>{
        // reset inflight track
        setInFlightPage(null);
    }, [
        resetWhenChanged
    ]);
    const [loadFirstPage, { data: data, loading: loading, error: error, refetch: refetch }] = (0, $iZuDo.useLazyQuery)(query, {
        variables: variables,
        errorPolicy: errorPolicy,
        fetchPolicy: fetchPolicy || 'network-only',
        onCompleted: onCompleted,
        onError: onError
    });
    if ((0, $1ybV0.ff)('jwm.fix-list-view-jql-query-errors_5jp7y') && data?.jira?.list?.__typename === 'QueryError') onError && onError(data?.jira?.list);
    const { next: next, hasNextPage: hasNextPage, endCursor: endCursor, isLoadingNextPage: isLoadingNextPage } = $f9609ccfe0ed4e32$export$f80c710216eae131({
        data: data,
        variables: variables,
        listName: 'list',
        onError: onPaginationError,
        errorPolicy: errorPolicy,
        query: query,
        uniqueId: uniqueId,
        filter: filter
    });
    const loadNextPage = (0, $eUqFw.useCallback)(()=>{
        /*
		 * Do not load the same page twice and do not load the next page if
		 * a request is already in progress.
		 */ if (!hasNextPage || endCursor === inFlightPage || loading) return;
        setInFlightPage(endCursor);
        next(endCursor);
        onNextPageLoaded && onNextPageLoaded();
    }, [
        endCursor,
        hasNextPage,
        inFlightPage,
        next,
        onNextPageLoaded,
        loading
    ]);
    return {
        loading: loading,
        error: error,
        data: data,
        loadFirstPage: loadFirstPage,
        hasNextPage: hasNextPage,
        isLoadingNextPage: isLoadingNextPage,
        loadNextPage: loadNextPage,
        refetch: refetch
    };
};
const $f9609ccfe0ed4e32$export$9408824d9baedabc = (options)=>$f9609ccfe0ed4e32$export$ea10f704343077db({
        ...options,
        ...$f9609ccfe0ed4e32$var$paginationOptionsForIssuesByJql
    });
const $f9609ccfe0ed4e32$export$7cfdc4e3bbeb1790 = (callback, condition, interval)=>{
    (0, $eUqFw.useEffect)(()=>{
        if (interval == null) // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        return ()=>{};
        const timer = setTimeout(()=>{
            if (condition) callback();
        }, interval * 1000);
        return ()=>{
            clearTimeout(timer);
        };
    }, [
        interval,
        callback,
        condition
    ]);
};

});

parcelRegister("hszK4", function(module, exports) {

$parcel$export(module.exports, "getVariables", () => $94d5f669705afeaf$export$a39eddd73bba62c1);

var $i3K0B = parcelRequire("i3K0B");
const $94d5f669705afeaf$var$DEFAULT_CHILDREN_PER_PAGE = 100;
const $94d5f669705afeaf$export$a39eddd73bba62c1 = (input)=>{
    const overriddenVariables = input.parentIssue ? {
        first: $94d5f669705afeaf$var$DEFAULT_CHILDREN_PER_PAGE
    } : {};
    return {
        ...(0, $i3K0B.getVariables)(input),
        ...overriddenVariables
    };
};

});

parcelRegister("2wbrs", function(module, exports) {

$parcel$export(module.exports, "useRankTimelineIssue", () => $789ffd0044220774$export$6c4394ff949c90b);

var $eUqFw = parcelRequire("eUqFw");

var $4G5xU = parcelRequire("4G5xU");

var $fGBNA = parcelRequire("fGBNA");

var $k8Qyf = parcelRequire("k8Qyf");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $2nzpw = parcelRequire("2nzpw");

var $HYwha = parcelRequire("HYwha");
const $789ffd0044220774$export$8d4e704b1891708c = {
    type: 'error',
    title: (0, $HYwha.default).rankItemErrorTitle,
    description: (0, $HYwha.default).rankItemGenericErrorDescription
};
const $789ffd0044220774$export$3d4660e65f55cbb9 = {
    type: 'error',
    title: (0, $HYwha.default).rankItemErrorTitle,
    description: (0, $HYwha.default).rankItem404ErrorDescription
};
const $789ffd0044220774$export$8e1bffd4c5401c9e = {
    type: 'error',
    title: (0, $HYwha.default).rankItemErrorTitle,
    description: (0, $HYwha.default).rankItem403ErrorDescription
};
const $789ffd0044220774$export$6c4394ff949c90b = ({ queryVariables: queryVariables, query: query })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const startExperience = (0, $4G5xU.useExperienceStart)((0, $2nzpw.RANK_ISSUE_EXPERIENCE));
    const markExperienceSuccess = (0, $4G5xU.useExperienceSuccess)((0, $2nzpw.RANK_ISSUE_EXPERIENCE));
    const markExperienceFailed = (0, $4G5xU.useExperienceFail)((0, $2nzpw.RANK_ISSUE_EXPERIENCE));
    const issueToRankRef = (0, $eUqFw.useRef)();
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagService)();
    const { rank: rank } = (0, $fGBNA.useRankIssue)({
        query: query,
        variables: queryVariables,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        onError: (error)=>{
            if (error.statusCode === 403) showFlag($789ffd0044220774$export$8e1bffd4c5401c9e);
            else if (error.statusCode === 404) showFlag($789ffd0044220774$export$3d4660e65f55cbb9);
            else {
                showFlag($789ffd0044220774$export$8d4e704b1891708c);
                if (error.statusCode >= 500) {
                    markExperienceFailed('Issue rank failed.', error);
                    return;
                }
            }
            markExperienceSuccess();
            (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'timelineRankIssue failure');
        },
        onSuccess: ()=>{
            markExperienceSuccess();
            (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'timelineRankIssue success');
            issueToRankRef.current = null;
        },
        onStart: ()=>{
            startExperience();
        }
    });
    return {
        rankIssue: rank
    };
};

});
parcelRegister("fGBNA", function(module, exports) {

$parcel$export(module.exports, "useRankIssue", () => $3fdb897bb751e0ab$export$dbe3d15eebe7e64c);

var $eUqFw = parcelRequire("eUqFw");

var $lskA1 = parcelRequire("lskA1");

var $1ybV0 = parcelRequire("1ybV0");

var $lRmyA = parcelRequire("lRmyA");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $hTnQu = parcelRequire("hTnQu");

var $85tnI = parcelRequire("85tnI");
const $3fdb897bb751e0ab$var$performRestCall = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
performRequest, url, issueId, relativeIssueId, setLoading, onError, onSuccess)=>{
    performRequest(url, {
        body: JSON.stringify({
            issueId: Number(issueId),
            relativeIssueId: Number(relativeIssueId)
        })
    }).then(()=>{
        setLoading(false);
        onSuccess && onSuccess();
    }).catch((error)=>{
        setLoading(false);
        onError && onError(error);
    });
};
const $3fdb897bb751e0ab$export$dbe3d15eebe7e64c = ({ query: query, variables: variables, onError: onError, onSuccess: onSuccess, onStart: onStart })=>{
    const [loading, setLoading] = (0, $eUqFw.useState)(false);
    const { getCachedIssueById: getCachedIssueById, updateItemsInCache: updateItemsInCache } = (0, $hTnQu.useCacheActions)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const queryRef = (0, $eUqFw.useRef)(query);
    queryRef.current = query;
    const variablesRef = (0, $eUqFw.useRef)(variables);
    variablesRef.current = variables;
    const rank = (0, $eUqFw.useCallback)(({ issueId: issueId, relativeIssue: relativeIssue, rankCall: rankCall, skipUpdateCache: skipUpdateCache, variablesInput: variablesInput })=>{
        setLoading(true);
        onStart && onStart();
        const cacheVariables = variablesInput ?? variablesRef.current;
        const issueToRank = getCachedIssueById({
            issueId: issueId,
            query: queryRef.current,
            variables: cacheVariables
        });
        const relativeIssueRank = relativeIssue.rank;
        if (issueToRank && relativeIssueRank) {
            const optimisticRank = rankCall === 'rankBefore' ? (0, $lskA1.getPreviousRank)(relativeIssueRank) : (0, $lskA1.getNextRank)(relativeIssueRank);
            if ((0, $1ybV0.ff)('jwm.visual-hierarchy-milestone-1') || (0, $1ybV0.ff)('jwm.visual-hierarchy-dnd')) // Skip updating the rank field in cache if re-rank issue is part of the reparenting operation.
            {
                if (!skipUpdateCache) updateItemsInCache({
                    query: queryRef.current,
                    variables: cacheVariables,
                    issueIds: [
                        issueToRank?.issueId
                    ],
                    updateItem: ()=>(0, $85tnI.getOptimisticRanked)(issueToRank, optimisticRank)
                });
            } else updateItemsInCache({
                query: queryRef.current,
                variables: cacheVariables,
                issueIds: [
                    issueToRank?.issueId
                ],
                updateItem: ()=>(0, $85tnI.getOptimisticRanked)(issueToRank, optimisticRank)
            });
            $3fdb897bb751e0ab$var$performRestCall((0, $lRmyA.performPutRequest), `/rest/board-api/1/rank/${rankCall}`, Number(issueToRank.issueId), Number(relativeIssue.issueId), setLoading, (error)=>{
                onError(error);
                updateItemsInCache({
                    query: query,
                    variables: cacheVariables,
                    issueIds: [
                        issueToRank?.issueId
                    ],
                    updateItem: (existingIssue)=>({
                            ...existingIssue,
                            fields: existingIssue.fields?.filter((field)=>field?.aliasFieldId !== 'rank').concat(issueToRank.fields?.find((field)=>field?.aliasFieldId === 'rank'))
                        })
                });
            }, ()=>{
                onSuccess && onSuccess();
                (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), 'issueRank succeeded');
            });
        } else setLoading(false);
    }, [
        createAnalyticsEvent,
        getCachedIssueById,
        onError,
        onStart,
        onSuccess,
        query,
        updateItemsInCache
    ]);
    const rankListViewIssue = (0, $eUqFw.useCallback)(({ newIndex: newIndex, oldIndex: oldIndex, issues: issues, issueToRank: prevIssueToRank, variables: variablesInput, skipUpdateCache: skipUpdateCache, instruction: instruction, relativeIssueOverride: relativeIssueOverride })=>{
        const rankingIssue = (0, $1ybV0.ff)('jwm.visual-hierarchy-dnd') ? prevIssueToRank ?? issues[oldIndex] : issues[oldIndex];
        const { rankCall: rankCall, relativeIssue: relativeIssue } = (0, $85tnI.getListViewRelativeIssueInfo)({
            newIndex: newIndex,
            oldIndex: oldIndex,
            issues: issues,
            instruction: instruction,
            relativeIssueOverride: relativeIssueOverride
        });
        if (relativeIssue) rank({
            relativeIssue: relativeIssue,
            issueId: rankingIssue.issueId,
            rankCall: rankCall,
            variablesInput: variablesInput,
            ...(0, $1ybV0.ff)('jwm.visual-hierarchy-dnd') ? {
                skipUpdateCache: skipUpdateCache
            } : {}
        });
    }, [
        rank
    ]);
    return {
        loading: loading,
        rank: rank,
        rankListViewIssue: rankListViewIssue
    };
};

});
parcelRegister("85tnI", function(module, exports) {

$parcel$export(module.exports, "getOptimisticRanked", () => $fc25204f4b93389f$export$44963c8ed1f74aef);
$parcel$export(module.exports, "getListViewRelativeIssueInfo", () => $fc25204f4b93389f$export$caf645882630a6c1);

var $1ybV0 = parcelRequire("1ybV0");

var $lO4Or = parcelRequire("lO4Or");
const $fc25204f4b93389f$export$44963c8ed1f74aef = (issue, rank)=>{
    const newRank = {
        ...issue?.fields?.find(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        (field)=>field.type === (0, $lO4Or.RANK_CF_TYPE) || field.aliasFieldId === 'rank')
    };
    newRank.text = rank;
    return {
        ...issue,
        fields: [
            ...issue?.fields?.filter(// eslint-disable-next-line @typescript-eslint/no-explicit-any
            (field)=>field.type !== (0, $lO4Or.RANK_CF_TYPE) && field.aliasFieldId !== 'rank') || [],
            newRank
        ]
    };
};
const $fc25204f4b93389f$export$caf645882630a6c1 = ({ newIndex: newIndex, oldIndex: oldIndex, issues: issues, instruction: instruction, relativeIssueOverride: relativeIssueOverride })=>{
    let rankCall = newIndex === 0 ? 'rankBefore' : 'rankAfter';
    // instruction will only be available ranking via dnd
    if ((0, $1ybV0.ff)('jwm.visual-hierarchy-dnd') && instruction) rankCall = instruction === 'reorder-below' ? 'rankAfter' : 'rankBefore';
    // if newIndex is 0 we want to optimistically rank it above the task that is
    // currently at index 0 of the collection
    let afterIndex = newIndex > oldIndex ? newIndex : Math.max(0, newIndex - 1);
    // newIndex will equal oldIndex in cases where we dnd to reparent and rank
    if ((0, $1ybV0.ff)('jwm.visual-hierarchy-dnd') && newIndex === oldIndex) afterIndex = rankCall === 'rankAfter' ? Math.max(0, newIndex - 1) : newIndex;
    let relativeIssue = relativeIssueOverride ?? issues[afterIndex];
    // if issue to rank after doesn't have a rank eg. group item then let's try and
    // rank before instead
    if (!relativeIssue?.rank) {
        const beforeIndex = newIndex > oldIndex ? Math.min(issues.length - 1, newIndex + 1) : newIndex;
        relativeIssue = issues[beforeIndex];
        rankCall = 'rankBefore';
    }
    return {
        rankCall: rankCall,
        relativeIssue: relativeIssue
    };
};

});


parcelRegister("HYwha", function(module, exports) {

$parcel$export(module.exports, "default", () => $594f6e7fa83dceb3$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $594f6e7fa83dceb3$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    rankItemErrorTitle: {
        "id": "business-timeline.services.rank-issue.rank-item-error-title",
        "defaultMessage": "Something's gone wrong"
    },
    rankItemGenericErrorDescription: {
        "id": "business-timeline.services.rank-issue.rank-item-generic-error-description",
        "defaultMessage": "Refresh the page and try again."
    },
    rankItem403ErrorDescription: {
        "id": "business-timeline.services.rank-issue.rank-item-403-error-description",
        "defaultMessage": "You don\u2019t have permission to move this issue. Contact a project admin."
    },
    rankItem404ErrorDescription: {
        "id": "business-timeline.services.rank-issue.rank-item-404-error-description",
        "defaultMessage": "We\u2019re having trouble moving this issue. To continue, refresh the page."
    }
});

});


parcelRegister("1IC6t", function(module, exports) {

$parcel$export(module.exports, "transformResult", () => $01ba744676a65a69$export$f13b29f9ed0c5a03);
$parcel$export(module.exports, "addChildToParentTimeline", () => $01ba744676a65a69$export$d85b7ed06474d572);
$parcel$export(module.exports, "rankSorter", () => $01ba744676a65a69$export$3aa46dde0a2e6e47);

var $jGcn0 = parcelRequire("jGcn0");

var $1ybV0 = parcelRequire("1ybV0");

var $lO4Or = parcelRequire("lO4Or");

var $6BYzZ = parcelRequire("6BYzZ");
const $01ba744676a65a69$var$transformField = (field)=>{
    if (!field) return {};
    const fieldId = field?.aliasFieldId || field?.fieldId;
    switch(fieldId){
        case 'issuekey':
            return {
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                key: field.text
            };
        case 0, $lO4Or.SUMMARY_TYPE:
            return {
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                summary: field?.text
            };
        case 0, $lO4Or.STATUS_TYPE:
            {
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                const { status: status } = field;
                return {
                    status: {
                        id: status.statusId,
                        name: status.name,
                        categoryId: status.statusCategory?.statusCategoryId
                    }
                };
            }
        case 0, $lO4Or.ISSUE_TYPE:
            {
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                const { issueType: issueType } = field;
                return {
                    issueType: {
                        id: issueType?.issueTypeId,
                        name: issueType?.name,
                        iconUrl: issueType?.avatar?.medium,
                        hierarchyLevel: issueType?.hierarchy?.level ?? 0
                    }
                };
            }
        case 'rank':
            return {
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                rank: field?.text
            };
        case 0, $jGcn0.START_DATE_ALIAS_FIELD_ID:
            {
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                const { date: date } = field;
                return {
                    startDate: (0, $6BYzZ.toDateOnly)(date)?.toUTCDate().valueOf()
                };
            }
        case 0, $lO4Or.DUE_DATE_TYPE:
            {
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                const { date: date } = field;
                return {
                    dueDate: (0, $6BYzZ.toDateOnly)(date)?.toUTCDate().valueOf()
                };
            }
        case 0, $lO4Or.ASSIGNEE_TYPE:
            {
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                const { user: user } = field;
                return {
                    assignee: (user && {
                        avatarUrl: user.picture,
                        displayName: user.name,
                        accountId: user.accountId
                    }) ?? undefined
                };
            }
        default:
            return {};
    }
};
const $01ba744676a65a69$var$INWARD = 'INWARD';
const $01ba744676a65a69$var$transformIssueLinks = (edges)=>{
    if (edges == null || !Array.isArray(edges) || edges.length === 0) return [];
    return edges.filter((edge)=>edge?.node).map((edge)=>{
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const { issueLinkId: issueLinkId, direction: direction, relationName: relationName, issue: issue } = edge.node;
        return {
            issueLinkId: issueLinkId || null,
            type: {
                inward: direction === $01ba744676a65a69$var$INWARD ? relationName || '' : '',
                outward: direction === $01ba744676a65a69$var$INWARD ? '' : relationName || ''
            },
            inward: direction === $01ba744676a65a69$var$INWARD ? {
                issueId: issue?.issueId ?? null
            } : null,
            outward: direction === $01ba744676a65a69$var$INWARD ? null : {
                issueId: issue?.issueId ?? null
            }
        };
    });
};
const $01ba744676a65a69$var$emptyArray = [];
const $01ba744676a65a69$export$f13b29f9ed0c5a03 = (edges)=>{
    if (edges == null || !Array.isArray(edges)) return {
        issues: []
    };
    const issues = edges.reduce((transformedData, edge)=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const populateItem = (acc, field)=>({
                ...acc,
                ...$01ba744676a65a69$var$transformField(field)
            });
        if (edge && edge.node && Array.isArray(edge.node?.fields)) {
            const issueLinkEdges = edge.node?.issueLinks?.edges || $01ba744676a65a69$var$emptyArray;
            const item = edge.node.fields.reduce(populateItem, {
                id: edge.node.id,
                issueId: String(edge.node.issueId),
                hasChildren: !!edge.node?.childSummary?.hasChildren,
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                issueLinks: $01ba744676a65a69$var$transformIssueLinks(issueLinkEdges),
                originalIssueLinks: issueLinkEdges
            });
            transformedData.push(item);
        }
        return transformedData;
    }, []);
    return {
        issues: issues
    };
};
const $01ba744676a65a69$export$d85b7ed06474d572 = (parentIssue)=>({
        ...parentIssue,
        childSummary: {
            __typename: 'JiraWorkManagementChildSummary',
            hasChildren: true
        }
    });
const $01ba744676a65a69$var$getIssueFieldByName = (edge, targetField)=>edge?.node?.fields?.find((field)=>(field?.aliasFieldId || field?.fieldId) === targetField);
const $01ba744676a65a69$var$issueIsSubTask = (edge)=>// @ts-expect-error - ts-2339 Property 'issueType' does not exist on type 'JWMTimelineViewItems_jira_list_JiraWorkManagementViewItemConnection_edges_node_fields'.
    $01ba744676a65a69$var$getIssueFieldByName(edge, 'issuetype')?.issueType?.name === 'Sub-task';
const $01ba744676a65a69$var$getParentRank = (edge)=>// @ts-expect-error - ts-2339 Property 'issueType' does not exist on type 'JWMTimelineViewItems_jira_list_JiraWorkManagementViewItemConnection_edges_node_fields'.
    $01ba744676a65a69$var$getIssueFieldByName(edge, 'parent')?.parentIssue?.rankField?.[0].text ?? '';
const $01ba744676a65a69$export$3aa46dde0a2e6e47 = (edge)=>{
    // @ts-expect-error - ts-2339 Property 'issueType' does not exist on type 'JWMTimelineViewItems_jira_list_JiraWorkManagementViewItemConnection_edges_node_fields'.
    const rank = $01ba744676a65a69$var$getIssueFieldByName(edge, 'rank')?.text;
    if ((0, $1ybV0.ff)('jwm-timeline-sort-parent-rank-first_waal4')) {
        if ($01ba744676a65a69$var$issueIsSubTask(edge)) {
            const parentRank = $01ba744676a65a69$var$getParentRank(edge);
            return parentRank.concat(rank ?? '');
        }
    }
    return rank;
};

});
parcelRegister("6BYzZ", function(module, exports) {

$parcel$export(module.exports, "DateOnly", () => $5d1ef987232e205a$export$988b361b394263b6);
$parcel$export(module.exports, "toDateOnly", () => $5d1ef987232e205a$export$b0961ad8aee63b8b);
const $5d1ef987232e205a$export$9cda9b56d134780f = 'Invalid date or date format';
const $5d1ef987232e205a$var$toISOString = (year, month, day)=>`${String(year).padStart(4, '0')}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
const $5d1ef987232e205a$var$isLeapYear = (year)=>year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
const $5d1ef987232e205a$var$daysInMonth = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
/**
 Returns a boolean to indicate that the date specified is valid.

 Note: Dates before Year zero are treated to be invalid.
 */ const $5d1ef987232e205a$var$isDateValid = (year, month, day)=>{
    if ([
        year,
        month,
        day
    ].findIndex((n)=>typeof n !== 'number' || Number.isNaN(n)) !== -1) return false;
    if (year < 0) return false;
    if (month < 1 || month > 12) return false;
    if (day < 1) return false;
    if (day > (month === 2 && $5d1ef987232e205a$var$isLeapYear(year) ? 29 : $5d1ef987232e205a$var$daysInMonth[month - 1])) return false;
    return true;
};
const $5d1ef987232e205a$var$dateFormatRegExp = /^([0-9][0-9][0-9][0-9])-([0-1][0-9])-([0-3][0-9])$/;
class $5d1ef987232e205a$export$988b361b394263b6 {
    /**
	 * Return true if the string is a valid ISO date string in the format 'YYYY-MM-DD'.
	 * @param dateString
	 * @returns {boolean}
	 */ static isISODateString(dateString) {
        try {
            $5d1ef987232e205a$export$988b361b394263b6.fromISODateString(dateString);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            if (e?.message === $5d1ef987232e205a$export$9cda9b56d134780f) return false;
            throw e;
        }
        return true;
    }
    /**
	 * Create a DateOnly object from a string in the format 'YYYY-MM-DD'.
	 */ // go/jfe-eslint
    static fromISODateString(dateString) {
        const matches = $5d1ef987232e205a$var$dateFormatRegExp.exec(dateString);
        if (matches === null) throw new Error($5d1ef987232e205a$export$9cda9b56d134780f);
        const [, year, month, day] = matches;
        // @ts-expect-error - TS2556 - A spread argument must either have a tuple type or be passed to a rest parameter.
        return new $5d1ef987232e205a$export$988b361b394263b6(...[
            year,
            month,
            day
        ].map((s)=>Number.parseInt(s, 10)));
    }
    /**
	 * DISCLAIMER:
	 * Date() does NOT store timezone information.
	 *
	 * Date.prototype.toString() leverages the system's timezone to serialize it into a string according to local time.
	 * Methods getDate(), getMonth(), getFullYear() behave the same and also return values according to local time.
	 *
	 * Methods toUTCString(), getUTCDate(), getUTCMonth(), getUTCFullYear() return values according to universal time.
	 *
	 * Reference: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date
	 */ /**
	 * Create a DateOnly object that reflects the local year, month & day for the specified Date.
	 *
	 * See the disclaimer above for further details.
	 */ // go/jfe-eslint
    static fromDateAccordingToLocalTime(date) {
        return new $5d1ef987232e205a$export$988b361b394263b6(date.getFullYear(), date.getMonth() + 1, date.getDate());
    }
    /**
	 * Create a DateOnly object that reflects the UTC year, month & day of the specified Date.
	 *
	 * See the disclaimer above for further details.
	 */ // go/jfe-eslint
    static fromDateAccordingToUTC(date) {
        return new $5d1ef987232e205a$export$988b361b394263b6(date.getUTCFullYear(), date.getUTCMonth() + 1, date.getUTCDate());
    }
    /**
	 * Compare 2 DateOnly objects.
	 *
	 * (Similar to the TC39 proposal Temporal.PlainDate.compare).
	 *
	 * If a comes before b, return -1.
	 * If a is equal to b, return 0.
	 * If a is greater than b, return 1.
	 */ static compare(a, b) {
        if (a.year === b.year) {
            if (a.month === b.month) {
                if (a.day === b.day) return 0;
                return a.day < b.day ? -1 : 1;
            }
            return a.month < b.month ? -1 : 1;
        }
        return a.year < b.year ? -1 : 1;
    }
    /**
	 * Create a DateOnly object which represents a day. It does not have a time component.
	 * @param year - A year, ranging between 0 and 9999 inclusive.
	 * @param month - A month, ranging between 1 and 12 inclusive.
	 * @param day - A day of the month, ranging between 1 and 31 inclusive.
	 */ constructor(year, month, day){
        if (!$5d1ef987232e205a$var$isDateValid(year, month, day)) throw new Error($5d1ef987232e205a$export$9cda9b56d134780f);
        this.year = year;
        this.month = month;
        this.day = day;
    }
    getYear() {
        return this.year;
    }
    getMonth() {
        return this.month;
    }
    getDay() {
        return this.day;
    }
    toISOString() {
        return $5d1ef987232e205a$var$toISOString(this.year, this.month, this.day);
    }
    /**
	 * Returns a Date object with the same date, with the time component set to 00:00:00 which corresponds to the UTC timezone.
	 */ toUTCDate() {
        return new Date(Date.UTC(this.year, this.month - 1, this.day));
    }
    /**
	 * Returns a Date object with the same date, with the time component set to 00:00:00 for the local timezone.
	 */ toLocalDate() {
        // take the current date (e.g. 1.06.2020)
        const localDate = new Date();
        // store current month in a const to compare below
        const currentMonth = localDate.getMonth();
        // set the year
        localDate.setFullYear(this.year);
        localDate.setHours(0);
        localDate.setMinutes(0);
        localDate.setSeconds(0);
        localDate.setMilliseconds(0);
        localDate.setDate(this.day);
        // if this.day doesn't exist in the current month (e.g. 31 doesn't exist in June ),
        // it will set the month to July instead. We need to make sure setDate doesn't change the month
        if (localDate.getMonth() !== currentMonth) {
            localDate.setMonth(this.month - 1);
            // reset the date after updating the month
            localDate.setDate(this.day);
        } else localDate.setMonth(this.month - 1);
        return localDate;
    }
    equals(dateOnly) {
        return $5d1ef987232e205a$export$988b361b394263b6.compare(this, dateOnly) === 0;
    }
}
const $5d1ef987232e205a$export$b0961ad8aee63b8b = (date)=>typeof date === 'string' ? $5d1ef987232e205a$export$988b361b394263b6.fromISODateString(date.replace(/T.*/, '')) : null;

});




parcelRegister("bvug1", function(module, exports) {

$parcel$export(module.exports, "useCreateItemAnchor", () => $291019385b27df3a$export$79c0b16424e10cdb);

var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");
const $291019385b27df3a$var$actions = {
    setCreateItemAnchor: (createItemAnchor)=>({ setState: setState, getState: getState })=>setState({
                ...getState(),
                createItemAnchor: createItemAnchor
            })
};
// @ts-expect-error - TS2344 - Type '{ readonly setCreateItemAnchor: (createItemAnchor: CreateItemAnchor) => ({ setState, getState }: StoreState<State>) => void; }' does not satisfy the constraint 'Record<string, ActionThunk<State, { readonly setCreateItemAnchor: (createItemAnchor: CreateItemAnchor) => ({ setState, getState }: StoreState<State>) => void; }>>'.
const $291019385b27df3a$var$Store = (0, $a61MH.createStore)({
    initialState: {
        createItemAnchor: undefined
    },
    actions: $291019385b27df3a$var$actions,
    name: 'JWMTimelineViewCreateItemAnchorStore'
});
const $291019385b27df3a$export$79c0b16424e10cdb = (0, $ggKAj.createHook)($291019385b27df3a$var$Store);

});

parcelRegister("lwlVZ", function(module, exports) {

$parcel$export(module.exports, "useDependencyUpdater", () => $9932634c75629907$export$cbe1bc5fd7675b9b);

var $eUqFw = parcelRequire("eUqFw");

var $1ybV0 = parcelRequire("1ybV0");

var $fE3Ua = parcelRequire("fE3Ua");

var $7rWus = parcelRequire("7rWus");
const $9932634c75629907$export$cbe1bc5fd7675b9b = ({ childrenQueryData: childrenQueryData })=>{
    const { onIssueUpdated: onIssueUpdated, onIssueRemoved: onIssueRemoved } = (0, $7rWus.useTimelineViewUpdater)({
        childrenQueryData: childrenQueryData
    });
    const onBentoChange = (0, $eUqFw.useCallback)((event)=>{
        if (event.type === (0, $fE3Ua.ChangeEventTypes).ISSUE_LINK_DELETED) onIssueUpdated([
            Number(event.issueId),
            Number(event.meta.linkedIssueId)
        ]);
        if (event.type === (0, $fE3Ua.ChangeEventTypes).ISSUE_LINKS_CREATED) onIssueUpdated([
            Number(event.issueId)
        ].concat(event.meta.links.map((link)=>Number(link.linkedIssueId))));
        if (event.type === (0, $fE3Ua.ChangeEventTypes).ISSUE_RELATIONSHIP_UPDATED) {
            const { issueId: issueId, meta: { oldParentIssueId: oldParentIssueId } } = event;
            if ((0, $1ybV0.ff)('jwm.visual-hierarchy-milestone-1')) // oldParentIssueId can be undefined if the issue didn't have a parent before the change
            onIssueRemoved({
                issueId: Number(issueId),
                parentId: oldParentIssueId ?? undefined
            });
            else if (oldParentIssueId) onIssueRemoved({
                issueId: Number(issueId),
                parentId: oldParentIssueId
            });
        }
    }, [
        onIssueRemoved,
        onIssueUpdated
    ]);
    const onBentoDelete = (0, $eUqFw.useCallback)(({ issueId: issueId, parentId: parentId })=>{
        onIssueRemoved({
            issueId: issueId,
            parentId: parentId
        });
    }, [
        onIssueRemoved
    ]);
    return {
        onBentoChange: onBentoChange,
        onBentoDelete: onBentoDelete
    };
};

});
parcelRegister("fE3Ua", function(module, exports) {

$parcel$export(module.exports, "ChangeEventTypes", () => $407ab16d43881e85$export$8db21fc94823e1cc);
const $407ab16d43881e85$var$FIELD_CHANGE_REQUESTED = 'FIELD_CHANGE_REQUESTED';
const $407ab16d43881e85$var$FIELD_CHANGED = 'FIELD_CHANGED';
const $407ab16d43881e85$var$FIELD_CHANGE_FAILED = 'FIELD_CHANGE_FAILED';
const $407ab16d43881e85$var$ISSUE_TYPE_CHANGED = 'ISSUE_TYPE_CHANGED';
const $407ab16d43881e85$var$ISSUE_RELATIONSHIP_UPDATED = 'ISSUE_RELATIONSHIP_UPDATED';
const $407ab16d43881e85$var$ISSUE_LINKS_CREATED = 'ISSUE_LINKS_CREATED';
const $407ab16d43881e85$var$ISSUE_LINK_DELETED = 'ISSUE_LINK_DELETED';
const $407ab16d43881e85$var$CHILD_ISSUE_ADDED = 'CHILD_ISSUE_ADDED';
const $407ab16d43881e85$var$SUBTASK_ADDED = 'SUBTASK_ADDED';
const $407ab16d43881e85$var$ISSUE_CHILDREN_ORDER_CHANGED = 'ISSUE_CHILDREN_ORDER_CHANGED';
const $407ab16d43881e85$var$CHILD_ISSUE_FIELD_UPDATED = 'CHILD_ISSUE_FIELD_UPDATED';
const $407ab16d43881e85$var$CREATE_CONFLUENCE_PAGE_LINK_SUCCESS = 'CREATE_CONFLUENCE_PAGE_LINK_SUCCESS';
const $407ab16d43881e85$var$DELETE_CONFLUENCE_PAGE_LINK_SUCCESS = 'DELETE_CONFLUENCE_PAGE_LINK_SUCCESS';
const $407ab16d43881e85$export$8db21fc94823e1cc = {
    [$407ab16d43881e85$var$FIELD_CHANGE_REQUESTED]: $407ab16d43881e85$var$FIELD_CHANGE_REQUESTED,
    [$407ab16d43881e85$var$FIELD_CHANGE_FAILED]: $407ab16d43881e85$var$FIELD_CHANGE_FAILED,
    [$407ab16d43881e85$var$FIELD_CHANGED]: $407ab16d43881e85$var$FIELD_CHANGED,
    [$407ab16d43881e85$var$ISSUE_TYPE_CHANGED]: $407ab16d43881e85$var$ISSUE_TYPE_CHANGED,
    [$407ab16d43881e85$var$ISSUE_RELATIONSHIP_UPDATED]: $407ab16d43881e85$var$ISSUE_RELATIONSHIP_UPDATED,
    [$407ab16d43881e85$var$ISSUE_LINKS_CREATED]: $407ab16d43881e85$var$ISSUE_LINKS_CREATED,
    [$407ab16d43881e85$var$ISSUE_LINK_DELETED]: $407ab16d43881e85$var$ISSUE_LINK_DELETED,
    [$407ab16d43881e85$var$CHILD_ISSUE_ADDED]: $407ab16d43881e85$var$CHILD_ISSUE_ADDED,
    [$407ab16d43881e85$var$SUBTASK_ADDED]: $407ab16d43881e85$var$SUBTASK_ADDED,
    [$407ab16d43881e85$var$ISSUE_CHILDREN_ORDER_CHANGED]: $407ab16d43881e85$var$ISSUE_CHILDREN_ORDER_CHANGED,
    [$407ab16d43881e85$var$CHILD_ISSUE_FIELD_UPDATED]: $407ab16d43881e85$var$CHILD_ISSUE_FIELD_UPDATED,
    [$407ab16d43881e85$var$CREATE_CONFLUENCE_PAGE_LINK_SUCCESS]: $407ab16d43881e85$var$CREATE_CONFLUENCE_PAGE_LINK_SUCCESS,
    [$407ab16d43881e85$var$DELETE_CONFLUENCE_PAGE_LINK_SUCCESS]: $407ab16d43881e85$var$DELETE_CONFLUENCE_PAGE_LINK_SUCCESS
};

});

parcelRegister("7rWus", function(module, exports) {

$parcel$export(module.exports, "useTimelineViewUpdater", () => $0eed9e52b8521e34$export$e47ce03a9ecfdc38);

var $gEmpR = parcelRequire("gEmpR");

var $053h2 = parcelRequire("053h2");

var $3uSNh = parcelRequire("3uSNh");

var $lGxgz = parcelRequire("lGxgz");

var $9j3OJ = parcelRequire("9j3OJ");
var $4oWxH = parcelRequire("4oWxH");
var $hTnQu = parcelRequire("hTnQu");
var $2rYp2 = parcelRequire("2rYp2");

var $guiFP = parcelRequire("guiFP");

var $1ybV0 = parcelRequire("1ybV0");

var $6vrw7 = parcelRequire("6vrw7");

var $dWLk9 = parcelRequire("dWLk9");

var $2nzpw = parcelRequire("2nzpw");

var $hszK4 = parcelRequire("hszK4");

var $am0NO = parcelRequire("am0NO");

var $PFCIp = parcelRequire("PFCIp");

var $dLnS7 = parcelRequire("dLnS7");

var $1IC6t = parcelRequire("1IC6t");
const $0eed9e52b8521e34$export$e47ce03a9ecfdc38 = ({ childrenQueryData: childrenQueryData })=>{
    const issueTypesAndFields = (0, $gEmpR.useIssueTypesAndFields)({
        issueOperation: 'VIEW'
    });
    const hierarchyLevels = (0, $1ybV0.ff)('jwm.visual-hierarchy-milestone-1') ? issueTypesAndFields.hierarchyLevels : undefined;
    const { quickFiltersJql: quickFiltersJql, hierarchyParent: hierarchyParent, sorting: sorting, jqlContext: jqlContext, isHidingDoneItems: isHidingDoneItems } = (0, $lGxgz.useFilteredViewContextInput)({
        view: 'timeline'
    });
    const { addToCache: addToCache, removeFromCache: removeFromCache, updateItemsInCache: updateItemsInCache } = (0, $hTnQu.useCacheActions)();
    const [{ issueParentMap: issueParentMap }] = (0, $am0NO.useIssueParentMap)();
    const [{ issuesMap: issuesMap }] = (0, $PFCIp.useIssuesMap)();
    const cloudId = (0, $dWLk9.useCloudId)();
    const topLevelVariables = {
        ...(0, $hszK4.getVariables)({
            jqlContext: jqlContext,
            fieldIds: $2nzpw.fieldIds,
            quickFiltersJql: quickFiltersJql,
            isHidingDoneItems: isHidingDoneItems,
            hierarchyParent: hierarchyParent,
            ...(0, $1ybV0.ff)('jwm.visual-hierarchy-milestone-1') && hierarchyLevels !== undefined && {
                // the above check will be unneccessary once the FF is removed
                hierarchyLevel: hierarchyLevels[0]?.level
            },
            sorting: sorting
        }),
        ...(0, $2nzpw.TIMELINE_PAGE_SIZE_ARGS)
    };
    const { addToCacheCallback: addToCacheCallback, removeFromCacheCallback: removeFromCacheCallback } = (0, $9j3OJ.createViewUpdaterCallbacksWithCacheActions)({
        query: (0, $dLnS7.TIMELINE_VIEW_ITEMS_QUERY),
        addToCache: addToCache,
        updateItemsInCache: updateItemsInCache,
        removeFromCache: removeFromCache,
        isHierarchyEnabled: ()=>typeof hierarchyParent !== 'undefined',
        isInfiniteHierarchyEnabled: ()=>!!(0, $1ybV0.ff)('jwm.visual-hierarchy-milestone-1'),
        createVariablesForItemWithoutParent: ()=>topLevelVariables,
        createVariablesForItemWithParent: (parentIssueId)=>{
            if (!hierarchyParent) // this scenario should be impossible because there is isHierarchyEnabled parameter above
            return topLevelVariables;
            return {
                ...(0, $hszK4.getVariables)({
                    jqlContext: jqlContext,
                    fieldIds: $2nzpw.fieldIds,
                    quickFiltersJql: quickFiltersJql,
                    isHidingDoneItems: isHidingDoneItems,
                    sorting: sorting,
                    hierarchyParent: undefined,
                    parentIssue: {
                        hierarchyType: hierarchyParent,
                        issueId: parentIssueId
                    }
                }),
                cloudId: cloudId
            };
        },
        // We only want to add or remove item if the existing query for children-of-this-parent exists
        // this is to prevent apollo error where the cache key is missing
        shouldChildItemBeAddedToOrRemovedFromCache: (parentIssueId)=>Boolean(childrenQueryData && childrenQueryData[(0, $6vrw7.toIssueId)(parentIssueId)] !== undefined),
        onUpdateParentWithNewChild: (0, $1IC6t.addChildToParentTimeline),
        getParentOfIssueIfExist: (issueId)=>{
            const maybeIssue = issuesMap.get(issueId);
            if (!maybeIssue) return undefined;
            return (0, $4oWxH.getParentIssueId)(maybeIssue);
        },
        getPrevParentOfIssueIfExists: (issueId)=>issueParentMap.get(String(issueId)),
        isItemHierarchySupported: (0, $1ybV0.ff)('jwm.visual-hierarchy-milestone-1') ? undefined : (item)=>{
            const issueType = (0, $3uSNh.safeGetValue)(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            item.fields, 'issuetype', 'issueType', null);
            // this method gets called if the item has a parent
            // if the item is a task, we don't support hierarchy
            // we return false to not update the parent query because that query doesn't exist
            if (issueType?.hierarchy?.level === 0) return false;
            return true;
        }
    });
    return (0, $2rYp2.useViewUpdater)({
        input: {
            fieldIds: $2nzpw.fieldIds,
            quickFiltersJql: quickFiltersJql,
            isHidingDoneItems: isHidingDoneItems
        },
        query: (0, $dLnS7.TIMELINE_VIEW_ITEMS_QUERY),
        actions: [
            {
                addToCache: addToCacheCallback,
                removeFromCache: removeFromCacheCallback
            }
        ],
        onError: (apolloError)=>{
            if (!(0, $053h2.shouldHandleTheError)(apolloError)) return;
            (0, $guiFP.default)({
                meta: {
                    id: 'timelineViewUpdaterQuery',
                    packageName: 'jiraBusinessTimeline',
                    teamName: 'jira-yurree'
                },
                attributes: {
                    message: 'Failed to fetch issues in timeline view updater'
                },
                error: apolloError,
                sendToPrivacyUnsafeSplunk: true
            });
        },
        onAppendItemsError: (apolloError)=>{
            if (!(0, $053h2.shouldHandleTheError)(apolloError)) return;
            (0, $guiFP.default)({
                meta: {
                    id: 'timelineViewAppendItemsQuery',
                    packageName: 'jiraBusinessTimeline',
                    teamName: 'jira-yurree'
                },
                attributes: {
                    message: 'Failed to append issues by id in timeline view updater'
                },
                error: apolloError,
                sendToPrivacyUnsafeSplunk: true
            });
        }
    });
};

});
parcelRegister("9j3OJ", function(module, exports) {

$parcel$export(module.exports, "createViewUpdaterCallbacksWithCacheActions", () => $8ac2f00f49bb3cf6$export$cc1c02509eec9edb);
$parcel$export(module.exports, "createGroupingViewUpdaterCacheActions", () => $8ac2f00f49bb3cf6$export$c410d2a23de7830a);

var $1ybV0 = parcelRequire("1ybV0");

var $4oWxH = parcelRequire("4oWxH");
const $8ac2f00f49bb3cf6$export$cc1c02509eec9edb = ({ isHierarchyEnabled: isHierarchyEnabled, isInfiniteHierarchyEnabled: isInfiniteHierarchyEnabled, query: query, addToCache: addToCache, removeFromCache: removeFromCache, updateItemsInCache: updateItemsInCache, createVariablesForItemWithParent: createVariablesForItemWithParent, createVariablesForItemWithoutParent: createVariablesForItemWithoutParent, shouldChildItemBeAddedToOrRemovedFromCache: shouldChildItemBeAddedToOrRemovedFromCache, onUpdateParentWithNewChild: onUpdateParentWithNewChild, getParentOfIssueIfExist: getParentOfIssueIfExist, isItemHierarchySupported: isItemHierarchySupported, removeChildFromParent: removeChildFromParent, updateIssueParentMap: updateIssueParentMap, getPrevParentOfIssueIfExists: getPrevParentOfIssueIfExists, createVariablesForGroupItem: createVariablesForGroupItem, isGroupingByStatus: isGroupingByStatus = false, isGrouping: isGrouping = false })=>{
    const getParentVariables = (parentId)=>{
        const variables = createVariablesForItemWithoutParent();
        if (!parentId) return variables;
        if (createVariablesForGroupItem && (0, $4oWxH.isGroupItem)(parentId)) return createVariablesForGroupItem(parentId);
        return createVariablesForItemWithParent(parentId);
    };
    const updateIssueParent = ({ prevParentIssueId: prevParentIssueId, parentIssueId: parentIssueId, item: item })=>{
        updateIssueParentMap && updateIssueParentMap(item.issueId, parentIssueId);
        if (!prevParentIssueId && !isGrouping || isGrouping && prevParentIssueId || prevParentIssueId && shouldChildItemBeAddedToOrRemovedFromCache(prevParentIssueId)) removeFromCache({
            query: query,
            variables: getParentVariables(prevParentIssueId),
            issueId: Number(item.issueId)
        });
        if (isGroupingByStatus) return;
        const hasParentToRemove = getParentOfIssueIfExist && !!getParentOfIssueIfExist(item.issueId);
        if (removeChildFromParent && prevParentIssueId && hasParentToRemove) {
            const grandParentId = getParentOfIssueIfExist ? getParentOfIssueIfExist(String(prevParentIssueId)) : undefined;
            if ((0, $4oWxH.isGroupItem)(grandParentId) || (0, $4oWxH.isGroupItem)(prevParentIssueId)) return;
            updateItemsInCache({
                query: query,
                variables: getParentVariables(grandParentId),
                issueIds: [
                    String(prevParentIssueId)
                ],
                updateItem: (existingParentIssue)=>removeChildFromParent(existingParentIssue, 1)
            });
        }
        if (!parentIssueId) return;
        // updateChildCount of new parent
        // so user will have an indicator that shows the parent has subtask now
        const newGrandParentId = getParentOfIssueIfExist ? getParentOfIssueIfExist(parentIssueId.toString()) : undefined;
        if ((0, $4oWxH.isGroupItem)(newGrandParentId) || (0, $4oWxH.isGroupItem)(parentIssueId)) return;
        updateItemsInCache({
            query: query,
            variables: getParentVariables(newGrandParentId),
            issueIds: [
                parentIssueId
            ],
            updateItem: (existingIssue)=>{
                const updatedIssueWithNewChild = onUpdateParentWithNewChild(existingIssue, item);
                return updatedIssueWithNewChild;
            }
        });
    };
    const addToCacheCallback = (items)=>{
        if (isHierarchyEnabled()) {
            const itemsWithoutParent = items.filter((i)=>(0, $4oWxH.getParentIssueId)(i) === undefined);
            const itemsWithParent = items.filter((i)=>(0, $4oWxH.getParentIssueId)(i) !== undefined);
            // add items WITHOUT parent first
            if (itemsWithoutParent.length > 0) {
                addToCache({
                    newNodes: itemsWithoutParent,
                    query: query,
                    variables: createVariablesForItemWithoutParent()
                });
                (0, $1ybV0.ff)('jwm.visual-hierarchy-milestone-1') && items.forEach((item)=>{
                    // when parent is unlinked from issue
                    const parentIssueId = undefined;
                    const prevParentIssueId = getPrevParentOfIssueIfExists ? getPrevParentOfIssueIfExists(item.issueId) : undefined;
                    if (isInfiniteHierarchyEnabled() && prevParentIssueId !== parentIssueId) updateIssueParent({
                        prevParentIssueId: prevParentIssueId,
                        parentIssueId: parentIssueId,
                        item: item
                    });
                });
            }
            // then add items WITH parent
            itemsWithParent.forEach((item)=>{
                const parentIssueId = (0, $4oWxH.getParentIssueId)(item);
                if (parentIssueId === undefined) // this scenario should be impossible because we already filtered the item
                // but doing this just to remove the Flow error
                return;
                // CLEAN UP THE FOLLOWING CONDITION WITH 'jwm.visual-hierarchy-milestone-1' as it's only used by timeline view
                if (isItemHierarchySupported && !isItemHierarchySupported(item)) {
                    // this is a specific scenario for the TIMELINE
                    // in that view we don't support epic hierarchy (we don't show the epic children, those are displayed on the same level)
                    // in that case we should not use the parent variables because that query doesn't exist
                    addToCache({
                        newNodes: [
                            item
                        ],
                        query: query,
                        variables: createVariablesForItemWithoutParent()
                    });
                    return;
                }
                const prevParentIssueId = getPrevParentOfIssueIfExists ? getPrevParentOfIssueIfExists(item.issueId) : undefined;
                const shouldUpdateIssueParent = (0, $1ybV0.ff)('jwm.visual-hierarchy-milestone-1') && isInfiniteHierarchyEnabled() && prevParentIssueId !== parentIssueId;
                const shouldChildItemBeAddedOrRemovedFromCache = shouldChildItemBeAddedToOrRemovedFromCache(parentIssueId);
                if (shouldUpdateIssueParent) updateIssueParent({
                    prevParentIssueId: prevParentIssueId,
                    parentIssueId: parentIssueId,
                    item: item
                });
                // We only want to add item if the existing query for children-of-this-parent exists
                // this is to prevent apollo error where the cache key is missing
                if (shouldChildItemBeAddedOrRemovedFromCache) addToCache({
                    newNodes: [
                        item
                    ],
                    query: query,
                    variables: createVariablesForItemWithParent(parentIssueId)
                });
                else if (!shouldChildItemBeAddedOrRemovedFromCache && !shouldUpdateIssueParent) {
                    let variables = createVariablesForItemWithoutParent();
                    if (isInfiniteHierarchyEnabled() && // Grandparent only exists in infinite hierarchy
                    getParentOfIssueIfExist) {
                        const grandParentId = getParentOfIssueIfExist(parentIssueId.toString());
                        if (grandParentId != null) variables = createVariablesForItemWithParent(grandParentId);
                    }
                    // if the parent is not listed to have child yet
                    // we will update the parent to show children
                    // so user will have an indicator that shows the parent has subtask now
                    updateItemsInCache({
                        query: query,
                        variables: variables,
                        issueIds: [
                            parentIssueId
                        ],
                        updateItem: (existingIssue)=>{
                            const updatedIssueWithNewChild = onUpdateParentWithNewChild(existingIssue, item);
                            return updatedIssueWithNewChild;
                        }
                    });
                }
            });
            return;
        }
        addToCache({
            newNodes: items,
            query: query,
            variables: createVariablesForItemWithoutParent()
        });
    };
    const removeFromCacheCallback = (items)=>{
        items.forEach((item)=>{
            if (isHierarchyEnabled()) {
                const parentIssueId = (0, $4oWxH.getParentIssueId)(item);
                if (parentIssueId !== undefined) {
                    if (shouldChildItemBeAddedToOrRemovedFromCache(parentIssueId)) removeFromCache({
                        issueId: item.issueId,
                        query: query,
                        variables: createVariablesForItemWithParent(parentIssueId)
                    });
                    // TODO remove the subtask from parent 'Subtask' field https://jbusiness.atlassian.net/browse/JET-1883
                    return;
                }
            }
            removeFromCache({
                issueId: item.issueId,
                query: query,
                variables: createVariablesForItemWithoutParent()
            });
        });
    };
    return {
        addToCacheCallback: addToCacheCallback,
        removeFromCacheCallback: removeFromCacheCallback
    };
};
const $8ac2f00f49bb3cf6$export$c410d2a23de7830a = ({ query: query, groupsQuery: groupsQuery, addToCache: addToCache, removeFromCache: removeFromCache, addGroupItemToCache: addGroupItemToCache, updateGroupItemInCache: updateGroupItemInCache, updateItemsInCache: updateItemsInCache, createVariablesForGroups: createVariablesForGroups, createVariablesForGroupItem: createVariablesForGroupItem, createItemGroup: createItemGroup, findItemGroup: findItemGroup, findGroupById: findGroupById, canUpdateGroupCache: canUpdateGroupCache, getParentOfIssueIfExist: getParentOfIssueIfExist, getPrevParentOfIssueIfExists: getPrevParentOfIssueIfExists, onUpdateParentWithNewChild: onUpdateParentWithNewChild, removeChildFromParent: removeChildFromParent, createVariablesForItemWithParent: createVariablesForItemWithParent, updateIssueParentMap: updateIssueParentMap })=>{
    const getReparentingInfo = (item)=>{
        const currentParent = (0, $4oWxH.getParentIssueId)(item);
        const prevParent = getPrevParentOfIssueIfExists(String(item.issueId));
        // note that currentParent can be undefined or a groupitem if parent is unlinked
        const isUnlinkParent = (!currentParent || (0, $4oWxH.isGroupItem)(currentParent)) && prevParent && currentParent !== prevParent;
        const isReparenting = currentParent && currentParent !== prevParent;
        return {
            isReparenting: isReparenting,
            isUnlinkParent: isUnlinkParent,
            currentParent: currentParent,
            prevParent: prevParent
        };
    };
    const removeItemFromCache = (item, currentGroupIssueId)=>{
        const { isReparenting: isReparenting, prevParent: prevParent, isUnlinkParent: isUnlinkParent } = getReparentingInfo(item);
        // check if items data exists in apollo cache, so that updating it won't blow up apollo
        if (canUpdateGroupCache(currentGroupIssueId) && (!isReparenting && !isUnlinkParent || prevParent && (0, $4oWxH.isGroupItem)(prevParent))) removeFromCache({
            issueId: item.issueId,
            query: query,
            variables: createVariablesForGroupItem(currentGroupIssueId)
        });
        else if (prevParent && (isReparenting || isUnlinkParent) && !(0, $4oWxH.isGroupItem)(prevParent)) removeFromCache({
            issueId: item.issueId,
            query: query,
            variables: createVariablesForItemWithParent(prevParent)
        });
        const groupItem = findGroupById(currentGroupIssueId);
        const prevGrandParent = prevParent ? getParentOfIssueIfExist(prevParent) : undefined;
        if (groupItem) {
            if (prevParent && (isReparenting || isUnlinkParent) && prevGrandParent && removeChildFromParent) // update count of prevParent
            updateItemsInCache({
                query: query,
                variables: (0, $4oWxH.isGroupItem)(prevGrandParent) ? createVariablesForGroupItem(prevGrandParent) : createVariablesForItemWithParent(prevGrandParent),
                issueIds: [
                    prevParent
                ],
                updateItem: (existingParentIssue)=>removeChildFromParent(existingParentIssue, 1)
            });
            else if (!(0, $1ybV0.ff)('jwm-list-view-update-group-count_36voh') || isChildIssueInGroup(groupItem, item.issueId)) // update totalGroupItems in itemGroups cache.
            updateGroupItemInCache({
                query: groupsQuery,
                variables: createVariablesForGroups(),
                id: groupItem.id,
                updateItem: (group)=>({
                        ...group,
                        totalCount: group.totalCount !== undefined ? Math.max(0, group.totalCount - 1) : undefined
                    })
            });
        }
    };
    const getGroupIssueId = (issueId)=>{
        if ((0, $4oWxH.isGroupItem)(issueId)) return issueId;
        const parentId = getParentOfIssueIfExist ? getParentOfIssueIfExist(issueId) : undefined;
        if (!parentId) return null;
        if ((0, $4oWxH.isGroupItem)(parentId)) return parentId;
        return getGroupIssueId(parentId);
    };
    const isChildIssueInGroup = (group, childIssueId)=>group.children?.some((issue)=>issue.issueId === childIssueId);
    const addToGroupCache = (items, { updateCountOnly: updateCountOnly = false } = {
        updateCountOnly: false
    })=>{
        items.forEach((item)=>{
            const { isReparenting: isReparenting, currentParent: currentParent, prevParent: prevParent } = getReparentingInfo(item);
            const currentGroupIssueId = prevParent ? getGroupIssueId(prevParent) : undefined;
            const nextGroup = findItemGroup(item);
            if (currentGroupIssueId != null && !updateCountOnly) removeItemFromCache(item, currentGroupIssueId);
            if (nextGroup != null) {
                // check if items data exists in apollo cache, so that updating it won't blow up apollo
                if (canUpdateGroupCache(nextGroup.issueId) && !updateCountOnly && !isReparenting) {
                    // add the item to the next group
                    addToCache({
                        newNodes: [
                            item
                        ],
                        query: query,
                        variables: createVariablesForGroupItem(nextGroup.issueId)
                    });
                    // this should not be necessary once background refetch when grouping is working correctly
                    updateIssueParentMap(item.issueId);
                }
                const newGrandParentId = currentParent ? getParentOfIssueIfExist(currentParent) : undefined;
                if (currentParent && isReparenting && newGrandParentId) updateItemsInCache({
                    query: query,
                    variables: (0, $4oWxH.isGroupItem)(newGrandParentId) ? createVariablesForGroupItem(newGrandParentId) : createVariablesForItemWithParent(newGrandParentId),
                    issueIds: [
                        currentParent
                    ],
                    updateItem: (existingIssue)=>{
                        const updatedIssueWithNewChild = onUpdateParentWithNewChild(existingIssue, item);
                        return updatedIssueWithNewChild;
                    }
                });
                else // update totalGroupItems in itemGroups cache.
                updateGroupItemInCache({
                    query: groupsQuery,
                    variables: createVariablesForGroups(),
                    id: nextGroup.id,
                    updateItem: (group)=>({
                            ...group,
                            totalCount: group.totalCount !== undefined ? Math.max(0, group.totalCount + 1) : undefined
                        })
                });
            } else {
                const newGroup = createItemGroup(item);
                if (newGroup != null) addGroupItemToCache({
                    query: groupsQuery,
                    variables: createVariablesForGroups(),
                    newNodes: [
                        newGroup
                    ]
                });
            }
        });
    };
    const removeFromGroupCache = (items)=>{
        items.forEach((item)=>{
            const prevParent = getPrevParentOfIssueIfExists(String(item.issueId));
            const currentGroupIssueId = prevParent ? getGroupIssueId(prevParent) : undefined;
            // happens when updating parent but new parent is not expanded
            if (currentGroupIssueId != null) removeItemFromCache(item, currentGroupIssueId);
        });
    };
    return {
        addToCache: addToGroupCache,
        removeFromCache: removeFromGroupCache
    };
};

});

parcelRegister("2rYp2", function(module, exports) {

$parcel$export(module.exports, "useViewUpdater", () => $7b05e60be9d51978$export$a7d7c9fa51f6f9e6);

var $eUqFw = parcelRequire("eUqFw");

var $iZuDo = parcelRequire("iZuDo");

var $i3K0B = parcelRequire("i3K0B");

var $eZbpk = parcelRequire("eZbpk");

var $lT4mK = parcelRequire("lT4mK");

var $1ybV0 = parcelRequire("1ybV0");

var $lO4Or = parcelRequire("lO4Or");

var $dWLk9 = parcelRequire("dWLk9");

var $aVwtE = parcelRequire("aVwtE");

var $2hnDK = parcelRequire("2hnDK");

var $6HSzd = parcelRequire("6HSzd");
const $7b05e60be9d51978$export$a7d7c9fa51f6f9e6 = ({ input: input, query: query, actions: actions, onError: onError, onAppendItemsError: onAppendItemsError })=>{
    const jqlContext = (0, $eZbpk.useJqlContext)();
    const cloudId = (0, $dWLk9.useCloudId)();
    // Keep track of updates in flight so we can validate them against the current list of issues.
    // Useful when filters are enabled and items are changed in a way that do not match the filter anymore.
    const [updateInFlightList, setUpdateInFlightList] = (0, $eUqFw.useState)([]);
    const [cacheActionIssues, dispatch] = (0, $6HSzd.useCacheActionsReducer)();
    // move this up here to stop eslint complaining
    let handleFilterMismatch;
    // Separate query to handle issue removal
    const [fetchIssueToRemove, { loading: fetchIssueToRemoveLoading }] = (0, $iZuDo.useLazyQuery)(query, {
        fetchPolicy: 'network-only',
        errorPolicy: 'all',
        onCompleted: (result)=>{
            const items = (0, $aVwtE.getAGGCompliantData)(result, 'list');
            const validNodes = items?.edges?.map((edge)=>edge?.node).filter(Boolean);
            if (validNodes && validNodes.length > 0) dispatch({
                type: 'REMOVE_FROM_CACHE',
                issues: validNodes
            });
        },
        onError: onAppendItemsError
    });
    // Separated query to update individual items so the other query can deal with pagination in the right sequence
    const [getIssuesById, { variables: getIssuesByIdVariables, loading: getIssuesByIdLoading }] = (0, $iZuDo.useLazyQuery)(query, {
        fetchPolicy: 'no-cache',
        errorPolicy: 'all',
        onError: (error)=>{
            if ((0, $lT4mK.isAbortError)(error.networkError)) return;
            onError(error);
        },
        onCompleted: (result)=>{
            handleFilterMismatch(getIssuesByIdVariables, result);
        }
    });
    // Separated query to append newly created items so we know it needs to be added to the top of the list.
    // Adding to the top to mimic backend behaviour but this might need to change when we introduce sorting.
    const [appendIssuesById, { loading: appendIssuesByIdLoading }] = (0, $iZuDo.useLazyQuery)(query, {
        fetchPolicy: 'network-only',
        errorPolicy: 'all',
        onCompleted: (result)=>{
            const items = (0, $aVwtE.getAGGCompliantData)(result, 'list', onError);
            const validNodes = items?.edges?.map((edge)=>edge?.node).filter(Boolean);
            if (validNodes && validNodes.length > 0) dispatch({
                type: 'ADD_TO_CACHE',
                issues: validNodes
            });
        },
        onError: onAppendItemsError
    });
    const { addRequestToQueue: addRequestToQueue, addRequestToAbortableQueue: addRequestToAbortableQueue } = (0, $2hnDK.useRequestQueue)({
        isRequestLoading: fetchIssueToRemoveLoading || getIssuesByIdLoading || appendIssuesByIdLoading
    });
    const removeIssueById = (0, $eUqFw.useCallback)((issueIdsToRemove)=>{
        addRequestToQueue(()=>fetchIssueToRemove({
                variables: {
                    ...(0, $i3K0B.getVariables)({
                        jqlContext: jqlContext,
                        issueIds: issueIdsToRemove,
                        fieldIds: input.fieldIds,
                        isHidingDoneItems: input.isHidingDoneItems,
                        isParentFieldVisible: input.isParentFieldVisible,
                        isDevSummaryFieldVisible: input.isDevSummaryFieldVisible,
                        projectIdOrKey: (0, $1ybV0.ff)('list-uses-new-jql-parent-project-directive_v5gfs') ? input.projectKey ?? undefined : undefined,
                        // we don't want to include any quickFiltersJql on purpose
                        // because we actually want to get the data of the issue that is not suppose to match the current quickFiltersJql
                        // e.g. consider this scenario
                        // - if the current quickFiltersJql is filtering DONE item
                        // - and the issueId that we need to remove is because user moving it to DONE
                        // - if we include the quickFiltersJql in here, the BE will NOT return the issue data because it's already DONE -> so we can't filter it in FE
                        // - so in this case we just want the data of the issue
                        quickFiltersJql: null
                    }),
                    cloudId: cloudId
                }
            }));
    }, [
        addRequestToQueue,
        fetchIssueToRemove,
        jqlContext,
        input.fieldIds,
        input.isHidingDoneItems,
        input.isParentFieldVisible,
        input.isDevSummaryFieldVisible,
        input.projectKey,
        cloudId
    ]);
    const removeIssue = (0, $eUqFw.useCallback)(({ issueId: issueId, parentId: parentId })=>{
        // @ts-expect-error ts(2322) - we can't instantiate an issue of the generic type, as we can't know the whole issue
        // However, the removeFromCache function called with this issue only needs this part of the interface
        const issueNode = {
            issueId: issueId,
            fields: parentId != null ? [
                {
                    fieldId: 'parent',
                    type: (0, $lO4Or.PARENT_TYPE),
                    parentIssue: {
                        issueId: parentId
                    }
                }
            ] : []
        };
        dispatch({
            type: 'REMOVE_FROM_CACHE',
            issues: [
                issueNode
            ]
        });
    }, [
        dispatch
    ]);
    // Filters are handled by JQL (not client side). The update function respects the filters so a BLANK update
    // means the item findIssueById didn't match the JQL filter and SHOULD be removed.
    handleFilterMismatch = (0, $eUqFw.useCallback)((variables, result)=>{
        if (!variables.jql) return;
        if (!result || !result.jira) // this is a case where the request failed, we don't want to remove the issue from the list in this case
        return;
        const updateIndex = updateInFlightList.findIndex((updateInput)=>(0, $i3K0B.getVariables)(updateInput).jql === variables.jql);
        if (updateIndex === -1) return;
        const currentUpdate = updateInFlightList[updateIndex];
        // In slow connections, users might change filters after an update was requested but before it can be applied.
        // We should not process those!
        const isUsingSameFilter = currentUpdate.quickFiltersJql === input.quickFiltersJql;
        const issueIds = [
            ...currentUpdate.issueIds || []
        ];
        const items = (0, $aVwtE.getAGGCompliantData)(result, 'list');
        const validNodes = items?.edges?.map((edge)=>edge?.node).filter(Boolean);
        if (isUsingSameFilter) {
            const issueIdsToRemove = [];
            issueIds.forEach((issueId, idIndex)=>{
                // item exists in the list but not in the filtered results - remove it!
                const item = validNodes?.find((node)=>node?.issueId === issueId);
                if (item == null) issueIdsToRemove.push(issueId);
                issueIds.splice(idIndex, 0);
                updateInFlightList[updateIndex] = {
                    ...currentUpdate,
                    issueIds: issueIds
                };
            });
            if (issueIdsToRemove.length > 0) removeIssueById(issueIdsToRemove);
        }
        setUpdateInFlightList((prevUpdateInFlightList)=>{
            prevUpdateInFlightList.splice(updateIndex, 1);
            return prevUpdateInFlightList;
        });
        // if item returns in filtered results it should be added to the cache. The method will dedup and sort by rank.
        if (validNodes && validNodes.length > 0) dispatch({
            type: 'ADD_TO_CACHE',
            issues: validNodes
        });
        // if item has been filtered out we may still want to do something with it
        const filteredIssueIds = issueIds.filter((issueId)=>!(validNodes ?? []).find((node)=>node?.issueId === issueId));
        if (filteredIssueIds.length > 0) dispatch({
            type: 'HANDLE_FILTERED_UPDATE',
            issues: filteredIssueIds
        });
    }, [
        updateInFlightList,
        input,
        removeIssueById,
        dispatch
    ]);
    // Interact with the cache in a useEffect to avoid doing it faster than the group items query data is updated
    (0, $eUqFw.useEffect)(()=>{
        if (cacheActionIssues.addToCache.length === 0 && cacheActionIssues.removeFromCache.length === 0 && cacheActionIssues.handleFilteredUpdate.length === 0) return;
        /* eslint-disable @typescript-eslint/consistent-type-assertions */ Object.entries(cacheActionIssues)/* eslint-enable @typescript-eslint/consistent-type-assertions */ .forEach(([actionName, issues])=>{
            if (Array.isArray(issues) && issues.length > 0) actions.forEach((actionEntry)=>{
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
                actionEntry?.[actionName]?.(issues);
            });
        });
        dispatch({
            type: 'CLEAR'
        });
    }, [
        cacheActionIssues,
        actions,
        dispatch
    ]);
    return {
        onIssueUpdated: (issueIds)=>{
            // we want to fetch this issueIds
            // but at the same time we pass the `quickFiltersJql`
            // so if in the end result, we don't get back the `issueIds`, we know that the updated issue is not valid anymore in the current `quickFiltersJql`
            // e.g.
            // - current quickFiltersJql is NOT showing DONE item
            // - then there is an update to an ISSUE-X that changes the status
            // - we then fetch updated data of ISSUE_X based on current quickFiltersJql
            // - if the ISSUE-X is returned in the result -> it means ISSUE-X still matches current quickFiltersJql
            // - otherwise it is not, so it will be handled in handleFilterMismatch to be removed from view
            const updateInput = {
                jqlContext: jqlContext,
                issueIds: issueIds,
                fieldIds: input.fieldIds,
                quickFiltersJql: input.quickFiltersJql,
                isHidingDoneItems: input.isHidingDoneItems,
                isParentFieldVisible: input.isParentFieldVisible,
                isDevSummaryFieldVisible: input.isDevSummaryFieldVisible,
                projectIdOrKey: (0, $1ybV0.ff)('list-uses-new-jql-parent-project-directive_v5gfs') ? input.projectKey ?? undefined : undefined
            };
            setUpdateInFlightList((prevUpdateInFlightList)=>[
                    ...prevUpdateInFlightList,
                    updateInput
                ]);
            if ((0, $1ybV0.ff)('jwm.visual-hierarchy-milestone-1')) addRequestToAbortableQueue(issueIds, getIssuesById, {
                variables: {
                    ...(0, $i3K0B.getVariables)(updateInput),
                    cloudId: cloudId
                }
            });
            else addRequestToQueue(()=>{
                getIssuesById({
                    variables: {
                        ...(0, $i3K0B.getVariables)(updateInput),
                        cloudId: cloudId
                    }
                });
            });
        },
        onIssueCreated: (issueIds)=>{
            addRequestToQueue(()=>appendIssuesById({
                    variables: {
                        ...(0, $i3K0B.getVariables)({
                            jqlContext: jqlContext,
                            issueIds: issueIds,
                            fieldIds: input.fieldIds,
                            quickFiltersJql: input.quickFiltersJql,
                            isHidingDoneItems: input.isHidingDoneItems,
                            isParentFieldVisible: input.isParentFieldVisible,
                            isDevSummaryFieldVisible: input.isDevSummaryFieldVisible,
                            projectIdOrKey: (0, $1ybV0.ff)('list-uses-new-jql-parent-project-directive_v5gfs') ? input.projectKey ?? undefined : undefined
                        }),
                        cloudId: cloudId
                    }
                }));
        },
        onIssueRemoved: (params)=>removeIssue(params)
    };
};

});
parcelRegister("lT4mK", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_ABORT_ERROR_MESSAGE", () => $804e6ae63bab13aa$export$6131a8d209a21250);
$parcel$export(module.exports, "AbortError", () => $804e6ae63bab13aa$export$18b052ffd8c84d7);
$parcel$export(module.exports, "isAbortError", () => $804e6ae63bab13aa$export$d2c30ea522b3259e);
const $804e6ae63bab13aa$export$6131a8d209a21250 = 'The operation was aborted.';
class $804e6ae63bab13aa$export$18b052ffd8c84d7 extends Error {
    constructor(message, statusCode = 499){
        super(message);
        this.name = 'AbortError';
        this.statusCode = statusCode;
    }
}
const $804e6ae63bab13aa$export$d2c30ea522b3259e = (error)=>error instanceof $804e6ae63bab13aa$export$18b052ffd8c84d7;

});

parcelRegister("2hnDK", function(module, exports) {

$parcel$export(module.exports, "useRequestQueue", () => $dfad9e82c2bb88f7$export$a90df70eeafb262f);

var $eUqFw = parcelRequire("eUqFw");

var $lT4mK = parcelRequire("lT4mK");
const $dfad9e82c2bb88f7$export$a90df70eeafb262f = ({ isRequestLoading: isRequestLoading })=>{
    const [abortableQueueMap, setAbortableQueueMap] = (0, $eUqFw.useState)(new Map());
    const abortControllerMap = (0, $eUqFw.useRef)(new Map());
    const inProgressRequestId = (0, $eUqFw.useRef)(null);
    const addRequestToAbortableQueue = (0, $eUqFw.useCallback)((issueIds, queryFunction, queryOptions)=>{
        const id = issueIds.join('-');
        const existingAbortController = abortControllerMap.current.get(id);
        existingAbortController?.abort(new (0, $lT4mK.AbortError)((0, $lT4mK.DEFAULT_ABORT_ERROR_MESSAGE)));
        const abortController = new AbortController();
        abortControllerMap.current.set(id, abortController);
        const request = ()=>{
            queryFunction({
                ...queryOptions,
                context: {
                    ...queryOptions.context,
                    fetchOptions: {
                        ...queryOptions.context?.fetchOptions,
                        signal: abortController.signal
                    }
                }
            });
        };
        setAbortableQueueMap((prevQueueMap)=>new Map([
                ...prevQueueMap,
                [
                    id,
                    request
                ]
            ]));
    }, []);
    (0, $eUqFw.useEffect)(()=>{
        if (!isRequestLoading && abortableQueueMap.size) {
            const iterator = abortableQueueMap.entries();
            const nextResult = iterator.next();
            if (!nextResult.done) {
                const [id, request] = nextResult.value;
                inProgressRequestId.current = id;
                request();
            }
            setAbortableQueueMap(new Map(iterator));
        }
    }, [
        abortableQueueMap,
        isRequestLoading
    ]);
    const [queue, setQueue] = (0, $eUqFw.useState)([]);
    (0, $eUqFw.useEffect)(()=>{
        if (!isRequestLoading && queue.length > 0) setQueue((prevQueue)=>{
            const [nextItem, ...restOfQueue] = prevQueue;
            nextItem();
            return restOfQueue;
        });
    }, [
        queue,
        isRequestLoading
    ]);
    const addRequestToQueue = (request)=>setQueue((prevQueue)=>[
                ...prevQueue,
                request
            ]);
    return {
        addRequestToQueue: addRequestToQueue,
        addRequestToAbortableQueue: addRequestToAbortableQueue
    };
};

});

parcelRegister("6HSzd", function(module, exports) {

$parcel$export(module.exports, "useCacheActionsReducer", () => $fe64e59249b7515f$export$83303d410e8412eb);

var $eUqFw = parcelRequire("eUqFw");
const $fe64e59249b7515f$var$cacheActionsReducer = (state, action)=>{
    switch(action.type){
        case 'ADD_TO_CACHE':
            return {
                ...state,
                addToCache: [
                    ...state.addToCache,
                    ...action.issues
                ]
            };
        case 'REMOVE_FROM_CACHE':
            return {
                ...state,
                removeFromCache: [
                    ...state.removeFromCache,
                    ...action.issues
                ]
            };
        case 'HANDLE_FILTERED_UPDATE':
            return {
                ...state,
                handleFilteredUpdate: [
                    ...state.handleFilteredUpdate,
                    ...action.issues
                ]
            };
        case 'CLEAR':
            return {
                addToCache: [],
                removeFromCache: [],
                handleFilteredUpdate: []
            };
        default:
            return state;
    }
};
const $fe64e59249b7515f$export$83303d410e8412eb = ()=>// @ts-expect-error - TS2554 - Expected 3 arguments, but got 2.
    (0, $eUqFw.useReducer)($fe64e59249b7515f$var$cacheActionsReducer, {
        addToCache: [],
        removeFromCache: [],
        handleFilteredUpdate: []
    });

});


parcelRegister("am0NO", function(module, exports) {

$parcel$export(module.exports, "useIssueParentMap", () => $4aa42d58d33fc4c7$export$103bc684cb3b9090);

var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");
const $4aa42d58d33fc4c7$var$actions = {
    setIssueParentMap: (issueParentMap)=>({ setState: setState, getState: getState })=>setState({
                ...getState(),
                issueParentMap: issueParentMap
            })
};
// @ts-expect-error - TS2344 - Type '{ readonly setIssueParentMap: (issueParentMap: IssueParentMap) => ({ setState, getState }: StoreState<State>) => void; }' does not satisfy the constraint 'Record<string, ActionThunk<State, { readonly setIssueParentMap: (issueParentMap: IssueParentMap) => ({ setState, getState }: StoreState<State>) => void; }>>'.
const $4aa42d58d33fc4c7$var$Store = (0, $a61MH.createStore)({
    initialState: {
        issueParentMap: new Map()
    },
    actions: $4aa42d58d33fc4c7$var$actions,
    name: 'JWMTimelineViewIssueParentMapStore'
});
const $4aa42d58d33fc4c7$export$103bc684cb3b9090 = (0, $ggKAj.createHook)($4aa42d58d33fc4c7$var$Store);

});

parcelRegister("PFCIp", function(module, exports) {

$parcel$export(module.exports, "useIssuesMap", () => $8c97483f48a9ac5d$export$d5c966ec437d4fa9);

var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");
const $8c97483f48a9ac5d$export$e324594224ef24da = {
    setIssuesMap: (issuesMap)=>({ setState: setState, getState: getState })=>setState({
                ...getState(),
                issuesMap: issuesMap
            })
};
const $8c97483f48a9ac5d$var$Store = (0, $a61MH.createStore)({
    initialState: {
        issuesMap: new Map()
    },
    actions: $8c97483f48a9ac5d$export$e324594224ef24da,
    name: 'JWMTimelineViewIssuesMapStore'
});
const $8c97483f48a9ac5d$export$d5c966ec437d4fa9 = (0, $ggKAj.createHook)($8c97483f48a9ac5d$var$Store);

});



parcelRegister("a2d2y", function(module, exports) {

$parcel$export(module.exports, "useHierarchy", () => $630a095c03716faa$export$84c4ea13397e6b16);

var $eUqFw = parcelRequire("eUqFw");
const $630a095c03716faa$export$84c4ea13397e6b16 = ()=>{
    const [childrenQueryData, setChildrenQuery] = (0, $eUqFw.useState)({});
    const [expandedItems, setExpandedItems] = (0, $eUqFw.useState)({});
    const setChildrenQueryData = (0, $eUqFw.useCallback)((issueId, newData)=>{
        setChildrenQuery((prevState)=>({
                ...prevState,
                [issueId]: newData
            }));
    }, []);
    const setIssueExpanded = (0, $eUqFw.useCallback)((issueId, isExpanded)=>{
        setExpandedItems((prevState)=>({
                ...prevState,
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                [issueId]: isExpanded
            }));
    }, []);
    return {
        childrenQueryData: childrenQueryData,
        expandedItems: expandedItems,
        setChildrenQueryData: setChildrenQueryData,
        setIssueExpanded: setIssueExpanded
    };
};

});

parcelRegister("kO3mo", function(module, exports) {

$parcel$export(module.exports, "TimelineViewUpdaterProvider", () => $ce8515efaa9def05$export$1efd096d14ad6572);
$parcel$export(module.exports, "useLockIssue", () => $ce8515efaa9def05$export$edf8e8c123aeceda);
$parcel$export(module.exports, "TimelineViewUpdater", () => $ce8515efaa9def05$export$a1432e92b20e37ea);

var $eUqFw = parcelRequire("eUqFw");

var $fDLFb = parcelRequire("fDLFb");

var $jvtK3 = parcelRequire("jvtK3");
var $h02O8 = parcelRequire("h02O8");
var $7SlEV = parcelRequire("7SlEV");

var $7rWus = parcelRequire("7rWus");
const $ce8515efaa9def05$var$LOCK_DELAY = 2000;
const $ce8515efaa9def05$export$ef5e6bae537251a2 = 'jira-business-timeline-view';
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
const $ce8515efaa9def05$var$Context = /*#__PURE__*/ (0, $eUqFw.createContext)(null);
const $ce8515efaa9def05$export$1efd096d14ad6572 = ({ children: children })=>{
    const value = (0, $eUqFw.useState)(new Map());
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ce8515efaa9def05$var$Context.Provider, {
        value: value
    }, children);
};
const $ce8515efaa9def05$export$edf8e8c123aeceda = ()=>{
    const [, setLockedIssueMap] = (0, $eUqFw.useContext)($ce8515efaa9def05$var$Context);
    return (0, $eUqFw.useCallback)((issueId)=>{
        setLockedIssueMap((prev)=>{
            // if a timeout is already registered for that issue, clear it first
            const existingTimeoutId = prev.get(issueId);
            if (existingTimeoutId != null) clearTimeout(existingTimeoutId);
            // unlock issue after a given delay
            const timeoutId = setTimeout(()=>{
                setLockedIssueMap((prev2)=>{
                    const newMap = new Map(prev2);
                    newMap.delete(issueId);
                    return newMap;
                });
            }, $ce8515efaa9def05$var$LOCK_DELAY);
            return new Map(prev).set(issueId, timeoutId);
        });
    }, [
        setLockedIssueMap
    ]);
};
const $ce8515efaa9def05$export$a1432e92b20e37ea = /*#__PURE__*/ (0, $eUqFw.memo)(({ childrenQueryData: childrenQueryData })=>{
    const { data: entity } = (0, $fDLFb.useBusinessEntity)();
    const [lockedIssuesMap] = (0, $eUqFw.useContext)($ce8515efaa9def05$var$Context);
    const { onIssueUpdated: onIssueUpdated, onIssueCreated: onIssueCreated } = (0, $7rWus.useTimelineViewUpdater)({
        childrenQueryData: childrenQueryData
    });
    const onRealtimeEvent = (event)=>{
        if ((0, $h02O8.isIssueEvent)(event)) {
            const issueId = Number(event.payload.issueId);
            if (lockedIssuesMap.has(issueId)) return;
            if (event.type === (0, $7SlEV.ISSUE_CREATED_EVENT)) onIssueCreated([
                issueId
            ]);
            else onIssueUpdated([
                issueId
            ]);
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jvtK3.GqlsRealtime), {
        appId: $ce8515efaa9def05$export$ef5e6bae537251a2,
        entityId: entity.id,
        onReceive: onRealtimeEvent
    });
});

});
parcelRegister("jvtK3", function(module, exports) {

$parcel$export(module.exports, "GqlsRealtime", () => $98ac3be71dbce786$export$ad092969d774a1ab);

var $eUqFw = parcelRequire("eUqFw");

var $ePgRW = parcelRequire("ePgRW");

var $4G5xU = parcelRequire("4G5xU");

var $ciZ8Y = parcelRequire("ciZ8Y");

var $huI7r = parcelRequire("huI7r");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $gd0Sp = parcelRequire("gd0Sp");

var $7SlEV = parcelRequire("7SlEV");

var $39J28 = parcelRequire("39J28");

var $jG3N9 = parcelRequire("jG3N9");

var $55JiT = parcelRequire("55JiT");

var $bqvPy = parcelRequire("bqvPy");
const $98ac3be71dbce786$export$ad092969d774a1ab = /*#__PURE__*/ (0, $eUqFw.memo)(({ appId: appId, entityId: entityId, onReceive: onReceive, eventsToSubscribeTo: eventsToSubscribeTo = (0, $7SlEV.DEFAULT_EVENTS_TO_SUBSCRIBE_TO) })=>{
    const { cloudId: cloudId } = (0, $gd0Sp.useTenantContext)();
    const siteId = (0, $huI7r.createAri)({
        resourceOwner: 'jira',
        resourceType: 'site',
        resourceId: cloudId
    });
    const realtimeIds = (0, $ePgRW.useRealtimeContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const createSubsExperienceStart = (0, $4G5xU.useExperienceStart)((0, $7SlEV.CREATE_SUBSCRIPTIONS_EXPERIENCE));
    const createSubsExperienceSuccess = (0, $4G5xU.useExperienceSuccess)((0, $7SlEV.CREATE_SUBSCRIPTIONS_EXPERIENCE));
    const createSubsExperienceFail = (0, $4G5xU.useExperienceFail)((0, $7SlEV.CREATE_SUBSCRIPTIONS_EXPERIENCE));
    const realtimeEventExperienceStart = (0, $4G5xU.useExperienceStart)((0, $7SlEV.REALTIME_EVENT_EXPERIENCE));
    const realtimeEventExperienceSuccess = (0, $4G5xU.useExperienceSuccess)((0, $7SlEV.REALTIME_EVENT_EXPERIENCE));
    const realtimeEventExperienceFail = (0, $4G5xU.useExperienceFail)((0, $7SlEV.REALTIME_EVENT_EXPERIENCE));
    createSubsExperienceStart();
    // We need to be careful not to re-trigger the subscriptions useMemo, as this
    // causes new subscribe messages to be sent over the WS, which we only want to
    // happen when something directly related to the subscription changes
    // So we are using Refs to prevent the handleReceive function from changing too much
    const extraEventDataRef = (0, $eUqFw.useRef)({
        appId: appId,
        entityId: entityId
    });
    extraEventDataRef.current.appId = appId;
    extraEventDataRef.current.entityId = entityId;
    const onReceiveRef = (0, $eUqFw.useRef)(onReceive);
    onReceiveRef.current = onReceive;
    const handleReceive = (0, $eUqFw.useCallback)((event)=>{
        realtimeEventExperienceStart();
        try {
            (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'subscription next', {
                ...extraEventDataRef.current,
                realtimeEvent: event.type
            });
            onReceiveRef.current(event);
            realtimeEventExperienceSuccess({
                realtimeEvent: event.type
            });
        } catch (error) {
            realtimeEventExperienceFail('jiraBusinessGqlsRealtime.gqlsRealtime', // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
            error, {
                realtimeEvent: event.type
            });
        }
    }, [
        createAnalyticsEvent,
        realtimeEventExperienceStart,
        realtimeEventExperienceSuccess,
        realtimeEventExperienceFail
    ]);
    const handleReactError = (0, $eUqFw.useCallback)((_location, error, event)=>{
        (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), 'jiraBusinessGqlsRealtime.gqlsRealtime failed', event);
        createSubsExperienceFail('jiraBusinessGqlsRealtime.gqlsRealtime', error);
    }, [
        createAnalyticsEvent,
        createSubsExperienceFail
    ]);
    const handleSubscriptionError = (0, $eUqFw.useCallback)((errorMessage, operationName)=>{
        (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), 'jiraBusinessGqlsRealtime.subscription failed', {
            errorMessage: errorMessage,
            operationName: operationName,
            ...extraEventDataRef.current
        });
    }, [
        createAnalyticsEvent
    ]);
    const subscriptions = (0, $eUqFw.useMemo)(()=>!realtimeIds.length ? null : realtimeIds.map((projectId)=>// eslint-disable-next-line react/jsx-key
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, eventsToSubscribeTo.includes((0, $7SlEV.ISSUE_UPDATED_EVENT)) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bqvPy.UpdateIssueSubscription), {
                cloudId: cloudId,
                projectId: projectId,
                onReceive: handleReceive,
                onError: handleSubscriptionError
            }), eventsToSubscribeTo.includes((0, $7SlEV.ISSUE_CREATED_EVENT)) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $39J28.CreateIssueSubscription), {
                cloudId: cloudId,
                projectId: projectId,
                onReceive: handleReceive,
                onError: handleSubscriptionError
            }), eventsToSubscribeTo.includes((0, $7SlEV.ISSUE_DELETED_EVENT)) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jG3N9.DeleteIssueSubscription), {
                cloudId: cloudId,
                projectId: projectId,
                onReceive: handleReceive,
                onError: handleSubscriptionError
            }), eventsToSubscribeTo.includes((0, $7SlEV.FIELD_MUTATION_EVENT)) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $55JiT.FieldMutationSubscription), {
                siteId: siteId,
                onReceive: handleReceive,
                onError: handleSubscriptionError
            }))), [
        cloudId,
        siteId,
        realtimeIds,
        eventsToSubscribeTo,
        handleReceive,
        handleSubscriptionError
    ]);
    (0, $eUqFw.useEffect)(()=>{
        const realtimeEvents = {
            issueCreated: eventsToSubscribeTo.includes((0, $7SlEV.ISSUE_CREATED_EVENT)),
            issueUpdated: eventsToSubscribeTo.includes((0, $7SlEV.ISSUE_UPDATED_EVENT)),
            issueDeleted: eventsToSubscribeTo.includes((0, $7SlEV.ISSUE_DELETED_EVENT)),
            fieldMutation: eventsToSubscribeTo.includes((0, $7SlEV.FIELD_MUTATION_EVENT))
        };
        (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'subscriptions created', {
            ...extraEventDataRef.current,
            ...realtimeEvents,
            subscriptions: realtimeIds.length * eventsToSubscribeTo.length
        });
        createSubsExperienceSuccess();
    }, [
        subscriptions,
        createAnalyticsEvent,
        realtimeIds,
        eventsToSubscribeTo,
        createSubsExperienceSuccess
    ]);
    (0, $eUqFw.useEffect)(()=>{
        (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'subscriptions init', extraEventDataRef.current);
        const extraEventData = extraEventDataRef.current;
        return ()=>{
            (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'subscriptions closed', extraEventData);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ciZ8Y.ErrorBoundary), {
        id: "gqlsRealtime",
        packageName: "jiraBusinessGqlsRealtime",
        extraEventData: extraEventDataRef.current,
        onError: handleReactError
    }, subscriptions);
});

});
parcelRegister("7SlEV", function(module, exports) {

$parcel$export(module.exports, "ISSUE_CREATED_EVENT", () => $dbd458bd7de773e3$export$b22a14d5dac59664);
$parcel$export(module.exports, "ISSUE_DELETED_EVENT", () => $dbd458bd7de773e3$export$25fa37e5059c5a99);
$parcel$export(module.exports, "ISSUE_UPDATED_EVENT", () => $dbd458bd7de773e3$export$b22142e61b3fdbee);
$parcel$export(module.exports, "FIELD_MUTATION_EVENT", () => $dbd458bd7de773e3$export$eddbca92a5bee91f);
$parcel$export(module.exports, "ISSUE_EVENTS", () => $dbd458bd7de773e3$export$f01b4f4e297998a0);
$parcel$export(module.exports, "DEFAULT_EVENTS_TO_SUBSCRIBE_TO", () => $dbd458bd7de773e3$export$edc58098c8ddf4cb);
$parcel$export(module.exports, "CREATE_SUBSCRIPTIONS_EXPERIENCE", () => $dbd458bd7de773e3$export$75b82bac1ec985d9);
$parcel$export(module.exports, "REALTIME_EVENT_EXPERIENCE", () => $dbd458bd7de773e3$export$245947dc0e8c134b);
const $dbd458bd7de773e3$export$b22a14d5dac59664 = 'avi:jira:created:issue';
const $dbd458bd7de773e3$export$25fa37e5059c5a99 = 'avi:jira:deleted:issue';
const $dbd458bd7de773e3$export$b22142e61b3fdbee = 'avi:jira:updated:issue';
const $dbd458bd7de773e3$export$eddbca92a5bee91f = 'avi:jira:field:updated';
const $dbd458bd7de773e3$export$f01b4f4e297998a0 = [
    $dbd458bd7de773e3$export$b22a14d5dac59664,
    $dbd458bd7de773e3$export$25fa37e5059c5a99,
    $dbd458bd7de773e3$export$b22142e61b3fdbee
];
const $dbd458bd7de773e3$export$edc58098c8ddf4cb = $dbd458bd7de773e3$export$f01b4f4e297998a0;
const $dbd458bd7de773e3$export$b8b9d90f9e5bd72b = 'jiraBusinessGqlsRealtime';
const $dbd458bd7de773e3$export$75b82bac1ec985d9 = {
    experience: 'createSubscriptions',
    packageName: $dbd458bd7de773e3$export$b8b9d90f9e5bd72b,
    teamName: 'jira-warepil'
};
const $dbd458bd7de773e3$export$245947dc0e8c134b = {
    experience: 'realtimeEvent',
    packageName: $dbd458bd7de773e3$export$b8b9d90f9e5bd72b,
    teamName: 'jira-warepil'
};

});

parcelRegister("39J28", function(module, exports) {

$parcel$export(module.exports, "CreateIssueSubscription", () => $4eeb3c77e3051e63$export$7876efe7a86fd4f1);

var $eUqFw = parcelRequire("eUqFw");

var $fEePJ = parcelRequire("fEePJ");

var $7SlEV = parcelRequire("7SlEV");

var $h02O8 = parcelRequire("h02O8");

const $4eeb3c77e3051e63$var$operationName = 'JwmIssueCreatedSubscription';
const $4eeb3c77e3051e63$export$7876efe7a86fd4f1 = /*#__PURE__*/ (0, $eUqFw.memo)(({ cloudId: cloudId, projectId: projectId, onReceive: onReceive, onError: onError })=>{
    (0, $fEePJ.useSubscribe)({
        query: (0, $f6f4d62eefeaafa1$export$89cddb5ca4c806e4),
        variables: {
            cloudId: cloudId,
            projectId: projectId
        },
        operationName: $4eeb3c77e3051e63$var$operationName
    }, {
        next: (value)=>{
            const error = (0, $h02O8.getResponseError)(value);
            if (error) onError(error, $4eeb3c77e3051e63$var$operationName);
            else {
                const payload = value.data?.jira?.onIssueCreatedByProject;
                if (payload) onReceive({
                    type: (0, $7SlEV.ISSUE_CREATED_EVENT),
                    payload: payload
                });
            }
        }
    });
    return null;
});

});
parcelRegister("fEePJ", function(module, exports) {

$parcel$export(module.exports, "useSubscribe", () => $a854284f214cc1d7$export$d3d523392640272);

var $eUqFw = parcelRequire("eUqFw");

var $fEYK5 = parcelRequire("fEYK5");

var $guiFP = parcelRequire("guiFP");

var $keguF = parcelRequire("keguF");


var $eliQU = parcelRequire("eliQU");

var $dIOaC = parcelRequire("dIOaC");

var $lE8MM = parcelRequire("lE8MM");
// Replace with lodash/noop
// eslint-disable-next-line @typescript-eslint/no-empty-function
const $a854284f214cc1d7$var$noop = ()=>{};
const $a854284f214cc1d7$var$subscribe = (payload, sink)=>{
    const client = (0, $dIOaC.getClient)();
    if (!client) return;
    const { query: query, variables: variables, operationName: operationName, extensions: extensions } = payload;
    const { next: next, error: error, complete: complete = $a854284f214cc1d7$var$noop } = sink;
    let requestId;
    return client.subscribe({
        query: query,
        variables: variables,
        operationName: operationName,
        extensions: {
            ...extensions ?? {}
        }
    }, {
        next: (value)=>{
            // @ts-expect-error agg prop is missing on generic "extensions" type
            const aggRequestId = value?.extensions?.agg?.request_id;
            if (aggRequestId) requestId = aggRequestId;
            // @ts-expect-error incompatible types between two libraries
            next(value);
        },
        complete: complete,
        error: (sinkError)=>{
            const errorInfo = (0, $lE8MM.getSinkError)(sinkError);
            const attributes = {
                operationName: operationName,
                requestId: requestId,
                userLocation: (0, $keguF.getUserLocation)()
            };
            error?.(errorInfo, attributes);
            (0, $guiFP.default)({
                meta: {
                    id: 'subscription',
                    packageName: 'jiraGraphqlSubscription',
                    teamName: 'uip-graphql'
                },
                error: errorInfo,
                attributes: attributes,
                sendToPrivacyUnsafeSplunk: true
            });
        }
    });
};
const $a854284f214cc1d7$export$d3d523392640272 = (payload, sink)=>{
    (0, $eUqFw.useEffect)(()=>{
        let unsubscribe = $a854284f214cc1d7$var$subscribe(payload, sink);
        let timeout;
        const onVisibilityChange = ()=>{
            if ((0, $fEYK5.isPageVisible)()) {
                if (timeout) {
                    clearTimeout(timeout);
                    timeout = undefined;
                } else unsubscribe = $a854284f214cc1d7$var$subscribe(payload, sink);
            } else if (!timeout) timeout = setTimeout(()=>{
                unsubscribe?.();
                unsubscribe = undefined;
                timeout = undefined;
            }, (0, $12457a63a9fa501a$export$1ad8434180c5936c));
        };
        if (!(0, $eliQU.isSSR)()) window.addEventListener((0, $fEYK5.supportedVisiblityEvent), onVisibilityChange);
        return ()=>{
            window.removeEventListener((0, $fEYK5.supportedVisiblityEvent), onVisibilityChange);
            unsubscribe?.();
        };
    }, [
        payload,
        sink
    ]);
};

});
const $12457a63a9fa501a$export$8b012b965402e06a = 580000; // 9m 40 - timeframe needed for UCT token refresh: https://developer.atlassian.com/platform/graphql-gateway/subscriptions/security/#long-lived-user-context-token
const $12457a63a9fa501a$export$bf6cd96e19b2987f = 100;
const $12457a63a9fa501a$export$1ad8434180c5936c = 300000; // 5m


parcelRegister("h02O8", function(module, exports) {

$parcel$export(module.exports, "isIssueEvent", () => $8984b81df6dead57$export$734ba008b9d9e61c);
$parcel$export(module.exports, "getResponseError", () => $8984b81df6dead57$export$135f2bf83a3d73b1);

var $7SlEV = parcelRequire("7SlEV");
const $8984b81df6dead57$export$734ba008b9d9e61c = (event)=>(0, $7SlEV.ISSUE_EVENTS).includes(event.type);
const $8984b81df6dead57$export$135f2bf83a3d73b1 = (response)=>Array.isArray(response.errors) && response.errors.length && response.errors[0].message;

});

const $f6f4d62eefeaafa1$export$89cddb5ca4c806e4 = `
  subscription JwmIssueCreatedSubscription(
    $cloudId: ID!
    $projectId: String!
  ) {
    jira {
      onIssueCreatedByProject(cloudId: $cloudId, projectId: $projectId) {
        issueId
      }
    }
  }
`;


parcelRegister("jG3N9", function(module, exports) {

$parcel$export(module.exports, "DeleteIssueSubscription", () => $ff6bd8b7c30a306f$export$cba4fc39801f6792);

var $eUqFw = parcelRequire("eUqFw");

var $fEePJ = parcelRequire("fEePJ");

var $huI7r = parcelRequire("huI7r");

var $7SlEV = parcelRequire("7SlEV");

var $h02O8 = parcelRequire("h02O8");

const $ff6bd8b7c30a306f$var$operationName = 'JwmIssueDeletedSubscription';
const $ff6bd8b7c30a306f$export$cba4fc39801f6792 = /*#__PURE__*/ (0, $eUqFw.memo)(({ cloudId: cloudId, projectId: projectId, onReceive: onReceive, onError: onError })=>{
    (0, $fEePJ.useSubscribe)({
        query: (0, $91d960b142a4aa36$export$9c299c317f46fdc4),
        variables: {
            cloudId: cloudId,
            projectId: projectId
        },
        operationName: $ff6bd8b7c30a306f$var$operationName
    }, {
        next: (value)=>{
            const error = (0, $h02O8.getResponseError)(value);
            if (error) onError(error, $ff6bd8b7c30a306f$var$operationName);
            else {
                const payload = value.data?.jira?.onIssueDeletedByProject;
                if (payload) onReceive({
                    type: (0, $7SlEV.ISSUE_DELETED_EVENT),
                    payload: {
                        ...payload,
                        issueId: (0, $huI7r.getAriConfig)(payload.resource).resourceId
                    }
                });
            }
        }
    });
    return null;
});

});
const $91d960b142a4aa36$export$9c299c317f46fdc4 = `
  subscription JwmIssueDeletedSubscription(
    $cloudId: ID!
    $projectId: String!
  ) {
    jira {
      onIssueDeletedByProject(cloudId: $cloudId, projectId: $projectId) {
        resource
      }
    }
  }
`;


parcelRegister("55JiT", function(module, exports) {

$parcel$export(module.exports, "FieldMutationSubscription", () => $0c96b6eb3ca20eae$export$d82ea923ea48fa52);

var $eUqFw = parcelRequire("eUqFw");

var $fEePJ = parcelRequire("fEePJ");

var $7SlEV = parcelRequire("7SlEV");

var $h02O8 = parcelRequire("h02O8");

const $0c96b6eb3ca20eae$var$operationName = 'JwmFieldMutationSubscription';
const $0c96b6eb3ca20eae$export$d82ea923ea48fa52 = /*#__PURE__*/ (0, $eUqFw.memo)(({ siteId: siteId, onReceive: onReceive, onError: onError })=>{
    (0, $fEePJ.useSubscribe)({
        query: (0, $993d2190e4ed31a0$export$2e75a8174f7cddb8),
        operationName: $0c96b6eb3ca20eae$var$operationName,
        variables: {
            siteId: siteId
        }
    }, {
        next: (value)=>{
            const error = (0, $h02O8.getResponseError)(value);
            if (error) onError(error, $0c96b6eb3ca20eae$var$operationName);
            else if (value.data?.jira?.onJwmFieldMutation) onReceive({
                type: (0, $7SlEV.FIELD_MUTATION_EVENT),
                payload: {}
            });
        }
    });
    return null;
});

});
const $993d2190e4ed31a0$export$2e75a8174f7cddb8 = `
  subscription JwmFieldMutationSubscription($siteId: ID!) {
    jira {
      onJwmFieldMutation(siteId: $siteId) {
        encryptedData
      }
    }
  }
`;


parcelRegister("bqvPy", function(module, exports) {

$parcel$export(module.exports, "UpdateIssueSubscription", () => $d3e4df2394577653$export$51fac6481c0b4595);

var $eUqFw = parcelRequire("eUqFw");

var $fEePJ = parcelRequire("fEePJ");

var $7SlEV = parcelRequire("7SlEV");

var $h02O8 = parcelRequire("h02O8");

const $d3e4df2394577653$var$operationName = 'JwmIssueUpdatedSubscription';
const $d3e4df2394577653$export$51fac6481c0b4595 = /*#__PURE__*/ (0, $eUqFw.memo)(({ cloudId: cloudId, projectId: projectId, onReceive: onReceive, onError: onError })=>{
    (0, $fEePJ.useSubscribe)({
        query: (0, $4aae5f340c4dce10$export$54c41e3133084b81),
        variables: {
            cloudId: cloudId,
            projectId: projectId
        },
        operationName: $d3e4df2394577653$var$operationName
    }, {
        next: (value)=>{
            const error = (0, $h02O8.getResponseError)(value);
            if (error) onError(error, $d3e4df2394577653$var$operationName);
            else {
                const payload = value.data?.jira?.onIssueUpdatedByProject;
                if (payload) onReceive({
                    type: (0, $7SlEV.ISSUE_UPDATED_EVENT),
                    payload: payload
                });
            }
        }
    });
    return null;
});

});
const $4aae5f340c4dce10$export$54c41e3133084b81 = `
  subscription JwmIssueUpdatedSubscription(
    $cloudId: ID!
    $projectId: String!
  ) {
    jira {
      onIssueUpdatedByProject(cloudId: $cloudId, projectId: $projectId) {
        issueId
      }
    }
  }
`;




parcelRegister("91m2x", function(module, exports) {

$parcel$export(module.exports, "useTimelineViewIssues", () => $77ae3659e978e3a3$export$66a1bd5ceb40f186);

var $eUqFw = parcelRequire("eUqFw");

var $lGxgz = parcelRequire("lGxgz");
var $96etS = parcelRequire("96etS");

var $hPXdk = parcelRequire("hPXdk");
var $3OkRL = parcelRequire("3OkRL");

var $1ybV0 = parcelRequire("1ybV0");

var $k8Qyf = parcelRequire("k8Qyf");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $fD1Hq = parcelRequire("fD1Hq");

var $fzymf = parcelRequire("fzymf");

var $2nzpw = parcelRequire("2nzpw");

var $am0NO = parcelRequire("am0NO");

var $PFCIp = parcelRequire("PFCIp");

var $eXeLp = parcelRequire("eXeLp");

var $dLnS7 = parcelRequire("dLnS7");

var $1IC6t = parcelRequire("1IC6t");

var $bvug1 = parcelRequire("bvug1");

var $g19OU = parcelRequire("g19OU");

var $3sm8e = parcelRequire("3sm8e");

var $37Inl = parcelRequire("37Inl");
const $77ae3659e978e3a3$export$529ba515dbd4b5b9 = {
    type: 'error',
    title: (0, $g19OU.default).loadingItemsErrorTitle,
    description: (0, $g19OU.default).loadingItemsErrorDescription
};
const $77ae3659e978e3a3$var$RANK_ERROR_FLAG = {
    type: 'error',
    title: (0, $g19OU.default).rankingErrorTitle,
    description: (0, $g19OU.default).rankingErrorMessage
};
const $77ae3659e978e3a3$export$66a1bd5ceb40f186 = ({ childrenQueryData: childrenQueryData = {}, expandedItems: expandedItems } = {})=>{
    const { hierarchyLevelsWithCache: hierarchyLevelsWithCache } = (0, $hPXdk.useHierarchyCache)({
        view: 'timeline'
    });
    const hierarchyLevels = (0, $eUqFw.useMemo)(()=>{
        if ((0, $1ybV0.ff)('jwm.visual-hierarchy-milestone-1')) return hierarchyLevelsWithCache;
        return undefined;
    }, [
        hierarchyLevelsWithCache
    ]);
    const isLinkingEnabled = (0, $fD1Hq.useIsLinkingEnabled)();
    const [{ issuesMap: issuesMap }] = (0, $PFCIp.useIssuesMap)();
    const [{ issueParentMap: issueParentMap }] = (0, $am0NO.useIssueParentMap)();
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagService)();
    const [{ createItemAnchor: createItemAnchor }] = (0, $bvug1.useCreateItemAnchor)();
    const { quickFiltersJql: quickFiltersJql, hierarchyParent: hierarchyParent, isFiltering: isFiltering, jqlContext: jqlContext } = (0, $lGxgz.useFilteredViewContextInput)({
        view: 'timeline'
    });
    const { isSearching: isSearching } = (0, $96etS.useSimpleSearchJQL)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { data: overview } = (0, $fzymf.useOverview)();
    const isOverview = overview != null && Array.isArray(overview.projects);
    const { data: timelineViewIssuesData, loadNextPage: loadNextPage, loading: issuesLoading, isLoadingNextPage: isLoadingNextPage, updateInCache: updateInCacheTopLevel, rankIssue: rankIssueTopLevel, updateItemsInCache: updateItemsInCacheTopLevel, error: error } = (0, $eXeLp.useTimelineViewIssues)({
        input: {
            jqlContext: jqlContext,
            fieldIds: $2nzpw.fieldIds,
            quickFiltersJql: quickFiltersJql,
            hierarchyParent: hierarchyParent,
            ...(0, $1ybV0.ff)('jwm.visual-hierarchy-milestone-1') && hierarchyLevels !== undefined && {
                // the above check will be unneccessary once the FF is removed
                hierarchyLevel: hierarchyLevels[0]?.level
            }
        },
        onComplete: ()=>{
            if (isSearching) (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), 'timelineSimpleSearchQuery succeeded');
        }
    });
    const { updateIssueParent: reparentIssue, unlinkParentIssue: unlinkParentIssue } = (0, $3OkRL.useUpdateIssueParent)({
        childrenQueryData: childrenQueryData,
        fieldIds: $2nzpw.fieldIds,
        issueParentMap: issueParentMap,
        issuesMap: issuesMap,
        cacheQuery: (0, $dLnS7.TIMELINE_VIEW_ITEMS_QUERY),
        addChildToParent: (0, $1IC6t.addChildToParentTimeline),
        view: 'timeline',
        packageName: 'jiraBusinessTimeline'
    });
    (0, $eUqFw.useEffect)(()=>{
        if (error) showFlag($77ae3659e978e3a3$export$529ba515dbd4b5b9);
    }, [
        showFlag,
        error
    ]);
    const data = (0, $37Inl.toTimelineData)({
        timelineViewIssuesData: timelineViewIssuesData,
        childrenQueryData: childrenQueryData,
        expandedItems: expandedItems,
        createItemAnchor: createItemAnchor,
        issuesMap: issuesMap,
        issueParentMap: issueParentMap,
        isLinkingEnabled: isLinkingEnabled,
        isFiltering: isFiltering,
        ...(0, $1ybV0.ff)('jwm.visual-hierarchy-milestone-1') ? {
            isOverview: isOverview
        } : {}
    });
    const updateInCache = (0, $eUqFw.useCallback)((params)=>{
        const updatedIssueParentIssueId = issueParentMap.get(params.id);
        // if the updated issue is parent level (no parent found), we just update the parent
        if (updatedIssueParentIssueId === undefined) {
            updateInCacheTopLevel(params);
            return;
        }
        // otherwise if the updated issue is a children issue
        // get the correct callback from the specific children query
        if (childrenQueryData[updatedIssueParentIssueId]) childrenQueryData[updatedIssueParentIssueId].updateInCache(params);
    }, [
        childrenQueryData,
        issueParentMap,
        updateInCacheTopLevel
    ]);
    /*
        Using this method you can only update many issues from the top level or
        many children of the same parent.
    */ const updateItemsInCache = (0, $eUqFw.useCallback)((params)=>{
        const firstIssue = params[0];
        const updatedIssueParentIssueId = issueParentMap.get(firstIssue.id);
        // if one of the issues is parent level (no parent found)
        if (updatedIssueParentIssueId === undefined) {
            updateItemsInCacheTopLevel(params);
            return;
        }
        // otherwise if the updated issue is a children issue
        // get the correct callback from the specific children query
        if (childrenQueryData[updatedIssueParentIssueId]) childrenQueryData[updatedIssueParentIssueId].updateItemsInCache(params);
    }, [
        childrenQueryData,
        issueParentMap,
        updateItemsInCacheTopLevel
    ]);
    const rankIssue = (0, $eUqFw.useCallback)((id, { rankRequest: rankRequest }, event, skipUpdateCache)=>{
        if (!rankRequest) {
            (0, $jMP2a.fireTrackAnalytics)(event, 'rankIssue invalidRequest');
            return;
        }
        const updatedIssueParentIssueId = issueParentMap.get(id);
        // @ts-expect-error - TS2339 - Property 'rankBeforeId' does not exist on type 'RankRequest'.
        const relativeIssueId = rankRequest.rankAfterId || rankRequest.rankBeforeId;
        const relativeIssue = issuesMap.get(relativeIssueId);
        if (!relativeIssue) {
            (0, $jMP2a.fireTrackAnalytics)(event, 'rankIssue invalidRequest', {
                relativeIssue: relativeIssueId
            });
            showFlag($77ae3659e978e3a3$var$RANK_ERROR_FLAG);
            return;
        }
        const params = {
            issueId: id,
            relativeIssue: relativeIssue,
            skipUpdateCache: skipUpdateCache,
            // @ts-expect-error - TS2339 - Property 'rankBeforeId' does not exist on type 'RankRequest'.
            rankCall: rankRequest.rankBeforeId ? 'rankBefore' : 'rankAfter'
        };
        if (updatedIssueParentIssueId === undefined) {
            rankIssueTopLevel(params);
            return;
        }
        // get the correct callback from the specific children query
        if (childrenQueryData[updatedIssueParentIssueId]) childrenQueryData[updatedIssueParentIssueId].rankIssue(params);
    }, [
        issueParentMap,
        issuesMap,
        childrenQueryData,
        showFlag,
        rankIssueTopLevel
    ]);
    const updateIssueParent = (0, $eUqFw.useCallback)(async (id, payload, event)=>{
        const { parentId: parentId, rankRequest: rankRequest, level: level } = payload;
        const parentIssue = parentId ? issuesMap.get(parentId) : undefined;
        const parentIdOld = issueParentMap.get(id);
        if (!parentId) await unlinkParentIssue({
            issueKey: id,
            rankRequest: rankRequest
        });
        else {
            if (parentIdOld === parentId) return;
            if (!parentIssue) {
                (0, $jMP2a.fireTrackAnalytics)(event, 'reparent invalidRequest', {
                    parentId: parentId
                });
                return;
            }
            await reparentIssue({
                issueKey: id,
                parentIssue: parentIssue,
                rankRequest: rankRequest
            });
        }
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'timelineDragAndDrop reparent', {
            action: (0, $3sm8e.getReparentAction)(parentId, parentIdOld),
            isRanking: !!rankRequest,
            hierarchyLevel: level,
            parentHierarchyLevel: parentIssue?.issueType?.hierarchyLevel
        });
        // Re-rank the issue if a rank request is provided during the reparenting process
        if (rankRequest) rankIssue(id, payload, event, true);
    }, [
        createAnalyticsEvent,
        issueParentMap,
        issuesMap,
        rankIssue,
        reparentIssue,
        unlinkParentIssue
    ]);
    return {
        loading: issuesLoading,
        error: error,
        data: data,
        loadNextPage: loadNextPage,
        isLoadingNextPage: isLoadingNextPage,
        updateInCache: updateInCache,
        rankIssue: rankIssue,
        updateItemsInCache: updateItemsInCache,
        isLinkingEnabled: isLinkingEnabled,
        updateIssueParent: updateIssueParent
    };
};

});
parcelRegister("hPXdk", function(module, exports) {

$parcel$export(module.exports, "useHierarchyCache", () => $3299fbc32eb7c5ca$export$c2cd1510e81d00ce);

var $eUqFw = parcelRequire("eUqFw");

var $hTLlD = parcelRequire("hTLlD");

var $fDLFb = parcelRequire("fDLFb");

var $gEmpR = parcelRequire("gEmpR");


var $9kyGZ = parcelRequire("9kyGZ");
const $3299fbc32eb7c5ca$export$c2cd1510e81d00ce = ({ view: view })=>{
    const { loading: loading, error: error, hierarchyLevels: newHierarchyLevels } = (0, $gEmpR.useIssueTypesAndFields)({
        issueOperation: 'VIEW'
    });
    const { data: entity } = (0, $fDLFb.useBusinessEntity)();
    const localStorage = (0, $9kyGZ.getLocalStorage)(view);
    const hierarchyStorageKey = `${entity.id}_${(0, $ed82405237805b60$export$2cab30374aa79c41)}`;
    const [hierarchyLevels, setHierarchyLevels] = (0, $eUqFw.useState)(localStorage.get(hierarchyStorageKey));
    // save hierarchyLevels in localStorage
    (0, $eUqFw.useEffect)(()=>{
        if (!loading && !error) {
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))(hierarchyLevels, newHierarchyLevels)) {
                setHierarchyLevels(newHierarchyLevels);
                localStorage.set(hierarchyStorageKey, newHierarchyLevels);
            }
        }
    }, [
        loading,
        error,
        hierarchyLevels,
        hierarchyStorageKey,
        setHierarchyLevels,
        localStorage,
        newHierarchyLevels
    ]);
    const hierarchyLevelsWithCache = (0, $eUqFw.useMemo)(()=>{
        // return from cache (localStorage)
        if (hierarchyLevels && Array.isArray(hierarchyLevels)) return hierarchyLevels;
        // returns nothing if available fields query is in progress. But if cache is empty, it returns newHierarchyLevels
        if (loading) return [];
        return newHierarchyLevels;
    }, [
        hierarchyLevels,
        loading,
        newHierarchyLevels
    ]);
    return {
        hierarchyLevelsWithCache: hierarchyLevelsWithCache
    };
};

});
const $ed82405237805b60$export$2cab30374aa79c41 = 'hierarchy_levels';

parcelRegister("9kyGZ", function(module, exports) {

$parcel$export(module.exports, "getLocalStorage", () => $f21eb66b21e85710$export$d3720feff416e85b);

var $aZaPn = parcelRequire("aZaPn");
const $f21eb66b21e85710$export$d3720feff416e85b = (view)=>(0, $aZaPn.createLocalStorageProvider)(`jira_business_${view}-view`);

});


parcelRegister("3OkRL", function(module, exports) {

$parcel$export(module.exports, "useUpdateIssueParent", () => $cd775cf1529c48eb$export$346cb12ae0ad6251);

var $eUqFw = parcelRequire("eUqFw");

var $i3K0B = parcelRequire("i3K0B");

var $gEmpR = parcelRequire("gEmpR");

var $4G5xU = parcelRequire("4G5xU");

var $lGxgz = parcelRequire("lGxgz");

var $lskA1 = parcelRequire("lskA1");

var $guiFP = parcelRequire("guiFP");

var $1ybV0 = parcelRequire("1ybV0");

var $k8Qyf = parcelRequire("k8Qyf");

var $lO4Or = parcelRequire("lO4Or");

var $hTnQu = parcelRequire("hTnQu");

var $85tnI = parcelRequire("85tnI");

var $jucRl = parcelRequire("jucRl");

var $9quC1 = parcelRequire("9quC1");

var $75h8j = parcelRequire("75h8j");
const $cd775cf1529c48eb$export$346cb12ae0ad6251 = ({ childrenQueryData: childrenQueryData = {}, fieldIds: fieldIds, issueParentMap: issueParentMap, issuesMap: issuesMap, cacheQuery: cacheQuery, addChildToParent: addChildToParent, removeChildFromParent: removeChildFromParent, view: view, packageName: packageName, shouldOnlyUpdateCache: shouldOnlyUpdateCache = false, projectKey: projectKey })=>{
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagService)();
    const { hierarchyLevels: hierarchyLevels } = (0, $gEmpR.useIssueTypesAndFields)({
        issueOperation: 'VIEW'
    });
    const { quickFiltersJql: quickFiltersJql, hierarchyParent: hierarchyParent, jqlContext: jqlContext, isHidingDoneItems: isHidingDoneItems } = (0, $lGxgz.useFilteredViewContextInput)({
        view: view
    });
    const { addToCache: addToCache, getCachedIssueById: getCachedIssueById, removeFromCache: removeFromCache, updateItemsInCache: updateItemsInCache } = (0, $hTnQu.useCacheActions)();
    const [newParentIssue, setNewParentIssue] = (0, $eUqFw.useState)();
    const [reparentIssue, setReparentIssue] = (0, $eUqFw.useState)();
    const [optimisticRank, setOptimisticRank] = (0, $eUqFw.useState)('');
    const [revertData, setRevertData] = (0, $eUqFw.useState)(null);
    const updateParentIssueExperience = (0, $9quC1.getUpdateParentIssueExperience)(packageName);
    const startExperience = (0, $4G5xU.useExperienceStart)(updateParentIssueExperience);
    const markExperienceSuccess = (0, $4G5xU.useExperienceSuccess)(updateParentIssueExperience);
    const markExperienceFailed = (0, $4G5xU.useExperienceFail)(updateParentIssueExperience);
    const updateIssueField = (0, $jucRl.useUpdateIssueField)({
        onSuccess: ()=>{
            markExperienceSuccess();
        },
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        onError: (error)=>{
            if (error.statusCode === 400) showFlag((0, $9quC1.UPDATE_ITEM_PARENT_FAIL_400_FLAG));
            else if (error.statusCode === 404) showFlag((0, $9quC1.UPDATE_ITEM_PARENT_FAIL_404_FLAG));
            else {
                showFlag((0, $9quC1.UPDATE_ITEM_PARENT_FAIL_GENERIC_FLAG));
                markExperienceFailed('update issue parent failed', error);
            }
            throw error;
        }
    });
    const getRankPosition = (0, $eUqFw.useCallback)((rankRequest)=>{
        if (!rankRequest) return;
        const relativeIssueId = rankRequest.rankAfterId || rankRequest.rankBeforeId;
        if (relativeIssueId) {
            const relativeIssue = issuesMap.get(relativeIssueId);
            const relativeIssueRank = rankRequest.rankPosition || relativeIssue?.rank;
            if (relativeIssueRank) {
                const { rankBeforeId: rankBeforeId } = rankRequest;
                return rankBeforeId ? (0, $lskA1.getPreviousRank)(relativeIssueRank) : (0, $lskA1.getNextRank)(relativeIssueRank);
            }
        }
    }, [
        issuesMap
    ]);
    const getVariablesInput = (0, $eUqFw.useCallback)((parentId)=>{
        const defaultVariableInput = {
            jqlContext: jqlContext,
            fieldIds: fieldIds,
            quickFiltersJql: quickFiltersJql,
            isHidingDoneItems: isHidingDoneItems,
            ...hierarchyLevels !== undefined && {
                hierarchyLevel: hierarchyLevels[0]?.level
            },
            // project clause is only used in List view to render issues with parents from foreign projects
            projectIdOrKey: (0, $1ybV0.ff)('list-uses-new-jql-parent-project-directive_v5gfs') ? projectKey : undefined
        };
        if (hierarchyParent && parentId) return {
            ...defaultVariableInput,
            hierarchyParent: undefined,
            parentIssue: {
                hierarchyType: hierarchyParent,
                issueId: parentId
            }
        };
        return {
            ...defaultVariableInput,
            hierarchyParent: hierarchyParent
        };
    }, [
        jqlContext,
        fieldIds,
        quickFiltersJql,
        isHidingDoneItems,
        hierarchyLevels,
        projectKey,
        hierarchyParent
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (hierarchyParent && newParentIssue && reparentIssue) {
            const { issueId: newParentId, hasChildren: hasChildren, childSummary: childSummary } = newParentIssue;
            if (childrenQueryData[newParentId] && childrenQueryData[newParentId].loading === false) {
                const grandParentId = issueParentMap?.get(newParentId) ?? newParentIssue?.parentIssueId;
                if (!hasChildren || typeof childSummary?.totalCount === 'number') // Update parent issue hasChildren to true
                updateItemsInCache({
                    query: cacheQuery,
                    // We need to get the details of the current parent from the grandparent
                    variables: (0, $i3K0B.getVariables)(getVariablesInput(grandParentId)),
                    issueIds: [
                        newParentIssue.issueId
                    ],
                    updateItem: (existingIssue)=>addChildToParent(existingIssue)
                });
                const variables = (0, $i3K0B.getVariables)(getVariablesInput(newParentId));
                const newNode = (0, $1ybV0.ff)('jwm.timeline-dnd-reparent-bugfix_ld0b3') ? (0, $75h8j.generateIssueWithUpdatedParent)(reparentIssue, newParentIssue, view) : (0, $75h8j.generateIssueWithUpdatedParent)(reparentIssue, newParentIssue);
                addToCache({
                    query: cacheQuery,
                    variables: variables,
                    newNodes: [
                        optimisticRank ? (0, $85tnI.getOptimisticRanked)(newNode, optimisticRank) : newNode
                    ]
                });
                setReparentIssue(undefined);
                setNewParentIssue(undefined);
                setOptimisticRank('');
            }
        }
    }, [
        addToCache,
        childrenQueryData,
        getVariablesInput,
        hierarchyParent,
        isHidingDoneItems,
        jqlContext,
        quickFiltersJql,
        newParentIssue,
        reparentIssue,
        updateItemsInCache,
        getCachedIssueById,
        issueParentMap,
        optimisticRank,
        cacheQuery,
        addChildToParent,
        issuesMap,
        view
    ]);
    const updateIssueParentCache = (0, $eUqFw.useCallback)(({ oldParentId: oldParentId, issueKey: issueKey, parentIssue: parentIssue })=>{
        const variables = (0, $i3K0B.getVariables)(getVariablesInput(oldParentId));
        const issue = getCachedIssueById({
            issueId: issueKey,
            query: cacheQuery,
            variables: variables
        });
        setNewParentIssue(parentIssue);
        if (issue) setReparentIssue(issue);
        // Remove the issue from the old parent
        removeFromCache({
            query: cacheQuery,
            variables: variables,
            issueId: Number(issueKey)
        });
        // update child count of prev parent
        if (oldParentId && removeChildFromParent) {
            const grandParentId = issuesMap.get(oldParentId)?.parentIssueId;
            const queryVariables = (0, $i3K0B.getVariables)(getVariablesInput(grandParentId));
            updateItemsInCache({
                query: cacheQuery,
                variables: queryVariables,
                issueIds: [
                    String(oldParentId)
                ],
                updateItem: (existingParentIssue)=>removeChildFromParent(existingParentIssue, 1)
            });
        }
    }, [
        getVariablesInput,
        getCachedIssueById,
        cacheQuery,
        removeFromCache,
        removeChildFromParent,
        updateItemsInCache,
        issuesMap
    ]);
    const unlinkParentIssueCache = (0, $eUqFw.useCallback)(({ issueKey: issueKey, oldParentId: oldParentId, updateRank: updateRank })=>{
        const variables = (0, $i3K0B.getVariables)(getVariablesInput(oldParentId));
        const issue = getCachedIssueById({
            issueId: issueKey,
            query: cacheQuery,
            variables: variables
        });
        // Remove the issue from the old parent
        removeFromCache({
            query: cacheQuery,
            variables: variables,
            issueId: Number(issueKey)
        });
        // update child count of prev parent
        if (oldParentId && removeChildFromParent) {
            const grandParentId = issuesMap.get(oldParentId)?.parentIssueId;
            const queryVariables = (0, $i3K0B.getVariables)(getVariablesInput(grandParentId));
            updateItemsInCache({
                query: cacheQuery,
                variables: queryVariables,
                issueIds: [
                    String(oldParentId)
                ],
                updateItem: (parentIssue)=>removeChildFromParent(parentIssue, 1)
            });
        }
        const reparentIssueVariable = (0, $i3K0B.getVariables)(getVariablesInput());
        if (issue) {
            const newNode = (0, $1ybV0.ff)('jwm.timeline-dnd-reparent-bugfix_ld0b3') ? (0, $75h8j.generateIssueWithUpdatedParent)(issue, undefined, view) : (0, $75h8j.generateIssueWithUpdatedParent)(issue);
            // Add issue to the top level
            addToCache({
                query: cacheQuery,
                variables: reparentIssueVariable,
                newNodes: [
                    updateRank ? (0, $85tnI.getOptimisticRanked)(newNode, updateRank) : newNode
                ]
            });
        }
    }, [
        getVariablesInput,
        getCachedIssueById,
        cacheQuery,
        removeFromCache,
        removeChildFromParent,
        issuesMap,
        updateItemsInCache,
        view,
        addToCache
    ]);
    const revertOptimisticCacheUpdate = (0, $eUqFw.useCallback)(({ originalParentId: originalParentId, parentIssue: parentIssue, issueKey: issueKey, originalRank: originalRank })=>{
        const originalParent = originalParentId && issuesMap.get(originalParentId);
        if (originalParent) updateIssueParentCache({
            oldParentId: parentIssue?.issueId,
            issueKey: issueKey,
            parentIssue: originalParent
        });
        else if (originalRank && parentIssue) unlinkParentIssueCache({
            oldParentId: parentIssue.issueId,
            issueKey: issueKey,
            updateRank: originalRank
        });
    }, [
        issuesMap,
        unlinkParentIssueCache,
        updateIssueParentCache
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (revertData && revertData.parentIssue?.issueId && childrenQueryData[revertData.parentIssue.issueId] && childrenQueryData[revertData.parentIssue.issueId].loading === false) {
            const { originalParentId: originalParentId, parentIssue: parentIssue, issueKey: issueKey, originalRank: originalRank } = revertData;
            originalRank && setOptimisticRank(originalRank);
            revertOptimisticCacheUpdate({
                originalParentId: originalParentId,
                parentIssue: parentIssue,
                issueKey: issueKey,
                originalRank: originalRank
            });
            setRevertData(null);
        }
    }, [
        childrenQueryData,
        revertData,
        revertOptimisticCacheUpdate
    ]);
    const updateIssueParent = (0, $eUqFw.useCallback)(async ({ issueKey: issueKey, parentIssue: parentIssue, rankRequest: rankRequest, oldParentIssueId: oldParentIssueId })=>{
        !shouldOnlyUpdateCache && startExperience();
        const updateRank = getRankPosition(rankRequest);
        if (updateRank) setOptimisticRank(updateRank);
        const issue = issuesMap.get(String(issueKey));
        const originalRank = issue?.rank;
        const oldParentId = oldParentIssueId ?? issueParentMap?.get(issueKey);
        updateIssueParentCache({
            oldParentId: oldParentId,
            issueKey: issueKey,
            parentIssue: parentIssue
        });
        if (shouldOnlyUpdateCache) {
            await Promise.resolve();
            return {
                updateStatus: (0, $9quC1.SUCCEEDED)
            };
        }
        try {
            await updateIssueField({
                issueKey: issueKey,
                fieldKey: (0, $lO4Or.PARENT_TYPE),
                newValue: {
                    id: String(parentIssue.issueId)
                }
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $guiFP.default)({
                meta: {
                    id: (0, $9quC1.ERROR_ID),
                    packageName: (0, $9quC1.PACKAGE_NAME),
                    teamName: (0, $9quC1.TEAM_NAME)
                },
                attributes: {
                    message: 'update issue parent failed',
                    parentLevel: parentIssue?.issueType?.hierarchyLevel,
                    issueLevel: issue?.issueType?.hierarchyLevel,
                    view: view
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            setRevertData({
                originalParentId: oldParentId,
                parentIssue: parentIssue,
                issueKey: issueKey,
                originalRank: originalRank
            });
            return {
                updateStatus: (0, $9quC1.FAILED)
            };
        }
        return {
            updateStatus: (0, $9quC1.SUCCEEDED)
        };
    }, [
        shouldOnlyUpdateCache,
        startExperience,
        getRankPosition,
        issuesMap,
        issueParentMap,
        updateIssueParentCache,
        updateIssueField,
        view
    ]);
    const unlinkParentIssue = (0, $eUqFw.useCallback)(async ({ issueKey: issueKey, rankRequest: rankRequest, oldParentIssueId: oldParentIssueId })=>{
        !shouldOnlyUpdateCache && startExperience();
        const oldParentId = oldParentIssueId || issueParentMap?.get(issueKey);
        const updateRank = getRankPosition(rankRequest);
        const originalRank = issuesMap.get(String(issueKey))?.rank;
        unlinkParentIssueCache({
            issueKey: issueKey,
            oldParentId: oldParentId,
            updateRank: updateRank
        });
        if (shouldOnlyUpdateCache) {
            await Promise.resolve();
            return {
                updateStatus: (0, $9quC1.SUCCEEDED)
            };
        }
        try {
            await updateIssueField({
                issueKey: issueKey,
                fieldKey: (0, $lO4Or.PARENT_TYPE),
                newValue: {
                    id: null
                }
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            const issue = issuesMap.get(String(issueKey));
            (0, $guiFP.default)({
                meta: {
                    id: (0, $9quC1.ERROR_ID),
                    packageName: (0, $9quC1.PACKAGE_NAME),
                    teamName: (0, $9quC1.TEAM_NAME)
                },
                attributes: {
                    message: 'unlink issue parent failed',
                    issueLevel: issue?.issueType?.hierarchyLevel,
                    view: view
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            if (originalRank) {
                setOptimisticRank(originalRank);
                revertOptimisticCacheUpdate({
                    originalParentId: oldParentId,
                    issueKey: issueKey
                });
            }
            return {
                updateStatus: (0, $9quC1.FAILED)
            };
        }
        return {
            updateStatus: (0, $9quC1.SUCCEEDED)
        };
    }, [
        shouldOnlyUpdateCache,
        startExperience,
        issueParentMap,
        getRankPosition,
        issuesMap,
        unlinkParentIssueCache,
        updateIssueField,
        view,
        revertOptimisticCacheUpdate
    ]);
    return {
        updateIssueParent: updateIssueParent,
        unlinkParentIssue: unlinkParentIssue
    };
};

});
parcelRegister("jucRl", function(module, exports) {

$parcel$export(module.exports, "useUpdateIssueField", () => $d5ea7f4a6ca981df$export$cc74d3329dbba44d);

var $eUqFw = parcelRequire("eUqFw");

var $guiFP = parcelRequire("guiFP");

var $fecbI = parcelRequire("fecbI");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");
const $d5ea7f4a6ca981df$var$JWM_ISSUE_FIELD_UPDATE = 'jwmIssueFieldUpdate';
const $d5ea7f4a6ca981df$export$cc74d3329dbba44d = ({ onError: onError, onSuccess: onSuccess })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const updateIssueField = (0, $eUqFw.useCallback)(async ({ issueKey: issueKey, fieldKey: fieldKey, newValue: newValue })=>(0, $fecbI.defaultSaveField)(issueKey, fieldKey, newValue, '').then((response)=>{
            (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), `${$d5ea7f4a6ca981df$var$JWM_ISSUE_FIELD_UPDATE} succeeded`, {
                field: newValue
            });
            onSuccess && onSuccess();
            return response;
        }).catch((error)=>{
            (0, $guiFP.default)({
                meta: {
                    id: $d5ea7f4a6ca981df$var$JWM_ISSUE_FIELD_UPDATE,
                    packageName: 'jiraBusinessListHandlers',
                    teamName: 'keystone'
                },
                attributes: {
                    message: `${$d5ea7f4a6ca981df$var$JWM_ISSUE_FIELD_UPDATE} failed`,
                    field: fieldKey.startsWith('customfield_') ? 'category' : fieldKey
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            onError && onError(error);
        }), [
        createAnalyticsEvent,
        onError,
        onSuccess
    ]);
    return updateIssueField;
};

});
parcelRegister("fecbI", function(module, exports) {

$parcel$export(module.exports, "defaultSaveField", () => $4eca3d717c3df3ee$export$b74e6b7f831f1cb2);
$parcel$export(module.exports, "defaultSaveFieldById", () => $4eca3d717c3df3ee$export$b2c49aae5d84cced);
$parcel$export(module.exports, "defaultAddValuesToField", () => $4eca3d717c3df3ee$export$c46c7284cd9c5d3);
$parcel$export(module.exports, "defaultRemoveValuesFromField", () => $4eca3d717c3df3ee$export$33b78476f5d734b3);

var $lRmyA = parcelRequire("lRmyA");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $4eca3d717c3df3ee$var$getFieldUpdate = (fieldKey, value)=>({
        fields: {
            [fieldKey]: value
        }
    });
const $4eca3d717c3df3ee$export$b74e6b7f831f1cb2 = async (issueKey, fieldKey, newValue, baseUrl)=>(0, $lRmyA.performPutRequest)(`${baseUrl}/rest/api/3/issue/${issueKey}/`, {
        body: JSON.stringify($4eca3d717c3df3ee$var$getFieldUpdate(fieldKey, newValue))
    });
const $4eca3d717c3df3ee$export$b2c49aae5d84cced = async (issueKey, fieldKey, newValue, baseUrl)=>(0, $lRmyA.performPutRequest)(`${baseUrl}/rest/api/3/issue/${issueKey}/?returnIssue=true`, {
        body: JSON.stringify($4eca3d717c3df3ee$var$getFieldUpdate(fieldKey, newValue))
    });
const $4eca3d717c3df3ee$export$c46c7284cd9c5d3 = async (issueKey, fieldKey, valuesToAdd, baseUrl)=>{
    const updateParam = {
        update: {
            [fieldKey]: [
                {
                    operation: 'add',
                    value: valuesToAdd
                }
            ]
        }
    };
    return (0, $lRmyA.performPutRequest)(`${baseUrl}/rest/api/3/issue/${issueKey}/`, {
        body: JSON.stringify(updateParam)
    });
};
const $4eca3d717c3df3ee$export$33b78476f5d734b3 = async (issueKey, fieldKey, valuesToRemove, baseUrl)=>{
    const updateParam = {
        update: {
            [fieldKey]: [
                {
                    operation: 'remove',
                    value: valuesToRemove
                }
            ]
        }
    };
    return (0, $lRmyA.performPutRequest)(`${baseUrl}/rest/api/3/issue/${issueKey}/`, {
        body: JSON.stringify(updateParam)
    });
};

});


parcelRegister("9quC1", function(module, exports) {

$parcel$export(module.exports, "UPDATE_ITEM_PARENT_FAIL_GENERIC_FLAG", () => $7c7324ba52c0b878$export$e80b28191e1d3602);
$parcel$export(module.exports, "UPDATE_ITEM_PARENT_FAIL_400_FLAG", () => $7c7324ba52c0b878$export$29d372313e7a3d7b);
$parcel$export(module.exports, "UPDATE_ITEM_PARENT_FAIL_404_FLAG", () => $7c7324ba52c0b878$export$6a4ca5120f2baf63);
$parcel$export(module.exports, "getUpdateParentIssueExperience", () => $7c7324ba52c0b878$export$8f39ff4e40cb6a05);
$parcel$export(module.exports, "SUCCEEDED", () => $7c7324ba52c0b878$export$11823571c61d4d02);
$parcel$export(module.exports, "FAILED", () => $7c7324ba52c0b878$export$d71930f7f5807a72);
$parcel$export(module.exports, "PACKAGE_NAME", () => $7c7324ba52c0b878$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "ERROR_ID", () => $7c7324ba52c0b878$export$f3390a0e172fee41);
$parcel$export(module.exports, "TEAM_NAME", () => $7c7324ba52c0b878$export$d57b6b390e78d90f);

var $1vfhg = parcelRequire("1vfhg");
const $7c7324ba52c0b878$export$e80b28191e1d3602 = {
    type: 'error',
    title: (0, $1vfhg.default).updateIssueParentErrorTitleNonFinal,
    description: (0, $1vfhg.default).updateIssueParentGenericErrorDescriptionNonFinal
};
const $7c7324ba52c0b878$export$29d372313e7a3d7b = {
    type: 'error',
    title: (0, $1vfhg.default).updateIssueParentErrorTitleNonFinal,
    description: (0, $1vfhg.default).updateIssueParent400ErrorDescriptionNonFinal
};
const $7c7324ba52c0b878$export$6a4ca5120f2baf63 = {
    type: 'error',
    title: (0, $1vfhg.default).updateIssueParentErrorTitleNonFinal,
    description: (0, $1vfhg.default).updateIssueParent404ErrorDescriptionNonFinal
};
const $7c7324ba52c0b878$export$8f39ff4e40cb6a05 = (packageName)=>({
        experience: 'updateParentIssue',
        packageName: packageName,
        teamName: 'keystone'
    });
const $7c7324ba52c0b878$export$11823571c61d4d02 = 'SUCCEEDED';
const $7c7324ba52c0b878$export$d71930f7f5807a72 = 'FAILED';
const $7c7324ba52c0b878$export$b8b9d90f9e5bd72b = 'jiraBusinessListHandlers';
const $7c7324ba52c0b878$export$f3390a0e172fee41 = 'useUpdateIssueParent';
const $7c7324ba52c0b878$export$d57b6b390e78d90f = 'keystone';

});
parcelRegister("1vfhg", function(module, exports) {

$parcel$export(module.exports, "default", () => $3855af390f6eddc6$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var // TODO: Finalize the following messages
$3855af390f6eddc6$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    updateIssueParentErrorTitleNonFinal: {
        "id": "business-list-handlers.controllers.update-issue-parent.update-issue-parent-error-title-non-final",
        "defaultMessage": "Something's gone wrong"
    },
    updateIssueParentGenericErrorDescriptionNonFinal: {
        "id": "business-list-handlers.controllers.update-issue-parent.update-issue-parent-generic-error-description-non-final",
        "defaultMessage": "Refresh the page and try again."
    },
    updateIssueParent400ErrorDescriptionNonFinal: {
        "id": "business-list-handlers.controllers.update-issue-parent.update-issue-parent-400-error-description-non-final",
        "defaultMessage": "You don\u2019t have permission to update this issue. Contact a project admin."
    },
    updateIssueParent404ErrorDescriptionNonFinal: {
        "id": "business-list-handlers.controllers.update-issue-parent.update-issue-parent-404-error-description-non-final",
        "defaultMessage": "We\u2019re having trouble updating this issue. To continue, refresh the page."
    }
});

});


parcelRegister("75h8j", function(module, exports) {

$parcel$export(module.exports, "generateIssueWithUpdatedParent", () => $6662a1b5dd306f5c$export$2b799a607e235a03);

var $1ybV0 = parcelRequire("1ybV0");

var $eI5EY = parcelRequire("eI5EY");

var $lO4Or = parcelRequire("lO4Or");
const $6662a1b5dd306f5c$export$32c176d5dc779b09 = (rank)=>rank ? [
        {
            aliasFieldId: 'rank',
            text: rank,
            __typename: 'JiraSingleLineTextField'
        }
    ] : null;
const $6662a1b5dd306f5c$var$generateParentField = (issueId, key, id, rank, view)=>{
    const shouldHaveIdAttribute = (0, $1ybV0.ff)('jwm.timeline-dnd-reparent-bugfix_ld0b3') ? (0, $eI5EY.fg)('jsw_list_view_-_all_the_fields') && view === 'list' : (0, $eI5EY.fg)('jsw_list_view_-_all_the_fields');
    return {
        aliasFieldId: null,
        fieldId: (0, $lO4Or.PARENT_TYPE),
        type: (0, $lO4Or.PARENT_TYPE),
        name: 'Parent',
        parentIssue: issueId && key ? {
            __typename: 'JiraIssue',
            issueId: issueId,
            key: key,
            ...shouldHaveIdAttribute ? {
                id: id
            } : {},
            rankField: $6662a1b5dd306f5c$export$32c176d5dc779b09(rank)
        } : null,
        __typename: 'JiraParentIssueField'
    };
};
const $6662a1b5dd306f5c$export$2b799a607e235a03 = (issue, newParentIssue, view)=>{
    const { issueId: newParentIssueId, key: newParentKey, id: newParentId, rank: newParentRank } = newParentIssue || {};
    const parentFieldIndex = issue?.fields?.findIndex((field)=>field.type === (0, $lO4Or.PARENT_TYPE) || field.fieldId === (0, $lO4Or.PARENT_TYPE));
    const shouldHaveIdAttribute = (0, $1ybV0.ff)('jwm.timeline-dnd-reparent-bugfix_ld0b3') ? (0, $eI5EY.fg)('jsw_list_view_-_all_the_fields') && view === 'list' : (0, $eI5EY.fg)('jsw_list_view_-_all_the_fields');
    const parentField = parentFieldIndex !== -1 && parentFieldIndex !== undefined ? {
        ...issue?.fields?.[parentFieldIndex],
        parentIssue: !newParentIssueId || !newParentKey ? null : {
            ...shouldHaveIdAttribute ? {
                id: newParentId
            } : {},
            issueId: newParentIssueId,
            rankField: $6662a1b5dd306f5c$export$32c176d5dc779b09(newParentRank),
            key: newParentKey,
            __typename: 'JiraIssue'
        }
    } : $6662a1b5dd306f5c$var$generateParentField(newParentIssueId, newParentKey, newParentId, newParentRank, view);
    return {
        ...issue,
        fields: [
            ...issue?.fields?.filter((field)=>field.type !== (0, $lO4Or.PARENT_TYPE) && field.fieldId !== (0, $lO4Or.PARENT_TYPE)) || [],
            parentField
        ]
    };
};

});


parcelRegister("g19OU", function(module, exports) {

$parcel$export(module.exports, "default", () => $5cbe665eb3c4fe74$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $5cbe665eb3c4fe74$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    rankingErrorTitle: {
        "id": "business-timeline.controllers.timeline-view-issues.ranking-error-title",
        "defaultMessage": "Something's gone wrong"
    },
    rankingErrorMessage: {
        "id": "business-timeline.controllers.timeline-view-issues.ranking-error-message",
        "defaultMessage": "Refresh the page and try again."
    },
    loadingItemsErrorTitle: {
        "id": "business-timeline.controllers.timeline-view-issues.loading-items-error-title",
        "defaultMessage": "Timeline items couldn't be retrieved"
    },
    loadingItemsErrorDescription: {
        "id": "business-timeline.controllers.timeline-view-issues.loading-items-error-description",
        "defaultMessage": "Refresh the page and try again."
    }
});

});

parcelRegister("3sm8e", function(module, exports) {

$parcel$export(module.exports, "getReparentAction", () => $a4cc06d98605b067$export$517f69c641140cf7);
const $a4cc06d98605b067$export$517f69c641140cf7 = (parentId, parentIdOld)=>{
    if (!parentId) return 'removeParent';
    if (parentIdOld) return 'changeParent';
    return 'addParent';
};

});

parcelRegister("37Inl", function(module, exports) {

$parcel$export(module.exports, "toTimelineData", () => $64a7c0e2f0deefb6$export$bd4e9db3df8041ab);

var $1urNG = parcelRequire("1urNG");

var $5iWql = parcelRequire("5iWql");

var $d3C6e = parcelRequire("d3C6e");

var $1ybV0 = parcelRequire("1ybV0");

var $6vrw7 = parcelRequire("6vrw7");

var $gf0vG = parcelRequire("gf0vG");

var $fHtBB = parcelRequire("fHtBB");
var $cERyr = parcelRequire("cERyr");

var $2nzpw = parcelRequire("2nzpw");

var $aRSCW = parcelRequire("aRSCW");

var $5Sg7D = parcelRequire("5Sg7D");

var $6FDoD = parcelRequire("6FDoD");

var $dIStB = parcelRequire("dIStB");

var $211Np = parcelRequire("211Np");

var $lj2Mb = parcelRequire("lj2Mb");
const $64a7c0e2f0deefb6$var$shallowCompare = (newArg, lastArg)=>{
    if (typeof newArg !== 'object' || newArg === null || typeof lastArg !== 'object' || lastArg === null) return newArg === lastArg;
    // for object parameter, we want to do shallow compare on the top level arguments
    return Object.keys(newArg).length === Object.keys(lastArg).length && // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{}'. | TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{}'.
    Object.keys(newArg).every((key)=>key in lastArg && newArg[key] === lastArg[key]);
};
const $64a7c0e2f0deefb6$var$getTransformedTimelineData = ({ timelineViewIssuesData: timelineViewIssuesData, childrenQueryData: childrenQueryData, expandedItems: expandedItems, createItemAnchor: createItemAnchor, issuesMap: issuesMap, issueParentMap: issueParentMap, isLinkingEnabled: isLinkingEnabled, isFiltering: isFiltering = false, isOverview: isOverview = false })=>{
    const { issues: issues } = timelineViewIssuesData;
    const itemHeight = (0, $gf0vG.DEFAULT_ITEM_HEIGHT);
    const rootItemIds = (0, $1ybV0.ff)('jwm.visual-hierarchy-milestone-1') && !isOverview ? issues.map((item)=>item.issueId) : [];
    const childIdsHash = {};
    const chartDataHash = {};
    const startDateHash = {};
    const dueDateHash = {};
    const dependenciesHash = {};
    const interactiveChartItems = [];
    issuesMap.clear();
    issueParentMap.clear();
    const convertIssueToInteractiveChartItem = (item, parentId)=>{
        // issueMap is used to access issueKey from custom Item component which is not accessible from its props
        issuesMap.set(item.issueId, item);
        // getting all dependencies and creating a hash used in getDependenciesItems()
        (isLinkingEnabled === true && item.issueLinks || []).forEach((link)=>{
            const { inward: inward, outward: outward } = link;
            const inwardId = inward?.issueId;
            const outwardId = outward?.issueId;
            if (inwardId && inwardId !== item.issueId) dependenciesHash[item.issueId] = (0, (/*@__PURE__*/$parcel$interopDefault($1urNG)))(dependenciesHash[item.issueId], [
                inwardId
            ]);
            if (outwardId && outwardId !== item.issueId) dependenciesHash[outwardId] = (0, (/*@__PURE__*/$parcel$interopDefault($1urNG)))(dependenciesHash[outwardId], [
                item.issueId
            ]);
        });
        // for the purpose of getDependenciesItems
        chartDataHash[item.issueId] = {
            color: (0, $aRSCW.getColor)(item.status.categoryId),
            ...(0, $lj2Mb.transformDates)({
                startDate: item.startDate,
                dueDate: item.dueDate
            })
        };
        startDateHash[item.issueId] = item.startDate;
        dueDateHash[item.issueId] = item.dueDate;
        const hasLeftPlaceholder = !item.startDate;
        const hasRightPlaceholder = !item.dueDate;
        return {
            level: parentId ? (0, $2nzpw.TIMELINE_CHILD_LEVEL) : (0, $2nzpw.TIMELINE_PARENT_LEVEL),
            id: item.issueId,
            ...(0, $lj2Mb.transformDates)({
                startDate: item.startDate,
                dueDate: item.dueDate
            }),
            placeholder: (0, $cERyr.getPlaceholder)(hasLeftPlaceholder, hasRightPlaceholder),
            startDateType: (0, $fHtBB.EXPLICIT),
            dueDateType: (0, $fHtBB.EXPLICIT),
            intervalId: undefined,
            parentId: parentId
        };
    };
    const createTimelineItem = (item)=>({
            id: (0, $6vrw7.toIssueId)(item.issueId),
            level: item.issueType.hierarchyLevel,
            isInTransition: (0, $d3C6e.isOptimisticIssue)(Number(item.issueId)),
            canCreateChildOverride: !(0, $dIStB.isSubTaskLevel)(item.issueType.hierarchyLevel),
            childItems: recursivelyPopulateChildItems(item)
        });
    const recursivelyPopulateChildItems = (item)=>{
        if (isFiltering || !item.hasChildren) return undefined;
        const childrenIssuesQueryData = childrenQueryData[item.issueId];
        if (!childIdsHash[item.issueId]) childIdsHash[item.issueId] = [];
        if (!childrenIssuesQueryData || childrenIssuesQueryData.loading) {
            const skeletonChildItem = (0, $211Np.createItemSkeleton)({
                id: item.issueId,
                level: item.issueType.hierarchyLevel - 1
            });
            childIdsHash[item.issueId].push(skeletonChildItem.id);
            return [
                {
                    ...skeletonChildItem,
                    isInTransition: false
                }
            ];
        }
        return childrenIssuesQueryData.data.issues.reduce((childItems, childIssue)=>{
            childIdsHash[item.issueId].push(childIssue.issueId);
            issueParentMap.set(childIssue.issueId, item.issueId);
            interactiveChartItems.push(convertIssueToInteractiveChartItem(childIssue, item.issueId));
            childItems.push(createTimelineItem(childIssue));
            return childItems;
        }, []);
    };
    let items = [];
    if ((0, $1ybV0.ff)('jwm.visual-hierarchy-milestone-1') && !isOverview) items = issues.reduce((acc, item)=>{
        interactiveChartItems.push(convertIssueToInteractiveChartItem(item));
        acc.push(createTimelineItem(item));
        return acc;
    }, []);
    else issues.forEach((item)=>{
        rootItemIds.push(item.issueId);
        const populateChildItems = ()=>{
            if (!isFiltering && item.hasChildren) {
                const childrenIssuesQueryData = childrenQueryData[item.issueId];
                if (!childrenIssuesQueryData || childrenIssuesQueryData.loading) {
                    const skeletonChildItem = (0, $211Np.createItemSkeleton)({
                        id: item.issueId,
                        level: (0, $2nzpw.TIMELINE_CHILD_LEVEL)
                    });
                    return [
                        {
                            id: skeletonChildItem.id,
                            level: (0, $2nzpw.TIMELINE_CHILD_LEVEL),
                            isInTransition: false
                        }
                    ];
                }
                const childItemsNew = [];
                childrenIssuesQueryData.data.issues.forEach((childIssue)=>{
                    if (!childIdsHash[item.issueId]) childIdsHash[item.issueId] = [];
                    childIdsHash[item.issueId].push(childIssue.issueId);
                    // register the parent of this child issue
                    issueParentMap.set(childIssue.issueId, item.issueId);
                    interactiveChartItems.push(convertIssueToInteractiveChartItem(childIssue, item.issueId));
                    childItemsNew.push({
                        id: (0, $6vrw7.toIssueId)(childIssue.issueId),
                        level: (0, $2nzpw.TIMELINE_CHILD_LEVEL),
                        isInTransition: (0, $d3C6e.isOptimisticIssue)(Number(childIssue.issueId)),
                        canCreateChildOverride: false
                    });
                });
                return childItemsNew;
            }
            return undefined;
        };
        interactiveChartItems.push(convertIssueToInteractiveChartItem(item));
        const timelineItem = {
            id: (0, $6vrw7.toIssueId)(item.issueId),
            level: (0, $2nzpw.TIMELINE_PARENT_LEVEL),
            isInTransition: (0, $d3C6e.isOptimisticIssue)(Number(item.issueId))
        };
        if (item.issueType.hierarchyLevel >= (0, $2nzpw.TIMELINE_EPIC_HIERARCHY_LEVEL)) // do not allow to create children issues for epic types
        timelineItem.canCreateChildOverride = false;
        else timelineItem.childItems = populateChildItems();
        items.push(timelineItem);
    });
    const positionsHash = (0, $1ybV0.ff)('jwm.visual-hierarchy-milestone-1') ? (0, $6FDoD.getItemOffsetPositions)(rootItemIds, childIdsHash, expandedItems, createItemAnchor) : (0, $6FDoD.getItemOffsetPositionsOld)(itemHeight, rootItemIds, childIdsHash, expandedItems, createItemAnchor);
    const dependencies = isLinkingEnabled === true ? (0, $5Sg7D.getDependenciesItems)(positionsHash, chartDataHash, dependenciesHash, startDateHash, dueDateHash) : [];
    return {
        items: items,
        issuesMap: issuesMap,
        issueParentMap: issueParentMap,
        dependencies: dependencies,
        interactiveChartItems: interactiveChartItems
    };
};
const $64a7c0e2f0deefb6$export$bd4e9db3df8041ab = (0, $5iWql.default)((params)=>$64a7c0e2f0deefb6$var$getTransformedTimelineData(params), (newArgs, lastArgs)=>{
    if (newArgs.length !== lastArgs.length) return false;
    const equalityFn = $64a7c0e2f0deefb6$var$shallowCompare;
    return newArgs.every((newArg, index)=>equalityFn(newArg, lastArgs[index]));
});

});
parcelRegister("1urNG", function(module, exports) {

var $hKE3p = parcelRequire("hKE3p");

var $9eFtX = parcelRequire("9eFtX");

var $42tFs = parcelRequire("42tFs");

var $cRpul = parcelRequire("cRpul");
/**
 * Creates an array of unique values, in order, from all given arrays using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @returns {Array} Returns the new array of combined values.
 * @example
 *
 * _.union([2], [1, 2]);
 * // => [2, 1]
 */ var $115e28588d963fcd$var$union = $9eFtX(function(arrays) {
    return $42tFs($hKE3p(arrays, 1, $cRpul, true));
});
module.exports = $115e28588d963fcd$var$union;

});

parcelRegister("fHtBB", function(module, exports) {

$parcel$export(module.exports, "DATE_FORMAT_MOMENT", () => $d61a398c89b7109c$export$98de7bb6e1f5105c);
$parcel$export(module.exports, "DUE_DATE_OFFSET", () => $d61a398c89b7109c$export$28c98c2c1f9d90de);
$parcel$export(module.exports, "INTERVAL", () => $d61a398c89b7109c$export$7dea0e6e08f87a8a);
$parcel$export(module.exports, "ROLLUP", () => $d61a398c89b7109c$export$e299765c2b7892c0);
$parcel$export(module.exports, "EXPLICIT", () => $d61a398c89b7109c$export$29c6b89b5966039e);

const $d61a398c89b7109c$export$45c85543ba71221d = 'yyyy/MM/dd';
const $d61a398c89b7109c$export$98de7bb6e1f5105c = 'yyyy/MM/DD';
const $d61a398c89b7109c$export$28c98c2c1f9d90de = (0, $4975412c8fcbfa24$export$1f04624003d2da7d) - 1;
const $d61a398c89b7109c$export$7dea0e6e08f87a8a = 'INTERVAL';
const $d61a398c89b7109c$export$e299765c2b7892c0 = 'ROLLUP';
const $d61a398c89b7109c$export$29c6b89b5966039e = 'EXPLICIT';

});

parcelRegister("cERyr", function(module, exports) {

$parcel$export(module.exports, "isStartDatePlaceholder", () => $19c0e4ccb73df2dd$export$1673e5e0e5ff398a);
$parcel$export(module.exports, "isDueDatePlaceholder", () => $19c0e4ccb73df2dd$export$bd9b44c69998322c);
$parcel$export(module.exports, "getPlaceholderWhileDragging", () => $19c0e4ccb73df2dd$export$97dae3d8f882d620);
$parcel$export(module.exports, "getPlaceholder", () => $19c0e4ccb73df2dd$export$d3f5c5e0a5023fa0);

var $c3IKH = parcelRequire("c3IKH");
var $4P2VV = parcelRequire("4P2VV");
const $19c0e4ccb73df2dd$export$1673e5e0e5ff398a = (placeholder)=>placeholder === (0, $c3IKH.START_DATE_PLACEHOLDER) || placeholder === (0, $c3IKH.START_AND_DUE_DATE_PLACEHOLDER);
const $19c0e4ccb73df2dd$export$bd9b44c69998322c = (placeholder)=>placeholder === (0, $c3IKH.DUE_DATE_PLACEHOLDER) || placeholder === (0, $c3IKH.START_AND_DUE_DATE_PLACEHOLDER);
const $19c0e4ccb73df2dd$export$97dae3d8f882d620 = (dragType, placeholder)=>{
    if (dragType === (0, $4P2VV.LEFT_AND_RIGHT)) return undefined;
    if (dragType === (0, $4P2VV.LEFT) && placeholder === (0, $c3IKH.START_DATE_PLACEHOLDER)) return undefined;
    if (dragType === (0, $4P2VV.RIGHT) && placeholder === (0, $c3IKH.DUE_DATE_PLACEHOLDER)) return undefined;
    if (dragType === (0, $4P2VV.RIGHT) && placeholder === (0, $c3IKH.START_AND_DUE_DATE_PLACEHOLDER)) return 0, $c3IKH.START_DATE_PLACEHOLDER;
    if (dragType === (0, $4P2VV.LEFT) && placeholder === (0, $c3IKH.START_AND_DUE_DATE_PLACEHOLDER)) return 0, $c3IKH.DUE_DATE_PLACEHOLDER;
    return placeholder;
};
const $19c0e4ccb73df2dd$export$d3f5c5e0a5023fa0 = (hasLeftPlaceholder, hasRightPlaceholder)=>{
    if (hasLeftPlaceholder && hasRightPlaceholder) return 0, $c3IKH.START_AND_DUE_DATE_PLACEHOLDER;
    if (hasLeftPlaceholder) return 0, $c3IKH.START_DATE_PLACEHOLDER;
    if (hasRightPlaceholder) return 0, $c3IKH.DUE_DATE_PLACEHOLDER;
    return undefined;
};

});
parcelRegister("c3IKH", function(module, exports) {

$parcel$export(module.exports, "BAR_HEIGHT", () => $ce33e285ef462695$export$4f2f40eb3120c);
$parcel$export(module.exports, "BASE_BAR_HEIGHT", () => $ce33e285ef462695$export$c8c47b136dc7ac05);
$parcel$export(module.exports, "MINIMUM_BAR_LENGTH", () => $ce33e285ef462695$export$729e677ca5ac2f4f);
$parcel$export(module.exports, "DEFAULT_BORDER_RADIUS", () => $ce33e285ef462695$export$f2926bd20425bb0d);
$parcel$export(module.exports, "LEFT_PLACEHOLDER_BORDER_RADIUS", () => $ce33e285ef462695$export$df860cf23132dfbb);
$parcel$export(module.exports, "RIGHT_PLACEHOLDER_BORDER_RADIUS", () => $ce33e285ef462695$export$a822ec327ef716a4);
$parcel$export(module.exports, "LEFT_AND_RIGHT_PLACEHOLDER_BORDER_RADIUS", () => $ce33e285ef462695$export$5b9db862a15e1457);
$parcel$export(module.exports, "START_DATE_PLACEHOLDER", () => $ce33e285ef462695$export$cfcf3497a5711f2c);
$parcel$export(module.exports, "DUE_DATE_PLACEHOLDER", () => $ce33e285ef462695$export$42702a43f0325a0c);
$parcel$export(module.exports, "START_AND_DUE_DATE_PLACEHOLDER", () => $ce33e285ef462695$export$1b72784d953fe9b3);
// eslint-disable-next-line jira/restricted/@atlassian+jira-common-styles

var $c9TLT = parcelRequire("c9TLT");
const $ce33e285ef462695$export$4f2f40eb3120c = (0, $c9TLT.gridSize) * 3;
const $ce33e285ef462695$export$c8c47b136dc7ac05 = (0, $c9TLT.gridSize) * 2.5;
const $ce33e285ef462695$export$729e677ca5ac2f4f = 36;
const $ce33e285ef462695$export$f2926bd20425bb0d = `${(0, $c9TLT.borderRadius)}px`;
const $ce33e285ef462695$export$deb313264d4a6a20 = `${(0, $c9TLT.borderRadius) * 3}px`;
const $ce33e285ef462695$export$df860cf23132dfbb = `${$ce33e285ef462695$export$deb313264d4a6a20} ${$ce33e285ef462695$export$f2926bd20425bb0d} ${$ce33e285ef462695$export$f2926bd20425bb0d} ${$ce33e285ef462695$export$deb313264d4a6a20}`;
const $ce33e285ef462695$export$a822ec327ef716a4 = `${$ce33e285ef462695$export$f2926bd20425bb0d} ${$ce33e285ef462695$export$deb313264d4a6a20} ${$ce33e285ef462695$export$deb313264d4a6a20} ${$ce33e285ef462695$export$f2926bd20425bb0d}`;
const $ce33e285ef462695$export$5b9db862a15e1457 = `${$ce33e285ef462695$export$deb313264d4a6a20}`;
const $ce33e285ef462695$export$cfcf3497a5711f2c = 'START_DATE_PLACEHOLDER';
const $ce33e285ef462695$export$42702a43f0325a0c = 'DUE_DATE_PLACEHOLDER';
const $ce33e285ef462695$export$1b72784d953fe9b3 = 'START_AND_DUE_DATE_PLACEHOLDER';

});

parcelRegister("4P2VV", function(module, exports) {

$parcel$export(module.exports, "TOP", () => $489ab04a62618e5c$export$793ed84f5e13fedc);
$parcel$export(module.exports, "BOTTOM", () => $489ab04a62618e5c$export$84e1549b474f1b93);
$parcel$export(module.exports, "LEFT", () => $489ab04a62618e5c$export$f981f70d61d1405a);
$parcel$export(module.exports, "RIGHT", () => $489ab04a62618e5c$export$1cac5500365a4eb4);
$parcel$export(module.exports, "LEFT_AND_RIGHT", () => $489ab04a62618e5c$export$15a640865ed23fd6);
$parcel$export(module.exports, "RELEASES_HEADER_ID", () => $489ab04a62618e5c$export$c44d80b675e16f76);
$parcel$export(module.exports, "SPRINTS_HEADER_ID", () => $489ab04a62618e5c$export$8b5a447b30b83d68);
$parcel$export(module.exports, "DEFAULT_RENDERER", () => $489ab04a62618e5c$export$8c50c502a6dae24);

var $fHtBB = parcelRequire("fHtBB");

var $c3IKH = parcelRequire("c3IKH");


var $8OTV8 = parcelRequire("8OTV8");



var $ksGD2 = parcelRequire("ksGD2");

var $fbLos = parcelRequire("fbLos");

const $489ab04a62618e5c$export$793ed84f5e13fedc = 'TOP';
const $489ab04a62618e5c$export$84e1549b474f1b93 = 'BOTTOM';
const $489ab04a62618e5c$export$f981f70d61d1405a = 'LEFT';
const $489ab04a62618e5c$export$1cac5500365a4eb4 = 'RIGHT';
const $489ab04a62618e5c$export$15a640865ed23fd6 = 'LEFT_AND_RIGHT';
const $489ab04a62618e5c$export$c44d80b675e16f76 = 'RELEASES_HEADER_ID';
const $489ab04a62618e5c$export$8b5a447b30b83d68 = 'SPRINTS_HEADER_ID';
const $489ab04a62618e5c$export$8c50c502a6dae24 = ()=>null;

});
const $4a5f481703991dee$export$62467065a148cd06 = 8;
const $4a5f481703991dee$export$462ae417bcee39bd = 2;
const $4a5f481703991dee$export$e2bd4c1faded7921 = 2;

parcelRegister("8OTV8", function(module, exports) {

$parcel$export(module.exports, "HEADER_BACKGROUND_COLOR", () => $ae9af783e318ec5a$export$cff61b214d368dd4);

var $PdmhA = parcelRequire("PdmhA");
const $ae9af783e318ec5a$export$cff61b214d368dd4 = `var(--ds-surface-sunken, ${(0, $PdmhA.N20)})`; // TODO: fix token https://hello.atlassian.net/wiki/spaces/ADOS/pages/1511543981/Dark+Mode+Mismatched+Colors+on+Roadmaps+issue+epic-color

});

const $fbe90688b36d692e$export$48a2b55760ce2355 = 'dependency-drag-id';
const $fbe90688b36d692e$export$c330e9be73819573 = 'dependencies-drop-target';
const $fbe90688b36d692e$export$920d6feba87a57ed = 'INCOMING';
const $fbe90688b36d692e$export$2c998d8d93f14e97 = 'OUTGOING';

const $4a21b57a573cad8c$export$19c4f83398a8dbce = 'CLOSED';
const $4a21b57a573cad8c$export$2b35adb71b3f6143 = 'ACTIVE';
const $4a21b57a573cad8c$export$47b7b82714c61a7c = 'FUTURE';

parcelRegister("ksGD2", function(module, exports) {

$parcel$export(module.exports, "CHART_BAR_Z_INDEX", () => $9d21b0c8cbcd8930$export$b769e19d85a0dd1f);
$parcel$export(module.exports, "OVERLAY_FLYOUT_Z_INDEX", () => $9d21b0c8cbcd8930$export$607b7b6549bb844a);

var $c9TLT = parcelRequire("c9TLT");
const $9d21b0c8cbcd8930$export$b8c38275349a321a = 2;
const $9d21b0c8cbcd8930$export$bf7c4b09e1259e0c = 2;
const $9d21b0c8cbcd8930$export$b769e19d85a0dd1f = 3;
const $9d21b0c8cbcd8930$export$e3452b0e8cf45d94 = 3;
const $9d21b0c8cbcd8930$export$fd0eb84f1cc64bd1 = 4;
const $9d21b0c8cbcd8930$export$ccfab360c3bec41f = 5;
const $9d21b0c8cbcd8930$export$d0b62675e5ca73fd = 6;
const $9d21b0c8cbcd8930$export$952b9e656bb22739 = 6;
const $9d21b0c8cbcd8930$export$bf33c90eb728615a = 8;
const $9d21b0c8cbcd8930$export$d2c2571c3482d99f = 15;
const $9d21b0c8cbcd8930$export$607b7b6549bb844a = (0, $c9TLT.layers).navigation;

});

parcelRegister("fbLos", function(module, exports) {

$parcel$export(module.exports, "MARKER_WIDTH", () => $4aeafc4f5c417c61$export$4a6351d766d85076);
$parcel$export(module.exports, "MARKER_WIDTH_WITH_SPACE", () => $4aeafc4f5c417c61$export$95fcddab5858cd42);
$parcel$export(module.exports, "MARKER_BORDER_WIDTH", () => $4aeafc4f5c417c61$export$ff01cdc3aad1196);
$parcel$export(module.exports, "COMPLETED", () => $4aeafc4f5c417c61$export$fc332a617fd34192);
$parcel$export(module.exports, "IN_PROGRESS", () => $4aeafc4f5c417c61$export$5a9ac66c2785cc13);
$parcel$export(module.exports, "WARNING", () => $4aeafc4f5c417c61$export$64fdd419ec8dbc36);
$parcel$export(module.exports, "MARKER_COLORS", () => $4aeafc4f5c417c61$export$d4060d4eb5ad0b29);
$parcel$export(module.exports, "STATUS_PRIORITY", () => $4aeafc4f5c417c61$export$dc65af84169ff7fb);

var $PdmhA = parcelRequire("PdmhA");

var $c9TLT = parcelRequire("c9TLT");
const $4aeafc4f5c417c61$export$4a6351d766d85076 = (0, $c9TLT.gridSize) * 2.5;
const $4aeafc4f5c417c61$export$95fcddab5858cd42 = $4aeafc4f5c417c61$export$4a6351d766d85076 + (0, $c9TLT.gridSize) * 2;
const $4aeafc4f5c417c61$export$ff01cdc3aad1196 = 2;
const $4aeafc4f5c417c61$export$fc332a617fd34192 = 'COMPLETED';
const $4aeafc4f5c417c61$export$5a9ac66c2785cc13 = 'IN_PROGRESS';
const $4aeafc4f5c417c61$export$64fdd419ec8dbc36 = 'WARNING';
const $4aeafc4f5c417c61$export$d4060d4eb5ad0b29 = {
    [$4aeafc4f5c417c61$export$fc332a617fd34192]: `var(--ds-icon-success, ${(0, $PdmhA.G400)})`,
    [$4aeafc4f5c417c61$export$5a9ac66c2785cc13]: `var(--ds-icon-information, ${(0, $PdmhA.B400)})`,
    [$4aeafc4f5c417c61$export$64fdd419ec8dbc36]: `var(--ds-icon-danger, ${(0, $PdmhA.R400)})`
};
const $4aeafc4f5c417c61$export$dc65af84169ff7fb = {
    [$4aeafc4f5c417c61$export$fc332a617fd34192]: 0,
    [$4aeafc4f5c417c61$export$5a9ac66c2785cc13]: 1,
    [$4aeafc4f5c417c61$export$64fdd419ec8dbc36]: 2
};

});

const $aba7cf5b5acfd3bc$export$4b680a32bbb87a28 = 'DEPENDENCIES_FLYOUT';
const $aba7cf5b5acfd3bc$export$a9487b0be9740846 = 'CONTEXT_MENU';



parcelRegister("aRSCW", function(module, exports) {

$parcel$export(module.exports, "getColor", () => $a37f905ef82d0b2f$export$5551a2d24ff40153);

var $8Qd0L = parcelRequire("8Qd0L");

var $opsFH = parcelRequire("opsFH");
const $a37f905ef82d0b2f$var$colorMap = {
    [(0, $8Qd0L.UNDEFINED)]: (0, $opsFH.DARK_GREY),
    [(0, $8Qd0L.TODO)]: (0, $opsFH.DARK_GREY),
    [(0, $8Qd0L.DONE)]: (0, $opsFH.DARK_GREEN),
    [(0, $8Qd0L.IN_PROGRESS)]: (0, $opsFH.DARK_BLUE)
};
const $a37f905ef82d0b2f$export$5551a2d24ff40153 = (categoryId)=>$a37f905ef82d0b2f$var$colorMap[(0, $8Qd0L.statusCategoryForId)(categoryId)];

});
parcelRegister("opsFH", function(module, exports) {

$parcel$export(module.exports, "PURPLE", () => $e6c2c5f41d0c328b$export$7ffdeca4b2f927a2);
$parcel$export(module.exports, "DARK_PURPLE", () => $e6c2c5f41d0c328b$export$c815fe495e8174a0);
$parcel$export(module.exports, "BLUE", () => $e6c2c5f41d0c328b$export$738c3b9a44c87ecc);
$parcel$export(module.exports, "DARK_BLUE", () => $e6c2c5f41d0c328b$export$1225f83626261b80);
$parcel$export(module.exports, "GREEN", () => $e6c2c5f41d0c328b$export$48d4b2cd5bc0e88b);
$parcel$export(module.exports, "DARK_GREEN", () => $e6c2c5f41d0c328b$export$c6f4cf2e5768eb78);
$parcel$export(module.exports, "TEAL", () => $e6c2c5f41d0c328b$export$d0446fe88325854e);
$parcel$export(module.exports, "DARK_TEAL", () => $e6c2c5f41d0c328b$export$bb848c92687e69dc);
$parcel$export(module.exports, "YELLOW", () => $e6c2c5f41d0c328b$export$aab610c505c06a8f);
$parcel$export(module.exports, "DARK_YELLOW", () => $e6c2c5f41d0c328b$export$466af87757d343a2);
$parcel$export(module.exports, "ORANGE", () => $e6c2c5f41d0c328b$export$3de5e29ed1757f9b);
$parcel$export(module.exports, "DARK_ORANGE", () => $e6c2c5f41d0c328b$export$da02e4820b6ab753);
$parcel$export(module.exports, "GREY", () => $e6c2c5f41d0c328b$export$7d278ca694634874);
$parcel$export(module.exports, "DARK_GREY", () => $e6c2c5f41d0c328b$export$26453300bfc61cb8);
$parcel$export(module.exports, "COLORS", () => $e6c2c5f41d0c328b$export$56d196d2844d1ca1);
$parcel$export(module.exports, "SERVER_PURPLE", () => $e6c2c5f41d0c328b$export$792af22a0198af8d);
$parcel$export(module.exports, "SERVER_DARK_PURPLE", () => $e6c2c5f41d0c328b$export$588af712afdcb006);
$parcel$export(module.exports, "SERVER_BLUE", () => $e6c2c5f41d0c328b$export$84c4918645391802);
$parcel$export(module.exports, "SERVER_DARK_BLUE", () => $e6c2c5f41d0c328b$export$b8f1f5838352a33a);
$parcel$export(module.exports, "SERVER_GREEN", () => $e6c2c5f41d0c328b$export$9384b7e350ee6542);
$parcel$export(module.exports, "SERVER_DARK_GREEN", () => $e6c2c5f41d0c328b$export$87d3fb8d8656d38b);
$parcel$export(module.exports, "SERVER_TEAL", () => $e6c2c5f41d0c328b$export$b0b4ce3e99e66aae);
$parcel$export(module.exports, "SERVER_DARK_TEAL", () => $e6c2c5f41d0c328b$export$a89b77a449bd223e);
$parcel$export(module.exports, "SERVER_YELLOW", () => $e6c2c5f41d0c328b$export$9a33b5e3cde94885);
$parcel$export(module.exports, "SERVER_DARK_YELLOW", () => $e6c2c5f41d0c328b$export$33253d7862bceb8a);
$parcel$export(module.exports, "SERVER_ORANGE", () => $e6c2c5f41d0c328b$export$6609c2b23fc42f39);
$parcel$export(module.exports, "SERVER_DARK_ORANGE", () => $e6c2c5f41d0c328b$export$cd994662b5911917);
$parcel$export(module.exports, "SERVER_GREY", () => $e6c2c5f41d0c328b$export$1793d43e13e078c5);
$parcel$export(module.exports, "SERVER_DARK_GREY", () => $e6c2c5f41d0c328b$export$487a6e9145526564);
$parcel$export(module.exports, "GHX_LABEL_1", () => $e6c2c5f41d0c328b$export$e4bdf2d4c4bbb15e);
$parcel$export(module.exports, "GHX_LABEL_2", () => $e6c2c5f41d0c328b$export$8f5c1c5512278dc6);
$parcel$export(module.exports, "GHX_LABEL_3", () => $e6c2c5f41d0c328b$export$94ac87c81ed074a7);
$parcel$export(module.exports, "GHX_LABEL_4", () => $e6c2c5f41d0c328b$export$6bc9ab1f489f76f7);
$parcel$export(module.exports, "GHX_LABEL_5", () => $e6c2c5f41d0c328b$export$610a2c132b6fcf96);
$parcel$export(module.exports, "GHX_LABEL_6", () => $e6c2c5f41d0c328b$export$8e4997dba71f1c40);
$parcel$export(module.exports, "GHX_LABEL_7", () => $e6c2c5f41d0c328b$export$18a545b4e69b27b4);
$parcel$export(module.exports, "GHX_LABEL_8", () => $e6c2c5f41d0c328b$export$27fff1a0d295292a);
$parcel$export(module.exports, "GHX_LABEL_9", () => $e6c2c5f41d0c328b$export$e57aa662a56724e1);
$parcel$export(module.exports, "GHX_LABEL_10", () => $e6c2c5f41d0c328b$export$4b0d63e2c3be2072);
$parcel$export(module.exports, "GHX_LABEL_11", () => $e6c2c5f41d0c328b$export$457ecb9560f2bf83);
$parcel$export(module.exports, "GHX_LABEL_12", () => $e6c2c5f41d0c328b$export$a866db37165a696c);
$parcel$export(module.exports, "GHX_LABEL_13", () => $e6c2c5f41d0c328b$export$9b18447c1168a1b6);
$parcel$export(module.exports, "GHX_LABEL_14", () => $e6c2c5f41d0c328b$export$93b9ad4020e271b7);
$parcel$export(module.exports, "AGILE_COLOR_1", () => $e6c2c5f41d0c328b$export$5cd2af17b34de3e3);
$parcel$export(module.exports, "AGILE_COLOR_2", () => $e6c2c5f41d0c328b$export$987671fa69482a7b);
$parcel$export(module.exports, "AGILE_COLOR_3", () => $e6c2c5f41d0c328b$export$70ba8a5b1f4c7446);
$parcel$export(module.exports, "AGILE_COLOR_4", () => $e6c2c5f41d0c328b$export$fcd1c42d8d3ebd36);
$parcel$export(module.exports, "AGILE_COLOR_5", () => $e6c2c5f41d0c328b$export$f80a5bd2fa0ba256);
$parcel$export(module.exports, "AGILE_COLOR_6", () => $e6c2c5f41d0c328b$export$37ad5ce8d2aeaf78);
$parcel$export(module.exports, "AGILE_COLOR_7", () => $e6c2c5f41d0c328b$export$9dc62d5d151cb355);
$parcel$export(module.exports, "AGILE_COLOR_8", () => $e6c2c5f41d0c328b$export$1ed15b30f5663f92);
$parcel$export(module.exports, "AGILE_COLOR_9", () => $e6c2c5f41d0c328b$export$5d23a84d55ac1644);
$parcel$export(module.exports, "AGILE_COLOR_10", () => $e6c2c5f41d0c328b$export$bf08c9a6ed42e349);
$parcel$export(module.exports, "AGILE_COLOR_11", () => $e6c2c5f41d0c328b$export$66c5d8f0b5ff279c);
$parcel$export(module.exports, "AGILE_COLOR_12", () => $e6c2c5f41d0c328b$export$da30755a37c3a597);
$parcel$export(module.exports, "AGILE_COLOR_13", () => $e6c2c5f41d0c328b$export$721cf84faff6bf19);
$parcel$export(module.exports, "AGILE_COLOR_14", () => $e6c2c5f41d0c328b$export$4b8f8666bd7b61dd);
$parcel$export(module.exports, "Colors", () => $e6c2c5f41d0c328b$export$c537fa0d021d010b);
$parcel$export(module.exports, "ServerColors", () => $e6c2c5f41d0c328b$export$d33d39828a18210a);
$parcel$export(module.exports, "ClassicEpicColors", () => $e6c2c5f41d0c328b$export$f476e6e43e0101e7);
$parcel$export(module.exports, "AgileColors", () => $e6c2c5f41d0c328b$export$4b7407b8700035bd);
/**
 * Color constants
 */ const $e6c2c5f41d0c328b$export$7ffdeca4b2f927a2 = 'PURPLE';
const $e6c2c5f41d0c328b$export$c815fe495e8174a0 = 'DARK_PURPLE';
const $e6c2c5f41d0c328b$export$738c3b9a44c87ecc = 'BLUE';
const $e6c2c5f41d0c328b$export$1225f83626261b80 = 'DARK_BLUE';
const $e6c2c5f41d0c328b$export$48d4b2cd5bc0e88b = 'GREEN';
const $e6c2c5f41d0c328b$export$c6f4cf2e5768eb78 = 'DARK_GREEN';
const $e6c2c5f41d0c328b$export$d0446fe88325854e = 'TEAL';
const $e6c2c5f41d0c328b$export$bb848c92687e69dc = 'DARK_TEAL';
const $e6c2c5f41d0c328b$export$aab610c505c06a8f = 'YELLOW';
const $e6c2c5f41d0c328b$export$466af87757d343a2 = 'DARK_YELLOW';
const $e6c2c5f41d0c328b$export$3de5e29ed1757f9b = 'ORANGE';
const $e6c2c5f41d0c328b$export$da02e4820b6ab753 = 'DARK_ORANGE';
const $e6c2c5f41d0c328b$export$7d278ca694634874 = 'GREY';
const $e6c2c5f41d0c328b$export$26453300bfc61cb8 = 'DARK_GREY';
const $e6c2c5f41d0c328b$export$56d196d2844d1ca1 = [
    $e6c2c5f41d0c328b$export$7ffdeca4b2f927a2,
    $e6c2c5f41d0c328b$export$c815fe495e8174a0,
    $e6c2c5f41d0c328b$export$738c3b9a44c87ecc,
    $e6c2c5f41d0c328b$export$1225f83626261b80,
    $e6c2c5f41d0c328b$export$48d4b2cd5bc0e88b,
    $e6c2c5f41d0c328b$export$c6f4cf2e5768eb78,
    $e6c2c5f41d0c328b$export$d0446fe88325854e,
    $e6c2c5f41d0c328b$export$bb848c92687e69dc,
    $e6c2c5f41d0c328b$export$aab610c505c06a8f,
    $e6c2c5f41d0c328b$export$466af87757d343a2,
    $e6c2c5f41d0c328b$export$3de5e29ed1757f9b,
    $e6c2c5f41d0c328b$export$da02e4820b6ab753,
    $e6c2c5f41d0c328b$export$7d278ca694634874,
    $e6c2c5f41d0c328b$export$26453300bfc61cb8
];
const $e6c2c5f41d0c328b$export$792af22a0198af8d = 'purple';
const $e6c2c5f41d0c328b$export$588af712afdcb006 = 'dark_purple';
const $e6c2c5f41d0c328b$export$84c4918645391802 = 'blue';
const $e6c2c5f41d0c328b$export$b8f1f5838352a33a = 'dark_blue';
const $e6c2c5f41d0c328b$export$9384b7e350ee6542 = 'green';
const $e6c2c5f41d0c328b$export$87d3fb8d8656d38b = 'dark_green';
const $e6c2c5f41d0c328b$export$b0b4ce3e99e66aae = 'teal';
const $e6c2c5f41d0c328b$export$a89b77a449bd223e = 'dark_teal';
const $e6c2c5f41d0c328b$export$9a33b5e3cde94885 = 'yellow';
const $e6c2c5f41d0c328b$export$33253d7862bceb8a = 'dark_yellow';
const $e6c2c5f41d0c328b$export$6609c2b23fc42f39 = 'orange';
const $e6c2c5f41d0c328b$export$cd994662b5911917 = 'dark_orange';
const $e6c2c5f41d0c328b$export$1793d43e13e078c5 = 'grey';
const $e6c2c5f41d0c328b$export$487a6e9145526564 = 'dark_grey';
const $e6c2c5f41d0c328b$export$e4bdf2d4c4bbb15e = 'ghx-label-1';
const $e6c2c5f41d0c328b$export$8f5c1c5512278dc6 = 'ghx-label-2';
const $e6c2c5f41d0c328b$export$94ac87c81ed074a7 = 'ghx-label-3';
const $e6c2c5f41d0c328b$export$6bc9ab1f489f76f7 = 'ghx-label-4';
const $e6c2c5f41d0c328b$export$610a2c132b6fcf96 = 'ghx-label-5';
const $e6c2c5f41d0c328b$export$8e4997dba71f1c40 = 'ghx-label-6';
const $e6c2c5f41d0c328b$export$18a545b4e69b27b4 = 'ghx-label-7';
const $e6c2c5f41d0c328b$export$27fff1a0d295292a = 'ghx-label-8';
const $e6c2c5f41d0c328b$export$e57aa662a56724e1 = 'ghx-label-9';
const $e6c2c5f41d0c328b$export$4b0d63e2c3be2072 = 'ghx-label-10';
const $e6c2c5f41d0c328b$export$457ecb9560f2bf83 = 'ghx-label-11';
const $e6c2c5f41d0c328b$export$a866db37165a696c = 'ghx-label-12';
const $e6c2c5f41d0c328b$export$9b18447c1168a1b6 = 'ghx-label-13';
const $e6c2c5f41d0c328b$export$93b9ad4020e271b7 = 'ghx-label-14';
const $e6c2c5f41d0c328b$export$5cd2af17b34de3e3 = 'color_1';
const $e6c2c5f41d0c328b$export$987671fa69482a7b = 'color_2';
const $e6c2c5f41d0c328b$export$70ba8a5b1f4c7446 = 'color_3';
const $e6c2c5f41d0c328b$export$fcd1c42d8d3ebd36 = 'color_4';
const $e6c2c5f41d0c328b$export$f80a5bd2fa0ba256 = 'color_5';
const $e6c2c5f41d0c328b$export$37ad5ce8d2aeaf78 = 'color_6';
const $e6c2c5f41d0c328b$export$9dc62d5d151cb355 = 'color_7';
const $e6c2c5f41d0c328b$export$1ed15b30f5663f92 = 'color_8';
const $e6c2c5f41d0c328b$export$5d23a84d55ac1644 = 'color_9';
const $e6c2c5f41d0c328b$export$bf08c9a6ed42e349 = 'color_10';
const $e6c2c5f41d0c328b$export$66c5d8f0b5ff279c = 'color_11';
const $e6c2c5f41d0c328b$export$da30755a37c3a597 = 'color_12';
const $e6c2c5f41d0c328b$export$721cf84faff6bf19 = 'color_13';
const $e6c2c5f41d0c328b$export$4b8f8666bd7b61dd = 'color_14';
const $e6c2c5f41d0c328b$export$c537fa0d021d010b = {
    PURPLE: $e6c2c5f41d0c328b$export$7ffdeca4b2f927a2,
    DARK_PURPLE: $e6c2c5f41d0c328b$export$c815fe495e8174a0,
    BLUE: $e6c2c5f41d0c328b$export$738c3b9a44c87ecc,
    DARK_BLUE: $e6c2c5f41d0c328b$export$1225f83626261b80,
    GREEN: $e6c2c5f41d0c328b$export$48d4b2cd5bc0e88b,
    DARK_GREEN: $e6c2c5f41d0c328b$export$c6f4cf2e5768eb78,
    TEAL: $e6c2c5f41d0c328b$export$d0446fe88325854e,
    DARK_TEAL: $e6c2c5f41d0c328b$export$bb848c92687e69dc,
    YELLOW: $e6c2c5f41d0c328b$export$aab610c505c06a8f,
    DARK_YELLOW: $e6c2c5f41d0c328b$export$466af87757d343a2,
    ORANGE: $e6c2c5f41d0c328b$export$3de5e29ed1757f9b,
    DARK_ORANGE: $e6c2c5f41d0c328b$export$da02e4820b6ab753,
    GREY: $e6c2c5f41d0c328b$export$7d278ca694634874,
    DARK_GREY: $e6c2c5f41d0c328b$export$26453300bfc61cb8
};
const $e6c2c5f41d0c328b$export$d33d39828a18210a = {
    SERVER_PURPLE: $e6c2c5f41d0c328b$export$792af22a0198af8d,
    SERVER_DARK_PURPLE: $e6c2c5f41d0c328b$export$588af712afdcb006,
    SERVER_BLUE: $e6c2c5f41d0c328b$export$84c4918645391802,
    SERVER_DARK_BLUE: $e6c2c5f41d0c328b$export$b8f1f5838352a33a,
    SERVER_GREEN: $e6c2c5f41d0c328b$export$9384b7e350ee6542,
    SERVER_DARK_GREEN: $e6c2c5f41d0c328b$export$87d3fb8d8656d38b,
    SERVER_TEAL: $e6c2c5f41d0c328b$export$b0b4ce3e99e66aae,
    SERVER_DARK_TEAL: $e6c2c5f41d0c328b$export$a89b77a449bd223e,
    SERVER_YELLOW: $e6c2c5f41d0c328b$export$9a33b5e3cde94885,
    SERVER_DARK_YELLOW: $e6c2c5f41d0c328b$export$33253d7862bceb8a,
    SERVER_ORANGE: $e6c2c5f41d0c328b$export$6609c2b23fc42f39,
    SERVER_DARK_ORANGE: $e6c2c5f41d0c328b$export$cd994662b5911917,
    SERVER_GREY: $e6c2c5f41d0c328b$export$1793d43e13e078c5,
    SERVER_DARK_GREY: $e6c2c5f41d0c328b$export$487a6e9145526564
};
const $e6c2c5f41d0c328b$export$f476e6e43e0101e7 = {
    GHX_LABEL_1: $e6c2c5f41d0c328b$export$e4bdf2d4c4bbb15e,
    GHX_LABEL_2: $e6c2c5f41d0c328b$export$8f5c1c5512278dc6,
    GHX_LABEL_3: $e6c2c5f41d0c328b$export$94ac87c81ed074a7,
    GHX_LABEL_4: $e6c2c5f41d0c328b$export$6bc9ab1f489f76f7,
    GHX_LABEL_5: $e6c2c5f41d0c328b$export$610a2c132b6fcf96,
    GHX_LABEL_6: $e6c2c5f41d0c328b$export$8e4997dba71f1c40,
    GHX_LABEL_7: $e6c2c5f41d0c328b$export$18a545b4e69b27b4,
    GHX_LABEL_8: $e6c2c5f41d0c328b$export$27fff1a0d295292a,
    GHX_LABEL_9: $e6c2c5f41d0c328b$export$e57aa662a56724e1,
    GHX_LABEL_10: $e6c2c5f41d0c328b$export$4b0d63e2c3be2072,
    GHX_LABEL_11: $e6c2c5f41d0c328b$export$457ecb9560f2bf83,
    GHX_LABEL_12: $e6c2c5f41d0c328b$export$a866db37165a696c,
    GHX_LABEL_13: $e6c2c5f41d0c328b$export$9b18447c1168a1b6,
    GHX_LABEL_14: $e6c2c5f41d0c328b$export$93b9ad4020e271b7
};
const $e6c2c5f41d0c328b$export$4b7407b8700035bd = {
    AGILE_COLOR_1: $e6c2c5f41d0c328b$export$5cd2af17b34de3e3,
    AGILE_COLOR_2: $e6c2c5f41d0c328b$export$987671fa69482a7b,
    AGILE_COLOR_3: $e6c2c5f41d0c328b$export$70ba8a5b1f4c7446,
    AGILE_COLOR_4: $e6c2c5f41d0c328b$export$fcd1c42d8d3ebd36,
    AGILE_COLOR_5: $e6c2c5f41d0c328b$export$f80a5bd2fa0ba256,
    AGILE_COLOR_6: $e6c2c5f41d0c328b$export$37ad5ce8d2aeaf78,
    AGILE_COLOR_7: $e6c2c5f41d0c328b$export$9dc62d5d151cb355,
    AGILE_COLOR_8: $e6c2c5f41d0c328b$export$1ed15b30f5663f92,
    AGILE_COLOR_9: $e6c2c5f41d0c328b$export$5d23a84d55ac1644,
    AGILE_COLOR_10: $e6c2c5f41d0c328b$export$bf08c9a6ed42e349,
    AGILE_COLOR_11: $e6c2c5f41d0c328b$export$66c5d8f0b5ff279c,
    AGILE_COLOR_12: $e6c2c5f41d0c328b$export$da30755a37c3a597,
    AGILE_COLOR_13: $e6c2c5f41d0c328b$export$721cf84faff6bf19,
    AGILE_COLOR_14: $e6c2c5f41d0c328b$export$4b8f8666bd7b61dd
};

});


parcelRegister("5Sg7D", function(module, exports) {

$parcel$export(module.exports, "getDependenciesItems", () => $69e3dcee2e2ed839$export$675e7796a0dd4b1e);

var $6vrw7 = parcelRequire("6vrw7");

var $gf0vG = parcelRequire("gf0vG");

var $btCKK = parcelRequire("btCKK");

var $6W7Vb = parcelRequire("6W7Vb");
const $69e3dcee2e2ed839$export$675e7796a0dd4b1e = (positionsHash, itemsHash, dependenciesHash, startDateHash, dueDateHash)=>{
    const dependencies = [];
    Object.keys(dependenciesHash).forEach((issueId)=>{
        const targetIssueId = (0, $6vrw7.toIssueId)(issueId);
        const issueDependencies = dependenciesHash[targetIssueId];
        if (itemsHash[targetIssueId] && positionsHash[targetIssueId] !== undefined) {
            const targetItem = itemsHash[targetIssueId];
            const targetDate = (0, $btCKK.evaluateTargetDependencyDate)(targetItem);
            if (targetDate !== undefined) {
                const to = {
                    id: (0, $6vrw7.toIssueId)(targetIssueId),
                    startDate: targetDate,
                    y: positionsHash[targetIssueId],
                    color: targetItem.color
                };
                issueDependencies.forEach((sourceIssueId)=>{
                    if (itemsHash[sourceIssueId] && positionsHash[sourceIssueId] !== undefined) {
                        const sourceItem = itemsHash[sourceIssueId];
                        const sourceDate = (0, $btCKK.evaluateSourceDependencyDate)(sourceItem);
                        if (sourceDate !== undefined) {
                            const itemHeight = (0, $gf0vG.DEFAULT_ITEM_HEIGHT);
                            dependencies.push({
                                itemHeight: itemHeight,
                                from: {
                                    id: sourceIssueId,
                                    dueDate: sourceDate,
                                    y: positionsHash[sourceIssueId],
                                    color: sourceItem.color
                                },
                                to: to,
                                isOverlapping: (0, $6W7Vb.isDependencyDatesOverlapping)(startDateHash[sourceIssueId], dueDateHash[sourceIssueId], startDateHash[issueId], dueDateHash[issueId])
                            });
                        }
                    }
                });
            }
        }
    });
    return dependencies;
};

});
parcelRegister("btCKK", function(module, exports) {

$parcel$export(module.exports, "evaluateTargetDependencyDate", () => $ccc6171e0baf43a1$export$81334eb3d1727c87);
$parcel$export(module.exports, "evaluateSourceDependencyDate", () => $ccc6171e0baf43a1$export$5bed6e237e54824f);

var $1ybV0 = parcelRequire("1ybV0");
const $ccc6171e0baf43a1$export$81334eb3d1727c87 = (targetItem)=>{
    const { startDate: start, dueDate: due } = targetItem;
    if ((0, $1ybV0.ff)('timeline-bar-start-date-after-due-date_ddpds') && due !== undefined && start !== undefined && due < start) return due;
    return start;
};
const $ccc6171e0baf43a1$export$5bed6e237e54824f = (sourceItem)=>{
    const { startDate: start, dueDate: due } = sourceItem;
    if ((0, $1ybV0.ff)('timeline-bar-start-date-after-due-date_ddpds') && due !== undefined && start !== undefined && due < start) return start;
    return due;
};

});

parcelRegister("6W7Vb", function(module, exports) {

$parcel$export(module.exports, "isDependencyDatesOverlapping", () => $a12e5fbd4d98598b$export$9fb40a5a7e47a5dd);
const $a12e5fbd4d98598b$export$9fb40a5a7e47a5dd = (dependencyStartDate = -1, dependencyDueDate = -1, dependeeStartDate = -1, dependeeDueDate = -1)=>{
    // happy case where dates are defined
    if (dependencyDueDate > -1 && dependeeStartDate > -1) return dependencyDueDate > dependeeStartDate;
    // no dates on either dependency or dependee
    if (dependencyStartDate === -1 && dependencyDueDate === -1 || dependeeStartDate === -1 && dependeeDueDate === -1) return false;
    // only start date on dependency and due date on dependee
    if (dependencyDueDate === -1 && dependeeStartDate === -1) return dependencyStartDate > dependeeDueDate;
    // due date of dependency and due date of dependee
    if (dependencyDueDate !== -1) return dependencyDueDate > dependeeDueDate;
    // start date of dependency and start date of dependee
    if (dependencyStartDate !== -1) return dependencyStartDate > dependeeStartDate;
    // impossible case
    return false;
};

});


parcelRegister("6FDoD", function(module, exports) {

$parcel$export(module.exports, "getItemOffsetPositions", () => $f3812ba36ef554f3$export$1c16f71ecb9378cb);
$parcel$export(module.exports, "getItemOffsetPositionsOld", () => $f3812ba36ef554f3$export$e1891c9f54dae789);

var $5iWql = parcelRequire("5iWql");

var $gf0vG = parcelRequire("gf0vG");

var $dIStB = parcelRequire("dIStB");
const $f3812ba36ef554f3$export$1c16f71ecb9378cb = (0, $5iWql.default)((itemIds, childIdsHash, expandedItems, createItemAnchor)=>{
    const positions = {};
    let cumulativeOffset = 0;
    const calculateOffsetPositions = (id, depth)=>{
        if ((0, $dIStB.isCreateBeforeItem)(createItemAnchor, id)) cumulativeOffset += (0, $gf0vG.DEFAULT_ITEM_HEIGHT);
        const itemHeight = (0, $dIStB.isRootDepth)(depth) ? (0, $gf0vG.DEFAULT_ITEM_HEIGHT) : (0, $gf0vG.BASE_LEVEL_ITEM_HEIGHT);
        positions[id] = cumulativeOffset + itemHeight / 2;
        cumulativeOffset += itemHeight;
        const childIds = childIdsHash[id];
        if (childIds && expandedItems[id]) childIds.forEach((childId)=>calculateOffsetPositions(childId, depth + 1));
        if ((0, $dIStB.isCreateInsideItem)(createItemAnchor, id)) cumulativeOffset += (0, $gf0vG.DEFAULT_ITEM_HEIGHT);
    };
    itemIds.forEach((id)=>calculateOffsetPositions(id, 0));
    return positions;
});
const $f3812ba36ef554f3$export$70dc67daffbef8af = (itemHeight, itemIds, childIdsHash = {}, expandedItems = {}, createItemAnchor)=>{
    const result = [];
    let prevItemOffset = 0;
    itemIds.forEach((id)=>{
        const childIds = childIdsHash[id] || [];
        let childHeight = expandedItems[id] ? childIds.length * (0, $gf0vG.BASE_LEVEL_ITEM_HEIGHT) : 0;
        let currentOffset = prevItemOffset;
        /* Include offsets caused by the create item.
		 * The create item is always the same height (itemHeight) even when creating children.
		 */ if (createItemAnchor) {
            const createBeforeItem = createItemAnchor.position === (0, $gf0vG.BEFORE) && createItemAnchor.beforeId === id;
            const createBeforeChildItem = createItemAnchor.position === (0, $gf0vG.BEFORE) && createItemAnchor.beforeId === id && createItemAnchor.parentId !== undefined;
            const createInsideItem = createItemAnchor.position === (0, $gf0vG.INSIDE) && createItemAnchor.parentId === id;
            if (createBeforeItem) currentOffset += itemHeight;
            if (createInsideItem || createBeforeChildItem) childHeight += itemHeight;
        }
        const totalHeight = itemHeight + childHeight;
        result.push({
            id: String(id),
            position: currentOffset + itemHeight / 2,
            height: itemHeight
        });
        // if parent is expanded, include children in the list
        if (expandedItems[id]) {
            let childPrevItemOffset = currentOffset + itemHeight;
            childIds.forEach((childId)=>{
                if (createItemAnchor && // @ts-expect-error - TS2339 - Property 'parentId' does not exist on type 'LastAnchor | RelativeAnchor'.
                createItemAnchor.parentId && createItemAnchor.position === (0, $gf0vG.BEFORE) && createItemAnchor.beforeId === childId) {
                    childPrevItemOffset += itemHeight;
                    currentOffset += itemHeight;
                }
                result.push({
                    id: String(childId),
                    position: childPrevItemOffset + (0, $gf0vG.BASE_LEVEL_ITEM_HEIGHT) / 2,
                    height: (0, $gf0vG.BASE_LEVEL_ITEM_HEIGHT)
                });
                childPrevItemOffset += (0, $gf0vG.BASE_LEVEL_ITEM_HEIGHT);
            });
        }
        prevItemOffset = currentOffset + totalHeight;
    });
    return result;
};
const $f3812ba36ef554f3$var$parsePositions = (items)=>items.reduce((acc, { id: id, position: position })=>{
        acc[id] = position;
        return acc;
    }, {});
const $f3812ba36ef554f3$export$e1891c9f54dae789 = (itemHeight, itemIds, childIdsHash, expandedItems, // @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
createItemAnchor)=>$f3812ba36ef554f3$var$parsePositions($f3812ba36ef554f3$export$70dc67daffbef8af(itemHeight, itemIds, childIdsHash, expandedItems, createItemAnchor));

});
parcelRegister("dIStB", function(module, exports) {

$parcel$export(module.exports, "isSubTaskLevel", () => $45a5bdab6e13981e$export$aebc411043116683);
$parcel$export(module.exports, "isRootDepth", () => $45a5bdab6e13981e$export$6bb8bb5846dfcbbf);
$parcel$export(module.exports, "isCreateBeforeItem", () => $45a5bdab6e13981e$export$f914dd0333de5d26);
$parcel$export(module.exports, "isCreateInsideItem", () => $45a5bdab6e13981e$export$193d1b66e1b4992a);

var $gf0vG = parcelRequire("gf0vG");

var $2nzpw = parcelRequire("2nzpw");
const $45a5bdab6e13981e$export$aebc411043116683 = (level)=>level === (0, $2nzpw.TIMELINE_SUBTASK_HIERARCHY_LEVEL);
const $45a5bdab6e13981e$export$6bb8bb5846dfcbbf = (depth)=>depth === (0, $2nzpw.TIMELINE_ROOT_DEPTH);
const $45a5bdab6e13981e$export$f914dd0333de5d26 = (createItemAnchor, id)=>createItemAnchor && createItemAnchor.position === (0, $gf0vG.BEFORE) && createItemAnchor.beforeId === id;
const $45a5bdab6e13981e$export$193d1b66e1b4992a = (createItemAnchor, id)=>createItemAnchor && createItemAnchor.position === (0, $gf0vG.INSIDE) && createItemAnchor.parentId === id;

});


parcelRegister("lj2Mb", function(module, exports) {

$parcel$export(module.exports, "transformDates", () => $26fc58a33a58a3e0$export$5501ec26d974b092);

var $6wqPF = parcelRequire("6wqPF");
var $f9KE2 = parcelRequire("f9KE2");
var $3jYzf = parcelRequire("3jYzf");
var $9FEvp = parcelRequire("9FEvp");

var $bbmZl = parcelRequire("bbmZl");
var $h0vyZ = parcelRequire("h0vyZ");
const $26fc58a33a58a3e0$export$b7c7dc1344e0909e = (startDate, dueDate)=>{
    if (startDate !== undefined && dueDate !== undefined) return startDate > dueDate;
    return false;
};
const $26fc58a33a58a3e0$export$5501ec26d974b092 = ({ startDate: startDate, dueDate: dueDate })=>{
    if (startDate !== undefined && dueDate !== undefined) return {
        startDate: startDate,
        dueDate: dueDate
    };
    if (startDate !== undefined) // No due date - default to showing the due date one week after the start date
    return {
        startDate: startDate,
        dueDate: (0, $f9KE2.default)((0, $h0vyZ.default)((0, $3jYzf.default)((0, $6wqPF.default)((0, $bbmZl.default)(new Date(startDate), 'utc'), 7)), 'utc'))
    };
    if (dueDate !== undefined) // No start date - default to showing the start date once week before the due date
    return {
        startDate: (0, $f9KE2.default)((0, $h0vyZ.default)((0, $3jYzf.default)((0, $9FEvp.default)((0, $bbmZl.default)(new Date(dueDate), 'utc'), 7)), 'utc')),
        dueDate: dueDate
    };
    return {
        startDate: startDate,
        dueDate: dueDate
    };
};

});



parcelRegister("6plCc", function(module, exports) {

$parcel$export(module.exports, "useUpdateItem", () => $760d5d0545eac358$export$9e926802efff7290);

var $eUqFw = parcelRequire("eUqFw");

var $lT4mK = parcelRequire("lT4mK");

var $4G5xU = parcelRequire("4G5xU");

var $1ybV0 = parcelRequire("1ybV0");

var $JRB5w = parcelRequire("JRB5w");
var $7byHA = parcelRequire("7byHA");

var $k8Qyf = parcelRequire("k8Qyf");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $fD1Hq = parcelRequire("fD1Hq");

var $2nzpw = parcelRequire("2nzpw");

var $2luad = parcelRequire("2luad");

var $eTH8y = parcelRequire("eTH8y");

var $kO3mo = parcelRequire("kO3mo");

var $dUN1d = parcelRequire("dUN1d");

var $j8CuA = parcelRequire("j8CuA");
const $760d5d0545eac358$export$9e926802efff7290 = ({ issuesMap: issuesMap, updateItemsInCache: updateItemsInCache, childrenQueryData: childrenQueryData })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagService)();
    const lockIssue = (0, $kO3mo.useLockIssue)();
    const [{ timelineDuration: timelineDuration }] = (0, $eTH8y.useTimelineUI)();
    const { onScheduleItem: onScheduleItem, onScheduleItems: onScheduleItems } = (0, $2luad.useScheduleItem)();
    const { data: startDateField } = (0, $fD1Hq.useStartDateField)();
    const startExperience = (0, $4G5xU.useExperienceStart)((0, $2nzpw.SCHEDULE_ITEM_EXPERIENCE));
    const markExperienceAborted = (0, $4G5xU.useExperienceAbort)((0, $2nzpw.SCHEDULE_ITEM_EXPERIENCE));
    const markExperienceSuccess = (0, $4G5xU.useExperienceSuccess)((0, $2nzpw.SCHEDULE_ITEM_EXPERIENCE));
    const markExperienceFailed = (0, $4G5xU.useExperienceFail)((0, $2nzpw.SCHEDULE_ITEM_EXPERIENCE));
    // Callback for the result of a drag and drop operation on an item
    const onItemUpdate = (0, $eUqFw.useCallback)((id, param)=>{
        const issue = issuesMap.get(id);
        if (!issue || !param.dates) return;
        const { dates: dates } = param;
        const startDate = dates?.startDate != null ? (0, $j8CuA.toISOString)(dates.startDate) : null;
        const dueDate = dates?.dueDate != null ? (0, $j8CuA.toISOString)(dates.dueDate) : null;
        if (!startDate && !dueDate) // no dates? no problem: do nothing!
        return;
        const issueStartDate = issue.startDate != null ? (0, $j8CuA.toISOString)(issue.startDate) : null;
        const issueDueDate = issue.dueDate != null ? (0, $j8CuA.toISOString)(issue.dueDate) : null;
        // temporarily lock the issue to prevent updates coming in from realtime updates
        lockIssue(Number(id));
        const updateItemsInCacheList = [];
        if ((0, $1ybV0.ff)('jwm.visual-hierarchy-milestone-1')) updateItemsInCacheList.push({
            bulkUpdates: [
                {
                    id: id,
                    fields: {
                        startDate: startDate,
                        dueDate: dueDate
                    }
                }
            ],
            originalValues: [
                {
                    id: id,
                    fields: {
                        startDate: issueStartDate,
                        dueDate: issueDueDate
                    }
                }
            ]
        });
        else updateItemsInCache([
            {
                id: id,
                fields: {
                    startDate: startDate,
                    dueDate: dueDate
                }
            }
        ]);
        let childrenOriginalValues = [];
        const shouldScheduleChildren = (0, $j8CuA.shouldScheduleChildrenIssues)({
            issue: issue,
            modifiedDates: dates
        });
        if (shouldScheduleChildren) {
            if ((0, $1ybV0.ff)('jwm.visual-hierarchy-milestone-1')) {
                const populateChildUpdates = (parentIssueId)=>{
                    const childrenOnCache = childrenQueryData[parentIssueId]?.data?.issues;
                    if (childrenOnCache) {
                        const { bulkUpdates: bulkUpdates, originalValues: originalValues } = (0, $j8CuA.getIssuesBulkDatesUpdate)({
                            issue: issue,
                            issueChildren: childrenOnCache,
                            dates: dates,
                            timelineDuration: timelineDuration
                        });
                        updateItemsInCacheList.push({
                            bulkUpdates: bulkUpdates,
                            originalValues: originalValues
                        });
                        childrenOnCache.forEach((child)=>populateChildUpdates(child.issueId));
                    }
                };
                populateChildUpdates(id);
            } else {
                const childrenOnCache = childrenQueryData[id]?.data?.issues;
                if (childrenOnCache) {
                    const { bulkUpdates: bulkUpdates, originalValues: originalValues } = (0, $j8CuA.getIssuesBulkDatesUpdate)({
                        issue: issue,
                        issueChildren: childrenOnCache,
                        dates: dates,
                        timelineDuration: timelineDuration
                    });
                    if (bulkUpdates.length) {
                        updateItemsInCache(bulkUpdates);
                        childrenOriginalValues = originalValues;
                    }
                }
            }
        }
        if ((0, $1ybV0.ff)('jwm.visual-hierarchy-milestone-1')) updateItemsInCacheList.forEach(({ bulkUpdates: bulkUpdates })=>{
            if (bulkUpdates.length) updateItemsInCache(bulkUpdates);
        });
        const rollbackUpdates = ()=>{
            if ((0, $1ybV0.ff)('jwm.visual-hierarchy-milestone-1')) updateItemsInCacheList.forEach(({ originalValues: originalValues })=>{
                if (originalValues.length) updateItemsInCache(originalValues);
            });
            else {
                if (childrenOriginalValues.length) updateItemsInCache(childrenOriginalValues);
                updateItemsInCache([
                    {
                        id: id,
                        fields: {
                            startDate: issueStartDate,
                            dueDate: issueDueDate
                        }
                    }
                ]);
            }
        };
        // There are two kind of operations when the user set the start and due date on the same time
        // The user can SET new due and start date just clicking on the timeline
        // or de user can DRAG along and update both dates
        // For now we can detect the operation DRAG if the user has defined previusly start or due date
        // once we implement rollup dates, the user can drag just without any dates.
        // TODO: JET-3804 revisit condition once rollup dates is implemented.
        const isDragOperation = startDate != null && dueDate != null && (issueStartDate != null || issueDueDate != null);
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'itemDates updated', {
            startDate: startDate,
            dueDate: dueDate,
            shouldScheduleChildren: shouldScheduleChildren
        });
        startExperience();
        if ((0, $1ybV0.ff)('jwm.visual-hierarchy-milestone-1')) {
            // TODO: HRZ-917 replace the following once the backend api that updates the descendant items is implemented.
            // The following is a temporary workaround to update item and descendant issues
            let isParentItemSuccessfullyUpdated = false;
            const batchUpdateDescendants = async (descendants)=>{
                while(descendants.length > 0){
                    const batch = descendants.splice(0, (0, $dUN1d.DESCENDANTS_UPDATE_BATCH_SIZE));
                    if (batch.length) {
                        // eslint-disable-next-line no-await-in-loop -- items are already batched and concurrently processed. we need to wait for the batch to finish.
                        const isSuccessful = await onScheduleItems(batch, isDragOperation);
                        if (!isSuccessful) break;
                    }
                }
            };
            const updateAllItems = async ()=>{
                const [_, ...descendantUpdateFields] = updateItemsInCacheList.flatMap((item)=>item.bulkUpdates);
                const descendantIssueIds = descendantUpdateFields.map((field)=>field.id);
                const success = await onScheduleItem({
                    issueId: id,
                    isDragOperation: isDragOperation,
                    ...dates
                }, descendantIssueIds);
                if (success) {
                    isParentItemSuccessfullyUpdated = true;
                    await batchUpdateDescendants(descendantUpdateFields);
                }
                return success;
            };
            const onComplete = ()=>{
                markExperienceSuccess();
                (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'scheduleItem success', {
                    issueId: id,
                    startDate: startDate,
                    dueDate: dueDate
                });
                if (!isParentItemSuccessfullyUpdated) {
                    showFlag((0, $dUN1d.SCHEDULE_ITEM_FAIL_FLAG));
                    rollbackUpdates();
                }
            };
            const onError = (err)=>{
                if (err instanceof (0, $lT4mK.AbortError)) {
                    markExperienceAborted(err.message || 'scheduleItem aborted');
                    (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'scheduleItem aborted', {
                        error: err,
                        startDate: startDate,
                        dueDate: dueDate
                    });
                    return;
                }
                if ('statusCode' in err && err.statusCode === 404) {
                    showFlag((0, $dUN1d.SCHEDULE_ITEM_NOT_FOUND));
                    return;
                }
                // Exclude client fetch, validation and 4xx errors from experience fail events reporting
                if ((0, $JRB5w.isClientFetchError)(err) || (0, $7byHA.isValidationError)(err) || (0, $JRB5w.isHttpClientErrorResponse)(err)) markExperienceSuccess();
                else markExperienceFailed('schedule item failed', err);
                (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'scheduleItem failed', {
                    error: err,
                    startDate: startDate,
                    dueDate: dueDate
                });
                showFlag((0, $dUN1d.SCHEDULE_ITEM_FAIL_FLAG));
                if ((0, $1ybV0.ff)('jwm-schedule-timeline-update-all-descendants-on-drag-operation_v39wp')) rollbackUpdates();
                else if (!isParentItemSuccessfullyUpdated) rollbackUpdates();
            };
            const finalise = ()=>{
                if (startDate != null && !startDateField) showFlag((0, $dUN1d.START_DATE_MISSING_FLAG));
            };
            if ((0, $1ybV0.ff)('jwm-schedule-timeline-update-all-descendants-on-drag-operation_v39wp')) onScheduleItem({
                issueId: id,
                isDragOperation: isDragOperation,
                ...dates
            }).then((success)=>{
                if (success === true) isParentItemSuccessfullyUpdated = true;
                onComplete();
            }).catch(onError).finally(finalise);
            else updateAllItems().then(onComplete).catch(onError).finally(finalise);
        } else onScheduleItem({
            issueId: id,
            isDragOperation: isDragOperation,
            ...dates
        }).then(()=>{
            markExperienceSuccess();
            (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'scheduleItem success', {
                issueId: id,
                startDate: startDate,
                dueDate: dueDate
            });
        }).catch((err)=>{
            if (err?.statusCode === 404) {
                showFlag((0, $dUN1d.SCHEDULE_ITEM_NOT_FOUND));
                return;
            }
            // Exclude client fetch, validation and 4xx errors from experience fail events reporting
            if (err && ((0, $JRB5w.isClientFetchError)(err) || (0, $7byHA.isValidationError)(err) || (0, $JRB5w.isHttpClientErrorResponse)(err))) markExperienceSuccess();
            else markExperienceFailed('schedule item failed', err);
            (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'scheduleItem failed', {
                error: err,
                startDate: startDate,
                dueDate: dueDate
            });
            showFlag((0, $dUN1d.SCHEDULE_ITEM_FAIL_FLAG));
            rollbackUpdates();
        }).finally(()=>{
            if (startDate != null && !startDateField) showFlag((0, $dUN1d.START_DATE_MISSING_FLAG));
        });
    }, [
        issuesMap,
        lockIssue,
        createAnalyticsEvent,
        startExperience,
        updateItemsInCache,
        childrenQueryData,
        timelineDuration,
        onScheduleItems,
        onScheduleItem,
        markExperienceSuccess,
        showFlag,
        markExperienceAborted,
        markExperienceFailed,
        startDateField
    ]);
    return {
        onItemUpdate: onItemUpdate
    };
};

});
parcelRegister("2luad", function(module, exports) {

$parcel$export(module.exports, "useScheduleItem", () => $a906362125620c1d$export$62e208b89a8c71ad);

var $eUqFw = parcelRequire("eUqFw");

var $bnlpg = parcelRequire("bnlpg");

var $iZuDo = parcelRequire("iZuDo");

var $EN9B6 = parcelRequire("EN9B6");

var $3xcI8 = parcelRequire("3xcI8");

var $lT4mK = parcelRequire("lT4mK");
var $kkYfO = parcelRequire("kkYfO");

var $guiFP = parcelRequire("guiFP");

var $1ybV0 = parcelRequire("1ybV0");

var $7byHA = parcelRequire("7byHA");

var $6BYzZ = parcelRequire("6BYzZ");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $fD1Hq = parcelRequire("fD1Hq");

var $dWLk9 = parcelRequire("dWLk9");

var $4mu2r = parcelRequire("4mu2r");
const $a906362125620c1d$var$DATE_FORMAT = 'dd/MMM/yyyy';
const $a906362125620c1d$var$QUERY_NAME = 'scheduleTimelineJwmItem';
const $a906362125620c1d$var$mapDateToValidDateVariable = (date)=>{
    const mappedDate = (0, $6BYzZ.DateOnly).fromDateAccordingToUTC(new Date(date)).toISOString();
    return (0, $EN9B6.default)((0, $3xcI8.default)(mappedDate), $a906362125620c1d$var$DATE_FORMAT);
};
class $a906362125620c1d$export$78c95b58762d2106 extends (0, $7byHA.ValidationError) {
    constructor(){
        super('Issue not found');
    }
}
const $a906362125620c1d$export$62e208b89a8c71ad = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const cloudId = (0, $dWLk9.useCloudId)();
    const { data: startDateField } = (0, $fD1Hq.useStartDateField)();
    const abortController = (0, $eUqFw.useRef)(new AbortController());
    // TODO: Remove during `jwm-schedule-timeline-update-all-descendants-on-drag-operation_v39wp` ff cleanup
    const abortControllerMapRef = (0, $eUqFw.useRef)(new Map());
    const doFireErrorAnalytics = (error)=>{
        (0, $guiFP.default)({
            meta: {
                id: $a906362125620c1d$var$QUERY_NAME,
                packageName: 'jiraBusinessTimeline',
                teamName: 'jira-yurree'
            },
            error: Array.isArray(error) ? error[0] : error,
            attributes: {
                message: 'Failed to schedule item'
            },
            sendToPrivacyUnsafeSplunk: true
        });
    };
    const [scheduleItem] = (0, $iZuDo.useMutation)((0, $4mu2r.SCHEDULE_TIMELINE_ITEM_MUTATION), {
        onError: (apolloError)=>{
            if ((0, $1ybV0.ff)('jwm.visual-hierarchy-milestone-1') && (0, $lT4mK.isAbortError)(apolloError.networkError)) throw apolloError.networkError;
            const firstError = (0, (/*@__PURE__*/$parcel$interopDefault($bnlpg)))(apolloError?.graphQLErrors);
            const errorCode = firstError?.extensions?.statusCode;
            if ((0, $1ybV0.ff)('jwm.filter-4xx-from-timeline-schedule-issue') && errorCode >= 500) doFireErrorAnalytics(apolloError);
            else if (!(0, $1ybV0.ff)('jwm.filter-4xx-from-timeline-schedule-issue')) doFireErrorAnalytics(apolloError);
            throw new (0, $7byHA.default)(errorCode || 500, firstError?.message || 'Timeline schedule item mutation returned an error');
        },
        onCompleted: (onCompletedData)=>{
            (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), `${$a906362125620c1d$var$QUERY_NAME} succeeded`, {});
            if (onCompletedData.scheduleTimelineJwmItem?.errors?.length) doFireErrorAnalytics(onCompletedData.scheduleTimelineJwmItem.errors.map((e)=>new (0, $kkYfO.MutationError)({
                    message: e.message
                })));
            else if (onCompletedData?.scheduleTimelineJwmItem?.success === false) doFireErrorAnalytics([
                new (0, $kkYfO.MutationError)({
                    message: 'Success mutation value as false without error'
                })
            ]);
        }
    });
    const initialiseAbortController = (0, $eUqFw.useCallback)((id)=>{
        const localAbortController = new AbortController();
        abortControllerMapRef.current.set(id, localAbortController);
        return localAbortController;
    }, []);
    const abortExistingControllers = (0, $eUqFw.useCallback)((issueIds)=>{
        issueIds.forEach((issueId)=>{
            const controller = abortControllerMapRef.current.get(issueId);
            if (controller) {
                controller.abort(new (0, $lT4mK.AbortError)((0, $lT4mK.DEFAULT_ABORT_ERROR_MESSAGE)));
                abortControllerMapRef.current.delete(issueId);
            }
        });
    }, []);
    /**
	 * This function is used to schedule multiple items at once. It takes an array of `UpdateIssueField` objects and a boolean indicating whether the operation is a drag operation.
	 * Each `UpdateIssueField` object should contain the issue ID and the new start and due dates.
	 * The function will return a promise that resolves to a boolean indicating the success of the operation.
	 *
	 * Note: This function will be removed during the cleanup of the `jwm-schedule-timeline-update-all-descendants-on-drag-operation_v39wp` feature flag.
	 *
	 * @param updateIssueFields - An array of objects, each containing the issue ID and the new start and due dates.
	 * @param isDragOperation - A boolean indicating whether the operation is a drag operation.
	 * @returns A promise that resolves to a boolean indicating the success of the operation.
	 */ const onScheduleItems = (0, $eUqFw.useCallback)(async (updateIssueFields, isDragOperation)=>{
        const mutationPromises = updateIssueFields.map((item)=>{
            const localAbortController = initialiseAbortController(item.id);
            const variables = {
                input: {
                    issueId: `ari:cloud:jira:${cloudId}:issue/${item.id}`,
                    operation: isDragOperation ? 'DRAG' : 'SET',
                    ...item.fields.startDate != null && startDateField?.id ? {
                        startDate: {
                            fieldId: startDateField.id,
                            date: {
                                formattedDate: $a906362125620c1d$var$mapDateToValidDateVariable(item.fields.startDate)
                            }
                        }
                    } : {},
                    ...item.fields.dueDate != null ? {
                        dueDate: {
                            fieldId: 'duedate',
                            date: {
                                formattedDate: $a906362125620c1d$var$mapDateToValidDateVariable(item.fields.dueDate)
                            }
                        }
                    } : {}
                }
            };
            return scheduleItem({
                variables: // @ts-expect-error - TS2305 -  Type 'string' is not assignable to type 'JWMScheduleTimelineItemOperation'.
                variables,
                context: {
                    fetchOptions: {
                        signal: localAbortController.signal
                    }
                }
            });
        });
        const results = await Promise.allSettled(mutationPromises);
        const { aborted: aborted, success: success, errorMessage: errorMessage } = results.reduce((acc, result)=>{
            if (result.status === 'rejected') {
                acc.errorMessage = result.reason instanceof Error ? result.reason.message : result.reason;
                if (!acc.aborted) acc.aborted = result.reason instanceof (0, $lT4mK.AbortError);
                acc.success = false;
            } else {
                const error = (0, (/*@__PURE__*/$parcel$interopDefault($bnlpg)))(result.value.data?.scheduleTimelineJwmItem?.errors);
                const isSuccessful = Boolean(result.value?.data?.scheduleTimelineJwmItem?.success);
                if (error || !isSuccessful) {
                    acc.errorMessage = error?.message || 'Timeline schedule item mutation result data included an error or success was not true';
                    acc.success = false;
                }
            }
            return acc;
        }, {
            aborted: false,
            success: true,
            errorMessage: null
        });
        if (!success && !aborted) throw new Error(errorMessage || 'Timeline schedule item mutation result data included an error or success was not true');
        return success && !aborted;
    }, [
        initialiseAbortController,
        cloudId,
        startDateField,
        scheduleItem
    ]);
    const onScheduleItem = (0, $eUqFw.useCallback)(({ issueId: issueId, startDate: startDate, dueDate: dueDate, isDragOperation: isDragOperation }, descendantIssueIds = [])=>{
        if ((0, $1ybV0.ff)('jwm-schedule-timeline-update-all-descendants-on-drag-operation_v39wp')) {
            abortController.current.abort(new (0, $lT4mK.AbortError)((0, $lT4mK.DEFAULT_ABORT_ERROR_MESSAGE)));
            abortController.current = new AbortController();
        } else if ((0, $1ybV0.ff)('jwm.visual-hierarchy-milestone-1')) abortExistingControllers([
            issueId,
            ...descendantIssueIds
        ]);
        const variables = {
            input: {
                issueId: `ari:cloud:jira:${cloudId}:issue/${issueId}`,
                operation: isDragOperation ? 'DRAG' : 'SET',
                ...startDate != null && startDateField?.id ? {
                    startDate: {
                        fieldId: startDateField.id,
                        date: {
                            formattedDate: $a906362125620c1d$var$mapDateToValidDateVariable(startDate)
                        }
                    }
                } : {},
                ...dueDate != null ? {
                    dueDate: {
                        fieldId: 'duedate',
                        date: {
                            formattedDate: $a906362125620c1d$var$mapDateToValidDateVariable(dueDate)
                        }
                    }
                } : {}
            }
        };
        return scheduleItem({
            variables: // @ts-expect-error - TS2305 -  Type 'string' is not assignable to type 'JWMScheduleTimelineItemOperation'.
            variables,
            ...(0, $1ybV0.ff)('jwm.visual-hierarchy-milestone-1') ? {
                context: {
                    fetchOptions: {
                        signal: (0, $1ybV0.ff)('jwm-schedule-timeline-update-all-descendants-on-drag-operation_v39wp') ? abortController.current.signal : initialiseAbortController(issueId).signal
                    }
                }
            } : {}
        }).then((result)=>{
            const error = (0, (/*@__PURE__*/$parcel$interopDefault($bnlpg)))(result?.data?.scheduleTimelineJwmItem?.errors);
            if (error || result?.data?.scheduleTimelineJwmItem?.success !== true) throw new Error(error?.message || 'Timeline schedule item mutation result data included an error or success was not true');
            return result?.data?.scheduleTimelineJwmItem?.success;
        });
    }, [
        cloudId,
        startDateField,
        scheduleItem,
        initialiseAbortController,
        abortExistingControllers
    ]);
    return {
        onScheduleItem: onScheduleItem,
        onScheduleItems: onScheduleItems
    };
};

});
parcelRegister("bnlpg", function(module, exports) {

module.exports = (parcelRequire("jtpa0"));

});
parcelRegister("jtpa0", function(module, exports) {
/**
 * Gets the first element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias first
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the first element of `array`.
 * @example
 *
 * _.head([1, 2, 3]);
 * // => 1
 *
 * _.head([]);
 * // => undefined
 */ function $e2d43e13ed703ec3$var$head(array) {
    return array && array.length ? array[0] : undefined;
}
module.exports = $e2d43e13ed703ec3$var$head;

});


parcelRegister("4mu2r", function(module, exports) {

$parcel$export(module.exports, "SCHEDULE_TIMELINE_ITEM_MUTATION", () => $0093e64484a33c2b$export$31219886be2a5896);

var $9ypom = parcelRequire("9ypom");
const $0093e64484a33c2b$export$31219886be2a5896 = (0, $9ypom.default)`
    mutation ScheduleTimelineJwmItem($input: JWMScheduleTimelineItemInput!) {
        scheduleTimelineJwmItem(input: $input) {
            success
            errors {
                message
                extensions {
                    statusCode
                    errorType
                }
            }
        }
    }
`;

});


parcelRegister("dUN1d", function(module, exports) {

$parcel$export(module.exports, "START_DATE_MISSING_FLAG", () => $89f400498c2c2adb$export$c4d0266ea6d22734);
$parcel$export(module.exports, "SCHEDULE_ITEM_FAIL_FLAG", () => $89f400498c2c2adb$export$56d33b992984cd75);
$parcel$export(module.exports, "SCHEDULE_ITEM_NOT_FOUND", () => $89f400498c2c2adb$export$2e974dce72b69a83);
$parcel$export(module.exports, "DESCENDANTS_UPDATE_BATCH_SIZE", () => $89f400498c2c2adb$export$dd6e38a0f11b5591);

var $2gp9u = parcelRequire("2gp9u");
const $89f400498c2c2adb$export$c4d0266ea6d22734 = {
    type: 'error',
    title: (0, $2gp9u.default).startDateMissingErrorTitle,
    description: (0, $2gp9u.default).startDateMissingErrorMessage
};
const $89f400498c2c2adb$export$56d33b992984cd75 = {
    type: 'error',
    title: (0, $2gp9u.default).scheduleItemErrorTitle,
    description: (0, $2gp9u.default).scheduleItemErrorDescription
};
const $89f400498c2c2adb$export$2e974dce72b69a83 = {
    type: 'error',
    title: (0, $2gp9u.default).scheduleItemNotFound,
    description: (0, $2gp9u.default).scheduleItemRemoved
};
const $89f400498c2c2adb$export$dd6e38a0f11b5591 = 10;

});
parcelRegister("2gp9u", function(module, exports) {

$parcel$export(module.exports, "default", () => $b2032cdff0f01ff7$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $b2032cdff0f01ff7$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    startDateMissingErrorTitle: {
        "id": "business-timeline.controllers.update-item.start-date-missing-error-title",
        "defaultMessage": "We couldn't save the item"
    },
    startDateMissingErrorMessage: {
        "id": "business-timeline.controllers.update-item.start-date-missing-error-message",
        "defaultMessage": "Field 'Start date' cannot be set. It is not on the appropriate screen."
    },
    scheduleItemErrorTitle: {
        "id": "business-timeline.controllers.update-item.schedule-item-error-title",
        "defaultMessage": "Something's gone wrong"
    },
    scheduleItemErrorDescription: {
        "id": "business-timeline.controllers.update-item.schedule-item-error-description",
        "defaultMessage": "Refresh the page and try again."
    },
    scheduleItemNotFound: {
        "id": "business-timeline.controllers.update-item.schedule-item-not-found",
        "defaultMessage": "Issue not found"
    },
    scheduleItemRemoved: {
        "id": "business-timeline.controllers.update-item.schedule-item-removed",
        "defaultMessage": "Looks like this issue has been removed."
    }
});

});


parcelRegister("j8CuA", function(module, exports) {

$parcel$export(module.exports, "toISOString", () => $cce2148c2882e00b$export$dfaaa8705752128f);
$parcel$export(module.exports, "shouldScheduleChildrenIssues", () => $cce2148c2882e00b$export$f98ee0b182e34597);
$parcel$export(module.exports, "getIssuesBulkDatesUpdate", () => $cce2148c2882e00b$export$6fad4cd647ef6c8c);

var $6BYzZ = parcelRequire("6BYzZ");
const $cce2148c2882e00b$export$dfaaa8705752128f = (timestamp)=>(0, $6BYzZ.DateOnly).fromDateAccordingToUTC(new Date(timestamp)).toISOString();
const $cce2148c2882e00b$export$f98ee0b182e34597 = ({ issue: issue, modifiedDates: { startDate: startDate, dueDate: dueDate } })=>{
    /**
	 * When the issue is a parent
	 * When parent bar is dragged (i.e. both start and due dates are updated), then child bars also dragged together.
	 * When parent bar is resized (i.e. only one of start of due dates are updated), then child bars are unaffected.
	 */ const { startDate: oldStartDate, dueDate: oldDueDate, hasChildren: hasChildren } = issue;
    const isBothDatesPopulated = startDate !== undefined && dueDate !== undefined;
    const isBothDatesUpdated = startDate !== oldStartDate && dueDate !== oldDueDate;
    return hasChildren && isBothDatesPopulated && isBothDatesUpdated;
};
const $cce2148c2882e00b$export$1f04624003d2da7d = 86400000;
const $cce2148c2882e00b$export$28c98c2c1f9d90de = $cce2148c2882e00b$export$1f04624003d2da7d - 1;
const $cce2148c2882e00b$var$LEFT = 'LEFT';
const $cce2148c2882e00b$var$RIGHT = 'RIGHT';
const $cce2148c2882e00b$export$a43c8446bad60ee = ({ startDate: startDate, dueDate: dueDate, timelineDuration: timelineDuration, offset: offset })=>{
    const direction = offset < 0 ? $cce2148c2882e00b$var$LEFT : $cce2148c2882e00b$var$RIGHT;
    const { startMilliseconds: startMilliseconds, endMilliseconds: endMilliseconds } = timelineDuration;
    let newOffset = offset;
    if (direction === $cce2148c2882e00b$var$LEFT && startDate !== undefined) {
        const maxLeftOffset = -Math.max(0, startDate - startMilliseconds);
        newOffset = Math.max(maxLeftOffset, offset);
    } else if (direction === $cce2148c2882e00b$var$RIGHT && dueDate !== undefined) {
        const maxRightOffset = Math.max(0, endMilliseconds - dueDate - $cce2148c2882e00b$export$28c98c2c1f9d90de);
        newOffset = Math.min(maxRightOffset, offset);
    }
    const newStartDate = startDate !== undefined ? startDate + newOffset : undefined;
    const newDueDate = dueDate !== undefined ? dueDate + newOffset : undefined;
    return {
        startDate: newStartDate,
        dueDate: newDueDate
    };
};
const $cce2148c2882e00b$export$6fad4cd647ef6c8c = ({ issue: issue, issueChildren: issueChildren, dates: { startDate: startDate, dueDate: dueDate }, timelineDuration: timelineDuration })=>{
    const bulkUpdates = [];
    const originalValues = [];
    if (issueChildren.length && startDate !== undefined && dueDate !== undefined) {
        let offset = 0;
        const oldStartDate = issue.startDate ?? null;
        const oldDueDate = issue.dueDate ?? null;
        if (oldStartDate != null) offset = startDate - oldStartDate;
        else if (oldDueDate != null) offset = dueDate - oldDueDate;
        if (offset) issueChildren.forEach((issueChild)=>{
            const { startDate: childStartDate, dueDate: childDueDate } = issueChild;
            const { startDate: safeStartDate, dueDate: safeDueDate } = $cce2148c2882e00b$export$a43c8446bad60ee({
                startDate: childStartDate,
                dueDate: childDueDate,
                timelineDuration: timelineDuration,
                offset: offset
            });
            const newStartDate = safeStartDate != null ? $cce2148c2882e00b$export$dfaaa8705752128f(safeStartDate) : null;
            const newDueDate = safeDueDate != null ? $cce2148c2882e00b$export$dfaaa8705752128f(safeDueDate) : null;
            // Exclude issue if the dates have no changes
            if (childStartDate !== safeStartDate || childDueDate !== safeDueDate) {
                originalValues.push({
                    id: issueChild.issueId,
                    fields: {
                        startDate: childStartDate ? $cce2148c2882e00b$export$dfaaa8705752128f(childStartDate) : null,
                        dueDate: childDueDate ? $cce2148c2882e00b$export$dfaaa8705752128f(childDueDate) : null
                    }
                });
                bulkUpdates.push({
                    id: issueChild.issueId,
                    fields: {
                        startDate: newStartDate,
                        dueDate: newDueDate
                    }
                });
            }
        });
    }
    return {
        bulkUpdates: bulkUpdates,
        originalValues: originalValues
    };
};

});


parcelRegister("ixHL5", function(module, exports) {

$parcel$export(module.exports, "useIntersectionObserver", () => $cb95c0ae4b9b6a74$export$a7395f9832c00176);

var $eUqFw = parcelRequire("eUqFw");
const $cb95c0ae4b9b6a74$export$a7395f9832c00176 = (onIntersection)=>{
    const [ref, setRef] = (0, $eUqFw.useState)(null);
    const handleObserver = (0, $eUqFw.useCallback)((entries)=>{
        entries.forEach(({ isIntersecting: isIntersecting })=>{
            if (isIntersecting) onIntersection();
        });
    }, [
        onIntersection
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (!ref || false) return undefined;
        const observer = new IntersectionObserver(handleObserver, {
            root: null,
            rootMargin: '20px',
            threshold: 0
        });
        if (ref) observer.observe(ref);
        return ()=>{
            observer.disconnect();
        };
    }, [
        ref,
        onIntersection,
        handleObserver
    ]);
    return setRef;
};

});

parcelRegister("2ElAN", function(module, exports) {

$parcel$export(module.exports, "ChartItemContent", () => $ac5055ddf16666e2$export$ef51232970f03d8e);

var $eUqFw = parcelRequire("eUqFw");

var $ltfxy = parcelRequire("ltfxy");

var $7Sz8O = parcelRequire("7Sz8O");

var $kkACl = parcelRequire("kkACl");

var $1ybV0 = parcelRequire("1ybV0");

var $6vrw7 = parcelRequire("6vrw7");

var $kbiEp = parcelRequire("kbiEp");

var $3XwA1 = parcelRequire("3XwA1");
var $6TBpb = parcelRequire("6TBpb");

var $fHtBB = parcelRequire("fHtBB");
var $cww1R = parcelRequire("cww1R");
var $ezynO = parcelRequire("ezynO");


var $6ELMa = parcelRequire("6ELMa");

var $aRSCW = parcelRequire("aRSCW");

var $PFCIp = parcelRequire("PFCIp");

var $203kY = parcelRequire("203kY");

var $390co = parcelRequire("390co");

var $jlF1Y = parcelRequire("jlF1Y");
const $ac5055ddf16666e2$var$DndLongTaskMetricComponent = ({ level: level, isDragging: isDragging })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6ELMa.DndLongTaskMetric), {
        isDragging: isDragging,
        metricType: (0, $028d5637f56fe710$export$2475592765cae5b0),
        extraProps: {
            isBaseLevel: (0, $kbiEp.isBaseLevel)(level)
        }
    });
const $ac5055ddf16666e2$export$ef51232970f03d8e = /*#__PURE__*/ (0, $eUqFw.memo)((props)=>{
    const { isExportTable: isExportTable, isHovered: isHovered, isReadOnly: isReadOnly, issue: issue, level: level, onItemUpdate: onItemUpdate, placeholder: placeholder, setSelectedIssueKey: setSelectedIssueKey } = props;
    let { dueDate: dueDate, startDate: startDate } = props;
    const warnings = [];
    if ((0, $1ybV0.ff)('timeline-bar-start-date-after-due-date_ddpds') && dueDate !== undefined && startDate !== undefined && dueDate < startDate) {
        warnings.push((0, $jlF1Y.START_DATE_LATER_DUE_DATE_MESSAGE_ID));
        [startDate, dueDate] = [
            dueDate,
            startDate
        ];
    }
    const { status: status, issueId: issueId } = issue;
    const color = (0, $aRSCW.getColor)(status.categoryId);
    const [{ issuesMap: issuesMap }] = (0, $PFCIp.useIssuesMap)();
    const [{ nudgeStep: nudgeStep }] = (0, $kkACl.useNudgeStep)();
    const { requestViewportScrollBounding: requestViewportScrollBounding } = (0, $6TBpb.useViewport)();
    const [{ timelineDuration: timelineDuration, timelineWidth: timelineWidth }] = (0, $3XwA1.useTimelineState)();
    const [shouldRenderTimelineNudge, setShouldRenderTimelineNudge] = (0, $eUqFw.useState)(false);
    const { issueViewInteraction: issueViewInteraction } = (0, $203kY.useTimelineFeatures)();
    const onUpdate = (0, $eUqFw.useCallback)(// @ts-expect-error - TS7006 - Parameter 'id' implicitly has an 'any' type. | TS7006 - Parameter 'param' implicitly has an 'any' type. | TS7006 - Parameter 'analyticEvent' implicitly has an 'any' type.
    (id, param, analyticEvent)=>{
        onItemUpdate((0, $6vrw7.toIssueId)(id), param, analyticEvent);
    }, [
        onItemUpdate
    ]);
    /*
   * We should show timeline dependency nudge only if the following conditions are met:
   * - current bar is first issue and in view
   * - there's at least 2 bars
   * - the current nudge step is DEPENDENCY_HOVER_NUDGE_STEP
   * The following function determines whether we should show it or not based on them
   */ const setShouldRenderHoverNudge = (0, $eUqFw.useCallback)(()=>{
        const viewportBoundingClient = requestViewportScrollBounding();
        if (viewportBoundingClient) {
            const { scrollLeft: scrollLeft, scrollRight: scrollRight } = viewportBoundingClient;
            const [firstItem, secondItem] = Array.from(issuesMap.values());
            const isFirstItem = issueId === firstItem?.issueId;
            const timelineHasTwoBars = issuesMap.size > 1 && firstItem?.startDate != null && firstItem?.dueDate != null && secondItem.startDate != null && secondItem?.dueDate != null;
            let isBarInView = false;
            if (startDate != null && dueDate != null) {
                const leftPosition = (0, $cww1R.getBarLeftPosition)(startDate, timelineDuration, timelineWidth);
                const rightPosition = (0, $cww1R.getBarRightPosition)(dueDate, timelineDuration, timelineWidth);
                const isBarInPast = leftPosition < scrollLeft;
                const isBarInFuture = rightPosition < scrollRight;
                isBarInView = !isBarInPast && !isBarInFuture;
            }
            const shouldRenderHoverNudge = isFirstItem && timelineHasTwoBars && nudgeStep === (0, $62f34a28cfc7189c$export$8537c4b3aa8a0484) && isBarInView;
            setShouldRenderTimelineNudge(shouldRenderHoverNudge);
        }
    }, [
        requestViewportScrollBounding,
        dueDate,
        startDate,
        issueId,
        issuesMap,
        nudgeStep,
        timelineDuration,
        timelineWidth
    ]);
    /*
   * Viewport information is only available after all components are rendered
   * We therefore need to trigger requestViewportScrollBounding a second time after initial render
   * to correctly receive the scroll positions
   * For more information: software/roadmap/timeline-table/src/common/context/viewport/README.md
   */ (0, $eUqFw.useEffect)(()=>{
        setShouldRenderHoverNudge();
    }, [
        setShouldRenderHoverNudge
    ]);
    const leftClickHandler = (0, $eUqFw.useCallback)((_id, meta)=>{
        if (issue.id.startsWith((0, $7Sz8O.OPTIMISTIC_ID_PREFIX))) return;
        if (issueViewInteraction === 'openNewTab' || meta.withCmd || meta.withShift) {
            window.open(`/browse/${issue.key}`, '_blank');
            return;
        }
        setSelectedIssueKey(issue.key);
    }, [
        issue.id,
        issue.key,
        issueViewInteraction,
        setSelectedIssueKey
    ]);
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ezynO.RoadmapChartItemContent), {
        renderBarContent: isExportTable ? undefined : (0, $390co.renderBarContent),
        onUpdate: onUpdate,
        level: level,
        isHovered: isHovered,
        id: issueId,
        color: color,
        startDate: startDate,
        dueDate: dueDate,
        startDateType: (0, $fHtBB.EXPLICIT),
        dueDateType: (0, $fHtBB.EXPLICIT),
        placeholder: placeholder,
        DndLongTaskMetric: $ac5055ddf16666e2$var$DndLongTaskMetricComponent,
        isReadOnly: isReadOnly,
        onLeftClick: leftClickHandler,
        ...(0, $1ybV0.ff)('timeline-bar-start-date-after-due-date_ddpds') && {
            warnings: warnings
        }
    });
    if (shouldRenderTimelineNudge) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ltfxy.default), {
        name: (0, $62f34a28cfc7189c$export$8537c4b3aa8a0484)
    }, content, " ");
    return content;
});

});
const $62f34a28cfc7189c$export$8537c4b3aa8a0484 = 'DEPENDENCY_HOVER_NUDGE_STEP';
const $62f34a28cfc7189c$export$f5cfd1d92acc18fb = 'DEPENDENCY_DETAILS_ICON_NUDGE_STEP';
const $62f34a28cfc7189c$export$48c9cfd6c84a85fe = 'DEPENDENCY_UNLINK_ICON_NUDGE_STEP';

parcelRegister("kkACl", function(module, exports) {

$parcel$export(module.exports, "useNudgeStep", () => $f57252eadb7ca8f8$export$c5e63e44ad178ae8);

var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");

const $f57252eadb7ca8f8$var$actions = {
    setNudgeStep: (nudgeStep)=>({ setState: setState, getState: getState })=>setState({
                ...getState(),
                nudgeStep: nudgeStep
            })
};
// @ts-expect-error - TS2344 - Type '{ readonly setNudgeStep: (nudgeStep: NUDGE_STEP) => ({ setState, getState }: StoreState<State>) => void; }' does not satisfy the constraint 'Record<string, ActionThunk<State, { readonly setNudgeStep: (nudgeStep: NUDGE_STEP) => ({ setState, getState }: StoreState<State>) => void; }>>'.
const $f57252eadb7ca8f8$var$Store = (0, $a61MH.createStore)({
    initialState: {
        nudgeStep: (0, $62f34a28cfc7189c$export$8537c4b3aa8a0484)
    },
    actions: $f57252eadb7ca8f8$var$actions,
    name: 'JWMTimelineNudgeStepStore'
});
const $f57252eadb7ca8f8$export$c5e63e44ad178ae8 = (0, $ggKAj.createHook)($f57252eadb7ca8f8$var$Store);

});

parcelRegister("kbiEp", function(module, exports) {

$parcel$export(module.exports, "BASE_LEVEL", () => $88b3a53c4d7efea4$export$d5993e01b9439be4);
$parcel$export(module.exports, "PARENT_LEVEL", () => $88b3a53c4d7efea4$export$6c5e715ac831956e);
$parcel$export(module.exports, "isBaseLevel", () => $88b3a53c4d7efea4$export$3f3fbf12338c09a4);
const $88b3a53c4d7efea4$export$7f882bb969de14a3 = 0;
const $88b3a53c4d7efea4$export$d5993e01b9439be4 = 0;
const $88b3a53c4d7efea4$export$6c5e715ac831956e = 1;
const $88b3a53c4d7efea4$export$e3140dc7d0c35e48 = (depth)=>depth === $88b3a53c4d7efea4$export$7f882bb969de14a3;
const $88b3a53c4d7efea4$export$3f3fbf12338c09a4 = (level)=>level === $88b3a53c4d7efea4$export$d5993e01b9439be4;
const $88b3a53c4d7efea4$export$dbfe1bb564ec5b98 = (level)=>level === $88b3a53c4d7efea4$export$6c5e715ac831956e;

});

parcelRegister("cww1R", function(module, exports) {

$parcel$export(module.exports, "getBarLeftPosition", () => $5eb2dfac86109cf2$export$7515da295c144459);
$parcel$export(module.exports, "getBarRightPosition", () => $5eb2dfac86109cf2$export$6d1b18b85e7cc7aa);
$parcel$export(module.exports, "getStartDate", () => $5eb2dfac86109cf2$export$3ee8fbdbeceaef0e);
$parcel$export(module.exports, "getDueDate", () => $5eb2dfac86109cf2$export$813ac50a60a492f2);
$parcel$export(module.exports, "getIsBarVisible", () => $5eb2dfac86109cf2$export$4a4fadfd0dbb59d8);


var $1QJt8 = parcelRequire("1QJt8");

var $fHtBB = parcelRequire("fHtBB");
const $5eb2dfac86109cf2$export$7515da295c144459 = (startDate, timelineDuration, timelineWidth)=>(0, $1QJt8.getTimelinePositionFromDate)(timelineDuration, timelineWidth, startDate);
const $5eb2dfac86109cf2$export$6d1b18b85e7cc7aa = (dueDate, timelineDuration, timelineWidth)=>{
    const endOfDueDate = dueDate + (0, $fHtBB.DUE_DATE_OFFSET);
    const leftPosition = (0, $1QJt8.getTimelinePositionFromDate)(timelineDuration, timelineWidth, endOfDueDate);
    return timelineWidth - leftPosition;
};
const $5eb2dfac86109cf2$export$b6b0beaf88b31f31 = (date)=>Math.round(date / (0, $4975412c8fcbfa24$export$1f04624003d2da7d)) * (0, $4975412c8fcbfa24$export$1f04624003d2da7d);
const $5eb2dfac86109cf2$export$3ee8fbdbeceaef0e = (leftPosition, timelineDuration, timelineWidth)=>{
    const startDate = (0, $1QJt8.getDateFromTimelinePosition)(timelineDuration, timelineWidth, leftPosition);
    return $5eb2dfac86109cf2$export$b6b0beaf88b31f31(startDate);
};
const $5eb2dfac86109cf2$export$813ac50a60a492f2 = (rightPosition, timelineDuration, timelineWidth)=>{
    const dueDate = (0, $1QJt8.getDateFromTimelinePosition)(timelineDuration, timelineWidth, timelineWidth - rightPosition) - (0, $fHtBB.DUE_DATE_OFFSET);
    return $5eb2dfac86109cf2$export$b6b0beaf88b31f31(dueDate);
};
const $5eb2dfac86109cf2$export$4a4fadfd0dbb59d8 = (barLeftPosition, barRightPosition, timelineWidth)=>{
    const isBeforeTimeline = barLeftPosition < 0 && barRightPosition >= timelineWidth;
    const isAfterTimeline = barLeftPosition >= timelineWidth && barRightPosition < 0;
    return !isBeforeTimeline && !isAfterTimeline;
};

});

parcelRegister("ezynO", function(module, exports) {

$parcel$export(module.exports, "RoadmapChartItemContent", () => $8eaf7269cfb7e602$export$3b537bb5a0afaee4);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $4P2VV = parcelRequire("4P2VV");
var $fHtBB = parcelRequire("fHtBB");

var $54tWw = parcelRequire("54tWw");

var $9afsD = parcelRequire("9afsD");

var $cxkGw = parcelRequire("cxkGw");
const $8eaf7269cfb7e602$export$3b537bb5a0afaee4 = ({ id: id, startDate: startDate, dueDate: dueDate, color: color, level: level, startDateType: startDateType, dueDateType: dueDateType, placeholder: placeholder, DndLongTaskMetric: DndLongTaskMetric, warnings: warnings, intervals: intervals, isHovered: isHovered, isReadOnly: isReadOnly, onLeftClick: onLeftClick, onRightClick: onRightClick, onUpdate: onUpdate, renderBarContent: renderBarContent })=>{
    if (startDate !== undefined && dueDate !== undefined) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, !isReadOnly && intervals.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9afsD.IntervalDropZones), {
        id: id,
        intervals: intervals
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $54tWw.DateContent), {
        id: id,
        color: color,
        level: level,
        startDate: startDate,
        dueDate: dueDate,
        startDateType: startDateType,
        dueDateType: dueDateType,
        warnings: warnings,
        placeholder: placeholder,
        isHovered: isHovered,
        isReadOnly: isReadOnly,
        onLeftClick: onLeftClick,
        onRightClick: onRightClick,
        onUpdate: onUpdate,
        renderBarContent: renderBarContent,
        DndLongTaskMetric: DndLongTaskMetric
    }));
    return !isReadOnly ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cxkGw.NoDateContent), {
        id: id,
        level: level,
        color: color,
        startDateType: startDateType,
        dueDateType: dueDateType,
        isHovered: isHovered,
        onUpdate: onUpdate
    }, intervals.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9afsD.IntervalDropZones), {
        id: id,
        intervals: intervals,
        onClick: onUpdate
    }))) : null;
};
$8eaf7269cfb7e602$export$3b537bb5a0afaee4.defaultProps = {
    startDateType: (0, $fHtBB.EXPLICIT),
    dueDateType: (0, $fHtBB.EXPLICIT),
    DndLongTaskMetric: ()=>null,
    warnings: [],
    intervals: [],
    isReadOnly: false,
    onLeftClick: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    renderBarContent: (0, $4P2VV.DEFAULT_RENDERER)
};

});
parcelRegister("54tWw", function(module, exports) {

$parcel$export(module.exports, "DateContent", () => $28edd2fb3c147048$export$cede4067c9cec7c9);

var $eUqFw = parcelRequire("eUqFw");

var $3XwA1 = parcelRequire("3XwA1");

var $fHtBB = parcelRequire("fHtBB");

var $7E8Bd = parcelRequire("7E8Bd");

var $cww1R = parcelRequire("cww1R");

var $f2nyx = parcelRequire("f2nyx");

var $i9sDh = parcelRequire("i9sDh");
const $28edd2fb3c147048$export$cede4067c9cec7c9 = ({ id: id, color: color, level: level, startDate: startDate, dueDate: dueDate, startDateType: startDateType, dueDateType: dueDateType, warnings: warnings, placeholder: placeholder, isHovered: isHovered, isReadOnly: isReadOnly, DndLongTaskMetric: DndLongTaskMetric, renderBarContent: renderBarContent, onUpdate: onUpdate, onLeftClick: onLeftClick, onRightClick: onRightClick })=>{
    const [{ timelineDuration: timelineDuration, timelineWidth: timelineWidth }] = (0, $3XwA1.useTimelineState)();
    const barLeftPosition = (0, $cww1R.getBarLeftPosition)(startDate, timelineDuration, timelineWidth);
    const barRightPosition = (0, $cww1R.getBarRightPosition)(dueDate, timelineDuration, timelineWidth);
    const isBarVisible = (0, $cww1R.getIsBarVisible)(barLeftPosition, barRightPosition, timelineWidth);
    if (!isBarVisible) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $f2nyx.RoadmapBar), {
        id: id,
        left: barLeftPosition,
        right: barRightPosition,
        color: color,
        level: level,
        startDateType: startDateType,
        dueDateType: dueDateType,
        warnings: warnings,
        placeholder: placeholder,
        isReadOnly: isReadOnly,
        onUpdate: onUpdate,
        onLeftClick: onLeftClick,
        onRightClick: onRightClick,
        renderBarContent: renderBarContent,
        DndLongTaskMetric: DndLongTaskMetric
    }), isHovered && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $i9sDh.RoadmapNavigateButton), {
        itemMinLeftPosition: barLeftPosition,
        itemMaxRightPosition: barRightPosition,
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7E8Bd.FormattedDate), {
            startDate: startDate,
            startDateType: startDateType,
            dueDate: dueDate,
            dueDateType: dueDateType,
            placeholder: placeholder,
            isDurationVisible: !placeholder
        })
    }));
};
$28edd2fb3c147048$export$cede4067c9cec7c9.defaultProps = {
    startDateType: (0, $fHtBB.EXPLICIT),
    dueDateType: (0, $fHtBB.EXPLICIT)
};

});
parcelRegister("7E8Bd", function(module, exports) {

$parcel$export(module.exports, "FormattedDate", () => $52e07480f3bfdb54$export$40ae3194919d16b);
/* main.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $lfgcv = parcelRequire("lfgcv");

var $fHtBB = parcelRequire("fHtBB");
var $4P2VV = parcelRequire("4P2VV");

var $cERyr = parcelRequire("cERyr");

var $1B9M2 = parcelRequire("1B9M2");

var $8i5Uy = parcelRequire("8i5Uy");

var $etu0n = parcelRequire("etu0n");
/* Combines timestamps into a human readable label that changes based upon the date type (see props).
 * - If a date is not provided it will *not* be rendered.
 * - By providing a placement, the dates will be rendered absolute to either side of their nearest relative ancestor.
 */ const $52e07480f3bfdb54$export$40ae3194919d16b = ({ startDate: startDate, dueDate: dueDate, startDateType: startDateType = (0, $fHtBB.EXPLICIT), dueDateType: dueDateType = (0, $fHtBB.EXPLICIT), placeholder: placeholder, isDurationVisible: isDurationVisible = false, placement: placement, renderDuration: renderDuration })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const startDatePlaceholderMessage = (0, $cERyr.isStartDatePlaceholder)(placeholder) ? formatMessage((0, $etu0n.default).noStartDate) : undefined;
    const dueDatePlaceholderMessage = (0, $cERyr.isDueDatePlaceholder)(placeholder) ? formatMessage((0, $etu0n.default).noDueDate) : undefined; // === RENDER === //
    const renderDurationLabel = (shouldRender = true)=>{
        const isDurationValid = startDate !== undefined || dueDate !== undefined;
        return isDurationVisible && isDurationValid && shouldRender ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, ' ', renderDuration ? renderDuration() : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1B9M2.Duration), {
            fromDate: startDate ?? 0,
            toDate: dueDate ?? 0
        })) : null;
    };
    const renderDate = (dateType, date, placeholderMessage)=>{
        if (date === undefined) return null;
        const DateContainer = (0, $8i5Uy.DATE_CONTAINER_LOOKUP)[dateType];
        const DateIcon = (0, $8i5Uy.DATE_ICON_LOOKUP)[dateType];
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(DateIcon, null), placeholderMessage ?? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(DateContainer, null, (0, $lfgcv.getDateFromTimestamp)(date)));
    };
    if (placement === (0, $4P2VV.LEFT_AND_RIGHT)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("small" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    , {
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _19pkidpf _1p1dangw _o572qvpr _1pby37uc _jr2u1qyh",
            "_kqswstnw",
            "_1xi21osq _u5f3u2gc",
            "notranslate"
        ])
    }, renderDate(startDateType, startDate, startDatePlaceholderMessage), renderDurationLabel(startDate !== undefined && dueDate === undefined)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("small" // eslint-disable-next-line  @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    , {
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _19pkidpf _1p1dangw _o572qvpr _1pby37uc _jr2u1qyh",
            "_kqswstnw",
            "_1ltv1osq _19bvu2gc",
            "notranslate"
        ])
    }, renderDate(dueDateType, dueDate, dueDatePlaceholderMessage), renderDurationLabel(dueDate !== undefined)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("small", {
        "data-testid": "roadmap.timeline-table-kit.common.ui.formatted-date.formatted-date" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        ,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _19pkidpf _1p1dangw _o572qvpr _1pby37uc _jr2u1qyh",
            placement && "_kqswstnw",
            placement === (0, $4P2VV.LEFT) && "_1xi21osq _u5f3u2gc",
            placement === (0, $4P2VV.RIGHT) && "_1ltv1osq _19bvu2gc",
            "notranslate"
        ])
    }, renderDate(startDateType, startDate, startDatePlaceholderMessage), startDate !== undefined && dueDate !== undefined && ' - ', renderDate(dueDateType, dueDate, dueDatePlaceholderMessage), renderDurationLabel());
};
const $52e07480f3bfdb54$var$placemenetLeftStyles = null;
const $52e07480f3bfdb54$var$placemenetRightStyles = null;
const $52e07480f3bfdb54$var$defaultPlacementStyles = null;
const $52e07480f3bfdb54$var$outerContainerStyles = null;

});
parcelRegister("1B9M2", function(module, exports) {

$parcel$export(module.exports, "Duration", () => $d1fbd509c0742160$export$3b11bc38611c5941);

var $eUqFw = parcelRequire("eUqFw");

var $1Rj2M = parcelRequire("1Rj2M");

var $RvPFT = parcelRequire("RvPFT");
const $d1fbd509c0742160$export$3b11bc38611c5941 = ({ fromDate: fromDate, toDate: toDate, isSigned: isSigned, isToDateExcluded: isToDateExcluded })=>{
    const sign = toDate < fromDate ? '-' : '+';
    const duration = (0, $RvPFT.getDaysInBetween)(fromDate, toDate, isToDateExcluded);
    return duration ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Rj2M.default), {
        duration: duration,
        sign: isSigned ? sign : undefined
    }) : null;
};
$d1fbd509c0742160$export$3b11bc38611c5941.defaultProps = {
    isSigned: false,
    isToDateExcluded: false
};

});
parcelRegister("1Rj2M", function(module, exports) {

$parcel$export(module.exports, "default", () => $a1c9db1f9748c4f6$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $9nkwJ = parcelRequire("9nkwJ");

var $5JgJ2 = parcelRequire("5JgJ2");

var $2LgCb = parcelRequire("2LgCb");
const $a1c9db1f9748c4f6$var$DurationBadge = ({ duration: duration, sign: sign })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return duration ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9nkwJ.default), null, formatMessage((0, $2LgCb.default).duration, {
        duration: `${sign ?? ''}${duration}`
    })) : null;
};
var $a1c9db1f9748c4f6$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($a1c9db1f9748c4f6$var$DurationBadge);

});
parcelRegister("9nkwJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $00d99ab26ca06411$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $XHGTv = parcelRequire("XHGTv");

var $b5IAe = parcelRequire("b5IAe");
var $1Yimi = parcelRequire("1Yimi");
var $1ZAYh = parcelRequire("1ZAYh");

var $aG4Mw = parcelRequire("aG4Mw");
function $00d99ab26ca06411$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $00d99ab26ca06411$var$boxStyles = (0, $1ZAYh.xcss)({
    borderRadius: 'border.radius.200',
    display: 'inline-flex',
    blockSize: 'min-content',
    flexShrink: 0 // Text component can wrap text, this ensures it doesn't wrap in flex containers.
});
/**
 * Visual refresh colors.
 * Hardcoded hex colors are used as the they should not change based on theme, and there are no appropriate color tokens.
 *
 * Using separate variables as opposed to an object, to comply with UI styling standard
 * https://atlassian.design/components/eslint-plugin-ui-styling-standard/no-unsafe-values/usage#object-access
 */ const $00d99ab26ca06411$var$neutral300 = '#DDDEE1';
const $00d99ab26ca06411$var$red300 = '#FD9891';
const $00d99ab26ca06411$var$blue300 = '#8FB8F6';
const $00d99ab26ca06411$var$neutral1000 = '#292A2E';
const $00d99ab26ca06411$var$styles = {
    root: {
        name: "85bcg3",
        styles: "display:inline-flex;box-sizing:border-box;min-width:var(--ds-space-300, 24px);justify-content:center;flex-shrink:0;block-size:min-content;border-radius:var(--ds-border-radius-050, 2px);padding-inline:var(--ds-space-050, 4px)"
    },
    added: {
        name: "4x7cmh",
        styles: "background-color:var(--ds-background-success, #DCFFF1);color:var(--ds-text, #172B4D)"
    },
    default: /*#__PURE__*/ (0, $byn9U.css)({
        backgroundColor: $00d99ab26ca06411$var$neutral300,
        color: $00d99ab26ca06411$var$neutral1000
    }),
    important: /*#__PURE__*/ (0, $byn9U.css)({
        backgroundColor: $00d99ab26ca06411$var$red300,
        color: $00d99ab26ca06411$var$neutral1000
    }),
    primary: /*#__PURE__*/ (0, $byn9U.css)({
        backgroundColor: $00d99ab26ca06411$var$blue300,
        color: $00d99ab26ca06411$var$neutral1000
    }),
    primaryInverted: {
        name: "1425qmy",
        styles: "background-color:var(--ds-surface, #FFFFFF);color:var(--ds-text-brand, #0C66E4)"
    },
    removed: {
        name: "10hiq01",
        styles: "background-color:var(--ds-background-danger, #FFECEB);color:var(--ds-text, #172B4D)"
    }
};
/**
 * __Badge__
 *
 * This component gives you the full badge functionality and automatically formats the number you provide in \`children\`.
 *
 * - [Examples](https://atlassian.design/components/badge/examples)
 * - [Code](https://atlassian.design/components/badge/code)
 * - [Usage](https://atlassian.design/components/badge/usage)
 */ const $00d99ab26ca06411$var$Badge = /*#__PURE__*/ (0, $eUqFw.memo)(function Badge({ appearance: appearance = 'default', children: children = 0, max: max = 99, style: style, testId: testId }) {
    if ((0, $XHGTv.fg)('platform-component-visual-refresh')) return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        "data-testid": testId,
        css: [
            $00d99ab26ca06411$var$styles.root,
            $00d99ab26ca06411$var$styles[appearance]
        ],
        style: {
            background: style?.backgroundColor,
            color: style?.color
        }
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $1Yimi.default), {
        size: "small",
        align: "center",
        color: "inherit"
    }, typeof children === 'number' && max ? (0, $aG4Mw.formatValue)(children, max) : children));
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $b5IAe.default), {
        testId: testId,
        as: "span",
        backgroundColor: $00d99ab26ca06411$var$backgroundColors[appearance],
        xcss: $00d99ab26ca06411$var$boxStyles,
        style: {
            background: style?.backgroundColor,
            color: style?.color
        },
        paddingInline: "space.075"
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $1Yimi.default), {
        size: "UNSAFE_small",
        align: "center",
        color: style?.color ? 'inherit' : $00d99ab26ca06411$var$textColors[appearance]
    }, typeof children === 'number' && max ? (0, $aG4Mw.formatValue)(children, max) : children));
});
$00d99ab26ca06411$var$Badge.displayName = 'Badge';
var $00d99ab26ca06411$export$2e2bcd8739ae039 = $00d99ab26ca06411$var$Badge;
const $00d99ab26ca06411$var$backgroundColors = {
    added: 'color.background.success',
    default: 'color.background.neutral',
    important: 'color.background.danger.bold',
    primary: 'color.background.brand.bold',
    primaryInverted: 'elevation.surface',
    removed: 'color.background.danger'
};
const $00d99ab26ca06411$var$textColors = {
    added: 'color.text.success',
    default: 'color.text',
    important: 'color.text.inverse',
    primary: 'color.text.inverse',
    primaryInverted: 'color.text.brand',
    removed: 'color.text.danger'
};

});
parcelRegister("aG4Mw", function(module, exports) {

$parcel$export(module.exports, "formatValue", () => $a8e5bba3d913fce3$export$7c4d25c0c3217d8c);
function $a8e5bba3d913fce3$var$getSafeValue(value = 0) {
    const numericValue = +value;
    if (numericValue < 0) return 0;
    return value;
}
function $a8e5bba3d913fce3$export$7c4d25c0c3217d8c(value, max) {
    const safeValue = $a8e5bba3d913fce3$var$getSafeValue(value);
    const safeMax = $a8e5bba3d913fce3$var$getSafeValue(max);
    if (safeMax && safeMax < safeValue) return `${safeMax}+`;
    if (safeValue === Infinity) return "\u221E";
    return safeValue.toString();
}

});


parcelRegister("2LgCb", function(module, exports) {

$parcel$export(module.exports, "default", () => $35cdd44f95ef063a$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $35cdd44f95ef063a$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    duration: {
        "id": "roadmap.timeline-table-kit.common.date-labels.duration.duration",
        "defaultMessage": "{duration}d"
    }
});

});


parcelRegister("RvPFT", function(module, exports) {

$parcel$export(module.exports, "getDaysInBetween", () => $9bb911c33738d184$export$ae6ef52daacfecd3);
$parcel$export(module.exports, "getDurationProps", () => $9bb911c33738d184$export$100189a9c6d8b999);

const $9bb911c33738d184$export$ae6ef52daacfecd3 = (fromDate, toDate, isToDateExcluded = false)=>Math.round(Math.abs(fromDate - toDate) / (0, $4975412c8fcbfa24$export$1f04624003d2da7d)) + (isToDateExcluded ? 0 : 1);
const $9bb911c33738d184$export$100189a9c6d8b999 = (prevStartDate, prevDueDate, startDate, dueDate, dragType, currentStartDate, currentDueDate)=>{
    // Show duration on hover if no dragging or dragging entire bar
    if (dragType === undefined || dragType === 'LEFT_AND_RIGHT') return {
        fromDate: currentStartDate,
        toDate: currentDueDate,
        isSigned: false,
        isToDateExcluded: false
    };
    const isDurationDiff = prevStartDate !== undefined && prevDueDate !== undefined && startDate !== undefined && dueDate !== undefined;
    const isStartDateFixed = prevDueDate !== undefined && startDate === undefined && dueDate !== undefined;
    const isDueDateFixed = prevStartDate !== undefined && startDate !== undefined && dueDate === undefined;
    const isDurationMeta = prevStartDate === undefined && prevDueDate === undefined && startDate !== undefined && dueDate !== undefined;
    if (isDurationDiff || isStartDateFixed) return {
        fromDate: prevDueDate,
        toDate: dueDate,
        isSigned: true,
        isToDateExcluded: true
    };
    if (isDueDateFixed) return {
        fromDate: startDate,
        toDate: prevStartDate,
        isSigned: true,
        isToDateExcluded: true
    };
    if (isDurationMeta) return {
        fromDate: startDate,
        toDate: dueDate,
        isSigned: false,
        isToDateExcluded: false
    };
    return {
        fromDate: startDate ?? 0,
        toDate: dueDate ?? 0,
        isSigned: false,
        isToDateExcluded: false
    };
};

});


parcelRegister("8i5Uy", function(module, exports) {

$parcel$export(module.exports, "DATE_ICON_LOOKUP", () => $9bd6902d7174b387$export$b6abe4b9e409dfb2);
$parcel$export(module.exports, "DATE_CONTAINER_LOOKUP", () => $9bd6902d7174b387$export$f3b594588fe8a99e);

var $eUqFw = parcelRequire("eUqFw");

var $fHtBB = parcelRequire("fHtBB");

var $2jWeb = parcelRequire("2jWeb");

var $fRzLJ = parcelRequire("fRzLJ");
const $9bd6902d7174b387$export$b6abe4b9e409dfb2 = {
    [(0, $fHtBB.EXPLICIT)]: (0, $eUqFw.Fragment),
    [(0, $fHtBB.ROLLUP)]: (0, $2jWeb.RollupIcon),
    [(0, $fHtBB.INTERVAL)]: (0, $fRzLJ.SprintIcon)
};
const $9bd6902d7174b387$export$f3b594588fe8a99e = {
    [(0, $fHtBB.EXPLICIT)]: (0, $eUqFw.Fragment),
    [(0, $fHtBB.ROLLUP)]: 'i',
    [(0, $fHtBB.INTERVAL)]: 'i'
};

});
parcelRegister("2jWeb", function(module, exports) {

$parcel$export(module.exports, "RollupIcon", () => $2bb69f1e183ce4ea$export$a33e84c97d0c570c);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $2ziLQ = parcelRequire("2ziLQ");

var $5JgJ2 = parcelRequire("5JgJ2");

var $2S19W = parcelRequire("2S19W");
const $2bb69f1e183ce4ea$var$getRollupIconGlyph = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fill: "currentColor",
        d: "M14.586 11l-2.293-2.293a1 1 0 1 1 1.414-1.414l4 4a1 1 0 0 1 0 1.414l-4 4a1 1 0 0 1-1.414-1.414L14.586 13H10a1 1 0 0 0-1 1v7a1 1 0 0 1-2 0v-7a3 3 0 0 1 3-3h4.586z"
    }));
const $2bb69f1e183ce4ea$export$a33e84c97d0c570c = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2bb69f1e183ce4ea$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2ziLQ.default), {
        glyph: $2bb69f1e183ce4ea$var$getRollupIconGlyph,
        label: formatMessage((0, $2S19W.default).rollUpIconLabel),
        size: "small"
    }));
};
const $2bb69f1e183ce4ea$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3igktf _1bsb7vkz _2hwxv77o",
            __cmplp.className
        ])
    });
});

});
parcelRegister("2S19W", function(module, exports) {

$parcel$export(module.exports, "default", () => $c6b6b7044658c652$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
const $c6b6b7044658c652$var$messages = (0, $90IgZ.defineMessages)({
    rollUpIconLabel: {
        "id": "roadmap.timeline-table-kit.common.rollup-icon.roll-up-icon-label",
        "defaultMessage": "Roll-up"
    }
});
var $c6b6b7044658c652$export$2e2bcd8739ae039 = $c6b6b7044658c652$var$messages;

});


parcelRegister("fRzLJ", function(module, exports) {

$parcel$export(module.exports, "SprintIcon", () => $e6b11f88cabe053a$export$8c2ca4d5c7ca94da);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $gk7tF = parcelRequire("gk7tF");

var $5JgJ2 = parcelRequire("5JgJ2");

var $0l6OE = parcelRequire("0l6OE");
const $e6b11f88cabe053a$var$getIconSize = (iconSize)=>iconSize === 'small' ? 16 : 24;
const $e6b11f88cabe053a$var$wrapperStyles = null;
const $e6b11f88cabe053a$export$8c2ca4d5c7ca94da = ({ size: size })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        style: {
            height: `${$e6b11f88cabe053a$var$getIconSize(size)}px`,
            width: `${$e6b11f88cabe053a$var$getIconSize(size)}px`
        },
        className: (0, $7JEyt.default)([
            "_2hwxv77o"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gk7tF))), {
        label: formatMessage((0, $0l6OE.default).sprintLabel),
        size: size
    }));
};
$e6b11f88cabe053a$export$8c2ca4d5c7ca94da.defaultProps = {
    size: 'small'
};

});
parcelRegister("gk7tF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $be245075b7e5aee7$var$_react = $be245075b7e5aee7$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $be245075b7e5aee7$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $be245075b7e5aee7$var$SprintIcon = (props)=>/*#__PURE__*/ $be245075b7e5aee7$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M17.717 17.137l-1.436-1.438a1.003 1.003 0 011.418-1.418l3.007 3.01a1.002 1.002 0 010 1.417l-3.007 3.01a1.003 1.003 0 01-1.417-1.42l1.3-1.3-6.072-.003A8 8 0 014 11.01C4 6.587 7.582 3 12 3s8 3.587 8 8.01a7.982 7.982 0 01-.789 3.451l-1.438-1.44a6.11 6.11 0 00.345-2.01A6.121 6.121 0 0012 4.884a6.121 6.121 0 00-6.118 6.125 6.119 6.119 0 005.647 6.102l6.188.025zm-12.163-.119c.561.759 1.456 1.49 2.457 1.981L3.937 19C3.42 19 3 18.552 3 18s.42-1 .937-1l1.614.005.003.013z" fill="currentColor"/></svg>`
    }, props));
$be245075b7e5aee7$var$SprintIcon.displayName = 'SprintIcon';
var $be245075b7e5aee7$var$_default = $be245075b7e5aee7$var$SprintIcon;
module.exports.default = $be245075b7e5aee7$var$_default;

});

parcelRegister("0l6OE", function(module, exports) {

$parcel$export(module.exports, "default", () => $5b0717b646608dc5$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
const $5b0717b646608dc5$var$messages = (0, $90IgZ.defineMessages)({
    sprintLabel: {
        "id": "roadmap.timeline-table-kit.common.sprint-icon.sprint-label",
        "defaultMessage": "Sprint"
    }
});
var $5b0717b646608dc5$export$2e2bcd8739ae039 = $5b0717b646608dc5$var$messages;

});



parcelRegister("etu0n", function(module, exports) {

$parcel$export(module.exports, "default", () => $3c9056b40d9e646a$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $3c9056b40d9e646a$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    noStartDate: {
        "id": "roadmap.timeline-table-kit.common.formatted-date.no-start-date",
        "defaultMessage": "No start date"
    },
    noDueDate: {
        "id": "roadmap.timeline-table-kit.common.formatted-date.no-due-date",
        "defaultMessage": "No due date"
    }
});

});


parcelRegister("f2nyx", function(module, exports) {

$parcel$export(module.exports, "RoadmapBar", () => $770cd89388528d6a$export$9335a0f7fb12b232);

var $eUqFw = parcelRequire("eUqFw");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $PdmhA = parcelRequire("PdmhA");

var $lkPEe = parcelRequire("lkPEe");

var $3R70n = parcelRequire("3R70n");

var $eI5EY = parcelRequire("eI5EY");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $9WNLk = parcelRequire("9WNLk");
var $3XwA1 = parcelRequire("3XwA1");

var $lfgcv = parcelRequire("lfgcv");

var $c3IKH = parcelRequire("c3IKH");
var $fHtBB = parcelRequire("fHtBB");
var $4P2VV = parcelRequire("4P2VV");

var $3qiQH = parcelRequire("3qiQH");

var $iQiGF = parcelRequire("iQiGF");
var $cww1R = parcelRequire("cww1R");
var $cERyr = parcelRequire("cERyr");

var $bxXN4 = parcelRequire("bxXN4");

var $e3AcU = parcelRequire("e3AcU");
var $fKdC1 = parcelRequire("fKdC1");
var $2sNQW = parcelRequire("2sNQW");
var $dBmAu = parcelRequire("dBmAu");

var $ezwuA = parcelRequire("ezwuA");

var $65R8W = parcelRequire("65R8W");

var $5SkIe = parcelRequire("5SkIe");

var $3t0oV = parcelRequire("3t0oV");
const $770cd89388528d6a$var$StyledBar = ({ left: left, right: right, placeholder: placeholder, theme: theme, level: level, shouldAnimate: shouldAnimate, isSelectEnabled: isSelectEnabled, innerRef: innerRef, children: children, startDate: startDate, dueDate: dueDate, color: color, 'data-testid': testId, ...rest })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    if ((0, $eI5EY.fg)('jsw_roadmaps_timeline_table_bar_a11y')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        ref: innerRef,
        xcss: $770cd89388528d6a$var$focusedBarStyles,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            ...(0, $3qiQH.getBaseBarStyles)({
                level: level,
                placeholder: placeholder,
                theme: theme
            }),
            left: `${left}px`,
            right: `${right}px`,
            transition: shouldAnimate ? 'left 0.1s ease, right 0.1s ease' : 'none',
            cursor: isSelectEnabled ? 'pointer' : 'default'
        },
        "aria-label": formatMessage((0, $65R8W.default).gridCellAriaLabel, {
            startDate: (0, $lfgcv.getDateFromTimestamp)(startDate),
            dueDate: (0, $lfgcv.getDateFromTimestamp)(dueDate),
            color: color
        }),
        testId: testId,
        ...rest
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        ref: innerRef,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            ...(0, $3qiQH.getBaseBarStyles)({
                level: level,
                placeholder: placeholder,
                theme: theme
            }),
            left: `${left}px`,
            right: `${right}px`,
            transition: shouldAnimate ? 'left 0.1s ease, right 0.1s ease' : 'none',
            cursor: isSelectEnabled ? 'pointer' : 'default'
        },
        "data-testid": testId,
        ...rest
    }, children);
};
const $770cd89388528d6a$var$DraggableBar = (0, $3R70n.withDragObserver)($770cd89388528d6a$var$StyledBar);
const $770cd89388528d6a$export$9335a0f7fb12b232 = ({ id: id, color: color, level: level, left: initialLeftPosition, right: initialRightPosition, startDateType: startDateType, dueDateType: dueDateType, warnings: warnings, placeholder: placeholder, isReadOnly: isReadOnly, DndLongTaskMetric: DndLongTaskMetric, onUpdate: onUpdate, onLeftClick: onLeftClick, onRightClick: onRightClick, renderBarContent: renderBarContent })=>{
    const [{ isSelectEnabled: isSelectEnabled }] = (0, $9WNLk.useEnablements)();
    const [{ timelineDuration: timelineDuration, timelineWidth: timelineWidth }] = (0, $3XwA1.useTimelineState)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const barRef = (0, $eUqFw.useRef)(null);
    const [{ isActive: isActive, dragType: dragType, ...interactionState }, { onDragStart: onDragStart, onDrag: onDrag, onDragEnd: onDragEnd, onLingerStart: onLingerStart, onLingerEnd: onLingerEnd }] = (0, $bxXN4.useChartItemInteractions)(id);
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const isHovered = isActive && !dragType;
    const isDragging = dragType !== undefined;
    const isDragExplicit = isDragging && isActive;
    const isResizeEnabled = startDateType !== (0, $fHtBB.INTERVAL) && dueDateType !== (0, $fHtBB.INTERVAL);
    const leftPosition = interactionState.leftPosition ?? initialLeftPosition;
    const rightPosition = interactionState.rightPosition ?? initialRightPosition;
    const { minimumLeft: minimumLeft, minimumRight: minimumRight } = (0, $5SkIe.getMinimumPositions)(leftPosition, rightPosition, timelineWidth);
    const isMinimumBar = minimumLeft !== undefined && minimumRight !== undefined;
    const newLeft = (isDragExplicit || isHovered) && minimumLeft !== undefined ? minimumLeft : leftPosition;
    const newRight = (isDragExplicit || isHovered) && minimumRight !== undefined ? minimumRight : rightPosition;
    const newPlaceholder = isDragExplicit ? (0, $cERyr.getPlaceholderWhileDragging)(dragType, placeholder) : placeholder;
    const prevStartDate = (0, $cww1R.getStartDate)(initialLeftPosition, timelineDuration, timelineWidth);
    const prevDueDate = (0, $cww1R.getDueDate)(initialRightPosition, timelineDuration, timelineWidth);
    const startDate = (0, $cww1R.getStartDate)(leftPosition, timelineDuration, timelineWidth);
    const dueDate = (0, $cww1R.getDueDate)(rightPosition, timelineDuration, timelineWidth);
    const theme = (0, $iQiGF.getBarTheme)(color);
    // === CALLBACKS === //
    const getBarBoundingClientRect = (0, $eUqFw.useCallback)(()=>barRef.current?.getBoundingClientRect(), []);
    const onResizeStartLeft = ()=>{
        onDragStart((0, $4P2VV.LEFT));
    };
    const onResizeStartRight = ()=>{
        onDragStart((0, $4P2VV.RIGHT));
    };
    const onBarDragStart = ()=>{
        onDragStart((0, $4P2VV.LEFT_AND_RIGHT));
    };
    const onBarDragEnd = ()=>{
        const updatedDates = (0, $5SkIe.getUpdatedDates)(startDate, dueDate, dragType);
        const analyticsEvent = createAnalyticsEvent({
            action: 'dragEnded',
            actionSubject: 'bar'
        });
        const attributes = {
            type: (0, $5SkIe.getAnalyticsType)(updatedDates),
            level: level,
            isStartDateInferred: startDateType === (0, $fHtBB.ROLLUP) || startDateType === (0, $fHtBB.INTERVAL),
            isDueDateInferred: dueDateType === (0, $fHtBB.ROLLUP) || dueDateType === (0, $fHtBB.INTERVAL)
        };
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'issueBar', attributes);
        onDragEnd();
        onUpdate(id, {
            dates: updatedDates,
            meta: {
                isDragged: true
            }
        }, analyticsEvent);
    };
    const onBarRightClick = (event)=>{
        if (onRightClick !== undefined) {
            event.preventDefault();
            const { top: top, height: height } = event.currentTarget.getBoundingClientRect();
            const analyticsEvent = createAnalyticsEvent({
                action: 'rightClicked',
                actionSubject: 'bar'
            });
            (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'issueBar');
            onRightClick(id, {
                x: event.clientX,
                y: top + height
            });
        }
    };
    const onBarLeftClick = ({ target: target, ctrlKey: ctrlKey, metaKey: metaKey, shiftKey: shiftKey })=>{
        if (target === barRef.current) {
            const withCmd = ctrlKey || metaKey;
            const withShift = shiftKey;
            const analyticsEvent = createAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'bar'
            });
            const itemClickMeta = {
                level: level,
                withCmd: withCmd,
                withShift: withShift
            };
            (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'issueBar', itemClickMeta);
            onLeftClick(id, itemClickMeta, analyticsEvent);
        }
    };
    // === RENDER === //
    const renderDragHandle = (type, hasPlaceholder)=>{
        const shouldRenderHandle = isHovered && dragType === undefined || dragType === type && isDragExplicit;
        return shouldRenderHandle && isResizeEnabled && !isReadOnly ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ezwuA.RoadmapDragHandle), {
            id: id,
            type: type,
            theme: theme,
            hasPlaceholder: hasPlaceholder,
            onDragStart: type === (0, $4P2VV.LEFT) ? onResizeStartLeft : onResizeStartRight,
            onDrag: onDrag,
            onDragEnd: onBarDragEnd
        }) : null;
    };
    const renderGhostBar = ()=>{
        if (!isDragging) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                ...(0, $3qiQH.getBaseBarStyles)({
                    level: level,
                    placeholder: placeholder,
                    theme: theme
                }),
                left: `${initialLeftPosition}px`,
                right: `${initialRightPosition}px`,
                backgroundColor: theme.background,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                opacity: '0.3'
            }
        });
    };
    const barContentProps = {
        id: id,
        dragType: dragType,
        prevStartDate: prevStartDate,
        prevDueDate: prevDueDate,
        startDate: startDate,
        dueDate: dueDate,
        startDateType: startDateType,
        dueDateType: dueDateType,
        leftPosition: newLeft,
        rightPosition: newRight,
        placeholder: newPlaceholder,
        isReadOnly: isReadOnly,
        isMinimumBar: isMinimumBar,
        getBarBoundingClientRect: getBarBoundingClientRect,
        onBarMouseLeave: onLingerEnd
    };
    const barContentState = {
        isActive: isActive,
        isHovered: isHovered
    };
    const warningsDescription = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lkPEe.default), {
            id: `roadmap.timeline-table-kit.ui.chart-item-content.date-content.bar.warning-desc-${id}`
        }, warnings.length > 0 && `${formatMessage((0, $65R8W.default).warningsCount, {
            count: warnings.length
        })} `, warnings.map((errorMessage)=>`${formatMessage(errorMessage)} `));
    const renderDraggableBar = ()=>//  NOTE: ts error needs to be fixed in withDragObserver from @atlassian/jira-drag-observer
        // @ts-expect-error - TS2322 -   Property 'children' does not exist on type 'IntrinsicAttributes & IntrinsicClassAttributes<DragObserver> & Pick<Readonly<Props>, never> & InexactPartial<...> & InexactPartial<...>'. */}
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($770cd89388528d6a$var$DraggableBar, {
            "data-testid": `roadmap.timeline-table-kit.ui.chart-item-content.date-content.bar.draggable-bar-${id}`,
            innerRef: barRef,
            left: newLeft,
            right: newRight,
            level: level,
            theme: theme,
            placeholder: newPlaceholder,
            shouldAnimate: isHovered && isMinimumBar && !isDragging,
            isSelectEnabled: isSelectEnabled,
            isDisabled: isReadOnly,
            onMouseEnter: onLingerStart,
            onMouseLeave: onLingerEnd,
            onDrag: onDrag,
            onDragStart: onBarDragStart,
            onDragEnd: onBarDragEnd,
            onContextMenu: !isReadOnly ? onBarRightClick : undefined,
            onClick: isSelectEnabled ? onBarLeftClick : undefined,
            ...(0, $eI5EY.fg)('jsw_roadmaps_timeline_table_bar_a11y') && {
                tabIndex: 0,
                startDate: startDate,
                dueDate: dueDate,
                color: color,
                role: 'button',
                'aria-describedby': `roadmap.timeline-table-kit.ui.chart-item-content.date-content.bar.warning-desc-${id}`
            }
        }, renderBarContent(barContentProps, barContentState), renderDragHandle((0, $4P2VV.LEFT), placeholder === (0, $c3IKH.START_DATE_PLACEHOLDER) || placeholder === (0, $c3IKH.START_AND_DUE_DATE_PLACEHOLDER)), renderDragHandle((0, $4P2VV.RIGHT), placeholder === (0, $c3IKH.DUE_DATE_PLACEHOLDER) || placeholder === (0, $c3IKH.START_AND_DUE_DATE_PLACEHOLDER)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, renderGhostBar(), renderDraggableBar(), (0, $eI5EY.fg)('jsw_roadmaps_timeline_table_bar_a11y') && warningsDescription(), !isDragExplicit && !isHovered && warnings.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3t0oV.RoadmapBarWarnings), {
        warnings: warnings,
        right: newRight
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(DndLongTaskMetric, {
        isDragging: isDragging,
        level: level
    }));
};
const $770cd89388528d6a$var$focusedBarStyles = (0, $1ZAYh.xcss)({
    ':focus-visible': {
        outline: `2px solid ${`var(--ds-border-focused, ${(0, $PdmhA.B100)})`}`,
        outlineOffset: 'space.025'
    }
});

});
parcelRegister("3qiQH", function(module, exports) {

$parcel$export(module.exports, "getBaseBarStyles", () => $e0d8b0306f7fc500$export$bbdfdd7c08708e05);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $kbiEp = parcelRequire("kbiEp");

var $c3IKH = parcelRequire("c3IKH");
var $ksGD2 = parcelRequire("ksGD2");

var $5p0tX = parcelRequire("5p0tX");
const $e0d8b0306f7fc500$var$generateBarBackground = ({ theme: theme, placeholder: placeholder })=>{
    if (placeholder === (0, $c3IKH.START_AND_DUE_DATE_PLACEHOLDER)) return `linear-gradient(90deg, ${theme.gradient} 0%, ${theme.background} 30%, ${theme.background} 70%, ${theme.gradient} 100%)`;
    if (placeholder === (0, $c3IKH.START_DATE_PLACEHOLDER)) return `linear-gradient(90deg, ${theme.gradient} 0%, ${theme.background} 30%)`;
    if (placeholder === (0, $c3IKH.DUE_DATE_PLACEHOLDER)) return `linear-gradient(90deg, ${theme.background} 70%, ${theme.gradient} 100%)`;
    return theme.background;
};
const $e0d8b0306f7fc500$export$bbdfdd7c08708e05 = ({ level: level, placeholder: placeholder, theme: theme })=>({
        position: 'absolute',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        minWidth: '3px',
        padding: '0 5px',
        zIndex: `${0, $ksGD2.CHART_BAR_Z_INDEX}`,
        height: `${(0, $kbiEp.isBaseLevel)(level) ? `${0, $c3IKH.BASE_BAR_HEIGHT}px` : `${0, $c3IKH.BAR_HEIGHT}px`}`,
        borderRadius: `${(0, $5p0tX.generateBarBorderRadius)(placeholder)}`,
        background: `${$e0d8b0306f7fc500$var$generateBarBackground({
            placeholder: placeholder,
            theme: theme
        })}`
    });
const $e0d8b0306f7fc500$export$8759e0e73077886f = ({ placeholder: placeholder, left: left, right: right, theme: theme, level: level, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        style: {
            left: `${left}px`,
            right: `${right}px`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            height: `${(0, $kbiEp.isBaseLevel)(level) ? `${0, $c3IKH.BASE_BAR_HEIGHT}px` : `${0, $c3IKH.BAR_HEIGHT}px`}`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            borderRadius: `${(0, $5p0tX.generateBarBorderRadius)(placeholder)}`,
            background: `${$e0d8b0306f7fc500$var$generateBarBackground({
                placeholder: placeholder,
                theme: theme
            })}`
        },
        className: (0, $7JEyt.default)([
            "_kqswstnw _1e0c1txw _4cvr1h6o _1bahesu3 _1ul91b66 _1yt4otz2 _1pby11wp"
        ])
    }, children);
const $e0d8b0306f7fc500$var$baseBarStyles = null;

});
parcelRegister("5p0tX", function(module, exports) {

$parcel$export(module.exports, "generateBarBorderRadius", () => $c32927331baea9a1$export$f984deddd1b0e289);

var $c3IKH = parcelRequire("c3IKH");
const $c32927331baea9a1$export$f984deddd1b0e289 = (placeholder)=>{
    if (placeholder === (0, $c3IKH.START_AND_DUE_DATE_PLACEHOLDER)) return 0, $c3IKH.LEFT_AND_RIGHT_PLACEHOLDER_BORDER_RADIUS;
    if (placeholder === (0, $c3IKH.START_DATE_PLACEHOLDER)) return 0, $c3IKH.LEFT_PLACEHOLDER_BORDER_RADIUS;
    if (placeholder === (0, $c3IKH.DUE_DATE_PLACEHOLDER)) return 0, $c3IKH.RIGHT_PLACEHOLDER_BORDER_RADIUS;
    return 0, $c3IKH.DEFAULT_BORDER_RADIUS;
};

});


parcelRegister("iQiGF", function(module, exports) {

$parcel$export(module.exports, "getBarTheme", () => $8660ece9241da453$export$9f7946b895cedb51);

var $lPQPn = parcelRequire("lPQPn");
const $8660ece9241da453$var$colorToBarTheme = (color)=>({
        background: color.primary,
        gradient: color.primaryGradient,
        handle: color.secondary,
        hasContrastSecondaryGradient: color.hasContrastSecondaryGradient
    });
const $8660ece9241da453$var$barThemes = (0, $lPQPn.transformColorToTheme)($8660ece9241da453$var$colorToBarTheme);
const $8660ece9241da453$export$9f7946b895cedb51 = (color)=>$8660ece9241da453$var$barThemes[color] || $8660ece9241da453$var$barThemes.PURPLE;

});
parcelRegister("lPQPn", function(module, exports) {

$parcel$export(module.exports, "asColor", () => $66f7283bb625ccc7$export$b74af6529f09947);
$parcel$export(module.exports, "asServerColor", () => $66f7283bb625ccc7$export$442690a499ee9598);
$parcel$export(module.exports, "asClassicEpicColor", () => $66f7283bb625ccc7$export$eb754032c0b9698c);
$parcel$export(module.exports, "transformColorToTheme", () => $66f7283bb625ccc7$export$37c9bd72afe7f286);
$parcel$export(module.exports, "getValueFromColor", () => $66f7283bb625ccc7$export$a00423580059ae28);
$parcel$export(module.exports, "getColorFromValue", () => $66f7283bb625ccc7$export$6d14528e40cbe34b);
$parcel$export(module.exports, "toFrontendColor", () => $66f7283bb625ccc7$export$574e4dbf3c01f0ad);
$parcel$export(module.exports, "toBackendColor", () => $66f7283bb625ccc7$export$47af25386a01de1);
$parcel$export(module.exports, "classicToFrontendColor", () => $66f7283bb625ccc7$export$8f81207f7ac5fb9a);
$parcel$export(module.exports, "classicToBackendColor", () => $66f7283bb625ccc7$export$28fb68bb1de025d5);
$parcel$export(module.exports, "getDefaultColorPalette", () => $66f7283bb625ccc7$export$f6e067d5c418081a);
$parcel$export(module.exports, "getLozengeThemeByColor", () => $66f7283bb625ccc7$export$949dc67535a8ff2);
$parcel$export(module.exports, "getRandomColor", () => $66f7283bb625ccc7$export$e4369cabd7e84cd9);
/* eslint-disable jira/js/no-reduce-accumulator-spread */ 
var $aXGkF = parcelRequire("aXGkF");

var $tgbCK = parcelRequire("tgbCK");

var $hNY9X = parcelRequire("hNY9X");

var $opsFH = parcelRequire("opsFH");
const $66f7283bb625ccc7$export$b74af6529f09947 = (color)=>{
    if (color == null) return (0, $opsFH.Colors).PURPLE;
    if (color in (0, $opsFH.Colors)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return color;
    if (color in (0, $tgbCK.MAP_FROM_SERVER_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $tgbCK.MAP_FROM_SERVER_COLOR)[color];
    if (color in (0, $tgbCK.MAP_FROM_AGILE_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $tgbCK.MAP_FROM_AGILE_COLOR)[color];
    if (color in (0, $tgbCK.MAP_FROM_SERVER_CLASSIC_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $tgbCK.MAP_FROM_SERVER_CLASSIC_COLOR)[color];
    return (0, $opsFH.Colors).PURPLE;
};
const $66f7283bb625ccc7$export$442690a499ee9598 = (color)=>{
    if (color == null) return (0, $opsFH.ServerColors).SERVER_PURPLE;
    if (color in (0, $opsFH.ServerColors)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return color;
    if (color in (0, $tgbCK.MAP_FROM_CLIENT_SERVER_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $tgbCK.MAP_FROM_CLIENT_SERVER_COLOR)[color];
    if (color in (0, $tgbCK.MAP_FROM_AGILE_COLOR) && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $tgbCK.MAP_FROM_AGILE_COLOR)[color] in (0, $tgbCK.MAP_FROM_CLIENT_SERVER_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $tgbCK.MAP_FROM_CLIENT_SERVER_COLOR)[(0, $tgbCK.MAP_FROM_AGILE_COLOR)[color]];
    if (color in (0, $tgbCK.MAP_FROM_SERVER_CLASSIC_COLOR) && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $tgbCK.MAP_FROM_SERVER_CLASSIC_COLOR)[color] in (0, $tgbCK.MAP_FROM_CLIENT_SERVER_COLOR)) return (0, $tgbCK.MAP_FROM_CLIENT_SERVER_COLOR)[// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $tgbCK.MAP_FROM_SERVER_CLASSIC_COLOR)[color]];
    return (0, $opsFH.ServerColors).SERVER_PURPLE;
};
const $66f7283bb625ccc7$export$eb754032c0b9698c = (color)=>{
    if (color === null) return (0, $tgbCK.MAP_FROM_CLIENT_CLASSIC_COLOR)[(0, $opsFH.Colors).PURPLE];
    if (color in (0, $opsFH.ClassicEpicColors)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return color;
    if (color in (0, $tgbCK.MAP_FROM_CLIENT_CLASSIC_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $tgbCK.MAP_FROM_CLIENT_CLASSIC_COLOR)[color];
    if (color in (0, $tgbCK.MAP_FROM_SERVER_COLOR) && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $tgbCK.MAP_FROM_SERVER_COLOR)[color] in (0, $tgbCK.MAP_FROM_CLIENT_CLASSIC_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $tgbCK.MAP_FROM_CLIENT_CLASSIC_COLOR)[(0, $tgbCK.MAP_FROM_SERVER_COLOR)[color]];
    if (color in (0, $tgbCK.MAP_FROM_AGILE_COLOR) && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $tgbCK.MAP_FROM_AGILE_COLOR)[color] in (0, $tgbCK.MAP_FROM_CLIENT_CLASSIC_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $tgbCK.MAP_FROM_CLIENT_CLASSIC_COLOR)[(0, $tgbCK.MAP_FROM_AGILE_COLOR)[color]];
    // i.e: ghx-label-7
    return (0, $tgbCK.MAP_FROM_CLIENT_CLASSIC_COLOR)[(0, $opsFH.Colors).PURPLE];
};
const $66f7283bb625ccc7$export$1a0a4af71e00cea4 = (color)=>{
    if (color === null) return (0, $tgbCK.MAP_FROM_CLIENT_AGILE_COLOR)[(0, $opsFH.Colors).PURPLE];
    if (color in (0, $opsFH.AgileColors)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return color;
    if (color in (0, $tgbCK.MAP_FROM_CLIENT_AGILE_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $tgbCK.MAP_FROM_CLIENT_AGILE_COLOR)[color];
    if (color in (0, $tgbCK.MAP_FROM_SERVER_COLOR) && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $tgbCK.MAP_FROM_SERVER_COLOR)[color] in (0, $tgbCK.MAP_FROM_CLIENT_AGILE_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $tgbCK.MAP_FROM_CLIENT_AGILE_COLOR)[(0, $tgbCK.MAP_FROM_SERVER_COLOR)[color]];
    if (color in (0, $tgbCK.MAP_FROM_SERVER_CLASSIC_COLOR) && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $tgbCK.MAP_FROM_SERVER_CLASSIC_COLOR)[color] in (0, $tgbCK.MAP_FROM_CLIENT_AGILE_COLOR)) return (0, $tgbCK.MAP_FROM_CLIENT_AGILE_COLOR)[// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $tgbCK.MAP_FROM_SERVER_CLASSIC_COLOR)[color]];
    // i.e: color_7
    return (0, $tgbCK.MAP_FROM_CLIENT_AGILE_COLOR)[(0, $opsFH.Colors).PURPLE];
};
const $66f7283bb625ccc7$export$37c9bd72afe7f286 = (transformation, colorSchemaExtension)=>{
    const newColorSchema = {
        ...(0, $tgbCK.BASE_COLOR_SCHEMA),
        ...colorSchemaExtension
    };
    const extendedColors = (colorSchemaExtension ? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    Object.keys(colorSchemaExtension) : []).concat(Object.keys((0, $opsFH.Colors)));
    return extendedColors.reduce((obj, color)=>({
            ...obj,
            [color]: transformation(newColorSchema[color])
        }), // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    {});
};
const $66f7283bb625ccc7$export$a00423580059ae28 = (color)=>(0, $tgbCK.MAP_COLORS_TO_VALUE)[color] || (0, $tgbCK.MAP_COLORS_TO_VALUE)[0, $opsFH.PURPLE];
const $66f7283bb625ccc7$export$6d14528e40cbe34b = (value)=>// NOTE: lodash invert coerce the output to Dictionary<string> instead of using a polymorphic type
    // @ts-expect-error - TS2322 - Type 'string' is not assignable to type 'Color'.
    (0, (/*@__PURE__*/$parcel$interopDefault($aXGkF)))((0, $tgbCK.MAP_COLORS_TO_VALUE))[value] || (0, $opsFH.PURPLE);
const $66f7283bb625ccc7$export$574e4dbf3c01f0ad = (colorStr)=>colorStr !== '' && colorStr !== undefined && colorStr !== null && colorStr in (0, $tgbCK.MAP_FROM_SERVER_COLOR) ? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $tgbCK.MAP_FROM_SERVER_COLOR)[colorStr] : (0, $opsFH.PURPLE);
const $66f7283bb625ccc7$export$47af25386a01de1 = (color)=>(0, $tgbCK.MAP_FROM_CLIENT_SERVER_COLOR)[color];
const $66f7283bb625ccc7$export$8f81207f7ac5fb9a = (colorStr)=>colorStr !== '' && colorStr !== undefined && colorStr !== null && colorStr in (0, $tgbCK.MAP_FROM_SERVER_CLASSIC_COLOR) ? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $tgbCK.MAP_FROM_SERVER_CLASSIC_COLOR)[colorStr] : (0, $opsFH.PURPLE);
const $66f7283bb625ccc7$export$28fb68bb1de025d5 = (color)=>(0, $tgbCK.MAP_FROM_CLIENT_CLASSIC_COLOR)[color];
/**
 * Return default color palette
 */ const $66f7283bb625ccc7$var$paletteColorValues = $66f7283bb625ccc7$export$37c9bd72afe7f286((colorSchema)=>colorSchema.primary);
const $66f7283bb625ccc7$export$f6e067d5c418081a = (formatMessage)=>[
        {
            label: formatMessage((0, $hNY9X.default).purpleLabel),
            value: $66f7283bb625ccc7$var$paletteColorValues[(0, $opsFH.Colors).PURPLE]
        },
        {
            label: formatMessage((0, $hNY9X.default).blueLabel),
            value: $66f7283bb625ccc7$var$paletteColorValues[(0, $opsFH.Colors).BLUE]
        },
        {
            label: formatMessage((0, $hNY9X.default).greenLabel),
            value: $66f7283bb625ccc7$var$paletteColorValues[(0, $opsFH.Colors).GREEN]
        },
        {
            label: formatMessage((0, $hNY9X.default).tealLabel),
            value: $66f7283bb625ccc7$var$paletteColorValues[(0, $opsFH.Colors).TEAL]
        },
        {
            label: formatMessage((0, $hNY9X.default).yellowLabel),
            value: $66f7283bb625ccc7$var$paletteColorValues[(0, $opsFH.Colors).YELLOW]
        },
        {
            label: formatMessage((0, $hNY9X.default).orangeLabel),
            value: $66f7283bb625ccc7$var$paletteColorValues[(0, $opsFH.Colors).ORANGE]
        },
        {
            label: formatMessage((0, $hNY9X.default).greyLabel),
            value: $66f7283bb625ccc7$var$paletteColorValues[(0, $opsFH.Colors).GREY]
        },
        {
            label: formatMessage((0, $hNY9X.default).darkPurpleLabel),
            value: $66f7283bb625ccc7$var$paletteColorValues[(0, $opsFH.Colors).DARK_PURPLE]
        },
        {
            label: formatMessage((0, $hNY9X.default).darkBlueLabel),
            value: $66f7283bb625ccc7$var$paletteColorValues[(0, $opsFH.Colors).DARK_BLUE]
        },
        {
            label: formatMessage((0, $hNY9X.default).darkGreenLabel),
            value: $66f7283bb625ccc7$var$paletteColorValues[(0, $opsFH.Colors).DARK_GREEN]
        },
        {
            label: formatMessage((0, $hNY9X.default).darkTealLabel),
            value: $66f7283bb625ccc7$var$paletteColorValues[(0, $opsFH.Colors).DARK_TEAL]
        },
        {
            label: formatMessage((0, $hNY9X.default).darkYellowLabel),
            value: $66f7283bb625ccc7$var$paletteColorValues[(0, $opsFH.Colors).DARK_YELLOW]
        },
        {
            label: formatMessage((0, $hNY9X.default).darkOrangeLabel),
            value: $66f7283bb625ccc7$var$paletteColorValues[(0, $opsFH.Colors).DARK_ORANGE]
        },
        {
            label: formatMessage((0, $hNY9X.default).darkGreyLabel),
            value: $66f7283bb625ccc7$var$paletteColorValues[(0, $opsFH.Colors).DARK_GREY]
        }
    ];
const $66f7283bb625ccc7$export$9b822862d986dfdf = $66f7283bb625ccc7$export$37c9bd72afe7f286((colorSchema)=>({
        color: colorSchema.text,
        backgroundColor: colorSchema.textBackground
    }));
const $66f7283bb625ccc7$export$949dc67535a8ff2 = (color = (0, $tgbCK.DEFAULT_EPIC_COLOR))=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    $66f7283bb625ccc7$export$9b822862d986dfdf[color] ?? $66f7283bb625ccc7$export$9b822862d986dfdf[0, $tgbCK.DEFAULT_EPIC_COLOR];
const $66f7283bb625ccc7$export$e4369cabd7e84cd9 = ()=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const colorKeys = Object.keys((0, $opsFH.Colors));
    return colorKeys[Math.floor(Math.random() * colorKeys.length)];
};

});
parcelRegister("tgbCK", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_EPIC_COLOR", () => $3e0c3a8718e9d782$export$c2357bec51c5cf5b);
$parcel$export(module.exports, "MAP_COLORS_TO_VALUE", () => $3e0c3a8718e9d782$export$db33d74b098e3da9);
$parcel$export(module.exports, "MAP_COLORS_TO_TOKEN", () => $3e0c3a8718e9d782$export$fc5fe4213a5703f1);
$parcel$export(module.exports, "MAP_VALUE_TO_COLOR", () => $3e0c3a8718e9d782$export$a6cb26e106674600);
$parcel$export(module.exports, "MAP_FROM_SERVER_COLOR", () => $3e0c3a8718e9d782$export$43264b0781f10167);
$parcel$export(module.exports, "MAP_FROM_CLIENT_SERVER_COLOR", () => $3e0c3a8718e9d782$export$aedca9f3a1ee43d7);
$parcel$export(module.exports, "MAP_FROM_SERVER_CLASSIC_COLOR", () => $3e0c3a8718e9d782$export$fb5d051fe1b2bccc);
$parcel$export(module.exports, "MAP_FROM_CLIENT_CLASSIC_COLOR", () => $3e0c3a8718e9d782$export$c13af2d9629c53d8);
$parcel$export(module.exports, "MAP_FROM_AGILE_COLOR", () => $3e0c3a8718e9d782$export$994d3ffa39be04fd);
$parcel$export(module.exports, "MAP_FROM_CLIENT_AGILE_COLOR", () => $3e0c3a8718e9d782$export$db17671bf37971e7);
$parcel$export(module.exports, "MAP_CLASSIC_COLOR_TO_AGILE_COLOR", () => $3e0c3a8718e9d782$export$1fdd5a248b5f697c);
$parcel$export(module.exports, "MAP_COLOR_TO_AK_COLOR", () => $3e0c3a8718e9d782$export$82fc3b0b98905453);
$parcel$export(module.exports, "MAP_AGILE_COLOR_TO_AK_COLOR", () => $3e0c3a8718e9d782$export$703aca53c431bb88);
$parcel$export(module.exports, "BASE_COLOR_SCHEMA", () => $3e0c3a8718e9d782$export$92b6aebfb522f0d9);

var $aXGkF = parcelRequire("aXGkF");

var $PdmhA = parcelRequire("PdmhA");

var $opsFH = parcelRequire("opsFH");
const $3e0c3a8718e9d782$export$c2357bec51c5cf5b = 'PURPLE';
const $3e0c3a8718e9d782$export$db33d74b098e3da9 = {
    [(0, $opsFH.PURPLE)]: `var(--ds-background-accent-purple-subtle, ${(0, $PdmhA).P200})`,
    [(0, $opsFH.BLUE)]: `var(--ds-background-accent-blue-subtle, ${(0, $PdmhA).B200})`,
    [(0, $opsFH.GREEN)]: `var(--ds-background-accent-green-subtle, ${(0, $PdmhA).G200})`,
    [(0, $opsFH.TEAL)]: `var(--ds-background-accent-teal-subtle, ${(0, $PdmhA).T200})`,
    [(0, $opsFH.YELLOW)]: `var(--ds-background-accent-yellow-subtle, ${(0, $PdmhA).Y200})`,
    [(0, $opsFH.ORANGE)]: `var(--ds-background-accent-red-subtle, ${(0, $PdmhA).R200})`,
    [(0, $opsFH.GREY)]: `var(--ds-background-accent-gray-subtle, ${(0, $PdmhA).N200})`,
    [(0, $opsFH.DARK_PURPLE)]: `var(--ds-background-accent-purple-bolder, ${(0, $PdmhA).P400})`,
    [(0, $opsFH.DARK_BLUE)]: `var(--ds-background-accent-blue-bolder, ${(0, $PdmhA).B400})`,
    [(0, $opsFH.DARK_GREEN)]: `var(--ds-background-accent-green-bolder, ${(0, $PdmhA).G400})`,
    [(0, $opsFH.DARK_TEAL)]: `var(--ds-background-accent-teal-bolder, ${(0, $PdmhA).T400})`,
    [(0, $opsFH.DARK_YELLOW)]: `var(--ds-background-accent-orange-bolder, ${(0, $PdmhA).Y400})`,
    [(0, $opsFH.DARK_ORANGE)]: `var(--ds-background-accent-red-bolder, ${(0, $PdmhA).R400})`,
    [(0, $opsFH.DARK_GREY)]: `var(--ds-background-accent-gray-bolder, ${(0, $PdmhA).N700})`
};
const $3e0c3a8718e9d782$export$fc5fe4213a5703f1 = {
    [(0, $PdmhA).P200]: `var(--ds-background-accent-purple-subtle, ${(0, $PdmhA).P200})`,
    [(0, $PdmhA).B200]: `var(--ds-background-accent-blue-subtle, ${(0, $PdmhA).B200})`,
    [(0, $PdmhA).G200]: `var(--ds-background-accent-green-subtle, ${(0, $PdmhA).G200})`,
    [(0, $PdmhA).T200]: `var(--ds-background-accent-teal-subtle, ${(0, $PdmhA).T200})`,
    [(0, $PdmhA).Y200]: `var(--ds-background-accent-yellow-subtle, ${(0, $PdmhA).Y200})`,
    [(0, $PdmhA).R200]: `var(--ds-background-accent-red-subtle, ${(0, $PdmhA).R200})`,
    [(0, $PdmhA).N200]: `var(--ds-background-accent-gray-subtle, ${(0, $PdmhA).N200})`,
    [(0, $PdmhA).P400]: `var(--ds-background-accent-purple-bolder, ${(0, $PdmhA).P400})`,
    [(0, $PdmhA).B400]: `var(--ds-background-accent-blue-bolder, ${(0, $PdmhA).B400})`,
    [(0, $PdmhA).G400]: `var(--ds-background-accent-green-bolder, ${(0, $PdmhA).G400})`,
    [(0, $PdmhA).T400]: `var(--ds-background-accent-teal-bolder, ${(0, $PdmhA).T400})`,
    [(0, $PdmhA).Y400]: `var(--ds-background-accent-orange-bolder, ${(0, $PdmhA).Y400})`,
    [(0, $PdmhA).R400]: `var(--ds-background-accent-red-bolder, ${(0, $PdmhA).R400})`,
    [(0, $PdmhA).N700]: `var(--ds-background-accent-gray-bolder, ${(0, $PdmhA).N700})`
};
const $3e0c3a8718e9d782$export$a6cb26e106674600 = (0, (/*@__PURE__*/$parcel$interopDefault($aXGkF)))($3e0c3a8718e9d782$export$db33d74b098e3da9);
const $3e0c3a8718e9d782$export$43264b0781f10167 = {
    [(0, $opsFH.SERVER_PURPLE)]: (0, $opsFH.PURPLE),
    [(0, $opsFH.SERVER_DARK_PURPLE)]: (0, $opsFH.DARK_PURPLE),
    [(0, $opsFH.SERVER_BLUE)]: (0, $opsFH.BLUE),
    [(0, $opsFH.SERVER_DARK_BLUE)]: (0, $opsFH.DARK_BLUE),
    [(0, $opsFH.SERVER_GREEN)]: (0, $opsFH.GREEN),
    [(0, $opsFH.SERVER_DARK_GREEN)]: (0, $opsFH.DARK_GREEN),
    [(0, $opsFH.SERVER_TEAL)]: (0, $opsFH.TEAL),
    [(0, $opsFH.SERVER_DARK_TEAL)]: (0, $opsFH.DARK_TEAL),
    [(0, $opsFH.SERVER_YELLOW)]: (0, $opsFH.YELLOW),
    [(0, $opsFH.SERVER_DARK_YELLOW)]: (0, $opsFH.DARK_YELLOW),
    [(0, $opsFH.SERVER_ORANGE)]: (0, $opsFH.ORANGE),
    [(0, $opsFH.SERVER_DARK_ORANGE)]: (0, $opsFH.DARK_ORANGE),
    [(0, $opsFH.SERVER_GREY)]: (0, $opsFH.GREY),
    [(0, $opsFH.SERVER_DARK_GREY)]: (0, $opsFH.DARK_GREY)
};
const $3e0c3a8718e9d782$export$aedca9f3a1ee43d7 = (0, (/*@__PURE__*/$parcel$interopDefault($aXGkF)))($3e0c3a8718e9d782$export$43264b0781f10167);
const $3e0c3a8718e9d782$export$fb5d051fe1b2bccc = {
    [(0, $opsFH.GHX_LABEL_1)]: (0, $opsFH.DARK_GREY),
    [(0, $opsFH.GHX_LABEL_2)]: (0, $opsFH.DARK_YELLOW),
    [(0, $opsFH.GHX_LABEL_3)]: (0, $opsFH.YELLOW),
    [(0, $opsFH.GHX_LABEL_4)]: (0, $opsFH.DARK_BLUE),
    [(0, $opsFH.GHX_LABEL_5)]: (0, $opsFH.DARK_TEAL),
    [(0, $opsFH.GHX_LABEL_6)]: (0, $opsFH.GREEN),
    [(0, $opsFH.GHX_LABEL_7)]: (0, $opsFH.PURPLE),
    [(0, $opsFH.GHX_LABEL_8)]: (0, $opsFH.DARK_PURPLE),
    [(0, $opsFH.GHX_LABEL_9)]: (0, $opsFH.ORANGE),
    [(0, $opsFH.GHX_LABEL_10)]: (0, $opsFH.BLUE),
    [(0, $opsFH.GHX_LABEL_11)]: (0, $opsFH.TEAL),
    [(0, $opsFH.GHX_LABEL_12)]: (0, $opsFH.GREY),
    [(0, $opsFH.GHX_LABEL_13)]: (0, $opsFH.DARK_GREEN),
    [(0, $opsFH.GHX_LABEL_14)]: (0, $opsFH.DARK_ORANGE)
};
const $3e0c3a8718e9d782$export$c13af2d9629c53d8 = (0, (/*@__PURE__*/$parcel$interopDefault($aXGkF)))($3e0c3a8718e9d782$export$fb5d051fe1b2bccc);
const $3e0c3a8718e9d782$export$994d3ffa39be04fd = {
    [(0, $opsFH.AGILE_COLOR_1)]: (0, $opsFH.DARK_GREY),
    [(0, $opsFH.AGILE_COLOR_2)]: (0, $opsFH.DARK_YELLOW),
    [(0, $opsFH.AGILE_COLOR_3)]: (0, $opsFH.YELLOW),
    [(0, $opsFH.AGILE_COLOR_4)]: (0, $opsFH.DARK_BLUE),
    [(0, $opsFH.AGILE_COLOR_5)]: (0, $opsFH.DARK_TEAL),
    [(0, $opsFH.AGILE_COLOR_6)]: (0, $opsFH.GREEN),
    [(0, $opsFH.AGILE_COLOR_7)]: (0, $opsFH.PURPLE),
    [(0, $opsFH.AGILE_COLOR_8)]: (0, $opsFH.DARK_PURPLE),
    [(0, $opsFH.AGILE_COLOR_9)]: (0, $opsFH.ORANGE),
    [(0, $opsFH.AGILE_COLOR_10)]: (0, $opsFH.BLUE),
    [(0, $opsFH.AGILE_COLOR_11)]: (0, $opsFH.TEAL),
    [(0, $opsFH.AGILE_COLOR_12)]: (0, $opsFH.GREY),
    [(0, $opsFH.AGILE_COLOR_13)]: (0, $opsFH.DARK_GREEN),
    [(0, $opsFH.AGILE_COLOR_14)]: (0, $opsFH.DARK_ORANGE)
};
const $3e0c3a8718e9d782$export$db17671bf37971e7 = (0, (/*@__PURE__*/$parcel$interopDefault($aXGkF)))($3e0c3a8718e9d782$export$994d3ffa39be04fd);
const $3e0c3a8718e9d782$export$1fdd5a248b5f697c = {
    [(0, $opsFH.GHX_LABEL_1)]: (0, $opsFH.AGILE_COLOR_1),
    [(0, $opsFH.GHX_LABEL_2)]: (0, $opsFH.AGILE_COLOR_2),
    [(0, $opsFH.GHX_LABEL_3)]: (0, $opsFH.AGILE_COLOR_3),
    [(0, $opsFH.GHX_LABEL_4)]: (0, $opsFH.AGILE_COLOR_4),
    [(0, $opsFH.GHX_LABEL_5)]: (0, $opsFH.AGILE_COLOR_5),
    [(0, $opsFH.GHX_LABEL_6)]: (0, $opsFH.AGILE_COLOR_6),
    [(0, $opsFH.GHX_LABEL_7)]: (0, $opsFH.AGILE_COLOR_7),
    [(0, $opsFH.GHX_LABEL_8)]: (0, $opsFH.AGILE_COLOR_8),
    [(0, $opsFH.GHX_LABEL_9)]: (0, $opsFH.AGILE_COLOR_9),
    [(0, $opsFH.GHX_LABEL_10)]: (0, $opsFH.AGILE_COLOR_10),
    [(0, $opsFH.GHX_LABEL_11)]: (0, $opsFH.AGILE_COLOR_11),
    [(0, $opsFH.GHX_LABEL_12)]: (0, $opsFH.AGILE_COLOR_12),
    [(0, $opsFH.GHX_LABEL_13)]: (0, $opsFH.AGILE_COLOR_13),
    [(0, $opsFH.GHX_LABEL_14)]: (0, $opsFH.AGILE_COLOR_14)
};
const $3e0c3a8718e9d782$export$82fc3b0b98905453 = {
    [(0, $opsFH.DARK_GREY)]: 'grey',
    [(0, $opsFH.DARK_YELLOW)]: 'yellow',
    [(0, $opsFH.YELLOW)]: 'yellowLight',
    [(0, $opsFH.DARK_BLUE)]: 'blue',
    [(0, $opsFH.DARK_TEAL)]: 'teal',
    [(0, $opsFH.GREEN)]: 'greenLight',
    [(0, $opsFH.PURPLE)]: 'purpleLight',
    [(0, $opsFH.DARK_PURPLE)]: 'purple',
    [(0, $opsFH.ORANGE)]: 'redLight',
    [(0, $opsFH.BLUE)]: 'blueLight',
    [(0, $opsFH.TEAL)]: 'tealLight',
    [(0, $opsFH.GREY)]: 'greyLight',
    [(0, $opsFH.DARK_GREEN)]: 'green',
    [(0, $opsFH.DARK_ORANGE)]: 'red'
};
const $3e0c3a8718e9d782$export$703aca53c431bb88 = {
    [(0, $opsFH.AGILE_COLOR_1)]: 'grey',
    [(0, $opsFH.AGILE_COLOR_2)]: 'yellow',
    [(0, $opsFH.AGILE_COLOR_3)]: 'yellowLight',
    [(0, $opsFH.AGILE_COLOR_4)]: 'blue',
    [(0, $opsFH.AGILE_COLOR_5)]: 'teal',
    [(0, $opsFH.AGILE_COLOR_6)]: 'greenLight',
    [(0, $opsFH.AGILE_COLOR_7)]: 'purpleLight',
    [(0, $opsFH.AGILE_COLOR_8)]: 'purple',
    [(0, $opsFH.AGILE_COLOR_9)]: 'redLight',
    [(0, $opsFH.AGILE_COLOR_10)]: 'blueLight',
    [(0, $opsFH.AGILE_COLOR_11)]: 'tealLight',
    [(0, $opsFH.AGILE_COLOR_12)]: 'greyLight',
    [(0, $opsFH.AGILE_COLOR_13)]: 'green',
    [(0, $opsFH.AGILE_COLOR_14)]: 'red'
};
const $3e0c3a8718e9d782$export$92b6aebfb522f0d9 = {
    [(0, $opsFH.PURPLE)]: {
        primary: `var(--ds-background-accent-purple-subtle, ${(0, $PdmhA).P200})`,
        secondary: `var(--ds-background-accent-purple-bolder, ${(0, $PdmhA).P500})`,
        text: `var(--ds-text-accent-purple, ${(0, $PdmhA).P500})`,
        textBackground: `var(--ds-background-accent-purple-subtler, ${(0, $PdmhA).P50})`,
        border: `var(--ds-border-accent-purple, ${(0, $PdmhA).P400})`,
        line: `var(--ds-border-accent-purple, ${(0, $PdmhA).P300})`,
        primaryGradient: `var(--ds-background-accent-purple-subtler, ${(0, $PdmhA).P75})`,
        hasContrastSecondaryGradient: true
    },
    [(0, $opsFH.BLUE)]: {
        primary: `var(--ds-background-accent-blue-subtle, ${(0, $PdmhA).B200})`,
        secondary: `var(--ds-background-accent-blue-bolder, ${(0, $PdmhA).B500})`,
        text: `var(--ds-text-accent-blue, ${(0, $PdmhA).B500})`,
        textBackground: `var(--ds-background-accent-blue-subtler, ${(0, $PdmhA).B50})`,
        border: `var(--ds-border-accent-blue, ${(0, $PdmhA).B400})`,
        line: `var(--ds-border-accent-blue, ${(0, $PdmhA).B300})`,
        primaryGradient: `var(--ds-background-accent-blue-subtler, ${(0, $PdmhA).B75})`,
        hasContrastSecondaryGradient: true
    },
    [(0, $opsFH.GREEN)]: {
        primary: `var(--ds-background-accent-green-subtle, ${(0, $PdmhA).G200})`,
        secondary: `var(--ds-background-accent-green-bolder, ${(0, $PdmhA).G500})`,
        text: `var(--ds-text-accent-green, ${(0, $PdmhA).G500})`,
        textBackground: `var(--ds-background-accent-green-subtler, ${(0, $PdmhA).G50})`,
        border: `var(--ds-border-accent-green, ${(0, $PdmhA).G400})`,
        line: `var(--ds-border-accent-green, ${(0, $PdmhA).G300})`,
        primaryGradient: `var(--ds-background-accent-green-subtler, ${(0, $PdmhA).G75})`,
        hasContrastSecondaryGradient: true
    },
    [(0, $opsFH.TEAL)]: {
        primary: `var(--ds-background-accent-teal-subtle, ${(0, $PdmhA).T200})`,
        secondary: `var(--ds-background-accent-teal-bolder, ${(0, $PdmhA).T500})`,
        text: `var(--ds-text-accent-teal, ${(0, $PdmhA).T500})`,
        textBackground: `var(--ds-background-accent-teal-subtler, ${(0, $PdmhA).T50})`,
        border: `var(--ds-border-accent-teal, ${(0, $PdmhA).T400})`,
        line: `var(--ds-border-accent-teal, ${(0, $PdmhA).T300})`,
        primaryGradient: `var(--ds-background-accent-teal-subtler, ${(0, $PdmhA).T75})`,
        hasContrastSecondaryGradient: true
    },
    [(0, $opsFH.YELLOW)]: {
        primary: `var(--ds-background-accent-yellow-subtle, ${(0, $PdmhA).Y200})`,
        secondary: `var(--ds-background-accent-yellow-bolder, ${(0, $PdmhA).Y500})`,
        text: `var(--ds-text-accent-yellow, ${(0, $PdmhA).Y500})`,
        textBackground: `var(--ds-background-accent-yellow-subtler, ${(0, $PdmhA).Y50})`,
        border: `var(--ds-border-accent-yellow, ${(0, $PdmhA).Y400})`,
        line: `var(--ds-border-accent-yellow, ${(0, $PdmhA).Y300})`,
        primaryGradient: `var(--ds-background-accent-yellow-subtler, ${(0, $PdmhA).Y75})`,
        hasContrastSecondaryGradient: true
    },
    [(0, $opsFH.ORANGE)]: {
        primary: `var(--ds-background-accent-red-subtle, ${(0, $PdmhA).R200})`,
        secondary: `var(--ds-background-accent-red-bolder, ${(0, $PdmhA).R500})`,
        text: `var(--ds-text-accent-red, ${(0, $PdmhA).R500})`,
        textBackground: `var(--ds-background-accent-red-subtler, ${(0, $PdmhA).R50})`,
        border: `var(--ds-border-accent-red, ${(0, $PdmhA).R400})`,
        line: `var(--ds-border-accent-red, ${(0, $PdmhA).R300})`,
        primaryGradient: `var(--ds-background-accent-red-subtler, ${(0, $PdmhA).R75})`,
        hasContrastSecondaryGradient: true
    },
    [(0, $opsFH.GREY)]: {
        primary: `var(--ds-background-accent-gray-subtle, ${(0, $PdmhA).N200})`,
        secondary: `var(--ds-background-accent-gray-bolder, ${(0, $PdmhA).N500})`,
        text: `var(--ds-text-accent-gray, ${(0, $PdmhA).N500})`,
        textBackground: `var(--ds-background-accent-gray-subtler, ${(0, $PdmhA).N30})`,
        border: `var(--ds-border-accent-gray, ${(0, $PdmhA).N700})`,
        line: `var(--ds-border-accent-gray, ${(0, $PdmhA).N500})`,
        primaryGradient: `var(--ds-background-accent-gray-subtler, ${(0, $PdmhA).N50})`,
        hasContrastSecondaryGradient: true
    },
    [(0, $opsFH.DARK_PURPLE)]: {
        primary: `var(--ds-background-accent-purple-bolder, ${(0, $PdmhA).P400})`,
        secondary: `var(--ds-background-accent-purple-subtle, ${(0, $PdmhA).P200})`,
        text: `var(--ds-text-inverse, ${(0, $PdmhA).N0})`,
        textBackground: `var(--ds-background-accent-purple-bolder, ${(0, $PdmhA).P400})`,
        border: `var(--ds-border-accent-purple, ${(0, $PdmhA).P100})`,
        line: `var(--ds-border-accent-purple, ${(0, $PdmhA).P300})`,
        primaryGradient: `var(--ds-background-accent-purple-subtle, ${(0, $PdmhA).P100})`,
        hasContrastSecondaryGradient: false
    },
    [(0, $opsFH.DARK_BLUE)]: {
        primary: `var(--ds-background-accent-blue-bolder, ${(0, $PdmhA).B400})`,
        secondary: `var(--ds-background-accent-blue-subtle, ${(0, $PdmhA).B200})`,
        text: `var(--ds-text-inverse, ${(0, $PdmhA).N0})`,
        textBackground: `var(--ds-background-accent-blue-bolder, ${(0, $PdmhA).B400})`,
        border: `var(--ds-border-accent-blue, ${(0, $PdmhA).B200})`,
        line: `var(--ds-border-accent-blue, ${(0, $PdmhA).B100})`,
        primaryGradient: `var(--ds-background-accent-blue-subtle, ${(0, $PdmhA).B100})`,
        hasContrastSecondaryGradient: false
    },
    [(0, $opsFH.DARK_GREEN)]: {
        primary: `var(--ds-background-accent-green-bolder, ${(0, $PdmhA).G400})`,
        secondary: `var(--ds-background-accent-green-subtle, ${(0, $PdmhA).G200})`,
        text: `var(--ds-text-inverse, ${(0, $PdmhA).N0})`,
        textBackground: `var(--ds-background-accent-green-bolder, ${(0, $PdmhA).G400})`,
        border: `var(--ds-border-accent-green, ${(0, $PdmhA).G200})`,
        line: `var(--ds-border-accent-green, ${(0, $PdmhA).G300})`,
        primaryGradient: `var(--ds-background-accent-green-subtle, ${(0, $PdmhA).G200})`,
        hasContrastSecondaryGradient: false
    },
    [(0, $opsFH.DARK_TEAL)]: {
        primary: `var(--ds-background-accent-teal-bolder, ${(0, $PdmhA).T400})`,
        secondary: `var(--ds-background-accent-teal-subtle, ${(0, $PdmhA).T200})`,
        text: `var(--ds-text-inverse, ${(0, $PdmhA).N0})`,
        textBackground: `var(--ds-background-accent-teal-bolder, ${(0, $PdmhA).T400})`,
        border: `var(--ds-border-accent-teal, ${(0, $PdmhA).T200})`,
        line: `var(--ds-border-accent-teal, ${(0, $PdmhA).T300})`,
        primaryGradient: `var(--ds-background-accent-teal-subtle, ${(0, $PdmhA).T100})`,
        hasContrastSecondaryGradient: false
    },
    [(0, $opsFH.DARK_YELLOW)]: {
        primary: `var(--ds-background-accent-orange-bolder, ${(0, $PdmhA).Y400})`,
        secondary: `var(--ds-background-accent-orange-subtle, ${(0, $PdmhA).Y200})`,
        text: `var(--ds-text-inverse, ${(0, $PdmhA).N0})`,
        textBackground: `var(--ds-background-accent-orange-bolder, ${(0, $PdmhA).Y400})`,
        border: `var(--ds-background-accent-orange-subtle, ${(0, $PdmhA).Y200})`,
        line: `var(--ds-border-accent-orange, ${(0, $PdmhA).Y300})`,
        primaryGradient: `var(--ds-background-accent-orange-subtle, ${(0, $PdmhA).Y100})`,
        hasContrastSecondaryGradient: false
    },
    [(0, $opsFH.DARK_ORANGE)]: {
        primary: `var(--ds-background-accent-red-bolder, ${(0, $PdmhA).R400})`,
        secondary: `var(--ds-background-accent-red-subtle, ${(0, $PdmhA).R200})`,
        text: `var(--ds-text-inverse, ${(0, $PdmhA).N0})`,
        textBackground: `var(--ds-background-accent-red-bolder, ${(0, $PdmhA).R400})`,
        border: `var(--ds-background-accent-red-subtle, ${(0, $PdmhA).R100})`,
        line: `var(--ds-border-accent-red, ${(0, $PdmhA).R300})`,
        primaryGradient: `var(--ds-background-accent-red-subtle, ${(0, $PdmhA).R100})`,
        hasContrastSecondaryGradient: false
    },
    [(0, $opsFH.DARK_GREY)]: {
        primary: `var(--ds-background-accent-gray-bolder, ${(0, $PdmhA).N700})`,
        secondary: `var(--ds-background-accent-gray-subtle, ${(0, $PdmhA).N300})`,
        text: `var(--ds-text-inverse, ${(0, $PdmhA).N0})`,
        textBackground: `var(--ds-background-accent-gray-bolder, ${(0, $PdmhA).N500})`,
        border: `var(--ds-background-accent-gray-subtle, ${(0, $PdmhA).N100})`,
        line: `var(--ds-border-accent-gray, ${(0, $PdmhA).N500})`,
        primaryGradient: `var(--ds-background-accent-gray-subtle, ${(0, $PdmhA).N100})`,
        hasContrastSecondaryGradient: false
    }
};

});

parcelRegister("hNY9X", function(module, exports) {

$parcel$export(module.exports, "default", () => $a7d8f225d60e32dd$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $a7d8f225d60e32dd$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    purpleLabel: {
        "id": "issue-epic-color.common.purple-label",
        "defaultMessage": "purple"
    },
    blueLabel: {
        "id": "issue-epic-color.common.blue-label",
        "defaultMessage": "blue"
    },
    greenLabel: {
        "id": "issue-epic-color.common.green-label",
        "defaultMessage": "green"
    },
    tealLabel: {
        "id": "issue-epic-color.common.teal-label",
        "defaultMessage": "teal"
    },
    yellowLabel: {
        "id": "issue-epic-color.common.yellow-label",
        "defaultMessage": "yellow"
    },
    orangeLabel: {
        "id": "issue-epic-color.common.orange-label",
        "defaultMessage": "orange"
    },
    greyLabel: {
        "id": "issue-epic-color.common.grey-label",
        "defaultMessage": "grey"
    },
    darkPurpleLabel: {
        "id": "issue-epic-color.common.dark-purple-label",
        "defaultMessage": "dark purple"
    },
    darkBlueLabel: {
        "id": "issue-epic-color.common.dark-blue-label",
        "defaultMessage": "dark blue"
    },
    darkGreenLabel: {
        "id": "issue-epic-color.common.dark-green-label",
        "defaultMessage": "dark green"
    },
    darkTealLabel: {
        "id": "issue-epic-color.common.dark-teal-label",
        "defaultMessage": "dark teal"
    },
    darkYellowLabel: {
        "id": "issue-epic-color.common.dark-yellow-label",
        "defaultMessage": "dark yellow"
    },
    darkOrangeLabel: {
        "id": "issue-epic-color.common.dark-orange-label",
        "defaultMessage": "dark orange"
    },
    darkGreyLabel: {
        "id": "issue-epic-color.common.dark-grey-label",
        "defaultMessage": "dark grey"
    }
});

});



parcelRegister("bxXN4", function(module, exports) {

$parcel$export(module.exports, "useChartItemInteractions", () => $adb6f1ea918fa2b3$export$7de9fc62a8d2ea96);

var $eUqFw = parcelRequire("eUqFw");

var $hevaQ = parcelRequire("hevaQ");
/* A lightweight wrapper that orchestrates the interaction actions:
 * - Internally supplies the item id to the underlying actions so that the components don't have to
 * - Centralises the handling of timers (throttling, etc)
 */ const $adb6f1ea918fa2b3$export$7de9fc62a8d2ea96 = (id)=>{
    const timeoutId = (0, $eUqFw.useRef)(undefined);
    const frameId = (0, $eUqFw.useRef)(undefined);
    const [interactionState, interactionActions] = (0, $hevaQ.useInteractionData)(id);
    (0, $eUqFw.useEffect)(()=>()=>{
            frameId.current && cancelAnimationFrame(frameId.current);
            clearTimeout(timeoutId.current);
        }, []);
    const onDragStart = (0, $eUqFw.useCallback)((dragType)=>{
        interactionActions.onDragStart(id, dragType);
    }, [
        id,
        interactionActions
    ]);
    const onLingerStart = (0, $eUqFw.useCallback)(()=>{
        interactionActions.onLingerStart(id);
        timeoutId.current = setTimeout(()=>interactionActions.onLinger(), 200);
    }, [
        id,
        interactionActions
    ]);
    const onLingerEnd = (0, $eUqFw.useCallback)(()=>{
        clearTimeout(timeoutId.current);
        interactionActions.onLingerEnd();
    }, [
        interactionActions
    ]);
    const onPreview = (0, $eUqFw.useCallback)((previewX)=>{
        if (!frameId.current) frameId.current = requestAnimationFrame(()=>{
            frameId.current = undefined;
            interactionActions.onPreview(previewX);
        });
    }, [
        interactionActions
    ]);
    return [
        interactionState,
        {
            ...interactionActions,
            onDragStart: onDragStart,
            onLingerStart: onLingerStart,
            onLingerEnd: onLingerEnd,
            onPreview: onPreview
        }
    ];
};

});
parcelRegister("hevaQ", function(module, exports) {

$parcel$export(module.exports, "useResetChartInteractionState", () => $25c20dd0ba0dc6e6$export$fc4108d49b02ba94);
$parcel$export(module.exports, "useInteractionData", () => $25c20dd0ba0dc6e6$export$2f4e7606a05110d7);
$parcel$export(module.exports, "useTargetIntervalId", () => $25c20dd0ba0dc6e6$export$a93e57268029ba2d);
$parcel$export(module.exports, "useIntervalDropZoneData", () => $25c20dd0ba0dc6e6$export$6814590c602b8a2a);
$parcel$export(module.exports, "useIsHeaderModalActive", () => $25c20dd0ba0dc6e6$export$5eb5fe0fd641b668);
$parcel$export(module.exports, "useHeaderItemActions", () => $25c20dd0ba0dc6e6$export$fad9cd2384b134e0);
$parcel$export(module.exports, "RoadmapChartItemInteractionProvider", () => $25c20dd0ba0dc6e6$export$9d4771cc037ac267);

var $eUqFw = parcelRequire("eUqFw");

var $ggKAj = parcelRequire("ggKAj");
var $heB5U = parcelRequire("heB5U");
var $a61MH = parcelRequire("a61MH");

var $bwj1b = parcelRequire("bwj1b");
var $3XwA1 = parcelRequire("3XwA1");

var $94kLM = parcelRequire("94kLM");

var $97CZA = parcelRequire("97CZA");

var $bYbPQ = parcelRequire("bYbPQ");

var $ei022 = parcelRequire("ei022");

var $623w8 = parcelRequire("623w8");
const $25c20dd0ba0dc6e6$export$c830a1fa415103b0 = (0, $a61MH.createStore)({
    initialState: (0, $bYbPQ.DEFAULT_STATE),
    actions: $97CZA.actions,
    name: 'timeline-table-kit.table-providers.chart-item-interactions'
});
const $25c20dd0ba0dc6e6$var$useChartInteractionActions = (0, $ggKAj.createHook)($25c20dd0ba0dc6e6$export$c830a1fa415103b0, {
    selector: null
});
const $25c20dd0ba0dc6e6$export$fc4108d49b02ba94 = ()=>{
    const [, chartInteractionActions] = $25c20dd0ba0dc6e6$var$useChartInteractionActions();
    return {
        resetChartInteractionState: chartInteractionActions.onLingerEnd
    };
};
const $25c20dd0ba0dc6e6$export$2f4e7606a05110d7 = (0, $ggKAj.createHook)($25c20dd0ba0dc6e6$export$c830a1fa415103b0, {
    selector: (0, $ei022.getInteractionDataById)
});
const $25c20dd0ba0dc6e6$export$a93e57268029ba2d = (0, $ggKAj.createHook)($25c20dd0ba0dc6e6$export$c830a1fa415103b0, {
    selector: (0, $ei022.getTargetIntervalId)
});
const $25c20dd0ba0dc6e6$export$6814590c602b8a2a = (0, $ggKAj.createHook)($25c20dd0ba0dc6e6$export$c830a1fa415103b0, {
    selector: (0, $ei022.getIntervalDropZoneDataById)
});
const $25c20dd0ba0dc6e6$export$5eb5fe0fd641b668 = (0, $ggKAj.createHook)($25c20dd0ba0dc6e6$export$c830a1fa415103b0, {
    selector: (0, $ei022.getIsHeaderModalActive)
});
const $25c20dd0ba0dc6e6$export$fad9cd2384b134e0 = (0, $ggKAj.createActionsHook)($25c20dd0ba0dc6e6$export$c830a1fa415103b0);
const $25c20dd0ba0dc6e6$var$Container = (0, $heB5U.createContainer)($25c20dd0ba0dc6e6$export$c830a1fa415103b0);
const $25c20dd0ba0dc6e6$export$9d4771cc037ac267 = ({ items: items, selectedItemIds: selectedItemIds, isDragAlongEnabled: isDragAlongEnabled, intervals: intervals, children: children })=>{
    const sideEffectMarshal = (0, $bwj1b.useSideEffectMarshal)();
    const [{ timelineMode: timelineMode, timelineDuration: timelineDuration, timelineWidth: timelineWidth }] = (0, $3XwA1.useTimelineState)();
    const { updateViewportCache: updateViewportCache, adjustScrollPositionAndGetOffset: adjustScrollPositionAndGetOffset } = (0, $94kLM.useAdjustScrollPosition)();
    const simpleIntervals = (0, $623w8.getSimpleIntervals)(intervals, timelineDuration, timelineWidth);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($25c20dd0ba0dc6e6$var$Container, {
        items: items,
        selectedItemIds: selectedItemIds,
        sideEffectMarshal: sideEffectMarshal,
        timelineMode: timelineMode,
        timelineWidth: timelineWidth,
        timelineDuration: timelineDuration,
        setViewportCache: updateViewportCache,
        getScrollOffset: adjustScrollPositionAndGetOffset,
        isDragAlongEnabled: isDragAlongEnabled,
        simpleIntervals: simpleIntervals
    }, children);
};
$25c20dd0ba0dc6e6$export$9d4771cc037ac267.defaultProps = {
    selectedItemIds: []
};

});
parcelRegister("94kLM", function(module, exports) {

$parcel$export(module.exports, "adjustScrollPosition", () => $f3def37c59f5822f$export$9b07bbd51c0d1d84);
$parcel$export(module.exports, "useAdjustScrollPosition", () => $f3def37c59f5822f$export$6853243092b02409);

var $eUqFw = parcelRequire("eUqFw");

var $6TBpb = parcelRequire("6TBpb");

var $ix5qZ = parcelRequire("ix5qZ");
const $f3def37c59f5822f$var$calculateScrollOnDragLeft = (0, $ix5qZ.createCalculateScrollOnDragWithOffset)(120);
const $f3def37c59f5822f$var$calculateScrollOnDragTop = (0, $ix5qZ.createCalculateScrollOnDragWithOffset)(40);
const $f3def37c59f5822f$var$DEFAULT_VIEWPORT_CACHE = {
    scrollBoundingRect: undefined,
    viewportBoundingRect: undefined
};
const $f3def37c59f5822f$export$9b07bbd51c0d1d84 = (from, to, setViewportScroll, initialScrollBoundingRect, requestViewportScrollBounding, viewportBoundingRect, // Use current viewport scrollbounding if this is not defined
newScrollLeft, // Use current viewport scrollbounding if this is not defined
newScrollTop)=>{
    const initialScrollLeft = initialScrollBoundingRect ? initialScrollBoundingRect.scrollLeft : 0;
    const initialScrollTop = initialScrollBoundingRect ? initialScrollBoundingRect.scrollTop : 0;
    const { scrollLeft: scrollLeft, scrollWidth: scrollWidth, scrollTop: scrollTop, scrollHeight: scrollHeight } = requestViewportScrollBounding();
    let topScroll;
    let leftScroll;
    if (viewportBoundingRect) {
        const { width: width, left: left, right: right, top: top, height: height, bottom: bottom } = viewportBoundingRect;
        const newScrollTopValue = $f3def37c59f5822f$var$calculateScrollOnDragTop(height, top, bottom, to.y, to.y - from.y, scrollTop, scrollHeight - height);
        if (newScrollTopValue !== scrollTop && newScrollTopValue > 0) {
            setViewportScroll({
                scrollTop: newScrollTopValue
            });
            topScroll = newScrollTopValue;
        }
        const newScrollLeftValue = $f3def37c59f5822f$var$calculateScrollOnDragLeft(width, left, right, to.x, to.x - from.x, scrollLeft, scrollWidth - width);
        if (newScrollLeftValue !== scrollLeft && newScrollLeftValue > 0) {
            setViewportScroll({
                scrollLeft: newScrollLeftValue
            });
            leftScroll = newScrollLeftValue;
        }
    }
    return {
        scrollLeft: initialScrollLeft - (newScrollLeft !== undefined ? newScrollLeft : scrollLeft),
        scrollTop: initialScrollTop - (newScrollTop !== undefined ? newScrollTop : scrollTop),
        updatedScrollLeft: leftScroll,
        updatedScrollTop: topScroll
    };
};
const $f3def37c59f5822f$export$6853243092b02409 = ()=>{
    const viewportContext = (0, $6TBpb.useViewport)();
    const viewportCache = (0, $eUqFw.useRef)($f3def37c59f5822f$var$DEFAULT_VIEWPORT_CACHE);
    const baselineScrollLeft = (0, $eUqFw.useRef)(0);
    const baselineScrollTop = (0, $eUqFw.useRef)(0);
    const { requestViewportBoundingClient: requestViewportBoundingClient, requestViewportScrollBounding: requestViewportScrollBounding, setViewportScroll: setViewportScroll } = viewportContext;
    const updateViewportCache = (0, $eUqFw.useCallback)(()=>{
        const scrollBoundingRect = requestViewportScrollBounding();
        const viewportBoundingRect = requestViewportBoundingClient();
        viewportCache.current = {
            viewportBoundingRect: viewportBoundingRect,
            scrollBoundingRect: scrollBoundingRect
        };
        baselineScrollLeft.current = scrollBoundingRect.scrollLeft;
        baselineScrollTop.current = scrollBoundingRect.scrollTop;
    }, [
        requestViewportBoundingClient,
        requestViewportScrollBounding
    ]);
    // The offset between the old and new scroll positions is returned.
    // This can be used to help keep a drag element up to date with the mouse position.
    const adjustScrollPositionAndGetOffset = (0, $eUqFw.useCallback)((from, to)=>{
        const { scrollBoundingRect: scrollBoundingRect, viewportBoundingRect: viewportBoundingRect } = viewportCache.current;
        const { scrollLeft: scrollLeft, updatedScrollLeft: updatedScrollLeft } = $f3def37c59f5822f$export$9b07bbd51c0d1d84(from, to, setViewportScroll, scrollBoundingRect, requestViewportScrollBounding, viewportBoundingRect, baselineScrollLeft.current, baselineScrollTop.current);
        if (updatedScrollLeft !== undefined) baselineScrollLeft.current = updatedScrollLeft;
        return scrollLeft;
    }, [
        setViewportScroll,
        requestViewportScrollBounding
    ]);
    return {
        updateViewportCache: updateViewportCache,
        adjustScrollPositionAndGetOffset: adjustScrollPositionAndGetOffset
    };
};

});
parcelRegister("ix5qZ", function(module, exports) {

$parcel$export(module.exports, "createCalculateScrollOnDragWithOffset", () => $c40412c71cf2dbf1$export$62b7f59ff4b39d81);
const $c40412c71cf2dbf1$var$SCROLL_SCALE_WITH_OFFSET = 2;
const $c40412c71cf2dbf1$var$getWeightedScrollAmountWithOffset = (scrollAmount)=>Math.round(scrollAmount ** $c40412c71cf2dbf1$var$SCROLL_SCALE_WITH_OFFSET);
const $c40412c71cf2dbf1$var$SCROLL_MAX = 150;
const $c40412c71cf2dbf1$var$getThrottledScrollAmount = (scrollAmount)=>Math.min($c40412c71cf2dbf1$var$SCROLL_MAX, scrollAmount);
const $c40412c71cf2dbf1$export$62b7f59ff4b39d81 = (scrollThreshold)=>(height, top, bottom, cursorOffset, cursorOffsetDiff, scrollPosition, scrollSize)=>{
        // Fallback to current scrollPosition
        let newScrollPosition = scrollPosition;
        // small tables need a fallback threshold derived from its' size
        const threshold = Math.min(height / 2, scrollThreshold);
        if (cursorOffset > top && cursorOffset <= top + threshold && cursorOffsetDiff < 0) {
            // inversely relative to distance to list top
            const scrollAmount = $c40412c71cf2dbf1$var$getWeightedScrollAmountWithOffset(1 / ((cursorOffset - top) / threshold));
            const throttledScrollAmount = $c40412c71cf2dbf1$var$getThrottledScrollAmount(scrollAmount);
            // don't scroll beyond the list start
            newScrollPosition = Math.max(0, scrollPosition - throttledScrollAmount);
        } else if (cursorOffset < bottom && cursorOffset >= bottom - threshold && cursorOffset > 0) {
            // inversely relative to distance to list bottom
            const scrollAmount = $c40412c71cf2dbf1$var$getWeightedScrollAmountWithOffset(1 / ((bottom - cursorOffset) / threshold));
            const throttledScrollAmount = $c40412c71cf2dbf1$var$getThrottledScrollAmount(scrollAmount);
            // don't scroll beyond the list end
            newScrollPosition = Math.min(scrollSize, scrollPosition + throttledScrollAmount);
        }
        return newScrollPosition;
    };

});


parcelRegister("97CZA", function(module, exports) {

$parcel$export(module.exports, "actions", () => $831fef74b7670418$export$e324594224ef24da);

var $d7OQi = parcelRequire("d7OQi");

var $dJqdT = parcelRequire("dJqdT");

var $53tmg = parcelRequire("53tmg");

var $aadAS = parcelRequire("aadAS");

var $jfM9p = parcelRequire("jfM9p");

var $gLLn4 = parcelRequire("gLLn4");

var $eqZIm = parcelRequire("eqZIm");

var $dF5k3 = parcelRequire("dF5k3");
const $831fef74b7670418$export$e324594224ef24da = {
    onDrag: $d7OQi.onDrag,
    onDragEnd: $dJqdT.onDragEnd,
    onDragStart: $53tmg.onDragStart,
    onLinger: $aadAS.onLinger,
    onLingerEnd: $jfM9p.onLingerEnd,
    onLingerStart: $gLLn4.onLingerStart,
    onPreview: $eqZIm.onPreview,
    onToggleHeaderModal: $dF5k3.onToggleHeaderModal
};

});
parcelRegister("d7OQi", function(module, exports) {

$parcel$export(module.exports, "onDrag", () => $a0580fae0e3e9274$export$11a07b18d6f8f6d2);

var $1RX3i = parcelRequire("1RX3i");

var $4m3tp = parcelRequire("4m3tp");
const $a0580fae0e3e9274$export$11a07b18d6f8f6d2 = (from, to, start)=>({ setState: setState, getState: getState }, containerProps)=>{
        const { activeItem: activeItem, dragType: dragType, itemPositions: itemPositions, previewBaselinePosition: previewBaselinePosition } = getState();
        if (!activeItem || !dragType) return;
        let dragResult;
        const { startDate: startDate, dueDate: dueDate } = activeItem;
        if (startDate === undefined && dueDate === undefined && previewBaselinePosition) {
            // Refine types to prove to flow that both dates are always absent
            const noDateActiveItem = {
                ...activeItem,
                startDate: startDate,
                dueDate: dueDate
            };
            dragResult = (0, $4m3tp.onNoDateDrag)({
                from: from,
                to: to,
                start: start
            }, {
                activeItem: noDateActiveItem,
                dragType: dragType,
                previewBaselinePosition: previewBaselinePosition
            }, containerProps);
        } else if (startDate !== undefined && dueDate !== undefined) {
            // Refine types to prove to flow that both dates are always present
            const dateActiveItem = {
                ...activeItem,
                startDate: startDate,
                dueDate: dueDate
            };
            dragResult = (0, $1RX3i.onDateDrag)({
                from: from,
                to: to,
                start: start
            }, {
                activeItem: dateActiveItem,
                dragType: dragType,
                itemPositions: itemPositions
            }, containerProps);
        }
        // In case of an invalid drag (e.g. out of bounds) there will be no drag result
        dragResult && setState(dragResult);
    };

});
parcelRegister("1RX3i", function(module, exports) {

$parcel$export(module.exports, "onDateDrag", () => $e264ad6ddb4ca35f$export$6abaacf95e615b18);

var $8blac = parcelRequire("8blac");

var $1ybV0 = parcelRequire("1ybV0");

var $fHtBB = parcelRequire("fHtBB");
var $4P2VV = parcelRequire("4P2VV");

var $81Dhf = parcelRequire("81Dhf");

var $5WPbd = parcelRequire("5WPbd");
const $e264ad6ddb4ca35f$export$6abaacf95e615b18 = (dragPosition, { activeItem: activeItem, dragType: dragType, itemPositions: itemPositions }, { items: items, selectedItemIds: selectedItemIds, timelineDuration: timelineDuration, timelineWidth: timelineWidth, isDragAlongEnabled: isDragAlongEnabled, getScrollOffset: getScrollOffset, simpleIntervals: simpleIntervals })=>{
    const gridSize = (0, $81Dhf.getGridSize)(timelineDuration, timelineWidth);
    const scrollOffset = getScrollOffset(dragPosition.from, dragPosition.to);
    const { selectedItems: selectedItems, childItemsHash: childItemsHash } = (0, $5WPbd.getItemsCollection)(items, selectedItemIds);
    const newItemPositions = {};
    const handleDrag = (targetItem)=>{
        const { leftPosition: leftPosition, rightPosition: rightPosition } = (0, $5WPbd.getDragPosition)(dragType, targetItem, timelineDuration, timelineWidth, dragPosition, gridSize, scrollOffset);
        // In case of an invalid drag (e.g. out of bounds) neither positions will be defined
        if (leftPosition === undefined && rightPosition === undefined) return;
        const { id: id, parentId: parentId } = targetItem;
        newItemPositions[id] = {
            leftPosition: leftPosition,
            rightPosition: rightPosition
        };
        // Depending on the interaction, an item with children can result in updating their positions also
        if (isDragAlongEnabled && (parentId === undefined || (0, $1ybV0.ff)('jwm.visual-hierarchy-milestone-1')) && dragType === (0, $4P2VV.LEFT_AND_RIGHT)) {
            const childItems = childItemsHash[id] || [];
            // Move the parent item along with its children
            childItems.forEach((childItem)=>{
                const { leftPosition: childLeftPosition, rightPosition: childRightPosition } = (0, $5WPbd.getDragPosition)(dragType, childItem, timelineDuration, timelineWidth, dragPosition, gridSize, scrollOffset);
                if (childLeftPosition !== undefined || childRightPosition !== undefined) newItemPositions[childItem.id] = {
                    leftPosition: childLeftPosition,
                    rightPosition: childRightPosition
                };
            });
        }
    };
    let targetIntervalId;
    const { id: id, intervalId: intervalId, startDateType: startDateType, dueDateType: dueDateType } = activeItem;
    // bulk-scheduling (bar-dragging and bar-resizing) is only available when
    // - there is more than one item selected
    // - the active item is part of the selection
    // - the items selected are schedulable (i.e. their dates are not derived from intervals. Currently only base-level issues in scrum fit)
    if (selectedItemIds.length > 1 && selectedItemIds.includes(id) && startDateType !== (0, $fHtBB.INTERVAL) && dueDateType !== (0, $fHtBB.INTERVAL)) {
        selectedItems.forEach((item)=>{
            handleDrag(item);
        });
        if ((0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(newItemPositions)) return undefined;
    } else {
        handleDrag(activeItem);
        if ((0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(newItemPositions)) return undefined;
        const { leftPosition: leftPosition, rightPosition: rightPosition } = newItemPositions[id];
        if (intervalId !== undefined && dragType === (0, $4P2VV.LEFT_AND_RIGHT) && leftPosition !== undefined && rightPosition !== undefined) {
            const midPosition = (timelineWidth - rightPosition - leftPosition) / 2 + leftPosition;
            const unsafeTargetIntervalId = (0, $81Dhf.getTargetIntervalId)(simpleIntervals, timelineWidth, midPosition);
            // Skip setting to an items existing assigned intervals
            if (unsafeTargetIntervalId !== intervalId) targetIntervalId = unsafeTargetIntervalId;
        }
    }
    return {
        itemPositions: {
            ...itemPositions,
            ...newItemPositions
        },
        targetIntervalId: targetIntervalId
    };
};

});
parcelRegister("81Dhf", function(module, exports) {

$parcel$export(module.exports, "to1DP", () => $ef4f0afa86695ff4$export$6c9c23d367dcea0f);
$parcel$export(module.exports, "getTargetIntervalId", () => $ef4f0afa86695ff4$export$fd188f2e31f7a51c);
$parcel$export(module.exports, "getGridSize", () => $ef4f0afa86695ff4$export$3a0507da8b146ff1);
$parcel$export(module.exports, "snapToGrid", () => $ef4f0afa86695ff4$export$195604d042fd3f87);

var $5iWql = parcelRequire("5iWql");

var $jJwwt = parcelRequire("jJwwt");
const $ef4f0afa86695ff4$export$6c9c23d367dcea0f = (value)=>Math.round((value + Number.EPSILON) * 10) / 10;
const $ef4f0afa86695ff4$export$fd188f2e31f7a51c = (simpleIntervals, timelineWidth, posX)=>{
    const overlappingIntervals = simpleIntervals.filter(({ leftPosition: leftPosition, rightPosition: rightPosition })=>{
        const isItemStartEqualToOrGreaterThanIntervalStart = $ef4f0afa86695ff4$export$6c9c23d367dcea0f(posX) >= $ef4f0afa86695ff4$export$6c9c23d367dcea0f(leftPosition);
        const isItemStartLessThanIntervalEnd = $ef4f0afa86695ff4$export$6c9c23d367dcea0f(posX) < $ef4f0afa86695ff4$export$6c9c23d367dcea0f(timelineWidth - rightPosition);
        return isItemStartEqualToOrGreaterThanIntervalStart && isItemStartLessThanIntervalEnd;
    });
    return overlappingIntervals.length > 0 ? overlappingIntervals[0].targetId : undefined;
};
const $ef4f0afa86695ff4$export$3a0507da8b146ff1 = (0, $5iWql.default)(({ endMilliseconds: endMilliseconds, startMilliseconds: startMilliseconds }, timelineWidth)=>{
    const numberOfDaysInTimeline = (0, (/*@__PURE__*/$parcel$interopDefault($jJwwt)))(endMilliseconds).diff(startMilliseconds, 'days') + 1;
    return timelineWidth / numberOfDaysInTimeline;
});
const $ef4f0afa86695ff4$export$195604d042fd3f87 = (position, gridSize, offset = 0)=>{
    const roundedOffset = Math.round(offset / gridSize) * gridSize;
    return position + roundedOffset;
};

});

parcelRegister("5WPbd", function(module, exports) {

$parcel$export(module.exports, "getDragPosition", () => $6bdbb0ab06e4e356$export$43fc86aa4efa07b0);
$parcel$export(module.exports, "getItemsCollection", () => $6bdbb0ab06e4e356$export$68a20f16cafe8131);

var $5iWql = parcelRequire("5iWql");

var $1ybV0 = parcelRequire("1ybV0");

var $c3IKH = parcelRequire("c3IKH");
var $4P2VV = parcelRequire("4P2VV");
var $fHtBB = parcelRequire("fHtBB");

var $cww1R = parcelRequire("cww1R");

var $81Dhf = parcelRequire("81Dhf");
const $6bdbb0ab06e4e356$export$38e26b36381469ee = (dragType, hasLeftPlaceholder, dateType)=>dragType === (0, $4P2VV.LEFT_AND_RIGHT) || dragType === (0, $4P2VV.LEFT) || dragType === (0, $4P2VV.RIGHT) && hasLeftPlaceholder && dateType !== (0, $fHtBB.ROLLUP);
const $6bdbb0ab06e4e356$export$40ce9920ffc376d2 = (dragType, hasRightPlaceholder, dateType)=>dragType === (0, $4P2VV.LEFT_AND_RIGHT) || dragType === (0, $4P2VV.RIGHT) || dragType === (0, $4P2VV.LEFT) && hasRightPlaceholder && dateType !== (0, $fHtBB.ROLLUP);
const $6bdbb0ab06e4e356$export$94ff4f58995a561 = (dragType, leftPosition, rightPosition, timelineWidth, direction)=>{
    if (dragType === (0, $4P2VV.LEFT_AND_RIGHT) && leftPosition < 0 && direction === (0, $4P2VV.LEFT)) return false;
    if (dragType === (0, $4P2VV.LEFT_AND_RIGHT) && rightPosition < 0 && direction === (0, $4P2VV.RIGHT)) return false;
    if (dragType === (0, $4P2VV.LEFT) && (leftPosition < 0 || leftPosition > timelineWidth)) return false;
    if (dragType === (0, $4P2VV.RIGHT) && (rightPosition < 0 || rightPosition > timelineWidth)) return false;
    if (dragType === (0, $4P2VV.LEFT) || dragType === (0, $4P2VV.RIGHT)) // Cannot be smaller than the minimum width
    return timelineWidth - rightPosition - leftPosition > (0, $c3IKH.MINIMUM_BAR_LENGTH);
    return true;
};
const $6bdbb0ab06e4e356$var$getDragDirection = (dragType, leftPosition, baselineLeftPosition)=>{
    if (dragType === (0, $4P2VV.LEFT_AND_RIGHT)) return leftPosition !== undefined && leftPosition < baselineLeftPosition ? (0, $4P2VV.LEFT) : (0, $4P2VV.RIGHT);
    if (dragType === (0, $4P2VV.LEFT)) return 0, $4P2VV.LEFT;
    return 0, $4P2VV.RIGHT;
};
const $6bdbb0ab06e4e356$export$43fc86aa4efa07b0 = (dragType, item, timelineDuration, timelineWidth, { to: to, start: start }, gridSize, scrollOffset)=>{
    let leftPosition;
    let rightPosition;
    const { startDate: startDate, dueDate: dueDate, placeholder: placeholder, startDateType: startDateType, dueDateType: dueDateType } = item;
    const baselineLeftPosition = (0, $cww1R.getBarLeftPosition)(startDate, timelineDuration, timelineWidth);
    const baselineRightPosition = (0, $cww1R.getBarRightPosition)(dueDate, timelineDuration, timelineWidth);
    const hasLeftPlaceholder = placeholder === (0, $c3IKH.START_DATE_PLACEHOLDER) || placeholder === (0, $c3IKH.START_AND_DUE_DATE_PLACEHOLDER);
    const hasRightPlaceholder = placeholder === (0, $c3IKH.DUE_DATE_PLACEHOLDER) || placeholder === (0, $c3IKH.START_AND_DUE_DATE_PLACEHOLDER);
    if ($6bdbb0ab06e4e356$export$38e26b36381469ee(dragType, hasLeftPlaceholder, startDateType)) {
        const offset = to.x - start.x - scrollOffset;
        leftPosition = (0, $81Dhf.snapToGrid)(baselineLeftPosition, gridSize, offset);
    }
    if ($6bdbb0ab06e4e356$export$40ce9920ffc376d2(dragType, hasRightPlaceholder, dueDateType)) {
        const offset = start.x - to.x + scrollOffset;
        rightPosition = (0, $81Dhf.snapToGrid)(baselineRightPosition, gridSize, offset);
    }
    const actualLeftPosition = leftPosition ?? baselineLeftPosition;
    const actualRightPosition = rightPosition ?? baselineRightPosition;
    const direction = $6bdbb0ab06e4e356$var$getDragDirection(dragType, leftPosition, baselineLeftPosition);
    if ($6bdbb0ab06e4e356$export$94ff4f58995a561(dragType, actualLeftPosition, actualRightPosition, timelineWidth, direction)) return {
        leftPosition: leftPosition,
        rightPosition: rightPosition
    };
    return {
        leftPosition: undefined,
        rightPosition: undefined
    };
};
const $6bdbb0ab06e4e356$export$d3d9395e56d22d2a = (0, $5iWql.default)((items, selectedItemIds)=>{
    const selectedItems = [];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const childItemsHash = {};
    items.forEach((item)=>{
        if (item.startDate === undefined || item.dueDate === undefined) return;
        selectedItemIds.includes(item.id) && // NOTE: InteractiveChartItem startDate and dueDate type is number | undefined, but we checked whether it is undefined above. DateInteractiveChartItem startDate and dueDate type is number.
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        selectedItems.push(item);
        if (item.parentId !== undefined) {
            const childItems = childItemsHash[item.parentId];
            childItemsHash[item.parentId] = childItems ? childItems.concat([
                item
            ]) : [
                item
            ];
        }
    });
    return {
        selectedItems: selectedItems,
        childItemsHash: childItemsHash
    };
});
const $6bdbb0ab06e4e356$var$isDateInteractiveChartItem = (item)=>item.startDate !== undefined && item.dueDate !== undefined;
const $6bdbb0ab06e4e356$export$5ea7f78a215e80f5 = (0, $5iWql.default)((items, selectedItemIds)=>{
    const itemsTree = items.reduce((acc, item)=>{
        if (item.parentId && $6bdbb0ab06e4e356$var$isDateInteractiveChartItem(item)) {
            const childItems = acc[item.parentId] ?? [];
            childItems.push(item);
            acc[item.parentId] = childItems;
        }
        return acc;
    }, {});
    const descendantItemsHash = {};
    const findDescendants = (parentId)=>{
        if (descendantItemsHash[parentId]) return descendantItemsHash[parentId];
        const children = itemsTree[parentId] ?? [];
        const descendants = children.flatMap((child)=>[
                child,
                ...findDescendants(child.id)
            ]);
        descendantItemsHash[parentId] = descendants;
        return descendants;
    };
    return items.reduce((acc, item)=>{
        if (!$6bdbb0ab06e4e356$var$isDateInteractiveChartItem(item)) return acc;
        if (selectedItemIds.includes(item.id)) acc.selectedItems.push(item);
        if (item.parentId) acc.childItemsHash[item.parentId] = findDescendants(item.parentId);
        return acc;
    }, {
        selectedItems: [],
        childItemsHash: {}
    });
});
const $6bdbb0ab06e4e356$export$68a20f16cafe8131 = (items, selectedItemIds)=>(0, $1ybV0.ff)('jwm.visual-hierarchy-milestone-1') ? $6bdbb0ab06e4e356$export$5ea7f78a215e80f5(items, selectedItemIds) : $6bdbb0ab06e4e356$export$d3d9395e56d22d2a(items, selectedItemIds);

});


parcelRegister("4m3tp", function(module, exports) {

$parcel$export(module.exports, "onNoDateDrag", () => $3e1025a76856b3d8$export$30770ba27cbf606f);

var $4P2VV = parcelRequire("4P2VV");

var $81Dhf = parcelRequire("81Dhf");

var $6cmG2 = parcelRequire("6cmG2");
const $3e1025a76856b3d8$export$30770ba27cbf606f = ({ from: from, to: to, start: start }, { activeItem: activeItem, dragType: dragType, previewBaselinePosition: previewBaselinePosition }, { timelineDuration: timelineDuration, timelineWidth: timelineWidth, getScrollOffset: getScrollOffset, simpleIntervals: simpleIntervals })=>{
    const gridSize = (0, $81Dhf.getGridSize)(timelineDuration, timelineWidth);
    const scrollOffset = getScrollOffset(from, to);
    const startPosition = previewBaselinePosition.leftPosition;
    let leftPosition;
    let rightPosition;
    let nextDragType;
    if (dragType === (0, $4P2VV.LEFT)) {
        const offset = to.x - start.x - scrollOffset;
        rightPosition = timelineWidth - startPosition;
        leftPosition = (0, $81Dhf.snapToGrid)(startPosition, gridSize, offset);
        nextDragType = leftPosition < startPosition ? (0, $4P2VV.LEFT) : (0, $4P2VV.RIGHT);
    } else {
        const offset = to.x - start.x - scrollOffset;
        leftPosition = startPosition;
        rightPosition = timelineWidth - (0, $81Dhf.snapToGrid)(startPosition, gridSize, offset);
        nextDragType = timelineWidth - rightPosition < startPosition ? (0, $4P2VV.LEFT) : (0, $4P2VV.RIGHT);
    }
    if (!(0, $6cmG2.isValidDrag)(leftPosition, rightPosition, gridSize, timelineWidth)) return undefined;
    const targetIntervalId = (0, $81Dhf.getTargetIntervalId)(simpleIntervals, timelineWidth, leftPosition);
    return {
        itemPositions: {
            [`${activeItem.id}`]: {
                leftPosition: leftPosition,
                rightPosition: rightPosition
            }
        },
        targetIntervalId: targetIntervalId,
        dragType: nextDragType
    };
};

});
parcelRegister("6cmG2", function(module, exports) {

$parcel$export(module.exports, "isValidDrag", () => $9b739c155524713e$export$94ff4f58995a561);

var $81Dhf = parcelRequire("81Dhf");
const $9b739c155524713e$export$94ff4f58995a561 = (leftPosition, rightPosition, gridSize, timelineWidth)=>{
    const distance = Math.abs(timelineWidth - rightPosition - leftPosition);
    return (0, $81Dhf.to1DP)(distance) >= (0, $81Dhf.to1DP)(gridSize);
};

});



parcelRegister("dJqdT", function(module, exports) {

$parcel$export(module.exports, "onDragEnd", () => $d5e7f1bb3a9c4b50$export$8566066e92caa8a);

var $bYbPQ = parcelRequire("bYbPQ");
const $d5e7f1bb3a9c4b50$export$8566066e92caa8a = ()=>({ setState: setState }, { sideEffectMarshal: sideEffectMarshal })=>{
        sideEffectMarshal.custom.onBarInteractionEnd();
        /* Don't reset activeItem, the mouse remains on the item after drag finishes so it is still "active".
		 * Don't reset hasLingered, the user may still intend to interact again. Without it, we won't show any target intervals.
		 */ const { activeItem: activeItem, hasLingered: hasLingered, ...defaultState } = (0, $bYbPQ.DEFAULT_STATE);
        setState(defaultState);
    };

});
parcelRegister("bYbPQ", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_STATE", () => $e648e84a85a5c3db$export$a3a6a28ae8823b06);
const $e648e84a85a5c3db$export$a3a6a28ae8823b06 = {
    activeItem: undefined,
    hasLingered: false,
    dragType: undefined,
    itemPositions: {},
    targetIntervalId: undefined,
    isHeaderModalActive: false,
    previewBaselinePosition: undefined
};

});


parcelRegister("53tmg", function(module, exports) {

$parcel$export(module.exports, "onDragStart", () => $04a7943594562b62$export$b00174fdb6a6ab8f);

var $fHtBB = parcelRequire("fHtBB");

var $5Hx5H = parcelRequire("5Hx5H");
const $04a7943594562b62$export$b00174fdb6a6ab8f = (id, dragType)=>({ getState: getState, setState: setState }, { items: items, sideEffectMarshal: sideEffectMarshal, setViewportCache: setViewportCache })=>{
        const activeItem = items.find((item)=>item.id === id);
        if (activeItem) {
            const { itemPositions: itemPositions, hasLingered: hasLingeredFromState } = getState();
            const previewBaselinePosition = (0, $5Hx5H.getPreviewBaselinePosition)(activeItem, itemPositions);
            /* Reset hasLingered for non-INTERVAL type, we don't highlight target interval while dragging.
			 */ const hasLingered = activeItem.startDateType === (0, $fHtBB.INTERVAL) && activeItem.dueDateType === (0, $fHtBB.INTERVAL) ? hasLingeredFromState : false;
            setViewportCache();
            sideEffectMarshal.custom.onBarInteractionStart();
            setState({
                activeItem: activeItem,
                dragType: dragType,
                previewBaselinePosition: previewBaselinePosition,
                hasLingered: hasLingered
            });
        }
    };

});
parcelRegister("5Hx5H", function(module, exports) {

$parcel$export(module.exports, "getPreviewBaselinePosition", () => $c695995dbeb4f280$export$6e65532e85c8e991);
const $c695995dbeb4f280$export$6e65532e85c8e991 = (activeItem, itemPositions)=>{
    let previewBaselinePosition;
    const { id: id, startDate: startDate, dueDate: dueDate } = activeItem;
    if (startDate === undefined && dueDate === undefined && itemPositions[id]) {
        const { leftPosition: leftPosition, rightPosition: rightPosition } = itemPositions[id];
        if (leftPosition !== undefined && rightPosition !== undefined) previewBaselinePosition = {
            leftPosition: leftPosition,
            rightPosition: rightPosition
        };
    }
    return previewBaselinePosition;
};

});


parcelRegister("aadAS", function(module, exports) {

$parcel$export(module.exports, "onLinger", () => $1e4f1410163d8f3a$export$c9ef8a8ee2b7f513);

var $fHtBB = parcelRequire("fHtBB");

var $81Dhf = parcelRequire("81Dhf");
const $1e4f1410163d8f3a$export$c9ef8a8ee2b7f513 = ()=>({ getState: getState, setState: setState }, { timelineWidth: timelineWidth, simpleIntervals: simpleIntervals })=>{
        const { activeItem: activeItem, itemPositions: itemPositions } = getState();
        if (activeItem?.startDateType === (0, $fHtBB.INTERVAL) && activeItem?.dueDateType === (0, $fHtBB.INTERVAL) || activeItem?.intervalId !== undefined) {
            let targetIntervalId;
            const { id: id, startDate: startDate, dueDate: dueDate, intervalId: intervalId } = activeItem;
            const leftPosition = itemPositions[id]?.leftPosition;
            /* For existing items, we can directly compare their pre-existing interval.
			 * Otherwise, for previews that don't have an interval yet, we can compare interval positions.
			 */ if (startDate !== undefined && dueDate !== undefined) {
                const isIntervalExists = simpleIntervals.find(({ intervalIds: intervalIds })=>intervalId && intervalIds.includes(intervalId));
                if (isIntervalExists) targetIntervalId = intervalId;
            } else if (/* Don't highlight target interval id if a date-based item has no dates
				 */ leftPosition !== undefined && activeItem.startDateType === (0, $fHtBB.INTERVAL) && activeItem.dueDateType === (0, $fHtBB.INTERVAL)) targetIntervalId = (0, $81Dhf.getTargetIntervalId)(simpleIntervals, timelineWidth, leftPosition);
            setState({
                hasLingered: true,
                targetIntervalId: targetIntervalId
            });
        }
    };

});

parcelRegister("jfM9p", function(module, exports) {

$parcel$export(module.exports, "onLingerEnd", () => $0501fab761d3150a$export$5066f5e6e6738857);

var $bYbPQ = parcelRequire("bYbPQ");
const $0501fab761d3150a$export$5066f5e6e6738857 = ()=>({ getState: getState, setState: setState })=>{
        const { dragType: dragType } = getState();
        /* The current affordance allows users to continue dragging an item even if
		 * their cursor moves to an adjacent row. Do *not* reset the state in this
		 * circumstance or it will cancel the drag interaction.
		 */ if (dragType === undefined) setState((0, $bYbPQ.DEFAULT_STATE));
    };

});

parcelRegister("gLLn4", function(module, exports) {

$parcel$export(module.exports, "onLingerStart", () => $7c3de49c7a130000$export$bb211627ff50e51b);
const $7c3de49c7a130000$export$bb211627ff50e51b = (id)=>({ getState: getState, setState: setState }, { items: items })=>{
        const { dragType: dragType } = getState();
        const activeItem = items.find((item)=>item.id === id);
        /* The current affordance allows users to continue dragging an item even if
		 * their cursor moves to an adjacent row. Do *not* override the active item
		 * in this circumstance or it will cancel the drag interaction.
		 */ if (activeItem !== undefined && dragType === undefined) setState({
            activeItem: activeItem
        });
    };

});

parcelRegister("eqZIm", function(module, exports) {

$parcel$export(module.exports, "onPreview", () => $acc1b9163d3f4bad$export$9d4a8aef590e6b33);

var $gf0vG = parcelRequire("gf0vG");

var $fHtBB = parcelRequire("fHtBB");

var $81Dhf = parcelRequire("81Dhf");
const $acc1b9163d3f4bad$var$TIMELINE_MODE_OFFSET = {
    [(0, $gf0vG.WEEKS)]: 7,
    [(0, $gf0vG.MONTHS)]: 14,
    [(0, $gf0vG.QUARTERS)]: 30
};
const $acc1b9163d3f4bad$export$9d4a8aef590e6b33 = (previewX)=>({ getState: getState, setState: setState }, { timelineMode: timelineMode, timelineDuration: timelineDuration, timelineWidth: timelineWidth, simpleIntervals: simpleIntervals })=>{
        const { activeItem: activeItem, dragType: dragType } = getState();
        // Dragging interactions have precedence (interactions should be mutually exclusive)
        if (!activeItem || activeItem && dragType) return;
        const isInterval = activeItem.startDateType === (0, $fHtBB.INTERVAL) && activeItem.dueDateType === (0, $fHtBB.INTERVAL);
        let leftPosition;
        let rightPosition;
        let targetIntervalId;
        const gridSize = (0, $81Dhf.getGridSize)(timelineDuration, timelineWidth);
        const leftPositionSnapToGrid = (0, $81Dhf.snapToGrid)(0, gridSize, previewX);
        if (!isInterval) {
            const rightOffset = $acc1b9163d3f4bad$var$TIMELINE_MODE_OFFSET[timelineMode] * gridSize;
            leftPosition = leftPositionSnapToGrid;
            rightPosition = timelineWidth - (leftPosition + rightOffset);
        } else /**
			 * An item will not have mixed date types when one side is INTERVAL.
			 * When startDateType is INTERVAL, it's dueDateType will be INTERVAL, too.
			 */ targetIntervalId = (0, $81Dhf.getTargetIntervalId)(simpleIntervals, timelineWidth, previewX);
        setState({
            itemPositions: {
                [`${activeItem.id}`]: {
                    leftPosition: leftPosition,
                    rightPosition: rightPosition
                }
            },
            targetIntervalId: targetIntervalId
        });
    };

});

parcelRegister("dF5k3", function(module, exports) {

$parcel$export(module.exports, "onToggleHeaderModal", () => $24570f01504beb05$export$8560de0545726746);
const $24570f01504beb05$export$8560de0545726746 = (isActive)=>({ setState: setState })=>{
        setState({
            isHeaderModalActive: isActive
        });
    };

});


parcelRegister("ei022", function(module, exports) {

$parcel$export(module.exports, "getTargetIntervalId", () => $25f3660e38a08887$export$fd188f2e31f7a51c);
$parcel$export(module.exports, "getInteractionDataById", () => $25f3660e38a08887$export$56ac7aa92dc17fde);
$parcel$export(module.exports, "getIsHeaderModalActive", () => $25f3660e38a08887$export$1c272fb440996072);
$parcel$export(module.exports, "getIntervalDropZoneDataById", () => $25f3660e38a08887$export$416f05e681eaec5b);

var $fHtBB = parcelRequire("fHtBB");
const $25f3660e38a08887$export$fd188f2e31f7a51c = ({ targetIntervalId: targetIntervalId, hasLingered: hasLingered }, intervals)=>{
    if (hasLingered) {
        const targetInterval = intervals.find(({ id: id })=>id === targetIntervalId);
        return targetInterval?.id;
    }
    return undefined;
};
const $25f3660e38a08887$export$56ac7aa92dc17fde = ({ activeItem: activeItem, dragType: dragType, itemPositions: itemPositions }, id)=>{
    const leftPosition = itemPositions[id]?.leftPosition;
    const rightPosition = itemPositions[id]?.rightPosition;
    const hasAnyPosition = leftPosition !== undefined || rightPosition !== undefined;
    return {
        isActive: activeItem?.id === id,
        leftPosition: leftPosition,
        rightPosition: rightPosition,
        dragType: hasAnyPosition ? dragType : undefined
    };
};
const $25f3660e38a08887$export$1c272fb440996072 = ({ isHeaderModalActive: isHeaderModalActive })=>({
        isHeaderModalActive: isHeaderModalActive
    });
const $25f3660e38a08887$export$416f05e681eaec5b = ({ activeItem: activeItem, dragType: dragType, hasLingered: hasLingered }, id)=>{
    if (!activeItem || activeItem.id !== id || activeItem.startDateType !== (0, $fHtBB.INTERVAL) && activeItem.dueDateType !== (0, $fHtBB.INTERVAL)) return {
        isVisible: false,
        currentIntervalId: undefined
    };
    if (activeItem.startDate !== undefined && activeItem.dueDate !== undefined) return {
        isVisible: dragType !== undefined,
        currentIntervalId: activeItem.intervalId
    };
    return {
        isVisible: hasLingered,
        currentIntervalId: activeItem.intervalId
    };
};

});

parcelRegister("623w8", function(module, exports) {

$parcel$export(module.exports, "getSimpleIntervals", () => $bf42115b0ccbec92$export$ba37947e5e9cffea);

var $5iWql = parcelRequire("5iWql");


var $9j4Ay = parcelRequire("9j4Ay");
const $bf42115b0ccbec92$export$ba37947e5e9cffea = (0, $5iWql.default)((intervals, timelineDuration, timelineWidth)=>{
    const intervalGroups = (0, $9j4Ay.getIntervalGroupPositions)(intervals, timelineDuration, timelineWidth);
    const simpleIntervals = [];
    intervalGroups.forEach((intervalGroup)=>{
        const leftPosition = Math.max(intervalGroup.left, intervalGroup.targetIntervalLeft);
        const rightPosition = Math.max(intervalGroup.right, intervalGroup.targetIntervalRight);
        const targetInterval = intervalGroup.intervals.find((interval)=>interval.state !== (0, $4a21b57a573cad8c$export$19c4f83398a8dbce));
        const intervalIds = intervals.map((interval)=>interval.id);
        if (targetInterval) simpleIntervals.push({
            targetId: targetInterval.id,
            leftPosition: leftPosition,
            rightPosition: rightPosition,
            intervalIds: intervalIds
        });
    });
    return simpleIntervals;
});

});
parcelRegister("9j4Ay", function(module, exports) {

$parcel$export(module.exports, "getIntervalGroupPositions", () => $d04bc95426bb71dd$export$209e346bf640604);

var $fHtBB = parcelRequire("fHtBB");

var $cww1R = parcelRequire("cww1R");

var $ch4pj = parcelRequire("ch4pj");
const $d04bc95426bb71dd$export$cd3d993a5aa1490e = (intervals, timelineDuration)=>{
    const saneIntervals = [];
    intervals.forEach((interval)=>{
        const saneStartDate = Math.min(interval.startDate, interval.endDate);
        const saneEndDate = Math.max(interval.startDate, interval.endDate) + (0, $fHtBB.DUE_DATE_OFFSET);
        const isStartInTimeline = saneStartDate >= timelineDuration.startMilliseconds && saneStartDate <= timelineDuration.endMilliseconds;
        const isEndInTimeline = saneEndDate >= timelineDuration.startMilliseconds && saneEndDate <= timelineDuration.endMilliseconds;
        const isLongerThanTimeline = saneStartDate <= timelineDuration.startMilliseconds && saneEndDate >= timelineDuration.endMilliseconds;
        if (isStartInTimeline || isEndInTimeline || isLongerThanTimeline) saneIntervals.push({
            id: interval.id,
            name: interval.name,
            state: interval.state,
            startDate: saneStartDate,
            endDate: saneEndDate
        });
    });
    return saneIntervals;
};
const $d04bc95426bb71dd$export$487a26b15ffb2465 = (intervalGroup, timelineDuration, timelineWidth)=>{
    const { startDate: startDate, endDate: endDate, expandedEndDate: expandedEndDate, intervals: intervals } = intervalGroup;
    // === Calculate sub-interval positions === //
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const intervalsPositions = {};
    intervals.forEach((interval)=>{
        const left = (0, $cww1R.getBarLeftPosition)(interval.startDate, timelineDuration, timelineWidth);
        const right = (0, $cww1R.getBarRightPosition)(interval.endDate - (0, $fHtBB.DUE_DATE_OFFSET), timelineDuration, timelineWidth);
        intervalsPositions[interval.id] = {
            left: Math.max(0, left),
            right: Math.max(0, right)
        };
    });
    // === Calculate group level positions === //
    const left = (0, $cww1R.getBarLeftPosition)(startDate, timelineDuration, timelineWidth);
    const right = (0, $cww1R.getBarRightPosition)(endDate - (0, $fHtBB.DUE_DATE_OFFSET), timelineDuration, timelineWidth);
    const rightExpanded = (0, $cww1R.getBarRightPosition)(expandedEndDate - (0, $fHtBB.DUE_DATE_OFFSET), timelineDuration, timelineWidth);
    let targetIntervalLeft = left;
    let targetIntervalRight = right;
    const targetInterval = intervals.find((interval)=>interval.state !== (0, $4a21b57a573cad8c$export$19c4f83398a8dbce));
    if (targetInterval !== undefined && intervalsPositions[targetInterval.id]) {
        targetIntervalLeft = intervalsPositions[targetInterval.id].left;
        targetIntervalRight = intervalsPositions[targetInterval.id].right;
    }
    // === Sanitise group level positions === //
    const clippedLeft = Math.max(0, left);
    const clippedRight = Math.max(0, right);
    const clippedTargetLeft = Math.max(0, targetIntervalLeft);
    const clippedTargetRight = Math.max(0, targetIntervalRight);
    const clippedRightExpanded = Math.max(0, rightExpanded);
    const width = timelineWidth - clippedLeft - clippedRight;
    const widthExpanded = timelineWidth - clippedLeft - clippedRightExpanded;
    return {
        isLeftClipped: left !== clippedLeft,
        isRightClipped: right !== clippedRight,
        isRightExpandedClipped: rightExpanded !== clippedRightExpanded,
        left: clippedLeft,
        right: clippedRight,
        targetIntervalLeft: clippedTargetLeft,
        targetIntervalRight: clippedTargetRight,
        rightExpanded: clippedRightExpanded,
        width: width,
        widthExpanded: widthExpanded,
        intervalsPositions: intervalsPositions,
        intervals: intervals
    };
};
const $d04bc95426bb71dd$export$209e346bf640604 = (intervals, timelineDuration, timelineWidth)=>{
    const saneIntervals = $d04bc95426bb71dd$export$cd3d993a5aa1490e(intervals, timelineDuration);
    const intervalGroups = (0, $ch4pj.groupOverlappingIntervals)(saneIntervals);
    return intervalGroups.map((intervalGroup)=>$d04bc95426bb71dd$export$487a26b15ffb2465(intervalGroup, timelineDuration, timelineWidth));
};

});
parcelRegister("ch4pj", function(module, exports) {

$parcel$export(module.exports, "groupOverlappingIntervals", () => $7b2b723999ef6d54$export$1b45218c7b9e570f);
const $7b2b723999ef6d54$export$1b45218c7b9e570f = (intervals)=>{
    /* To read the diagram:
	 * - Each unique character represents an interval, where the start is the first character, and the end is the last character.
	 * - Intervals are ordered in the same way they appear in the input list.
	 * - Uppercase characters represent overlapping time, and lowercase characters represents overlapped time.
	 * - Each row, separated by (-), represents an interval grouping.
	 *
	 * |---------------------|
	 * |   A A A             |
	 * |---------------------|
	 * |   B B B B           |
	 * |---------------------|
	 * |               C C   |
	 * |---------------------|
	 * |   D D               |
	 * |---------------------|
	 * | E E E               |
	 * |---------------------|
	 * |   F F               |
	 * |---------------------|
	 */ // remember original position in the list, because we'll need to sort again at the end
    const intervalsWithIndex = intervals.map((interval, index)=>({
            ...interval,
            index: index
        }));
    // First sort, as it will make the grouping logic a lot simpler.
    // Sprint with later end last; earlier sprint start last.
    const sortedIntervals = [
        ...intervalsWithIndex
    ].sort((interval, otherInterval)=>{
        const endComparison = interval.endDate - otherInterval.endDate;
        if (endComparison !== 0) return endComparison;
        return otherInterval.startDate - interval.startDate;
    });
    /* |---------------------|
	 * |   D D               |
	 * |---------------------|
	 * |   F F               |
	 * |---------------------|
	 * | E E E               |
	 * |---------------------|
	 * |   A A A             |
	 * |---------------------|
	 * |   B B B B           |
	 * |---------------------|
	 * |               C C   |
	 * |---------------------|
	 */ let result = [];
    // Traverse through the list of sorted intervals in _reverse_ order.
    // Group together adjacent intervals that are _completely_ overlapped.
    let i = sortedIntervals.length - 1;
    while(i >= 0){
        const currentInterval = sortedIntervals[i];
        let groupedIntervals = [
            currentInterval
        ];
        let j = i - 1;
        while(j >= 0){
            const nextInterval = sortedIntervals[j];
            // Since intervals are sorted, then the currentInterval.end >= nextInterval.end
            const isNextIntervalCompletelyOverlapped = currentInterval.startDate <= nextInterval.startDate;
            if (isNextIntervalCompletelyOverlapped) groupedIntervals = [
                nextInterval
            ].concat(groupedIntervals);
            else break;
            j -= 1;
        }
        const groupedIntervalsInOriginalOrdering = groupedIntervals.sort((interval, otherInterval)=>interval.index - otherInterval.index).map(({ index: index, ...interval })=>interval);
        result = [
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            {
                startDate: currentInterval.startDate,
                endDate: currentInterval.endDate,
                expandedEndDate: currentInterval.endDate,
                intervals: groupedIntervalsInOriginalOrdering
            }
        ].concat(result);
        i = j;
    }
    /* |---------------------|
	 * |               C C   |
	 * |---------------------|
	 * |   B B B B           |
	 * |   a a a             |
	 * |---------------------|
	 * | E E E               |
	 * |   f f               |
	 * |   d d               |
	 * |---------------------|
	 */ // We now "collapse" adjacent interval groups that overlap.
    // Later interval groups take precedence over earlier interval groups.
    if (result.length >= 2) for(let k = 0; k < result.length - 1; k += 1){
        const currentIntervalGroup = result[k];
        const nextIntervalGroup = result[k + 1];
        if (currentIntervalGroup.endDate > nextIntervalGroup.startDate) currentIntervalGroup.endDate = nextIntervalGroup.startDate;
    }
    /* |---------------------|
	 * | E e e               |
	 * |   f f               |
	 * |   d d               |
	 * |---------------------|
	 * |   B B B B           |
	 * |   a a a             |
	 * |---------------------|
	 * |               C C   |
	 * |---------------------|
	 */ return result;
};

});





parcelRegister("e3AcU", function(module, exports) {

$parcel$export(module.exports, "RoadmapBarContent", () => $9c0c7cb98a402b2d$export$6ad7b40eb111e24e);

var $eUqFw = parcelRequire("eUqFw");

var $4P2VV = parcelRequire("4P2VV");

var $2sNQW = parcelRequire("2sNQW");

var $fKdC1 = parcelRequire("fKdC1");

var $dBmAu = parcelRequire("dBmAu");
const $9c0c7cb98a402b2d$export$6ad7b40eb111e24e = ({ id: id, dragType: dragType, leftPosition: leftPosition, rightPosition: rightPosition, prevStartDate: prevStartDate, prevDueDate: prevDueDate, startDate: startDate, dueDate: dueDate, startDateType: startDateType, dueDateType: dueDateType, placeholder: placeholder, isActive: isActive, isReadOnly: isReadOnly, isMinimumBar: isMinimumBar, renderBarIcon: renderBarIcon, renderDateLabel: renderDateLabel, renderDependencyHandler: renderDependencyHandler, onBarMouseLeave: onBarMouseLeave, getBarBoundingClientRect: getBarBoundingClientRect })=>{
    const isHovered = isActive && !dragType;
    const isDraggingExplicit = isActive && dragType !== undefined;
    const isDragging = dragType !== undefined;
    const getRenderDependencyHandler = ()=>!isDragging && !isReadOnly && renderDependencyHandler({
            id: id,
            leftPosition: leftPosition,
            rightPosition: rightPosition,
            placeholder: placeholder,
            getBarBoundingClientRect: getBarBoundingClientRect,
            onBarMouseLeave: onBarMouseLeave
        }, {
            isHovered: isHovered
        });
    const getRenderDateLabel = ()=>isDraggingExplicit || isHovered ? renderDateLabel({
            prevStartDate: prevStartDate,
            prevDueDate: prevDueDate,
            startDate: startDate,
            dueDate: dueDate,
            startDateType: startDateType,
            dueDateType: dueDateType,
            placeholder: placeholder,
            getBarBoundingClientRect: getBarBoundingClientRect,
            dragType: dragType
        }) : null;
    const getRenderBarIcon = ()=>!isMinimumBar && !isDraggingExplicit && renderBarIcon({
            id: id,
            leftPosition: leftPosition,
            rightPosition: rightPosition
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, getRenderDependencyHandler(), getRenderDateLabel(), getRenderBarIcon());
};
$9c0c7cb98a402b2d$export$6ad7b40eb111e24e.defaultProps = {
    renderBarIcon: (0, $4P2VV.DEFAULT_RENDERER),
    renderDateLabel: (0, $4P2VV.DEFAULT_RENDERER),
    renderDependencyHandler: (0, $4P2VV.DEFAULT_RENDERER)
};

});
parcelRegister("2sNQW", function(module, exports) {

$parcel$export(module.exports, "RoadmapDateLabels", () => $9b4da58cc8a3c9de$export$b6e3ec15be9e500e);

var $eUqFw = parcelRequire("eUqFw");

var $fHtBB = parcelRequire("fHtBB");
var $4P2VV = parcelRequire("4P2VV");

var $7E8Bd = parcelRequire("7E8Bd");

var $1B9M2 = parcelRequire("1B9M2");

var $RvPFT = parcelRequire("RvPFT");

var $6iHFH = parcelRequire("6iHFH");
/* For the purpose of displaying the dates, the interaction context is important.
 * - If a date would be hidden by the viewport on one side, we attempt to display it on the other side
 * - All dates are considered explicit while dragging, as any inferred dates will be replaced after the interaction
 * - Only show the date that is being updated.
 */ const $9b4da58cc8a3c9de$export$b6e3ec15be9e500e = ({ prevStartDate: prevStartDate, prevDueDate: prevDueDate, startDate: startDate, dueDate: dueDate, startDateType: startDateType, dueDateType: dueDateType, placeholder: placeholder, dragType: dragType, getBarBoundingClientRect: getBarBoundingClientRect })=>{
    const displayStartDateType = dragType === (0, $4P2VV.LEFT) || dragType === (0, $4P2VV.LEFT_AND_RIGHT) ? (0, $fHtBB.EXPLICIT) : startDateType;
    const displayDueDateType = dragType === (0, $4P2VV.RIGHT) || dragType === (0, $4P2VV.LEFT_AND_RIGHT) ? (0, $fHtBB.EXPLICIT) : dueDateType;
    const displayPrevStartDate = dragType !== (0, $4P2VV.RIGHT) ? prevStartDate : undefined;
    const displayPrevDueDate = dragType !== (0, $4P2VV.LEFT) ? prevDueDate : undefined;
    const displayStartDate = dragType !== (0, $4P2VV.RIGHT) ? startDate : undefined;
    const displayDueDate = dragType !== (0, $4P2VV.LEFT) ? dueDate : undefined;
    const isDurationVisible = !placeholder;
    const placement = (0, $6iHFH.useDatePlacement)({
        dragType: dragType,
        startDateType: displayStartDateType,
        dueDateType: displayDueDateType,
        placeholder: placeholder,
        isDurationVisible: isDurationVisible,
        getBarBoundingClientRect: getBarBoundingClientRect
    });
    const renderDuration = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1B9M2.Duration), (0, $RvPFT.getDurationProps)(displayPrevStartDate, displayPrevDueDate, displayStartDate, displayDueDate, dragType, startDate, dueDate));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7E8Bd.FormattedDate), {
        placement: placement,
        startDate: displayStartDate,
        dueDate: displayDueDate,
        startDateType: displayStartDateType,
        dueDateType: displayDueDateType,
        placeholder: placeholder,
        isDurationVisible: isDurationVisible,
        renderDuration: renderDuration
    });
};
$9b4da58cc8a3c9de$export$b6e3ec15be9e500e.defaultProps = {
    startDateType: (0, $fHtBB.EXPLICIT),
    dueDateType: (0, $fHtBB.EXPLICIT)
};

});
parcelRegister("6iHFH", function(module, exports) {

$parcel$export(module.exports, "useDatePlacement", () => $f6bfa6f4b70ce4d9$export$469d58375b7706b3);

var $6TBpb = parcelRequire("6TBpb");

var $4P2VV = parcelRequire("4P2VV");

var $k6sGo = parcelRequire("k6sGo");
const $f6bfa6f4b70ce4d9$export$469d58375b7706b3 = ({ dragType: dragType, placeholder: placeholder, startDateType: startDateType, dueDateType: dueDateType, isDurationVisible: isDurationVisible, getBarBoundingClientRect: getBarBoundingClientRect })=>{
    const { requestViewportBoundingClient: requestViewportBoundingClient } = (0, $6TBpb.useViewport)();
    const rect = getBarBoundingClientRect();
    if (!rect) return 0, $4P2VV.LEFT_AND_RIGHT;
    const { isStartDateVisible: isStartDateVisible, isDueDateVisible: isDueDateVisible } = (0, $k6sGo.calculateDateVisibilities)(rect, requestViewportBoundingClient(), placeholder, startDateType, dueDateType, isDurationVisible);
    return (0, $k6sGo.getDatePlacement)(dragType, isStartDateVisible, isDueDateVisible);
};

});
parcelRegister("k6sGo", function(module, exports) {

$parcel$export(module.exports, "calculateDateVisibilities", () => $2071d5efb1937894$export$883141a0ed8178c0);
$parcel$export(module.exports, "getDatePlacement", () => $2071d5efb1937894$export$af34474977f1fefb);

var $fHtBB = parcelRequire("fHtBB");
var $4P2VV = parcelRequire("4P2VV");

var $cERyr = parcelRequire("cERyr");
const $2071d5efb1937894$var$APPROX_DATE_PIXELS = 85;
const $2071d5efb1937894$var$APPROX_PLACEHOLDER_PIXELS = 98;
const $2071d5efb1937894$var$APPROX_ICON_PIXELS = 20;
const $2071d5efb1937894$var$APPOX_DURATION_PIXELS = 33;
const $2071d5efb1937894$var$add = (accumulator, nextValue)=>accumulator + nextValue;
const $2071d5efb1937894$export$883141a0ed8178c0 = (barRect, viewportRect, placeholder, startDateType, dueDateType, isDurationVisible)=>{
    const { left: barLeft, right: barRight } = barRect;
    const { left: viewportLeft, right: viewportRight } = viewportRect;
    const availableLeftSpace = barLeft - viewportLeft;
    const availableRightSpace = viewportRight - barRight;
    const hasStartDateIcon = startDateType !== (0, $fHtBB.EXPLICIT);
    const hasDueDateIcon = dueDateType !== (0, $fHtBB.EXPLICIT);
    const spaceRequiredLeft = [
        (0, $cERyr.isStartDatePlaceholder)(placeholder) ? $2071d5efb1937894$var$APPROX_PLACEHOLDER_PIXELS : $2071d5efb1937894$var$APPROX_DATE_PIXELS,
        hasStartDateIcon ? $2071d5efb1937894$var$APPROX_ICON_PIXELS : 0
    ];
    const spaceRequiredRight = [
        (0, $cERyr.isDueDatePlaceholder)(placeholder) ? $2071d5efb1937894$var$APPROX_PLACEHOLDER_PIXELS : $2071d5efb1937894$var$APPROX_DATE_PIXELS,
        hasDueDateIcon ? $2071d5efb1937894$var$APPROX_ICON_PIXELS : 0,
        isDurationVisible ? $2071d5efb1937894$var$APPOX_DURATION_PIXELS : 0
    ];
    return {
        isStartDateVisible: spaceRequiredLeft.reduce($2071d5efb1937894$var$add, 0) <= availableLeftSpace,
        isDueDateVisible: spaceRequiredRight.reduce($2071d5efb1937894$var$add, 0) <= availableRightSpace
    };
};
const $2071d5efb1937894$export$af34474977f1fefb = (dragType, isStartDateVisible, isDueDateVisible)=>{
    if (dragType === (0, $4P2VV.LEFT_AND_RIGHT) || isStartDateVisible && isDueDateVisible || !isStartDateVisible && !isDueDateVisible) return 0, $4P2VV.LEFT_AND_RIGHT;
    return isStartDateVisible ? (0, $4P2VV.LEFT) : (0, $4P2VV.RIGHT);
};

});



parcelRegister("fKdC1", function(module, exports) {

$parcel$export(module.exports, "RoadmapBarIcon", () => $d28fdf4c1cbf56b2$export$31f28142b8ae6fe0);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $hUwRB = parcelRequire("hUwRB");

var $PdmhA = parcelRequire("PdmhA");

var $4q38b = parcelRequire("4q38b");

var $8cU5f = parcelRequire("8cU5f");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $duQ8C = parcelRequire("duQ8C");

var $hHcrs = parcelRequire("hHcrs");
const $d28fdf4c1cbf56b2$export$31f28142b8ae6fe0 = ({ level: level, onClick: onClick })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { colorMode: colorMode } = (0, $4q38b.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const onClickCallback = (0, $eUqFw.useCallback)((event)=>{
        (0, $duQ8C.default)('timeline-dependency-clicked', event.timeStamp);
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'icon'
        });
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'dependencyIcon', {
            level: level
        });
        const { top: top, left: left, width: width } = event.currentTarget.getBoundingClientRect();
        const position = {
            y: top + width,
            x: left
        };
        onClick(position);
    }, [
        onClick,
        level,
        createAnalyticsEvent
    ]);
    const CustomToolTipTag = (0, $eUqFw.useMemo)(()=>// FIXME: Chronos should fix this by extracting the forwarded component
        /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                ...props,
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                ref: ref,
                onClick: onClickCallback,
                className: (0, $7JEyt.default)([
                    "_1e0c1txw _4cvr1h6o _1bah1h6o _1bsbv47k _4t3iv47k _2hwx1b66 _2rko1ssb _1pbyegat _80omtlke _p7r11txw _irr31fly"
                ])
            })), [
        onClickCallback
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        tag: CustomToolTipTag,
        position: "top",
        content: formatMessage((0, $hHcrs.default).viewDetail)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hUwRB))), {
        size: "small",
        label: "",
        primaryColor: colorMode ? 'rgba(255, 255, 255, 0.8)' : (0, $PdmhA.N0),
        testId: "roadmap.timeline-table-kit.ui.chart-item-content.date-content.bar.bar-content.bar-icon.link-icon"
    }));
};
const $d28fdf4c1cbf56b2$var$iconWrapperStyles = null;

});
parcelRegister("hUwRB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d0a128a0d80d703a$var$_react = $d0a128a0d80d703a$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $d0a128a0d80d703a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $d0a128a0d80d703a$var$LinkIcon = (props)=>/*#__PURE__*/ $d0a128a0d80d703a$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentColor" fill-rule="evenodd"><path d="M12.856 5.457l-.937.92a1.002 1.002 0 000 1.437 1.047 1.047 0 001.463 0l.984-.966c.967-.95 2.542-1.135 3.602-.288a2.54 2.54 0 01.203 3.81l-2.903 2.852a2.646 2.646 0 01-3.696 0l-1.11-1.09L9 13.57l1.108 1.089c1.822 1.788 4.802 1.788 6.622 0l2.905-2.852a4.558 4.558 0 00-.357-6.82c-1.893-1.517-4.695-1.226-6.422.47"/><path d="M11.144 19.543l.937-.92a1.002 1.002 0 000-1.437 1.047 1.047 0 00-1.462 0l-.985.966c-.967.95-2.542 1.135-3.602.288a2.54 2.54 0 01-.203-3.81l2.903-2.852a2.646 2.646 0 013.696 0l1.11 1.09L15 11.43l-1.108-1.089c-1.822-1.788-4.802-1.788-6.622 0l-2.905 2.852a4.558 4.558 0 00.357 6.82c1.893 1.517 4.695 1.226 6.422-.47"/></g></svg>`
    }, props));
$d0a128a0d80d703a$var$LinkIcon.displayName = 'LinkIcon';
var $d0a128a0d80d703a$var$_default = $d0a128a0d80d703a$var$LinkIcon;
module.exports.default = $d0a128a0d80d703a$var$_default;

});

parcelRegister("hHcrs", function(module, exports) {

$parcel$export(module.exports, "default", () => $89017eb46014f714$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $89017eb46014f714$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    viewDetail: {
        "id": "roadmap.timeline-table-kit.chart-item-content.date-content.bar.bar-content.bar-icon.view-detail",
        "defaultMessage": "View dependency details"
    }
});

});


parcelRegister("dBmAu", function(module, exports) {

$parcel$export(module.exports, "RoadmapDependencyHandlers", () => $a7d6c00f5f0a4c25$export$14c359ef0e13a4a6);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $4P2VV = parcelRequire("4P2VV");

var $kjGqG = parcelRequire("kjGqG");
var $5p0tX = parcelRequire("5p0tX");

var $b73YN = parcelRequire("b73YN");

var $734ti = parcelRequire("734ti");
const $a7d6c00f5f0a4c25$var$containerStyles = null;
const $a7d6c00f5f0a4c25$var$suffixElementStyles = null;
const $a7d6c00f5f0a4c25$export$14c359ef0e13a4a6 = ({ id: id, color: color, leftPosition: leftPosition, rightPosition: rightPosition, isHovered: isHovered, placeholder: placeholder, onCreateDependency: onCreateDependency, getBarBoundingClientRect: getBarBoundingClientRect, onBarMouseLeave: onBarMouseLeave })=>{
    const [{ isDraggedOver: isDraggedOver }, makeDroppable, cleanupDroppable] = (0, $734ti.useDependenciesDrop)(id, onCreateDependency);
    const [currentDragHandle, setCurrentDragHandle] = (0, $eUqFw.useState)(undefined);
    const isDragging = currentDragHandle !== undefined;
    const theme = (0, $kjGqG.dependencyThemes)[color];
    // Callbacks //
    const onDragStart = (0, $eUqFw.useCallback)((type)=>{
        setCurrentDragHandle(type);
        onBarMouseLeave();
    }, [
        onBarMouseLeave
    ]);
    const onDragEnd = (0, $eUqFw.useCallback)(()=>{
        setCurrentDragHandle(undefined);
    }, []);
    // Effects //
    (0, $eUqFw.useEffect)(()=>()=>{
            // drop connections will be unsubscribed if NULL was passed to drop handler.
            cleanupDroppable();
        }, [
        cleanupDroppable
    ]);
    // Render //
    const renderDragHandle = (type)=>{
        const isHandleInteractive = isHovered || currentDragHandle === type;
        if (!isHandleInteractive) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b73YN.default), {
            id: id,
            type: type,
            theme: theme,
            leftPosition: leftPosition,
            rightPosition: rightPosition,
            onDrop: onCreateDependency,
            onDragEnd: onDragEnd,
            onDragStart: onDragStart,
            getBarBoundingClientRect: getBarBoundingClientRect
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            borderRadius: (0, $5p0tX.generateBarBorderRadius)(placeholder)
        },
        "data-testid": `roadmap.timeline-table-kit.ui.chart-item-content.date-content.bar.dependency-drop-target-${id}`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $7JEyt.default)([
            "_kqswstnw _154iidpf _1ltvidpf _1xi2idpf _94n5idpf _lcxvglyw _1pbyqfx8",
            (0, $fbe90688b36d692e$export$c330e9be73819573)
        ]),
        ref: makeDroppable
    }, renderDragHandle((0, $4P2VV.TOP)), renderDragHandle((0, $4P2VV.BOTTOM)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            borderRadius: (0, $5p0tX.generateBarBorderRadius)(placeholder),
            boxShadow: `inset 0 0 0 2px ${theme.border}`,
            opacity: isDragging || isDraggedOver ? 1 : 0
        },
        className: (0, $7JEyt.default)([
            "_1sb2b3bt _kqswstnw _1bsb1osq _4t3i1osq _v5641w7c"
        ])
    }));
};

});
parcelRegister("kjGqG", function(module, exports) {

$parcel$export(module.exports, "dependencyThemes", () => $b846dbad7bfe357f$export$895cd5f608903fe5);

var $lPQPn = parcelRequire("lPQPn");
const $b846dbad7bfe357f$export$895cd5f608903fe5 = (0, $lPQPn.transformColorToTheme)((cs)=>({
        icon: cs.primary,
        line: cs.line,
        border: cs.border,
        handle: {
            shadow: cs.primary,
            background: cs.primary
        }
    }));

});

parcelRegister("b73YN", function(module, exports) {

$parcel$export(module.exports, "default", () => $02631d5419a72b77$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $dxIU5 = parcelRequire("dxIU5");

var $a576Y = parcelRequire("a576Y");

var $hzcvF = parcelRequire("hzcvF");

var $kVOqJ = parcelRequire("kVOqJ");
var $bwj1b = parcelRequire("bwj1b");
var $6TBpb = parcelRequire("6TBpb");

var $4P2VV = parcelRequire("4P2VV");

var $1KNKa = parcelRequire("1KNKa");

var $h8IDk = parcelRequire("h8IDk");

var $3K5D4 = parcelRequire("3K5D4");
const $02631d5419a72b77$var$DependenciesDragHandles = ({ theme: theme, id: id, type: type, leftPosition: leftPosition, rightPosition: rightPosition, getBarBoundingClientRect: getBarBoundingClientRect, onDrop: onDrop, onDragStart: onDragStart, onDragEnd: onDragEnd })=>{
    const [handlePosition, setHandlePosition] = (0, $eUqFw.useState)(undefined);
    const { custom: custom } = (0, $bwj1b.useSideEffectMarshal)();
    const { listenToViewportScroll: listenToViewportScroll, stopListeningToViewportScroll: stopListeningToViewportScroll } = (0, $6TBpb.useViewport)();
    const [{ isDragging: isDragging }, makeDraggable, cleanupDraggable] = (0, $3K5D4.useDependenciesDrag)({
        id: id,
        type: type,
        leftPosition: leftPosition,
        rightPosition: rightPosition,
        getBarBoundingClientRect: getBarBoundingClientRect,
        onDrop: onDrop
    });
    const wasDragging = (0, $hzcvF.usePreviousWithInitial)(isDragging);
    // Callbacks //
    const onUpdateBarRectPosition = (0, $eUqFw.useCallback)(()=>{
        const barClientRect = getBarBoundingClientRect();
        if (barClientRect) {
            const fixedHandlePosition = (0, $h8IDk.getFixedHandlePosition)(type, barClientRect);
            setHandlePosition(fixedHandlePosition);
        }
    }, [
        type,
        getBarBoundingClientRect
    ]);
    // go/jfe-eslint
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const onScrollEnd = (0, $eUqFw.useCallback)((0, (/*@__PURE__*/$parcel$interopDefault($dxIU5)))(()=>{
        onUpdateBarRectPosition();
    }, 100), []);
    // go/jfe-eslint
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const onScroll = (0, $eUqFw.useCallback)((0, (/*@__PURE__*/$parcel$interopDefault($a576Y)))(()=>{
        setHandlePosition(undefined);
        onScrollEnd();
    }, 100), []);
    // Effects //
    (0, $eUqFw.useEffect)(()=>{
        listenToViewportScroll(onScroll);
        return ()=>{
            stopListeningToViewportScroll(onScroll);
            // drag connections will be unsubscribed if NULL was passed to drag handler.
            cleanupDraggable();
        };
    }, [
        onScroll,
        cleanupDraggable,
        listenToViewportScroll,
        stopListeningToViewportScroll
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (!wasDragging && isDragging) {
            onDragStart(type);
            custom.onDependencyDragStart();
        } else if (wasDragging && !isDragging) {
            onDragEnd();
            custom.onDependencyDragEnd();
        }
    }, [
        type,
        isDragging,
        wasDragging,
        onDragEnd,
        onDragStart,
        custom
    ]);
    (0, $eUqFw.useEffect)(()=>{
        onUpdateBarRectPosition();
    }, [
        onUpdateBarRectPosition
    ]);
    // Render //
    if (!handlePosition) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kVOqJ.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        style: {
            visibility: isDragging ? 'hidden' : 'visible',
            left: handlePosition.left,
            top: handlePosition.top
        },
        "data-testid": "roadmap.timeline-table-kit.ui.chart-item-content.date-content.bar.bar-content.dependency-handler.handle",
        ref: makeDraggable,
        className: (0, $7JEyt.default)([
            "_kqsw1n9t _1e0c1txw _2lx21bp4 _1bsb1ejb _4t3i1ejb _4cvr1h6o _1bah1h6o _2rko1ssb _lcxv1rj4 _t9ec1ooe _zdyikb7n _f1zwidpf"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        "data-component-selector": "timeline-data-dot",
        style: {
            backgroundColor: theme.handle.background
        },
        className: (0, $7JEyt.default)([
            "_1bsbu2gc _4t3iu2gc _2rko1ssb _80omtlke _tip8kb7n _v564m7ou",
            type === (0, $4P2VV.TOP) && "",
            type === (0, $4P2VV.TOP) && "_y44vea6k",
            type !== (0, $4P2VV.TOP) && "",
            type !== (0, $4P2VV.TOP) && "_y44vg57k"
        ])
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        "data-component-selector": "timeline-drag-handler",
        className: (0, $7JEyt.default)([
            "_kqswstnw _154iv77o _1ltvv77o _80omtlke _tzy4idpf _v564m7ou"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1KNKa.DependencyDragHandler), {
        color: theme.icon
    }))));
};
var $02631d5419a72b77$export$2e2bcd8739ae039 = $02631d5419a72b77$var$DependenciesDragHandles;
const $02631d5419a72b77$var$SLIDE_OFFSET = 15;
const $02631d5419a72b77$var$slideInTop = null;
const $02631d5419a72b77$var$slideInBottom = null;
const $02631d5419a72b77$var$slideInTopStyles = null;
const $02631d5419a72b77$var$slideInBottomStyles = null;
const $02631d5419a72b77$var$dragHandleDotStyles = null;
const $02631d5419a72b77$var$dragHandleWrapperStyles = null;
// Current solution for component selectors https://hello.atlassian.net/wiki/spaces/UAF/pages/1393355483/Compiled+Component+selectors#Proposed-solution---HTML-data-attribute-selectors (a WIP solution yet to be implement for better parent/child styling and will be documented)
const $02631d5419a72b77$var$dragHandleContainerStyles = null;

});
parcelRegister("kVOqJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $227cdbf999c5e4d4$export$2e2bcd8739ae039);

var $lEfVV = parcelRequire("lEfVV");

var $h829Y = parcelRequire("h829Y");
const $227cdbf999c5e4d4$var$Portal = ({ children: children })=>{
    const { portalContainerElement: portalContainerElement } = (0, $h829Y.usePortalScope)();
    if (portalContainerElement) return /*#__PURE__*/ (0, $lEfVV.createPortal)(children, portalContainerElement);
    return null;
};
var $227cdbf999c5e4d4$export$2e2bcd8739ae039 = $227cdbf999c5e4d4$var$Portal;

});

parcelRegister("1KNKa", function(module, exports) {

$parcel$export(module.exports, "DependencyDragHandler", () => $dba97944697d074e$export$df820fc059ab8cf4);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $hUwRB = parcelRequire("hUwRB");

var $PdmhA = parcelRequire("PdmhA");
const $dba97944697d074e$var$iconWrapperStyles = null;
const $dba97944697d074e$export$df820fc059ab8cf4 = ({ color: color })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        style: {
            backgroundColor: color
        },
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1bsbgktf _4t3igktf _2rko1ssb _4cvr1h6o _1bah1h6o _16qsanr3"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hUwRB))), {
        size: "small",
        label: "",
        primaryColor: `var(--ds-icon-inverse, ${(0, $PdmhA.N0)})`
    }));

});

parcelRegister("h8IDk", function(module, exports) {

$parcel$export(module.exports, "getFixedHandlePosition", () => $fe6e739d2c85baf0$export$cdacaba1feb143c8);
$parcel$export(module.exports, "getRelativeHandlePosition", () => $fe6e739d2c85baf0$export$eb8d2bc119196ff0);

var $4P2VV = parcelRequire("4P2VV");
const $fe6e739d2c85baf0$var$FIXED_OFFSET_X = 15;
const $fe6e739d2c85baf0$var$FIXED_OFFSET_Y = 8;
const $fe6e739d2c85baf0$export$cdacaba1feb143c8 = (type, barClientRect)=>{
    const { top: top, left: left, width: width, height: height } = barClientRect;
    if (type === (0, $4P2VV.TOP)) return {
        top: top - $fe6e739d2c85baf0$var$FIXED_OFFSET_Y,
        left: left + $fe6e739d2c85baf0$var$FIXED_OFFSET_X
    };
    return {
        top: top + height + $fe6e739d2c85baf0$var$FIXED_OFFSET_Y,
        left: left + width - $fe6e739d2c85baf0$var$FIXED_OFFSET_X
    };
};
const $fe6e739d2c85baf0$export$eb8d2bc119196ff0 = (type, timelineWidth, barLeftPosition, barRightPosition)=>type === (0, $4P2VV.TOP) ? barLeftPosition : timelineWidth - barRightPosition;

});

parcelRegister("3K5D4", function(module, exports) {

$parcel$export(module.exports, "useDependenciesDrag", () => $b69b720a663d9a1e$export$8d873462c415f4c3);

var $eUqFw = parcelRequire("eUqFw");
parcelRequire("3f2za");
var $jFl9L = parcelRequire("jFl9L");

var $eo9PV = parcelRequire("eo9PV");

var $3XwA1 = parcelRequire("3XwA1");
var $6TBpb = parcelRequire("6TBpb");


var $h8IDk = parcelRequire("h8IDk");
const $b69b720a663d9a1e$export$8d873462c415f4c3 = ({ id: id, type: type, getBarBoundingClientRect: getBarBoundingClientRect, leftPosition: leftPosition, rightPosition: rightPosition })=>{
    const cleanupDragAndDrop = (0, $eUqFw.useRef)(null);
    const [dragState, setDragState] = (0, $eUqFw.useState)({
        isDragging: false
    });
    const [{ timelineWidth: timelineWidth }] = (0, $3XwA1.useTimelineState)();
    const { requestViewportBoundingClient: requestViewportBoundingClient, requestViewportScrollBounding: requestViewportScrollBounding, setViewportScroll: setViewportScroll } = (0, $6TBpb.useViewport)();
    const makeDraggable = (0, $eUqFw.useCallback)((dragElement)=>{
        const el = dragElement;
        if (el === null) return;
        cleanupDragAndDrop.current = (0, $jFl9L.combine)((0, $eo9PV.draggable)({
            element: el,
            getInitialData: ()=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                ({
                    type: (0, $fbe90688b36d692e$export$48a2b55760ce2355),
                    id: id,
                    handleType: type,
                    barRect: getBarBoundingClientRect(),
                    leftPosition: (0, $h8IDk.getRelativeHandlePosition)(type, timelineWidth, leftPosition, rightPosition),
                    viewportBoundingRect: requestViewportBoundingClient(),
                    initialScrollBoundingRect: requestViewportScrollBounding(),
                    requestViewportScrollBounding: requestViewportScrollBounding,
                    setViewportScroll: setViewportScroll
                }),
            onGenerateDragPreview: ({ source: source })=>{
                const { element: draggedElement } = source;
                // hide the native drag preview
                draggedElement.style.opacity = '0';
            },
            onDragStart: ({ source: source })=>{
                const { element: draggedElement } = source;
                draggedElement.style.opacity = '1';
                setDragState({
                    isDragging: true
                });
            },
            onDrop: ()=>{
                setDragState({
                    isDragging: false
                });
            }
        }));
    }, [
        id,
        type,
        leftPosition,
        rightPosition,
        timelineWidth,
        setViewportScroll,
        requestViewportScrollBounding,
        requestViewportBoundingClient,
        getBarBoundingClientRect
    ]);
    const cleanupDraggable = (0, $eUqFw.useCallback)(()=>{
        cleanupDragAndDrop.current?.();
    }, []);
    return [
        dragState,
        makeDraggable,
        cleanupDraggable
    ];
};

});


parcelRegister("734ti", function(module, exports) {

$parcel$export(module.exports, "useDependenciesDrop", () => $02c88ff16b7170ce$export$52e673c9910da4de);

var $eUqFw = parcelRequire("eUqFw");
parcelRequire("3f2za");
var $jFl9L = parcelRequire("jFl9L");

var $eo9PV = parcelRequire("eo9PV");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $4P2VV = parcelRequire("4P2VV");
const $02c88ff16b7170ce$export$52e673c9910da4de = (id, onDrop)=>{
    const cleanupDropTarget = (0, $eUqFw.useRef)(null);
    const [dragState, setDragState] = (0, $eUqFw.useState)({
        isDraggedOver: false
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const makeDroppable = (0, $eUqFw.useCallback)((dropTargetElement)=>{
        const el = dropTargetElement;
        if (el === null) return;
        cleanupDropTarget.current = (0, $jFl9L.combine)((0, $eo9PV.dropTargetForElements)({
            element: el,
            canDrop: ({ source: source })=>{
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                const item = source.data;
                return item.type === (0, $fbe90688b36d692e$export$48a2b55760ce2355) && item.id !== id;
            },
            onDragEnter: ({ source: source })=>{
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                const item = source.data;
                if (item.type === (0, $fbe90688b36d692e$export$48a2b55760ce2355) && item.id !== id) setDragState({
                    isDraggedOver: true
                });
            },
            onDragLeave: ({ source: source })=>{
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                const item = source.data;
                if (item.type === (0, $fbe90688b36d692e$export$48a2b55760ce2355) && item.id !== id) setDragState({
                    isDraggedOver: false
                });
            },
            onDrop: ({ source: source })=>{
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                const item = source.data;
                const analyticsEvent = createAnalyticsEvent({
                    action: 'dropped',
                    actionSubject: 'dropArea'
                });
                (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'dependencyDropArea');
                const from = item.handleType === (0, $4P2VV.TOP) ? item.id : id;
                const to = item.handleType === (0, $4P2VV.TOP) ? id : item.id;
                onDrop(from, to, analyticsEvent);
                setDragState({
                    isDraggedOver: false
                });
            }
        }));
    }, [
        id,
        onDrop,
        createAnalyticsEvent
    ]);
    const cleanupDroppable = (0, $eUqFw.useCallback)(()=>{
        cleanupDropTarget.current?.();
    }, []);
    return [
        dragState,
        makeDroppable,
        cleanupDroppable
    ];
};

});



parcelRegister("ezwuA", function(module, exports) {

$parcel$export(module.exports, "RoadmapDragHandle", () => $0c682102f9ebb04f$export$fd31a6ac7f6022ac);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $3R70n = parcelRequire("3R70n");
const $0c682102f9ebb04f$var$handleStyles = null;
const $0c682102f9ebb04f$var$Handle = ({ type: type, hasPlaceholder: hasPlaceholder, theme: theme, children: children, testid: testid })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            [type]: 0,
            backgroundColor: !theme.hasContrastSecondaryGradient && hasPlaceholder ? theme.background : theme.handle
        },
        "data-testid": testid,
        className: (0, $7JEyt.default)([
            "_kqswstnw _154iidpf _94n5idpf _1yt41b66 _1bsbi2wt _2rkoftgi _1y1m1ntv _80om11mm"
        ])
    }, children);
const $0c682102f9ebb04f$var$DraggableHandle = (0, $3R70n.withDragObserver)($0c682102f9ebb04f$var$Handle, 0.1);
const $0c682102f9ebb04f$export$fd31a6ac7f6022ac = ({ id: id, type: type, theme: theme, hasPlaceholder: hasPlaceholder, onDragStart: onDragStart, onDrag: onDrag, onDragEnd: onDragEnd })=>{
    const onDragHandleStart = (0, $eUqFw.useCallback)(()=>{
        onDragStart(type);
    }, [
        type,
        onDragStart
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0c682102f9ebb04f$var$DraggableHandle, {
        // NOTE: ts error needs to be fixed in withDragObserver from @atlassian/jira-drag-observer
        // @ts-expect-error - TS2322 - Type '{ "testid": string; theme: BarTheme; position: HorizontalDirection; hasPlaceholder: boolean; onDragStart: () => void; onDrag: (from: Position, to: Position, start: Position) => void; onDragEnd: () => void; }' is not assignable to type 'IntrinsicAttributes & IntrinsicClassAttributes<DragObserver> & Pick<Readonly<Props> & Readonly<...>, "children"> & Partial<...> & Partial<...>'.
        testid: `roadmap.timeline-table.components.bar.draggable.${type.toLowerCase()}-draggable-handle-${id}`,
        theme: theme,
        type: type.toLowerCase(),
        hasPlaceholder: hasPlaceholder,
        onDragStart: onDragHandleStart,
        onDrag: onDrag,
        onDragEnd: onDragEnd
    });
};

});

parcelRegister("65R8W", function(module, exports) {

$parcel$export(module.exports, "default", () => $dbaa40a29f89eae9$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $dbaa40a29f89eae9$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    gridCellAriaLabel: {
        "id": "roadmap.timeline-table-kit.chart-item-content.date-content.bar.grid-cell-aria-label",
        "defaultMessage": "Start date {startDate} until due date {dueDate} with color {color}"
    },
    warningsCount: {
        "id": "roadmap.timeline-table-kit.chart-item-content.date-content.bar.warnings-count",
        "defaultMessage": "{count, plural, one {# warning} other {# warnings}}"
    }
});

});

parcelRegister("5SkIe", function(module, exports) {

$parcel$export(module.exports, "getMinimumPositions", () => $2e6075c6047ad389$export$c1b6dd342ed8c79c);
$parcel$export(module.exports, "getUpdatedDates", () => $2e6075c6047ad389$export$3aa346efaf981bb1);
$parcel$export(module.exports, "getAnalyticsType", () => $2e6075c6047ad389$export$a3569ac53b82a914);

var $4P2VV = parcelRequire("4P2VV");
var $c3IKH = parcelRequire("c3IKH");
const $2e6075c6047ad389$export$c1b6dd342ed8c79c = (leftPosition, rightPosition, timelineWidth)=>{
    const barLength = timelineWidth - rightPosition - leftPosition;
    if (barLength < (0, $c3IKH.MINIMUM_BAR_LENGTH)) {
        const minimumOffset = ((0, $c3IKH.MINIMUM_BAR_LENGTH) - barLength) / 2;
        return {
            minimumLeft: leftPosition - minimumOffset,
            minimumRight: rightPosition - minimumOffset
        };
    }
    return {
        minimumLeft: undefined,
        minimumRight: undefined
    };
};
const $2e6075c6047ad389$export$3aa346efaf981bb1 = (startDate, dueDate, dragType)=>{
    if (dragType === (0, $4P2VV.LEFT)) return {
        startDate: startDate
    };
    if (dragType === (0, $4P2VV.RIGHT)) return {
        dueDate: dueDate
    };
    if (dragType === (0, $4P2VV.LEFT_AND_RIGHT)) return {
        startDate: startDate,
        dueDate: dueDate
    };
    return {};
};
const $2e6075c6047ad389$export$a3569ac53b82a914 = (updatedDates)=>{
    const { startDate: startDate, dueDate: dueDate } = updatedDates;
    if (startDate && !dueDate) return 'resizeLeft';
    if (!startDate && dueDate) return 'resizeRight';
    return 'moveBar';
};

});

parcelRegister("3t0oV", function(module, exports) {

$parcel$export(module.exports, "RoadmapBarWarnings", () => $2760de060644b8c4$export$a4e6ea3b919ca9a9);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $5YsMl = parcelRequire("5YsMl");

var $PdmhA = parcelRequire("PdmhA");

var $8cU5f = parcelRequire("8cU5f");
var $g3tFP = parcelRequire("g3tFP");

var $4ksts = parcelRequire("4ksts");
const $2760de060644b8c4$var$containerStyles = null;
const $2760de060644b8c4$var$contentWrapperStyles = null;
const $2760de060644b8c4$var$tooltipTextStyles = null;
const $2760de060644b8c4$var$iconContainerStyles = null;
const $2760de060644b8c4$var$TooltipTag = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        ref: ref,
        ...props,
        className: (0, $7JEyt.default)([
            "_syaz2owi _1e0c1txw"
        ])
    }));
const $2760de060644b8c4$export$a4e6ea3b919ca9a9 = ({ right: right, warnings: warnings })=>{
    const { formatMessage: formatMessage } = (0, $4ksts.useIntlV2)(); // FIXME: Chronos should fix that by extracting the forwarded component
    const TooltipComponent = /*#__PURE__*/ (0, $eUqFw.forwardRef)((tooltipProps, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $g3tFP.default), {
            ...tooltipProps,
            ref: ref
        }));
    const tooltipContent = warnings.map((errorMessage)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            key: `${errorMessage.id}`,
            className: (0, $7JEyt.default)([
                "_1e0c1txw _1bsbp3fh _otyr1b66 _1yt41pyq _2rko1l7b _11q71bhr _16qsac02 _syaz1rn8"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5YsMl))), {
            primaryColor: `var(--ds-icon-warning, ${(0, $PdmhA.Y300)})`,
            size: "medium",
            label: ""
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: (0, $7JEyt.default)([
                "_1yt4swc3 _1wyb1crf _18u0u2gc"
            ])
        }, formatMessage(errorMessage))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        style: {
            right: `${right}px`
        },
        className: (0, $7JEyt.default)([
            "_kqswstnw _1e0c1ule _t9ecwq5g _80omtlke _1pby11wp"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        component: TooltipComponent,
        content: tooltipContent,
        position: "bottom-start",
        delay: 0,
        hideTooltipOnClick: true,
        tag: $2760de060644b8c4$var$TooltipTag
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5YsMl))), {
        primaryColor: `var(--ds-icon-warning, ${(0, $PdmhA.Y300)})`,
        label: ""
    })));
};

});


parcelRegister("i9sDh", function(module, exports) {

$parcel$export(module.exports, "RoadmapNavigateButton", () => $76b6135759dfcd50$export$f4de1542efe44c4);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $eUqFw = parcelRequire("eUqFw");

var $fyp42 = parcelRequire("fyp42");

var $k4jc8 = parcelRequire("k4jc8");

var $PdmhA = parcelRequire("PdmhA");

var $c9TLT = parcelRequire("c9TLT");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $hxnNZ = parcelRequire("hxnNZ");
var $6TBpb = parcelRequire("6TBpb");

// Constants //
const $76b6135759dfcd50$var$BUTTON_SIZE = 3 * (0, $c9TLT.gridSize);
const $76b6135759dfcd50$var$DATE_OFFSET = $76b6135759dfcd50$var$BUTTON_SIZE + (0, $c9TLT.gridSize);
const $76b6135759dfcd50$var$SCROLL_BAR_OFFSET = 10;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $76b6135759dfcd50$var$PAST_BORDER_RADIUS = `0 ${(0, $c9TLT.borderRadius)}px ${(0, $c9TLT.borderRadius)}px 0`;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $76b6135759dfcd50$var$FUTURE_BORDER_RADIUS = `${(0, $c9TLT.borderRadius)}px 0 0 ${(0, $c9TLT.borderRadius)}px`;
const $76b6135759dfcd50$var$baseButtonStyles = null;
const $76b6135759dfcd50$var$pastButtonBorderRadiusStyles = null;
const $76b6135759dfcd50$var$futureButtonBorderRadiusStyles = null;
const $76b6135759dfcd50$var$pastLabelContainerStyles = null;
const $76b6135759dfcd50$var$futureLabelContainerStyles = null;
const $76b6135759dfcd50$export$f4de1542efe44c4 = ({ itemMinLeftPosition: itemMinLeftPosition, itemMaxRightPosition: itemMaxRightPosition, label: label })=>{
    const { requestViewportScrollBounding: requestViewportScrollBounding, setViewportScroll: setViewportScroll } = (0, $6TBpb.useViewport)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [isScrollingX] = (0, $hxnNZ.useIsScrollingX)();
    const [isHovered, setIsHovered] = (0, $eUqFw.useState)(false);
    if (isScrollingX) return null;
    const { scrollLeft: scrollLeft, scrollRight: scrollRight, scrollWidth: scrollWidth, isOverflowY: isOverflowY } = requestViewportScrollBounding();
    const isItemInPast = scrollWidth - itemMaxRightPosition < scrollLeft;
    const isItemInFuture = scrollWidth - itemMinLeftPosition < scrollRight;
    // The chart-item-content is visible in the viewport, no need to navigate to it.
    if (!isItemInPast && !isItemInFuture) return null;
    // Callbacks //
    const onMouseEnter = ()=>{
        setIsHovered(true);
    };
    const onMouseLeave = ()=>{
        setIsHovered(false);
    };
    const onClick = ()=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        });
        const analyticsAttributes = {
            direction: isItemInPast ? 'past' : 'future'
        };
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'navigateButton', analyticsAttributes);
        setViewportScroll({
            scrollLeft: itemMinLeftPosition - (0, $1ee7517576a29949$export$6053dd7bb292e51e)
        });
    };
    // Render //
    const renderArrowIcon = (Icon)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Icon, {
            size: "small",
            label: "",
            primaryColor: isHovered ? `var(--ds-icon, ${0, $PdmhA.N0})` : `var(--ds-icon, ${0, $PdmhA.N50})`,
            secondaryColor: `var(--ds-icon-inverse, ${(0, $PdmhA.N70)})`
        });
    if (isItemInPast) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        "data-testid": "roadmap.timeline-table-kit.ui.chart-item-content.date-content.navigate-button.navigate",
        onClick: onClick,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        onKeyDown: (e)=>(e.key === 'Enter' || e.key === 'Space') && onClick(),
        role: "presentation",
        className: (0, $7JEyt.default)([
            "_kqswstnw _1e0c1txw _4cvr1h6o _4t3i1tcg _vchhusvi _1yt41b66 _bfhk1i4r _1pbyouyt _80omtlke _irr3arkb",
            "_2rko1gaq"
        ]),
        style: {
            left: `${scrollLeft}px`,
            width: `${$76b6135759dfcd50$var$BUTTON_SIZE}px`,
            "--_3j09fn": (0, $9t7rW.default)($76b6135759dfcd50$var$PAST_BORDER_RADIUS)
        }
    }, renderArrowIcon((0, (/*@__PURE__*/$parcel$interopDefault($fyp42)))), isHovered && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: (0, $7JEyt.default)([
            "_kqswstnw _1ltvxy5q"
        ])
    }, label));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        "data-testid": "roadmap.timeline-table-kit.ui.chart-item-content.date-content.navigate-button.navigate",
        onClick: onClick,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        className: (0, $7JEyt.default)([
            "_kqswstnw _1e0c1txw _4cvr1h6o _4t3i1tcg _vchhusvi _1yt41b66 _bfhk1i4r _1pbyouyt _80omtlke _irr3arkb",
            "_2rkoff7z"
        ]),
        style: {
            right: `${scrollRight}px`,
            width: `${$76b6135759dfcd50$var$BUTTON_SIZE + (isOverflowY ? $76b6135759dfcd50$var$SCROLL_BAR_OFFSET : 0)}px`,
            "--_kwbool": (0, $9t7rW.default)($76b6135759dfcd50$var$FUTURE_BORDER_RADIUS)
        }
    }, renderArrowIcon((0, (/*@__PURE__*/$parcel$interopDefault($k4jc8)))), isHovered && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        style: {
            right: `${$76b6135759dfcd50$var$DATE_OFFSET + (isOverflowY ? $76b6135759dfcd50$var$SCROLL_BAR_OFFSET : 0)}px`
        },
        className: (0, $7JEyt.default)([
            "_kqswstnw"
        ])
    }, label));
};

});
// When navigating to a chart item, we don't want to be aligned right to the edge of the viewport
const $1ee7517576a29949$export$6053dd7bb292e51e = 32;



parcelRegister("9afsD", function(module, exports) {

$parcel$export(module.exports, "IntervalDropZones", () => $af6ec96c04a8f46d$export$f18d47ee39e90aec);

var $eUqFw = parcelRequire("eUqFw");

var $3XwA1 = parcelRequire("3XwA1");

var $hevaQ = parcelRequire("hevaQ");

var $67lY7 = parcelRequire("67lY7");

var $3pD74 = parcelRequire("3pD74");
const $af6ec96c04a8f46d$var$VisibleIntervalDropZones = ({ id: id, intervals: intervals, currentIntervalId: currentIntervalId, onClick: onClick })=>{
    const [{ timelineDuration: timelineDuration, timelineWidth: timelineWidth }] = (0, $3XwA1.useTimelineState)();
    const activeOrFutureGroups = (0, $3pD74.getActiveOrFutureIntervalGroups)({
        intervals: intervals,
        currentIntervalId: currentIntervalId,
        timelineDuration: timelineDuration,
        timelineWidth: timelineWidth
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, activeOrFutureGroups.map((intervalGroup, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $67lY7.default), {
            id: id,
            key: index,
            left: Math.max(intervalGroup.left, intervalGroup.targetIntervalLeft),
            right: Math.max(intervalGroup.right, intervalGroup.targetIntervalRight),
            intervals: intervalGroup.intervals,
            onClick: onClick
        })));
};
const $af6ec96c04a8f46d$export$f18d47ee39e90aec = ({ id: id, intervals: intervals, onClick: onClick })=>{
    // this is where we show/hide the dropzones
    const [{ isVisible: isVisible, currentIntervalId: currentIntervalId }] = (0, $hevaQ.useIntervalDropZoneData)(id);
    return isVisible ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($af6ec96c04a8f46d$var$VisibleIntervalDropZones, {
        id: id,
        intervals: intervals,
        currentIntervalId: currentIntervalId,
        onClick: onClick
    }) : null;
};
var $af6ec96c04a8f46d$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($af6ec96c04a8f46d$export$f18d47ee39e90aec);

});
parcelRegister("67lY7", function(module, exports) {

$parcel$export(module.exports, "default", () => $ce5a7260da90d7b6$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $eUqFw = parcelRequire("eUqFw");

var $PdmhA = parcelRequire("PdmhA");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $hevaQ = parcelRequire("hevaQ");
const $ce5a7260da90d7b6$var$DROPZONE_BACKGROUND = `var(--ds-background-accent-blue-bolder, ${`${(0, $PdmhA.B100)}`})`;
const $ce5a7260da90d7b6$var$INTERVAL_DROPZONE_WIDTH_EXPANSION = 2;
const $ce5a7260da90d7b6$var$dropZoneStyles = null;
const $ce5a7260da90d7b6$export$ad226bf0b5a21555 = ({ id: id, left: left, right: right, intervals: intervals, onClick: onClickDropZone })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [targetIntervalId] = (0, $hevaQ.useTargetIntervalId)(intervals);
    const { resetChartInteractionState: resetChartInteractionState } = (0, $hevaQ.useResetChartInteractionState)();
    const onClick = ()=>{
        if (onClickDropZone && targetIntervalId !== undefined) {
            const analyticsEvent = createAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'dropzone'
            });
            onClickDropZone(id, {
                intervalId: targetIntervalId
            }, analyticsEvent);
            resetChartInteractionState();
            (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'intervalDropzone');
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        onClick: onClick,
        onKeyDown: (e)=>(e.key === 'Enter' || e.key === 'Space') && onClick(),
        role: "presentation",
        className: (0, $7JEyt.default)([
            "_kqswstnw _4t3igktf _2rko1l7b _1pbycs5v _19it1gv3 _bfhkuyzt _v5641ql7"
        ]),
        style: {
            left: `${targetIntervalId !== undefined ? left - $ce5a7260da90d7b6$var$INTERVAL_DROPZONE_WIDTH_EXPANSION : left + 1}px`,
            right: `${targetIntervalId !== undefined ? right - $ce5a7260da90d7b6$var$INTERVAL_DROPZONE_WIDTH_EXPANSION : right + 1}px`,
            opacity: targetIntervalId !== undefined ? 0.38 : 0.13,
            cursor: targetIntervalId !== undefined ? 'pointer' : 'default',
            /* border width is used to expand the dropzone vertically */ borderWidth: targetIntervalId !== undefined ? `${$ce5a7260da90d7b6$var$INTERVAL_DROPZONE_WIDTH_EXPANSION}px` : 0,
            "--_1m5or25": (0, $9t7rW.default)($ce5a7260da90d7b6$var$DROPZONE_BACKGROUND)
        }
    });
};
var $ce5a7260da90d7b6$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($ce5a7260da90d7b6$export$ad226bf0b5a21555);

});

parcelRegister("3pD74", function(module, exports) {

$parcel$export(module.exports, "getActiveOrFutureIntervalGroups", () => $765f9e21fd77f69b$export$8d82d19c3a1af9a2);


var $9j4Ay = parcelRequire("9j4Ay");
const $765f9e21fd77f69b$export$8d82d19c3a1af9a2 = ({ intervals: intervals, currentIntervalId: currentIntervalId, timelineDuration: timelineDuration, timelineWidth: timelineWidth })=>{
    let unassignedIntervals = intervals;
    if (currentIntervalId !== undefined) unassignedIntervals = intervals.filter((interval)=>interval.id !== currentIntervalId);
    const intervalGroups = (0, $9j4Ay.getIntervalGroupPositions)(unassignedIntervals, timelineDuration, timelineWidth);
    return intervalGroups.filter((intervalGroup)=>intervalGroup.intervals.some((interval)=>interval.state !== (0, $4a21b57a573cad8c$export$19c4f83398a8dbce)));
};

});


parcelRegister("cxkGw", function(module, exports) {

$parcel$export(module.exports, "NoDateContent", () => $4daabea91b86b276$export$372da41cc9735180);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $hzcvF = parcelRequire("hzcvF");

var $hxnNZ = parcelRequire("hxnNZ");
var $6TBpb = parcelRequire("6TBpb");

var $bxXN4 = parcelRequire("bxXN4");

var $j1aaL = parcelRequire("j1aaL");
const $4daabea91b86b276$var$previewContainerStyles = null;
const $4daabea91b86b276$export$372da41cc9735180 = ({ id: id, level: level, color: color, startDateType: startDateType, dueDateType: dueDateType, isHovered: isHovered, onUpdate: onUpdate, children: children })=>{
    const lastScrollLeft = (0, $eUqFw.useRef)(0);
    const [isScrollingX] = (0, $hxnNZ.useIsScrollingX)();
    const wasScrollingX = (0, $hzcvF.usePreviousWithInitial)(isScrollingX);
    const { requestViewportScrollBounding: requestViewportScrollBounding } = (0, $6TBpb.useViewport)();
    const [{ isActive: isActive, leftPosition: leftPosition, rightPosition: rightPosition, dragType: dragType }, { onDragStart: onDragStart, onDrag: onDrag, onDragEnd: onDragEnd, onLingerStart: onLingerStart, onLingerEnd: onLingerEnd, onPreview: onPreview }] = (0, $bxXN4.useChartItemInteractions)(id);
    // === EFFECTS === //
    /* This component is hidden while scrolling. After scrolling ends we need to update the
   * preview position to match the new scroll offset (where the user cursor *now* is).
   */ (0, $eUqFw.useEffect)(()=>{
        if (isActive && !dragType) {
            const { scrollLeft: scrollLeft } = requestViewportScrollBounding();
            if (!wasScrollingX && isScrollingX) lastScrollLeft.current = scrollLeft;
            else if (wasScrollingX && !isScrollingX && leftPosition !== undefined) {
                const scrollOffset = scrollLeft - lastScrollLeft.current;
                lastScrollLeft.current = scrollLeft;
                onPreview(leftPosition + scrollOffset);
            }
        }
    });
    // === CALLBACKS === //
    const onContainerMouseMove = ({ pageX: pageX, currentTarget: currentTarget })=>{
        // Get the left position relative to the timeline
        onPreview(pageX - currentTarget.getBoundingClientRect().left);
    };
    const onPreviewClick = (params, analyticsEvent)=>{
        onUpdate(id, params, analyticsEvent);
        onLingerEnd();
    };
    const onPreviewDragEnd = (params, analyticsEvent)=>{
        onUpdate(id, params, analyticsEvent);
        onDragEnd();
    };
    // === RENDER === //
    /* Why check the passed in hover state when we have our own mouse enter and leave listeners here?
   * 1. The hover state is passed from a table internal renderer to minimise the consumer DOM (on average).
   *    We don't need to render an extra div to track the mouse move state until necessary.
   * 2. Calling onLingerStart and onLingerEnd from a useEffect results in an item's start being called before
   *    the previous items end which results in strange behaviour.
   */ if (isHovered && !isScrollingX || isActive && dragType) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        "data-testid": `roadmap.timeline-table-kit.ui.chart-item-content.no-date-content.preview-container-${id}`,
        onMouseMove: onContainerMouseMove,
        onMouseEnter: onLingerStart,
        onMouseLeave: onLingerEnd,
        className: (0, $7JEyt.default)([
            "_1bsb1osq _4t3i1osq _1e0c1txw _4cvr1h6o _1pbyouyt"
        ])
    }, children, leftPosition !== undefined && rightPosition !== undefined && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j1aaL.PreviewBar), {
        level: level,
        color: color,
        startDateType: startDateType,
        dueDateType: dueDateType,
        leftPosition: leftPosition,
        rightPosition: rightPosition,
        onDrag: onDrag,
        onDragStart: onDragStart,
        onDragEnd: onPreviewDragEnd,
        onClick: onPreviewClick
    }));
    return null;
};

});
parcelRegister("j1aaL", function(module, exports) {

$parcel$export(module.exports, "PreviewBar", () => $62bb2659498a4054$export$cf6bba1afb8df9b7);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $3R70n = parcelRequire("3R70n");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $kbiEp = parcelRequire("kbiEp");

var $3XwA1 = parcelRequire("3XwA1");

var $fHtBB = parcelRequire("fHtBB");
var $4P2VV = parcelRequire("4P2VV");

var $2sNQW = parcelRequire("2sNQW");

var $iQiGF = parcelRequire("iQiGF");
var $cww1R = parcelRequire("cww1R");
const $62bb2659498a4054$var$Bar = ({ left: left, right: right, level: level, color: color, children: children, 'data-testid': dataTestId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        style: {
            left: `${left}px`,
            right: `${right}px`
        },
        "data-testid": dataTestId,
        className: (0, $7JEyt.default)([
            "_kqswstnw _1ul91b66 _4t3i1tcg _1e0c1txw _4cvr1h6o _2rko1l7b _tzy4idpf _ju25fnf5 _5sagfnf5 _j7hq3v5s _1pgl1ytf _1o51q7pw _80omtlke",
            (0, $kbiEp.isBaseLevel)(level) && "_4t3igktf"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        style: {
            backgroundColor: (0, $iQiGF.getBarTheme)(color).background
        },
        className: (0, $7JEyt.default)([
            "_1sb2b3bt _kqswstnw _154iidpf _1ltvidpf _94n5idpf _1xi2idpf _tzy4105o _2rko1l7b"
        ])
    }), children);
const $62bb2659498a4054$var$DraggableBar = (0, $3R70n.withDragObserver)($62bb2659498a4054$var$Bar);
const $62bb2659498a4054$export$cf6bba1afb8df9b7 = ({ level: level, color: color, startDateType: startDateType, dueDateType: dueDateType, leftPosition: leftPosition, rightPosition: rightPosition, onDrag: onDrag, onDragStart: onDragStart, onDragEnd: onDragEnd, onClick: onClick })=>{
    const elemRef = (0, $eUqFw.useRef)(null);
    const [{ timelineDuration: timelineDuration, timelineWidth: timelineWidth }] = (0, $3XwA1.useTimelineState)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const startDate = (0, $cww1R.getStartDate)(leftPosition, timelineDuration, timelineWidth);
    const dueDate = (0, $cww1R.getDueDate)(rightPosition, timelineDuration, timelineWidth);
    // === CALLBACKS === //
    const onHandleDragStart = ()=>{
        // Just a sensible default direction, this will update depending on current drag state
        onDragStart((0, $4P2VV.RIGHT));
    };
    const onHandleDragEnd = ()=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'dragged',
            actionSubject: 'previewBar'
        });
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'previewBar', {
            level: level
        });
        onDragEnd({
            dates: {
                startDate: startDate,
                dueDate: dueDate
            }
        }, analyticsEvent);
    };
    const onHandleClick = ()=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'previewBar'
        });
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'previewBar', {
            level: level
        });
        onClick({
            dates: {
                startDate: startDate,
                dueDate: dueDate
            }
        }, analyticsEvent);
    };
    const getBarBoundingClientRect = ()=>elemRef.current?.getBoundingClientRect();
    // === RENDER === //
    /* Interval items should:
   * - Not be draggable, since their dates only be set to existing intervals, not arbitrarily.
   * - Not display date labels, for the same reason as above.
   */ const isIntervalDateType = startDateType === (0, $fHtBB.INTERVAL) && dueDateType === (0, $fHtBB.INTERVAL);
    return(// NOTE: ts error needs to be fixed in withDragObserver from @atlassian/jira-drag-observer
    // @ts-expect-error - TS2322 - Type '{ children: false | Element; "data-testid": string; innerRef: MutableRefObject<unknown>; color: Color; left: number; right: number; isDisabled: boolean; onDrag: OnDrag; onDragStart: OnDragStart; onDragEnd: OnDragEnd; onClick: () => void; }' is not assignable to type 'IntrinsicAttributes & IntrinsicClassAttributes<DragObserver> & Pick<Readonly<Props>, never> & InexactPartial<...> & InexactPartial<...>'.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($62bb2659498a4054$var$DraggableBar, {
        "data-testid": "roadmap.timeline-table-kit.ui.chart-item-content.no-date-content.preview-bar.preview-bar",
        innerRef: elemRef,
        color: color,
        left: leftPosition,
        right: rightPosition,
        isDisabled: isIntervalDateType,
        onDrag: onDrag,
        onDragStart: onHandleDragStart,
        onDragEnd: onHandleDragEnd,
        onClick: onHandleClick
    }, !isIntervalDateType && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2sNQW.RoadmapDateLabels), {
        startDate: startDate,
        dueDate: dueDate,
        getBarBoundingClientRect: getBarBoundingClientRect
    })));
};
const $62bb2659498a4054$var$fadeInStyles = null;
const $62bb2659498a4054$var$baseLevelStyles = null;
const $62bb2659498a4054$var$barStyles = null;
// NOTE: There's no easy way atm to apply opacity to a color token without affecting its children
// Hence, a pseudo "before" element is used as a hack here for controlling the background color
const $62bb2659498a4054$var$indicatorStyles = null;

});



parcelRegister("390co", function(module, exports) {

$parcel$export(module.exports, "renderBarContent", () => $0d94e71adcb89252$export$2c88996aa786b971);

var $eUqFw = parcelRequire("eUqFw");

var $e3AcU = parcelRequire("e3AcU");
var $2sNQW = parcelRequire("2sNQW");

var $9kISn = parcelRequire("9kISn");

var $2ua8t = parcelRequire("2ua8t");
const $0d94e71adcb89252$export$2c88996aa786b971 = (barContentProps, barContentState)=>{
    const barContentRenderers = {
        renderBarIcon: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9kISn.BarIcon), {
                ...props,
                isHovered: barContentState.isHovered
            }),
        renderDependencyHandler: (props, state)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2ua8t.DependencyHandler), {
                ...props,
                ...state
            }),
        renderDateLabel: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2sNQW.RoadmapDateLabels), props)
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $e3AcU.RoadmapBarContent), {
        ...barContentProps,
        ...barContentState,
        ...barContentRenderers
    });
};

});
parcelRegister("9kISn", function(module, exports) {

$parcel$export(module.exports, "BarIcon", () => $d00cda8827a138c4$export$48fe3a86c9f0baf3);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $iJlfe = parcelRequire("iJlfe");

var $k9Z3M = parcelRequire("k9Z3M");

var $hUwRB = parcelRequire("hUwRB");

var $ltfxy = parcelRequire("ltfxy");

var $c0jFd = parcelRequire("c0jFd");
var $1ZAYh = parcelRequire("1ZAYh");

var $PdmhA = parcelRequire("PdmhA");

var $8cU5f = parcelRequire("8cU5f");

var $kkACl = parcelRequire("kkACl");

var $8Qd0L = parcelRequire("8Qd0L");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $fD1Hq = parcelRequire("fD1Hq");

var $6vrw7 = parcelRequire("6vrw7");

var $3XwA1 = parcelRequire("3XwA1");
var $6TBpb = parcelRequire("6TBpb");


var $PFCIp = parcelRequire("PFCIp");

var $1zeqz = parcelRequire("1zeqz");

var $fqRkR = parcelRequire("fqRkR");
const $d00cda8827a138c4$var$ICON_SIZE = 20;
const $d00cda8827a138c4$var$BAR_PADDING = 24;
const $d00cda8827a138c4$export$9b0440c731c2c8d1 = /*#__PURE__*/ (0, $eUqFw.memo)(({ dependees: dependees, dependencies: dependencies, id: id, isHovered: isHovered, issue: issue, withAvatar: withAvatar, withDoneIcon: withDoneIcon, withIconNudge: withIconNudge, withLinksIcon: withLinksIcon })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [, { setTooltipParams: setTooltipParams }] = (0, $1zeqz.useDependencyTooltip)();
    const onLinkIconClick = (0, $eUqFw.useCallback)((event)=>{
        const target = event.currentTarget;
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'icon'
        });
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'dependencyIcon');
        const links = {
            fromIds: dependencies,
            toIds: dependees
        }; // Roadmap's dependency tooltip relies on a render caused by "onClose" for correct positioning,
        // where it re-mounts inline-dialog. Therefore we let React unmount the dialog before setting new position
        setTimeout(()=>{
            if (target != null) {
                const { top: top, left: left, height: height } = target.getBoundingClientRect();
                const position = {
                    x: left,
                    y: top + height
                };
                setTooltipParams({
                    id: id,
                    type: (0, $aba7cf5b5acfd3bc$export$4b680a32bbb87a28),
                    links: links,
                    position: position
                });
            }
        });
    }, [
        createAnalyticsEvent,
        dependencies,
        dependees,
        setTooltipParams,
        id
    ]);
    const detailsIconContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d00cda8827a138c4$var$LinkIconWrapper, {
        onClick: onLinkIconClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        position: "top",
        content: formatMessage((0, $fqRkR.default).viewDetail),
        hideTooltipOnClick: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hUwRB))), {
        size: "small",
        label: "",
        primaryColor: `var(--ds-icon-inverse, ${(0, $PdmhA).N0})`
    })));
    const detailsIcon = withIconNudge ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ltfxy.default), {
        name: (0, $62f34a28cfc7189c$export$f5cfd1d92acc18fb)
    }, detailsIconContent) : detailsIconContent;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d00cda8827a138c4$var$BarContentWrapper, {
        isHovered: isHovered,
        withAvatar: withAvatar
    }, withAvatar && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJlfe.default), {
        appearance: "circle",
        src: issue?.assignee?.avatarUrl,
        size: "xsmall"
    }), (withDoneIcon || withLinksIcon) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d00cda8827a138c4$var$IconsWrapper, null, withDoneIcon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($k9Z3M))), {
        label: formatMessage((0, $fqRkR.default).doneLabel),
        primaryColor: `var(--ds-icon-inverse, ${(0, $PdmhA).N0})`,
        size: "small"
    }), withLinksIcon && detailsIcon));
});
const $d00cda8827a138c4$export$48fe3a86c9f0baf3 = ({ id: id, isHovered: isHovered, leftPosition: leftPosition, rightPosition: rightPosition })=>{
    const [{ timelineWidth: timelineWidth }] = (0, $3XwA1.useTimelineState)();
    const [{ issuesMap: issuesMap }] = (0, $PFCIp.useIssuesMap)();
    const [{ nudgeStep: nudgeStep }] = (0, $kkACl.useNudgeStep)();
    const { requestViewportScrollBounding: requestViewportScrollBounding } = (0, $6TBpb.useViewport)();
    const isLinkingEnabled = (0, $fD1Hq.useIsLinkingEnabled)();
    const issue = issuesMap.get(id);
    const [dependencies, dependees] = (0, $eUqFw.useMemo)(()=>{
        const [inwards, outwards] = [
            [],
            []
        ];
        (issue?.issueLinks || []).forEach((link)=>{
            const { inward: inward, outward: outward } = link;
            const inwardId = inward?.issueId;
            const outwardId = outward?.issueId;
            if (inwardId && inwardId !== issue?.issueId && issuesMap.has(inwardId)) // @ts-expect-error - TS2345 - Argument of type 'any' is not assignable to parameter of type 'never'.
            inwards.push(inwardId);
            if (outwardId && outwardId !== issue?.issueId && issuesMap.has(outwardId)) // @ts-expect-error - TS2345 - Argument of type 'any' is not assignable to parameter of type 'never'.
            outwards.push(outwardId);
        });
        return [
            inwards,
            outwards
        ];
    }, [
        issuesMap,
        issue
    ]);
    const [firstItem] = Array.from(issuesMap.values());
    const isDone = (0, $eUqFw.useMemo)(()=>(0, $8Qd0L.statusCategoryForId)(issue?.status?.categoryId) === (0, $8Qd0L.DONE), [
        issue
    ]);
    const hasLinks = isLinkingEnabled && (dependencies.length > 0 || dependees.length > 0);
    if (!issue) return null;
     // Determine which icons should be shown based on the available width of the bar
    const barWidth = timelineWidth - leftPosition - rightPosition;
    let shouldShowDone = false;
    let shouldShowAvatar = false;
    let availableIconSpaces = (barWidth - $d00cda8827a138c4$var$BAR_PADDING) / $d00cda8827a138c4$var$ICON_SIZE;
    if (hasLinks) availableIconSpaces -= 1;
    if (isDone) {
        shouldShowDone = availableIconSpaces >= 1;
        availableIconSpaces -= 1;
    }
    if (availableIconSpaces >= 1) shouldShowAvatar = true;
     // Determine whether to render onboarding nudges
    const { scrollLeft: scrollLeft, scrollRight: scrollRight } = requestViewportScrollBounding();
    const isBarInPast = leftPosition < scrollLeft;
    const isBarInFuture = rightPosition < scrollRight;
    const isBarInView = !isBarInPast && !isBarInFuture;
    const isFirstItem = id === firstItem?.issueId;
    const shouldRenderIconNudge = isFirstItem && nudgeStep === (0, $62f34a28cfc7189c$export$f5cfd1d92acc18fb) && isBarInView;
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d00cda8827a138c4$export$9b0440c731c2c8d1, {
        dependees: dependees,
        dependencies: dependencies,
        id: (0, $6vrw7.toIssueId)(id),
        isHovered: isHovered,
        issue: issue,
        withAvatar: shouldShowAvatar,
        withDoneIcon: shouldShowDone,
        withIconNudge: shouldRenderIconNudge,
        withLinksIcon: hasLinks
    });
    return content;
};
// eslint-disable-next-line jira/styled/styled-component-order
const $d00cda8827a138c4$var$barContentWrapperBaseStyles = (0, $1ZAYh.xcss)({
    flex: 1,
    transition: 'padding-left 100ms ease-in-out',
    pointerEvents: 'none',
    marginRight: 'space.0',
    paddingLeft: 'space.0'
}); // eslint-disable-next-line jira/styled/styled-component-order
const $d00cda8827a138c4$var$barContentWrapperWithAvatarStyles = (0, $1ZAYh.xcss)({
    marginRight: 'space.100'
}); // eslint-disable-next-line jira/styled/styled-component-order
const $d00cda8827a138c4$var$barContentWrapperWithAvatarAndHoverStyles = (0, $1ZAYh.xcss)({
    paddingLeft: 'space.100'
});
const $d00cda8827a138c4$var$BarContentWrapper = ({ isHovered: isHovered, withAvatar: withAvatar, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c0jFd.default), {
        alignItems: "center",
        justifyContent: withAvatar ? 'space-between' : 'center',
        xcss: [
            $d00cda8827a138c4$var$barContentWrapperBaseStyles,
            withAvatar && $d00cda8827a138c4$var$barContentWrapperWithAvatarStyles,
            isHovered && withAvatar && $d00cda8827a138c4$var$barContentWrapperWithAvatarAndHoverStyles
        ]
    }, children); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d00cda8827a138c4$var$LinkIconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _1bsbgktf _4t3igktf _2rko1ssb _1pbyegat _80omtlke _p7r11txw _irr3178z",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d00cda8827a138c4$var$IconsWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1yb4",
            __cmplp.className
        ])
    });
});

});
parcelRegister("k9Z3M", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ead4032469749d51$var$_react = $ead4032469749d51$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $ead4032469749d51$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $ead4032469749d51$var$EditorDoneIcon = (props)=>/*#__PURE__*/ $ead4032469749d51$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M7.356 10.942a.497.497 0 00-.713 0l-.7.701a.501.501 0 00-.003.71l3.706 3.707a.501.501 0 00.705.003l7.712-7.712a.493.493 0 00-.006-.708l-.7-.7a.504.504 0 00-.714 0l-6.286 6.286a.506.506 0 01-.713 0l-2.288-2.287z" fill="currentColor"/></svg>`
    }, props));
$ead4032469749d51$var$EditorDoneIcon.displayName = 'EditorDoneIcon';
var $ead4032469749d51$var$_default = $ead4032469749d51$var$EditorDoneIcon;
module.exports.default = $ead4032469749d51$var$_default;

});

parcelRegister("1zeqz", function(module, exports) {

$parcel$export(module.exports, "useDependencyTooltip", () => $0794b43cd452eff8$export$8a5ed5a9e3a93595);

var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");

var $jjA5j = parcelRequire("jjA5j");
const $0794b43cd452eff8$var$actions = {
    setTooltipParams: (tooltip)=>({ setState: setState, getState: getState })=>setState({
                ...getState(),
                tooltipParams: (0, $jjA5j.getDependenciesTooltipParams)({
                    tooltip: tooltip
                })
            }),
    onCloseTooltip: ()=>({ setState: setState, getState: getState })=>{
            setState({
                ...getState(),
                tooltipParams: undefined
            });
        }
};
// @ts-expect-error - TS2344 - Type '{ readonly setTooltipParams: (tooltip: DependencyTooltip) => ({ setState, getState }: StoreState<State>) => void; readonly onCloseTooltip: () => ({ setState, getState }: StoreState<State>) => void; }' does not satisfy the constraint 'Record<string, ActionThunk<State, { readonly setTooltipParams: (tooltip: DependencyTooltip) => ({ setState, getState }: StoreState<State>) => void; readonly onCloseTooltip: () => ({ setState, getState }: StoreState<...>) => void; }>>'.
const $0794b43cd452eff8$var$Store = (0, $a61MH.createStore)({
    initialState: {
        tooltipParams: undefined
    },
    actions: $0794b43cd452eff8$var$actions,
    name: 'JWMTimelineViewDependencyTooltipStore'
});
const $0794b43cd452eff8$export$8a5ed5a9e3a93595 = (0, $ggKAj.createHook)($0794b43cd452eff8$var$Store);

});
parcelRegister("jjA5j", function(module, exports) {

$parcel$export(module.exports, "getDependenciesTooltipParams", () => $68b6ae46f9ad92bb$export$9b579a6f4b6af263);

const $68b6ae46f9ad92bb$export$9b579a6f4b6af263 = ({ tooltip: tooltip })=>{
    if (tooltip && tooltip.type === (0, $aba7cf5b5acfd3bc$export$4b680a32bbb87a28)) {
        const { id: id, position: position, links: { fromIds: fromIds, toIds: toIds } } = tooltip;
        return {
            position: position,
            issueId: id,
            dependencies: fromIds,
            dependees: toIds
        };
    }
    return undefined;
};

});


parcelRegister("fqRkR", function(module, exports) {

$parcel$export(module.exports, "default", () => $f589623ec156f9c1$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $f589623ec156f9c1$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    doneLabel: {
        "id": "business-timeline.timeline-view.chart-item-content.bar-content.bar-icon.done-label",
        "defaultMessage": "Done"
    },
    viewDetail: {
        "id": "business-timeline.timeline-view.chart-item-content.bar-content.bar-icon.view-detail",
        "defaultMessage": "View dependency details"
    }
});

});


parcelRegister("2ua8t", function(module, exports) {

$parcel$export(module.exports, "DependencyHandler", () => $29f59a5fa5a837fd$export$15fb125bf375b8e5);

var $eUqFw = parcelRequire("eUqFw");

var $7byHA = parcelRequire("7byHA");

var $k8Qyf = parcelRequire("k8Qyf");

var $fD1Hq = parcelRequire("fD1Hq");

var $6vrw7 = parcelRequire("6vrw7");

var $dBmAu = parcelRequire("dBmAu");

var $aRSCW = parcelRequire("aRSCW");

var $PFCIp = parcelRequire("PFCIp");

var $203kY = parcelRequire("203kY");

var $bJA0r = parcelRequire("bJA0r");

var $d57Fs = parcelRequire("d57Fs");
const $29f59a5fa5a837fd$export$15fb125bf375b8e5 = (props)=>{
    const { id: id } = props;
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagService)();
    const [{ issuesMap: issuesMap }] = (0, $PFCIp.useIssuesMap)();
    const isLinkingEnabled = (0, $fD1Hq.useIsLinkingEnabled)();
    const { hasIssueLinking: hasIssueLinking } = (0, $203kY.useTimelineFeatures)();
    const { create: create } = (0, $bJA0r.useCreateDependency)();
    const issue = issuesMap.get(id);
    const color = (0, $aRSCW.getColor)(issue?.status.categoryId);
    const onCreateDependency = (from, to)=>{
        if (from !== to) // @see JET-1624, JET-1626: we need to let the UI cleanup the drag state first
        requestAnimationFrame(()=>{
            create({
                input: {
                    inwardIssueId: (0, $6vrw7.toIssueId)(to),
                    outwardIssueId: (0, $6vrw7.toIssueId)(from)
                }
            }).catch((createError)=>{
                showFlag({
                    type: 'error',
                    title: (0, $d57Fs.default).createDependencyErrorTitle,
                    description: createError instanceof (0, $7byHA.ValidationError) ? [
                        (0, $d57Fs.default).createDependencyDynamicErrorMessage,
                        {
                            error: createError.message
                        }
                    ] : (0, $d57Fs.default).createDependencyErrorMessage
                });
            });
        });
    };
    if (!hasIssueLinking || isLinkingEnabled !== true) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dBmAu.RoadmapDependencyHandlers), {
        color: color,
        onCreateDependency: onCreateDependency,
        ...props
    });
};

});
parcelRegister("bJA0r", function(module, exports) {

$parcel$export(module.exports, "useCreateDependency", () => $2d64ef8cc479a060$export$8194a3b2b545a3ed);

var $iZuDo = parcelRequire("iZuDo");

var $4G5xU = parcelRequire("4G5xU");

var $guiFP = parcelRequire("guiFP");

var $7byHA = parcelRequire("7byHA");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $2nzpw = parcelRequire("2nzpw");

var $PFCIp = parcelRequire("PFCIp");

var $hyqqr = parcelRequire("hyqqr");

var $7gIiY = parcelRequire("7gIiY");

var $lK6LT = parcelRequire("lK6LT");
const $2d64ef8cc479a060$export$5dfc3c3db5e1e7f6 = [
    'issuelinks'
];
const $2d64ef8cc479a060$var$QUERY_NAME = 'createDependencyTimelineView';
const $2d64ef8cc479a060$var$findMutationBadRequestError = (data)=>data?.linkJwmItems?.errors?.find((e)=>e.message);
const $2d64ef8cc479a060$export$8194a3b2b545a3ed = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { updateIssueLinksInCache: updateIssueLinksInCache } = (0, $hyqqr.useUpdateIssueLinksInCache)();
    const [{ issuesMap: issuesMap }] = (0, $PFCIp.useIssuesMap)();
    const startExperience = (0, $4G5xU.useExperienceStart)((0, $2nzpw.LINK_ISSUES_EXPERIENCE));
    const markExperienceSuccess = (0, $4G5xU.useExperienceSuccess)((0, $2nzpw.LINK_ISSUES_EXPERIENCE));
    const markExperienceFailed = (0, $4G5xU.useExperienceFail)((0, $2nzpw.LINK_ISSUES_EXPERIENCE));
    const [createDependency, { data: data, loading: loading, error: error }] = (0, $iZuDo.useMutation)((0, $7gIiY.CREATE_DEPENDENCY_TIMELINE_MUTATION), {
        onError: (apolloError)=>{
            (0, $guiFP.default)({
                meta: {
                    id: $2d64ef8cc479a060$var$QUERY_NAME,
                    packageName: 'jiraBusinessTimeline',
                    teamName: 'jira-yurree'
                },
                error: apolloError,
                attributes: {
                    message: 'Failed to create dependency in timeline view'
                },
                sendToPrivacyUnsafeSplunk: true
            });
            markExperienceFailed('timeline create dependency service', apolloError);
        },
        onCompleted: (apolloData)=>{
            const mutationBadRequestError = $2d64ef8cc479a060$var$findMutationBadRequestError(apolloData);
            if (mutationBadRequestError) markExperienceFailed('timeline create dependency service', Error(mutationBadRequestError.message ?? 'MutationBadRequestError'));
            else {
                (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), `${$2d64ef8cc479a060$var$QUERY_NAME} succeeded`, {});
                markExperienceSuccess();
            }
        }
    });
    const create = async ({ input: input })=>{
        startExperience();
        const optimisticResponse = {
            linkJwmItems: (0, $lK6LT.createOptimisticLinkItems)({
                inwardIssueId: input.inwardIssueId,
                outwardIssueId: input.outwardIssueId,
                issuesMap: issuesMap
            })
        };
        const response = await createDependency({
            variables: {
                input: input,
                fieldIdsToReturn: []
            },
            optimisticResponse: optimisticResponse,
            update: (proxy, result)=>{
                const linkJwmItems = result.data?.linkJwmItems;
                if (linkJwmItems) {
                    // update both issues (dependency and dependee) in Apollo cache with newly created links
                    updateIssueLinksInCache({
                        issueId: linkJwmItems.inwardItem?.issueId,
                        issueLinks: linkJwmItems.inwardItem?.issueLinks
                    });
                    updateIssueLinksInCache({
                        issueId: linkJwmItems.outwardItem?.issueId,
                        issueLinks: linkJwmItems.outwardItem?.issueLinks
                    });
                }
            }
        });
        const mutationError = $2d64ef8cc479a060$var$findMutationBadRequestError(response.data);
        if (mutationError) throw new (0, $7byHA.ValidationError)(mutationError.message ?? '');
    };
    return {
        loading: loading,
        // @ts-expect-error - Type 'ApolloError | CreateJWMDependencyTimelineView_linkJwmItems_errors | undefined' is not assignable to type 'ApolloError | undefined'.
        // if there are any errors from Apollo, surface that first
        // otherwise if there are errors from bad request, use that
        error: error || $2d64ef8cc479a060$var$findMutationBadRequestError(data),
        create: create
    };
};

});
parcelRegister("hyqqr", function(module, exports) {

$parcel$export(module.exports, "useUpdateIssueLinksInCache", () => $bbddb8364de33b12$export$a74cd4b680b6b775);
/* eslint-disable camelcase */ 
var $gEmpR = parcelRequire("gEmpR");

var $lGxgz = parcelRequire("lGxgz");

var $hTnQu = parcelRequire("hTnQu");

var $1ybV0 = parcelRequire("1ybV0");

var $2nzpw = parcelRequire("2nzpw");

var $hszK4 = parcelRequire("hszK4");

var $am0NO = parcelRequire("am0NO");

var $dLnS7 = parcelRequire("dLnS7");
const $bbddb8364de33b12$export$a74cd4b680b6b775 = ()=>{
    const { updateItemsInCache: updateItemsInCache } = (0, $hTnQu.useCacheActions)();
    const [{ issueParentMap: issueParentMap }] = (0, $am0NO.useIssueParentMap)();
    const { hierarchyLevels: hierarchyLevels } = (0, $gEmpR.useIssueTypesAndFields)({
        issueOperation: 'VIEW'
    });
    const { quickFiltersJql: quickFiltersJql, hierarchyParent: hierarchyParent, jqlContext: jqlContext, isHidingDoneItems: isHidingDoneItems } = (0, $lGxgz.useFilteredViewContextInput)({
        view: 'timeline'
    });
    const hierarchyLevel = hierarchyLevels[0]?.level;
    const updateIssueLinksInCache = ({ issueId: issueId, issueLinks: issueLinks })=>{
        if (!issueId) return;
        const parentIssueId = issueParentMap.get(String(issueId));
        const hasParentIssue = parentIssueId != null && hierarchyParent != null;
        updateItemsInCache({
            query: (0, $dLnS7.TIMELINE_VIEW_ITEMS_QUERY),
            variables: {
                ...(0, $hszK4.getVariables)({
                    jqlContext: jqlContext,
                    fieldIds: $2nzpw.fieldIds,
                    quickFiltersJql: quickFiltersJql,
                    isHidingDoneItems: isHidingDoneItems,
                    ...(0, $1ybV0.ff)('jwm.visual-hierarchy-milestone-1') ? {
                        hierarchyLevel: hierarchyLevel
                    } : {},
                    hierarchyParent: hierarchyParent,
                    ...hasParentIssue ? {
                        hierarchyParent: undefined,
                        parentIssue: {
                            hierarchyType: hierarchyParent,
                            issueId: parentIssueId
                        }
                    } : {}
                }),
                ...hasParentIssue ? null : (0, $2nzpw.TIMELINE_PAGE_SIZE_ARGS)
            },
            issueIds: [
                issueId
            ],
            updateItem: (existingIssue)=>({
                    ...existingIssue,
                    issueLinks: issueLinks ?? null
                })
        });
    };
    return {
        updateIssueLinksInCache: updateIssueLinksInCache
    };
};

});

parcelRegister("7gIiY", function(module, exports) {

$parcel$export(module.exports, "CREATE_DEPENDENCY_TIMELINE_MUTATION", () => $06ff2ca089317971$export$aca1ef0fe554e695);

var $9ypom = parcelRequire("9ypom");
const $06ff2ca089317971$export$aca1ef0fe554e695 = (0, $9ypom.default)`
    mutation CreateJWMDependencyTimelineView($input: JWMLinkItemsInput!, $fieldIdsToReturn: [String]!) {
        linkJwmItems(input: $input, fieldIdsToReturn: $fieldIdsToReturn) {
            inwardItem {
                issueId
                issueLinks(first: 10) {
                    edges {
                        node {
                            issue {
                                issueId
                            }
                            issueLinkId
                            relationName
                            direction
                        }
                    }
                }	
            }
            outwardItem {
                issueId
                issueLinks(first: 10) {
                    edges {
                        node {
                            issue {
                                issueId
                            }
                            issueLinkId
                            relationName
                            direction
                        }
                    }
                }	
            }
            success
            errors {
                message
                extensions {
                    statusCode
                    errorType
                }
            }
        }
    }
`;

});

parcelRegister("lK6LT", function(module, exports) {

$parcel$export(module.exports, "createOptimisticLinkItems", () => $5d8b922de5815851$export$f5f603284bb2b3c7);
/* eslint-disable camelcase */ const $5d8b922de5815851$var$OPTIMISTIC_ID_PREFIX = 'optimistic-issuelink-id-';
const $5d8b922de5815851$export$f5f603284bb2b3c7 = ({ inwardIssueId: inwardIssueId, outwardIssueId: outwardIssueId, issuesMap: issuesMap })=>({
        inwardItem: {
            issueId: Number(inwardIssueId),
            issueLinks: {
                edges: [
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    ...issuesMap.get(inwardIssueId)?.originalIssueLinks || [],
                    {
                        node: {
                            issue: {
                                issueId: outwardIssueId,
                                __typename: 'JiraIssue'
                            },
                            issueLinkId: `${$5d8b922de5815851$var$OPTIMISTIC_ID_PREFIX}${outwardIssueId}`,
                            relationName: 'is blocked by',
                            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                            direction: 'OUTWARD',
                            __typename: 'JiraIssueLink'
                        },
                        __typename: 'JiraIssueLinkEdge'
                    }
                ],
                __typename: 'JiraIssueLinkConnection'
            },
            __typename: 'JiraWorkManagementViewItem'
        },
        outwardItem: {
            issueId: Number(outwardIssueId),
            issueLinks: {
                edges: [
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    ...issuesMap.get(outwardIssueId)?.originalIssueLinks || [],
                    {
                        node: {
                            issue: {
                                issueId: inwardIssueId,
                                __typename: 'JiraIssue'
                            },
                            issueLinkId: `${$5d8b922de5815851$var$OPTIMISTIC_ID_PREFIX}${inwardIssueId}`,
                            relationName: 'blocks',
                            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                            direction: 'INWARD',
                            __typename: 'JiraIssueLink'
                        },
                        __typename: 'JiraIssueLinkEdge'
                    }
                ],
                __typename: 'JiraIssueLinkConnection'
            },
            __typename: 'JiraWorkManagementViewItem'
        },
        success: true,
        errors: null,
        __typename: 'JWMLinkItemsPayload'
    });

});


parcelRegister("d57Fs", function(module, exports) {

$parcel$export(module.exports, "default", () => $2a04f9cf5984d539$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $2a04f9cf5984d539$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    createDependencyErrorTitle: {
        "id": "business-timeline.timeline-view.chart-item-content.bar-content.dependency-handler.create-dependency-error-title",
        "defaultMessage": "We couldn't link items"
    },
    createDependencyErrorMessage: {
        "id": "business-timeline.timeline-view.chart-item-content.bar-content.dependency-handler.create-dependency-error-message",
        "defaultMessage": "Check your connection, then give it another try."
    },
    createDependencyDynamicErrorMessage: {
        "id": "business-timeline.timeline-view.chart-item-content.bar-content.dependency-handler.create-dependency-dynamic-error-message",
        "defaultMessage": "{error}"
    }
});

});



parcelRegister("jlF1Y", function(module, exports) {

$parcel$export(module.exports, "START_DATE_LATER_DUE_DATE_MESSAGE_ID", () => $8cd00cb115c2965a$export$92d02ff4a955dc9b);

var $12sLA = parcelRequire("12sLA");
const $8cd00cb115c2965a$export$92d02ff4a955dc9b = (0, $12sLA.default).startDateLaterDueDate;

});
parcelRegister("12sLA", function(module, exports) {

$parcel$export(module.exports, "default", () => $493fa3f5711c5fda$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $493fa3f5711c5fda$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    startDateLaterDueDate: {
        "id": "business-timeline.timeline-view.chart-item-content.start-date-later-due-date",
        "defaultMessage": "Start date must be before Due date."
    }
});

});



parcelRegister("dxylj", function(module, exports) {

$parcel$export(module.exports, "ChartItemContentLite", () => $f9ad80f5069ae04d$export$5e423deb824db21b);

var $eUqFw = parcelRequire("eUqFw");

var $cERyr = parcelRequire("cERyr");
var $bl3ir = parcelRequire("bl3ir");

var $aRSCW = parcelRequire("aRSCW");
const $f9ad80f5069ae04d$export$5e423deb824db21b = (props)=>{
    const { issue: issue, startDate: startDate, dueDate: dueDate, level: level } = props;
    const { status: status, startDate: actualStartDate, dueDate: actualDueDate } = issue;
    const color = (0, $aRSCW.getColor)(status.categoryId);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bl3ir.RoadmapChartItemContentLite), {
        color: color,
        startDate: startDate,
        dueDate: dueDate,
        placeholder: (0, $cERyr.getPlaceholder)(!actualStartDate, !actualDueDate),
        level: level
    });
};

});
parcelRegister("bl3ir", function(module, exports) {

$parcel$export(module.exports, "RoadmapChartItemContentLite", () => $637e09d5da9856a9$export$440d1bc6878927ac);

var $eUqFw = parcelRequire("eUqFw");

var $3XwA1 = parcelRequire("3XwA1");

var $3qiQH = parcelRequire("3qiQH");

var $cww1R = parcelRequire("cww1R");
var $iQiGF = parcelRequire("iQiGF");
const $637e09d5da9856a9$var$DateItemLite = ({ startDate: startDate, dueDate: dueDate, level: level, placeholder: placeholder, color: color })=>{
    const [{ timelineDuration: timelineDuration, timelineWidth: timelineWidth }] = (0, $3XwA1.useTimelineState)();
    const barLeftPosition = (0, $cww1R.getBarLeftPosition)(startDate, timelineDuration, timelineWidth);
    const barRightPosition = (0, $cww1R.getBarRightPosition)(dueDate, timelineDuration, timelineWidth);
    const isBarVisible = (0, $cww1R.getIsBarVisible)(barLeftPosition, barRightPosition, timelineWidth);
    if (!isBarVisible) return null;
    const theme = (0, $iQiGF.getBarTheme)(color);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            ...(0, $3qiQH.getBaseBarStyles)({
                level: level,
                theme: theme,
                placeholder: placeholder
            }),
            left: `${barLeftPosition}px`,
            right: `${barRightPosition}px`
        }
    });
};
const $637e09d5da9856a9$export$440d1bc6878927ac = ({ startDate: startDate, dueDate: dueDate, ...restProps })=>{
    if (startDate !== undefined && dueDate !== undefined) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($637e09d5da9856a9$var$DateItemLite, {
        ...restProps,
        startDate: startDate,
        dueDate: dueDate
    });
    return null;
};

});


parcelRegister("hZat9", function(module, exports) {

$parcel$export(module.exports, "ChartItemContentSkeleton", () => $867fc5eaf81ec8a3$export$e1058ec667e297ea);

var $eUqFw = parcelRequire("eUqFw");

var $6wqPF = parcelRequire("6wqPF");
var $f9KE2 = parcelRequire("f9KE2");
var $9FEvp = parcelRequire("9FEvp");

var $gf0vG = parcelRequire("gf0vG");
var $3XwA1 = parcelRequire("3XwA1");

var $cww1R = parcelRequire("cww1R");

var $ijZnZ = parcelRequire("ijZnZ");
const $867fc5eaf81ec8a3$export$e1058ec667e297ea = /*#__PURE__*/ (0, $eUqFw.memo)(()=>{
    const [{ timelineDuration: timelineDuration, timelineWidth: timelineWidth }] = (0, $3XwA1.useTimelineState)();
    const today = Date.now();
    const startDate = (0, $f9KE2.default)((0, $9FEvp.default)(today, Math.floor(Math.random() * 10) + 1));
    const dueDate = (0, $f9KE2.default)((0, $6wqPF.default)(today, Math.floor(Math.random() * 10) + 30));
    const leftPosition = (0, $cww1R.getBarLeftPosition)(startDate, timelineDuration, timelineWidth);
    const rightPosition = (0, $cww1R.getBarRightPosition)(dueDate, timelineDuration, timelineWidth);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ijZnZ.LoadingBar), {
        leftPosition: leftPosition,
        rightPosition: rightPosition,
        itemHeight: (0, $gf0vG.DEFAULT_ITEM_HEIGHT)
    });
});

});

parcelRegister("3gNlI", function(module, exports) {

$parcel$export(module.exports, "ChartOverlay", () => $43b0a7a66a00f039$export$bc9910710930e66a);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $opsFH = parcelRequire("opsFH");

var $VrUCp = parcelRequire("VrUCp");

var $4y1Ki = parcelRequire("4y1Ki");
var $3HSXN = parcelRequire("3HSXN");


var $2nzpw = parcelRequire("2nzpw");

var $6ELMa = parcelRequire("6ELMa");

var $aRSCW = parcelRequire("aRSCW");

var $8bngU = parcelRequire("8bngU");

var $9dlSD = parcelRequire("9dlSD");

var $ldv0L = parcelRequire("ldv0L");
const $43b0a7a66a00f039$var$DndLongTaskMetricComponent = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6ELMa.DndLongTaskMetric), {
        ...props,
        metricType: (0, $028d5637f56fe710$export$3ac90e7f239a7193)
    });
const $43b0a7a66a00f039$var$renderOverlayButton = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9dlSD.ChartOverlayButton), null);
const $43b0a7a66a00f039$export$bc9910710930e66a = ({ issuesMap: issuesMap })=>{
    const [{ headerHeight: headerHeight }] = (0, $VrUCp.useHeaderState)();
    const renderPreview = (props)=>{
        const previewProps = (0, $ldv0L.getPreviewProps)(props);
        if (!previewProps) return null;
        const item = issuesMap.get(previewProps.id);
        const color = item ? (0, $aRSCW.getColor)(item.status.categoryId) : // We are mapping Color to design tokens in transformColorToTheme
        (0, $opsFH.PURPLE);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8bngU.DependencyLinePreview), {
            ...previewProps,
            color: color
        });
    };
    const renderChartDragLayer = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4y1Ki.RoadmapChartDragLayer), {
            type: (0, $2nzpw.DEPENDENCY_DRAG_ITEM_ID),
            renderPreview: renderPreview,
            DndLongTaskMetric: $43b0a7a66a00f039$var$DndLongTaskMetricComponent
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($43b0a7a66a00f039$var$DragLayerContainer, {
        top: headerHeight
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3HSXN.RoadmapChartOverlay), {
        renderChartDragLayer: renderChartDragLayer,
        renderOverlayButton: $43b0a7a66a00f039$var$renderOverlayButton
    }));
};
const $43b0a7a66a00f039$var$dragLayerContainerBaseStyles = null;
const $43b0a7a66a00f039$var$DragLayerContainer = ({ top: top, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        // eslint-disable-next-line jira/react/no-style-attribute
        style: {
            top: `${top}px`
        },
        className: (0, $7JEyt.default)([
            "_kqswstnw _1xi2idpf _94n5idpf _1ltvidpf _1pby1o8a"
        ])
    }, children);

});
parcelRegister("4y1Ki", function(module, exports) {

$parcel$export(module.exports, "RoadmapChartDragLayer", () => $2ad5edd666f7787d$export$f32354274fa76e25);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $5iWql = parcelRequire("5iWql");
parcelRequire("3f2za");
var $jFl9L = parcelRequire("jFl9L");

var $eo9PV = parcelRequire("eo9PV");

var $94kLM = parcelRequire("94kLM");
const $2ad5edd666f7787d$var$getDefaultPreviewProps = (0, $5iWql.default)(()=>({
        item: undefined,
        clientOffset: {
            x: 0,
            y: 0
        },
        scrollOffset: {
            scrollLeft: 0,
            scrollTop: 0
        }
    }));
const $2ad5edd666f7787d$export$f32354274fa76e25 = ({ type: type, renderPreview: renderPreview, DndLongTaskMetric: DndLongTaskMetric = ()=>null })=>{
    const defaultPreviewProps = (0, $eUqFw.useMemo)(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    ()=>$2ad5edd666f7787d$var$getDefaultPreviewProps(), []);
    const [isDragging, setIsDragging] = (0, $eUqFw.useState)(false);
    const [previewProps, setPreviewProps] = (0, $eUqFw.useState)(defaultPreviewProps);
    (0, $eUqFw.useEffect)(()=>(0, $jFl9L.combine)((0, $eo9PV.monitorForElements)({
            onDrag: ({ source: source, location: location })=>{
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                const item = source.data;
                const { current: { input: current }, initial: { input: initial } } = location;
                if (item.type === type) {
                    const { viewportBoundingRect: viewportBoundingRect, initialScrollBoundingRect: initialScrollBoundingRect, requestViewportScrollBounding: requestViewportScrollBounding, setViewportScroll: setViewportScroll } = item;
                    const initialOffset = {
                        x: initial.pageX,
                        y: initial.pageY
                    };
                    const clientOffset = {
                        x: current.pageX,
                        y: current.pageY
                    };
                    if (initialOffset && clientOffset) {
                        const { scrollLeft: scrollLeft, scrollTop: scrollTop } = (0, $94kLM.adjustScrollPosition)(initialOffset, clientOffset, setViewportScroll, initialScrollBoundingRect, requestViewportScrollBounding, viewportBoundingRect);
                        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                        const previewItem = source.data;
                        setPreviewProps({
                            item: previewItem,
                            clientOffset: clientOffset,
                            scrollOffset: {
                                scrollLeft: scrollLeft,
                                scrollTop: scrollTop
                            }
                        });
                    }
                    setIsDragging(true);
                }
            },
            onDrop ({ source: source }) {
                const item = source.data;
                if (item.type === type) {
                    setPreviewProps(defaultPreviewProps);
                    setIsDragging(false);
                }
            }
        })), [
        type,
        defaultPreviewProps
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ad5edd666f7787d$var$Container, null, renderPreview(previewProps), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(DndLongTaskMetric, {
        isDragging: isDragging
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2ad5edd666f7787d$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswstnw _1ltvidpf _154iidpf _1xi2idpf _94n5idpf _1reo15vq _18m915vq",
            __cmplp.className
        ])
    });
});

});

parcelRegister("3HSXN", function(module, exports) {

$parcel$export(module.exports, "RoadmapChartOverlay", () => $be74f6f5f99a2415$export$74441df56fec708f);

var $eUqFw = parcelRequire("eUqFw");

var $4y1Ki = parcelRequire("4y1Ki");

var $i6oRi = parcelRequire("i6oRi");

var $hRgs1 = parcelRequire("hRgs1");
const $be74f6f5f99a2415$export$74441df56fec708f = ({ renderChartDragLayer: renderChartDragLayer = ()=>null, renderOverlayButton: renderOverlayButton = ()=>null })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, renderOverlayButton(), renderChartDragLayer());

});
parcelRegister("i6oRi", function(module, exports) {

$parcel$export(module.exports, "RoadmapTodayButton", () => $3fa52422bc3b33f8$export$5fc60be363e9a750);

var $eUqFw = parcelRequire("eUqFw");

var $1SqWq = parcelRequire("1SqWq");

var $jMP2a = parcelRequire("jMP2a");

var $3XwA1 = parcelRequire("3XwA1");

var $kAsWD = parcelRequire("kAsWD");
const $3fa52422bc3b33f8$export$5fc60be363e9a750 = ()=>{
    const [{ timelineOriginPosition: timelineOriginPosition }] = (0, $3XwA1.useTimelineState)();
    const onClickCallback = (0, $eUqFw.useCallback)((_, analyticsEvent)=>{
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'todayButton');
        (0, $kAsWD.timelineScroller).scrollTo({
            left: timelineOriginPosition
        });
    }, [
        timelineOriginPosition
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1SqWq.default), {
        onClick: onClickCallback
    });
};

});
parcelRegister("1SqWq", function(module, exports) {

$parcel$export(module.exports, "default", () => $34cf626268fb34aa$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $5JgJ2 = parcelRequire("5JgJ2");

var $hcwQN = parcelRequire("hcwQN");
const $34cf626268fb34aa$var$TodayButton = ({ onClick: onClick, testId: testId })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        testId: testId,
        appearance: "subtle",
        onClick: onClick
    }, formatMessage((0, $hcwQN.default).today));
};
var $34cf626268fb34aa$export$2e2bcd8739ae039 = $34cf626268fb34aa$var$TodayButton;

});
parcelRegister("hcwQN", function(module, exports) {

$parcel$export(module.exports, "default", () => $0a676279f6b60d04$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
$0a676279f6b60d04$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    today: {
        "id": "aais-timeline-toolbar.today-button.today",
        "defaultMessage": "Today"
    }
});

});


parcelRegister("kAsWD", function(module, exports) {

$parcel$export(module.exports, "timelineScroller", () => $b676217d7d50af48$export$e3f9523c9658dc67);
$parcel$export(module.exports, "useTimelineScroller", () => $b676217d7d50af48$export$8b6469154a100351);

var $gf0vG = parcelRequire("gf0vG");
/* Components from all over the node tree have functionality that involves scrolling the timeline.
 * React has not been able to simply fulfil our requirements, so back to vanilla JS we go.
 */ const $b676217d7d50af48$var$scrollTo = ({ left: left, top: top })=>{
    const timelineElem = document.getElementById((0, $gf0vG.TIMELINE_ID));
    if (timelineElem !== null) {
        if (left !== undefined) timelineElem.scrollLeft = left;
        if (top !== undefined) timelineElem.scrollTop = top;
    }
};
const $b676217d7d50af48$var$getScrollLeft = ()=>{
    const timelineElem = document.getElementById((0, $gf0vG.TIMELINE_ID));
    if (timelineElem !== null) return timelineElem.scrollLeft;
    return 0;
};
const $b676217d7d50af48$var$getVisibleWidth = ()=>{
    const timelineElem = document.getElementById((0, $gf0vG.TIMELINE_ID));
    if (timelineElem !== null) return timelineElem.clientWidth;
    return 0;
};
const $b676217d7d50af48$export$e3f9523c9658dc67 = {
    scrollTo: $b676217d7d50af48$var$scrollTo,
    getScrollLeft: $b676217d7d50af48$var$getScrollLeft,
    getVisibleWidth: $b676217d7d50af48$var$getVisibleWidth
};
const $b676217d7d50af48$export$8b6469154a100351 = ()=>$b676217d7d50af48$export$e3f9523c9658dc67;

});


parcelRegister("hRgs1", function(module, exports) {

$parcel$export(module.exports, "RoadmapTimelineMode", () => $38622c545c370c98$export$d1eb62afe3c5898c);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $gGtKh = parcelRequire("gGtKh");

var $gf0vG = parcelRequire("gf0vG");
var $3XwA1 = parcelRequire("3XwA1");

var $duQ8C = parcelRequire("duQ8C");

var $i0235 = parcelRequire("i0235");

var $5Ieb0 = parcelRequire("5Ieb0");

const $38622c545c370c98$var$LazyTimelineModeSwitcher = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("6Unth")).then(({ TimelineModeSwitcher: TimelineModeSwitcher })=>TimelineModeSwitcher), {
    moduleId: "./src/packages/aais/timeline-toolbar/src/index.tsx"
});
const $38622c545c370c98$var$MODE_DESCRIPTORS = [
    {
        type: (0, $gf0vG.WEEKS),
        title: (0, $i0235.default).weeks
    },
    {
        type: (0, $gf0vG.MONTHS),
        title: (0, $i0235.default).months
    },
    {
        type: (0, $gf0vG.QUARTERS),
        title: (0, $i0235.default).quarters
    }
];
const $38622c545c370c98$var$timelineModeContainerStyles = null;
const $38622c545c370c98$export$d1eb62afe3c5898c = ({ onClick: onClick, withContainerStyles: withContainerStyles = false })=>{
    const [{ timelineMode: timelineMode }] = (0, $3XwA1.useTimelineState)();
    const changeMode = (0, $eUqFw.useCallback)((mode, event)=>{
        (0, $duQ8C.default)('timeline-mode', event.timeStamp); // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        onClick(mode);
    }, [
        onClick
    ]);
    const element = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "timeline-mode-switcher",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5Ieb0.default), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($38622c545c370c98$var$LazyTimelineModeSwitcher, {
        modes: $38622c545c370c98$var$MODE_DESCRIPTORS,
        onModeChange: changeMode,
        currentMode: timelineMode
    }));
    return withContainerStyles ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: (0, $7JEyt.default)([
            "_1e0c116y _bfhk1bhr _16qsrs09 _2rko1l7b _1ul91lit _1yt41b66"
        ])
    }, element) : element;
};

});
parcelRegister("i0235", function(module, exports) {

$parcel$export(module.exports, "default", () => $545c82ab0a365033$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $545c82ab0a365033$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    weeks: {
        "id": "roadmap.timeline-table-kit.chart-overlay.timeline-mode.weeks",
        "defaultMessage": "Weeks"
    },
    months: {
        "id": "roadmap.timeline-table-kit.chart-overlay.timeline-mode.months",
        "defaultMessage": "Months"
    },
    quarters: {
        "id": "roadmap.timeline-table-kit.chart-overlay.timeline-mode.quarters",
        "defaultMessage": "Quarters"
    }
});

});

parcelRegister("5Ieb0", function(module, exports) {

$parcel$export(module.exports, "default", () => $b85245f2dc01f9e0$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $9VPEO = parcelRequire("9VPEO");
const $b85245f2dc01f9e0$var$TimelineModeSwitcherSkeleton = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b85245f2dc01f9e0$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9VPEO.Skeleton), {
        width: "74px",
        height: "32px"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9VPEO.Skeleton), {
        width: "74px",
        height: "32px"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9VPEO.Skeleton), {
        width: "74px",
        height: "32px"
    }));
var $b85245f2dc01f9e0$export$2e2bcd8739ae039 = $b85245f2dc01f9e0$var$TimelineModeSwitcherSkeleton;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b85245f2dc01f9e0$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _zulp1b66",
            __cmplp.className
        ])
    });
});

});
parcelRegister("9VPEO", function(module, exports) {

$parcel$export(module.exports, "getKeyframes", () => $fdf3dd89d5b95a51$export$b2b5e866b2fbf2ec);
$parcel$export(module.exports, "Skeleton", () => $fdf3dd89d5b95a51$export$8f31e4c4a37b8e9c);
$parcel$export(module.exports, "Spacer", () => $fdf3dd89d5b95a51$export$d7a54cba636a8cd6);
$parcel$export(module.exports, "SkeletonCompiled", () => $fdf3dd89d5b95a51$export$dc84d515085190e);
$parcel$export(module.exports, "SpacerCompiled", () => $fdf3dd89d5b95a51$export$e477bb7d17087f28);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ // eslint-disable-next-line jira/restricted/styled-components-migration, @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $kwce8 = parcelRequire("kwce8");

var $PdmhA = parcelRequire("PdmhA");
const $fdf3dd89d5b95a51$export$b2b5e866b2fbf2ec = (offsetX = 0)=>{
    const fromPositionX = -Math.abs(offsetX) - 300;
    const toPositionX = fromPositionX + 2000;
    return (0, $kwce8.keyframes)({
        '0%': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundPosition: `${fromPositionX}px 0`
        },
        '100%': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundPosition: `${toPositionX}px 0`
        }
    });
};
const $fdf3dd89d5b95a51$var$shimmer = $fdf3dd89d5b95a51$export$b2b5e866b2fbf2ec();
const $fdf3dd89d5b95a51$export$8f31e4c4a37b8e9c = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "ieqbub-0"
})(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
(props)=>({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        animationDelay: props.theme.animationDelay || '0s',
        animationDuration: '1s',
        animationFillMode: 'forwards',
        animationIterationCount: 'infinite',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        animationName: props.theme.animationName || $fdf3dd89d5b95a51$var$shimmer,
        animationTimingFunction: 'linear',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        backgroundColor: `var(--ds-skeleton, ${(0, $PdmhA).N30})`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        backgroundImage: `linear-gradient( to right, ${`var(--ds-skeleton, ${(0, $PdmhA).N30})`} 10%, ${`var(--ds-skeleton-subtle, ${(0, $PdmhA).N20})`} 30%, ${`var(--ds-skeleton, ${(0, $PdmhA).N30})`} 50% )`,
        backgroundRepeat: 'no-repeat',
        borderRadius: '2px',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: props.height,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: props.width
    }));
const $fdf3dd89d5b95a51$export$d7a54cba636a8cd6 = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "ieqbub-1"
})((props)=>({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: props.height
    }));
const $fdf3dd89d5b95a51$export$dc84d515085190e = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_8jvb0j": (0, $9t7rW.default)(__cmplp.height),
            "--_1gljcou": (0, $9t7rW.default)(__cmplp.width)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_ju25ru3m _5sag9cwz _1o51q7pw _tip812c5 _j7hq1245 _1pglp3kn _bfhkqrzy _1itk1ipn _12vemgnk _2rkoyh40 _4t3i1474 _1bsb1rkg",
            __cmplp.className
        ])
    });
});
const $fdf3dd89d5b95a51$export$e477bb7d17087f28 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_8jvb0j": (0, $9t7rW.default)(__cmplp.height)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i1474",
            __cmplp.className
        ])
    });
});

});


parcelRegister("6Unth", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('hPzOn'),
            load('7Ww1i')
        ]);
        const value = parcelRequire('1Zf6X');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("hPzOn"),
        load("7Ww1i")
    ]).then(()=>parcelRequire('1Zf6X'));
}

});



parcelRegister("8bngU", function(module, exports) {

$parcel$export(module.exports, "DependencyLinePreview", () => $a4f23381ca3be433$export$893df8e27c9969cb);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $opsFH = parcelRequire("opsFH");

var $bCK4s = parcelRequire("bCK4s");

var $4PLZX = parcelRequire("4PLZX");
const $a4f23381ca3be433$export$893df8e27c9969cb = ({ x0: x0, y0: y0, x: x, y: y, width: width, height: height, color: color })=>{
    const theme = (0, $bCK4s.dependencyThemes)[color];
    const top = y - 5;
    const left = x - 5;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4PLZX.Icon), {
        color: theme.icon,
        top: top,
        left: left
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: width,
        height: height
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a4f23381ca3be433$export$17d680238e50603e, {
        x1: x0,
        y1: y0,
        x2: left,
        y2: top,
        color: theme.line
    })));
};
$a4f23381ca3be433$export$893df8e27c9969cb.defaultProps = {
    // We are mapping Color to design tokens in transformColorToTheme
    color: (0, $opsFH.PURPLE)
};
const $a4f23381ca3be433$export$17d680238e50603e = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "line", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_xexnhp": (0, $9t7rW.default)(__cmplp.color)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1s171cj8 _1snbcs5v _134c892t _lswuglyw",
            __cmplp.className
        ])
    });
});

});
parcelRegister("bCK4s", function(module, exports) {

$parcel$export(module.exports, "dependencyThemes", () => $df4636e36adcd9fd$export$895cd5f608903fe5);

var $lPQPn = parcelRequire("lPQPn");
const $df4636e36adcd9fd$export$895cd5f608903fe5 = (0, $lPQPn.transformColorToTheme)((cs)=>({
        icon: cs.primary,
        line: cs.line,
        border: cs.border,
        handle: {
            shadow: cs.primary,
            background: cs.primary
        }
    }));

});

parcelRegister("4PLZX", function(module, exports) {

$parcel$export(module.exports, "Icon", () => $84776056054dfff2$export$f04a61298a47a40f);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $91OYD = parcelRequire("91OYD");
const $84776056054dfff2$export$f04a61298a47a40f = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($84776056054dfff2$var$Wrapper, {
        top: props.top,
        left: props.left
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $91OYD.DependencyIcon), {
        color: props.color
    }));
const $84776056054dfff2$var$ICON_SIZE = 20;
const $84776056054dfff2$var$wrapperBaseStyles = null;
const $84776056054dfff2$var$Wrapper = ({ top: top, left: left, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        // eslint-disable-next-line jira/react/no-style-attribute
        style: {
            top: `${top}px`,
            left: `${left}px`
        },
        className: (0, $7JEyt.default)([
            "_kqswstnw _1bsbgktf _4t3igktf _t9ec8aj6"
        ])
    }, children);

});
parcelRegister("91OYD", function(module, exports) {

$parcel$export(module.exports, "DependencyIcon", () => $253b6f089fd69400$export$1ebee5633231798d);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $hUwRB = parcelRequire("hUwRB");

var $PdmhA = parcelRequire("PdmhA");

var $5JgJ2 = parcelRequire("5JgJ2");

var $fIT4V = parcelRequire("fIT4V");
const $253b6f089fd69400$export$1ebee5633231798d = (props)=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($253b6f089fd69400$var$Wrapper, {
        color: props.color
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hUwRB))), {
        size: "small",
        primaryColor: `var(--ds-icon-inverse, ${(0, $PdmhA.N0)})`,
        label: formatMessage((0, $fIT4V.default).tooltip)
    }));
};
const $253b6f089fd69400$var$ICON_SIZE = 20; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $253b6f089fd69400$var$Wrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_xexnhp": (0, $9t7rW.default)(__cmplp.color)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_bfhk1cj8 _1e0c1txw _1bsbgktf _4t3igktf _2rko1ssb _4cvr1h6o _1bah1h6o _16qsanr3",
            __cmplp.className
        ])
    });
});

});
parcelRegister("fIT4V", function(module, exports) {

$parcel$export(module.exports, "default", () => $897ba01ca77a4919$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $897ba01ca77a4919$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    tooltip: {
        "id": "business-timeline.common.dependency-icon.tooltip",
        "defaultMessage": "Create a dependency"
    }
});

});




parcelRegister("9dlSD", function(module, exports) {

$parcel$export(module.exports, "ChartOverlayButton", () => $f617f83ed6f16472$export$b17a49730a3f0177);

var $eUqFw = parcelRequire("eUqFw");

var $9pngN = parcelRequire("9pngN");

var $hRgs1 = parcelRequire("hRgs1");

var $hsBO5 = parcelRequire("hsBO5");

var $eTH8y = parcelRequire("eTH8y");
const $f617f83ed6f16472$export$b17a49730a3f0177 = ()=>{
    const interactionMetrics = (0, $hsBO5.useInteractionMetrics)();
    const [, { setTimelineMode: setTimelineMode }] = (0, $eTH8y.useTimelineUI)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9pngN.JiraBottomRightCornerOutlet), {
        orderFromRight: 2,
        id: "business-timeline-overlay"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hRgs1.RoadmapTimelineMode), {
        onClick: (mode)=>{
            interactionMetrics[0, $hsBO5.TIMELINE_MODE_CHANGED].start();
            setTimelineMode(mode);
        },
        withContainerStyles: true
    }));
};

});
parcelRegister("9pngN", function(module, exports) {

$parcel$export(module.exports, "JiraBottomRightCornerOutlet", () => $c006a225e0f72214$export$ee54e6ed235df65e);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $lEfVV = parcelRequire("lEfVV");

var $ciZ8Y = parcelRequire("ciZ8Y");

var $71g00 = parcelRequire("71g00");
const $c006a225e0f72214$var$OutletWithPortal = ({ orderFromRight: orderFromRight, children: children, id: id })=>{
    const portalWrapper = (0, $eUqFw.useRef)(document.createElement('div'));
    const container = (0, $71g00.useBottomRightCornerContainer)();
    if (!container) throw new Error('GlobalBottomRightContainer could not be found. Please ensure that this container was rendered on the page.');
    const { insertBottomRightCornerPortal: insertBottomRightCornerPortal, removeBottomRightCornerPortal: removeBottomRightCornerPortal } = (0, $71g00.useBottomRightCornerActions)();
    (0, $eUqFw.useEffect)(()=>{
        if (container) {
            const indexToRender = insertBottomRightCornerPortal({
                orderFromRight: orderFromRight,
                id: id
            });
            // @ts-expect-error - TS2538 - Type 'Promise<void>' cannot be used as an index type. | TS2538 - Type 'void' cannot be used as an index type.
            container.insertBefore(portalWrapper.current, container.children[indexToRender]);
        }
        // required as eslint complains about the ref in cleanup function
        const portalCurrent = portalWrapper.current;
        return ()=>{
            container?.removeChild(portalCurrent);
            removeBottomRightCornerPortal(id);
        };
    }, [
        container,
        id,
        orderFromRight,
        insertBottomRightCornerPortal,
        removeBottomRightCornerPortal
    ]);
    return /*#__PURE__*/ (0, $lEfVV.createPortal)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c006a225e0f72214$var$StyledOutlet, null, children), portalWrapper.current);
};
const $c006a225e0f72214$export$ee54e6ed235df65e = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ciZ8Y.ErrorBoundary), {
        id: "bottom-right-corner-outlet",
        packageName: "jira-bottom-right-corner-controller",
        extraEventData: {
            portalId: props.id
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c006a225e0f72214$var$OutletWithPortal, props));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c006a225e0f72214$var$StyledOutlet = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1vgl1wug _1ko9pxbi",
            __cmplp.className
        ])
    });
});

});


parcelRegister("ldv0L", function(module, exports) {

$parcel$export(module.exports, "getPreviewProps", () => $919eea50225353a6$export$746e70e91ead5d94);
const $919eea50225353a6$export$746e70e91ead5d94 = ({ clientOffset: clientOffset, scrollOffset: scrollOffset, item: item })=>{
    if (!item) return undefined;
    const { id: id, barRect: barRect, leftPosition: leftPosition, viewportBoundingRect: viewportBoundingRect, requestViewportScrollBounding: requestViewportScrollBounding } = item;
    const scrollBounding = requestViewportScrollBounding();
    return {
        id: id,
        x0: leftPosition - scrollBounding.scrollLeft,
        y0: barRect.top + barRect.height / 2 - viewportBoundingRect.top + scrollOffset.scrollTop,
        x: clientOffset.x - viewportBoundingRect.left,
        y: clientOffset.y - viewportBoundingRect.top,
        width: viewportBoundingRect.width,
        height: viewportBoundingRect.height
    };
};

});


parcelRegister("lpABi", function(module, exports) {

$parcel$export(module.exports, "ChartTimelineOverlay", () => $d9d5ac7e2dcbbe42$export$85741b7831292a19);

var $eUqFw = parcelRequire("eUqFw");

var $7byHA = parcelRequire("7byHA");

var $k8Qyf = parcelRequire("k8Qyf");

var $fD1Hq = parcelRequire("fD1Hq");

var $6vrw7 = parcelRequire("6vrw7");

var $3DJhp = parcelRequire("3DJhp");
var $aYYDR = parcelRequire("aYYDR");

var $1zeqz = parcelRequire("1zeqz");

var $203kY = parcelRequire("203kY");

var $bypfu = parcelRequire("bypfu");

var $cjigh = parcelRequire("cjigh");

var $if9qQ = parcelRequire("if9qQ");

var $k7sVX = parcelRequire("k7sVX");
const $d9d5ac7e2dcbbe42$export$85741b7831292a19 = ({ issuesMap: issuesMap, dependencies: dependencies })=>{
    const isLinkingEnabled = (0, $fD1Hq.useIsLinkingEnabled)();
    const { hasIssueLinking: hasIssueLinking } = (0, $203kY.useTimelineFeatures)();
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagService)();
    const { remove: remove, error: removeDependencyError } = (0, $bypfu.useRemoveDependency)();
    const [{ tooltipParams: tooltipParams }, { onCloseTooltip: onCloseTooltip, setTooltipParams: setTooltipParams }] = (0, $1zeqz.useDependencyTooltip)();
    const { issueId: issueId, position: tooltipPosition, dependencies: tooltipDependencies = [], dependees: tooltipDependees = [] } = tooltipParams || {};
    const onUnlink = (0, $eUqFw.useCallback)(({ dependency: dependency, dependee: dependee })=>{
        const inwardLinkId = (issuesMap.get(dependee)?.issueLinks || []).find((link)=>link.inward?.issueId === dependency)?.issueLinkId;
        const outwardLinkId = (issuesMap.get(dependency)?.issueLinks || []).find((link)=>link.outward?.issueId === dependee)?.issueLinkId;
        const linkId = inwardLinkId || outwardLinkId;
        if (!linkId) return;
        const fromIds = inwardLinkId ? tooltipDependencies.filter((id)=>String(id) !== String(dependency)) : tooltipDependencies;
        const toIds = outwardLinkId ? tooltipDependees.filter((id)=>String(id) !== String(dependee)) : tooltipDependees;
        setTooltipParams({
            id: issueId,
            position: tooltipPosition,
            type: (0, $aba7cf5b5acfd3bc$export$4b680a32bbb87a28),
            links: {
                fromIds: fromIds,
                toIds: toIds
            }
        });
        remove({
            linkId: linkId,
            inwardIssueId: dependee,
            outwardIssueId: dependency
        });
    }, [
        issueId,
        issuesMap,
        remove,
        setTooltipParams,
        tooltipDependees,
        tooltipDependencies,
        tooltipPosition
    ]);
    const renderDependencyFlyout = (0, $eUqFw.useCallback)(({ id: id, position: position })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cjigh.DependencyFlyout), {
            id: id,
            position: position,
            issueId: issueId,
            issuesMap: issuesMap,
            dependees: tooltipDependees,
            dependencies: tooltipDependencies,
            canUnlink: hasIssueLinking && isLinkingEnabled,
            onUnlink: onUnlink,
            onCloseTooltip: onCloseTooltip
        }), [
        issueId,
        issuesMap,
        tooltipDependees,
        tooltipDependencies,
        hasIssueLinking,
        isLinkingEnabled,
        onUnlink,
        onCloseTooltip
    ]);
    const onDependencyClick = (0, $eUqFw.useCallback)(({ fromId: fromId, toId: toId }, position)=>{
        setTooltipParams({
            id: (0, $6vrw7.toIssueId)(fromId),
            type: (0, $aba7cf5b5acfd3bc$export$4b680a32bbb87a28),
            links: {
                fromIds: [],
                toIds: [
                    (0, $6vrw7.toIssueId)(toId)
                ]
            },
            position: position
        });
    }, [
        setTooltipParams
    ]);
    const renderDependencyLines = (0, $eUqFw.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aYYDR.RoadmapDependencyLines), {
            dependencies: (0, $k7sVX.transformDependencies)(dependencies),
            // @ts-expect-error - TS2345 - Argument of type 'string | undefined' is not assignable to parameter of type 'string'.
            selectedDependency: (0, $k7sVX.getSelectedDependency)(issueId, tooltipDependees),
            onDependencyClick: onDependencyClick
        }), [
        dependencies,
        issueId,
        tooltipDependees,
        onDependencyClick
    ]);
    const id = tooltipParams ? String(issueId) : undefined;
    (0, $eUqFw.useEffect)(()=>{
        if (removeDependencyError) showFlag({
            type: 'error',
            title: (0, $if9qQ.default).removeDependencyErrorTitle,
            description: removeDependencyError instanceof (0, $7byHA.ValidationError) ? [
                (0, $if9qQ.default).removeDependencyDynamicErrorMessage,
                {
                    error: removeDependencyError.message
                }
            ] : (0, $if9qQ.default).removeDependencyErrorMessage
        });
    }, [
        removeDependencyError,
        showFlag
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3DJhp.RoadmapChartTimelineOverlay), {
        id: id,
        type: (0, $aba7cf5b5acfd3bc$export$4b680a32bbb87a28),
        position: tooltipPosition,
        isDependenciesVisible: isLinkingEnabled,
        renderDependencyFlyout: renderDependencyFlyout,
        renderDependencyLines: renderDependencyLines
    });
};

});
parcelRegister("3DJhp", function(module, exports) {

$parcel$export(module.exports, "RoadmapChartTimelineOverlay", () => $a02b73eb1ab6ec86$export$8858e3c7842aaf2);

var $eUqFw = parcelRequire("eUqFw");

var $4P2VV = parcelRequire("4P2VV");
const $a02b73eb1ab6ec86$export$8858e3c7842aaf2 = ({ id: id, position: position, type: type, isDependenciesVisible: isDependenciesVisible, renderDependencyFlyout: renderDependencyFlyout, renderDependencyLines: renderDependencyLines, renderHighlightLines: renderHighlightLines, renderContextMenu: renderContextMenu })=>{
    const renderFlyout = ()=>{
        if (id !== undefined && type !== undefined && position !== undefined) switch(type){
            case 0, $aba7cf5b5acfd3bc$export$4b680a32bbb87a28:
                return renderDependencyFlyout({
                    id: id,
                    position: position
                });
            case 0, $aba7cf5b5acfd3bc$export$a9487b0be9740846:
                return renderContextMenu({
                    id: id,
                    position: position
                });
            default:
                return null;
        }
        return null;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, renderFlyout(), isDependenciesVisible && renderDependencyLines(), renderHighlightLines());
};
$a02b73eb1ab6ec86$export$8858e3c7842aaf2.defaultProps = {
    renderDependencyFlyout: (0, $4P2VV.DEFAULT_RENDERER),
    renderDependencyLines: (0, $4P2VV.DEFAULT_RENDERER),
    renderHighlightLines: (0, $4P2VV.DEFAULT_RENDERER),
    renderContextMenu: (0, $4P2VV.DEFAULT_RENDERER)
};

});

parcelRegister("aYYDR", function(module, exports) {

$parcel$export(module.exports, "RoadmapDependencyLines", () => $38179f1e8688769e$export$ef4d1c7f7fde068f);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $bs7an = parcelRequire("bs7an");

var $3XwA1 = parcelRequire("3XwA1");

var $3bhRL = parcelRequire("3bhRL");
const $38179f1e8688769e$var$containerStyles = null;
const $38179f1e8688769e$export$ef4d1c7f7fde068f = ({ dependencies: dependencies, selectedDependency: selectedDependency, onDependencyClick: onDependencyClick })=>{
    const [{ timelineDuration: timelineDuration, timelineWidth: timelineWidth }] = (0, $3XwA1.useTimelineState)();
    // No need to recalculate positions when the selected dependency changes
    const dependenciesWithPositionsAndIsOverlap = (0, $eUqFw.useMemo)(()=>(0, $3bhRL.getDependenciesWithPositions)(dependencies, timelineDuration, timelineWidth), [
        dependencies,
        timelineDuration,
        timelineWidth
    ]);
    const onHandleDependencyClick = ({ pageX: pageX, pageY: pageY }, { toId: toId, fromId: fromId })=>{
        onDependencyClick && onDependencyClick({
            toId: toId,
            fromId: fromId
        }, {
            x: pageX,
            y: pageY
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: (0, $7JEyt.default)([
            "_1pbycs5v"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bs7an.default), {
        dependencies: dependenciesWithPositionsAndIsOverlap,
        selectedDependency: selectedDependency,
        onDependencyClick: onHandleDependencyClick
    }));
};
$38179f1e8688769e$export$ef4d1c7f7fde068f.defaultProps = {
    selectedDependency: undefined
};

});
parcelRegister("bs7an", function(module, exports) {

$parcel$export(module.exports, "default", () => $98318066b465b791$export$2e2bcd8739ae039);
/* eslint-disable jira/restricted/styled-components-migration */ 
var $eUqFw = parcelRequire("eUqFw");

var $kwce8 = parcelRequire("kwce8");

var $jG2Eu = parcelRequire("jG2Eu");


var $2CrYe = parcelRequire("2CrYe");
const $98318066b465b791$var$SvgOverlay = ({ dependencies: dependencies, selectedDependency: selectedDependency, onDependencyClick: onDependencyClick })=>{
    const selectedDependencyLine = selectedDependency && dependencies.find((dependency)=>dependency.from.id === selectedDependency.fromId && dependency.to.id === selectedDependency.toId && dependency.from.indexOnScope === selectedDependency.fromIndex && dependency.to.indexOnScope === selectedDependency.toIndex);
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($98318066b465b791$var$SvgContainer, {
        className: (0, $dfce2d8dd72914ca$export$1e54f8b472a07d8d)
    }, dependencies.map((dependency)=>{
        if (dependency !== selectedDependencyLine) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2CrYe.default), {
            key: `${dependency.from.id}-${dependency.to.id}-${dependency.from.y}-${dependency.to.y}`,
            ...dependency,
            onClick: onDependencyClick,
            isSelected: false
        });
        return null;
    }), selectedDependencyLine && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2CrYe.default), {
        ...selectedDependencyLine,
        onClick: onDependencyClick,
        isSelected: true
    })));
};
$98318066b465b791$var$SvgOverlay.defaultProps = {
    selectedDependency: undefined,
    onDependencyClick: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    dependencies: []
};
var $98318066b465b791$export$2e2bcd8739ae039 = $98318066b465b791$var$SvgOverlay;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $98318066b465b791$var$SvgContainer = /*#__PURE__*/ (0, $kwce8.default).svg.withConfig({
    componentId: "sc-7b34v9-0"
})({
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    transition: 'opacity 0.2s ease-in-out',
    overflow: 'visible',
    pointerEvents: 'none'
});

});
/**
 * Style marshal classes
 */ const $dfce2d8dd72914ca$export$1e54f8b472a07d8d = 'dependencies-overlay';
const $dfce2d8dd72914ca$export$cd944e09ecad5145 = 'dependency-line';

parcelRegister("2CrYe", function(module, exports) {

$parcel$export(module.exports, "default", () => $03c7f5a778bca93d$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $hTLlD = parcelRequire("hTLlD");

var $PdmhA = parcelRequire("PdmhA");

var $8cU5f = parcelRequire("8cU5f");

var $5JgJ2 = parcelRequire("5JgJ2");

var $lPQPn = parcelRequire("lPQPn");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $duQ8C = parcelRequire("duQ8C");


var $aM1JA = parcelRequire("aM1JA");

var $fR5Z4 = parcelRequire("fR5Z4");
/* Even though this component represents a single line, multiple elements are used to achieve all of the requirements.
 * 1. An additional element with a larger surface area is used to capture interactions to improve the UX.
 * 2. Gradients cannot be applied to SVG elements using CSS. For this we use a linearGradient element.
 */ const $03c7f5a778bca93d$var$DependencyLine = ({ from: from, to: to, itemHeight: itemHeight, isOverlapping: isOverlapping, isSelected: isSelected, onClick: onClick })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [isHovered, setIsHovered] = (0, $eUqFw.useState)(false);
    const onPathClick = (0, $eUqFw.useCallback)((event)=>{
        (0, $duQ8C.default)('timeline-dependency-clicked', event.timeStamp);
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'line'
        });
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'dependencyLine', {
            isOverlapping: isOverlapping
        });
        onClick(event, {
            fromId: from.id,
            toId: to.id,
            isOverlapping: isOverlapping,
            fromIndexOnScope: from.indexOnScope,
            toIndexOnScope: to.indexOnScope
        });
    }, [
        createAnalyticsEvent,
        isOverlapping,
        from,
        to,
        onClick
    ]);
    const onPathMouseEnter = (0, $eUqFw.useCallback)(()=>{
        setIsHovered(true);
    }, []);
    const onPathMouseLeave = (0, $eUqFw.useCallback)(()=>{
        setIsHovered(false);
    }, []);
    const path = (0, $fR5Z4.getPath)(from, to, itemHeight);
    const gradientId = `linear-gradient-${from.id}-${to.id}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, (isHovered || isSelected) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("linearGradient", {
        id: gradientId,
        x1: from.x,
        x2: to.x,
        y1: from.y,
        y2: to.y,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0%",
        stopColor: (0, $lPQPn.getValueFromColor)(from.color)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "100%",
        stopColor: (0, $lPQPn.getValueFromColor)(to.color)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: path,
        fill: "transparent",
        strokeWidth: "2",
        stroke: $03c7f5a778bca93d$export$a73db48ef11a2bc3({
            isOverlapping: isOverlapping,
            isSelected: isSelected,
            isHovered: isHovered,
            gradientId: gradientId
        }),
        pointerEvents: "none",
        "data-testid": "aais-dependency-lines-overlay.common.ui.line.dependency-line"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        position: "mouse",
        mousePosition: "top",
        content: formatMessage((0, $aM1JA.default).viewDetail),
        tag: "g"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($03c7f5a778bca93d$var$InteractivePath // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    , {
        className: (0, $dfce2d8dd72914ca$export$cd944e09ecad5145),
        d: path,
        stroke: "transparent",
        strokeWidth: "9",
        fill: "none",
        cursor: "pointer",
        onClick: onPathClick,
        onMouseEnter: onPathMouseEnter,
        onMouseLeave: onPathMouseLeave,
        "data-testid": "aais-dependency-lines-overlay.common.ui.line.interactive-path"
    })));
};
$03c7f5a778bca93d$var$DependencyLine.whyDidYouRender = true; // Custom memo to handle common case where 'from' and 'to' objects change reference but not value
var // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
$03c7f5a778bca93d$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($03c7f5a778bca93d$var$DependencyLine, (0, (/*@__PURE__*/$parcel$interopDefault($hTLlD))));
const $03c7f5a778bca93d$var$InteractivePath = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "path", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_lcxv1yxs",
            __cmplp.className
        ])
    });
});
const $03c7f5a778bca93d$export$a73db48ef11a2bc3 = ({ isOverlapping: isOverlapping, isSelected: isSelected, isHovered: isHovered, gradientId: gradientId })=>{
    const isHighlighted = isSelected || isHovered;
    if (isOverlapping) {
        if (isHighlighted) return `var(--ds-background-danger-bold-hovered, ${(0, $PdmhA).R500})`;
        return `var(--ds-background-danger-bold, ${(0, $PdmhA).R300})`;
    }
    if (isHighlighted) return `url(#${gradientId})`;
    return `var(--ds-border-bold, ${(0, $PdmhA).N50})`;
};

});
parcelRegister("aM1JA", function(module, exports) {

$parcel$export(module.exports, "default", () => $106a95137f755680$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $106a95137f755680$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    viewDetail: {
        "id": "aais-dependency-lines-overlay.common.line.view-detail",
        "defaultMessage": "View dependency detail"
    }
});

});

parcelRegister("fR5Z4", function(module, exports) {

$parcel$export(module.exports, "getPath", () => $73e9f2077e2ffc0d$export$2aa3fd96c49a84a8);

var $5iWql = parcelRequire("5iWql");
const $73e9f2077e2ffc0d$var$calculateMidPoint = (from, to)=>({
        x: (from.x + to.x) / 2,
        y: (from.y + to.y) / 2
    });
const $73e9f2077e2ffc0d$var$getY = (p1, p2, x)=>{
    const m = (p2.y - p1.y) / (p2.x - p1.x);
    return m * (x - p1.x) + p1.y;
};
// Generates half of the complex segment
const $73e9f2077e2ffc0d$var$generateSegment = (start, end, offset)=>{
    const c1 = {
        x: start.x + offset.x,
        y: start.y
    };
    const c2 = {
        x: start.x + offset.x,
        y: start.y + offset.y
    };
    const s1 = {
        x: start.x,
        y: $73e9f2077e2ffc0d$var$getY(c2, end, start.x)
    };
    return `M${start.x} ${start.y} C${c1.x} ${c1.y} ${c2.x} ${c2.y} ${s1.x} ${s1.y} L${s1.x} ${s1.y} ${end.x} ${end.y}`;
};
const $73e9f2077e2ffc0d$var$getSegmentOffsets = (from, to, halfItemHeight)=>{
    const fromOffset = {
        x: halfItemHeight,
        y: from.y <= to.y ? halfItemHeight : -halfItemHeight
    };
    const toOffset = {
        x: -fromOffset.x,
        y: -fromOffset.y
    };
    return [
        fromOffset,
        toOffset
    ];
};
// Generates a path made up of two segments for when the dependency start is after the end
const $73e9f2077e2ffc0d$var$generateComplexPath = (from, to, halfItemHeight)=>{
    const middle = $73e9f2077e2ffc0d$var$calculateMidPoint(from, to);
    const [fromOffset, toOffset] = $73e9f2077e2ffc0d$var$getSegmentOffsets(from, to, halfItemHeight);
    return `${$73e9f2077e2ffc0d$var$generateSegment(from, middle, fromOffset)} ${$73e9f2077e2ffc0d$var$generateSegment(to, middle, toOffset)}`;
};
//  Generates a single path for when the dependency start is before the end (happy case)
const $73e9f2077e2ffc0d$var$generateSinglePath = (from, to, itemHeight)=>{
    const diffX = Math.abs(from.x - to.x);
    const progression = itemHeight + diffX * 0.1;
    return `M${from.x} ${from.y} C${from.x + progression} ${from.y} ${to.x - progression} ${to.y} ${to.x} ${to.y}`;
};
const $73e9f2077e2ffc0d$export$2aa3fd96c49a84a8 = (0, $5iWql.default)((from, to, itemHeight)=>from.x > to.x ? $73e9f2077e2ffc0d$var$generateComplexPath(from, to, itemHeight / 2) : $73e9f2077e2ffc0d$var$generateSinglePath(from, to, itemHeight));

});



parcelRegister("3bhRL", function(module, exports) {

$parcel$export(module.exports, "getDependenciesWithPositions", () => $90fe3047e59ee8d8$export$2503ae09d0c5f74);

var $fHtBB = parcelRequire("fHtBB");

var $cww1R = parcelRequire("cww1R");
var $eENQ7 = parcelRequire("eENQ7");
const $90fe3047e59ee8d8$export$2503ae09d0c5f74 = (dependencies, timelineDuration, timelineWidth)=>dependencies.map(({ itemHeight: itemHeight, from: from, to: to })=>({
            isOverlapping: (0, $eENQ7.isDependencyDatesOverlapping)(undefined, from.dueDate, to.startDate, undefined),
            itemHeight: itemHeight,
            to: {
                id: to.id,
                y: to.y,
                x: (0, $cww1R.getBarLeftPosition)(to.startDate, timelineDuration, timelineWidth),
                color: to.color
            },
            from: {
                id: from.id,
                y: from.y,
                x: (0, $cww1R.getBarLeftPosition)(from.dueDate + (0, $fHtBB.DUE_DATE_OFFSET), timelineDuration, timelineWidth),
                color: from.color
            }
        }));

});
parcelRegister("eENQ7", function(module, exports) {

$parcel$export(module.exports, "isDependencyDatesOverlapping", () => $6257ea1530e2071a$export$9fb40a5a7e47a5dd);
const $6257ea1530e2071a$export$9fb40a5a7e47a5dd = (dependencyStartDate = -1, dependencyDueDate = -1, dependeeStartDate = -1, dependeeDueDate = -1)=>{
    // happy case where dates are defined
    if (dependencyDueDate > -1 && dependeeStartDate > -1) return dependencyDueDate > dependeeStartDate;
    // no dates on either dependency or dependee
    if (dependencyStartDate === -1 && dependencyDueDate === -1 || dependeeStartDate === -1 && dependeeDueDate === -1) return false;
    // only start date on dependency and due date on dependee
    if (dependencyDueDate === -1 && dependeeStartDate === -1) return dependencyStartDate > dependeeDueDate;
    // due date of dependency and due date of dependee
    if (dependencyDueDate !== -1) return dependencyDueDate > dependeeDueDate;
    // start date of dependency and start date of dependee
    if (dependencyStartDate !== -1) return dependencyStartDate > dependeeStartDate;
    // impossible case
    return false;
};

});



parcelRegister("bypfu", function(module, exports) {

$parcel$export(module.exports, "useRemoveDependency", () => $bd3034118575a087$export$4e34ad0a8569f3f5);

var $eUqFw = parcelRequire("eUqFw");

var $iZuDo = parcelRequire("iZuDo");

var $4G5xU = parcelRequire("4G5xU");

var $guiFP = parcelRequire("guiFP");

var $7byHA = parcelRequire("7byHA");

var $2nzpw = parcelRequire("2nzpw");

var $PFCIp = parcelRequire("PFCIp");

var $hyqqr = parcelRequire("hyqqr");

var $bk5Ao = parcelRequire("bk5Ao");

var $kMU0F = parcelRequire("kMU0F");
const $bd3034118575a087$export$5dfc3c3db5e1e7f6 = [
    'issuelinks'
];
const $bd3034118575a087$var$QUERY_NAME = 'removeDependencyTimelineView';
const $bd3034118575a087$var$getRelevantError = (data)=>{
    if (data == null || data.unlinkJwmItems?.success === true) return undefined;
    const firstError = data.unlinkJwmItems?.errors?.[0];
    if (firstError != null) {
        // if the issue is not found, do not consider it as an error for deleting
        if (firstError.extensions?.statusCode === 404) return undefined;
        // if there is an error message, show it to the user
        if (firstError.message != null) return new (0, $7byHA.ValidationError)(firstError.message);
    }
    return undefined;
};
const $bd3034118575a087$export$4e34ad0a8569f3f5 = ()=>{
    const { updateIssueLinksInCache: updateIssueLinksInCache } = (0, $hyqqr.useUpdateIssueLinksInCache)();
    const [{ issuesMap: issuesMap }] = (0, $PFCIp.useIssuesMap)();
    const start = (0, $4G5xU.useExperienceStart)((0, $2nzpw.UNLINK_ISSUES_EXPERIENCE));
    const onSuccess = (0, $4G5xU.useExperienceSuccess)((0, $2nzpw.UNLINK_ISSUES_EXPERIENCE));
    const onFail = (0, $4G5xU.useExperienceFail)((0, $2nzpw.UNLINK_ISSUES_EXPERIENCE));
    const [removeDependency, { data: data, loading: loading, error: error }] = (0, $iZuDo.useMutation)((0, $bk5Ao.REMOVE_DEPENDENCY_TIMELINE_MUTATION), {
        onError: (apolloError)=>{
            (0, $guiFP.default)({
                meta: {
                    id: $bd3034118575a087$var$QUERY_NAME,
                    packageName: 'jiraBusinessTimeline',
                    teamName: 'jira-yurree'
                },
                error: apolloError,
                attributes: {
                    message: 'Failed to remove dependency in timeline view'
                },
                sendToPrivacyUnsafeSplunk: true
            });
            onFail('timeline remove dependency service', apolloError);
        },
        onCompleted: (apolloData)=>{
            const relevantError = $bd3034118575a087$var$getRelevantError(apolloData);
            if (relevantError) onFail('timeline remove dependency service', relevantError);
            else onSuccess();
        }
    });
    const remove = async ({ linkId: linkId, inwardIssueId: inwardIssueId, outwardIssueId: outwardIssueId })=>{
        start();
        const optimisticResponse = {
            unlinkJwmItems: (0, $kMU0F.createOptimisticLinkItems)({
                linkId: linkId,
                issuesMap: issuesMap
            })
        };
        await removeDependency({
            variables: {
                fieldIdsToReturn: $bd3034118575a087$export$5dfc3c3db5e1e7f6,
                input: {
                    linkId: linkId
                }
            },
            optimisticResponse: optimisticResponse,
            update: (proxy, result)=>{
                if (!$bd3034118575a087$var$getRelevantError(result.data)) {
                    // update both issues (dependency and dependee) in Apollo cache with newly created links
                    updateIssueLinksInCache({
                        issueId: inwardIssueId,
                        issueLinks: {
                            edges: (issuesMap.get(inwardIssueId)?.originalIssueLinks ?? []).filter((edge)=>edge?.node?.issueLinkId !== linkId),
                            __typename: 'JiraIssueLinkConnection'
                        }
                    });
                    updateIssueLinksInCache({
                        issueId: outwardIssueId,
                        issueLinks: {
                            edges: (issuesMap.get(outwardIssueId)?.originalIssueLinks ?? []).filter((edge)=>edge?.node?.issueLinkId !== linkId),
                            __typename: 'JiraIssueLinkConnection'
                        }
                    });
                }
            }
        });
    };
    const relevantError = (0, $eUqFw.useMemo)(()=>$bd3034118575a087$var$getRelevantError(data) || error, [
        data,
        error
    ]);
    return {
        loading: loading,
        error: relevantError,
        remove: remove
    };
};

});
parcelRegister("bk5Ao", function(module, exports) {

$parcel$export(module.exports, "REMOVE_DEPENDENCY_TIMELINE_MUTATION", () => $ce807b6702308c27$export$deba7c477fa9c7e9);

var $9ypom = parcelRequire("9ypom");
const $ce807b6702308c27$export$deba7c477fa9c7e9 = (0, $9ypom.default)`
mutation RemoveJWMDependencyTimelineView($input: JWMUnlinkItemsInput!, $fieldIdsToReturn: [String]) {
    unlinkJwmItems(input: $input, fieldIdsToReturn: $fieldIdsToReturn) {
        inwardItem {
            issueId
            issueLinks(first: 10) {
                edges {
                    node {
                        issue {
                            issueId
                        }
                        issueLinkId
                        relationName
                        direction
                    }
                }
            }	
        }
        outwardItem {
            issueId
            issueLinks(first: 10) {
                edges {
                    node {
                        issue {
                            issueId
                        }
                        issueLinkId
                        relationName
                        direction
                    }
                }
            }	
        }
        success
        errors {
            message
            extensions {
                statusCode
                errorType
            }
        }
    }
}
`;

});

parcelRegister("kMU0F", function(module, exports) {

$parcel$export(module.exports, "createOptimisticLinkItems", () => $6c7eda26d117a70c$export$f5f603284bb2b3c7);
/* eslint-disable camelcase */ const $6c7eda26d117a70c$export$f5f603284bb2b3c7 = ({ linkId: linkId, issuesMap: issuesMap })=>{
    // linked issues
    const [inwardIssue, outwardIssue] = Array.from(issuesMap.values()).filter((issue)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        !!issue.originalIssueLinks.find((edge)=>edge.node?.issueLinkId === linkId));
    return {
        inwardItem: {
            issueId: Number(inwardIssue?.issueId),
            issueLinks: {
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                edges: inwardIssue?.originalIssueLinks.filter((edge)=>edge.node?.issueLinkId !== linkId),
                __typename: 'JiraIssueLinkConnection'
            },
            __typename: 'JiraWorkManagementViewItem'
        },
        outwardItem: {
            issueId: Number(outwardIssue?.issueId),
            issueLinks: {
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                edges: outwardIssue?.originalIssueLinks.filter((edge)=>edge.node?.issueLinkId !== linkId),
                __typename: 'JiraIssueLinkConnection'
            },
            __typename: 'JiraWorkManagementViewItem'
        },
        success: true,
        errors: null,
        __typename: 'JWMUnlinkItemsPayload'
    };
};

});


parcelRegister("cjigh", function(module, exports) {

$parcel$export(module.exports, "DependencyFlyout", () => $69a171aa14ace08a$export$7358cd3eeab0484b);

var $eUqFw = parcelRequire("eUqFw");

var $4G5xU = parcelRequire("4G5xU");

var $eI5EY = parcelRequire("eI5EY");

var $6DO4p = parcelRequire("6DO4p");

var $2nzpw = parcelRequire("2nzpw");

var $8kMQk = parcelRequire("8kMQk");
const $69a171aa14ace08a$var$DependencyFlyoutComponent = ({ id: id, position: position, issueId: issueId, issuesMap: issuesMap, dependees: dependees, dependencies: dependencies, canUnlink: canUnlink, onUnlink: onUnlink, onCloseTooltip: onCloseTooltip })=>{
    const fromIssue = issueId ? (0, $8kMQk.getIssueFromMap)(issueId, issuesMap) : undefined;
    const toIssue = (0, $8kMQk.getIssueFromMap)(Number(dependees[0]), issuesMap); // there's only one "to" issue which clicked dependency can link to
    // searching for the same dependency in the "from" and "to" issues by ID to determine which one was clicked
    const dependency = (fromIssue?.issueLinks || []).find((fromLink)=>(toIssue?.issueLinks || []).map((toLink)=>toLink.issueLinkId).includes(fromLink.issueLinkId));
    const item = (0, $8kMQk.getOverlayIssueItem)(fromIssue);
    if (!item) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6DO4p.RoadmapDependencyFlyout), {
        id: id,
        item: item,
        position: position,
        // @ts-expect-error - TS2322 - Type '(OverlayItem | undefined)[]' is not assignable to type 'OverlayItem[]'.
        dependencies: (0, $8kMQk.getDepsItem)({
            issuesMap: issuesMap,
            issueIds: dependencies
        }),
        // @ts-expect-error - TS2322 - Type '(OverlayItem | undefined)[]' is not assignable to type 'OverlayItem[]'.
        dependees: (0, $8kMQk.getDepsItem)({
            issuesMap: issuesMap,
            issueIds: dependees
        }),
        implicitDependencyItems: [],
        maybeInwardDependencyDescription: dependency?.type.inward,
        maybeOutwardDependencyDescription: dependency?.type.outward,
        onClose: onCloseTooltip,
        ...canUnlink ? {
            onUnlink: onUnlink
        } : undefined
    }), !(0, $eI5EY.fg)('remove_business_timeline_viewdependency_experience') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4G5xU.ExperienceSuccess), {
        experience: (0, $2nzpw.VIEW_DEPENDENCY_EXPERIENCE)
    }));
};
const $69a171aa14ace08a$export$7358cd3eeab0484b = (props)=>{
    if ((0, $eI5EY.fg)('remove_business_timeline_viewdependency_experience')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4G5xU.ExperienceErrorBoundary), {
        experience: (0, $2nzpw.VIEW_DEPENDENCY_EXPERIENCE),
        shouldStartExperience: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($69a171aa14ace08a$var$DependencyFlyoutComponent, props));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($69a171aa14ace08a$var$DependencyFlyoutComponent, props);
};

});
parcelRegister("6DO4p", function(module, exports) {

$parcel$export(module.exports, "RoadmapDependencyFlyout", () => $0c4a1682a843f228$export$d59848488912363);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $8uD7Y = parcelRequire("8uD7Y");
var $4ksts = parcelRequire("4ksts");


var $fVBY3 = parcelRequire("fVBY3");

var $jVELx = parcelRequire("jVELx");

var $fM3pJ = parcelRequire("fM3pJ");

var $5CTGR = parcelRequire("5CTGR");
var $eENQ7 = parcelRequire("eENQ7");

var $cyVUy = parcelRequire("cyVUy");

var $jIH5Q = parcelRequire("jIH5Q");

var $l4wwE = parcelRequire("l4wwE");
const $0c4a1682a843f228$export$d59848488912363 = ({ position: position, ...contentProps })=>{
    const { formatMessage: formatMessage } = (0, $4ksts.useIntlV2)();
    const { id: id, item: item, dependencies: dependencies, dependees: dependees, implicitDependencyItems: implicitDependencyItems, onUnlink: onUnlink, onClose: onClose, maybeInwardDependencyDescription: maybeInwardDependencyDescription, maybeOutwardDependencyDescription: maybeOutwardDependencyDescription } = contentProps;
    const hasDependencies = dependencies.length > 0;
    const hasDependees = dependees.length > 0;
    const hasImplicitDependencies = implicitDependencyItems ? implicitDependencyItems.length > 0 : false;
    (0, $eUqFw.useEffect)(()=>{
        if (!hasDependencies && !hasDependees && !hasImplicitDependencies) onClose();
    }, [
        hasDependencies,
        hasDependees,
        hasImplicitDependencies,
        onClose
    ]);
    const defaultInwardDependencyDescription = `${formatMessage((0, $l4wwE.default).blockedBy)}`;
    const defaultOutwardDependencyDescription = `${formatMessage((0, $l4wwE.default).blocks)}`;
    const inwardDependencyDescription = maybeInwardDependencyDescription ?? defaultInwardDependencyDescription;
    const outwardDependencyDescription = maybeOutwardDependencyDescription ?? defaultOutwardDependencyDescription;
    const renderDepsBlock = (deps, appearance, label)=>{
        if (!deps.length) return null;
        const isOverlapping = deps.some(({ startDate: startDate, dueDate: dueDate })=>appearance === (0, $fbe90688b36d692e$export$920d6feba87a57ed) ? (0, $eENQ7.isDependencyDatesOverlapping)(startDate, dueDate, item.startDate, item.dueDate) : (0, $eENQ7.isDependencyDatesOverlapping)(item.startDate, item.dueDate, startDate, dueDate));
        const isFiltered = deps.some(({ isHidden: isHidden })=>isHidden);
        const hasDepItems = appearance === (0, $fbe90688b36d692e$export$920d6feba87a57ed) ? hasDependees : hasDependencies;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fVBY3.default), {
            appearance: appearance,
            ...item
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jVELx.default), {
            label: label,
            isOverlapping: isOverlapping,
            isFiltered: isFiltered,
            ...onUnlink && deps.length === 1 ? {
                onUnlink: (0, $5CTGR.createUnlinkHandlerByAppearance)(item.id, deps[0].id, appearance, onUnlink, hasDepItems ? undefined : onClose)
            } : undefined
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, deps.map((dep)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fVBY3.default), {
                key: dep.id,
                appearance: appearance === (0, $fbe90688b36d692e$export$920d6feba87a57ed) ? (0, $fbe90688b36d692e$export$2c998d8d93f14e97) : (0, $fbe90688b36d692e$export$920d6feba87a57ed),
                ...dep,
                isOverlapping: appearance === (0, $fbe90688b36d692e$export$920d6feba87a57ed) ? (0, $eENQ7.isDependencyDatesOverlapping)(dep.startDate, dep.dueDate, item.startDate, item.dueDate) : (0, $eENQ7.isDependencyDatesOverlapping)(item.startDate, item.dueDate, dep.startDate, dep.dueDate),
                ...onUnlink && deps.length > 1 ? {
                    onUnlink: (0, $5CTGR.createUnlinkHandlerByAppearance)(item.id, dep.id, appearance, onUnlink, undefined)
                } : undefined
            }))));
    };
    const { itemKey: itemKey, title: title } = item;
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        "data-testid": "roadmap.timeline-table-kit.ui.chart-timeline-overlay.dependency-flyout.container",
        className: (0, $7JEyt.default)([
            "_1yt4v47k _bfhkexu1 _16qsbnrv _2rko1l7b _c71l1mjv _1reo1wug _18m91wug _1pby3ced",
            hasImplicitDependencies && "_1bsbeo28",
            !hasImplicitDependencies && "_1bsb1178"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: (0, $7JEyt.default)([
            "_1bsb1178"
        ])
    }, hasImplicitDependencies && (hasDependencies || hasDependees) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $0c4a1682a843f228$var$styledDependencyStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
        ...(0, $l4wwE.default).dependencyOf,
        values: {
            itemKey: itemKey,
            title: title,
            // @ts-expect-error  TS2322: Type '(chunks: string) => JSX.Element' is not assignable to type 'ReactNode'.
            b: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("b", null, chunks)
        }
    })), renderDepsBlock(dependencies, (0, $fbe90688b36d692e$export$920d6feba87a57ed), inwardDependencyDescription), hasDependencies && hasDependees && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jIH5Q.default), null), renderDepsBlock(dependees, (0, $fbe90688b36d692e$export$2c998d8d93f14e97), outwardDependencyDescription), hasImplicitDependencies && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cyVUy.default), {
        parentItem: item,
        implicitDependencyItems: implicitDependencyItems,
        onClose: onClose,
        ...onUnlink ? {
            onUnlink: onUnlink
        } : undefined,
        inwardDependencyDescription: inwardDependencyDescription,
        outwardDependencyDescription: outwardDependencyDescription
    }))); /* NOTE: providing a key here is a hack !!
           * The flyout does not re-render just because its anchor changed position (if it is already open).
           * Instead, we must force it to re-render if we would be showing it for a different item.
           */ 
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fM3pJ.OverlayFlyout), {
        key: id,
        position: position,
        content: content,
        onClose: onClose
    });
};
$0c4a1682a843f228$export$d59848488912363.defaultProps = {
    dependencies: [],
    dependees: [],
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    onClose: ()=>{}
};
const $0c4a1682a843f228$var$containerWideWidthStyles = null;
const $0c4a1682a843f228$var$containerNotWideWidthStyles = null;
const $0c4a1682a843f228$var$containerStyles = null;
const $0c4a1682a843f228$var$styledDependencyStyles = (0, $1ZAYh.xcss)({
    marginBottom: 'space.100'
});

});
parcelRegister("fVBY3", function(module, exports) {

$parcel$export(module.exports, "default", () => $fb49434d2735bd73$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $5YsMl = parcelRequire("5YsMl");

var $PdmhA = parcelRequire("PdmhA");

var $4ksts = parcelRequire("4ksts");

var $fHtBB = parcelRequire("fHtBB");

var $bH8HM = parcelRequire("bH8HM");

var $1RxG7 = parcelRequire("1RxG7");

var $lAEGD = parcelRequire("lAEGD");

var $bZA4O = parcelRequire("bZA4O");
const $fb49434d2735bd73$var$containerStyles = null;
const $fb49434d2735bd73$var$contentStyles = null;
const $fb49434d2735bd73$var$contentLeftStyles = null;
const $fb49434d2735bd73$var$titleContainerStyles = null;
const $fb49434d2735bd73$var$typeIconContainerStyles = null;
const $fb49434d2735bd73$var$unlinkIconWrapperStyles = null;
const $fb49434d2735bd73$var$titleStyles = null;
const $fb49434d2735bd73$var$warningIconWrapperStyles = null;
const $fb49434d2735bd73$var$warningMessageStyles = null;
const $fb49434d2735bd73$var$childContainerStyles = null;
const $fb49434d2735bd73$var$parentTitleStyles = null;
const $fb49434d2735bd73$var$renderWarningMessage = (key, message)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        key: key,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _ca0qu2gc _1wyb1skh _k48pni7l"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1bsb1ejb"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5YsMl))), {
        primaryColor: `var(--ds-icon-warning, ${(0, $PdmhA.Y300)})`,
        size: "small",
        label: message
    })), message);
const $fb49434d2735bd73$var$DependenciesCardContent = ({ appearance: appearance, isOverlapping: isOverlapping = false, startDateType: startDateType, dueDateType: dueDateType, title: title, iconUrl: iconUrl, typeName: typeName, startDate: startDate, dueDate: dueDate, onUnlink: onUnlink, intervalName: intervalName, warningMessages: warningMessages })=>{
    const { formatMessage: formatMessage } = (0, $4ksts.useIntlV2)();
    const getCardDateLabelProps = ()=>{
        let labelProps = {
            caption: '',
            noDateMessage: ''
        };
        const isIncoming = appearance === (0, $fbe90688b36d692e$export$920d6feba87a57ed);
        const dateType = isIncoming ? startDateType : dueDateType;
        switch(dateType){
            case 0, $fHtBB.INTERVAL:
                labelProps = {
                    caption: formatMessage(isIncoming ? (0, $bZA4O.default).sprintStartDateCaption : (0, $bZA4O.default).sprintEndDateCaption),
                    noDateMessage: formatMessage((0, $bZA4O.default).noSprintAssigned)
                };
                break;
            case 0, $fHtBB.ROLLUP:
            case 0, $fHtBB.EXPLICIT:
            default:
                labelProps = {
                    caption: formatMessage(isIncoming ? (0, $bZA4O.default).startDateCaption : (0, $bZA4O.default).dueDateCaption),
                    noDateMessage: formatMessage(isIncoming ? (0, $bZA4O.default).noStartDateSet : (0, $bZA4O.default).noDueDateSet)
                };
                break;
        }
        return {
            dateType: dateType,
            date: isIncoming ? startDate : dueDate,
            intervalName: intervalName,
            ...labelProps
        };
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx2vrvc"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx21bp4 _16jlkb7n _1reo15vq _18m915vq"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: (0, $7JEyt.default)([
            "_1e0c1txw _kqswh2mm _2lx2vrvc _4cvr1h6o _1reo15vq _18m915vq"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2hwxu2gc"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bH8HM.default), {
        src: iconUrl || '',
        alt: formatMessage((0, $bZA4O.default).iconAltText, {
            typeName: typeName
        })
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        title: title,
        className: (0, $7JEyt.default)([
            "_1wybdlk8 _vwz41tcg _syaz1fxt _1reo15vq _18m915vq _o5721q9c _1bto1l2s"
        ])
    }, title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lAEGD.default), getCardDateLabelProps())), onUnlink && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx2vrvc _4cvr1h6o _1bsbpxbi _4t3i1ejb"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1RxG7.default), {
        onClick: onUnlink
    }))), isOverlapping && $fb49434d2735bd73$var$renderWarningMessage((0, $bZA4O.default).datesOverlapWarning.id, formatMessage((0, $bZA4O.default).datesOverlapWarning)), warningMessages.map((message)=>$fb49434d2735bd73$var$renderWarningMessage(message.id, formatMessage(message))));
};
const $fb49434d2735bd73$var$DependencyCard = ({ parent: parent, ...props })=>{
    const dependenciesCardContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($fb49434d2735bd73$var$DependenciesCardContent, props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx21bp4 _kqswh2mm _1yt41pyq _bfhkhp5a _16qsuole _1nktglyw"
        ])
    }, parent !== undefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: (0, $7JEyt.default)([
            "_1e0c1txw _kqswh2mm _2lx2vrvc _4cvr1h6o _1reo15vq _18m915vq"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2hwxu2gc"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bH8HM.default), {
        src: parent.iconUrl
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        title: parent.title,
        className: (0, $7JEyt.default)([
            "_1wyb1crf _vwz41tcg _syaz1wmz _1reo15vq _18m915vq _o5721q9c _1bto1l2s"
        ])
    }, parent.title, " /")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: (0, $7JEyt.default)([
            "_kqswh2mm _19bv1ejb _19pk1b66"
        ])
    }, dependenciesCardContent)) : dependenciesCardContent);
};
$fb49434d2735bd73$var$DependencyCard.displayName = 'DependencyCard';
var $fb49434d2735bd73$export$2e2bcd8739ae039 = $fb49434d2735bd73$var$DependencyCard;

});
parcelRegister("bH8HM", function(module, exports) {

$parcel$export(module.exports, "default", () => $f0f578a9fd44e810$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");
const $f0f578a9fd44e810$var$iconImageStyles = null;
const $f0f578a9fd44e810$var$Icon = ({ src: src, alt: alt = '', size: size = '16px' })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("img", {
        src: src,
        alt: alt,
        style: {
            width: size,
            height: size
        },
        className: (0, $7JEyt.default)([
            "_16jlidpf _1o9zidpf _i0dl1wug _2rko1sit"
        ])
    });
var $f0f578a9fd44e810$export$2e2bcd8739ae039 = $f0f578a9fd44e810$var$Icon;

});

parcelRegister("1RxG7", function(module, exports) {

$parcel$export(module.exports, "default", () => $27592d81729c6d66$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $fcRCL = parcelRequire("fcRCL");

var $8cU5f = parcelRequire("8cU5f");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");

var $1qn3a = parcelRequire("1qn3a");
const $27592d81729c6d66$var$UnlinkButton = ({ onClick: onClick })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const onClickCallback = (0, $eUqFw.useCallback)((event, analyticsEvent)=>{
        event.stopPropagation();
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'dependencyUnlinkButton');
        onClick(analyticsEvent);
    }, [
        onClick
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: formatMessage((0, $1qn3a.default).unlink)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fcRCL))), {
            label: formatMessage((0, $1qn3a.default).unlink),
            size: "small",
            testId: "roadmap.timeline-table-kit.common.ui.dependency.unlink-button.unlink-button"
        }),
        spacing: "compact",
        appearance: "subtle",
        onClick: onClickCallback
    }));
};
var $27592d81729c6d66$export$2e2bcd8739ae039 = $27592d81729c6d66$var$UnlinkButton;

});
parcelRegister("fcRCL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b12192af1a89a6ac$var$_react = $b12192af1a89a6ac$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $b12192af1a89a6ac$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $b12192af1a89a6ac$var$UnlinkIcon = (props)=>/*#__PURE__*/ $b12192af1a89a6ac$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M13.721 14.43a.972.972 0 00-1.37-.004l-2.088 2.059a1.928 1.928 0 01-1.37.568c-.588 0-1.135-.26-1.525-.738-.634-.777-.505-1.933.203-2.643l1.321-1.322.002.001.688-.686a.974.974 0 000-1.377l-.002-.003a.972.972 0 00-1.375 0l-2.068 2.07a3.892 3.892 0 000 5.497l.009.01A3.87 3.87 0 008.892 19a3.87 3.87 0 002.746-1.139l2.083-2.085a.951.951 0 000-1.345zm-3.442-4.86a.972.972 0 001.37.004l2.088-2.058c.366-.367.853-.57 1.37-.57.588 0 1.135.26 1.525.739.634.777.505 1.933-.203 2.643l-1.321 1.322-.002-.001-.688.686a.974.974 0 000 1.377l.002.003c.38.38.995.38 1.375 0l2.068-2.07a3.892 3.892 0 000-5.497l-.009-.01A3.87 3.87 0 0015.108 5a3.87 3.87 0 00-2.746 1.139l-2.083 2.085a.951.951 0 000 1.345zM8.924 4.618l.401.968a1 1 0 11-1.848.765l-.4-.968a1 1 0 111.848-.765M5.383 7.076l.968.401a1.001 1.001 0 01-.766 1.848l-.968-.4a1.001 1.001 0 01.766-1.848m9.932 10.413a1.003 1.003 0 00-.542 1.307l.402.968A1 1 0 1017.023 19l-.401-.967a1 1 0 00-1.307-.542zm2.176-2.174a1 1 0 00.54 1.306l.969.401a1.001 1.001 0 00.766-1.848l-.969-.4a1 1 0 00-1.306.542z" fill="currentColor" fill-rule="evenodd"/></svg>`
    }, props));
$b12192af1a89a6ac$var$UnlinkIcon.displayName = 'UnlinkIcon';
var $b12192af1a89a6ac$var$_default = $b12192af1a89a6ac$var$UnlinkIcon;
module.exports.default = $b12192af1a89a6ac$var$_default;

});

parcelRegister("1qn3a", function(module, exports) {

$parcel$export(module.exports, "default", () => $408b9b33d17c39b0$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $408b9b33d17c39b0$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    unlink: {
        "id": "roadmap.timeline-table-kit.common.dependency.unlink-button.unlink",
        "defaultMessage": "Unlink issue"
    }
});

});


parcelRegister("lAEGD", function(module, exports) {

$parcel$export(module.exports, "default", () => $723f1ab8d783d21c$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $jJwwt = parcelRequire("jJwwt");

var $fHtBB = parcelRequire("fHtBB");

var $2jWeb = parcelRequire("2jWeb");

var $fRzLJ = parcelRequire("fRzLJ");
const $723f1ab8d783d21c$var$DependencyCardDateLabel = ({ dateType: dateType, date: date, intervalName: intervalName, caption: caption, noDateMessage: noDateMessage })=>{
    const label = date !== undefined ? (0, (/*@__PURE__*/$parcel$interopDefault($jJwwt))).utc(date).format((0, $fHtBB.DATE_FORMAT_MOMENT)) : noDateMessage;
    const renderExplicitDate = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($723f1ab8d783d21c$var$Container, {
            "data-testid": "roadmap.timeline-table-kit.common.ui.dependency.card.date-label.explicit-date"
        }, date !== undefined && `${caption} `, label);
    const renderIntervalDate = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, intervalName !== undefined && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($723f1ab8d783d21c$var$Container, {
            "data-testid": "roadmap.timeline-table-kit.common.ui.dependency.card.date-label.interval-date"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fRzLJ.SprintIcon), null), intervalName), renderExplicitDate());
    const renderRollupDate = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($723f1ab8d783d21c$var$Container, {
            "data-testid": "roadmap.timeline-table-kit.common.ui.dependency.card.date-label.rollup-date"
        }, date !== undefined && `${caption} `, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2jWeb.RollupIcon), null), label);
    switch(dateType){
        case 0, $fHtBB.INTERVAL:
            return renderIntervalDate();
        case 0, $fHtBB.ROLLUP:
            return renderRollupDate();
        case 0, $fHtBB.EXPLICIT:
        default:
            return renderExplicitDate();
    }
};
var $723f1ab8d783d21c$export$2e2bcd8739ae039 = $723f1ab8d783d21c$var$DependencyCardDateLabel;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $723f1ab8d783d21c$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19bv1ejb _1wyb1skh _syaz1wmz _1e0c1txw",
            __cmplp.className
        ])
    });
});

});

parcelRegister("bZA4O", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab9befebbd939703$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $ab9befebbd939703$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    iconAltText: {
        "id": "roadmap.timeline-table-kit.common.dependency.card.icon-alt-text",
        "defaultMessage": "{typeName} issue type"
    },
    datesOverlapWarning: {
        "id": "roadmap.timeline-table-kit.common.dependency.card.dates-overlap-warning",
        "defaultMessage": "Dates overlap"
    },
    startDateCaption: {
        "id": "roadmap.timeline-table-kit.common.dependency.card.start-date-caption",
        "defaultMessage": "Start date"
    },
    dueDateCaption: {
        "id": "roadmap.timeline-table-kit.common.dependency.card.due-date-caption",
        "defaultMessage": "Due date"
    },
    sprintStartDateCaption: {
        "id": "roadmap.timeline-table-kit.common.dependency.card.sprint-start-date-caption",
        "defaultMessage": "Sprint starts on"
    },
    sprintEndDateCaption: {
        "id": "roadmap.timeline-table-kit.common.dependency.card.sprint-end-date-caption",
        "defaultMessage": "Sprint ends on"
    },
    noStartDateSet: {
        "id": "roadmap.timeline-table-kit.common.dependency.card.no-start-date-set",
        "defaultMessage": "No start date set"
    },
    noDueDateSet: {
        "id": "roadmap.timeline-table-kit.common.dependency.card.no-due-date-set",
        "defaultMessage": "No due date set"
    },
    noSprintAssigned: {
        "id": "roadmap.timeline-table-kit.common.dependency.card.no-sprint-assigned",
        "defaultMessage": "No sprint assigned"
    }
});

});


parcelRegister("jVELx", function(module, exports) {

$parcel$export(module.exports, "default", () => $fa7bb6be5b045789$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $hUwRB = parcelRequire("hUwRB");

var $PdmhA = parcelRequire("PdmhA");

var $1RxG7 = parcelRequire("1RxG7");
const $fa7bb6be5b045789$var$getBackgroundColor = (isOverlapping)=>isOverlapping ? `var(--ds-background-danger-bold, ${0, $PdmhA.R300})` : `var(--ds-background-neutral-bold, ${0, $PdmhA.N400})`;
const $fa7bb6be5b045789$var$Separator = ({ label: label, isOverlapping: isOverlapping, isFiltered: isFiltered, onUnlink: onUnlink })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        "data-testid": "roadmap.timeline-table-kit.common.ui.dependency.separator",
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx2vrvc _kqswh2mm"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx21bp4 _18u0pxbi _2hwxu2gc _4cvr1h6o"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        style: {
            border: `1px ${isFiltered ? 'dashed' : 'solid'} ${$fa7bb6be5b045789$var$getBackgroundColor(isOverlapping)}`
        },
        className: (0, $7JEyt.default)([
            "_4t3iutpp"
        ])
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        style: {
            backgroundColor: $fa7bb6be5b045789$var$getBackgroundColor(isOverlapping)
        },
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _1bsbv47k _4t3iv47k _16qs14w9 _2rko1ssb"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hUwRB))), {
        size: "small",
        label: label,
        primaryColor: `var(--ds-icon-inverse, ${(0, $PdmhA.N0)})`
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        style: {
            border: `1px ${isFiltered ? 'dashed' : 'solid'} ${$fa7bb6be5b045789$var$getBackgroundColor(isOverlapping)}`
        },
        className: (0, $7JEyt.default)([
            "_4t3iutpp"
        ])
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: (0, $7JEyt.default)([
            "_1e0c1txw _16jlkb7n _4cvr1h6o _1wyb1crf _vwz4utpp _k48pni7l"
        ])
    }, label), onUnlink && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: (0, $7JEyt.default)([
            "_kqswstnw _154iutpp _1xi2idpf"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1RxG7.default), {
        onClick: onUnlink
    })));
var $fa7bb6be5b045789$export$2e2bcd8739ae039 = $fa7bb6be5b045789$var$Separator;
const $fa7bb6be5b045789$var$containerStyles = null;
const $fa7bb6be5b045789$var$separatorContainerStyles = null;
const $fa7bb6be5b045789$var$textContainerStyles = null;
const $fa7bb6be5b045789$var$iconWrapperStyles = null;
const $fa7bb6be5b045789$var$lineStyles = null;
const $fa7bb6be5b045789$var$unlinkButtonWrapperStyles = null;

});

parcelRegister("fM3pJ", function(module, exports) {

$parcel$export(module.exports, "OverlayFlyout", () => $0ead9480826a5a97$export$66ffd5d51c2b84d0);
/* main.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $29yDk = parcelRequire("29yDk");

var $gmZvv = parcelRequire("gmZvv");

var $6TBpb = parcelRequire("6TBpb");

var $ksGD2 = parcelRequire("ksGD2");
/* The overlay flyout will be rendered on a Portal with a fixed position.
 * It needs to close on scroll, otherwise appear to move away from its trigger.
 */ const $0ead9480826a5a97$export$66ffd5d51c2b84d0 = ({ position: position, content: content, testId: testId, onClose: onClose, triggerRef: triggerRef })=>{
    const { listenToViewportScroll: listenToViewportScroll, stopListeningToViewportScroll: stopListeningToViewportScroll } = (0, $6TBpb.useViewport)();
    const onCloseInternal = (0, $eUqFw.useCallback)(()=>{
        stopListeningToViewportScroll(onCloseInternal);
        onClose?.();
    }, [
        onClose,
        stopListeningToViewportScroll
    ]);
    const onCloseDialog = (0, $eUqFw.useCallback)(({ event: event })=>{
        if (// call onClose if the trigger is not defined
        triggerRef.current === null || // call onClose if click outside the trigger
        !(triggerRef.current && event.target instanceof Node && triggerRef.current.contains(event.target))) onCloseInternal();
    }, [
        onCloseInternal,
        triggerRef
    ]);
    (0, $eUqFw.useEffect)(()=>{
        listenToViewportScroll(onCloseInternal);
        return ()=>{
            stopListeningToViewportScroll(onCloseInternal);
        };
    }, [
        listenToViewportScroll,
        onCloseInternal,
        stopListeningToViewportScroll
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gmZvv.default), {
        zIndex: (0, $ksGD2.OVERLAY_FLYOUT_Z_INDEX)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        ...testId ? {
            'data-testid': testId
        } : {},
        className: (0, $7JEyt.default)([
            "_ogwtidpf _6tinidpf _1cezidpf _m3zkidpf _hc7q15vq _njtz15vq _bp7o1ceh"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $29yDk.default), {
        isOpen: true,
        content: content,
        onClose: onCloseDialog
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        style: {
            left: position.x,
            top: position.y
        },
        className: (0, $7JEyt.default)([
            "_kqsw1n9t"
        ])
    }))));
};
const $0ead9480826a5a97$var$defaultProps = {
    triggerRef: {
        current: null
    }
};
$0ead9480826a5a97$export$66ffd5d51c2b84d0.defaultProps = $0ead9480826a5a97$var$defaultProps;
// Child selector is for the nested inline dialog
const $0ead9480826a5a97$var$inlineDialogWrapperStyles = null;
const $0ead9480826a5a97$var$anchorStyles = null;

});
parcelRegister("29yDk", function(module, exports) {

$parcel$export(module.exports, "default", () => $99fb58582e83d080$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $74BVL = parcelRequire("74BVL");

var $lbDTY = parcelRequire("lbDTY");

var $hM7RE = parcelRequire("hM7RE");
var $1ngde = parcelRequire("1ngde");
var $2jDha = parcelRequire("2jDha");

var $5Q9wj = parcelRequire("5Q9wj");

var $etCs9 = parcelRequire("etCs9");
var $eN43R = parcelRequire("eN43R");

var $XHGTv = parcelRequire("XHGTv");

var $8nlzU = parcelRequire("8nlzU");
var $i6BC8 = parcelRequire("i6BC8");
var $6frYP = parcelRequire("6frYP");

var $1GZRB = parcelRequire("1GZRB");
const $99fb58582e83d080$var$packageName = "platform-pkg";
const $99fb58582e83d080$var$packageVersion = "0.0.0-use.local";
const $99fb58582e83d080$var$checkIsChildOfPortal = (node)=>{
    if (!node) return false;
    return node.classList && node.classList.contains('atlaskit-portal-container') || $99fb58582e83d080$var$checkIsChildOfPortal(node.parentElement);
};
// escape close manager for layering
const $99fb58582e83d080$var$EscapeCloseManager = ({ handleClose: handleClose })=>{
    (0, $eN43R.useCloseOnEscapePress)({
        onClose: handleClose
    });
    // only create a dummy component for using ths hook in class component
    return /*#__PURE__*/ (0, $byn9U.jsx)("span", null);
};
const $99fb58582e83d080$export$513033cc22e3bc20 = /*#__PURE__*/ (0, $eUqFw.memo)(function InlineDialog({ isOpen: isOpen = false, onContentBlur: onContentBlur = (0, $5Q9wj.default), onContentClick: onContentClick = (0, $5Q9wj.default), onContentFocus: onContentFocus = (0, $5Q9wj.default), onClose: onClose = (0, $5Q9wj.default), placement: placement = 'bottom-start', strategy: strategy = 'fixed', testId: testId, content: content, children: children }) {
    const containerRef = (0, $eUqFw.useRef)(null);
    const triggerRef = (0, $eUqFw.useRef)(null);
    // we put this into a ref to avoid handleCloseRequest having this as a dependency
    const onCloseRef = (0, $eUqFw.useRef)(onClose);
    const isLayeringEnabled = (0, $XHGTv.fg)('platform.design-system-team.inline-message-layering_wfp1p') && isOpen;
    (0, $eUqFw.useEffect)(()=>{
        onCloseRef.current = onClose;
    });
    const handleCloseRequest = (0, $eUqFw.useCallback)((event)=>{
        const { target: target } = event;
        // checks for when target is not HTMLElement
        if (!(target instanceof HTMLElement)) return;
        // TODO: This is to handle the case where the target is no longer in the DOM.
        // This happens with react-select in datetime picker. There might be other
        // edge cases for this.
        if (!document.body.contains(target)) return;
        if (isLayeringEnabled) {
            onCloseRef.current?.({
                isOpen: false,
                event: event
            });
            return;
        }
        // handles the case where inline dialog opens portalled elements such as modal
        if ($99fb58582e83d080$var$checkIsChildOfPortal(target)) return;
        // call onClose if the click originated from outside the dialog
        if (containerRef.current && !containerRef.current.contains(target)) onCloseRef.current?.({
            isOpen: false,
            event: event
        });
    }, [
        isLayeringEnabled
    ]);
    const handleClick = (0, $eUqFw.useCallback)((event)=>{
        // exit if we click outside but on the trigger — it can handle the clicks itself
        if (triggerRef.current && triggerRef.current.contains(event.target)) return;
        // if feature flag is enabled we won't file the close event when clicking inside dialog
        if (isLayeringEnabled && containerRef.current?.contains(event.target)) return;
        handleCloseRequest(event);
    }, [
        handleCloseRequest,
        isLayeringEnabled
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (!isOpen) return;
        return (0, $74BVL.bind)(window, {
            type: 'click',
            listener: handleClick,
            options: {
                capture: true
            }
        });
    }, [
        isOpen,
        handleClick
    ]);
    const handleKeyDown = (0, $eUqFw.useCallback)((event)=>{
        if (event.key === 'Escape') handleCloseRequest(event);
    }, [
        handleCloseRequest
    ]);
    (0, $eUqFw.useEffect)(()=>{
        // if layering is enabled, we will use useCloseOnEscapePress hook instead
        if (!isOpen || isLayeringEnabled) return;
        const unbind = (0, $74BVL.bind)(window, {
            type: 'keydown',
            listener: handleKeyDown,
            options: {
                capture: true
            }
        });
        return unbind;
    }, [
        isOpen,
        handleKeyDown,
        isLayeringEnabled
    ]);
    const popper = isOpen ? /*#__PURE__*/ (0, $byn9U.jsx)((0, $i6BC8.Popper), {
        placement: placement,
        strategy: strategy
    }, ({ ref: ref, style: style })=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $1GZRB.Container), {
            onBlur: onContentBlur,
            onFocus: onContentFocus,
            onClick: onContentClick,
            ref: (node)=>{
                if (node) {
                    containerRef.current = node;
                    if (typeof ref === 'function') ref(node);
                    else ref.current = node;
                }
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: style,
            testId: testId
        }, content)) : null;
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $8nlzU.Manager), null, /*#__PURE__*/ (0, $byn9U.jsx)((0, $6frYP.Reference), null, ({ ref: ref })=>/*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lbDTY))), {
            innerRef: (node)=>{
                triggerRef.current = node;
                if (typeof ref === 'function') ref(node);
                else ref.current = node;
            }
        }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children))), isLayeringEnabled ? /*#__PURE__*/ (0, $byn9U.jsx)((0, $etCs9.UNSAFE_LAYERING), {
        isDisabled: false
    }, popper, /*#__PURE__*/ (0, $byn9U.jsx)($99fb58582e83d080$var$EscapeCloseManager, {
        handleClose: handleCloseRequest
    })) : popper);
});
$99fb58582e83d080$export$513033cc22e3bc20.displayName = 'InlineDialog';
const $99fb58582e83d080$var$createAndFireEventOnAtlaskit = (0, $hM7RE.default)('atlaskit');
/**
 * __Inline dialog__
 *
 * _We are planning on deprecating Inline dialog. We recommend using the Popup component instead._
 *
 * An inline dialog is a pop-up container for small amounts of information. It can also contain controls.
 *
 * - [Examples](https://atlassian.design/components/inline-dialog/examples)
 * - [Code](https://atlassian.design/components/inline-dialog/code)
 * - [Usage](https://atlassian.design/components/inline-dialog/usage)
 */ const $99fb58582e83d080$var$InlineDialog = (0, $1ngde.default)({
    componentName: 'inlineDialog',
    packageName: $99fb58582e83d080$var$packageName,
    packageVersion: $99fb58582e83d080$var$packageVersion
})((0, $2jDha.default)({
    onClose: $99fb58582e83d080$var$createAndFireEventOnAtlaskit({
        action: 'closed',
        actionSubject: 'inlineDialog',
        attributes: {
            componentName: 'inlineDialog',
            packageName: $99fb58582e83d080$var$packageName,
            packageVersion: $99fb58582e83d080$var$packageVersion
        }
    })
})($99fb58582e83d080$export$513033cc22e3bc20));
var $99fb58582e83d080$export$2e2bcd8739ae039 = $99fb58582e83d080$var$InlineDialog;

});
parcelRegister("1GZRB", function(module, exports) {

$parcel$export(module.exports, "Container", () => $9db71f94672a5c3a$export$42a852a2b6b56249);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $PdmhA = parcelRequire("PdmhA");

var $lcnyw = parcelRequire("lcnyw");
const $9db71f94672a5c3a$var$CSS_THEME_BACKGROUND = '--theme-background';
const $9db71f94672a5c3a$var$CSS_THEME_COLOR = '--theme-color';
const $9db71f94672a5c3a$var$CSS_THEME_BOX_SHADOW = '--theme-box-shadow';
const $9db71f94672a5c3a$var$containerStyles = /*#__PURE__*/ (0, $byn9U.css)({
    boxSizing: 'content-box',
    maxWidth: `${448}px`,
    maxHeight: `${448}px`,
    padding: `${"var(--ds-space-200, 16px)"} ${"var(--ds-space-300, 24px)"}`,
    zIndex: (0, $lcnyw.layers).dialog(),
    background: `var(${$9db71f94672a5c3a$var$CSS_THEME_BACKGROUND})`,
    borderRadius: "var(--ds-border-radius, 3px)",
    boxShadow: `var(${$9db71f94672a5c3a$var$CSS_THEME_BOX_SHADOW})`,
    color: `var(${$9db71f94672a5c3a$var$CSS_THEME_COLOR})`,
    '&:focus': {
        outline: 'none'
    }
});
const $9db71f94672a5c3a$export$42a852a2b6b56249 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ children: children, onBlur: onBlur, onClick: onClick, onFocus: onFocus, style: style, testId: testId }, ref)=>{
    return(// Unfortunately, these are used for products to pass through. Inline Dialog is being deprecated anyway
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
    /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $9db71f94672a5c3a$var$containerStyles,
        "data-testid": testId,
        onBlur: onBlur,
        onClick: onClick,
        onFocus: onFocus,
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            [$9db71f94672a5c3a$var$CSS_THEME_BACKGROUND]: `var(--ds-surface-overlay, ${(0, $PdmhA.N0)})`,
            [$9db71f94672a5c3a$var$CSS_THEME_COLOR]: `var(--ds-text, ${(0, $PdmhA.N900)})`,
            [$9db71f94672a5c3a$var$CSS_THEME_BOX_SHADOW]: `var(--ds-shadow-overlay, ${`0 4px 8px -2px ${(0, $PdmhA.N50A)}, 0 0 1px ${(0, $PdmhA.N60A)}`})`,
            ...style
        }
    }, children));
});

});



parcelRegister("5CTGR", function(module, exports) {

$parcel$export(module.exports, "createUnlinkHandlerByAppearance", () => $6da21b132629badf$export$988c496a68d093d3);

const $6da21b132629badf$export$878bf38ae07e22f8 = (fromId, toId, onUnlink, callback)=>(analyticsEvent)=>{
        onUnlink({
            dependency: fromId,
            dependee: toId
        }, analyticsEvent);
        if (callback) callback();
    };
const $6da21b132629badf$export$988c496a68d093d3 = (fromId, toId, appearance, onUnlink, callback)=>appearance === (0, $fbe90688b36d692e$export$920d6feba87a57ed) ? $6da21b132629badf$export$878bf38ae07e22f8(toId, fromId, onUnlink, callback) : $6da21b132629badf$export$878bf38ae07e22f8(fromId, toId, onUnlink, callback);

});

parcelRegister("cyVUy", function(module, exports) {

$parcel$export(module.exports, "default", () => $8a72cf325c71e632$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $8uD7Y = parcelRequire("8uD7Y");


var $bCXJF = parcelRequire("bCXJF");

var $cI8D2 = parcelRequire("cI8D2");
const $8a72cf325c71e632$var$implicitTitleStyles = null;
const $8a72cf325c71e632$var$ImplicitDependency = ({ parentItem: { itemKey: itemKey, title: title }, implicitDependencyItems: implicitDependencyItems, inwardDependencyDescription: inwardDependencyDescription, outwardDependencyDescription: outwardDependencyDescription, ...otherProps })=>{
    const incoming = implicitDependencyItems.filter(({ dependencies: dependencies })=>dependencies.length > 0);
    const outgoing = implicitDependencyItems.filter(({ dependees: dependees })=>dependees.length > 0);
    if (incoming.length === 0 && outgoing.length === 0) return null;
    const renderDependencyItems = (items, appearance, messageDescriptorSingular, messageDescriptorPlural, description)=>{
        if (!items.length) return null;
        const messageDescriptor = items.length === 1 ? messageDescriptorSingular : messageDescriptorPlural;
        const dependencyItemsKey = appearance === (0, $fbe90688b36d692e$export$920d6feba87a57ed) ? 'dependencies' : 'dependees';
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: (0, $7JEyt.default)([
                "_18s81rf7 _1hk5idpf"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
            ...messageDescriptor,
            values: {
                count: items.length,
                itemKey: itemKey,
                title: title,
                // @ts-expect-error - Type '(chunks: string) => JSX.Element' is not assignable to type 'ReactNode'.
                b: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("b", null, chunks)
            }
        })), items.map(({ item: item, ...rest })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bCXJF.default), {
                key: item.id,
                appearance: appearance,
                ...otherProps,
                item: item,
                dependencyItems: rest[dependencyItemsKey],
                description: description
            })));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, renderDependencyItems(incoming, (0, $fbe90688b36d692e$export$920d6feba87a57ed), (0, $cI8D2.default).singleIncomingDependency, (0, $cI8D2.default).incomingDependencies, inwardDependencyDescription), renderDependencyItems(outgoing, (0, $fbe90688b36d692e$export$2c998d8d93f14e97), (0, $cI8D2.default).singleOutgoingDependency, (0, $cI8D2.default).outgoingDependencies, outwardDependencyDescription));
};
var $8a72cf325c71e632$export$2e2bcd8739ae039 = $8a72cf325c71e632$var$ImplicitDependency;

});
parcelRegister("bCXJF", function(module, exports) {

$parcel$export(module.exports, "default", () => $b2bb9ced7833e374$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7u4fN = parcelRequire("7u4fN");

var $86Ndv = parcelRequire("86Ndv");

var $5xnoX = parcelRequire("5xnoX");

var $PdmhA = parcelRequire("PdmhA");

var $jMP2a = parcelRequire("jMP2a");


var $5CTGR = parcelRequire("5CTGR");
var $eENQ7 = parcelRequire("eENQ7");

var $fVBY3 = parcelRequire("fVBY3");

var $jVELx = parcelRequire("jVELx");
const $b2bb9ced7833e374$var$ExpandableCard = ({ dependencyItems: dependencyItems, item: item, description: description, appearance: appearance, onUnlink: onUnlink, onClose: onClose, isExpanded: isExpanded = false })=>{
    const [isOpen, setIsOpen] = (0, $eUqFw.useState)(isExpanded);
    const Chevron = isOpen ? (0, (/*@__PURE__*/$parcel$interopDefault($5xnoX))) : (0, (/*@__PURE__*/$parcel$interopDefault($86Ndv)));
    const hasFilteredItems = dependencyItems.some((dependencyItem)=>dependencyItem.isHidden);
    const onToggleExpand = (0, $eUqFw.useCallback)((event, analyticsEvent)=>{
        const toggleOn = !isOpen;
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'expandDependencySummaryButton', {
            toggle: toggleOn
        });
        setIsOpen(toggleOn);
    }, [
        isOpen
    ]);
    const isItemDatesOverlap = (startDate, dueDate)=>appearance === (0, $fbe90688b36d692e$export$920d6feba87a57ed) ? (0, $eENQ7.isDependencyDatesOverlapping)(startDate, dueDate, item.startDate, item.dueDate) : (0, $eENQ7.isDependencyDatesOverlapping)(item.startDate, item.dueDate, startDate, dueDate);
    // Check if any of the dependency items has overlapped dates
    const hasOverlapDate = dependencyItems.some((dependencyItem)=>isItemDatesOverlap(dependencyItem.startDate, dependencyItem.dueDate));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b2bb9ced7833e374$var$DependencyDetailContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fVBY3.default), {
        appearance: appearance,
        ...item
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b2bb9ced7833e374$var$ExpandButton, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Chevron, {
            primaryColor: `var(--ds-icon, ${(0, $PdmhA.N300)})`,
            label: ""
        }),
        spacing: "compact",
        appearance: "subtle",
        testId: "roadmap.timeline-table-kit.common.ui.dependency.expandable-card.button",
        onClick: onToggleExpand
    })), isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jVELx.default), {
        label: description,
        isOverlapping: hasOverlapDate,
        isFiltered: hasFilteredItems,
        ...onUnlink && dependencyItems.length === 1 ? {
            onUnlink: (0, $5CTGR.createUnlinkHandlerByAppearance)(item.id, dependencyItems[0].id, appearance, onUnlink, dependencyItems.length ? undefined : onClose)
        } : undefined
    }), dependencyItems.map((dependencyItem)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fVBY3.default), {
            key: dependencyItem.id,
            appearance: appearance === (0, $fbe90688b36d692e$export$920d6feba87a57ed) ? (0, $fbe90688b36d692e$export$2c998d8d93f14e97) : (0, $fbe90688b36d692e$export$920d6feba87a57ed),
            ...dependencyItem,
            isOverlapping: isItemDatesOverlap(dependencyItem.startDate, dependencyItem.dueDate),
            ...onUnlink && dependencyItems.length > 1 ? {
                onUnlink: (0, $5CTGR.createUnlinkHandlerByAppearance)(item.id, dependencyItem.id, appearance, onUnlink)
            } : undefined
        }))));
};
var $b2bb9ced7833e374$export$2e2bcd8739ae039 = $b2bb9ced7833e374$var$ExpandableCard;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b2bb9ced7833e374$var$DependencyDetailContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswh2mm _19pku2gc _otyru2gc",
            __cmplp.className
        ])
    });
});
const $b2bb9ced7833e374$var$ExpandButton = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1ule _kqswstnw _154iidpf _1xi2ukr8 _1bsb1tcg",
            __cmplp.className
        ])
    });
});

});
parcelRegister("5xnoX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $40822fe6f5908262$var$_react = $40822fe6f5908262$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $40822fe6f5908262$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $40822fe6f5908262$var$ChevronUpIcon = (props)=>/*#__PURE__*/ $40822fe6f5908262$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M11.221 9.322l-2.929 2.955a1.009 1.009 0 000 1.419.986.986 0 001.405 0l2.298-2.317 2.307 2.327a.989.989 0 001.407 0 1.01 1.01 0 000-1.419l-2.94-2.965A1.106 1.106 0 0011.991 9c-.279 0-.557.107-.77.322z" fill="currentColor" fill-rule="evenodd"/></svg>`
    }, props));
$40822fe6f5908262$var$ChevronUpIcon.displayName = 'ChevronUpIcon';
var $40822fe6f5908262$var$_default = $40822fe6f5908262$var$ChevronUpIcon;
module.exports.default = $40822fe6f5908262$var$_default;

});


parcelRegister("cI8D2", function(module, exports) {

$parcel$export(module.exports, "default", () => $f915ee17037cb3b2$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $f915ee17037cb3b2$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    incomingDependencies: {
        "id": "roadmap.timeline-table-kit.chart-timeline-overlay.dependency-flyout.implicit-dependencies.incoming-dependencies",
        "defaultMessage": "{count} child {count, plural, one {issue} other {issues}} of <b>{itemKey} {title}</b> have incoming dependencies"
    },
    singleIncomingDependency: {
        "id": "roadmap.timeline-table-kit.chart-timeline-overlay.dependency-flyout.implicit-dependencies.single-incoming-dependency",
        "defaultMessage": "{count} child {count, plural, one {issue} other {issues}} of <b>{itemKey} {title}</b> has an incoming dependency"
    },
    outgoingDependencies: {
        "id": "roadmap.timeline-table-kit.chart-timeline-overlay.dependency-flyout.implicit-dependencies.outgoing-dependencies",
        "defaultMessage": "{count} child {count, plural, one {issue} other {issues}} of <b>{itemKey} {title}</b> have outgoing dependencies"
    },
    singleOutgoingDependency: {
        "id": "roadmap.timeline-table-kit.chart-timeline-overlay.dependency-flyout.implicit-dependencies.single-outgoing-dependency",
        "defaultMessage": "{count} child {count, plural, one {issue} other {issues}} of <b>{itemKey} {title}</b> has an outgoing dependency"
    }
});

});


parcelRegister("jIH5Q", function(module, exports) {

$parcel$export(module.exports, "default", () => $30720f4b48fbbf4f$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $30720f4b48fbbf4f$var$Line = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($30720f4b48fbbf4f$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($30720f4b48fbbf4f$var$FlyoutLine, null));
var $30720f4b48fbbf4f$export$2e2bcd8739ae039 = $30720f4b48fbbf4f$var$Line;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $30720f4b48fbbf4f$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1yt4pxbi",
            __cmplp.className
        ])
    });
});
const $30720f4b48fbbf4f$var$FlyoutLine = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _vchhusvi _4t3it94y _1bsb1osq _19ith6cr",
            __cmplp.className
        ])
    });
});

});

parcelRegister("l4wwE", function(module, exports) {

$parcel$export(module.exports, "default", () => $5ab7a8c273d7724c$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $5ab7a8c273d7724c$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    blockedBy: {
        "id": "roadmap.timeline-table-kit.chart-timeline-overlay.dependency-flyout.blocked-by",
        "defaultMessage": "blocked by"
    },
    blocks: {
        "id": "roadmap.timeline-table-kit.chart-timeline-overlay.dependency-flyout.blocks",
        "defaultMessage": "blocks"
    },
    dependencyOf: {
        "id": "roadmap.timeline-table-kit.chart-timeline-overlay.dependency-flyout.dependency-of",
        "defaultMessage": "Dependency of <b>{itemKey} {title}</b>"
    }
});

});


parcelRegister("8kMQk", function(module, exports) {

$parcel$export(module.exports, "getOverlayIssueItem", () => $bc42d5abb34fc156$export$8dc7a148cdc283f7);
$parcel$export(module.exports, "getIssueFromMap", () => $bc42d5abb34fc156$export$8cf9d303c3d4d4bb);
$parcel$export(module.exports, "getDepsItem", () => $bc42d5abb34fc156$export$a6f1c27790748d15);

var $fHtBB = parcelRequire("fHtBB");
const $bc42d5abb34fc156$export$8dc7a148cdc283f7 = (issue)=>issue && {
        id: issue.issueId,
        itemKey: issue.key,
        title: issue.summary || '',
        typeName: issue.issueType.name,
        iconUrl: issue.issueType.iconUrl,
        startDateType: (0, $fHtBB.EXPLICIT),
        startDate: issue.startDate,
        dueDateType: (0, $fHtBB.EXPLICIT),
        dueDate: issue.dueDate,
        isHidden: false,
        intervalName: undefined,
        warningMessages: []
    };
const $bc42d5abb34fc156$export$8cf9d303c3d4d4bb = (issueId, issuesMap)=>// TODO: JEH-21 convert "issueMap" to <number, TimelineViewIssue>
    // @ts-expect-error - TS2345 - Argument of type 'string | number' is not assignable to parameter of type 'string'.
    issuesMap.get(issueId) || issuesMap.get(`${issueId}`);
const $bc42d5abb34fc156$export$a6f1c27790748d15 = ({ issuesMap: issuesMap, issueIds: issueIds })=>issueIds.map((issueId)=>$bc42d5abb34fc156$export$8dc7a148cdc283f7($bc42d5abb34fc156$export$8cf9d303c3d4d4bb(Number(issueId), issuesMap))).filter(Boolean);

});


parcelRegister("if9qQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $43680757160e6d33$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $43680757160e6d33$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    removeDependencyErrorTitle: {
        "id": "business-timeline.timeline-view.chart-timeline-overlay.remove-dependency-error-title",
        "defaultMessage": "We couldn't unlink items"
    },
    removeDependencyErrorMessage: {
        "id": "business-timeline.timeline-view.chart-timeline-overlay.remove-dependency-error-message",
        "defaultMessage": "Check your connection, then give it another try."
    },
    removeDependencyDynamicErrorMessage: {
        "id": "business-timeline.timeline-view.chart-timeline-overlay.remove-dependency-dynamic-error-message",
        "defaultMessage": "{error}"
    }
});

});

parcelRegister("k7sVX", function(module, exports) {

$parcel$export(module.exports, "transformDependencies", () => $3d3ad495f882d371$export$afd306a2b7dc4cc1);
$parcel$export(module.exports, "getSelectedDependency", () => $3d3ad495f882d371$export$aff715abe5e6e33c);

var $5iWql = parcelRequire("5iWql");
const $3d3ad495f882d371$export$afd306a2b7dc4cc1 = (0, $5iWql.default)((dependencies)=>dependencies.map(({ from: from, to: to, itemHeight: itemHeight })=>({
            itemHeight: itemHeight,
            from: from,
            to: to
        })));
const $3d3ad495f882d371$export$aff715abe5e6e33c = (0, $5iWql.default)((issueId, dependees)=>({
        fromId: issueId,
        toId: dependees[0]
    }));

});


parcelRegister("gzr66", function(module, exports) {

$parcel$export(module.exports, "timelineProps", () => $81345af5da84d7a8$export$3043dd4bffe33000);

var $gf0vG = parcelRequire("gf0vG");
const $81345af5da84d7a8$export$9767e017b05e6b70 = (0, $gf0vG.DEFAULT_ITEM_HEIGHT);
// Base prefix for all table html element ids and style marshal classes
const $81345af5da84d7a8$var$scope = 'jwm-timeline';
// Controls features related to creating items after the last row
const $81345af5da84d7a8$var$isCreateLastEnabled = true;
// Determines whether the list can be resized, including reacting to window resizes. The listWidth prop is still respected.
const $81345af5da84d7a8$var$isResizeEnabled = true;
const $81345af5da84d7a8$var$isSelectEnabled = false;
const $81345af5da84d7a8$var$isDragEnabled = true;
// Determines whether to show visual elements derived from the today prop (e.g. TodayMarker)
const $81345af5da84d7a8$var$isHighlightToday = true;
// Determines whether to hide the custom scrollbars in the chart (scrolling will still be enabled)
const $81345af5da84d7a8$var$isHideScrollbar = false;
const $81345af5da84d7a8$export$3043dd4bffe33000 = {
    itemHeight: $81345af5da84d7a8$export$9767e017b05e6b70,
    scope: $81345af5da84d7a8$var$scope,
    isCreateLastEnabled: $81345af5da84d7a8$var$isCreateLastEnabled,
    isResizeEnabled: $81345af5da84d7a8$var$isResizeEnabled,
    isSelectEnabled: $81345af5da84d7a8$var$isSelectEnabled,
    isDragEnabled: $81345af5da84d7a8$var$isDragEnabled,
    isHighlightToday: $81345af5da84d7a8$var$isHighlightToday,
    isHideScrollbar: $81345af5da84d7a8$var$isHideScrollbar
};

});

parcelRegister("7Szg9", function(module, exports) {

$parcel$export(module.exports, "marshalOptions", () => $8d554d82cff4a81e$export$57eb6ddea50ecba1);


const $8d554d82cff4a81e$var$dependenciesOverlayHiddenStyles = `
    opacity: 0;
`;
const $8d554d82cff4a81e$var$dependencyLinesHiddenStyles = `
    pointer-events: none;
`;
const $8d554d82cff4a81e$var$dependenciesDropTargetStyles = `
    pointer-events: all;
`;
/**
 * Marshal action overrides
 */ const $8d554d82cff4a81e$var$onRowDragStart = ({ styleAPI: styleAPI })=>{
    styleAPI.insertStyle((0, $dfce2d8dd72914ca$export$1e54f8b472a07d8d), $8d554d82cff4a81e$var$dependenciesOverlayHiddenStyles);
    styleAPI.insertStyle((0, $dfce2d8dd72914ca$export$cd944e09ecad5145), $8d554d82cff4a81e$var$dependencyLinesHiddenStyles);
};
const $8d554d82cff4a81e$var$onRowDragEnd = ({ styleAPI: styleAPI })=>{
    styleAPI.removeStyle((0, $dfce2d8dd72914ca$export$1e54f8b472a07d8d));
    styleAPI.removeStyle((0, $dfce2d8dd72914ca$export$cd944e09ecad5145));
};
/**
 * Custom marshal actions
 */ const $8d554d82cff4a81e$var$onDependencyDragStart = ({ styleAPI: styleAPI })=>{
    styleAPI.insertStyle((0, $fbe90688b36d692e$export$c330e9be73819573), $8d554d82cff4a81e$var$dependenciesDropTargetStyles);
};
const $8d554d82cff4a81e$var$onDependencyDragEnd = ({ styleAPI: styleAPI })=>{
    styleAPI.removeStyle((0, $fbe90688b36d692e$export$c330e9be73819573));
};
const $8d554d82cff4a81e$var$onBarInteractionStart = ({ styleAPI: styleAPI })=>{
    styleAPI.insertStyle((0, $dfce2d8dd72914ca$export$1e54f8b472a07d8d), $8d554d82cff4a81e$var$dependenciesOverlayHiddenStyles);
    styleAPI.insertStyle((0, $dfce2d8dd72914ca$export$cd944e09ecad5145), $8d554d82cff4a81e$var$dependencyLinesHiddenStyles);
};
const $8d554d82cff4a81e$var$onBarInteractionEnd = ({ styleAPI: styleAPI })=>{
    styleAPI.removeStyle((0, $dfce2d8dd72914ca$export$1e54f8b472a07d8d));
    styleAPI.removeStyle((0, $dfce2d8dd72914ca$export$cd944e09ecad5145));
};
const $8d554d82cff4a81e$export$57eb6ddea50ecba1 = {
    customActions: {
        onDependencyDragStart: $8d554d82cff4a81e$var$onDependencyDragStart,
        onDependencyDragEnd: $8d554d82cff4a81e$var$onDependencyDragEnd,
        onBarInteractionStart: $8d554d82cff4a81e$var$onBarInteractionStart,
        onBarInteractionEnd: $8d554d82cff4a81e$var$onBarInteractionEnd
    },
    overrideActions: {
        onRowDragStart: $8d554d82cff4a81e$var$onRowDragStart,
        onRowDragEnd: $8d554d82cff4a81e$var$onRowDragEnd
    }
};

});

parcelRegister("53aAp", function(module, exports) {

$parcel$export(module.exports, "ExportToImage", () => $b0118261710b6c74$export$955ec9c8783dd76);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $23NQ5 = parcelRequire("23NQ5");

var $4G5xU = parcelRequire("4G5xU");

var $lGiWG = parcelRequire("lGiWG");

var $5JgJ2 = parcelRequire("5JgJ2");

var $gGtKh = parcelRequire("gGtKh");

var $8WuJm = parcelRequire("8WuJm");
var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $2nzpw = parcelRequire("2nzpw");

var $h8wfA = parcelRequire("h8wfA");

var $2o0ZO = parcelRequire("2o0ZO");

const $b0118261710b6c74$export$80d473a3298c2f82 = (0, $7rh0R.lazy)(()=>(parcelRequire("eqyCS")), {
    ssr: false,
    moduleId: "./src/packages/software/roadmap/image-export/src/modal/index.tsx"
});
const $b0118261710b6c74$var$EXPORT_ICON = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($23NQ5))), {
    label: "",
    size: "small"
});
const $b0118261710b6c74$export$955ec9c8783dd76 = ({ tableProps: tableProps })=>{
    const [open, setOpen] = (0, $eUqFw.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4G5xU.ExperienceErrorBoundary), {
        experience: (0, $2nzpw.EXPORT_IMAGE_EXPERIENCE)
    }, open && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceName: "exportImageShare",
        sourceType: (0, $41ea3621645e2acc$export$1171103ea9083ffa)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4G5xU.ExperienceStart), {
        experience: (0, $2nzpw.EXPORT_IMAGE_EXPERIENCE)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "sharing-modal",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b0118261710b6c74$export$80d473a3298c2f82, {
        ExportImage: (0, $h8wfA.LazySharingExport),
        tableProps: tableProps,
        onClickDownload: (_, analyticsEvent)=>{
            (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'saveImageButton');
        },
        onClose: ()=>{
            (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'exportImageShare closed');
            setOpen(false);
        }
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lGiWG.ThemedButton), {
        onClick: (_, analyticsEvent)=>{
            (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'exportToImage');
            setOpen(true);
        },
        appearance: "subtle",
        iconBefore: $b0118261710b6c74$var$EXPORT_ICON,
        testId: "business-timeline.ui.timeline-view.export-image"
    }, formatMessage((0, $2o0ZO.default).export)));
};

});
parcelRegister("lGiWG", function(module, exports) {

$parcel$export(module.exports, "ThemedButton", () => $3bf493f9be098b31$export$f67fb575035cc7d0);
/* ThemedButton.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $7opLA = parcelRequire("7opLA");
const $3bf493f9be098b31$export$f67fb575035cc7d0 = /*#__PURE__*/ (0, $eUqFw.memo)(/*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: as, ...props }, ref)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3bf493f9be098b31$var$CustomButton, {
        ...props,
        as: as,
        ref: ref
    })));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3bf493f9be098b31$var$CustomButton = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $7opLA.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1qt31mi8 _1g9hu0za _1umftrgn _6l8rsb7u _9se51pfj _12ra13cp _zk5ur2ew _18vg1w6j _192e1czd _fnp71tko _1xjgkwex _1u0u1y8w _17z21063 _7n831c2q _n2ulgr9p _1cf15clp _1d7c63lg _nwukkwex",
            __cmplp.className
        ])
    });
});

});

parcelRegister("h8wfA", function(module, exports) {

$parcel$export(module.exports, "LazySharingExport", () => $cce9d0bcc4070551$export$5c8de0d1658b214);

var $7rh0R = parcelRequire("7rh0R");

const $cce9d0bcc4070551$export$5c8de0d1658b214 = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("aX9fT")), {
    ssr: false,
    moduleId: "./src/packages/business/timeline/src/ui/timeline-view/export-image/export-share/main.tsx"
});

});
parcelRegister("aX9fT", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('bnZQx');
        const value = parcelRequire('bmuXr');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("bnZQx").then(()=>parcelRequire('bmuXr'));
}

});


parcelRegister("2o0ZO", function(module, exports) {

$parcel$export(module.exports, "default", () => $28a9ecc9ecac111a$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $28a9ecc9ecac111a$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    export: {
        "id": "business-timeline.timeline-view.export-image.export",
        "defaultMessage": "Export"
    }
});

});

parcelRegister("eqyCS", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('8qggu');
        const value = parcelRequire('b2Sct');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("8qggu").then(()=>parcelRequire('b2Sct'));
}

});


parcelRegister("brx5D", function(module, exports) {

$parcel$export(module.exports, "ListHeader", () => $52e2f96e4ef5e898$export$3d6ed0715468a113);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $5JgJ2 = parcelRequire("5JgJ2");

var $6vQ9J = parcelRequire("6vQ9J");
const $52e2f96e4ef5e898$export$3d6ed0715468a113 = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($52e2f96e4ef5e898$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($52e2f96e4ef5e898$var$Title, null, formatMessage((0, $6vQ9J.default).itemsListHeader)));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $52e2f96e4ef5e898$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _16jlidpf _1o9zidpf _i0dl1wug _4cvr1h6o _4t3i1osq _1yt41g30",
            __cmplp.className
        ])
    });
});
const $52e2f96e4ef5e898$var$Title = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1reo15vq _18m915vq _1bto1l2s _o5721q9c",
            __cmplp.className
        ])
    });
});

});
parcelRegister("6vQ9J", function(module, exports) {

$parcel$export(module.exports, "default", () => $0a68aeb75303dc5f$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $0a68aeb75303dc5f$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    itemsListHeader: {
        "id": "business-timeline.timeline-view.list-header.items-list-header",
        "defaultMessage": "Items"
    }
});

});


parcelRegister("fP9K4", function(module, exports) {

$parcel$export(module.exports, "ListItemContent", () => $419fe72c3b522851$export$a09b9fc02aa00007);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $8cU5f = parcelRequire("8cU5f");

var $j8Htg = parcelRequire("j8Htg");

var $jGcn0 = parcelRequire("jGcn0");

var $96etS = parcelRequire("96etS");

var $hYeSy = parcelRequire("hYeSy");

var $7Sz8O = parcelRequire("7Sz8O");

var $hIxFu = parcelRequire("hIxFu");

var $1ybV0 = parcelRequire("1ybV0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $5cLMB = parcelRequire("5cLMB");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $7PAQj = parcelRequire("7PAQj");

var $krW1A = parcelRequire("krW1A");

var $gf0vG = parcelRequire("gf0vG");

var $fa2D3 = parcelRequire("fa2D3");

var $bvug1 = parcelRequire("bvug1");

var $203kY = parcelRequire("203kY");

var $2PGZs = parcelRequire("2PGZs");

var $aRUSs = parcelRequire("aRUSs");
// eslint-disable-next-line @typescript-eslint/no-empty-function
const $419fe72c3b522851$var$noop = ()=>{};
const $419fe72c3b522851$export$213890d52566537e = /*#__PURE__*/ (0, $eUqFw.memo)(({ onChildCreateClick: onChildCreateClick })=>{
    const [nudgeStep] = (0, $5cLMB.useNudgeStep)();
    const [{ createItemAnchor: createItemAnchor }] = (0, $bvug1.useCreateItemAnchor)();
    const shouldShowAddChildItemNudge = nudgeStep === 'timelineAddChildItemNudge' && !createItemAnchor;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, shouldShowAddChildItemNudge && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($419fe72c3b522851$var$AddItemNudgeWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $krW1A.TimelineAddChildItemNudgeAsync), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($419fe72c3b522851$export$4a45809d2280850, {
        onClick: onChildCreateClick
    }))));
});
const $419fe72c3b522851$export$b3e18ebdf3899c38 = (props)=>{
    const highlight = (0, $96etS.useSimpleSearchHighlight)();
    const { title: title } = props;
    if (title == null) return null;
    const shouldHighlight = highlight.length > 0;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($419fe72c3b522851$var$IssueTitleWrapper, null, shouldHighlight ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7PAQj.default), {
        highlight: highlight,
        text: title
    }) : title);
};
const $419fe72c3b522851$export$a09b9fc02aa00007 = /*#__PURE__*/ (0, $eUqFw.memo)(({ title: title, setSelectedIssueKey: setSelectedIssueKey = $419fe72c3b522851$var$noop, issue: issue, isFirstItem: isFirstItem, onCreateClick: onCreateClick, isLastItem: isLastItem, setInfiniteScrollerRef: setInfiniteScrollerRef })=>{
    const ufoPressTracing = (0, $fa2D3.default)('jwm.timeline.issue-view-opened');
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    let prefetchIssue = $419fe72c3b522851$var$noop;
    if ((0, $1ybV0.ff)('jwm.preload-issue-view-critical-data')) // eslint-disable-next-line react-hooks/rules-of-hooks
    ({ prefetchIssue: prefetchIssue } = (0, $hYeSy.usePrefetchIssueViewDataActions)());
    const handleIssueKeyMouseEnter = (0, $eUqFw.useCallback)(()=>{
        if (issue?.key) prefetchIssue(issue?.key);
    }, [
        issue?.key,
        prefetchIssue
    ]);
    const { issueViewInteraction: issueViewInteraction } = (0, $203kY.useTimelineFeatures)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const openIssueModal = (0, $eUqFw.useCallback)((event)=>{
        if (issue && issue.id && !issue.id.startsWith((0, $7Sz8O.OPTIMISTIC_ID_PREFIX)) && issue.key) {
            ufoPressTracing(event.timeStamp);
            if (issueViewInteraction === 'openNewTab') {
                (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'timelineEmbedIssueKey clicked');
                (0, $j8Htg.openViewFromEmbed)({
                    key: (0, $jGcn0.SELECTED_ISSUE_PARAM),
                    value: issue.key
                });
                event.preventDefault();
                event.stopPropagation();
            } else if (!(0, $hIxFu.isModifiedEvent)(event)) {
                setSelectedIssueKey(issue.key);
                event.preventDefault();
                event.stopPropagation();
                (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'timelineIssueKey clicked');
            }
        }
    }, [
        issue,
        issueViewInteraction,
        createAnalyticsEvent,
        setSelectedIssueKey,
        ufoPressTracing
    ]);
    const onChildCreate = (0, $eUqFw.useCallback)(()=>{
        if (issue) onCreateClick({
            parentId: issue.issueId,
            position: (0, $gf0vG.INSIDE)
        });
    }, [
        onCreateClick,
        issue
    ]);
    if (!issue) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($419fe72c3b522851$var$ListItemContentWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2PGZs.default), {
        src: issue.issueType.iconUrl,
        alt: issue.issueType.name
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: formatMessage((0, $aRUSs.default).toolTip)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($419fe72c3b522851$var$IssueKeyLink, {
        onClick: openIssueModal,
        onMouseEnter: (0, $1ybV0.ff)('jwm.preload-issue-view-critical-data') ? handleIssueKeyMouseEnter : $419fe72c3b522851$var$noop,
        href: `/browse/${issue.key}`,
        "data-test-id": "business-timeline.ui.timeline-view.list-item-content.issue-key",
        "data-testid": "business-timeline.ui.timeline-view.list-item-content.issue-key"
    }, issue.key)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($419fe72c3b522851$export$b3e18ebdf3899c38, {
        title: title
    })), isFirstItem && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($419fe72c3b522851$export$213890d52566537e, {
        onChildCreateClick: onChildCreate
    }), isLastItem && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        ref: setInfiniteScrollerRef
    }));
});
$419fe72c3b522851$export$a09b9fc02aa00007.displayName = 'ListItemContent';
const $419fe72c3b522851$var$NUDGE_SIZE = 24; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $419fe72c3b522851$var$AddItemNudgeWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswstnw _1r041l7b _lcxvglyw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $419fe72c3b522851$var$IssueKeyLink = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_k48pbfng _syaz1v9b _o5721q9c _80omtlke _2hwxpxbi _18u0u2gc _hc7q15vq _njtz15vq _1xnh1l2s _1aaynkob _f8pj1v9b _7ehiglyw _9oik18uv _1bnx8stv _jf4cnqa1 _30l31v9b",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $419fe72c3b522851$var$IssueTitleWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_o5721q9c _1bto1l2s _1reo15vq _18m915vq",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $419fe72c3b522851$var$ListItemContentWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _16jlkb7n _1o9zkb7n _i0dlf1ug _1reo15vq _18m915vq _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // All NudgeTooltipPulse's child nodes will be relative positioned, we have to override position value for the button
const $419fe72c3b522851$export$4a45809d2280850 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqsw7079 _154i1grp _1xi212x7 _1bsb1tcg _4t3i1tcg _lcxv1wug _80omtlke _1ywuglyw _cfu1glyw",
            __cmplp.className
        ])
    });
});

});
parcelRegister("j8Htg", function(module, exports) {

$parcel$export(module.exports, "openViewFromEmbed", () => $3314031ff4af418d$export$a29603f2eb9b6da6);
const $3314031ff4af418d$export$a29603f2eb9b6da6 = (param)=>{
    const cleanUrl = window.location.href.replace('/embed', '');
    const currentUrl = new URL(cleanUrl);
    if (param != null) currentUrl.searchParams.append(param.key, param.value);
    window.open(currentUrl.href, '_blank');
};

});

parcelRegister("7PAQj", function(module, exports) {

$parcel$export(module.exports, "default", () => $dea2f8628dbce2aa$export$2e2bcd8739ae039);

var $gttjd = parcelRequire("gttjd");

var $e63D2 = parcelRequire("e63D2");
var $dea2f8628dbce2aa$export$2e2bcd8739ae039 = (0, $e63D2.default);

});
parcelRegister("gttjd", function(module, exports) {

$parcel$export(module.exports, "removeAccents", () => $38a0e824f156ae86$export$f3f2882e8b11d731);
$parcel$export(module.exports, "getParts", () => $38a0e824f156ae86$export$a3aee8a24a54661f);

var $e1vfz = parcelRequire("e1vfz");

var $hTLlD = parcelRequire("hTLlD");

var $lyOYo = parcelRequire("lyOYo");

var $5iWql = parcelRequire("5iWql");
const $38a0e824f156ae86$export$f3f2882e8b11d731 = (0, $5iWql.default)((text)=>text.normalize('NFD').replace(/[\u0300-\u036f]/g, ''));
const $38a0e824f156ae86$export$1633667427d99697 = (0, $5iWql.default)((highlight)=>{
    const escapedFilter = highlight.map((phrase)=>(0, (/*@__PURE__*/$parcel$interopDefault($e1vfz)))(phrase)).join('|');
    return new RegExp(escapedFilter, 'gmi');
}, (newArgs, lastArgs)=>{
    if (newArgs.length !== lastArgs.length) return false;
    const equalityFn = (0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)));
    return newArgs.every((newArg, index)=>equalityFn(newArg, lastArgs[index]));
});
const $38a0e824f156ae86$export$2235873b95f89ea = (content)=>({
        type: 'text',
        content: content
    });
const $38a0e824f156ae86$export$39ae7d355c29b45f = (content)=>({
        type: 'highlight',
        content: content
    });
const $38a0e824f156ae86$export$c05c39859172f90c = (str, regExp)=>{
    const ms = [];
    let m = regExp.exec(str);
    while(m){
        ms.push(m);
        m = regExp.exec(str);
    }
    return ms;
};
const $38a0e824f156ae86$export$a3aee8a24a54661f = (highlight, text)=>{
    if (highlight == null || highlight.filter((phrase)=>phrase !== '').length === 0) return [
        $38a0e824f156ae86$export$2235873b95f89ea(text)
    ];
    const parts = [];
    // Long text lengths will cause "Invalid regular expression" error
    const truncatedHighlight = highlight.map((phrase)=>phrase.substring(0, 255));
    const highlightRegExp = $38a0e824f156ae86$export$1633667427d99697(truncatedHighlight.filter((phrase)=>phrase !== ''));
    const textWithoutAccents = $38a0e824f156ae86$export$f3f2882e8b11d731(text);
    const textMatches = $38a0e824f156ae86$export$c05c39859172f90c(text, highlightRegExp);
    const textWithoutAccentsMatches = $38a0e824f156ae86$export$c05c39859172f90c(textWithoutAccents, highlightRegExp);
    const highlightMatches = (0, (/*@__PURE__*/$parcel$interopDefault($lyOYo)))([
        ...textWithoutAccentsMatches,
        ...textMatches
    ], 'index');
    let currentPosition = 0;
    highlightMatches.forEach((match)=>{
        const matchText = text.slice(match.index, match.index + match[0].length);
        const leading = text.slice(currentPosition, match.index);
        if (leading !== '') parts.push($38a0e824f156ae86$export$2235873b95f89ea(leading));
        parts.push($38a0e824f156ae86$export$39ae7d355c29b45f(matchText));
        currentPosition = match.index + matchText.length;
    });
    const trailing = text.slice(currentPosition);
    if (trailing !== '') parts.push($38a0e824f156ae86$export$2235873b95f89ea(trailing));
    return parts;
};

});

parcelRegister("e63D2", function(module, exports) {

$parcel$export(module.exports, "default", () => $29e295d31ad42542$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $gttjd = parcelRequire("gttjd");

var $lbHMu = parcelRequire("lbHMu");
const $29e295d31ad42542$var$HighlightTextWithParser = /*#__PURE__*/ (0, $eUqFw.memo)(({ text: text, highlight: highlight })=>{
    const parts = (0, $gttjd.getParts)(highlight, text);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lbHMu.default), {
        parts: parts
    });
});
var $29e295d31ad42542$export$2e2bcd8739ae039 = $29e295d31ad42542$var$HighlightTextWithParser;

});
parcelRegister("lbHMu", function(module, exports) {

$parcel$export(module.exports, "default", () => $ed9071505b4a281f$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $gda1r = parcelRequire("gda1r");
const $ed9071505b4a281f$var$HighlightText = ({ parts: parts })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, parts.map((part, i)=>{
        if (part.type === 'text') return part.content;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gda1r.Mark), {
            key: i
        }, part.content);
    }));
var $ed9071505b4a281f$export$2e2bcd8739ae039 = $ed9071505b4a281f$var$HighlightText;

});
parcelRegister("gda1r", function(module, exports) {

$parcel$export(module.exports, "Mark", () => $8f973f57522751f3$export$c9d15bcfc6d42044);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $8f973f57522751f3$export$c9d15bcfc6d42044 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "mark", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_bfhkwtfv _syaz1fxt",
            __cmplp.className
        ])
    });
});

});




parcelRegister("krW1A", function(module, exports) {

$parcel$export(module.exports, "TimelineAddChildItemNudgeAsync", () => $6ba268ccec4b73cf$export$1ed63402e1f87c79);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $ewdMq = parcelRequire("ewdMq");

var $gGtKh = parcelRequire("gGtKh");


// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $6ba268ccec4b73cf$var$TimelineAddChildItemNudgeLazy = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("eRKML")).then((exportedModule)=>exportedModule.TimelineAddChildItemNudge), {
    ssr: false,
    moduleId: "./src/packages/software/onboarding-nudges/src/ui/jwm-timeline-nudge-tour/timeline-add-child-item/index.tsx"
});
const $6ba268ccec4b73cf$export$1ed63402e1f87c79 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ewdMq.OnboardingNudgeErrorBoundary), {
        id: (0, $99a775c02d636a41$export$2f06a16c987cc1a2),
        fallback: children,
        attributes: {
            nudgeId: (0, $99a775c02d636a41$export$aac6e5779d47ef37)
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "timeline-add-child-item-onboarding-nudge",
        fallback: children
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6ba268ccec4b73cf$var$TimelineAddChildItemNudgeLazy, null, children)));
$6ba268ccec4b73cf$export$1ed63402e1f87c79.displayName = 'TimelineAddChildItemNudgeAsync';

});
const $99a775c02d636a41$export$64d75060ee6ba425 = 'backlogCreateIssueNudge';
const $99a775c02d636a41$export$e0197e09cccd4e50 = 'backlogCreateSprintNudge';
const $99a775c02d636a41$export$6770a2081a63fc15 = 'backlogStartSprintNudge';
const $99a775c02d636a41$export$63b61f654ce3da3d = 'backlogCompleteSprintNudge';
const $99a775c02d636a41$export$1c7a80b00ad9619 = 'backlogInsightsNudge';
const $99a775c02d636a41$export$b8b9d90f9e5bd72b = 'jiraSoftwareOnboardingNudges';
const $99a775c02d636a41$export$65fb0c4e534f03fc = 'asyncScrumTourNudge';
const $99a775c02d636a41$export$f2fe211acb4aa81a = 'asyncKanbanTourNudge';
const $99a775c02d636a41$export$fb9c6e63a7490968 = 'asyncJWMCalendarTourNudge';
const $99a775c02d636a41$export$df53a339af97f102 = 'asyncJWMCalendarAndTimelineTourNudge';
const $99a775c02d636a41$export$573d4bf1da6d2bc6 = 'asyncJWMBoardTourNudge';
const $99a775c02d636a41$export$501e36925fa10eef = 'asyncJWMListTourNudge';
const $99a775c02d636a41$export$2f06a16c987cc1a2 = 'asyncJWMTimelineTourNudge';
const $99a775c02d636a41$export$226bdcb034c75951 = 'asyncJWMFormTourNudge';
const $99a775c02d636a41$export$b72fce9f4cf11b5c = 'asyncJWMTrelloKeyDifferencesTourNudge';
const $99a775c02d636a41$export$306510c7b1760652 = 'asyncJWMSummaryAndReportsTabNudge';
const $99a775c02d636a41$export$cf1943561be3a3c2 = 'asyncJWMSummaryViewNudge';
const $99a775c02d636a41$export$4d6567e7ee0281bf = 'asyncManageProjectsNudge';
const $99a775c02d636a41$export$f8bf435a6066832c = 'button clicked';
const $99a775c02d636a41$export$3bc551fe07069f89 = 'asyncJWMInviteTeamNudge';
const $99a775c02d636a41$export$4db327e1949c2108 = 'boardInProgressColumnNudge';
const $99a775c02d636a41$export$a402f2c11da96cd7 = 'boardCreateIssueNudge';
const $99a775c02d636a41$export$1e174cd1e0212f3a = 'navigateCalendarNudge';
const $99a775c02d636a41$export$6ffa29e74c0304c4 = 'tailorBoardColumnsNudge';
const $99a775c02d636a41$export$a1398a6ef9526001 = 'inlineEditListNudge';
const $99a775c02d636a41$export$5908fa8acd2c0739 = 'filterListNudge';
const $99a775c02d636a41$export$50192b0fdc9bdacf = 'moreDropdownListNudge';
const $99a775c02d636a41$export$e34e81ed4f255f6e = 'timelineAddDateNudge';
const $99a775c02d636a41$export$aac6e5779d47ef37 = 'timelineAddChildItemNudge';
const $99a775c02d636a41$export$69aca8ebee0d34c8 = 'trelloCrossflowAddItemsCalendarNudge';
const $99a775c02d636a41$export$dd4b359b5a58cdc0 = 'trelloCrossflowTimelineTabNudge';
const $99a775c02d636a41$export$1e0e647cc08bb4d8 = 'trelloKeyDifferencesIssueNudge';
const $99a775c02d636a41$export$762576896c225bd6 = 'trelloKeyDifferencesSummaryNudge';
const $99a775c02d636a41$export$5a96f813312dc7fa = 'trelloKeyDifferencesBoardNudge';
const $99a775c02d636a41$export$ae8eeb04e0b1e9af = 'availableFieldsFormNudge';
const $99a775c02d636a41$export$a54d77300f1dddea = 'changeIssueTypeFormNudge';
const $99a775c02d636a41$export$6afdc7e5f6d2e915 = 'previewSaveFormNudge';
const $99a775c02d636a41$export$eb0b199de90a7ec2 = 'backgroundColorNudge';
const $99a775c02d636a41$export$e9e47a7ad42e71f5 = 'feedbackNudge';
const $99a775c02d636a41$export$791f56b3d78403cc = 'calendarReleasesNudge';
const $99a775c02d636a41$export$a1be34032ee24f78 = 'shareProjectNudge';
const $99a775c02d636a41$export$29fe6611cc093756 = 'summaryTabNudge';
const $99a775c02d636a41$export$f107c06c0830f09d = 'reportsTabNudge';

parcelRegister("eRKML", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('d1N5m')
        ]);
        const value = parcelRequire('566aj');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("d1N5m")
    ]).then(()=>parcelRequire('566aj'));
}

});


parcelRegister("2PGZs", function(module, exports) {

$parcel$export(module.exports, "default", () => $74e2fbf541f62049$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $c9TLT = parcelRequire("c9TLT");
const $74e2fbf541f62049$var$Icon = ({ src: src, alt: alt, size: size })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($74e2fbf541f62049$var$IconImage, {
        src: src,
        alt: alt,
        size: size
    });
$74e2fbf541f62049$var$Icon.defaultProps = {
    alt: '',
    size: `${(0, $c9TLT.gridSize) * 2}px`
};
var $74e2fbf541f62049$export$2e2bcd8739ae039 = $74e2fbf541f62049$var$Icon;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $74e2fbf541f62049$var$IconImage = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1frub2c": (0, $9t7rW.default)(__cmplp.size)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1vpm _4t3i1vpm _16jlidpf _1o9zidpf _i0dl1wug _2rko1sit",
            __cmplp.className
        ])
    });
});

});

parcelRegister("aRUSs", function(module, exports) {

$parcel$export(module.exports, "default", () => $53e376b2131f8d73$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $53e376b2131f8d73$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    toolTip: {
        "id": "business-timeline.timeline-view.list-item-content.tool-tip",
        "defaultMessage": "View Details"
    }
});

});


parcelRegister("aPHtc", function(module, exports) {

$parcel$export(module.exports, "default", () => $7328576ed8150ace$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $7328576ed8150ace$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    timelineHeading: {
        "id": "business-timeline.timeline-view.timeline-heading",
        "defaultMessage": "Timeline"
    },
    inlineCreateErrorTitle: {
        "id": "business-timeline.timeline-view.inline-create-error-title",
        "defaultMessage": "Failed to create an item."
    },
    inlineCreateErrorDescription: {
        "id": "business-timeline.timeline-view.inline-create-error-description",
        "defaultMessage": "We were not able to create the item. Try again with the create button."
    },
    loadingMoreItems: {
        "id": "business-timeline.timeline-view.loading-more-items",
        "defaultMessage": "Loading more items..."
    },
    createDependencyErrorTitle: {
        "id": "business-timeline.timeline-view.create-dependency-error-title",
        "defaultMessage": "We couldn't link items."
    },
    createDependencyErrorMessage: {
        "id": "business-timeline.timeline-view.create-dependency-error-message",
        "defaultMessage": "Check your connection, then give it another try."
    },
    startDateMissingErrorTitle: {
        "id": "business-timeline.timeline-view.start-date-missing-error-title",
        "defaultMessage": "We couldn't save the item."
    },
    startDateMissingErrorMessage: {
        "id": "business-timeline.timeline-view.start-date-missing-error-message",
        "defaultMessage": "Field 'Start date' cannot be set. It is not on the appropriate screen."
    }
});

});

parcelRegister("eow9N", function(module, exports) {

$parcel$export(module.exports, "StickyInlineCreate", () => $28eb93d0097ea210$export$22baec6f8784b075);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $a576Y = parcelRequire("a576Y");

var $gCss4 = parcelRequire("gCss4");
var $gIx2f = parcelRequire("gIx2f");

var $1T0MC = parcelRequire("1T0MC");

var $1ybV0 = parcelRequire("1ybV0");

var $k7Dye = parcelRequire("k7Dye");

var $gf0vG = parcelRequire("gf0vG");
var $VrUCp = parcelRequire("VrUCp");

var $jK1pm = parcelRequire("jK1pm");

var $2nzpw = parcelRequire("2nzpw");

var $1Pl9B = parcelRequire("1Pl9B");

var $bvug1 = parcelRequire("bvug1");

var $ifD1l = parcelRequire("ifD1l");

var $bAqCS = parcelRequire("bAqCS");
const $28eb93d0097ea210$var$inlineCreateStyles = (height)=>({
        horizontalPadding: `${"var(--ds-space-100, 8px)"} 0 ${"var(--ds-space-250, 20px)"}`,
        /* -1 to fit border-bottom */ minHeight: `${height - 1}px`,
        borderRadius: `0 0 0 ${"var(--ds-border-radius-200, 8px)"}`
    });
const $28eb93d0097ea210$export$22baec6f8784b075 = ({ issuesMap: issuesMap, loading: loading, listWidth: listWidth, height: height, items: items, expandedItems: expandedItems, timelineRef: timelineRef })=>{
    const [{ createItemAnchor: createItemAnchor }] = (0, $bvug1.useCreateItemAnchor)();
    const [{ headerHeight: headerHeight }] = (0, $VrUCp.useHeaderState)();
    const [containerHeight, setContainerHeight] = (0, $eUqFw.useState)(()=>(timelineRef?.offsetHeight || 0) - headerHeight);
    const { addOptimisticIssue: addOptimisticIssue, updateIssue: updateIssue, removeOptimisticIssue: removeOptimisticIssue } = (0, $ifD1l.useOptimisticIssueCreate)();
    const isEmpty = items.length === 0;
    const onPrepareIssueContext = (0, $eUqFw.useCallback)(()=>{
        // New issue will be created after the last visible issue in the viewport based on scroll position
        const issue = (0, $bAqCS.getIssueAfter)(containerHeight, expandedItems, height, issuesMap, items, timelineRef);
        if (!issue || !issue.rank) return {};
        return {
            rankAfter: {
                issueId: issue.issueId,
                rank: issue.rank
            }
        };
    }, [
        containerHeight,
        expandedItems,
        height,
        issuesMap,
        items,
        timelineRef
    ]);
    const { sticky: sticky, offsetTop: offsetTop } = (0, $eUqFw.useMemo)(()=>{
        let isSticky = items.length * height + height > containerHeight;
        let expandedItemOffset = isSticky ? 0 : items.reduce((sum, item)=>expandedItems[item.id] ? sum + (0, $gf0vG.BASE_LEVEL_ITEM_HEIGHT) * (item.childItems?.length ?? 0) : sum, 0);
        let itemsHeight = 0;
        if ((0, $1ybV0.ff)('jwm.visual-hierarchy-milestone-1')) {
            itemsHeight = (0, $1Pl9B.getTimelineTableItemsHeight)(items, expandedItems, height);
            // consider the height of the create item itself which is equla to 'height'
            isSticky = itemsHeight + height > containerHeight;
            expandedItemOffset = isSticky ? 0 : itemsHeight;
        }
        const createItemAnchorOffset = !isSticky && createItemAnchor ? height : 0;
        return {
            sticky: isSticky,
            offsetTop: (0, $1ybV0.ff)('jwm.visual-hierarchy-milestone-1') ? itemsHeight + createItemAnchorOffset + headerHeight : items.length * height + headerHeight + expandedItemOffset + createItemAnchorOffset
        };
    }, [
        containerHeight,
        createItemAnchor,
        height,
        items,
        expandedItems,
        headerHeight
    ]);
    const throttledUpdateContainerHeight = (0, $eUqFw.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($a576Y)))(()=>{
            if (!timelineRef) return;
            setContainerHeight((timelineRef?.offsetHeight || 0) - headerHeight);
        }, 100), [
        headerHeight,
        timelineRef
    ]);
    (0, $1T0MC.useResizeObserver)(timelineRef ?? null, throttledUpdateContainerHeight);
    const onSubmit = (0, $eUqFw.useCallback)(async ({ optimisticIssuePayload: optimisticIssuePayload, promise: promise })=>{
        addOptimisticIssue(optimisticIssuePayload);
        try {
            const issue = await promise;
            if (issue) updateIssue(issue);
            else removeOptimisticIssue(optimisticIssuePayload.issueId, optimisticIssuePayload.parentIssueId);
        } catch  {
            removeOptimisticIssue(optimisticIssuePayload.issueId, optimisticIssuePayload.parentIssueId);
        }
    }, [
        addOptimisticIssue,
        updateIssue,
        removeOptimisticIssue
    ]);
    if (loading || !timelineRef) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jK1pm.default), {
        name: "business-timeline-sticky-inline-create"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($28eb93d0097ea210$var$Wrapper, {
        width: listWidth,
        height: height,
        sticky: sticky,
        offsetTop: offsetTop
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $k7Dye.TimelineAddItemNudgeAsync), {
        attributes: {
            isEmpty: isEmpty
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gCss4.default), {
        appearance: (0, $gIx2f.ROW_APPEARANCE),
        fieldIdsToReturn: (0, $2nzpw.fieldIds),
        inlineCreateStyles: $28eb93d0097ea210$var$inlineCreateStyles(height),
        isCompact: true,
        location: "timelineFooter",
        onPrepareIssueContext: onPrepareIssueContext,
        onSubmit: onSubmit
    }))));
};
const $28eb93d0097ea210$var$BORDER_OFFSET = 4;
const $28eb93d0097ea210$var$wrapperBaseStylesOld = null;
const $28eb93d0097ea210$var$wrapperBaseStyles = null;
const $28eb93d0097ea210$var$wrapperStickyStyles = null;
const $28eb93d0097ea210$var$Wrapper = ({ sticky: sticky, offsetTop: offsetTop, width: width, height: height, children: children, ...rest })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        // eslint-disable-next-line jira/react/no-style-attribute
        style: {
            top: sticky ? 'auto' : `${offsetTop}px`,
            height: `${height - 1}px`,
            width: `${width - $28eb93d0097ea210$var$BORDER_OFFSET}px`
        },
        ...rest,
        className: (0, $7JEyt.default)([
            (0, $1ybV0.ff)('jwm.visual-hierarchy-dnd') ? "_11q7vuon _kqswstnw _1ltvv77o _1pbyzo7u _1yt4ze3t _x3doqvwq _n7zl1lnu _2rkoidpf _1e0c1txw _4cvr1h6o _bhl91osq" : "_11q7vuon _kqswstnw _1ltvv77o _1pby1o8a _1yt4ze3t _x3doqvwq _n7zl1lnu _2rkoidpf _1e0c1txw _4cvr1h6o _bhl91osq",
            sticky && "_2rko6iej _94n51i6y"
        ])
    }, children);

});
parcelRegister("gCss4", function(module, exports) {

$parcel$export(module.exports, "default", () => $8d57348ffad7a3f9$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $gIx2f = parcelRequire("gIx2f");

var $73dL5 = parcelRequire("73dL5");
const $8d57348ffad7a3f9$var$InlineCreate = ({ allowedIssueTypeIds: allowedIssueTypeIds, appearance: appearance, fieldIdsToReturn: fieldIdsToReturn, inlineCreateStyles: inlineCreateStyles, isCompact: isCompact, location: location, maxHierarchyLevel: maxHierarchyLevel, minHierarchyLevel: minHierarchyLevel, onBlur: onBlur, onPrepareIssueContext: onPrepareIssueContext, onSubmit: onSubmit, onToggleForm: onToggleForm, popperStrategy: popperStrategy })=>{
    const [isFormVisible, setIsFormVisible] = (0, $eUqFw.useState)(false);
    const showForm = (0, $eUqFw.useCallback)(()=>{
        setIsFormVisible(true);
        onToggleForm?.(true);
    }, [
        onToggleForm
    ]);
    const hideForm = (0, $eUqFw.useCallback)(()=>{
        setIsFormVisible(false);
        onToggleForm?.(false);
    }, [
        onToggleForm
    ]);
    const handleBlur = (0, $eUqFw.useCallback)(()=>{
        hideForm();
        onBlur?.();
    }, [
        hideForm,
        onBlur
    ]);
    return isFormVisible ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gIx2f.default), {
        allowedIssueTypeIds: allowedIssueTypeIds,
        appearance: appearance,
        fieldIdsToReturn: fieldIdsToReturn,
        isCompact: isCompact,
        location: location,
        maxHierarchyLevel: maxHierarchyLevel,
        minHierarchyLevel: minHierarchyLevel,
        onBlur: handleBlur,
        onPrepareIssueContext: onPrepareIssueContext,
        onSubmit: onSubmit,
        popperStrategy: popperStrategy,
        ...inlineCreateStyles
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $73dL5.default), {
        onClick: showForm,
        ...inlineCreateStyles
    });
};
const $8d57348ffad7a3f9$var$genericMemo = (0, $eUqFw.memo);
var $8d57348ffad7a3f9$export$2e2bcd8739ae039 = $8d57348ffad7a3f9$var$genericMemo($8d57348ffad7a3f9$var$InlineCreate);

});
parcelRegister("gIx2f", function(module, exports) {

$parcel$export(module.exports, "CARD_APPEARANCE", () => $4f781e23a9165d0b$export$2e234a0f40160716);
$parcel$export(module.exports, "ROW_APPEARANCE", () => $4f781e23a9165d0b$export$e99c52f52501386d);
$parcel$export(module.exports, "default", () => $4f781e23a9165d0b$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $7u4fN = parcelRequire("7u4fN");

var $86Ndv = parcelRequire("86Ndv");

var $jQxSL = parcelRequire("jQxSL");
var $l44HT = parcelRequire("l44HT");

var $8cU5f = parcelRequire("8cU5f");

var $gEmpR = parcelRequire("gEmpR");

var $kQAZu = parcelRequire("kQAZu");

var $4G5xU = parcelRequire("4G5xU");

var $hw2eW = parcelRequire("hw2eW");

var $ji3xf = parcelRequire("ji3xf");
var $7c3W1 = parcelRequire("7c3W1");

var $5JgJ2 = parcelRequire("5JgJ2");


var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $kJlBc = parcelRequire("kJlBc");

var $l4rzg = parcelRequire("l4rzg");

var $auegK = parcelRequire("auegK");

var $d3C6e = parcelRequire("d3C6e");

var $kTIhq = parcelRequire("kTIhq");

var $fkT5k = parcelRequire("fkT5k");
const $4f781e23a9165d0b$var$GENERIC_ICON_URL = '/icons/issuetypes/genericissue.svg';
const $4f781e23a9165d0b$export$2e234a0f40160716 = 'CARD';
const $4f781e23a9165d0b$export$e99c52f52501386d = 'ROW';
const $4f781e23a9165d0b$var$LINK = 'link';
const $4f781e23a9165d0b$var$ISSUE_TYPE = 'issueType';
const $4f781e23a9165d0b$var$useExperience = (location)=>(0, $eUqFw.useMemo)(()=>{
        let experienceId;
        switch(location){
            case 'listFooter':
            case 'listSibling':
            case 'listGroup':
            case 'listHierarchy':
                experienceId = 'list';
                break;
            case 'boardFooter':
            case 'boardSibling':
                experienceId = 'board';
                break;
            case 'calendarDate':
                experienceId = 'calendar';
                break;
            case 'timelineFooter':
            case 'timelineSibling':
            case 'timelineHierarchy':
                experienceId = 'timeline';
                break;
            default:
                throw new Error(`Unknown location ${location}`);
        }
        return {
            ...(0, $l4rzg.CREATE_ISSUE_EXPERIENCE),
            experienceId: experienceId
        };
    }, [
        location
    ]);
const $4f781e23a9165d0b$var$Option = ({ children: children, ...props })=>{
    if (props.data.optionType === $4f781e23a9165d0b$var$ISSUE_TYPE) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jQxSL.c).Option, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4f781e23a9165d0b$var$OptionWrapper, {
        "data-testid": "business-issue-create.ui.inline-create-form.option"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4f781e23a9165d0b$var$OptionTypeIcon, {
        src: props.data.issueType.avatarUrl ?? $4f781e23a9165d0b$var$GENERIC_ICON_URL,
        alt: ""
    }), children));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4f781e23a9165d0b$var$ExtraLinksGroup, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4f781e23a9165d0b$var$StyledLink, {
        href: props.data.url
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jQxSL.c).Option, props, children)));
};
const $4f781e23a9165d0b$export$35cad9398ceaeef0 = ()=>{
    const isReadyRef = (0, $eUqFw.useRef)(false);
    (0, $eUqFw.useEffect)(()=>{
        setTimeout(()=>{
            isReadyRef.current = true;
        }, 100);
    }, []);
    return isReadyRef;
};
const $4f781e23a9165d0b$var$isComposing = (event)=>event.nativeEvent.isComposing;
const $4f781e23a9165d0b$var$InlineCreateForm = ({ allowedIssueTypeIds: allowedIssueTypeIds, appearance: appearance, borderRadius: borderRadius, fieldIdsToReturn: fieldIdsToReturn = [], indent: indent, isCompact: isCompact, location: location, maxHierarchyLevel: maxHierarchyLevel = Number.POSITIVE_INFINITY, minHeight: minHeight, minHierarchyLevel: minHierarchyLevel = 0, onBlur: onBlur, onPrepareIssueContext: onPrepareIssueContext, onSubmit: onSubmit, popperStrategy: popperStrategy = 'absolute' })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { data: { issueTypes: issueTypes } } = (0, $gEmpR.useIssueTypesAndFields)({
        issueOperation: 'CREATE'
    });
    const project = (0, $kQAZu.useProject)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [filter] = (0, $7c3W1.useViewPreference)((0, $ji3xf.FILTER_PREFERENCE));
    const [sorting] = (0, $7c3W1.useViewPreference)((0, $ji3xf.SORTING_PREFERENCE));
    const [preferredIssueTypeId, savePreferredIssueTypeId] = (0, $7c3W1.useViewPreference)((0, $ji3xf.CREATE_TYPE_ID_PREFERENCE));
    const showSuccessFlag = filter != null || sorting != null;
    const experience = $4f781e23a9165d0b$var$useExperience(location);
    const startExperience = (0, $4G5xU.useExperienceStart)(experience);
    const markExperienceSuccess = (0, $4G5xU.useExperienceSuccess)(experience);
    const markExperienceFail = (0, $4G5xU.useExperienceFail)(experience);
    const abortExperience = (0, $4G5xU.useExperienceAbort)(experience);
    const issueTypeOptions = (0, $eUqFw.useMemo)(()=>{
        const validIssueTypes = issueTypes.filter((issueType)=>{
            const isAllowed = allowedIssueTypeIds?.includes(issueType.id) ?? true;
            return isAllowed && issueType.hierarchyLevel >= minHierarchyLevel && issueType.hierarchyLevel <= maxHierarchyLevel;
        });
        const typeOptions = validIssueTypes.map((issueType)=>({
                label: issueType.name,
                value: issueType.id,
                issueType: issueType,
                optionType: $4f781e23a9165d0b$var$ISSUE_TYPE
            }));
        typeOptions.sort(// sort by decreasing hierarchy level
        (a, b)=>b.issueType.hierarchyLevel - a.issueType.hierarchyLevel);
        return typeOptions;
    }, [
        allowedIssueTypeIds,
        issueTypes,
        maxHierarchyLevel,
        minHierarchyLevel
    ]);
    const options = (0, $eUqFw.useMemo)(()=>{
        const canManageTypes = project.permissions.administerProject;
        const manageIssueTypesLink = (0, $hw2eW.getIssueTypesSettingsUrl)(project.key, project.isSimplified);
        let manageTypesOption = null;
        if (canManageTypes) {
            manageTypesOption = {
                label: formatMessage((0, $kTIhq.default).manageIssueTypes),
                value: manageIssueTypesLink,
                url: manageIssueTypesLink,
                optionType: $4f781e23a9165d0b$var$LINK
            };
            return [
                ...issueTypeOptions,
                manageTypesOption
            ];
        }
        return [
            ...issueTypeOptions
        ];
    }, [
        formatMessage,
        issueTypeOptions,
        project
    ]);
    const { summaryRef: summaryRef, submit: submit, blur: blur } = (0, $d3C6e.useCreateIssue)(onSubmit, onBlur);
    const [selectedType, setSelectedType] = (0, $eUqFw.useState)(()=>{
        if (preferredIssueTypeId) {
            const defaultIssueType = issueTypeOptions.find((issueType)=>issueType.value === preferredIssueTypeId);
            if (defaultIssueType) return defaultIssueType;
        } // Returns the first issue type with hierarchy level of zero if there is no last used issue type
        if (minHierarchyLevel === 0) return issueTypeOptions.find((option)=>option.issueType.hierarchyLevel === 0) ?? options[0];
        return options[0];
    });
    const [textContent, setTextContent] = (0, $eUqFw.useState)(summaryRef.current);
    summaryRef.current = textContent;
    const formRef = (0, $eUqFw.useRef)(null);
    const popperRef = (0, $eUqFw.useRef)(null);
    const isEmptyRef = (0, $eUqFw.useRef)(true);
    const textAreaRef = (0, $eUqFw.useRef)(null);
    isEmptyRef.current = textContent.trim().length === 0;
    const handleCreateIssue = ()=>{
        if (!isEmptyRef.current && selectedType.optionType === $4f781e23a9165d0b$var$ISSUE_TYPE) {
            const issueType = issueTypes.find((type)=>type.id === selectedType.value);
            startExperience();
            const result = submit({
                input: {
                    summary: textContent.trim(),
                    projectId: String(project.id),
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    issueType: issueType,
                    ...onPrepareIssueContext?.()
                },
                fieldIdsToReturn: fieldIdsToReturn,
                location: location,
                showSuccessFlag: showSuccessFlag
            });
            setTextContent('');
            result.promise.then(()=>markExperienceSuccess()).catch((error)=>{
                if (error instanceof (0, $auegK.CancelledError)) abortExperience('User cancelled');
                else markExperienceFail('Failed to create issue', error);
            });
        }
    };
    const handleCreateIssueRef = (0, $eUqFw.useRef)(handleCreateIssue);
    handleCreateIssueRef.current = handleCreateIssue; // prevent blurring from occurring when the form is first rendered
    const isReadyRef = $4f781e23a9165d0b$export$35cad9398ceaeef0();
    const handleBlur = (0, $eUqFw.useCallback)((event)=>{
        if (!isReadyRef.current) return;
         // make sure to make a local copy of the isEmptyRef value before it gets reset by the create handler
        const formEmpty = isEmptyRef.current; // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const inForm = formRef.current?.contains(event.target) ?? false; // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const inPopper = popperRef.current?.contains(event.target) ?? false;
        if (!inForm && !inPopper) {
            handleCreateIssueRef.current();
            blur();
            (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'form blurred', 'inlineCreate', {
                location: location,
                formEmpty: formEmpty,
                escapeKeyPressed: false
            });
        }
    }, [
        isReadyRef,
        blur,
        createAnalyticsEvent,
        location
    ]); // PopupSelectTriggerProps is not exported from @atlaskit/select
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const issueTypeButton = (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4f781e23a9165d0b$var$StyledButton, {
            ...triggerProps,
            "aria-label": formatMessage((0, $kTIhq.default).selectIssueTypeButton, {
                issueType: selectedType.label
            }),
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("img" // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            , {
                src: selectedType.issueType.avatarUrl ?? undefined,
                alt: "",
                height: 16,
                width: 16
            }),
            iconAfter: isCompact ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4f781e23a9165d0b$var$ChevronDownWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($86Ndv))), {
                label: ""
            })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($86Ndv))), {
                label: ""
            }),
            spacing: "compact",
            testId: "business-issue-create.ui.inline-create-form.issue-type-trigger"
        }, !isCompact && selectedType.label);
    (0, $eUqFw.useEffect)(()=>{
        // on mount, we want to move the cursor to the end of the input
        textAreaRef.current?.setSelectionRange(textAreaRef.current.value.length, textAreaRef.current.value.length);
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'form focused', 'inlineCreate', {
            location: location
        });
    }, [
        createAnalyticsEvent,
        location
    ]);
    (0, $eUqFw.useEffect)(()=>{
        document.addEventListener('click', handleBlur, true);
        return ()=>{
            document.removeEventListener('click', handleBlur, true);
        };
    }, [
        handleBlur
    ]); // this is not a scenario we expect to happen but we know it does happen when a project is just created
    // the issue types and fields have a retry mechanism to avoid this but we want to handle it here as well
    // to avoid runtime errors
    if (issueTypes.length === 0) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4f781e23a9165d0b$var$FullContent, {
        appearance: appearance,
        borderRadius: borderRadius,
        indent: indent,
        minHeight: minHeight,
        onKeyDown: (event)=>{
            event.stopPropagation();
            if (event.key === 'Escape' && !$4f781e23a9165d0b$var$isComposing(event)) {
                blur();
                (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'form blurred', 'inlineCreate', {
                    location: location,
                    formEmpty: isEmptyRef.current,
                    escapeKeyPressed: true
                });
            }
        },
        onSubmit: (event)=>{
            event.preventDefault();
            handleCreateIssue();
        },
        ref: formRef
    }, appearance === $4f781e23a9165d0b$export$e99c52f52501386d && !isCompact && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4f781e23a9165d0b$var$IssueTypeIcon, {
        alt: "" // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        ,
        src: selectedType.issueType.avatarUrl ?? $4f781e23a9165d0b$var$GENERIC_ICON_URL
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4f781e23a9165d0b$var$StyledTextArea, {
        appearance: appearance,
        autoFocus: true,
        "data-testid": "business-issue-create.ui.inline-create-form.textarea",
        maxLength: (0, $3b526ddeb90a4d89$export$193356664cd84c83),
        onChange: (event)=>{
            const content = event.target.value.replace(/[\n\r]+/g, ' ');
            setTextContent(content);
        },
        onKeyDown: (event)=>{
            if (event.key === 'Enter' && !$4f781e23a9165d0b$var$isComposing(event)) {
                event.preventDefault();
                handleCreateIssue();
            }
        },
        placeholder: formatMessage((0, $kTIhq.default).placeholderText),
        value: textContent,
        ref: textAreaRef
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4f781e23a9165d0b$var$Footer, {
        appearance: appearance
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $l44HT.default), {
        onMenuOpen: ()=>{
            (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'select opened', 'inlineCreateIssueTypes', {
                location: location
            });
        },
        components: {
            Option: $4f781e23a9165d0b$var$Option
        },
        searchThreshold: 10,
        options: options,
        onChange: (option)=>{
            if (option?.optionType === $4f781e23a9165d0b$var$ISSUE_TYPE) {
                setSelectedType(option);
                savePreferredIssueTypeId(option.value);
            }
        },
        popperProps: {
            strategy: popperStrategy,
            innerRef: popperRef
        },
        value: selectedType,
        target: ({ isOpen: isOpen, ...triggerProps })=>isCompact ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
                content: selectedType.label
            }, issueTypeButton(triggerProps)) : issueTypeButton(triggerProps)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4f781e23a9165d0b$var$StyledCreateButton, {
        appearance: "primary",
        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fkT5k.default), null),
        isDisabled: isEmptyRef.current,
        spacing: "compact",
        type: "submit",
        onClick: ()=>{
            (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'inlineCreateSubmit', {
                location: location,
                hierarchyLevel: selectedType.optionType === $4f781e23a9165d0b$var$ISSUE_TYPE ? selectedType.issueType?.hierarchyLevel : undefined
            });
        }
    }, formatMessage((0, $kTIhq.default).createButton))));
};
const $4f781e23a9165d0b$var$InlineCreateFormWithErrorBoundary = (props)=>{
    const experience = $4f781e23a9165d0b$var$useExperience(props.location);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4G5xU.ExperienceErrorBoundary), {
        experience: experience,
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4f781e23a9165d0b$var$InlineCreateForm, props));
};
const $4f781e23a9165d0b$var$genericMemo = (0, $eUqFw.memo);
var $4f781e23a9165d0b$export$2e2bcd8739ae039 = $4f781e23a9165d0b$var$genericMemo($4f781e23a9165d0b$var$InlineCreateFormWithErrorBoundary);
const $4f781e23a9165d0b$var$lineHeight = 20; // margin: '0px' is needed to override the default margin of the form element
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4f781e23a9165d0b$var$FullContent = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "form", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { borderRadius: borderRadius, minHeight: minHeight, appearance: appearance, indent: indent, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_a70prk": (0, $9t7rW.default)(__cmplp.borderRadius ?? "var(--ds-border-radius, 3px)"),
            "--_jfgeee": (0, $9t7rW.default)(__cmplp.minHeight ?? '40px'),
            "--_10qudx8": (0, $9t7rW.default)(__cmplp.appearance === $4f781e23a9165d0b$export$e99c52f52501386d && 'center'),
            "--_gg0ene": (0, $9t7rW.default)(__cmplp.indent)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _zulpu2gc _bfhkvuon _v56416gf _16qshqll _vchhusvi _12ji1r31 _1qu2glyw _12y31o36 _2rko7ebt _1tkej4pn _4cvrnb98 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0q1b66 _u5f3u2gc _n3td1b66 _19bvu2gc",
            __cmplp.appearance === $4f781e23a9165d0b$export$2e234a0f40160716 ? "_2lx21bp4" : "_2lx2vrvc",
            __cmplp.appearance === $4f781e23a9165d0b$export$e99c52f52501386d ? "_4t3i1ylp" : "_4t3i53f4",
            __cmplp.appearance === $4f781e23a9165d0b$export$2e234a0f40160716 && "_ca0qu2gc _n3tdu2gc",
            __cmplp.indent && "_19bv2uct",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4f781e23a9165d0b$var$StyledTextArea = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "textarea", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { appearance: appearance, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _19itglyw _12ji1r31 _1qu2glyw _12y31o36 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1yt41b66 _14zgglyw _bfhkvuon _syaz1fxt _ect41wi2 _1wybdlk8 _vwz4gktf _1idr1wmz _1wfakb7n",
            __cmplp.appearance === $4f781e23a9165d0b$export$2e234a0f40160716 ? "_4t3i1ylp" : "_4t3igktf",
            __cmplp.appearance === $4f781e23a9165d0b$export$e99c52f52501386d && "_o572qvpr _1fjgglyw _1cicglyw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4f781e23a9165d0b$var$Footer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { appearance: appearance, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _zulpu2gc _4cvr1h6o",
            __cmplp.appearance === $4f781e23a9165d0b$export$2e234a0f40160716 ? "_1bah1yb4" : "_1bahh9n0",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4f781e23a9165d0b$var$StyledButton = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $7u4fN.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1ul9idpf",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4f781e23a9165d0b$var$StyledCreateButton = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $7u4fN.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlidpf _1o9zidpf _i0dl1wug",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4f781e23a9165d0b$var$OptionWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4f781e23a9165d0b$var$OptionTypeIcon = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3ipxbi _1bsbpxbi _2hwxu2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4f781e23a9165d0b$var$ExtraLinksGroup = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_x3dope8f _19pk1b66 _ca0q1b66",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4f781e23a9165d0b$var$StyledLink = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $kJlBc.Link), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_9oik18uv _1bnxglyw _jf4cnqa1",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4f781e23a9165d0b$var$IssueTypeIcon = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3ipxbi _1bsbpxbi",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4f781e23a9165d0b$var$ChevronDownWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18s83jz8",
            __cmplp.className
        ])
    });
});

});
parcelRegister("jQxSL", function(module, exports) {

$parcel$export(module.exports, "K", () => $e72d27f6b1599862$export$3466f893ebf79586);
$parcel$export(module.exports, "E", () => $e72d27f6b1599862$export$a9c23c6ac3fc3eca);
$parcel$export(module.exports, "I", () => $e72d27f6b1599862$export$9bb611d729802a56);
$parcel$export(module.exports, "L", () => $e72d27f6b1599862$export$61196ced6d74a310);
$parcel$export(module.exports, "H", () => $e72d27f6b1599862$export$7f8ddf7c7c20b3cd);
$parcel$export(module.exports, "J", () => $e72d27f6b1599862$export$b4171a6734a65d42);
$parcel$export(module.exports, "z", () => $e72d27f6b1599862$export$df995fae86a55f06);
$parcel$export(module.exports, "A", () => $e72d27f6b1599862$export$ebd11618f299a286);
$parcel$export(module.exports, "s", () => $e72d27f6b1599862$export$2408f22a0fab9ae5);
$parcel$export(module.exports, "G", () => $e72d27f6b1599862$export$2329c99376c9d0a4);
$parcel$export(module.exports, "D", () => $e72d27f6b1599862$export$96f57966bedc81b4);
$parcel$export(module.exports, "C", () => $e72d27f6b1599862$export$e7094788287c5e9b);
$parcel$export(module.exports, "B", () => $e72d27f6b1599862$export$ef35774e6d314e91);
$parcel$export(module.exports, "r", () => $e72d27f6b1599862$export$43caf9889c228507);
$parcel$export(module.exports, "m", () => $e72d27f6b1599862$export$953cecd6e717a553);
$parcel$export(module.exports, "M", () => $e72d27f6b1599862$export$3a1a48c8f6ef640e);
$parcel$export(module.exports, "n", () => $e72d27f6b1599862$export$7ccc53e8f1e7dfc5);
$parcel$export(module.exports, "u", () => $e72d27f6b1599862$export$3b14a55fb2447963);
$parcel$export(module.exports, "k", () => $e72d27f6b1599862$export$342063e11d6c3cad);
$parcel$export(module.exports, "o", () => $e72d27f6b1599862$export$ae1af26003f05816);
$parcel$export(module.exports, "b", () => $e72d27f6b1599862$export$8b22cf2602fb60ce);
$parcel$export(module.exports, "y", () => $e72d27f6b1599862$export$4a5767248b18ef41);
$parcel$export(module.exports, "i", () => $e72d27f6b1599862$export$23f2a1d2818174ef);
$parcel$export(module.exports, "e", () => $e72d27f6b1599862$export$f1e1789686576879);
$parcel$export(module.exports, "a", () => $e72d27f6b1599862$export$407448d2b89b1813);
$parcel$export(module.exports, "h", () => $e72d27f6b1599862$export$dda1d9f60106f0e9);
$parcel$export(module.exports, "l", () => $e72d27f6b1599862$export$882b5998b3b9117c);
$parcel$export(module.exports, "d", () => $e72d27f6b1599862$export$4368d992c4eafac0);
$parcel$export(module.exports, "g", () => $e72d27f6b1599862$export$39b482c5e57630a8);
$parcel$export(module.exports, "f", () => $e72d27f6b1599862$export$2d1720544b23b823);
$parcel$export(module.exports, "j", () => $e72d27f6b1599862$export$35e795649ee09318);
$parcel$export(module.exports, "p", () => $e72d27f6b1599862$export$ffb5f4729a158638);
$parcel$export(module.exports, "q", () => $e72d27f6b1599862$export$9e5f44173e64f162);
$parcel$export(module.exports, "t", () => $e72d27f6b1599862$export$625550452a3fa3ec);
$parcel$export(module.exports, "v", () => $e72d27f6b1599862$export$90a7f3efeed30595);
$parcel$export(module.exports, "w", () => $e72d27f6b1599862$export$efccba1c4a2ef57b);
$parcel$export(module.exports, "x", () => $e72d27f6b1599862$export$d141bba7fdc215a3);
$parcel$export(module.exports, "c", () => $e72d27f6b1599862$export$db3b6bfb95261072);
$parcel$export(module.exports, "F", () => $e72d27f6b1599862$export$d66501df72047452);

var $1Xn5q = parcelRequire("1Xn5q");

var $kU09D = parcelRequire("kU09D");

var $byn9U = parcelRequire("byn9U");

var $aKcqM = parcelRequire("aKcqM");

var $bwPfh = parcelRequire("bwPfh");

var $5sKOb = parcelRequire("5sKOb");

var $jqNEH = parcelRequire("jqNEH");

var $5zQU9 = parcelRequire("5zQU9");

var $eUqFw = parcelRequire("eUqFw");

var $lEfVV = parcelRequire("lEfVV");

var $5O3G9 = parcelRequire("5O3G9");

var $k286k = parcelRequire("k286k");
var $e72d27f6b1599862$var$_excluded$3 = [
    "className",
    "clearValue",
    "cx",
    "getStyles",
    "getClassNames",
    "getValue",
    "hasValue",
    "isMulti",
    "isRtl",
    "options",
    "selectOption",
    "selectProps",
    "setValue",
    "theme"
];
// ==============================
// NO OP
// ==============================
var $e72d27f6b1599862$export$3466f893ebf79586 = function noop() {};
// ==============================
// Class Name Prefixer
// ==============================
/**
 String representation of component state for styling with class names.

 Expects an array of strings OR a string/object pair:
 - className(['comp', 'comp-arg', 'comp-arg-2'])
   @returns 'react-select__comp react-select__comp-arg react-select__comp-arg-2'
 - className('comp', { some: true, state: false })
   @returns 'react-select__comp react-select__comp--some'
*/ function $e72d27f6b1599862$var$applyPrefixToName(prefix, name) {
    if (!name) return prefix;
    else if (name[0] === '-') return prefix + name;
    else return prefix + '__' + name;
}
function $e72d27f6b1599862$export$a9c23c6ac3fc3eca(prefix, state) {
    for(var _len = arguments.length, classNameList = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)classNameList[_key - 2] = arguments[_key];
    var arr = [].concat(classNameList);
    if (state && prefix) {
        for(var key in state)if (state.hasOwnProperty(key) && state[key]) arr.push("".concat($e72d27f6b1599862$var$applyPrefixToName(prefix, key)));
    }
    return arr.filter(function(i) {
        return i;
    }).map(function(i) {
        return String(i).trim();
    }).join(' ');
}
// ==============================
// Clean Value
// ==============================
var $e72d27f6b1599862$export$9bb611d729802a56 = function cleanValue(value) {
    if ($e72d27f6b1599862$var$isArray(value)) return value.filter(Boolean);
    if ((0, $5sKOb.default)(value) === 'object' && value !== null) return [
        value
    ];
    return [];
};
// ==============================
// Clean Common Props
// ==============================
var $e72d27f6b1599862$var$cleanCommonProps = function cleanCommonProps(props) {
    //className
    props.className;
    props.clearValue;
    props.cx;
    props.getStyles;
    props.getClassNames;
    props.getValue;
    props.hasValue;
    props.isMulti;
    props.isRtl;
    props.options;
    props.selectOption;
    props.selectProps;
    props.setValue;
    props.theme;
    var innerProps = (0, $bwPfh.default)(props, $e72d27f6b1599862$var$_excluded$3);
    return (0, $1Xn5q.default)({}, innerProps);
};
// ==============================
// Get Style Props
// ==============================
var $e72d27f6b1599862$var$getStyleProps = function getStyleProps(props, name, classNamesState) {
    var cx = props.cx, getStyles = props.getStyles, getClassNames = props.getClassNames, className = props.className;
    return {
        css: getStyles(name, props),
        className: cx(classNamesState !== null && classNamesState !== void 0 ? classNamesState : {}, getClassNames(name, props), className)
    };
};
// ==============================
// Handle Input Change
// ==============================
function $e72d27f6b1599862$export$61196ced6d74a310(inputValue, actionMeta, onInputChange) {
    if (onInputChange) {
        var _newValue = onInputChange(inputValue, actionMeta);
        if (typeof _newValue === 'string') return _newValue;
    }
    return inputValue;
}
// ==============================
// Scroll Helpers
// ==============================
function $e72d27f6b1599862$export$7f8ddf7c7c20b3cd(el) {
    return [
        document.documentElement,
        document.body,
        window
    ].indexOf(el) > -1;
}
// Normalized Scroll Top
// ------------------------------
function $e72d27f6b1599862$var$normalizedHeight(el) {
    if ($e72d27f6b1599862$export$7f8ddf7c7c20b3cd(el)) return window.innerHeight;
    return el.clientHeight;
}
// Normalized scrollTo & scrollTop
// ------------------------------
function $e72d27f6b1599862$var$getScrollTop(el) {
    if ($e72d27f6b1599862$export$7f8ddf7c7c20b3cd(el)) return window.pageYOffset;
    return el.scrollTop;
}
function $e72d27f6b1599862$var$scrollTo(el, top) {
    // with a scroll distance, we perform scroll on the element
    if ($e72d27f6b1599862$export$7f8ddf7c7c20b3cd(el)) {
        window.scrollTo(0, top);
        return;
    }
    el.scrollTop = top;
}
// Get Scroll Parent
// ------------------------------
function $e72d27f6b1599862$var$getScrollParent(element) {
    var style = getComputedStyle(element);
    var excludeStaticParent = style.position === 'absolute';
    var overflowRx = /(auto|scroll)/;
    if (style.position === 'fixed') return document.documentElement;
    for(var parent = element; parent = parent.parentElement;){
        style = getComputedStyle(parent);
        if (excludeStaticParent && style.position === 'static') continue;
        if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) return parent;
    }
    return document.documentElement;
}
// Animated Scroll To
// ------------------------------
/**
  @param t: time (elapsed)
  @param b: initial value
  @param c: amount of change
  @param d: duration
*/ function $e72d27f6b1599862$var$easeOutCubic(t, b, c, d) {
    return c * ((t = t / d - 1) * t * t + 1) + b;
}
function $e72d27f6b1599862$var$animatedScrollTo(element, to) {
    var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 200;
    var callback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : $e72d27f6b1599862$export$3466f893ebf79586;
    var start = $e72d27f6b1599862$var$getScrollTop(element);
    var change = to - start;
    var increment = 10;
    var currentTime = 0;
    function animateScroll() {
        currentTime += increment;
        var val = $e72d27f6b1599862$var$easeOutCubic(currentTime, start, change, duration);
        $e72d27f6b1599862$var$scrollTo(element, val);
        if (currentTime < duration) window.requestAnimationFrame(animateScroll);
        else callback(element);
    }
    animateScroll();
}
// Scroll Into View
// ------------------------------
function $e72d27f6b1599862$export$b4171a6734a65d42(menuEl, focusedEl) {
    var menuRect = menuEl.getBoundingClientRect();
    var focusedRect = focusedEl.getBoundingClientRect();
    var overScroll = focusedEl.offsetHeight / 3;
    if (focusedRect.bottom + overScroll > menuRect.bottom) $e72d27f6b1599862$var$scrollTo(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
    else if (focusedRect.top - overScroll < menuRect.top) $e72d27f6b1599862$var$scrollTo(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
}
// ==============================
// Get bounding client object
// ==============================
// cannot get keys using array notation with DOMRect
function $e72d27f6b1599862$var$getBoundingClientObj(element) {
    var rect = element.getBoundingClientRect();
    return {
        bottom: rect.bottom,
        height: rect.height,
        left: rect.left,
        right: rect.right,
        top: rect.top,
        width: rect.width
    };
}
// ==============================
// Touch Capability Detector
// ==============================
function $e72d27f6b1599862$export$df995fae86a55f06() {
    try {
        document.createEvent('TouchEvent');
        return true;
    } catch (e) {
        return false;
    }
}
// ==============================
// Mobile Device Detector
// ==============================
function $e72d27f6b1599862$export$ebd11618f299a286() {
    try {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    } catch (e) {
        return false;
    }
}
// ==============================
// Passive Event Detector
// ==============================
// https://github.com/rafgraph/detect-it/blob/main/src/index.ts#L19-L36
var $e72d27f6b1599862$var$passiveOptionAccessed = false;
var $e72d27f6b1599862$var$options = {
    get passive () {
        return $e72d27f6b1599862$var$passiveOptionAccessed = true;
    }
};
// check for SSR
var $e72d27f6b1599862$var$w = typeof window !== 'undefined' ? window : {};
if ($e72d27f6b1599862$var$w.addEventListener && $e72d27f6b1599862$var$w.removeEventListener) {
    $e72d27f6b1599862$var$w.addEventListener('p', $e72d27f6b1599862$export$3466f893ebf79586, $e72d27f6b1599862$var$options);
    $e72d27f6b1599862$var$w.removeEventListener('p', $e72d27f6b1599862$export$3466f893ebf79586, false);
}
var $e72d27f6b1599862$export$2408f22a0fab9ae5 = $e72d27f6b1599862$var$passiveOptionAccessed;
function $e72d27f6b1599862$export$2329c99376c9d0a4(item) {
    return item != null;
}
function $e72d27f6b1599862$var$isArray(arg) {
    return Array.isArray(arg);
}
function $e72d27f6b1599862$export$96f57966bedc81b4(isMulti, multiValue, singleValue) {
    return isMulti ? multiValue : singleValue;
}
function $e72d27f6b1599862$export$e7094788287c5e9b(singleValue) {
    return singleValue;
}
function $e72d27f6b1599862$export$ef35774e6d314e91(multiValue) {
    return multiValue;
}
var $e72d27f6b1599862$export$43caf9889c228507 = function removeProps(propsObj) {
    for(var _len2 = arguments.length, properties = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)properties[_key2 - 1] = arguments[_key2];
    var propsMap = Object.entries(propsObj).filter(function(_ref) {
        var _ref2 = (0, $aKcqM.default)(_ref, 1), key = _ref2[0];
        return !properties.includes(key);
    });
    return propsMap.reduce(function(newProps, _ref3) {
        var _ref4 = (0, $aKcqM.default)(_ref3, 2), key = _ref4[0], val = _ref4[1];
        newProps[key] = val;
        return newProps;
    }, {});
};
function $e72d27f6b1599862$var$getMenuPlacement(_ref) {
    var preferredMaxHeight = _ref.maxHeight, menuEl = _ref.menuEl, minHeight = _ref.minHeight, preferredPlacement = _ref.placement, shouldScroll = _ref.shouldScroll, isFixedPosition = _ref.isFixedPosition, controlHeight = _ref.controlHeight;
    var scrollParent = $e72d27f6b1599862$var$getScrollParent(menuEl);
    var defaultState = {
        placement: 'bottom',
        maxHeight: preferredMaxHeight
    };
    // something went wrong, return default state
    if (!menuEl || !menuEl.offsetParent) return defaultState;
    // we can't trust `scrollParent.scrollHeight` --> it may increase when
    // the menu is rendered
    var _scrollParent$getBoun = scrollParent.getBoundingClientRect(), scrollHeight = _scrollParent$getBoun.height;
    var _menuEl$getBoundingCl = menuEl.getBoundingClientRect(), menuBottom = _menuEl$getBoundingCl.bottom, menuHeight = _menuEl$getBoundingCl.height, menuTop = _menuEl$getBoundingCl.top;
    var _menuEl$offsetParent$ = menuEl.offsetParent.getBoundingClientRect(), containerTop = _menuEl$offsetParent$.top;
    var viewHeight = isFixedPosition ? window.innerHeight : $e72d27f6b1599862$var$normalizedHeight(scrollParent);
    var scrollTop = $e72d27f6b1599862$var$getScrollTop(scrollParent);
    var marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
    var marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
    var viewSpaceAbove = containerTop - marginTop;
    var viewSpaceBelow = viewHeight - menuTop;
    var scrollSpaceAbove = viewSpaceAbove + scrollTop;
    var scrollSpaceBelow = scrollHeight - scrollTop - menuTop;
    var scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
    var scrollUp = scrollTop + menuTop - marginTop;
    var scrollDuration = 160;
    switch(preferredPlacement){
        case 'auto':
        case 'bottom':
            // 1: the menu will fit, do nothing
            if (viewSpaceBelow >= menuHeight) return {
                placement: 'bottom',
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
                if (shouldScroll) $e72d27f6b1599862$var$animatedScrollTo(scrollParent, scrollDown, scrollDuration);
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
                if (shouldScroll) $e72d27f6b1599862$var$animatedScrollTo(scrollParent, scrollDown, scrollDuration);
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                var constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
                return {
                    placement: 'bottom',
                    maxHeight: constrainedHeight
                };
            }
            // 4. Forked beviour when there isn't enough space below
            // AUTO: flip the menu, render above
            if (preferredPlacement === 'auto' || isFixedPosition) {
                // may need to be constrained after flipping
                var _constrainedHeight = preferredMaxHeight;
                var spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;
                if (spaceAbove >= minHeight) _constrainedHeight = Math.min(spaceAbove - marginBottom - controlHeight, preferredMaxHeight);
                return {
                    placement: 'top',
                    maxHeight: _constrainedHeight
                };
            }
            // BOTTOM: allow browser to increase scrollable area and immediately set scroll
            if (preferredPlacement === 'bottom') {
                if (shouldScroll) $e72d27f6b1599862$var$scrollTo(scrollParent, scrollDown);
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            }
            break;
        case 'top':
            // 1: the menu will fit, do nothing
            if (viewSpaceAbove >= menuHeight) return {
                placement: 'top',
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
                if (shouldScroll) $e72d27f6b1599862$var$animatedScrollTo(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
                var _constrainedHeight2 = preferredMaxHeight;
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) _constrainedHeight2 = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
                if (shouldScroll) $e72d27f6b1599862$var$animatedScrollTo(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: _constrainedHeight2
                };
            }
            // 4. not enough space, the browser WILL NOT increase scrollable area when
            // absolutely positioned element rendered above the viewport (only below).
            // Flip the menu, render below
            return {
                placement: 'bottom',
                maxHeight: preferredMaxHeight
            };
        default:
            throw new Error("Invalid placement provided \"".concat(preferredPlacement, "\"."));
    }
    return defaultState;
}
// Menu Component
// ------------------------------
function $e72d27f6b1599862$var$alignToControl(placement) {
    var placementToCSSProp = {
        bottom: 'top',
        top: 'bottom'
    };
    return placement ? placementToCSSProp[placement] : 'bottom';
}
var $e72d27f6b1599862$var$coercePlacement = function coercePlacement(p) {
    return p === 'auto' ? 'bottom' : p;
};
var $e72d27f6b1599862$export$953cecd6e717a553 = function menuCSS(_ref2, unstyled) {
    var _objectSpread2;
    var placement = _ref2.placement, _ref2$theme = _ref2.theme, borderRadius = _ref2$theme.borderRadius, spacing = _ref2$theme.spacing, colors = _ref2$theme.colors;
    return (0, $1Xn5q.default)((_objectSpread2 = {
        label: 'menu'
    }, (0, $5zQU9.default)(_objectSpread2, $e72d27f6b1599862$var$alignToControl(placement), '100%'), (0, $5zQU9.default)(_objectSpread2, "position", 'absolute'), (0, $5zQU9.default)(_objectSpread2, "width", '100%'), (0, $5zQU9.default)(_objectSpread2, "zIndex", 1), _objectSpread2), unstyled ? {} : {
        backgroundColor: colors.neutral0,
        borderRadius: borderRadius,
        boxShadow: '0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)',
        marginBottom: spacing.menuGutter,
        marginTop: spacing.menuGutter
    });
};
var $e72d27f6b1599862$var$PortalPlacementContext = /*#__PURE__*/ (0, $eUqFw.createContext)(null);
// NOTE: internal only
var $e72d27f6b1599862$export$3a1a48c8f6ef640e = function MenuPlacer(props) {
    var children = props.children, minMenuHeight = props.minMenuHeight, maxMenuHeight = props.maxMenuHeight, menuPlacement = props.menuPlacement, menuPosition = props.menuPosition, menuShouldScrollIntoView = props.menuShouldScrollIntoView, theme = props.theme;
    var _ref3 = (0, $eUqFw.useContext)($e72d27f6b1599862$var$PortalPlacementContext) || {}, setPortalPlacement = _ref3.setPortalPlacement;
    var ref = (0, $eUqFw.useRef)(null);
    var _useState = (0, $eUqFw.useState)(maxMenuHeight), _useState2 = (0, $aKcqM.default)(_useState, 2), maxHeight = _useState2[0], setMaxHeight = _useState2[1];
    var _useState3 = (0, $eUqFw.useState)(null), _useState4 = (0, $aKcqM.default)(_useState3, 2), placement = _useState4[0], setPlacement = _useState4[1];
    var controlHeight = theme.spacing.controlHeight;
    (0, $k286k.default)(function() {
        var menuEl = ref.current;
        if (!menuEl) return;
        // DO NOT scroll if position is fixed
        var isFixedPosition = menuPosition === 'fixed';
        var shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
        var state = $e72d27f6b1599862$var$getMenuPlacement({
            maxHeight: maxMenuHeight,
            menuEl: menuEl,
            minHeight: minMenuHeight,
            placement: menuPlacement,
            shouldScroll: shouldScroll,
            isFixedPosition: isFixedPosition,
            controlHeight: controlHeight
        });
        setMaxHeight(state.maxHeight);
        setPlacement(state.placement);
        setPortalPlacement === null || setPortalPlacement === void 0 || setPortalPlacement(state.placement);
    }, [
        maxMenuHeight,
        menuPlacement,
        menuPosition,
        menuShouldScrollIntoView,
        minMenuHeight,
        setPortalPlacement,
        controlHeight
    ]);
    return children({
        ref: ref,
        placerProps: (0, $1Xn5q.default)((0, $1Xn5q.default)({}, props), {}, {
            placement: placement || $e72d27f6b1599862$var$coercePlacement(menuPlacement),
            maxHeight: maxHeight
        })
    });
};
var $e72d27f6b1599862$var$Menu = function Menu(props) {
    var children = props.children, innerRef = props.innerRef, innerProps = props.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'menu', {
        menu: true
    }), {
        ref: innerRef
    }, innerProps), children);
};
// ==============================
// Menu List
// ==============================
var $e72d27f6b1599862$export$7ccc53e8f1e7dfc5 = function menuListCSS(_ref4, unstyled) {
    var maxHeight = _ref4.maxHeight, baseUnit = _ref4.theme.spacing.baseUnit;
    return (0, $1Xn5q.default)({
        maxHeight: maxHeight,
        overflowY: 'auto',
        position: 'relative',
        // required for offset[Height, Top] > keyboard scroll
        WebkitOverflowScrolling: 'touch'
    }, unstyled ? {} : {
        paddingBottom: baseUnit,
        paddingTop: baseUnit
    });
};
var $e72d27f6b1599862$var$MenuList = function MenuList(props) {
    var children = props.children, innerProps = props.innerProps, innerRef = props.innerRef, isMulti = props.isMulti;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'menuList', {
        'menu-list': true,
        'menu-list--is-multi': isMulti
    }), {
        ref: innerRef
    }, innerProps), children);
};
// ==============================
// Menu Notices
// ==============================
var $e72d27f6b1599862$var$noticeCSS = function noticeCSS(_ref5, unstyled) {
    var _ref5$theme = _ref5.theme, baseUnit = _ref5$theme.spacing.baseUnit, colors = _ref5$theme.colors;
    return (0, $1Xn5q.default)({
        textAlign: 'center'
    }, unstyled ? {} : {
        color: colors.neutral40,
        padding: "".concat(baseUnit * 2, "px ").concat(baseUnit * 3, "px")
    });
};
var $e72d27f6b1599862$export$3b14a55fb2447963 = $e72d27f6b1599862$var$noticeCSS;
var $e72d27f6b1599862$export$342063e11d6c3cad = $e72d27f6b1599862$var$noticeCSS;
var $e72d27f6b1599862$var$NoOptionsMessage = function NoOptionsMessage(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'noOptionsMessage', {
        'menu-notice': true,
        'menu-notice--no-options': true
    }), innerProps), children);
};
$e72d27f6b1599862$var$NoOptionsMessage.defaultProps = {
    children: 'No options'
};
var $e72d27f6b1599862$var$LoadingMessage = function LoadingMessage(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'loadingMessage', {
        'menu-notice': true,
        'menu-notice--loading': true
    }), innerProps), children);
};
$e72d27f6b1599862$var$LoadingMessage.defaultProps = {
    children: 'Loading...'
};
// ==============================
// Menu Portal
// ==============================
var $e72d27f6b1599862$export$ae1af26003f05816 = function menuPortalCSS(_ref6) {
    var rect = _ref6.rect, offset = _ref6.offset, position = _ref6.position;
    return {
        left: rect.left,
        position: position,
        top: offset,
        width: rect.width,
        zIndex: 1
    };
};
var $e72d27f6b1599862$var$MenuPortal = function MenuPortal(props) {
    var appendTo = props.appendTo, children = props.children, controlElement = props.controlElement, innerProps = props.innerProps, menuPlacement = props.menuPlacement, menuPosition = props.menuPosition;
    var menuPortalRef = (0, $eUqFw.useRef)(null);
    var cleanupRef = (0, $eUqFw.useRef)(null);
    var _useState5 = (0, $eUqFw.useState)($e72d27f6b1599862$var$coercePlacement(menuPlacement)), _useState6 = (0, $aKcqM.default)(_useState5, 2), placement = _useState6[0], setPortalPlacement = _useState6[1];
    var portalPlacementContext = (0, $eUqFw.useMemo)(function() {
        return {
            setPortalPlacement: setPortalPlacement
        };
    }, []);
    var _useState7 = (0, $eUqFw.useState)(null), _useState8 = (0, $aKcqM.default)(_useState7, 2), computedPosition = _useState8[0], setComputedPosition = _useState8[1];
    var updateComputedPosition = (0, $eUqFw.useCallback)(function() {
        if (!controlElement) return;
        var rect = $e72d27f6b1599862$var$getBoundingClientObj(controlElement);
        var scrollDistance = menuPosition === 'fixed' ? 0 : window.pageYOffset;
        var offset = rect[placement] + scrollDistance;
        if (offset !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset) || rect.left !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left) || rect.width !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width)) setComputedPosition({
            offset: offset,
            rect: rect
        });
    }, [
        controlElement,
        menuPosition,
        placement,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width
    ]);
    (0, $k286k.default)(function() {
        updateComputedPosition();
    }, [
        updateComputedPosition
    ]);
    var runAutoUpdate = (0, $eUqFw.useCallback)(function() {
        if (typeof cleanupRef.current === 'function') {
            cleanupRef.current();
            cleanupRef.current = null;
        }
        if (controlElement && menuPortalRef.current) cleanupRef.current = (0, $5O3G9.autoUpdate)(controlElement, menuPortalRef.current, updateComputedPosition, {
            elementResize: 'ResizeObserver' in window
        });
    }, [
        controlElement,
        updateComputedPosition
    ]);
    (0, $k286k.default)(function() {
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    var setMenuPortalElement = (0, $eUqFw.useCallback)(function(menuPortalElement) {
        menuPortalRef.current = menuPortalElement;
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    // bail early if required elements aren't present
    if (!appendTo && menuPosition !== 'fixed' || !computedPosition) return null;
    // same wrapper element whether fixed or portalled
    var menuWrapper = (0, $byn9U.jsx)("div", (0, $kU09D.default)({
        ref: setMenuPortalElement
    }, $e72d27f6b1599862$var$getStyleProps((0, $1Xn5q.default)((0, $1Xn5q.default)({}, props), {}, {
        offset: computedPosition.offset,
        position: menuPosition,
        rect: computedPosition.rect
    }), 'menuPortal', {
        'menu-portal': true
    }), innerProps), children);
    return (0, $byn9U.jsx)($e72d27f6b1599862$var$PortalPlacementContext.Provider, {
        value: portalPlacementContext
    }, appendTo ? /*#__PURE__*/ (0, $lEfVV.createPortal)(menuWrapper, appendTo) : menuWrapper);
};
// ==============================
// Root Container
// ==============================
var $e72d27f6b1599862$export$8b22cf2602fb60ce = function containerCSS(_ref) {
    var isDisabled = _ref.isDisabled, isRtl = _ref.isRtl;
    return {
        label: 'container',
        direction: isRtl ? 'rtl' : undefined,
        pointerEvents: isDisabled ? 'none' : undefined,
        // cancel mouse events when disabled
        position: 'relative'
    };
};
var $e72d27f6b1599862$var$SelectContainer = function SelectContainer(props) {
    var children = props.children, innerProps = props.innerProps, isDisabled = props.isDisabled, isRtl = props.isRtl;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'container', {
        '--is-disabled': isDisabled,
        '--is-rtl': isRtl
    }), innerProps), children);
};
// ==============================
// Value Container
// ==============================
var $e72d27f6b1599862$export$4a5767248b18ef41 = function valueContainerCSS(_ref2, unstyled) {
    var spacing = _ref2.theme.spacing, isMulti = _ref2.isMulti, hasValue = _ref2.hasValue, controlShouldRenderValue = _ref2.selectProps.controlShouldRenderValue;
    return (0, $1Xn5q.default)({
        alignItems: 'center',
        display: isMulti && hasValue && controlShouldRenderValue ? 'flex' : 'grid',
        flex: 1,
        flexWrap: 'wrap',
        WebkitOverflowScrolling: 'touch',
        position: 'relative',
        overflow: 'hidden'
    }, unstyled ? {} : {
        padding: "".concat(spacing.baseUnit / 2, "px ").concat(spacing.baseUnit * 2, "px")
    });
};
var $e72d27f6b1599862$var$ValueContainer = function ValueContainer(props) {
    var children = props.children, innerProps = props.innerProps, isMulti = props.isMulti, hasValue = props.hasValue;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'valueContainer', {
        'value-container': true,
        'value-container--is-multi': isMulti,
        'value-container--has-value': hasValue
    }), innerProps), children);
};
// ==============================
// Indicator Container
// ==============================
var $e72d27f6b1599862$export$23f2a1d2818174ef = function indicatorsContainerCSS() {
    return {
        alignItems: 'center',
        alignSelf: 'stretch',
        display: 'flex',
        flexShrink: 0
    };
};
var $e72d27f6b1599862$var$IndicatorsContainer = function IndicatorsContainer(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'indicatorsContainer', {
        indicators: true
    }), innerProps), children);
};
var $e72d27f6b1599862$var$_templateObject;
var $e72d27f6b1599862$var$_excluded$2 = [
    "size"
];
function $e72d27f6b1599862$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// ==============================
// Dropdown & Clear Icons
// ==============================
var $e72d27f6b1599862$var$_ref2 = {
    name: "8mmkcg",
    styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0"
};
var $e72d27f6b1599862$var$Svg = function Svg(_ref) {
    var size = _ref.size, props = (0, $bwPfh.default)(_ref, $e72d27f6b1599862$var$_excluded$2);
    return (0, $byn9U.jsx)("svg", (0, $kU09D.default)({
        height: size,
        width: size,
        viewBox: "0 0 20 20",
        "aria-hidden": "true",
        focusable: "false",
        css: $e72d27f6b1599862$var$_ref2
    }, props));
};
var $e72d27f6b1599862$var$CrossIcon = function CrossIcon(props) {
    return (0, $byn9U.jsx)($e72d27f6b1599862$var$Svg, (0, $kU09D.default)({
        size: 20
    }, props), (0, $byn9U.jsx)("path", {
        d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
    }));
};
var $e72d27f6b1599862$var$DownChevron = function DownChevron(props) {
    return (0, $byn9U.jsx)($e72d27f6b1599862$var$Svg, (0, $kU09D.default)({
        size: 20
    }, props), (0, $byn9U.jsx)("path", {
        d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
    }));
};
// ==============================
// Dropdown & Clear Buttons
// ==============================
var $e72d27f6b1599862$var$baseCSS = function baseCSS(_ref3, unstyled) {
    var isFocused = _ref3.isFocused, _ref3$theme = _ref3.theme, baseUnit = _ref3$theme.spacing.baseUnit, colors = _ref3$theme.colors;
    return (0, $1Xn5q.default)({
        label: 'indicatorContainer',
        display: 'flex',
        transition: 'color 150ms'
    }, unstyled ? {} : {
        color: isFocused ? colors.neutral60 : colors.neutral20,
        padding: baseUnit * 2,
        ':hover': {
            color: isFocused ? colors.neutral80 : colors.neutral40
        }
    });
};
var $e72d27f6b1599862$export$f1e1789686576879 = $e72d27f6b1599862$var$baseCSS;
var $e72d27f6b1599862$var$DropdownIndicator = function DropdownIndicator(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'dropdownIndicator', {
        indicator: true,
        'dropdown-indicator': true
    }), innerProps), children || (0, $byn9U.jsx)($e72d27f6b1599862$var$DownChevron, null));
};
var $e72d27f6b1599862$export$407448d2b89b1813 = $e72d27f6b1599862$var$baseCSS;
var $e72d27f6b1599862$var$ClearIndicator = function ClearIndicator(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'clearIndicator', {
        indicator: true,
        'clear-indicator': true
    }), innerProps), children || (0, $byn9U.jsx)($e72d27f6b1599862$var$CrossIcon, null));
};
// ==============================
// Separator
// ==============================
var $e72d27f6b1599862$export$dda1d9f60106f0e9 = function indicatorSeparatorCSS(_ref4, unstyled) {
    var isDisabled = _ref4.isDisabled, _ref4$theme = _ref4.theme, baseUnit = _ref4$theme.spacing.baseUnit, colors = _ref4$theme.colors;
    return (0, $1Xn5q.default)({
        label: 'indicatorSeparator',
        alignSelf: 'stretch',
        width: 1
    }, unstyled ? {} : {
        backgroundColor: isDisabled ? colors.neutral10 : colors.neutral20,
        marginBottom: baseUnit * 2,
        marginTop: baseUnit * 2
    });
};
var $e72d27f6b1599862$var$IndicatorSeparator = function IndicatorSeparator(props) {
    var innerProps = props.innerProps;
    return (0, $byn9U.jsx)("span", (0, $kU09D.default)({}, innerProps, $e72d27f6b1599862$var$getStyleProps(props, 'indicatorSeparator', {
        'indicator-separator': true
    })));
};
// ==============================
// Loading
// ==============================
var $e72d27f6b1599862$var$loadingDotAnimations = (0, $byn9U.keyframes)($e72d27f6b1599862$var$_templateObject || ($e72d27f6b1599862$var$_templateObject = (0, $jqNEH.default)([
    "\n  0%, 80%, 100% { opacity: 0; }\n  40% { opacity: 1; }\n"
])));
var $e72d27f6b1599862$export$882b5998b3b9117c = function loadingIndicatorCSS(_ref5, unstyled) {
    var isFocused = _ref5.isFocused, size = _ref5.size, _ref5$theme = _ref5.theme, colors = _ref5$theme.colors, baseUnit = _ref5$theme.spacing.baseUnit;
    return (0, $1Xn5q.default)({
        label: 'loadingIndicator',
        display: 'flex',
        transition: 'color 150ms',
        alignSelf: 'center',
        fontSize: size,
        lineHeight: 1,
        marginRight: size,
        textAlign: 'center',
        verticalAlign: 'middle'
    }, unstyled ? {} : {
        color: isFocused ? colors.neutral60 : colors.neutral20,
        padding: baseUnit * 2
    });
};
var $e72d27f6b1599862$var$LoadingDot = function LoadingDot(_ref6) {
    var delay = _ref6.delay, offset = _ref6.offset;
    return (0, $byn9U.jsx)("span", {
        css: /*#__PURE__*/ (0, $byn9U.css)({
            animation: "".concat($e72d27f6b1599862$var$loadingDotAnimations, " 1s ease-in-out ").concat(delay, "ms infinite;"),
            backgroundColor: 'currentColor',
            borderRadius: '1em',
            display: 'inline-block',
            marginLeft: offset ? '1em' : undefined,
            height: '1em',
            verticalAlign: 'top',
            width: '1em'
        }, "", "")
    });
};
var $e72d27f6b1599862$var$LoadingIndicator = function LoadingIndicator(props) {
    var innerProps = props.innerProps, isRtl = props.isRtl;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'loadingIndicator', {
        indicator: true,
        'loading-indicator': true
    }), innerProps), (0, $byn9U.jsx)($e72d27f6b1599862$var$LoadingDot, {
        delay: 0,
        offset: isRtl
    }), (0, $byn9U.jsx)($e72d27f6b1599862$var$LoadingDot, {
        delay: 160,
        offset: true
    }), (0, $byn9U.jsx)($e72d27f6b1599862$var$LoadingDot, {
        delay: 320,
        offset: !isRtl
    }));
};
$e72d27f6b1599862$var$LoadingIndicator.defaultProps = {
    size: 4
};
var $e72d27f6b1599862$export$4368d992c4eafac0 = function css(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, isFocused = _ref.isFocused, _ref$theme = _ref.theme, colors = _ref$theme.colors, borderRadius = _ref$theme.borderRadius, spacing = _ref$theme.spacing;
    return (0, $1Xn5q.default)({
        label: 'control',
        alignItems: 'center',
        cursor: 'default',
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
        minHeight: spacing.controlHeight,
        outline: '0 !important',
        position: 'relative',
        transition: 'all 100ms'
    }, unstyled ? {} : {
        backgroundColor: isDisabled ? colors.neutral5 : colors.neutral0,
        borderColor: isDisabled ? colors.neutral10 : isFocused ? colors.primary : colors.neutral20,
        borderRadius: borderRadius,
        borderStyle: 'solid',
        borderWidth: 1,
        boxShadow: isFocused ? "0 0 0 1px ".concat(colors.primary) : undefined,
        '&:hover': {
            borderColor: isFocused ? colors.primary : colors.neutral30
        }
    });
};
var $e72d27f6b1599862$var$Control = function Control(props) {
    var children = props.children, isDisabled = props.isDisabled, isFocused = props.isFocused, innerRef = props.innerRef, innerProps = props.innerProps, menuIsOpen = props.menuIsOpen;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({
        ref: innerRef
    }, $e72d27f6b1599862$var$getStyleProps(props, 'control', {
        control: true,
        'control--is-disabled': isDisabled,
        'control--is-focused': isFocused,
        'control--menu-is-open': menuIsOpen
    }), innerProps), children);
};
var $e72d27f6b1599862$var$_excluded$1 = [
    "data"
];
var $e72d27f6b1599862$export$39b482c5e57630a8 = function groupCSS(_ref, unstyled) {
    var spacing = _ref.theme.spacing;
    return unstyled ? {} : {
        paddingBottom: spacing.baseUnit * 2,
        paddingTop: spacing.baseUnit * 2
    };
};
var $e72d27f6b1599862$var$Group = function Group(props) {
    var children = props.children, cx = props.cx, getStyles = props.getStyles, getClassNames = props.getClassNames, Heading = props.Heading, headingProps = props.headingProps, innerProps = props.innerProps, label = props.label, theme = props.theme, selectProps = props.selectProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'group', {
        group: true
    }), innerProps), (0, $byn9U.jsx)(Heading, (0, $kU09D.default)({}, headingProps, {
        selectProps: selectProps,
        theme: theme,
        getStyles: getStyles,
        getClassNames: getClassNames,
        cx: cx
    }), label), (0, $byn9U.jsx)("div", null, children));
};
var $e72d27f6b1599862$export$2d1720544b23b823 = function groupHeadingCSS(_ref2, unstyled) {
    var _ref2$theme = _ref2.theme, colors = _ref2$theme.colors, spacing = _ref2$theme.spacing;
    return (0, $1Xn5q.default)({
        label: 'group',
        cursor: 'default',
        display: 'block'
    }, unstyled ? {} : {
        color: colors.neutral40,
        fontSize: '75%',
        fontWeight: 500,
        marginBottom: '0.25em',
        paddingLeft: spacing.baseUnit * 3,
        paddingRight: spacing.baseUnit * 3,
        textTransform: 'uppercase'
    });
};
var $e72d27f6b1599862$var$GroupHeading = function GroupHeading(props) {
    var _cleanCommonProps = $e72d27f6b1599862$var$cleanCommonProps(props);
    _cleanCommonProps.data;
    var innerProps = (0, $bwPfh.default)(_cleanCommonProps, $e72d27f6b1599862$var$_excluded$1);
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'groupHeading', {
        'group-heading': true
    }), innerProps));
};
var $e72d27f6b1599862$var$_excluded = [
    "innerRef",
    "isDisabled",
    "isHidden",
    "inputClassName"
];
var $e72d27f6b1599862$export$35e795649ee09318 = function inputCSS(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, value = _ref.value, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $1Xn5q.default)((0, $1Xn5q.default)({
        visibility: isDisabled ? 'hidden' : 'visible',
        // force css to recompute when value change due to @emotion bug.
        // We can remove it whenever the bug is fixed.
        transform: value ? 'translateZ(0)' : ''
    }, $e72d27f6b1599862$var$containerStyle), unstyled ? {} : {
        margin: spacing.baseUnit / 2,
        paddingBottom: spacing.baseUnit / 2,
        paddingTop: spacing.baseUnit / 2,
        color: colors.neutral80
    });
};
var $e72d27f6b1599862$var$spacingStyle = {
    gridArea: '1 / 2',
    font: 'inherit',
    minWidth: '2px',
    border: 0,
    margin: 0,
    outline: 0,
    padding: 0
};
var $e72d27f6b1599862$var$containerStyle = {
    flex: '1 1 auto',
    display: 'inline-grid',
    gridArea: '1 / 1 / 2 / 3',
    gridTemplateColumns: '0 min-content',
    '&:after': (0, $1Xn5q.default)({
        content: 'attr(data-value) " "',
        visibility: 'hidden',
        whiteSpace: 'pre'
    }, $e72d27f6b1599862$var$spacingStyle)
};
var $e72d27f6b1599862$var$inputStyle = function inputStyle(isHidden) {
    return (0, $1Xn5q.default)({
        label: 'input',
        color: 'inherit',
        background: 0,
        opacity: isHidden ? 0 : 1,
        width: '100%'
    }, $e72d27f6b1599862$var$spacingStyle);
};
var $e72d27f6b1599862$var$Input = function Input(props) {
    var cx = props.cx, value = props.value;
    var _cleanCommonProps = $e72d27f6b1599862$var$cleanCommonProps(props), innerRef = _cleanCommonProps.innerRef, isDisabled = _cleanCommonProps.isDisabled, isHidden = _cleanCommonProps.isHidden, inputClassName = _cleanCommonProps.inputClassName, innerProps = (0, $bwPfh.default)(_cleanCommonProps, $e72d27f6b1599862$var$_excluded);
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'input', {
        'input-container': true
    }), {
        "data-value": value || ''
    }), (0, $byn9U.jsx)("input", (0, $kU09D.default)({
        className: cx({
            input: true
        }, inputClassName),
        ref: innerRef,
        style: $e72d27f6b1599862$var$inputStyle(isHidden),
        disabled: isDisabled
    }, innerProps)));
};
var $e72d27f6b1599862$export$ffb5f4729a158638 = function multiValueCSS(_ref, unstyled) {
    var _ref$theme = _ref.theme, spacing = _ref$theme.spacing, borderRadius = _ref$theme.borderRadius, colors = _ref$theme.colors;
    return (0, $1Xn5q.default)({
        label: 'multiValue',
        display: 'flex',
        minWidth: 0
    }, unstyled ? {} : {
        backgroundColor: colors.neutral10,
        borderRadius: borderRadius / 2,
        margin: spacing.baseUnit / 2
    });
};
var $e72d27f6b1599862$export$9e5f44173e64f162 = function multiValueLabelCSS(_ref2, unstyled) {
    var _ref2$theme = _ref2.theme, borderRadius = _ref2$theme.borderRadius, colors = _ref2$theme.colors, cropWithEllipsis = _ref2.cropWithEllipsis;
    return (0, $1Xn5q.default)({
        overflow: 'hidden',
        textOverflow: cropWithEllipsis || cropWithEllipsis === undefined ? 'ellipsis' : undefined,
        whiteSpace: 'nowrap'
    }, unstyled ? {} : {
        borderRadius: borderRadius / 2,
        color: colors.neutral80,
        fontSize: '85%',
        padding: 3,
        paddingLeft: 6
    });
};
var $e72d27f6b1599862$export$625550452a3fa3ec = function multiValueRemoveCSS(_ref3, unstyled) {
    var _ref3$theme = _ref3.theme, spacing = _ref3$theme.spacing, borderRadius = _ref3$theme.borderRadius, colors = _ref3$theme.colors, isFocused = _ref3.isFocused;
    return (0, $1Xn5q.default)({
        alignItems: 'center',
        display: 'flex'
    }, unstyled ? {} : {
        borderRadius: borderRadius / 2,
        backgroundColor: isFocused ? colors.dangerLight : undefined,
        paddingLeft: spacing.baseUnit,
        paddingRight: spacing.baseUnit,
        ':hover': {
            backgroundColor: colors.dangerLight,
            color: colors.danger
        }
    });
};
var $e72d27f6b1599862$var$MultiValueGeneric = function MultiValueGeneric(_ref4) {
    var children = _ref4.children, innerProps = _ref4.innerProps;
    return (0, $byn9U.jsx)("div", innerProps, children);
};
var $e72d27f6b1599862$var$MultiValueContainer = $e72d27f6b1599862$var$MultiValueGeneric;
var $e72d27f6b1599862$var$MultiValueLabel = $e72d27f6b1599862$var$MultiValueGeneric;
function $e72d27f6b1599862$var$MultiValueRemove(_ref5) {
    var children = _ref5.children, innerProps = _ref5.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({
        role: "button"
    }, innerProps), children || (0, $byn9U.jsx)($e72d27f6b1599862$var$CrossIcon, {
        size: 14
    }));
}
var $e72d27f6b1599862$var$MultiValue = function MultiValue(props) {
    var children = props.children, components = props.components, data = props.data, innerProps = props.innerProps, isDisabled = props.isDisabled, removeProps = props.removeProps, selectProps = props.selectProps;
    var Container = components.Container, Label = components.Label, Remove = components.Remove;
    return (0, $byn9U.jsx)(Container, {
        data: data,
        innerProps: (0, $1Xn5q.default)((0, $1Xn5q.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'multiValue', {
            'multi-value': true,
            'multi-value--is-disabled': isDisabled
        })), innerProps),
        selectProps: selectProps
    }, (0, $byn9U.jsx)(Label, {
        data: data,
        innerProps: (0, $1Xn5q.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'multiValueLabel', {
            'multi-value__label': true
        })),
        selectProps: selectProps
    }, children), (0, $byn9U.jsx)(Remove, {
        data: data,
        innerProps: (0, $1Xn5q.default)((0, $1Xn5q.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'multiValueRemove', {
            'multi-value__remove': true
        })), {}, {
            'aria-label': "Remove ".concat(children || 'option')
        }, removeProps),
        selectProps: selectProps
    }));
};
var $e72d27f6b1599862$export$90a7f3efeed30595 = function optionCSS(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, isFocused = _ref.isFocused, isSelected = _ref.isSelected, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $1Xn5q.default)({
        label: 'option',
        cursor: 'default',
        display: 'block',
        fontSize: 'inherit',
        width: '100%',
        userSelect: 'none',
        WebkitTapHighlightColor: 'rgba(0, 0, 0, 0)'
    }, unstyled ? {} : {
        backgroundColor: isSelected ? colors.primary : isFocused ? colors.primary25 : 'transparent',
        color: isDisabled ? colors.neutral20 : isSelected ? colors.neutral0 : 'inherit',
        padding: "".concat(spacing.baseUnit * 2, "px ").concat(spacing.baseUnit * 3, "px"),
        // provide some affordance on touch devices
        ':active': {
            backgroundColor: !isDisabled ? isSelected ? colors.primary : colors.primary50 : undefined
        }
    });
};
var $e72d27f6b1599862$var$Option = function Option(props) {
    var children = props.children, isDisabled = props.isDisabled, isFocused = props.isFocused, isSelected = props.isSelected, innerRef = props.innerRef, innerProps = props.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'option', {
        option: true,
        'option--is-disabled': isDisabled,
        'option--is-focused': isFocused,
        'option--is-selected': isSelected
    }), {
        ref: innerRef,
        "aria-disabled": isDisabled
    }, innerProps), children);
};
var $e72d27f6b1599862$export$efccba1c4a2ef57b = function placeholderCSS(_ref, unstyled) {
    var _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $1Xn5q.default)({
        label: 'placeholder',
        gridArea: '1 / 1 / 2 / 3'
    }, unstyled ? {} : {
        color: colors.neutral50,
        marginLeft: spacing.baseUnit / 2,
        marginRight: spacing.baseUnit / 2
    });
};
var $e72d27f6b1599862$var$Placeholder = function Placeholder(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'placeholder', {
        placeholder: true
    }), innerProps), children);
};
var $e72d27f6b1599862$export$d141bba7fdc215a3 = function css(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $1Xn5q.default)({
        label: 'singleValue',
        gridArea: '1 / 1 / 2 / 3',
        maxWidth: '100%',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    }, unstyled ? {} : {
        color: isDisabled ? colors.neutral40 : colors.neutral80,
        marginLeft: spacing.baseUnit / 2,
        marginRight: spacing.baseUnit / 2
    });
};
var $e72d27f6b1599862$var$SingleValue = function SingleValue(props) {
    var children = props.children, isDisabled = props.isDisabled, innerProps = props.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'singleValue', {
        'single-value': true,
        'single-value--is-disabled': isDisabled
    }), innerProps), children);
};
var $e72d27f6b1599862$export$db3b6bfb95261072 = {
    ClearIndicator: $e72d27f6b1599862$var$ClearIndicator,
    Control: $e72d27f6b1599862$var$Control,
    DropdownIndicator: $e72d27f6b1599862$var$DropdownIndicator,
    DownChevron: $e72d27f6b1599862$var$DownChevron,
    CrossIcon: $e72d27f6b1599862$var$CrossIcon,
    Group: $e72d27f6b1599862$var$Group,
    GroupHeading: $e72d27f6b1599862$var$GroupHeading,
    IndicatorsContainer: $e72d27f6b1599862$var$IndicatorsContainer,
    IndicatorSeparator: $e72d27f6b1599862$var$IndicatorSeparator,
    Input: $e72d27f6b1599862$var$Input,
    LoadingIndicator: $e72d27f6b1599862$var$LoadingIndicator,
    Menu: $e72d27f6b1599862$var$Menu,
    MenuList: $e72d27f6b1599862$var$MenuList,
    MenuPortal: $e72d27f6b1599862$var$MenuPortal,
    LoadingMessage: $e72d27f6b1599862$var$LoadingMessage,
    NoOptionsMessage: $e72d27f6b1599862$var$NoOptionsMessage,
    MultiValue: $e72d27f6b1599862$var$MultiValue,
    MultiValueContainer: $e72d27f6b1599862$var$MultiValueContainer,
    MultiValueLabel: $e72d27f6b1599862$var$MultiValueLabel,
    MultiValueRemove: $e72d27f6b1599862$var$MultiValueRemove,
    Option: $e72d27f6b1599862$var$Option,
    Placeholder: $e72d27f6b1599862$var$Placeholder,
    SelectContainer: $e72d27f6b1599862$var$SelectContainer,
    SingleValue: $e72d27f6b1599862$var$SingleValue,
    ValueContainer: $e72d27f6b1599862$var$ValueContainer
};
var $e72d27f6b1599862$export$d66501df72047452 = function defaultComponents(props) {
    return (0, $1Xn5q.default)((0, $1Xn5q.default)({}, $e72d27f6b1599862$export$db3b6bfb95261072), props.components);
};

});
parcelRegister("1Xn5q", function(module, exports) {

$parcel$export(module.exports, "default", () => $16cd35a30248fb20$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");
function $16cd35a30248fb20$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $16cd35a30248fb20$export$2e2bcd8739ae039(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $16cd35a30248fb20$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $16cd35a30248fb20$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}

});

parcelRegister("aKcqM", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d27d7cb7c770f64$export$2e2bcd8739ae039);

var $kcDiK = parcelRequire("kcDiK");

var $61Jn4 = parcelRequire("61Jn4");

var $e5SQy = parcelRequire("e5SQy");

var $gP5fl = parcelRequire("gP5fl");
function $7d27d7cb7c770f64$export$2e2bcd8739ae039(arr, i) {
    return (0, $kcDiK.default)(arr) || (0, $61Jn4.default)(arr, i) || (0, $e5SQy.default)(arr, i) || (0, $gP5fl.default)();
}

});
parcelRegister("kcDiK", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb536a1805ce1726$export$2e2bcd8739ae039);
function $eb536a1805ce1726$export$2e2bcd8739ae039(arr) {
    if (Array.isArray(arr)) return arr;
}

});

parcelRegister("61Jn4", function(module, exports) {

$parcel$export(module.exports, "default", () => $463607d84fb47652$export$2e2bcd8739ae039);
function $463607d84fb47652$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}

});

parcelRegister("e5SQy", function(module, exports) {

$parcel$export(module.exports, "default", () => $a42c13bbb83e195c$export$2e2bcd8739ae039);

var $aLrjs = parcelRequire("aLrjs");
function $a42c13bbb83e195c$export$2e2bcd8739ae039(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $aLrjs.default)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $aLrjs.default)(o, minLen);
}

});
parcelRegister("aLrjs", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d637af256120630$export$2e2bcd8739ae039);
function $7d637af256120630$export$2e2bcd8739ae039(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}

});


parcelRegister("gP5fl", function(module, exports) {

$parcel$export(module.exports, "default", () => $c3f57a97be8f63bf$export$2e2bcd8739ae039);
function $c3f57a97be8f63bf$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("bwPfh", function(module, exports) {

$parcel$export(module.exports, "default", () => $864a6f28f9285041$export$2e2bcd8739ae039);

var $6XgOP = parcelRequire("6XgOP");
function $864a6f28f9285041$export$2e2bcd8739ae039(source, excluded) {
    if (source == null) return {};
    var target = (0, $6XgOP.default)(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}

});

parcelRegister("jqNEH", function(module, exports) {

$parcel$export(module.exports, "default", () => $e256f68f3295e6bf$export$2e2bcd8739ae039);
function $e256f68f3295e6bf$export$2e2bcd8739ae039(strings, raw) {
    if (!raw) raw = strings.slice(0);
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}

});

parcelRegister("5O3G9", function(module, exports) {

$parcel$export(module.exports, "autoUpdate", () => $023d07731ce8610f$export$deee3a793edee05f);

var $7MIdi = parcelRequire("7MIdi");
function $023d07731ce8610f$var$n(t) {
    var e;
    return (null == (e = t.ownerDocument) ? void 0 : e.defaultView) || window;
}
function $023d07731ce8610f$var$o(t) {
    return $023d07731ce8610f$var$n(t).getComputedStyle(t);
}
function $023d07731ce8610f$var$i(t) {
    return t instanceof $023d07731ce8610f$var$n(t).Node;
}
function $023d07731ce8610f$var$r(t) {
    return $023d07731ce8610f$var$i(t) ? (t.nodeName || "").toLowerCase() : "";
}
let $023d07731ce8610f$var$l;
function $023d07731ce8610f$var$c() {
    if ($023d07731ce8610f$var$l) return $023d07731ce8610f$var$l;
    const t = navigator.userAgentData;
    return t && Array.isArray(t.brands) ? ($023d07731ce8610f$var$l = t.brands.map((t)=>t.brand + "/" + t.version).join(" "), $023d07731ce8610f$var$l) : navigator.userAgent;
}
function $023d07731ce8610f$var$s(t) {
    return t instanceof $023d07731ce8610f$var$n(t).HTMLElement;
}
function $023d07731ce8610f$var$f(t) {
    return t instanceof $023d07731ce8610f$var$n(t).Element;
}
function $023d07731ce8610f$var$u(t) {
    if ("undefined" == typeof ShadowRoot) return !1;
    return t instanceof $023d07731ce8610f$var$n(t).ShadowRoot || t instanceof ShadowRoot;
}
function $023d07731ce8610f$var$a(t) {
    const { overflow: e, overflowX: n, overflowY: i, display: r } = $023d07731ce8610f$var$o(t);
    return /auto|scroll|overlay|hidden|clip/.test(e + i + n) && ![
        "inline",
        "contents"
    ].includes(r);
}
function $023d07731ce8610f$var$d(t) {
    return [
        "table",
        "td",
        "th"
    ].includes($023d07731ce8610f$var$r(t));
}
function $023d07731ce8610f$var$h(t) {
    const e = /firefox/i.test($023d07731ce8610f$var$c()), n = $023d07731ce8610f$var$o(t), i = n.backdropFilter || n.WebkitBackdropFilter;
    return "none" !== n.transform || "none" !== n.perspective || !!i && "none" !== i || e && "filter" === n.willChange || e && !!n.filter && "none" !== n.filter || [
        "transform",
        "perspective"
    ].some((t)=>n.willChange.includes(t)) || [
        "paint",
        "layout",
        "strict",
        "content"
    ].some((t)=>{
        const e = n.contain;
        return null != e && e.includes(t);
    });
}
function $023d07731ce8610f$var$p() {
    return /^((?!chrome|android).)*safari/i.test($023d07731ce8610f$var$c());
}
function $023d07731ce8610f$var$g(t) {
    return [
        "html",
        "body",
        "#document"
    ].includes($023d07731ce8610f$var$r(t));
}
const $023d07731ce8610f$var$m = Math.min, $023d07731ce8610f$var$y = Math.max, $023d07731ce8610f$var$x = Math.round;
function $023d07731ce8610f$var$w(t) {
    const e = $023d07731ce8610f$var$o(t);
    let n = parseFloat(e.width), i = parseFloat(e.height);
    const r = $023d07731ce8610f$var$s(t), l = r ? t.offsetWidth : n, c = r ? t.offsetHeight : i, f = $023d07731ce8610f$var$x(n) !== l || $023d07731ce8610f$var$x(i) !== c;
    return f && (n = l, i = c), {
        width: n,
        height: i,
        fallback: f
    };
}
function $023d07731ce8610f$var$v(t) {
    return $023d07731ce8610f$var$f(t) ? t : t.contextElement;
}
const $023d07731ce8610f$var$b = {
    x: 1,
    y: 1
};
function $023d07731ce8610f$var$L(t) {
    const e = $023d07731ce8610f$var$v(t);
    if (!$023d07731ce8610f$var$s(e)) return $023d07731ce8610f$var$b;
    const n = e.getBoundingClientRect(), { width: o, height: i, fallback: r } = $023d07731ce8610f$var$w(e);
    let l = (r ? $023d07731ce8610f$var$x(n.width) : n.width) / o, c = (r ? $023d07731ce8610f$var$x(n.height) : n.height) / i;
    return l && Number.isFinite(l) || (l = 1), c && Number.isFinite(c) || (c = 1), {
        x: l,
        y: c
    };
}
function $023d07731ce8610f$var$E(e, o, i, r) {
    var l, c;
    void 0 === o && (o = !1), void 0 === i && (i = !1);
    const s = e.getBoundingClientRect(), u = $023d07731ce8610f$var$v(e);
    let a = $023d07731ce8610f$var$b;
    o && (r ? $023d07731ce8610f$var$f(r) && (a = $023d07731ce8610f$var$L(r)) : a = $023d07731ce8610f$var$L(e));
    const d = u ? $023d07731ce8610f$var$n(u) : window, h = $023d07731ce8610f$var$p() && i;
    let g = (s.left + (h && (null == (l = d.visualViewport) ? void 0 : l.offsetLeft) || 0)) / a.x, m = (s.top + (h && (null == (c = d.visualViewport) ? void 0 : c.offsetTop) || 0)) / a.y, y = s.width / a.x, x = s.height / a.y;
    if (u) {
        const t = $023d07731ce8610f$var$n(u), e = r && $023d07731ce8610f$var$f(r) ? $023d07731ce8610f$var$n(r) : r;
        let o = t.frameElement;
        for(; o && r && e !== t;){
            const t = $023d07731ce8610f$var$L(o), e = o.getBoundingClientRect(), i = getComputedStyle(o);
            e.x += (o.clientLeft + parseFloat(i.paddingLeft)) * t.x, e.y += (o.clientTop + parseFloat(i.paddingTop)) * t.y, g *= t.x, m *= t.y, y *= t.x, x *= t.y, g += e.x, m += e.y, o = $023d07731ce8610f$var$n(o).frameElement;
        }
    }
    return (0, $7MIdi.rectToClientRect)({
        width: y,
        height: x,
        x: g,
        y: m
    });
}
function $023d07731ce8610f$var$T(t) {
    return (($023d07731ce8610f$var$i(t) ? t.ownerDocument : t.document) || window.document).documentElement;
}
function $023d07731ce8610f$var$R(t) {
    return $023d07731ce8610f$var$f(t) ? {
        scrollLeft: t.scrollLeft,
        scrollTop: t.scrollTop
    } : {
        scrollLeft: t.pageXOffset,
        scrollTop: t.pageYOffset
    };
}
function $023d07731ce8610f$var$C(t) {
    return $023d07731ce8610f$var$E($023d07731ce8610f$var$T(t)).left + $023d07731ce8610f$var$R(t).scrollLeft;
}
function $023d07731ce8610f$var$F(t) {
    if ("html" === $023d07731ce8610f$var$r(t)) return t;
    const e = t.assignedSlot || t.parentNode || $023d07731ce8610f$var$u(t) && t.host || $023d07731ce8610f$var$T(t);
    return $023d07731ce8610f$var$u(e) ? e.host : e;
}
function $023d07731ce8610f$var$W(t) {
    const e = $023d07731ce8610f$var$F(t);
    return $023d07731ce8610f$var$g(e) ? e.ownerDocument.body : $023d07731ce8610f$var$s(e) && $023d07731ce8610f$var$a(e) ? e : $023d07731ce8610f$var$W(e);
}
function $023d07731ce8610f$export$3b57c1601291186b(t, e) {
    var o;
    void 0 === e && (e = []);
    const i = $023d07731ce8610f$var$W(t), r = i === (null == (o = t.ownerDocument) ? void 0 : o.body), l = $023d07731ce8610f$var$n(i);
    return r ? e.concat(l, l.visualViewport || [], $023d07731ce8610f$var$a(i) ? i : []) : e.concat(i, $023d07731ce8610f$export$3b57c1601291186b(i));
}
function $023d07731ce8610f$var$S(e, i, r) {
    let l;
    if ("viewport" === i) l = function(t, e) {
        const o = $023d07731ce8610f$var$n(t), i = $023d07731ce8610f$var$T(t), r = o.visualViewport;
        let l = i.clientWidth, c = i.clientHeight, s = 0, f = 0;
        if (r) {
            l = r.width, c = r.height;
            const t = $023d07731ce8610f$var$p();
            (!t || t && "fixed" === e) && (s = r.offsetLeft, f = r.offsetTop);
        }
        return {
            width: l,
            height: c,
            x: s,
            y: f
        };
    }(e, r);
    else if ("document" === i) l = function(t) {
        const e = $023d07731ce8610f$var$T(t), n = $023d07731ce8610f$var$R(t), i = t.ownerDocument.body, r = $023d07731ce8610f$var$y(e.scrollWidth, e.clientWidth, i.scrollWidth, i.clientWidth), l = $023d07731ce8610f$var$y(e.scrollHeight, e.clientHeight, i.scrollHeight, i.clientHeight);
        let c = -n.scrollLeft + $023d07731ce8610f$var$C(t);
        const s = -n.scrollTop;
        return "rtl" === $023d07731ce8610f$var$o(i).direction && (c += $023d07731ce8610f$var$y(e.clientWidth, i.clientWidth) - r), {
            width: r,
            height: l,
            x: c,
            y: s
        };
    }($023d07731ce8610f$var$T(e));
    else if ($023d07731ce8610f$var$f(i)) l = function(t, e) {
        const n = $023d07731ce8610f$var$E(t, !0, "fixed" === e), o = n.top + t.clientTop, i = n.left + t.clientLeft, r = $023d07731ce8610f$var$s(t) ? $023d07731ce8610f$var$L(t) : {
            x: 1,
            y: 1
        };
        return {
            width: t.clientWidth * r.x,
            height: t.clientHeight * r.y,
            x: i * r.x,
            y: o * r.y
        };
    }(i, r);
    else {
        const t = {
            ...i
        };
        if ($023d07731ce8610f$var$p()) {
            var c, u;
            const o = $023d07731ce8610f$var$n(e);
            t.x -= (null == (c = o.visualViewport) ? void 0 : c.offsetLeft) || 0, t.y -= (null == (u = o.visualViewport) ? void 0 : u.offsetTop) || 0;
        }
        l = t;
    }
    return (0, $7MIdi.rectToClientRect)(l);
}
function $023d07731ce8610f$var$A(t, e) {
    return $023d07731ce8610f$var$s(t) && "fixed" !== $023d07731ce8610f$var$o(t).position ? e ? e(t) : t.offsetParent : null;
}
function $023d07731ce8610f$var$H(t, e) {
    const i = $023d07731ce8610f$var$n(t);
    if (!$023d07731ce8610f$var$s(t)) return i;
    let l = $023d07731ce8610f$var$A(t, e);
    for(; l && $023d07731ce8610f$var$d(l) && "static" === $023d07731ce8610f$var$o(l).position;)l = $023d07731ce8610f$var$A(l, e);
    return l && ("html" === $023d07731ce8610f$var$r(l) || "body" === $023d07731ce8610f$var$r(l) && "static" === $023d07731ce8610f$var$o(l).position && !$023d07731ce8610f$var$h(l)) ? i : l || function(t) {
        let e = $023d07731ce8610f$var$F(t);
        for(; $023d07731ce8610f$var$s(e) && !$023d07731ce8610f$var$g(e);){
            if ($023d07731ce8610f$var$h(e)) return e;
            e = $023d07731ce8610f$var$F(e);
        }
        return null;
    }(t) || i;
}
function $023d07731ce8610f$var$V(t, e, n) {
    const o = $023d07731ce8610f$var$s(e), i = $023d07731ce8610f$var$T(e), l = $023d07731ce8610f$var$E(t, !0, "fixed" === n, e);
    let c = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const f = {
        x: 0,
        y: 0
    };
    if (o || !o && "fixed" !== n) {
        if (("body" !== $023d07731ce8610f$var$r(e) || $023d07731ce8610f$var$a(i)) && (c = $023d07731ce8610f$var$R(e)), $023d07731ce8610f$var$s(e)) {
            const t = $023d07731ce8610f$var$E(e, !0);
            f.x = t.x + e.clientLeft, f.y = t.y + e.clientTop;
        } else i && (f.x = $023d07731ce8610f$var$C(i));
    }
    return {
        x: l.left + c.scrollLeft - f.x,
        y: l.top + c.scrollTop - f.y,
        width: l.width,
        height: l.height
    };
}
const $023d07731ce8610f$export$722a64dea1b767dc = {
    getClippingRect: function(t) {
        let { element: e, boundary: n, rootBoundary: i, strategy: l } = t;
        const c = "clippingAncestors" === n ? function(t, e) {
            const n = e.get(t);
            if (n) return n;
            let i = $023d07731ce8610f$export$3b57c1601291186b(t).filter((t)=>$023d07731ce8610f$var$f(t) && "body" !== $023d07731ce8610f$var$r(t)), l = null;
            const c = "fixed" === $023d07731ce8610f$var$o(t).position;
            let s = c ? $023d07731ce8610f$var$F(t) : t;
            for(; $023d07731ce8610f$var$f(s) && !$023d07731ce8610f$var$g(s);){
                const t = $023d07731ce8610f$var$o(s), e = $023d07731ce8610f$var$h(s);
                "fixed" === t.position ? l = null : (c ? e || l : e || "static" !== t.position || !l || ![
                    "absolute",
                    "fixed"
                ].includes(l.position)) ? l = t : i = i.filter((t)=>t !== s), s = $023d07731ce8610f$var$F(s);
            }
            return e.set(t, i), i;
        }(e, this._c) : [].concat(n), s = [
            ...c,
            i
        ], u = s[0], a = s.reduce((t, n)=>{
            const o = $023d07731ce8610f$var$S(e, n, l);
            return t.top = $023d07731ce8610f$var$y(o.top, t.top), t.right = $023d07731ce8610f$var$m(o.right, t.right), t.bottom = $023d07731ce8610f$var$m(o.bottom, t.bottom), t.left = $023d07731ce8610f$var$y(o.left, t.left), t;
        }, $023d07731ce8610f$var$S(e, u, l));
        return {
            width: a.right - a.left,
            height: a.bottom - a.top,
            x: a.left,
            y: a.top
        };
    },
    convertOffsetParentRelativeRectToViewportRelativeRect: function(t) {
        let { rect: e, offsetParent: n, strategy: o } = t;
        const i = $023d07731ce8610f$var$s(n), l = $023d07731ce8610f$var$T(n);
        if (n === l) return e;
        let c = {
            scrollLeft: 0,
            scrollTop: 0
        }, f = {
            x: 1,
            y: 1
        };
        const u = {
            x: 0,
            y: 0
        };
        if ((i || !i && "fixed" !== o) && (("body" !== $023d07731ce8610f$var$r(n) || $023d07731ce8610f$var$a(l)) && (c = $023d07731ce8610f$var$R(n)), $023d07731ce8610f$var$s(n))) {
            const t = $023d07731ce8610f$var$E(n);
            f = $023d07731ce8610f$var$L(n), u.x = t.x + n.clientLeft, u.y = t.y + n.clientTop;
        }
        return {
            width: e.width * f.x,
            height: e.height * f.y,
            x: e.x * f.x - c.scrollLeft * f.x + u.x,
            y: e.y * f.y - c.scrollTop * f.y + u.y
        };
    },
    isElement: $023d07731ce8610f$var$f,
    getDimensions: function(t) {
        return $023d07731ce8610f$var$w(t);
    },
    getOffsetParent: $023d07731ce8610f$var$H,
    getDocumentElement: $023d07731ce8610f$var$T,
    getScale: $023d07731ce8610f$var$L,
    async getElementRects (t) {
        let { reference: e, floating: n, strategy: o } = t;
        const i = this.getOffsetParent || $023d07731ce8610f$var$H, r = this.getDimensions;
        return {
            reference: $023d07731ce8610f$var$V(e, await i(n), o),
            floating: {
                x: 0,
                y: 0,
                ...await r(n)
            }
        };
    },
    getClientRects: (t)=>Array.from(t.getClientRects()),
    isRTL: (t)=>"rtl" === $023d07731ce8610f$var$o(t).direction
};
function $023d07731ce8610f$export$deee3a793edee05f(t, e, n, o) {
    void 0 === o && (o = {});
    const { ancestorScroll: i = !0, ancestorResize: r = !0, elementResize: l = !0, animationFrame: c = !1 } = o, s = i && !c, u = s || r ? [
        ...$023d07731ce8610f$var$f(t) ? $023d07731ce8610f$export$3b57c1601291186b(t) : t.contextElement ? $023d07731ce8610f$export$3b57c1601291186b(t.contextElement) : [],
        ...$023d07731ce8610f$export$3b57c1601291186b(e)
    ] : [];
    u.forEach((t)=>{
        s && t.addEventListener("scroll", n, {
            passive: !0
        }), r && t.addEventListener("resize", n);
    });
    let a, d = null;
    l && (d = new ResizeObserver(()=>{
        n();
    }), $023d07731ce8610f$var$f(t) && !c && d.observe(t), $023d07731ce8610f$var$f(t) || !t.contextElement || c || d.observe(t.contextElement), d.observe(e));
    let h = c ? $023d07731ce8610f$var$E(t) : null;
    return c && function e() {
        const o = $023d07731ce8610f$var$E(t);
        !h || o.x === h.x && o.y === h.y && o.width === h.width && o.height === h.height || n();
        h = o, a = requestAnimationFrame(e);
    }(), n(), ()=>{
        var t;
        u.forEach((t)=>{
            s && t.removeEventListener("scroll", n), r && t.removeEventListener("resize", n);
        }), null == (t = d) || t.disconnect(), d = null, c && cancelAnimationFrame(a);
    };
}
const $023d07731ce8610f$export$48a53dcb22e581d0 = (t, n, o)=>{
    const i = new Map, r = {
        platform: $023d07731ce8610f$export$722a64dea1b767dc,
        ...o
    }, l = {
        ...r.platform,
        _c: i
    };
    return (0, $7MIdi.computePosition)(t, n, {
        ...r,
        platform: l
    });
};

});
parcelRegister("7MIdi", function(module, exports) {

$parcel$export(module.exports, "computePosition", () => $4dacbd6c81f90f16$export$48a53dcb22e581d0);
$parcel$export(module.exports, "rectToClientRect", () => $4dacbd6c81f90f16$export$ee05aea0aeecbad4);
function $4dacbd6c81f90f16$var$t(t) {
    return t.split("-")[1];
}
function $4dacbd6c81f90f16$var$e(t) {
    return "y" === t ? "height" : "width";
}
function $4dacbd6c81f90f16$var$n(t) {
    return t.split("-")[0];
}
function $4dacbd6c81f90f16$var$o(t) {
    return [
        "top",
        "bottom"
    ].includes($4dacbd6c81f90f16$var$n(t)) ? "x" : "y";
}
function $4dacbd6c81f90f16$var$i(i, r, a) {
    let { reference: l, floating: s } = i;
    const c = l.x + l.width / 2 - s.width / 2, f = l.y + l.height / 2 - s.height / 2, m = $4dacbd6c81f90f16$var$o(r), u = $4dacbd6c81f90f16$var$e(m), g = l[u] / 2 - s[u] / 2, d = "x" === m;
    let p;
    switch($4dacbd6c81f90f16$var$n(r)){
        case "top":
            p = {
                x: c,
                y: l.y - s.height
            };
            break;
        case "bottom":
            p = {
                x: c,
                y: l.y + l.height
            };
            break;
        case "right":
            p = {
                x: l.x + l.width,
                y: f
            };
            break;
        case "left":
            p = {
                x: l.x - s.width,
                y: f
            };
            break;
        default:
            p = {
                x: l.x,
                y: l.y
            };
    }
    switch($4dacbd6c81f90f16$var$t(r)){
        case "start":
            p[m] -= g * (a && d ? -1 : 1);
            break;
        case "end":
            p[m] += g * (a && d ? -1 : 1);
    }
    return p;
}
const $4dacbd6c81f90f16$export$48a53dcb22e581d0 = async (t, e, n)=>{
    const { placement: o = "bottom", strategy: r = "absolute", middleware: a = [], platform: l } = n, s = a.filter(Boolean), c = await (null == l.isRTL ? void 0 : l.isRTL(e));
    let f = await l.getElementRects({
        reference: t,
        floating: e,
        strategy: r
    }), { x: m, y: u } = $4dacbd6c81f90f16$var$i(f, o, c), g = o, d = {}, p = 0;
    for(let n = 0; n < s.length; n++){
        const { name: a, fn: h } = s[n], { x: y, y: x, data: w, reset: v } = await h({
            x: m,
            y: u,
            initialPlacement: o,
            placement: g,
            strategy: r,
            middlewareData: d,
            rects: f,
            platform: l,
            elements: {
                reference: t,
                floating: e
            }
        });
        m = null != y ? y : m, u = null != x ? x : u, d = {
            ...d,
            [a]: {
                ...d[a],
                ...w
            }
        }, v && p <= 50 && (p++, "object" == typeof v && (v.placement && (g = v.placement), v.rects && (f = !0 === v.rects ? await l.getElementRects({
            reference: t,
            floating: e,
            strategy: r
        }) : v.rects), { x: m, y: u } = $4dacbd6c81f90f16$var$i(f, g, c)), n = -1);
    }
    return {
        x: m,
        y: u,
        placement: g,
        strategy: r,
        middlewareData: d
    };
};
function $4dacbd6c81f90f16$var$a(t) {
    return "number" != typeof t ? function(t) {
        return {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            ...t
        };
    }(t) : {
        top: t,
        right: t,
        bottom: t,
        left: t
    };
}
function $4dacbd6c81f90f16$export$ee05aea0aeecbad4(t) {
    return {
        ...t,
        top: t.y,
        left: t.x,
        right: t.x + t.width,
        bottom: t.y + t.height
    };
}
async function $4dacbd6c81f90f16$export$37b6bde19b108ecc(t, e) {
    var n;
    void 0 === e && (e = {});
    const { x: o, y: i, platform: r, rects: s, elements: c, strategy: f } = t, { boundary: m = "clippingAncestors", rootBoundary: u = "viewport", elementContext: g = "floating", altBoundary: d = !1, padding: p = 0 } = e, h = $4dacbd6c81f90f16$var$a(p), y = c[d ? "floating" === g ? "reference" : "floating" : g], x = $4dacbd6c81f90f16$export$ee05aea0aeecbad4(await r.getClippingRect({
        element: null == (n = await (null == r.isElement ? void 0 : r.isElement(y))) || n ? y : y.contextElement || await (null == r.getDocumentElement ? void 0 : r.getDocumentElement(c.floating)),
        boundary: m,
        rootBoundary: u,
        strategy: f
    })), w = "floating" === g ? {
        ...s.floating,
        x: o,
        y: i
    } : s.reference, v = await (null == r.getOffsetParent ? void 0 : r.getOffsetParent(c.floating)), b = await (null == r.isElement ? void 0 : r.isElement(v)) && await (null == r.getScale ? void 0 : r.getScale(v)) || {
        x: 1,
        y: 1
    }, A = $4dacbd6c81f90f16$export$ee05aea0aeecbad4(r.convertOffsetParentRelativeRectToViewportRelativeRect ? await r.convertOffsetParentRelativeRectToViewportRelativeRect({
        rect: w,
        offsetParent: v,
        strategy: f
    }) : w);
    return {
        top: (x.top - A.top + h.top) / b.y,
        bottom: (A.bottom - x.bottom + h.bottom) / b.y,
        left: (x.left - A.left + h.left) / b.x,
        right: (A.right - x.right + h.right) / b.x
    };
}
const $4dacbd6c81f90f16$var$c = Math.min, $4dacbd6c81f90f16$var$f = Math.max;
function $4dacbd6c81f90f16$var$m(t, e, n) {
    return $4dacbd6c81f90f16$var$f(t, $4dacbd6c81f90f16$var$c(e, n));
}
const $4dacbd6c81f90f16$export$f2120bbfa5450bd2 = (n)=>({
        name: "arrow",
        options: n,
        async fn (i) {
            const { element: r, padding: l = 0 } = n || {}, { x: s, y: c, placement: f, rects: u, platform: g, elements: d } = i;
            if (null == r) return {};
            const p = $4dacbd6c81f90f16$var$a(l), h = {
                x: s,
                y: c
            }, y = $4dacbd6c81f90f16$var$o(f), x = $4dacbd6c81f90f16$var$e(y), w = await g.getDimensions(r), v = "y" === y, b = v ? "top" : "left", A = v ? "bottom" : "right", R = v ? "clientHeight" : "clientWidth", P = u.reference[x] + u.reference[y] - h[y] - u.floating[x], E = h[y] - u.reference[y], T = await (null == g.getOffsetParent ? void 0 : g.getOffsetParent(r));
            let D = T ? T[R] : 0;
            D && await (null == g.isElement ? void 0 : g.isElement(T)) || (D = d.floating[R] || u.floating[x]);
            const L = P / 2 - E / 2, k = p[b], O = D - w[x] - p[A], B = D / 2 - w[x] / 2 + L, C = $4dacbd6c81f90f16$var$m(k, B, O), H = null != $4dacbd6c81f90f16$var$t(f) && B != C && u.reference[x] / 2 - (B < k ? p[b] : p[A]) - w[x] / 2 < 0;
            return {
                [y]: h[y] - (H ? B < k ? k - B : O - B : 0),
                data: {
                    [y]: C,
                    centerOffset: B - C
                }
            };
        }
    }), $4dacbd6c81f90f16$var$g = [
    "top",
    "right",
    "bottom",
    "left"
], $4dacbd6c81f90f16$var$d = $4dacbd6c81f90f16$var$g.reduce((t, e)=>t.concat(e, e + "-start", e + "-end"), []), $4dacbd6c81f90f16$var$p = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
function $4dacbd6c81f90f16$var$h(t) {
    return t.replace(/left|right|bottom|top/g, (t)=>$4dacbd6c81f90f16$var$p[t]);
}
function $4dacbd6c81f90f16$var$y(n, i, r) {
    void 0 === r && (r = !1);
    const a = $4dacbd6c81f90f16$var$t(n), l = $4dacbd6c81f90f16$var$o(n), s = $4dacbd6c81f90f16$var$e(l);
    let c = "x" === l ? a === (r ? "end" : "start") ? "right" : "left" : "start" === a ? "bottom" : "top";
    return i.reference[s] > i.floating[s] && (c = $4dacbd6c81f90f16$var$h(c)), {
        main: c,
        cross: $4dacbd6c81f90f16$var$h(c)
    };
}
const $4dacbd6c81f90f16$var$x = {
    start: "end",
    end: "start"
};
function $4dacbd6c81f90f16$var$w(t) {
    return t.replace(/start|end/g, (t)=>$4dacbd6c81f90f16$var$x[t]);
}
const $4dacbd6c81f90f16$export$91fb6ecbd551914 = function(e) {
    return void 0 === e && (e = {}), {
        name: "autoPlacement",
        options: e,
        async fn (o) {
            var i, r, a;
            const { rects: l, middlewareData: c, placement: f, platform: m, elements: u } = o, { crossAxis: g = !1, alignment: p, allowedPlacements: h = $4dacbd6c81f90f16$var$d, autoAlignment: x = !0, ...v } = e, b = void 0 !== p || h === $4dacbd6c81f90f16$var$d ? function(e, o, i) {
                return (e ? [
                    ...i.filter((n)=>$4dacbd6c81f90f16$var$t(n) === e),
                    ...i.filter((n)=>$4dacbd6c81f90f16$var$t(n) !== e)
                ] : i.filter((t)=>$4dacbd6c81f90f16$var$n(t) === t)).filter((n)=>!e || $4dacbd6c81f90f16$var$t(n) === e || !!o && $4dacbd6c81f90f16$var$w(n) !== n);
            }(p || null, x, h) : h, A = await $4dacbd6c81f90f16$export$37b6bde19b108ecc(o, v), R = (null == (i = c.autoPlacement) ? void 0 : i.index) || 0, P = b[R];
            if (null == P) return {};
            const { main: E, cross: T } = $4dacbd6c81f90f16$var$y(P, l, await (null == m.isRTL ? void 0 : m.isRTL(u.floating)));
            if (f !== P) return {
                reset: {
                    placement: b[0]
                }
            };
            const D = [
                A[$4dacbd6c81f90f16$var$n(P)],
                A[E],
                A[T]
            ], L = [
                ...(null == (r = c.autoPlacement) ? void 0 : r.overflows) || [],
                {
                    placement: P,
                    overflows: D
                }
            ], k = b[R + 1];
            if (k) return {
                data: {
                    index: R + 1,
                    overflows: L
                },
                reset: {
                    placement: k
                }
            };
            const O = L.map((e)=>{
                const n = $4dacbd6c81f90f16$var$t(e.placement);
                return [
                    e.placement,
                    n && g ? e.overflows.slice(0, 2).reduce((t, e)=>t + e, 0) : e.overflows[0],
                    e.overflows
                ];
            }).sort((t, e)=>t[1] - e[1]), B = (null == (a = O.filter((e)=>e[2].slice(0, $4dacbd6c81f90f16$var$t(e[0]) ? 2 : 3).every((t)=>t <= 0))[0]) ? void 0 : a[0]) || O[0][0];
            return B !== f ? {
                data: {
                    index: R + 1,
                    overflows: L
                },
                reset: {
                    placement: B
                }
            } : {};
        }
    };
};
const $4dacbd6c81f90f16$export$8a83211c878a3f1f = function(e) {
    return void 0 === e && (e = {}), {
        name: "flip",
        options: e,
        async fn (o) {
            var i;
            const { placement: r, middlewareData: a, rects: l, initialPlacement: c, platform: f, elements: m } = o, { mainAxis: u = !0, crossAxis: g = !0, fallbackPlacements: d, fallbackStrategy: p = "bestFit", fallbackAxisSideDirection: x = "none", flipAlignment: v = !0, ...b } = e, A = $4dacbd6c81f90f16$var$n(r), R = $4dacbd6c81f90f16$var$n(c) === c, P = await (null == f.isRTL ? void 0 : f.isRTL(m.floating)), E = d || (R || !v ? [
                $4dacbd6c81f90f16$var$h(c)
            ] : function(t) {
                const e = $4dacbd6c81f90f16$var$h(t);
                return [
                    $4dacbd6c81f90f16$var$w(t),
                    e,
                    $4dacbd6c81f90f16$var$w(e)
                ];
            }(c));
            d || "none" === x || E.push(...function(e, o, i, r) {
                const a = $4dacbd6c81f90f16$var$t(e);
                let l = function(t, e, n) {
                    const o = [
                        "left",
                        "right"
                    ], i = [
                        "right",
                        "left"
                    ], r = [
                        "top",
                        "bottom"
                    ], a = [
                        "bottom",
                        "top"
                    ];
                    switch(t){
                        case "top":
                        case "bottom":
                            return n ? e ? i : o : e ? o : i;
                        case "left":
                        case "right":
                            return e ? r : a;
                        default:
                            return [];
                    }
                }($4dacbd6c81f90f16$var$n(e), "start" === i, r);
                return a && (l = l.map((t)=>t + "-" + a), o && (l = l.concat(l.map($4dacbd6c81f90f16$var$w)))), l;
            }(c, v, x, P));
            const T = [
                c,
                ...E
            ], D = await $4dacbd6c81f90f16$export$37b6bde19b108ecc(o, b), L = [];
            let k = (null == (i = a.flip) ? void 0 : i.overflows) || [];
            if (u && L.push(D[A]), g) {
                const { main: t, cross: e } = $4dacbd6c81f90f16$var$y(r, l, P);
                L.push(D[t], D[e]);
            }
            if (k = [
                ...k,
                {
                    placement: r,
                    overflows: L
                }
            ], !L.every((t)=>t <= 0)) {
                var O, B;
                const t = ((null == (O = a.flip) ? void 0 : O.index) || 0) + 1, e = T[t];
                if (e) return {
                    data: {
                        index: t,
                        overflows: k
                    },
                    reset: {
                        placement: e
                    }
                };
                let n = null == (B = k.filter((t)=>t.overflows[0] <= 0).sort((t, e)=>t.overflows[1] - e.overflows[1])[0]) ? void 0 : B.placement;
                if (!n) switch(p){
                    case "bestFit":
                        {
                            var C;
                            const t = null == (C = k.map((t)=>[
                                    t.placement,
                                    t.overflows.filter((t)=>t > 0).reduce((t, e)=>t + e, 0)
                                ]).sort((t, e)=>t[1] - e[1])[0]) ? void 0 : C[0];
                            t && (n = t);
                            break;
                        }
                    case "initialPlacement":
                        n = c;
                }
                if (r !== n) return {
                    reset: {
                        placement: n
                    }
                };
            }
            return {};
        }
    };
};
function $4dacbd6c81f90f16$var$A(t, e) {
    return {
        top: t.top - e.height,
        right: t.right - e.width,
        bottom: t.bottom - e.height,
        left: t.left - e.width
    };
}
function $4dacbd6c81f90f16$var$R(t) {
    return $4dacbd6c81f90f16$var$g.some((e)=>t[e] >= 0);
}
const $4dacbd6c81f90f16$export$fe8985bb6374093c = function(t) {
    return void 0 === t && (t = {}), {
        name: "hide",
        options: t,
        async fn (e) {
            const { strategy: n = "referenceHidden", ...o } = t, { rects: i } = e;
            switch(n){
                case "referenceHidden":
                    {
                        const t = $4dacbd6c81f90f16$var$A(await $4dacbd6c81f90f16$export$37b6bde19b108ecc(e, {
                            ...o,
                            elementContext: "reference"
                        }), i.reference);
                        return {
                            data: {
                                referenceHiddenOffsets: t,
                                referenceHidden: $4dacbd6c81f90f16$var$R(t)
                            }
                        };
                    }
                case "escaped":
                    {
                        const t = $4dacbd6c81f90f16$var$A(await $4dacbd6c81f90f16$export$37b6bde19b108ecc(e, {
                            ...o,
                            altBoundary: !0
                        }), i.floating);
                        return {
                            data: {
                                escapedOffsets: t,
                                escaped: $4dacbd6c81f90f16$var$R(t)
                            }
                        };
                    }
                default:
                    return {};
            }
        }
    };
};
function $4dacbd6c81f90f16$var$E(t) {
    const e = $4dacbd6c81f90f16$var$c(...t.map((t)=>t.left)), n = $4dacbd6c81f90f16$var$c(...t.map((t)=>t.top));
    return {
        x: e,
        y: n,
        width: $4dacbd6c81f90f16$var$f(...t.map((t)=>t.right)) - e,
        height: $4dacbd6c81f90f16$var$f(...t.map((t)=>t.bottom)) - n
    };
}
const $4dacbd6c81f90f16$export$18c8ad048e32c7d5 = function(t) {
    return void 0 === t && (t = {}), {
        name: "inline",
        options: t,
        async fn (e) {
            const { placement: i, elements: r, rects: s, platform: m, strategy: u } = e, { padding: g = 2, x: d, y: p } = t, h = Array.from(await (null == m.getClientRects ? void 0 : m.getClientRects(r.reference)) || []), y = function(t) {
                const e = t.slice().sort((t, e)=>t.y - e.y), n = [];
                let o = null;
                for(let t = 0; t < e.length; t++){
                    const i = e[t];
                    !o || i.y - o.y > o.height / 2 ? n.push([
                        i
                    ]) : n[n.length - 1].push(i), o = i;
                }
                return n.map((t)=>$4dacbd6c81f90f16$export$ee05aea0aeecbad4($4dacbd6c81f90f16$var$E(t)));
            }(h), x = $4dacbd6c81f90f16$export$ee05aea0aeecbad4($4dacbd6c81f90f16$var$E(h)), w = $4dacbd6c81f90f16$var$a(g);
            const v = await m.getElementRects({
                reference: {
                    getBoundingClientRect: function() {
                        if (2 === y.length && y[0].left > y[1].right && null != d && null != p) return y.find((t)=>d > t.left - w.left && d < t.right + w.right && p > t.top - w.top && p < t.bottom + w.bottom) || x;
                        if (y.length >= 2) {
                            if ("x" === $4dacbd6c81f90f16$var$o(i)) {
                                const t = y[0], e = y[y.length - 1], o = "top" === $4dacbd6c81f90f16$var$n(i), r = t.top, a = e.bottom, l = o ? t.left : e.left, s = o ? t.right : e.right;
                                return {
                                    top: r,
                                    bottom: a,
                                    left: l,
                                    right: s,
                                    width: s - l,
                                    height: a - r,
                                    x: l,
                                    y: r
                                };
                            }
                            const t = "left" === $4dacbd6c81f90f16$var$n(i), e = $4dacbd6c81f90f16$var$f(...y.map((t)=>t.right)), r = $4dacbd6c81f90f16$var$c(...y.map((t)=>t.left)), a = y.filter((n)=>t ? n.left === r : n.right === e), l = a[0].top, s = a[a.length - 1].bottom;
                            return {
                                top: l,
                                bottom: s,
                                left: r,
                                right: e,
                                width: e - r,
                                height: s - l,
                                x: r,
                                y: l
                            };
                        }
                        return x;
                    }
                },
                floating: r.floating,
                strategy: u
            });
            return s.reference.x !== v.reference.x || s.reference.y !== v.reference.y || s.reference.width !== v.reference.width || s.reference.height !== v.reference.height ? {
                reset: {
                    rects: v
                }
            } : {};
        }
    };
};
const $4dacbd6c81f90f16$export$cc800923e997bb8 = function(e) {
    return void 0 === e && (e = 0), {
        name: "offset",
        options: e,
        async fn (i) {
            const { x: r, y: a } = i, l = await async function(e, i) {
                const { placement: r, platform: a, elements: l } = e, s = await (null == a.isRTL ? void 0 : a.isRTL(l.floating)), c = $4dacbd6c81f90f16$var$n(r), f = $4dacbd6c81f90f16$var$t(r), m = "x" === $4dacbd6c81f90f16$var$o(r), u = [
                    "left",
                    "top"
                ].includes(c) ? -1 : 1, g = s && m ? -1 : 1, d = "function" == typeof i ? i(e) : i;
                let { mainAxis: p, crossAxis: h, alignmentAxis: y } = "number" == typeof d ? {
                    mainAxis: d,
                    crossAxis: 0,
                    alignmentAxis: null
                } : {
                    mainAxis: 0,
                    crossAxis: 0,
                    alignmentAxis: null,
                    ...d
                };
                return f && "number" == typeof y && (h = "end" === f ? -1 * y : y), m ? {
                    x: h * g,
                    y: p * u
                } : {
                    x: p * u,
                    y: h * g
                };
            }(i, e);
            return {
                x: r + l.x,
                y: a + l.y,
                data: l
            };
        }
    };
};
function $4dacbd6c81f90f16$var$L(t) {
    return "x" === t ? "y" : "x";
}
const $4dacbd6c81f90f16$export$fba63a578e423eb = function(t) {
    return void 0 === t && (t = {}), {
        name: "shift",
        options: t,
        async fn (e) {
            const { x: i, y: r, placement: a } = e, { mainAxis: l = !0, crossAxis: c = !1, limiter: f = {
                fn: (t)=>{
                    let { x: e, y: n } = t;
                    return {
                        x: e,
                        y: n
                    };
                }
            }, ...u } = t, g = {
                x: i,
                y: r
            }, d = await $4dacbd6c81f90f16$export$37b6bde19b108ecc(e, u), p = $4dacbd6c81f90f16$var$o($4dacbd6c81f90f16$var$n(a)), h = $4dacbd6c81f90f16$var$L(p);
            let y = g[p], x = g[h];
            if (l) {
                const t = "y" === p ? "bottom" : "right";
                y = $4dacbd6c81f90f16$var$m(y + d["y" === p ? "top" : "left"], y, y - d[t]);
            }
            if (c) {
                const t = "y" === h ? "bottom" : "right";
                x = $4dacbd6c81f90f16$var$m(x + d["y" === h ? "top" : "left"], x, x - d[t]);
            }
            const w = f.fn({
                ...e,
                [p]: y,
                [h]: x
            });
            return {
                ...w,
                data: {
                    x: w.x - i,
                    y: w.y - r
                }
            };
        }
    };
}, $4dacbd6c81f90f16$export$7bf07e38f3dc4b69 = function(t) {
    return void 0 === t && (t = {}), {
        options: t,
        fn (e) {
            const { x: i, y: r, placement: a, rects: l, middlewareData: s } = e, { offset: c = 0, mainAxis: f = !0, crossAxis: m = !0 } = t, u = {
                x: i,
                y: r
            }, g = $4dacbd6c81f90f16$var$o(a), d = $4dacbd6c81f90f16$var$L(g);
            let p = u[g], h = u[d];
            const y = "function" == typeof c ? c(e) : c, x = "number" == typeof y ? {
                mainAxis: y,
                crossAxis: 0
            } : {
                mainAxis: 0,
                crossAxis: 0,
                ...y
            };
            if (f) {
                const t = "y" === g ? "height" : "width", e = l.reference[g] - l.floating[t] + x.mainAxis, n = l.reference[g] + l.reference[t] - x.mainAxis;
                p < e ? p = e : p > n && (p = n);
            }
            if (m) {
                var w, v;
                const t = "y" === g ? "width" : "height", e = [
                    "top",
                    "left"
                ].includes($4dacbd6c81f90f16$var$n(a)), o = l.reference[d] - l.floating[t] + (e && (null == (w = s.offset) ? void 0 : w[d]) || 0) + (e ? 0 : x.crossAxis), i = l.reference[d] + l.reference[t] + (e ? 0 : (null == (v = s.offset) ? void 0 : v[d]) || 0) - (e ? x.crossAxis : 0);
                h < o ? h = o : h > i && (h = i);
            }
            return {
                [g]: p,
                [d]: h
            };
        }
    };
}, $4dacbd6c81f90f16$export$346677f925de839c = function(e) {
    return void 0 === e && (e = {}), {
        name: "size",
        options: e,
        async fn (i) {
            const { placement: r, rects: a, platform: l, elements: m } = i, { apply: u = ()=>{}, ...g } = e, d = await $4dacbd6c81f90f16$export$37b6bde19b108ecc(i, g), p = $4dacbd6c81f90f16$var$n(r), h = $4dacbd6c81f90f16$var$t(r), y = "x" === $4dacbd6c81f90f16$var$o(r), { width: x, height: w } = a.floating;
            let v, b;
            "top" === p || "bottom" === p ? (v = p, b = h === (await (null == l.isRTL ? void 0 : l.isRTL(m.floating)) ? "start" : "end") ? "left" : "right") : (b = p, v = "end" === h ? "top" : "bottom");
            const A = w - d[v], R = x - d[b];
            let P = A, E = R;
            if (y ? E = $4dacbd6c81f90f16$var$c(x - d.right - d.left, R) : P = $4dacbd6c81f90f16$var$c(w - d.bottom - d.top, A), !i.middlewareData.shift && !h) {
                const t = $4dacbd6c81f90f16$var$f(d.left, 0), e = $4dacbd6c81f90f16$var$f(d.right, 0), n = $4dacbd6c81f90f16$var$f(d.top, 0), o = $4dacbd6c81f90f16$var$f(d.bottom, 0);
                y ? E = x - 2 * (0 !== t || 0 !== e ? t + e : $4dacbd6c81f90f16$var$f(d.left, d.right)) : P = w - 2 * (0 !== n || 0 !== o ? n + o : $4dacbd6c81f90f16$var$f(d.top, d.bottom));
            }
            await u({
                ...i,
                availableWidth: E,
                availableHeight: P
            });
            const T = await l.getDimensions(m.floating);
            return x !== T.width || w !== T.height ? {
                reset: {
                    rects: !0
                }
            } : {};
        }
    };
};

});


parcelRegister("k286k", function(module, exports) {

$parcel$export(module.exports, "default", () => $e95a473d1e65c2a9$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
var $e95a473d1e65c2a9$var$index = (0, $eUqFw.useLayoutEffect);
var $e95a473d1e65c2a9$export$2e2bcd8739ae039 = $e95a473d1e65c2a9$var$index;

});


parcelRegister("l44HT", function(module, exports) {

$parcel$export(module.exports, "default", () => $e29cbcff993ea6c5$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $lEfVV = parcelRequire("lEfVV");

var $6Pq2D = parcelRequire("6Pq2D");

var $hOLnS = parcelRequire("hOLnS");
var $cEc3i = parcelRequire("cEc3i");

var $tkrFt = parcelRequire("tkrFt");

var $3aVBa = parcelRequire("3aVBa");
var $aV2RP = parcelRequire("aV2RP");
var $6XvxP = parcelRequire("6XvxP");

var $lbDTY = parcelRequire("lbDTY");

var $asNSH = parcelRequire("asNSH");

var $5wCDk = parcelRequire("5wCDk");

var $PdmhA = parcelRequire("PdmhA");

var $XHGTv = parcelRequire("XHGTv");

var $7ldaw = parcelRequire("7ldaw");

var $bKJfr = parcelRequire("bKJfr");

var $74BVL = parcelRequire("74BVL");
/** Are we rendering on the client or server? */ const $e29cbcff993ea6c5$var$canUseDOM = ()=>Boolean(typeof window !== 'undefined' && window.document && window.document.createElement);
// ==============================
// Class
// ==============================
const $e29cbcff993ea6c5$var$modifiers = [
    {
        name: 'offset',
        options: {
            offset: [
                0,
                8
            ]
        }
    },
    {
        name: 'preventOverflow',
        enabled: true,
        options: {
            padding: 5,
            boundary: 'clippingParents',
            altAxis: true,
            altBoundary: true
        }
    }
];
const $e29cbcff993ea6c5$var$defaultPopperProps = {
    modifiers: $e29cbcff993ea6c5$var$modifiers,
    placement: 'bottom-start'
};
const $e29cbcff993ea6c5$var$isEmpty = (obj)=>Object.keys(obj).length === 0;
class $e29cbcff993ea6c5$export$2e2bcd8739ae039 extends (0, $eUqFw.PureComponent) {
    static{
        this.defaultProps = {
            closeMenuOnSelect: true,
            components: {},
            maxMenuHeight: 300,
            maxMenuWidth: 440,
            minMenuWidth: 220,
            popperProps: {},
            isSearchable: true,
            searchThreshold: 5,
            styles: {},
            options: []
        };
    }
    static getDerivedStateFromProps(props, state) {
        const newState = {};
        // Merge consumer and default popper props
        const mergedPopperProps = {
            ...$e29cbcff993ea6c5$var$defaultPopperProps,
            ...props.popperProps
        };
        if (!(0, $asNSH.shallowEqualObjects)(mergedPopperProps, state.mergedPopperProps)) newState.mergedPopperProps = mergedPopperProps;
        // Merge consumer and default components
        const mergedComponents = {
            ...(0, $7ldaw.defaultComponents),
            ...props.components
        };
        if (!(0, $asNSH.shallowEqualObjects)(mergedComponents, state.mergedComponents)) newState.mergedComponents = mergedComponents;
        if (!$e29cbcff993ea6c5$var$isEmpty(newState)) return newState;
        return null;
    }
    componentDidMount() {
        if (typeof window === 'undefined') return;
        this.unbindWindowClick = (0, $74BVL.bind)(window, {
            type: 'click',
            listener: this.handleClick,
            options: {
                capture: true
            }
        });
    }
    componentWillUnmount() {
        if (typeof window === 'undefined') return;
        this.unbindWindowClick?.();
        this.unbindWindowClick = null;
        this.unbindWindowKeydown?.();
        this.unbindWindowKeydown = null;
    }
    componentDidUpdate(prevProps) {
        const { isOpen: isOpen } = this.props;
        if (prevProps.isOpen !== isOpen) {
            if (isOpen === true) this.open({
                controlOverride: true
            });
            else if (isOpen === false) this.close({
                controlOverride: true
            });
        }
    }
    render() {
        const { target: target } = this.props;
        const { isOpen: isOpen } = this.state;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3aVBa.Manager), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6XvxP.Reference), null, ({ ref: ref })=>target && target({
                isOpen: isOpen,
                onKeyDown: this.handleTargetKeyDown,
                ref: this.resolveTargetRef(ref),
                'aria-haspopup': 'true',
                'aria-expanded': isOpen,
                'aria-controls': isOpen ? this.popperWrapperId : undefined
            })), this.renderSelect());
    }
    constructor(...args){
        super(...args);
        this.menuRef = null;
        this.targetRef = null;
        this.unbindWindowClick = null;
        this.unbindWindowKeydown = null;
        this.defaultStyles = (0, $cEc3i.m)((0, $bKJfr.default)(this.props.validationState || (this.props.isInvalid ? 'error' : 'default'), this.props.spacing === 'compact', 'default'), {
            groupHeading: (provided)=>({
                    ...provided,
                    color: `var(--ds-text-subtlest, ${0, $PdmhA.N80})`
                })
        });
        this.isOpenControlled = this.props.isOpen !== undefined;
        this.defaultOpenState = this.isOpenControlled ? this.props.isOpen : this.props.defaultIsOpen;
        this.state = {
            focusLockEnabled: false,
            isOpen: this.defaultOpenState ?? false,
            mergedComponents: (0, $7ldaw.defaultComponents),
            mergedPopperProps: $e29cbcff993ea6c5$var$defaultPopperProps
        };
        this.popperWrapperId = `${(0, $tkrFt.uid)({
            options: this.props.options
        })}-popup-select`;
        // Event Handlers
        // ==============================
        this.handleTargetKeyDown = (event)=>{
            switch(event.key){
                case 'ArrowDown':
                    this.open();
                    break;
                default:
            }
        };
        this.handleKeyDown = (event)=>{
            switch(event.key){
                case 'Escape':
                case 'Esc':
                    this.close();
                    break;
                default:
            }
            if (this.props.onKeyDown) /* @ts-ignore - updating type of event React.KeyboardEvent effects the unbindWindowsKeyDown listener. Check if this can be fixed once the component gets refactor to functional */ this.props.onKeyDown(event);
        };
        this.handleClick = ({ target: target })=>{
            const { isOpen: isOpen } = this.state;
            // appease flow
            if (!(target instanceof Element)) return;
            // NOTE: Why not use the <Blanket /> component to close?
            // We don't want to interupt the user's flow. Taking this approach allows
            // user to click "through" to other elements and close the popout.
            if (isOpen && this.menuRef && !this.menuRef.contains(target)) this.close();
            // open on target click -- we can't trust consumers to spread the onClick
            // property to the target
            if (!isOpen && this.targetRef && this.targetRef.contains(target)) this.open();
        };
        this.handleSelectChange = (value, actionMeta)=>{
            const { closeMenuOnSelect: closeMenuOnSelect, onChange: onChange } = this.props;
            if (closeMenuOnSelect && actionMeta.action !== 'clear') this.close();
            if (onChange) onChange(value, actionMeta);
        };
        this.handleFirstPopperUpdate = ()=>{
            // When the popup opens it's focused into. Since the popup is inside a portal, it's position is
            // initially set to 0,0 - this causes the window scroll position to jump to the top. To prevent
            // this we defer enabling the focus-lock until after Popper has positioned the popup the first time.
            this.setState({
                focusLockEnabled: true
            });
        };
        // Internal Lifecycle
        // ==============================
        /**
   * Opens the popup
   *
   * @param options.controlOverride  - Force the popup to open when it's open state is being controlled
   */ this.open = (options)=>{
            const { onOpen: onOpen } = this.props;
            if (!options?.controlOverride && this.isOpenControlled) // Prevent popup opening if it's open state is already being controlled
            return;
            if (onOpen) onOpen();
            this.setState({
                isOpen: true
            });
            if (this.selectRef) (0, $XHGTv.getBooleanFF)('platform.design-system-team.use-default-select-in-popup-select_46rmj') ? this.selectRef.select?.openMenu('first') : this.selectRef.openMenu('first');
            if (typeof window === 'undefined') return;
            this.unbindWindowKeydown = (0, $74BVL.bind)(window, {
                type: 'keydown',
                listener: this.handleKeyDown,
                options: {
                    capture: true
                }
            });
        };
        /**
   * Closes the popup
   *
   * @param options.controlOverride  - Force the popup to close when it's open state is being controlled
   */ this.close = (options)=>{
            const { onClose: onClose } = this.props;
            if (!options?.controlOverride && this.isOpenControlled) // Prevent popup closing if it's open state is already being controlled
            return;
            if (onClose) onClose();
            this.setState({
                isOpen: false
            });
            this.setState({
                focusLockEnabled: false
            });
            if (this.targetRef != null) this.targetRef.focus();
            if (typeof window === 'undefined') return;
            this.unbindWindowKeydown?.();
            this.unbindWindowKeydown = null;
        };
        // Refs
        // ==============================
        this.resolveTargetRef = (popperRef)=>(ref)=>{
                // avoid thrashing fn calls
                if (!this.targetRef && popperRef && ref) {
                    this.targetRef = ref;
                    if (typeof popperRef === 'function') popperRef(ref);
                    else popperRef.current = ref;
                }
            };
        this.resolveMenuRef = (popperRef)=>(ref)=>{
                this.menuRef = ref;
                if (typeof popperRef === 'function') popperRef(ref);
                else popperRef.current = ref;
            };
        this.getSelectRef = (ref)=>{
            this.selectRef = ref;
        };
        // Utils
        // ==============================
        // account for groups when counting options
        // this may need to be recursive, right now it just counts one level
        this.getItemCount = ()=>{
            const { options: options } = this.props;
            let count = 0;
            options.forEach((groupOrOption)=>{
                if (groupOrOption.options) groupOrOption.options.forEach(()=>count++);
                else count++;
            });
            return count;
        };
        this.getMaxHeight = ()=>{
            const { maxMenuHeight: maxMenuHeight } = this.props;
            if (!this.selectRef) return maxMenuHeight;
            // subtract the control height to maintain consistency
            const showSearchControl = this.showSearchControl();
            let controlRef = (0, $XHGTv.getBooleanFF)('platform.design-system-team.use-default-select-in-popup-select_46rmj') ? this.selectRef.select?.controlRef : this.selectRef.controlRef;
            const offsetHeight = showSearchControl && controlRef ? controlRef.offsetHeight : 0;
            const maxHeight = maxMenuHeight - offsetHeight;
            return maxHeight;
        };
        // if the threshold is exceeded, AND isSearchable is true, then display the search control
        this.showSearchControl = ()=>{
            const { searchThreshold: searchThreshold, isSearchable: isSearchable } = this.props;
            return isSearchable && this.getItemCount() > searchThreshold;
        };
        // Renderers
        // ==============================
        this.renderSelect = ()=>{
            const { footer: footer, label: label, maxMenuWidth: maxMenuWidth, minMenuWidth: minMenuWidth, placeholder: placeholder, target: target, testId: testId, ...props } = this.props;
            const { focusLockEnabled: focusLockEnabled, isOpen: isOpen, mergedComponents: mergedComponents, mergedPopperProps: mergedPopperProps } = this.state;
            const showSearchControl = this.showSearchControl();
            const portalDestination = $e29cbcff993ea6c5$var$canUseDOM() ? document.body : null;
            if (!portalDestination || !isOpen) return null;
            const selectComponents = {
                ...mergedComponents,
                Control: showSearchControl ? mergedComponents.Control : (0, $7ldaw.DummyControl)
            };
            const getLabel = ()=>{
                if (label) return label;
                else if (typeof placeholder === 'string') return placeholder;
            };
            const InternalSelect = (0, $XHGTv.getBooleanFF)('platform.design-system-team.use-default-select-in-popup-select_46rmj') ? (0, $5wCDk.default) : (0, $hOLnS.default);
            const popper = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aV2RP.Popper), {
                ...mergedPopperProps,
                onFirstUpdate: (state)=>{
                    this.handleFirstPopperUpdate();
                    mergedPopperProps.onFirstUpdate?.(state);
                }
            }, ({ placement: placement, ref: ref, style: style })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lbDTY))), {
                    innerRef: this.resolveMenuRef(ref)
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7ldaw.MenuDialog), {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                    style: style,
                    "data-placement": placement,
                    minWidth: minMenuWidth,
                    maxWidth: maxMenuWidth,
                    id: this.popperWrapperId,
                    testId: testId
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6Pq2D.default), {
                    disabled: !focusLockEnabled,
                    returnFocus: true
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(InternalSelect, {
                    "aria-label": getLabel(),
                    backspaceRemovesValue: false,
                    controlShouldRenderValue: false,
                    isClearable: false,
                    tabSelectsValue: false,
                    menuIsOpen: true,
                    placeholder: placeholder,
                    ref: this.getSelectRef,
                    ...props,
                    onMenuClose: ()=>{
                        (0, $XHGTv.getBooleanFF)('platform.design-system-team.popup-select-close_8h15h') && this.close();
                        props.onMenuClose?.();
                    },
                    isSearchable: showSearchControl,
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                    styles: (0, $cEc3i.m)(this.defaultStyles, props.styles || {}),
                    maxMenuHeight: this.getMaxHeight(),
                    components: selectComponents,
                    onChange: this.handleSelectChange
                }), footer))));
            return mergedPopperProps.strategy === 'fixed' ? popper : /*#__PURE__*/ (0, $lEfVV.createPortal)(popper, portalDestination);
        };
    }
}

});
parcelRegister("hOLnS", function(module, exports) {

$parcel$export(module.exports, "default", () => $cf8bdca71ec4c4b4$export$2e2bcd8739ae039);

var $7IqRg = parcelRequire("7IqRg");

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $cEc3i = parcelRequire("cEc3i");

var $4WmDP = parcelRequire("4WmDP");

var $i4xqP = parcelRequire("i4xqP");

var $jQxSL = parcelRequire("jQxSL");
parcelRequire("1Xn5q");
parcelRequire("aKcqM");
parcelRequire("bwPfh");
parcelRequire("lDSrn");
parcelRequire("lIEGP");
parcelRequire("eT4IF");
parcelRequire("7Dzgl");
parcelRequire("fVK4C");

parcelRequire("5sKOb");
parcelRequire("jqNEH");
parcelRequire("5zQU9");
parcelRequire("lEfVV");

parcelRequire("k286k");
var $cf8bdca71ec4c4b4$var$StateManagedSelect = /*#__PURE__*/ (0, $eUqFw.forwardRef)(function(props, ref) {
    var baseSelectProps = (0, $7IqRg.u)(props);
    return /*#__PURE__*/ $eUqFw.createElement((0, $cEc3i.S), (0, $kU09D.default)({
        ref: ref
    }, baseSelectProps));
});
var $cf8bdca71ec4c4b4$export$a7deb1594c5ce10e = function(_ref) {
    var nonce = _ref.nonce, children = _ref.children, cacheKey = _ref.cacheKey;
    var emotionCache = (0, $eUqFw.useMemo)(function() {
        return (0, $i4xqP.default)({
            key: cacheKey,
            nonce: nonce
        });
    }, [
        cacheKey,
        nonce
    ]);
    return /*#__PURE__*/ $eUqFw.createElement((0, $4WmDP.C), {
        value: emotionCache
    }, children);
};
var $cf8bdca71ec4c4b4$export$2e2bcd8739ae039 = $cf8bdca71ec4c4b4$var$StateManagedSelect;

});
parcelRegister("7IqRg", function(module, exports) {

$parcel$export(module.exports, "u", () => $59e179ee89746bd6$export$3b14a55fb2447963);

var $1Xn5q = parcelRequire("1Xn5q");

var $aKcqM = parcelRequire("aKcqM");

var $bwPfh = parcelRequire("bwPfh");

var $eUqFw = parcelRequire("eUqFw");
var $59e179ee89746bd6$var$_excluded = [
    "defaultInputValue",
    "defaultMenuIsOpen",
    "defaultValue",
    "inputValue",
    "menuIsOpen",
    "onChange",
    "onInputChange",
    "onMenuClose",
    "onMenuOpen",
    "value"
];
function $59e179ee89746bd6$export$3b14a55fb2447963(_ref) {
    var _ref$defaultInputValu = _ref.defaultInputValue, defaultInputValue = _ref$defaultInputValu === void 0 ? '' : _ref$defaultInputValu, _ref$defaultMenuIsOpe = _ref.defaultMenuIsOpen, defaultMenuIsOpen = _ref$defaultMenuIsOpe === void 0 ? false : _ref$defaultMenuIsOpe, _ref$defaultValue = _ref.defaultValue, defaultValue = _ref$defaultValue === void 0 ? null : _ref$defaultValue, propsInputValue = _ref.inputValue, propsMenuIsOpen = _ref.menuIsOpen, propsOnChange = _ref.onChange, propsOnInputChange = _ref.onInputChange, propsOnMenuClose = _ref.onMenuClose, propsOnMenuOpen = _ref.onMenuOpen, propsValue = _ref.value, restSelectProps = (0, $bwPfh.default)(_ref, $59e179ee89746bd6$var$_excluded);
    var _useState = (0, $eUqFw.useState)(propsInputValue !== undefined ? propsInputValue : defaultInputValue), _useState2 = (0, $aKcqM.default)(_useState, 2), stateInputValue = _useState2[0], setStateInputValue = _useState2[1];
    var _useState3 = (0, $eUqFw.useState)(propsMenuIsOpen !== undefined ? propsMenuIsOpen : defaultMenuIsOpen), _useState4 = (0, $aKcqM.default)(_useState3, 2), stateMenuIsOpen = _useState4[0], setStateMenuIsOpen = _useState4[1];
    var _useState5 = (0, $eUqFw.useState)(propsValue !== undefined ? propsValue : defaultValue), _useState6 = (0, $aKcqM.default)(_useState5, 2), stateValue = _useState6[0], setStateValue = _useState6[1];
    var onChange = (0, $eUqFw.useCallback)(function(value, actionMeta) {
        if (typeof propsOnChange === 'function') propsOnChange(value, actionMeta);
        setStateValue(value);
    }, [
        propsOnChange
    ]);
    var onInputChange = (0, $eUqFw.useCallback)(function(value, actionMeta) {
        var newValue;
        if (typeof propsOnInputChange === 'function') newValue = propsOnInputChange(value, actionMeta);
        setStateInputValue(newValue !== undefined ? newValue : value);
    }, [
        propsOnInputChange
    ]);
    var onMenuOpen = (0, $eUqFw.useCallback)(function() {
        if (typeof propsOnMenuOpen === 'function') propsOnMenuOpen();
        setStateMenuIsOpen(true);
    }, [
        propsOnMenuOpen
    ]);
    var onMenuClose = (0, $eUqFw.useCallback)(function() {
        if (typeof propsOnMenuClose === 'function') propsOnMenuClose();
        setStateMenuIsOpen(false);
    }, [
        propsOnMenuClose
    ]);
    var inputValue = propsInputValue !== undefined ? propsInputValue : stateInputValue;
    var menuIsOpen = propsMenuIsOpen !== undefined ? propsMenuIsOpen : stateMenuIsOpen;
    var value = propsValue !== undefined ? propsValue : stateValue;
    return (0, $1Xn5q.default)((0, $1Xn5q.default)({}, restSelectProps), {}, {
        inputValue: inputValue,
        menuIsOpen: menuIsOpen,
        onChange: onChange,
        onInputChange: onInputChange,
        onMenuClose: onMenuClose,
        onMenuOpen: onMenuOpen,
        value: value
    });
}

});

parcelRegister("cEc3i", function(module, exports) {

$parcel$export(module.exports, "c", () => $935291c440101c41$export$db3b6bfb95261072);
$parcel$export(module.exports, "b", () => $935291c440101c41$export$8b22cf2602fb60ce);
$parcel$export(module.exports, "g", () => $935291c440101c41$export$39b482c5e57630a8);
$parcel$export(module.exports, "m", () => $935291c440101c41$export$953cecd6e717a553);
$parcel$export(module.exports, "S", () => $935291c440101c41$export$25ce5a424b770e84);

var $kU09D = parcelRequire("kU09D");

var $1Xn5q = parcelRequire("1Xn5q");

var $lDSrn = parcelRequire("lDSrn");

var $lIEGP = parcelRequire("lIEGP");

var $eT4IF = parcelRequire("eT4IF");

var $7Dzgl = parcelRequire("7Dzgl");

var $fVK4C = parcelRequire("fVK4C");

var $eUqFw = parcelRequire("eUqFw");

var $jQxSL = parcelRequire("jQxSL");

var $byn9U = parcelRequire("byn9U");

var $5iWql = parcelRequire("5iWql");

var $bwPfh = parcelRequire("bwPfh");
function $935291c440101c41$var$_EMOTION_STRINGIFIED_CSS_ERROR__$2() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// Assistive text to describe visual elements. Hidden for sighted users.
var $935291c440101c41$var$_ref = {
    name: "7pg0cj-a11yText",
    styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap"
};
var $935291c440101c41$var$A11yText = function A11yText(props) {
    return (0, $byn9U.jsx)("span", (0, $kU09D.default)({
        css: $935291c440101c41$var$_ref
    }, props));
};
var $935291c440101c41$var$defaultAriaLiveMessages = {
    guidance: function guidance(props) {
        var isSearchable = props.isSearchable, isMulti = props.isMulti, isDisabled = props.isDisabled, tabSelectsValue = props.tabSelectsValue, context = props.context;
        switch(context){
            case 'menu':
                return "Use Up and Down to choose options".concat(isDisabled ? '' : ', press Enter to select the currently focused option', ", press Escape to exit the menu").concat(tabSelectsValue ? ', press Tab to select the option and exit the menu' : '', ".");
            case 'input':
                return "".concat(props['aria-label'] || 'Select', " is focused ").concat(isSearchable ? ',type to refine list' : '', ", press Down to open the menu, ").concat(isMulti ? ' press left to focus selected values' : '');
            case 'value':
                return 'Use left and right to toggle between focused values, press Backspace to remove the currently focused value';
            default:
                return '';
        }
    },
    onChange: function onChange(props) {
        var action = props.action, _props$label = props.label, label = _props$label === void 0 ? '' : _props$label, labels = props.labels, isDisabled = props.isDisabled;
        switch(action){
            case 'deselect-option':
            case 'pop-value':
            case 'remove-value':
                return "option ".concat(label, ", deselected.");
            case 'clear':
                return 'All selected options have been cleared.';
            case 'initial-input-focus':
                return "option".concat(labels.length > 1 ? 's' : '', " ").concat(labels.join(','), ", selected.");
            case 'select-option':
                return isDisabled ? "option ".concat(label, " is disabled. Select another option.") : "option ".concat(label, ", selected.");
            default:
                return '';
        }
    },
    onFocus: function onFocus(props) {
        var context = props.context, focused = props.focused, options = props.options, _props$label2 = props.label, label = _props$label2 === void 0 ? '' : _props$label2, selectValue = props.selectValue, isDisabled = props.isDisabled, isSelected = props.isSelected;
        var getArrayIndex = function getArrayIndex(arr, item) {
            return arr && arr.length ? "".concat(arr.indexOf(item) + 1, " of ").concat(arr.length) : '';
        };
        if (context === 'value' && selectValue) return "value ".concat(label, " focused, ").concat(getArrayIndex(selectValue, focused), ".");
        if (context === 'menu') {
            var disabled = isDisabled ? ' disabled' : '';
            var status = "".concat(isSelected ? 'selected' : 'focused').concat(disabled);
            return "option ".concat(label, " ").concat(status, ", ").concat(getArrayIndex(options, focused), ".");
        }
        return '';
    },
    onFilter: function onFilter(props) {
        var inputValue = props.inputValue, resultsMessage = props.resultsMessage;
        return "".concat(resultsMessage).concat(inputValue ? ' for search term ' + inputValue : '', ".");
    }
};
var $935291c440101c41$var$LiveRegion = function LiveRegion(props) {
    var ariaSelection = props.ariaSelection, focusedOption = props.focusedOption, focusedValue = props.focusedValue, focusableOptions = props.focusableOptions, isFocused = props.isFocused, selectValue = props.selectValue, selectProps = props.selectProps, id = props.id;
    var ariaLiveMessages = selectProps.ariaLiveMessages, getOptionLabel = selectProps.getOptionLabel, inputValue = selectProps.inputValue, isMulti = selectProps.isMulti, isOptionDisabled = selectProps.isOptionDisabled, isSearchable = selectProps.isSearchable, menuIsOpen = selectProps.menuIsOpen, options = selectProps.options, screenReaderStatus = selectProps.screenReaderStatus, tabSelectsValue = selectProps.tabSelectsValue;
    var ariaLabel = selectProps['aria-label'];
    var ariaLive = selectProps['aria-live'];
    // Update aria live message configuration when prop changes
    var messages = (0, $eUqFw.useMemo)(function() {
        return (0, $1Xn5q.default)((0, $1Xn5q.default)({}, $935291c440101c41$var$defaultAriaLiveMessages), ariaLiveMessages || {});
    }, [
        ariaLiveMessages
    ]);
    // Update aria live selected option when prop changes
    var ariaSelected = (0, $eUqFw.useMemo)(function() {
        var message = '';
        if (ariaSelection && messages.onChange) {
            var option = ariaSelection.option, selectedOptions = ariaSelection.options, removedValue = ariaSelection.removedValue, removedValues = ariaSelection.removedValues, value = ariaSelection.value;
            // select-option when !isMulti does not return option so we assume selected option is value
            var asOption = function asOption(val) {
                return !Array.isArray(val) ? val : null;
            };
            // If there is just one item from the action then get its label
            var selected = removedValue || option || asOption(value);
            var label = selected ? getOptionLabel(selected) : '';
            // If there are multiple items from the action then return an array of labels
            var multiSelected = selectedOptions || removedValues || undefined;
            var labels = multiSelected ? multiSelected.map(getOptionLabel) : [];
            var onChangeProps = (0, $1Xn5q.default)({
                // multiSelected items are usually items that have already been selected
                // or set by the user as a default value so we assume they are not disabled
                isDisabled: selected && isOptionDisabled(selected, selectValue),
                label: label,
                labels: labels
            }, ariaSelection);
            message = messages.onChange(onChangeProps);
        }
        return message;
    }, [
        ariaSelection,
        messages,
        isOptionDisabled,
        selectValue,
        getOptionLabel
    ]);
    var ariaFocused = (0, $eUqFw.useMemo)(function() {
        var focusMsg = '';
        var focused = focusedOption || focusedValue;
        var isSelected = !!(focusedOption && selectValue && selectValue.includes(focusedOption));
        if (focused && messages.onFocus) {
            var onFocusProps = {
                focused: focused,
                label: getOptionLabel(focused),
                isDisabled: isOptionDisabled(focused, selectValue),
                isSelected: isSelected,
                options: focusableOptions,
                context: focused === focusedOption ? 'menu' : 'value',
                selectValue: selectValue
            };
            focusMsg = messages.onFocus(onFocusProps);
        }
        return focusMsg;
    }, [
        focusedOption,
        focusedValue,
        getOptionLabel,
        isOptionDisabled,
        messages,
        focusableOptions,
        selectValue
    ]);
    var ariaResults = (0, $eUqFw.useMemo)(function() {
        var resultsMsg = '';
        if (menuIsOpen && options.length && messages.onFilter) {
            var resultsMessage = screenReaderStatus({
                count: focusableOptions.length
            });
            resultsMsg = messages.onFilter({
                inputValue: inputValue,
                resultsMessage: resultsMessage
            });
        }
        return resultsMsg;
    }, [
        focusableOptions,
        inputValue,
        menuIsOpen,
        messages,
        options,
        screenReaderStatus
    ]);
    var ariaGuidance = (0, $eUqFw.useMemo)(function() {
        var guidanceMsg = '';
        if (messages.guidance) {
            var context = focusedValue ? 'value' : menuIsOpen ? 'menu' : 'input';
            guidanceMsg = messages.guidance({
                'aria-label': ariaLabel,
                context: context,
                isDisabled: focusedOption && isOptionDisabled(focusedOption, selectValue),
                isMulti: isMulti,
                isSearchable: isSearchable,
                tabSelectsValue: tabSelectsValue
            });
        }
        return guidanceMsg;
    }, [
        ariaLabel,
        focusedOption,
        focusedValue,
        isMulti,
        isOptionDisabled,
        isSearchable,
        menuIsOpen,
        messages,
        selectValue,
        tabSelectsValue
    ]);
    var ariaContext = "".concat(ariaFocused, " ").concat(ariaResults, " ").concat(ariaGuidance);
    var ScreenReaderText = (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, (0, $byn9U.jsx)("span", {
        id: "aria-selection"
    }, ariaSelected), (0, $byn9U.jsx)("span", {
        id: "aria-context"
    }, ariaContext));
    var isInitialFocus = (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus';
    return (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, (0, $byn9U.jsx)($935291c440101c41$var$A11yText, {
        id: id
    }, isInitialFocus && ScreenReaderText), (0, $byn9U.jsx)($935291c440101c41$var$A11yText, {
        "aria-live": ariaLive,
        "aria-atomic": "false",
        "aria-relevant": "additions text"
    }, isFocused && !isInitialFocus && ScreenReaderText));
};
var $935291c440101c41$var$diacritics = [
    {
        base: 'A',
        letters: "A\u24B6\uFF21\xC0\xC1\xC2\u1EA6\u1EA4\u1EAA\u1EA8\xC3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\xC4\u01DE\u1EA2\xC5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F"
    },
    {
        base: 'AA',
        letters: "\uA732"
    },
    {
        base: 'AE',
        letters: "\xC6\u01FC\u01E2"
    },
    {
        base: 'AO',
        letters: "\uA734"
    },
    {
        base: 'AU',
        letters: "\uA736"
    },
    {
        base: 'AV',
        letters: "\uA738\uA73A"
    },
    {
        base: 'AY',
        letters: "\uA73C"
    },
    {
        base: 'B',
        letters: "B\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181"
    },
    {
        base: 'C',
        letters: "C\u24B8\uFF23\u0106\u0108\u010A\u010C\xC7\u1E08\u0187\u023B\uA73E"
    },
    {
        base: 'D',
        letters: "D\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779"
    },
    {
        base: 'DZ',
        letters: "\u01F1\u01C4"
    },
    {
        base: 'Dz',
        letters: "\u01F2\u01C5"
    },
    {
        base: 'E',
        letters: "E\u24BA\uFF25\xC8\xC9\xCA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\xCB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E"
    },
    {
        base: 'F',
        letters: "F\u24BB\uFF26\u1E1E\u0191\uA77B"
    },
    {
        base: 'G',
        letters: "G\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E"
    },
    {
        base: 'H',
        letters: "H\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D"
    },
    {
        base: 'I',
        letters: "I\u24BE\uFF29\xCC\xCD\xCE\u0128\u012A\u012C\u0130\xCF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197"
    },
    {
        base: 'J',
        letters: "J\u24BF\uFF2A\u0134\u0248"
    },
    {
        base: 'K',
        letters: "K\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2"
    },
    {
        base: 'L',
        letters: "L\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780"
    },
    {
        base: 'LJ',
        letters: "\u01C7"
    },
    {
        base: 'Lj',
        letters: "\u01C8"
    },
    {
        base: 'M',
        letters: "M\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C"
    },
    {
        base: 'N',
        letters: "N\u24C3\uFF2E\u01F8\u0143\xD1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4"
    },
    {
        base: 'NJ',
        letters: "\u01CA"
    },
    {
        base: 'Nj',
        letters: "\u01CB"
    },
    {
        base: 'O',
        letters: "O\u24C4\uFF2F\xD2\xD3\xD4\u1ED2\u1ED0\u1ED6\u1ED4\xD5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\xD6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\xD8\u01FE\u0186\u019F\uA74A\uA74C"
    },
    {
        base: 'OI',
        letters: "\u01A2"
    },
    {
        base: 'OO',
        letters: "\uA74E"
    },
    {
        base: 'OU',
        letters: "\u0222"
    },
    {
        base: 'P',
        letters: "P\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754"
    },
    {
        base: 'Q',
        letters: "Q\u24C6\uFF31\uA756\uA758\u024A"
    },
    {
        base: 'R',
        letters: "R\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782"
    },
    {
        base: 'S',
        letters: "S\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784"
    },
    {
        base: 'T',
        letters: "T\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786"
    },
    {
        base: 'TZ',
        letters: "\uA728"
    },
    {
        base: 'U',
        letters: "U\u24CA\uFF35\xD9\xDA\xDB\u0168\u1E78\u016A\u1E7A\u016C\xDC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244"
    },
    {
        base: 'V',
        letters: "V\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245"
    },
    {
        base: 'VY',
        letters: "\uA760"
    },
    {
        base: 'W',
        letters: "W\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72"
    },
    {
        base: 'X',
        letters: "X\u24CD\uFF38\u1E8A\u1E8C"
    },
    {
        base: 'Y',
        letters: "Y\u24CE\uFF39\u1EF2\xDD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE"
    },
    {
        base: 'Z',
        letters: "Z\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762"
    },
    {
        base: 'a',
        letters: "a\u24D0\uFF41\u1E9A\xE0\xE1\xE2\u1EA7\u1EA5\u1EAB\u1EA9\xE3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\xE4\u01DF\u1EA3\xE5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250"
    },
    {
        base: 'aa',
        letters: "\uA733"
    },
    {
        base: 'ae',
        letters: "\xE6\u01FD\u01E3"
    },
    {
        base: 'ao',
        letters: "\uA735"
    },
    {
        base: 'au',
        letters: "\uA737"
    },
    {
        base: 'av',
        letters: "\uA739\uA73B"
    },
    {
        base: 'ay',
        letters: "\uA73D"
    },
    {
        base: 'b',
        letters: "b\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253"
    },
    {
        base: 'c',
        letters: "c\u24D2\uFF43\u0107\u0109\u010B\u010D\xE7\u1E09\u0188\u023C\uA73F\u2184"
    },
    {
        base: 'd',
        letters: "d\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A"
    },
    {
        base: 'dz',
        letters: "\u01F3\u01C6"
    },
    {
        base: 'e',
        letters: "e\u24D4\uFF45\xE8\xE9\xEA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\xEB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD"
    },
    {
        base: 'f',
        letters: "f\u24D5\uFF46\u1E1F\u0192\uA77C"
    },
    {
        base: 'g',
        letters: "g\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F"
    },
    {
        base: 'h',
        letters: "h\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265"
    },
    {
        base: 'hv',
        letters: "\u0195"
    },
    {
        base: 'i',
        letters: "i\u24D8\uFF49\xEC\xED\xEE\u0129\u012B\u012D\xEF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131"
    },
    {
        base: 'j',
        letters: "j\u24D9\uFF4A\u0135\u01F0\u0249"
    },
    {
        base: 'k',
        letters: "k\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3"
    },
    {
        base: 'l',
        letters: "l\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747"
    },
    {
        base: 'lj',
        letters: "\u01C9"
    },
    {
        base: 'm',
        letters: "m\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F"
    },
    {
        base: 'n',
        letters: "n\u24DD\uFF4E\u01F9\u0144\xF1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5"
    },
    {
        base: 'nj',
        letters: "\u01CC"
    },
    {
        base: 'o',
        letters: "o\u24DE\uFF4F\xF2\xF3\xF4\u1ED3\u1ED1\u1ED7\u1ED5\xF5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\xF6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\xF8\u01FF\u0254\uA74B\uA74D\u0275"
    },
    {
        base: 'oi',
        letters: "\u01A3"
    },
    {
        base: 'ou',
        letters: "\u0223"
    },
    {
        base: 'oo',
        letters: "\uA74F"
    },
    {
        base: 'p',
        letters: "p\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755"
    },
    {
        base: 'q',
        letters: "q\u24E0\uFF51\u024B\uA757\uA759"
    },
    {
        base: 'r',
        letters: "r\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783"
    },
    {
        base: 's',
        letters: "s\u24E2\uFF53\xDF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B"
    },
    {
        base: 't',
        letters: "t\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787"
    },
    {
        base: 'tz',
        letters: "\uA729"
    },
    {
        base: 'u',
        letters: "u\u24E4\uFF55\xF9\xFA\xFB\u0169\u1E79\u016B\u1E7B\u016D\xFC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289"
    },
    {
        base: 'v',
        letters: "v\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C"
    },
    {
        base: 'vy',
        letters: "\uA761"
    },
    {
        base: 'w',
        letters: "w\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73"
    },
    {
        base: 'x',
        letters: "x\u24E7\uFF58\u1E8B\u1E8D"
    },
    {
        base: 'y',
        letters: "y\u24E8\uFF59\u1EF3\xFD\u0177\u1EF9\u0233\u1E8F\xFF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF"
    },
    {
        base: 'z',
        letters: "z\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763"
    }
];
var $935291c440101c41$var$anyDiacritic = new RegExp('[' + $935291c440101c41$var$diacritics.map(function(d) {
    return d.letters;
}).join('') + ']', 'g');
var $935291c440101c41$var$diacriticToBase = {};
for(var $935291c440101c41$var$i = 0; $935291c440101c41$var$i < $935291c440101c41$var$diacritics.length; $935291c440101c41$var$i++){
    var $935291c440101c41$var$diacritic = $935291c440101c41$var$diacritics[$935291c440101c41$var$i];
    for(var $935291c440101c41$var$j = 0; $935291c440101c41$var$j < $935291c440101c41$var$diacritic.letters.length; $935291c440101c41$var$j++)$935291c440101c41$var$diacriticToBase[$935291c440101c41$var$diacritic.letters[$935291c440101c41$var$j]] = $935291c440101c41$var$diacritic.base;
}
var $935291c440101c41$var$stripDiacritics = function stripDiacritics(str) {
    return str.replace($935291c440101c41$var$anyDiacritic, function(match) {
        return $935291c440101c41$var$diacriticToBase[match];
    });
};
var $935291c440101c41$var$memoizedStripDiacriticsForInput = (0, $5iWql.default)($935291c440101c41$var$stripDiacritics);
var $935291c440101c41$var$trimString = function trimString(str) {
    return str.replace(/^\s+|\s+$/g, '');
};
var $935291c440101c41$var$defaultStringify = function defaultStringify(option) {
    return "".concat(option.label, " ").concat(option.value);
};
var $935291c440101c41$export$db3b6bfb95261072 = function createFilter(config) {
    return function(option, rawInput) {
        // eslint-disable-next-line no-underscore-dangle
        if (option.data.__isNew__) return true;
        var _ignoreCase$ignoreAcc = (0, $1Xn5q.default)({
            ignoreCase: true,
            ignoreAccents: true,
            stringify: $935291c440101c41$var$defaultStringify,
            trim: true,
            matchFrom: 'any'
        }, config), ignoreCase = _ignoreCase$ignoreAcc.ignoreCase, ignoreAccents = _ignoreCase$ignoreAcc.ignoreAccents, stringify = _ignoreCase$ignoreAcc.stringify, trim = _ignoreCase$ignoreAcc.trim, matchFrom = _ignoreCase$ignoreAcc.matchFrom;
        var input = trim ? $935291c440101c41$var$trimString(rawInput) : rawInput;
        var candidate = trim ? $935291c440101c41$var$trimString(stringify(option)) : stringify(option);
        if (ignoreCase) {
            input = input.toLowerCase();
            candidate = candidate.toLowerCase();
        }
        if (ignoreAccents) {
            input = $935291c440101c41$var$memoizedStripDiacriticsForInput(input);
            candidate = $935291c440101c41$var$stripDiacritics(candidate);
        }
        return matchFrom === 'start' ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
    };
};
var $935291c440101c41$var$_excluded = [
    "innerRef"
];
function $935291c440101c41$var$DummyInput(_ref) {
    var innerRef = _ref.innerRef, props = (0, $bwPfh.default)(_ref, $935291c440101c41$var$_excluded);
    // Remove animation props not meant for HTML elements
    var filteredProps = (0, $jQxSL.r)(props, 'onExited', 'in', 'enter', 'exit', 'appear');
    return (0, $byn9U.jsx)("input", (0, $kU09D.default)({
        ref: innerRef
    }, filteredProps, {
        css: /*#__PURE__*/ (0, $byn9U.css)({
            label: 'dummyInput',
            // get rid of any default styles
            background: 0,
            border: 0,
            // important! this hides the flashing cursor
            caretColor: 'transparent',
            fontSize: 'inherit',
            gridArea: '1 / 1 / 2 / 3',
            outline: 0,
            padding: 0,
            // important! without `width` browsers won't allow focus
            width: 1,
            // remove cursor on desktop
            color: 'transparent',
            // remove cursor on mobile whilst maintaining "scroll into view" behaviour
            left: -100,
            opacity: 0,
            position: 'relative',
            transform: 'scale(.01)'
        }, "", "")
    }));
}
var $935291c440101c41$var$cancelScroll = function cancelScroll(event) {
    event.preventDefault();
    event.stopPropagation();
};
function $935291c440101c41$var$useScrollCapture(_ref) {
    var isEnabled = _ref.isEnabled, onBottomArrive = _ref.onBottomArrive, onBottomLeave = _ref.onBottomLeave, onTopArrive = _ref.onTopArrive, onTopLeave = _ref.onTopLeave;
    var isBottom = (0, $eUqFw.useRef)(false);
    var isTop = (0, $eUqFw.useRef)(false);
    var touchStart = (0, $eUqFw.useRef)(0);
    var scrollTarget = (0, $eUqFw.useRef)(null);
    var handleEventDelta = (0, $eUqFw.useCallback)(function(event, delta) {
        if (scrollTarget.current === null) return;
        var _scrollTarget$current = scrollTarget.current, scrollTop = _scrollTarget$current.scrollTop, scrollHeight = _scrollTarget$current.scrollHeight, clientHeight = _scrollTarget$current.clientHeight;
        var target = scrollTarget.current;
        var isDeltaPositive = delta > 0;
        var availableScroll = scrollHeight - clientHeight - scrollTop;
        var shouldCancelScroll = false;
        // reset bottom/top flags
        if (availableScroll > delta && isBottom.current) {
            if (onBottomLeave) onBottomLeave(event);
            isBottom.current = false;
        }
        if (isDeltaPositive && isTop.current) {
            if (onTopLeave) onTopLeave(event);
            isTop.current = false;
        }
        // bottom limit
        if (isDeltaPositive && delta > availableScroll) {
            if (onBottomArrive && !isBottom.current) onBottomArrive(event);
            target.scrollTop = scrollHeight;
            shouldCancelScroll = true;
            isBottom.current = true;
        // top limit
        } else if (!isDeltaPositive && -delta > scrollTop) {
            if (onTopArrive && !isTop.current) onTopArrive(event);
            target.scrollTop = 0;
            shouldCancelScroll = true;
            isTop.current = true;
        }
        // cancel scroll
        if (shouldCancelScroll) $935291c440101c41$var$cancelScroll(event);
    }, [
        onBottomArrive,
        onBottomLeave,
        onTopArrive,
        onTopLeave
    ]);
    var onWheel = (0, $eUqFw.useCallback)(function(event) {
        handleEventDelta(event, event.deltaY);
    }, [
        handleEventDelta
    ]);
    var onTouchStart = (0, $eUqFw.useCallback)(function(event) {
        // set touch start so we can calculate touchmove delta
        touchStart.current = event.changedTouches[0].clientY;
    }, []);
    var onTouchMove = (0, $eUqFw.useCallback)(function(event) {
        var deltaY = touchStart.current - event.changedTouches[0].clientY;
        handleEventDelta(event, deltaY);
    }, [
        handleEventDelta
    ]);
    var startListening = (0, $eUqFw.useCallback)(function(el) {
        // bail early if no element is available to attach to
        if (!el) return;
        var notPassive = (0, $jQxSL.s) ? {
            passive: false
        } : false;
        el.addEventListener('wheel', onWheel, notPassive);
        el.addEventListener('touchstart', onTouchStart, notPassive);
        el.addEventListener('touchmove', onTouchMove, notPassive);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    var stopListening = (0, $eUqFw.useCallback)(function(el) {
        // bail early if no element is available to detach from
        if (!el) return;
        el.removeEventListener('wheel', onWheel, false);
        el.removeEventListener('touchstart', onTouchStart, false);
        el.removeEventListener('touchmove', onTouchMove, false);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    (0, $eUqFw.useEffect)(function() {
        if (!isEnabled) return;
        var element = scrollTarget.current;
        startListening(element);
        return function() {
            stopListening(element);
        };
    }, [
        isEnabled,
        startListening,
        stopListening
    ]);
    return function(element) {
        scrollTarget.current = element;
    };
}
var $935291c440101c41$var$STYLE_KEYS = [
    'boxSizing',
    'height',
    'overflow',
    'paddingRight',
    'position'
];
var $935291c440101c41$var$LOCK_STYLES = {
    boxSizing: 'border-box',
    // account for possible declaration `width: 100%;` on body
    overflow: 'hidden',
    position: 'relative',
    height: '100%'
};
function $935291c440101c41$var$preventTouchMove(e) {
    e.preventDefault();
}
function $935291c440101c41$var$allowTouchMove(e) {
    e.stopPropagation();
}
function $935291c440101c41$var$preventInertiaScroll() {
    var top = this.scrollTop;
    var totalScroll = this.scrollHeight;
    var currentScroll = top + this.offsetHeight;
    if (top === 0) this.scrollTop = 1;
    else if (currentScroll === totalScroll) this.scrollTop = top - 1;
}
// `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface
function $935291c440101c41$var$isTouchDevice() {
    return 'ontouchstart' in window || navigator.maxTouchPoints;
}
var $935291c440101c41$var$canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
var $935291c440101c41$var$activeScrollLocks = 0;
var $935291c440101c41$var$listenerOptions = {
    capture: false,
    passive: false
};
function $935291c440101c41$var$useScrollLock(_ref) {
    var isEnabled = _ref.isEnabled, _ref$accountForScroll = _ref.accountForScrollbars, accountForScrollbars = _ref$accountForScroll === void 0 ? true : _ref$accountForScroll;
    var originalStyles = (0, $eUqFw.useRef)({});
    var scrollTarget = (0, $eUqFw.useRef)(null);
    var addScrollLock = (0, $eUqFw.useCallback)(function(touchScrollTarget) {
        if (!$935291c440101c41$var$canUseDOM) return;
        var target = document.body;
        var targetStyle = target && target.style;
        if (accountForScrollbars) // store any styles already applied to the body
        $935291c440101c41$var$STYLE_KEYS.forEach(function(key) {
            var val = targetStyle && targetStyle[key];
            originalStyles.current[key] = val;
        });
        // apply the lock styles and padding if this is the first scroll lock
        if (accountForScrollbars && $935291c440101c41$var$activeScrollLocks < 1) {
            var currentPadding = parseInt(originalStyles.current.paddingRight, 10) || 0;
            var clientWidth = document.body ? document.body.clientWidth : 0;
            var adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
            Object.keys($935291c440101c41$var$LOCK_STYLES).forEach(function(key) {
                var val = $935291c440101c41$var$LOCK_STYLES[key];
                if (targetStyle) targetStyle[key] = val;
            });
            if (targetStyle) targetStyle.paddingRight = "".concat(adjustedPadding, "px");
        }
        // account for touch devices
        if (target && $935291c440101c41$var$isTouchDevice()) {
            // Mobile Safari ignores { overflow: hidden } declaration on the body.
            target.addEventListener('touchmove', $935291c440101c41$var$preventTouchMove, $935291c440101c41$var$listenerOptions);
            // Allow scroll on provided target
            if (touchScrollTarget) {
                touchScrollTarget.addEventListener('touchstart', $935291c440101c41$var$preventInertiaScroll, $935291c440101c41$var$listenerOptions);
                touchScrollTarget.addEventListener('touchmove', $935291c440101c41$var$allowTouchMove, $935291c440101c41$var$listenerOptions);
            }
        }
        // increment active scroll locks
        $935291c440101c41$var$activeScrollLocks += 1;
    }, [
        accountForScrollbars
    ]);
    var removeScrollLock = (0, $eUqFw.useCallback)(function(touchScrollTarget) {
        if (!$935291c440101c41$var$canUseDOM) return;
        var target = document.body;
        var targetStyle = target && target.style;
        // safely decrement active scroll locks
        $935291c440101c41$var$activeScrollLocks = Math.max($935291c440101c41$var$activeScrollLocks - 1, 0);
        // reapply original body styles, if any
        if (accountForScrollbars && $935291c440101c41$var$activeScrollLocks < 1) $935291c440101c41$var$STYLE_KEYS.forEach(function(key) {
            var val = originalStyles.current[key];
            if (targetStyle) targetStyle[key] = val;
        });
        // remove touch listeners
        if (target && $935291c440101c41$var$isTouchDevice()) {
            target.removeEventListener('touchmove', $935291c440101c41$var$preventTouchMove, $935291c440101c41$var$listenerOptions);
            if (touchScrollTarget) {
                touchScrollTarget.removeEventListener('touchstart', $935291c440101c41$var$preventInertiaScroll, $935291c440101c41$var$listenerOptions);
                touchScrollTarget.removeEventListener('touchmove', $935291c440101c41$var$allowTouchMove, $935291c440101c41$var$listenerOptions);
            }
        }
    }, [
        accountForScrollbars
    ]);
    (0, $eUqFw.useEffect)(function() {
        if (!isEnabled) return;
        var element = scrollTarget.current;
        addScrollLock(element);
        return function() {
            removeScrollLock(element);
        };
    }, [
        isEnabled,
        addScrollLock,
        removeScrollLock
    ]);
    return function(element) {
        scrollTarget.current = element;
    };
}
function $935291c440101c41$var$_EMOTION_STRINGIFIED_CSS_ERROR__$1() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $935291c440101c41$var$blurSelectInput = function blurSelectInput() {
    return document.activeElement && document.activeElement.blur();
};
var $935291c440101c41$var$_ref2$1 = {
    name: "1kfdb0e",
    styles: "position:fixed;left:0;bottom:0;right:0;top:0"
};
function $935291c440101c41$var$ScrollManager(_ref) {
    var children = _ref.children, lockEnabled = _ref.lockEnabled, _ref$captureEnabled = _ref.captureEnabled, captureEnabled = _ref$captureEnabled === void 0 ? true : _ref$captureEnabled, onBottomArrive = _ref.onBottomArrive, onBottomLeave = _ref.onBottomLeave, onTopArrive = _ref.onTopArrive, onTopLeave = _ref.onTopLeave;
    var setScrollCaptureTarget = $935291c440101c41$var$useScrollCapture({
        isEnabled: captureEnabled,
        onBottomArrive: onBottomArrive,
        onBottomLeave: onBottomLeave,
        onTopArrive: onTopArrive,
        onTopLeave: onTopLeave
    });
    var setScrollLockTarget = $935291c440101c41$var$useScrollLock({
        isEnabled: lockEnabled
    });
    var targetRef = function targetRef(element) {
        setScrollCaptureTarget(element);
        setScrollLockTarget(element);
    };
    return (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, lockEnabled && (0, $byn9U.jsx)("div", {
        onClick: $935291c440101c41$var$blurSelectInput,
        css: $935291c440101c41$var$_ref2$1
    }), children(targetRef));
}
function $935291c440101c41$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $935291c440101c41$var$_ref2 = {
    name: "1a0ro4n-requiredInput",
    styles: "label:requiredInput;opacity:0;pointer-events:none;position:absolute;bottom:0;left:0;right:0;width:100%"
};
var $935291c440101c41$var$RequiredInput = function RequiredInput(_ref) {
    var name = _ref.name, onFocus = _ref.onFocus;
    return (0, $byn9U.jsx)("input", {
        required: true,
        name: name,
        tabIndex: -1,
        "aria-hidden": "true",
        onFocus: onFocus,
        css: $935291c440101c41$var$_ref2,
        value: "",
        onChange: function onChange() {}
    });
};
var $935291c440101c41$var$formatGroupLabel = function formatGroupLabel(group) {
    return group.label;
};
var $935291c440101c41$export$8b22cf2602fb60ce = function getOptionLabel(option) {
    return option.label;
};
var $935291c440101c41$export$39b482c5e57630a8 = function getOptionValue(option) {
    return option.value;
};
var $935291c440101c41$var$isOptionDisabled = function isOptionDisabled(option) {
    return !!option.isDisabled;
};
var $935291c440101c41$var$defaultStyles = {
    clearIndicator: (0, $jQxSL.a),
    container: (0, $jQxSL.b),
    control: (0, $jQxSL.d),
    dropdownIndicator: (0, $jQxSL.e),
    group: (0, $jQxSL.g),
    groupHeading: (0, $jQxSL.f),
    indicatorsContainer: (0, $jQxSL.i),
    indicatorSeparator: (0, $jQxSL.h),
    input: (0, $jQxSL.j),
    loadingIndicator: (0, $jQxSL.l),
    loadingMessage: (0, $jQxSL.k),
    menu: (0, $jQxSL.m),
    menuList: (0, $jQxSL.n),
    menuPortal: (0, $jQxSL.o),
    multiValue: (0, $jQxSL.p),
    multiValueLabel: (0, $jQxSL.q),
    multiValueRemove: (0, $jQxSL.t),
    noOptionsMessage: (0, $jQxSL.u),
    option: (0, $jQxSL.v),
    placeholder: (0, $jQxSL.w),
    singleValue: (0, $jQxSL.x),
    valueContainer: (0, $jQxSL.y)
};
// Merge Utility
// Allows consumers to extend a base Select with additional styles
function $935291c440101c41$export$953cecd6e717a553(source) {
    var target = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    // initialize with source styles
    var styles = (0, $1Xn5q.default)({}, source);
    // massage in target styles
    Object.keys(target).forEach(function(keyAsString) {
        var key = keyAsString;
        if (source[key]) styles[key] = function(rsCss, props) {
            return target[key](source[key](rsCss, props), props);
        };
        else styles[key] = target[key];
    });
    return styles;
}
var $935291c440101c41$var$colors = {
    primary: '#2684FF',
    primary75: '#4C9AFF',
    primary50: '#B2D4FF',
    primary25: '#DEEBFF',
    danger: '#DE350B',
    dangerLight: '#FFBDAD',
    neutral0: 'hsl(0, 0%, 100%)',
    neutral5: 'hsl(0, 0%, 95%)',
    neutral10: 'hsl(0, 0%, 90%)',
    neutral20: 'hsl(0, 0%, 80%)',
    neutral30: 'hsl(0, 0%, 70%)',
    neutral40: 'hsl(0, 0%, 60%)',
    neutral50: 'hsl(0, 0%, 50%)',
    neutral60: 'hsl(0, 0%, 40%)',
    neutral70: 'hsl(0, 0%, 30%)',
    neutral80: 'hsl(0, 0%, 20%)',
    neutral90: 'hsl(0, 0%, 10%)'
};
var $935291c440101c41$var$borderRadius = 4;
// Used to calculate consistent margin/padding on elements
var $935291c440101c41$var$baseUnit = 4;
// The minimum height of the control
var $935291c440101c41$var$controlHeight = 38;
// The amount of space between the control and menu */
var $935291c440101c41$var$menuGutter = $935291c440101c41$var$baseUnit * 2;
var $935291c440101c41$var$spacing = {
    baseUnit: $935291c440101c41$var$baseUnit,
    controlHeight: $935291c440101c41$var$controlHeight,
    menuGutter: $935291c440101c41$var$menuGutter
};
var $935291c440101c41$export$4368d992c4eafac0 = {
    borderRadius: $935291c440101c41$var$borderRadius,
    colors: $935291c440101c41$var$colors,
    spacing: $935291c440101c41$var$spacing
};
var $935291c440101c41$export$407448d2b89b1813 = {
    'aria-live': 'polite',
    backspaceRemovesValue: true,
    blurInputOnSelect: (0, $jQxSL.z)(),
    captureMenuScroll: !(0, $jQxSL.z)(),
    classNames: {},
    closeMenuOnSelect: true,
    closeMenuOnScroll: false,
    components: {},
    controlShouldRenderValue: true,
    escapeClearsValue: false,
    filterOption: $935291c440101c41$export$db3b6bfb95261072(),
    formatGroupLabel: $935291c440101c41$var$formatGroupLabel,
    getOptionLabel: $935291c440101c41$export$8b22cf2602fb60ce,
    getOptionValue: $935291c440101c41$export$39b482c5e57630a8,
    isDisabled: false,
    isLoading: false,
    isMulti: false,
    isRtl: false,
    isSearchable: true,
    isOptionDisabled: $935291c440101c41$var$isOptionDisabled,
    loadingMessage: function loadingMessage() {
        return 'Loading...';
    },
    maxMenuHeight: 300,
    minMenuHeight: 140,
    menuIsOpen: false,
    menuPlacement: 'bottom',
    menuPosition: 'absolute',
    menuShouldBlockScroll: false,
    menuShouldScrollIntoView: !(0, $jQxSL.A)(),
    noOptionsMessage: function noOptionsMessage() {
        return 'No options';
    },
    openMenuOnFocus: false,
    openMenuOnClick: true,
    options: [],
    pageSize: 5,
    placeholder: 'Select...',
    screenReaderStatus: function screenReaderStatus(_ref) {
        var count = _ref.count;
        return "".concat(count, " result").concat(count !== 1 ? 's' : '', " available");
    },
    styles: {},
    tabIndex: 0,
    tabSelectsValue: true,
    unstyled: false
};
function $935291c440101c41$var$toCategorizedOption(props, option, selectValue, index) {
    var isDisabled = $935291c440101c41$var$_isOptionDisabled(props, option, selectValue);
    var isSelected = $935291c440101c41$var$_isOptionSelected(props, option, selectValue);
    var label = $935291c440101c41$var$getOptionLabel(props, option);
    var value = $935291c440101c41$var$getOptionValue(props, option);
    return {
        type: 'option',
        data: option,
        isDisabled: isDisabled,
        isSelected: isSelected,
        label: label,
        value: value,
        index: index
    };
}
function $935291c440101c41$var$buildCategorizedOptions(props, selectValue) {
    return props.options.map(function(groupOrOption, groupOrOptionIndex) {
        if ('options' in groupOrOption) {
            var categorizedOptions = groupOrOption.options.map(function(option, optionIndex) {
                return $935291c440101c41$var$toCategorizedOption(props, option, selectValue, optionIndex);
            }).filter(function(categorizedOption) {
                return $935291c440101c41$var$isFocusable(props, categorizedOption);
            });
            return categorizedOptions.length > 0 ? {
                type: 'group',
                data: groupOrOption,
                options: categorizedOptions,
                index: groupOrOptionIndex
            } : undefined;
        }
        var categorizedOption = $935291c440101c41$var$toCategorizedOption(props, groupOrOption, selectValue, groupOrOptionIndex);
        return $935291c440101c41$var$isFocusable(props, categorizedOption) ? categorizedOption : undefined;
    }).filter((0, $jQxSL.G));
}
function $935291c440101c41$var$buildFocusableOptionsFromCategorizedOptions(categorizedOptions) {
    return categorizedOptions.reduce(function(optionsAccumulator, categorizedOption) {
        if (categorizedOption.type === 'group') optionsAccumulator.push.apply(optionsAccumulator, (0, $fVK4C.default)(categorizedOption.options.map(function(option) {
            return option.data;
        })));
        else optionsAccumulator.push(categorizedOption.data);
        return optionsAccumulator;
    }, []);
}
function $935291c440101c41$var$buildFocusableOptions(props, selectValue) {
    return $935291c440101c41$var$buildFocusableOptionsFromCategorizedOptions($935291c440101c41$var$buildCategorizedOptions(props, selectValue));
}
function $935291c440101c41$var$isFocusable(props, categorizedOption) {
    var _props$inputValue = props.inputValue, inputValue = _props$inputValue === void 0 ? '' : _props$inputValue;
    var data = categorizedOption.data, isSelected = categorizedOption.isSelected, label = categorizedOption.label, value = categorizedOption.value;
    return (!$935291c440101c41$var$shouldHideSelectedOptions(props) || !isSelected) && $935291c440101c41$var$_filterOption(props, {
        label: label,
        value: value,
        data: data
    }, inputValue);
}
function $935291c440101c41$var$getNextFocusedValue(state, nextSelectValue) {
    var focusedValue = state.focusedValue, lastSelectValue = state.selectValue;
    var lastFocusedIndex = lastSelectValue.indexOf(focusedValue);
    if (lastFocusedIndex > -1) {
        var nextFocusedIndex = nextSelectValue.indexOf(focusedValue);
        if (nextFocusedIndex > -1) // the focused value is still in the selectValue, return it
        return focusedValue;
        else if (lastFocusedIndex < nextSelectValue.length) // the focusedValue is not present in the next selectValue array by
        // reference, so return the new value at the same index
        return nextSelectValue[lastFocusedIndex];
    }
    return null;
}
function $935291c440101c41$var$getNextFocusedOption(state, options) {
    var lastFocusedOption = state.focusedOption;
    return lastFocusedOption && options.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options[0];
}
var $935291c440101c41$var$getOptionLabel = function getOptionLabel(props, data) {
    return props.getOptionLabel(data);
};
var $935291c440101c41$var$getOptionValue = function getOptionValue(props, data) {
    return props.getOptionValue(data);
};
function $935291c440101c41$var$_isOptionDisabled(props, option, selectValue) {
    return typeof props.isOptionDisabled === 'function' ? props.isOptionDisabled(option, selectValue) : false;
}
function $935291c440101c41$var$_isOptionSelected(props, option, selectValue) {
    if (selectValue.indexOf(option) > -1) return true;
    if (typeof props.isOptionSelected === 'function') return props.isOptionSelected(option, selectValue);
    var candidate = $935291c440101c41$var$getOptionValue(props, option);
    return selectValue.some(function(i) {
        return $935291c440101c41$var$getOptionValue(props, i) === candidate;
    });
}
function $935291c440101c41$var$_filterOption(props, option, inputValue) {
    return props.filterOption ? props.filterOption(option, inputValue) : true;
}
var $935291c440101c41$var$shouldHideSelectedOptions = function shouldHideSelectedOptions(props) {
    var hideSelectedOptions = props.hideSelectedOptions, isMulti = props.isMulti;
    if (hideSelectedOptions === undefined) return isMulti;
    return hideSelectedOptions;
};
var $935291c440101c41$var$instanceId = 1;
var $935291c440101c41$export$25ce5a424b770e84 = /*#__PURE__*/ function(_Component) {
    (0, $eT4IF.default)(Select, _Component);
    var _super = (0, $7Dzgl.default)(Select);
    // Misc. Instance Properties
    // ------------------------------
    // TODO
    // Refs
    // ------------------------------
    // Lifecycle
    // ------------------------------
    function Select(_props) {
        var _this;
        (0, $lDSrn.default)(this, Select);
        _this = _super.call(this, _props);
        _this.state = {
            ariaSelection: null,
            focusedOption: null,
            focusedValue: null,
            inputIsHidden: false,
            isFocused: false,
            selectValue: [],
            clearFocusValueOnUpdate: false,
            prevWasFocused: false,
            inputIsHiddenAfterUpdate: undefined,
            prevProps: undefined
        };
        _this.blockOptionHover = false;
        _this.isComposing = false;
        _this.commonProps = void 0;
        _this.initialTouchX = 0;
        _this.initialTouchY = 0;
        _this.instancePrefix = '';
        _this.openAfterFocus = false;
        _this.scrollToFocusedOptionOnUpdate = false;
        _this.userIsDragging = void 0;
        _this.controlRef = null;
        _this.getControlRef = function(ref) {
            _this.controlRef = ref;
        };
        _this.focusedOptionRef = null;
        _this.getFocusedOptionRef = function(ref) {
            _this.focusedOptionRef = ref;
        };
        _this.menuListRef = null;
        _this.getMenuListRef = function(ref) {
            _this.menuListRef = ref;
        };
        _this.inputRef = null;
        _this.getInputRef = function(ref) {
            _this.inputRef = ref;
        };
        _this.focus = _this.focusInput;
        _this.blur = _this.blurInput;
        _this.onChange = function(newValue, actionMeta) {
            var _this$props = _this.props, onChange = _this$props.onChange, name = _this$props.name;
            actionMeta.name = name;
            _this.ariaOnChange(newValue, actionMeta);
            onChange(newValue, actionMeta);
        };
        _this.setValue = function(newValue, action, option) {
            var _this$props2 = _this.props, closeMenuOnSelect = _this$props2.closeMenuOnSelect, isMulti = _this$props2.isMulti, inputValue = _this$props2.inputValue;
            _this.onInputChange('', {
                action: 'set-value',
                prevInputValue: inputValue
            });
            if (closeMenuOnSelect) {
                _this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                _this.onMenuClose();
            }
            // when the select value should change, we should reset focusedValue
            _this.setState({
                clearFocusValueOnUpdate: true
            });
            _this.onChange(newValue, {
                action: action,
                option: option
            });
        };
        _this.selectOption = function(newValue) {
            var _this$props3 = _this.props, blurInputOnSelect = _this$props3.blurInputOnSelect, isMulti = _this$props3.isMulti, name = _this$props3.name;
            var selectValue = _this.state.selectValue;
            var deselected = isMulti && _this.isOptionSelected(newValue, selectValue);
            var isDisabled = _this.isOptionDisabled(newValue, selectValue);
            if (deselected) {
                var candidate = _this.getOptionValue(newValue);
                _this.setValue((0, $jQxSL.B)(selectValue.filter(function(i) {
                    return _this.getOptionValue(i) !== candidate;
                })), 'deselect-option', newValue);
            } else if (!isDisabled) {
                // Select option if option is not disabled
                if (isMulti) _this.setValue((0, $jQxSL.B)([].concat((0, $fVK4C.default)(selectValue), [
                    newValue
                ])), 'select-option', newValue);
                else _this.setValue((0, $jQxSL.C)(newValue), 'select-option');
            } else {
                _this.ariaOnChange((0, $jQxSL.C)(newValue), {
                    action: 'select-option',
                    option: newValue,
                    name: name
                });
                return;
            }
            if (blurInputOnSelect) _this.blurInput();
        };
        _this.removeValue = function(removedValue) {
            var isMulti = _this.props.isMulti;
            var selectValue = _this.state.selectValue;
            var candidate = _this.getOptionValue(removedValue);
            var newValueArray = selectValue.filter(function(i) {
                return _this.getOptionValue(i) !== candidate;
            });
            var newValue = (0, $jQxSL.D)(isMulti, newValueArray, newValueArray[0] || null);
            _this.onChange(newValue, {
                action: 'remove-value',
                removedValue: removedValue
            });
            _this.focusInput();
        };
        _this.clearValue = function() {
            var selectValue = _this.state.selectValue;
            _this.onChange((0, $jQxSL.D)(_this.props.isMulti, [], null), {
                action: 'clear',
                removedValues: selectValue
            });
        };
        _this.popValue = function() {
            var isMulti = _this.props.isMulti;
            var selectValue = _this.state.selectValue;
            var lastSelectedValue = selectValue[selectValue.length - 1];
            var newValueArray = selectValue.slice(0, selectValue.length - 1);
            var newValue = (0, $jQxSL.D)(isMulti, newValueArray, newValueArray[0] || null);
            _this.onChange(newValue, {
                action: 'pop-value',
                removedValue: lastSelectedValue
            });
        };
        _this.getValue = function() {
            return _this.state.selectValue;
        };
        _this.cx = function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return (0, $jQxSL.E).apply(void 0, [
                _this.props.classNamePrefix
            ].concat(args));
        };
        _this.getOptionLabel = function(data) {
            return $935291c440101c41$var$getOptionLabel(_this.props, data);
        };
        _this.getOptionValue = function(data) {
            return $935291c440101c41$var$getOptionValue(_this.props, data);
        };
        _this.getStyles = function(key, props) {
            var unstyled = _this.props.unstyled;
            var base = $935291c440101c41$var$defaultStyles[key](props, unstyled);
            base.boxSizing = 'border-box';
            var custom = _this.props.styles[key];
            return custom ? custom(base, props) : base;
        };
        _this.getClassNames = function(key, props) {
            var _this$props$className, _this$props$className2;
            return (_this$props$className = (_this$props$className2 = _this.props.classNames)[key]) === null || _this$props$className === void 0 ? void 0 : _this$props$className.call(_this$props$className2, props);
        };
        _this.getElementId = function(element) {
            return "".concat(_this.instancePrefix, "-").concat(element);
        };
        _this.getComponents = function() {
            return (0, $jQxSL.F)(_this.props);
        };
        _this.buildCategorizedOptions = function() {
            return $935291c440101c41$var$buildCategorizedOptions(_this.props, _this.state.selectValue);
        };
        _this.getCategorizedOptions = function() {
            return _this.props.menuIsOpen ? _this.buildCategorizedOptions() : [];
        };
        _this.buildFocusableOptions = function() {
            return $935291c440101c41$var$buildFocusableOptionsFromCategorizedOptions(_this.buildCategorizedOptions());
        };
        _this.getFocusableOptions = function() {
            return _this.props.menuIsOpen ? _this.buildFocusableOptions() : [];
        };
        _this.ariaOnChange = function(value, actionMeta) {
            _this.setState({
                ariaSelection: (0, $1Xn5q.default)({
                    value: value
                }, actionMeta)
            });
        };
        _this.onMenuMouseDown = function(event) {
            if (event.button !== 0) return;
            event.stopPropagation();
            event.preventDefault();
            _this.focusInput();
        };
        _this.onMenuMouseMove = function(event) {
            _this.blockOptionHover = false;
        };
        _this.onControlMouseDown = function(event) {
            var openMenuOnClick = _this.props.openMenuOnClick;
            if (!_this.state.isFocused) {
                if (openMenuOnClick) _this.openAfterFocus = true;
                _this.focusInput();
            } else if (!_this.props.menuIsOpen) {
                if (openMenuOnClick) _this.openMenu('first');
            } else if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') _this.onMenuClose();
            if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') event.preventDefault();
        };
        _this.onDropdownIndicatorMouseDown = function(event) {
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            if (_this.props.isDisabled) return;
            var _this$props4 = _this.props, isMulti = _this$props4.isMulti, menuIsOpen = _this$props4.menuIsOpen;
            _this.focusInput();
            if (menuIsOpen) {
                _this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                _this.onMenuClose();
            } else _this.openMenu('first');
            event.preventDefault();
            event.stopPropagation();
        };
        _this.onClearIndicatorMouseDown = function(event) {
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            _this.clearValue();
            event.preventDefault();
            event.stopPropagation();
            _this.openAfterFocus = false;
            if (event.type === 'touchend') _this.focusInput();
            else setTimeout(function() {
                return _this.focusInput();
            });
        };
        _this.onScroll = function(event) {
            if (typeof _this.props.closeMenuOnScroll === 'boolean') {
                if (event.target instanceof HTMLElement && (0, $jQxSL.H)(event.target)) _this.props.onMenuClose();
            } else if (typeof _this.props.closeMenuOnScroll === 'function') {
                if (_this.props.closeMenuOnScroll(event)) _this.props.onMenuClose();
            }
        };
        _this.onCompositionStart = function() {
            _this.isComposing = true;
        };
        _this.onCompositionEnd = function() {
            _this.isComposing = false;
        };
        _this.onTouchStart = function(_ref2) {
            var touches = _ref2.touches;
            var touch = touches && touches.item(0);
            if (!touch) return;
            _this.initialTouchX = touch.clientX;
            _this.initialTouchY = touch.clientY;
            _this.userIsDragging = false;
        };
        _this.onTouchMove = function(_ref3) {
            var touches = _ref3.touches;
            var touch = touches && touches.item(0);
            if (!touch) return;
            var deltaX = Math.abs(touch.clientX - _this.initialTouchX);
            var deltaY = Math.abs(touch.clientY - _this.initialTouchY);
            var moveThreshold = 5;
            _this.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
        };
        _this.onTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            // close the menu if the user taps outside
            // we're checking on event.target here instead of event.currentTarget, because we want to assert information
            // on events on child elements, not the document (which we've attached this handler to).
            if (_this.controlRef && !_this.controlRef.contains(event.target) && _this.menuListRef && !_this.menuListRef.contains(event.target)) _this.blurInput();
            // reset move vars
            _this.initialTouchX = 0;
            _this.initialTouchY = 0;
        };
        _this.onControlTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onControlMouseDown(event);
        };
        _this.onClearIndicatorTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onClearIndicatorMouseDown(event);
        };
        _this.onDropdownIndicatorTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onDropdownIndicatorMouseDown(event);
        };
        _this.handleInputChange = function(event) {
            var prevInputValue = _this.props.inputValue;
            var inputValue = event.currentTarget.value;
            _this.setState({
                inputIsHiddenAfterUpdate: false
            });
            _this.onInputChange(inputValue, {
                action: 'input-change',
                prevInputValue: prevInputValue
            });
            if (!_this.props.menuIsOpen) _this.onMenuOpen();
        };
        _this.onInputFocus = function(event) {
            if (_this.props.onFocus) _this.props.onFocus(event);
            _this.setState({
                inputIsHiddenAfterUpdate: false,
                isFocused: true
            });
            if (_this.openAfterFocus || _this.props.openMenuOnFocus) _this.openMenu('first');
            _this.openAfterFocus = false;
        };
        _this.onInputBlur = function(event) {
            var prevInputValue = _this.props.inputValue;
            if (_this.menuListRef && _this.menuListRef.contains(document.activeElement)) {
                _this.inputRef.focus();
                return;
            }
            if (_this.props.onBlur) _this.props.onBlur(event);
            _this.onInputChange('', {
                action: 'input-blur',
                prevInputValue: prevInputValue
            });
            _this.onMenuClose();
            _this.setState({
                focusedValue: null,
                isFocused: false
            });
        };
        _this.onOptionHover = function(focusedOption) {
            if (_this.blockOptionHover || _this.state.focusedOption === focusedOption) return;
            _this.setState({
                focusedOption: focusedOption
            });
        };
        _this.shouldHideSelectedOptions = function() {
            return $935291c440101c41$var$shouldHideSelectedOptions(_this.props);
        };
        _this.onValueInputFocus = function(e) {
            e.preventDefault();
            e.stopPropagation();
            _this.focus();
        };
        _this.onKeyDown = function(event) {
            var _this$props5 = _this.props, isMulti = _this$props5.isMulti, backspaceRemovesValue = _this$props5.backspaceRemovesValue, escapeClearsValue = _this$props5.escapeClearsValue, inputValue = _this$props5.inputValue, isClearable = _this$props5.isClearable, isDisabled = _this$props5.isDisabled, menuIsOpen = _this$props5.menuIsOpen, onKeyDown = _this$props5.onKeyDown, tabSelectsValue = _this$props5.tabSelectsValue, openMenuOnFocus = _this$props5.openMenuOnFocus;
            var _this$state = _this.state, focusedOption = _this$state.focusedOption, focusedValue = _this$state.focusedValue, selectValue = _this$state.selectValue;
            if (isDisabled) return;
            if (typeof onKeyDown === 'function') {
                onKeyDown(event);
                if (event.defaultPrevented) return;
            }
            // Block option hover events when the user has just pressed a key
            _this.blockOptionHover = true;
            switch(event.key){
                case 'ArrowLeft':
                    if (!isMulti || inputValue) return;
                    _this.focusValue('previous');
                    break;
                case 'ArrowRight':
                    if (!isMulti || inputValue) return;
                    _this.focusValue('next');
                    break;
                case 'Delete':
                case 'Backspace':
                    if (inputValue) return;
                    if (focusedValue) _this.removeValue(focusedValue);
                    else {
                        if (!backspaceRemovesValue) return;
                        if (isMulti) _this.popValue();
                        else if (isClearable) _this.clearValue();
                    }
                    break;
                case 'Tab':
                    if (_this.isComposing) return;
                    if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption || // don't capture the event if the menu opens on focus and the focused
                    // option is already selected; it breaks the flow of navigation
                    openMenuOnFocus && _this.isOptionSelected(focusedOption, selectValue)) return;
                    _this.selectOption(focusedOption);
                    break;
                case 'Enter':
                    if (event.keyCode === 229) break;
                    if (menuIsOpen) {
                        if (!focusedOption) return;
                        if (_this.isComposing) return;
                        _this.selectOption(focusedOption);
                        break;
                    }
                    return;
                case 'Escape':
                    if (menuIsOpen) {
                        _this.setState({
                            inputIsHiddenAfterUpdate: false
                        });
                        _this.onInputChange('', {
                            action: 'menu-close',
                            prevInputValue: inputValue
                        });
                        _this.onMenuClose();
                    } else if (isClearable && escapeClearsValue) _this.clearValue();
                    break;
                case ' ':
                    // space
                    if (inputValue) return;
                    if (!menuIsOpen) {
                        _this.openMenu('first');
                        break;
                    }
                    if (!focusedOption) return;
                    _this.selectOption(focusedOption);
                    break;
                case 'ArrowUp':
                    if (menuIsOpen) _this.focusOption('up');
                    else _this.openMenu('last');
                    break;
                case 'ArrowDown':
                    if (menuIsOpen) _this.focusOption('down');
                    else _this.openMenu('first');
                    break;
                case 'PageUp':
                    if (!menuIsOpen) return;
                    _this.focusOption('pageup');
                    break;
                case 'PageDown':
                    if (!menuIsOpen) return;
                    _this.focusOption('pagedown');
                    break;
                case 'Home':
                    if (!menuIsOpen) return;
                    _this.focusOption('first');
                    break;
                case 'End':
                    if (!menuIsOpen) return;
                    _this.focusOption('last');
                    break;
                default:
                    return;
            }
            event.preventDefault();
        };
        _this.instancePrefix = 'react-select-' + (_this.props.instanceId || ++$935291c440101c41$var$instanceId);
        _this.state.selectValue = (0, $jQxSL.I)(_props.value);
        // Set focusedOption if menuIsOpen is set on init (e.g. defaultMenuIsOpen)
        if (_props.menuIsOpen && _this.state.selectValue.length) {
            var focusableOptions = _this.buildFocusableOptions();
            var optionIndex = focusableOptions.indexOf(_this.state.selectValue[0]);
            _this.state.focusedOption = focusableOptions[optionIndex];
        }
        return _this;
    }
    (0, $lIEGP.default)(Select, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.startListeningComposition();
                this.startListeningToTouch();
                if (this.props.closeMenuOnScroll && document && document.addEventListener) // Listen to all scroll events, and filter them out inside of 'onScroll'
                document.addEventListener('scroll', this.onScroll, true);
                if (this.props.autoFocus) this.focusInput();
                // Scroll focusedOption into view if menuIsOpen is set on mount (e.g. defaultMenuIsOpen)
                if (this.props.menuIsOpen && this.state.focusedOption && this.menuListRef && this.focusedOptionRef) (0, $jQxSL.J)(this.menuListRef, this.focusedOptionRef);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var _this$props6 = this.props, isDisabled = _this$props6.isDisabled, menuIsOpen = _this$props6.menuIsOpen;
                var isFocused = this.state.isFocused;
                if (// ensure focus is restored correctly when the control becomes enabled
                isFocused && !isDisabled && prevProps.isDisabled || // ensure focus is on the Input when the menu opens
                isFocused && menuIsOpen && !prevProps.menuIsOpen) this.focusInput();
                if (isFocused && isDisabled && !prevProps.isDisabled) // ensure select state gets blurred in case Select is programmatically disabled while focused
                // eslint-disable-next-line react/no-did-update-set-state
                this.setState({
                    isFocused: false
                }, this.onMenuClose);
                else if (!isFocused && !isDisabled && prevProps.isDisabled && this.inputRef === document.activeElement) // ensure select state gets focused in case Select is programatically re-enabled while focused (Firefox)
                // eslint-disable-next-line react/no-did-update-set-state
                this.setState({
                    isFocused: true
                });
                // scroll the focused option into view if necessary
                if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
                    (0, $jQxSL.J)(this.menuListRef, this.focusedOptionRef);
                    this.scrollToFocusedOptionOnUpdate = false;
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.stopListeningComposition();
                this.stopListeningToTouch();
                document.removeEventListener('scroll', this.onScroll, true);
            }
        },
        {
            key: "onMenuOpen",
            value: function onMenuOpen() {
                this.props.onMenuOpen();
            }
        },
        {
            key: "onMenuClose",
            value: function onMenuClose() {
                this.onInputChange('', {
                    action: 'menu-close',
                    prevInputValue: this.props.inputValue
                });
                this.props.onMenuClose();
            }
        },
        {
            key: "onInputChange",
            value: function onInputChange(newValue, actionMeta) {
                this.props.onInputChange(newValue, actionMeta);
            }
        },
        {
            key: "focusInput",
            value: function focusInput() {
                if (!this.inputRef) return;
                this.inputRef.focus();
            }
        },
        {
            key: "blurInput",
            value: function blurInput() {
                if (!this.inputRef) return;
                this.inputRef.blur();
            }
        },
        {
            key: "openMenu",
            value: function openMenu(focusOption) {
                var _this2 = this;
                var _this$state2 = this.state, selectValue = _this$state2.selectValue, isFocused = _this$state2.isFocused;
                var focusableOptions = this.buildFocusableOptions();
                var openAtIndex = focusOption === 'first' ? 0 : focusableOptions.length - 1;
                if (!this.props.isMulti) {
                    var selectedIndex = focusableOptions.indexOf(selectValue[0]);
                    if (selectedIndex > -1) openAtIndex = selectedIndex;
                }
                // only scroll if the menu isn't already open
                this.scrollToFocusedOptionOnUpdate = !(isFocused && this.menuListRef);
                this.setState({
                    inputIsHiddenAfterUpdate: false,
                    focusedValue: null,
                    focusedOption: focusableOptions[openAtIndex]
                }, function() {
                    return _this2.onMenuOpen();
                });
            }
        },
        {
            key: "focusValue",
            value: function focusValue(direction) {
                var _this$state3 = this.state, selectValue = _this$state3.selectValue, focusedValue = _this$state3.focusedValue;
                // Only multiselects support value focusing
                if (!this.props.isMulti) return;
                this.setState({
                    focusedOption: null
                });
                var focusedIndex = selectValue.indexOf(focusedValue);
                if (!focusedValue) focusedIndex = -1;
                var lastIndex = selectValue.length - 1;
                var nextFocus = -1;
                if (!selectValue.length) return;
                switch(direction){
                    case 'previous':
                        if (focusedIndex === 0) // don't cycle from the start to the end
                        nextFocus = 0;
                        else if (focusedIndex === -1) // if nothing is focused, focus the last value first
                        nextFocus = lastIndex;
                        else nextFocus = focusedIndex - 1;
                        break;
                    case 'next':
                        if (focusedIndex > -1 && focusedIndex < lastIndex) nextFocus = focusedIndex + 1;
                        break;
                }
                this.setState({
                    inputIsHidden: nextFocus !== -1,
                    focusedValue: selectValue[nextFocus]
                });
            }
        },
        {
            key: "focusOption",
            value: function focusOption() {
                var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'first';
                var pageSize = this.props.pageSize;
                var focusedOption = this.state.focusedOption;
                var options = this.getFocusableOptions();
                if (!options.length) return;
                var nextFocus = 0; // handles 'first'
                var focusedIndex = options.indexOf(focusedOption);
                if (!focusedOption) focusedIndex = -1;
                if (direction === 'up') nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options.length - 1;
                else if (direction === 'down') nextFocus = (focusedIndex + 1) % options.length;
                else if (direction === 'pageup') {
                    nextFocus = focusedIndex - pageSize;
                    if (nextFocus < 0) nextFocus = 0;
                } else if (direction === 'pagedown') {
                    nextFocus = focusedIndex + pageSize;
                    if (nextFocus > options.length - 1) nextFocus = options.length - 1;
                } else if (direction === 'last') nextFocus = options.length - 1;
                this.scrollToFocusedOptionOnUpdate = true;
                this.setState({
                    focusedOption: options[nextFocus],
                    focusedValue: null
                });
            }
        },
        {
            key: "getTheme",
            value: // ==============================
            // Getters
            // ==============================
            function getTheme() {
                // Use the default theme if there are no customisations.
                if (!this.props.theme) return $935291c440101c41$export$4368d992c4eafac0;
                // If the theme prop is a function, assume the function
                // knows how to merge the passed-in default theme with
                // its own modifications.
                if (typeof this.props.theme === 'function') return this.props.theme($935291c440101c41$export$4368d992c4eafac0);
                // Otherwise, if a plain theme object was passed in,
                // overlay it with the default theme.
                return (0, $1Xn5q.default)((0, $1Xn5q.default)({}, $935291c440101c41$export$4368d992c4eafac0), this.props.theme);
            }
        },
        {
            key: "getCommonProps",
            value: function getCommonProps() {
                var clearValue = this.clearValue, cx = this.cx, getStyles = this.getStyles, getClassNames = this.getClassNames, getValue = this.getValue, selectOption = this.selectOption, setValue = this.setValue, props = this.props;
                var isMulti = props.isMulti, isRtl = props.isRtl, options = props.options;
                var hasValue = this.hasValue();
                return {
                    clearValue: clearValue,
                    cx: cx,
                    getStyles: getStyles,
                    getClassNames: getClassNames,
                    getValue: getValue,
                    hasValue: hasValue,
                    isMulti: isMulti,
                    isRtl: isRtl,
                    options: options,
                    selectOption: selectOption,
                    selectProps: props,
                    setValue: setValue,
                    theme: this.getTheme()
                };
            }
        },
        {
            key: "hasValue",
            value: function hasValue() {
                var selectValue = this.state.selectValue;
                return selectValue.length > 0;
            }
        },
        {
            key: "hasOptions",
            value: function hasOptions() {
                return !!this.getFocusableOptions().length;
            }
        },
        {
            key: "isClearable",
            value: function isClearable() {
                var _this$props7 = this.props, isClearable = _this$props7.isClearable, isMulti = _this$props7.isMulti;
                // single select, by default, IS NOT clearable
                // multi select, by default, IS clearable
                if (isClearable === undefined) return isMulti;
                return isClearable;
            }
        },
        {
            key: "isOptionDisabled",
            value: function isOptionDisabled(option, selectValue) {
                return $935291c440101c41$var$_isOptionDisabled(this.props, option, selectValue);
            }
        },
        {
            key: "isOptionSelected",
            value: function isOptionSelected(option, selectValue) {
                return $935291c440101c41$var$_isOptionSelected(this.props, option, selectValue);
            }
        },
        {
            key: "filterOption",
            value: function filterOption(option, inputValue) {
                return $935291c440101c41$var$_filterOption(this.props, option, inputValue);
            }
        },
        {
            key: "formatOptionLabel",
            value: function formatOptionLabel(data, context) {
                if (typeof this.props.formatOptionLabel === 'function') {
                    var _inputValue = this.props.inputValue;
                    var _selectValue = this.state.selectValue;
                    return this.props.formatOptionLabel(data, {
                        context: context,
                        inputValue: _inputValue,
                        selectValue: _selectValue
                    });
                } else return this.getOptionLabel(data);
            }
        },
        {
            key: "formatGroupLabel",
            value: function formatGroupLabel(data) {
                return this.props.formatGroupLabel(data);
            }
        },
        {
            key: "startListeningComposition",
            value: // ==============================
            // Composition Handlers
            // ==============================
            function startListeningComposition() {
                if (document && document.addEventListener) {
                    document.addEventListener('compositionstart', this.onCompositionStart, false);
                    document.addEventListener('compositionend', this.onCompositionEnd, false);
                }
            }
        },
        {
            key: "stopListeningComposition",
            value: function stopListeningComposition() {
                if (document && document.removeEventListener) {
                    document.removeEventListener('compositionstart', this.onCompositionStart);
                    document.removeEventListener('compositionend', this.onCompositionEnd);
                }
            }
        },
        {
            key: "startListeningToTouch",
            value: // ==============================
            // Touch Handlers
            // ==============================
            function startListeningToTouch() {
                if (document && document.addEventListener) {
                    document.addEventListener('touchstart', this.onTouchStart, false);
                    document.addEventListener('touchmove', this.onTouchMove, false);
                    document.addEventListener('touchend', this.onTouchEnd, false);
                }
            }
        },
        {
            key: "stopListeningToTouch",
            value: function stopListeningToTouch() {
                if (document && document.removeEventListener) {
                    document.removeEventListener('touchstart', this.onTouchStart);
                    document.removeEventListener('touchmove', this.onTouchMove);
                    document.removeEventListener('touchend', this.onTouchEnd);
                }
            }
        },
        {
            key: "renderInput",
            value: // ==============================
            // Renderers
            // ==============================
            function renderInput() {
                var _this$props8 = this.props, isDisabled = _this$props8.isDisabled, isSearchable = _this$props8.isSearchable, inputId = _this$props8.inputId, inputValue = _this$props8.inputValue, tabIndex = _this$props8.tabIndex, form = _this$props8.form, menuIsOpen = _this$props8.menuIsOpen, required = _this$props8.required;
                var _this$getComponents = this.getComponents(), Input = _this$getComponents.Input;
                var _this$state4 = this.state, inputIsHidden = _this$state4.inputIsHidden, ariaSelection = _this$state4.ariaSelection;
                var commonProps = this.commonProps;
                var id = inputId || this.getElementId('input');
                // aria attributes makes the JSX "noisy", separated for clarity
                var ariaAttributes = (0, $1Xn5q.default)((0, $1Xn5q.default)((0, $1Xn5q.default)({
                    'aria-autocomplete': 'list',
                    'aria-expanded': menuIsOpen,
                    'aria-haspopup': true,
                    'aria-errormessage': this.props['aria-errormessage'],
                    'aria-invalid': this.props['aria-invalid'],
                    'aria-label': this.props['aria-label'],
                    'aria-labelledby': this.props['aria-labelledby'],
                    'aria-required': required,
                    role: 'combobox'
                }, menuIsOpen && {
                    'aria-controls': this.getElementId('listbox'),
                    'aria-owns': this.getElementId('listbox')
                }), !isSearchable && {
                    'aria-readonly': true
                }), this.hasValue() ? (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus' && {
                    'aria-describedby': this.getElementId('live-region')
                } : {
                    'aria-describedby': this.getElementId('placeholder')
                });
                if (!isSearchable) // use a dummy input to maintain focus/blur functionality
                return /*#__PURE__*/ $eUqFw.createElement($935291c440101c41$var$DummyInput, (0, $kU09D.default)({
                    id: id,
                    innerRef: this.getInputRef,
                    onBlur: this.onInputBlur,
                    onChange: (0, $jQxSL.K),
                    onFocus: this.onInputFocus,
                    disabled: isDisabled,
                    tabIndex: tabIndex,
                    inputMode: "none",
                    form: form,
                    value: ""
                }, ariaAttributes));
                return /*#__PURE__*/ $eUqFw.createElement(Input, (0, $kU09D.default)({}, commonProps, {
                    autoCapitalize: "none",
                    autoComplete: "off",
                    autoCorrect: "off",
                    id: id,
                    innerRef: this.getInputRef,
                    isDisabled: isDisabled,
                    isHidden: inputIsHidden,
                    onBlur: this.onInputBlur,
                    onChange: this.handleInputChange,
                    onFocus: this.onInputFocus,
                    spellCheck: "false",
                    tabIndex: tabIndex,
                    form: form,
                    type: "text",
                    value: inputValue
                }, ariaAttributes));
            }
        },
        {
            key: "renderPlaceholderOrValue",
            value: function renderPlaceholderOrValue() {
                var _this3 = this;
                var _this$getComponents2 = this.getComponents(), MultiValue = _this$getComponents2.MultiValue, MultiValueContainer = _this$getComponents2.MultiValueContainer, MultiValueLabel = _this$getComponents2.MultiValueLabel, MultiValueRemove = _this$getComponents2.MultiValueRemove, SingleValue = _this$getComponents2.SingleValue, Placeholder = _this$getComponents2.Placeholder;
                var commonProps = this.commonProps;
                var _this$props9 = this.props, controlShouldRenderValue = _this$props9.controlShouldRenderValue, isDisabled = _this$props9.isDisabled, isMulti = _this$props9.isMulti, inputValue = _this$props9.inputValue, placeholder = _this$props9.placeholder;
                var _this$state5 = this.state, selectValue = _this$state5.selectValue, focusedValue = _this$state5.focusedValue, isFocused = _this$state5.isFocused;
                if (!this.hasValue() || !controlShouldRenderValue) return inputValue ? null : /*#__PURE__*/ $eUqFw.createElement(Placeholder, (0, $kU09D.default)({}, commonProps, {
                    key: "placeholder",
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    innerProps: {
                        id: this.getElementId('placeholder')
                    }
                }), placeholder);
                if (isMulti) return selectValue.map(function(opt, index) {
                    var isOptionFocused = opt === focusedValue;
                    var key = "".concat(_this3.getOptionLabel(opt), "-").concat(_this3.getOptionValue(opt));
                    return /*#__PURE__*/ $eUqFw.createElement(MultiValue, (0, $kU09D.default)({}, commonProps, {
                        components: {
                            Container: MultiValueContainer,
                            Label: MultiValueLabel,
                            Remove: MultiValueRemove
                        },
                        isFocused: isOptionFocused,
                        isDisabled: isDisabled,
                        key: key,
                        index: index,
                        removeProps: {
                            onClick: function onClick() {
                                return _this3.removeValue(opt);
                            },
                            onTouchEnd: function onTouchEnd() {
                                return _this3.removeValue(opt);
                            },
                            onMouseDown: function onMouseDown(e) {
                                e.preventDefault();
                                e.stopPropagation();
                            }
                        },
                        data: opt
                    }), _this3.formatOptionLabel(opt, 'value'));
                });
                if (inputValue) return null;
                var singleValue = selectValue[0];
                return /*#__PURE__*/ $eUqFw.createElement(SingleValue, (0, $kU09D.default)({}, commonProps, {
                    data: singleValue,
                    isDisabled: isDisabled
                }), this.formatOptionLabel(singleValue, 'value'));
            }
        },
        {
            key: "renderClearIndicator",
            value: function renderClearIndicator() {
                var _this$getComponents3 = this.getComponents(), ClearIndicator = _this$getComponents3.ClearIndicator;
                var commonProps = this.commonProps;
                var _this$props10 = this.props, isDisabled = _this$props10.isDisabled, isLoading = _this$props10.isLoading;
                var isFocused = this.state.isFocused;
                if (!this.isClearable() || !ClearIndicator || isDisabled || !this.hasValue() || isLoading) return null;
                var innerProps = {
                    onMouseDown: this.onClearIndicatorMouseDown,
                    onTouchEnd: this.onClearIndicatorTouchEnd,
                    'aria-hidden': 'true'
                };
                return /*#__PURE__*/ $eUqFw.createElement(ClearIndicator, (0, $kU09D.default)({}, commonProps, {
                    innerProps: innerProps,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderLoadingIndicator",
            value: function renderLoadingIndicator() {
                var _this$getComponents4 = this.getComponents(), LoadingIndicator = _this$getComponents4.LoadingIndicator;
                var commonProps = this.commonProps;
                var _this$props11 = this.props, isDisabled = _this$props11.isDisabled, isLoading = _this$props11.isLoading;
                var isFocused = this.state.isFocused;
                if (!LoadingIndicator || !isLoading) return null;
                var innerProps = {
                    'aria-hidden': 'true'
                };
                return /*#__PURE__*/ $eUqFw.createElement(LoadingIndicator, (0, $kU09D.default)({}, commonProps, {
                    innerProps: innerProps,
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderIndicatorSeparator",
            value: function renderIndicatorSeparator() {
                var _this$getComponents5 = this.getComponents(), DropdownIndicator = _this$getComponents5.DropdownIndicator, IndicatorSeparator = _this$getComponents5.IndicatorSeparator;
                // separator doesn't make sense without the dropdown indicator
                if (!DropdownIndicator || !IndicatorSeparator) return null;
                var commonProps = this.commonProps;
                var isDisabled = this.props.isDisabled;
                var isFocused = this.state.isFocused;
                return /*#__PURE__*/ $eUqFw.createElement(IndicatorSeparator, (0, $kU09D.default)({}, commonProps, {
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderDropdownIndicator",
            value: function renderDropdownIndicator() {
                var _this$getComponents6 = this.getComponents(), DropdownIndicator = _this$getComponents6.DropdownIndicator;
                if (!DropdownIndicator) return null;
                var commonProps = this.commonProps;
                var isDisabled = this.props.isDisabled;
                var isFocused = this.state.isFocused;
                var innerProps = {
                    onMouseDown: this.onDropdownIndicatorMouseDown,
                    onTouchEnd: this.onDropdownIndicatorTouchEnd,
                    'aria-hidden': 'true'
                };
                return /*#__PURE__*/ $eUqFw.createElement(DropdownIndicator, (0, $kU09D.default)({}, commonProps, {
                    innerProps: innerProps,
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderMenu",
            value: function renderMenu() {
                var _this4 = this;
                var _this$getComponents7 = this.getComponents(), Group = _this$getComponents7.Group, GroupHeading = _this$getComponents7.GroupHeading, Menu = _this$getComponents7.Menu, MenuList = _this$getComponents7.MenuList, MenuPortal = _this$getComponents7.MenuPortal, LoadingMessage = _this$getComponents7.LoadingMessage, NoOptionsMessage = _this$getComponents7.NoOptionsMessage, Option = _this$getComponents7.Option;
                var commonProps = this.commonProps;
                var focusedOption = this.state.focusedOption;
                var _this$props12 = this.props, captureMenuScroll = _this$props12.captureMenuScroll, inputValue = _this$props12.inputValue, isLoading = _this$props12.isLoading, loadingMessage = _this$props12.loadingMessage, minMenuHeight = _this$props12.minMenuHeight, maxMenuHeight = _this$props12.maxMenuHeight, menuIsOpen = _this$props12.menuIsOpen, menuPlacement = _this$props12.menuPlacement, menuPosition = _this$props12.menuPosition, menuPortalTarget = _this$props12.menuPortalTarget, menuShouldBlockScroll = _this$props12.menuShouldBlockScroll, menuShouldScrollIntoView = _this$props12.menuShouldScrollIntoView, noOptionsMessage = _this$props12.noOptionsMessage, onMenuScrollToTop = _this$props12.onMenuScrollToTop, onMenuScrollToBottom = _this$props12.onMenuScrollToBottom;
                if (!menuIsOpen) return null;
                // TODO: Internal Option Type here
                var render = function render(props, id) {
                    var type = props.type, data = props.data, isDisabled = props.isDisabled, isSelected = props.isSelected, label = props.label, value = props.value;
                    var isFocused = focusedOption === data;
                    var onHover = isDisabled ? undefined : function() {
                        return _this4.onOptionHover(data);
                    };
                    var onSelect = isDisabled ? undefined : function() {
                        return _this4.selectOption(data);
                    };
                    var optionId = "".concat(_this4.getElementId('option'), "-").concat(id);
                    var innerProps = {
                        id: optionId,
                        onClick: onSelect,
                        onMouseMove: onHover,
                        onMouseOver: onHover,
                        tabIndex: -1
                    };
                    return /*#__PURE__*/ $eUqFw.createElement(Option, (0, $kU09D.default)({}, commonProps, {
                        innerProps: innerProps,
                        data: data,
                        isDisabled: isDisabled,
                        isSelected: isSelected,
                        key: optionId,
                        label: label,
                        type: type,
                        value: value,
                        isFocused: isFocused,
                        innerRef: isFocused ? _this4.getFocusedOptionRef : undefined
                    }), _this4.formatOptionLabel(props.data, 'menu'));
                };
                var menuUI;
                if (this.hasOptions()) menuUI = this.getCategorizedOptions().map(function(item) {
                    if (item.type === 'group') {
                        var _data = item.data, options = item.options, groupIndex = item.index;
                        var groupId = "".concat(_this4.getElementId('group'), "-").concat(groupIndex);
                        var headingId = "".concat(groupId, "-heading");
                        return /*#__PURE__*/ $eUqFw.createElement(Group, (0, $kU09D.default)({}, commonProps, {
                            key: groupId,
                            data: _data,
                            options: options,
                            Heading: GroupHeading,
                            headingProps: {
                                id: headingId,
                                data: item.data
                            },
                            label: _this4.formatGroupLabel(item.data)
                        }), item.options.map(function(option) {
                            return render(option, "".concat(groupIndex, "-").concat(option.index));
                        }));
                    } else if (item.type === 'option') return render(item, "".concat(item.index));
                });
                else if (isLoading) {
                    var message = loadingMessage({
                        inputValue: inputValue
                    });
                    if (message === null) return null;
                    menuUI = /*#__PURE__*/ $eUqFw.createElement(LoadingMessage, commonProps, message);
                } else {
                    var _message = noOptionsMessage({
                        inputValue: inputValue
                    });
                    if (_message === null) return null;
                    menuUI = /*#__PURE__*/ $eUqFw.createElement(NoOptionsMessage, commonProps, _message);
                }
                var menuPlacementProps = {
                    minMenuHeight: minMenuHeight,
                    maxMenuHeight: maxMenuHeight,
                    menuPlacement: menuPlacement,
                    menuPosition: menuPosition,
                    menuShouldScrollIntoView: menuShouldScrollIntoView
                };
                var menuElement = /*#__PURE__*/ $eUqFw.createElement((0, $jQxSL.M), (0, $kU09D.default)({}, commonProps, menuPlacementProps), function(_ref4) {
                    var ref = _ref4.ref, _ref4$placerProps = _ref4.placerProps, placement = _ref4$placerProps.placement, maxHeight = _ref4$placerProps.maxHeight;
                    return /*#__PURE__*/ $eUqFw.createElement(Menu, (0, $kU09D.default)({}, commonProps, menuPlacementProps, {
                        innerRef: ref,
                        innerProps: {
                            onMouseDown: _this4.onMenuMouseDown,
                            onMouseMove: _this4.onMenuMouseMove,
                            id: _this4.getElementId('listbox')
                        },
                        isLoading: isLoading,
                        placement: placement
                    }), /*#__PURE__*/ $eUqFw.createElement($935291c440101c41$var$ScrollManager, {
                        captureEnabled: captureMenuScroll,
                        onTopArrive: onMenuScrollToTop,
                        onBottomArrive: onMenuScrollToBottom,
                        lockEnabled: menuShouldBlockScroll
                    }, function(scrollTargetRef) {
                        return /*#__PURE__*/ $eUqFw.createElement(MenuList, (0, $kU09D.default)({}, commonProps, {
                            innerRef: function innerRef(instance) {
                                _this4.getMenuListRef(instance);
                                scrollTargetRef(instance);
                            },
                            isLoading: isLoading,
                            maxHeight: maxHeight,
                            focusedOption: focusedOption
                        }), menuUI);
                    }));
                });
                // positioning behaviour is almost identical for portalled and fixed,
                // so we use the same component. the actual portalling logic is forked
                // within the component based on `menuPosition`
                return menuPortalTarget || menuPosition === 'fixed' ? /*#__PURE__*/ $eUqFw.createElement(MenuPortal, (0, $kU09D.default)({}, commonProps, {
                    appendTo: menuPortalTarget,
                    controlElement: this.controlRef,
                    menuPlacement: menuPlacement,
                    menuPosition: menuPosition
                }), menuElement) : menuElement;
            }
        },
        {
            key: "renderFormField",
            value: function renderFormField() {
                var _this5 = this;
                var _this$props13 = this.props, delimiter = _this$props13.delimiter, isDisabled = _this$props13.isDisabled, isMulti = _this$props13.isMulti, name = _this$props13.name, required = _this$props13.required;
                var selectValue = this.state.selectValue;
                if (required && !this.hasValue() && !isDisabled) return /*#__PURE__*/ $eUqFw.createElement($935291c440101c41$var$RequiredInput, {
                    name: name,
                    onFocus: this.onValueInputFocus
                });
                if (!name || isDisabled) return;
                if (isMulti) {
                    if (delimiter) {
                        var value = selectValue.map(function(opt) {
                            return _this5.getOptionValue(opt);
                        }).join(delimiter);
                        return /*#__PURE__*/ $eUqFw.createElement("input", {
                            name: name,
                            type: "hidden",
                            value: value
                        });
                    } else {
                        var input = selectValue.length > 0 ? selectValue.map(function(opt, i) {
                            return /*#__PURE__*/ $eUqFw.createElement("input", {
                                key: "i-".concat(i),
                                name: name,
                                type: "hidden",
                                value: _this5.getOptionValue(opt)
                            });
                        }) : /*#__PURE__*/ $eUqFw.createElement("input", {
                            name: name,
                            type: "hidden",
                            value: ""
                        });
                        return /*#__PURE__*/ $eUqFw.createElement("div", null, input);
                    }
                } else {
                    var _value = selectValue[0] ? this.getOptionValue(selectValue[0]) : '';
                    return /*#__PURE__*/ $eUqFw.createElement("input", {
                        name: name,
                        type: "hidden",
                        value: _value
                    });
                }
            }
        },
        {
            key: "renderLiveRegion",
            value: function renderLiveRegion() {
                var commonProps = this.commonProps;
                var _this$state6 = this.state, ariaSelection = _this$state6.ariaSelection, focusedOption = _this$state6.focusedOption, focusedValue = _this$state6.focusedValue, isFocused = _this$state6.isFocused, selectValue = _this$state6.selectValue;
                var focusableOptions = this.getFocusableOptions();
                return /*#__PURE__*/ $eUqFw.createElement($935291c440101c41$var$LiveRegion, (0, $kU09D.default)({}, commonProps, {
                    id: this.getElementId('live-region'),
                    ariaSelection: ariaSelection,
                    focusedOption: focusedOption,
                    focusedValue: focusedValue,
                    isFocused: isFocused,
                    selectValue: selectValue,
                    focusableOptions: focusableOptions
                }));
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$getComponents8 = this.getComponents(), Control = _this$getComponents8.Control, IndicatorsContainer = _this$getComponents8.IndicatorsContainer, SelectContainer = _this$getComponents8.SelectContainer, ValueContainer = _this$getComponents8.ValueContainer;
                var _this$props14 = this.props, className = _this$props14.className, id = _this$props14.id, isDisabled = _this$props14.isDisabled, menuIsOpen = _this$props14.menuIsOpen;
                var isFocused = this.state.isFocused;
                var commonProps = this.commonProps = this.getCommonProps();
                return /*#__PURE__*/ $eUqFw.createElement(SelectContainer, (0, $kU09D.default)({}, commonProps, {
                    className: className,
                    innerProps: {
                        id: id,
                        onKeyDown: this.onKeyDown
                    },
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }), this.renderLiveRegion(), /*#__PURE__*/ $eUqFw.createElement(Control, (0, $kU09D.default)({}, commonProps, {
                    innerRef: this.getControlRef,
                    innerProps: {
                        onMouseDown: this.onControlMouseDown,
                        onTouchEnd: this.onControlTouchEnd
                    },
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    menuIsOpen: menuIsOpen
                }), /*#__PURE__*/ $eUqFw.createElement(ValueContainer, (0, $kU09D.default)({}, commonProps, {
                    isDisabled: isDisabled
                }), this.renderPlaceholderOrValue(), this.renderInput()), /*#__PURE__*/ $eUqFw.createElement(IndicatorsContainer, (0, $kU09D.default)({}, commonProps, {
                    isDisabled: isDisabled
                }), this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField());
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(props, state) {
                var prevProps = state.prevProps, clearFocusValueOnUpdate = state.clearFocusValueOnUpdate, inputIsHiddenAfterUpdate = state.inputIsHiddenAfterUpdate, ariaSelection = state.ariaSelection, isFocused = state.isFocused, prevWasFocused = state.prevWasFocused;
                var options = props.options, value = props.value, menuIsOpen = props.menuIsOpen, inputValue = props.inputValue, isMulti = props.isMulti;
                var selectValue = (0, $jQxSL.I)(value);
                var newMenuOptionsState = {};
                if (prevProps && (value !== prevProps.value || options !== prevProps.options || menuIsOpen !== prevProps.menuIsOpen || inputValue !== prevProps.inputValue)) {
                    var focusableOptions = menuIsOpen ? $935291c440101c41$var$buildFocusableOptions(props, selectValue) : [];
                    var focusedValue = clearFocusValueOnUpdate ? $935291c440101c41$var$getNextFocusedValue(state, selectValue) : null;
                    var focusedOption = $935291c440101c41$var$getNextFocusedOption(state, focusableOptions);
                    newMenuOptionsState = {
                        selectValue: selectValue,
                        focusedOption: focusedOption,
                        focusedValue: focusedValue,
                        clearFocusValueOnUpdate: false
                    };
                }
                // some updates should toggle the state of the input visibility
                var newInputIsHiddenState = inputIsHiddenAfterUpdate != null && props !== prevProps ? {
                    inputIsHidden: inputIsHiddenAfterUpdate,
                    inputIsHiddenAfterUpdate: undefined
                } : {};
                var newAriaSelection = ariaSelection;
                var hasKeptFocus = isFocused && prevWasFocused;
                if (isFocused && !hasKeptFocus) {
                    // If `value` or `defaultValue` props are not empty then announce them
                    // when the Select is initially focused
                    newAriaSelection = {
                        value: (0, $jQxSL.D)(isMulti, selectValue, selectValue[0] || null),
                        options: selectValue,
                        action: 'initial-input-focus'
                    };
                    hasKeptFocus = !prevWasFocused;
                }
                // If the 'initial-input-focus' action has been set already
                // then reset the ariaSelection to null
                if ((ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus') newAriaSelection = null;
                return (0, $1Xn5q.default)((0, $1Xn5q.default)((0, $1Xn5q.default)({}, newMenuOptionsState), newInputIsHiddenState), {}, {
                    prevProps: props,
                    ariaSelection: newAriaSelection,
                    prevWasFocused: hasKeptFocus
                });
            }
        }
    ]);
    return Select;
}((0, $eUqFw.Component));
$935291c440101c41$export$25ce5a424b770e84.defaultProps = $935291c440101c41$export$407448d2b89b1813;

});
parcelRegister("lDSrn", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc177843783b087f$export$2e2bcd8739ae039);
function $fc177843783b087f$export$2e2bcd8739ae039(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("lIEGP", function(module, exports) {

$parcel$export(module.exports, "default", () => $fcfd452a83bb612a$export$2e2bcd8739ae039);

var $aM0Ke = parcelRequire("aM0Ke");
function $fcfd452a83bb612a$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, (0, $aM0Ke.default)(descriptor.key), descriptor);
    }
}
function $fcfd452a83bb612a$export$2e2bcd8739ae039(Constructor, protoProps, staticProps) {
    if (protoProps) $fcfd452a83bb612a$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $fcfd452a83bb612a$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}

});

parcelRegister("eT4IF", function(module, exports) {

$parcel$export(module.exports, "default", () => $ad69dceb97fc37d0$export$2e2bcd8739ae039);

var $c2pQl = parcelRequire("c2pQl");
function $ad69dceb97fc37d0$export$2e2bcd8739ae039(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) (0, $c2pQl.default)(subClass, superClass);
}

});

parcelRegister("7Dzgl", function(module, exports) {

$parcel$export(module.exports, "default", () => $58f7875a71af82f1$export$2e2bcd8739ae039);

var $i3rTN = parcelRequire("i3rTN");

var $8c5pC = parcelRequire("8c5pC");

var $4mIeV = parcelRequire("4mIeV");
function $58f7875a71af82f1$export$2e2bcd8739ae039(Derived) {
    var hasNativeReflectConstruct = (0, $8c5pC.default)();
    return function _createSuperInternal() {
        var Super = (0, $i3rTN.default)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $i3rTN.default)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $4mIeV.default)(this, result);
    };
}

});
parcelRegister("i3rTN", function(module, exports) {

$parcel$export(module.exports, "default", () => $d24e25f7bdedc6a7$export$2e2bcd8739ae039);
function $d24e25f7bdedc6a7$export$2e2bcd8739ae039(o) {
    $d24e25f7bdedc6a7$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $d24e25f7bdedc6a7$export$2e2bcd8739ae039(o);
}

});

parcelRegister("8c5pC", function(module, exports) {

$parcel$export(module.exports, "default", () => $5f73a47aa7a9581c$export$2e2bcd8739ae039);
function $5f73a47aa7a9581c$export$2e2bcd8739ae039() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($5f73a47aa7a9581c$export$2e2bcd8739ae039 = function _isNativeReflectConstruct() {
        return !!t;
    })();
}

});

parcelRegister("4mIeV", function(module, exports) {

$parcel$export(module.exports, "default", () => $32db889076b63d40$export$2e2bcd8739ae039);

var $5sKOb = parcelRequire("5sKOb");

var $aCdHv = parcelRequire("aCdHv");
function $32db889076b63d40$export$2e2bcd8739ae039(self, call) {
    if (call && ((0, $5sKOb.default)(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $aCdHv.default)(self);
}

});


parcelRegister("fVK4C", function(module, exports) {

$parcel$export(module.exports, "default", () => $b98feb1d5dd86921$export$2e2bcd8739ae039);

var $b7OIr = parcelRequire("b7OIr");

var $2B3l3 = parcelRequire("2B3l3");

var $e5SQy = parcelRequire("e5SQy");

var $csAMF = parcelRequire("csAMF");
function $b98feb1d5dd86921$export$2e2bcd8739ae039(arr) {
    return (0, $b7OIr.default)(arr) || (0, $2B3l3.default)(arr) || (0, $e5SQy.default)(arr) || (0, $csAMF.default)();
}

});
parcelRegister("b7OIr", function(module, exports) {

$parcel$export(module.exports, "default", () => $8197b040df4187a0$export$2e2bcd8739ae039);

var $aLrjs = parcelRequire("aLrjs");
function $8197b040df4187a0$export$2e2bcd8739ae039(arr) {
    if (Array.isArray(arr)) return (0, $aLrjs.default)(arr);
}

});

parcelRegister("2B3l3", function(module, exports) {

$parcel$export(module.exports, "default", () => $1e41a0710a3b4a62$export$2e2bcd8739ae039);
function $1e41a0710a3b4a62$export$2e2bcd8739ae039(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

});

parcelRegister("csAMF", function(module, exports) {

$parcel$export(module.exports, "default", () => $9124a21752235a23$export$2e2bcd8739ae039);
function $9124a21752235a23$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});




parcelRegister("3aVBa", function(module, exports) {

$parcel$export(module.exports, "ManagerReferenceNodeContext", () => $24fefc1eb423cf0c$export$3dbd3405086fec7b);
$parcel$export(module.exports, "ManagerReferenceNodeSetterContext", () => $24fefc1eb423cf0c$export$cbabb21c2529b130);
$parcel$export(module.exports, "Manager", () => $24fefc1eb423cf0c$export$d0d38e7dec7a1a61);

var $eUqFw = parcelRequire("eUqFw");
var $24fefc1eb423cf0c$export$3dbd3405086fec7b = $eUqFw.createContext();
var $24fefc1eb423cf0c$export$cbabb21c2529b130 = $eUqFw.createContext();
function $24fefc1eb423cf0c$export$d0d38e7dec7a1a61(_ref) {
    var children = _ref.children;
    var _React$useState = $eUqFw.useState(null), referenceNode = _React$useState[0], setReferenceNode = _React$useState[1];
    var hasUnmounted = $eUqFw.useRef(false);
    $eUqFw.useEffect(function() {
        return function() {
            hasUnmounted.current = true;
        };
    }, []);
    var handleSetReferenceNode = $eUqFw.useCallback(function(node) {
        if (!hasUnmounted.current) setReferenceNode(node);
    }, []);
    return /*#__PURE__*/ $eUqFw.createElement($24fefc1eb423cf0c$export$3dbd3405086fec7b.Provider, {
        value: referenceNode
    }, /*#__PURE__*/ $eUqFw.createElement($24fefc1eb423cf0c$export$cbabb21c2529b130.Provider, {
        value: handleSetReferenceNode
    }, children));
}

});

parcelRegister("aV2RP", function(module, exports) {

$parcel$export(module.exports, "Popper", () => $7f317398a3c1e136$export$badac9ada3a0bdf9);

var $eUqFw = parcelRequire("eUqFw");

var $3aVBa = parcelRequire("3aVBa");

var $4J8wt = parcelRequire("4J8wt");

var $fATwl = parcelRequire("fATwl");
var $7f317398a3c1e136$var$NOOP = function NOOP() {
    return void 0;
};
var $7f317398a3c1e136$var$NOOP_PROMISE = function NOOP_PROMISE() {
    return Promise.resolve(null);
};
var $7f317398a3c1e136$var$EMPTY_MODIFIERS = [];
function $7f317398a3c1e136$export$badac9ada3a0bdf9(_ref) {
    var _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? 'bottom' : _ref$placement, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? 'absolute' : _ref$strategy, _ref$modifiers = _ref.modifiers, modifiers = _ref$modifiers === void 0 ? $7f317398a3c1e136$var$EMPTY_MODIFIERS : _ref$modifiers, referenceElement = _ref.referenceElement, onFirstUpdate = _ref.onFirstUpdate, innerRef = _ref.innerRef, children = _ref.children;
    var referenceNode = $eUqFw.useContext((0, $3aVBa.ManagerReferenceNodeContext));
    var _React$useState = $eUqFw.useState(null), popperElement = _React$useState[0], setPopperElement = _React$useState[1];
    var _React$useState2 = $eUqFw.useState(null), arrowElement = _React$useState2[0], setArrowElement = _React$useState2[1];
    $eUqFw.useEffect(function() {
        (0, $4J8wt.setRef)(innerRef, popperElement);
    }, [
        innerRef,
        popperElement
    ]);
    var options = $eUqFw.useMemo(function() {
        return {
            placement: placement,
            strategy: strategy,
            onFirstUpdate: onFirstUpdate,
            modifiers: [].concat(modifiers, [
                {
                    name: 'arrow',
                    enabled: arrowElement != null,
                    options: {
                        element: arrowElement
                    }
                }
            ])
        };
    }, [
        placement,
        strategy,
        onFirstUpdate,
        modifiers,
        arrowElement
    ]);
    var _usePopper = (0, $fATwl.usePopper)(referenceElement || referenceNode, popperElement, options), state = _usePopper.state, styles = _usePopper.styles, forceUpdate = _usePopper.forceUpdate, update = _usePopper.update;
    var childrenProps = $eUqFw.useMemo(function() {
        return {
            ref: setPopperElement,
            style: styles.popper,
            placement: state ? state.placement : placement,
            hasPopperEscaped: state && state.modifiersData.hide ? state.modifiersData.hide.hasPopperEscaped : null,
            isReferenceHidden: state && state.modifiersData.hide ? state.modifiersData.hide.isReferenceHidden : null,
            arrowProps: {
                style: styles.arrow,
                ref: setArrowElement
            },
            forceUpdate: forceUpdate || $7f317398a3c1e136$var$NOOP,
            update: update || $7f317398a3c1e136$var$NOOP_PROMISE
        };
    }, [
        setPopperElement,
        setArrowElement,
        placement,
        state,
        styles,
        update,
        forceUpdate
    ]);
    return (0, $4J8wt.unwrapArray)(children)(childrenProps);
}

});
parcelRegister("4J8wt", function(module, exports) {

$parcel$export(module.exports, "unwrapArray", () => $3711f9d89c6c0713$export$f52c55943429c8b6);
$parcel$export(module.exports, "safeInvoke", () => $3711f9d89c6c0713$export$3dfa7c28635fe028);
$parcel$export(module.exports, "setRef", () => $3711f9d89c6c0713$export$4bb192c7cacf928f);
$parcel$export(module.exports, "fromEntries", () => $3711f9d89c6c0713$export$5150077fc2e7c662);
$parcel$export(module.exports, "useIsomorphicLayoutEffect", () => $3711f9d89c6c0713$export$700979bc83e7db82);

var $eUqFw = parcelRequire("eUqFw");
var $3711f9d89c6c0713$export$f52c55943429c8b6 = function unwrapArray(arg) {
    return Array.isArray(arg) ? arg[0] : arg;
};
var $3711f9d89c6c0713$export$3dfa7c28635fe028 = function safeInvoke(fn) {
    if (typeof fn === 'function') {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        return fn.apply(void 0, args);
    }
};
var $3711f9d89c6c0713$export$4bb192c7cacf928f = function setRef(ref, node) {
    // if its a function call it
    if (typeof ref === 'function') return $3711f9d89c6c0713$export$3dfa7c28635fe028(ref, node);
    else if (ref != null) ref.current = node;
};
var $3711f9d89c6c0713$export$5150077fc2e7c662 = function fromEntries(entries) {
    return entries.reduce(function(acc, _ref) {
        var key = _ref[0], value = _ref[1];
        acc[key] = value;
        return acc;
    }, {});
};
var $3711f9d89c6c0713$export$700979bc83e7db82 = typeof window !== 'undefined' && window.document && window.document.createElement ? $eUqFw.useLayoutEffect : $eUqFw.useEffect;

});

parcelRegister("fATwl", function(module, exports) {

$parcel$export(module.exports, "usePopper", () => $b5a5490e72f59dbf$export$f4d5bf230a36dd6e);

var $eUqFw = parcelRequire("eUqFw");

var $lEfVV = parcelRequire("lEfVV");

var $1sNnY = parcelRequire("1sNnY");

var $an8Qp = parcelRequire("an8Qp");

var $4J8wt = parcelRequire("4J8wt");
var $b5a5490e72f59dbf$var$EMPTY_MODIFIERS = [];
var $b5a5490e72f59dbf$export$f4d5bf230a36dd6e = function usePopper(referenceElement, popperElement, options) {
    if (options === void 0) options = {};
    var prevOptions = $eUqFw.useRef(null);
    var optionsWithDefaults = {
        onFirstUpdate: options.onFirstUpdate,
        placement: options.placement || 'bottom',
        strategy: options.strategy || 'absolute',
        modifiers: options.modifiers || $b5a5490e72f59dbf$var$EMPTY_MODIFIERS
    };
    var _React$useState = $eUqFw.useState({
        styles: {
            popper: {
                position: optionsWithDefaults.strategy,
                left: '0',
                top: '0'
            },
            arrow: {
                position: 'absolute'
            }
        },
        attributes: {}
    }), state = _React$useState[0], setState = _React$useState[1];
    var updateStateModifier = $eUqFw.useMemo(function() {
        return {
            name: 'updateState',
            enabled: true,
            phase: 'write',
            fn: function fn(_ref) {
                var state = _ref.state;
                var elements = Object.keys(state.elements);
                $lEfVV.flushSync(function() {
                    setState({
                        styles: (0, $4J8wt.fromEntries)(elements.map(function(element) {
                            return [
                                element,
                                state.styles[element] || {}
                            ];
                        })),
                        attributes: (0, $4J8wt.fromEntries)(elements.map(function(element) {
                            return [
                                element,
                                state.attributes[element]
                            ];
                        }))
                    });
                });
            },
            requires: [
                'computeStyles'
            ]
        };
    }, []);
    var popperOptions = $eUqFw.useMemo(function() {
        var newOptions = {
            onFirstUpdate: optionsWithDefaults.onFirstUpdate,
            placement: optionsWithDefaults.placement,
            strategy: optionsWithDefaults.strategy,
            modifiers: [].concat(optionsWithDefaults.modifiers, [
                updateStateModifier,
                {
                    name: 'applyStyles',
                    enabled: false
                }
            ])
        };
        if ((0, (/*@__PURE__*/$parcel$interopDefault($an8Qp)))(prevOptions.current, newOptions)) return prevOptions.current || newOptions;
        else {
            prevOptions.current = newOptions;
            return newOptions;
        }
    }, [
        optionsWithDefaults.onFirstUpdate,
        optionsWithDefaults.placement,
        optionsWithDefaults.strategy,
        optionsWithDefaults.modifiers,
        updateStateModifier
    ]);
    var popperInstanceRef = $eUqFw.useRef();
    (0, $4J8wt.useIsomorphicLayoutEffect)(function() {
        if (popperInstanceRef.current) popperInstanceRef.current.setOptions(popperOptions);
    }, [
        popperOptions
    ]);
    (0, $4J8wt.useIsomorphicLayoutEffect)(function() {
        if (referenceElement == null || popperElement == null) return;
        var createPopper = options.createPopper || (0, $1sNnY.createPopper);
        var popperInstance = createPopper(referenceElement, popperElement, popperOptions);
        popperInstanceRef.current = popperInstance;
        return function() {
            popperInstance.destroy();
            popperInstanceRef.current = null;
        };
    }, [
        referenceElement,
        popperElement,
        options.createPopper
    ]);
    return {
        state: popperInstanceRef.current ? popperInstanceRef.current.state : null,
        styles: state.styles,
        attributes: state.attributes,
        update: popperInstanceRef.current ? popperInstanceRef.current.update : null,
        forceUpdate: popperInstanceRef.current ? popperInstanceRef.current.forceUpdate : null
    };
};

});
parcelRegister("1sNnY", function(module, exports) {

$parcel$export(module.exports, "createPopper", () => $110eb6f1d5d14a7b$export$8f7491d57c8f97a9);

var $6dO3d = parcelRequire("6dO3d");

var $hKNVt = parcelRequire("hKNVt");

var $1hjVu = parcelRequire("1hjVu");

var $1T37S = parcelRequire("1T37S");

var $gbbnc = parcelRequire("gbbnc");

var $bX36N = parcelRequire("bX36N");

var $9chVh = parcelRequire("9chVh");

var $e0gkO = parcelRequire("e0gkO");

var $RxAbB = parcelRequire("RxAbB");

var $4Jkbd = parcelRequire("4Jkbd");


var $110eb6f1d5d14a7b$export$d34966752335dd47 = [
    (0, $hKNVt.default),
    (0, $1hjVu.default),
    (0, $1T37S.default),
    (0, $gbbnc.default),
    (0, $bX36N.default),
    (0, $9chVh.default),
    (0, $e0gkO.default),
    (0, $RxAbB.default),
    (0, $4Jkbd.default)
];
var $110eb6f1d5d14a7b$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $6dO3d.popperGenerator)({
    defaultModifiers: $110eb6f1d5d14a7b$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("6dO3d", function(module, exports) {

$parcel$export(module.exports, "popperGenerator", () => $487ac80c4f86ec1e$export$ed5e13716264f202);

var $gka9g = parcelRequire("gka9g");

var $3F4KV = parcelRequire("3F4KV");

var $edd0p = parcelRequire("edd0p");

var $1Z5jy = parcelRequire("1Z5jy");

var $UiAmo = parcelRequire("UiAmo");

var $4YkF9 = parcelRequire("4YkF9");

var $aCxpo = parcelRequire("aCxpo");


var $jxz5k = parcelRequire("jxz5k");
var $487ac80c4f86ec1e$var$DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function $487ac80c4f86ec1e$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function $487ac80c4f86ec1e$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $487ac80c4f86ec1e$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign({}, $487ac80c4f86ec1e$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $jxz5k.isElement)(reference) ? (0, $edd0p.default)(reference) : reference.contextElement ? (0, $edd0p.default)(reference.contextElement) : [],
                    popper: (0, $edd0p.default)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $UiAmo.default)((0, $aCxpo.default)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$487ac80c4f86ec1e$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $gka9g.default)(reference, (0, $1Z5jy.default)(popper), state.options.strategy === 'fixed'),
                    popper: (0, $3F4KV.default)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $4YkF9.default)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$487ac80c4f86ec1e$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $487ac80c4f86ec1e$export$8f7491d57c8f97a9 = /*#__PURE__*/ $487ac80c4f86ec1e$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("gka9g", function(module, exports) {

$parcel$export(module.exports, "default", () => $be2662d6eb9e3a4a$export$2e2bcd8739ae039);

var $gQlmL = parcelRequire("gQlmL");

var $3Q5Qy = parcelRequire("3Q5Qy");

var $3Ih4r = parcelRequire("3Ih4r");

var $jxz5k = parcelRequire("jxz5k");

var $gIy3I = parcelRequire("gIy3I");

var $9ce0D = parcelRequire("9ce0D");

var $lp2b7 = parcelRequire("lp2b7");

var $3Gelu = parcelRequire("3Gelu");
function $be2662d6eb9e3a4a$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $3Gelu.round)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $3Gelu.round)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $be2662d6eb9e3a4a$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $jxz5k.isHTMLElement)(offsetParent);
    var offsetParentIsScaled = (0, $jxz5k.isHTMLElement)(offsetParent) && $be2662d6eb9e3a4a$var$isElementScaled(offsetParent);
    var documentElement = (0, $9ce0D.default)(offsetParent);
    var rect = (0, $gQlmL.default)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $3Ih4r.default)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        (0, $lp2b7.default)(documentElement)) scroll = (0, $3Q5Qy.default)(offsetParent);
        if ((0, $jxz5k.isHTMLElement)(offsetParent)) {
            offsets = (0, $gQlmL.default)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $gIy3I.default)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}

});
parcelRegister("gQlmL", function(module, exports) {

$parcel$export(module.exports, "default", () => $c432138ece0d4fa8$export$2e2bcd8739ae039);

var $jxz5k = parcelRequire("jxz5k");

var $3Gelu = parcelRequire("3Gelu");

var $eNjCb = parcelRequire("eNjCb");

var $2QPpT = parcelRequire("2QPpT");
function $c432138ece0d4fa8$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $jxz5k.isHTMLElement)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $3Gelu.round)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $3Gelu.round)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $jxz5k.isElement)(element) ? (0, $eNjCb.default)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $2QPpT.default)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}

});
parcelRegister("jxz5k", function(module, exports) {

$parcel$export(module.exports, "isElement", () => $e39c508a61a40243$export$45a5e7f76e0caa8d);
$parcel$export(module.exports, "isHTMLElement", () => $e39c508a61a40243$export$1b3bfaa9684536aa);
$parcel$export(module.exports, "isShadowRoot", () => $e39c508a61a40243$export$af51f0f06c0f328a);

var $eNjCb = parcelRequire("eNjCb");
function $e39c508a61a40243$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $eNjCb.default)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $e39c508a61a40243$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $eNjCb.default)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $e39c508a61a40243$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') return false;
    var OwnElement = (0, $eNjCb.default)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}

});
parcelRegister("eNjCb", function(module, exports) {

$parcel$export(module.exports, "default", () => $ac54db6104c61765$export$2e2bcd8739ae039);
function $ac54db6104c61765$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}

});


parcelRegister("3Gelu", function(module, exports) {

$parcel$export(module.exports, "max", () => $2ae06c1a24639922$export$8960430cfd85939f);
$parcel$export(module.exports, "min", () => $2ae06c1a24639922$export$96ec731ed4dcb222);
$parcel$export(module.exports, "round", () => $2ae06c1a24639922$export$2077e0241d6afd3c);
var $2ae06c1a24639922$export$8960430cfd85939f = Math.max;
var $2ae06c1a24639922$export$96ec731ed4dcb222 = Math.min;
var $2ae06c1a24639922$export$2077e0241d6afd3c = Math.round;

});

parcelRegister("2QPpT", function(module, exports) {

$parcel$export(module.exports, "default", () => $2138525ae724b403$export$2e2bcd8739ae039);

var $j87Uw = parcelRequire("j87Uw");
function $2138525ae724b403$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $j87Uw.default)());
}

});
parcelRegister("j87Uw", function(module, exports) {

$parcel$export(module.exports, "default", () => $ded4e693f114a81c$export$2e2bcd8739ae039);
function $ded4e693f114a81c$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(' ');
    return navigator.userAgent;
}

});



parcelRegister("3Q5Qy", function(module, exports) {

$parcel$export(module.exports, "default", () => $2cbac36da0487101$export$2e2bcd8739ae039);

var $hRE8q = parcelRequire("hRE8q");

var $eNjCb = parcelRequire("eNjCb");

var $jxz5k = parcelRequire("jxz5k");

var $4K3DC = parcelRequire("4K3DC");
function $2cbac36da0487101$export$2e2bcd8739ae039(node) {
    if (node === (0, $eNjCb.default)(node) || !(0, $jxz5k.isHTMLElement)(node)) return (0, $hRE8q.default)(node);
    else return (0, $4K3DC.default)(node);
}

});
parcelRegister("hRE8q", function(module, exports) {

$parcel$export(module.exports, "default", () => $d01684e258e44be2$export$2e2bcd8739ae039);

var $eNjCb = parcelRequire("eNjCb");
function $d01684e258e44be2$export$2e2bcd8739ae039(node) {
    var win = (0, $eNjCb.default)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}

});

parcelRegister("4K3DC", function(module, exports) {

$parcel$export(module.exports, "default", () => $373e47b99d05f3c9$export$2e2bcd8739ae039);
function $373e47b99d05f3c9$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}

});


parcelRegister("3Ih4r", function(module, exports) {

$parcel$export(module.exports, "default", () => $2b42b9085e0eb740$export$2e2bcd8739ae039);
function $2b42b9085e0eb740$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}

});

parcelRegister("gIy3I", function(module, exports) {

$parcel$export(module.exports, "default", () => $c2bb2ccf0fe2e3c3$export$2e2bcd8739ae039);

var $gQlmL = parcelRequire("gQlmL");

var $9ce0D = parcelRequire("9ce0D");

var $hRE8q = parcelRequire("hRE8q");
function $c2bb2ccf0fe2e3c3$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $gQlmL.default)((0, $9ce0D.default)(element)).left + (0, $hRE8q.default)(element).scrollLeft;
}

});
parcelRegister("9ce0D", function(module, exports) {

$parcel$export(module.exports, "default", () => $6b2019f883903c78$export$2e2bcd8739ae039);

var $jxz5k = parcelRequire("jxz5k");
function $6b2019f883903c78$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $jxz5k.isElement)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}

});


parcelRegister("lp2b7", function(module, exports) {

$parcel$export(module.exports, "default", () => $f94d9f5c84260b26$export$2e2bcd8739ae039);

var $itp1E = parcelRequire("itp1E");
function $f94d9f5c84260b26$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $itp1E.default)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

});
parcelRegister("itp1E", function(module, exports) {

$parcel$export(module.exports, "default", () => $d72e58fb356d483c$export$2e2bcd8739ae039);

var $eNjCb = parcelRequire("eNjCb");
function $d72e58fb356d483c$export$2e2bcd8739ae039(element) {
    return (0, $eNjCb.default)(element).getComputedStyle(element);
}

});



parcelRegister("3F4KV", function(module, exports) {

$parcel$export(module.exports, "default", () => $2aa8e3d950b93051$export$2e2bcd8739ae039);

var $gQlmL = parcelRequire("gQlmL");
function $2aa8e3d950b93051$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $gQlmL.default)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}

});

parcelRegister("edd0p", function(module, exports) {

$parcel$export(module.exports, "default", () => $a58c5e38958f7507$export$2e2bcd8739ae039);

var $hfADZ = parcelRequire("hfADZ");

var $6P0Dy = parcelRequire("6P0Dy");

var $eNjCb = parcelRequire("eNjCb");

var $lp2b7 = parcelRequire("lp2b7");
function $a58c5e38958f7507$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $hfADZ.default)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $eNjCb.default)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $lp2b7.default)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($a58c5e38958f7507$export$2e2bcd8739ae039((0, $6P0Dy.default)(target)));
}

});
parcelRegister("hfADZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $c8f043198ffd7cdf$export$2e2bcd8739ae039);

var $6P0Dy = parcelRequire("6P0Dy");

var $lp2b7 = parcelRequire("lp2b7");

var $3Ih4r = parcelRequire("3Ih4r");

var $jxz5k = parcelRequire("jxz5k");
function $c8f043198ffd7cdf$export$2e2bcd8739ae039(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf((0, $3Ih4r.default)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $jxz5k.isHTMLElement)(node) && (0, $lp2b7.default)(node)) return node;
    return $c8f043198ffd7cdf$export$2e2bcd8739ae039((0, $6P0Dy.default)(node));
}

});
parcelRegister("6P0Dy", function(module, exports) {

$parcel$export(module.exports, "default", () => $4f780000a33023fc$export$2e2bcd8739ae039);

var $3Ih4r = parcelRequire("3Ih4r");

var $9ce0D = parcelRequire("9ce0D");

var $jxz5k = parcelRequire("jxz5k");
function $4f780000a33023fc$export$2e2bcd8739ae039(element) {
    if ((0, $3Ih4r.default)(element) === 'html') return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $jxz5k.isShadowRoot)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $9ce0D.default)(element) // fallback
    );
}

});



parcelRegister("1Z5jy", function(module, exports) {

$parcel$export(module.exports, "default", () => $171f9c4bd8752ce1$export$2e2bcd8739ae039);

var $eNjCb = parcelRequire("eNjCb");

var $3Ih4r = parcelRequire("3Ih4r");

var $itp1E = parcelRequire("itp1E");

var $jxz5k = parcelRequire("jxz5k");

var $cPuw6 = parcelRequire("cPuw6");

var $6P0Dy = parcelRequire("6P0Dy");

var $j87Uw = parcelRequire("j87Uw");
function $171f9c4bd8752ce1$var$getTrueOffsetParent(element) {
    if (!(0, $jxz5k.isHTMLElement)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $itp1E.default)(element).position === 'fixed') return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $171f9c4bd8752ce1$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $j87Uw.default)());
    var isIE = /Trident/i.test((0, $j87Uw.default)());
    if (isIE && (0, $jxz5k.isHTMLElement)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $itp1E.default)(element);
        if (elementCss.position === 'fixed') return null;
    }
    var currentNode = (0, $6P0Dy.default)(element);
    if ((0, $jxz5k.isShadowRoot)(currentNode)) currentNode = currentNode.host;
    while((0, $jxz5k.isHTMLElement)(currentNode) && [
        'html',
        'body'
    ].indexOf((0, $3Ih4r.default)(currentNode)) < 0){
        var css = (0, $itp1E.default)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $171f9c4bd8752ce1$export$2e2bcd8739ae039(element) {
    var window = (0, $eNjCb.default)(element);
    var offsetParent = $171f9c4bd8752ce1$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $cPuw6.default)(offsetParent) && (0, $itp1E.default)(offsetParent).position === 'static')offsetParent = $171f9c4bd8752ce1$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $3Ih4r.default)(offsetParent) === 'html' || (0, $3Ih4r.default)(offsetParent) === 'body' && (0, $itp1E.default)(offsetParent).position === 'static')) return window;
    return offsetParent || $171f9c4bd8752ce1$var$getContainingBlock(element) || window;
}

});
parcelRegister("cPuw6", function(module, exports) {

$parcel$export(module.exports, "default", () => $9571eb7890da3be6$export$2e2bcd8739ae039);

var $3Ih4r = parcelRequire("3Ih4r");
function $9571eb7890da3be6$export$2e2bcd8739ae039(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf((0, $3Ih4r.default)(element)) >= 0;
}

});


parcelRegister("UiAmo", function(module, exports) {

$parcel$export(module.exports, "default", () => $0a93a5c300cea5e9$export$2e2bcd8739ae039);

var $cUxAV = parcelRequire("cUxAV");
function $0a93a5c300cea5e9$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $0a93a5c300cea5e9$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $0a93a5c300cea5e9$var$order(modifiers); // order based on phase
    return (0, $cUxAV.modifierPhases).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}

});
parcelRegister("cUxAV", function(module, exports) {

$parcel$export(module.exports, "top", () => $9664c6303656943f$export$1e95b668f3b82d);
$parcel$export(module.exports, "bottom", () => $9664c6303656943f$export$40e543e69a8b3fbb);
$parcel$export(module.exports, "right", () => $9664c6303656943f$export$79ffe56a765070d2);
$parcel$export(module.exports, "left", () => $9664c6303656943f$export$eabcd2c8791e7bf4);
$parcel$export(module.exports, "auto", () => $9664c6303656943f$export$dfb5619354ba860);
$parcel$export(module.exports, "basePlacements", () => $9664c6303656943f$export$aec2ce47c367b8c3);
$parcel$export(module.exports, "start", () => $9664c6303656943f$export$b3571188c770cc5a);
$parcel$export(module.exports, "end", () => $9664c6303656943f$export$bd5df0f255a350f8);
$parcel$export(module.exports, "clippingParents", () => $9664c6303656943f$export$390fd549c5303b4d);
$parcel$export(module.exports, "viewport", () => $9664c6303656943f$export$d7b7311ec04a3e8f);
$parcel$export(module.exports, "popper", () => $9664c6303656943f$export$ae5ab1c730825774);
$parcel$export(module.exports, "reference", () => $9664c6303656943f$export$ca50aac9f3ba507f);
$parcel$export(module.exports, "variationPlacements", () => $9664c6303656943f$export$368f9a87e87fa4e1);
$parcel$export(module.exports, "placements", () => $9664c6303656943f$export$803cd8101b6c182b);
$parcel$export(module.exports, "modifierPhases", () => $9664c6303656943f$export$d087d3878fdf71d5);
var $9664c6303656943f$export$1e95b668f3b82d = 'top';
var $9664c6303656943f$export$40e543e69a8b3fbb = 'bottom';
var $9664c6303656943f$export$79ffe56a765070d2 = 'right';
var $9664c6303656943f$export$eabcd2c8791e7bf4 = 'left';
var $9664c6303656943f$export$dfb5619354ba860 = 'auto';
var $9664c6303656943f$export$aec2ce47c367b8c3 = [
    $9664c6303656943f$export$1e95b668f3b82d,
    $9664c6303656943f$export$40e543e69a8b3fbb,
    $9664c6303656943f$export$79ffe56a765070d2,
    $9664c6303656943f$export$eabcd2c8791e7bf4
];
var $9664c6303656943f$export$b3571188c770cc5a = 'start';
var $9664c6303656943f$export$bd5df0f255a350f8 = 'end';
var $9664c6303656943f$export$390fd549c5303b4d = 'clippingParents';
var $9664c6303656943f$export$d7b7311ec04a3e8f = 'viewport';
var $9664c6303656943f$export$ae5ab1c730825774 = 'popper';
var $9664c6303656943f$export$ca50aac9f3ba507f = 'reference';
var $9664c6303656943f$export$368f9a87e87fa4e1 = /*#__PURE__*/ $9664c6303656943f$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $9664c6303656943f$export$b3571188c770cc5a,
        placement + "-" + $9664c6303656943f$export$bd5df0f255a350f8
    ]);
}, []);
var $9664c6303656943f$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($9664c6303656943f$export$aec2ce47c367b8c3, [
    $9664c6303656943f$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $9664c6303656943f$export$b3571188c770cc5a,
        placement + "-" + $9664c6303656943f$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $9664c6303656943f$export$421679a7c3d56e = 'beforeRead';
var $9664c6303656943f$export$aafa59e2e03f2942 = 'read';
var $9664c6303656943f$export$6964f6c886723980 = 'afterRead'; // pure-logic modifiers
var $9664c6303656943f$export$c65e99957a05207c = 'beforeMain';
var $9664c6303656943f$export$f22da7240b7add18 = 'main';
var $9664c6303656943f$export$bab79516f2d662fe = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var $9664c6303656943f$export$8d4d2d70e7d46032 = 'beforeWrite';
var $9664c6303656943f$export$68d8715fc104d294 = 'write';
var $9664c6303656943f$export$70a6e5159acce2e6 = 'afterWrite';
var $9664c6303656943f$export$d087d3878fdf71d5 = [
    $9664c6303656943f$export$421679a7c3d56e,
    $9664c6303656943f$export$aafa59e2e03f2942,
    $9664c6303656943f$export$6964f6c886723980,
    $9664c6303656943f$export$c65e99957a05207c,
    $9664c6303656943f$export$f22da7240b7add18,
    $9664c6303656943f$export$bab79516f2d662fe,
    $9664c6303656943f$export$8d4d2d70e7d46032,
    $9664c6303656943f$export$68d8715fc104d294,
    $9664c6303656943f$export$70a6e5159acce2e6
];

});


parcelRegister("4YkF9", function(module, exports) {

$parcel$export(module.exports, "default", () => $39eccb35e3c50f87$export$2e2bcd8739ae039);
function $39eccb35e3c50f87$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}

});

parcelRegister("aCxpo", function(module, exports) {

$parcel$export(module.exports, "default", () => $7bb75e3a2d172ac3$export$2e2bcd8739ae039);
function $7bb75e3a2d172ac3$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}

});


parcelRegister("hKNVt", function(module, exports) {

$parcel$export(module.exports, "default", () => $cecd75ca68a9b247$export$2e2bcd8739ae039);

var $eNjCb = parcelRequire("eNjCb");
var $cecd75ca68a9b247$var$passive = {
    passive: true
};
function $cecd75ca68a9b247$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $eNjCb.default)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, $cecd75ca68a9b247$var$passive);
    });
    if (resize) window.addEventListener('resize', instance.update, $cecd75ca68a9b247$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, $cecd75ca68a9b247$var$passive);
        });
        if (resize) window.removeEventListener('resize', instance.update, $cecd75ca68a9b247$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $cecd75ca68a9b247$export$2e2bcd8739ae039 = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: $cecd75ca68a9b247$var$effect,
    data: {}
};

});

parcelRegister("1hjVu", function(module, exports) {

$parcel$export(module.exports, "default", () => $0ee6d5e58dbc65f7$export$2e2bcd8739ae039);

var $2v9wJ = parcelRequire("2v9wJ");
function $0ee6d5e58dbc65f7$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $2v9wJ.default)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $0ee6d5e58dbc65f7$export$2e2bcd8739ae039 = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: $0ee6d5e58dbc65f7$var$popperOffsets,
    data: {}
};

});
parcelRegister("2v9wJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $1d25dddec077799d$export$2e2bcd8739ae039);

var $i0vbU = parcelRequire("i0vbU");

var $hqMUN = parcelRequire("hqMUN");

var $lM4La = parcelRequire("lM4La");

var $cUxAV = parcelRequire("cUxAV");
function $1d25dddec077799d$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $i0vbU.default)(placement) : null;
    var variation = placement ? (0, $hqMUN.default)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $cUxAV.top:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $cUxAV.bottom:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $cUxAV.right:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $cUxAV.left:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $lM4La.default)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case 0, $cUxAV.start:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $cUxAV.end:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}

});
parcelRegister("i0vbU", function(module, exports) {

$parcel$export(module.exports, "default", () => $d1c06bfb436e5b63$export$2e2bcd8739ae039);

function $d1c06bfb436e5b63$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[0];
}

});

parcelRegister("hqMUN", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb0acede73c1ccbf$export$2e2bcd8739ae039);
function $cb0acede73c1ccbf$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[1];
}

});

parcelRegister("lM4La", function(module, exports) {

$parcel$export(module.exports, "default", () => $fda1c5d978c44f54$export$2e2bcd8739ae039);
function $fda1c5d978c44f54$export$2e2bcd8739ae039(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}

});



parcelRegister("1T37S", function(module, exports) {

$parcel$export(module.exports, "default", () => $15fd5a492bd54a2d$export$2e2bcd8739ae039);

var $cUxAV = parcelRequire("cUxAV");

var $1Z5jy = parcelRequire("1Z5jy");

var $eNjCb = parcelRequire("eNjCb");

var $9ce0D = parcelRequire("9ce0D");

var $itp1E = parcelRequire("itp1E");

var $i0vbU = parcelRequire("i0vbU");

var $hqMUN = parcelRequire("hqMUN");

var $3Gelu = parcelRequire("3Gelu");
var $15fd5a492bd54a2d$var$unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $15fd5a492bd54a2d$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $3Gelu.round)(x * dpr) / dpr || 0,
        y: (0, $3Gelu.round)(y * dpr) / dpr || 0
    };
}
function $15fd5a492bd54a2d$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = (0, $cUxAV.left);
    var sideY = (0, $cUxAV.top);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $1Z5jy.default)(popper);
        var heightProp = 'clientHeight';
        var widthProp = 'clientWidth';
        if (offsetParent === (0, $eNjCb.default)(popper)) {
            offsetParent = (0, $9ce0D.default)(popper);
            if ((0, $itp1E.default)(offsetParent).position !== 'static' && position === 'absolute') {
                heightProp = 'scrollHeight';
                widthProp = 'scrollWidth';
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $cUxAV.top) || (placement === (0, $cUxAV.left) || placement === (0, $cUxAV.right)) && variation === (0, $cUxAV.end)) {
            sideY = (0, $cUxAV.bottom);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $cUxAV.left) || (placement === (0, $cUxAV.top) || placement === (0, $cUxAV.bottom)) && variation === (0, $cUxAV.end)) {
            sideX = (0, $cUxAV.right);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $15fd5a492bd54a2d$var$unsetSides);
    var _ref4 = roundOffsets === true ? $15fd5a492bd54a2d$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $eNjCb.default)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function $15fd5a492bd54a2d$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $i0vbU.default)(state.placement),
        variation: (0, $hqMUN.default)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === 'fixed'
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $15fd5a492bd54a2d$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $15fd5a492bd54a2d$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $15fd5a492bd54a2d$export$2e2bcd8739ae039 = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: $15fd5a492bd54a2d$var$computeStyles,
    data: {}
};

});

parcelRegister("gbbnc", function(module, exports) {

$parcel$export(module.exports, "default", () => $bc767ee95e24374d$export$2e2bcd8739ae039);

var $3Ih4r = parcelRequire("3Ih4r");

var $jxz5k = parcelRequire("jxz5k");
// and applies them to the HTMLElements such as popper and arrow
function $bc767ee95e24374d$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $jxz5k.isHTMLElement)(element) || !(0, $3Ih4r.default)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? '' : value);
        });
    });
}
function $bc767ee95e24374d$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: '0',
            top: '0',
            margin: '0'
        },
        arrow: {
            position: 'absolute'
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = '';
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $jxz5k.isHTMLElement)(element) || !(0, $3Ih4r.default)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $bc767ee95e24374d$export$2e2bcd8739ae039 = {
    name: 'applyStyles',
    enabled: true,
    phase: 'write',
    fn: $bc767ee95e24374d$var$applyStyles,
    effect: $bc767ee95e24374d$var$effect,
    requires: [
        'computeStyles'
    ]
};

});

parcelRegister("bX36N", function(module, exports) {

$parcel$export(module.exports, "default", () => $8b379db63df9cbb0$export$2e2bcd8739ae039);

var $i0vbU = parcelRequire("i0vbU");

var $cUxAV = parcelRequire("cUxAV");
function $8b379db63df9cbb0$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $i0vbU.default)(placement);
    var invertDistance = [
        (0, $cUxAV.left),
        (0, $cUxAV.top)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $cUxAV.left),
        (0, $cUxAV.right)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $8b379db63df9cbb0$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $cUxAV.placements).reduce(function(acc, placement) {
        acc[placement] = $8b379db63df9cbb0$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $8b379db63df9cbb0$export$2e2bcd8739ae039 = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: [
        'popperOffsets'
    ],
    fn: $8b379db63df9cbb0$var$offset
};

});

parcelRegister("9chVh", function(module, exports) {

$parcel$export(module.exports, "default", () => $6b23232380764dc2$export$2e2bcd8739ae039);

var $3J90z = parcelRequire("3J90z");

var $i0vbU = parcelRequire("i0vbU");

var $69vda = parcelRequire("69vda");

var $9c30h = parcelRequire("9c30h");

var $cnkWG = parcelRequire("cnkWG");

var $cUxAV = parcelRequire("cUxAV");

var $hqMUN = parcelRequire("hqMUN");
function $6b23232380764dc2$var$getExpandedFallbackPlacements(placement) {
    if ((0, $i0vbU.default)(placement) === (0, $cUxAV.auto)) return [];
    var oppositePlacement = (0, $3J90z.default)(placement);
    return [
        (0, $69vda.default)(placement),
        oppositePlacement,
        (0, $69vda.default)(oppositePlacement)
    ];
}
function $6b23232380764dc2$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $i0vbU.default)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $3J90z.default)(preferredPlacement)
    ] : $6b23232380764dc2$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $i0vbU.default)(placement) === (0, $cUxAV.auto) ? (0, $cnkWG.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $i0vbU.default)(placement);
        var isStartVariation = (0, $hqMUN.default)(placement) === (0, $cUxAV.start);
        var isVertical = [
            (0, $cUxAV.top),
            (0, $cUxAV.bottom)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = (0, $9c30h.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $cUxAV.right) : (0, $cUxAV.left) : isStartVariation ? (0, $cUxAV.bottom) : (0, $cUxAV.top);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $3J90z.default)(mainVariationSide);
        var altVariationSide = (0, $3J90z.default)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $6b23232380764dc2$export$2e2bcd8739ae039 = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: $6b23232380764dc2$var$flip,
    requiresIfExists: [
        'offset'
    ],
    data: {
        _skip: false
    }
};

});
parcelRegister("3J90z", function(module, exports) {

$parcel$export(module.exports, "default", () => $2b6c8fe3295acfa9$export$2e2bcd8739ae039);
var $2b6c8fe3295acfa9$var$hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $2b6c8fe3295acfa9$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $2b6c8fe3295acfa9$var$hash[matched];
    });
}

});

parcelRegister("69vda", function(module, exports) {

$parcel$export(module.exports, "default", () => $47abcb4441e1bf89$export$2e2bcd8739ae039);
var $47abcb4441e1bf89$var$hash = {
    start: 'end',
    end: 'start'
};
function $47abcb4441e1bf89$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $47abcb4441e1bf89$var$hash[matched];
    });
}

});

parcelRegister("9c30h", function(module, exports) {

$parcel$export(module.exports, "default", () => $01ba2fbfff0d8e73$export$2e2bcd8739ae039);

var $euRUt = parcelRequire("euRUt");

var $9ce0D = parcelRequire("9ce0D");

var $gQlmL = parcelRequire("gQlmL");

var $2v9wJ = parcelRequire("2v9wJ");

var $e4Nvn = parcelRequire("e4Nvn");

var $cUxAV = parcelRequire("cUxAV");

var $jxz5k = parcelRequire("jxz5k");

var $k6Ryt = parcelRequire("k6Ryt");

var $5kx8d = parcelRequire("5kx8d");
function $01ba2fbfff0d8e73$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $cUxAV.clippingParents) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $cUxAV.viewport) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $cUxAV.popper) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $k6Ryt.default)(typeof padding !== 'number' ? padding : (0, $5kx8d.default)(padding, (0, $cUxAV.basePlacements)));
    var altContext = elementContext === (0, $cUxAV.popper) ? (0, $cUxAV.reference) : (0, $cUxAV.popper);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $euRUt.default)((0, $jxz5k.isElement)(element) ? element : element.contextElement || (0, $9ce0D.default)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $gQlmL.default)(state.elements.reference);
    var popperOffsets = (0, $2v9wJ.default)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
    });
    var popperClientRect = (0, $e4Nvn.default)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $cUxAV.popper) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $cUxAV.popper) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $cUxAV.right),
                (0, $cUxAV.bottom)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $cUxAV.top),
                (0, $cUxAV.bottom)
            ].indexOf(key) >= 0 ? 'y' : 'x';
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}

});
parcelRegister("euRUt", function(module, exports) {

$parcel$export(module.exports, "default", () => $a8ddaf68f655dcbb$export$2e2bcd8739ae039);

var $cUxAV = parcelRequire("cUxAV");

var $9VLoV = parcelRequire("9VLoV");

var $4dh5d = parcelRequire("4dh5d");

var $edd0p = parcelRequire("edd0p");

var $1Z5jy = parcelRequire("1Z5jy");

var $9ce0D = parcelRequire("9ce0D");

var $itp1E = parcelRequire("itp1E");

var $jxz5k = parcelRequire("jxz5k");

var $gQlmL = parcelRequire("gQlmL");

var $6P0Dy = parcelRequire("6P0Dy");

var $lzCV1 = parcelRequire("lzCV1");

var $3Ih4r = parcelRequire("3Ih4r");

var $e4Nvn = parcelRequire("e4Nvn");

var $3Gelu = parcelRequire("3Gelu");
function $a8ddaf68f655dcbb$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $gQlmL.default)(element, false, strategy === 'fixed');
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $a8ddaf68f655dcbb$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $cUxAV.viewport) ? (0, $e4Nvn.default)((0, $9VLoV.default)(element, strategy)) : (0, $jxz5k.isElement)(clippingParent) ? $a8ddaf68f655dcbb$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $e4Nvn.default)((0, $4dh5d.default)((0, $9ce0D.default)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $a8ddaf68f655dcbb$var$getClippingParents(element) {
    var clippingParents = (0, $edd0p.default)((0, $6P0Dy.default)(element));
    var canEscapeClipping = [
        'absolute',
        'fixed'
    ].indexOf((0, $itp1E.default)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $jxz5k.isHTMLElement)(element) ? (0, $1Z5jy.default)(element) : element;
    if (!(0, $jxz5k.isElement)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $jxz5k.isElement)(clippingParent) && (0, $lzCV1.default)(clippingParent, clipperElement) && (0, $3Ih4r.default)(clippingParent) !== 'body';
    });
} // Gets the maximum area that the element is visible in due to any number of
function $a8ddaf68f655dcbb$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === 'clippingParents' ? $a8ddaf68f655dcbb$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $a8ddaf68f655dcbb$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $3Gelu.max)(rect.top, accRect.top);
        accRect.right = (0, $3Gelu.min)(rect.right, accRect.right);
        accRect.bottom = (0, $3Gelu.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, $3Gelu.max)(rect.left, accRect.left);
        return accRect;
    }, $a8ddaf68f655dcbb$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}

});
parcelRegister("9VLoV", function(module, exports) {

$parcel$export(module.exports, "default", () => $73ae34c7061d9956$export$2e2bcd8739ae039);

var $eNjCb = parcelRequire("eNjCb");

var $9ce0D = parcelRequire("9ce0D");

var $gIy3I = parcelRequire("gIy3I");

var $2QPpT = parcelRequire("2QPpT");
function $73ae34c7061d9956$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $eNjCb.default)(element);
    var html = (0, $9ce0D.default)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $2QPpT.default)();
        if (layoutViewport || !layoutViewport && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $gIy3I.default)(element),
        y: y
    };
}

});

parcelRegister("4dh5d", function(module, exports) {

$parcel$export(module.exports, "default", () => $3115a0ad95105587$export$2e2bcd8739ae039);

var $9ce0D = parcelRequire("9ce0D");

var $itp1E = parcelRequire("itp1E");

var $gIy3I = parcelRequire("gIy3I");

var $hRE8q = parcelRequire("hRE8q");

var $3Gelu = parcelRequire("3Gelu");
function $3115a0ad95105587$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $9ce0D.default)(element);
    var winScroll = (0, $hRE8q.default)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $3Gelu.max)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $3Gelu.max)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $gIy3I.default)(element);
    var y = -winScroll.scrollTop;
    if ((0, $itp1E.default)(body || html).direction === 'rtl') x += (0, $3Gelu.max)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}

});

parcelRegister("lzCV1", function(module, exports) {

$parcel$export(module.exports, "default", () => $fb4b0e4a19431f61$export$2e2bcd8739ae039);

var $jxz5k = parcelRequire("jxz5k");
function $fb4b0e4a19431f61$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $jxz5k.isShadowRoot)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}

});

parcelRegister("e4Nvn", function(module, exports) {

$parcel$export(module.exports, "default", () => $a3f7d713ddb7bbc6$export$2e2bcd8739ae039);
function $a3f7d713ddb7bbc6$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}

});


parcelRegister("k6Ryt", function(module, exports) {

$parcel$export(module.exports, "default", () => $ea3de91a59864afc$export$2e2bcd8739ae039);

var $5ZEXv = parcelRequire("5ZEXv");
function $ea3de91a59864afc$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $5ZEXv.default)(), paddingObject);
}

});
parcelRegister("5ZEXv", function(module, exports) {

$parcel$export(module.exports, "default", () => $45d26bcdb7eb1b34$export$2e2bcd8739ae039);
function $45d26bcdb7eb1b34$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}

});


parcelRegister("5kx8d", function(module, exports) {

$parcel$export(module.exports, "default", () => $3e1885427cc06434$export$2e2bcd8739ae039);
function $3e1885427cc06434$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}

});


parcelRegister("cnkWG", function(module, exports) {

$parcel$export(module.exports, "default", () => $9027e15f6f74b552$export$2e2bcd8739ae039);

var $hqMUN = parcelRequire("hqMUN");

var $cUxAV = parcelRequire("cUxAV");

var $9c30h = parcelRequire("9c30h");

var $i0vbU = parcelRequire("i0vbU");
function $9027e15f6f74b552$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $cUxAV.placements) : _options$allowedAutoP;
    var variation = (0, $hqMUN.default)(placement);
    var placements = variation ? flipVariations ? (0, $cUxAV.variationPlacements) : (0, $cUxAV.variationPlacements).filter(function(placement) {
        return (0, $hqMUN.default)(placement) === variation;
    }) : (0, $cUxAV.basePlacements);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $9c30h.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $i0vbU.default)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}

});


parcelRegister("e0gkO", function(module, exports) {

$parcel$export(module.exports, "default", () => $a31dbc8612778f59$export$2e2bcd8739ae039);

var $cUxAV = parcelRequire("cUxAV");

var $i0vbU = parcelRequire("i0vbU");

var $lM4La = parcelRequire("lM4La");

var $3ZBe7 = parcelRequire("3ZBe7");

var $1lJXP = parcelRequire("1lJXP");

var $3F4KV = parcelRequire("3F4KV");

var $1Z5jy = parcelRequire("1Z5jy");

var $9c30h = parcelRequire("9c30h");

var $hqMUN = parcelRequire("hqMUN");

var $5ZEXv = parcelRequire("5ZEXv");

var $3Gelu = parcelRequire("3Gelu");
function $a31dbc8612778f59$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $9c30h.default)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $i0vbU.default)(state.placement);
    var variation = (0, $hqMUN.default)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $lM4La.default)(basePlacement);
    var altAxis = (0, $3ZBe7.default)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === 'y' ? (0, $cUxAV.top) : (0, $cUxAV.left);
        var altSide = mainAxis === 'y' ? (0, $cUxAV.bottom) : (0, $cUxAV.right);
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $cUxAV.start) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $cUxAV.start) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $3F4KV.default)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, $5ZEXv.default)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $1lJXP.within)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $1Z5jy.default)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $1lJXP.within)(tether ? (0, $3Gelu.min)(min, tetherMin) : min, offset, tether ? (0, $3Gelu.max)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === 'x' ? (0, $cUxAV.top) : (0, $cUxAV.left);
        var _altSide = mainAxis === 'x' ? (0, $cUxAV.bottom) : (0, $cUxAV.right);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === 'y' ? 'height' : 'width';
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $cUxAV.top),
            (0, $cUxAV.left)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $1lJXP.withinMaxClamp)(_tetherMin, _offset, _tetherMax) : (0, $1lJXP.within)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $a31dbc8612778f59$export$2e2bcd8739ae039 = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: $a31dbc8612778f59$var$preventOverflow,
    requiresIfExists: [
        'offset'
    ]
};

});
parcelRegister("3ZBe7", function(module, exports) {

$parcel$export(module.exports, "default", () => $2e83f21121a987af$export$2e2bcd8739ae039);
function $2e83f21121a987af$export$2e2bcd8739ae039(axis) {
    return axis === 'x' ? 'y' : 'x';
}

});

parcelRegister("1lJXP", function(module, exports) {

$parcel$export(module.exports, "within", () => $0fbb681521294cde$export$f28d906d67a997f3);
$parcel$export(module.exports, "withinMaxClamp", () => $0fbb681521294cde$export$86c8af6d3ef0b4a);

var $3Gelu = parcelRequire("3Gelu");
function $0fbb681521294cde$export$f28d906d67a997f3(min, value, max) {
    return (0, $3Gelu.max)(min, (0, $3Gelu.min)(value, max));
}
function $0fbb681521294cde$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $0fbb681521294cde$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}

});


parcelRegister("RxAbB", function(module, exports) {

$parcel$export(module.exports, "default", () => $0a0f002a9e1932ee$export$2e2bcd8739ae039);

var $i0vbU = parcelRequire("i0vbU");

var $3F4KV = parcelRequire("3F4KV");

var $lzCV1 = parcelRequire("lzCV1");

var $1Z5jy = parcelRequire("1Z5jy");

var $lM4La = parcelRequire("lM4La");

var $1lJXP = parcelRequire("1lJXP");

var $k6Ryt = parcelRequire("k6Ryt");

var $5kx8d = parcelRequire("5kx8d");

var $cUxAV = parcelRequire("cUxAV");
var $0a0f002a9e1932ee$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $k6Ryt.default)(typeof padding !== 'number' ? padding : (0, $5kx8d.default)(padding, (0, $cUxAV.basePlacements)));
};
function $0a0f002a9e1932ee$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $i0vbU.default)(state.placement);
    var axis = (0, $lM4La.default)(basePlacement);
    var isVertical = [
        (0, $cUxAV.left),
        (0, $cUxAV.right)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $0a0f002a9e1932ee$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $3F4KV.default)(arrowElement);
    var minProp = axis === 'y' ? (0, $cUxAV.top) : (0, $cUxAV.left);
    var maxProp = axis === 'y' ? (0, $cUxAV.bottom) : (0, $cUxAV.right);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $1Z5jy.default)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $1lJXP.within)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $0a0f002a9e1932ee$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $lzCV1.default)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $0a0f002a9e1932ee$export$2e2bcd8739ae039 = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: $0a0f002a9e1932ee$var$arrow,
    effect: $0a0f002a9e1932ee$var$effect,
    requires: [
        'popperOffsets'
    ],
    requiresIfExists: [
        'preventOverflow'
    ]
};

});

parcelRegister("4Jkbd", function(module, exports) {

$parcel$export(module.exports, "default", () => $371b04b800cbe6bc$export$2e2bcd8739ae039);

var $cUxAV = parcelRequire("cUxAV");

var $9c30h = parcelRequire("9c30h");
function $371b04b800cbe6bc$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $371b04b800cbe6bc$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $cUxAV.top),
        (0, $cUxAV.right),
        (0, $cUxAV.bottom),
        (0, $cUxAV.left)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $371b04b800cbe6bc$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $9c30h.default)(state, {
        elementContext: 'reference'
    });
    var popperAltOverflow = (0, $9c30h.default)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $371b04b800cbe6bc$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $371b04b800cbe6bc$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $371b04b800cbe6bc$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $371b04b800cbe6bc$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-reference-hidden': isReferenceHidden,
        'data-popper-escaped': hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $371b04b800cbe6bc$export$2e2bcd8739ae039 = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: [
        'preventOverflow'
    ],
    fn: $371b04b800cbe6bc$var$hide
};

});




parcelRegister("6XvxP", function(module, exports) {

$parcel$export(module.exports, "Reference", () => $5110b8d9e7655c91$export$e0be378c32fb70a7);

var $eUqFw = parcelRequire("eUqFw");

var $k6muC = parcelRequire("k6muC");

var $3aVBa = parcelRequire("3aVBa");

var $4J8wt = parcelRequire("4J8wt");
function $5110b8d9e7655c91$export$e0be378c32fb70a7(_ref) {
    var children = _ref.children, innerRef = _ref.innerRef;
    var setReferenceNode = $eUqFw.useContext((0, $3aVBa.ManagerReferenceNodeSetterContext));
    var refHandler = $eUqFw.useCallback(function(node) {
        (0, $4J8wt.setRef)(innerRef, node);
        (0, $4J8wt.safeInvoke)(setReferenceNode, node);
    }, [
        innerRef,
        setReferenceNode
    ]); // ran on unmount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    $eUqFw.useEffect(function() {
        return function() {
            return (0, $4J8wt.setRef)(innerRef, null);
        };
    }, []);
    $eUqFw.useEffect(function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($k6muC)))(Boolean(setReferenceNode), '`Reference` should not be used outside of a `Manager` component.');
    }, [
        setReferenceNode
    ]);
    return (0, $4J8wt.unwrapArray)(children)({
        ref: refHandler
    });
}

});

parcelRegister("asNSH", function(module, exports) {

$parcel$export(module.exports, "shallowEqualObjects", () => $c9294410708307cc$export$3e67810a3f0e9f1c);
function $c9294410708307cc$export$967a6b9924a689f7(arrA, arrB) {
    if (arrA === arrB) return true;
    if (!arrA || !arrB) return false;
    const len = arrA.length;
    if (arrB.length !== len) return false;
    for(let i = 0; i < len; i++){
        if (arrA[i] !== arrB[i]) return false;
    }
    return true;
}
function $c9294410708307cc$export$3e67810a3f0e9f1c(objA, objB) {
    if (objA === objB) return true;
    if (!objA || !objB) return false;
    const aKeys = Object.keys(objA);
    const bKeys = Object.keys(objB);
    const len = aKeys.length;
    if (bKeys.length !== len) return false;
    for(let i = 0; i < len; i++){
        const key = aKeys[i];
        if (objA[key] !== objB[key] || !Object.prototype.hasOwnProperty.call(objB, key)) return false;
    }
    return true;
}
function $c9294410708307cc$export$d36bdfa510afb180(a, b) {
    const aIsArr = Array.isArray(a);
    const bIsArr = Array.isArray(b);
    if (aIsArr !== bIsArr) return false;
    if (aIsArr && bIsArr) return $c9294410708307cc$export$967a6b9924a689f7(a, b);
    return $c9294410708307cc$export$3e67810a3f0e9f1c(a, b);
}

});

parcelRegister("5wCDk", function(module, exports) {

$parcel$export(module.exports, "SelectWithoutAnalytics", () => $eb73e877c5661200$export$d1de3b251ccaa8a3);
$parcel$export(module.exports, "default", () => $eb73e877c5661200$export$2e2bcd8739ae039);

var $hOLnS = parcelRequire("hOLnS");

var $hM7RE = parcelRequire("hM7RE");
var $1ngde = parcelRequire("1ngde");
var $2jDha = parcelRequire("2jDha");

var $5FjBr = parcelRequire("5FjBr");
const $eb73e877c5661200$var$packageName = "platform-pkg";
const $eb73e877c5661200$var$packageVersion = "0.0.0-use.local";
const $eb73e877c5661200$export$d1de3b251ccaa8a3 = (0, $5FjBr.default)((0, $hOLnS.default));
const $eb73e877c5661200$var$createAndFireEventOnAtlaskit = (0, $hM7RE.default)('atlaskit');
const $eb73e877c5661200$var$Select = (0, $1ngde.default)({
    componentName: 'select',
    packageName: $eb73e877c5661200$var$packageName,
    packageVersion: $eb73e877c5661200$var$packageVersion
})((0, $2jDha.default)({
    onChange: $eb73e877c5661200$var$createAndFireEventOnAtlaskit({
        action: 'changed',
        actionSubject: 'option',
        attributes: {
            componentName: 'select',
            packageName: $eb73e877c5661200$var$packageName,
            packageVersion: $eb73e877c5661200$var$packageVersion
        }
    })
})($eb73e877c5661200$export$d1de3b251ccaa8a3));
var $eb73e877c5661200$export$2e2bcd8739ae039 = $eb73e877c5661200$var$Select;

});
parcelRegister("5FjBr", function(module, exports) {

$parcel$export(module.exports, "default", () => $ba6ba00681316b2f$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $cEc3i = parcelRequire("cEc3i");

var $jQirI = parcelRequire("jQirI");

var $hgqfZ = parcelRequire("hgqfZ");

var $o2lI9 = parcelRequire("o2lI9");
var $7HYS7 = parcelRequire("7HYS7");

var $bKJfr = parcelRequire("bKJfr");

var $lT14u = parcelRequire("lT14u");
function $ba6ba00681316b2f$export$2e2bcd8739ae039(WrappedComponent) {
    const AtlaskitSelect = /*#__PURE__*/ (0, $eUqFw.forwardRef)(function AtlaskitSelect(props, forwardedRef) {
        const { appearance: appearance, ariaLiveMessages: ariaLiveMessages, components: componentsProp, isInvalid: isInvalid, onClickPreventDefault: onClickPreventDefault = true, spacing: spacing = 'default', styles: styles = {}, tabSelectsValue: tabSelectsValue = false, validationState: validationState = 'default', ...restProps } = props;
        const internalSelectRef = (0, $eUqFw.useRef)(null);
        const components = (0, $eUqFw.useMemo)(()=>({
                ClearIndicator: $o2lI9.ClearIndicator,
                DropdownIndicator: $o2lI9.DropdownIndicator,
                LoadingIndicator: $o2lI9.LoadingIndicator,
                MultiValueRemove: $7HYS7.MultiValueRemove,
                IndicatorSeparator: $7HYS7.IndicatorSeparator,
                Input: $jQirI.Input,
                NoOptionsMessage: $hgqfZ.NoOptionsMessage,
                ...componentsProp
            }), [
            componentsProp
        ]);
        const descriptionId = props['aria-describedby'];
        const isSearchable = props.isSearchable;
        (0, $eUqFw.useEffect)(()=>{
            if (!isSearchable && descriptionId) {
                // when isSearchable is false, react-select will create its own dummy input instead of using ours,
                // so we need to manually add the additional aria-describedby using ref.
                const input = internalSelectRef.current?.inputRef;
                const ariaDescribedby = input?.getAttribute('aria-describedby');
                if (!ariaDescribedby?.includes(descriptionId)) input?.setAttribute('aria-describedby', `${ariaDescribedby} ${descriptionId}`);
            }
        }, [
            descriptionId,
            isSearchable
        ]);
        const isCompact = spacing === 'compact';
        /**
		 * The following `useImperativeHandle` hook exists for the sake of backwards compatibility.
		 * This component used to be a class component which set the value of the `ref` prop to object with the properties and value as below.
		 * This has lead to slightly odd usage of refs with this component, e.g. `myRef.current.select.select.controlRef` instead of just `myRef.current.select.controlRef`
		 * In the next major release, this should removed and the ref should be passed directly to the wrapped component (given users have updated usage)
		 * More info https://stash.atlassian.com/projects/ATLASSIAN/repos/atlassian-frontend-monorepo/pull-requests/88021/overview
		 */ (0, $eUqFw.useImperativeHandle)(forwardedRef, ()=>({
                select: internalSelectRef.current,
                focus: ()=>internalSelectRef.current?.focus(),
                blur: ()=>internalSelectRef.current?.blur()
            }), []);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, {
            ref: internalSelectRef,
            "aria-live": "assertive",
            ariaLiveMessages: (0, $lT14u.isOptionsGrouped)(props.options) ? {
                onFocus: $lT14u.onFocus,
                ...ariaLiveMessages
            } : {
                ...ariaLiveMessages
            },
            tabSelectsValue: tabSelectsValue,
            onClickPreventDefault: onClickPreventDefault,
            ...restProps,
            components: components,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            styles: (0, $cEc3i.m)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $bKJfr.default)(// This will cover both props for invalid state while giving priority to isInvalid. When cleaning up validationState, we can just keep the inner condition.
            typeof isInvalid !== 'undefined' ? isInvalid ? 'error' : 'default' : validationState, isCompact, appearance || 'default'), styles)
        });
    });
    AtlaskitSelect.displayName = 'AtlaskitSelect';
    return AtlaskitSelect;
}

});
parcelRegister("jQirI", function(module, exports) {

$parcel$export(module.exports, "Input", () => $644d9bc3d652d5d7$export$f5b8910cec6cf069);

var $eUqFw = parcelRequire("eUqFw");

var $jQxSL = parcelRequire("jQxSL");
function $644d9bc3d652d5d7$export$f5b8910cec6cf069(props) {
    let ariaDescribedByAttribute;
    const passed_describedby = props.selectProps['aria-describedby'];
    if (props['aria-describedby'] && passed_describedby) ariaDescribedByAttribute = props['aria-describedby'] + ' ' + passed_describedby;
    else ariaDescribedByAttribute = props['aria-describedby'] || passed_describedby;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jQxSL.c).Input, {
        ...props,
        "aria-describedby": ariaDescribedByAttribute
    });
}

});

parcelRegister("hgqfZ", function(module, exports) {

$parcel$export(module.exports, "NoOptionsMessage", () => $4d0dc96eef1d75f0$export$d58b72b7d3c4072c);

var $eUqFw = parcelRequire("eUqFw");

var $jQxSL = parcelRequire("jQxSL");
const $4d0dc96eef1d75f0$export$d58b72b7d3c4072c = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jQxSL.c).NoOptionsMessage, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        id: "no-options",
        role: "alert"
    }, props.children || `No options`));
};

});

parcelRegister("o2lI9", function(module, exports) {

$parcel$export(module.exports, "ClearIndicator", () => $a14d8b5e9bff27a8$export$ecf9cf59142dd54a);
$parcel$export(module.exports, "DropdownIndicator", () => $a14d8b5e9bff27a8$export$ec98719d3db7f2e4);
$parcel$export(module.exports, "LoadingIndicator", () => $a14d8b5e9bff27a8$export$7c20be4c1d342248);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $jQxSL = parcelRequire("jQxSL");

var $4ZL0y = parcelRequire("4ZL0y");
var $1ZAYh = parcelRequire("1ZAYh");

var $4Bees = parcelRequire("4Bees");

var $hUbUe = parcelRequire("hUbUe");

var $86Ndv = parcelRequire("86Ndv");
const $a14d8b5e9bff27a8$var$iconContainerStyles = (0, $1ZAYh.xcss)({
    all: 'unset',
    outline: 'revert',
    display: 'flex',
    alignItems: 'center'
});
const $a14d8b5e9bff27a8$export$ecf9cf59142dd54a = (props)=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $jQxSL.c).ClearIndicator, {
        ...props,
        innerProps: {
            ...props.innerProps,
            'aria-hidden': 'false'
        }
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $4ZL0y.default), {
        xcss: $a14d8b5e9bff27a8$var$iconContainerStyles,
        tabIndex: -1
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hUbUe))), {
        size: "small",
        label: "clear"
    })));
const $a14d8b5e9bff27a8$export$ec98719d3db7f2e4 = (props)=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $jQxSL.c).DropdownIndicator, props, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($86Ndv))), {
        label: "open"
    }));
const $a14d8b5e9bff27a8$export$7c20be4c1d342248 = (props)=>{
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    const loadingStyles = /*#__PURE__*/ (0, $byn9U.css)(props.getStyles('loadingIndicator', props));
    return(// This *must* be constructed this way because this is being consumed by
    // `react-select` and we don't control what it wants.
    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
    /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: loadingStyles,
        ...props.innerProps
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $4Bees.default), {
        size: "small"
    })));
};

});
parcelRegister("hUbUe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d090e6e9cc89e346$var$_react = $d090e6e9cc89e346$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $d090e6e9cc89e346$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $d090e6e9cc89e346$var$SelectClearIcon = (props)=>/*#__PURE__*/ $d090e6e9cc89e346$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle fill="currentColor" cx="12" cy="12" r="9"/><path d="M16.155 14.493a1.174 1.174 0 11-1.662 1.663L12 13.662l-2.494 2.494a1.172 1.172 0 01-1.662 0 1.176 1.176 0 010-1.663L10.337 12 7.844 9.507a1.176 1.176 0 011.662-1.662L12 10.338l2.493-2.493a1.174 1.174 0 111.662 1.662L13.662 12l2.493 2.493z" fill="inherit"/></g></svg>`
    }, props));
$d090e6e9cc89e346$var$SelectClearIcon.displayName = 'SelectClearIcon';
var $d090e6e9cc89e346$var$_default = $d090e6e9cc89e346$var$SelectClearIcon;
module.exports.default = $d090e6e9cc89e346$var$_default;

});


parcelRegister("7HYS7", function(module, exports) {

$parcel$export(module.exports, "MultiValueRemove", () => $7fda2332979a5c13$export$8e1fd1a40e7a2f4a);
$parcel$export(module.exports, "IndicatorSeparator", () => $7fda2332979a5c13$export$bd638c2ba7915668);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $hUbUe = parcelRequire("hUbUe");

var $jQxSL = parcelRequire("jQxSL");

var $o2lI9 = parcelRequire("o2lI9");
function $7fda2332979a5c13$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $7fda2332979a5c13$var$disabledStyles = {
    name: "eivff4",
    styles: "display:none"
};
const $7fda2332979a5c13$var$enabledStyles = {
    name: "ck88l6",
    styles: "display:inherit"
};
const $7fda2332979a5c13$export$8e1fd1a40e7a2f4a = (props)=>{
    const { isDisabled: isDisabled } = props.selectProps;
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $jQxSL.c).MultiValueRemove, props, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: isDisabled ? $7fda2332979a5c13$var$disabledStyles : $7fda2332979a5c13$var$enabledStyles,
        "data-testid": isDisabled ? 'hide-clear-icon' : 'show-clear-icon'
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hUbUe))), {
        label: "Clear",
        size: "small",
        primaryColor: "transparent",
        secondaryColor: "inherit"
    })));
};
const $7fda2332979a5c13$export$bd638c2ba7915668 = null;

});

parcelRegister("bKJfr", function(module, exports) {

$parcel$export(module.exports, "default", () => $6eba8612e97e7e89$export$2e2bcd8739ae039);

var $PdmhA = parcelRequire("PdmhA");

var $XHGTv = parcelRequire("XHGTv");
function $6eba8612e97e7e89$export$2e2bcd8739ae039(validationState, isCompact = false, appearance) {
    return {
        container: (css, { isDisabled: isDisabled })=>({
                ...css,
                ...(0, $XHGTv.getBooleanFF)('platform.design-system-team.select-new-typography_7m89c') ? {
                    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
                } : {
                    fontFamily: "var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
                },
                // react-select disables pointer events when isDisabled is true.
                // We override this and make the inner container turn it off instead.
                pointerEvents: 'all',
                cursor: isDisabled ? 'not-allowed' : css.cursor
            }),
        input: (css)=>({
                ...css,
                color: "var(--ds-text, hsl(0, 0%, 20%))"
            }),
        control: (css, { isFocused: isFocused, isDisabled: isDisabled })=>{
            let borderColor = isFocused ? `var(--ds-border-focused, ${0, $PdmhA.B100})` : `var(--ds-border-input, ${0, $PdmhA.N100})`;
            let backgroundColor = isFocused ? `var(--ds-background-input-pressed, ${0, $PdmhA.N0})` : `var(--ds-background-input, ${0, $PdmhA.N20})`;
            let backgroundColorHover = isFocused ? `var(--ds-background-input-pressed, ${0, $PdmhA.N0})` : `var(--ds-background-input-hovered, ${0, $PdmhA.N30})`;
            if (isDisabled) {
                backgroundColor = `var(--ds-background-disabled, ${0, $PdmhA.N20})`;
                borderColor = `var(--ds-background-disabled, ${0, $PdmhA.N20})`;
            }
            if (validationState === 'error') borderColor = `var(--ds-border-danger, ${0, $PdmhA.R400})`;
            if (validationState === 'success') borderColor = `var(--ds-border-success, ${0, $PdmhA.G400})`;
            let borderColorHover = isFocused ? `var(--ds-border-focused, ${0, $PdmhA.B100})` : `var(--ds-border-input, ${0, $PdmhA.N100})`;
            if (validationState === 'error') borderColorHover = `var(--ds-border-danger, ${0, $PdmhA.R400})`;
            if (validationState === 'success') borderColorHover = `var(--ds-border-success, ${0, $PdmhA.G400})`;
            const transitionDuration = '200ms';
            if (appearance === 'subtle') {
                borderColor = isFocused ? `var(--ds-border-focused, ${0, $PdmhA.B100})` : 'transparent';
                backgroundColor = isFocused ? `var(--ds-surface, ${0, $PdmhA.N0})` : 'transparent';
                backgroundColorHover = isFocused ? `var(--ds-background-input-pressed, ${0, $PdmhA.N0})` : `var(--ds-background-input-hovered, ${0, $PdmhA.N30})`;
            }
            if (appearance === 'none') {
                borderColor = 'transparent';
                backgroundColor = 'transparent';
                backgroundColorHover = 'transparent';
                borderColorHover = 'transparent';
            }
            return {
                ...css,
                // Turn pointer events off when disabled - this makes it so hover etc don't work.
                pointerEvents: isDisabled ? 'none' : undefined,
                backgroundColor: backgroundColor,
                borderColor: borderColor,
                borderStyle: 'solid',
                borderRadius: "var(--ds-border-radius-100, 3px)",
                borderWidth: "var(--ds-border-width, 1px)",
                boxShadow: validationState === 'error' ? `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${borderColor}` : 'none',
                '&:focus-within': {
                    boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${borderColor}`
                },
                minHeight: isCompact ? 32 : 40,
                padding: 0,
                transition: `background-color ${transitionDuration} ease-in-out,
        border-color ${transitionDuration} ease-in-out`,
                '::-webkit-scrollbar': {
                    height: 8,
                    width: 8
                },
                '::-webkit-scrollbar-corner': {
                    display: 'none'
                },
                ':hover': {
                    '::-webkit-scrollbar-thumb': {
                        // scrollbars occur only if the user passes in a custom component with overflow: scroll
                        backgroundColor: 'rgba(0,0,0,0.2)'
                    },
                    cursor: 'pointer',
                    backgroundColor: backgroundColorHover,
                    borderColor: borderColorHover
                },
                '::-webkit-scrollbar-thumb:hover': {
                    backgroundColor: 'rgba(0,0,0,0.4)'
                }
            };
        },
        valueContainer: (css)=>({
                ...css,
                paddingLeft: "var(--ds-space-075, 6px)",
                paddingRight: "var(--ds-space-075, 6px)",
                paddingBottom: isCompact ? 0 : 2,
                paddingTop: isCompact ? 0 : 2
            }),
        clearIndicator: (css)=>({
                ...css,
                color: `var(--ds-text-subtlest, ${0, $PdmhA.N70})`,
                paddingLeft: "var(--ds-space-025, 2px)",
                paddingRight: "var(--ds-space-025, 2px)",
                paddingBottom: isCompact ? 0 : 6,
                paddingTop: isCompact ? 0 : 6,
                ':hover': {
                    color: `var(--ds-text-subtle, ${0, $PdmhA.N500})`
                }
            }),
        loadingIndicator: (css)=>({
                ...css,
                paddingBottom: isCompact ? 0 : 6,
                paddingTop: isCompact ? 0 : 6
            }),
        dropdownIndicator: (css, { isDisabled: isDisabled })=>{
            let color = `var(--ds-text-subtle, ${(0, $PdmhA.N500)})`;
            if (isDisabled) color = `var(--ds-text-disabled, ${0, $PdmhA.N70})`;
            return {
                ...css,
                color: color,
                paddingLeft: "var(--ds-space-025, 2px)",
                paddingRight: "var(--ds-space-025, 2px)",
                paddingBottom: isCompact ? 0 : 6,
                paddingTop: isCompact ? 0 : 6,
                ':hover': {
                    color: `var(--ds-text-subtle, ${0, $PdmhA.N200})`
                }
            };
        },
        indicatorsContainer: (css)=>({
                ...css,
                paddingRight: "var(--ds-space-050, 4px)"
            }),
        option: (css, { isFocused: isFocused, isSelected: isSelected, isDisabled: isDisabled })=>{
            let color = `var(--ds-text, ${(0, $PdmhA.N800)})`;
            if (isDisabled) color = `var(--ds-text-disabled, ${0, $PdmhA.N70})`;
            else if (isSelected) color = `var(--ds-text-selected, ${0, $PdmhA.B400})`;
            let boxShadow;
            let backgroundColor;
            if (isDisabled) backgroundColor = undefined;
            else if (isSelected && isFocused) backgroundColor = `var(--ds-background-selected-hovered, ${0, $PdmhA.B50})`;
            else if (isSelected) backgroundColor = `var(--ds-background-selected, ${0, $PdmhA.B50})`;
            else if (isFocused) backgroundColor = `var(--ds-background-neutral-subtle-hovered, ${0, $PdmhA.N20})`;
            if (!isDisabled && (isFocused || isSelected)) boxShadow = `inset 2px 0px 0px ${`var(--ds-border-selected, ${0, $PdmhA.B400})`}`;
            const cursor = isDisabled ? 'not-allowed' : css.cursor;
            return {
                ...css,
                padding: '6px 12px',
                backgroundColor: backgroundColor,
                color: color,
                cursor: cursor,
                boxShadow: boxShadow,
                ':active': {
                    backgroundColor: !isDisabled ? isSelected ? `var(--ds-background-selected-pressed, ${0, $PdmhA.N20})` : `var(--ds-background-neutral-subtle-pressed, ${0, $PdmhA.N30})` : undefined
                },
                '@media screen and (-ms-high-contrast: active)': {
                    borderLeft: !isDisabled && (isFocused || isSelected) ? '2px solid transparent' : ''
                }
            };
        },
        placeholder: (css, { isDisabled: isDisabled })=>({
                ...css,
                color: isDisabled ? `var(--ds-text-disabled, ${0, $PdmhA.N300})` : `var(--ds-text-subtlest, ${0, $PdmhA.N200})`
            }),
        singleValue: (css, { isDisabled: isDisabled })=>({
                ...css,
                color: isDisabled ? `var(--ds-text-disabled, ${0, $PdmhA.N70})` : `var(--ds-text, ${0, $PdmhA.N800})`,
                ...!(0, $XHGTv.getBooleanFF)('platform.design-system-team.select-new-typography_7m89c') && {
                    lineHeight: '1rem'
                }
            }),
        menu: (css)=>({
                ...css,
                backgroundColor: "var(--ds-surface-overlay, white)",
                boxShadow: "var(--ds-shadow-overlay, 0 0 0 1px hsl(0deg 0% 0% / 10%), 0 4px 11px hsl(0deg 0% 0% / 10%))"
            }),
        menuList: (css)=>({
                ...css,
                paddingTop: "var(--ds-space-100, 8px)",
                paddingBottom: "var(--ds-space-100, 8px)"
            }),
        multiValue: (css, { isDisabled: isDisabled, isFocused: isFocused })=>{
            let backgroundColor;
            let color;
            if (isDisabled) {
                // Use the basic neutral background so it is slightly separate from the
                // field's background
                backgroundColor = `var(--ds-background-neutral, ${0, $PdmhA.N40})`;
                color = `var(--ds-text-disabled, ${0, $PdmhA.N70})`;
            } else if (isFocused) {
                backgroundColor = `var(--ds-background-selected, ${0, $PdmhA.N40})`;
                color = "var(--ds-text-selected, hsl(0, 0%, 20%))";
            } else {
                backgroundColor = `var(--ds-background-neutral, ${0, $PdmhA.N40})`;
                color = "var(--ds-text, hsl(0, 0%, 20%))";
            }
            return {
                ...css,
                borderRadius: "var(--ds-border-radius-050, 2px)",
                backgroundColor: backgroundColor,
                boxShadow: isFocused ? `0 0 0 2px ${"var(--ds-surface, transparent)"}, 0 0 0 4px ${"var(--ds-border-focused, transparent)"}` : 'none',
                maxWidth: '100%',
                '@media screen and (-ms-high-contrast: active)': {
                    border: isFocused ? '1px solid transparent' : 'none'
                },
                color: color
            };
        },
        multiValueLabel: (css, { isDisabled: isDisabled })=>({
                ...css,
                padding: "var(--ds-space-025, 2px)",
                color: isDisabled ? `var(--ds-text-disabled, ${0, $PdmhA.N70})` : 'inherit',
                paddingRight: "var(--ds-space-025, 2px)"
            }),
        multiValueRemove: (css, { isFocused: isFocused })=>({
                ...css,
                backgroundColor: isFocused ? `var(--ds-UNSAFE-transparent, ${0, $PdmhA.R75})` : undefined,
                fill: isFocused ? "var(--ds-text-selected, #000)" : "var(--ds-text, #000)",
                paddingLeft: "var(--ds-space-025, 2px)",
                paddingRight: "var(--ds-space-025, 2px)",
                borderRadius: '0px 2px 2px 0px',
                // DSP-6470 we should style like Tag once we have the :has selector
                ':hover': {
                    backgroundColor: `var(--ds-background-danger-hovered, ${0, $PdmhA.R75})`,
                    fill: "var(--ds-text-danger, #000)"
                },
                ':active': {
                    backgroundColor: `var(--ds-background-danger-pressed, ${0, $PdmhA.R75})`,
                    fill: "var(--ds-text-danger, #000)"
                }
            }),
        groupHeading: (css)=>({
                ...css,
                ...(0, $XHGTv.getBooleanFF)('platform.design-system-team.select-new-typography_7m89c') && {
                    font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
                },
                color: `var(--ds-text-subtle, ${0, $PdmhA.N200})`
            })
    };
}

});

parcelRegister("lT14u", function(module, exports) {

$parcel$export(module.exports, "onFocus", () => $7ccc5140c845bc58$export$ecf9bf35ad97eb74);
$parcel$export(module.exports, "isOptionsGrouped", () => $7ccc5140c845bc58$export$d2756249f53f9f8);
function $7ccc5140c845bc58$export$ecf9bf35ad97eb74(props) {
    const { focused: focused, options: options } = props;
    const isOptionFocused = (option)=>{
        return option === focused;
    };
    const groupData = options?.find((option)=>{
        return option.options?.some(isOptionFocused);
    });
    const groupOptionIndex = groupData?.options.findIndex(isOptionFocused) ?? 0;
    return `Option ${focused.label}, ${groupData?.label} group, item ${groupOptionIndex + 1} out of ${groupData?.options.length}. All in all `;
}
const $7ccc5140c845bc58$export$d2756249f53f9f8 = (arr)=>{
    return arr?.every((obj)=>obj.hasOwnProperty('options'));
};

});



parcelRegister("7ldaw", function(module, exports) {

$parcel$export(module.exports, "MenuDialog", () => $e208c4fdfb4dbbc3$export$c94219dad7c0e37d);
$parcel$export(module.exports, "DummyControl", () => $e208c4fdfb4dbbc3$export$87ce933b7fc29b8c);
$parcel$export(module.exports, "defaultComponents", () => $e208c4fdfb4dbbc3$export$71abc632aa29e6fe);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $jQxSL = parcelRequire("jQxSL");

var $byn9U = parcelRequire("byn9U");

var $lkPEe = parcelRequire("lkPEe");

var $bPZtE = parcelRequire("bPZtE");

var $lcnyw = parcelRequire("lcnyw");

var $PdmhA = parcelRequire("PdmhA");
function $e208c4fdfb4dbbc3$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $e208c4fdfb4dbbc3$var$menuDialogStyles = /*#__PURE__*/ (0, $byn9U.css)({
    backgroundColor: "var(--ds-surface-overlay, white)",
    borderRadius: "var(--ds-border-radius-100, 4px)",
    boxShadow: `var(--ds-shadow-overlay, ${`0 0 0 1px ${(0, $PdmhA.N40A)}, 0 4px 11px ${(0, $PdmhA.N40A)}`})`,
    zIndex: (0, $lcnyw.layers).modal()
});
const $e208c4fdfb4dbbc3$export$c94219dad7c0e37d = ({ maxWidth: maxWidth, minWidth: minWidth, children: children, id: id, style: style, testId: testId })=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: [
            $e208c4fdfb4dbbc3$var$menuDialogStyles,
            // There is not a limited amount of values for the widths, so they need
            // to remain dynamic.
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            {
                maxWidth: maxWidth,
                minWidth: minWidth
            }
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        id: id,
        "data-testid": testId && `${testId}--menu`
    }, children);
// ==============================
// Custom Components
// ==============================
const $e208c4fdfb4dbbc3$var$dropdownStyles = {
    name: "1sujbl1",
    styles: "margin-inline-end:var(--ds-space-025, 2px);text-align:center;width:32px"
};
const $e208c4fdfb4dbbc3$var$DropdownIndicator = ()=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $e208c4fdfb4dbbc3$var$dropdownStyles
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bPZtE))), {
        label: "open"
    }));
const $e208c4fdfb4dbbc3$var$controlStyles = /*#__PURE__*/ (0, $byn9U.css)({
    padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-100, 8px)"} ${"var(--ds-space-050, 4px)"}`
});
const $e208c4fdfb4dbbc3$var$Control = ({ innerRef: innerRef, innerProps: innerProps, ...props })=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
        ref: innerRef,
        css: $e208c4fdfb4dbbc3$var$controlStyles
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $jQxSL.c).Control, {
        ...props,
        innerProps: innerProps
    }));
const $e208c4fdfb4dbbc3$export$87ce933b7fc29b8c = (props)=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $lkPEe.default), null, /*#__PURE__*/ (0, $byn9U.jsx)((0, $jQxSL.c).Control, props));
// NOTE `props` intentionally omitted from `Fragment`
const $e208c4fdfb4dbbc3$var$Menu = ({ children: children, innerProps: innerProps })=>/*#__PURE__*/ (0, $byn9U.jsx)("div", innerProps, children);
const $e208c4fdfb4dbbc3$export$71abc632aa29e6fe = {
    Control: $e208c4fdfb4dbbc3$var$Control,
    DropdownIndicator: $e208c4fdfb4dbbc3$var$DropdownIndicator,
    Menu: $e208c4fdfb4dbbc3$var$Menu
};

});
parcelRegister("bPZtE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $89e4253a013a6022$var$_react = $89e4253a013a6022$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $89e4253a013a6022$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $89e4253a013a6022$var$EditorSearchIcon = (props)=>/*#__PURE__*/ $89e4253a013a6022$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M14.823 15.883a5.5 5.5 0 111.06-1.06l2.647 2.647c.293.293.53.59 0 1.06-.53.47-.767.293-1.06 0l-2.647-2.647zM11.5 15.5a4 4 0 100-8 4 4 0 000 8z" fill="currentColor"/></svg>`
    }, props));
$89e4253a013a6022$var$EditorSearchIcon.displayName = 'EditorSearchIcon';
var $89e4253a013a6022$var$_default = $89e4253a013a6022$var$EditorSearchIcon;
module.exports.default = $89e4253a013a6022$var$_default;

});



parcelRegister("hw2eW", function(module, exports) {

$parcel$export(module.exports, "getIssueTypesSettingsUrl", () => $4a7674a4409ee541$export$b9500524016e18f0);
const $4a7674a4409ee541$export$b9500524016e18f0 = (projectKey, isSimplified)=>isSimplified ? `/jira/core/projects/${projectKey}/settings/issuetypes` : `/plugins/servlet/project-config/${projectKey}/issuetypes`;

});

const $3b526ddeb90a4d89$export$3789e4b2a10baa2b = 'full';
const $3b526ddeb90a4d89$export$db1cdb8627b81f84 = 'compact';
const $3b526ddeb90a4d89$export$aca095bc476d426f = 'simple';
const $3b526ddeb90a4d89$export$1aad44a7533f8ad8 = 'table_row';
const $3b526ddeb90a4d89$export$d2f7b3f0efb6e208 = 'hidden';
const $3b526ddeb90a4d89$export$dda6912361cddac9 = 'visible';
const $3b526ddeb90a4d89$export$565566e3df4dad53 = 'blur';
const $3b526ddeb90a4d89$export$806b905ec7df742f = 'enter';
const $3b526ddeb90a4d89$export$2bb790b9008907b4 = 'escape';
const $3b526ddeb90a4d89$export$ba9f60edfdf2e66 = 'create_button';
const $3b526ddeb90a4d89$export$3dd832bb5d8861ec = 'multi_dialog_single_create_button';
const $3b526ddeb90a4d89$export$b5288579893d806 = 'multi_dialog_multi_create_button';
const $3b526ddeb90a4d89$export$193356664cd84c83 = 255;
const $3b526ddeb90a4d89$export$f9e3e7ede9ba929d = 500;
const $3b526ddeb90a4d89$export$e0bc602b327f818b = 'add-issue-type-option';

parcelRegister("l4rzg", function(module, exports) {

$parcel$export(module.exports, "CREATE_ISSUE_EXPERIENCE", () => $004447294a5330e0$export$ed625f60643a6c30);
const $004447294a5330e0$export$ed625f60643a6c30 = {
    experience: 'createIssue',
    packageName: 'jiraBusinessIssueCreate',
    teamName: 'wanjel'
};

});

parcelRegister("kTIhq", function(module, exports) {

$parcel$export(module.exports, "default", () => $2ef962d80dcbffe5$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $2ef962d80dcbffe5$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    placeholderText: {
        "id": "business-issue-create.inline-create-form.placeholder-text",
        "defaultMessage": "What needs to be done?"
    },
    createButton: {
        "id": "business-issue-create.inline-create-form.create-button",
        "defaultMessage": "Create"
    },
    selectIssueTypeButton: {
        "id": "business-issue-create.inline-create-form.select-issue-type-button",
        "defaultMessage": "Select issue type. {issueType} currently selected."
    },
    manageIssueTypes: {
        "id": "business-issue-create.inline-create-form.manage-issue-types",
        "defaultMessage": "Manage types"
    }
});

});

parcelRegister("fkT5k", function(module, exports) {

$parcel$export(module.exports, "default", () => $c337a03315092ec3$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $2ziLQ = parcelRequire("2ziLQ");
const $c337a03315092ec3$var$ReturnGlyph = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: "24",
        height: "16",
        viewBox: "0 0 24 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3 0C1.34315 0 0 1.34315 0 3V13C0 14.6569 1.34315 16 3 16H21C22.6569 16 24 14.6569 24 13V3C24 1.34315 22.6569 0 21 0H3Z",
        fill: "var(--ds-background-inverse-subtle, #FFFFFF)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M15.5 5.75V6.75C15.5 8.26878 14.2688 9.5 12.75 9.5H8.75C8.33579 9.5 8 9.16421 8 8.75C8 8.33579 8.33579 8 8.75 8H12.75C13.4404 8 14 7.44036 14 6.75V5.75C14 5.33579 14.3358 5 14.75 5C15.1642 5 15.5 5.33579 15.5 5.75Z",
        fill: "var(--ds-text-inverse, #FFFFFF)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M9.28033 9.28033L11.0303 7.53033C11.3232 7.23744 11.3232 6.76256 11.0303 6.46967C10.7374 6.17678 10.2626 6.17678 9.96967 6.46967L8.21967 8.21967C7.92678 8.51256 7.92678 8.98744 8.21967 9.28033C8.51256 9.57322 8.98744 9.57322 9.28033 9.28033Z",
        fill: "var(--ds-text-inverse, #FFFFFF)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M9.28033 8.21967L11.0303 9.96967C11.3232 10.2626 11.3232 10.7374 11.0303 11.0303C10.7374 11.3232 10.2626 11.3232 9.96967 11.0303L8.21967 9.28033C7.92678 8.98744 7.92678 8.51256 8.21967 8.21967C8.51256 7.92678 8.98744 7.92678 9.28033 8.21967Z",
        fill: "var(--ds-text-inverse, #FFFFFF)"
    }));
const $c337a03315092ec3$var$ReturnIcon = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2ziLQ.default), {
        glyph: $c337a03315092ec3$var$ReturnGlyph,
        label: ""
    });
var $c337a03315092ec3$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($c337a03315092ec3$var$ReturnIcon);

});


parcelRegister("73dL5", function(module, exports) {

$parcel$export(module.exports, "default", () => $526fef1529e77253$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $gO9Xw = parcelRequire("gO9Xw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $9W2dp = parcelRequire("9W2dp");
const $526fef1529e77253$var$InlineCreateTrigger = ({ onClick: onClick, minHeight: minHeight, borderRadius: borderRadius, horizontalPadding: horizontalPadding })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($526fef1529e77253$var$Trigger, {
        borderRadius: borderRadius,
        "data-testid": "business-issue-create.ui.inline-create-trigger",
        horizontalPadding: horizontalPadding,
        minHeight: minHeight,
        onClick: onClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gO9Xw))), {
        label: "",
        size: "small"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($526fef1529e77253$var$Label, null, formatMessage((0, $9W2dp.default).createLabel)));
};
var $526fef1529e77253$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = /*#__PURE__*/ (0, $eUqFw.memo)($526fef1529e77253$var$InlineCreateTrigger);
const $526fef1529e77253$var$Trigger = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { borderRadius: borderRadius, minHeight: minHeight, horizontalPadding: horizontalPadding, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_ri98hz": (0, $9t7rW.default)(__cmplp.borderRadius ?? 0),
            "--_19b8a3e": (0, $9t7rW.default)(__cmplp.minHeight ?? '32px'),
            "--_1w524p6": (0, $9t7rW.default)(`0 ${__cmplp.horizontalPadding ?? "var(--ds-space-100, 8px)"}`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _80omtlke _syaz1thw _bfhk18uv _19itglyw _1wybdlk8 _k48pbfng _2rko16jm _1tke1um9 _1yt414jf _zulph9hh _1bsb1osq _1jhm1q09 _y2mv1q09 _1ygb1q09 _13ro1n1a _1bg41n1a _1ah31n1a _irr3166n _1di61dty",
            __cmplp.className
        ])
    });
});
const $526fef1529e77253$var$Label = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "",
            __cmplp.className
        ])
    });
});

});
parcelRegister("9W2dp", function(module, exports) {

$parcel$export(module.exports, "default", () => $37a764120c338951$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $37a764120c338951$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    createLabel: {
        "id": "business-issue-create.inline-create-trigger.create-label",
        "defaultMessage": "Create"
    }
});

});



parcelRegister("1T0MC", function(module, exports) {

$parcel$export(module.exports, "useResizeObserver", () => $e148d161081077aa$export$683480f191c0e3ea);

var $eUqFw = parcelRequire("eUqFw");
const $e148d161081077aa$export$683480f191c0e3ea = (element, callback)=>{
    (0, $eUqFw.useEffect)(()=>{
        let resizeObserver;
        if (element && typeof ResizeObserver !== 'undefined') {
            resizeObserver = new ResizeObserver(callback);
            resizeObserver.observe(element);
        }
        return ()=>{
            if (resizeObserver) resizeObserver.disconnect();
        };
    }, [
        element,
        callback
    ]);
    return null;
};

});

parcelRegister("k7Dye", function(module, exports) {

$parcel$export(module.exports, "TimelineAddItemNudgeAsync", () => $7493f1ea122b7550$export$be1e825e671d7036);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");


var $ewdMq = parcelRequire("ewdMq");

var $gGtKh = parcelRequire("gGtKh");


// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $7493f1ea122b7550$var$TimelineAddItemNudgeLazy = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("eUpD5")).then((exportedModule)=>exportedModule.TimelineAddItemNudge), {
    ssr: false,
    moduleId: "./src/packages/software/onboarding-nudges/src/ui/jwm-timeline-nudge-tour/timeline-add-item/index.tsx"
});
const $7493f1ea122b7550$export$be1e825e671d7036 = ({ children: children, attributes: attributes })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ewdMq.OnboardingNudgeErrorBoundary), {
        id: (0, $99a775c02d636a41$export$2f06a16c987cc1a2),
        fallback: children,
        attributes: {
            nudgeId: (0, $8379f5d78bf6fb5a$export$468488291ccd988)
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "timeline-add-item-onboarding-nudge",
        fallback: children
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7493f1ea122b7550$var$TimelineAddItemNudgeLazy, {
        attributes: attributes
    }, children)));
$7493f1ea122b7550$export$be1e825e671d7036.displayName = 'TimelineAddItemNudgeAsync';

});
// Session storage constants used between going through initial onboarding screens
// and landing in JIRA
// Note this key used to be 'should-show-scrum-modal' but was changed to prevent a bug where experienced users
// Could see the modal if they were previously enrolled into ISO
const $8379f5d78bf6fb5a$export$67abe0a3b8dfe03f = 'should-show-scrum-modal-v2';
const $8379f5d78bf6fb5a$export$4e1360a3e7785935 = 'should-show-kanban-modal';
const $8379f5d78bf6fb5a$export$e3884212029f7bef = 'should-show-welcome-modal';
const $8379f5d78bf6fb5a$export$928ffae10e4c0006 = 'template-key-to-show-onboarding-modal';
const $8379f5d78bf6fb5a$export$8a00ecf6498ee2fe = 'onboarding-selected-project-template-type';
const $8379f5d78bf6fb5a$export$69fe8832c4f79a32 = 'onboarding_started_timestamp';
const $8379f5d78bf6fb5a$export$a8d62e500b59f31e = 'boardCreateColumnButtonNudge';
const $8379f5d78bf6fb5a$export$92c7f0eacc8d8d98 = 'assigneeFilterAddPeopleButtonNudge';
const $8379f5d78bf6fb5a$export$dd63d0099d95ba4f = 'navigationAppsNavItemNudge';
const $8379f5d78bf6fb5a$export$aba87e019f5ccb8d = 'navigationCreateIssueButtonNudge';
const $8379f5d78bf6fb5a$export$46d9a3d441dfd22b = 'navigationPlansNavItemNudge';
const $8379f5d78bf6fb5a$export$e20072f7d0c5357f = 'roadmapCreateEpicButtonNudge';
const $8379f5d78bf6fb5a$export$1e39959907a7f359 = 'roadmapCreateEpicChildIssueButtonNudge';
const $8379f5d78bf6fb5a$export$b74a8fdb2c75b869 = 'navigationPeopleNavItemNudge';
const $8379f5d78bf6fb5a$export$b1a6ab17737f33e = 'backlogAccordionNudge';
const $8379f5d78bf6fb5a$export$3366ddefe77d5112 = 'boardCreateColumnNudge';
const $8379f5d78bf6fb5a$export$9d9e95a66a2c6abe = 'addItemsCalendarNudge';
const $8379f5d78bf6fb5a$export$69aca8ebee0d34c8 = 'trelloCrossflowAddItemsCalendarNudge';
const $8379f5d78bf6fb5a$export$dd4b359b5a58cdc0 = 'trelloCrossflowTimelineTabNudge';
const $8379f5d78bf6fb5a$export$7aa8bceae32c7862 = 'navigationAppsProfileItemNudge';
const $8379f5d78bf6fb5a$export$c6df9a2c7447e12d = 'getStartedListNudge';
const $8379f5d78bf6fb5a$export$468488291ccd988 = 'timelineAddItemNudge';
const $8379f5d78bf6fb5a$export$7a33548109ac931d = 'createFormNudge';
const $8379f5d78bf6fb5a$export$b65ba9ea0c0ced43 = 'jsw-onboarding-checklist.open';
const $8379f5d78bf6fb5a$export$594d3436316492be = 'summaryViewNudge';
const $8379f5d78bf6fb5a$export$77bc79debbf5c069 = 'inviteTeamNudge';
const $8379f5d78bf6fb5a$export$73278890f736ee6f = 'manageProjectsNudge';

parcelRegister("eUpD5", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('4yMlN');
        const value = parcelRequire('1c4yc');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("4yMlN").then(()=>parcelRequire('1c4yc'));
}

});


parcelRegister("ifD1l", function(module, exports) {

$parcel$export(module.exports, "useOptimisticIssueCreate", () => $894d5c6d08c363b4$export$d4c0864cc288e78a);

var $eUqFw = parcelRequire("eUqFw");

var $bnlpg = parcelRequire("bnlpg");

var $gEmpR = parcelRequire("gEmpR");

var $lGxgz = parcelRequire("lGxgz");

var $d3C6e = parcelRequire("d3C6e");

var $hTnQu = parcelRequire("hTnQu");

var $1ybV0 = parcelRequire("1ybV0");

var $2nzpw = parcelRequire("2nzpw");

var $hszK4 = parcelRequire("hszK4");

var $am0NO = parcelRequire("am0NO");

var $2rjl4 = parcelRequire("2rjl4");

var $dLnS7 = parcelRequire("dLnS7");

var $1IC6t = parcelRequire("1IC6t");
const $894d5c6d08c363b4$export$d4c0864cc288e78a = ()=>{
    const { quickFiltersJql: quickFiltersJql, hierarchyParent: hierarchyParent, jqlContext: jqlContext, isHidingDoneItems: isHidingDoneItems } = (0, $lGxgz.useFilteredViewContextInput)({
        view: 'timeline'
    });
    const { hierarchyLevels: hierarchyLevels } = (0, $gEmpR.useIssueTypesAndFields)({
        issueOperation: 'VIEW'
    });
    const hierarchyLevel = (0, (/*@__PURE__*/$parcel$interopDefault($bnlpg)))(hierarchyLevels)?.level;
    const [{ issueParentMap: issueParentMap }] = (0, $am0NO.useIssueParentMap)();
    const { updateItemsInCache: updateItemsInCache, addToCache: addToCache, removeFromCache: removeFromCache } = (0, $hTnQu.useCacheActions)();
    const getUpdateVariables = (0, $eUqFw.useCallback)((parentId)=>{
        const grandparentIssueId = issueParentMap.get(parentId);
        const baseVariables = {
            jqlContext: jqlContext,
            fieldIds: $2nzpw.fieldIds,
            quickFiltersJql: quickFiltersJql,
            isHidingDoneItems: isHidingDoneItems
        };
        if (grandparentIssueId && hierarchyParent) return (0, $hszK4.getVariables)({
            ...baseVariables,
            hierarchyParent: undefined,
            parentIssue: {
                hierarchyType: hierarchyParent,
                issueId: grandparentIssueId
            }
        });
        return (0, $hszK4.getVariables)({
            ...baseVariables,
            hierarchyLevel: hierarchyLevel,
            hierarchyParent: hierarchyParent
        });
    }, [
        hierarchyLevel,
        hierarchyParent,
        isHidingDoneItems,
        issueParentMap,
        jqlContext,
        quickFiltersJql
    ]);
    // Update the cache with the newly created issue, replacing any optimistic issue if present
    const updateIssue = (0, $eUqFw.useCallback)((item, parentId)=>{
        // handle optimistic update for children item if the hierarchy feature is enabled
        if (parentId != null && hierarchyParent != null) {
            // update the parent issue to contain the new subtask so it will be shown in the UI correctly
            if ((0, $1ybV0.ff)('jwm.visual-hierarchy-milestone-1')) {
                if ((0, $d3C6e.isOptimisticIssue)(item.issueId)) updateItemsInCache({
                    query: (0, $dLnS7.TIMELINE_VIEW_ITEMS_QUERY),
                    variables: getUpdateVariables(parentId),
                    issueIds: [
                        parentId
                    ],
                    updateItem: (0, $1IC6t.addChildToParentTimeline)
                });
            } else updateItemsInCache({
                query: (0, $dLnS7.TIMELINE_VIEW_ITEMS_QUERY),
                variables: (0, $hszK4.getVariables)({
                    jqlContext: jqlContext,
                    fieldIds: $2nzpw.fieldIds,
                    quickFiltersJql: quickFiltersJql,
                    isHidingDoneItems: isHidingDoneItems,
                    hierarchyParent: hierarchyParent
                }),
                issueIds: [
                    parentId
                ],
                updateItem: (0, $1IC6t.addChildToParentTimeline)
            });
            // update the children cache to add the new subtask
            addToCache({
                newNodes: [
                    item
                ],
                query: (0, $dLnS7.TIMELINE_VIEW_ITEMS_QUERY),
                variables: (0, $hszK4.getVariables)({
                    jqlContext: jqlContext,
                    fieldIds: $2nzpw.fieldIds,
                    quickFiltersJql: quickFiltersJql,
                    isHidingDoneItems: isHidingDoneItems,
                    hierarchyParent: undefined,
                    parentIssue: {
                        hierarchyType: hierarchyParent,
                        issueId: parentId
                    }
                })
            });
            return;
        }
        addToCache({
            newNodes: [
                item
            ],
            query: (0, $dLnS7.TIMELINE_VIEW_ITEMS_QUERY),
            variables: {
                ...(0, $hszK4.getVariables)({
                    jqlContext: jqlContext,
                    fieldIds: $2nzpw.fieldIds,
                    quickFiltersJql: quickFiltersJql,
                    isHidingDoneItems: isHidingDoneItems,
                    hierarchyParent: hierarchyParent,
                    ...(0, $1ybV0.ff)('jwm.visual-hierarchy-milestone-1') && {
                        hierarchyLevel: hierarchyLevel
                    }
                }),
                ...(0, $2nzpw.TIMELINE_PAGE_SIZE_ARGS)
            }
        });
    }, [
        hierarchyParent,
        addToCache,
        jqlContext,
        quickFiltersJql,
        isHidingDoneItems,
        hierarchyLevel,
        updateItemsInCache,
        getUpdateVariables
    ]);
    // Add an optimistic issue to the cache
    const addOptimisticIssue = (0, $eUqFw.useCallback)((issue, parentId)=>{
        const optimisticItem = (0, $2rjl4.createOptimisticIssue)(issue);
        updateIssue(optimisticItem, parentId);
    }, [
        updateIssue
    ]);
    const removeOptimisticIssue = (0, $eUqFw.useCallback)((issueId, parentId)=>{
        let variables;
        if (parentId != null && hierarchyParent != null) variables = (0, $hszK4.getVariables)({
            jqlContext: jqlContext,
            fieldIds: $2nzpw.fieldIds,
            quickFiltersJql: quickFiltersJql,
            isHidingDoneItems: isHidingDoneItems,
            hierarchyParent: undefined,
            parentIssue: {
                hierarchyType: hierarchyParent,
                issueId: parentId
            }
        });
        else variables = (0, $hszK4.getVariables)({
            jqlContext: jqlContext,
            fieldIds: $2nzpw.fieldIds,
            quickFiltersJql: quickFiltersJql,
            isHidingDoneItems: isHidingDoneItems,
            hierarchyParent: hierarchyParent,
            ...(0, $1ybV0.ff)('jwm.visual-hierarchy-milestone-1') && {
                hierarchyLevel: hierarchyLevel
            }
        });
        removeFromCache({
            query: (0, $dLnS7.TIMELINE_VIEW_ITEMS_QUERY),
            variables: variables,
            issueId: issueId
        });
    }, [
        hierarchyParent,
        removeFromCache,
        jqlContext,
        quickFiltersJql,
        isHidingDoneItems,
        hierarchyLevel
    ]);
    return {
        addOptimisticIssue: addOptimisticIssue,
        updateIssue: updateIssue,
        removeOptimisticIssue: removeOptimisticIssue
    };
};

});
parcelRegister("2rjl4", function(module, exports) {

$parcel$export(module.exports, "createOptimisticIssue", () => $920b3ec8d9b8aece$export$4c62dfdc23f8a071);

var $7Sz8O = parcelRequire("7Sz8O");

var $lO4Or = parcelRequire("lO4Or");
const $920b3ec8d9b8aece$export$4c62dfdc23f8a071 = ({ issueId: issueId, summary: summary, issueType: issueType, rank: rank, status: status })=>({
        id: `${0, $7Sz8O.OPTIMISTIC_ID_PREFIX}${issueId}`,
        issueId: issueId,
        __typename: 'JiraWorkManagementViewItem',
        childSummary: {
            __typename: 'JiraWorkManagementChildSummary',
            hasChildren: false
        },
        issueLinks: {
            edges: [],
            __typename: 'JiraIssueLinkConnection'
        },
        fields: [
            {
                aliasFieldId: null,
                fieldId: 'summary',
                text: summary ?? null,
                type: (0, $lO4Or.SUMMARY_TYPE),
                __typename: (0, $lO4Or.TEXT_GQL_FIELD)
            },
            {
                fieldId: 'issuekey',
                aliasFieldId: null,
                type: (0, $lO4Or.ISSUE_KEY_TYPE),
                text: '',
                __typename: (0, $lO4Or.TEXT_GQL_FIELD)
            },
            {
                fieldId: 'issuetype',
                aliasFieldId: null,
                type: 'issuetype',
                issueType: {
                    __typename: 'JiraIssueType',
                    issueTypeId: issueType.id,
                    name: issueType.name,
                    hierarchy: {
                        level: issueType.hierarchyLevel,
                        __typename: 'JiraIssueTypeHierarchyLevel'
                    },
                    avatar: {
                        __typename: 'JiraAvatar',
                        medium: issueType.avatarUrl
                    }
                },
                __typename: (0, $lO4Or.ISSUE_TYPE_GQL_FIELD)
            },
            {
                fieldId: 'customfield_10019',
                aliasFieldId: 'rank',
                type: (0, $lO4Or.RANK_CF_TYPE),
                text: rank ?? 'z',
                __typename: (0, $lO4Or.TEXT_GQL_FIELD)
            },
            {
                fieldId: 'status',
                aliasFieldId: null,
                type: (0, $lO4Or.STATUS_TYPE),
                status: {
                    name: status?.name ?? 'To Do',
                    statusId: status?.statusId ?? '0',
                    statusCategory: {
                        statusCategoryId: String(status?.statusCategoryId ?? 2),
                        __typename: 'JiraStatusCategory'
                    },
                    __typename: 'JiraStatus'
                },
                __typename: (0, $lO4Or.STATUS_GQL_FIELD)
            },
            {
                fieldId: 'duedate',
                aliasFieldId: null,
                type: (0, $lO4Or.DUE_DATE_TYPE),
                date: null,
                __typename: (0, $lO4Or.DATE_PICKER_GQL_FIELD)
            },
            {
                fieldId: 'assignee',
                aliasFieldId: null,
                type: (0, $lO4Or.ASSIGNEE_TYPE),
                user: null,
                __typename: (0, $lO4Or.USER_PICKER_GQL_FIELD)
            },
            {
                fieldId: 'customfield_10015',
                aliasFieldId: 'startdate',
                type: (0, $lO4Or.DATE_CF_TYPE),
                date: null,
                __typename: (0, $lO4Or.DATE_PICKER_GQL_FIELD)
            }
        ]
    });

});


parcelRegister("bAqCS", function(module, exports) {

$parcel$export(module.exports, "getIssueAfter", () => $f7218090bffdbfd0$export$3503751cbe8a73eb);

var $1ybV0 = parcelRequire("1ybV0");

var $gf0vG = parcelRequire("gf0vG");

var $1Pl9B = parcelRequire("1Pl9B");
const $f7218090bffdbfd0$export$3503751cbe8a73eb = (containerHeight, expandedItems, height, issuesMap, items, timelineRef)=>{
    // This selector represents the scrollable element of the timeline table platform component.
    const scrollTop = timelineRef?.querySelector('#sr-timeline')?.scrollTop ?? 0;
    /**
	 * 2.5 here represented by
	 * - 1 height of the inline create itself, we want the anchor to be above the inline create bar
	 * - 1 height is for to target the starting point of issue visible above inline create bar
	 * - 0.5 height is to adjust so that the NEWLY created issue will always be 100%  visible without scrolling
	 * (in other words, requires the last issue to be visible more than 50% of the height to be considered as anchor, if it is less than 50% shown, we pick the issue before)
	 */ const maxHeightForAnchor = containerHeight + scrollTop - height * 2.5;
    // we loop through all items to pick the most appropriate issue as the anchor
    // and make sure the issue is less than the maxHeightForAnchor
    let offset = 0;
    let itemIndexForStickyAnchor = 0;
    items.forEach((item, index)=>{
        if (offset < maxHeightForAnchor) {
            itemIndexForStickyAnchor = index;
            offset += height;
            // check if it is in expanded state
            if (expandedItems[item.id]) {
                // if yes, we want to sum the children height
                if ((0, $1ybV0.ff)('jwm.visual-hierarchy-milestone-1')) offset += (0, $1Pl9B.getTimelineTableItemsHeight)(item.childItems, expandedItems, height, false);
                else offset += (0, $gf0vG.BASE_LEVEL_ITEM_HEIGHT) * (item.childItems?.length ?? 0);
            }
        }
    });
    const item = items[itemIndexForStickyAnchor];
    return item ? issuesMap.get(item.id) : undefined;
};

});


parcelRegister("4vChJ", function(module, exports) {

$parcel$export(module.exports, "StickyInlineNudge", () => $22d7a1fd5eca92bb$export$bed5b0bc851c45b0);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $5cLMB = parcelRequire("5cLMB");

var $fKPqw = parcelRequire("fKPqw");

var $VrUCp = parcelRequire("VrUCp");
const $22d7a1fd5eca92bb$export$bed5b0bc851c45b0 = ({ listWidth: listWidth, height: height, loading: loading, timelineRef: timelineRef, isEmpty: isEmpty })=>{
    const [{ headerHeight: headerHeight }] = (0, $VrUCp.useHeaderState)();
    const [nudgeStep, { setNudgeStep: setNudgeStep }] = (0, $5cLMB.useNudgeStep)();
    if (loading || !timelineRef || nudgeStep !== 'timelineAddDateNudge') return null;
    const handleClick = ()=>{
        setNudgeStep('');
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fKPqw.TimelineAddDateNudgeAsync), {
        attributes: {
            isEmpty: isEmpty
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($22d7a1fd5eca92bb$export$e6dfd72ab29f8598, {
        "data-testId": "business-timeline.ui.timeline-view.sticky-inline-nudge.wrapper",
        width: listWidth,
        height: height,
        offsetTop: headerHeight,
        onClick: isEmpty ? handleClick : undefined
    }));
};
const $22d7a1fd5eca92bb$var$RESIZE_HANDLE_SIZE = 2;
const $22d7a1fd5eca92bb$var$wrapperBaseStyles = null;
const $22d7a1fd5eca92bb$export$e6dfd72ab29f8598 = ({ width: width, offsetTop: offsetTop, height: height, ...rest })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        // eslint-disable-next-line jira/react/no-style-attribute
        style: {
            left: `${width - $22d7a1fd5eca92bb$var$RESIZE_HANDLE_SIZE}px`,
            top: `${offsetTop - 6}px`,
            width: `calc(100% - ${width - $22d7a1fd5eca92bb$var$RESIZE_HANDLE_SIZE}px)`,
            height: `${height - 3}px`
        },
        ...rest,
        className: (0, $7JEyt.default)([
            "_kqswh2mm _2rko6iej _1pbyidpf"
        ])
    });

});
parcelRegister("fKPqw", function(module, exports) {

$parcel$export(module.exports, "TimelineAddDateNudgeAsync", () => $05e97eca2849f554$export$1fb63fd3c0dfa456);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $ewdMq = parcelRequire("ewdMq");

var $gGtKh = parcelRequire("gGtKh");


// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $05e97eca2849f554$var$TimelineAddDateNudgeLazy = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("7DRqO")).then((exportedModule)=>exportedModule.TimelineAddDateNudge), {
    ssr: false,
    moduleId: "./src/packages/software/onboarding-nudges/src/ui/jwm-timeline-nudge-tour/timeline-add-date/index.tsx"
});
const $05e97eca2849f554$export$1fb63fd3c0dfa456 = ({ children: children, attributes: attributes })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ewdMq.OnboardingNudgeErrorBoundary), {
        id: (0, $99a775c02d636a41$export$2f06a16c987cc1a2),
        fallback: children,
        attributes: {
            nudgeId: (0, $99a775c02d636a41$export$e34e81ed4f255f6e)
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "timeline-add-date-onboarding-nudge",
        fallback: children
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($05e97eca2849f554$var$TimelineAddDateNudgeLazy, {
        attributes: attributes
    }, children)));
$05e97eca2849f554$export$1fb63fd3c0dfa456.displayName = 'TimelineAddDateNudgeAsync';

});
parcelRegister("7DRqO", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('iuaS8');
        const value = parcelRequire('gapIG');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("iuaS8").then(()=>parcelRequire('gapIG'));
}

});



parcelRegister("e1P9V", function(module, exports) {

$parcel$export(module.exports, "TableProvider", () => $6beeda8410d5a341$export$d542ac353845c9cf);

var $eUqFw = parcelRequire("eUqFw");

var $hevaQ = parcelRequire("hevaQ");
const $6beeda8410d5a341$var$EMPTY_ARRAY = [];
const $6beeda8410d5a341$export$d542ac353845c9cf = (props)=>{
    const { items: items, children: children } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hevaQ.RoadmapChartItemInteractionProvider), {
        intervals: $6beeda8410d5a341$var$EMPTY_ARRAY,
        items: items,
        isDragAlongEnabled: true
    }, children);
};

});

parcelRegister("bKIjS", function(module, exports) {

$parcel$export(module.exports, "TimelineTableInlineCreate", () => $1e57113025960741$export$405c60de0f923a9);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $4Bees = parcelRequire("4Bees");

var $gIx2f = parcelRequire("gIx2f");

var $1ybV0 = parcelRequire("1ybV0");

var $gf0vG = parcelRequire("gf0vG");

var $2nzpw = parcelRequire("2nzpw");

var $bvug1 = parcelRequire("bvug1");

var $ifD1l = parcelRequire("ifD1l");
const $1e57113025960741$export$405c60de0f923a9 = ({ childrenQueryData: childrenQueryData, issuesMap: issuesMap, items: items })=>{
    const [{ createItemAnchor: createItemAnchor }, { setCreateItemAnchor: setCreateItemAnchor }] = (0, $bvug1.useCreateItemAnchor)();
    const { addOptimisticIssue: addOptimisticIssue, updateIssue: updateIssue, removeOptimisticIssue: removeOptimisticIssue } = (0, $ifD1l.useOptimisticIssueCreate)();
    const onPrepareIssueContext = (0, $eUqFw.useCallback)(()=>{
        const issueContext = {};
        if (createItemAnchor) {
            // if created in between issues
            if (createItemAnchor.position === (0, $gf0vG.BEFORE)) {
                issueContext.parentIssueId = createItemAnchor.parentId;
                const issueForBeforeRank = createItemAnchor.beforeId ? issuesMap.get(createItemAnchor.beforeId) : null;
                if (issueForBeforeRank?.issueId && issueForBeforeRank?.rank) issueContext.rankBefore = {
                    issueId: issueForBeforeRank.issueId,
                    rank: issueForBeforeRank.rank
                };
            } else if (createItemAnchor.position === (0, $gf0vG.LAST)) {
                const lastIssueId = items[items.length - 1]?.id;
                const lastIssue = issuesMap.get(lastIssueId);
                if (lastIssue?.issueId && lastIssue?.rank) issueContext.rankAfter = {
                    issueId: lastIssue.issueId,
                    rank: lastIssue.rank
                };
            } else if (createItemAnchor.position === (0, $gf0vG.INSIDE)) {
                const parentIssue = items.find((i)=>i.id === createItemAnchor.parentId);
                const childItems = parentIssue?.childItems ?? [];
                // this can be undefined for parent without children
                const lastChildWithinParent = childItems.length > 0 ? childItems[childItems.length - 1].id : null;
                const lastChildWithinParentIssue = lastChildWithinParent ? issuesMap.get(lastChildWithinParent) : null;
                issueContext.parentIssueId = createItemAnchor.parentId;
                if (lastChildWithinParentIssue?.issueId && lastChildWithinParentIssue?.rank) issueContext.rankAfter = {
                    issueId: lastChildWithinParentIssue.issueId,
                    rank: lastChildWithinParentIssue.rank
                };
            }
        }
        return issueContext;
    }, [
        createItemAnchor,
        issuesMap,
        items
    ]);
    const onSubmit = (0, $eUqFw.useCallback)(async ({ optimisticIssuePayload: optimisticIssuePayload, promise: promise })=>{
        addOptimisticIssue(optimisticIssuePayload, optimisticIssuePayload.parentIssueId);
        try {
            const issue = await promise;
            if (issue) updateIssue(issue, optimisticIssuePayload.parentIssueId);
            else removeOptimisticIssue(optimisticIssuePayload.issueId, optimisticIssuePayload.parentIssueId);
        } catch  {
            removeOptimisticIssue(optimisticIssuePayload.issueId, optimisticIssuePayload.parentIssueId);
        }
    }, [
        addOptimisticIssue,
        updateIssue,
        removeOptimisticIssue
    ]);
    // Hide the inline create when the user cancels/blurs the form
    const onBlur = (0, $eUqFw.useCallback)(()=>{
        setCreateItemAnchor(undefined);
    }, [
        setCreateItemAnchor
    ]);
    const parentId = createItemAnchor && (createItemAnchor.position === (0, $gf0vG.INSIDE) || createItemAnchor.position === (0, $gf0vG.BEFORE)) ? createItemAnchor.parentId : undefined;
    const hierarchyLevels = (0, $eUqFw.useMemo)(()=>{
        if ((0, $1ybV0.ff)('jwm.visual-hierarchy-milestone-1')) {
            if (parentId) {
                const parent = issuesMap.get(parentId);
                const parentHierarchyLevel = parent?.issueType.hierarchyLevel;
                return parentHierarchyLevel !== undefined ? {
                    maxHierarchyLevel: parentHierarchyLevel - 1,
                    minHierarchyLevel: parentHierarchyLevel - 1
                } : undefined;
            }
            return undefined;
        }
        return parentId ? {
            maxHierarchyLevel: -1,
            minHierarchyLevel: -1
        } : undefined;
    }, [
        issuesMap,
        parentId
    ]);
    const queryData = parentId ? childrenQueryData[parentId] : undefined;
    if (parentId && (!queryData || queryData.loading)) {
        if (!queryData) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1e57113025960741$var$InlineCreateLoadingWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1e57113025960741$var$SpinnerWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), {
            size: "small"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1e57113025960741$var$InlineCreateLoading, {
            type: "text",
            disabled: true
        }));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $1e57113025960741$var$inlineCreateWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gIx2f.default), {
        appearance: (0, $gIx2f.ROW_APPEARANCE),
        location: createItemAnchor?.position === (0, $gf0vG.BEFORE) ? 'timelineSibling' : 'timelineHierarchy',
        fieldIdsToReturn: (0, $2nzpw.fieldIds),
        isCompact: true,
        onBlur: onBlur,
        onPrepareIssueContext: onPrepareIssueContext,
        onSubmit: onSubmit,
        ...hierarchyLevels
    }));
};
const $1e57113025960741$var$inlineCreateWrapperStyles = (0, $1ZAYh.xcss)({
    width: '100%'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1e57113025960741$var$InlineCreateLoadingWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswh2mm _1bsb1osq",
            __cmplp.className
        ])
    });
});
const $1e57113025960741$var$SpinnerWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswstnw _154i1b66 _1ltvu2gc",
            __cmplp.className
        ])
    });
});
const $1e57113025960741$var$InlineCreateLoading = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "input", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb11dc _2rkoyh40 _4t3i1tcg _16qsglyw _19it1j2r _80om13gf",
            __cmplp.className
        ])
    });
});

});

parcelRegister("hvTT6", function(module, exports) {

$parcel$export(module.exports, "default", () => $63d59add0a9137fe$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $ltfxy = parcelRequire("ltfxy");

var $lkPEe = parcelRequire("lkPEe");

var $RZgA1 = parcelRequire("RZgA1");

var $8rPxE = parcelRequire("8rPxE");
var $d9gm1 = parcelRequire("d9gm1");
var $gZpkQ = parcelRequire("gZpkQ");

var $bSsl1 = parcelRequire("bSsl1");
var $iSNkS = parcelRequire("iSNkS");
var $eCCst = parcelRequire("eCCst");

var $91Lr1 = parcelRequire("91Lr1");

var $jcm0y = parcelRequire("jcm0y");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jK1pm = parcelRequire("jK1pm");

var $203kY = parcelRequire("203kY");

var $gR2L1 = parcelRequire("gR2L1");

var $d08Di = parcelRequire("d08Di");
const $63d59add0a9137fe$var$Toolbar = ({ exportToImageButton: exportToImageButton })=>{
    const [hideDoneItems, setHideDoneItems] = (0, $gZpkQ.useHideDoneItems)();
    const [{ nudgeStep: nudgeStep, shouldOpenModal: shouldOpenModal }, { setShouldOpenModal: setShouldOpenModal }] = (0, $jcm0y.useNudgeStep)();
    const { hasShareButton: hasShareButton, hasExportButton: hasExportButton, inviteButtonInteraction: inviteButtonInteraction, hasPresence: hasPresence, hasInviteButton: hasInviteButton, hasFilterCustomFields: hasFilterCustomFields } = (0, $203kY.useTimelineFeatures)();
    const handleDialogClose = (0, $eUqFw.useCallback)(()=>{
        if (shouldOpenModal) setShouldOpenModal(false);
    }, [
        setShouldOpenModal,
        shouldOpenModal
    ]);
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const showShareButtonSpotlight = nudgeStep === (0, $96fdf0f7cea6c0d2$export$3524fa372f8a92d5);
    const shareButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eCCst.JWMShareButton), {
        shareTitle: (0, $gR2L1.default).shareTitle,
        integrationType: (0, $iSNkS.integrationTypes).TIMELINE,
        shareContentType: "timeline",
        isAutoOpenDialog: shouldOpenModal,
        onDialogClose: handleDialogClose
    });
    const wrappedShareButton = showShareButtonSpotlight ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ltfxy.default), {
        name: (0, $96fdf0f7cea6c0d2$export$3524fa372f8a92d5)
    }, shareButton) : shareButton;
    const searchBarLabelId = 'header-actions-search-field-label';
    const searchBar = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lkPEe.default), {
        id: searchBarLabelId
    }, formatMessage((0, $gR2L1.default).searchLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d9gm1.SimpleSearchField), {
        placeholder: (0, $gR2L1.default).simpleSearch,
        view: "timeline",
        describedbyId: searchBarLabelId
    }));
    const addPeopleWithPresence = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bSsl1.default), {
        view: "timeline",
        isPresenceEnabledInContext: hasPresence,
        hasInviteButton: hasInviteButton,
        isOpenNewTabOnClick: inviteButtonInteraction === 'openNewTab'
    });
    const todayButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d08Di.default), null);
    const shareActionButton = hasShareButton && wrappedShareButton;
    const exportButton = hasExportButton && exportToImageButton;
    const filters = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8rPxE.Filters), {
        view: "timeline",
        allowCustomFields: hasFilterCustomFields
    });
    const moreMenu = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $91Lr1.default), {
        hideDoneItems: Boolean(hideDoneItems),
        onChangeHideDoneItems: setHideDoneItems
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jK1pm.default), {
        name: "business-timeline-toolbar"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $RZgA1.ActionsWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $RZgA1.LeftActionsWrapper), null, searchBar, addPeopleWithPresence), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($63d59add0a9137fe$var$UnorderedListWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($63d59add0a9137fe$var$ListItemWrapper, null, todayButton), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($63d59add0a9137fe$var$ListItemWrapper, null, shareActionButton), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($63d59add0a9137fe$var$ListItemWrapper, null, exportButton), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($63d59add0a9137fe$var$ListItemWrapper, null, filters), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($63d59add0a9137fe$var$ListItemWrapper, null, moreMenu))));
};
var $63d59add0a9137fe$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = /*#__PURE__*/ (0, $eUqFw.memo)($63d59add0a9137fe$var$Toolbar);
const $63d59add0a9137fe$var$UnorderedListWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "ul", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _zulpu2gc _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $63d59add0a9137fe$var$ListItemWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "li", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});

});
parcelRegister("RZgA1", function(module, exports) {

$parcel$export(module.exports, "ActionsWrapper", () => $2a4eb501d360abec$export$c8223871eecc8f3a);
$parcel$export(module.exports, "LeftActionsWrapper", () => $2a4eb501d360abec$export$42cb1c7ab389bf4d);
$parcel$export(module.exports, "RightActionsWrapper", () => $2a4eb501d360abec$export$4aa2cd250ec24dcc);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $hSCS8 = parcelRequire("hSCS8");
const $2a4eb501d360abec$export$c8223871eecc8f3a = ({ children: children, testId: testId })=>{
    const [{ content: content }] = (0, $hSCS8.useSidebar)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2a4eb501d360abec$var$ActionsWrapperStyled, {
        sidebarOpen: !!content,
        "data-testid": testId
    }, children);
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2a4eb501d360abec$var$CenterAlignedWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _zulpu2gc",
            __cmplp.className
        ])
    });
});
const $2a4eb501d360abec$var$ActionsWrapperStyled = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = $2a4eb501d360abec$var$CenterAlignedWrapper, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_10qff79": (0, $9t7rW.default)(`0 ${__cmplp.sidebarOpen ? 0 : "var(--ds-space-negative-300, -24px)"} ${"var(--ds-space-200, 16px)"} ${"var(--ds-space-negative-300, -24px)"}`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1tke1ylp _18s8l1uc _1yt46hdp _1n261g80 _bfhk1ml8 _18k9kjed",
            __cmplp.className
        ])
    });
});
const $2a4eb501d360abec$export$42cb1c7ab389bf4d = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = $2a4eb501d360abec$var$CenterAlignedWrapper, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug",
            __cmplp.className
        ])
    });
});
const $2a4eb501d360abec$export$4aa2cd250ec24dcc = $2a4eb501d360abec$var$CenterAlignedWrapper;

});

parcelRegister("8rPxE", function(module, exports) {

$parcel$export(module.exports, "Filters", () => $4a948cec7cd2ee06$export$92a576f896a9bf72);

var $eUqFw = parcelRequire("eUqFw");

var $3MV1G = parcelRequire("3MV1G");

var $1ybV0 = parcelRequire("1ybV0");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $jK1pm = parcelRequire("jK1pm");

var $jpXBE = parcelRequire("jpXBE");

var $fvzkg = parcelRequire("fvzkg");

var $jWIW7 = parcelRequire("jWIW7");

var $9GlEj = parcelRequire("9GlEj");

var $27zPy = parcelRequire("27zPy");

var $6M6Pf = parcelRequire("6M6Pf");
const $4a948cec7cd2ee06$var$hiddenQuickFiltersDefault = [
    'ACTIVE_SPRINTS'
];
const $4a948cec7cd2ee06$export$92a576f896a9bf72 = /*#__PURE__*/ (0, $eUqFw.memo)(({ view: view, allowedFieldTypes: inputAllowedFieldTypes, allowedAliasFieldId: allowedAliasFieldId, hiddenQuickFilters: hiddenQuickFilters = $4a948cec7cd2ee06$var$hiddenQuickFiltersDefault, allowCustomFields: allowCustomFields, allowSavedFilters: allowSavedFilters = true })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const allowedFieldTypes = (0, $jWIW7.useAllowedFieldTypes)(inputAllowedFieldTypes);
    const [isOpen, setIsOpen] = (0, $eUqFw.useState)(false);
    const close = (0, $eUqFw.useCallback)(()=>{
        setIsOpen(false);
    }, []);
    const toggle = (0, $eUqFw.useCallback)(()=>{
        setIsOpen((prevIsOpen)=>!prevIsOpen);
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'jwmFilterButton clicked');
    }, [
        createAnalyticsEvent
    ]);
    const { quickFilters: quickFilters, persistQuickFilters: setQuickFilters } = (0, $9GlEj.useQuickFilters)();
    const { filters: filters, fieldConfig: fieldConfig, customFieldsLoader: customFieldsLoader, hasFilterError: hasFilterError, setFilters: setFilters } = (0, $fvzkg.useDeserialiseJqlFilters)({
        view: view,
        allowedFieldTypes: allowedFieldTypes,
        allowedAliasFieldId: allowedAliasFieldId,
        allowCustomFields: allowCustomFields
    });
    const count = Object.values(filters).flat().length + Object.values(quickFilters).filter((value)=>value).length;
    if ((0, $1ybV0.ff)('native-goals-integration-in-list-view_h12va')) // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $jpXBE.useGoalsFilterAnalyticsEvent)({
        filters: filters,
        view: view
    });
    const hasFiltersApplied = count > 0 || hasFilterError;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jK1pm.default), {
        name: "business-filters"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3MV1G.default), {
        isOpen: isOpen,
        onClose: close,
        placement: "bottom-end",
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $27zPy.MenuContent), {
                "data-testid": "business-filters.ui.filters.menu-content",
                count: count,
                fieldConfig: fieldConfig,
                filters: filters,
                quickFilters: quickFilters,
                setQuickFilters: setQuickFilters,
                setFilters: setFilters,
                hiddenQuickFilters: hiddenQuickFilters,
                view: view,
                allowCustomFields: allowCustomFields,
                allowSavedFilters: allowSavedFilters,
                hasFilterError: hasFilterError
            })),
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6M6Pf.Trigger), {
                ...triggerProps,
                count: count,
                hasFiltersApplied: hasFiltersApplied,
                isSelected: isOpen,
                onClick: toggle
            }),
        shouldRenderToParent: (0, $1ybV0.ff)('fix-should-render-to-parent-with-custom-backgrounds'),
        strategy: (0, $1ybV0.ff)('fix-should-render-to-parent-with-custom-backgrounds') ? 'absolute' : undefined
    }), customFieldsLoader));
});

});
parcelRegister("jpXBE", function(module, exports) {

$parcel$export(module.exports, "useGoalsFilterAnalyticsEvent", () => $bf0eb06c2610c94c$export$c9b2aef46b42c898);

var $eUqFw = parcelRequire("eUqFw");

var $hLW3I = parcelRequire("hLW3I");

var $lO4Or = parcelRequire("lO4Or");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");
const $bf0eb06c2610c94c$export$c9b2aef46b42c898 = ({ filters: filters, view: view })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { data: filterFields } = (0, $hLW3I.useFilterFields)();
    const goalField = (0, $eUqFw.useMemo)(()=>filterFields.find((field)=>field.type === (0, $lO4Or.GOALS_CF_TYPE)), [
        filterFields
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (goalField && filters[goalField.id]) {
            const goalsFilter = filters[goalField.id];
            (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'goalsFilter applied', {
                source: view,
                goalsCount: Array.isArray(goalsFilter) ? goalsFilter.length : 0
            });
        }
    }, [
        createAnalyticsEvent,
        filters,
        goalField,
        view
    ]);
};

});
parcelRegister("hLW3I", function(module, exports) {

$parcel$export(module.exports, "useFilterFields", () => $b966faf4b3b8c8a2$export$b2d30fa5478b571a);

var $eUqFw = parcelRequire("eUqFw");

var $kMmsu = parcelRequire("kMmsu");
const $b966faf4b3b8c8a2$export$b2d30fa5478b571a = ()=>{
    const { data: fields, loading: loading } = (0, $kMmsu.useFieldsResource)();
    const data = (0, $eUqFw.useMemo)(()=>fields?.map((field)=>({
                id: field.jqlTerm,
                name: field.displayName,
                type: field.type
            })) ?? [], [
        fields
    ]);
    return {
        data: data,
        loading: loading,
        error: undefined
    };
};

});


parcelRegister("fvzkg", function(module, exports) {

$parcel$export(module.exports, "DeserialisedFiltersProvider", () => $df8b3ad8c9e75684$export$c5640c1fbeb250b6);
$parcel$export(module.exports, "useDeserialisedFilters", () => $df8b3ad8c9e75684$export$ac7ff3aa0620d1a7);
$parcel$export(module.exports, "useDeserialiseJqlFilters", () => $df8b3ad8c9e75684$export$eaa578dc219a620a);

var $eUqFw = parcelRequire("eUqFw");

var $guiFP = parcelRequire("guiFP");

var $eI5EY = parcelRequire("eI5EY");

var $9TEHc = parcelRequire("9TEHc");

var $jhNgz = parcelRequire("jhNgz");

var $hLW3I = parcelRequire("hLW3I");

var $gZpkQ = parcelRequire("gZpkQ");

var $lEWmB = parcelRequire("lEWmB");

var $9GlEj = parcelRequire("9GlEj");

var $coMWQ = parcelRequire("coMWQ");
const $df8b3ad8c9e75684$var$DEFAULT_VALUE = {
    filters: {}
};
/* Context used by the board view until the filters get implemented in the backend */ const $df8b3ad8c9e75684$var$DeserialisedFiltersContext = /*#__PURE__*/ (0, $eUqFw.createContext)($df8b3ad8c9e75684$var$DEFAULT_VALUE);
const $df8b3ad8c9e75684$export$c5640c1fbeb250b6 = ({ children: children })=>{
    const [filters, setFilters] = (0, $eUqFw.useState)({});
    const [isLoading, setIsLoading] = (0, $eUqFw.useState)(false);
    const value = (0, $eUqFw.useMemo)(()=>({
            filters: filters,
            setFilters: setFilters,
            isLoading: isLoading,
            setIsLoading: setIsLoading
        }), [
        filters,
        isLoading
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($df8b3ad8c9e75684$var$DeserialisedFiltersContext.Provider, {
        value: value
    }, children);
};
const $df8b3ad8c9e75684$export$ac7ff3aa0620d1a7 = ()=>(0, $eUqFw.useContext)($df8b3ad8c9e75684$var$DeserialisedFiltersContext);
/**
 * There are known limitations with deserialising JQL that the backend supports but the UI filter
 * dialog does not. This is mainly seen from links on the Summary page that contain filters like relative
 * dates (i.e. `statusCategoryChangedDate >= -1w`) and `statusCategory`. For these types of filters
 * we don't want to send errors to our analytics service as they create too much noise
 * and make it harder to identify errors we care about.
 *
 * Software projects do not have a Summary page so we are using `allowedFilterTypes` as a way of
 * approximating what type of project we are, this allows us to then prevent/allow sending
 * errors to the analytics service.
 *
 * @see https://jbusiness.atlassian.net/browse/FLINGO-370
 */ const $df8b3ad8c9e75684$var$useErrorDeserializeAnalytics = ({ allowedFieldTypes: allowedFieldTypes, error: error })=>{
    const isSoftwareProject = (0, $9TEHc.SOFTWARE_FIELD_TYPES).some(Set.prototype.has, allowedFieldTypes);
    const shouldSuppressErrors = !isSoftwareProject;
    (0, $eUqFw.useEffect)(()=>{
        if (shouldSuppressErrors) return;
        if (error) (0, $guiFP.default)({
            meta: {
                id: 'deserializeJQL',
                packageName: 'jiraBusinessFilters',
                // eslint-disable-next-line jira/js/team-name-enforcer-for-error-analytics
                teamName: 'keystone'
            },
            attributes: {
                message: 'Failed to deserialize filters'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true,
            skipSentry: (0, $eI5EY.fg)('jwm_filters_remove_unsupported_fields_from_filters')
        });
    }, [
        error,
        shouldSuppressErrors
    ]);
};
const $df8b3ad8c9e75684$var$EMPTY_FILTER = {};
const $df8b3ad8c9e75684$export$eaa578dc219a620a = ({ view: view, allowedFieldTypes: allowedFieldTypes, allowedAliasFieldId: allowedAliasFieldId, allowCustomFields: allowCustomFields })=>{
    const { jql: jql, setFilter: setFilter } = (0, $lEWmB.useFilters)();
    const { setFilters: setContextFilters, setIsLoading: setIsLoadingFilters } = $df8b3ad8c9e75684$export$ac7ff3aa0620d1a7();
    const { fieldConfig: fieldConfig, resolvers: resolvers, customFieldsLoader: customFieldsLoader, loading: isLoadingFieldConfig } = (0, $jhNgz.useFieldConfigWithCustomFields)({
        view: view,
        allowedFieldTypes: allowedFieldTypes,
        allowedAliasFieldId: allowedAliasFieldId,
        allowCustomFields: allowCustomFields
    });
    const [filters, setFilters] = (0, $eUqFw.useState)({});
    const [error, setError] = (0, $eUqFw.useState)(null);
    const hasFilterError = error != null;
    const [isDeserialisingFilters, setIsDeserialisingFilters] = (0, $eUqFw.useState)(false);
    const [filtersCache, setFiltersCache] = (0, $eUqFw.useState)({});
    const { data: filterFields, loading: isLoadingFilterFields } = (0, $hLW3I.useFilterFields)();
    const { quickFiltersJql: quickFiltersJql } = (0, $9GlEj.useQuickFilters)();
    (0, $eUqFw.useEffect)(()=>{
        // Skip if loading
        if (isDeserialisingFilters || isLoadingFieldConfig || isLoadingFilterFields) return;
        // Skip if no fields supported
        if (!Object.keys(fieldConfig).length) return;
        // Skip if deserialised this jql before
        if (jql != null && filters === filtersCache[jql]) return;
        // Skip if has error and jql not empty
        if (hasFilterError && jql != null) return;
        if (jql == null) {
            if (hasFilterError) setError(null);
            if (filters !== $df8b3ad8c9e75684$var$EMPTY_FILTER) setFilters($df8b3ad8c9e75684$var$EMPTY_FILTER);
            return;
        }
        if (quickFiltersJql !== null) {
            setFilters($df8b3ad8c9e75684$var$EMPTY_FILTER);
            return;
        }
        if (filtersCache[jql]) {
            setFilters(filtersCache[jql]);
            return;
        }
        setIsDeserialisingFilters(true);
        (0, $coMWQ.deserialiseJql)(jql, fieldConfig, filterFields, resolvers).then((result)=>{
            setFilters(result);
            setFiltersCache({
                ...filtersCache,
                [jql]: result
            });
        }).catch((e)=>{
            setError(e);
        }).finally(()=>{
            setIsDeserialisingFilters(false);
        });
    }, [
        hasFilterError,
        quickFiltersJql,
        error,
        filters,
        isLoadingFieldConfig,
        isLoadingFilterFields,
        fieldConfig,
        jql,
        filtersCache,
        filterFields,
        resolvers,
        isDeserialisingFilters
    ]);
    $df8b3ad8c9e75684$var$useErrorDeserializeAnalytics({
        allowedFieldTypes: allowedFieldTypes,
        error: error
    });
    (0, $gZpkQ.useInferHideDoneItemsWithFilters)({
        filters: filters
    });
    (0, $eUqFw.useEffect)(()=>{
        if (setContextFilters) setContextFilters(filters);
    }, [
        filters,
        setContextFilters
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (setIsLoadingFilters) setIsLoadingFilters(isLoadingFieldConfig || isDeserialisingFilters);
    }, [
        isDeserialisingFilters,
        isLoadingFieldConfig,
        setIsLoadingFilters
    ]);
    return {
        fieldConfig: fieldConfig,
        filters: filters,
        hasFilterError: hasFilterError,
        customFieldsLoader: customFieldsLoader,
        setFilters: setFilter
    };
};

});
parcelRegister("jhNgz", function(module, exports) {

$parcel$export(module.exports, "useFieldConfigWithCustomFields", () => $d017338cf4a59425$export$9f6dc7e3584916fa);

var $eUqFw = parcelRequire("eUqFw");

var $lO4Or = parcelRequire("lO4Or");

var $9TEHc = parcelRequire("9TEHc");

var $ejYlo = parcelRequire("ejYlo");

var $bPRqC = parcelRequire("bPRqC");

var $aWjLM = parcelRequire("aWjLM");
const $d017338cf4a59425$var$emptySet = new Set();
const $d017338cf4a59425$var$CustomFieldsLoader = ({ allowedFieldTypes: allowedFieldTypes, allowedAliasFieldId: allowedAliasFieldId, setFieldConfig: setFieldConfig })=>{
    const { fieldConfig: fieldConfig, resolvers: resolvers, loading: loading } = (0, $bPRqC.useFieldConfig)({
        allowedFieldTypes: allowedFieldTypes,
        allowedAliasFieldId: allowedAliasFieldId
    });
    (0, $eUqFw.useEffect)(()=>{
        setFieldConfig({
            fieldConfig: fieldConfig,
            resolvers: resolvers,
            loading: loading
        });
    }, [
        fieldConfig,
        resolvers,
        loading,
        setFieldConfig
    ]);
    return null;
};
const $d017338cf4a59425$export$9f6dc7e3584916fa = ({ view: view, allowCustomFields: allowCustomFields, allowedAliasFieldId: allowedAliasFieldId, allowedFieldTypes: allowedFieldTypes })=>{
    const [newAllowedFieldTypes, oldAllowedFieldTypes] = (0, $eUqFw.useMemo)(()=>{
        // split allowedFieldTypes into new and old input for useFieldConfigV2 and useFieldConfigOld
        const newTypes = new Set(allowedFieldTypes);
        const oldTypes = new Set();
        (0, $9TEHc.EXTRA_CUSTOM_FIELD_TYPES).forEach((type)=>{
            if (allowedFieldTypes.has(type)) {
                newTypes.delete(type);
                oldTypes.add(type);
            }
        });
        return [
            newTypes,
            oldTypes
        ];
    }, [
        allowedFieldTypes
    ]);
    const hasCustomFields = Boolean(allowCustomFields) && oldAllowedFieldTypes.size > 0;
    const hasAliasFields = allowedAliasFieldId != null && allowedAliasFieldId.size > 0;
    const shouldLoadOldFieldConfig = hasAliasFields || hasCustomFields;
    const { fieldConfig: fieldConfigNew, resolvers: resolversNew, loading: isLoadingFieldConfigNew } = (0, $aWjLM.useFieldConfigV2)({
        view: view,
        allowedFieldTypes: newAllowedFieldTypes
    });
    const [{ fieldConfig: fieldConfigOld, loading: isLoadingFieldConfigOld, resolvers: resolversOld }, setFieldConfig] = (0, $eUqFw.useState)({
        fieldConfig: {},
        resolvers: {},
        loading: shouldLoadOldFieldConfig
    });
    const customFieldsLoader = (0, $eUqFw.useMemo)(()=>{
        if (!shouldLoadOldFieldConfig) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d017338cf4a59425$var$CustomFieldsLoader, {
            allowedFieldTypes: allowCustomFields ? oldAllowedFieldTypes : $d017338cf4a59425$var$emptySet,
            allowedAliasFieldId: allowedAliasFieldId,
            setFieldConfig: setFieldConfig
        });
    }, [
        allowCustomFields,
        allowedAliasFieldId,
        oldAllowedFieldTypes,
        shouldLoadOldFieldConfig
    ]);
    const { fetchUsers: fetchUsers } = (0, $ejYlo.useFetchFieldValues)({
        view: view,
        allowedFieldTypes: allowedFieldTypes
    });
    const fieldConfig = (0, $eUqFw.useMemo)(()=>{
        const aliasFields = {};
        const otherFields = {};
        Object.keys(fieldConfigOld).forEach((id)=>{
            if (fieldConfigOld[id].systemType === (0, $lO4Or.PEOPLE_CF_TYPE) || fieldConfigOld[id].systemType === (0, $lO4Or.USER_CF_TYPE)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            fieldConfigOld[id] = {
                ...fieldConfigOld[id],
                loadOptions: fetchUsers
            };
            // We want to assure that alias fields are always at the end of the filter
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            if (fieldConfigOld[id].aliasFieldId != null) aliasFields[id] = fieldConfigOld[id];
            else otherFields[id] = fieldConfigOld[id];
        });
        return {
            ...otherFields,
            ...fieldConfigNew,
            ...aliasFields
        };
    }, [
        fieldConfigOld,
        fieldConfigNew,
        fetchUsers
    ]);
    return {
        fieldConfig: fieldConfig,
        resolvers: {
            ...resolversOld,
            ...resolversNew
        },
        customFieldsLoader: customFieldsLoader,
        loading: isLoadingFieldConfigNew || isLoadingFieldConfigOld
    };
};

});
parcelRegister("ejYlo", function(module, exports) {

$parcel$export(module.exports, "useFetchFieldValues", () => $a250a9d5a7d089ab$export$6cb851ed13e3949e);

var $eUqFw = parcelRequire("eUqFw");

var $5iWql = parcelRequire("5iWql");

var $jGcn0 = parcelRequire("jGcn0");

var $eZbpk = parcelRequire("eZbpk");

var $dlVOn = parcelRequire("dlVOn");

var $1ybV0 = parcelRequire("1ybV0");

var $eI5EY = parcelRequire("eI5EY");

var $lRmyA = parcelRequire("lRmyA");

var $lO4Or = parcelRequire("lO4Or");

var $kJlBc = parcelRequire("kJlBc");

var $dWLk9 = parcelRequire("dWLk9");

var $kIODn = parcelRequire("kIODn");

var $4Zgod = parcelRequire("4Zgod");

var $gF4D9 = parcelRequire("gF4D9");

var $5IIOI = parcelRequire("5IIOI");


var $bRzz9 = parcelRequire("bRzz9");
const $a250a9d5a7d089ab$var$MAX_NUMBER_OF_OPTIONS = 20; // min number to render two rows of the priority filter
const $a250a9d5a7d089ab$var$MAX_INITIAL_NUMBER_OF_OPTIONS = 50; // Increased initial number of options fetched
const $a250a9d5a7d089ab$var$EMPTY_FIELD_DATA = {
    totalCount: 0,
    options: []
};
const $a250a9d5a7d089ab$var$ACTIVE_SPRINTS_JQL = '(sprint in openSprints() OR sprint in futureSprints())';
// TODO: remove shouldFetchSprints and keep shouldFetchSoftwareFields after clean up  jsw_list_view_-_all_the_fields
const $a250a9d5a7d089ab$var$fetchInitialDataInternal = async (cloudId, jqlContext, jqlURLParam, allowedFieldTypes, goalsJqlTerm)=>{
    try {
        const response = await (0, $lRmyA.performPostRequest)('/rest/gira/1/?operation=JWMInitialFilterFieldValues', {
            body: JSON.stringify({
                query: (0, $8d92abf0af87bfd8$export$a48313dd44fc9855),
                variables: {
                    cloudId: cloudId,
                    first: $a250a9d5a7d089ab$var$MAX_INITIAL_NUMBER_OF_OPTIONS,
                    jql: jqlContext,
                    shouldFetchSprints: Boolean(allowedFieldTypes?.has((0, $lO4Or.SPRINT_TYPE))),
                    shouldFetchSoftwareFields: Boolean((0, $eI5EY.fg)('jsw_list_view_-_all_the_fields') && allowedFieldTypes?.has((0, $lO4Or.FIX_VERSIONS_TYPE))),
                    shouldFetchParentField: Boolean((0, $eI5EY.fg)('jsw_list_view_-_all_the_fields')),
                    shouldFetchGoalsField: Boolean(allowedFieldTypes?.has((0, $lO4Or.GOALS_CF_TYPE)) && !!goalsJqlTerm && (0, $1ybV0.ff)('native-goals-integration-in-list-view_h12va')),
                    goalsJqlTerm: goalsJqlTerm && (0, $1ybV0.ff)('native-goals-integration-in-list-view_h12va') ? goalsJqlTerm : '',
                    sprintsJqlContext: allowedFieldTypes?.has((0, $lO4Or.SPRINT_TYPE)) ? `${jqlContext} AND ${$a250a9d5a7d089ab$var$ACTIVE_SPRINTS_JQL}` : undefined
                }
            })
        });
        if (response.data?.jira?.jqlBuilder == null && response.data?.jwmCategoryOptions == null) throw new (0, $dlVOn.GraphQLErrors)(response.errors);
        const hydratedValues = jqlURLParam ? await (0, $gF4D9.hydrateFilterValues)(cloudId, jqlURLParam) : null;
        const transformedInitialData = (0, $bRzz9.transformInitialData)(response.data);
        if (hydratedValues !== null) {
            const transformedHydratedValues = (0, $5IIOI.transformHydratedValues)(hydratedValues);
            return (0, $5IIOI.mergeHydratedValues)(transformedInitialData, transformedHydratedValues);
        }
        return transformedInitialData;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err) {
        (0, $bRzz9.fireFieldValuesErrorAnalytics)('initialiseFilterData', 'Failed to initialise filter data', err);
    }
    return null;
};
const $a250a9d5a7d089ab$var$memoizedFetchInitialData = (0, $5iWql.default)($a250a9d5a7d089ab$var$fetchInitialDataInternal);
const $a250a9d5a7d089ab$var$fetchTeamsServiceFnc = ()=>Promise.resolve((0, $4Zgod.EMPTY_TEAMS));
const $a250a9d5a7d089ab$export$6cb851ed13e3949e = ({ view: view, allowedFieldTypes: allowedFieldTypes, filterFields: filterFields })=>{
    const cloudId = (0, $dWLk9.useCloudId)();
    const jqlContext = (0, $eZbpk.useJqlContext)();
    const [jqlURLParam] = (0, $kJlBc.useQueryParam)((0, $jGcn0.FILTER_PARAM));
    const jqlURLParamRef = (0, $eUqFw.useRef)(jqlURLParam);
    const goalsJqlTerm = (0, $bRzz9.useGoalsJqlTerm)(filterFields);
    let fetchTeamsService = $a250a9d5a7d089ab$var$fetchTeamsServiceFnc;
    if ((0, $eI5EY.fg)('jsw_list_view_-_all_the_fields')) // eslint-disable-next-line react-hooks/rules-of-hooks
    fetchTeamsService = (0, $4Zgod.useFetchTeams)();
    const fetchInitialData = (0, $eUqFw.useCallback)(async ()=>{
        if ((0, $eI5EY.fg)('jsw_list_view_-_all_the_fields')) return Promise.all([
            $a250a9d5a7d089ab$var$memoizedFetchInitialData(cloudId, jqlContext, jqlURLParamRef.current, allowedFieldTypes, goalsJqlTerm),
            fetchTeamsService({
                first: $a250a9d5a7d089ab$var$MAX_NUMBER_OF_OPTIONS
            })
        ]).then((values)=>{
            let result = (0, $kIODn.EMPTY_TRANSFORMED_DATA);
            values.forEach((value)=>{
                result = {
                    ...result,
                    ...value
                };
            });
            return result;
        });
        return $a250a9d5a7d089ab$var$memoizedFetchInitialData(cloudId, jqlContext, jqlURLParamRef.current, allowedFieldTypes, goalsJqlTerm);
    }, [
        allowedFieldTypes,
        cloudId,
        fetchTeamsService,
        goalsJqlTerm,
        jqlContext
    ]);
    const fetchData = (0, $eUqFw.useCallback)(async ({ fieldName: fieldName, query: query = '', first: first = $a250a9d5a7d089ab$var$MAX_NUMBER_OF_OPTIONS, afterCursor: afterCursor, jqlContext: jqlContextProp })=>{
        const response = await (0, $lRmyA.performPostRequest)('/rest/gira/1/?operation=JWMFilterFieldValues', {
            body: JSON.stringify({
                query: (0, $8d92abf0af87bfd8$export$f8e8a5f34f6ea725),
                variables: {
                    cloudId: cloudId,
                    first: first,
                    jqlTerm: fieldName,
                    jql: jqlContextProp ?? jqlContext,
                    searchString: query,
                    after: afterCursor
                }
            })
        });
        if (response.data?.jira?.jqlBuilder?.fieldValues == null) throw new (0, $dlVOn.GraphQLErrors)(response.errors);
        return response.data.jira.jqlBuilder.fieldValues;
    }, [
        cloudId,
        jqlContext
    ]);
    const fetchLabels = (0, $eUqFw.useCallback)(async ({ query: query = '', afterCursor: afterCursor, first: first })=>{
        try {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const fieldValuesData = await fetchData({
                fieldName: 'labels',
                query: query,
                first: first,
                afterCursor: afterCursor
            });
            return {
                totalCount: fieldValuesData.totalCount,
                options: (0, $kIODn.transformDefaultField)(fieldValuesData)
            };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            (0, $bRzz9.fireFieldValuesErrorAnalytics)('searchFilterLabels', 'Failed to search labels', err);
        }
        return $a250a9d5a7d089ab$var$EMPTY_FIELD_DATA;
    }, [
        fetchData
    ]);
    const fetchComponents = (0, $eUqFw.useCallback)(async ({ query: query = '', afterCursor: afterCursor, first: first })=>{
        try {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const fieldValuesData = await fetchData({
                fieldName: 'component',
                query: query,
                first: first,
                afterCursor: afterCursor
            });
            return {
                totalCount: fieldValuesData.totalCount,
                options: (0, $kIODn.transformDefaultField)(fieldValuesData)
            };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            (0, $bRzz9.fireFieldValuesErrorAnalytics)('searchFilterComponents', 'Failed to search components', err);
        }
        return $a250a9d5a7d089ab$var$EMPTY_FIELD_DATA;
    }, [
        fetchData
    ]);
    const fetchPriorities = (0, $eUqFw.useCallback)(async ({ query: query = '', afterCursor: afterCursor, first: first })=>{
        try {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const fieldValuesData = await fetchData({
                fieldName: 'priority',
                query: query,
                first: first,
                afterCursor: afterCursor
            });
            return {
                totalCount: fieldValuesData.totalCount,
                options: (0, $kIODn.transformPriorities)(fieldValuesData)
            };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            (0, $bRzz9.fireFieldValuesErrorAnalytics)('searchFilterPriorities', 'Failed to search priorities', err);
        }
        return $a250a9d5a7d089ab$var$EMPTY_FIELD_DATA;
    }, [
        fetchData
    ]);
    const fetchUsers = (0, $eUqFw.useCallback)(async ({ query: query = '', afterCursor: afterCursor, first: first })=>{
        try {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const fieldValuesData = await fetchData({
                fieldName: 'assignee',
                query: query,
                first: first,
                afterCursor: afterCursor
            });
            return {
                totalCount: fieldValuesData.totalCount,
                options: (0, $kIODn.transformUsers)(fieldValuesData)
            };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            (0, $bRzz9.fireFieldValuesErrorAnalytics)('searchFilterUsers', 'Failed to search users', err);
        }
        return $a250a9d5a7d089ab$var$EMPTY_FIELD_DATA;
    }, [
        fetchData
    ]);
    const fetchIssueTypes = (0, $eUqFw.useCallback)(async ({ query: query = '', afterCursor: afterCursor, first: first })=>{
        try {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const fieldValuesData = await fetchData({
                fieldName: 'issuetype',
                query: query,
                first: first,
                afterCursor: afterCursor
            });
            let options = (0, $kIODn.transformIssueTypes)(fieldValuesData);
            if (view === 'board') options = options.filter((option)=>option.hierarchyLevel !== -1);
            return {
                totalCount: fieldValuesData.totalCount,
                options: options
            };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            (0, $bRzz9.fireFieldValuesErrorAnalytics)('searchFilterIssueTypes', 'Failed to search issue types', err);
        }
        return $a250a9d5a7d089ab$var$EMPTY_FIELD_DATA;
    }, [
        fetchData,
        view
    ]);
    const fetchStatuses = (0, $eUqFw.useCallback)(async ({ query: query = '', afterCursor: afterCursor, first: first })=>{
        try {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const fieldValuesData = await fetchData({
                fieldName: 'status',
                query: query,
                first: first,
                afterCursor: afterCursor
            });
            return {
                totalCount: fieldValuesData.totalCount,
                options: (0, $kIODn.transformStatuses)(fieldValuesData)
            };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            (0, $bRzz9.fireFieldValuesErrorAnalytics)('searchFilterStatuses', 'Failed to search statuses', err);
        }
        return $a250a9d5a7d089ab$var$EMPTY_FIELD_DATA;
    }, [
        fetchData
    ]);
    const fetchCategories = (0, $eUqFw.useCallback)(async ({ query: query = '', afterCursor: afterCursor, first: first = $a250a9d5a7d089ab$var$MAX_NUMBER_OF_OPTIONS })=>{
        try {
            const response = await (0, $lRmyA.performPostRequest)('/rest/gira/1/?operation=JWMCategoryFieldValuesSearch', {
                body: JSON.stringify({
                    query: (0, $8d92abf0af87bfd8$export$562e34ec948f373d),
                    variables: {
                        first: first,
                        jql: jqlContext,
                        searchQuery: query,
                        after: afterCursor
                    }
                })
            });
            if (response.errors != null) throw new (0, $dlVOn.GraphQLErrors)(response.errors);
            if (response.data?.jira?.jwmCategoryOptions?.edges == null) throw new Error('GraphQL response has no data');
            return {
                totalCount: response.data.jira.jwmCategoryOptions.totalCount,
                options: (0, $kIODn.transformCategories)(response.data.jira.jwmCategoryOptions)
            };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            (0, $bRzz9.fireFieldValuesErrorAnalytics)('searchFilterCategories', 'Failed to search categories', err);
        }
        return $a250a9d5a7d089ab$var$EMPTY_FIELD_DATA;
    }, [
        jqlContext
    ]);
    const fetchSprints = (0, $eUqFw.useCallback)(async ({ query: query = '', afterCursor: afterCursor, first: first })=>{
        try {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const fieldValuesData = await fetchData({
                fieldName: 'sprint',
                query: query,
                first: first,
                afterCursor: afterCursor,
                jqlContext: `${jqlContext} AND ${$a250a9d5a7d089ab$var$ACTIVE_SPRINTS_JQL}`
            });
            return {
                totalCount: fieldValuesData.totalCount,
                options: (0, $kIODn.transformSprints)(fieldValuesData)
            };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            (0, $bRzz9.fireFieldValuesErrorAnalytics)('searchFilterSprints', 'Failed to search sprints', err);
        }
        return $a250a9d5a7d089ab$var$EMPTY_FIELD_DATA;
    }, [
        fetchData,
        jqlContext
    ]);
    const fetchFixVersions = (0, $eUqFw.useCallback)(async ({ query: query = '', afterCursor: afterCursor, first: first })=>{
        try {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const fieldValuesData = await fetchData({
                fieldName: 'fixVersion',
                query: query,
                first: first,
                afterCursor: afterCursor
            });
            return {
                totalCount: fieldValuesData.totalCount,
                options: (0, $kIODn.transformDefaultField)(fieldValuesData)
            };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            (0, $bRzz9.fireFieldValuesErrorAnalytics)('searchFilterFixVersion', 'Failed to search fix version', err);
        }
        return $a250a9d5a7d089ab$var$EMPTY_FIELD_DATA;
    }, [
        fetchData
    ]);
    const fetchParents = (0, $eUqFw.useCallback)(async ({ query: query = '', afterCursor: afterCursor, first: first })=>{
        try {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const fieldValuesData = await fetchData({
                fieldName: 'parent',
                query: query,
                first: first,
                afterCursor: afterCursor
            });
            return {
                totalCount: fieldValuesData.totalCount,
                options: (0, $kIODn.transformParent)(fieldValuesData)
            };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            (0, $bRzz9.fireFieldValuesErrorAnalytics)('searchFilterParent', 'Failed to search parents', err);
        }
        return $a250a9d5a7d089ab$var$EMPTY_FIELD_DATA;
    }, [
        fetchData
    ]);
    const fetchGoals = (0, $eUqFw.useCallback)(async ({ query: query = '', afterCursor: afterCursor, first: first })=>{
        if (!goalsJqlTerm) return $a250a9d5a7d089ab$var$EMPTY_FIELD_DATA;
        try {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const fieldValuesData = await fetchData({
                fieldName: goalsJqlTerm,
                query: query,
                first: first,
                afterCursor: afterCursor
            });
            return {
                totalCount: fieldValuesData.totalCount,
                options: (0, $kIODn.transformGoals)(fieldValuesData)
            };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            (0, $bRzz9.fireFieldValuesErrorAnalytics)('searchFilterGoals', 'Failed to search goals', err);
        }
        return $a250a9d5a7d089ab$var$EMPTY_FIELD_DATA;
    }, [
        fetchData,
        goalsJqlTerm
    ]);
    const fetchTeams = (0, $eUqFw.useCallback)(async ({ query: query = '', afterCursor: afterCursor, first: first })=>{
        try {
            const fieldValuesData = await fetchTeamsService({
                query: query,
                first: first,
                after: afterCursor
            });
            return fieldValuesData[0, $lO4Or.TEAMS_PLATFORM_CF_TYPE];
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            (0, $bRzz9.fireFieldValuesErrorAnalytics)('searchFilterTeams', 'Failed to search teams', err);
        }
        return $a250a9d5a7d089ab$var$EMPTY_FIELD_DATA;
    }, [
        fetchTeamsService
    ]);
    return {
        fetchInitialData: fetchInitialData,
        fetchLabels: fetchLabels,
        fetchComponents: fetchComponents,
        fetchPriorities: fetchPriorities,
        fetchUsers: fetchUsers,
        fetchIssueTypes: fetchIssueTypes,
        fetchStatuses: fetchStatuses,
        fetchCategories: fetchCategories,
        fetchSprints: fetchSprints,
        ...(0, $eI5EY.fg)('jsw_list_view_-_all_the_fields') ? {
            fetchFixVersions: fetchFixVersions,
            fetchParents: fetchParents,
            fetchTeams: fetchTeams
        } : {},
        fetchGoals: fetchGoals
    };
};

});
parcelRegister("kIODn", function(module, exports) {

$parcel$export(module.exports, "transformPriorities", () => $661a0fc6907b6ea1$export$86ca92dec35c4797);
$parcel$export(module.exports, "transformUsers", () => $661a0fc6907b6ea1$export$fb8c90bfc4beaa59);
$parcel$export(module.exports, "transformIssueTypes", () => $661a0fc6907b6ea1$export$4c05e2584b34e4d8);
$parcel$export(module.exports, "transformStatuses", () => $661a0fc6907b6ea1$export$20a57a5ec025f2d);
$parcel$export(module.exports, "transformCategories", () => $661a0fc6907b6ea1$export$1b389c47cf1df04e);
$parcel$export(module.exports, "transformDefaultField", () => $661a0fc6907b6ea1$export$6133e08eeff30d5f);
$parcel$export(module.exports, "transformSprints", () => $661a0fc6907b6ea1$export$6a33be7fc7f04943);
$parcel$export(module.exports, "transformGoals", () => $661a0fc6907b6ea1$export$673d4fceed3e8383);
$parcel$export(module.exports, "transformParent", () => $661a0fc6907b6ea1$export$87e9766fb5100314);
$parcel$export(module.exports, "transformTeams", () => $661a0fc6907b6ea1$export$fd398a52d6f57b46);
$parcel$export(module.exports, "EMPTY_TRANSFORMED_DATA", () => $661a0fc6907b6ea1$export$ca9df9cab9cc134f);
$parcel$export(module.exports, "transformValuesData", () => $661a0fc6907b6ea1$export$8e327b5f9ebc175d);
/* eslint-disable complexity */ 
var $lyOYo = parcelRequire("lyOYo");

var $lO4Or = parcelRequire("lO4Or");
const $661a0fc6907b6ea1$var$getFirstIssueTypeAvatar = (node)=>node.issueTypes?.find((issueType)=>issueType?.avatar?.medium != null)?.avatar?.medium;
const $661a0fc6907b6ea1$var$getFirstIssueTypeId = (node)=>node.issueTypes[0]?.issueTypeId;
const $661a0fc6907b6ea1$var$getFirstIssueTypeHierarchyLevel = (node)=>node.issueTypes[0]?.hierarchy?.level;
const $661a0fc6907b6ea1$export$86ca92dec35c4797 = (data)=>data.edges.map(({ node: node, cursor: cursor })=>({
            cursor: cursor,
            value: node.jqlTerm,
            label: node.displayName,
            avatar: node.priority.iconUrl || ''
        }));
const $661a0fc6907b6ea1$export$fb8c90bfc4beaa59 = (data)=>data.edges.filter(({ node: node })=>node?.user != null).map(({ node: node, cursor: cursor })=>({
            cursor: cursor,
            value: node.jqlTerm,
            label: node.displayName,
            avatar: node?.user?.picture || ''
        }));
const $661a0fc6907b6ea1$export$4c05e2584b34e4d8 = (data)=>data.edges.map(({ node: node, cursor: cursor })=>({
            cursor: cursor,
            value: node.jqlTerm,
            label: node.displayName,
            id: $661a0fc6907b6ea1$var$getFirstIssueTypeId(node),
            avatar: $661a0fc6907b6ea1$var$getFirstIssueTypeAvatar(node) || '',
            square: true,
            hierarchyLevel: $661a0fc6907b6ea1$var$getFirstIssueTypeHierarchyLevel(node) || 0
        }));
const $661a0fc6907b6ea1$export$20a57a5ec025f2d = (data)=>data.edges.map(({ node: node, cursor: cursor })=>({
            cursor: cursor,
            value: node.jqlTerm,
            label: node.displayName,
            categoryId: node.statusCategory.statusCategoryId
        }));
const $661a0fc6907b6ea1$export$1b389c47cf1df04e = (data)=>{
    const transformedCategories = data.edges.map((edge)=>({
            cursor: edge?.cursor,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            value: edge.node.option.value,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            label: edge.node.option.value,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            color: edge.node.color
        }));
    // Remove any categories that have the same name across multiple projects
    return (0, (/*@__PURE__*/$parcel$interopDefault($lyOYo)))(transformedCategories, ({ value: value })=>value);
};
const $661a0fc6907b6ea1$export$6133e08eeff30d5f = (data)=>data.edges.map(({ node: node, cursor: cursor })=>({
            cursor: cursor,
            value: node.jqlTerm,
            label: node.displayName
        }));
const $661a0fc6907b6ea1$export$6a33be7fc7f04943 = (data)=>data.edges.filter(({ node: node })=>node?.sprint != null).map(({ node: node, cursor: cursor })=>({
            cursor: cursor,
            value: node.displayName,
            label: node.sprint?.name || ''
        }));
const $661a0fc6907b6ea1$export$673d4fceed3e8383 = (data)=>data.edges.map(({ node: node, cursor: cursor })=>({
            cursor: cursor,
            value: node.jqlTerm,
            label: node.goal.name || '',
            status: node.goal.status || ''
        }));
const $661a0fc6907b6ea1$export$87e9766fb5100314 = (data)=>data?.edges.map(({ node: node, cursor: cursor })=>{
        let avatar = '';
        if (Number(node.issue?.fieldsByIdOrAlias.length) > 0) avatar = node.issue?.fieldsByIdOrAlias[0].issueType?.avatar?.medium || '';
        return {
            cursor: cursor,
            value: node.jqlTerm,
            label: node.displayName,
            avatar: avatar
        };
    });
const $661a0fc6907b6ea1$export$fd398a52d6f57b46 = (data)=>data?.edges.filter(({ node: node })=>node?.team != null).map(({ node: node })=>({
            cursor: data.pageInfo?.endCursor,
            value: node.team.id.replace('ari:cloud:identity::team/', ''),
            label: node.team.displayName || '',
            avatar: node.team.smallAvatarImageUrl || ''
        }));
// Type predicted
const $661a0fc6907b6ea1$var$isIssueType = (fieldValue)=>{
    const { node: node } = fieldValue.edges[0];
    return Boolean(node && 'issueTypes' in node);
};
const $661a0fc6907b6ea1$var$isPriority = (fieldValue)=>{
    const { node: node } = fieldValue.edges[0];
    return Boolean(node && 'priority' in node);
};
const $661a0fc6907b6ea1$var$isStatus = (fieldValue)=>{
    const { node: node } = fieldValue.edges[0];
    return Boolean(node && 'statusCategory' in node);
};
const $661a0fc6907b6ea1$var$isSprint = (fieldValue)=>{
    const { node: node } = fieldValue.edges[0];
    return Boolean(node && 'sprint' in node);
};
const $661a0fc6907b6ea1$var$isGoal = (fieldValue)=>{
    const { node: node } = fieldValue.edges[0];
    return Boolean(node && 'goal' in node);
};
const $661a0fc6907b6ea1$var$isParent = (fieldValue)=>{
    const { node: node } = fieldValue.edges[0];
    return Boolean(node && 'issue' in node);
};
// any fieldValue could be a UserFieldValues because the edges could have some node with "user" undefined
// for example : { node: { displayName: "administrators", jqlTerm: "membersOf(administrators)" }}
const $661a0fc6907b6ea1$var$isUser = (fieldValue)=>true;
const $661a0fc6907b6ea1$var$isDefaultField = (fieldValue)=>Boolean(fieldValue.edges[0]);
const $661a0fc6907b6ea1$export$ca9df9cab9cc134f = {
    labels: {
        totalCount: 0,
        options: []
    },
    components: {
        totalCount: 0,
        options: []
    },
    priority: {
        totalCount: 0,
        options: []
    },
    users: {
        totalCount: 0,
        options: []
    },
    issuetype: {
        totalCount: 0,
        options: []
    },
    status: {
        totalCount: 0,
        options: []
    },
    [(0, $lO4Or.CATEGORY_TYPE)]: {
        totalCount: 0,
        options: []
    },
    [(0, $lO4Or.SPRINT_TYPE)]: {
        totalCount: 0,
        options: []
    },
    [(0, $lO4Or.FIX_VERSIONS_TYPE)]: {
        totalCount: 0,
        options: []
    },
    [(0, $lO4Or.PARENT_FIELD_TYPE)]: {
        totalCount: 0,
        options: []
    },
    [(0, $lO4Or.GOALS_CF_TYPE)]: {
        totalCount: 0,
        options: []
    },
    [(0, $lO4Or.TEAMS_PLATFORM_CF_TYPE)]: {
        totalCount: 0,
        options: []
    }
};
const $661a0fc6907b6ea1$export$8e327b5f9ebc175d = (data)=>{
    const transformedData = {
        ...$661a0fc6907b6ea1$export$ca9df9cab9cc134f
    };
    Object.entries(data).forEach(([key, fieldValue])=>{
        if (fieldValue && fieldValue.edges && Array.isArray(fieldValue.edges) && fieldValue.edges.length) switch(key){
            case 'issuetype':
                if ($661a0fc6907b6ea1$var$isIssueType(fieldValue)) transformedData.issuetype = {
                    totalCount: fieldValue.totalCount,
                    options: $661a0fc6907b6ea1$export$4c05e2584b34e4d8(fieldValue)
                };
                break;
            case 'priority':
                if ($661a0fc6907b6ea1$var$isPriority(fieldValue)) transformedData.priority = {
                    totalCount: fieldValue.totalCount,
                    options: $661a0fc6907b6ea1$export$86ca92dec35c4797(fieldValue)
                };
                break;
            case 'status':
                if ($661a0fc6907b6ea1$var$isStatus(fieldValue)) transformedData.status = {
                    totalCount: fieldValue.totalCount,
                    options: $661a0fc6907b6ea1$export$20a57a5ec025f2d(fieldValue)
                };
                break;
            case 'component':
            case 'components':
            case 'fixVersions':
            case 'labels':
                if ($661a0fc6907b6ea1$var$isDefaultField(fieldValue)) {
                    const transformedKey = key === 'component' ? (0, $lO4Or.COMPONENTS_TYPE) : key;
                    transformedData[transformedKey] = {
                        totalCount: fieldValue.totalCount,
                        options: $661a0fc6907b6ea1$export$6133e08eeff30d5f(fieldValue)
                    };
                }
                break;
            case 'parent':
                if ($661a0fc6907b6ea1$var$isParent(fieldValue)) transformedData[key] = {
                    totalCount: fieldValue.totalCount,
                    options: $661a0fc6907b6ea1$export$87e9766fb5100314(fieldValue)
                };
                break;
            default:
                if ($661a0fc6907b6ea1$var$isSprint(fieldValue)) transformedData[0, $lO4Or.SPRINT_TYPE] = {
                    totalCount: fieldValue.totalCount,
                    options: $661a0fc6907b6ea1$export$6a33be7fc7f04943(fieldValue)
                };
                else if (fieldValue.edges.some((item)=>item.node && 'user' in item.node) && $661a0fc6907b6ea1$var$isUser(fieldValue)) {
                    const usersData = $661a0fc6907b6ea1$export$fb8c90bfc4beaa59(fieldValue);
                    const userOptions = (0, (/*@__PURE__*/$parcel$interopDefault($lyOYo)))([
                        ...usersData,
                        ...transformedData.users?.options ?? []
                    ], ({ value: value })=>value);
                    transformedData.users = {
                        totalCount: userOptions.length,
                        options: userOptions
                    };
                } else if ($661a0fc6907b6ea1$var$isGoal(fieldValue)) transformedData[0, $lO4Or.GOALS_CF_TYPE] = {
                    totalCount: fieldValue.totalCount,
                    options: $661a0fc6907b6ea1$export$673d4fceed3e8383(fieldValue)
                };
        }
    });
    return transformedData;
};

});

parcelRegister("4Zgod", function(module, exports) {

$parcel$export(module.exports, "EMPTY_TEAMS", () => $f012c42657d68d46$export$37430da53242c305);
$parcel$export(module.exports, "useFetchTeams", () => $f012c42657d68d46$export$da1ab223b3f1410c);

var $eUqFw = parcelRequire("eUqFw");

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");

var $lO4Or = parcelRequire("lO4Or");

var $jD3pk = parcelRequire("jD3pk");

var $dWLk9 = parcelRequire("dWLk9");

var $kIODn = parcelRequire("kIODn");

// use ari functions from @atlassian/ari whenever it is ready for import
const $f012c42657d68d46$var$prependOrgIdAri = (orgId)=>`ari:cloud:platform::org/${orgId}`;
const $f012c42657d68d46$export$37430da53242c305 = {
    [(0, $lO4Or.TEAMS_PLATFORM_CF_TYPE)]: {
        totalCount: 0,
        options: []
    }
};
const $f012c42657d68d46$var$MAX_NUMBER_OF_OPTIONS = 20;
const $f012c42657d68d46$export$da1ab223b3f1410c = ()=>{
    const cloudId = (0, $dWLk9.useCloudId)();
    const { data: orgId } = (0, $jD3pk.useOrgId)();
    const fetchTeams = (0, $eUqFw.useCallback)(async ({ query: query, first: first = $f012c42657d68d46$var$MAX_NUMBER_OF_OPTIONS, after: after })=>{
        if (orgId) try {
            const response = await (0, $lRmyA.performPostRequest)('/gateway/api/graphql', {
                body: JSON.stringify({
                    query: (0, $1a073e75df73c791$export$cbe5a6af25588495),
                    variables: {
                        orgId: $f012c42657d68d46$var$prependOrgIdAri(orgId),
                        cloudId: cloudId,
                        queryString: query,
                        first: first,
                        after: after
                    }
                })
            });
            const options = (0, $kIODn.transformTeams)(response.data.team.teamSearchV2) || [];
            // Teams query doesn't return the total count
            const totalCount = options.length >= first ? first : options.length;
            return {
                [(0, $lO4Or.TEAMS_PLATFORM_CF_TYPE)]: {
                    totalCount: totalCount,
                    options: options
                }
            };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            (0, $guiFP.default)({
                meta: {
                    id: 'fetchTeams',
                    packageName: 'jiraBusinessFilters',
                    teamName: 'wanjel'
                },
                attributes: {
                    message: 'Failed to fetch team filter data'
                },
                error: err,
                sendToPrivacyUnsafeSplunk: true
            });
        }
        return $f012c42657d68d46$export$37430da53242c305;
    }, [
        cloudId,
        orgId
    ]);
    return fetchTeams;
};

});
const $1a073e75df73c791$export$cbe5a6af25588495 = `
    query JWMTeamFilterValues($cloudId: String!, $orgId: ID!, $queryString: String, $first: Int, $after: String) {
        team @optIn(to: "Team-search-v2") {
            teamSearchV2(
                organizationId: $orgId
                siteId: $cloudId
                first: $first
                after: $after
                filter: {query: $queryString}
            ) {
                pageInfo {
                    hasNextPage
                    endCursor
                }
                edges {
                    node {
                        team {
                            id
                            displayName
                            smallAvatarImageUrl
                        }
                    }
                }
            }
        }
    }
`;


parcelRegister("gF4D9", function(module, exports) {

$parcel$export(module.exports, "hydrateFilterValues", () => $12ce55db15189323$export$b18eef22aaa99c21);

var $5iWql = parcelRequire("5iWql");

var $6gPph = parcelRequire("6gPph");

var $dlVOn = parcelRequire("dlVOn");

var $guiFP = parcelRequire("guiFP");

var $1ybV0 = parcelRequire("1ybV0");

var $lRmyA = parcelRequire("lRmyA");

const $12ce55db15189323$export$3361e9be8093ddcc = (fields)=>{
    const hydratedValues = {};
    fields.forEach((hydratedField)=>{
        if (!hydratedField) return;
        const { field: field, values: values } = hydratedField;
        if (!field || !values) return;
        hydratedValues[field.jqlTerm] = {
            edges: values.map((item)=>(item && item.values && item.values[0]) ?? null).filter(Boolean).map((item)=>({
                    node: item
                })),
            totalCount: 0
        };
    });
    return hydratedValues;
};
const $12ce55db15189323$export$7a89edfb546e2344 = async (cloudId, jqlContext)=>{
    try {
        const response = await (0, $lRmyA.performPostRequest)('/rest/gira/1/?operation=JWMHydrateFilterValues', {
            body: JSON.stringify({
                query: (0, $1ybV0.ff)('native-goals-integration-in-list-view_h12va') ? (0, $a02b4224be9155fa$export$2bd792833522f1f1) : (0, $a02b4224be9155fa$export$e8b5e80812d4a604),
                variables: {
                    cloudId: cloudId,
                    jql: jqlContext
                }
            })
        });
        if (response.errors != null) throw new (0, $dlVOn.GraphQLErrors)(response.errors);
        if (response.data?.jira?.jqlBuilder?.hydrateJqlQuery?.fields == null) {
            if (response.data?.jira?.jqlBuilder?.hydrateJqlQuery?.__typename === 'QueryError') throw new (0, $6gPph.QueryError)(response.data.jira.jqlBuilder.hydrateJqlQuery);
            throw new Error('Failed to fetch on hydrateFilterValuesService');
        }
        return $12ce55db15189323$export$3361e9be8093ddcc(response.data.jira.jqlBuilder.hydrateJqlQuery.fields);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $guiFP.default)({
            meta: {
                id: 'JWMHydrateFilterValues',
                packageName: 'jiraBusinessFilters',
                teamName: 'wanjel'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
        throw error;
    }
};
const $12ce55db15189323$export$b18eef22aaa99c21 = (0, $5iWql.default)($12ce55db15189323$export$7a89edfb546e2344);

});
const $a02b4224be9155fa$var$FIELD_VALUE_NODE_FRAGMENT_OLD = `
fragment FieldValueNodeFragment on JiraJqlFieldValue {
    jqlTerm
    displayName
    ... on JiraJqlUserFieldValue {
        user {
            picture
        }
    }
    ... on JiraJqlPriorityFieldValue {
        priority {
            iconUrl
        }
    }
    ... on JiraJqlIssueTypeFieldValue {
        issueTypes {
            issueTypeId
            avatar {
                medium
            }
            hierarchy {
                level
            }
        }
    }
    ... on JiraJqlStatusFieldValue {
        statusCategory {
            statusCategoryId
        }
    }
    ... on JiraJqlSprintFieldValue {
        sprint {
            sprintId
            name
        }
    }
    ... on JiraJqlIssueFieldValue {
        issue {
            fieldsByIdOrAlias(idsOrAliases: ["issuetype"]) {
                ... on JiraIssueTypeField {
                    issueType {
                        avatar {
                            medium
                        }
                    }
                }
            }
        }
    }
}
`;
const $a02b4224be9155fa$export$e8b5e80812d4a604 = `
query JwmHydrateFilterValues($cloudId: ID!, $jql: String!) {
	jira {
        jqlBuilder(cloudId: $cloudId) {
            hydrateJqlQuery(query: $jql, viewContext: JWM) {
                ... on JiraJqlHydratedQuery {
                    fields {
                        ... on JiraJqlQueryHydratedField {
                            field {
                                jqlTerm
                            }
                            values {
                                ... on JiraJqlQueryHydratedValue {
                                    values {
                                        jqlTerm
                                        displayName
                                        ...FieldValueNodeFragment
                                    }
                                }
                            }
                        }
                    }
                }
                ... on QueryError {
                    message
                    extensions {
                      statusCode
                    }
                }
                __typename
            }
        }
	}
}
${$a02b4224be9155fa$var$FIELD_VALUE_NODE_FRAGMENT_OLD}
`;
const $a02b4224be9155fa$var$FIELD_VALUE_NODE_FRAGMENT = `
fragment FieldValueNodeFragment on JiraJqlFieldValue {
    jqlTerm
    displayName
    ... on JiraJqlUserFieldValue {
        user {
            picture
        }
    }
    ... on JiraJqlPriorityFieldValue {
        priority {
            iconUrl
        }
    }
    ... on JiraJqlIssueTypeFieldValue {
        issueTypes {
            issueTypeId
            avatar {
                medium
            }
            hierarchy {
                level
            }
        }
    }
    ... on JiraJqlStatusFieldValue {
        statusCategory {
            statusCategoryId
        }
    }
    ... on JiraJqlSprintFieldValue {
        sprint {
            sprintId
            name
        }
    }
    ... on JiraJqlGoalsFieldValue {
        goal {
            name
            status
        }
    }
    ... on JiraJqlIssueFieldValue {
        issue {
            fieldsByIdOrAlias(idsOrAliases: ["issuetype"]) {
                ... on JiraIssueTypeField {
                    issueType {
                        avatar {
                            medium
                        }
                    }
                }
            }
        }
    }
}
`;
const $a02b4224be9155fa$export$2bd792833522f1f1 = `
query JwmHydrateFilterValues($cloudId: ID!, $jql: String!) {
	jira {
        jqlBuilder(cloudId: $cloudId) {
            hydrateJqlQuery(query: $jql, viewContext: JWM) {
                ... on JiraJqlHydratedQuery {
                    fields {
                        ... on JiraJqlQueryHydratedField {
                            field {
                                jqlTerm
                            }
                            values {
                                ... on JiraJqlQueryHydratedValue {
                                    values {
                                        jqlTerm
                                        displayName
                                        ...FieldValueNodeFragment
                                    }
                                }
                            }
                        }
                    }
                }
                ... on QueryError {
                    message
                    extensions {
                      statusCode
                    }
                }
                __typename
            }
        }
	}
}
${$a02b4224be9155fa$var$FIELD_VALUE_NODE_FRAGMENT}
`;


parcelRegister("5IIOI", function(module, exports) {

$parcel$export(module.exports, "transformHydratedValues", () => $3cf74c17db7589d0$export$56282b201a60959e);
$parcel$export(module.exports, "mergeHydratedValues", () => $3cf74c17db7589d0$export$8f60413c08081990);

var $lyOYo = parcelRequire("lyOYo");

var $eI5EY = parcelRequire("eI5EY");

var $lO4Or = parcelRequire("lO4Or");

var $kIODn = parcelRequire("kIODn");
const $3cf74c17db7589d0$var$transformHydratedValuesOld = (data)=>{
    const transformedHydratedData = {
        labels: {
            totalCount: 0,
            options: []
        },
        components: {
            totalCount: 0,
            options: []
        },
        priority: {
            totalCount: 0,
            options: []
        },
        users: {
            totalCount: 0,
            options: []
        },
        issuetype: {
            totalCount: 0,
            options: []
        },
        status: {
            totalCount: 0,
            options: []
        },
        [(0, $lO4Or.CATEGORY_TYPE)]: {
            totalCount: 0,
            options: []
        },
        [(0, $lO4Or.SPRINT_TYPE)]: {
            totalCount: 0,
            options: []
        }
    };
    Object.keys(data).forEach((key)=>{
        if (data[key] && data[key].edges && Array.isArray(data[key].edges)) switch(key){
            case 'issuetype':
                transformedHydratedData[key] = {
                    totalCount: 0,
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    options: (0, $kIODn.transformIssueTypes)(data[key])
                };
                return;
            case 'priority':
                transformedHydratedData[key] = {
                    totalCount: 0,
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    options: (0, $kIODn.transformPriorities)(data[key])
                };
                return;
            case 'status':
                transformedHydratedData[key] = {
                    totalCount: 0,
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    options: (0, $kIODn.transformStatuses)(data[key])
                };
                return;
            case 'labels':
                transformedHydratedData[key] = {
                    totalCount: 0,
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    options: (0, $kIODn.transformDefaultField)(data[key])
                };
                return;
            case 'component':
                transformedHydratedData.components = {
                    totalCount: 0,
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    options: (0, $kIODn.transformDefaultField)(data[key])
                };
                return;
            default:
                if (data[key].edges.some((item)=>item.node && 'user' in item.node)) transformedHydratedData.users = {
                    totalCount: 0,
                    options: (0, (/*@__PURE__*/$parcel$interopDefault($lyOYo)))([
                        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                        ...(0, $kIODn.transformUsers)(data[key]),
                        ...transformedHydratedData.users?.options ?? []
                    ], ({ value: value })=>value)
                };
                else if (data[key].edges.some((item)=>item.node && 'sprint' in item.node)) transformedHydratedData[0, $lO4Or.SPRINT_TYPE] = {
                    totalCount: 0,
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    options: (0, $kIODn.transformSprints)(data[key])
                };
        }
    });
    return transformedHydratedData;
};
const $3cf74c17db7589d0$export$56282b201a60959e = (data)=>{
    if ((0, $eI5EY.fg)('jsw_list_view_-_all_the_fields')) return (0, $kIODn.transformValuesData)(data);
    return $3cf74c17db7589d0$var$transformHydratedValuesOld(data);
};
const $3cf74c17db7589d0$export$8f60413c08081990 = (initialData, hydratedValues)=>({
        labels: {
            totalCount: initialData.labels.totalCount,
            options: (0, (/*@__PURE__*/$parcel$interopDefault($lyOYo)))([
                ...hydratedValues.labels.options,
                ...initialData.labels.options
            ], ({ value: value })=>value)
        },
        components: {
            totalCount: initialData.components.totalCount,
            options: (0, (/*@__PURE__*/$parcel$interopDefault($lyOYo)))([
                ...hydratedValues.components.options,
                ...initialData.components.options
            ], ({ value: value })=>value)
        },
        priority: {
            totalCount: initialData.priority.totalCount,
            options: (0, (/*@__PURE__*/$parcel$interopDefault($lyOYo)))([
                ...hydratedValues.priority.options,
                ...initialData.priority.options
            ], ({ value: value })=>value)
        },
        users: {
            totalCount: initialData.users.totalCount,
            options: (0, (/*@__PURE__*/$parcel$interopDefault($lyOYo)))([
                ...hydratedValues.users.options,
                ...initialData.users.options
            ], ({ value: value })=>value)
        },
        issuetype: {
            totalCount: initialData.issuetype.totalCount,
            options: (0, (/*@__PURE__*/$parcel$interopDefault($lyOYo)))([
                ...hydratedValues.issuetype.options,
                ...initialData.issuetype.options
            ], ({ value: value })=>value)
        },
        status: {
            totalCount: initialData.status.totalCount,
            options: (0, (/*@__PURE__*/$parcel$interopDefault($lyOYo)))([
                ...hydratedValues.status.options,
                ...initialData.status.options
            ], ({ value: value })=>value)
        },
        // hydrate values endpoint doesn't support categories
        [(0, $lO4Or.CATEGORY_TYPE)]: initialData[0, $lO4Or.CATEGORY_TYPE],
        [(0, $lO4Or.SPRINT_TYPE)]: {
            totalCount: initialData[0, $lO4Or.SPRINT_TYPE].totalCount,
            options: (0, (/*@__PURE__*/$parcel$interopDefault($lyOYo)))([
                ...hydratedValues[0, $lO4Or.SPRINT_TYPE].options,
                ...initialData[0, $lO4Or.SPRINT_TYPE].options
            ], ({ value: value })=>value)
        },
        [(0, $lO4Or.FIX_VERSIONS_TYPE)]: {
            totalCount: initialData[0, $lO4Or.FIX_VERSIONS_TYPE]?.totalCount || 0,
            options: (0, (/*@__PURE__*/$parcel$interopDefault($lyOYo)))([
                ...hydratedValues[0, $lO4Or.FIX_VERSIONS_TYPE]?.options || [],
                ...initialData[0, $lO4Or.FIX_VERSIONS_TYPE]?.options || []
            ], ({ value: value })=>value)
        },
        [(0, $lO4Or.PARENT_FIELD_TYPE)]: {
            totalCount: initialData[0, $lO4Or.PARENT_FIELD_TYPE]?.totalCount || 0,
            options: (0, (/*@__PURE__*/$parcel$interopDefault($lyOYo)))([
                ...hydratedValues[0, $lO4Or.PARENT_FIELD_TYPE]?.options || [],
                ...initialData[0, $lO4Or.PARENT_FIELD_TYPE]?.options || []
            ], ({ value: value })=>value)
        },
        [(0, $lO4Or.GOALS_CF_TYPE)]: {
            totalCount: initialData[0, $lO4Or.GOALS_CF_TYPE]?.totalCount || 0,
            options: (0, (/*@__PURE__*/$parcel$interopDefault($lyOYo)))([
                ...hydratedValues[0, $lO4Or.GOALS_CF_TYPE]?.options || [],
                ...initialData[0, $lO4Or.GOALS_CF_TYPE]?.options || []
            ], ({ value: value })=>value)
        },
        [(0, $lO4Or.TEAMS_PLATFORM_CF_TYPE)]: {
            totalCount: initialData[0, $lO4Or.TEAMS_PLATFORM_CF_TYPE]?.totalCount || 0,
            options: (0, (/*@__PURE__*/$parcel$interopDefault($lyOYo)))([
                ...hydratedValues[0, $lO4Or.TEAMS_PLATFORM_CF_TYPE]?.options || [],
                ...initialData[0, $lO4Or.TEAMS_PLATFORM_CF_TYPE]?.options || []
            ], ({ value: value })=>value)
        }
    });

});

const $8d92abf0af87bfd8$var$FIELD_VALUE_NODE_FRAGMENT = `
fragment FieldValueNodeFragment on JiraJqlFieldValue {
    jqlTerm
    displayName
    ... on JiraJqlUserFieldValue {
        user {
            picture
        }
    }
    ... on JiraJqlPriorityFieldValue {
        priority {
            iconUrl
        }
    }
    ... on JiraJqlIssueTypeFieldValue {
        issueTypes {
            issueTypeId
            avatar {
                medium
            }
            hierarchy {
                level
            }
        }
    }
    ... on JiraJqlStatusFieldValue {
        statusCategory {
            statusCategoryId
        }
    }
    ... on JiraJqlSprintFieldValue {
        sprint {
            sprintId
            name
        }
    }
    ... on JiraJqlGoalsFieldValue {
        goal {
            name
            status
        }
    }
    ... on JiraJqlIssueFieldValue {
        issue {
            fieldsByIdOrAlias(idsOrAliases: ["issuetype"]) {
                ... on JiraIssueTypeField {
                    issueType {
                        avatar {
                            medium
                        }
                    }
                }
            }
        }
    }
}
`;
const $8d92abf0af87bfd8$var$CATEGORY_CONNECTION_FRAGMENT = `
fragment CategoryConnection on JiraWorkManagementCategoryOptionConnection {
    edges {
        cursor
        node {
            option {
              value
            }
            color
        }
    }
    totalCount
}
`;
const $8d92abf0af87bfd8$export$a48313dd44fc9855 = `
query JwmInitialFilterValues($cloudId: ID!, $first: Int, $jql: String!, $shouldFetchSprints: Boolean = false, $shouldFetchSoftwareFields: Boolean = false, $sprintsJqlContext: String, $goalsJqlTerm: String!, $shouldFetchGoalsField: Boolean = false, $shouldFetchParentField: Boolean = false) {
    jira {
        jqlBuilder(cloudId: $cloudId) {
            labels: fieldValues(
                first: $first
                jqlTerm: "labels"
                jqlContext: $jql
                viewContext: JWM
            ) {
                edges {
                    cursor
                    node {
                        ...FieldValueNodeFragment
                    }
                }
                totalCount
            }
            components: fieldValues(
                first: $first
                jqlTerm: "component"
                jqlContext: $jql
                viewContext: JWM
            ) {
                edges {
                    cursor
                    node {
                        ...FieldValueNodeFragment
                    }
                }
                totalCount
            }
            priority: fieldValues(
                first: $first
                jqlTerm: "priority"
                jqlContext: $jql
                viewContext: JWM
            ) {
                edges {
                    cursor
                    node {
                        ...FieldValueNodeFragment
                    }
                }
                totalCount
            }
            users: fieldValues(
                first: $first
                jqlTerm: "assignee"
                jqlContext: $jql
                viewContext: JWM
            ) {
                edges {
                    cursor
                    node {
                        ...FieldValueNodeFragment
                    }
                }
                totalCount
            }
            recentlyUsedUsers(
                first: $first
            ) {
                edges {
                    cursor
                    node {
                        ...FieldValueNodeFragment
                    }
                }
                totalCount
            }
            issuetype: fieldValues(
                first: $first
                jqlTerm: "issuetype"
                jqlContext: $jql
                viewContext: JWM
            ) {
                edges {
                     cursor
                    node {
                        ...FieldValueNodeFragment
                    }
                }
                totalCount
            }
            status: fieldValues(
                first: $first
                jqlTerm: "status"
                jqlContext: $jql
                viewContext: JWM
            ) {
                edges {
                    cursor
                    node {
                        ...FieldValueNodeFragment
                    }
                }
                totalCount
            }
            sprints: fieldValues(
                first: $first
                jqlTerm: "sprint"
                jqlContext: $sprintsJqlContext
                viewContext: JSW
            ) @include(if: $shouldFetchSprints) {
                edges {
                    cursor
                    node {
                        ...FieldValueNodeFragment
                    }
                }
                totalCount
            }
            fixVersions: fieldValues(
                first: $first
                jqlTerm: "fixVersion"
                jqlContext: $jql
                viewContext: JWM
            ) @include(if: $shouldFetchSoftwareFields) {
                edges {
                    cursor
                    node {
                        ...FieldValueNodeFragment
                    }
                }
                totalCount
            }
            parent: fieldValues(
                first: $first
                jqlTerm: "parent"
                jqlContext: $jql
                viewContext: JSW
            ) @include(if: $shouldFetchParentField) {
                edges {
                    cursor
                    node {
                        ...FieldValueNodeFragment
                    }
                }
                totalCount
            }

            goals: fieldValues(
                first: $first
                jqlTerm: $goalsJqlTerm
                jqlContext: $jql
                viewContext: JWM
            ) @include(if: $shouldFetchGoalsField) {
                edges {
                    cursor
                    node {
                        ...FieldValueNodeFragment
                    }
                }
                totalCount
            }
        }
        jwmCategoryOptions(jqlContext: $jql, first: $first) {
            ...CategoryConnection
        }
    }
}
${$8d92abf0af87bfd8$var$FIELD_VALUE_NODE_FRAGMENT}
${$8d92abf0af87bfd8$var$CATEGORY_CONNECTION_FRAGMENT}
`;
const $8d92abf0af87bfd8$export$f8e8a5f34f6ea725 = `
query JwmSearchFilterValues($cloudId: ID!, $first: Int, $jqlTerm: String!, $jql: String!, $searchString: String, $after: String) {
    jira {
        jqlBuilder(cloudId: $cloudId) {
            fieldValues(
                first: $first
                jqlTerm: $jqlTerm
                jqlContext: $jql
                searchString: $searchString
                after: $after
                viewContext: JWM
            ) {
                edges {
                    cursor
                    node {
                        ...FieldValueNodeFragment
                    }
                }
                totalCount
            }
        }
    }
}
${$8d92abf0af87bfd8$var$FIELD_VALUE_NODE_FRAGMENT}
`;
const $8d92abf0af87bfd8$export$562e34ec948f373d = `
query JwmCategorySearchFilterValues($first: Int, $jql: String!, $searchQuery: String, $after: String) {
    jira {       
        jwmCategoryOptions(jqlContext: $jql, first: $first, searchQuery: $searchQuery, after: $after) {
            ...CategoryConnection
        }
    }
}
${$8d92abf0af87bfd8$var$CATEGORY_CONNECTION_FRAGMENT}
`;

parcelRegister("bRzz9", function(module, exports) {

$parcel$export(module.exports, "transformInitialData", () => $26047d310e78058e$export$93219b8691fe49a0);
$parcel$export(module.exports, "fireFieldValuesErrorAnalytics", () => $26047d310e78058e$export$c3c62a63250fc6f8);
$parcel$export(module.exports, "useGoalsJqlTerm", () => $26047d310e78058e$export$674eff5ec8403101);

var $eUqFw = parcelRequire("eUqFw");

var $lyOYo = parcelRequire("lyOYo");

var $guiFP = parcelRequire("guiFP");

var $eI5EY = parcelRequire("eI5EY");

var $lO4Or = parcelRequire("lO4Or");

var $kIODn = parcelRequire("kIODn");
const $26047d310e78058e$var$transformInitialCategories = (data)=>{
    if (data.jira.jwmCategoryOptions?.edges != null && Array.isArray(data.jira.jwmCategoryOptions.edges)) return {
        totalCount: data.jira.jwmCategoryOptions.totalCount,
        options: (0, $kIODn.transformCategories)(data.jira.jwmCategoryOptions)
    };
    return undefined;
};
const $26047d310e78058e$var$transformInitialDataOld = (data)=>{
    const { components: components, issuetype: issuetype, priority: priority, labels: labels, status: status, users: users, recentlyUsedUsers: recentlyUsedUsers, sprints: sprints } = data.jira.jqlBuilder;
    const transformedData = {
        labels: {
            totalCount: 0,
            options: []
        },
        components: {
            totalCount: 0,
            options: []
        },
        priority: {
            totalCount: 0,
            options: []
        },
        users: {
            totalCount: 0,
            options: []
        },
        issuetype: {
            totalCount: 0,
            options: []
        },
        status: {
            totalCount: 0,
            options: []
        },
        [(0, $lO4Or.CATEGORY_TYPE)]: {
            totalCount: 0,
            options: []
        },
        [(0, $lO4Or.SPRINT_TYPE)]: {
            totalCount: 0,
            options: []
        }
    };
    if (components?.edges != null && Array.isArray(components.edges)) transformedData.components = {
        totalCount: components.totalCount,
        options: (0, $kIODn.transformDefaultField)(components)
    };
    if (issuetype?.edges != null && Array.isArray(issuetype.edges)) transformedData.issuetype = {
        totalCount: issuetype.totalCount,
        options: (0, $kIODn.transformIssueTypes)(issuetype)
    };
    if (priority?.edges != null && Array.isArray(priority.edges)) transformedData.priority = {
        totalCount: priority.totalCount,
        options: (0, $kIODn.transformPriorities)(priority)
    };
    if (labels?.edges != null && Array.isArray(labels.edges)) transformedData.labels = {
        totalCount: labels.totalCount,
        options: (0, $kIODn.transformDefaultField)(labels)
    };
    if (status?.edges != null && Array.isArray(status.edges)) transformedData.status = {
        totalCount: status.totalCount,
        options: (0, $kIODn.transformStatuses)(status)
    };
    if (users?.edges != null && Array.isArray(users.edges)) {
        const usersData = (0, $kIODn.transformUsers)(users);
        const recentlyUsedUsersData = recentlyUsedUsers?.edges != null && Array.isArray(recentlyUsedUsers.edges) ? (0, $kIODn.transformUsers)(recentlyUsedUsers) : null;
        transformedData.users = {
            totalCount: users.totalCount,
            options: // combine `recentlyUsedUsers` and `users` options to improve relevancy of the users field
            recentlyUsedUsersData != null ? (0, (/*@__PURE__*/$parcel$interopDefault($lyOYo)))([
                ...recentlyUsedUsersData,
                ...usersData
            ], ({ value: value })=>value) : usersData
        };
    }
    const categories = $26047d310e78058e$var$transformInitialCategories(data);
    if (categories) transformedData[0, $lO4Or.CATEGORY_TYPE] = categories;
    if (sprints?.edges != null && Array.isArray(sprints.edges)) transformedData[0, $lO4Or.SPRINT_TYPE] = {
        options: (0, $kIODn.transformSprints)(sprints),
        totalCount: sprints.totalCount
    };
    return transformedData;
};
const $26047d310e78058e$export$93219b8691fe49a0 = (data)=>{
    if ((0, $eI5EY.fg)('jsw_list_view_-_all_the_fields')) {
        const transformedData = (0, $kIODn.transformValuesData)(data.jira.jqlBuilder);
        const categories = $26047d310e78058e$var$transformInitialCategories(data);
        if (categories) transformedData[0, $lO4Or.CATEGORY_TYPE] = categories;
        return transformedData;
    }
    return $26047d310e78058e$var$transformInitialDataOld(data);
};
const $26047d310e78058e$export$c3c62a63250fc6f8 = (errorId, errorMessage, // eslint-disable-next-line @typescript-eslint/no-explicit-any
error)=>{
    (0, $guiFP.default)({
        meta: {
            id: errorId,
            packageName: 'jiraBusinessFilters',
            teamName: 'wanjel'
        },
        attributes: {
            message: errorMessage
        },
        error: error,
        sendToPrivacyUnsafeSplunk: true
    });
};
const $26047d310e78058e$export$674eff5ec8403101 = (filterFields)=>{
    const goalsJqlTerm = (0, $eUqFw.useMemo)(()=>filterFields?.find((field)=>field?.type === (0, $lO4Or.GOALS_CF_TYPE))?.id, [
        filterFields
    ]);
    return goalsJqlTerm;
};

});


parcelRegister("bPRqC", function(module, exports) {

$parcel$export(module.exports, "useFieldConfig", () => $527c6b4310270d47$export$70da50df1be2dbe1);

var $eUqFw = parcelRequire("eUqFw");

var $lyOYo = parcelRequire("lyOYo");

var $jGcn0 = parcelRequire("jGcn0");

var $35jYz = parcelRequire("35jYz");
var $gEmpR = parcelRequire("gEmpR");

var $ihkPC = parcelRequire("ihkPC");

var $fP7qq = parcelRequire("fP7qq");

var $e20I1 = parcelRequire("e20I1");

var $guiFP = parcelRequire("guiFP");

var $2OdyW = parcelRequire("2OdyW");

var $5JgJ2 = parcelRequire("5JgJ2");

var $lO4Or = parcelRequire("lO4Or");

var $kJlBc = parcelRequire("kJlBc");

var $dWLk9 = parcelRequire("dWLk9");

var $gF4D9 = parcelRequire("gF4D9");

var $5IIOI = parcelRequire("5IIOI");

var $a75Ge = parcelRequire("a75Ge");

var $7G14t = parcelRequire("7G14t");

var $ijEQD = parcelRequire("ijEQD");
const $527c6b4310270d47$var$MAX_NUMBER_OF_OPTIONS = 10;
const $527c6b4310270d47$var$useFilterMapper = true;
const $527c6b4310270d47$var$EMPTY_ARRAY = [];
const $527c6b4310270d47$var$EMPTY_USER_ARRAY = [];
const $527c6b4310270d47$var$EMPTY_COMPONENT_ARRAY = [];
const $527c6b4310270d47$var$EMPTY_CATEGORY_ARRAY = [];
const $527c6b4310270d47$export$1fe8227c57fa0d68 = ()=>({
        initialUsers: {
            data: $527c6b4310270d47$var$EMPTY_USER_ARRAY,
            isLoading: false
        },
        initialLabels: {
            data: $527c6b4310270d47$var$EMPTY_ARRAY,
            isLoading: false
        },
        initialComponents: {
            data: $527c6b4310270d47$var$EMPTY_COMPONENT_ARRAY,
            isLoading: false
        },
        initialCategories: {
            data: $527c6b4310270d47$var$EMPTY_CATEGORY_ARRAY,
            isLoading: false
        },
        projectKey: null
    });
const $527c6b4310270d47$export$74cea4b24a6bc9fa = $527c6b4310270d47$export$1fe8227c57fa0d68();
const $527c6b4310270d47$var$useForceUpdate = ()=>{
    const [, setValue] = (0, $eUqFw.useState)(0);
    return (0, $eUqFw.useCallback)(()=>setValue((value)=>value + 1), []);
};
const $527c6b4310270d47$export$70da50df1be2dbe1 = ({ allowedFieldTypes: allowedFieldTypes, allowedAliasFieldId: allowedAliasFieldId })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [userResolver] = (0, $eUqFw.useState)(new (0, $e20I1.UserResolver)());
    const forceUpdate = $527c6b4310270d47$var$useForceUpdate();
    // this is used to check whether the hook is still mounted by the time we call fireErrorAnalytics
    // see JET-2324
    const mounted = (0, $eUqFw.useRef)(true);
    const [priorityFieldConfig] = (0, $35jYz.useIssueTypeFieldConfig)({
        screen: 'VIEW',
        issueTypeId: 'default',
        fieldId: 'priority'
    });
    const { data: issueTypeData } = (0, $gEmpR.useIssueTypesAndFields)({
        issueOperation: 'VIEW'
    });
    const formattedCategoryOptions = (0, $eUqFw.useMemo)(()=>{
        const categoryOptions = issueTypeData.fields.find((field)=>field.type === (0, $lO4Or.CATEGORY_TYPE))?.fieldConfig?.selectOptions ?? [];
        return categoryOptions.map(({ value: value })=>({
                label: value,
                value: value
            }));
    }, [
        issueTypeData
    ]);
    const { statuses: statuses, loading: loadingStatuses } = (0, $a75Ge.useProjectStatuses)();
    const [{ match: { params: { projectKey: projectKey } } }] = (0, $kJlBc.useRouter)();
    const cloudId = (0, $dWLk9.useCloudId)();
    const [jqlURLParam] = (0, $kJlBc.useQueryParam)((0, $jGcn0.FILTER_PARAM));
    const jqlURLParamRef = (0, $eUqFw.useRef)(jqlURLParam);
    const hydratedUsers = (0, $eUqFw.useRef)(null);
    const fetchInitialUsers = (0, $eUqFw.useCallback)(async ()=>{
        $527c6b4310270d47$export$74cea4b24a6bc9fa.initialUsers.isLoading = true;
        let users = [];
        const hydratedValues = jqlURLParamRef.current ? await (0, $gF4D9.hydrateFilterValues)(cloudId, jqlURLParamRef.current) : null;
        if (hydratedValues !== null) {
            const transformedHydratedValues = (0, $5IIOI.transformHydratedValues)(hydratedValues);
            hydratedUsers.current = transformedHydratedValues.users.options;
        }
        const url = `/rest/api/3/user/search?maxResults=${$527c6b4310270d47$var$MAX_NUMBER_OF_OPTIONS}&query=`;
        users = await (0, $2OdyW.default)(url);
        $527c6b4310270d47$export$74cea4b24a6bc9fa.initialUsers = {
            data: users,
            isLoading: false
        };
        forceUpdate();
        return users;
    }, [
        cloudId,
        forceUpdate
    ]);
    const fetchInitialLabels = (0, $eUqFw.useCallback)(async ()=>{
        const url = `/rest/api/3/label?maxResults=${$527c6b4310270d47$var$MAX_NUMBER_OF_OPTIONS}`;
        try {
            $527c6b4310270d47$export$74cea4b24a6bc9fa.initialLabels.isLoading = true;
            const response = await (0, $2OdyW.default)(url);
            const labels = response.values;
            $527c6b4310270d47$export$74cea4b24a6bc9fa.initialLabels = {
                data: labels,
                isLoading: false
            };
            forceUpdate();
            return labels;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            (0, $guiFP.default)({
                meta: {
                    id: 'fetchFilterInitialLabels',
                    packageName: 'jiraBusinessFilters',
                    teamName: 'wanjel'
                },
                attributes: {
                    message: 'Failed to fetch initial labels',
                    errorType: (0, $ihkPC.getErrorType)(err),
                    online: window.navigator.onLine,
                    mounted: mounted.current
                },
                error: err,
                sendToPrivacyUnsafeSplunk: true
            });
        }
        $527c6b4310270d47$export$74cea4b24a6bc9fa.initialLabels = {
            data: $527c6b4310270d47$var$EMPTY_ARRAY,
            isLoading: false
        };
        forceUpdate();
        return $527c6b4310270d47$var$EMPTY_ARRAY;
    }, [
        forceUpdate
    ]);
    const fetchUsers = (0, $eUqFw.useCallback)(async (query = '')=>{
        if (projectKey != null) {
            const url = `/rest/api/2/user/assignable/search?project=${projectKey}&maxResults=${$527c6b4310270d47$var$MAX_NUMBER_OF_OPTIONS}&query=${query}`;
            try {
                const response = await (0, $2OdyW.default)(url);
                return response;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (err) {
                (0, $guiFP.default)({
                    meta: {
                        id: 'searchFilterUsers',
                        packageName: 'jiraBusinessFilters',
                        teamName: 'wanjel'
                    },
                    attributes: {
                        message: 'Failed to search users',
                        errorType: (0, $ihkPC.getErrorType)(err),
                        online: window.navigator.onLine,
                        mounted: mounted.current
                    },
                    error: err,
                    sendToPrivacyUnsafeSplunk: true
                });
            }
        }
        return $527c6b4310270d47$var$EMPTY_USER_ARRAY;
    }, [
        projectKey
    ]);
    const fetchProjectComponents = (0, $eUqFw.useCallback)(async (query = '')=>{
        if (projectKey != null) try {
            const response = await (0, $fP7qq.fetchComponents)({
                inputValue: query,
                autoCompleteUrl: `/rest/api/3/project/${projectKey}/component`,
                useFilterMapper: $527c6b4310270d47$var$useFilterMapper,
                mounted: mounted.current
            });
            return response;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            (0, $guiFP.default)({
                meta: {
                    id: 'fetchFilterComponents',
                    packageName: 'jiraBusinessFilters',
                    teamName: 'wanjel'
                },
                attributes: {
                    message: 'Failed to fetch components',
                    errorType: (0, $ihkPC.getErrorType)(err),
                    online: window.navigator.onLine,
                    mounted: mounted.current
                },
                error: err,
                sendToPrivacyUnsafeSplunk: true
            });
        }
        return [];
    }, [
        projectKey
    ]);
    const fetchLabels = (0, $eUqFw.useCallback)((query = '')=>(0, $2OdyW.default)(`/rest/api/1.0/labels/suggest?query=${query}`).catch((err)=>{
            (0, $guiFP.default)({
                meta: {
                    id: 'searchFilterLabels',
                    packageName: 'jiraBusinessFilters',
                    teamName: 'wanjel'
                },
                attributes: {
                    message: 'Failed to search labels',
                    errorType: (0, $ihkPC.getErrorType)(err),
                    online: window.navigator.onLine,
                    mounted: mounted.current
                },
                error: err,
                sendToPrivacyUnsafeSplunk: true
            });
        }), []);
    const fetchProjectCategories = (0, $eUqFw.useCallback)((query = '')=>{
        // TODO Replace with back end fetch API
        const filteredCategoriesQuery = formattedCategoryOptions?.filter((categoryOption)=>categoryOption.label.toLowerCase().startsWith(query.toLowerCase()));
        return Promise.resolve(filteredCategoriesQuery ?? []);
    }, [
        formattedCategoryOptions
    ]);
    const { fetch: fetchInitialStoryPointsData, data: initialStoryPoints, loading: loadingStoryPoints } = (0, $7G14t.useGroupItemValues)({
        groupFieldId: (0, $jGcn0.STORY_POINTS_ALIAS_FIELD_ID)
    });
    const { fetch: fetchInitialStoryPointsEstimateData, data: initialStoryPointsEstimate, loading: loadingStoryPointsEstimate } = (0, $7G14t.useGroupItemValues)({
        groupFieldId: (0, $jGcn0.STORY_POINT_ESTIMATE_ALIAS_FIELD_ID)
    });
    (0, $eUqFw.useEffect)(()=>{
        if (allowedAliasFieldId != null && allowedAliasFieldId.has((0, $jGcn0.STORY_POINTS_ALIAS_FIELD_ID))) fetchInitialStoryPointsData();
    }, [
        allowedAliasFieldId,
        fetchInitialStoryPointsData
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (allowedAliasFieldId != null && allowedAliasFieldId.has((0, $jGcn0.STORY_POINT_ESTIMATE_ALIAS_FIELD_ID))) fetchInitialStoryPointsEstimateData();
    }, [
        allowedAliasFieldId,
        fetchInitialStoryPointsEstimateData
    ]);
    (0, $eUqFw.useEffect)(()=>()=>{
            mounted.current = false;
        }, []);
    (0, $eUqFw.useEffect)(()=>{
        if (projectKey != null && // Initially fetch for everything if projectKey is updated or users is empty
        ($527c6b4310270d47$export$74cea4b24a6bc9fa.projectKey !== projectKey || $527c6b4310270d47$export$74cea4b24a6bc9fa.initialUsers.data === $527c6b4310270d47$var$EMPTY_USER_ARRAY)) {
            if ($527c6b4310270d47$export$74cea4b24a6bc9fa.initialUsers.isLoading === false) {
                $527c6b4310270d47$export$74cea4b24a6bc9fa.projectKey = projectKey;
                fetchInitialUsers();
            }
        }
    }, [
        fetchInitialUsers,
        fetchProjectComponents,
        projectKey,
        fetchInitialLabels,
        fetchProjectCategories,
        forceUpdate
    ]);
    const { data: initialUsers, isLoading: isLoadingUsers } = $527c6b4310270d47$export$74cea4b24a6bc9fa.initialUsers;
    const { data: initialLabels, isLoading: isLoadingLabels } = $527c6b4310270d47$export$74cea4b24a6bc9fa.initialLabels;
    const { data: initialComponents, isLoading: isLoadingComponents } = $527c6b4310270d47$export$74cea4b24a6bc9fa.initialComponents;
    const { data: initialCategories, isLoading: isLoadingCategories } = $527c6b4310270d47$export$74cea4b24a6bc9fa.initialCategories;
    const fieldOptionsData = (0, $eUqFw.useMemo)(()=>({
            priority: (0, $ijEQD.transformPriority)(priorityFieldConfig),
            issuetype: (0, $ijEQD.transformIssueType)(issueTypeData),
            status: (0, $ijEQD.transformStatuses)(statuses),
            users: (0, $ijEQD.transformUsers)(initialUsers),
            labels: (0, $ijEQD.transformLabels)(initialLabels),
            components: initialComponents,
            [(0, $lO4Or.CATEGORY_TYPE)]: initialCategories,
            [(0, $jGcn0.STORY_POINTS_ALIAS_FIELD_ID)]: initialStoryPoints?.options || [],
            [(0, $jGcn0.STORY_POINT_ESTIMATE_ALIAS_FIELD_ID)]: initialStoryPointsEstimate?.options || []
        }), [
        priorityFieldConfig,
        issueTypeData,
        statuses,
        initialUsers,
        initialLabels,
        initialComponents,
        initialCategories,
        initialStoryPoints?.options,
        initialStoryPointsEstimate?.options
    ]);
    fieldOptionsData.users = (0, $eUqFw.useMemo)(()=>{
        if (hydratedUsers.current === null) return fieldOptionsData.users;
        return (0, (/*@__PURE__*/$parcel$interopDefault($lyOYo)))([
            ...hydratedUsers.current ?? [],
            ...fieldOptionsData.users ?? []
        ], ({ value: value })=>value);
    }, [
        fieldOptionsData
    ]);
    const { fieldConfig: fieldConfig, resolvers: resolvers } = (0, $ijEQD.getFilterFieldConfigAndResolvers)({
        formatMessage: formatMessage,
        allowedFieldTypes: allowedFieldTypes,
        allowedAliasFieldId: allowedAliasFieldId,
        allFields: issueTypeData.fields,
        fieldOptionsData: fieldOptionsData,
        fetchUsers: (query)=>fetchUsers(query).then((users)=>(0, $ijEQD.transformUsers)(users || [])),
        fetchLabels: (query)=>fetchLabels(query).then((labels)=>labels ? (0, $ijEQD.transformLabelSuggestions)(labels) : []),
        fetchComponents: (query)=>fetchProjectComponents(query).then((components)=>components),
        fetchCategories: (query)=>fetchProjectCategories(query).then((categoriesResponse)=>categoriesResponse),
        userResolver: userResolver
    });
    const fetching = isLoadingUsers || isLoadingLabels || isLoadingComponents || isLoadingCategories || loadingStoryPoints || loadingStoryPointsEstimate;
    return {
        fieldConfig: fieldConfig,
        resolvers: resolvers,
        loading: loadingStatuses || fetching
    };
};

});
parcelRegister("ihkPC", function(module, exports) {

$parcel$export(module.exports, "getErrorType", () => $348eddd0ac284a22$export$e19f9f08a6d79fd2);

var $7byHA = parcelRequire("7byHA");
const $348eddd0ac284a22$export$7453182ebe5973d4 = 'APOLLO_NETWORK_ERROR';
const $348eddd0ac284a22$export$9705762bba4e9e25 = 'NULL_OR_UNDEFINED';
const $348eddd0ac284a22$export$d46a05f8561f868a = 'OTHER';
const $348eddd0ac284a22$export$c748438cec453c9f = {
    FAILED_TO_FETCH: 'Failed to fetch',
    NETWORK_ERROR: 'NetworkError when attempting to fetch resource.',
    NETWORK_REQUEST_FAILED: 'Network request failed',
    NETWORK_CONNECTION_LOST: 'The network connection was lost.',
    NETWORK_CONNECTION_ERROR: 'upstream connect error or disconnect/reset before headers. reset reason: connection',
    UNEXPECTED_ERROR_OCCURRED: 'Response ended with an error message: An unexpected error occurred',
    ABORTED: 'operation was aborted.',
    CANCELLED: 'cancelled',
    TIMEOUT: 'The request timed out.'
};
const $348eddd0ac284a22$var$isApolloClientNetworkError = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
error)=>error.networkError !== undefined && error.networkError !== null;
const $348eddd0ac284a22$export$e19f9f08a6d79fd2 = (error)=>{
    if (error == null) return $348eddd0ac284a22$export$9705762bba4e9e25;
    const message = String(error instanceof Error ? error.message : error).trim();
    if (error instanceof (0, $7byHA.default)) {
        const { statusCode: statusCode } = error;
        if (statusCode) return `FETCH_ERROR_${statusCode}`;
    }
    if ($348eddd0ac284a22$var$isApolloClientNetworkError(error)) return $348eddd0ac284a22$export$7453182ebe5973d4;
    const entry = Object.entries($348eddd0ac284a22$export$c748438cec453c9f).find((arrayItem)=>String(arrayItem[1]).toLowerCase() === message.toLowerCase());
    return entry ? entry[0] : $348eddd0ac284a22$export$d46a05f8561f868a;
};

});

parcelRegister("fP7qq", function(module, exports) {

$parcel$export(module.exports, "fetchComponents", () => $9fb5f20e4a6bfa39$export$4f703ddb7c8cc5b3);
$parcel$export(module.exports, "mapComponentsToOptions", () => (parcelRequire("a9hW2")).mapComponentsToOptions);

var $53ciZ = parcelRequire("53ciZ");

var $ihkPC = parcelRequire("ihkPC");

var $guiFP = parcelRequire("guiFP");

var $1ybV0 = parcelRequire("1ybV0");

var $lRmyA = parcelRequire("lRmyA");

var $a9hW2 = parcelRequire("a9hW2");
const $9fb5f20e4a6bfa39$export$4f703ddb7c8cc5b3 = ({ inputValue: inputValue, autoCompleteUrl: autoCompleteUrl, useFilterMapper: useFilterMapper, mounted: mounted, queryParameters: queryParameters })=>{
    const mapperFunction = useFilterMapper === true ? (0, $a9hW2.mapComponentsToFilterOptions) : (0, $a9hW2.mapComponentsToOptions);
    const query = (0, $1ybV0.ff)('jira.list.field-support-part1') ? (0, (/*@__PURE__*/$parcel$interopDefault($53ciZ))).stringify({
        query: inputValue,
        ...queryParameters
    }) : (0, (/*@__PURE__*/$parcel$interopDefault($53ciZ))).stringify({
        query: inputValue
    });
    return (0, $lRmyA.performGetRequest)(`${autoCompleteUrl}?${query}`).then((response)=>mapperFunction(response.values)).catch((error)=>{
        (0, $guiFP.default)({
            meta: {
                id: 'fetchProjectComponents',
                packageName: 'jiraBusinessFetchComponents',
                teamName: 'wanjel'
            },
            attributes: {
                message: 'Failed to fetch jwm project components',
                errorType: (0, $ihkPC.getErrorType)(error),
                online: window.navigator.onLine,
                mounted: mounted
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
        throw error;
    });
};

});
parcelRegister("a9hW2", function(module, exports) {

$parcel$export(module.exports, "mapComponentsToOptions", () => $c0b17925cb48a958$export$85e44418187c2c1e);
$parcel$export(module.exports, "mapComponentsToFilterOptions", () => $c0b17925cb48a958$export$b4ef58d3e943e4d5);
const $c0b17925cb48a958$export$85e44418187c2c1e = (components)=>components.map(({ id: id, componentId: componentId, name: name })=>({
            label: name,
            value: componentId !== undefined ? String(componentId) : String(id)
        }));
const $c0b17925cb48a958$export$b4ef58d3e943e4d5 = (components)=>components.map(({ name: name })=>({
            label: name,
            value: name
        }));

});


parcelRegister("e20I1", function(module, exports) {

$parcel$export(module.exports, "UserResolver", () => $2f3c56b3440530f6$export$723df28d03868f02);

var $gUUjF = parcelRequire("gUUjF");

var $2OdyW = parcelRequire("2OdyW");
class $2f3c56b3440530f6$export$723df28d03868f02 {
    constructor(){
        // eslint-disable-next-line @typescript-eslint/no-invalid-void-type
        this.getUsersFromAccountId = (accountIds)=>{
            const recoveredFromCache = [];
            const missingFromCache = [];
            accountIds.forEach((accountId)=>{
                const user = this.cache.get(accountId);
                if (user) recoveredFromCache.push(user);
                else missingFromCache.push(accountId);
            });
            if (missingFromCache.length === 0) // @ts-expect-error - User is not assignable to type 'string'
            return Promise.resolve(recoveredFromCache);
            return (0, $2OdyW.default)(`/rest/api/2/user/bulk?maxResults=10&${missingFromCache.map((accountId)=>`accountId=${accountId}`).join('&')}`).then((response)=>response && response.values.length > 0 && // @ts-expect-error - TS2339 - Property 'forEach' does not exist on type '() => IterableIterator<Readonly<Partial<Diff<ResponseSuccess, Record<any, any>>> & { accountId: string | null; displayName: string; avatarUrls: { readonly "48x48"?: string | undefined; readonly "32x32"?: string | undefined; readonly "24x24"?: string | undefined; readonly "16x16"?: string | undefined; }; }>>'. | TS7006 - Parameter 'user' implicitly has an 'any' type.
                response.values.forEach((user)=>{
                    if (user) this.cache.set(user.accountId, user);
                })).then(()=>this.getUsersFromAccountId(accountIds)).catch((err)=>{
                (0, $gUUjF.default).safeErrorWithoutCustomerData('jwm.services.get-users', 'Failed to fetch users', err);
            });
        };
        this.cache = new Map();
    }
}

});

parcelRegister("7G14t", function(module, exports) {

$parcel$export(module.exports, "useGroupItemValues", () => $f05aa0c8a487bc66$export$f05af123f98299b0);

var $eUqFw = parcelRequire("eUqFw");

var $NFHn0 = parcelRequire("NFHn0");

var $eZbpk = parcelRequire("eZbpk");

var $dlVOn = parcelRequire("dlVOn");

var $5JgJ2 = parcelRequire("5JgJ2");

var $lKPnc = parcelRequire("lKPnc");

var $fOoev = parcelRequire("fOoev");
const $f05aa0c8a487bc66$var$reducer = (state, action)=>{
    switch(action.type){
        case 'loading':
            return {
                loading: true
            };
        case 'success':
            return {
                loading: false,
                data: action.payload
            };
        case 'error':
            return {
                loading: false,
                data: null
            };
        default:
            return state;
    }
};
const $f05aa0c8a487bc66$export$f05af123f98299b0 = ({ groupFieldId: groupFieldId })=>{
    const [state, dispatch] = (0, $eUqFw.useReducer)($f05aa0c8a487bc66$var$reducer, {
        loading: false
    });
    const jqlContext = (0, $eZbpk.useJqlContext)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const fetchDataAbortable = (0, $NFHn0.useAbortable)((0, $lKPnc.fetchGroupItemValues));
    const fetch = (0, $eUqFw.useCallback)(async ()=>{
        try {
            dispatch({
                type: 'loading'
            });
            const response = await fetchDataAbortable(groupFieldId, jqlContext);
            if (response.data?.items == null) throw new (0, $dlVOn.GraphQLErrors)(response.errors);
            dispatch({
                type: 'success',
                payload: (0, $fOoev.transformInitialData)({
                    data: response.data,
                    formatMessage: formatMessage
                })
            });
        } catch (error) {
            if (error === (0, $NFHn0.ABORTED)) return;
            dispatch({
                type: 'error'
            });
        }
    }, [
        fetchDataAbortable,
        formatMessage,
        groupFieldId,
        jqlContext
    ]);
    return {
        fetch: fetch,
        data: state.data,
        loading: state.loading
    };
};

});
parcelRegister("NFHn0", function(module, exports) {

$parcel$export(module.exports, "ABORTED", () => $f9f77c4f962e82bc$export$23e29024ea698a35);
$parcel$export(module.exports, "useAbortable", () => $f9f77c4f962e82bc$export$a487c7eb4387f959);
/* eslint-disable @typescript-eslint/no-explicit-any */ 
var $eUqFw = parcelRequire("eUqFw");
const $f9f77c4f962e82bc$export$23e29024ea698a35 = Symbol('ABORTED');
const $f9f77c4f962e82bc$export$a487c7eb4387f959 = (fetch)=>{
    const prevControllerRef = (0, $eUqFw.useRef)(null);
    return (0, $eUqFw.useCallback)((...args)=>{
        if (prevControllerRef.current) prevControllerRef.current.abort();
        const controller = new AbortController();
        prevControllerRef.current = controller;
        return fetch(controller.signal, ...args).catch((error)=>{
            if (controller.signal.aborted) throw $f9f77c4f962e82bc$export$23e29024ea698a35;
            else throw error;
        });
    }, [
        fetch
    ]);
};

});

parcelRegister("lKPnc", function(module, exports) {

$parcel$export(module.exports, "fetchGroupItemValues", () => $8489c6f37b087f09$export$7e6e0c3f4468ce45);

var $guiFP = parcelRequire("guiFP");

var $JRB5w = parcelRequire("JRB5w");
var $lRmyA = parcelRequire("lRmyA");

const $8489c6f37b087f09$var$MAX_NUMBER_OF_OPTIONS = 20; // min number to render two rows
const $8489c6f37b087f09$export$7e6e0c3f4468ce45 = async (signal, groupFieldId, jqlContext)=>{
    try {
        const variables = {
            fieldId: groupFieldId,
            first: $8489c6f37b087f09$var$MAX_NUMBER_OF_OPTIONS,
            jql: jqlContext
        };
        const response = await (0, $lRmyA.performPostRequest)('/rest/gira/1/?operation=JWMFilterValuesByGroupItems', {
            body: JSON.stringify({
                query: (0, $622211c2999f2f37$export$a48313dd44fc9855),
                variables: variables
            })
        });
        return response;
    } catch (error) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        if (!(0, $JRB5w.isHttpClientErrorResponse)(error) && !signal.aborted) (0, $guiFP.default)({
            meta: {
                id: 'initializeFilterGroupItemsData',
                packageName: 'jiraBusinessFilters',
                teamName: 'wanjel'
            },
            attributes: {
                message: 'Failed to initialize filter data using the group query'
            },
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
        throw error;
    }
};

});
const $622211c2999f2f37$export$a48313dd44fc9855 = `
query JWMFilterValuesByGroupItems($fieldId: ID!, $jql: String!, $first: Int!) {
  items: jwmItemGroups(jql: $jql, groupByFieldId: $fieldId, fieldIds: [], first: $first) {
    totalCount
    edges {
      node {
        id
        field {
          __typename
          ... on FloatCustomField {
            floatValue
          }
        }
      }
    }
  }
}
`;


parcelRegister("fOoev", function(module, exports) {

$parcel$export(module.exports, "transformInitialData", () => $2b76e62e743cb9ff$export$93219b8691fe49a0);

var $ivaRx = parcelRequire("ivaRx");
const $2b76e62e743cb9ff$export$93219b8691fe49a0 = ({ data: data, formatMessage: formatMessage })=>({
        totalCount: data.items.totalCount,
        options: data.items.edges.map((edge)=>{
            if (edge.node.field.floatValue == null) return {
                value: null,
                label: formatMessage((0, $ivaRx.default).noneOption)
            };
            const stringFloatValue = String(edge.node.field.floatValue);
            return {
                value: stringFloatValue,
                label: stringFloatValue
            };
        })
    });

});
parcelRegister("ivaRx", function(module, exports) {

$parcel$export(module.exports, "default", () => $4dd2394f0a911447$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $4dd2394f0a911447$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    noneOption: {
        "id": "business-filters.controllers.group-item-values.none-option",
        "defaultMessage": "None"
    }
});

});



parcelRegister("ijEQD", function(module, exports) {

$parcel$export(module.exports, "transformPriority", () => $c6e67604bea772f5$export$1b9f55a39456e911);
$parcel$export(module.exports, "transformIssueType", () => $c6e67604bea772f5$export$96520244689f81c1);
$parcel$export(module.exports, "transformStatuses", () => $c6e67604bea772f5$export$20a57a5ec025f2d);
$parcel$export(module.exports, "transformUsers", () => $c6e67604bea772f5$export$fb8c90bfc4beaa59);
$parcel$export(module.exports, "transformLabels", () => $c6e67604bea772f5$export$c072126708d93f04);
$parcel$export(module.exports, "transformLabelSuggestions", () => $c6e67604bea772f5$export$cdfcc40760c1a4f8);
$parcel$export(module.exports, "getFilterFieldConfigAndResolvers", () => $c6e67604bea772f5$export$ba4f3d2149c2bf3b);

var $illlw = parcelRequire("illlw");

var $5iWql = parcelRequire("5iWql");

var $jGcn0 = parcelRequire("jGcn0");

var $lO4Or = parcelRequire("lO4Or");

var $9TEHc = parcelRequire("9TEHc");

var $1run3 = parcelRequire("1run3");

var $dG4cR = parcelRequire("dG4cR");

var $h1vWF = parcelRequire("h1vWF");
const $c6e67604bea772f5$export$1b9f55a39456e911 = (0, $5iWql.default)((priorityFieldConfig)=>[
        ...priorityFieldConfig?.options || []
    ].reduce((acc, next)=>{
        acc.push({
            value: next.name,
            label: next.name,
            avatar: next.iconUrl || ''
        });
        return acc;
    }, []));
const $c6e67604bea772f5$export$96520244689f81c1 = (0, $5iWql.default)((issueTypeData)=>issueTypeData.issueTypes.reduce((acc, next)=>{
        acc.push({
            value: next.id,
            label: next.name,
            id: next.id,
            avatar: next.avatarUrl,
            square: true
        });
        return acc;
    }, []));
const $c6e67604bea772f5$export$20a57a5ec025f2d = (0, $5iWql.default)((statuses)=>statuses.reduce((acc, next)=>{
        acc.push({
            value: next.untranslatedName,
            label: next.name,
            categoryId: next.statusCategory.id,
            // Board needs the status id as number for client side filtering
            id: Number(next.id)
        });
        return acc;
    }, []));
const $c6e67604bea772f5$export$fb8c90bfc4beaa59 = (0, $5iWql.default)((users)=>users.reduce((acc, next)=>{
        acc.push({
            value: next.accountId || '',
            label: next.displayName,
            avatar: (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(next, [
                'avatarUrls',
                '24x24'
            ], '')
        });
        return acc;
    }, []));
const $c6e67604bea772f5$export$c072126708d93f04 = (0, $5iWql.default)((labels)=>labels.reduce((acc, next)=>{
        acc.push({
            value: next || '',
            label: next
        });
        return acc;
    }, []));
const $c6e67604bea772f5$export$cdfcc40760c1a4f8 = (0, $5iWql.default)((labels)=>labels?.suggestions.reduce((acc, next)=>{
        acc.push({
            value: next.label || '',
            label: next.label
        });
        return acc;
    }, []));
const $c6e67604bea772f5$var$getType = ({ type: type })=>{
    switch(type){
        case 0, $lO4Or.PRIORITY_TYPE:
            return (0, $1run3.FieldType).PrioritySelectFilter;
        case 0, $lO4Or.ASSIGNEE_TYPE:
        case 0, $lO4Or.REPORTER_TYPE:
        case 0, $lO4Or.USER_CF_TYPE:
        case 0, $lO4Or.PEOPLE_CF_TYPE:
            return (0, $1run3.FieldType).AvatarAsyncSelectFilter;
        case 0, $lO4Or.ISSUE_TYPE:
            return (0, $1run3.FieldType).AvatarSelectFilter;
        case 0, $lO4Or.STATUS_TYPE:
            return (0, $1run3.FieldType).LozengeSelectFilter;
        case 0, $lO4Or.LABELS_TYPE:
        case 0, $lO4Or.COMPONENTS_TYPE:
        case 0, $lO4Or.SELECT_CF_TYPE:
        case 0, $lO4Or.MULTI_SELECT_CF_TYPE:
            return (0, $1run3.FieldType).AsyncSelectFilter;
        case 0, $lO4Or.CREATED:
        case 0, $lO4Or.UPDATED:
        case 0, $lO4Or.DATE_CF_TYPE:
            return (0, $1run3.FieldType).DateFilter;
        case 0, $lO4Or.CATEGORY_TYPE:
            return (0, $1run3.FieldType).CategorySelectFilter;
        case 0, $lO4Or.NUMBER_CF_TYPE:
        case 0, $lO4Or.STORY_POINT_ESTIMATE_CF_TYPE:
        default:
            return (0, $1run3.FieldType).SelectFilter;
    }
};
const $c6e67604bea772f5$var$getSelectCustomFieldValues = (field)=>(field?.fieldConfig?.selectOptions ?? []).map(({ value: value })=>({
            label: value,
            value: value
        }));
const $c6e67604bea772f5$var$getValues = ({ type: type, fieldOptionsData: fieldOptionsData, field: field, aliasFieldId: aliasFieldId })=>{
    switch(type){
        case 0, $lO4Or.ASSIGNEE_TYPE:
        case 0, $lO4Or.REPORTER_TYPE:
        case 0, $lO4Or.USER_CF_TYPE:
        case 0, $lO4Or.PEOPLE_CF_TYPE:
            return fieldOptionsData.users;
        case 0, $lO4Or.SELECT_CF_TYPE:
        case 0, $lO4Or.MULTI_SELECT_CF_TYPE:
        case 0, $lO4Or.MULTI_CHECKBOXES_CF_TYPE:
            return $c6e67604bea772f5$var$getSelectCustomFieldValues(field);
        case 0, $lO4Or.NUMBER_CF_TYPE:
            if (aliasFieldId === (0, $jGcn0.STORY_POINTS_ALIAS_FIELD_ID)) return fieldOptionsData[0, $jGcn0.STORY_POINTS_ALIAS_FIELD_ID];
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return fieldOptionsData[type];
        case 0, $lO4Or.STORY_POINT_ESTIMATE_CF_TYPE:
            return fieldOptionsData[0, $jGcn0.STORY_POINT_ESTIMATE_ALIAS_FIELD_ID];
        default:
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return fieldOptionsData[type];
    }
};
const $c6e67604bea772f5$var$isUserField = (type)=>{
    switch(type){
        case 0, $lO4Or.ASSIGNEE_TYPE:
        case 0, $lO4Or.REPORTER_TYPE:
        case 0, $lO4Or.USER_CF_TYPE:
        case 0, $lO4Or.PEOPLE_CF_TYPE:
            return true;
        default:
            return false;
    }
};
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
const $c6e67604bea772f5$var$isCustomField = (type)=>(0, $9TEHc.EXTRA_CUSTOM_FIELD_TYPES).has(type);
const $c6e67604bea772f5$var$createUserValueGetter = (userResolver)=>(0, $5iWql.default)((accountIds)=>// @ts-expect-error - TS7006 - Parameter 'response' implicitly has an 'any' type.
        userResolver.getUsersFromAccountId(accountIds).then((response)=>$c6e67604bea772f5$export$fb8c90bfc4beaa59(response)));
const $c6e67604bea772f5$export$ba4f3d2149c2bf3b = ({ formatMessage: formatMessage, allowedFieldTypes: allowedFieldTypes, allowedAliasFieldId: allowedAliasFieldId = new Set(), allFields: allFields, fieldOptionsData: fieldOptionsData, fetchUsers: fetchUsers, fetchLabels: fetchLabels, fetchComponents: fetchComponents, fetchCategories: fetchCategories, userResolver: userResolver })=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const fieldConfig = {};
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const resolvers = {};
    if (allowedFieldTypes.has((0, $9TEHc.DATE_RANGE_TYPE))) // manually add dateRange to fieldConfig
    fieldConfig.dateRange = {
        label: formatMessage((0, $h1vWF.default).dateRangeLabel),
        type: (0, $1run3.FieldType).DateFilter
    };
    const fields = allFields.filter((field)=>allowedFieldTypes.has(field.type ?? '') || allowedAliasFieldId.has(field.aliasFieldId || ''));
    fields.forEach((field)=>{
        const { name: name, type: type, id: id, aliasFieldId: aliasFieldId } = field;
        // if the type is unsupported
        // or it's the start date field (which is handled separately as 'date range')
        // then skip
        if (type == null || aliasFieldId === (0, $jGcn0.START_DATE_ALIAS_FIELD_ID)) return;
        const selectType = $c6e67604bea772f5$var$getType({
            type: type
        });
        fieldConfig[id] = {
            systemType: type,
            label: name,
            type: selectType,
            placeholder: formatMessage((0, $h1vWF.default).filterPlaceholder),
            options: $c6e67604bea772f5$var$getValues({
                type: type,
                fieldOptionsData: fieldOptionsData,
                field: field,
                aliasFieldId: aliasFieldId
            }),
            isCustomField: $c6e67604bea772f5$var$isCustomField(type),
            fieldConfigVersion: 1
        };
        if (aliasFieldId != null && allowedAliasFieldId.has(aliasFieldId)) fieldConfig[id].aliasFieldId = aliasFieldId;
        if (type === (0, $lO4Or.ISSUE_TYPE)) fieldConfig[id].label = formatMessage((0, $h1vWF.default).typeLabel);
        if ($c6e67604bea772f5$var$isUserField(type)) {
            fieldConfig[id].loadOptions = fetchUsers;
            fieldConfig[id].defaultOptions = $c6e67604bea772f5$var$getValues({
                type: type,
                fieldOptionsData: fieldOptionsData
            });
            resolvers[id] = $c6e67604bea772f5$var$createUserValueGetter(userResolver);
            fieldConfig[id].options = [
                ...fieldConfig[id].options,
                {
                    value: 'EMPTY',
                    label: formatMessage((0, $h1vWF.default).unassignedLabel),
                    isEmptyOption: true
                }
            ];
        }
        if (type === (0, $lO4Or.LABELS_TYPE)) {
            fieldConfig[id].loadOptions = fetchLabels;
            fieldConfig[id].defaultOptions = $c6e67604bea772f5$var$getValues({
                type: type,
                fieldOptionsData: fieldOptionsData
            });
        }
        if (type === (0, $lO4Or.COMPONENTS_TYPE)) {
            fieldConfig[id].loadOptions = fetchComponents;
            fieldConfig[id].defaultOptions = $c6e67604bea772f5$var$getValues({
                type: type,
                fieldOptionsData: fieldOptionsData
            });
        }
        if (type === (0, $lO4Or.CATEGORY_TYPE)) {
            fieldConfig[id].loadOptions = fetchCategories;
            fieldConfig[id].defaultOptions = $c6e67604bea772f5$var$getValues({
                type: type,
                fieldOptionsData: fieldOptionsData
            });
        }
        if (type === (0, $lO4Or.SELECT_CF_TYPE) || type === (0, $lO4Or.MULTI_SELECT_CF_TYPE) || type === (0, $lO4Or.MULTI_CHECKBOXES_CF_TYPE)) fieldConfig[id].options = [
            ...fieldConfig[id].options,
            {
                value: (0, $dG4cR.EMPTY_FILTER_VALUE),
                label: formatMessage((0, $h1vWF.default).noneOption),
                isEmptyOption: true
            }
        ];
    });
    return {
        fieldConfig: fieldConfig,
        resolvers: resolvers
    };
};

});
parcelRegister("1run3", function(module, exports) {

$parcel$export(module.exports, "FieldType", () => $0804b64445570a47$export$ed12481c953b8653);
$parcel$export(module.exports, "isDateField", () => $0804b64445570a47$export$7d34c8548269835d);
const $0804b64445570a47$export$ed12481c953b8653 = {
    AsyncSelectFilter: 'AsyncSelectFilter',
    AvatarSelectFilter: 'AvatarSelectFilter',
    AvatarAsyncSelectFilter: 'AvatarAsyncSelectFilter',
    PaginatedAsyncSelectFilter: 'PaginatedAsyncSelectFilter',
    LozengeAsyncSelectFilter: 'LozengeAsyncSelectFilter',
    PaginatedLozengeAsyncSelectFilter: 'PaginatedLozengeAsyncSelectFilter',
    LozengeSelectFilter: 'LozengeSelectFilter',
    PrioritySelectFilter: 'PrioritySelectFilter',
    CategorySelectFilter: 'CategorySelectFilter',
    GoalsSelectFilter: 'GoalsSelectFilter',
    PaginatedAvatarAsyncSelectFilter: 'PaginatedAvatarAsyncSelectFilter',
    NumberFilter: 'NumberFilter',
    SelectFilter: 'SelectFilter',
    SearchFilter: 'SearchFilter',
    TextFilter: 'TextFilter',
    DateFilter: 'DateFilter',
    ProjectFilter: 'ProjectFilter'
};
const $0804b64445570a47$export$7d34c8548269835d = (field)=>field.type === $0804b64445570a47$export$ed12481c953b8653.DateFilter;

});

parcelRegister("h1vWF", function(module, exports) {

$parcel$export(module.exports, "default", () => $e2a86e8a54f0713c$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $e2a86e8a54f0713c$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    filterPlaceholder: {
        "id": "business-filters.controllers.field-config.filter-placeholder",
        "defaultMessage": "Search"
    },
    dateRangeLabel: {
        "id": "business-filters.controllers.field-config.date-range-label",
        "defaultMessage": "Date range"
    },
    typeLabel: {
        "id": "business-filters.controllers.field-config.type-label",
        "defaultMessage": "Type"
    },
    unassignedLabel: {
        "id": "business-filters.controllers.field-config.unassigned-label",
        "defaultMessage": "Unassigned"
    },
    noneOption: {
        "id": "business-filters.controllers.field-config.none-option",
        "defaultMessage": "None"
    }
});

});



parcelRegister("aWjLM", function(module, exports) {

$parcel$export(module.exports, "useFieldConfigV2", () => $f0c719cf639dcc71$export$c041141a7ef797c1);

var $eUqFw = parcelRequire("eUqFw");

var $fDLFb = parcelRequire("fDLFb");

var $e20I1 = parcelRequire("e20I1");

var $eI5EY = parcelRequire("eI5EY");

var $5JgJ2 = parcelRequire("5JgJ2");

var $lO4Or = parcelRequire("lO4Or");

var $ejYlo = parcelRequire("ejYlo");

var $hLW3I = parcelRequire("hLW3I");

var $jWIW7 = parcelRequire("jWIW7");

var $7goEv = parcelRequire("7goEv");
const $f0c719cf639dcc71$var$EMPTY_FIELD_DATA = {
    totalCount: 0,
    options: []
};
const $f0c719cf639dcc71$var$EMPTY_FILTER_DATA = {
    initialUsers: $f0c719cf639dcc71$var$EMPTY_FIELD_DATA,
    initialLabels: $f0c719cf639dcc71$var$EMPTY_FIELD_DATA,
    initialComponents: $f0c719cf639dcc71$var$EMPTY_FIELD_DATA,
    initialPriorities: $f0c719cf639dcc71$var$EMPTY_FIELD_DATA,
    initialIssueTypes: $f0c719cf639dcc71$var$EMPTY_FIELD_DATA,
    initialStatuses: $f0c719cf639dcc71$var$EMPTY_FIELD_DATA,
    initialCategories: $f0c719cf639dcc71$var$EMPTY_FIELD_DATA,
    initialSprints: $f0c719cf639dcc71$var$EMPTY_FIELD_DATA,
    initialFixVersions: $f0c719cf639dcc71$var$EMPTY_FIELD_DATA,
    initialParents: $f0c719cf639dcc71$var$EMPTY_FIELD_DATA,
    initialGoals: $f0c719cf639dcc71$var$EMPTY_FIELD_DATA,
    initialTeams: $f0c719cf639dcc71$var$EMPTY_FIELD_DATA
};
const $f0c719cf639dcc71$var$initialState = {
    data: undefined,
    loadingData: true
};
const $f0c719cf639dcc71$var$reducer = (state, action)=>{
    switch(action.type){
        case 'init':
            return $f0c719cf639dcc71$var$initialState;
        case 'fetch-data-success':
            return {
                ...state,
                data: action.value,
                loadingData: false
            };
        case 'fetch-data-error':
            return {
                ...state,
                data: $f0c719cf639dcc71$var$EMPTY_FILTER_DATA,
                loadingData: false
            };
        default:
            return state;
    }
};
/**
 * useFieldConfig hook that is used to populate the field and field values for JWM Filters.
 * It can be used for JWM Overviews which includes multiple Jira Projects.
 */ const $f0c719cf639dcc71$var$emptyFieldValue = {
    totalCount: 0,
    options: []
};
const $f0c719cf639dcc71$export$c041141a7ef797c1 = ({ view: view, allowedFieldTypes: allowedFieldTypes })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const projectFieldData = (0, $jWIW7.useProjectFilter)();
    const { data: filterFields, loading: loadingFilterFields } = (0, $hLW3I.useFilterFields)();
    const [{ data: data, loadingData: loadingData }, dispatch] = (0, $eUqFw.useReducer)($f0c719cf639dcc71$var$reducer, $f0c719cf639dcc71$var$initialState);
    const userResolver = (0, $eUqFw.useRef)(new (0, $e20I1.UserResolver)());
    const { fetchLabels: fetchLabels, fetchComponents: fetchComponents, fetchUsers: fetchUsers, fetchCategories: fetchCategories, fetchInitialData: fetchInitialData, ...fetchOptions } = (0, $ejYlo.useFetchFieldValues)({
        view: view,
        allowedFieldTypes: allowedFieldTypes,
        filterFields: filterFields
    });
    const { data: entity } = (0, $fDLFb.useBusinessEntity)();
    const businessEntityId = entity.id;
    const initialiseDefaultData = (0, $eUqFw.useCallback)(()=>{
        fetchInitialData().then((initialData)=>{
            dispatch({
                type: 'fetch-data-success',
                value: {
                    initialUsers: initialData?.users ?? $f0c719cf639dcc71$var$emptyFieldValue,
                    initialLabels: initialData?.labels ?? $f0c719cf639dcc71$var$emptyFieldValue,
                    initialComponents: initialData?.components ?? $f0c719cf639dcc71$var$emptyFieldValue,
                    initialPriorities: initialData?.priority ?? $f0c719cf639dcc71$var$emptyFieldValue,
                    initialIssueTypes: initialData?.issuetype ?? $f0c719cf639dcc71$var$emptyFieldValue,
                    initialStatuses: initialData?.status ?? $f0c719cf639dcc71$var$emptyFieldValue,
                    initialCategories: initialData?.[0, $lO4Or.CATEGORY_TYPE] ?? $f0c719cf639dcc71$var$emptyFieldValue,
                    initialSprints: initialData?.[0, $lO4Or.SPRINT_TYPE] ?? $f0c719cf639dcc71$var$emptyFieldValue,
                    ...(0, $eI5EY.fg)('jsw_list_view_-_all_the_fields') ? {
                        initialFixVersions: initialData?.[0, $lO4Or.FIX_VERSIONS_TYPE] ?? $f0c719cf639dcc71$var$emptyFieldValue,
                        initialParents: initialData?.[0, $lO4Or.PARENT_FIELD_TYPE] ?? $f0c719cf639dcc71$var$emptyFieldValue,
                        initialTeams: initialData?.[0, $lO4Or.TEAMS_PLATFORM_CF_TYPE] ?? $f0c719cf639dcc71$var$emptyFieldValue
                    } : {},
                    initialGoals: initialData?.[0, $lO4Or.GOALS_CF_TYPE] ?? $f0c719cf639dcc71$var$emptyFieldValue
                }
            });
        }).catch(()=>{
            dispatch({
                type: 'fetch-data-error'
            });
        });
    }, [
        fetchInitialData
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (!loadingFilterFields) {
            dispatch({
                type: 'init'
            });
            initialiseDefaultData();
        }
    }, [
        initialiseDefaultData,
        loadingFilterFields,
        businessEntityId
    ]);
    const { fieldConfig: fieldConfig, resolvers: resolvers } = (0, $eUqFw.useMemo)(()=>{
        const fieldOptionsData = {
            priority: data?.initialPriorities ?? $f0c719cf639dcc71$var$emptyFieldValue,
            issuetype: data?.initialIssueTypes ?? $f0c719cf639dcc71$var$emptyFieldValue,
            status: data?.initialStatuses ?? $f0c719cf639dcc71$var$emptyFieldValue,
            users: data?.initialUsers ?? $f0c719cf639dcc71$var$emptyFieldValue,
            labels: data?.initialLabels ?? $f0c719cf639dcc71$var$emptyFieldValue,
            components: data?.initialComponents ?? $f0c719cf639dcc71$var$emptyFieldValue,
            [(0, $lO4Or.CATEGORY_TYPE)]: data?.initialCategories ?? $f0c719cf639dcc71$var$emptyFieldValue,
            [(0, $lO4Or.SPRINT_TYPE)]: data?.initialSprints ?? $f0c719cf639dcc71$var$emptyFieldValue,
            project: projectFieldData,
            ...(0, $eI5EY.fg)('jsw_list_view_-_all_the_fields') ? {
                [(0, $lO4Or.FIX_VERSIONS_TYPE)]: data?.initialFixVersions ?? $f0c719cf639dcc71$var$emptyFieldValue,
                [(0, $lO4Or.PARENT_FIELD_TYPE)]: data?.initialParents ?? $f0c719cf639dcc71$var$emptyFieldValue,
                [(0, $lO4Or.TEAMS_PLATFORM_CF_TYPE)]: data?.initialTeams ?? $f0c719cf639dcc71$var$emptyFieldValue
            } : {},
            [(0, $lO4Or.GOALS_CF_TYPE)]: data?.initialGoals ?? $f0c719cf639dcc71$var$emptyFieldValue
        };
        return (0, $7goEv.getFilterFieldConfigAndResolvers)({
            view: view,
            formatMessage: formatMessage,
            allFields: filterFields,
            allowedFieldTypes: allowedFieldTypes,
            fieldOptionsData: fieldOptionsData,
            fetchUsers: fetchUsers,
            fetchLabels: fetchLabels,
            fetchComponents: fetchComponents,
            fetchCategories: fetchCategories,
            ...fetchOptions,
            userResolver: userResolver.current
        });
    }, [
        data?.initialPriorities,
        data?.initialIssueTypes,
        data?.initialStatuses,
        data?.initialUsers,
        data?.initialLabels,
        data?.initialComponents,
        data?.initialCategories,
        data?.initialSprints,
        data?.initialFixVersions,
        data?.initialParents,
        data?.initialGoals,
        data?.initialTeams,
        projectFieldData,
        view,
        formatMessage,
        filterFields,
        allowedFieldTypes,
        fetchUsers,
        fetchLabels,
        fetchComponents,
        fetchCategories,
        fetchOptions
    ]);
    return {
        fieldConfig: fieldConfig,
        resolvers: resolvers,
        loading: loadingData || loadingFilterFields || data == null
    };
};

});
parcelRegister("7goEv", function(module, exports) {

$parcel$export(module.exports, "getFilterFieldConfigAndResolvers", () => $1ffbd75d284f79d7$export$ba4f3d2149c2bf3b);

var $illlw = parcelRequire("illlw");

var $5iWql = parcelRequire("5iWql");

var $eI5EY = parcelRequire("eI5EY");

var $lO4Or = parcelRequire("lO4Or");

var $9TEHc = parcelRequire("9TEHc");

var $1run3 = parcelRequire("1run3");

var $dG4cR = parcelRequire("dG4cR");

var $9Jtgc = parcelRequire("9Jtgc");
const $1ffbd75d284f79d7$export$fb8c90bfc4beaa59 = (0, $5iWql.default)((users)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    users.reduce((acc, next)=>{
        acc.push({
            value: next.accountId || '',
            label: next.displayName,
            avatar: (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(next, [
                'avatarUrls',
                '24x24'
            ], '')
        });
        return acc;
    }, []));
const $1ffbd75d284f79d7$var$getType = (type)=>{
    switch(type){
        case 0, $lO4Or.CATEGORY_TYPE:
            return (0, $1run3.FieldType).CategorySelectFilter;
        case 0, $lO4Or.PRIORITY_TYPE:
            return (0, $1run3.FieldType).PrioritySelectFilter;
        case 0, $lO4Or.ASSIGNEE_TYPE:
        case 0, $lO4Or.REPORTER_TYPE:
        case 0, $lO4Or.USER_CF_TYPE:
            return (0, $1run3.FieldType).AvatarAsyncSelectFilter;
        case 0, $lO4Or.ISSUE_TYPE:
        case 0, $lO4Or.PARENT_FIELD_TYPE:
        case 0, $lO4Or.TEAMS_PLATFORM_CF_TYPE:
            return (0, $1run3.FieldType).AvatarSelectFilter;
        case 0, $lO4Or.STATUS_TYPE:
            return (0, $1run3.FieldType).LozengeSelectFilter;
        case 0, $lO4Or.LABELS_TYPE:
        case 0, $lO4Or.COMPONENTS_TYPE:
        case 0, $lO4Or.FIX_VERSIONS_TYPE:
        case 0, $lO4Or.SPRINT_TYPE:
            return (0, $1run3.FieldType).AsyncSelectFilter;
        case 0, $lO4Or.CREATED:
        case 0, $lO4Or.UPDATED:
            return (0, $1run3.FieldType).DateFilter;
        case 0, $lO4Or.PROJECT_TYPE:
            return (0, $1run3.FieldType).ProjectFilter;
        case 0, $lO4Or.GOALS_CF_TYPE:
            return (0, $1run3.FieldType).GoalsSelectFilter;
        default:
            return (0, $1run3.FieldType).SelectFilter;
    }
};
const $1ffbd75d284f79d7$var$getValues = (type, fieldOptionsData)=>{
    switch(type){
        case 0, $lO4Or.ASSIGNEE_TYPE:
        case 0, $lO4Or.REPORTER_TYPE:
        case 0, $lO4Or.USER_CF_TYPE:
            return fieldOptionsData.users;
        default:
            return fieldOptionsData[type];
    }
};
const $1ffbd75d284f79d7$var$isUserField = (type)=>{
    switch(type){
        case 0, $lO4Or.ASSIGNEE_TYPE:
        case 0, $lO4Or.REPORTER_TYPE:
        case 0, $lO4Or.USER_CF_TYPE:
            return true;
        default:
            return false;
    }
};
const $1ffbd75d284f79d7$var$isCustomField = (type)=>{
    switch(type){
        case 0, $lO4Or.USER_CF_TYPE:
        case 0, $lO4Or.PEOPLE_CF_TYPE:
        case 0, $lO4Or.SELECT_CF_TYPE:
        case 0, $lO4Or.MULTI_SELECT_CF_TYPE:
        case 0, $lO4Or.MULTI_CHECKBOXES_CF_TYPE:
            return true;
        default:
            return false;
    }
};
const $1ffbd75d284f79d7$var$createUserValueGetter = (userResolver)=>(0, $5iWql.default)((accountIds)=>userResolver.getUsersFromAccountId(accountIds) // eslint-disable-next-line @typescript-eslint/no-explicit-any
        .then((response)=>$1ffbd75d284f79d7$export$fb8c90bfc4beaa59(response)));
const $1ffbd75d284f79d7$export$ba4f3d2149c2bf3b = ({ view: view, formatMessage: formatMessage, allowedFieldTypes: allowedFieldTypes, allFields: allFields, fieldOptionsData: fieldOptionsData, userResolver: userResolver, fetchUsers: fetchUsers, fetchLabels: fetchLabels, fetchComponents: fetchComponents, fetchCategories: fetchCategories, fetchStatuses: fetchStatuses, fetchPriorities: fetchPriorities, fetchIssueTypes: fetchIssueTypes, fetchSprints: fetchSprints, fetchFixVersions: fetchFixVersions, fetchParents: fetchParents, fetchGoals: fetchGoals, fetchTeams: fetchTeams })=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const fieldConfig = {};
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const resolvers = {};
    if (allowedFieldTypes.has((0, $9TEHc.DATE_RANGE_TYPE))) // manually add dateRange to fieldConfig
    fieldConfig.dateRange = {
        label: formatMessage((0, $9Jtgc.default).dateRangeLabel),
        type: (0, $1run3.FieldType).DateFilter,
        fromLabel: formatMessage((0, $9Jtgc.default).startDateLabel),
        toLabel: formatMessage((0, $9Jtgc.default).dueDateLabel)
    };
    const fields = allFields.filter((field)=>allowedFieldTypes.has(field.type ?? ''));
    // eslint-disable-next-line complexity
    fields.forEach((field)=>{
        const { name: name, type: type, id: id } = field;
        const fieldType = type ?? '';
        const fieldValues = $1ffbd75d284f79d7$var$getValues(fieldType, fieldOptionsData);
        fieldConfig[id] = {
            label: name,
            type: $1ffbd75d284f79d7$var$getType(fieldType),
            placeholder: formatMessage((0, $9Jtgc.default).filterPlaceholder),
            options: fieldValues?.options || [],
            totalCount: fieldValues?.totalCount || 0,
            isCustomField: $1ffbd75d284f79d7$var$isCustomField(fieldType),
            fieldConfigVersion: 2
        };
        // issue type
        if (type === (0, $lO4Or.ISSUE_TYPE)) {
            let options = fieldValues?.options || [];
            if (view === 'board') {
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                options = (fieldValues?.options).filter((option)=>option.hierarchyLevel !== -1);
                fieldConfig[id].options = options;
            }
            if (fetchIssueTypes) {
                fieldConfig[id].loadOptions = fetchIssueTypes;
                fieldConfig[id].defaultOptions = options;
            }
        } else if ($1ffbd75d284f79d7$var$isUserField(fieldType)) {
            fieldConfig[id].loadOptions = fetchUsers;
            fieldConfig[id].defaultOptions = fieldValues?.options || [];
            resolvers[id] = $1ffbd75d284f79d7$var$createUserValueGetter(userResolver);
            fieldConfig[id].options = [
                ...fieldConfig[id].options,
                {
                    value: (0, $dG4cR.EMPTY_FILTER_VALUE),
                    label: formatMessage((0, $9Jtgc.default).unassignedLabel),
                    isEmptyOption: true
                }
            ];
            fieldConfig[id].totalCount += 1;
        } else if (fieldType === (0, $lO4Or.LABELS_TYPE)) {
            fieldConfig[id].loadOptions = fetchLabels;
            fieldConfig[id].defaultOptions = fieldValues?.options || [];
            fieldConfig[id].options = [
                ...fieldConfig[id].options,
                {
                    value: (0, $dG4cR.EMPTY_FILTER_VALUE),
                    label: formatMessage((0, $9Jtgc.default).noLabelsLabel),
                    isEmptyOption: true
                }
            ];
            fieldConfig[id].totalCount += 1;
        } else if (fieldType === (0, $lO4Or.COMPONENTS_TYPE)) {
            fieldConfig[id].loadOptions = fetchComponents;
            fieldConfig[id].defaultOptions = fieldValues?.options || [];
            fieldConfig[id].options = [
                ...fieldConfig[id].options,
                {
                    value: (0, $dG4cR.EMPTY_FILTER_VALUE),
                    label: formatMessage((0, $9Jtgc.default).noComponentsLabel),
                    isEmptyOption: true
                }
            ];
            fieldConfig[id].totalCount += 1;
        } else if (fieldType === (0, $lO4Or.CATEGORY_TYPE)) {
            fieldConfig[id].loadOptions = fetchCategories;
            fieldConfig[id].defaultOptions = fieldValues?.options || [];
            fieldConfig[id].options = [
                ...fieldConfig[id].options,
                {
                    value: (0, $dG4cR.EMPTY_FILTER_VALUE),
                    label: formatMessage((0, $9Jtgc.default).noCategoriesLabel),
                    isEmptyOption: true
                }
            ];
            fieldConfig[id].totalCount += 1;
        } else if (fieldType === (0, $lO4Or.STATUS_TYPE) && fetchStatuses) {
            fieldConfig[id].loadOptions = fetchStatuses;
            fieldConfig[id].defaultOptions = fieldValues?.options || [];
        } else if (fieldType === (0, $lO4Or.PRIORITY_TYPE) && fetchPriorities) {
            fieldConfig[id].loadOptions = fetchPriorities;
            fieldConfig[id].defaultOptions = fieldValues?.options || [];
        } else if (fieldType === (0, $lO4Or.SPRINT_TYPE) && fetchSprints) {
            fieldConfig[id].loadOptions = fetchSprints;
            fieldConfig[id].defaultOptions = fieldValues?.options || [];
            fieldConfig[id].options = [
                ...fieldConfig[id].options,
                {
                    value: (0, $dG4cR.EMPTY_FILTER_VALUE),
                    label: formatMessage((0, $9Jtgc.default).noSprintLabel),
                    isEmptyOption: true
                }
            ];
            fieldConfig[id].totalCount += 1;
        } else if (fieldType === (0, $lO4Or.FIX_VERSIONS_TYPE) && fetchFixVersions && (0, $eI5EY.fg)('jsw_list_view_-_all_the_fields')) {
            fieldConfig[id].loadOptions = fetchFixVersions;
            fieldConfig[id].defaultOptions = fieldValues?.options || [];
            fieldConfig[id].options = [
                ...fieldConfig[id].options,
                {
                    value: (0, $dG4cR.EMPTY_FILTER_VALUE),
                    label: formatMessage((0, $9Jtgc.default).noVersionLabel),
                    isEmptyOption: true
                }
            ];
            fieldConfig[id].totalCount += 1;
        } else if (fieldType === (0, $lO4Or.PARENT_FIELD_TYPE) && fetchParents && (0, $eI5EY.fg)('jsw_list_view_-_all_the_fields')) {
            fieldConfig[id].loadOptions = fetchParents;
            fieldConfig[id].defaultOptions = fieldValues?.options || [];
            fieldConfig[id].options = [
                ...fieldConfig[id].options,
                {
                    value: (0, $dG4cR.EMPTY_FILTER_VALUE),
                    label: formatMessage((0, $9Jtgc.default).noParentLabel),
                    isEmptyOption: true
                }
            ];
            fieldConfig[id].totalCount += 1;
        } else if (fieldType === (0, $lO4Or.GOALS_CF_TYPE) && fetchGoals) {
            fieldConfig[id].loadOptions = fetchGoals;
            fieldConfig[id].options = [
                ...fieldConfig[id].options,
                {
                    value: (0, $dG4cR.EMPTY_FILTER_VALUE),
                    label: formatMessage((0, $9Jtgc.default).noGoalLabel),
                    isEmptyOption: true
                }
            ];
            fieldConfig[id].totalCount += 1;
        } else if (fetchTeams && fieldType === (0, $lO4Or.TEAMS_PLATFORM_CF_TYPE) && (0, $eI5EY.fg)('jsw_list_view_-_all_the_fields')) {
            fieldConfig[id].loadOptions = fetchTeams;
            fieldConfig[id].defaultOptions = fieldValues?.options || [];
            fieldConfig[id].options = [
                ...fieldConfig[id].options,
                {
                    value: (0, $dG4cR.EMPTY_FILTER_VALUE),
                    label: formatMessage((0, $9Jtgc.default).noTeamLabel),
                    isEmptyOption: true
                }
            ];
            fieldConfig[id].totalCount += 1;
        }
    });
    return {
        fieldConfig: fieldConfig,
        resolvers: resolvers
    };
};

});
parcelRegister("9Jtgc", function(module, exports) {

$parcel$export(module.exports, "default", () => $510082940a52668b$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $510082940a52668b$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    filterPlaceholder: {
        "id": "business-filters.controllers.field-config-v2.filter-placeholder",
        "defaultMessage": "Search"
    },
    dateRangeLabel: {
        "id": "business-filters.controllers.field-config-v2.date-range-label",
        "defaultMessage": "Date range"
    },
    startDateLabel: {
        "id": "business-filters.controllers.field-config-v2.start-date-label",
        "defaultMessage": "Start date"
    },
    dueDateLabel: {
        "id": "business-filters.controllers.field-config-v2.due-date-label",
        "defaultMessage": "Due date"
    },
    unassignedLabel: {
        "id": "business-filters.controllers.field-config-v2.unassigned-label",
        "defaultMessage": "Unassigned"
    },
    noLabelsLabel: {
        "id": "business-filters.controllers.field-config-v2.no-labels-label",
        "defaultMessage": "No label"
    },
    noCategoriesLabel: {
        "id": "business-filters.controllers.field-config-v2.no-categories-label",
        "defaultMessage": "No category"
    },
    noComponentsLabel: {
        "id": "business-filters.controllers.field-config-v2.no-components-label",
        "defaultMessage": "No component"
    },
    noSprintLabel: {
        "id": "business-filters.controllers.field-config-v2.no-sprint-label",
        "defaultMessage": "Backlog"
    },
    noVersionLabel: {
        "id": "business-filters.controllers.field-config-v2.no-version-label",
        "defaultMessage": "No version"
    },
    noParentLabel: {
        "id": "business-filters.controllers.field-config-v2.no-parent-label",
        "defaultMessage": "No parent"
    },
    noGoalLabel: {
        "id": "business-filters.controllers.field-config-v2.no-goal-label",
        "defaultMessage": "No goal"
    },
    noTeamLabel: {
        "id": "business-filters.controllers.field-config-v2.no-team-label",
        "defaultMessage": "No team"
    }
});

});




parcelRegister("coMWQ", function(module, exports) {

$parcel$export(module.exports, "deserialiseJql", () => $67199c690c914c16$export$214464255b766962);

var $hir2i = parcelRequire("hir2i");

var $27QuD = parcelRequire("27QuD");

var $9FEvp = parcelRequire("9FEvp");

var $6x1NF = parcelRequire("6x1NF");

var $6RWCB = parcelRequire("6RWCB");
var $bXcc5 = parcelRequire("bXcc5");
var $k85ht = parcelRequire("k85ht");

var $1ybV0 = parcelRequire("1ybV0");

var $lO4Or = parcelRequire("lO4Or");

var $1run3 = parcelRequire("1run3");

var $dG4cR = parcelRequire("dG4cR");
const $67199c690c914c16$var$START_DATE_JQL = 'Start date[Date]';
const $67199c690c914c16$var$EMPTY = 'EMPTY';
// remove any extra space first
// then replace any escaped apostrophe,
// lastly replace any quotation marks in the beginning and end of word but not the apostrophes in the middle of the word
const $67199c690c914c16$var$cleanString = (value)=>(0, $1ybV0.ff)('migrate-business-filters-serialising-to-jql-ast_j6qj6') ? value.trim() : value.trim().replace(/\\'/g, "'").replace(/^'|'$/g, '');
// some filters should display options retrieved from the URL parameters even when they are not returned amongst the useFieldConfig field values
const $67199c690c914c16$var$shouldIncludeUnknownOption = (filterField)=>{
    const allowedFieldTypes = new Set([
        (0, $lO4Or.COMPONENTS_TYPE),
        (0, $lO4Or.LABELS_TYPE),
        (0, $lO4Or.PRIORITY_TYPE),
        (0, $lO4Or.CATEGORY_TYPE)
    ]);
    return allowedFieldTypes.has(filterField?.type ?? '');
};
const $67199c690c914c16$var$getFieldIdFromJql = (rawFieldName, getShouldConvertCustomField)=>{
    const fieldName = (0, (/*@__PURE__*/$parcel$interopDefault($27QuD)))(rawFieldName, '"');
    const shouldConvertCustomField = getShouldConvertCustomField ? getShouldConvertCustomField(fieldName) : true;
    // `cf[id]` -> `customfield_${id}`.
    if (fieldName.indexOf('cf[') === 0 && shouldConvertCustomField) {
        const extraction = new RegExp(/cf\[(.+)\]/).exec(fieldName);
        if (!extraction) return fieldName;
        const fieldId = extraction[1];
        return `customfield_${fieldId}`;
    }
    const startDateJql = $67199c690c914c16$var$START_DATE_JQL;
    // update this if we add a start date or due date filter
    if (fieldName === startDateJql || fieldName === 'due') return 'dateRange';
    return fieldName;
};
const $67199c690c914c16$var$transformIntoOptions = async (list, field, resolver, filterField)=>{
    if (resolver && typeof resolver === 'function') {
        const cleanIds = list.map((value)=>$67199c690c914c16$var$cleanString(value));
        const ids = cleanIds.filter((value)=>(0, $1ybV0.ff)('migrate-business-filters-serialising-to-jql-ast_j6qj6') || value !== $67199c690c914c16$var$EMPTY);
        return resolver(ids).then((options)=>{
            // keep empty option in the response
            if (!(0, $1ybV0.ff)('migrate-business-filters-serialising-to-jql-ast_j6qj6') && list.find((value)=>value === $67199c690c914c16$var$EMPTY)) return [
                ...options,
                {
                    value: (0, $dG4cR.EMPTY_FILTER_VALUE),
                    label: ''
                }
            ];
            return options;
        });
    }
    const allowUnknownOption = $67199c690c914c16$var$shouldIncludeUnknownOption(filterField);
    return list.map((value)=>{
        const cleanValue = $67199c690c914c16$var$cleanString(value);
        if (field && !(0, $1run3.isDateField)(field) && Array.isArray(field.options)) {
            const optionInField = field.options.find((option)=>{
                if ((option == null || option.value == null) && !option.isEmptyOption) return null;
                if (option.isEmptyOption) return value === $67199c690c914c16$var$EMPTY;
                return option.value === cleanValue;
            });
            if (!optionInField && allowUnknownOption) return {
                value: cleanValue,
                label: cleanValue
            };
            if (!(0, $1ybV0.ff)('migrate-business-filters-serialising-to-jql-ast_j6qj6') && value === $67199c690c914c16$var$EMPTY) return {
                value: (0, $dG4cR.EMPTY_FILTER_VALUE),
                label: ''
            };
            return optionInField;
        }
        return undefined;
    }).filter((item)=>item != null && 'value' in item);
};
class $67199c690c914c16$export$5299115fe71e8b39 extends (0, $6RWCB.AbstractJastVisitor) {
    constructor(fieldConfig, filterFields, resolvers){
        super();
        this.getOption = (fieldName, items)=>$67199c690c914c16$var$transformIntoOptions(items, this.fieldConfig[fieldName], this.resolvers[fieldName], this.filterFields.find((field)=>field.id === fieldName));
        this.visitCompoundClause = (compoundClause)=>{
            const clauseMap = Promise.resolve({});
            const operator = compoundClause.operator.value;
            if (operator === (0, $e5bc650799ce4838$export$6d6d48d210d3ca97)) return compoundClause.clauses.reduce((result, clause)=>this.aggregateResult(clause.accept(this), result), clauseMap);
            throw new Error(`JQL contains invalid operator between clauses: ${operator}`);
        };
        this.parseDateOperand = (operator, operand)=>{
            if (operand?.operandType === (0, $807962b43ef03b56$export$38accfc5a5d1c113)) {
                let date = (0, $6x1NF.default)(new Date(operand.value), 'UTC', 'yyyy-MM-dd');
                if (operator.value === (0, $k85ht.OPERATOR_LT)) date = (0, $6x1NF.default)((0, $9FEvp.default)(new Date(operand.value), 1), 'UTC', 'yyyy-MM-dd');
                const dateType = operator.value === (0, $k85ht.OPERATOR_LT) ? 'to' : 'from';
                return {
                    value: {
                        [dateType]: date
                    }
                };
            }
            throw new Error(`JQL cannot parse date operand type: ${operand.operandType}`);
        };
        this.parseSelectOperand = async (fieldName, operand)=>{
            if (operand?.operandType === (0, $807962b43ef03b56$export$fabec4aebba3f4df)) {
                const optionPromises = operand.values.flatMap((value)=>this.parseSelectOperand(fieldName, value));
                return (await Promise.all(optionPromises)).flatMap((option)=>option);
            }
            if (operand?.operandType === (0, $807962b43ef03b56$export$38accfc5a5d1c113)) return this.getOption(fieldName, [
                operand.value
            ]);
            if (operand?.operandType === (0, $807962b43ef03b56$export$f6049126fd97001f)) return (0, $1ybV0.ff)('migrate-business-filters-serialising-to-jql-ast_j6qj6') ? [
                {
                    isEmptyOption: true,
                    value: (0, $dG4cR.EMPTY_FILTER_VALUE),
                    label: ''
                }
            ] : this.getOption(fieldName, [
                $67199c690c914c16$var$EMPTY
            ]);
            throw new Error(`JQL cannot parse select operand type: ${operand.operandType}`);
        };
        this.visitTerminalClause = async (terminalClause)=>{
            const { field: field, operand: operand, operator: operator } = terminalClause;
            if (!operand || !operator) return Promise.resolve({});
            const getShouldConvertCustomField = (fieldName)=>// should convert cf[] -> customfield_ if it's not a field from version 2
                !(this.fieldConfig[fieldName] && this.fieldConfig[fieldName].fieldConfigVersion === 2);
            const fieldName = $67199c690c914c16$var$getFieldIdFromJql(field.value, getShouldConvertCustomField);
            if (!Object.keys(this.fieldConfig).includes(fieldName)) throw new Error(`JQL contains unsupported fields: ${fieldName}`);
            let value = [];
            if (operator.value === (0, $k85ht.OPERATOR_GT_EQUALS) || operator.value === (0, $k85ht.OPERATOR_LT)) value = this.parseDateOperand(operator, operand);
            else if (operator.value === (0, $k85ht.OPERATOR_EQUALS) || operator.value === (0, $k85ht.OPERATOR_IN)) value = await this.parseSelectOperand(fieldName, operand);
            else throw new Error(`JQL contains unsupported operator in terminal clause: ${operator.value}`);
            return {
                [fieldName]: value
            };
        };
        this.fieldConfig = fieldConfig;
        this.filterFields = filterFields;
        this.resolvers = resolvers;
    }
    visitNotClause() {
        throw new Error('JQL contains invalid clause: NOT');
    }
    defaultResult() {
        return Promise.resolve({});
    }
    /**
	 * @param aggregate new ClauseMap to add into nextResult
	 * @param nextResult ClauseMap with previous results
	 * @returns ClauseMap with the merged results adding the aggregate at the end
	 */ async aggregateResult(aggregate, nextResult) {
        // First parameter is the object where we want to add the values and the second the new values to merge into the first object.
        return (0, (/*@__PURE__*/$parcel$interopDefault($hir2i)))(await nextResult, await aggregate, (destValue, srcValue)=>{
            if (Array.isArray(srcValue)) return srcValue.concat(destValue ?? []);
            return undefined;
        });
    }
}
const $67199c690c914c16$export$214464255b766962 = async (jql, fieldConfig, filterFields, resolvers)=>{
    // Create the syntax tree for the filters JQL
    const builder = new (0, $bXcc5.JastBuilder)();
    const jast = builder.build(jql);
    if (jast.query?.orderBy != null) throw new Error('JQL contains unsupported ORDER BY');
    // Parse the JQL AST into a FilterType object
    const parser = new $67199c690c914c16$export$5299115fe71e8b39(fieldConfig, filterFields, resolvers);
    const parsedJql = await jast.query?.accept(parser);
    return parsedJql ?? {};
};

});
parcelRegister("hir2i", function(module, exports) {

var $eljWd = parcelRequire("eljWd");

var $3Bqj8 = parcelRequire("3Bqj8");
/**
 * This method is like `_.merge` except that it accepts `customizer` which
 * is invoked to produce the merged values of the destination and source
 * properties. If `customizer` returns `undefined`, merging is handled by the
 * method instead. The `customizer` is invoked with six arguments:
 * (objValue, srcValue, key, object, source, stack).
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} sources The source objects.
 * @param {Function} customizer The function to customize assigned values.
 * @returns {Object} Returns `object`.
 * @example
 *
 * function customizer(objValue, srcValue) {
 *   if (_.isArray(objValue)) {
 *     return objValue.concat(srcValue);
 *   }
 * }
 *
 * var object = { 'a': [1], 'b': [2] };
 * var other = { 'a': [3], 'b': [4] };
 *
 * _.mergeWith(object, other, customizer);
 * // => { 'a': [1, 3], 'b': [2, 4] }
 */ var $c97916e8180d3b9a$var$mergeWith = $3Bqj8(function(object, source, srcIndex, customizer) {
    $eljWd(object, source, srcIndex, customizer);
});
module.exports = $c97916e8180d3b9a$var$mergeWith;

});



parcelRegister("27zPy", function(module, exports) {

$parcel$export(module.exports, "MenuContent", () => $d758afbde8c38bbf$export$479f0f2f71193efe);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $gGtKh = parcelRequire("gGtKh");

var $cqv89 = parcelRequire("cqv89");

var $hEiVl = parcelRequire("hEiVl");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $d758afbde8c38bbf$var$LazyMenuContent = (0, $7rh0R.lazy)(()=>(parcelRequire("gk2kI")), {
    moduleId: "./src/packages/business/shared/components/filters/src/ui/filters/menu-content/main.tsx"
});
const $d758afbde8c38bbf$export$479f0f2f71193efe = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hEiVl.DropdownWrapper), {
        "data-testid": "business-filters.ui.filters.menu-content"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "menu-content",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cqv89.MenuFallback), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d758afbde8c38bbf$var$LazyMenuContent, props)));

});
parcelRegister("cqv89", function(module, exports) {

$parcel$export(module.exports, "MenuFallback", () => $d72c10a0e4505968$export$1198e585d599d03);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $4Bees = parcelRequire("4Bees");
const $d72c10a0e4505968$export$1198e585d599d03 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d72c10a0e4505968$var$SpinnerWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), {
        size: "medium",
        testId: "business-filters.common.ui.menu-fallback.spinner"
    }));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d72c10a0e4505968$var$SpinnerWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _1yt4pxbi",
            __cmplp.className
        ])
    });
});

});

parcelRegister("hEiVl", function(module, exports) {

$parcel$export(module.exports, "DropdownWrapper", () => $5348b95debef5641$export$5f7211d21bfdae05);
$parcel$export(module.exports, "ScrollableContent", () => $5348b95debef5641$export$6c560fdadeb11d78);
$parcel$export(module.exports, "DropdownHeaderWrapper", () => $5348b95debef5641$export$e23294aded7a8a49);
$parcel$export(module.exports, "DropdownHeaderButtons", () => $5348b95debef5641$export$53ca7a3701b98335);
$parcel$export(module.exports, "FiltersListSeparator", () => $5348b95debef5641$export$1a67069896d998b9);
$parcel$export(module.exports, "FiltersListWrapper", () => $5348b95debef5641$export$a5a9080bd2c85987);
$parcel$export(module.exports, "Section", () => $5348b95debef5641$export$6e2c8f0811a474ce);
$parcel$export(module.exports, "LastSection", () => $5348b95debef5641$export$1faf3c7558df435);
$parcel$export(module.exports, "SectionMessageWrapper", () => $5348b95debef5641$export$c5e20d5e200edfe2);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $9TEHc = parcelRequire("9TEHc");
const $5348b95debef5641$var$DROPDOWN_HEADER_HEIGHT = 52;
const $5348b95debef5641$var$DROPDOWN_HEADER_VERTICAL_PADDING = "var(--ds-space-150, 12px)";
const $5348b95debef5641$export$5f7211d21bfdae05 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1ul91gwv",
            __cmplp.className
        ])
    });
});
const $5348b95debef5641$export$6c560fdadeb11d78 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { offsetTop: offsetTop, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1uik9ob": (0, $9t7rW.default)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            `calc(${__cmplp.offsetTop && __cmplp.offsetTop > (0, $9TEHc.POPUP_OFFSET_TOP) ? '95vh' : '85vh'} - ${// dynamically calculating offsetTop on popup mount
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (__cmplp.offsetTop ?? (0, $9TEHc.POPUP_OFFSET_TOP)) + $5348b95debef5641$var$DROPDOWN_HEADER_HEIGHT}px)`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1reo1wug _18m91wug _ln19p27b _c71l1pam",
            __cmplp.className
        ])
    });
});
const $5348b95debef5641$export$e23294aded7a8a49 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { stickyHeader: stickyHeader, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_11q71bhr _2rko1sit _1pbykb7n _kqswh2mm _1yt4jd10 _1e0c1txw _1bah1yb4 _4cvr1h6o _11c8qk37",
            __cmplp.stickyHeader ? "_16qsf7oa" : "_16qsglyw",
            __cmplp.className
        ])
    });
});
const $5348b95debef5641$export$53ca7a3701b98335 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1bahesu3",
            __cmplp.className
        ])
    });
});
const $5348b95debef5641$export$1a67069896d998b9 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_x3do13y8 _18s81alc",
            __cmplp.className
        ])
    });
});
const $5348b95debef5641$export$a5a9080bd2c85987 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_p12f1gwv",
            __cmplp.className
        ])
    });
});
const $5348b95debef5641$export$6e2c8f0811a474ce = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx21bp4 _zulp1f4h _n3td1f4h",
            __cmplp.className
        ])
    });
});
const $5348b95debef5641$export$1faf3c7558df435 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = $5348b95debef5641$export$6e2c8f0811a474ce, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_n3tdidpf _zulpidpf",
            __cmplp.className
        ])
    });
});
const $5348b95debef5641$export$c5e20d5e200edfe2 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1yt4pxbi",
            __cmplp.className
        ])
    });
});

});

parcelRegister("gk2kI", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('8LeNQ')
        ]);
        const value = parcelRequire('fTzDz');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("8LeNQ")
    ]).then(()=>parcelRequire('fTzDz'));
}

});


parcelRegister("6M6Pf", function(module, exports) {

$parcel$export(module.exports, "Trigger", () => $70b788e25198d514$export$41fb9f06171c75f4);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $4ki2H = parcelRequire("4ki2H");

var $lGiWG = parcelRequire("lGiWG");

var $5JgJ2 = parcelRequire("5JgJ2");

var $lwKJI = parcelRequire("lwKJI");
const $70b788e25198d514$var$FILTER_ICON = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4ki2H))), {
    label: "",
    size: "small"
});
const $70b788e25198d514$export$41fb9f06171c75f4 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ onClick: onClick, isSelected: isSelected, count: count, hasFiltersApplied: hasFiltersApplied, withThemedButton: withThemedButton = true, isDisabled: isDisabled, ...otherProps }, ref)=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const filterMessage = (0, $eUqFw.useMemo)(()=>{
        if (count > 0) return formatMessage((0, $lwKJI.default).filtersCount, {
            filters: count
        });
        if (hasFiltersApplied) return formatMessage((0, $lwKJI.default).buttonWithFilters);
        return formatMessage((0, $lwKJI.default).filterButton);
    }, [
        count,
        formatMessage,
        hasFiltersApplied
    ]);
    const TriggerButton = withThemedButton ? (0, $lGiWG.ThemedButton) : (0, $7u4fN.default);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(TriggerButton, {
        ...otherProps,
        ref: ref,
        testId: "business-filters.ui.filters.trigger.button-wrapper",
        iconBefore: $70b788e25198d514$var$FILTER_ICON,
        isSelected: isSelected,
        onClick: onClick,
        appearance: "subtle",
        isDisabled: isDisabled
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($70b788e25198d514$var$ButtonContents, null, filterMessage));
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $70b788e25198d514$var$ButtonContents = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx2vrvc _zulp1b66 _4cvr1h6o",
            __cmplp.className
        ])
    });
});

});
parcelRegister("lwKJI", function(module, exports) {

$parcel$export(module.exports, "default", () => $142e1a2d3eb527a7$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $142e1a2d3eb527a7$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    filtersCount: {
        "id": "business-filters.filters.trigger.filters-count",
        "defaultMessage": "{filters, number} {filters, plural, one {filter applied} other {filters applied}}"
    },
    filterButton: {
        "id": "business-filters.filters.trigger.filter-button",
        "defaultMessage": "Filter"
    },
    buttonWithFilters: {
        "id": "business-filters.filters.trigger.button-with-filters",
        "defaultMessage": "Filters applied"
    },
    newLozenge: {
        "id": "business-filters.filters.trigger.new-lozenge",
        "defaultMessage": "New"
    },
    newLozengeTooltip: {
        "id": "business-filters.filters.trigger.new-lozenge-tooltip",
        "defaultMessage": "Now you can save your frequently used filters. Apply some filters to get started."
    }
});

});



parcelRegister("d9gm1", function(module, exports) {

$parcel$export(module.exports, "SimpleSearchTextField", () => $2ba7b21880f0a587$export$63f96dda4bd4f7dc);
$parcel$export(module.exports, "SimpleSearchField", () => $2ba7b21880f0a587$export$44e8ccf3428dc1d5);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $6zOB7 = parcelRequire("6zOB7");

var $jWuk1 = parcelRequire("jWuk1");

var $dsroq = parcelRequire("dsroq");

var $cf2Y4 = parcelRequire("cf2Y4");

var $kar7l = parcelRequire("kar7l");

var $c1K7Q = parcelRequire("c1K7Q");

var $5JgJ2 = parcelRequire("5JgJ2");

var $2jdHI = parcelRequire("2jdHI");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $9JEYY = parcelRequire("9JEYY");

var $96etS = parcelRequire("96etS");

var $j33Mg = parcelRequire("j33Mg");
const $2ba7b21880f0a587$export$63f96dda4bd4f7dc = /*#__PURE__*/ (0, $eUqFw.memo)(({ inputRef: inputRef, placeholder: placeholder, value: externalValue = '', onChange: onChange, onFocus: onFocus, view: view, testId: testId, isDisabled: isDisabled, label: label, describedbyId: describedbyId, themedField: themedField = true })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [searchValue, setSearchValue] = (0, $eUqFw.useState)(externalValue);
    const handleSearchChange = (0, $eUqFw.useCallback)((newValue)=>{
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'simpleSearchField updated', {
            view: view,
            ...(0, $9JEYY.getTextFieldAttributes)(newValue)
        });
        onChange(newValue);
    }, [
        createAnalyticsEvent,
        onChange,
        view
    ]);
    const [handleSearchChangeDebounced] = (0, $2jdHI.default)(handleSearchChange, 500);
    const handleChange = (0, $eUqFw.useCallback)((e)=>{
        setSearchValue(e.target.value);
        handleSearchChangeDebounced(e.target.value);
    }, [
        handleSearchChangeDebounced
    ]);
    const handleClear = (0, $eUqFw.useCallback)(()=>{
        setSearchValue('');
        handleSearchChangeDebounced('');
    }, [
        setSearchValue,
        handleSearchChangeDebounced
    ]);
    const themedIconPrimaryColor = isDisabled ? (0, $kar7l.Tokens).COLOR_TEXT_DISABLED : (0, $kar7l.Tokens).COLOR_TEXT_SUBTLEST;
    const Container = themedField ? $2ba7b21880f0a587$var$ThemedContainer : (0, $eUqFw.Fragment);
    (0, $eUqFw.useEffect)(()=>{
        setSearchValue(externalValue);
    }, [
        externalValue
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cf2Y4.default), {
        ref: inputRef,
        ...(0, $c1K7Q.generateDataTestId)('searchfield'),
        "aria-describedby": describedbyId,
        testId: testId,
        value: searchValue,
        isCompact: true,
        placeholder: formatMessage(placeholder),
        "aria-label": label || formatMessage(placeholder),
        onChange: handleChange,
        onFocus: onFocus,
        isDisabled: isDisabled,
        elemAfterInput: searchValue !== '' ? // We used Button with no children instead of IconButton because
        // of different sizing between an icon alone and IconButton
        // Using Button allows us to access to spacing="none" to mimic the
        // same spacing to the icon alone
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6zOB7.default), {
            iconBefore: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jWuk1))), {
                    ...iconProps,
                    size: "small",
                    primaryColor: themedField ? themedIconPrimaryColor : undefined
                }),
            appearance: "subtle",
            spacing: "none",
            "aria-label": formatMessage((0, $j33Mg.default).clear),
            testId: "business-filters.ui.simple-search-field.clear-button",
            onClick: handleClear
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dsroq))), {
            label: "",
            size: "small",
            primaryColor: themedField ? themedIconPrimaryColor : undefined
        }),
        className: (0, $7JEyt.default)([
            "_dzcou2gc"
        ])
    }));
});
const $2ba7b21880f0a587$export$44e8ccf3428dc1d5 = /*#__PURE__*/ (0, $eUqFw.memo)(({ placeholder: placeholder, view: view, describedbyId: describedbyId })=>{
    const [simpleSearch, setSimpleSearch] = (0, $96etS.useSimpleSearch)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const handleFocus = (0, $eUqFw.useCallback)(()=>{
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'simpleSearchField focused', {
            view: view
        });
    }, [
        createAnalyticsEvent,
        view
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ba7b21880f0a587$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ba7b21880f0a587$export$63f96dda4bd4f7dc, {
        view: view,
        onFocus: handleFocus,
        describedbyId: describedbyId,
        onChange: setSimpleSearch,
        value: simpleSearch,
        placeholder: placeholder
    }));
});
const $2ba7b21880f0a587$var$textFieldStyles = null; /* eslint-disable @atlaskit/design-system/no-unsafe-design-token-usage */ 
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2ba7b21880f0a587$var$ThemedContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_6l8r1oay _x2xk1oay _sg3v1oay _w15a1oay _n8yf1v8d _jeiekwex _7n831c2q _1o8hu22k _n2ulgr9p",
            __cmplp.className
        ])
    });
}); /* eslint-enable @atlaskit/design-system/no-unsafe-design-token-usage */ 
const $2ba7b21880f0a587$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw",
            __cmplp.className
        ])
    });
});

});
parcelRegister("cf2Y4", function(module, exports) {

$parcel$export(module.exports, "default", () => $ecaf8c9a10cf48c9$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $lUFyV = parcelRequire("lUFyV");

var $abUSh = parcelRequire("abUSh");
const $ecaf8c9a10cf48c9$var$analyticsParams = {
    componentName: 'textField',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
/**
 * __Textfield__
 *
 * A text field is an input that allows a user to write or edit text.
 *
 * - [Examples](https://atlassian.design/components/textfield/examples)
 * - [Code](https://atlassian.design/components/textfield/code)
 * - [Usage](https://atlassian.design/components/textfield/usage)
 */ const $ecaf8c9a10cf48c9$var$Textfield = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>{
    const { appearance: appearance = 'standard', className: className, elemAfterInput: elemAfterInput, elemBeforeInput: elemBeforeInput, isCompact: isCompact = false, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isMonospaced: isMonospaced = false, isReadOnly: isReadOnly = false, isRequired: isRequired = false, name: name, onBlur: onBlur, onChange: onChange, onFocus: onFocus, onMouseDown: onMouseDown, placeholder: placeholder, testId: testId, width: width, ...spreadProps } = props;
    const inputRef = (0, $eUqFw.useRef)(null);
    const handleOnFocus = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onFocus && onFocus(event);
        },
        action: 'focused',
        ...$ecaf8c9a10cf48c9$var$analyticsParams
    });
    const handleOnBlur = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onBlur && onBlur(event);
        },
        action: 'blurred',
        ...$ecaf8c9a10cf48c9$var$analyticsParams
    });
    const handleOnMouseDown = (0, $eUqFw.useCallback)((event)=>{
        // Running e.preventDefault() on the INPUT prevents double click behaviour
        // Sadly we needed this cast as the target type is being correctly set
        const target = event.target;
        if (target.tagName !== 'INPUT') event.preventDefault();
        if (inputRef && inputRef.current && !isDisabled && document.activeElement !== inputRef.current) inputRef.current.focus();
        onMouseDown && onMouseDown(event);
    }, [
        onMouseDown,
        isDisabled
    ]);
    const setInputRef = (0, $eUqFw.useCallback)((inputElement)=>{
        inputRef.current = inputElement;
        if (!ref) return;
        if (typeof ref === 'object') ref.current = inputElement;
        if (typeof ref === 'function') ref(inputElement);
    }, [
        ref
    ]);
    const containerStyles = (0, $eUqFw.useMemo)(()=>(0, $abUSh.containerStyles)(appearance, width), [
        appearance,
        width
    ]);
    const inputStyle = (0, $abUSh.inputStyles)();
    return(/**
     * It is not normally acceptable to add click and key handlers to
     * non-interactive elements as this is an accessibility anti-pattern.
     * However, because this instance is to handle events on all children that
     * should be associated with the input, we can add role="presentation" so
     * that there are no negative impacts to assistive technologies.
     */ /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        role: "presentation",
        "data-disabled": isDisabled ? isDisabled : undefined,
        "data-invalid": isInvalid ? isInvalid : undefined,
        "data-ds--text-field--container": true,
        "data-testid": testId && `${testId}-container`,
        onMouseDown: handleOnMouseDown,
        // TODO: When removing legacy theming fix this.
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        css: containerStyles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className
    }, elemBeforeInput, /*#__PURE__*/ (0, $byn9U.jsx)("input", {
        ...spreadProps,
        "aria-invalid": isInvalid ? isInvalid : undefined,
        // TODO: When removing legacy theming fix this.
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        css: inputStyle,
        "data-compact": isCompact ? isCompact : undefined,
        "data-ds--text-field--input": true,
        "data-monospaced": isMonospaced ? isMonospaced : undefined,
        "data-testid": testId,
        disabled: isDisabled,
        name: name,
        onBlur: handleOnBlur,
        onChange: onChange,
        onFocus: handleOnFocus,
        placeholder: placeholder,
        readOnly: isReadOnly,
        ref: setInputRef,
        required: isRequired
    }), elemAfterInput));
});
var $ecaf8c9a10cf48c9$export$2e2bcd8739ae039 = $ecaf8c9a10cf48c9$var$Textfield;

});
parcelRegister("abUSh", function(module, exports) {

$parcel$export(module.exports, "containerStyles", () => $6ff5b404db052892$export$5972a68b6e54f38f);
$parcel$export(module.exports, "inputStyles", () => $6ff5b404db052892$export$3eeb47dc8e6249d9);

var $PdmhA = parcelRequire("PdmhA");
const $6ff5b404db052892$var$backgroundColor = {
    standard: `var(--ds-background-input, ${(0, $PdmhA.N10)})`,
    subtle: 'transparent',
    none: 'transparent'
};
const $6ff5b404db052892$var$backgroundColorFocus = {
    standard: `var(--ds-background-input-pressed, ${(0, $PdmhA.N0)})`,
    subtle: `var(--ds-background-input-pressed, ${(0, $PdmhA.N0)})`,
    none: 'transparent'
};
const $6ff5b404db052892$var$backgroundColorHover = {
    standard: `var(--ds-background-input-hovered, ${(0, $PdmhA.N30)})`,
    subtle: `var(--ds-background-input-hovered, ${(0, $PdmhA.N30)})`,
    none: 'transparent'
};
const $6ff5b404db052892$var$borderColor = {
    standard: `var(--ds-border-input, ${(0, $PdmhA.N100)})`,
    subtle: 'transparent',
    none: 'transparent'
};
const $6ff5b404db052892$var$borderColorFocus = {
    standard: `var(--ds-border-focused, ${(0, $PdmhA.B200)})`,
    subtle: `var(--ds-border-focused, ${(0, $PdmhA.B200)})`,
    none: 'transparent'
};
const $6ff5b404db052892$var$borderColorHover = {
    standard: `var(--ds-border-input, ${(0, $PdmhA.N100)})`,
    subtle: "var(--ds-border-input, transparent)",
    none: 'transparent'
};
const $6ff5b404db052892$var$getContainerTextBgAndBorderColor = (appearance)=>({
        backgroundColor: $6ff5b404db052892$var$backgroundColor[appearance],
        borderColor: $6ff5b404db052892$var$borderColor[appearance],
        color: `var(--ds-text, ${0, $PdmhA.N900})`,
        cursor: 'text',
        '&:hover:not([data-disabled])': {
            backgroundColor: $6ff5b404db052892$var$backgroundColorHover[appearance],
            borderColor: $6ff5b404db052892$var$borderColorHover[appearance]
        },
        '&:focus-within:not([data-disabled])': {
            backgroundColor: $6ff5b404db052892$var$backgroundColorFocus[appearance],
            borderColor: $6ff5b404db052892$var$borderColorFocus[appearance],
            boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${$6ff5b404db052892$var$borderColorFocus[appearance]}`
        },
        '&[data-disabled]': {
            color: `var(--ds-text-disabled, ${0, $PdmhA.N70})`,
            cursor: 'not-allowed',
            // Disabled background and border styles should not be applied to components that
            // have either no background or transparent background to begin with
            ...appearance === 'standard' && {
                backgroundColor: `var(--ds-background-disabled, ${0, $PdmhA.N10})`,
                borderColor: `var(--ds-background-disabled, ${0, $PdmhA.N10})`
            }
        },
        '&[data-invalid], &[data-invalid]:hover': {
            borderColor: `var(--ds-border-danger, ${0, $PdmhA.R400})`,
            boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${`var(--ds-border-danger, ${0, $PdmhA.R400})`}`
        },
        '&[data-invalid]:focus-within': {
            backgroundColor: `var(--ds-background-input-pressed, ${0, $PdmhA.N0})`,
            borderColor: `var(--ds-border-focused, ${0, $PdmhA.B200})`,
            boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${`var(--ds-border-focused, ${0, $PdmhA.B200})`}`
        },
        '@media screen and (-ms-high-contrast: active)': {
            '&[data-invalid]:focus-within': {
                borderColor: 'Highlight'
            },
            '&:focus-within': {
                borderColor: 'Highlight'
            },
            '&[data-disabled]': {
                borderColor: 'GrayText'
            }
        }
    });
const $6ff5b404db052892$var$widthMap = {
    xsmall: 80,
    small: 160,
    medium: 240,
    large: 320,
    xlarge: 480
};
const $6ff5b404db052892$var$getMaxWidth = (width)=>!width ? `100%` : width in $6ff5b404db052892$var$widthMap ? $6ff5b404db052892$var$widthMap[width] : +width;
const $6ff5b404db052892$export$5972a68b6e54f38f = (appearance, width)=>({
        alignItems: 'center',
        ...$6ff5b404db052892$var$getContainerTextBgAndBorderColor(appearance),
        borderRadius: 3,
        borderWidth: "var(--ds-border-width, 1px)",
        // add 1px padding on both top and bottom to keep the same overall height after border reduced from 2px to 1px under feature flag
        ...appearance !== 'none' ? {
            padding: `${"var(--ds-border-width, 1px)"} 0`
        } : {},
        borderStyle: appearance === 'none' ? 'none' : 'solid',
        boxSizing: 'border-box',
        display: 'flex',
        flex: '1 1 100%',
        font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        justifyContent: 'space-between',
        maxWidth: $6ff5b404db052892$var$getMaxWidth(width),
        overflow: 'hidden',
        transition: `background-color 0.2s ease-in-out, border-color 0.2s ease-in-out`,
        wordWrap: 'break-word',
        verticalAlign: 'top',
        pointerEvents: 'auto'
    });
const $6ff5b404db052892$export$3eeb47dc8e6249d9 = ()=>({
        backgroundColor: 'transparent',
        border: 0,
        boxSizing: 'border-box',
        color: 'inherit',
        cursor: 'inherit',
        font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        minWidth: '0',
        outline: 'none',
        width: '100%',
        '&[data-monospaced]': {
            fontFamily: "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)"
        },
        '&[data-compact]': {
            padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-075, 6px)"}`
        },
        '&:not([data-compact])': {
            padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-075, 6px)"}`
        },
        '&[disabled]': {
            // Safari (WebKit) adds a -webkit-text-fill-color style to disabled inputs
            // which takes priority over color and makes the text unreadable. Need to
            // override it with the color we want.
            WebkitTextFillColor: `var(--ds-text-disabled, ${0, $PdmhA.N70})`
        },
        // Hide the clear indicator on Edge (Windows only)
        '&::-ms-clear': {
            display: 'none'
        },
        '&:invalid': {
            boxShadow: 'none'
        },
        '&:placeholder-shown': {
            textOverflow: 'ellipsis'
        },
        '&::placeholder': {
            color: `var(--ds-text-subtlest, ${0, $PdmhA.N200})`,
            '&:disabled': {
                color: `var(--ds-text-disabled, ${0, $PdmhA.N70})`
            }
        },
        '@media screen and (-ms-high-contrast: active)': {
            '&[disabled]': {
                color: 'GrayText'
            }
        }
    });

});


parcelRegister("c1K7Q", function(module, exports) {

$parcel$export(module.exports, "generateDataTestId", () => $9d0a034fe3d4cf2e$export$7de5661ad251801);

var $1ybV0 = parcelRequire("1ybV0");
const $9d0a034fe3d4cf2e$var$DISABLED = 'disabled';
const $9d0a034fe3d4cf2e$var$DUPLICATED = 'duplicated';
const $9d0a034fe3d4cf2e$var$REPLACED = 'replaced';
const $9d0a034fe3d4cf2e$var$DEFAULT_FF = 'replace-data-test-id-with-data-testid-in-bento-m2';
const $9d0a034fe3d4cf2e$var$getDataTestIdFlagValue = (featureFlag = $9d0a034fe3d4cf2e$var$DEFAULT_FF)=>// eslint-disable-next-line jira/ff/static-feature-flags
    (0, $1ybV0.getMultivariateFeatureFlag)(featureFlag, $9d0a034fe3d4cf2e$var$DISABLED, [
        $9d0a034fe3d4cf2e$var$DISABLED,
        $9d0a034fe3d4cf2e$var$DUPLICATED,
        $9d0a034fe3d4cf2e$var$REPLACED
    ]);
const $9d0a034fe3d4cf2e$export$7de5661ad251801 = (testId, featureFlag = $9d0a034fe3d4cf2e$var$DEFAULT_FF)=>{
    const flagValue = $9d0a034fe3d4cf2e$var$getDataTestIdFlagValue(featureFlag);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let testIdProps = {};
    switch(flagValue){
        case 'duplicated':
            testIdProps = {
                'data-test-id': testId,
                'data-testid': testId
            };
            break;
        case 'replaced':
            testIdProps = {
                'data-testid': testId
            };
            break;
        case 'disabled':
        default:
            testIdProps = {
                'data-test-id': testId
            };
            break;
    }
    return testIdProps;
};

});

parcelRegister("2jdHI", function(module, exports) {

$parcel$export(module.exports, "default", () => $3243fa342b695d88$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $dxIU5 = parcelRequire("dxIU5");
function $3243fa342b695d88$export$2e2bcd8739ae039(callback, delay, options) {
    const optionsRef = (0, $eUqFw.useRef)(options);
    // @ts-expect-error - TS7019 - Rest parameter 'args' implicitly has an 'any[]' type.
    const callbackRef = (0, $eUqFw.useRef)((...args)=>{
        callback(...args);
    });
    callbackRef.current = callback;
    const debouncedCallBack = (0, $eUqFw.useMemo)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    ()=>(0, (/*@__PURE__*/$parcel$interopDefault($dxIU5)))((...args)=>callbackRef.current(...args), delay, optionsRef.current), [
        delay
    ]);
    (0, $eUqFw.useEffect)(()=>debouncedCallBack.cancel, [
        debouncedCallBack
    ]);
    return [
        debouncedCallBack,
        debouncedCallBack.cancel
    ];
}

});

parcelRegister("9JEYY", function(module, exports) {

$parcel$export(module.exports, "getTextFieldAttributes", () => $98a728a18d600acd$export$dfd7972bcd113afb);
const $98a728a18d600acd$export$dfd7972bcd113afb = (value = '')=>{
    const wordCount = value.split(/s+/).filter((word)=>word !== '').length;
    return {
        queryLength: value.length,
        wordCount: wordCount
    };
};

});

parcelRegister("j33Mg", function(module, exports) {

$parcel$export(module.exports, "default", () => $7a6d42843abbf146$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $7a6d42843abbf146$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    clear: {
        "id": "business-filters.simple-search-field.clear",
        "defaultMessage": "Clear"
    }
});

});


parcelRegister("bSsl1", function(module, exports) {

$parcel$export(module.exports, "default", () => $cf2ff9f75b0cc835$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7rh0R = parcelRequire("7rh0R");

var $ciZ8Y = parcelRequire("ciZ8Y");

var $gGtKh = parcelRequire("gGtKh");

var $3f7Cz = parcelRequire("3f7Cz");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $cf2ff9f75b0cc835$var$LazyAddPeopleWithAvatars = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("ixyeo")), {
    ssr: false,
    moduleId: "./src/packages/business/shared/components/invite-people/src/ui/add-people-with-avatars/main.tsx"
});
const $cf2ff9f75b0cc835$var$AddPeopleWithAvatar = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ciZ8Y.ErrorBoundary), {
        id: "async.jira-business.invite-people.add-people-with-avatars",
        packageName: "jiraBusinessInvitePeople",
        teamName: "jira-warepil"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "invite-button-with-avatars",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cf2ff9f75b0cc835$var$AvatarFallback, null)
    }, props?.hasInviteButton === false ? // not including the Add People provider if the invite button is not needed
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cf2ff9f75b0cc835$var$LazyAddPeopleWithAvatars, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3f7Cz.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cf2ff9f75b0cc835$var$LazyAddPeopleWithAvatars, props))));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cf2ff9f75b0cc835$var$AvatarFallback = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i1ylp",
            __cmplp.className
        ])
    });
});
var $cf2ff9f75b0cc835$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($cf2ff9f75b0cc835$var$AddPeopleWithAvatar);

});
parcelRegister("3f7Cz", function(module, exports) {

$parcel$export(module.exports, "default", () => $5829e6ed86dc42e3$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $ciZ8Y = parcelRequire("ciZ8Y");

var $bvGWz = parcelRequire("bvGWz");

var $3MjJX = parcelRequire("3MjJX");
const $5829e6ed86dc42e3$var$AddPeopleModal = ({ shouldUseInvitePeopleModal: shouldUseInvitePeopleModal, source: source })=>{
    const { isModalOpen: isModalOpen, closeAddPeopleModal: closeAddPeopleModal } = (0, $bvGWz.useAddPeople)();
    if (isModalOpen) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3MjJX.ProjectInvitePeopleModal), {
        onModalClose: closeAddPeopleModal,
        shouldUseInvitePeopleModal: shouldUseInvitePeopleModal,
        source: source
    });
    return null;
};
const $5829e6ed86dc42e3$var$AddPeople = ({ children: children, shouldUseInvitePeopleModal: shouldUseInvitePeopleModal, source: source })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bvGWz.AddPeopleProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ciZ8Y.ErrorBoundary), {
        id: "jira-business.invite-people.ui.add-people",
        packageName: "jira-business.invite-people.ui.add-people",
        teamName: "jira-warepil"
    }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5829e6ed86dc42e3$var$InviteWrapper, {
        "data-testid": "business-invite-people.ui.add-people-with-avatars.add-people.invite-wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5829e6ed86dc42e3$var$AddPeopleModal, {
        shouldUseInvitePeopleModal: shouldUseInvitePeopleModal,
        source: source
    }))));
var $5829e6ed86dc42e3$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($5829e6ed86dc42e3$var$AddPeople);
// this wrapper prevents the modal component to inherit any css logic from its parent, which could cause interferences in the consumer's UI
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5829e6ed86dc42e3$var$InviteWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0cglyw",
            __cmplp.className
        ])
    });
});

});
parcelRegister("bvGWz", function(module, exports) {

$parcel$export(module.exports, "AddPeopleProvider", () => $f3a4a647f29aa9d7$export$6d41c2327e862d9d);
$parcel$export(module.exports, "useAddPeople", () => $f3a4a647f29aa9d7$export$93ea361ec674cff6);

var $eUqFw = parcelRequire("eUqFw");

var $kQAZu = parcelRequire("kQAZu");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");
const $f3a4a647f29aa9d7$var$AddPeopleContext = /*#__PURE__*/ (0, $eUqFw.createContext)({
    triggerBtnRef: {
        current: null
    },
    isModalOpen: false,
    // Replace with lodash/noop
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    openAddPeopleModal: ()=>{},
    // Replace with lodash/noop
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    closeAddPeopleModal: ()=>{}
});
const $f3a4a647f29aa9d7$export$6d41c2327e862d9d = ({ children: children })=>{
    const projectData = (0, $kQAZu.useProject)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [isModalOpen, setIsModalOpen] = (0, $eUqFw.useState)(false);
    const triggerBtnRef = (0, $eUqFw.useRef)(null);
    const onCloseCallbackRef = (0, $eUqFw.useRef)();
    const openAddPeopleModal = (0, $eUqFw.useCallback)((onClose, source)=>{
        setIsModalOpen(true);
        const eventName = projectData.isSimplified ? 'jwmProjectInviteComponent' : 'jwmInstanceInviteComponent';
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', eventName, {
            source: source
        });
        if (onClose) onCloseCallbackRef.current = onClose;
    }, [
        createAnalyticsEvent,
        projectData.isSimplified
    ]);
    const closeAddPeopleModal = (0, $eUqFw.useCallback)(()=>{
        setIsModalOpen(false);
        if (typeof onCloseCallbackRef.current === 'function') {
            onCloseCallbackRef.current();
            onCloseCallbackRef.current = null;
        }
    }, []);
    const context = (0, $eUqFw.useMemo)(()=>({
            triggerBtnRef: triggerBtnRef,
            isModalOpen: isModalOpen,
            openAddPeopleModal: openAddPeopleModal,
            closeAddPeopleModal: closeAddPeopleModal
        }), [
        triggerBtnRef,
        isModalOpen,
        openAddPeopleModal,
        closeAddPeopleModal
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f3a4a647f29aa9d7$var$AddPeopleContext.Provider, {
        value: context
    }, children);
};
const $f3a4a647f29aa9d7$export$93ea361ec674cff6 = ()=>(0, $eUqFw.useContext)($f3a4a647f29aa9d7$var$AddPeopleContext);

});

parcelRegister("3MjJX", function(module, exports) {

$parcel$export(module.exports, "ProjectInvitePeopleModal", () => $1368af08b2bd60b0$export$6dfea89767cb5ac1);

var $eUqFw = parcelRequire("eUqFw");

var $kQAZu = parcelRequire("kQAZu");

var $hlZx3 = parcelRequire("hlZx3");

var $66rnh = parcelRequire("66rnh");

var $d1I0W = parcelRequire("d1I0W");
const $1368af08b2bd60b0$export$6dfea89767cb5ac1 = ({ onModalClose: onModalClose, shouldUseInvitePeopleModal: shouldUseInvitePeopleModal = false, source: source })=>{
    const projectData = (0, $kQAZu.useProject)();
    const { handleAddSuccess: handleAddSuccess, handleError: handleError } = (0, $hlZx3.useInviteModalHandlers)();
    if (!shouldUseInvitePeopleModal && projectData.isSimplified) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $66rnh.AddPeopleModal), {
        onModalClose: onModalClose,
        onInviteSuccess: handleAddSuccess,
        onInviteError: handleError
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d1I0W.InvitePeopleModal), {
        onModalClose: onModalClose,
        onInviteSuccess: handleAddSuccess,
        onInviteError: handleError,
        source: source
    });
};

});
parcelRegister("hlZx3", function(module, exports) {

$parcel$export(module.exports, "useInviteModalHandlers", () => $72fe370f230f9c2c$export$f696e14fc423d0b);

var $eUqFw = parcelRequire("eUqFw");

var $kQAZu = parcelRequire("kQAZu");

var $guiFP = parcelRequire("guiFP");

var $k8Qyf = parcelRequire("k8Qyf");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $gd0Sp = parcelRequire("gd0Sp");


var $f90H0 = parcelRequire("f90H0");

var $bLjrh = parcelRequire("bLjrh");
const $72fe370f230f9c2c$export$f696e14fc423d0b = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagService)();
    const { isSiteAdmin: isSiteAdmin } = (0, $gd0Sp.useTenantContext)();
    const projectData = (0, $kQAZu.useProject)();
    const handleAddSuccess = (0, $eUqFw.useCallback)(({ modalType: modalType, totalPeopleAdded: totalPeopleAdded, email: email, inviteStatus: inviteStatus })=>{
        const hasSentInvitation = inviteStatus === (0, $f90H0.InvitationStatusEnum).INVITED;
        const hasSuccessfullyAddedPeople = !inviteStatus && projectData.permissions.administerProject;
        showFlag(hasSuccessfullyAddedPeople ? (0, $bLjrh.createAddSuccessFlagConfig)({
            totalPeopleAdded: totalPeopleAdded,
            email: email,
            projectKey: projectData.key
        }) : (0, $bLjrh.createInviteSuccessFlagConfig)({
            totalPeopleAdded: totalPeopleAdded,
            email: email,
            hasSentInvitation: hasSentInvitation
        }));
        // The event tracked by the Invite People SLOs
        (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), `jwm${modalType}Invite success`, {
            inviteStatus: inviteStatus
        });
    }, [
        createAnalyticsEvent,
        showFlag,
        projectData
    ]);
    const handleError = (0, $eUqFw.useCallback)(({ modalType: modalType, errorMessage: errorMessage, statusCode: statusCode })=>{
        if (errorMessage.includes((0, $aa13349e4e2d4a46$export$4e427f77b64bbbed)) || errorMessage.includes((0, $aa13349e4e2d4a46$export$20ef020abfaa9ec))) {
            showFlag((0, $bLjrh.createInviteFailedUserLimitFlagConfig)(isSiteAdmin, createAnalyticsEvent));
            (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'userLimit reached', `jwm${modalType}Invite`);
            return;
        }
        if (errorMessage.includes((0, $aa13349e4e2d4a46$export$a1d765adf759361e))) showFlag((0, $bLjrh.inviteFailBadRequestFlagConfig));
        else if (errorMessage.includes((0, $aa13349e4e2d4a46$export$c7f012c6e67c4217))) showFlag((0, $bLjrh.inviteFailNetworkErrorFlagConfig));
        else if (errorMessage.includes((0, $aa13349e4e2d4a46$export$c8a538cf4ae41623)) || errorMessage.includes((0, $aa13349e4e2d4a46$export$9bbcbc11675c1278)) || errorMessage.includes((0, $aa13349e4e2d4a46$export$a51af3c30283d234))) showFlag((0, $bLjrh.inviteFailGenericFlagConfig));
        else showFlag((0, $bLjrh.inviteFailFlagConfig));
        const isClientError = statusCode && statusCode >= 400 && statusCode < 500;
        if (errorMessage.includes((0, $aa13349e4e2d4a46$export$14fb68f74ccc8b23)) || isClientError) return;
        (0, $guiFP.default)({
            meta: {
                id: `jwm${modalType}Invite`,
                packageName: (0, $aa13349e4e2d4a46$export$b8b9d90f9e5bd72b),
                teamName: 'jira-warepil'
            },
            attributes: {
                message: errorMessage
            },
            error: new Error(errorMessage),
            sendToPrivacyUnsafeSplunk: true
        });
        // The event tracked by the Invite People SLOs
        (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), `jwm${modalType}Invite failed`);
    }, [
        createAnalyticsEvent,
        isSiteAdmin,
        showFlag
    ]);
    return {
        handleAddSuccess: handleAddSuccess,
        handleError: handleError
    };
};

});
const $aa13349e4e2d4a46$export$b8b9d90f9e5bd72b = 'jira-business.invite-people';
const $aa13349e4e2d4a46$export$a1d765adf759361e = 'Check your request, then give it another try.';
const $aa13349e4e2d4a46$export$c7f012c6e67c4217 = 'Check your network connection, then give it another try.';
const $aa13349e4e2d4a46$export$c8a538cf4ae41623 = 'AUTH_FAILED';
const $aa13349e4e2d4a46$export$9bbcbc11675c1278 = 'SERVER_ERROR';
const $aa13349e4e2d4a46$export$a51af3c30283d234 = 'USER_NOT_FOUND';
const $aa13349e4e2d4a46$export$4e427f77b64bbbed = 'LICENSE_LIMIT_REACHED';
const $aa13349e4e2d4a46$export$20ef020abfaa9ec = 'Licence Exceeded';
const $aa13349e4e2d4a46$export$14fb68f74ccc8b23 = 'Recaptcha validation failed';

parcelRegister("f90H0", function(module, exports) {

$parcel$export(module.exports, "InvitationStatusEnum", () => $2279512461e31f50$export$2e0a7d2dc28c9a18);
const $2279512461e31f50$export$2e0a7d2dc28c9a18 = {
    ACCESS_REQUESTED: 'ACCESS_REQUESTED',
    INVITED: 'INVITED'
};

});

parcelRegister("bLjrh", function(module, exports) {

$parcel$export(module.exports, "inviteFailFlagConfig", () => $493a4fc4ed3495fe$export$95c6157ced8b3439);
$parcel$export(module.exports, "inviteFailGenericFlagConfig", () => $493a4fc4ed3495fe$export$1108ab4b8a5d8a7d);
$parcel$export(module.exports, "inviteFailBadRequestFlagConfig", () => $493a4fc4ed3495fe$export$7f2d6442eed4d708);
$parcel$export(module.exports, "inviteFailNetworkErrorFlagConfig", () => $493a4fc4ed3495fe$export$c3bdacfc2255a9ed);
$parcel$export(module.exports, "createInviteSuccessFlagConfig", () => $493a4fc4ed3495fe$export$d456881895c2a0b2);
$parcel$export(module.exports, "createAddSuccessFlagConfig", () => $493a4fc4ed3495fe$export$cca35dec2a083169);
$parcel$export(module.exports, "createInviteFailedUserLimitFlagConfig", () => $493a4fc4ed3495fe$export$251dc06b3962c565);

var $jMP2a = parcelRequire("jMP2a");

var $7Ya7f = parcelRequire("7Ya7f");
const $493a4fc4ed3495fe$export$8c9a09c293b933fb = ({ specificDescription: specificDescription, agnosticDescription: agnosticDescription, totalPeopleAdded: totalPeopleAdded, email: email })=>{
    if (totalPeopleAdded <= 0) return [
        agnosticDescription,
        {}
    ];
    return [
        specificDescription,
        {
            totalPeopleAddedMinusOne: totalPeopleAdded - 1,
            totalPeopleAdded: totalPeopleAdded,
            email: email
        }
    ];
};
const $493a4fc4ed3495fe$export$95c6157ced8b3439 = {
    type: 'error',
    title: (0, $7Ya7f.default).inviteFailedMessageTitle,
    description: (0, $7Ya7f.default).inviteFailedMessageDescription,
    actions: [
        {
            content: (0, $7Ya7f.default).inviteFailedMessageCta,
            onClick: ()=>window.open('/secure/ContactAdministrators!default.jspa', '_blank')
        }
    ]
};
const $493a4fc4ed3495fe$export$1108ab4b8a5d8a7d = {
    type: 'error',
    title: (0, $7Ya7f.default).inviteFailedMessageTitle,
    description: (0, $7Ya7f.default).inviteFailedGenericMessageDescription
};
const $493a4fc4ed3495fe$export$7f2d6442eed4d708 = {
    type: 'error',
    title: (0, $7Ya7f.default).inviteFailedMessageTitle,
    description: (0, $7Ya7f.default).inviteFailedBadRequestMessageDescription
};
const $493a4fc4ed3495fe$export$c3bdacfc2255a9ed = {
    type: 'error',
    title: (0, $7Ya7f.default).inviteFailedMessageTitle,
    description: (0, $7Ya7f.default).inviteFailedNetworkErrorMessageDescription
};
const $493a4fc4ed3495fe$export$d456881895c2a0b2 = ({ totalPeopleAdded: totalPeopleAdded, email: email, hasSentInvitation: hasSentInvitation })=>{
    if (!hasSentInvitation) return {
        type: 'success',
        title: (0, $7Ya7f.default).requestInviteSuccessMessageTitle,
        description: $493a4fc4ed3495fe$export$8c9a09c293b933fb({
            agnosticDescription: (0, $7Ya7f.default).requestInviteSuccessMessageDescriptionAgnostic,
            specificDescription: (0, $7Ya7f.default).requestInviteSuccessMessageDescription,
            totalPeopleAdded: totalPeopleAdded,
            email: email
        })
    };
    return {
        type: 'success',
        title: (0, $7Ya7f.default).inviteSuccessMessageTitle,
        description: $493a4fc4ed3495fe$export$8c9a09c293b933fb({
            agnosticDescription: (0, $7Ya7f.default).inviteSuccessMessageDescriptionAgnostic,
            specificDescription: (0, $7Ya7f.default).inviteSuccessMessageDescription,
            totalPeopleAdded: totalPeopleAdded,
            email: email
        })
    };
};
const $493a4fc4ed3495fe$export$cca35dec2a083169 = ({ totalPeopleAdded: totalPeopleAdded, email: email, projectKey: projectKey })=>({
        type: 'success',
        title: (0, $7Ya7f.default).peopleAddedSuccessMessageTitle,
        description: $493a4fc4ed3495fe$export$8c9a09c293b933fb({
            agnosticDescription: (0, $7Ya7f.default).peopleAddedSuccessMessageDescriptionAgnostic,
            specificDescription: (0, $7Ya7f.default).peopleAddedSuccessMessageDescription,
            totalPeopleAdded: totalPeopleAdded,
            email: email
        }),
        actions: [
            {
                content: (0, $7Ya7f.default).peopleAddedManageAccess,
                onClick: ()=>window.location.assign(`/jira/core/projects/${projectKey}/settings/access`)
            }
        ]
    });
const $493a4fc4ed3495fe$export$251dc06b3962c565 = (isSiteAdmin, createAnalyticsEvent)=>({
        type: 'warning',
        title: (0, $7Ya7f.default).userLimitInviteErrorTitle,
        description: isSiteAdmin ? (0, $7Ya7f.default).userLimitInviteErrorDescriptionAdmin : (0, $7Ya7f.default).userLimitInviteErrorDescription,
        actions: isSiteAdmin ? [
            {
                content: (0, $7Ya7f.default).upgradePlan,
                onClick: ()=>{
                    (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'upgradePlan');
                    window.open('/admin/billing/applications', '_blank');
                }
            },
            {
                content: (0, $7Ya7f.default).viewUsers,
                onClick: ()=>{
                    (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'viewUsers');
                    window.open('/admin/users', '_blank');
                }
            }
        ] : [
            {
                content: (0, $7Ya7f.default).inviteFailedMessageCta,
                onClick: ()=>{
                    (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'contactAdmin');
                    window.open('/secure/ContactAdministrators!default.jspa', '_blank');
                }
            }
        ]
    });

});
parcelRegister("7Ya7f", function(module, exports) {

$parcel$export(module.exports, "default", () => $97084d0fb7d00df5$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $97084d0fb7d00df5$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    inviteSuccessMessageTitle: {
        "id": "business-invite-people.controllers.modal-handlers.invite-success-message-title",
        "defaultMessage": "Invitation sent"
    },
    inviteSuccessMessageDescription: {
        "id": "business-invite-people.controllers.modal-handlers.invite-success-message-description",
        "defaultMessage": "You've invited {totalPeopleAdded, plural, one {{email}} =2 {{email} and {totalPeopleAddedMinusOne} other} other {{email} and {totalPeopleAddedMinusOne} others}} to this business project."
    },
    inviteSuccessMessageDescriptionAgnostic: {
        "id": "business-invite-people.controllers.modal-handlers.invite-success-message-description-agnostic",
        "defaultMessage": "You've successfully invited people to your business project."
    },
    inviteFailedMessageTitle: {
        "id": "business-invite-people.controllers.modal-handlers.invite-failed-message-title",
        "defaultMessage": "Something went wrong"
    },
    inviteFailedMessageDescription: {
        "id": "business-invite-people.controllers.modal-handlers.invite-failed-message-description",
        "defaultMessage": "We weren\u2019t able to invite any users. Contact your admin for help."
    },
    inviteFailedMessageCta: {
        "id": "business-invite-people.controllers.modal-handlers.invite-failed-message-cta",
        "defaultMessage": "Contact your admin"
    },
    inviteFailedGenericMessageDescription: {
        "id": "business-invite-people.controllers.modal-handlers.invite-failed-generic-message-description",
        "defaultMessage": "We weren\u2019t able to invite any users, please try again."
    },
    inviteFailedBadRequestMessageDescription: {
        "id": "business-invite-people.controllers.modal-handlers.invite-failed-bad-request-message-description",
        "defaultMessage": "We weren\u2019t able to invite any users. Check your request, then give it another try."
    },
    inviteFailedNetworkErrorMessageDescription: {
        "id": "business-invite-people.controllers.modal-handlers.invite-failed-network-error-message-description",
        "defaultMessage": "We weren\u2019t able to invite any users. Check your network connection, then give it another try."
    },
    requestInviteSuccessMessageTitle: {
        "id": "business-invite-people.controllers.modal-handlers.request-invite-success-message-title",
        "defaultMessage": "Access request sent to your admin"
    },
    requestInviteSuccessMessageDescription: {
        "id": "business-invite-people.controllers.modal-handlers.request-invite-success-message-description",
        "defaultMessage": "Your admin needs to approve access for {totalPeopleAdded, plural, one {{email}} =2 {{email} and {totalPeopleAddedMinusOne} other} other {{email} and {totalPeopleAddedMinusOne} others}}."
    },
    requestInviteSuccessMessageDescriptionAgnostic: {
        "id": "business-invite-people.controllers.modal-handlers.request-invite-success-message-description-agnostic",
        "defaultMessage": "Your admin needs to approve access for people to your business project."
    },
    peopleAddedSuccessMessageTitle: {
        "id": "business-invite-people.controllers.modal-handlers.people-added-success-message-title",
        "defaultMessage": "New people added"
    },
    peopleAddedSuccessMessageDescription: {
        "id": "business-invite-people.controllers.modal-handlers.people-added-success-message-description",
        "defaultMessage": "{totalPeopleAdded, plural, one {{email}} =2 {{email} and {totalPeopleAddedMinusOne} other} other {{email} and {totalPeopleAddedMinusOne} others}} added to the project. You can also add teammates and manage their access to the project from Project settings"
    },
    peopleAddedSuccessMessageDescriptionAgnostic: {
        "id": "business-invite-people.controllers.modal-handlers.people-added-success-message-description-agnostic",
        "defaultMessage": "People added to the project. You can also add teammates and manage their access to the project from Project settings"
    },
    peopleAddedManageAccess: {
        "id": "business-invite-people.controllers.modal-handlers.people-added-manage-access",
        "defaultMessage": "Manage access"
    },
    userLimitInviteErrorTitle: {
        "id": "business-invite-people.controllers.modal-handlers.user-limit-invite-error-title",
        "defaultMessage": "Can't add more people"
    },
    userLimitInviteErrorDescriptionAdmin: {
        "id": "business-invite-people.controllers.modal-handlers.user-limit-invite-error-description-admin",
        "defaultMessage": "You've reached your user limit. Upgrade your plan or remove other users."
    },
    userLimitInviteErrorDescription: {
        "id": "business-invite-people.controllers.modal-handlers.user-limit-invite-error-description",
        "defaultMessage": "You've reached your user limit. Contact your admin for help."
    },
    viewUsers: {
        "id": "business-invite-people.controllers.modal-handlers.view-users",
        "defaultMessage": "View users"
    },
    upgradePlan: {
        "id": "business-invite-people.controllers.modal-handlers.upgrade-plan",
        "defaultMessage": "Upgrade plan"
    }
});

});



parcelRegister("66rnh", function(module, exports) {

$parcel$export(module.exports, "AddPeopleModal", () => $0d2c4bae7dd02578$export$b28f48897cdf7241);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $7rh0R = parcelRequire("7rh0R");

var $kQAZu = parcelRequire("kQAZu");

var $ciZ8Y = parcelRequire("ciZ8Y");

var $gGtKh = parcelRequire("gGtKh");

var $d6f6c = parcelRequire("d6f6c");

var $c7H0g = parcelRequire("c7H0g");

var $bvGWz = parcelRequire("bvGWz");


const $0d2c4bae7dd02578$export$a4917c848b5c6ce8 = (0, $7rh0R.lazy)(()=>(parcelRequire("5zF4d")), {
    ssr: false,
    moduleId: "./src/packages/permissions-administration/components/project-add-people/src/index.tsx"
});
const $0d2c4bae7dd02578$var$userInviteErrorCodes = {
    BAD_REQUEST_ERROR_CODE: $aa13349e4e2d4a46$export$a1d765adf759361e,
    NETWORK_ERROR_CODE: $aa13349e4e2d4a46$export$c7f012c6e67c4217,
    AUTH_FAILED_ERROR_CODE: $aa13349e4e2d4a46$export$c8a538cf4ae41623,
    SERVER_ERROR_ERROR_CODE: $aa13349e4e2d4a46$export$9bbcbc11675c1278,
    USER_NOT_FOUND_ERROR_CODE: $aa13349e4e2d4a46$export$a51af3c30283d234
};
const $0d2c4bae7dd02578$export$b28f48897cdf7241 = /*#__PURE__*/ (0, $eUqFw.memo)(({ onInviteSuccess: onInviteSuccess, onInviteError: onInviteError, onModalClose: onModalClose })=>{
    const { triggerBtnRef: triggerBtnRef } = (0, $bvGWz.useAddPeople)();
    const projectData = (0, $kQAZu.useProject)();
    const isAdmin = (0, $c7H0g.useIsAdmin)();
    const handleInviteSuccess = (0, $eUqFw.useCallback)((addedParties, _role)=>{
        onInviteSuccess({
            totalPeopleAdded: addedParties.length,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            email: addedParties[0]?.email || addedParties[0]?.displayName,
            modalType: 'Project'
        });
    }, [
        onInviteSuccess
    ]);
    // From the given error message, we want to search for a known error code defined under the user invite endpoint
    // Otherwise, we return the whole message and use that as error code for mapping later on
    const extractErrorCode = (message)=>{
        // Typescript assumes Object.keys is of type string[] so need to type cast
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        for (const errorCode of Object.keys($0d2c4bae7dd02578$var$userInviteErrorCodes)){
            const errorMessage = $0d2c4bae7dd02578$var$userInviteErrorCodes[errorCode];
            if (message.includes(errorMessage)) return errorCode;
        }
        return message; // Return original message if no error code found
    };
    const handleInviteFailure = (0, $eUqFw.useCallback)((errors)=>{
        const userInviteErrorsWithCode = {};
        errors.forEach((error)=>{
            // Group all errors by known user invite error codes
            const errorCode = extractErrorCode(error.message);
            if (errorCode) {
                if (!userInviteErrorsWithCode[errorCode]) userInviteErrorsWithCode[errorCode] = [];
                userInviteErrorsWithCode[errorCode].push(error);
            }
        });
        // Join messages with the same error code
        const groupedUserInviteErrors = Object.values(userInviteErrorsWithCode).map((group)=>{
            const statusCode = group[0]?.statusCode; // Assuming all errors with same error code have the same status code
            const messages = group.map((obj)=>obj.message).join('\n');
            return {
                message: messages,
                statusCode: statusCode
            };
        });
        groupedUserInviteErrors.forEach((groupedUserInviteError)=>{
            onInviteError({
                modalType: 'Project',
                errorMessage: groupedUserInviteError.message,
                statusCode: groupedUserInviteError.statusCode
            });
        });
    }, [
        onInviteError
    ]);
    const { id: id, key: key } = projectData;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ciZ8Y.ErrorBoundary), {
        id: "async.jira-business.project-invite-people-modal.add-people",
        packageName: "jira-business.project-invite-people-modal.add-people",
        teamName: "jira-warepil"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireTrackAnalytics), {
        eventName: "jwmProjectInviteComponent viewed"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "add-people-modal-lazy",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0d2c4bae7dd02578$export$a4917c848b5c6ce8, {
        isOpen: true,
        triggerBtnRef: triggerBtnRef,
        onClose: onModalClose,
        onAddSuccess: handleInviteSuccess,
        onError: handleInviteFailure,
        projectId: id,
        projectKey: key,
        projectType: "business",
        isAdmin: isAdmin,
        baseUrl: "",
        analyticsPrefix: "",
        allowFlags: false,
        onStopPerfMetric: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
    })));
});

});
parcelRegister("5zF4d", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('2hmUs'),
            load('bCeK4'),
            load('6HI0g')
        ]);
        const value = parcelRequire('4urEy');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("2hmUs"),
        load("bCeK4"),
        load("6HI0g")
    ]).then(()=>parcelRequire('4urEy'));
}

});


parcelRegister("d1I0W", function(module, exports) {

$parcel$export(module.exports, "InvitePeopleModal", () => $c68f3c6d5279f8a1$export$e3ec81c4d0451f63);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $aOw1G = parcelRequire("aOw1G");

var $kQAZu = parcelRequire("kQAZu");

var $kGQen = parcelRequire("kGQen");

var $exb0h = parcelRequire("exb0h");

var $ciZ8Y = parcelRequire("ciZ8Y");

var $1ybV0 = parcelRequire("1ybV0");

var $gGtKh = parcelRequire("gGtKh");

var $10fdS = parcelRequire("10fdS");

var $d6f6c = parcelRequire("d6f6c");

var $6Ua7e = parcelRequire("6Ua7e");

var $jD3pk = parcelRequire("jD3pk");

var $6WXNs = parcelRequire("6WXNs");
var $eIp1n = parcelRequire("eIp1n");

var $ab6rA = parcelRequire("ab6rA");
var $dWLk9 = parcelRequire("dWLk9");
var $c7H0g = parcelRequire("c7H0g");

var $f90H0 = parcelRequire("f90H0");

const $c68f3c6d5279f8a1$export$cbfde4f653ce234 = (0, $7rh0R.lazy)(()=>(parcelRequire("9Bx8m")), {
    ssr: false,
    moduleId: "../platform/packages/people-and-teams/invite-people/src/index.ts"
});
const $c68f3c6d5279f8a1$export$4d2a63c83bbce998 = (res)=>{
    if (res.accessRequested?.length) return (0, $f90H0.InvitationStatusEnum).ACCESS_REQUESTED;
    return (0, $f90H0.InvitationStatusEnum).INVITED;
};
const $c68f3c6d5279f8a1$var$LIST_ROUTES = [
    (0, $exb0h.ROUTE_NAMES).SOFTWARE_LIST_CLASSIC,
    (0, $exb0h.ROUTE_NAMES).SOFTWARE_LIST
];
const $c68f3c6d5279f8a1$var$isFailureResponse = (res)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    res.failure !== undefined;
const $c68f3c6d5279f8a1$export$e3ec81c4d0451f63 = /*#__PURE__*/ (0, $eUqFw.memo)(({ onInviteSuccess: onInviteSuccess, onInviteError: onInviteError, onModalClose: onModalClose, source: source = 'projectBoard' })=>{
    const route = (0, $10fdS.useCurrentRoute)();
    const cloudId = (0, $dWLk9.useCloudId)();
    const appEditions = (0, $ab6rA.useAppEditions)();
    const { data: orgId } = (0, $jD3pk.useOrgId)();
    const projectData = (0, $kQAZu.useProject)();
    const isAdmin = (0, $c7H0g.useIsAdmin)();
    const onInviteCompleteHandler = (0, $eUqFw.useCallback)((response)=>{
        if ($c68f3c6d5279f8a1$var$isFailureResponse(response)) {
            const { message: message, status: status } = response.failure;
            if ((0, $1ybV0.ff)('filter-out-client-errors-from-instance-admin-invite-users')) onInviteError({
                modalType: 'Instance',
                errorMessage: message,
                statusCode: status
            });
            else onInviteError({
                modalType: 'Instance',
                errorMessage: message
            });
            return;
        }
        const inviteStatus = $c68f3c6d5279f8a1$export$4d2a63c83bbce998(response);
        const { invited: invited, accessRequested: accessRequested } = response;
        onInviteSuccess({
            totalPeopleAdded: invited.length || accessRequested.length,
            email: invited[0]?.email || accessRequested[0]?.email || '',
            modalType: 'Instance',
            inviteStatus: inviteStatus
        });
    }, [
        onInviteError,
        onInviteSuccess
    ]);
    const isSoftwareRoute = (0, $eUqFw.useMemo)(()=>$c68f3c6d5279f8a1$var$LIST_ROUTES.includes(route.name), [
        route
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ciZ8Y.ErrorBoundary), {
        id: "async.jira-business.project-invite-people-modal.invite-people",
        packageName: "jira-business.project-invite-people-modal.invite-people",
        teamName: "jira-warepil"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "project-invite-people-modal.invite-people",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kGQen.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aOw1G.default), {
        onClose: onModalClose,
        width: "small",
        shouldScrollInViewport: true,
        testId: "business-invite-people.ui.add-people-with-avatars.add-people.project-invite-people-modal.invite-people-modal"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireTrackAnalytics), {
        eventName: "jwmInstanceInviteComponent viewed"
    }), isSoftwareRoute ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6Ua7e.default), {
        isOpen: true,
        cloudId: cloudId,
        projectId: projectData.id,
        jiraProjectKey: projectData.key,
        isSiteAdmin: isAdmin,
        onClose: onModalClose,
        appEdition: (0, $6WXNs.getEdition)((0, $eIp1n.JIRA_SOFTWARE), appEditions),
        jiraProjectName: projectData.name
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c68f3c6d5279f8a1$export$cbfde4f653ce234, {
        onSendHandler: onModalClose,
        onInviteCompletedHandler: onInviteCompleteHandler,
        onCancelHandler: onModalClose,
        resourceAri: `ari:cloud:jira::site/${cloudId}`,
        continueUrl: window.location.href,
        enableThirdParty: true,
        source: source,
        orgId: orgId
    })))));
});

});
parcelRegister("kGQen", function(module, exports) {

$parcel$export(module.exports, "ShortcutRegistryContext", () => $082205e2100625d8$export$ebbb59327adb551a);
$parcel$export(module.exports, "default", () => $082205e2100625d8$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $fVFUy = parcelRequire("fVFUy");
const $082205e2100625d8$export$ebbb59327adb551a = /*#__PURE__*/ (0, $eUqFw.createContext)((0, $fVFUy.rootRegistry));
const $082205e2100625d8$var$ShortcutScope = ({ children: children = null })=>{
    const registry = (0, $eUqFw.useMemo)(()=>new (0, $fVFUy.ShortcutRegistry)(), []);
    const parentRegistry = (0, $eUqFw.useContext)($082205e2100625d8$export$ebbb59327adb551a) || (0, $fVFUy.rootRegistry);
    (0, $eUqFw.useEffect)(()=>{
        // "This only happens ONCE.  But it happens AFTER the initial render."
        const removeRegistry = parentRegistry.addChildRegistry(registry);
        return removeRegistry;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($082205e2100625d8$export$ebbb59327adb551a.Provider, {
        value: registry
    }, children);
};
var $082205e2100625d8$export$2e2bcd8739ae039 = false ? ({ children: children = null })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children) : $082205e2100625d8$var$ShortcutScope;

});
parcelRegister("fVFUy", function(module, exports) {

$parcel$export(module.exports, "ShortcutRegistry", () => $3843ad0413ec519e$export$ca1c75b575abf5ff);
$parcel$export(module.exports, "rootRegistry", () => $3843ad0413ec519e$export$1dd4c61d1ce1fa15);
/* eslint-disable jira/js/no-reduce-accumulator-spread */ /**
 * A tree-like registry of shortcuts, with a default, root registry.
 */ 
var $fUTZC = parcelRequire("fUTZC");

var $6G5mG = parcelRequire("6G5mG");

var $ldoFd = parcelRequire("ldoFd");

var $bFXjh = parcelRequire("bFXjh");

var $1YqdI = parcelRequire("1YqdI");
const $3843ad0413ec519e$var$validateKeyMaps = (keyMaps)=>{
    (0, (/*@__PURE__*/$parcel$interopDefault($fUTZC)))(keyMaps, (keyMap, keyMapIndex)=>{
        const shortcuts = Object.keys(keyMap);
        (0, (/*@__PURE__*/$parcel$interopDefault($fUTZC)))(shortcuts, (shortcut, shortcutIndex)=>{
            if (!(0, $1YqdI.isValidShortcut)(shortcut)) // eslint-disable-next-line no-console
            console.error(`"${shortcut}" is an incorrect shortcut. Please, update it according to a playbook entry on shortcuts.`);
            for(let indexForOtherKeymaps = keyMapIndex + 1; indexForOtherKeymaps < keyMaps.length; indexForOtherKeymaps += 1){
                const anotherKeyMap = keyMaps[indexForOtherKeymaps];
                (0, (/*@__PURE__*/$parcel$interopDefault($fUTZC)))(anotherKeyMap, (anotherAction, anotherShortcut)=>{
                    if ((0, $1YqdI.isShortcutCollision)(anotherShortcut, shortcut)) // If neither shortcut has a priority we have a conflict.. You should ideally
                    // put a priority on one of these conflicting shortcut configs so you definitively
                    // know which one should be active when there is a conflict.
                    {
                        if ((0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(keyMap[shortcut].priority) && (0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(anotherKeyMap[anotherShortcut].priority) || keyMap[shortcut].priority === anotherKeyMap[anotherShortcut].priority) // DO NOT LET THIS HAPPEN. ADD A PRIORITY!!!
                        // eslint-disable-next-line no-console
                        console.error(`"${shortcut}" has a collision with "${anotherShortcut}" shortcut from another keyMap.`);
                    }
                });
            }
            for(let indexToCompareSelf = shortcutIndex + 1; indexToCompareSelf < shortcuts.length; indexToCompareSelf += 1)if ((0, $1YqdI.isShortcutCollision)(shortcut, shortcuts[indexToCompareSelf])) // eslint-disable-next-line no-console
            console.error(`"${shortcut}" has a collision with "${shortcuts[indexToCompareSelf]}" shortcut from the same keyMap.`);
        });
    });
};
const $3843ad0413ec519e$var$mergeKeyMaps = (keyMapsToMerge)=>// Instead of doing the standard Object.assign({}, ...keyMapsToMerge)
    // we want to have a bit more control over what we can and can't override
    // through the use of the priority
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    keyMapsToMerge.reduce((prev, keyMap)=>({
            ...prev,
            // Add the keys that can be overridden
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            ...Object.keys(keyMap).reduce((newAccumulator, newKey)=>{
                if (!(0, (/*@__PURE__*/$parcel$interopDefault($6G5mG)))(prev, newKey) || (prev[newKey].priority ?? 0) < (keyMap[newKey].priority ?? 1 // Default behaviour is override
                )) return {
                    ...newAccumulator,
                    [newKey]: keyMap[newKey]
                };
                return newAccumulator;
            }, {})
        }), {});
class $3843ad0413ec519e$export$ca1c75b575abf5ff {
    addChildRegistry(child) {
        this.children.push(child);
        return ()=>{
            (0, (/*@__PURE__*/$parcel$interopDefault($bFXjh)))(this.children, child);
        };
    }
    addKeyMap(getKeyMap) {
        this.keyMapRetrievers.push(getKeyMap);
        return ()=>{
            (0, (/*@__PURE__*/$parcel$interopDefault($bFXjh)))(this.keyMapRetrievers, getKeyMap);
        };
    }
    getActiveKeyMap() {
        const keyMaps = this.children.length ? this.children.map((child)=>child.getActiveKeyMap()) : this.keyMapRetrievers.map((getKeyMap)=>getKeyMap().keyMap);
        return {
            ...$3843ad0413ec519e$var$mergeKeyMaps(keyMaps)
        };
    }
    getKeyMapInfo() {
        const info = this.children.length ? this.children.map((child)=>child.getKeyMapInfo()) : this.keyMapRetrievers.map((getInfo)=>getInfo());
        // @ts-expect-error - TS2769 - No overload matches this call.
        const flattenedInfo = [].concat(...info);
        return flattenedInfo;
    }
    constructor(){
        // go/jfe-eslint
        this.children = [];
        this.keyMapRetrievers = [];
    }
}
const $3843ad0413ec519e$export$1dd4c61d1ce1fa15 = new $3843ad0413ec519e$export$ca1c75b575abf5ff();

});
parcelRegister("bFXjh", function(module, exports) {

var $9eFtX = parcelRequire("9eFtX");

var $49axs = parcelRequire("49axs");
/**
 * Removes all given values from `array` using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
 * to remove elements from an array by predicate.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Array
 * @param {Array} array The array to modify.
 * @param {...*} [values] The values to remove.
 * @returns {Array} Returns `array`.
 * @example
 *
 * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
 *
 * _.pull(array, 'a', 'c');
 * console.log(array);
 * // => ['b', 'b']
 */ var $880187c06210b759$var$pull = $9eFtX($49axs);
module.exports = $880187c06210b759$var$pull;

});
parcelRegister("49axs", function(module, exports) {

var $3cvRc = parcelRequire("3cvRc");
/**
 * This method is like `_.pull` except that it accepts an array of values to remove.
 *
 * **Note:** Unlike `_.difference`, this method mutates `array`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to modify.
 * @param {Array} values The values to remove.
 * @returns {Array} Returns `array`.
 * @example
 *
 * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
 *
 * _.pullAll(array, ['a', 'c']);
 * console.log(array);
 * // => ['b', 'b']
 */ function $30502d761f1085cf$var$pullAll(array, values) {
    return array && array.length && values && values.length ? $3cvRc(array, values) : array;
}
module.exports = $30502d761f1085cf$var$pullAll;

});
parcelRegister("3cvRc", function(module, exports) {

var $kJvGp = parcelRequire("kJvGp");

var $jkhuN = parcelRequire("jkhuN");

var $2Rm6I = parcelRequire("2Rm6I");

var $74vSq = parcelRequire("74vSq");

var $b69Sx = parcelRequire("b69Sx");
/** Used for built-in method references. */ var $254b343f3ff82813$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $254b343f3ff82813$var$splice = $254b343f3ff82813$var$arrayProto.splice;
/**
 * The base implementation of `_.pullAllBy` without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to remove.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns `array`.
 */ function $254b343f3ff82813$var$basePullAll(array, values, iteratee, comparator) {
    var indexOf = comparator ? $2Rm6I : $jkhuN, index = -1, length = values.length, seen = array;
    if (array === values) values = $b69Sx(values);
    if (iteratee) seen = $kJvGp(array, $74vSq(iteratee));
    while(++index < length){
        var fromIndex = 0, value = values[index], computed = iteratee ? iteratee(value) : value;
        while((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1){
            if (seen !== array) $254b343f3ff82813$var$splice.call(seen, fromIndex, 1);
            $254b343f3ff82813$var$splice.call(array, fromIndex, 1);
        }
    }
    return array;
}
module.exports = $254b343f3ff82813$var$basePullAll;

});
parcelRegister("2Rm6I", function(module, exports) {
/**
 * This function is like `baseIndexOf` except that it accepts a comparator.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $2151ae143791d52b$var$baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1, length = array.length;
    while(++index < length){
        if (comparator(array[index], value)) return index;
    }
    return -1;
}
module.exports = $2151ae143791d52b$var$baseIndexOfWith;

});




parcelRegister("1YqdI", function(module, exports) {

$parcel$export(module.exports, "toKeyWithModifiers", () => $1b99fa3356e664b3$export$8cf0d2c3d060a0c2);
$parcel$export(module.exports, "isValidShortcut", () => $1b99fa3356e664b3$export$8e231506c5580162);
$parcel$export(module.exports, "isShortcutCollision", () => $1b99fa3356e664b3$export$4add9e50cb49d130);
/**
 * Converts a KeyboardEvent to a normalised string representation of
 * modifiers and key.
 *
 * Ordering of modifier keys is taken from Apple's guidelines:
 * https://developer.apple.com/macos/human-interface-guidelines/input-and-output/keyboard/
 *
 * Example representation of ArrowUp key with all modifiers present:
 * ctrl+shift+meta+arrowup
 *
 * Character keys never include the 'shift' modifier,.
 * as it changes the character itself.
 * Examples:
 *  - instead of 'shift+a' the normal form is 'A'
 *  - instead of 'shift+/' the normal form is '?'
 *
 * The 'alt' modifier is NOT supported at all due to inconsistent behaviour
 * across platforms. On Mac, it changes the character input, e.g.
 * 'alt+z' is 'Ω' - which becomes the `event.key`. To properly support
 * this, a reverse-mapping of all these characters needs to be added.
 * Alternatively, `String.fromCharCode(event.which)` can be used, but
 * 1. This is a deprecated property
 * 2. The char code is still for the modified character for some keys on Mac
 *    (e.g. The char code for 'alt+/' is '¿')
 */ // Special keys such as 'Escape', 'ArrowUp' or ' '
const $1b99fa3356e664b3$var$isNonCharacterKey = (e)=>e.key.length > 1 || e.key === ' ';
const $1b99fa3356e664b3$var$modifiers = [
    {
        name: 'ctrl',
        // @ts-expect-error - TS7006 - Parameter 'e' implicitly has an 'any' type.
        test: (e)=>e.ctrlKey
    },
    {
        name: 'shift',
        // @ts-expect-error - TS7006 - Parameter 'e' implicitly has an 'any' type.
        test: (e)=>e.shiftKey && $1b99fa3356e664b3$var$isNonCharacterKey(e)
    },
    {
        // Command key on MacOS, Windows key on Windows
        name: 'meta',
        // @ts-expect-error - TS7006 - Parameter 'e' implicitly has an 'any' type.
        test: (e)=>e.metaKey || e.getModifierState && e.getModifierState('OS')
    }
];
const $1b99fa3356e664b3$var$toKey = (e)=>{
    if ($1b99fa3356e664b3$var$isNonCharacterKey(e)) return e.key.toLowerCase();
    // Ignore accidental CapsLock
    return e.shiftKey ? e.key.toUpperCase() : e.key.toLowerCase();
};
const $1b99fa3356e664b3$export$8cf0d2c3d060a0c2 = (e)=>{
    if (!e || !e.key) // There are still browsers out there that do not support e.key;
    // Just today (Oct 2018) I have observed Chrome 47 in Sentry, but it started supporting e.key since 51.
    // So instead of crashing the page with TypeError let's not detect keyboard shortcuts.
    return {
        sequence: '',
        e: e
    };
    return {
        sequence: $1b99fa3356e664b3$var$modifiers.filter((modifier)=>modifier.test(e)).map((modifier)=>modifier.name).concat($1b99fa3356e664b3$var$toKey(e)).join('+'),
        e: e
    };
};
/*
 *  Selected special key values disjunction for regex. All lowercase, ordered alphabethically.
 *  See https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/key/Key_Values.
 */ const $1b99fa3356e664b3$var$orSpecialChars = ' |arrowdown|arrowleft|arrowright|arrowup|backspace|clear|delete|end|enter|escape|home|insert|pagedown|pageup|pause|printscreen|tab';
/*
 * This string when used as a regular expression:
 * 1. Allows lowercase only with a single exception (see 3)
 * 2. Allows optional ctrl, shift, meta followed by "+" in that specific order in the beginning
 * 3. Allows any printable character (may be uppercase letter) or a special key value
 * 4. If shift modifier is used it can only be followed by a special char
 * 5. Is based on toKeyWithModifiers, uses orSpecialChars whitelist for shift chars
 * 6. Does not capture redundant groups
 */ const $1b99fa3356e664b3$var$singleShortcutEntry = `(ctrl\\+)?(shift\\+(?=(?:(?:meta\\+)?(?:${$1b99fa3356e664b3$var$orSpecialChars}))))?(meta\\+)?(${$1b99fa3356e664b3$var$orSpecialChars}|[!-~])`;
/*
 * Any number of singleShortcutEntry separated by a single space
 * We are not specifying "g" flag, so it's fine to reuse the same regex object.
 */ const $1b99fa3356e664b3$var$shortcutRegex = RegExp(`^${$1b99fa3356e664b3$var$singleShortcutEntry}( ${$1b99fa3356e664b3$var$singleShortcutEntry})*$`);
const $1b99fa3356e664b3$export$8e231506c5580162 = (shortcut)=>$1b99fa3356e664b3$var$shortcutRegex.test(shortcut);
const $1b99fa3356e664b3$export$4add9e50cb49d130 = (leftShortcut, rightShortcut)=>{
    if (!leftShortcut || !rightShortcut) return leftShortcut === rightShortcut;
    if (rightShortcut === leftShortcut) return true;
    if (leftShortcut.indexOf(rightShortcut) === 0) return leftShortcut[rightShortcut.length] === ' ';
    if (rightShortcut.indexOf(leftShortcut) === 0) return rightShortcut[leftShortcut.length] === ' ';
    return false;
};

});



parcelRegister("6Ua7e", function(module, exports) {

$parcel$export(module.exports, "default", () => $586cc92d06f8b9df$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $0cdA8 = parcelRequire("0cdA8");

var $gGtKh = parcelRequire("gGtKh");

const $586cc92d06f8b9df$var$LazyComponent = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("3L3ei")), {
    moduleId: "./src/packages/project-settings/invite-people-modal-project/src/index.tsx"
});
const $586cc92d06f8b9df$export$6a02a79fa2b0ddab = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "async-project-invite-people-modal",
        packageName: "jira-project-invite-people-modal",
        teamName: "groot-growth"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "project-invite-people-modal",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($586cc92d06f8b9df$var$LazyComponent, props)));
var $586cc92d06f8b9df$export$2e2bcd8739ae039 = $586cc92d06f8b9df$export$6a02a79fa2b0ddab;

});
parcelRegister("3L3ei", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('hPzOn'),
            load('h2MrD'),
            load('bYT2S'),
            load('e1vXm')
        ]);
        const value = parcelRequire('bagiu');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("hPzOn"),
        load("h2MrD"),
        load("bYT2S"),
        load("e1vXm")
    ]).then(()=>parcelRequire('bagiu'));
}

});


parcelRegister("9Bx8m", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('h2MrD'),
            load('bYT2S'),
            load('evBHV')
        ]);
        const value = parcelRequire('6SUBw');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("h2MrD"),
        load("bYT2S"),
        load("evBHV")
    ]).then(()=>parcelRequire('6SUBw'));
}

});




parcelRegister("ixyeo", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('j6IJU')
        ]);
        const value = parcelRequire('dNnOv');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("j6IJU")
    ]).then(()=>parcelRequire('dNnOv'));
}

});


parcelRegister("iSNkS", function(module, exports) {

$parcel$export(module.exports, "integrationTypes", () => $60586429dc17d610$export$a7359bcfb0ca8e98);
const $60586429dc17d610$export$a7359bcfb0ca8e98 = {
    BENTO_ISSUE: 'bentoIssue',
    CLASSIC_BOARD: 'classicBoard',
    NEXTGEN_BOARD: 'nextGenBoard',
    ROADMAP: 'roadmap',
    TIMELINE: 'timeline',
    LIST: 'list',
    CALENDAR: 'calendar',
    BOARD: 'board',
    FORM: 'form',
    SUMMARY: 'summary',
    ATTACHMENTS: 'attachments'
};

});

parcelRegister("eCCst", function(module, exports) {

$parcel$export(module.exports, "JWMShareButton", () => $7c9cba86062e6e6f$export$b326da26415fdf10);

var $eUqFw = parcelRequire("eUqFw");

var $dFWNP = parcelRequire("dFWNP");

var $bDUCT = parcelRequire("bDUCT");

var $lGiWG = parcelRequire("lGiWG");

var $1ybV0 = parcelRequire("1ybV0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $fQ7Iw = parcelRequire("fQ7Iw");

var $hfslX = parcelRequire("hfslX");

var $lxV3x = parcelRequire("lxV3x");

var $bPBzW = parcelRequire("bPBzW");

var $iSNkS = parcelRequire("iSNkS");
const $7c9cba86062e6e6f$var$SHARE_ICON = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dFWNP))), {
    label: "",
    size: "small"
});
const $7c9cba86062e6e6f$export$b326da26415fdf10 = ({ shareTitle: shareTitle, integrationType: integrationType, shareContentType: shareContentType, isAutoOpenDialog: isAutoOpenDialog = false, onDialogClose: onDialogClose })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { shareIntegrations: shareIntegrations } = (0, $hfslX.useShareIntegrations)(shareContentType);
    const entityAri = (0, $bDUCT.useEntityAri)();
    const shareButtonRef = (0, $eUqFw.useRef)(null);
    const renderCustomTriggerButton = (0, $eUqFw.useCallback)(// @ts-expect-error - TS7031 - Binding element 'onClick' implicitly has an 'any' type. | TS7031 - Binding element 'isSelected' implicitly has an 'any' type. | TS7031 - Binding element 'ref' implicitly has an 'any' type.
    ({ onClick: onClick, isSelected: isSelected }, { ref: ref, ...triggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            ref: ref
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lGiWG.ThemedButton), {
            ...triggerProps,
            ref: shareButtonRef,
            onClick: onClick,
            isSelected: isSelected,
            iconBefore: $7c9cba86062e6e6f$var$SHARE_ICON,
            appearance: "subtle"
        }, formatMessage((0, $bPBzW.default).share))), [
        formatMessage
    ]);
    const handleDialogClose = ()=>{
        onDialogClose?.();
        if ((0, $1ybV0.ff)('jwm-a11y-round2_guwbb')) shareButtonRef?.current?.focus();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lxV3x.AsyncShareProjectNudge), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fQ7Iw.default), {
        isAutoOpenDialog: isAutoOpenDialog,
        integrationType: integrationType,
        triggerButtonStyle: "icon-with-text",
        productId: "jira",
        subProductId: "jira-core",
        shareLink: false ? '' : window.location.href,
        shareTitle: formatMessage(shareTitle),
        shareContentType: shareContentType,
        // @ts-expect-error - TS2322 - Type '({ onClick, isSelected }: { onClick: any; isSelected: any; }, { ref, ...triggerProps }: { [x: string]: any; ref: any; }) => Element' is not assignable to type 'RenderCustomTriggerButton'.
        renderCustomTriggerButton: renderCustomTriggerButton,
        objectAri: entityAri,
        onDialogClose: handleDialogClose,
        copyTooltipText: formatMessage((0, $bPBzW.default).shareTooltipText),
        shareIntegrations: shareIntegrations,
        integrationMode: "tabs",
        shareFormHelperMessage: formatMessage((0, $bPBzW.default).shareJwmHelperMessage)
    }));
};

});
parcelRegister("dFWNP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9f4cb7ac67043f68$var$_react = $9f4cb7ac67043f68$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $9f4cb7ac67043f68$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $9f4cb7ac67043f68$var$ShareIcon = (props)=>/*#__PURE__*/ $9f4cb7ac67043f68$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentColor" fill-rule="evenodd"><path d="M6 15a3 3 0 100-6 3 3 0 000 6zm0-2a1 1 0 110-2 1 1 0 010 2zm12-4a3 3 0 100-6 3 3 0 000 6zm0-2a1 1 0 110-2 1 1 0 010 2zm0 14a3 3 0 100-6 3 3 0 000 6zm0-2a1 1 0 110-2 1 1 0 010 2z" fill-rule="nonzero"/><path d="M7 13.562l8.66 5 1-1.732-8.66-5z"/><path d="M7 10.83l1 1.732 8.66-5-1-1.732z"/></g></svg>`
    }, props));
$9f4cb7ac67043f68$var$ShareIcon.displayName = 'ShareIcon';
var $9f4cb7ac67043f68$var$_default = $9f4cb7ac67043f68$var$ShareIcon;
module.exports.default = $9f4cb7ac67043f68$var$_default;

});

parcelRegister("fQ7Iw", function(module, exports) {

$parcel$export(module.exports, "ShareLoadingPlaceholder", () => $eb292e1f91805d5c$export$5619d05bf511476b);
$parcel$export(module.exports, "default", () => $eb292e1f91805d5c$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $7rh0R = parcelRequire("7rh0R");

var $7u4fN = parcelRequire("7u4fN");

var $dFWNP = parcelRequire("dFWNP");

var $PdmhA = parcelRequire("PdmhA");

var $ciZ8Y = parcelRequire("ciZ8Y");

var $5JgJ2 = parcelRequire("5JgJ2");

var $gGtKh = parcelRequire("gGtKh");

var $8nUKh = parcelRequire("8nUKh");

const $eb292e1f91805d5c$export$5619d05bf511476b = ({ triggerButtonStyle: triggerButtonStyle = 'icon-only' })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "subtle",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dFWNP))), {
            size: "medium",
            label: formatMessage((0, $8nUKh.messages).shareTriggerButtonText),
            primaryColor: `var(--ds-icon, ${(0, $PdmhA).N30})`
        }),
        isDisabled: true
    }, triggerButtonStyle === 'icon-with-text' ? formatMessage((0, $8nUKh.messages).shareTriggerButtonText) : null));
};

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $eb292e1f91805d5c$var$ShareButton = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("jdZ2L")), {
    ssr: false,
    moduleId: "./src/packages/growth/share-button/src/ui/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$eb292e1f91805d5c$export$2e2bcd8739ae039 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ciZ8Y.ErrorBoundary), {
        id: "async.share.button",
        packageName: "share-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "share-button",
        fallback: props.renderCustomTriggerButton === undefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($eb292e1f91805d5c$export$5619d05bf511476b, {
            triggerButtonStyle: props.triggerButtonStyle
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(props.renderCustomTriggerButton, {
            isDisabled: true,
            onClick: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($eb292e1f91805d5c$var$ShareButton, props)));

});
parcelRegister("8nUKh", function(module, exports) {

$parcel$export(module.exports, "messages", () => $c445af617ae0da86$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $c445af617ae0da86$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    shareTriggerButtonText: {
        "id": "share-button.share-trigger-button-text",
        "defaultMessage": "Share"
    }
});

});

parcelRegister("jdZ2L", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('hPzOn'),
            load('2hmUs'),
            load('bCeK4'),
            load('dsiAd'),
            load('h2MrD'),
            load('bYT2S'),
            load('2xQrm')
        ]);
        const value = parcelRequire('iHQJU');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("hPzOn"),
        load("2hmUs"),
        load("bCeK4"),
        load("dsiAd"),
        load("h2MrD"),
        load("bYT2S"),
        load("2xQrm")
    ]).then(()=>parcelRequire('iHQJU'));
}

});


parcelRegister("hfslX", function(module, exports) {

$parcel$export(module.exports, "useShareIntegrations", () => $b36423e50cabd739$export$58a9f7a7ab3466f4);

var $eUqFw = parcelRequire("eUqFw");

var $dfBCt = parcelRequire("dfBCt");

var $8q0kG = parcelRequire("8q0kG");

var $1ybV0 = parcelRequire("1ybV0");

var $k8Qyf = parcelRequire("k8Qyf");

var $dWLk9 = parcelRequire("dWLk9");

var $gWV0M = parcelRequire("gWV0M");
var $ljgr5 = parcelRequire("ljgr5");
const $b36423e50cabd739$export$58a9f7a7ab3466f4 = (shareContentType)=>{
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagsService)();
    const cloudId = (0, $dWLk9.useCloudId)();
    const ineligibilityReasons = (0, $eUqFw.useMemo)(()=>{
        const reasons = [];
        if ((0, $8q0kG.default)()) reasons.push('notDesktop');
        // All Share to Slack must be disabled in FedRAMP environment as
        // Slack Jira Integration app is not available in FedRAMP
        if ((0, $1ybV0.ff)('confluence.frontend.growth.fedramp-check-isolation') && (0, $dfBCt.isFedRamp)()) reasons.push('isFedRAMP');
        return reasons;
    }, []);
    const shareIntegrations = (0, $eUqFw.useMemo)(()=>ineligibilityReasons.length === 0 ? [
            {
                type: 'Slack',
                Icon: (0, $ljgr5.default),
                Content: ({ onClose: onClose, changeTab: changeTab })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gWV0M.ShareToSlack), {
                        showFlag: showFlag,
                        product: "jira",
                        channel: "productAnalytics",
                        onClose: onClose,
                        cloudId: cloudId,
                        changeTab: changeTab,
                        shareContentType: shareContentType
                    })
            }
        ] : [], [
        ineligibilityReasons.length,
        showFlag,
        cloudId,
        shareContentType
    ]);
    return {
        shareIntegrations: shareIntegrations
    };
};

});
parcelRegister("gWV0M", function(module, exports) {

$parcel$export(module.exports, "ShareToSlack", () => $acb191acb45641f8$export$2cc56764fd9edb21);

var $eUqFw = parcelRequire("eUqFw");

var $ciZ8Y = parcelRequire("ciZ8Y");

var $gGtKh = parcelRequire("gGtKh");

var $335P8 = parcelRequire("335P8");

var $ljgr5 = parcelRequire("ljgr5");
const $acb191acb45641f8$export$2cc56764fd9edb21 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ciZ8Y.ErrorBoundary), {
        id: "async-share-to-slack",
        packageName: "integrations"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "share-to-slack",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $335P8.StyledShareToSlackLoader), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $335P8.StyledShareToSlack), props)));

});
parcelRegister("335P8", function(module, exports) {

$parcel$export(module.exports, "StyledShareToSlack", () => $7cc4332b79a68bdd$export$9aeb6210c91511b9);
$parcel$export(module.exports, "StyledShareToSlackLoader", () => $7cc4332b79a68bdd$export$d3f97cc63e3ee02);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $4Bees = parcelRequire("4Bees");

var $d3qIv = parcelRequire("d3qIv");
const $7cc4332b79a68bdd$export$9aeb6210c91511b9 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $d3qIv.LazyShareToSlack), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18s8ax2b",
            __cmplp.className
        ])
    });
});
const $7cc4332b79a68bdd$export$d3f97cc63e3ee02 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $4Bees.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1osq _19pkidpf _2hwx1wug _otyridpf _18u01wug",
            __cmplp.className
        ])
    });
});

});
parcelRegister("d3qIv", function(module, exports) {

$parcel$export(module.exports, "LazyShareToSlack", () => $3114157f9b395570$export$24281652e6b89b3b);

var $7rh0R = parcelRequire("7rh0R");

const $3114157f9b395570$export$24281652e6b89b3b = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("971uQ")), {
    ssr: false,
    moduleId: "../platform/packages/growth/integrations/src/share-to-slack/ui/index.tsx"
});

});
parcelRegister("971uQ", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('hPzOn'),
            load('dPtit')
        ]);
        const value = parcelRequire('dZKRj');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("hPzOn"),
        load("dPtit")
    ]).then(()=>parcelRequire('dZKRj'));
}

});



parcelRegister("ljgr5", function(module, exports) {

$parcel$export(module.exports, "default", () => $1f66b2d378eff6fc$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$1f66b2d378eff6fc$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: "16",
        height: "16",
        viewBox: "4 4 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M7.50403 13.8563C7.50403 14.727 6.79278 15.4382 5.92212 15.4382C5.05146 15.4382 4.34021 14.727 4.34021 13.8563C4.34021 12.9857 5.05146 12.2744 5.92212 12.2744H7.50403V13.8563Z",
        fill: "#E01E5A"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M8.30115 13.8563C8.30115 12.9857 9.0124 12.2744 9.88307 12.2744C10.7537 12.2744 11.465 12.9857 11.465 13.8563V17.8172C11.465 18.6879 10.7537 19.3991 9.88307 19.3991C9.0124 19.3991 8.30115 18.6879 8.30115 17.8172V13.8563Z",
        fill: "#E01E5A"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M9.88307 7.50415C9.0124 7.50415 8.30115 6.79291 8.30115 5.92224C8.30115 5.05158 9.0124 4.34033 9.88307 4.34033C10.7537 4.34033 11.465 5.05158 11.465 5.92224V7.50415H9.88307Z",
        fill: "#36C5F0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M9.88304 8.30127C10.7537 8.30127 11.465 9.01251 11.465 9.88317C11.465 10.7538 10.7537 11.4651 9.88304 11.4651H5.92212C5.05146 11.4651 4.34021 10.7538 4.34021 9.88317C4.34021 9.01251 5.05146 8.30127 5.92212 8.30127H9.88304Z",
        fill: "#36C5F0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M16.2354 9.88317C16.2354 9.01251 16.9466 8.30127 17.8172 8.30127C18.6879 8.30127 19.3991 9.01251 19.3991 9.88317C19.3991 10.7538 18.6879 11.4651 17.8172 11.4651H16.2354V9.88317Z",
        fill: "#2EB67D"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M15.4381 9.88316C15.4381 10.7538 14.7269 11.4651 13.8562 11.4651C12.9855 11.4651 12.2743 10.7538 12.2743 9.88316V5.92225C12.2743 5.05158 12.9855 4.34033 13.8562 4.34033C14.7269 4.34033 15.4381 5.05158 15.4381 5.92225V9.88316Z",
        fill: "#2EB67D"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M13.8562 16.2354C14.7269 16.2354 15.4381 16.9466 15.4381 17.8172C15.4381 18.6879 14.7269 19.3991 13.8562 19.3991C12.9855 19.3991 12.2743 18.6879 12.2743 17.8172V16.2354H13.8562Z",
        fill: "#ECB22E"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M13.8562 15.4382C12.9855 15.4382 12.2743 14.727 12.2743 13.8563C12.2743 12.9857 12.9855 12.2744 13.8562 12.2744H17.8171C18.6878 12.2744 19.399 12.9857 19.399 13.8563C19.399 14.727 18.6878 15.4382 17.8171 15.4382H13.8562Z",
        fill: "#ECB22E"
    }));

});



parcelRegister("lxV3x", function(module, exports) {

$parcel$export(module.exports, "AsyncShareProjectNudge", () => $906cb1053f659eb0$export$d95995d6ca76620b);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $ewdMq = parcelRequire("ewdMq");

var $gGtKh = parcelRequire("gGtKh");


// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $906cb1053f659eb0$var$LazyShareProjectNudge = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("hB1df")), {
    ssr: false,
    moduleId: "./src/packages/software/onboarding-nudges/src/ui/jwm-share-project/index.tsx"
});
const $906cb1053f659eb0$export$d95995d6ca76620b = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ewdMq.OnboardingNudgeErrorBoundary), {
        id: (0, $99a775c02d636a41$export$a1be34032ee24f78),
        fallback: children,
        attributes: {
            nudgeId: (0, $99a775c02d636a41$export$a1be34032ee24f78)
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "jwm-share-project-nudge",
        fallback: children
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($906cb1053f659eb0$var$LazyShareProjectNudge, null, children)));

});
parcelRegister("hB1df", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('afZr6');
        const value = parcelRequire('16oN0');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("afZr6").then(()=>parcelRequire('16oN0'));
}

});


parcelRegister("bPBzW", function(module, exports) {

$parcel$export(module.exports, "default", () => $6735bf02b619f7cd$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $6735bf02b619f7cd$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    share: {
        "id": "business-invite-people.jwm-share-button.share",
        "defaultMessage": "Share"
    },
    shareTooltipText: {
        "id": "business-invite-people.jwm-share-button.share-tooltip-text",
        "defaultMessage": "Embed this Smart Link in other Atlassian products such as Confluence"
    },
    shareJwmHelperMessage: {
        "id": "business-invite-people.jwm-share-button.share-jwm-helper-message",
        "defaultMessage": "This view, along with any applied groups and filters are shared"
    }
});

});


parcelRegister("91Lr1", function(module, exports) {

$parcel$export(module.exports, "default", () => $aff05ea3c914239b$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $gGtKh = parcelRequire("gGtKh");

var $l1jnn = parcelRequire("l1jnn");

var $cRKsH = parcelRequire("cRKsH");

const $aff05ea3c914239b$export$7174b56226171cc3 = (0, $7rh0R.lazy)(()=>(parcelRequire("euual")), {
    ssr: false,
    moduleId: "./src/packages/business/shared/components/more-menu/src/ui/more-menu/menu-content/index.tsx"
});
const $aff05ea3c914239b$var$MoreMenu = ({ hideDoneItems: hideDoneItems, hasExpandedAllItems: hasExpandedAllItems, hasCollapsedAllItems: hasCollapsedAllItems, hasFeedbackButton: hasFeedbackButton, projectType: projectType, isExpandCollapseButtonEnabled: isExpandCollapseButtonEnabled, onChangeHideDoneItems: onChangeHideDoneItems, onExpandCollapseAllItems: onExpandCollapseAllItems })=>{
    const renderContent = (0, $eUqFw.useCallback)((onCloseMenu)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
            name: "menu-content",
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $l1jnn.default), null)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($aff05ea3c914239b$export$7174b56226171cc3, {
            hideDoneItems: hideDoneItems,
            onChangeHideDoneItems: onChangeHideDoneItems,
            onExpandCollapseAllItems: onExpandCollapseAllItems,
            isExpandCollapseButtonEnabled: isExpandCollapseButtonEnabled,
            hasExpandedAllItems: hasExpandedAllItems,
            hasCollapsedAllItems: hasCollapsedAllItems,
            hasFeedbackButton: hasFeedbackButton,
            projectType: projectType,
            onCloseMenu: onCloseMenu
        })), [
        hideDoneItems,
        onChangeHideDoneItems,
        onExpandCollapseAllItems,
        isExpandCollapseButtonEnabled,
        hasExpandedAllItems,
        hasCollapsedAllItems,
        hasFeedbackButton,
        projectType
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cRKsH.default), {
        renderContent: renderContent
    });
};
var $aff05ea3c914239b$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($aff05ea3c914239b$var$MoreMenu);

});
parcelRegister("l1jnn", function(module, exports) {

$parcel$export(module.exports, "default", () => $a91aceacdc3d4a91$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $4Bees = parcelRequire("4Bees");

var $3Y9u8 = parcelRequire("3Y9u8");
const $a91aceacdc3d4a91$var$MenuFallback = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3Y9u8.SpinnerWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), {
        size: "medium"
    }));
var $a91aceacdc3d4a91$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($a91aceacdc3d4a91$var$MenuFallback);

});
parcelRegister("3Y9u8", function(module, exports) {

$parcel$export(module.exports, "SpinnerWrapper", () => $4a1a450a9393c394$export$52b4dfd89a6b3a1b);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $4a1a450a9393c394$export$52b4dfd89a6b3a1b = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _1yt4pxbi",
            __cmplp.className
        ])
    });
});

});


parcelRegister("cRKsH", function(module, exports) {

$parcel$export(module.exports, "default", () => $b0ab88bbf4e192a9$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $3MV1G = parcelRequire("3MV1G");

var $1ybV0 = parcelRequire("1ybV0");

var $jK1pm = parcelRequire("jK1pm");


var $fG0qd = parcelRequire("fG0qd");
const $b0ab88bbf4e192a9$var$MoreMenuCore = /*#__PURE__*/ (0, $eUqFw.memo)(({ renderContent: renderContent, minWidth: minWidth = (0, $f81b038ef83e0f85$export$8c68b096b2d5e9f6), forceVisibility: forceVisibility = false })=>{
    const [isOpen, setIsOpen] = (0, $eUqFw.useState)(forceVisibility);
    (0, $eUqFw.useEffect)(()=>{
        setIsOpen(forceVisibility);
    }, [
        forceVisibility
    ]);
    const closeMenu = (0, $eUqFw.useCallback)(()=>setIsOpen(false), []);
    const toggleMenu = (0, $eUqFw.useCallback)(()=>setIsOpen((oldIsOpen)=>!oldIsOpen), []);
    const content = (0, $eUqFw.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b0ab88bbf4e192a9$export$5f7211d21bfdae05, {
            width: minWidth
        }, renderContent(closeMenu)), [
        closeMenu,
        renderContent,
        minWidth
    ]);
    const trigger = (0, $eUqFw.useCallback)(// @ts-expect-error - TS7006 - Parameter 'triggerProps' implicitly has an 'any' type.
    (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fG0qd.default), {
            ...triggerProps,
            isSelected: isOpen,
            onClick: toggleMenu
        }), [
        isOpen,
        toggleMenu
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jK1pm.default), {
        name: "business-more-menu"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3MV1G.default), {
        isOpen: isOpen,
        onClose: closeMenu,
        placement: "bottom-end",
        content: content,
        trigger: trigger,
        shouldRenderToParent: (0, $1ybV0.ff)('fix-should-render-to-parent-with-custom-backgrounds'),
        strategy: (0, $1ybV0.ff)('fix-should-render-to-parent-with-custom-backgrounds') ? 'absolute' : undefined
    }));
});
var $b0ab88bbf4e192a9$export$2e2bcd8739ae039 = $b0ab88bbf4e192a9$var$MoreMenuCore;
const $b0ab88bbf4e192a9$export$5f7211d21bfdae05 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_6f8077": (0, $9t7rW.default)(`${__cmplp.width}px`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1hdq",
            __cmplp.className
        ])
    });
});

});
const $f81b038ef83e0f85$export$8c68b096b2d5e9f6 = 320;

parcelRegister("fG0qd", function(module, exports) {

$parcel$export(module.exports, "default", () => $4453e9a08a331d11$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jG1wZ = parcelRequire("jG1wZ");

var $lGiWG = parcelRequire("lGiWG");

var $5JgJ2 = parcelRequire("5JgJ2");

var $k1mhY = parcelRequire("k1mhY");
const $4453e9a08a331d11$var$MORE_ICON = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jG1wZ))), {
    label: "",
    size: "small"
});
const $4453e9a08a331d11$var$Trigger = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ onClick: onClick, isSelected: isSelected, ...otherProps }, ref)=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lGiWG.ThemedButton), {
        ...otherProps,
        ref: ref,
        testId: "business-more-menu.ui.more-menu.more-menu-core.trigger",
        iconBefore: $4453e9a08a331d11$var$MORE_ICON,
        isSelected: isSelected,
        onClick: onClick,
        appearance: "subtle",
        "aria-label": formatMessage((0, $k1mhY.default).moreButtonLabel)
    }, formatMessage((0, $k1mhY.default).moreButton));
});
var $4453e9a08a331d11$export$2e2bcd8739ae039 = $4453e9a08a331d11$var$Trigger;

});
parcelRegister("k1mhY", function(module, exports) {

$parcel$export(module.exports, "default", () => $255e4847f5c60031$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $255e4847f5c60031$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    moreButton: {
        "id": "business-more-menu.more-menu.more-menu-core.trigger.more-button",
        "defaultMessage": "More"
    },
    moreButtonLabel: {
        "id": "business-more-menu.more-menu.more-menu-core.trigger.more-button-label",
        "defaultMessage": "More actions on the view options"
    }
});

});



parcelRegister("euual", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('17KHX');
        const value = parcelRequire('dBYRZ');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("17KHX").then(()=>parcelRequire('dBYRZ'));
}

});


const $96fdf0f7cea6c0d2$export$3524fa372f8a92d5 = 'TIMELINE_EMBED_NUDGE_STEP';

parcelRegister("jcm0y", function(module, exports) {

$parcel$export(module.exports, "useNudgeStep", () => $f9b7836b4f53ac4b$export$c5e63e44ad178ae8);

var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");

const $f9b7836b4f53ac4b$var$actions = {
    setNudgeStep: (nudgeStep)=>({ setState: setState, getState: getState })=>setState({
                ...getState(),
                nudgeStep: nudgeStep
            }),
    setShouldOpenModal: (shouldOpenModal)=>({ setState: setState, getState: getState })=>setState({
                ...getState(),
                shouldOpenModal: shouldOpenModal
            })
};
// @ts-expect-error - TS2344 - Type '{ readonly setNudgeStep: (nudgeStep: NUDGE_STEP) => ({ setState, getState }: StoreState<State>) => void; readonly setShouldOpenModal: (shouldOpenModal: boolean) => ({ setState, getState }: StoreState<State>) => void; }' does not satisfy the constraint 'Record<string, ActionThunk<State, { readonly setNudgeStep: (nudgeStep: NUDGE_STEP) => ({ setState, getState }: StoreState<State>) => void; readonly setShouldOpenModal: (shouldOpenModal: boolean) => ({ setState, getState }: StoreState<...>) => void; }>>'.
const $f9b7836b4f53ac4b$var$Store = (0, $a61MH.createStore)({
    initialState: {
        nudgeStep: (0, $96fdf0f7cea6c0d2$export$3524fa372f8a92d5),
        shouldOpenModal: false
    },
    actions: $f9b7836b4f53ac4b$var$actions,
    name: 'JWMTimelineEmbedNudgeStepStore'
});
const $f9b7836b4f53ac4b$export$c5e63e44ad178ae8 = (0, $ggKAj.createHook)($f9b7836b4f53ac4b$var$Store);

});

parcelRegister("gR2L1", function(module, exports) {

$parcel$export(module.exports, "default", () => $53ebc7ca4df30486$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $53ebc7ca4df30486$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    shareTitle: {
        "id": "business-timeline.timeline-view.toolbar.share-title",
        "defaultMessage": "Timeline"
    },
    shareTooltipText: {
        "id": "business-timeline.timeline-view.toolbar.share-tooltip-text",
        "defaultMessage": "Embed this Smart Link in other Atlassian products such as Confluence"
    },
    simpleSearch: {
        "id": "business-timeline.timeline-view.toolbar.simple-search",
        "defaultMessage": "Search timeline"
    },
    searchLabel: {
        "id": "business-timeline.timeline-view.toolbar.search-label",
        "defaultMessage": "Typing letters in the search input applies filters"
    }
});

});

parcelRegister("d08Di", function(module, exports) {

$parcel$export(module.exports, "default", () => $b2f26dd70ea51ec5$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $lGiWG = parcelRequire("lGiWG");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");

var $kAsWD = parcelRequire("kAsWD");

var $hsBO5 = parcelRequire("hsBO5");

var $eTH8y = parcelRequire("eTH8y");

var $5ROWh = parcelRequire("5ROWh");
const $b2f26dd70ea51ec5$var$TodayButton = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const interactionMetrics = (0, $hsBO5.useInteractionMetrics)();
    const { scrollTo: scrollTo } = (0, $kAsWD.useTimelineScroller)();
    const [{ todayPosition: todayPosition }] = (0, $eTH8y.useTimelineUI)();
    const fireInteractionMetrics = (0, $eUqFw.useCallback)(()=>{
        interactionMetrics[0, $hsBO5.TODAY_BUTTON_CLICKED].start();
        // waiting for the browser to re-render timeline with updated scroll position
        requestAnimationFrame(()=>{
            interactionMetrics[0, $hsBO5.TODAY_BUTTON_CLICKED].stop({
                stopTime: Math.floor(performance.now())
            });
        });
    }, [
        interactionMetrics
    ]);
    const onClick = (0, $eUqFw.useCallback)((event, analyticsEvent)=>{
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'todayButton');
        scrollTo({
            left: todayPosition
        });
    }, [
        scrollTo,
        todayPosition
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lGiWG.ThemedButton), {
        onClick: onClick,
        onMouseDown: fireInteractionMetrics
    }, formatMessage((0, $5ROWh.default).today));
};
var // eslint-disable-next-line @typescript-eslint/no-explicit-any
$b2f26dd70ea51ec5$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($b2f26dd70ea51ec5$var$TodayButton);

});
parcelRegister("5ROWh", function(module, exports) {

$parcel$export(module.exports, "default", () => $2457e0a65e5c68b6$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $2457e0a65e5c68b6$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    today: {
        "id": "business-timeline.timeline-view.toolbar.today-button.today",
        "defaultMessage": "Today"
    }
});

});





parcelRegister("fO5rB", function(module, exports) {

$parcel$export(module.exports, "SubProductUpdater", () => $0dcc4693f2e4993e$export$eb40d3df56aa5c53);

var $eUqFw = parcelRequire("eUqFw");

var $3viaK = parcelRequire("3viaK");

var $cOnuN = parcelRequire("cOnuN");

var $6QL9v = parcelRequire("6QL9v");

var $kxBN8 = parcelRequire("kxBN8");

var $2SV7r = parcelRequire("2SV7r");
const $0dcc4693f2e4993e$export$eb40d3df56aa5c53 = ({ allowMonolithDeferral: allowMonolithDeferral = false, ...props })=>{
    const subProduct = (0, $2SV7r.isSubProductProps)(props) ? props.subProduct : (0, $6QL9v.subProductFromProjectType)(props.projectType);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3viaK.default), {
        op: (0, $kxBN8.default),
        args: [
            subProduct,
            allowMonolithDeferral
        ]
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cOnuN.default), {
        subProduct: subProduct
    }));
};

});
parcelRegister("cOnuN", function(module, exports) {

$parcel$export(module.exports, "default", () => $b3e22c81c3ebeab6$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $lgxha = parcelRequire("lgxha");

var $j5W2t = parcelRequire("j5W2t");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$b3e22c81c3ebeab6$export$2e2bcd8739ae039 = ({ subProduct: subProduct })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lgxha.default), {
        op: (0, $j5W2t.default),
        args: [
            subProduct
        ]
    });

});
parcelRegister("j5W2t", function(module, exports) {

$parcel$export(module.exports, "default", () => $8613fa53f568085a$export$2e2bcd8739ae039);

var $gUUjF = parcelRequire("gUUjF");

var $lRmyA = parcelRequire("lRmyA");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$8613fa53f568085a$export$2e2bcd8739ae039 = (subProduct)=>{
    (0, $lRmyA.performGetRequest)(`/rest/internal/2/mauTag/${subProduct}`).catch((err)=>{
        (0, $gUUjF.default).safeErrorWithoutCustomerData('common.tag-mau.tag-mau-event', 'Error connecting to monolith mau tag endpoint', err);
    });
};

});


parcelRegister("kxBN8", function(module, exports) {

$parcel$export(module.exports, "default", () => $95a7ec92a66826ce$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/wrm/no-load-bridge

var $2BvS3 = parcelRequire("2BvS3");
var $ds5Im = parcelRequire("ds5Im");
var $4DtuZ = parcelRequire("4DtuZ");


var $gUUjF = parcelRequire("gUUjF");

var $3FyZ4 = parcelRequire("3FyZ4");
const $95a7ec92a66826ce$var$maybeDelayAndRace = (// @ts-expect-error - TS2304 - Cannot find name 'Deferred'.
maybeWaitPromise, getDefaultPromise, getRacePromise)=>maybeWaitPromise ? Promise.race([
        maybeWaitPromise.then(getDefaultPromise),
        getRacePromise()
    ]) : getDefaultPromise();
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$95a7ec92a66826ce$export$2e2bcd8739ae039 = async (subProduct, allowMonolithDeferral)=>{
    (0, $3FyZ4.getAnalyticsWebClientPromise)().then((client)=>{
        client.setSubProduct(subProduct);
        if (subProduct === 'serviceDesk') client.setUIViewedAttributes({
            solutions: [
                (0, $96da08ab2c7a3243$export$c8b406ad8ee0dab9)
            ]
        });
        else client.removeUIViewedAttribute('solutions');
    });
    // IMPORTANT -
    // Until such time as all pre-TTI WRM loads are removed we find that waitForHeritage() then
    // loadBridgeStrict() is too slow, resulting in `subproduct:unknown` for analytics events.
    // In that same case however, profiling shows us that polling in loadBridgeWeak() somehow
    // resolves the same AMD code faster.
    // This is not well understood, but it does allow us to work around the issue by racing these
    // two techniques.
    // Once there is no pre-TTI WRM loads we the waitForHeritage() then loadBridgeStrict() does seem
    // to be faster such that we can remove the `Promise.race()`.
    /* eslint-disable jira/wrm/no-load-bridge */ $95a7ec92a66826ce$var$maybeDelayAndRace(allowMonolithDeferral ? (0, $4DtuZ.waitForHeritage)() : null, ()=>(0, $2BvS3.loadBridgeStrict)({
            name: 'jira/analytics/sub-product-resolver',
            wrmKeys: [
                'wrc!com.atlassian.jira.jira-client-analytics-plugin:analytics-web-client'
            ]
        }), ()=>(0, $ds5Im.loadBridgeWeak)({
            name: 'jira/analytics/sub-product-resolver'
        })).then((subProductResolver)=>{
        subProductResolver.setSubProduct(subProduct);
    }).catch((e)=>(0, $gUUjF.default).safeErrorWithoutCustomerData('common.analytics-sub-product.sub-product-updater', 'Error connecting to monolith sub product resolver', e));
/* eslint-enable jira/wrm/no-load-bridge */ };

});
const $96da08ab2c7a3243$export$c8b406ad8ee0dab9 = 'jiraServiceManagement';


parcelRegister("2SV7r", function(module, exports) {

$parcel$export(module.exports, "isSubProductProps", () => $5e5ef73a1d4e492a$export$c3063d6d7a8c075f);
const $5e5ef73a1d4e492a$export$c3063d6d7a8c075f = (props)=>'subProduct' in props && typeof props.subProduct === 'string';
const $5e5ef73a1d4e492a$export$81da4a7e1ba1dcee = (props)=>'projectType' in props && typeof props.projectType === 'string';

});




//# sourceMappingURL=async-business-timeline.3204f475.js.map
